/* eslint-disable */
import { subscription, query, mutation } from "../codegen/func";
import { gql } from "@apollo/client";
import * as React from "react";
import * as Apollo from "@apollo/client";
import * as ApolloReactComponents from "@apollo/client/react/components";
const getClient = (): Apollo.ApolloClient<any> => (window as any)["__APOLLO_CLIENT__"];
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Something with dates */
  Date: Date;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  HTML: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Mongo ObjectId */
  ObjectId: string;
  /** HH:mm string */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export enum AbsenceType {
  ChildCare = "ChildCare",
  None = "None",
  Other = "Other",
  SickDay = "SickDay",
  Vaccation = "Vaccation"
}

export type Accommodation = {
  Address?: Maybe<Address>;
  CancellationPolicy?: Maybe<Scalars["String"]>;
  CheckIn?: Maybe<Scalars["String"]>;
  CheckOut?: Maybe<Scalars["String"]>;
  Email?: Maybe<Array<Scalars["String"]>>;
  ImgUrl?: Maybe<Scalars["String"]>;
  Instruction?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Offers?: Maybe<Array<AccommodationOffer>>;
  Phone?: Maybe<Array<Scalars["String"]>>;
  ResponsiblePersonRef?: Maybe<UserRef>;
  Site?: Maybe<Scalars["String"]>;
  Type?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  documents?: Maybe<Array<Document>>;
  envCertification?: Maybe<Scalars["Boolean"]>;
  envCertificationName?: Maybe<Scalars["String"]>;
  preferredChoice?: Maybe<Scalars["Boolean"]>;
  unfit?: Maybe<AccommodationUnfit>;
};

export type AccommodationAlt = {
  MaxCost?: Maybe<ConsultantContractMaxCost>;
  PossibleSupplement?: Maybe<Scalars["String"]>;
  Type?: Maybe<ConsultantContractAccommodationAlt>;
};

export type AccommodationAltInput = {
  MaxCost?: InputMaybe<ConsultantContractMaxCostInput>;
  PossibleSupplement?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<ConsultantContractAccommodationAlt>;
};

export type AccommodationBase = {
  Address?: Maybe<Address>;
  Email?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ImgUrl?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Offers?: Maybe<Array<Maybe<AccommodationOffer>>>;
  Phone?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResponsiblePersonRef?: Maybe<UserRef>;
  Site?: Maybe<Scalars["String"]>;
  Type?: Maybe<AccommodationType>;
  _id?: Maybe<Scalars["ObjectId"]>;
  envCertification?: Maybe<Scalars["Boolean"]>;
  envCertificationName?: Maybe<Scalars["String"]>;
  preferredChoice?: Maybe<Scalars["Boolean"]>;
};

export type AccommodationConfirmation = {
  _id: Scalars["ObjectId"];
  accommodationRef?: Maybe<AccommodationRef>;
  allWeeks: Array<AccommodationConfirmationWeek>;
  area?: Maybe<Scalars["Float"]>;
  city?: Maybe<Scalars["String"]>;
  confirmedBy?: Maybe<UserRef>;
  confirmedOn?: Maybe<Scalars["Date"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  documents: Array<Document>;
  offerId?: Maybe<Scalars["ObjectId"]>;
  source: Scalars["String"];
  squareFootageAttached?: Maybe<Scalars["Boolean"]>;
  syncedAt?: Maybe<Scalars["Date"]>;
  taxWeeks: Array<AccommodationConfirmationWeek>;
  taxationId?: Maybe<Scalars["String"]>;
  totalCost?: Maybe<Scalars["Float"]>;
  totalExVAT?: Maybe<Scalars["Boolean"]>;
  weeks: Array<Scalars["Date"]>;
};

export type AccommodationConfirmationDocumentsArgs = {
  week?: InputMaybe<WeekYearInput>;
};

export type AccommodationConfirmationLine = {
  accommodationName: Scalars["String"];
  area: Scalars["Float"];
  city: Scalars["String"];
  cost: Scalars["Float"];
  endDate?: Maybe<Scalars["Date"]>;
  extraCost: Scalars["Float"];
  extraDescription?: Maybe<Scalars["String"]>;
  nights: Scalars["Int"];
  paymentMethod: Scalars["String"];
  reservationId?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  stayedNights: Scalars["Int"];
  tax: Scalars["Float"];
};

export enum AccommodationConfirmationSource {
  Erp = "Erp",
  Legacy = "Legacy"
}

export type AccommodationConfirmationWeek = {
  cost: Scalars["Float"];
  endDate?: Maybe<Scalars["Date"]>;
  extraCost: Scalars["Float"];
  extraDescription?: Maybe<Scalars["String"]>;
  isTaxed: Scalars["Boolean"];
  lines: Array<AccommodationConfirmationLine>;
  nights: Scalars["Int"];
  note?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  tax: Scalars["Float"];
  weekYear: WeekYear;
};

export enum AccommodationDocumentType {
  GeneralRoutines = "GeneralRoutines",
  Other = "Other",
  Sqm = "Sqm"
}

export type AccommodationEvent = Event & {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Scalars["String"]>>;
  Node: NodeRef;
  Sticky: Scalars["Boolean"];
  Type: AccommodationEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum AccommodationEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}

export type AccommodationFilter = {
  beds?: InputMaybe<Scalars["String"]>;
  location?: InputMaybe<LocationKlm>;
  options?: InputMaybe<Array<InputMaybe<AccommodationOfferOptions>>>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  rooms?: InputMaybe<Scalars["String"]>;
  switches?: InputMaybe<Array<InputMaybe<AccommodationSwitches>>>;
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<AccommodationType>;
};

export type AccommodationInput = {
  Address: AddressInput;
  CancellationPolicy?: InputMaybe<Scalars["String"]>;
  CheckIn?: InputMaybe<Scalars["String"]>;
  CheckOut?: InputMaybe<Scalars["String"]>;
  Email?: InputMaybe<Array<Scalars["String"]>>;
  Instruction?: InputMaybe<Scalars["String"]>;
  Name: Scalars["String"];
  Offers?: InputMaybe<Array<InputMaybe<AccommodationOfferInput>>>;
  Phone?: InputMaybe<Array<Scalars["String"]>>;
  ResponsiblePersonRef?: InputMaybe<UserRefInput>;
  Site?: InputMaybe<Scalars["String"]>;
  Type: AccommodationType;
  envCertification?: InputMaybe<Scalars["Boolean"]>;
  envCertificationName?: InputMaybe<Scalars["String"]>;
  preferredChoice?: InputMaybe<Scalars["Boolean"]>;
};

export type AccommodationListItem = AccommodationBase & {
  Address?: Maybe<Address>;
  Email?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ImgUrl?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Offers?: Maybe<Array<Maybe<AccommodationOffer>>>;
  Phone?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResponsiblePersonRef?: Maybe<UserRef>;
  Site?: Maybe<Scalars["String"]>;
  Type?: Maybe<AccommodationType>;
  _id: Scalars["ObjectId"];
  envCertification?: Maybe<Scalars["Boolean"]>;
  envCertificationName?: Maybe<Scalars["String"]>;
  preferredChoice?: Maybe<Scalars["Boolean"]>;
  unfit?: Maybe<AccommodationUnfit>;
};

export type AccommodationOffer = {
  Area?: Maybe<Scalars["Float"]>;
  Beds?: Maybe<Scalars["Float"]>;
  Name?: Maybe<Scalars["String"]>;
  Options?: Maybe<Array<Scalars["String"]>>;
  Price?: Maybe<Scalars["Float"]>;
  PriceType?: Maybe<Scalars["String"]>;
  Rooms?: Maybe<Scalars["Float"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type AccommodationOfferInput = {
  Area: Scalars["Int"];
  Beds: Scalars["Int"];
  Deleted?: InputMaybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  Options?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  Price: Scalars["Int"];
  PriceType: AccommodationPriceType;
  Rooms: Scalars["Int"];
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export enum AccommodationOfferOptions {
  Breakfast = "Breakfast",
  CleanOut = "CleanOut",
  Gym = "Gym",
  Internet = "Internet",
  NoKitchen = "NoKitchen",
  OwnKitchen = "OwnKitchen",
  Parking = "Parking",
  Pets = "Pets",
  SeparateBathroom = "SeparateBathroom",
  SharedKitchen = "SharedKitchen",
  SheetAndTowelsIncluded = "SheetAndTowelsIncluded"
}

export enum AccommodationPaymentMethod {
  BonlivaPays = "BonlivaPays",
  DeductFromSalary = "DeductFromSalary",
  InvoiceSubcontractor = "InvoiceSubcontractor",
  PayOnArrival = "PayOnArrival"
}

export type AccommodationPeriod = {
  end?: Maybe<Scalars["Date"]>;
  start?: Maybe<Scalars["Date"]>;
};

export type AccommodationPeriodInput = {
  end?: InputMaybe<Scalars["Date"]>;
  start?: InputMaybe<Scalars["Date"]>;
};

export enum AccommodationPriceType {
  PerMonth = "PerMonth",
  PerNight = "PerNight",
  PerWeek = "PerWeek"
}

export type AccommodationRef = {
  Name?: Maybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type AccommodationRequest = {
  _id: Scalars["ObjectId"];
  acceptedOveragePercent?: Maybe<Scalars["String"]>;
  accommodationLink?: Maybe<Scalars["String"]>;
  accommodationPreferences?: Maybe<Scalars["String"]>;
  accommodationSuggestion?: Maybe<AccommodationTypeOf>;
  accommodationType?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalInfo?: Maybe<Scalars["String"]>;
  bookingConfirmationFile?: Maybe<CrmDocument>;
  bookingGroup?: Maybe<Scalars["ObjectId"]>;
  bookingInformation?: Maybe<Scalars["String"]>;
  budget?: Maybe<Scalars["String"]>;
  budgetPeriod?: Maybe<AccommodationPriceType>;
  carAccess?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  commentAboutBooking?: Maybe<Scalars["String"]>;
  consultantId?: Maybe<Scalars["String"]>;
  costCenterId?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  createdById?: Maybe<Scalars["ObjectId"]>;
  createdByName?: Maybe<Scalars["String"]>;
  createdOn?: Maybe<Scalars["Date"]>;
  customerAddress?: Maybe<Scalars["String"]>;
  deadline?: Maybe<Scalars["Date"]>;
  differentCity?: Maybe<Scalars["Boolean"]>;
  endTime?: Maybe<Scalars["Date"]>;
  hasAccommodationSuggestion?: Maybe<Scalars["Boolean"]>;
  hasCarAccess?: Maybe<Scalars["Boolean"]>;
  hasOwnCar?: Maybe<Scalars["Boolean"]>;
  isProlongation?: Maybe<Scalars["Boolean"]>;
  isReschedule?: Maybe<Scalars["Boolean"]>;
  maxAllowedPerNight?: Maybe<Scalars["String"]>;
  paidBy?: Maybe<HospitalityPaidBy>;
  parkingMaxPrice?: Maybe<Scalars["String"]>;
  periodInput?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<AccommodationPeriod>>>;
  projectId?: Maybe<Scalars["String"]>;
  rescheduleComment?: Maybe<Scalars["String"]>;
  sharedBathroom?: Maybe<Scalars["Boolean"]>;
  sharedConveniences?: Maybe<Scalars["String"]>;
  sharedKitchen?: Maybe<Scalars["Boolean"]>;
  shouldBeBookedDirectly?: Maybe<Scalars["String"]>;
  specifyCity?: Maybe<Scalars["String"]>;
  staffAccommodation?: Maybe<Scalars["String"]>;
  startTime?: Maybe<Scalars["Date"]>;
  ticketDifficultyLevel?: Maybe<TicketDifficultyLevel>;
  travelPreferences?: Maybe<Scalars["String"]>;
  walkingDistance?: Maybe<Scalars["String"]>;
  zzNumber?: Maybe<Scalars["String"]>;
};

export type AccommodationRequestInfo = {
  accommodationIsOk: Scalars["Boolean"];
  accommodationRequest: Array<AccommodationRequest>;
  accommodationRequested: Scalars["Boolean"];
  confirmations: Array<AccommodationConfirmation>;
};

export type AccommodationRequestInput = {
  acceptedOveragePercent?: InputMaybe<Scalars["String"]>;
  accommodationLink?: InputMaybe<Scalars["String"]>;
  accommodationPreferences?: InputMaybe<Scalars["String"]>;
  accommodationSuggestion?: InputMaybe<AccommodationTypeOf>;
  accommodationType?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  additionalInfo?: InputMaybe<Scalars["String"]>;
  bookingConfirmationFile?: InputMaybe<Scalars["String"]>;
  bookingInformation?: InputMaybe<Scalars["String"]>;
  budget?: InputMaybe<Scalars["String"]>;
  budgetPeriod?: InputMaybe<AccommodationPriceType>;
  carAccess?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  commentAboutBooking?: InputMaybe<Scalars["String"]>;
  consultantId?: InputMaybe<Scalars["String"]>;
  costCenterId?: InputMaybe<Scalars["String"]>;
  customerAddress?: InputMaybe<Scalars["String"]>;
  deadline?: InputMaybe<Scalars["Date"]>;
  differentCity?: InputMaybe<Scalars["Boolean"]>;
  hasAccommodationSuggestion?: InputMaybe<Scalars["Boolean"]>;
  hasCarAccess?: InputMaybe<Scalars["Boolean"]>;
  hasOwnCar?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["ObjectId"]>;
  isProlongation?: InputMaybe<Scalars["Boolean"]>;
  isReschedule?: InputMaybe<Scalars["Boolean"]>;
  paidBy?: InputMaybe<HospitalityPaidBy>;
  parkingMaxPrice?: InputMaybe<Scalars["String"]>;
  periodInput?: InputMaybe<Scalars["String"]>;
  periodType?: InputMaybe<AccommodationRequestPeriodType>;
  periods?: InputMaybe<Array<InputMaybe<AccommodationPeriodInput>>>;
  projectId?: InputMaybe<Scalars["String"]>;
  rescheduleComment?: InputMaybe<Scalars["String"]>;
  sharedBathroom?: InputMaybe<Scalars["Boolean"]>;
  sharedConveniences?: InputMaybe<Scalars["String"]>;
  sharedKitchen?: InputMaybe<Scalars["Boolean"]>;
  shouldBeBookedDirectly?: InputMaybe<Scalars["String"]>;
  specifyCity?: InputMaybe<Scalars["String"]>;
  staffAccommodation?: InputMaybe<Scalars["String"]>;
  ticketDifficultyLevel: TicketDifficultyLevel;
  travelPreferences?: InputMaybe<Scalars["String"]>;
  walkingDistance?: InputMaybe<Scalars["String"]>;
  zzNumber?: InputMaybe<Scalars["String"]>;
};

export enum AccommodationRequestPeriodType {
  Durations = "Durations",
  Text = "Text"
}

export type AccommodationRequestQueryInput = {
  cityText?: InputMaybe<Scalars["String"]>;
  consultantIds?: InputMaybe<Array<Scalars["String"]>>;
  from?: InputMaybe<Scalars["Date"]>;
  hospitalIds?: InputMaybe<Array<Scalars["String"]>>;
  responsibleUserIds?: InputMaybe<Array<Scalars["String"]>>;
  senderIds?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<InputMaybe<AccommodationRequestStatusType>>>;
  text?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type AccommodationRequestSearch = {
  _id?: Maybe<Scalars["ObjectId"]>;
  city?: Maybe<Scalars["String"]>;
  consultantName?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<UserRef>;
  createdOn?: Maybe<Scalars["Date"]>;
  firstArrival?: Maybe<Scalars["Date"]>;
  status?: Maybe<AccommodationRequestStatus>;
  weeks?: Maybe<Array<Maybe<BookingLinks>>>;
};

export type AccommodationRequestSearchResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<AccommodationRequestSearch>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type AccommodationRequestSearchTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum AccommodationRequestSortBy {
  CreatedOn = "CreatedOn",
  FirstArrivalDate = "FirstArrivalDate"
}

export type AccommodationRequestStatus = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status?: Maybe<AccommodationRequestStatusType>;
};

export enum AccommodationRequestStatusType {
  Closed = "Closed",
  Open = "Open"
}

export enum AccommodationRequestTableColumns {
  ArrivalDate = "ArrivalDate",
  City = "City",
  Consultant = "Consultant",
  CreatedOn = "CreatedOn",
  Sender = "Sender",
  Status = "Status",
  Week = "Week"
}

export enum AccommodationSwitches {
  EnvCertification = "EnvCertification",
  PreferredChoice = "PreferredChoice"
}

export type AccommodationTravelAudit = {
  approved?: Maybe<Scalars["Boolean"]>;
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
};

export enum AccommodationTravelStatus {
  ApprovedManually = "ApprovedManually",
  Blank = "Blank",
  Confirmed = "Confirmed",
  NotRequired = "NotRequired",
  Requested = "Requested",
  Required = "Required"
}

export enum AccommodationType {
  Apartment = "Apartment",
  BedAndBreakfast = "BedAndBreakfast",
  CorporateApartment = "CorporateApartment",
  Guest = "Guest",
  Hostels = "Hostels",
  Hotel = "Hotel",
  StaffAccommodation = "StaffAccommodation"
}

export enum AccommodationTypeOf {
  Consultant = "Consultant",
  Directly = "Directly",
  HBA = "HBA"
}

export type AccommodationUnfit = {
  comment?: Maybe<Scalars["String"]>;
  userRef?: Maybe<UserRef>;
  value?: Maybe<Scalars["Boolean"]>;
};

export enum ActionType {
  CompleteTodo = "CompleteTodo",
  ConsultantFormSubmit = "ConsultantFormSubmit",
  ConsultantProfileAccess = "ConsultantProfileAccess",
  CreateTodo = "CreateTodo",
  DownloadConsultantPresentation = "DownloadConsultantPresentation",
  SubmitConsultantReference = "SubmitConsultantReference",
  UpdateConsultantAvailability = "UpdateConsultantAvailability",
  UserChatAction = "UserChatAction",
  UserClearedQualityItemStatus = "UserClearedQualityItemStatus",
  UserCommentAction = "UserCommentAction",
  UserCreatedBookingGroupAction = "UserCreatedBookingGroupAction",
  UserCreatedContactPerson = "UserCreatedContactPerson",
  UserEmailAction = "UserEmailAction",
  UserMassEmailAction = "UserMassEmailAction",
  UserMetInPersonAction = "UserMetInPersonAction",
  UserSMSAction = "UserSMSAction",
  UserSetQualityItemStatusApproved = "UserSetQualityItemStatusApproved",
  UserUpdatedCustomer = "UserUpdatedCustomer"
}

export type ActivitiesRecord = {
  count: Scalars["Int"];
  date: Scalars["Date"];
};

export type AddBookingInput = {
  AreaOfExpertise: Scalars["String"];
  ConsultantId: Scalars["ObjectId"];
  ContractType?: InputMaybe<ContractType>;
  CostCenter?: InputMaybe<Scalars["String"]>;
  Invoices?: InputMaybe<Array<InputMaybe<BookingInvoiceInput>>>;
  ProjectId: Scalars["ObjectId"];
  Weeks: Array<Scalars["Date"]>;
};

export type AddEventInput = {
  Description?: InputMaybe<Scalars["String"]>;
  Sticky?: InputMaybe<Scalars["Boolean"]>;
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export type AddNoanswerEventResult = {
  event?: Maybe<ConsultantEvent>;
  todo?: Maybe<TodoItem>;
};

export type Address = {
  City: Scalars["String"];
  Country: Scalars["String"];
  Region: Scalars["String"];
  StreetName: Scalars["String"];
  ZipCode: Scalars["String"];
  formattedShort: Scalars["String"];
};

export type AddressInput = {
  City?: InputMaybe<Scalars["String"]>;
  Country?: InputMaybe<Scalars["String"]>;
  Region?: InputMaybe<Scalars["String"]>;
  StreetName?: InputMaybe<Scalars["String"]>;
  ZipCode?: InputMaybe<Scalars["String"]>;
};

export type AllConsultantTagsResult = {
  tags: Array<Scalars["String"]>;
};

export type AnsweredQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type AnyNode = Consultant | Customer | TodoItem;

export type ApiToken = {
  createdOn: Scalars["Date"];
  id: Scalars["ID"];
  lastUsedOn?: Maybe<Scalars["Date"]>;
  name: Scalars["String"];
  revoked: Scalars["Boolean"];
};

export enum ApprovedAuthorizationOption {
  All = "All",
  No = "No",
  Yes = "Yes"
}

export type ApprovedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresInMonths: Scalars["Int"];
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
  pausedState?: Maybe<PausedState>;
};

export type ApprovedWithCommentQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresInMonths: Scalars["Int"];
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
};

export type AssignContactPersonToCustomerResult = {
  ContactPerson: ContactPerson;
  Customer: Customer;
};

export type AttachDocumentInput = {
  documentId: Scalars["ObjectId"];
  type: BookingDocumentType;
  weeks: Array<Scalars["Date"]>;
};

export type Audit = {
  Created?: Maybe<AuditContent>;
  Deleted?: Maybe<AuditContent>;
  Updated?: Maybe<AuditContent>;
};

export type AuditContent = {
  Date: Scalars["Date"];
  User: UserRef;
};

export type AuditContentInput = {
  Date?: InputMaybe<Scalars["Date"]>;
  User?: InputMaybe<UserRefInput>;
};

export type AuditInput = {
  Created: AuditContentInput;
  Updated?: InputMaybe<AuditContentInput>;
};

export type AuditItem = {
  date: Scalars["Date"];
  type: AuditItemType;
  userRef: UserRef;
};

export enum AuditItemType {
  Created = "created",
  Deleted = "deleted",
  Restored = "restored",
  Updated = "updated"
}

export type AwaitingApprovalQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type BaseContract = {
  _id: Scalars["ObjectId"];
  name?: Maybe<Scalars["String"]>;
  variant: BookingContractVariantType;
};

export type BaseFormAddress = {
  city: Scalars["String"];
  country: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type BaseUser = {
  AzureGroups?: Maybe<Array<Scalars["String"]>>;
  AzureId?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["Date"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  Deleted: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  Enabled: Scalars["Boolean"];
  ManagerId?: Maybe<Scalars["ObjectId"]>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  Teams: Array<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
};

export type BasicPrice = {
  dates?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["String"]>;
};

export type BisnodePerson = {
  AddressCity?: Maybe<Scalars["String"]>;
  AddressCountry?: Maybe<Scalars["String"]>;
  AddressStreetName?: Maybe<Scalars["String"]>;
  AddressZipCode?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  Fax?: Maybe<Scalars["String"]>;
  FirstName?: Maybe<Scalars["String"]>;
  LastName?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
};

export type BonlivaCareInvoiceInput = {
  invoiceNumber: Scalars["String"];
  invoiceTotal: Scalars["Float"];
};

export type BookedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type Booking = {
  AccommodationRequired: Scalars["Boolean"];
  AdditionalWork: Scalars["Boolean"];
  AdditionalWorkNote: Scalars["String"];
  AdministrativeFee: Scalars["Float"];
  AreaOfExpertise: Scalars["String"];
  BookingAudit?: Maybe<BookingAudit>;
  BookingGroup: BookingGroup;
  Consultant?: Maybe<Consultant>;
  ConsultantSnapshot: BookingConsultantSnapshot;
  ContractType?: Maybe<ContractType>;
  CostCenter?: Maybe<CostCenter>;
  CustomerFine: Scalars["Float"];
  CustomerNumber: Scalars["String"];
  GroupInvoiceTotal?: Maybe<Scalars["Float"]>;
  GroupInvoicing: Scalars["Boolean"];
  InvoiceTotal: Scalars["Float"];
  Invoices: Array<Maybe<BookingCustomerInvoice>>;
  IsCanceled: Scalars["Boolean"];
  IsConsultantPayed: Scalars["Boolean"];
  IsCustomerBilled: Scalars["Boolean"];
  Note: Scalars["String"];
  PatientId: Scalars["String"];
  Project?: Maybe<Project>;
  SubcontractorDocuments: Array<Document>;
  TravelRequired: Scalars["Boolean"];
  Week: Scalars["Date"];
  _id: Scalars["ObjectId"];
  additionalPayoutAmount?: Maybe<Scalars["Float"]>;
  additionalPayoutDescription?: Maybe<Scalars["String"]>;
  attachments?: Maybe<Array<Document>>;
  bookingAssignedTo?: Maybe<Array<BookingAssignedTo>>;
  bookingIntro?: Maybe<BookingIntro>;
  bookingKits: Array<BookingKit>;
  bookingStatus: BookingStatus;
  bookingSupportTagComment?: Maybe<Scalars["String"]>;
  bookingSupportTagStatus?: Maybe<Array<BookingSupportTagStatus>>;
  callNumber: Scalars["String"];
  costs?: Maybe<BookingCosts>;
  createdBy?: Maybe<User>;
  createdOn?: Maybe<Scalars["Date"]>;
  customersWithNoApproval?: Maybe<BookingNoApprovalForTimeReport>;
  deletedBy?: Maybe<User>;
  deletedOn?: Maybe<Scalars["Date"]>;
  draftCosts?: Maybe<BookingCosts>;
  duplicateIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  erpExportUnitRef?: Maybe<Scalars["String"]>;
  externalRef?: Maybe<Scalars["String"]>;
  hasKits?: Maybe<Scalars["Boolean"]>;
  isCancellable: Scalars["Boolean"];
  isFirstWeek?: Maybe<Scalars["Boolean"]>;
  isOpen: Scalars["Boolean"];
  isSickPayed: Scalars["Boolean"];
  monthBreakSide?: Maybe<BookingMonthBreakSide>;
  profit?: Maybe<BookingProfit>;
  rejectedBookingKits: Array<BookingKit>;
  requireTravelInvoicing?: Maybe<Scalars["Boolean"]>;
  skipTimereportReminder: Scalars["Boolean"];
  specializations: Array<Scalars["String"]>;
  timeReportHasSickTime?: Maybe<Scalars["Boolean"]>;
  timeReportStatus?: Maybe<TimeReportStatus>;
  timeReportTypeSentToHBA?: Maybe<TimeReportTemplateType>;
  unlockForms: Scalars["Boolean"];
  updatedBy?: Maybe<User>;
  updatedOn?: Maybe<Scalars["Date"]>;
};

export type BookingAssignedTo = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  setTo?: Maybe<UserRef>;
};

export type BookingAssignedToResult = {
  bookingAssignedTo?: Maybe<Array<BookingAssignedTo>>;
  bookingId?: Maybe<Scalars["ObjectId"]>;
};

export type BookingAudit = {
  Approved?: Maybe<Scalars["Boolean"]>;
  Comment?: Maybe<Scalars["String"]>;
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export enum BookingCSVReportType {
  Bookings = "Bookings",
  ClosedBookingWeeks = "ClosedBookingWeeks",
  Continuity = "Continuity",
  HalfOpenRecords = "HalfOpenRecords",
  NationalProcurementStatistics = "NationalProcurementStatistics",
  OpenHalfOpenRecords = "OpenHalfOpenRecords",
  OpenPosts = "OpenPosts",
  ProfitabilityPerConsultant = "ProfitabilityPerConsultant",
  ProjectReconciliation = "ProjectReconciliation",
  SAHLRStatus = "SAHLRStatus"
}

export enum BookingCannotBeRemovedReason {
  AccommodationBenefitTax = "AccommodationBenefitTax",
  ConsultantPaid = "ConsultantPaid",
  CustomerBilled = "CustomerBilled",
  HasInvoiceNumber = "HasInvoiceNumber",
  TimereportNotBlank = "TimereportNotBlank"
}

export type BookingChecks = {
  accommodationSum?: Maybe<Scalars["String"]>;
  attachTimeReport?: Maybe<Scalars["String"]>;
  consultantContractId?: Maybe<Scalars["String"]>;
  contractNumber?: Maybe<Scalars["String"]>;
  costCenter?: Maybe<Scalars["String"]>;
  customerContractId?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  expenses?: Maybe<Scalars["String"]>;
  groupInvoicing?: Maybe<Scalars["String"]>;
  hours?: Maybe<Scalars["String"]>;
  mileage?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  project?: Maybe<Scalars["String"]>;
  requiredForm?: Maybe<Scalars["String"]>;
  totalInvoice?: Maybe<Scalars["String"]>;
  travelSum?: Maybe<Scalars["String"]>;
};

export type BookingConsultantSnapshot = {
  BusinessName?: Maybe<Scalars["String"]>;
  BusinessSocialSecurityNo?: Maybe<Scalars["String"]>;
  LegalPersonType?: Maybe<LegalPersonType>;
};

export type BookingContractInfo = {
  _id: Scalars["ObjectId"];
  name?: Maybe<Scalars["String"]>;
  variant: BookingContractVariantType;
};

export enum BookingContractVariantType {
  Consultant = "Consultant",
  ConsultantBookingConfirmation = "ConsultantBookingConfirmation",
  Customer = "Customer",
  CustomerSubversion = "CustomerSubversion"
}

export type BookingCosts = {
  accommodation: Scalars["Float"];
  employeeSalary: Scalars["Float"];
  invoiceTotal: Scalars["Float"];
  sickPayTotal: Scalars["Float"];
  travel: Scalars["Float"];
};

export type BookingCustomerInvoice = {
  invoice?: Maybe<Invoice>;
  invoiceNumber: Scalars["String"];
};

export type BookingDocument = {
  _id: Scalars["ObjectId"];
  name?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export enum BookingDocumentType {
  AccommodationConfirmation = "AccommodationConfirmation",
  Subcontractor = "Subcontractor",
  TravelConfirmation = "TravelConfirmation"
}

export type BookingEvent = {
  Audit: Audit;
  BookingId: Scalars["ObjectId"];
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResultOfAction?: Maybe<Scalars["String"]>;
  Sticky: Scalars["Boolean"];
  Type: BookingEventType;
  UpdatedBy: WeakUserRef;
  UserRef?: Maybe<UserRef>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum BookingEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}

export type BookingGroup = {
  _id: Scalars["ObjectId"];
  accommodationRequestedWeeks: Array<Scalars["Date"]>;
  authorizedOrderer?: Maybe<Scalars["String"]>;
  billingInstructions?: Maybe<Scalars["String"]>;
  bookings: Array<Booking>;
  consultant?: Maybe<Consultant>;
  consultantContractId?: Maybe<Scalars["ObjectId"]>;
  customerContract?: Maybe<CustomerContractListItem>;
  customerContractId?: Maybe<Scalars["ObjectId"]>;
  department?: Maybe<Customer>;
  externalId?: Maybe<Scalars["String"]>;
  hasClosedBooking: Scalars["Boolean"];
  hasOpenBookings: Scalars["Boolean"];
  hospital: Customer;
  isDiscount?: Maybe<Scalars["Boolean"]>;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  nationalProcurementTravelRequired?: Maybe<Scalars["Boolean"]>;
  subVersionId?: Maybe<Scalars["ObjectId"]>;
  travelTemplateLevel?: Maybe<Scalars["String"]>;
};

export type BookingGroupBookingsArgs = {
  includeCanceled?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
};

export type BookingGroupCancellableResult = {
  isCancellable: Scalars["Boolean"];
  nonCancellableReason?: Maybe<Scalars["String"]>;
};

export type BookingGroupInput = {
  AccommodationRequired?: InputMaybe<Scalars["Boolean"]>;
  AreaOfExpertise: Scalars["String"];
  BusinessName?: InputMaybe<Scalars["String"]>;
  BusinessSocialSecurityNo?: InputMaybe<Scalars["String"]>;
  ConsultantId: Scalars["ObjectId"];
  ContractType?: InputMaybe<ContractType>;
  CostCenter?: InputMaybe<Scalars["String"]>;
  DepartmentsRefs: Array<CustomerRefInput>;
  HospitalRef: CustomerRefInput;
  LegalPersonType?: InputMaybe<LegalPersonType>;
  ProjectId: Scalars["ObjectId"];
  Specializations: Array<Scalars["String"]>;
  TravelRequired?: InputMaybe<Scalars["Boolean"]>;
  UpdateConsultantWithSnapshotData?: InputMaybe<Scalars["Boolean"]>;
  Weeks: Array<Scalars["Date"]>;
  WorkRequestId?: InputMaybe<Scalars["ObjectId"]>;
  authorizedOrderer?: InputMaybe<Scalars["String"]>;
  bookingIntro?: InputMaybe<BookingIntroInput>;
  callNumber?: InputMaybe<Scalars["String"]>;
  consultantContractId?: InputMaybe<Scalars["ObjectId"]>;
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  isDiscount?: InputMaybe<Scalars["Boolean"]>;
  isNationalProcurement: Scalars["Boolean"];
  nationalProcurementTravelRequired?: InputMaybe<Scalars["Boolean"]>;
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
  travelInvoicingWeeks?: InputMaybe<Array<Scalars["Date"]>>;
  travelZone?: InputMaybe<Scalars["String"]>;
};

export type BookingHospitality = {
  _id: Scalars["ObjectId"];
  accommodation: AccommodationRequestInfo;
  travel: TravelRequestInfo;
};

export type BookingIntro = {
  description?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  required?: Maybe<Scalars["Boolean"]>;
  startDate?: Maybe<Scalars["Date"]>;
};

export type BookingIntroInput = {
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["DateTime"]>;
  required?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
};

export type BookingInvoiceInput = {
  invoiceNumber?: InputMaybe<Scalars["String"]>;
  invoicePartial?: InputMaybe<Scalars["Float"]>;
};

export type BookingInvoicePaymentStatusesResult = {
  invoicePaymentStatuses: Scalars["JSON"];
};

export enum BookingInvoiceType {
  Completion = "Completion",
  Introduction = "Introduction",
  OrderCreated = "OrderCreated",
  Other = "Other",
  SickPay = "SickPay"
}

export type BookingKit = {
  _id?: Maybe<Scalars["ObjectId"]>;
  assigned?: Maybe<KitAssignedTo>;
  booking: Booking;
  bookingId: Scalars["ObjectId"];
  bookingSupportCheckWasValid?: Maybe<Scalars["Boolean"]>;
  bookingSupportTagComment: Scalars["String"];
  bookingSupportTagStatus?: Maybe<Array<BookingSupportTagStatus>>;
  comments?: Maybe<Array<Scalars["String"]>>;
  consultant?: Maybe<Consultant>;
  consultantPayoutType?: Maybe<Scalars["String"]>;
  costCenter?: Maybe<CostCenter>;
  createdOn: Scalars["Date"];
  currentFinanceInvoiceStatus?: Maybe<BookingKitStatus>;
  currentFinancePaymentStatus?: Maybe<BookingKitStatus>;
  currentHBAStatus?: Maybe<BookingKitStatus>;
  currentOCStatus?: Maybe<BookingKitStatus>;
  customerBillingInstructions?: Maybe<Scalars["String"]>;
  customerContractType?: Maybe<Scalars["String"]>;
  deleted: Scalars["Boolean"];
  deletedByName?: Maybe<Scalars["String"]>;
  deletedOn?: Maybe<Scalars["Date"]>;
  department?: Maybe<Customer>;
  documents: Array<CrmDocument>;
  hospital?: Maybe<Customer>;
  isDone: Scalars["Boolean"];
  isGroupInvoicing?: Maybe<Scalars["Boolean"]>;
  isRejected: Scalars["Boolean"];
  manager?: Maybe<User>;
  name?: Maybe<Scalars["String"]>;
  profitNet: Scalars["Float"];
  profitRatio: Scalars["Float"];
  project?: Maybe<Project>;
  receipts?: Maybe<Array<BookingKitExpensesReceipt>>;
  responsible?: Maybe<User>;
  status?: Maybe<BookingKitStatusType>;
  statuses?: Maybe<Array<BookingKitStatus>>;
  timeReportType?: Maybe<TimeReportTemplateType>;
  type?: Maybe<BookingKitType>;
  week: Scalars["Date"];
  withConsultantInvoice?: Maybe<Scalars["Boolean"]>;
  withCustomerInvoice?: Maybe<Scalars["Boolean"]>;
  withSickPay?: Maybe<Scalars["Boolean"]>;
  withSubcontractorPay?: Maybe<Scalars["Boolean"]>;
  withTimeReport?: Maybe<Scalars["Boolean"]>;
};

export type BookingKitApprovalConfig = {
  canApprove: Scalars["Boolean"];
  canReject: Scalars["Boolean"];
  canRejectDone: Scalars["Boolean"];
};

export enum BookingKitAutomationType {
  Full = "Full",
  Semi = "Semi"
}

export type BookingKitDraft = {
  costCenterId?: Maybe<Scalars["String"]>;
  documents: Array<CrmDocument>;
  timereportTemplateType?: Maybe<TimeReportTemplateType>;
};

export type BookingKitEvent = {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResultOfAction?: Maybe<Scalars["String"]>;
  Sticky: Scalars["Boolean"];
  Type: BookingKitEventType;
  UpdatedBy: WeakUserRef;
  UserRef?: Maybe<UserRef>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
  kitId: Scalars["ObjectId"];
};

export enum BookingKitEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}

export type BookingKitExpensesReceipt = {
  name: Scalars["String"];
  uri: Scalars["String"];
};

export type BookingKitExpensesReceiptInput = {
  name: Scalars["String"];
  uri: Scalars["String"];
};

export type BookingKitQueryInput = {
  areasOfExpertises?: InputMaybe<Array<Scalars["String"]>>;
  assignedUserIds?: InputMaybe<Array<Scalars["String"]>>;
  bookingKitStatuses?: InputMaybe<Array<BookingKitStatusType>>;
  bookingSupportTag?: InputMaybe<Array<Scalars["String"]>>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  consultantPayoutType?: InputMaybe<ConsultantContractPayoutType>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  fromBookingDate?: InputMaybe<Scalars["Date"]>;
  isGroupInvoicing?: InputMaybe<Scalars["Boolean"]>;
  isNationalProcurement?: InputMaybe<Scalars["Boolean"]>;
  legalPersonType?: InputMaybe<LegalPersonType>;
  managerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  projectIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  projectResponsiblePersonIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  responsibleUserIds?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  toBookingDate?: InputMaybe<Scalars["Date"]>;
  types?: InputMaybe<Array<BookingKitType>>;
};

export type BookingKitSearch = {
  _id?: Maybe<Scalars["ObjectId"]>;
  areaOfExpertise: Scalars["String"];
  assignedByUserId?: Maybe<Scalars["String"]>;
  assignedByUserName?: Maybe<Scalars["String"]>;
  assignedOn?: Maybe<Scalars["Date"]>;
  assignedToUserId?: Maybe<Scalars["String"]>;
  assignedToUserName?: Maybe<Scalars["String"]>;
  bookingId: Scalars["ObjectId"];
  bookingSupportTagComment: Scalars["String"];
  bookingSupportTagStatus?: Maybe<Array<BookingSupportTagStatus>>;
  consultantId: Scalars["ObjectId"];
  consultantName: Scalars["String"];
  consultantPayoutType?: Maybe<Scalars["String"]>;
  costCenterId?: Maybe<Scalars["String"]>;
  costCenterName?: Maybe<Scalars["String"]>;
  createdOn: Scalars["Date"];
  customerBillingInstructions?: Maybe<Scalars["String"]>;
  customerContractType?: Maybe<Scalars["String"]>;
  departmentId?: Maybe<Scalars["ObjectId"]>;
  departmentName?: Maybe<Scalars["String"]>;
  hospitalId: Scalars["ObjectId"];
  hospitalName: Scalars["String"];
  isHighPriority?: Maybe<Scalars["Boolean"]>;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  lastStatusSetByUserId?: Maybe<Scalars["String"]>;
  lastStatusSetByUserName?: Maybe<Scalars["String"]>;
  lastStatusSetOn?: Maybe<Scalars["Date"]>;
  lastStatusType?: Maybe<BookingKitStatusType>;
  name?: Maybe<Scalars["String"]>;
  projectId?: Maybe<Scalars["String"]>;
  projectName?: Maybe<Scalars["String"]>;
  regionId: Scalars["ObjectId"];
  regionName: Scalars["String"];
  timereportApprovedOn?: Maybe<Scalars["Date"]>;
  type: BookingKitType;
  week: Scalars["Date"];
};

export type BookingKitSearchResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<BookingKitSearch>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type BookingKitSearchTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum BookingKitSortBy {
  BookingDate = "BookingDate",
  CreatedOn = "CreatedOn",
  TimereportApprovedOn = "TimereportApprovedOn",
  TimereportCreatedOn = "TimereportCreatedOn"
}

export type BookingKitStatus = {
  comment?: Maybe<Scalars["String"]>;
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status?: Maybe<BookingKitStatusType>;
};

export enum BookingKitStatusType {
  ApprovedByFinance = "ApprovedByFinance",
  ApprovedByFinanceInvoicing = "ApprovedByFinanceInvoicing",
  ApprovedByFinancePayment = "ApprovedByFinancePayment",
  ApprovedByHBA = "ApprovedByHBA",
  ApprovedByOC = "ApprovedByOC",
  Created = "Created",
  Deleted = "Deleted",
  Done = "Done",
  RejectedByFinance = "RejectedByFinance",
  RejectedByFinanceInvoicing = "RejectedByFinanceInvoicing",
  RejectedByFinancePayment = "RejectedByFinancePayment",
  RejectedByHBA = "RejectedByHBA",
  RejectedByOC = "RejectedByOC",
  SentToFinance = "SentToFinance",
  SentToFinanceInvoicing = "SentToFinanceInvoicing",
  SentToFinancePayment = "SentToFinancePayment",
  SentToHBA = "SentToHBA",
  SentToOC = "SentToOC"
}

export enum BookingKitTableColumns {
  Alt = "Alt",
  Aoe = "Aoe",
  Assigned = "Assigned",
  Consultant = "Consultant",
  ConsultantPayoutType = "ConsultantPayoutType",
  CostCenter = "CostCenter",
  Customer = "Customer",
  IsNationalProcurement = "IsNationalProcurement",
  KitStatus = "KitStatus",
  LastEvent = "LastEvent",
  ManagementStatus = "ManagementStatus",
  Project = "Project",
  TimereportApprovedOn = "TimereportApprovedOn",
  Type = "Type",
  Week = "Week"
}

export enum BookingKitType {
  AccruedCost = "AccruedCost",
  AccruedIncome = "AccruedIncome",
  Compensation = "Compensation",
  Complete = "Complete",
  Credit = "Credit",
  PreviouslyAccruedCost = "PreviouslyAccruedCost",
  PreviouslyAccruedIncome = "PreviouslyAccruedIncome",
  SickPay = "SickPay"
}

export type BookingKitTypeFormConfig = {
  isAvailableForCreation: Scalars["Boolean"];
  requirements: BookingKitTypeFormRequirements;
  type: BookingKitType;
};

export type BookingKitTypeFormRequirements = {
  hbaApproval: Scalars["Boolean"];
  invoiceForm: Scalars["Boolean"];
  ocApproval: Scalars["Boolean"];
  payForm: Scalars["Boolean"];
  sickPayForm: Scalars["Boolean"];
  timeReport: Scalars["Boolean"];
};

export type BookingLinks = {
  link?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export enum BookingMonthBreakSide {
  FirstMonth = "FirstMonth",
  SecondMonth = "SecondMonth"
}

export type BookingNoApprovalForTimeReport = {
  needSignature: Array<CustomerRef>;
  needSignatureTROkInApp: Array<CustomerRef>;
  noApproval: Array<CustomerRef>;
  noApprovalMonthly: Array<CustomerRef>;
  noApprovalShortening: Array<CustomerRef>;
  noApprovalSpecial: Array<CustomerRef>;
};

export type BookingProfit = {
  invoiceTotal?: Maybe<Scalars["Float"]>;
  profitNet?: Maybe<Scalars["Float"]>;
  profitRatio?: Maybe<Scalars["Float"]>;
};

export enum BookingReportStatus {
  Billed = "Billed",
  BilledAndPaid = "BilledAndPaid",
  NotBilledNotPaid = "NotBilledNotPaid",
  NotBilledNotPaidNotPassed = "NotBilledNotPaidNotPassed",
  Paid = "Paid",
  Total = "Total"
}

export enum BookingReportType {
  ByConsultant = "ByConsultant",
  ByDepartment = "ByDepartment",
  ByHospital = "ByHospital",
  ByOrganization = "ByOrganization",
  ByProject = "ByProject",
  ByUser = "ByUser",
  ByWeek = "ByWeek"
}

export type BookingSkipTimereportReminderResults = {
  value?: Maybe<Scalars["Boolean"]>;
};

export type BookingStatus = {
  createdByUserId: Scalars["ObjectId"];
  createdByUserName: Scalars["String"];
  createdOn: Scalars["Date"];
  status: BookingStatusType;
};

export enum BookingStatusType {
  Billed = "Billed",
  Canceled = "Canceled",
  Closed = "Closed",
  Open = "Open",
  Paid = "Paid"
}

export type BookingSupportTagStatus = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  tag?: Maybe<Scalars["String"]>;
};

export type BookingSyncReport = {
  Groups: Array<BookingSyncReportGroup>;
  Items: Array<BookingSyncReportItem>;
  Total: Scalars["Float"];
};

export type BookingSyncReportGroup = {
  Total: Scalars["Float"];
  UserRef: UserRef;
};

export type BookingSyncReportItem = {
  ProjectName: Scalars["String"];
  Score: Scalars["Float"];
  UserRef: UserRef;
};

export enum BookingSystemEvents {
  AdditionalWorkOff = "AdditionalWorkOff",
  AdditionalWorkOn = "AdditionalWorkOn",
  Canceled = "Canceled",
  Created = "Created",
  EditCost = "EditCost",
  False = "False",
  InvoicePaidOff = "InvoicePaidOff",
  InvoicePaidOffEmp = "InvoicePaidOffEmp",
  InvoicePaidOn = "InvoicePaidOn",
  InvoicePaidOnEmp = "InvoicePaidOnEmp",
  RemoveAccConfirmation = "RemoveAccConfirmation",
  RemoveCustomerInvoice = "RemoveCustomerInvoice",
  RemoveSubcontractorDocument = "RemoveSubcontractorDocument",
  RemoveTravelConfirmation = "RemoveTravelConfirmation",
  RestoreAccConfirmation = "RestoreAccConfirmation",
  RestoreTravelConfirmation = "RestoreTravelConfirmation",
  Restored = "Restored",
  SaveInvoice = "SaveInvoice",
  True = "True",
  UpdateAccStatus = "UpdateAccStatus",
  UpdateFinanceStatus = "UpdateFinanceStatus",
  UpdatePatientId = "UpdatePatientId",
  UpdateSubContractorInvoice = "UpdateSubContractorInvoice",
  UpdateTravelStatus = "UpdateTravelStatus",
  UpdateWorkedHours = "UpdateWorkedHours",
  UploadSubCustomerInvoice = "UploadSubCustomerInvoice",
  UploadSubcontractorDocument = "UploadSubcontractorDocument",
  WriteNote = "WriteNote"
}

export type BookingTag = {
  booking: Scalars["Boolean"];
  bookingKit: Scalars["Boolean"];
  code: Scalars["String"];
  color: Scalars["String"];
  label?: Maybe<Scalars["String"]>;
};

export type BookingWeek = {
  AccommodationAudit?: Maybe<AccommodationTravelAudit>;
  AccommodationCost?: Maybe<Scalars["Float"]>;
  AccommodationDocuments: Array<Document>;
  AccommodationExpense: Scalars["Float"];
  AccommodationOK: Scalars["Boolean"];
  AccommodationRequired: Scalars["Boolean"];
  AccommodationStatus?: Maybe<AccommodationTravelStatus>;
  AdditionalWork: Scalars["Boolean"];
  AdditionalWorkNote: Scalars["String"];
  AreaOfExpertise: Scalars["String"];
  BookingAudit?: Maybe<BookingAudit>;
  BookingGroup: BookingGroup;
  BookingRef: NodeRef;
  Consultant?: Maybe<Consultant>;
  ConsultantRef: NodeRef;
  ConsultantSnapshot: BookingConsultantSnapshot;
  ContractType?: Maybe<ContractType>;
  ContractTypeAbbr: Scalars["String"];
  CostCenter?: Maybe<CostCenter>;
  CustomerFine: Scalars["Float"];
  CustomerNumber: Scalars["String"];
  Departments: Array<Customer>;
  DepartmentsRefs: Array<CustomerRef>;
  EmployeeSalary?: Maybe<Scalars["Float"]>;
  FinanceOK: Scalars["Boolean"];
  GroupInvoiceTotal?: Maybe<Scalars["Float"]>;
  Hospital?: Maybe<Customer>;
  HospitalRef: CustomerRef;
  InvoiceTotalGross: Scalars["Float"];
  InvoiceTotalGrossFmt: Scalars["String"];
  InvoiceTotalNet: Scalars["Float"];
  InvoiceTotalNetFmt: Scalars["String"];
  InvoicedTotal?: Maybe<Scalars["Float"]>;
  InvoicedTotalFmt?: Maybe<Scalars["String"]>;
  Invoices: Array<Maybe<BookingCustomerInvoice>>;
  IsCanceled: Scalars["Boolean"];
  IsConsultantPayed: Scalars["Boolean"];
  IsCustomerBilled: Scalars["Boolean"];
  IsDirect: Scalars["Boolean"];
  IsMarked: Scalars["Boolean"];
  Note: Scalars["String"];
  OrganizationRef: CustomerRef;
  OtherExpenses: Scalars["Float"];
  PatientId: Scalars["String"];
  ProfitNet?: Maybe<Scalars["Float"]>;
  ProfitNetFmt?: Maybe<Scalars["String"]>;
  ProfitRatio?: Maybe<Scalars["Float"]>;
  Project?: Maybe<Project>;
  Salary: Scalars["Float"];
  SubcontractorInvoiceTotal?: Maybe<Scalars["Float"]>;
  TimeReportStatus?: Maybe<TimeReportStatus>;
  TravelAudit?: Maybe<AccommodationTravelAudit>;
  TravelCost?: Maybe<Scalars["Float"]>;
  TravelDocuments: Array<Document>;
  TravelExpense: Scalars["Float"];
  TravelOK: Scalars["Boolean"];
  TravelRequired: Scalars["Boolean"];
  TravelStatus?: Maybe<AccommodationTravelStatus>;
  Week: Scalars["Date"];
  WorkRequestId: Scalars["ObjectId"];
  WorkRequestRef: NodeRef;
  _id: Scalars["ObjectId"];
  bookingAssignedTo?: Maybe<Array<Maybe<BookingAssignedTo>>>;
  bookingSupportTagStatus?: Maybe<Array<Maybe<BookingSupportTagStatus>>>;
};

export type BookingWeekCalendarItem = {
  Week: Scalars["Date"];
  _id: Scalars["ObjectId"];
};

export enum BookingWeekConsultantDocumentWithOutBookingType {
  AccTravelConfirmationsWithOutBooking = "AccTravelConfirmationsWithOutBooking",
  AccommodationInvoices = "AccommodationInvoices",
  BookingConfirmationToCustomer = "BookingConfirmationToCustomer",
  CallResponse = "CallResponse",
  Canceled = "Canceled",
  CreditUnderSupplierInvoice = "CreditUnderSupplierInvoice",
  OtherBookingWeekDocWithOutBookingType = "OtherBookingWeekDocWithOutBookingType",
  Receipts = "Receipts",
  RentalAdviceAgreement = "RentalAdviceAgreement"
}

export enum BookingWeekDocumentTypes {
  AccTravelConfirmationsWithOutBooking = "AccTravelConfirmationsWithOutBooking",
  AccommodationConfirmations = "AccommodationConfirmations",
  AccommodationTravelInvoices = "AccommodationTravelInvoices",
  BenefitTaxation = "BenefitTaxation",
  CallResponse = "CallResponse",
  CertifiedTimeReport = "CertifiedTimeReport",
  CreditUnderSupplierInvoice = "CreditUnderSupplierInvoice",
  ExpensesReceipts = "ExpensesReceipts",
  InvoiceDocs = "InvoiceDocs",
  InvoiceForm = "InvoiceForm",
  Other = "Other",
  PayForm = "PayForm",
  SalaryBasis = "SalaryBasis",
  SickPayBasis = "SickPayBasis",
  SickPayForm = "SickPayForm",
  StandingCertificateFromCustomer = "StandingCertificateFromCustomer",
  SubcontractorInvoices = "SubcontractorInvoices",
  SubcontractorPayForm = "SubcontractorPayForm",
  TimeReport = "TimeReport",
  TravelConfirmation = "TravelConfirmation",
  UncertifiedTimeReport = "UncertifiedTimeReport"
}

export type BookingWeekListItem = {
  AccommodationAudit?: Maybe<AccommodationTravelAudit>;
  AccommodationOK: Scalars["Boolean"];
  AccommodationRequired: Scalars["Boolean"];
  AccommodationStatus?: Maybe<AccommodationTravelStatus>;
  AreaOfExpertise: Scalars["String"];
  BookingAudit?: Maybe<BookingAudit>;
  BookingRef: NodeRef;
  ConsultantRef: NodeRef;
  ConsultantServicePreferences?: Maybe<Scalars["String"]>;
  ContractType?: Maybe<ContractType>;
  ContractTypeAbbr: Scalars["String"];
  CostCenterId?: Maybe<Scalars["String"]>;
  CostCenterName?: Maybe<Scalars["String"]>;
  CustomerNumber: Scalars["String"];
  DepartmentsRefs: Array<CustomerRef>;
  HospitalRef: CustomerRef;
  InvoiceNumbers?: Maybe<Array<Maybe<Scalars["String"]>>>;
  InvoiceTotalGrossFmt: Scalars["String"];
  InvoicedTotalFmt?: Maybe<Scalars["String"]>;
  IsCanceled: Scalars["Boolean"];
  IsConsultantPayed: Scalars["Boolean"];
  IsCustomerBilled: Scalars["Boolean"];
  IsMarked: Scalars["Boolean"];
  OrganizationRef: CustomerRef;
  ProfitNetFmt?: Maybe<Scalars["String"]>;
  ProfitRatio?: Maybe<Scalars["Float"]>;
  ProjectId?: Maybe<Scalars["String"]>;
  TimeReportStatus?: Maybe<TimeReportStatus>;
  TravelAudit?: Maybe<AccommodationTravelAudit>;
  TravelOK: Scalars["Boolean"];
  TravelRequired: Scalars["Boolean"];
  TravelStatus?: Maybe<AccommodationTravelStatus>;
  Week: Scalars["Date"];
  _id: Scalars["ObjectId"];
  bookingAssignedTo?: Maybe<Array<Maybe<BookingAssignedTo>>>;
  bookingStatus?: Maybe<BookingStatus>;
  bookingSupportTagComment?: Maybe<Scalars["String"]>;
  bookingSupportTagStatus?: Maybe<Array<Maybe<BookingSupportTagStatus>>>;
  callNumber?: Maybe<Scalars["String"]>;
  consultantContractId?: Maybe<Scalars["ObjectId"]>;
  customerContractId?: Maybe<Scalars["ObjectId"]>;
  /**
   * Where the demand for this week came from — the platform, e-mail or manual
   * work request it was won through. Set by the booking export queue; empty on
   * weeks created in the CRM and on weeks booked before it was recorded.
   */
  demandSource?: Maybe<Scalars["String"]>;
  /** Deep link into the platform the demand came from, where it has one. */
  demandSourceUrl?: Maybe<Scalars["String"]>;
  isHighPrior?: Maybe<Scalars["Int"]>;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  isTravelInvoiced?: Maybe<Scalars["Boolean"]>;
  lastKitCreationWfFailedAt?: Maybe<Scalars["Date"]>;
  projectName?: Maybe<Scalars["String"]>;
  projectNumber?: Maybe<Scalars["String"]>;
  requireTravelInvoicing?: Maybe<Scalars["Boolean"]>;
  /**
   * The channels this week's hours actually arrived on (ADR-0008), deduplicated.
   *
   * A different question from `demandSource`: a Bemlo-sourced week routinely has
   * its hours reported on paper. Empty when the week has no time report, no rows,
   * or only rows written before provenance was recorded.
   */
  timeReportRowSources: Array<TimeReportRowSource>;
  timeReportStatusSetBy?: Maybe<UserRef>;
  timeReportStatusSetOn?: Maybe<Scalars["Date"]>;
};

export type BookingWeekQueryInput = {
  accommodationStatus?: InputMaybe<Array<AccommodationTravelStatus>>;
  areasOfExpertise?: InputMaybe<Array<Scalars["String"]>>;
  assignedPersons?: InputMaybe<Array<Scalars["ObjectId"]>>;
  bookingStatus?: InputMaybe<Array<BookingStatusType>>;
  bookingSupportTag?: InputMaybe<Array<Scalars["String"]>>;
  callNumber?: InputMaybe<Scalars["String"]>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  costCenter?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  country?: InputMaybe<Array<Scalars["String"]>>;
  customerGroup?: InputMaybe<Array<Scalars["String"]>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerNumber?: InputMaybe<Scalars["String"]>;
  /**
   * Where the demand came from. Multi-select, because an HBA works one platform at
   * a time; the literal `Empty` selects the weeks nobody attributed, which is how
   * the gap in attribution is found rather than hidden.
   */
  demandSource?: InputMaybe<Array<Scalars["String"]>>;
  employeeId?: InputMaybe<Scalars["String"]>;
  from?: InputMaybe<Scalars["Date"]>;
  groupInvoicing?: InputMaybe<Scalars["String"]>;
  hasAccommodationBenefitTax?: InputMaybe<Scalars["String"]>;
  hasBookingKits?: InputMaybe<Scalars["String"]>;
  invoiceNumber?: InputMaybe<Scalars["String"]>;
  legalPersonType?: InputMaybe<LegalPersonTypeWithNoOption>;
  nationalProcurement?: InputMaybe<Scalars["String"]>;
  organizationType?: InputMaybe<Array<OrganizationType>>;
  patientId?: InputMaybe<Scalars["String"]>;
  projectId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  projectResponsiblePersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  region?: InputMaybe<Array<Scalars["String"]>>;
  responsiblePersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  specialization?: InputMaybe<Array<Scalars["String"]>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  timeReportStatus?: InputMaybe<Array<TimeReportStatus>>;
  timeReportStatusSetBy?: InputMaybe<Array<Scalars["ObjectId"]>>;
  to?: InputMaybe<Scalars["Date"]>;
  travelStatus?: InputMaybe<Array<AccommodationTravelStatus>>;
};

export type BookingWeekQueryResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<BookingWeekListItem>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  total?: Maybe<Scalars["Int"]>;
  totalDbTime?: Maybe<Scalars["Int"]>;
};

export type BookingWeeksCSVBackgroundResult = {
  result?: Maybe<Scalars["String"]>;
};

export type BookingWeeksCSVResult = {
  Filename: Scalars["String"];
  URL: Scalars["String"];
};

export type BookingWeeksTotalInput = {
  filter: BookingWeekQueryInput;
  singleMemberProjectIds: Array<Scalars["ObjectId"]>;
};

export type BookingWeeksTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum BulkActionCommunicationSubType {
  Information = "Information",
  JobMailing = "JobMailing",
  Marketing = "Marketing"
}

export type BulkActionInput = {
  payload: Scalars["JSON"];
  type: BulkActionType;
};

export type BulkActionResult = {
  actionId: Scalars["ObjectId"];
  error?: Maybe<Scalars["String"]>;
  status: BulkActionStatus;
};

export enum BulkActionStatus {
  Done = "Done",
  Error = "Error",
  Pending = "Pending",
  Running = "Running"
}

export enum BulkActionType {
  ConsultantAssignCallList = "ConsultantAssignCallList",
  ConsultantAssignTags = "ConsultantAssignTags",
  ConsultantDelete = "ConsultantDelete",
  ConsultantEmail = "ConsultantEmail",
  ConsultantExport = "ConsultantExport",
  ConsultantExportSsn = "ConsultantExportSsn",
  ConsultantOrderQualityDocuments = "ConsultantOrderQualityDocuments",
  ConsultantReassignBA = "ConsultantReassignBA",
  ConsultantSMS = "ConsultantSMS"
}

export type BulkUpdateResult = {
  consultants: Array<Consultant>;
  updated: Scalars["Int"];
};

export enum CacheControlScope {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC"
}

export type CallList = {
  _id: Scalars["ObjectId"];
  audit: Audit;
  deleted: Scalars["Boolean"];
  members: Array<UserRef>;
  name: Scalars["String"];
  nodes: Array<NodeRef>;
  type: NodeType;
};

export type CallListCreateInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  name: Scalars["String"];
  nodes: Array<NodeRefFullInput>;
  type: NodeType;
  userIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type CallListOpResult = {
  callList?: Maybe<CallList>;
};

export type CallListStats = {
  callListType?: Maybe<CallListType>;
  count?: Maybe<Scalars["Int"]>;
};

export enum CallListType {
  CallList = "CallList",
  ContactList = "ContactList"
}

export type CanDuplicateToTenantsResult = {
  items?: Maybe<Array<Maybe<CanDuplicateToTenantsResultItem>>>;
};

export type CanDuplicateToTenantsResultItem = {
  canDuplicate: Scalars["Boolean"];
  links?: Maybe<Array<Maybe<Scalars["String"]>>>;
  tenant: Scalars["String"];
};

export type CancelBookingResult = {
  Booking: Booking;
};

export enum CardType {
  OrdinaryCardBonliva = "OrdinaryCardBonliva",
  OrdinaryCardWCC = "OrdinaryCardWCC",
  OtherCard = "OtherCard",
  ReserveCardBonliva = "ReserveCardBonliva",
  ReserveCardWCC = "ReserveCardWCC"
}

export type CategoryBadge = {
  Category: TodoCategory;
  Done?: Maybe<Scalars["Int"]>;
  Read: Scalars["Int"];
  Unread: Scalars["Int"];
};

export type ChangeStatusConsultantReferenceInput = {
  adjustWorkRelationHistory?: InputMaybe<Scalars["Boolean"]>;
  status: ConsultantReferenceStatus;
  workRelation?: InputMaybe<ConsultantReferenceRelation>;
};

export type CheckContactExistsInput = {
  cellPhone?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  filterOut?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  ssn?: InputMaybe<Scalars["String"]>;
};

export type CheckContactExistsResult = {
  exact?: Maybe<Consultant>;
  similar: Array<Consultant>;
};

export type CityInhabitants = {
  city: Scalars["String"];
  inhabitants: Scalars["Int"];
  taxRegion: Scalars["String"];
};

export type Comment = {
  message?: Maybe<Scalars["String"]>;
};

export type CommentInput = {
  message: Scalars["String"];
};

export type Compensation = {
  Price?: Maybe<Scalars["Float"]>;
  Type?: Maybe<ConsultantContractPriceType>;
};

export type CompensationInput = {
  Price: Scalars["Float"];
  Type: ConsultantContractPriceType;
};

export type ConfigDoc = {
  blockBookingCreationForBemloCustomers: Scalars["Boolean"];
  bookingTags: Array<BookingTag>;
  cityInhabitants: Array<CityInhabitants>;
  competitors: Array<Scalars["String"]>;
  costCenters: Array<CostCenter>;
  countries: Array<Country>;
  customerGroups: Array<Scalars["String"]>;
  defaultTravelZones: Array<DefaultTravelZone>;
  expertises: Array<Expertise>;
  getSSKSpecializations: Array<Scalars["String"]>;
  languages: Array<Scalars["String"]>;
  nationalProcurementTravelRegions: Array<Scalars["String"]>;
  professionConfigs: Array<ProfessionConfig>;
  roles: Array<Role>;
  titles: Array<Scalars["String"]>;
  version: Scalars["Float"];
};

export type ConfirmAccommodationInput = {
  accommodationId?: InputMaybe<Scalars["ObjectId"]>;
  area: Scalars["Float"];
  bookingId: Scalars["ObjectId"];
  city?: InputMaybe<Scalars["String"]>;
  files: Array<Scalars["String"]>;
  offerId?: InputMaybe<Scalars["ObjectId"]>;
  squareFootageAttached?: InputMaybe<Scalars["Boolean"]>;
  totalCost: Scalars["Float"];
  totalExVAT?: InputMaybe<Scalars["Boolean"]>;
  weeks: Array<ConfirmAccommodationWeekInput>;
};

export type ConfirmAccommodationWeekInput = {
  cost: Scalars["Float"];
  endDate?: InputMaybe<Scalars["Date"]>;
  extraCost: Scalars["Float"];
  extraDescription?: InputMaybe<Scalars["String"]>;
  isTaxed: Scalars["Boolean"];
  nights: Scalars["Int"];
  note?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  tax: Scalars["Float"];
  weekYear: WeekYearInput;
};

export type ConfirmTravelInput = {
  bookingId: Scalars["ObjectId"];
  end?: InputMaybe<Scalars["Date"]>;
  files: Array<Scalars["String"]>;
  start?: InputMaybe<Scalars["Date"]>;
  totalCost?: InputMaybe<Scalars["String"]>;
  totalExVAT?: InputMaybe<Scalars["Boolean"]>;
  weeks: Array<ConfirmTravelWeekInput>;
};

export type ConfirmTravelWeekInput = {
  cost: Scalars["Float"];
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["Date"]>;
  isTravel: Scalars["Boolean"];
  note?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  weekYear: WeekYearInput;
};

export enum ConsentChannel {
  Email = "Email",
  Sms = "Sms"
}

export enum ConsentPurpose {
  JobMailing = "JobMailing",
  JobMailingCampaign = "JobMailingCampaign",
  Marketing = "Marketing",
  Transactional = "Transactional"
}

export type Consultant = IContact &
  INode & {
    AccommodationPreferences: Scalars["String"];
    Address?: Maybe<Address>;
    AreasOfExpertise: Array<Scalars["String"]>;
    Availability: ConsultantAvailability;
    AvailableForWorkInCountries: Array<Scalars["String"]>;
    AvatarPic?: Maybe<Scalars["String"]>;
    BirthDate?: Maybe<Scalars["Date"]>;
    BookingDocuments: Array<Document>;
    BusinessName?: Maybe<Scalars["String"]>;
    BusinessSocialSecurityNo?: Maybe<Scalars["String"]>;
    CellPhone?: Maybe<Scalars["String"]>;
    CellPhoneValid: Scalars["Boolean"];
    /** @deprecated Bad performance */
    ConsultantForm?: Maybe<ConsultantForm>;
    ContractSigned?: Maybe<Scalars["Boolean"]>;
    DocumentTypes: Array<Scalars["String"]>;
    Documents: Array<Document>;
    DocumentsShareable: Array<Document>;
    Email?: Maybe<Scalars["String"]>;
    EmailValid: Scalars["Boolean"];
    EmployeeNumber: Scalars["String"];
    Events: Array<ConsultantEvent>;
    FirstName?: Maybe<Scalars["String"]>;
    GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
    Intro?: Maybe<Scalars["String"]>;
    IsSocialSecurityNoExist?: Maybe<Scalars["Boolean"]>;
    IsValid?: Maybe<Scalars["Boolean"]>;
    KnownSystems: Array<Scalars["String"]>;
    LastContactDate?: Maybe<Scalars["Date"]>;
    LastMetInPerson?: Maybe<Scalars["Date"]>;
    LastName?: Maybe<Scalars["String"]>;
    LegalBasis?: Maybe<LegalBasis>;
    LegalPersonType?: Maybe<LegalPersonType>;
    Name?: Maybe<Scalars["String"]>;
    NodeName: Scalars["String"];
    NodeType: NodeType;
    Phone?: Maybe<Scalars["String"]>;
    PhoneValid: Scalars["Boolean"];
    PrescriptionCode?: Maybe<Scalars["String"]>;
    PresentationUrl: Scalars["String"];
    Professions?: Maybe<Array<Maybe<Scalars["String"]>>>;
    QualityPerCountry: Array<ConsultantQualityPerCountry>;
    ResponsiblePerson?: Maybe<UserRef>;
    Roles?: Maybe<Array<Scalars["String"]>>;
    SocialSecurityNo?: Maybe<Scalars["String"]>;
    Specializations: Array<Scalars["String"]>;
    Status?: Maybe<ConsultantStatus>;
    SubcontractorInfo?: Maybe<SubcontractorInfo>;
    Teams: Array<Scalars["String"]>;
    Title?: Maybe<Scalars["String"]>;
    TravelPreferences: Scalars["String"];
    Unfit: Scalars["Boolean"];
    UnfitComment: Scalars["String"];
    UnfitedBy?: Maybe<WeakUserRef>;
    UnfitedSetOn?: Maybe<Scalars["Date"]>;
    UserSettings: UserSettings;
    ValidationErrors: Array<NodeValidationError>;
    _id: Scalars["ObjectId"];
    availableCountries: Array<Scalars["String"]>;
    bookedPeriodEnd?: Maybe<Scalars["Date"]>;
    bookedPeriodStart?: Maybe<Scalars["Date"]>;
    bookingStatus: ConsultantBookingStatus;
    businessAddress?: Maybe<Address>;
    callListStats: Scalars["Int"];
    canCreateContractCheck: Array<Scalars["String"]>;
    canCreateSelfInvoicingContractCheck: Array<ConsultantContractSelfInvoicingCheck>;
    care: Scalars["String"];
    contactType?: Maybe<ConsultantContactTypeSection>;
    contracts: Array<ConsultantContractSnapshot>;
    createdAt?: Maybe<Scalars["Date"]>;
    drivingLicenceType?: Maybe<DrivingLicenceType>;
    expertise: ConsultantExpertise;
    generalInterest?: Maybe<ConsultantGeneralInterest>;
    hasDrivingLicence?: Maybe<Scalars["Boolean"]>;
    id?: Maybe<Scalars["ObjectId"]>;
    initialContact?: Maybe<InitialContact>;
    isCvDataAffected: Scalars["Boolean"];
    isNationalQualityApproved: Scalars["Boolean"];
    isNationalQualityExpired: Scalars["Boolean"];
    isPresentationReadyQualityApproved: Scalars["Boolean"];
    isPresentationReadyQualityExpired: Scalars["Boolean"];
    isQualityApproved: Scalars["Boolean"];
    isQualityExpired: Scalars["Boolean"];
    karens?: Maybe<Array<Maybe<ConsultantKarensItem>>>;
    leadStatus?: Maybe<ConsultantLeadStatusParams>;
    nationalQualification?: Maybe<NationalQualification>;
    nationalQualityApprovals: Array<QualityApproval>;
    nextContactDate?: Maybe<ConsultantNextContactDate>;
    pipelineStatus?: Maybe<ConsultantPipelineStatus>;
    pipelineStatusComment?: Maybe<Scalars["String"]>;
    preferredCommunication: Array<PreferredCommunication>;
    professions: Array<Maybe<ConsultantProfession>>;
    qualityApprovals: Array<QualityApproval>;
    qualityChecks: Array<ConsultantQualityCheck>;
    qualityNote?: Maybe<Scalars["String"]>;
    secondaryEmail?: Maybe<Scalars["String"]>;
    sithsCardNumber?: Maybe<Scalars["String"]>;
    tags: Array<Scalars["String"]>;
    type: NodeType;
    unfitType?: Maybe<ConsultantUnfitType>;
    updatedAt?: Maybe<Scalars["Date"]>;
    welcomeEmail?: Maybe<Scalars["Boolean"]>;
    welcomeEmailSetBy?: Maybe<Scalars["String"]>;
    welcomeEmailSetOn?: Maybe<Scalars["Date"]>;
    worksForCompetitors: Array<Scalars["String"]>;
  };

export type ConsultantEventsArgs = {
  text?: InputMaybe<Scalars["String"]>;
};

export type ConsultantContractsArgs = {
  params?: InputMaybe<ConsultantContractSnapshotParamsInput>;
};

export type ConsultantAvailability = {
  availableWeeksString: Scalars["String"];
  ranges: Array<ConsultantAvailabilityRange>;
  weeks: Array<Scalars["Date"]>;
};

export type ConsultantAvailabilityInput = {
  weeks: Array<Scalars["Date"]>;
};

export type ConsultantAvailabilityRange = {
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type ConsultantAvailableOnWeek = {
  Consultant: Consultant;
  Week: Scalars["Date"];
};

export type ConsultantBookingContract = {
  Address?: Maybe<Address>;
  AreaOfExpertise?: Maybe<Array<Maybe<Scalars["String"]>>>;
  BasicPrice?: Maybe<Scalars["Float"]>;
  Bonus?: Maybe<Array<Maybe<ConsultantContractBonus>>>;
  ConsultantId?: Maybe<Scalars["ObjectId"]>;
  ContactPerson?: Maybe<CustomerContactPerson>;
  ContractPriceTemplateId?: Maybe<Scalars["ObjectId"]>;
  DepartmentsRefs?: Maybe<CustomerRef>;
  EndDate?: Maybe<Scalars["String"]>;
  FileRef?: Maybe<FileRef>;
  HospitalRef?: Maybe<CustomerRef>;
  IntroductionPrice?: Maybe<Array<Maybe<ConsultantContractIntroductionPrice>>>;
  OtherInfo?: Maybe<Scalars["String"]>;
  Period?: Maybe<Scalars["String"]>;
  Price?: Maybe<Scalars["String"]>;
  PriceRecruitment?: Maybe<PriceRecruitment>;
  Profession?: Maybe<Scalars["String"]>;
  Recipients?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResponsiblePersonId?: Maybe<Scalars["ObjectId"]>;
  SalaryRecords?: Maybe<Array<Maybe<ContractsPriceRecord>>>;
  Schedule?: Maybe<Scalars["String"]>;
  SignedBy?: Maybe<UserRef>;
  SignedOn?: Maybe<Scalars["Date"]>;
  SpecificPeriodPrices?: Maybe<Array<Maybe<SpecificPeriodPrice>>>;
  SpecificRequirements?: Maybe<Array<Maybe<Scalars["String"]>>>;
  StartDate?: Maybe<Scalars["String"]>;
  Type?: Maybe<ConsultantBookingContractType>;
  _id?: Maybe<Scalars["ObjectId"]>;
  callNumber?: Maybe<Scalars["String"]>;
  hideDeptName?: Maybe<Scalars["Boolean"]>;
  hideHospitalName?: Maybe<Scalars["Boolean"]>;
  highHolidays?: Maybe<Array<Maybe<HighHoliday>>>;
  sithsCardNumber?: Maybe<Scalars["String"]>;
};

export type ConsultantBookingContractBonusInput = {
  Amount: Scalars["Float"];
  Config: Scalars["JSON"];
  Currency: Currency;
  Type: Scalars["String"];
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export type ConsultantBookingContractFormInput = {
  Address?: InputMaybe<AddressInput>;
  AreaOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  BasicPrice?: InputMaybe<Scalars["Float"]>;
  Bonus?: InputMaybe<Array<InputMaybe<ConsultantBookingContractBonusInput>>>;
  ContactPerson?: InputMaybe<CustomerContactPersonInput>;
  ContractPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
  ContractType?: InputMaybe<ConsultantBookingContractType>;
  DepartmentsRefs?: InputMaybe<CustomerRefInput>;
  EndDate?: InputMaybe<Scalars["Date"]>;
  HospitalRef?: InputMaybe<CustomerRefInput>;
  IntroductionPrice?: InputMaybe<
    Array<InputMaybe<ConsultantContractIntroductionPriceInput>>
  >;
  OtherInfo?: InputMaybe<Scalars["String"]>;
  Period?: InputMaybe<Scalars["String"]>;
  Price?: InputMaybe<Scalars["String"]>;
  PriceRecruitment?: InputMaybe<PriceRecruitmentInput>;
  Profession?: InputMaybe<Scalars["String"]>;
  Recipients?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  ResponsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  SalaryRecords?: InputMaybe<Array<InputMaybe<ContractPriceTemplateRecordInput>>>;
  Schedule?: InputMaybe<Scalars["String"]>;
  SpecificPeriodPrices?: InputMaybe<Array<InputMaybe<SpecificPeriodPriceInput>>>;
  SpecificRequirements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  StartDate?: InputMaybe<Scalars["Date"]>;
  callNumber?: InputMaybe<Scalars["String"]>;
  hideDeptName?: InputMaybe<Scalars["Boolean"]>;
  hideHospitalName?: InputMaybe<Scalars["Boolean"]>;
  highHolidays?: InputMaybe<Array<InputMaybe<HighHolidayInput>>>;
  sithsCardNumber?: InputMaybe<Scalars["String"]>;
};

export type ConsultantBookingContractListItem = {
  Attachment?: Maybe<Document>;
  ContactPerson?: Maybe<CustomerContactPerson>;
  CustomerCity?: Maybe<Scalars["String"]>;
  CustomerName?: Maybe<Scalars["String"]>;
  Dates?: Maybe<Scalars["String"]>;
  FileUrl?: Maybe<Scalars["String"]>;
  IsNullified?: Maybe<Scalars["Boolean"]>;
  IsSigned?: Maybe<Scalars["Boolean"]>;
  PublishedUrl?: Maybe<Scalars["String"]>;
  Recipients?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Type?: Maybe<ConsultantBookingContractType>;
  ViewUrl?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
  canDownload?: Maybe<Scalars["Boolean"]>;
  canDuplicate?: Maybe<Scalars["Boolean"]>;
  canEdit?: Maybe<Scalars["Boolean"]>;
  canPreview?: Maybe<Scalars["Boolean"]>;
};

export enum ConsultantBookingContractType {
  Confirmation = "Confirmation",
  Outsource = "Outsource"
}

export enum ConsultantBookingStatus {
  Booked = "Booked",
  BookedPreviously = "BookedPreviously",
  NeverBooked = "NeverBooked"
}

export type ConsultantByWorkExperienceItem = {
  consultant: Consultant;
  workExperience?: Maybe<ConsultantWorkExperienceItem>;
};

export type ConsultantByWorkExperienceResult = {
  items: Array<ConsultantByWorkExperienceItem>;
};

export type ConsultantCompetenceSection = {
  items: Array<ConsultantCompetenceSectionItem>;
};

export type ConsultantCompetenceSectionInput = {
  items: Array<ConsultantCompetenceSectionItemInput>;
};

export type ConsultantCompetenceSectionItem = {
  competenceName: Scalars["String"];
  fromYear?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  lastUsedYear?: Maybe<Scalars["String"]>;
};

export type ConsultantCompetenceSectionItemInput = {
  competenceName: Scalars["String"];
  fromYear?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  lastUsedYear?: InputMaybe<Scalars["String"]>;
};

export type ConsultantCompetitorsSection = {
  items: Array<Scalars["String"]>;
};

export type ConsultantCompetitorsSectionInput = {
  items: Array<Scalars["String"]>;
};

export type ConsultantContactTypeSection = {
  FTaxChecked?: Maybe<Scalars["Boolean"]>;
  VATChecked?: Maybe<Scalars["Boolean"]>;
  accountNumber?: Maybe<Scalars["String"]>;
  businessAddress?: Maybe<FormAddress>;
  clearingNumber?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  emailForSelfInvoicing?: Maybe<Scalars["String"]>;
  employeeContractType?: Maybe<ContractType>;
  employeeSalaryClaim?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  externalTaxNumber?: Maybe<Scalars["String"]>;
  increasedRate?: Maybe<Scalars["String"]>;
  rate?: Maybe<Scalars["String"]>;
  receiveWorkBreakdownByEmail?: Maybe<Scalars["Boolean"]>;
  ssn: Scalars["String"];
  startDate?: Maybe<Scalars["Date"]>;
  subcontractorSalaryClaim?: Maybe<Scalars["String"]>;
  type?: Maybe<LegalPersonType>;
};

export type ConsultantContactTypeSectionInput = {
  FTaxChecked?: InputMaybe<Scalars["Boolean"]>;
  VATChecked?: InputMaybe<Scalars["Boolean"]>;
  accountNumber?: InputMaybe<Scalars["String"]>;
  businessAddress?: InputMaybe<FormAddressInput>;
  clearingNumber?: InputMaybe<Scalars["String"]>;
  companyName?: InputMaybe<Scalars["String"]>;
  emailForSelfInvoicing?: InputMaybe<Scalars["String"]>;
  employeeContractType?: InputMaybe<ContractType>;
  employeeSalaryClaim?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["Date"]>;
  externalTaxNumber?: InputMaybe<Scalars["String"]>;
  increasedRate?: InputMaybe<Scalars["String"]>;
  rate?: InputMaybe<Scalars["String"]>;
  receiveWorkBreakdownByEmail?: InputMaybe<Scalars["Boolean"]>;
  ssn?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  subcontractorSalaryClaim?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<LegalPersonType>;
};

export type ConsultantContactsSection = {
  cellPhone: Scalars["String"];
  email: Scalars["String"];
  initialContact?: Maybe<InitialContact>;
  phone: Scalars["String"];
  preferredCommunication: Array<PreferredCommunication>;
  recommendedByConsultant?: Maybe<OptionObjectIDType>;
  secondaryEmail: Scalars["String"];
  selfRegisterOption?: Maybe<SelfRegisterOption>;
};

export type ConsultantContactsSectionInput = {
  cellPhone: Scalars["String"];
  email: Scalars["String"];
  initialContact?: InputMaybe<InitialContact>;
  phone: Scalars["String"];
  preferredCommunication: Array<PreferredCommunication>;
  recommendedByConsultant?: InputMaybe<OptionObjectIDInput>;
  secondaryEmail: Scalars["String"];
  selfRegisterOption?: InputMaybe<SelfRegisterOption>;
};

export type ConsultantContract = {
  Accommodation?: Maybe<AccommodationAlt>;
  Address?: Maybe<Address>;
  AreaOfExpertise?: Maybe<Scalars["String"]>;
  BasicPrice?: Maybe<Scalars["Float"]>;
  Bonus?: Maybe<Array<Maybe<ConsultantContractBonus>>>;
  Compensation?: Maybe<Compensation>;
  ConsultantGetsPaidPer?: Maybe<ConsultantGetsPaidPer>;
  ConsultantId?: Maybe<Scalars["ObjectId"]>;
  ContractPriceTemplateId?: Maybe<Scalars["ObjectId"]>;
  Country?: Maybe<Scalars["String"]>;
  Currency?: Maybe<ConsultantContractCurrency>;
  CustomerName?: Maybe<Scalars["String"]>;
  DateFrameworkContractTypeIsSigned?: Maybe<Scalars["String"]>;
  Dates?: Maybe<Scalars["String"]>;
  DepartmentsRefs?: Maybe<Array<Maybe<CustomerRef>>>;
  DriverLicense?: Maybe<Scalars["Boolean"]>;
  Education?: Maybe<EducationCC>;
  EndDate?: Maybe<Scalars["String"]>;
  ExcludeAddress?: Maybe<Scalars["Boolean"]>;
  FileName?: Maybe<Scalars["String"]>;
  FileRef?: Maybe<FileRef>;
  HospitalRef?: Maybe<CustomerRef>;
  IntroductionPrice?: Maybe<Array<Maybe<ConsultantContractIntroductionPrice>>>;
  InvestigationsNumber?: Maybe<Scalars["String"]>;
  IsRegionDalarna?: Maybe<Scalars["Boolean"]>;
  Language?: Maybe<Scalars["String"]>;
  NotRelevantMonthlyWeeklyPayouts?: Maybe<Scalars["Boolean"]>;
  NullificationReason?: Maybe<Scalars["String"]>;
  NullifiedBy?: Maybe<UserRef>;
  NullifiedOn?: Maybe<Scalars["Date"]>;
  OtherRequirements?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Overtime?: Maybe<ConsultantContractOvertimeOpt>;
  ParentContractId?: Maybe<Scalars["ObjectId"]>;
  PatientVisits?: Maybe<Scalars["String"]>;
  PayoutType?: Maybe<ConsultantContractPayoutType>;
  Period?: Maybe<Scalars["String"]>;
  Profession?: Maybe<Scalars["String"]>;
  SalaryChoice?: Maybe<ContractType>;
  SalaryRecords?: Maybe<Array<Maybe<ContractsPriceRecord>>>;
  Schedule?: Maybe<Scalars["String"]>;
  SignedBy?: Maybe<UserRef>;
  SignedOn?: Maybe<Scalars["Date"]>;
  Specializations?: Maybe<Array<Maybe<Scalars["String"]>>>;
  SpecificPeriodPrices?: Maybe<Array<Maybe<SpecificPeriodPrice>>>;
  SpecificRequirements?: Maybe<Array<Maybe<Scalars["String"]>>>;
  StartDate?: Maybe<Scalars["String"]>;
  Travels?: Maybe<TravelsAlt>;
  Type?: Maybe<ConsultantContractType>;
  YoEx?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
  hideDeptName?: Maybe<Scalars["Boolean"]>;
  highHolidays?: Maybe<Array<Maybe<HighHoliday>>>;
  isNationalProcurementPriceStrategy?: Maybe<Scalars["Boolean"]>;
  pensionModel?: Maybe<ContractPensionModel>;
  pensionSolution?: Maybe<ConsultantContractPensionSolution>;
  showOrgName?: Maybe<Scalars["Boolean"]>;
};

export enum ConsultantContractAccommodationAlt {
  BonlivaPayAccommodation = "BonlivaPayAccommodation",
  BonlivaPayAccommodationAllowance = "BonlivaPayAccommodationAllowance",
  BonlivaPayAccommodationAllowanceAgainstReceipt = "BonlivaPayAccommodationAllowanceAgainstReceipt",
  SupplierPayAccommodation = "SupplierPayAccommodation"
}

export type ConsultantContractBonus = {
  Amount?: Maybe<Scalars["Float"]>;
  Config?: Maybe<Scalars["JSON"]>;
  Currency?: Maybe<Currency>;
  SalaryType?: Maybe<ConsultantContractBonusType>;
  Type?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type ConsultantContractBonusInput = {
  Amount: Scalars["Float"];
  Config: Scalars["JSON"];
  Currency: Currency;
  SalaryType: ConsultantContractBonusType;
  Type: Scalars["String"];
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export enum ConsultantContractBonusType {
  GrossSalaryBonus = "GrossSalaryBonus",
  OtherBonus = "OtherBonus"
}

export enum ConsultantContractCurrency {
  Percentage = "Percentage",
  SEK = "SEK"
}

export type ConsultantContractFormInput = {
  Accommodation?: InputMaybe<AccommodationAltInput>;
  Address?: InputMaybe<AddressInput>;
  AreaOfExpertise?: InputMaybe<Scalars["String"]>;
  BasicPrice?: InputMaybe<Scalars["Float"]>;
  Bonus?: InputMaybe<Array<InputMaybe<ConsultantContractBonusInput>>>;
  ConsultantGetsPaidPer?: InputMaybe<ConsultantGetsPaidPer>;
  ContractPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
  ContractType: ConsultantContractType;
  Country?: InputMaybe<Scalars["String"]>;
  Currency?: InputMaybe<ConsultantContractCurrency>;
  DateFrameworkContractTypeIsSigned?: InputMaybe<Scalars["Date"]>;
  DepartmentsRefs?: InputMaybe<Array<InputMaybe<CustomerRefInput>>>;
  DriverLicense?: InputMaybe<Scalars["Boolean"]>;
  Education?: InputMaybe<EducationCCInput>;
  EndDate?: InputMaybe<Scalars["Date"]>;
  ExcludeAddress?: InputMaybe<Scalars["Boolean"]>;
  HospitalRef?: InputMaybe<CustomerRefInput>;
  IntroductionPrice?: InputMaybe<
    Array<InputMaybe<ConsultantContractIntroductionPriceInput>>
  >;
  InvestigationsNumber?: InputMaybe<Scalars["String"]>;
  IsRegionDalarna?: InputMaybe<Scalars["Boolean"]>;
  Language?: InputMaybe<Scalars["String"]>;
  NotRelevantMonthlyWeeklyPayouts?: InputMaybe<Scalars["Boolean"]>;
  OtherRequirements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  Overtime?: InputMaybe<ConsultantContractOvertimeOpt>;
  ParentContractId?: InputMaybe<Scalars["ObjectId"]>;
  PatientVisits?: InputMaybe<Scalars["String"]>;
  PayoutType?: InputMaybe<ConsultantContractPayoutType>;
  Period?: InputMaybe<Scalars["String"]>;
  Profession?: InputMaybe<Scalars["String"]>;
  SalaryChoice?: InputMaybe<ContractType>;
  SalaryRecords?: InputMaybe<Array<InputMaybe<ContractPriceTemplateRecordInput>>>;
  Schedule?: InputMaybe<Scalars["String"]>;
  Specializations?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  SpecificPeriodPrices?: InputMaybe<Array<InputMaybe<SpecificPeriodPriceInput>>>;
  SpecificRequirements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  StartDate?: InputMaybe<Scalars["Date"]>;
  Travels?: InputMaybe<TravelsAltInput>;
  YoEx?: InputMaybe<Scalars["String"]>;
  bankCounselling?: InputMaybe<Scalars["Boolean"]>;
  editsProofFileIds?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  hideDeptName?: InputMaybe<Scalars["Boolean"]>;
  highHolidays?: InputMaybe<Array<InputMaybe<HighHolidayInput>>>;
  isNationalProcurementPriceStrategy?: InputMaybe<Scalars["Boolean"]>;
  pensionModel?: InputMaybe<ContractPensionModel>;
  pensionSolution?: InputMaybe<ConsultantContractPensionSolution>;
  showOrgName?: InputMaybe<Scalars["Boolean"]>;
};

export type ConsultantContractIntroductionPrice = {
  Currency?: Maybe<Currency>;
  Description?: Maybe<Scalars["String"]>;
  Sum?: Maybe<Scalars["String"]>;
};

export type ConsultantContractIntroductionPriceInput = {
  Currency: Currency;
  Description: Scalars["String"];
  Sum: Scalars["Float"];
};

export type ConsultantContractListItem = {
  Attachment?: Maybe<Document>;
  ChildContracts?: Maybe<Array<Maybe<ConsultantContractListItem>>>;
  Consultant?: Maybe<Consultant>;
  CustomerCity?: Maybe<Scalars["String"]>;
  CustomerName?: Maybe<Scalars["String"]>;
  Dates?: Maybe<Scalars["String"]>;
  EndDate?: Maybe<Scalars["Date"]>;
  FileUrl?: Maybe<Scalars["String"]>;
  IsNullified?: Maybe<Scalars["Boolean"]>;
  IsSigned?: Maybe<Scalars["Boolean"]>;
  Name?: Maybe<Scalars["String"]>;
  NotRelevantMonthlyWeeklyPayouts?: Maybe<Scalars["Boolean"]>;
  NullificationReason?: Maybe<Scalars["String"]>;
  ParentContractId?: Maybe<Scalars["ObjectId"]>;
  ParentId?: Maybe<Scalars["String"]>;
  PayoutsAbbr?: Maybe<Scalars["String"]>;
  PdfUrl?: Maybe<Scalars["String"]>;
  Period?: Maybe<Scalars["String"]>;
  Profession?: Maybe<Scalars["String"]>;
  PublishedUrl?: Maybe<Scalars["String"]>;
  SalaryChoice?: Maybe<ContractType>;
  SalaryChoiceAbbr?: Maybe<Scalars["String"]>;
  StartDate?: Maybe<Scalars["Date"]>;
  Type?: Maybe<ConsultantContractType>;
  ViewUrl?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
  canDownload?: Maybe<Scalars["Boolean"]>;
  canDuplicate?: Maybe<Scalars["Boolean"]>;
  canEdit?: Maybe<Scalars["Boolean"]>;
  canNullify?: Maybe<Scalars["Boolean"]>;
  canPreview?: Maybe<Scalars["Boolean"]>;
  canPublishToOneFlowViaTicket?: Maybe<Scalars["Boolean"]>;
  canPublishToOneflowDirectly?: Maybe<Scalars["Boolean"]>;
  editsProof?: Maybe<Array<Maybe<EditProof>>>;
  pensionSolution?: Maybe<ConsultantContractPensionSolution>;
};

export type ConsultantContractMaxCost = {
  Currency?: Maybe<Currency>;
  Period?: Maybe<ConsultantContractPeriod>;
  Price?: Maybe<Scalars["Float"]>;
  SalaryType?: Maybe<ConsultantContractSalaryType>;
};

export type ConsultantContractMaxCostInput = {
  Currency?: InputMaybe<Currency>;
  Period?: InputMaybe<ConsultantContractPeriod>;
  Price?: InputMaybe<Scalars["Float"]>;
  SalaryType?: InputMaybe<ConsultantContractSalaryType>;
};

export enum ConsultantContractOvertimeOpt {
  NoSpecialOvertime = "NoSpecialOvertime",
  SKLBasedOvertime = "SKLBasedOvertime"
}

export enum ConsultantContractPayoutType {
  Monthly = "Monthly",
  Weekly = "Weekly"
}

export enum ConsultantContractPensionSolution {
  Full = "Full",
  Split = "Split"
}

export enum ConsultantContractPeriod {
  Day = "Day",
  Month = "Month",
  Week = "Week",
  WorkShift = "WorkShift"
}

export enum ConsultantContractPriceType {
  OfRevenue = "OfRevenue",
  PerDay = "PerDay",
  PerEmergencyCall = "PerEmergencyCall",
  PerHour = "PerHour",
  PerInquiry = "PerInquiry",
  PerMonth = "PerMonth",
  PerScreening = "PerScreening",
  PerShift = "PerShift",
  PerSurgery = "PerSurgery",
  PerWeek = "PerWeek"
}

export enum ConsultantContractSalaryType {
  GrossSalary = "GrossSalary",
  NetSalary = "NetSalary"
}

export enum ConsultantContractSelfInvoicingCheck {
  MustBeSubcontractor = "MustBeSubcontractor",
  MustBeSwedishResident = "MustBeSwedishResident",
  MustHaveBusinessAddress = "MustHaveBusinessAddress",
  MustHaveBusinessName = "MustHaveBusinessName",
  MustHaveBusinessSSN = "MustHaveBusinessSSN",
  MustHaveEmail = "MustHaveEmail",
  MustHaveFTaxChecked = "MustHaveFTaxChecked",
  MustHaveResponsiblePerson = "MustHaveResponsiblePerson",
  MustHaveSSN = "MustHaveSSN",
  MustHaveVATChecked = "MustHaveVATChecked"
}

export type ConsultantContractSnapshot = {
  endDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ObjectId"];
  startDate?: Maybe<Scalars["Date"]>;
};

export type ConsultantContractSnapshotParamsInput = {
  isActive?: InputMaybe<Scalars["Boolean"]>;
  isSigned?: InputMaybe<Scalars["Boolean"]>;
};

export enum ConsultantContractTravelsAlt {
  BonlivaPayTravel = "BonlivaPayTravel",
  BonlivaPayTravelAllowance = "BonlivaPayTravelAllowance",
  BonlivaPayTravelAllowanceAgainstReceipt = "BonlivaPayTravelAllowanceAgainstReceipt",
  ConsultantTaxCompensationAllowance = "ConsultantTaxCompensationAllowance",
  SupplierPayTravel = "SupplierPayTravel",
  TravelTemplate = "TravelTemplate"
}

export type ConsultantContractTravelsMaxCost = {
  Currency?: Maybe<Currency>;
  Period?: Maybe<ConsultantContractTravelsPeriod>;
  Price?: Maybe<Scalars["Float"]>;
  SalaryType?: Maybe<ConsultantContractSalaryType>;
};

export type ConsultantContractTravelsMaxCostInput = {
  Currency?: InputMaybe<Currency>;
  Period?: InputMaybe<ConsultantContractTravelsPeriod>;
  Price?: InputMaybe<Scalars["Float"]>;
  SalaryType?: InputMaybe<ConsultantContractSalaryType>;
};

export enum ConsultantContractTravelsPeriod {
  Day = "Day",
  Mile = "Mile",
  Month = "Month",
  PerTravel = "PerTravel",
  Week = "Week",
  WorkShift = "WorkShift"
}

export enum ConsultantContractType {
  BC_Framework = "BC_Framework",
  BC_Framework_Confirmation = "BC_Framework_Confirmation",
  BC_Intermittent = "BC_Intermittent",
  BC_Intermittent_Confirmation = "BC_Intermittent_Confirmation",
  Confirmation = "Confirmation",
  ConfirmationForEmployees = "ConfirmationForEmployees",
  ConfirmationForEmployees_National = "ConfirmationForEmployees_National",
  Confirmation_National = "Confirmation_National",
  Employment = "Employment",
  Employment_National = "Employment_National",
  Framework = "Framework",
  Framework_National = "Framework_National",
  Intermittent = "Intermittent",
  Intermittent_National = "Intermittent_National",
  Outsource = "Outsource",
  Outsource_National = "Outsource_National",
  SelfInvoicing = "SelfInvoicing"
}

export type ConsultantEducationSection = {
  items: Array<ConsultantEducationSectionItem>;
};

export type ConsultantEducationSectionInput = {
  items: Array<ConsultantEducationSectionItemInput>;
};

export type ConsultantEducationSectionItem = {
  courseLocation: Scalars["String"];
  courseName: Scalars["String"];
  educationType?: Maybe<Scalars["String"]>;
  from?: Maybe<Scalars["Date"]>;
  fromMonth?: Maybe<Scalars["String"]>;
  fromYear?: Maybe<Scalars["String"]>;
  isCourse?: Maybe<Scalars["Boolean"]>;
  to?: Maybe<Scalars["Date"]>;
  toMonth?: Maybe<Scalars["String"]>;
  toYear?: Maybe<Scalars["String"]>;
};

export type ConsultantEducationSectionItemInput = {
  courseLocation?: InputMaybe<Scalars["String"]>;
  courseName?: InputMaybe<Scalars["String"]>;
  educationType?: InputMaybe<Scalars["String"]>;
  fromMonth?: InputMaybe<Scalars["String"]>;
  fromYear?: InputMaybe<Scalars["String"]>;
  isCourse?: InputMaybe<Scalars["Boolean"]>;
  toMonth?: InputMaybe<Scalars["String"]>;
  toYear?: InputMaybe<Scalars["String"]>;
};

export enum ConsultantEducationType {
  AHLR = "AHLR",
  HLR = "HLR",
  SHLR = "SHLR"
}

export type ConsultantEmergencyContactsSection = {
  items: Array<ConsultantEmergencyContactsSectionItem>;
};

export type ConsultantEmergencyContactsSectionInput = {
  items: Array<ConsultantEmergencyContactsSectionItemInput>;
};

export type ConsultantEmergencyContactsSectionItem = {
  name: Scalars["String"];
  phone: Scalars["String"];
  relation: Scalars["String"];
};

export type ConsultantEmergencyContactsSectionItemInput = {
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type ConsultantEmployeeNumberSection = {
  employeeNumber: Scalars["String"];
  employeeNumber2: Scalars["String"];
  employeeNumber3: Scalars["String"];
};

export type ConsultantEmployeeNumberSectionInput = {
  employeeNumber: Scalars["String"];
  employeeNumber2: Scalars["String"];
  employeeNumber3: Scalars["String"];
};

export type ConsultantEvaluateContactsSection = {
  items: Array<ConsultantEvaluateContactsSectionItem>;
};

export type ConsultantEvaluateContactsSectionItem = {
  name: Scalars["String"];
  phone: Scalars["String"];
};

export type ConsultantEvaluatesSection = {
  items?: Maybe<Array<ConsultantEvaluatesSectionItem>>;
};

export type ConsultantEvaluatesSectionInput = {
  items: Array<ConsultantEvaluatesSectionItemInput>;
};

export type ConsultantEvaluatesSectionItem = {
  _id: Scalars["ObjectId"];
  deleted?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  workPlace?: Maybe<Scalars["String"]>;
};

export type ConsultantEvaluatesSectionItemInput = {
  _id: Scalars["ObjectId"];
  deleted?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  workPlace?: InputMaybe<Scalars["String"]>;
};

export type ConsultantEvent = Event & {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  EmailBody?: Maybe<Scalars["HTML"]>;
  EmailDescription?: Maybe<Scalars["String"]>;
  EmailRecipients?: Maybe<Array<EmailRecipient>>;
  EmailSubject?: Maybe<Scalars["String"]>;
  Links?: Maybe<Array<Scalars["String"]>>;
  MetBy?: Maybe<WeakUserRef>;
  Node: NodeRef;
  SMSMessage?: Maybe<SMSMessage>;
  SMSMessageID?: Maybe<Scalars["String"]>;
  SMSStatusLegacy?: Maybe<Scalars["String"]>;
  Sticky: Scalars["Boolean"];
  TodoItem?: Maybe<TodoItem>;
  TodoRef?: Maybe<NodeRef>;
  Type: ConsultantEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum ConsultantEventTag {
  ClearConsultantQualityItem = "ClearConsultantQualityItem",
  SetConsultantQualityItem = "SetConsultantQualityItem"
}

export enum ConsultantEventType {
  Call = "Call",
  Comment = "Comment",
  ConsultantApp = "ConsultantApp",
  Document = "Document",
  Email = "Email",
  GDPR = "GDPR",
  Interest = "Interest",
  MarketingMessage = "MarketingMessage",
  MetInPerson = "MetInPerson",
  Noanswer = "Noanswer",
  QualityUpdate = "QualityUpdate",
  Registered = "Registered",
  Reminder = "Reminder",
  SMS = "SMS",
  SystemLog = "SystemLog",
  UserSettings = "UserSettings",
  WelcomeEmail = "WelcomeEmail"
}

export type ConsultantExpertise = {
  educations: Array<Scalars["String"]>;
  machines: Array<Scalars["String"]>;
  methods: Array<Scalars["String"]>;
  professions?: Maybe<Array<ConsultantProfession>>;
  systems: Array<Maybe<Scalars["String"]>>;
};

export type ConsultantExpertiseSectionSpecialization = {
  experienced: Scalars["Boolean"];
  interested: Scalars["Boolean"];
  name: Scalars["String"];
};

export type ConsultantExpertiseSectionSpecializationInput = {
  experienced?: InputMaybe<Scalars["Boolean"]>;
  interested?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
};

export type ConsultantExportCSVResult = {
  Filename: Scalars["String"];
  URL: Scalars["String"];
};

export type ConsultantForm = {
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  address: FormAddress;
  competitors: ConsultantCompetitorsSection;
  consultantId: Scalars["ObjectId"];
  contactType: ConsultantContactTypeSection;
  contacts: ConsultantContactsSection;
  education: ConsultantEducationSection;
  emergencyContacts: ConsultantEmergencyContactsSection;
  employeeNumber: ConsultantEmployeeNumberSection;
  extraCurriculum?: Maybe<Scalars["String"]>;
  isNew: Scalars["Boolean"];
  knownSystems?: Maybe<Array<Maybe<Scalars["String"]>>>;
  languageSkills?: Maybe<ConsultantLanguageSkillsSection>;
  personal: ConsultantPersonalSection;
  prescriptionCode: ConsultantPrescriptionCodeSection;
  status?: Maybe<ConsultantStatus>;
  workExperience: ConsultantWorkExperienceSection;
};

export type ConsultantFormInput = {
  GDPRConsentRecords?: InputMaybe<Array<InputMaybe<GDPRInput>>>;
  address?: InputMaybe<FormAddressInput>;
  competitors?: InputMaybe<ConsultantCompetitorsSectionInput>;
  consultantId: Scalars["ObjectId"];
  contactType?: InputMaybe<ConsultantContactTypeSectionInput>;
  contacts?: InputMaybe<ConsultantContactsSectionInput>;
  education?: InputMaybe<ConsultantEducationSectionInput>;
  emergencyContacts?: InputMaybe<ConsultantEmergencyContactsSectionInput>;
  employeeNumber?: InputMaybe<ConsultantEmployeeNumberSectionInput>;
  extraCurriculum?: InputMaybe<Scalars["String"]>;
  isNew: Scalars["Boolean"];
  knownSystems?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  languageSkills?: InputMaybe<ConsultantLanguageSkillsSectionInput>;
  personal?: InputMaybe<ConsultantPersonalSectionInput>;
  prescriptionCode?: InputMaybe<ConsultantPrescriptionCodeSectionInput>;
  professions: Array<ConsultantProfessionInput>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  status?: InputMaybe<ConsultantStatus>;
  workExperience?: InputMaybe<ConsultantWorkExperienceSectionInput>;
};

export type ConsultantFormResult = {
  Consultant?: Maybe<Consultant>;
  ConsultantForm?: Maybe<ConsultantForm>;
  Errors?: Maybe<Array<Scalars["String"]>>;
  OK: Scalars["Boolean"];
  ValidationErrors?: Maybe<Array<ValidationError>>;
};

export type ConsultantGeneralInterest = {
  comment: Scalars["String"];
  regions: Array<Scalars["String"]>;
  workshifts: Array<Workshift>;
};

export type ConsultantGeneralInterestInput = {
  comment: Scalars["String"];
  regions: Array<Scalars["String"]>;
  workshifts: Array<Workshift>;
};

export enum ConsultantGetsPaidPer {
  Hour = "Hour",
  Investigation = "Investigation"
}

export type ConsultantImportDocumentResult = {
  Rows: Array<Maybe<ConsultantImportRow>>;
};

export type ConsultantImportRow = {
  AreaOfExpertise: Array<Scalars["String"]>;
  CellPhone: Scalars["String"];
  Competitor: Scalars["String"];
  CompetitorSource: Scalars["String"];
  Duplicate?: Maybe<Consultant>;
  Errors: Array<Maybe<ConsultantRowError>>;
  FirstName: Scalars["String"];
  HPRNumber: Scalars["String"];
  InitialComment: Scalars["String"];
  IsDuplicate?: Maybe<Scalars["Boolean"]>;
  IsLookupSuccess?: Maybe<Scalars["Boolean"]>;
  LastName: Scalars["String"];
  Meta: ImportConsultantMeta;
  Phone: Scalars["String"];
  ResponsiblePerson?: Maybe<UserRef>;
  ResponsiblePersonSource?: Maybe<WeakUserRef>;
  RowID?: Maybe<Scalars["Int"]>;
  SocialSecurityNo?: Maybe<Scalars["String"]>;
  SocialSecurityNoSource?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  isApprovedAuthorization?: Maybe<Scalars["Boolean"]>;
  streetName?: Maybe<Scalars["String"]>;
  zipCode?: Maybe<Scalars["String"]>;
};

export type ConsultantImportRowsInput = {
  AreasOfExpertise: Array<Scalars["String"]>;
  CellPhone: Scalars["String"];
  Competitor?: InputMaybe<Scalars["String"]>;
  FirstName: Scalars["String"];
  HPRNumber?: InputMaybe<Scalars["String"]>;
  InitialComment?: InputMaybe<Scalars["String"]>;
  LastName: Scalars["String"];
  Meta: ImportConsultantMetaInput;
  Phone: Scalars["String"];
  ResponsiblePerson?: InputMaybe<UserRefInputStrict>;
  RowID?: InputMaybe<Scalars["Int"]>;
  SocialSecurityNo?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  isApprovedAuthorization?: InputMaybe<Scalars["Boolean"]>;
  streetName?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type ConsultantKarensInput = {
  karens: Array<ConsultantKarensItemInput>;
};

export type ConsultantKarensItem = {
  expDate: Scalars["String"];
  region: Scalars["String"];
};

export type ConsultantKarensItemInput = {
  expDate: Scalars["String"];
  region: Scalars["String"];
};

export type ConsultantLanguageSkillsSection = {
  items: Array<ConsultantLanguageSkillsSectionItem>;
};

export type ConsultantLanguageSkillsSectionInput = {
  items: Array<ConsultantLanguageSkillsSectionItemInput>;
};

export type ConsultantLanguageSkillsSectionItem = {
  level: LanguageSkillLevel;
  name: Scalars["String"];
};

export type ConsultantLanguageSkillsSectionItemInput = {
  level: LanguageSkillLevel;
  name: Scalars["String"];
};

export enum ConsultantLeadStatus {
  Assigned = "Assigned",
  BadTiming = "BadTiming",
  ContactedNoAnswer = "ContactedNoAnswer",
  NotContacted = "NotContacted",
  NotRelevant = "NotRelevant",
  RelevantLater = "RelevantLater",
  Unknown = "Unknown",
  Warm = "Warm"
}

export enum ConsultantLeadStatusCustom {
  BadTiming = "BadTiming",
  NotRelevant = "NotRelevant",
  RelevantLater = "RelevantLater",
  Unknown = "Unknown",
  Warm = "Warm"
}

export type ConsultantLeadStatusInput = {
  isResponsibleHBA: Scalars["Boolean"];
  leadStatus: ConsultantLeadStatusCustom;
  nextContactDate?: InputMaybe<Scalars["Date"]>;
  reason?: InputMaybe<NextContactDateReason>;
  reasonComment?: InputMaybe<Scalars["String"]>;
};

export type ConsultantLeadStatusParams = {
  comment?: Maybe<Scalars["String"]>;
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status: ConsultantLeadStatus;
};

export type ConsultantMatchingItem = {
  consultant: Consultant;
  minutesTotal: Scalars["Int"];
  weeksTotal: Scalars["Int"];
};

export type ConsultantMatchingParams = {
  customerId: Scalars["ObjectId"];
};

export type ConsultantMatchingResult = {
  items: Array<ConsultantMatchingItem>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  total: Scalars["Int"];
};

export type ConsultantNextContactDate = {
  date?: Maybe<Scalars["Date"]>;
  reason?: Maybe<Scalars["String"]>;
};

export type ConsultantOpportunity = {
  _id: Scalars["ObjectId"];
  areaOfExpertise?: Maybe<Scalars["String"]>;
  consultant?: Maybe<Consultant>;
  costCenter?: Maybe<CostCenter>;
  createdAt: Scalars["Date"];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  isShared?: Maybe<Scalars["Boolean"]>;
  originalIssue?: Maybe<ConsultantOpportunity>;
  users: Array<User>;
  weeks: Array<Scalars["Date"]>;
  weeksLost?: Maybe<Array<Scalars["Date"]>>;
  weeksLostString: Scalars["String"];
  weeksString: Scalars["String"];
  weeksWon?: Maybe<Array<Scalars["Date"]>>;
  weeksWonString: Scalars["String"];
};

export type ConsultantOpportunityCard = KanbanCard & {
  _id: Scalars["String"];
  assignee?: Maybe<User>;
  boardId: Scalars["String"];
  columnId: Scalars["String"];
  consultantOpportunity: ConsultantOpportunity;
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  order: Scalars["Int"];
  title: Scalars["String"];
};

export type ConsultantOpportunityIssueWeeks = {
  lostWeeks: Array<Scalars["Date"]>;
  openWeeks: Array<Scalars["Date"]>;
  wonWeeks: Array<Scalars["Date"]>;
};

export type ConsultantOpportunityStats = {
  lostWeeks: Scalars["Float"];
  openWeeks: Scalars["Float"];
  presentedWeeks: Scalars["Float"];
  wonWeeks: Scalars["Float"];
};

export type ConsultantPayoutByYear = {
  total: Scalars["Float"];
  totalNationalProcurement: Scalars["Float"];
  totalNonNationalProcurement: Scalars["Float"];
  year: Scalars["Int"];
};

export type ConsultantPersonalSection = {
  about: Scalars["String"];
  accommodationPreferences: Scalars["String"];
  care: Scalars["String"];
  commentAuthorization: Scalars["String"];
  countries: Array<Scalars["String"]>;
  drivingLicenceType?: Maybe<DrivingLicenceTypeInput>;
  firstComment: Scalars["String"];
  firstName: Scalars["String"];
  hasDrivingLicence: Scalars["Boolean"];
  hprNumber: Scalars["String"];
  important: Scalars["String"];
  intro: Scalars["String"];
  isApprovedAuthorization: Scalars["Boolean"];
  isWorkedNorway: Scalars["Boolean"];
  lastName: Scalars["String"];
  norwayConsultantStatus?: Maybe<NorwayConsultantStatus>;
  norwegianSsn: Scalars["String"];
  ssn: Scalars["String"];
  travelPreferences: Scalars["String"];
};

export type ConsultantPersonalSectionInput = {
  about: Scalars["String"];
  accommodationPreferences: Scalars["String"];
  care: Scalars["String"];
  commentAuthorization: Scalars["String"];
  countries: Array<Scalars["String"]>;
  drivingLicenceType?: InputMaybe<DrivingLicenceTypeInput>;
  firstComment: Scalars["String"];
  firstName: Scalars["String"];
  hasDrivingLicence: Scalars["Boolean"];
  hprNumber: Scalars["String"];
  important: Scalars["String"];
  intro: Scalars["String"];
  isApprovedAuthorization: Scalars["Boolean"];
  isWorkedNorway: Scalars["Boolean"];
  lastName: Scalars["String"];
  norwayConsultantStatus?: InputMaybe<NorwayConsultantStatus>;
  norwegianSsn: Scalars["String"];
  ssn: Scalars["String"];
  travelPreferences: Scalars["String"];
};

export type ConsultantPipelineCard = KanbanCard & {
  _id: Scalars["String"];
  assignee?: Maybe<User>;
  boardId: Scalars["String"];
  columnId: Scalars["String"];
  consultant: Consultant;
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  order: Scalars["Int"];
  title: Scalars["String"];
};

export enum ConsultantPipelineStatus {
  Booked = "Booked",
  NotPlaced = "NotPlaced",
  NotRelevant = "NotRelevant",
  Presented = "Presented",
  ReadyToBePresented = "ReadyToBePresented",
  RelevantInTheFuture = "RelevantInTheFuture",
  RelevantNow = "RelevantNow",
  Warm = "Warm"
}

export type ConsultantPrescriptionCodeSection = {
  code: Scalars["String"];
};

export type ConsultantPrescriptionCodeSectionInput = {
  code: Scalars["String"];
};

export type ConsultantPresentation = {
  ViewURL: Scalars["String"];
  _id: Scalars["ObjectId"];
};

export enum ConsultantPresentationCountry {
  Denmark = "Denmark",
  Norway = "Norway",
  Sweden = "Sweden"
}

export enum ConsultantPresentationType {
  AboutMe = "AboutMe",
  CustomText = "CustomText",
  IntroText = "IntroText",
  NoText = "NoText"
}

export type ConsultantProfession = {
  certifiedFrom?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
};

export type ConsultantProfessionInput = {
  doctorProfession?: InputMaybe<DoctorProfessionInput>;
  genericProfession?: InputMaybe<GenericProfessionInput>;
  nurseProfession?: InputMaybe<NurseProfessionInput>;
  professionName: Scalars["String"];
  psykologProfession?: InputMaybe<PsykologProfessionInput>;
  radiographersProfession?: InputMaybe<RadioNurseProfessionInput>;
  socionomProfession?: InputMaybe<SocionomProfessionInput>;
  teacherProfession?: InputMaybe<TeacherProfessionInput>;
  type: ProfessionInputType;
};

export type ConsultantQualityCheck = {
  comment: Scalars["String"];
  country: Scalars["String"];
  expirationDate?: Maybe<Scalars["Date"]>;
  isPartiallyExpired: Scalars["Boolean"];
  itemName: Scalars["String"];
  params?: Maybe<Scalars["JSON"]>;
  setDate?: Maybe<Scalars["Date"]>;
  status?: Maybe<Scalars["String"]>;
};

export enum ConsultantQualityCheckStatus {
  Expired = "Expired",
  ExpiresSoon = "ExpiresSoon",
  NotSet = "NotSet",
  Valid = "Valid"
}

export type ConsultantQualityItem = {
  AvailableStatuses: Array<ConsultantQualityItemAvailableStatus>;
  Country: Scalars["String"];
  Disabled: Scalars["Boolean"];
  DisabledMsg?: Maybe<Scalars["String"]>;
  DocumentType?: Maybe<Scalars["String"]>;
  ExpiresOn?: Maybe<Scalars["Date"]>;
  ExpiresSoon?: Maybe<Scalars["Boolean"]>;
  HasDocument: Scalars["Boolean"];
  HasExpired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  Status?: Maybe<ConsultantQualityStatus>;
  StatusSetBy?: Maybe<UserRef>;
  StatusSetOn?: Maybe<Scalars["Date"]>;
  _id: Scalars["ObjectId"];
  templateName: Scalars["String"];
};

export type ConsultantQualityItemAvailableStatus = {
  Disabled?: Maybe<Scalars["Boolean"]>;
  DisabledMsg?: Maybe<Scalars["String"]>;
  IsCommentRequired: Scalars["Boolean"];
  IsDocumentRequired: Scalars["Boolean"];
  Name: Scalars["String"];
  WithComment: Scalars["Boolean"];
  WithDocument: Scalars["Boolean"];
};

export type ConsultantQualityPerCountry = {
  Country: Scalars["String"];
  QualityChecks: Array<ConsultantQualityItem>;
};

export enum ConsultantQualityReferenceType {
  CurrentBoss = "CurrentBoss",
  CurrentColleague = "CurrentColleague",
  FormerBoss = "FormerBoss",
  FormerColleague = "FormerColleague",
  LatestBoss = "LatestBoss"
}

export enum ConsultantQualityReferenceVariant {
  Evaluate = "Evaluate",
  EvaluateToThreeMonths = "EvaluateToThreeMonths",
  Reference = "Reference",
  UUNationalCrossQuestions = "UUNationalCrossQuestions"
}

export type ConsultantQualityStatus = {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export enum ConsultantQueryBookingStatus {
  BookingsInPeriod = "BookingsInPeriod",
  BookingsInPeriodButNotAfter = "BookingsInPeriodButNotAfter",
  HasBookingsFromDate = "HasBookingsFromDate",
  NoBookings = "NoBookings",
  NoBookingsBeforeDate = "NoBookingsBeforeDate",
  NoBookingsFromDate = "NoBookingsFromDate",
  NoBookingsFromDateBookedPreviously = "NoBookingsFromDateBookedPreviously",
  NoBookingsInPeriod = "NoBookingsInPeriod"
}

export type ConsultantReferenceDocument = {
  document: Document;
  name: Scalars["String"];
  referenceId: Scalars["ObjectId"];
  type: ConsultantReferenceType;
  workRelation?: Maybe<ConsultantReferenceRelation>;
};

export type ConsultantReferenceFormNew = {
  submittedAt?: Maybe<Scalars["Date"]>;
  submittedBy?: Maybe<NodeRefNew>;
};

export type ConsultantReferenceFormSubmissionHistory = {
  submittedAt?: Maybe<Scalars["Date"]>;
  submittedBy?: Maybe<Scalars["String"]>;
};

export type ConsultantReferenceInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  deleted?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type ConsultantReferenceInputNew = {
  areaOfExpertise: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  formType?: InputMaybe<ConsultantReferenceType>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  position: Scalars["String"];
  workPlace: Scalars["String"];
};

export type ConsultantReferenceNew = {
  _id: Scalars["ObjectId"];
  areaOfExpertise: Scalars["String"];
  canBeReSentToRef: Scalars["Boolean"];
  canBeSentToRef: Scalars["Boolean"];
  deleted: Scalars["Boolean"];
  document?: Maybe<Document>;
  editLink?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  form?: Maybe<ConsultantReferenceFormNew>;
  formLink?: Maybe<Scalars["String"]>;
  formType?: Maybe<ConsultantReferenceType>;
  lastStatusHistory: ConsultantReferenceStatusHistory;
  migrated?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  orderedUpdateFromKvk?: Maybe<Scalars["Boolean"]>;
  phone?: Maybe<Scalars["String"]>;
  position: Scalars["String"];
  reShared?: Maybe<Scalars["Boolean"]>;
  reminders?: Maybe<Array<ConsultantReferenceReminder>>;
  status: ConsultantReferenceStatus;
  submissionHistory?: Maybe<Array<Maybe<ConsultantReferenceFormSubmissionHistory>>>;
  updatedOn?: Maybe<Scalars["Date"]>;
  workPlace: Scalars["String"];
  workRelation?: Maybe<ConsultantReferenceRelation>;
};

export enum ConsultantReferenceRelation {
  CurrentBoss = "CurrentBoss",
  CurrentColleague = "CurrentColleague",
  FormerBoss = "FormerBoss",
  FormerColleague = "FormerColleague",
  LatestBoss = "LatestBoss"
}

export type ConsultantReferenceReminder = {
  createdAt: Scalars["Date"];
  sentTo: Scalars["String"];
};

export enum ConsultantReferenceReminderType {
  EightDays = "EightDays",
  FourDays = "FourDays",
  FourteenDays = "FourteenDays",
  SevenDays = "SevenDays",
  SixMonthsWarning = "SixMonthsWarning"
}

export enum ConsultantReferenceStatus {
  Approved = "Approved",
  ApprovedWithException = "ApprovedWithException",
  AwaitingApproval = "AwaitingApproval",
  Empty = "Empty",
  NotApproved = "NotApproved",
  NotRequested = "NotRequested",
  RequestExpired = "RequestExpired",
  RequestNotAnswered = "RequestNotAnswered",
  RequestSentToKVK = "RequestSentToKVK",
  RequestSentToReference = "RequestSentToReference"
}

export type ConsultantReferenceStatusHistory = {
  changedAt: Scalars["Date"];
  changedBy: NodeRefNew;
  newStatus: ConsultantReferenceStatus;
  prevStatus?: Maybe<ConsultantReferenceStatus>;
};

export enum ConsultantReferenceType {
  Evaluation = "Evaluation",
  EvaluationToThreeMonths = "EvaluationToThreeMonths",
  Reference = "Reference",
  UUCrossQuestions = "UUCrossQuestions"
}

export type ConsultantReferencesSection = {
  items: Array<ConsultantReferencesSectionItem>;
};

export type ConsultantReferencesSectionInput = {
  items: Array<ConsultantReferencesSectionItemInput>;
};

export type ConsultantReferencesSectionItem = {
  _id: Scalars["ObjectId"];
  deleted: Scalars["Boolean"];
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
  position: Scalars["String"];
  relation: Scalars["String"];
};

export type ConsultantReferencesSectionItemInput = {
  _id: Scalars["ObjectId"];
  deleted?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type ConsultantResponsibleQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type ConsultantRowError = {
  Column: Scalars["String"];
  Message: Scalars["String"];
};

export enum ConsultantSITHSErrand {
  ExitCard = "ExitCard",
  OrderCard = "OrderCard"
}

export type ConsultantSMS = {
  ConsultantId: Scalars["ObjectId"];
  SMSMessage: SMSMessage;
};

export type ConsultantSearchQualityItem = {
  name: Scalars["String"];
  statuses: Array<SearchQualityCheckStatus>;
};

export type ConsultantServicePreference = {
  _id: Scalars["ObjectId"];
  archived: Scalars["Boolean"];
  createdById: Scalars["String"];
  createdByName: Scalars["String"];
  createdOn: Scalars["Date"];
  customers: Array<Maybe<CustomerRef>>;
  deleted: Scalars["Boolean"];
  description: Scalars["String"];
  nullifiedById?: Maybe<Scalars["String"]>;
  nullifiedByName?: Maybe<Scalars["String"]>;
  nullifiedOn?: Maybe<Scalars["Date"]>;
  period: ConsultantServicePreferencePeriod;
  reminders: Array<ConsultantServicePreferenceReminder>;
  status: ConsultantServicePreferenceStatus;
};

export type ConsultantServicePreferenceForm = {
  _id: Scalars["ObjectId"];
  customers: Array<Maybe<Customer>>;
  description: Scalars["String"];
  period: ConsultantServicePreferencePeriod;
  status: ConsultantServicePreferenceStatus;
};

export type ConsultantServicePreferencePeriod = {
  end: Scalars["Date"];
  start: Scalars["Date"];
};

export type ConsultantServicePreferencePeriodInput = {
  end: Scalars["Date"];
  start: Scalars["Date"];
};

export type ConsultantServicePreferenceReminder = {
  createdAt?: Maybe<Scalars["Date"]>;
  sentTo?: Maybe<Scalars["String"]>;
};

export enum ConsultantServicePreferenceStatus {
  Active = "Active",
  Nullified = "Nullified"
}

export enum ConsultantStatus {
  Active = "Active",
  Deleted = "Deleted",
  ToBeDeleted = "ToBeDeleted",
  Unverified = "Unverified",
  Verified = "Verified"
}

export enum ConsultantTableColumns {
  Address = "Address",
  AreasOfExpertise = "AreasOfExpertise",
  Availability = "Availability",
  AvailableForWorkIn = "AvailableForWorkIn",
  BookingStatus = "BookingStatus",
  CallListStats = "CallListStats",
  Comments = "Comments",
  CreatedAt = "CreatedAt",
  Email = "Email",
  GDPRIntegrationPolicy = "GDPRIntegrationPolicy",
  GDPRJobMailing = "GDPRJobMailing",
  GDPRLegalBasis = "GDPRLegalBasis",
  GDPRMarketing = "GDPRMarketing",
  HOSP = "HOSP",
  HasDrivingLicense = "HasDrivingLicense",
  IVO = "IVO",
  IVOErrands = "IVOErrands",
  InterestedToWorkIn = "InterestedToWorkIn",
  IsNationalQualityApproved = "IsNationalQualityApproved",
  IsQualityApproved = "IsQualityApproved",
  LastContactDate = "LastContactDate",
  Machines = "Machines",
  MethodsAndInstruments = "MethodsAndInstruments",
  Name = "Name",
  NextContactDate = "NextContactDate",
  OtherEducations = "OtherEducations",
  Phone = "Phone",
  PipelineStatus = "PipelineStatus",
  QualityNote = "QualityNote",
  ResponsiblePerson = "ResponsiblePerson",
  SocialSecurityNo = "SocialSecurityNo",
  Specializations = "Specializations",
  SwedenBusinessIntelligence = "SwedenBusinessIntelligence",
  SwedenCVAudit = "SwedenCVAudit",
  SwedenCriminalRecord = "SwedenCriminalRecord",
  SwedenHLR = "SwedenHLR",
  SwedenHSAIDSITHS = "SwedenHSAIDSITHS",
  SwedenHealthDeclaration = "SwedenHealthDeclaration",
  SwedenIdCheck = "SwedenIdCheck",
  SwedenInterviewDone = "SwedenInterviewDone",
  SwedenLanguageCheck = "SwedenLanguageCheck",
  SwedenNationalReferences = "SwedenNationalReferences",
  SwedenNpCriminalRecord = "SwedenNpCriminalRecord",
  SwedenProofOfEducation = "SwedenProofOfEducation",
  SwedenProofOfWork = "SwedenProofOfWork",
  SwedenReferences = "SwedenReferences",
  SwedenSAHLR = "SwedenSAHLR",
  Systems = "Systems",
  Tags = "Tags",
  UpdatedAt = "UpdatedAt",
  WorksForCompetitors = "WorksForCompetitors"
}

export type ConsultantTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum ConsultantUnfitType {
  NotContactable = "NotContactable",
  Unfit = "Unfit"
}

export type ConsultantUpcomingWorkplace = {
  bookingId: Scalars["ObjectId"];
  department: Array<CustomerRef>;
  organisation?: Maybe<CustomerRef>;
  week: WeekYear;
  workplace?: Maybe<CustomerRef>;
};

export type ConsultantWorkExperienceItem = {
  areaOfExpertise: Scalars["String"];
  competitors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  customerRef?: Maybe<CustomerRef>;
  departmentIds?: Maybe<Array<Maybe<Scalars["ObjectId"]>>>;
  employmentType?: Maybe<LegalPersonType>;
  excludeFromPresentation?: Maybe<Scalars["Boolean"]>;
  experience?: Maybe<Scalars["String"]>;
  from?: Maybe<Scalars["Date"]>;
  fromMonth?: Maybe<Scalars["String"]>;
  fromYear?: Maybe<Scalars["String"]>;
  roles: Scalars["String"];
  to?: Maybe<Scalars["Date"]>;
  toMonth?: Maybe<Scalars["String"]>;
  toYear?: Maybe<Scalars["String"]>;
  workPlace: Scalars["String"];
  workType: Scalars["String"];
};

export type ConsultantWorkExperienceItemInput = {
  areaOfExpertise?: InputMaybe<Scalars["String"]>;
  competitors?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  customerRef?: InputMaybe<CustomerRefInput>;
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  employmentType?: InputMaybe<LegalPersonType>;
  excludeFromPresentation?: InputMaybe<Scalars["Boolean"]>;
  experience?: InputMaybe<Scalars["String"]>;
  fromMonth?: InputMaybe<Scalars["String"]>;
  fromYear?: InputMaybe<Scalars["String"]>;
  roles?: InputMaybe<Scalars["String"]>;
  toMonth?: InputMaybe<Scalars["String"]>;
  toYear?: InputMaybe<Scalars["String"]>;
  workPlace?: InputMaybe<Scalars["String"]>;
  workType?: InputMaybe<Scalars["String"]>;
};

export type ConsultantWorkExperienceResult = {
  OK: Scalars["Boolean"];
};

export type ConsultantWorkExperienceSection = {
  items: Array<Maybe<ConsultantWorkExperienceItem>>;
};

export type ConsultantWorkExperienceSectionInput = {
  items: Array<InputMaybe<ConsultantWorkExperienceItemInput>>;
};

export type ConsultantWorkStatus = {
  _id: Scalars["ObjectId"];
  competitorName?: Maybe<Scalars["String"]>;
  createdByName: Scalars["String"];
  createdOn: Scalars["Date"];
  deleted: Scalars["Boolean"];
  reminderDate?: Maybe<Scalars["Date"]>;
  startDate: Scalars["Date"];
  type: ConsultantWorkStatusType;
};

export enum ConsultantWorkStatusType {
  FullTimeConsultant = "FullTimeConsultant",
  OnSickLeave = "OnSickLeave",
  PartTimeConsultant = "PartTimeConsultant",
  PermanentPosition = "PermanentPosition",
  Retired = "Retired",
  WorkingForCompetitor = "WorkingForCompetitor"
}

export type ConsultantsByWeeksQueryInput = {
  Klm?: InputMaybe<Scalars["String"]>;
  ZipOrCity?: InputMaybe<Scalars["String"]>;
  activeUser?: InputMaybe<Scalars["ObjectId"]>;
  alphabetFilter?: InputMaybe<Array<Scalars["String"]>>;
  approvedAuthorization?: InputMaybe<ApprovedAuthorizationOption>;
  areasOfExpertise?: InputMaybe<Array<ExpertiseInput>>;
  areasOfExpertiseExperience?: InputMaybe<Scalars["Int"]>;
  availabilityDateRange?: InputMaybe<DateRangeInput2>;
  availabilityRegions?: InputMaybe<Array<Scalars["String"]>>;
  availabilityWorkshifts?: InputMaybe<Array<Workshift>>;
  availableForWorkInCountries?: InputMaybe<Array<Scalars["String"]>>;
  birthdate?: InputMaybe<DateRangeInput>;
  callListIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  competences?: InputMaybe<Array<Scalars["String"]>>;
  competitors?: InputMaybe<Array<Scalars["String"]>>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  dateRange?: InputMaybe<DateRangeInput>;
  dontRestrictAreasOfExpertise?: InputMaybe<Scalars["Boolean"]>;
  experienced?: InputMaybe<Scalars["String"]>;
  fitness?: InputMaybe<Scalars["String"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]>;
  gdprIntegrationPolicy?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailing?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingEmail?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingSms?: InputMaybe<Array<GDPROptionType>>;
  gdprMarketing?: InputMaybe<Array<GDPROptionType>>;
  hasDrivingLicence?: InputMaybe<Scalars["String"]>;
  hasEmail?: InputMaybe<Scalars["String"]>;
  hasLegalPersonType?: InputMaybe<LegalPersonTypeWithNoOption>;
  hasPhone?: InputMaybe<Scalars["String"]>;
  hprNumber?: InputMaybe<Scalars["Boolean"]>;
  initialContact?: InputMaybe<Array<Scalars["String"]>>;
  interested?: InputMaybe<Scalars["String"]>;
  isValid?: InputMaybe<Scalars["Boolean"]>;
  lastContactDate?: InputMaybe<DateRangeInput>;
  lastContactSelectType?: InputMaybe<SelectType>;
  lastContactType?: InputMaybe<Array<LastContactType>>;
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
  legalBasis?: InputMaybe<LegalBasis>;
  location?: InputMaybe<LocationKlm>;
  norwayConsultantStatus?: InputMaybe<NorwayConsultantStatus>;
  participatesInVaccination?: InputMaybe<Scalars["Boolean"]>;
  professionsForm?: InputMaybe<ConsultantsQueryProfessionsFormInput>;
  qualification?: InputMaybe<Scalars["String"]>;
  responsiblePersonId?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  specializations?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<ConsultantStatus>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  tags?: InputMaybe<Array<Scalars["String"]>>;
  team?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
  userActivityDate?: InputMaybe<DateRangeInput>;
  wageRange?: InputMaybe<NumericRangeInput>;
  workedInNorway?: InputMaybe<WorkedInNorwayOption>;
};

export type ConsultantsQueryDoctorInput = {
  experience?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryExpOnlyInput = {
  specializations?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryInput = {
  Klm?: InputMaybe<Scalars["String"]>;
  ZipOrCity?: InputMaybe<Scalars["String"]>;
  alphabetFilter?: InputMaybe<Array<Scalars["String"]>>;
  approvedAuthorization?: InputMaybe<ApprovedAuthorizationOption>;
  areasOfExpertise?: InputMaybe<Array<ExpertiseInput>>;
  areasOfExpertiseExperience?: InputMaybe<Scalars["Float"]>;
  availabilityDateRange?: InputMaybe<DateRangeInput2>;
  availabilityRegions?: InputMaybe<Array<Scalars["String"]>>;
  availabilityWorkshifts?: InputMaybe<Array<Workshift>>;
  availableForWorkInCountries?: InputMaybe<Array<Scalars["String"]>>;
  birthdate?: InputMaybe<DateRangeInput>;
  bookingStatus?: InputMaybe<ConsultantQueryBookingStatus>;
  bookingStatusDate?: InputMaybe<Scalars["Date"]>;
  bookingStatusDateEnd?: InputMaybe<Scalars["Date"]>;
  bookingStatusOption?: InputMaybe<Scalars["String"]>;
  callListIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  competences?: InputMaybe<Array<Scalars["String"]>>;
  competitors?: InputMaybe<Array<Scalars["String"]>>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  dontRestrictAreasOfExpertise?: InputMaybe<Scalars["Boolean"]>;
  experienced?: InputMaybe<Scalars["String"]>;
  fitness?: InputMaybe<Scalars["String"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]>;
  gdprIntegrationPolicy?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailing?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingEmail?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingSms?: InputMaybe<Array<GDPROptionType>>;
  gdprMarketing?: InputMaybe<Array<GDPROptionType>>;
  hasDrivingLicence?: InputMaybe<DrivingLicenceType>;
  hasEmail?: InputMaybe<Scalars["String"]>;
  hasLegalPersonType?: InputMaybe<LegalPersonTypeWithNoOption>;
  hasPhone?: InputMaybe<Scalars["String"]>;
  hprNumber?: InputMaybe<Scalars["Boolean"]>;
  initialContact?: InputMaybe<Array<Scalars["String"]>>;
  initialsLastName?: InputMaybe<Array<Scalars["String"]>>;
  interested?: InputMaybe<Scalars["String"]>;
  isValid?: InputMaybe<Scalars["Boolean"]>;
  lastContactDate?: InputMaybe<DateRangeInput>;
  lastContactSelectType?: InputMaybe<SelectType>;
  lastContactType?: InputMaybe<Array<LastContactType>>;
  lastContactUserId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
  legalBasis?: InputMaybe<LegalBasis>;
  location?: InputMaybe<LocationKlm>;
  nationalQualification?: InputMaybe<Scalars["String"]>;
  nextContactDate?: InputMaybe<DateRangeInput>;
  norwayConsultantStatus?: InputMaybe<NorwayConsultantStatus>;
  onlyFavourites?: InputMaybe<Scalars["Boolean"]>;
  participatesInVaccination?: InputMaybe<Scalars["Boolean"]>;
  pipelineStatus?: InputMaybe<Array<Scalars["String"]>>;
  professionsForm?: InputMaybe<ConsultantsQueryProfessionsFormInput>;
  qualification?: InputMaybe<Scalars["String"]>;
  qualityCheckNames?: InputMaybe<Array<Scalars["String"]>>;
  qualityCheckStatuses?: InputMaybe<Array<Scalars["String"]>>;
  qualityCheckStatusesDate?: InputMaybe<DateRangeInput>;
  responsiblePersonId?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  specializations?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<ConsultantStatus>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  team?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
  updatedBefore?: InputMaybe<Scalars["Date"]>;
  updatedSince?: InputMaybe<Scalars["Date"]>;
  wageRange?: InputMaybe<NumericRangeInput>;
  workedInNorway?: InputMaybe<WorkedInNorwayOption>;
};

export type ConsultantsQueryProfessionsFormInput = {
  doctor?: InputMaybe<ConsultantsQueryDoctorInput>;
  expOnly?: InputMaybe<ConsultantsQueryExpOnlyInput>;
  professions: Array<Scalars["String"]>;
  psykolog?: InputMaybe<ConsultantsQueryPsykologInput>;
  radiographer?: InputMaybe<ConsultantsQueryRadiographerInput>;
  socialWorkerForm?: InputMaybe<ConsultantsQuerySocialWorkerFormInput>;
  sskForm?: InputMaybe<ConsultantsQuerySskFormInput>;
  teacherForm?: InputMaybe<ConsultantsQueryTeacherFormInput>;
};

export type ConsultantsQueryPsykologInput = {
  experience?: InputMaybe<SelectValueInputString>;
  methods?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryRadiographerInput = {
  experience?: InputMaybe<SelectValueInputString>;
  machines?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQuerySocialWorkerFormInput = {
  educations?: InputMaybe<Array<Scalars["String"]>>;
  experienceMinYears?: InputMaybe<Scalars["String"]>;
  options?: InputMaybe<SocionomSelectOptionEnum>;
  specializations?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQuerySskFormInput = {
  areaOfExpertise?: InputMaybe<SelectValueInputString>;
  specializations?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryTeacherFormInput = {
  areaOfExpertise: Array<Scalars["String"]>;
  areaSelectType: SelectType;
  qualified: QualificationFilter;
};

export type ConsultantsResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<Consultant>;
  limit: Scalars["Int"];
  secondarySearch: Array<Consultant>;
  skip: Scalars["Int"];
  total: Scalars["Int"];
};

export type Contact = INode & {
  Address?: Maybe<Address>;
  AvatarPic?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  IsValid?: Maybe<Scalars["Boolean"]>;
  Name?: Maybe<Scalars["String"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles?: Maybe<Array<Scalars["String"]>>;
  Title?: Maybe<Scalars["String"]>;
  ValidationErrors: Array<NodeValidationError>;
  _id: Scalars["ObjectId"];
  id?: Maybe<Scalars["ObjectId"]>;
  type: NodeType;
};

export type ContactInput = {
  Email?: InputMaybe<Scalars["String"]>;
};

export type ContactPerson = IContact & {
  Address?: Maybe<Address>;
  AreasOfExpertise: Array<Maybe<Scalars["String"]>>;
  Audit: Audit;
  AvatarPic?: Maybe<Scalars["String"]>;
  BooksProfessions: Array<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  CustomerGroups: Array<Scalars["String"]>;
  CustomerRefs: Array<CustomerRef>;
  Customers: Array<Customer>;
  Deleted: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  IsInheritable: Scalars["Boolean"];
  IsValid?: Maybe<Scalars["Boolean"]>;
  /** Last update, else creation; date only when the change has no known user */
  LastChange: ContactPersonLastChange;
  Name?: Maybe<Scalars["String"]>;
  NodeName?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles: Array<Scalars["String"]>;
  RootCustomer: CustomerRef;
  Title?: Maybe<Scalars["String"]>;
  ValidationErrors?: Maybe<Array<Maybe<ValidationError>>>;
  _id: Scalars["ObjectId"];
};

export type ContactPersonInput = {
  AreasOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  BooksProfessions?: InputMaybe<Array<Scalars["String"]>>;
  CellPhone?: InputMaybe<Scalars["String"]>;
  CustomerGroups?: InputMaybe<Array<Scalars["String"]>>;
  CustomersIds: Array<Scalars["ObjectId"]>;
  Email?: InputMaybe<Scalars["String"]>;
  IsInheritable?: InputMaybe<Scalars["Boolean"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  Roles?: InputMaybe<Array<Scalars["String"]>>;
  Title?: InputMaybe<Scalars["String"]>;
};

export type ContactPersonLastChange = {
  Date: Scalars["Date"];
  IsUpdate: Scalars["Boolean"];
  User?: Maybe<UserRef>;
};

export type ContactPersonsFilter = {
  areasOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  customerId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  role?: InputMaybe<Array<Scalars["String"]>>;
  rootCustomerId?: InputMaybe<Scalars["ObjectId"]>;
  text?: InputMaybe<Array<Scalars["String"]>>;
  withEmailAttached?: InputMaybe<Scalars["Boolean"]>;
};

export type ContactPersonsResult = {
  items: Array<ContactPerson>;
  total?: Maybe<Scalars["Int"]>;
};

export enum ContractPensionModel {
  Annual = "Annual",
  Months = "Months"
}

export type ContractPriceTemplateFilter = {
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Array<ContractsPriceTemplateType>>;
};

export type ContractPriceTemplateInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  deleted: Scalars["Boolean"];
  highHolidays?: InputMaybe<Array<HighHolidayInput>>;
  name: Scalars["String"];
  private?: InputMaybe<Scalars["Boolean"]>;
  records?: InputMaybe<Array<ContractPriceTemplateRecordInput>>;
  type?: InputMaybe<ContractsPriceTemplateType>;
};

export type ContractPriceTemplateOpResult = {
  errors?: Maybe<Array<Scalars["String"]>>;
  value?: Maybe<ContractsPriceTemplate>;
};

export type ContractPriceTemplateRecordInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  articleNumber?: InputMaybe<Scalars["String"]>;
  articleNumberForOtherSpeciality?: InputMaybe<Scalars["String"]>;
  currency?: InputMaybe<Currency>;
  customPrice?: InputMaybe<Scalars["Float"]>;
  deleted?: InputMaybe<Scalars["Boolean"]>;
  endDay?: InputMaybe<PriceListDay>;
  fixedPrice?: InputMaybe<Scalars["Float"]>;
  from?: InputMaybe<Scalars["Time"]>;
  indexInWorkType?: InputMaybe<Scalars["Float"]>;
  isSecondPass?: InputMaybe<Scalars["Boolean"]>;
  paidPer?: InputMaybe<PayUnit>;
  period?: InputMaybe<PayPeriod>;
  priceMultiplier?: InputMaybe<Scalars["Float"]>;
  startDay?: InputMaybe<PriceListDay>;
  to?: InputMaybe<Scalars["Time"]>;
  workType?: InputMaybe<PriceListWorkType>;
};

export type ContractPriceTemplateSearchResult = {
  items: Array<ContractsPriceTemplate>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  total: Scalars["Int"];
};

export type ContractProfession = {
  areaOfExpertise?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  specialization?: Maybe<Scalars["String"]>;
};

export enum ContractType {
  Hourly = "Hourly",
  HourlyPension = "HourlyPension",
  HourlyPensionInsurance = "HourlyPensionInsurance",
  NationalProcurement = "NationalProcurement"
}

export type ContractsPriceRecord = {
  _id: Scalars["ObjectId"];
  articleNumber?: Maybe<Scalars["String"]>;
  articleNumberForOtherSpeciality?: Maybe<Scalars["String"]>;
  currency?: Maybe<Currency>;
  /** If user set it manual without calc */
  customPrice?: Maybe<Scalars["Float"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  endDay?: Maybe<PriceListDay>;
  /** Now it something like extra payment. */
  fixedPrice?: Maybe<Scalars["Float"]>;
  from?: Maybe<Scalars["String"]>;
  indexInWorkType?: Maybe<Scalars["Float"]>;
  isSecondPass?: Maybe<Scalars["Boolean"]>;
  paidPer?: Maybe<PayUnit>;
  period?: Maybe<PayPeriod>;
  /** If fixedPrice is set, priceMultiplier should be ignored on any calc */
  priceMultiplier?: Maybe<Scalars["Float"]>;
  startDay?: Maybe<PriceListDay>;
  to?: Maybe<Scalars["String"]>;
  workType?: Maybe<PriceListWorkType>;
};

export type ContractsPriceTemplate = {
  _id: Scalars["ObjectId"];
  createdByName?: Maybe<Scalars["String"]>;
  createdDate?: Maybe<Scalars["Date"]>;
  highHolidays?: Maybe<Array<HighHoliday>>;
  name?: Maybe<Scalars["String"]>;
  private?: Maybe<Scalars["Boolean"]>;
  records?: Maybe<Array<ContractsPriceRecord>>;
  type?: Maybe<Scalars["String"]>;
  updatedByName?: Maybe<Scalars["String"]>;
  updatedDate?: Maybe<Scalars["Date"]>;
};

export enum ContractsPriceTemplateType {
  ConsultantContract = "ConsultantContract",
  CustomerContract = "CustomerContract"
}

export type CostCenter = {
  Id: Scalars["String"];
  IsActive: Scalars["Boolean"];
  IsDeleted: Scalars["Boolean"];
  Name?: Maybe<Scalars["String"]>;
  Organisation?: Maybe<Scalars["String"]>;
  OriginalName?: Maybe<Scalars["String"]>;
};

export type CostCenterConfigFilterInput = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  organisation?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
};

export type CostCenterConfigItem = {
  _id: Scalars["ObjectId"];
  costCenterId: Scalars["String"];
  isActive: Scalars["Boolean"];
  isDeleted: Scalars["Boolean"];
  name: Scalars["String"];
  organisation: Scalars["String"];
  tenant: Scalars["String"];
};

export type Count = {
  total?: Maybe<Scalars["Int"]>;
};

export type Country = {
  canWorkIn?: Maybe<Scalars["Boolean"]>;
  countryId: Scalars["String"];
  name: Scalars["String"];
  onTopInSearch?: Maybe<Scalars["Boolean"]>;
  regions: Array<Region>;
  sort?: Maybe<Scalars["Float"]>;
};

export type CreateApiTokenResult = {
  apiToken: ApiToken;
  token: Scalars["String"];
};

export type CreateBookingKitInput = {
  bookingId: Scalars["ObjectId"];
  bookingSupportCheckWasValid: Scalars["Boolean"];
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  filesIds: Array<Scalars["ObjectId"]>;
  managerId?: InputMaybe<Scalars["ObjectId"]>;
  receipts?: InputMaybe<Array<BookingKitExpensesReceiptInput>>;
  responsibleId?: InputMaybe<Scalars["ObjectId"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  tagsNote?: InputMaybe<Scalars["String"]>;
  templateType: TimeReportTemplateType;
  type: BookingKitType;
  withConsultantInvoice: Scalars["Boolean"];
  withCustomerInvoice: Scalars["Boolean"];
  withSickPay: Scalars["Boolean"];
  withSubcontractorPay: Scalars["Boolean"];
  withTimeReport: Scalars["Boolean"];
};

export type CreateConsultantOpportunityInput = {
  areaOfExpertise?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  costCenter: Scalars["String"];
  customerId: Scalars["ObjectId"];
  estimatedResponseDate: Scalars["Date"];
  note?: InputMaybe<Scalars["String"]>;
  users: Array<Scalars["ObjectId"]>;
  weeks: Array<Scalars["Date"]>;
  workrequestConsultantId?: InputMaybe<Scalars["ObjectId"]>;
  workrequestId?: InputMaybe<Scalars["ObjectId"]>;
};

export type CreateConsultantServicePreferenceInput = {
  customers?: InputMaybe<Array<InputMaybe<CustomerRefInput>>>;
  description: Scalars["String"];
  period: ConsultantServicePreferencePeriodInput;
};

export type CreateConsultantWorkStatusInput = {
  competitorName?: InputMaybe<Scalars["String"]>;
  reminderDate?: InputMaybe<Scalars["Date"]>;
  startDate: Scalars["Date"];
  type: ConsultantWorkStatusType;
};

export type CreateContactPersonResult = {
  contactPerson?: Maybe<ContactPerson>;
  validationErrors: Array<ValidationError>;
};

export type CreateCostCenterInput = {
  costCenterId: Scalars["String"];
  isActive: Scalars["Boolean"];
  name: Scalars["String"];
  organisation: Scalars["String"];
};

export type CreateCustomerResult = {
  customer?: Maybe<Customer>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export type CreateDirectRequestContractInput = {
  areaOfExpertise: Scalars["String"];
  avropsnummer: Scalars["String"];
  basicPrice: Scalars["Float"];
  customerId: Scalars["ObjectId"];
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  extraInvoiceLine: Scalars["String"];
  weeks: Array<Scalars["Date"]>;
};

export type CreateTgRequirementInput = {
  costCenterId: Scalars["String"];
  minRequiredTG: Scalars["Float"];
  profession?: InputMaybe<Scalars["String"]>;
  validFrom?: InputMaybe<Scalars["Date"]>;
};

export enum CriminalRecordType {
  HVB = "HVB",
  HomeCareElderlyDisabled = "HomeCareElderlyDisabled",
  LSS = "LSS",
  MunicipalityLeadingPosition = "MunicipalityLeadingPosition",
  Norway = "Norway",
  OTHER = "OTHER",
  School = "School",
  WorkWithOtherKid = "WorkWithOtherKid"
}

export type CrmDocument = {
  _id: Scalars["ObjectId"];
  documentType?: Maybe<Scalars["String"]>;
  mimeType: Scalars["String"];
  name: Scalars["String"];
  pdfUrl: Scalars["String"];
  size: Scalars["Int"];
  thumbUrl: Scalars["String"];
  type: CrmDocumentType;
};

export enum CrmDocumentType {
  Accommodation = "Accommodation",
  Booking = "Booking",
  BookingKit = "BookingKit",
  Consultant = "Consultant",
  ConsultantContract = "ConsultantContract",
  ConsultantPresentation = "ConsultantPresentation",
  ConsultantReference = "ConsultantReference",
  Custom = "Custom",
  Customer = "Customer",
  CustomerContract = "CustomerContract",
  CustomerContractSnapshot = "CustomerContractSnapshot",
  Timereport = "Timereport"
}

export enum CrmEventType {
  Booking = "Booking",
  BookingKit = "BookingKit",
  Consultant = "Consultant",
  Customer = "Customer"
}

export enum Currency {
  NOK = "NOK",
  SEK = "SEK"
}

export type Customer = {
  AOESettings: Array<CustomerAOESettings>;
  Address?: Maybe<Address>;
  AreasOfExpertise: Array<Scalars["String"]>;
  AvatarPic?: Maybe<Scalars["String"]>;
  BgPic?: Maybe<Scalars["String"]>;
  CanBeDeleted: Scalars["Boolean"];
  CantBeDeletedReasons: Array<Scalars["String"]>;
  ContactPersons: Array<ContactPerson>;
  CustomerGroups: Array<Scalars["String"]>;
  CustomerTree: Array<CustomerTreeItem>;
  Deleted: Scalars["Boolean"];
  Description: Scalars["String"];
  DirectChildren: Array<CustomerRef>;
  DirectChildrenFull: Array<Customer>;
  DirectParent?: Maybe<CustomerRef>;
  DirectParents?: Maybe<Array<CustomerRef>>;
  DocumentTypes: Array<Scalars["String"]>;
  IsValid?: Maybe<Scalars["Boolean"]>;
  LastContactDate?: Maybe<Scalars["Date"]>;
  Name?: Maybe<Scalars["String"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  OrganizationNumber: Scalars["String"];
  OrganizationType?: Maybe<OrganizationType>;
  OwnProfessions: Array<Scalars["String"]>;
  Parents: Array<CustomerRef>;
  Professions: Array<Scalars["String"]>;
  RecruitingPortalType?: Maybe<RecruitingPortalType>;
  Ref: CustomerRef;
  RegionRef: CustomerRef;
  ShowHospitalAOERewriteWarning: Scalars["Boolean"];
  Specializations: Array<Scalars["String"]>;
  StaffingContactPersons: Array<ContactPerson>;
  Systems: Array<Scalars["String"]>;
  Type: CustomerType;
  ValidationErrors: Array<NodeValidationError>;
  WebsiteURL: Scalars["String"];
  WorkshiftSpans: Array<CustomerWorkshiftSpan>;
  _dummy?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  areasOfExpertiseTotal: Scalars["Int"];
  bemloOrgId?: Maybe<Scalars["String"]>;
  bemloUnitId?: Maybe<Scalars["String"]>;
  billingInstructions?: Maybe<Scalars["String"]>;
  documents?: Maybe<Array<CustomerDocument>>;
  forceCallNumber?: Maybe<Scalars["Boolean"]>;
  geolocation?: Maybe<Geolocation>;
  id?: Maybe<Scalars["ObjectId"]>;
  inLists: Scalars["Boolean"];
  journalSystem?: Maybe<Scalars["String"]>;
  municipalityId?: Maybe<Scalars["ObjectId"]>;
  needSignature: Scalars["Boolean"];
  needSignatureTROkInApp: Scalars["Boolean"];
  noApproval: Scalars["Boolean"];
  noApprovalMonthly: Scalars["Boolean"];
  noApprovalShortening: Scalars["Boolean"];
  noApprovalSpecial: Scalars["Boolean"];
  recommendedPrices: Array<CustomerRecommendedPrice>;
  timeReportTemplateSettings?: Maybe<Array<Maybe<TimereportTemplateSettings>>>;
  type: NodeType;
};

export type CustomerAreasOfExpertiseArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type CustomerContactPersonsArgs = {
  customerGroup?: InputMaybe<Scalars["String"]>;
  showDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomerAOESettings = {
  AreaOfExpertise: Scalars["String"];
  Enabled: Scalars["Boolean"];
  Error?: Maybe<Scalars["Boolean"]>;
  FortnoxId?: Maybe<Scalars["String"]>;
  GroupInvoicing?: Maybe<Scalars["Boolean"]>;
  Inherited?: Maybe<Scalars["Boolean"]>;
  InvoicingData?: Maybe<Scalars["String"]>;
  Profession: Scalars["String"];
  ResponsiblePerson?: Maybe<UserRef>;
  orderId?: Maybe<Scalars["String"]>;
  timeReport?: Maybe<Scalars["Boolean"]>;
};

export type CustomerAOESettingsInput = {
  AreaOfExpertise: Scalars["String"];
  Enabled: Scalars["Boolean"];
  FortnoxId?: InputMaybe<Scalars["String"]>;
  GroupInvoicing?: InputMaybe<Scalars["Boolean"]>;
  InvoicingData?: InputMaybe<Scalars["String"]>;
  Profession: Scalars["String"];
  ResponsiblePerson?: InputMaybe<OptionStringInput>;
  orderId?: InputMaybe<Scalars["String"]>;
  timeReport?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomerContact = IContact & {
  Address?: Maybe<Address>;
  AvatarPic?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles: Array<Scalars["String"]>;
  Title: Scalars["String"];
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type CustomerContactPerson = {
  CellPhone?: Maybe<Scalars["String"]>;
  Email?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
};

export type CustomerContactPersonInput = {
  Email?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  Title?: InputMaybe<Scalars["String"]>;
};

export type CustomerContract = {
  _id: Scalars["ObjectId"];
  adjustmentComment: Scalars["String"];
  attachmentRefs?: Maybe<Array<Maybe<FileRef>>>;
  attachments: Array<CustomerContractDocument>;
  avropsnummer?: Maybe<Scalars["String"]>;
  avtalsnummer?: Maybe<Scalars["String"]>;
  company: CustomerContractCompany;
  contactPerson?: Maybe<Array<CustomerContractContactPerson>>;
  contractEnd?: Maybe<Scalars["Date"]>;
  contractName?: Maybe<Scalars["String"]>;
  contractNumber?: Maybe<Scalars["String"]>;
  contractPriceAdjustmentDate?: Maybe<Scalars["Date"]>;
  contractPriceAdjustmentDateDeadline?: Maybe<Scalars["Date"]>;
  contractProlongation?: Maybe<Scalars["Date"]>;
  contractProlongationDeadline?: Maybe<Scalars["Date"]>;
  contractStart?: Maybe<Scalars["Date"]>;
  currentContractEnd?: Maybe<Scalars["Date"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  dispenseDeadline?: Maybe<Scalars["Float"]>;
  estimatedContractValue?: Maybe<Scalars["Float"]>;
  eventLogs: Array<CustomerContractEventLog>;
  extraInvoiceLine?: Maybe<Scalars["String"]>;
  info: Scalars["String"];
  introductionInfo?: Maybe<Scalars["String"]>;
  invoicingStrategy: InvoicingStrategyType;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  orgCustomerRefs: Array<CustomerRef>;
  orgCustomerTree: Array<CustomerTreeItem>;
  orgCustomers: Array<Customer>;
  otherOption?: Maybe<Scalars["Boolean"]>;
  otherOptionNote?: Maybe<Scalars["String"]>;
  overtime?: Maybe<Scalars["Boolean"]>;
  overtimeNote?: Maybe<Scalars["String"]>;
  overtimeOption?: Maybe<Scalars["Boolean"]>;
  overtimeOptionOBNote?: Maybe<Scalars["String"]>;
  possibleInvoiceForAccommodation?: Maybe<Scalars["Boolean"]>;
  possibleInvoiceForAccommodationNote?: Maybe<Scalars["String"]>;
  possibleInvoiceForTravel?: Maybe<Scalars["Boolean"]>;
  possibleInvoiceForTravelNote?: Maybe<Scalars["String"]>;
  priceLists: Array<CustomerContractPriceList>;
  professions: Array<Scalars["String"]>;
  prolongationComment: Scalars["String"];
  status?: Maybe<CustomerContractStatus>;
  subVersions: Array<CustomerContractSubVersion>;
  typeOfAgreement: CustomerContractAgreementType;
  useNationalProcurementInvoicing?: Maybe<Scalars["Boolean"]>;
};

export enum CustomerContractAgreementType {
  NotProcured = "NotProcured",
  Procured = "Procured"
}

export type CustomerContractByBookingFilter = {
  areaOfExpertise: Scalars["String"];
  consultantId: Scalars["String"];
  contractId?: InputMaybe<Scalars["String"]>;
  dates: Array<Scalars["Date"]>;
  weeks: Array<Scalars["Date"]>;
  workplaceIds: Array<Scalars["String"]>;
};

export enum CustomerContractCompany {
  Bonliva_AB = "Bonliva_AB",
  Bonliva_Care = "Bonliva_Care"
}

export type CustomerContractContactPerson = {
  _id: Scalars["ObjectId"];
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
};

export type CustomerContractContactPersonInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
  title: Scalars["String"];
};

export type CustomerContractDocument = {
  DocumentType?: Maybe<Scalars["String"]>;
  FileRef: FileRef;
  PdfURL?: Maybe<Scalars["String"]>;
  ThumbURL?: Maybe<Scalars["String"]>;
};

export enum CustomerContractDocumentTypes {
  Agreement = "Agreement",
  ContractAttachments = "ContractAttachments",
  Other = "Other",
  PricesOB = "PricesOB",
  SubVersion = "SubVersion"
}

export type CustomerContractEventInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  description: Scalars["String"];
  sticky: Scalars["Boolean"];
};

export type CustomerContractEventLog = Event & {
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  EventType: CustomerContractEventType;
  Links?: Maybe<Array<Scalars["String"]>>;
  Sticky: Scalars["Boolean"];
  UpdatedBy?: Maybe<WeakUserRef>;
  UpdatedOn?: Maybe<Scalars["Date"]>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum CustomerContractEventType {
  Comment = "Comment",
  Reminder = "Reminder",
  SystemLog = "SystemLog"
}

export type CustomerContractFilter = {
  company?: InputMaybe<CustomerContractCompany>;
  contractEnd?: InputMaybe<Scalars["Date"]>;
  contractPriceAdjustmentDate?: InputMaybe<Scalars["Date"]>;
  contractProlongation?: InputMaybe<Scalars["Date"]>;
  contractStart?: InputMaybe<Scalars["Date"]>;
  currentContractEnd?: InputMaybe<Scalars["Date"]>;
  professions?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  status?: InputMaybe<Array<CustomerContractStatus>>;
  tenant?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
  typeOfAgreement?: InputMaybe<CustomerContractAgreementType>;
};

export type CustomerContractFormInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  adjustmentComment?: InputMaybe<Scalars["String"]>;
  avropsnummer?: InputMaybe<Scalars["String"]>;
  avtalsnummer?: InputMaybe<Scalars["String"]>;
  company: CustomerContractCompany;
  contactPerson: Array<CustomerContractContactPersonInput>;
  contractEnd: Scalars["Date"];
  contractName: Scalars["String"];
  contractNumber?: InputMaybe<Scalars["String"]>;
  contractPriceAdjustmentDate?: InputMaybe<Scalars["Date"]>;
  contractPriceAdjustmentDateDeadline?: InputMaybe<Scalars["Date"]>;
  contractProlongation?: InputMaybe<Scalars["Date"]>;
  contractProlongationDeadline?: InputMaybe<Scalars["Date"]>;
  contractStart: Scalars["Date"];
  currentContractEnd?: InputMaybe<Scalars["Date"]>;
  dispenseDeadline?: InputMaybe<Scalars["Float"]>;
  estimatedContractValue?: InputMaybe<Scalars["Float"]>;
  extraInvoiceLine?: InputMaybe<Scalars["String"]>;
  introductionInfo?: InputMaybe<Scalars["String"]>;
  orgCustomers: Array<CustomerRefInput>;
  otherOption?: InputMaybe<Scalars["Boolean"]>;
  otherOptionNote?: InputMaybe<Scalars["String"]>;
  overtime?: InputMaybe<Scalars["Boolean"]>;
  overtimeNote?: InputMaybe<Scalars["String"]>;
  overtimeOption?: InputMaybe<Scalars["Boolean"]>;
  overtimeOptionOBNote?: InputMaybe<Scalars["String"]>;
  possibleInvoiceForAccommodation?: InputMaybe<Scalars["Boolean"]>;
  possibleInvoiceForAccommodationNote?: InputMaybe<Scalars["String"]>;
  possibleInvoiceForTravel?: InputMaybe<Scalars["Boolean"]>;
  possibleInvoiceForTravelNote?: InputMaybe<Scalars["String"]>;
  priceAdjustmentComment?: InputMaybe<Scalars["String"]>;
  professions: Array<Scalars["String"]>;
  prolongationComment?: InputMaybe<Scalars["String"]>;
  typeOfAgreement: CustomerContractAgreementType;
  useNationalProcurementInvoicing?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomerContractListItem = {
  _id: Scalars["String"];
  avropsnummer?: Maybe<Scalars["String"]>;
  basicPrices: Array<BasicPrice>;
  contractEnd: Scalars["Date"];
  contractName: Scalars["String"];
  contractStart: Scalars["Date"];
  contractType: Scalars["String"];
  isNationalProcurement: Scalars["Boolean"];
  isSubVersion: Scalars["Boolean"];
  parentId?: Maybe<Scalars["String"]>;
  priceLists: Array<Scalars["String"]>;
  useNationalProcurementInvoicing?: Maybe<Scalars["Boolean"]>;
};

export type CustomerContractOpResult = {
  errors?: Maybe<Array<Scalars["String"]>>;
  value?: Maybe<CustomerContract>;
};

export type CustomerContractPriceList = {
  _id: Scalars["ObjectId"];
  administrativeFee?: Maybe<Scalars["Float"]>;
  customerContract: CustomerContract;
  customerCount: Scalars["Int"];
  customerTree: Array<CustomerTreeItem>;
  customers: Array<Maybe<Customer>>;
  endDate?: Maybe<Scalars["Date"]>;
  name?: Maybe<Scalars["String"]>;
  priceGroups: Array<CustomerContractPriceListGroup>;
  startDate?: Maybe<Scalars["Date"]>;
  travelZones: Array<TravelZone>;
};

export type CustomerContractPriceListCustomersArgs = {
  limit?: InputMaybe<Scalars["Float"]>;
};

export type CustomerContractPriceListGroup = {
  _id: Scalars["ObjectId"];
  highHolidays: Array<HighHoliday>;
  professionsPrice: Array<CustomerContractProfessionsPrice>;
  records: Array<ContractsPriceRecord>;
};

export type CustomerContractProfessionsPrice = {
  price?: Maybe<Scalars["Float"]>;
  profession: ContractProfession;
};

export type CustomerContractSearchResult = {
  items: Array<CustomerContractSearchRow>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type CustomerContractSearchRow = {
  _id: Scalars["ObjectId"];
  contractEnd: Scalars["Date"];
  contractName?: Maybe<Scalars["String"]>;
  contractNumber?: Maybe<Scalars["String"]>;
  contractPriceAdjustmentDate?: Maybe<Scalars["Date"]>;
  contractPriceAdjustmentDateDeadline?: Maybe<Scalars["Date"]>;
  contractProlongation?: Maybe<Scalars["Date"]>;
  contractProlongationDeadline?: Maybe<Scalars["Date"]>;
  contractStart: Scalars["Date"];
  currentContractEnd?: Maybe<Scalars["Date"]>;
  estimatedContractValue?: Maybe<Scalars["Float"]>;
  orgCustomerRefs: Array<CustomerRef>;
  professions: Array<Scalars["String"]>;
  status?: Maybe<CustomerContractStatus>;
  subVersions: Array<CustomerContractSubVersion>;
};

export type CustomerContractSnapshot = {
  _id: Scalars["ObjectId"];
  consultantId?: Maybe<Scalars["ObjectId"]>;
  contactPersonId?: Maybe<Scalars["ObjectId"]>;
  customerContractId: Scalars["ObjectId"];
  customerId?: Maybe<Scalars["ObjectId"]>;
  externalId?: Maybe<Scalars["String"]>;
  fileRef?: Maybe<FileRef>;
  fileUrl?: Maybe<Scalars["String"]>;
  invoiceMarking?: Maybe<Scalars["String"]>;
  isNullified?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  parentId?: Maybe<Scalars["ObjectId"]>;
  publishedUrl?: Maybe<Scalars["String"]>;
  responsiblePersonId?: Maybe<Scalars["ObjectId"]>;
  signedOn?: Maybe<Scalars["Date"]>;
  type: CustomerContractSnapshotTypes;
  viewUrl?: Maybe<Scalars["String"]>;
};

export type CustomerContractSnapshotFormInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  contactPersonId?: InputMaybe<Scalars["ObjectId"]>;
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  customerId: Scalars["ObjectId"];
  invoiceMarking?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["ObjectId"]>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  type: CustomerContractSnapshotTypes;
};

export type CustomerContractSnapshotOpResult = {
  errors?: Maybe<Array<Scalars["String"]>>;
  value?: Maybe<CustomerContractSnapshot>;
};

export enum CustomerContractSnapshotTypes {
  Confirmation = "Confirmation",
  Framework = "Framework"
}

export enum CustomerContractSortBy {
  ContractEnd = "ContractEnd",
  ContractNumber = "ContractNumber",
  ContractPriceAdjustmentDate = "ContractPriceAdjustmentDate",
  ContractProlongation = "ContractProlongation",
  ContractStart = "ContractStart",
  CurrentContractEnd = "CurrentContractEnd",
  CustomerName = "CustomerName",
  EstimatedContractValue = "EstimatedContractValue"
}

export enum CustomerContractStatus {
  Active = "Active",
  Coming = "Coming",
  Completed = "Completed",
  Deleted = "Deleted"
}

export type CustomerContractSubVersion = {
  _id: Scalars["ObjectId"];
  basicPrice: Scalars["Float"];
  consultantId?: Maybe<Scalars["ObjectId"]>;
  customerContractName?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  fileRef?: Maybe<FileRef>;
  name?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
};

export type CustomerDocument = {
  DocumentType?: Maybe<CustomerDocumentTypes>;
  FileRef: FileRef;
  PdfURL?: Maybe<Scalars["String"]>;
  ThumbURL?: Maybe<Scalars["String"]>;
};

export enum CustomerDocumentTypes {
  Other = "Other",
  StandingCertificateForTR = "StandingCertificateForTR"
}

export type CustomerEvent = Event & {
  AreasOfExpertise: Array<Scalars["String"]>;
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  ContactPerson: Array<NodeRef>;
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  CustomerGroup?: Maybe<Scalars["String"]>;
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Scalars["String"]>>;
  MetBy?: Maybe<WeakUserRef>;
  Node: NodeRef;
  Roles: Array<Scalars["String"]>;
  RootCustomer: CustomerRef;
  Sticky: Scalars["Boolean"];
  TodoItem?: Maybe<TodoItem>;
  TodoRef?: Maybe<NodeRef>;
  Type: CustomerEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export type CustomerEventFilter = {
  AreasOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  ContactPersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  CustomerGroup?: InputMaybe<Scalars["String"]>;
  CustomerId: Scalars["ObjectId"];
  Deleted?: InputMaybe<Scalars["Boolean"]>;
  Role?: InputMaybe<Array<Scalars["String"]>>;
  SearchField?: InputMaybe<Scalars["String"]>;
};

export type CustomerEventInput = {
  AreasOfExpertise?: InputMaybe<Array<Scalars["String"]>>;
  ContactPersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  CustomerGroup?: InputMaybe<Scalars["String"]>;
  CustomerId: Scalars["ObjectId"];
  Description: Scalars["String"];
  RootCustomerId: Scalars["ObjectId"];
  Sticky?: InputMaybe<Scalars["Boolean"]>;
};

export enum CustomerEventType {
  Comment = "Comment",
  MetInPerson = "MetInPerson",
  Reminder = "Reminder"
}

export type CustomerInput = {
  AOESettings?: InputMaybe<Array<CustomerAOESettingsInput>>;
  Address?: InputMaybe<AddressInput>;
  AvatarPic?: InputMaybe<NodeRefInput>;
  BgPic?: InputMaybe<NodeRefInput>;
  CustomerGroups?: InputMaybe<Array<Scalars["String"]>>;
  Description?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  OrganizationNumber?: InputMaybe<Scalars["String"]>;
  OrganizationType?: InputMaybe<OrganizationType>;
  ParentId?: InputMaybe<Scalars["ObjectId"]>;
  Professions?: InputMaybe<Array<Scalars["String"]>>;
  RecruitingPortalType?: InputMaybe<RecruitingPortalType>;
  Systems?: InputMaybe<Array<Scalars["String"]>>;
  Type?: InputMaybe<CustomerType>;
  WorkshiftSpans?: InputMaybe<Array<CustomerWorkshiftSpanInput>>;
  _id?: InputMaybe<Scalars["ObjectId"]>;
  bemloOrgId?: InputMaybe<Scalars["String"]>;
  bemloUnitId?: InputMaybe<Scalars["String"]>;
  billingInstructions?: InputMaybe<Scalars["String"]>;
  forceCallNumber?: InputMaybe<Scalars["Boolean"]>;
  journalSystem?: InputMaybe<Scalars["String"]>;
  municipalityId?: InputMaybe<Scalars["ObjectId"]>;
};

export type CustomerRecommendedPrice = {
  areaOfExpertise: Scalars["String"];
  profession: Scalars["String"];
  value: Scalars["String"];
};

export type CustomerRecommendedPriceInput = {
  areaOfExpertise: Scalars["String"];
  profession: Scalars["String"];
  value: Scalars["String"];
};

export type CustomerRef = {
  Id: Scalars["ObjectId"];
  Name: Scalars["String"];
  Type: CustomerType;
};

export type CustomerRefInput = {
  Id: Scalars["ObjectId"];
  Name?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<CustomerType>;
};

export enum CustomerSettingsKey {
  NeedSignature = "needSignature",
  NeedSignatureTROkInApp = "needSignatureTROkInApp",
  NoApprovalMonthly = "noApprovalMonthly",
  NoApprovalShortening = "noApprovalShortening",
  NoApprovalSpecial = "noApprovalSpecial"
}

export type CustomerTreeItem = {
  CustomerRef: CustomerRef;
  HospitalRef?: Maybe<CustomerRef>;
  ParentId?: Maybe<Scalars["ObjectId"]>;
  ParentRef?: Maybe<CustomerRef>;
};

export enum CustomerType {
  Department = "Department",
  Hospital = "Hospital",
  Region = "Region"
}

export type CustomerWorkshiftSpan = {
  FromMinutes: Scalars["Int"];
  Profession: Scalars["String"];
  ToMinutes: Scalars["Int"];
  Workshift: Workshift;
};

export type CustomerWorkshiftSpanInput = {
  FromMinutes: Scalars["Int"];
  Profession: Scalars["String"];
  ToMinutes: Scalars["Int"];
  Workshift: Workshift;
};

export type CustomersFilter = {
  areasOfExpertise?: InputMaybe<Array<Scalars["String"]>>;
  callListIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerNumbers?: InputMaybe<Array<Scalars["String"]>>;
  directParentId?: InputMaybe<Scalars["ObjectId"]>;
  dontRestrictAreasOfExpertise?: InputMaybe<Scalars["Boolean"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]>;
  group?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  includeCustomerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  journalSystem?: InputMaybe<Scalars["String"]>;
  lastContactDate?: InputMaybe<DateRangeInput>;
  lastContactType?: InputMaybe<Array<LastContactType>>;
  myActivity?: InputMaybe<Scalars["Boolean"]>;
  nameStartsWith?: InputMaybe<Scalars["String"]>;
  organizationType?: InputMaybe<Array<OrganizationType>>;
  parentId?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  region?: InputMaybe<Array<Scalars["String"]>>;
  responsiblePersonId?: InputMaybe<Array<Scalars["String"]>>;
  specializations?: InputMaybe<Array<Scalars["String"]>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Array<CustomerType>>;
};

export type CustomersResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<Customer>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type CustomersTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars["Date"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type DateRangeInput2 = {
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type DefaultTravelZone = {
  label: Scalars["String"];
  name: Scalars["String"];
};

export type DoctorAreasOfExpertise = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: Maybe<Scalars["Boolean"]>;
  qualified?: Maybe<Scalars["Boolean"]>;
  specializations: Array<DoctorSpecialization>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type DoctorAreasOfExpertiseInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: InputMaybe<Scalars["Boolean"]>;
  qualified?: InputMaybe<Scalars["Boolean"]>;
  specializations: Array<DoctorSpecializationInput>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type DoctorProfession = ConsultantProfession & {
  areasOfExpertise: Array<DoctorAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export type DoctorProfessionInput = {
  areasOfExpertise: Array<DoctorAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export type DoctorSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
};

export type DoctorSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
};

export type Document = {
  DocumentType?: Maybe<Scalars["String"]>;
  FileRef: FileRef;
  PdfURL: Scalars["String"];
  PreviewURL: Scalars["String"];
  ThumbURL: Scalars["String"];
};

export type DocumentInput = {
  DocumentType?: InputMaybe<Scalars["String"]>;
  FileRef: FileRefInput;
  PdfURL?: InputMaybe<Scalars["String"]>;
  ThumbURL?: InputMaybe<Scalars["String"]>;
};

export enum DocumentShareType {
  Private = "Private",
  Public = "Public",
  Shared = "Shared"
}

export enum DrivingLicenceType {
  Automatic = "Automatic",
  Manual = "Manual"
}

export enum DrivingLicenceTypeInput {
  Automatic = "Automatic",
  Manual = "Manual",
  NotSet = "NotSet"
}

export enum DurationType {
  Date = "Date",
  Week = "Week"
}

export type EditConsultantOpportunityInput = {
  areaOfExpertise?: InputMaybe<Scalars["String"]>;
  costCenter?: InputMaybe<Scalars["String"]>;
  customerId?: InputMaybe<Scalars["ObjectId"]>;
  estimatedResponseDate?: InputMaybe<Scalars["Date"]>;
  note?: InputMaybe<Scalars["String"]>;
  projectId?: InputMaybe<Scalars["ObjectId"]>;
};

export type EditProof = {
  _id?: Maybe<Scalars["ObjectId"]>;
  editBy?: Maybe<UserRef>;
  editOn?: Maybe<Scalars["String"]>;
  fileRefs?: Maybe<Array<FileRef>>;
};

export type EducationCC = {
  Show?: Maybe<Scalars["Boolean"]>;
  Text?: Maybe<Scalars["String"]>;
};

export type EducationCCInput = {
  Show?: InputMaybe<Scalars["Boolean"]>;
  Text?: InputMaybe<Scalars["String"]>;
};

export type EmailInput = {
  attachments?: InputMaybe<Array<Scalars["ObjectId"]>>;
  body?: InputMaybe<Scalars["String"]>;
  /** sender, opt email address */
  from?: InputMaybe<Scalars["String"]>;
  recipients: Array<EmailRecipientInput>;
  subject?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["ObjectId"]>;
};

export type EmailRecipient = {
  Email: Scalars["String"];
  Name?: Maybe<Scalars["String"]>;
};

export type EmailRecipientInput = {
  email: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
};

export type EmailResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export type Event = {
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  /** direct links. For example link to a document preview */
  Links?: Maybe<Array<Scalars["String"]>>;
  Sticky: Scalars["Boolean"];
  UpdatedBy?: Maybe<WeakUserRef>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export type EventInput = {
  Description: Scalars["String"];
  Node: NodeRefInput;
  Sticky: Scalars["Boolean"];
};

export type Expertise = {
  Aliases: Array<Scalars["String"]>;
  Educations: Array<Scalars["String"]>;
  Exclusive?: Maybe<Scalars["Boolean"]>;
  Internal?: Maybe<Scalars["Boolean"]>;
  Machines: Array<Scalars["String"]>;
  Methods: Array<Scalars["String"]>;
  Name: Scalars["String"];
  Profession: Scalars["String"];
  QualityTemplates: Array<QualityTemplate>;
  Specializations: Array<Scalars["String"]>;
  Systems: Array<Scalars["String"]>;
};

export type ExpertiseConfig = {
  ADGroup: Array<Scalars["String"]>;
  Aliases: Array<Scalars["String"]>;
  Exclusive: Scalars["Boolean"];
  Internal: Scalars["Boolean"];
  Name: Scalars["String"];
  QualityTemplates: Scalars["String"];
  SNI: Array<Scalars["Int"]>;
  Specializations: Array<Scalars["String"]>;
};

export type ExpertiseInput = {
  exclusive?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
};

export enum ExternalDocumentSource {
  Erp = "Erp"
}

export enum ExternalOrderStatus {
  Closed = "Closed",
  Open = "Open"
}

export enum ExternalOrderType {
  Default = "Default",
  QualityCheck = "QualityCheck",
  Reference = "Reference"
}

export type ExtractContactPersonResult = {
  contactPerson?: Maybe<ContactPerson>;
  validationErrors: Array<ValidationError>;
};

export type FileRef = {
  MimeType: Scalars["String"];
  Name?: Maybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Size: Scalars["Int"];
};

export type FileRefInput = {
  MimeType?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Size?: InputMaybe<Scalars["Int"]>;
};

export type FilterInput = {
  exclude?: InputMaybe<Array<Scalars["ObjectId"]>>;
  include?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type FinaliseConsultantOpportunityResult = {
  lost?: Maybe<ConsultantOpportunity>;
  won?: Maybe<ConsultantOpportunity>;
};

export type FormAddress = BaseFormAddress & {
  city: Scalars["String"];
  country: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FormAddressInput = {
  city: Scalars["String"];
  country: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FormAddressWithRegion = BaseFormAddress & {
  city: Scalars["String"];
  country: Scalars["String"];
  region: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FormAddressWithRegionInput = {
  city: Scalars["String"];
  country: Scalars["String"];
  region: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FortnoxSalaryCache = {
  consultantId: Scalars["ObjectId"];
  employeeId: Scalars["String"];
  id: Scalars["String"];
  lastFetchedAt?: Maybe<Scalars["String"]>;
  yearSums: Array<FortnoxSalaryYearSum>;
};

export type FortnoxSalaryYearSum = {
  sum: Scalars["Float"];
  year: Scalars["Int"];
};

export type FortnoxVoucherSubmitResult = {
  result?: Maybe<Scalars["String"]>;
};

export type FortnoxWeekSalaryCheck = {
  employeeId: Scalars["String"];
  takenWeekDays: Array<Scalars["Int"]>;
};

export type FreeTimereportResult = {
  freeTimereports: Array<Scalars["JSON"]>;
};

export type FreshdeskTicket = {
  createdAt: Scalars["Date"];
  id: Scalars["Int"];
  status: Scalars["String"];
  subject: Scalars["String"];
  updatedAt: Scalars["Date"];
  url: Scalars["String"];
};

export enum GDPRCommunicationChannel {
  Email = "Email",
  InterestForm = "InterestForm",
  MobileApp = "MobileApp",
  NotDefined = "NotDefined",
  Self = "Self",
  UnfitAction = "UnfitAction",
  Verbal = "Verbal"
}

export type GDPRConsent = {
  communicationChannel: GDPRCommunicationChannel;
  dateGranted?: Maybe<Scalars["Date"]>;
  dateRevoked?: Maybe<Scalars["Date"]>;
  granted?: Maybe<Scalars["Boolean"]>;
  grantedBy?: Maybe<NodeRef>;
  revokedBy?: Maybe<NodeRef>;
  type: GDPRConsentType;
};

export enum GDPRConsentType {
  IntegrationPolicy = "IntegrationPolicy",
  JobMailing = "JobMailing",
  JobMailingCampaignEmail = "JobMailingCampaignEmail",
  JobMailingEmail = "JobMailingEmail",
  JobMailingSms = "JobMailingSms",
  Marketing = "Marketing"
}

export type GDPRInput = {
  communicationChannel: GDPRCommunicationChannel;
  granted: Scalars["Boolean"];
  type: GDPRConsentType;
};

export enum GDPROptionType {
  No = "No",
  NotSpecified = "NotSpecified",
  Yes = "Yes"
}

export type GeneratePresentationAttachmentError = {
  error: Scalars["String"];
  fileId: Scalars["String"];
  filename: Scalars["String"];
};

export type GeneratePresentationResult = {
  attachmentErrors: Array<GeneratePresentationAttachmentError>;
  presentation?: Maybe<ConsultantPresentation>;
};

export type GenericProfession = ConsultantProfession & {
  certifiedFrom?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<GenericSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type GenericProfessionInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<GenericSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type GenericSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type GenericSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type Geolocation = {
  geometry: Geometry;
};

export type Geometry = {
  coordinates: Array<Scalars["Float"]>;
  type: Scalars["String"];
};

export type GetAttestContactPersonsResult = {
  items: Array<ContactPerson>;
  workplaceAllowsDigitalTimereport: Scalars["Boolean"];
};

export type GetTimereportToCustomerEmailResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export enum HasBookingKitsFilter {
  False = "False",
  MissingCompleteAndAccruedCost = "MissingCompleteAndAccruedCost",
  MissingCompleteAndAccruedIncome = "MissingCompleteAndAccruedIncome",
  True = "True"
}

export type HealthDeclarationDocument = {
  createdAt: Scalars["Date"];
  id: Scalars["ID"];
  name: Scalars["String"];
  signedAt?: Maybe<Scalars["Date"]>;
  status: Scalars["String"];
  url: Scalars["String"];
};

export enum HealthDeclarationStatus {
  Pending = "Pending",
  Signed = "Signed"
}

export type HealthDeclarationsQueryResult = {
  items: Array<HealthDeclarationDocument>;
  total: Scalars["Int"];
};

export type HighHoliday = {
  _id: Scalars["ObjectId"];
  isGreatHoliday?: Maybe<Scalars["Boolean"]>;
  option: HighHolidayOption;
};

export type HighHolidayInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  isGreatHoliday?: InputMaybe<Scalars["Boolean"]>;
  option: HighHolidayOptionInput;
};

export type HighHolidayOption = {
  _id: Scalars["ObjectId"];
  listPosition?: Maybe<Scalars["Float"]>;
  name?: Maybe<Scalars["String"]>;
};

export type HighHolidayOptionInput = {
  _id: Scalars["ObjectId"];
  listPosition: Scalars["Float"];
  name: Scalars["String"];
};

export enum HospitalityPaidBy {
  Bonliva = "Bonliva",
  Consultant = "Consultant"
}

export type HourlyRatesInput = {
  Day: Scalars["Float"];
  Evening: Scalars["Float"];
  Holiday: Scalars["Float"];
  Night: Scalars["Float"];
  OnCall: Scalars["Float"];
  Weekend: Scalars["Float"];
};

export type IContact = {
  Address?: Maybe<Address>;
  AvatarPic?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles?: Maybe<Array<Scalars["String"]>>;
  Title?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type INode = {
  IsValid?: Maybe<Scalars["Boolean"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  ValidationErrors: Array<NodeValidationError>;
  _id: Scalars["ObjectId"];
};

export type ImportConsultantMeta = {
  importBatch?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["JSON"]>;
};

export type ImportConsultantMetaInput = {
  importBatch?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["JSON"]>;
};

export enum InitialContact {
  CreatedByBonliva = "CreatedByBonliva",
  CreatedByWCC = "CreatedByWCC",
  Recommendation = "Recommendation",
  SelfRegister = "SelfRegister"
}

export type Invoice = {
  CustomerName?: Maybe<Scalars["String"]>;
  CustomerNumber?: Maybe<Scalars["String"]>;
  DueDate?: Maybe<Scalars["Date"]>;
  InvoiceDate?: Maybe<Scalars["Date"]>;
  InvoiceNumber: Scalars["String"];
  InvoiceTotal?: Maybe<Scalars["Float"]>;
  IsCredit: Scalars["Boolean"];
  Notes?: Maybe<Scalars["String"]>;
  PreviewUrl: Scalars["String"];
  Provider: InvoiceProvider;
  TotalGross?: Maybe<Scalars["Float"]>;
  TotalNet?: Maybe<Scalars["Float"]>;
  _id: Scalars["ObjectId"];
};

export enum InvoiceMonth {
  FirstMonth = "FirstMonth",
  Full = "Full",
  SecondMonth = "SecondMonth"
}

export enum InvoiceProvider {
  Bonliva = "Bonliva",
  BonlivaCare = "BonlivaCare",
  Fortnox = "Fortnox",
  WCC = "WCC"
}

export enum InvoiceSplitType {
  ByDate = "ByDate",
  ByShift = "ByShift"
}

export enum InvoicingStrategyType {
  CreationDate = "CreationDate",
  ExecutionDate = "ExecutionDate"
}

export type KanbanBoard = {
  _id: Scalars["String"];
  columns: Array<KanbanColumn>;
  name: Scalars["String"];
  owner: User;
  type: KanbanBoardType;
};

export enum KanbanBoardType {
  ConsultantOpportunity = "ConsultantOpportunity",
  ConsultantPipeline = "ConsultantPipeline"
}

export type KanbanCard = {
  _id: Scalars["String"];
  assignee?: Maybe<User>;
  boardId: Scalars["String"];
  columnId: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  order: Scalars["Int"];
  title: Scalars["String"];
};

export type KanbanCardActionPayload = {
  boardId: Scalars["String"];
  cardId: Scalars["String"];
  sessionId: Scalars["String"];
  userId: Scalars["ObjectId"];
};

export type KanbanColumn = {
  _id: Scalars["String"];
  name: Scalars["String"];
  order: Scalars["Int"];
};

export type KitAssignedTo = {
  by?: Maybe<UserRef>;
  on?: Maybe<Scalars["Date"]>;
  to?: Maybe<UserRef>;
};

export enum LanguageSkillLevel {
  Fluent = "Fluent",
  Good = "Good",
  OK = "OK"
}

export enum LastContactType {
  Call = "Call",
  Comment = "Comment",
  Email = "Email",
  Interest = "Interest",
  MetInPerson = "MetInPerson",
  NoCall = "NoCall",
  NoCallAttempts = "NoCallAttempts",
  NoComment = "NoComment",
  NoContactAttempts = "NoContactAttempts",
  Noanswer = "Noanswer",
  Registered = "Registered",
  Reminder = "Reminder",
  SMS = "SMS"
}

export enum LegalBasis {
  Agreement = "Agreement",
  Consent = "Consent",
  InterestAssessment = "InterestAssessment"
}

export enum LegalPersonType {
  Employee = "Employee",
  Subcontractor = "Subcontractor"
}

export enum LegalPersonTypeWithNoOption {
  Employee = "Employee",
  NoOption = "NoOption",
  Subcontractor = "Subcontractor"
}

export type LocationKlm = {
  klm?: InputMaybe<Scalars["String"]>;
  zipOrCity?: InputMaybe<Scalars["String"]>;
};

export type LoginAttempt = {
  Date: Scalars["Date"];
  Ip: Scalars["String"];
  Success: Scalars["Boolean"];
};

export enum LuggageType {
  Handluggage = "Handluggage",
  HandluggagePlusChecked = "HandluggagePlusChecked"
}

export type Me = BaseUser & {
  AvatarPic?: Maybe<Scalars["String"]>;
  AzureGroups?: Maybe<Array<Scalars["String"]>>;
  AzureId?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["Date"]>;
  CallLists: Array<CallList>;
  CellPhone?: Maybe<Scalars["String"]>;
  ContactLists: Array<CallList>;
  Deleted: Scalars["Boolean"];
  Email: Scalars["String"];
  Enabled: Scalars["Boolean"];
  ExtraAreasOfExpertise: Array<Expertise>;
  ManagerId?: Maybe<Scalars["ObjectId"]>;
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Permissions: UserPermissions;
  Phone?: Maybe<Scalars["String"]>;
  Teams: Array<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  allowedCostCenters: Array<CostCenter>;
  favoriteTeam?: Maybe<Scalars["String"]>;
  favouriteConsultantIds: Array<Scalars["ObjectId"]>;
  permissions: Array<Scalars["String"]>;
  subordinates: Array<User>;
  todoBadges: TodoUserBadges;
};

export type MePartial = {
  CallLists?: Maybe<Array<CallList>>;
  ContactLists?: Maybe<Array<CallList>>;
};

export type Municipality = {
  _id: Scalars["ObjectId"];
  name: Scalars["String"];
  region: Scalars["String"];
  zone: Scalars["String"];
};

export type Mutation = {
  addAccommodation: Accommodation;
  addAccommodationCommentEvent?: Maybe<AccommodationEvent>;
  addBookingCommentEvent?: Maybe<BookingEvent>;
  addBookingKitCommentEvent?: Maybe<BookingKitEvent>;
  addConsultantAvailability: Consultant;
  addConsultantBookingContract: ConsultantBookingContractListItem;
  addConsultantCallEvent?: Maybe<ConsultantEvent>;
  addConsultantCommentEvent?: Maybe<ConsultantEvent>;
  addConsultantInterestEvent?: Maybe<ConsultantEvent>;
  addConsultantNoanswerEvent?: Maybe<AddNoanswerEventResult>;
  addConsultantReminderEvent?: Maybe<ConsultantEvent>;
  addConsultantSMSEvent?: Maybe<ConsultantEvent>;
  addConsultantTag: Consultant;
  addConsultantWorkExperience: ConsultantWorkExperienceResult;
  addCustomerCommentEvent?: Maybe<CustomerEvent>;
  addCustomerContractCommentEvent: CustomerContractOpResult;
  addCustomerMetInPersonEvent?: Maybe<CustomerEvent>;
  addCustomerReminderEvent?: Maybe<CustomerEvent>;
  addSalaryChoiceToConsultantContract: ConsultantContractListItem;
  addToCallList: CallListOpResult;
  addTodoCommentEvent?: Maybe<TodoEvent>;
  addTodoReminderEvent?: Maybe<TodoEvent>;
  addUnSignConsultantContract: ConsultantContractListItem;
  approveBookingKit: BookingKit;
  approveTimereport?: Maybe<Scalars["Boolean"]>;
  assignContactPersonToCustomer: AssignContactPersonToCustomerResult;
  assignFortnoxInvoiceToBooking: UpdateBookingResult;
  assignTimereportToBooking?: Maybe<Scalars["Boolean"]>;
  assignToBooking: BookingAssignedToResult;
  assignToBookingKit: Scalars["Boolean"];
  assignTodo?: Maybe<TodoItem>;
  bulkAction: BulkActionResult;
  bulkUpdateResponsiblePerson: BulkUpdateResult;
  cancelBooking?: Maybe<Scalars["Boolean"]>;
  cancelBookingGroup?: Maybe<Scalars["Boolean"]>;
  changeConsultantServicePreferenceStatus: ConsultantServicePreference;
  changeStatusConsultantReference: ConsultantReferenceNew;
  clearConsultantResponsiblePerson: Consultant;
  clearQualityItemStatus: Consultant;
  clearTimereportDays?: Maybe<Scalars["Boolean"]>;
  cloneBooking: Scalars["ObjectId"];
  confirmAccommodation: BookingHospitality;
  confirmTravel: BookingHospitality;
  consultantExportBulkAction: BulkActionResult;
  consultantExportSsnBulkAction: BulkActionResult;
  consultantGeneratePresentation: GeneratePresentationResult;
  consultantImportDeduplicate: Array<ConsultantImportRow>;
  consultantImportLookupRows: Array<ConsultantImportRow>;
  createAccommodationRequest: AccommodationRequest;
  createApiToken: CreateApiTokenResult;
  createBookingGroup: BookingGroup;
  createBookingKit: BookingKit;
  createCallList: CallListOpResult;
  createConsultantOpportunity: ConsultantOpportunity;
  createConsultantReference: ConsultantReferenceNew;
  createConsultantServicePreference: ConsultantServicePreference;
  createConsultantWorkStatus: ConsultantWorkStatus;
  createContactPerson: CreateContactPersonResult;
  createCostCenter: CostCenterConfigItem;
  createCustomer: CreateCustomerResult;
  createDirectRequestContract: CustomerContractOpResult;
  createTgRequirement: TgRequirement;
  createTravelRequest: TravelRequest;
  deassignContactPersonFromCustomers: ContactPerson;
  deleteAccommodation: Accommodation;
  deleteAccommodationDocument?: Maybe<Scalars["Boolean"]>;
  deleteAccommodationEvent?: Maybe<AccommodationEvent>;
  deleteBookingDocument: Scalars["Boolean"];
  deleteBookingEvent?: Maybe<BookingEvent>;
  deleteBookingKit?: Maybe<Scalars["Boolean"]>;
  deleteBookingKitEvent?: Maybe<BookingKitEvent>;
  deleteConsultantAvailability: Consultant;
  deleteConsultantBookingContract: ConsultantBookingContract;
  deleteConsultantContract: ConsultantContract;
  deleteConsultantEvent?: Maybe<ConsultantEvent>;
  deleteConsultantOpportunity: Scalars["Boolean"];
  deleteConsultantReference: Scalars["Boolean"];
  deleteConsultantServicePreference: Scalars["Boolean"];
  deleteConsultantWorkStatus: Scalars["Boolean"];
  deleteConsultants?: Maybe<Total>;
  deleteContactPerson: Scalars["Boolean"];
  deleteContractPriceTemplate: ContractPriceTemplateOpResult;
  deleteCostCenter: CostCenterConfigItem;
  deleteCustomer: Customer;
  deleteCustomerContractDocument: CustomerContractOpResult;
  deleteCustomerContractEvent: CustomerContractOpResult;
  deleteCustomerContractSnapshot: CustomerContractSnapshotOpResult;
  deleteCustomerContractSubVersion: CustomerContractOpResult;
  deleteCustomerDocument: Array<CustomerDocument>;
  deleteCustomerEvent?: Maybe<Scalars["Boolean"]>;
  deleteRestoreCustomerContract: CustomerContractOpResult;
  deleteTgRequirement: Scalars["Boolean"];
  deleteTodoEvent?: Maybe<TodoEvent>;
  duplicateConsultantToTenant?: Maybe<Scalars["String"]>;
  duplicateContractPriceTemplate: ContractPriceTemplateOpResult;
  editAccommodation: Accommodation;
  editConsultantBookingContract: ConsultantBookingContractListItem;
  editConsultantOpportunity: Scalars["Boolean"];
  editUnSignConsultantContract: ConsultantContractListItem;
  extractContactPerson: ExtractContactPersonResult;
  finaliseConsultantOpportunity: FinaliseConsultantOpportunityResult;
  generateCustomerContractSnapshot: CustomerContractSnapshotOpResult;
  importCV: ConsultantForm;
  importConsultants: ConsultantImportDocumentResult;
  leaveCallList: CallListOpResult;
  mergeConsultantReference: ConsultantReferenceNew;
  moveCard: Scalars["Boolean"];
  moveCustomer: UpdateMoveCustomerResult;
  nullifyConsultantBookingContract: ConsultantBookingContractListItem;
  nullifyConsultantContract: ConsultantContractListItem;
  nullifyCustomerContractSnapshot: CustomerContractSnapshotOpResult;
  pinAccommodationEvent?: Maybe<AccommodationEvent>;
  pinConsultantEvent?: Maybe<ConsultantEvent>;
  publishBookingContract: PublishContractResult;
  publishContract: PublishContractResult;
  publishContractViaWorkflow: PublishContractResult;
  publishCustomerContractSnapshot: Scalars["String"];
  publishPayFormRecordsToFortnox: WorkflowRun;
  publishSickPayFormToFortnox: WorkflowRun;
  publishSubcontractorInvoiceWorkflow: WorkflowRun;
  reSendConsultantReferenceForm: ConsultantReferenceNew;
  reactivateQualityItem: Consultant;
  refreshFortnoxSalaryCache: FortnoxSalaryCache;
  rejectBookingKit: BookingKit;
  rejectDoneBookingKit: BookingKit;
  removeAccommodationDocument?: Maybe<Scalars["Boolean"]>;
  removeConsultantAvatar?: Maybe<Consultant>;
  removeConsultantDocument: Scalars["Boolean"];
  removeConsultantTag: Consultant;
  removeCustomerAvatar?: Maybe<Customer>;
  removeCustomerContractPriceList: CustomerContractOpResult;
  removeFromCallList: CallListOpResult;
  removeSearchProfile: Scalars["Int"];
  removeSharedFile: Scalars["Boolean"];
  removeTravelDocument?: Maybe<Scalars["Boolean"]>;
  renameCallList: CallListOpResult;
  requestUpdToKvkConsultantReference: SendToKvkConsultantReferencePayload;
  resetConsultantUnfit: Consultant;
  restoreConsultantReference: ConsultantReferenceNew;
  restoreCostCenter: CostCenterConfigItem;
  resyncInvoice?: Maybe<Invoice>;
  revokeApiToken: ApiToken;
  runAutoCreateBookingKit: Scalars["Boolean"];
  saveConsultantSelection: SaveConsultantsResult;
  saveHSAIDStatusParams: Consultant;
  saveToFavouriteContractPriceTemplate: ContractPriceTemplateOpResult;
  sendBookingKitToOc: BookingKit;
  sendConsultantBookingContractEmailToBA?: Maybe<EmailResult>;
  sendConsultantContractEmailToConsultant?: Maybe<SendEmailToConsultantResult>;
  sendConsultantPresentation: Scalars["Boolean"];
  sendConsultantReferenceForm: ConsultantReferenceNew;
  sendConsultantToMedlo: SendConsultantToMedloResult;
  sendEmail?: Maybe<Scalars["String"]>;
  sendEmailToConsultant?: Maybe<SendEmailToConsultantResult>;
  sendMassEmail: SendMassEmailResult;
  sendMassSMSToConsultants: SendMassSMSToConsultantsResult;
  sendRequestIVO: Consultant;
  sendTimereportToConsultant?: Maybe<Scalars["String"]>;
  sendTimereportToCustomer?: Maybe<EmailResult>;
  sendToKvkConsultantReference: SendToKvkConsultantReferencePayload;
  setBookedStatus: Consultant;
  setBookingAdditionalPayout: Booking;
  setBookingCallNumber?: Maybe<Scalars["Boolean"]>;
  setCallListMembers: CallListOpResult;
  setConsultantNextContactDate: Scalars["Boolean"];
  setConsultantPipelineStatus: Consultant;
  setConsultantPipelineStatusComment: Consultant;
  setConsultantResponsiblePerson: Consultant;
  setConsultantResponsibleStatus: Consultant;
  setConsultantUnfit: Consultant;
  setConsultantWelcomeEmailSent: Consultant;
  setCustomerContractInvoiceStrategy: CustomerContractOpResult;
  setCustomerRecommendedPrices: Customer;
  setOrderedStatus: Consultant;
  setQualityItemApprovedStatus: Consultant;
  setQualityItemApprovedWithCommentStatus: Consultant;
  setQualityItemPausedStatus: Consultant;
  setQualityItemRequestReceivedStatus: Consultant;
  setQualityItemRequestSentIVOStatus: Consultant;
  setQualityItemRequestSentStatus: Consultant;
  setSkipTimereportReminder: BookingSkipTimereportReminderResults;
  setSupportTagToBooking: Array<BookingSupportTagStatus>;
  setTimereportToDraft?: Maybe<TimereportResult>;
  setTimereportToSubmitted?: Maybe<Scalars["Boolean"]>;
  setTodoStatus?: Maybe<TodoItem>;
  setUnlockBookingForms: UnlockFormsResult;
  submitConsultantForm: ConsultantFormResult;
  submitConsultantKarens: Consultant;
  submitContractPriceTemplateForm: ContractPriceTemplateOpResult;
  submitCustomerContractForm: CustomerContractOpResult;
  submitCustomerContractInfo: CustomerContractOpResult;
  submitCustomerContractPriceListForm: CustomerContractOpResult;
  submitCustomerContractSnapshotForm: CustomerContractSnapshotOpResult;
  submitCustomerContractSubVersionForm: CustomerContractOpResult;
  submitFortnoxVoucher?: Maybe<FortnoxVoucherSubmitResult>;
  submitSearchProfileForm: SearchProfile;
  syncTimeReportsWithBookingSearch: Array<Scalars["String"]>;
  toggleAccommodationConfirmation?: Maybe<BookingHospitality>;
  toggleConsultantFavourite: Scalars["Boolean"];
  toggleCostCenterActive: CostCenterConfigItem;
  toggleCustomerNoApproval: Customer;
  toggleCustomerSettings: Customer;
  toggleTravelConfirmation?: Maybe<BookingHospitality>;
  transitionConsultantQualityItem: Consultant;
  unAssignFromBookingKit: Scalars["Boolean"];
  unAssignToBooking: BookingAssignedToResult;
  unsetConsultantNextContactDate: Scalars["Boolean"];
  updateAccommodationConfirmation?: Maybe<Scalars["Boolean"]>;
  updateAccommodationEvent?: Maybe<AccommodationEvent>;
  updateBookingAudit?: Maybe<Scalars["Boolean"]>;
  updateBookingEvent?: Maybe<BookingEvent>;
  updateBookingFinance: Booking;
  updateBookingGroup: BookingGroup;
  updateBookingKit: BookingKit;
  updateBookingKitEvent?: Maybe<BookingKitEvent>;
  updateBookingKitTags: Array<BookingSupportTagStatus>;
  updateBookingProject: UpdateBookingResult;
  updateCommentForBookingAudit?: Maybe<Scalars["Boolean"]>;
  updateConsultantEvent?: Maybe<ConsultantEvent>;
  updateConsultantGDPR?: Maybe<Consultant>;
  updateConsultantGeneralInterest: Consultant;
  updateConsultantLeadStatus: Consultant;
  updateConsultantQualityNote: Scalars["Boolean"];
  updateConsultantReference: ConsultantReferenceNew;
  updateConsultantServicePreference: ConsultantServicePreference;
  updateConsultantStatus?: Maybe<Consultant>;
  updateConsultantUserSettings?: Maybe<Consultant>;
  updateConsultantWorkStatus: ConsultantWorkStatus;
  updateContactPerson: UpdateContactPersonResult;
  updateCostCenter: CostCenterConfigItem;
  updateCustomer: UpdateCustomerResult;
  updateCustomerContractEvent: CustomerContractOpResult;
  updateCustomerEvent?: Maybe<CustomerEvent>;
  updateCustomerRefsSearchProfiles: Array<SearchProfile>;
  updateFavoriteTeam?: Maybe<Me>;
  updateSharedFile: SharedFile;
  updateTgRequirement: TgRequirement;
  updateTodoEvent?: Maybe<TodoEvent>;
  updateTravelConfirmation?: Maybe<Scalars["Boolean"]>;
  updateUnfitAccommodation: AccommodationUnfit;
  uploadAccommodationDocument: Document;
  uploadBlob: Scalars["String"];
  uploadBookingDocument: UploadBookingDocumentResult;
  uploadConsultantAvatar?: Maybe<Consultant>;
  /** @deprecated Use uploadConsultantDocuments */
  uploadConsultantDocument: Document;
  uploadConsultantDocuments: Array<Document>;
  uploadCustomerAvatar?: Maybe<Customer>;
  uploadCustomerBgPic?: Maybe<Customer>;
  uploadCustomerContractDocument: CustomerContractOpResult;
  uploadCustomerContractSignedDocument: CustomerContractSnapshotOpResult;
  uploadCustomerDocument: Array<CustomerDocument>;
  uploadDocument: Document;
  uploadSharedFile: SharedFile;
  uploadSignedConsultantBookingContract: ConsultantBookingContractListItem;
  uploadSignedConsultantContract: ConsultantContractListItem;
};

export type MutationAddAccommodationArgs = {
  data: AccommodationInput;
  img?: InputMaybe<Scalars["Upload"]>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationAddAccommodationCommentEventArgs = {
  accommodationId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddBookingCommentEventArgs = {
  bookingId: Scalars["ObjectId"];
  desc: Scalars["String"];
};

export type MutationAddBookingKitCommentEventArgs = {
  desc: Scalars["String"];
  kitId: Scalars["ObjectId"];
};

export type MutationAddConsultantAvailabilityArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantAvailabilityInput;
};

export type MutationAddConsultantBookingContractArgs = {
  consultantId: Scalars["ObjectId"];
  data: ConsultantBookingContractFormInput;
};

export type MutationAddConsultantCallEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
};

export type MutationAddConsultantCommentEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddConsultantInterestEventArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationAddConsultantNoanswerEventArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationAddConsultantReminderEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddConsultantSMSEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddConsultantTagArgs = {
  consultantId: Scalars["ObjectId"];
  tag: Scalars["String"];
};

export type MutationAddConsultantWorkExperienceArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  data: ConsultantWorkExperienceItemInput;
};

export type MutationAddCustomerCommentEventArgs = {
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddCustomerContractCommentEventArgs = {
  customerContractId: Scalars["ObjectId"];
  eventLog: CustomerContractEventInput;
};

export type MutationAddCustomerMetInPersonEventArgs = {
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddCustomerReminderEventArgs = {
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddSalaryChoiceToConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
  salaryChoice: ContractType;
};

export type MutationAddToCallListArgs = {
  callListId: Scalars["ObjectId"];
  node: NodeRefFullInput;
};

export type MutationAddTodoCommentEventArgs = {
  desc: Scalars["String"];
  todoId: Scalars["ObjectId"];
};

export type MutationAddTodoReminderEventArgs = {
  desc: Scalars["String"];
  todoId: Scalars["ObjectId"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddUnSignConsultantContractArgs = {
  consultantId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
};

export type MutationApproveBookingKitArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationApproveTimereportArgs = {
  approvedBy: Scalars["String"];
  timereportId: Scalars["ObjectId"];
};

export type MutationAssignContactPersonToCustomerArgs = {
  contactPersonId: Scalars["ObjectId"];
  customerId: Scalars["ObjectId"];
};

export type MutationAssignFortnoxInvoiceToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  isGroupInvoicing?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationAssignTimereportToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  timeReportId: Scalars["ObjectId"];
};

export type MutationAssignToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationAssignToBookingKitArgs = {
  kitId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationAssignTodoArgs = {
  todoId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationBulkActionArgs = {
  input: BulkActionInput;
};

export type MutationBulkUpdateResponsiblePersonArgs = {
  ids: Array<Scalars["ObjectId"]>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationCancelBookingArgs = {
  bookingId: Scalars["ObjectId"];
  reason: Scalars["String"];
};

export type MutationCancelBookingGroupArgs = {
  bookingGroupId: Scalars["ObjectId"];
  reason: Scalars["String"];
};

export type MutationChangeConsultantServicePreferenceStatusArgs = {
  id: Scalars["ObjectId"];
  status: ConsultantServicePreferenceStatus;
};

export type MutationChangeStatusConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  file?: InputMaybe<Scalars["Upload"]>;
  input?: InputMaybe<ChangeStatusConsultantReferenceInput>;
};

export type MutationClearConsultantResponsiblePersonArgs = {
  consultantId: Scalars["ObjectId"];
  setLeadStatus?: InputMaybe<ConsultantLeadStatus>;
};

export type MutationClearQualityItemStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
};

export type MutationClearTimereportDaysArgs = {
  timeReportId: Scalars["ObjectId"];
};

export type MutationCloneBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type MutationConfirmAccommodationArgs = {
  input: ConfirmAccommodationInput;
};

export type MutationConfirmTravelArgs = {
  input: ConfirmTravelInput;
};

export type MutationConsultantExportBulkActionArgs = {
  filter: ConsultantsQueryInput;
};

export type MutationConsultantExportSsnBulkActionArgs = {
  filter: ConsultantsQueryInput;
};

export type MutationConsultantGeneratePresentationArgs = {
  consultantId: Scalars["ObjectId"];
  contactPerson?: InputMaybe<Scalars["String"]>;
  evaluatesIds: Array<Scalars["ObjectId"]>;
  evaluatesThreeMonthsIds: Array<Scalars["ObjectId"]>;
  fileIds: Array<Scalars["ObjectId"]>;
  generateCV?: InputMaybe<Scalars["Boolean"]>;
  presentationCountry: ConsultantPresentationCountry;
  presentationText?: InputMaybe<Scalars["String"]>;
  presentationType: ConsultantPresentationType;
  referenceIds: Array<Scalars["ObjectId"]>;
};

export type MutationConsultantImportDeduplicateArgs = {
  rows: Array<ConsultantImportRowsInput>;
};

export type MutationConsultantImportLookupRowsArgs = {
  rows: Array<ConsultantImportRowsInput>;
};

export type MutationCreateAccommodationRequestArgs = {
  bookingGroupId?: InputMaybe<Scalars["ObjectId"]>;
  bookingIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  data: AccommodationRequestInput;
  file?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateApiTokenArgs = {
  name: Scalars["String"];
};

export type MutationCreateBookingGroupArgs = {
  duplicateFromBookingId?: InputMaybe<Scalars["ObjectId"]>;
  input: BookingGroupInput;
};

export type MutationCreateBookingKitArgs = {
  input: CreateBookingKitInput;
};

export type MutationCreateCallListArgs = {
  data: CallListCreateInput;
  type: CallListType;
};

export type MutationCreateConsultantOpportunityArgs = {
  input: CreateConsultantOpportunityInput;
};

export type MutationCreateConsultantReferenceArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantReferenceInputNew;
};

export type MutationCreateConsultantServicePreferenceArgs = {
  consultantId: Scalars["ObjectId"];
  input: CreateConsultantServicePreferenceInput;
};

export type MutationCreateConsultantWorkStatusArgs = {
  consultantId: Scalars["ObjectId"];
  input: CreateConsultantWorkStatusInput;
};

export type MutationCreateContactPersonArgs = {
  data: ContactPersonInput;
};

export type MutationCreateCostCenterArgs = {
  input: CreateCostCenterInput;
};

export type MutationCreateCustomerArgs = {
  input: CustomerInput;
};

export type MutationCreateDirectRequestContractArgs = {
  data: CreateDirectRequestContractInput;
};

export type MutationCreateTgRequirementArgs = {
  input: CreateTgRequirementInput;
};

export type MutationCreateTravelRequestArgs = {
  bookingGroupId?: InputMaybe<Scalars["ObjectId"]>;
  bookingIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  data: TravelRequestInput;
};

export type MutationDeassignContactPersonFromCustomersArgs = {
  contactPersonId: Scalars["ObjectId"];
  customerIds: Array<Scalars["ObjectId"]>;
};

export type MutationDeleteAccommodationArgs = {
  accommodationId: Scalars["ObjectId"];
};

export type MutationDeleteAccommodationDocumentArgs = {
  fileId: Scalars["ObjectId"];
  id: Scalars["ObjectId"];
};

export type MutationDeleteAccommodationEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteBookingDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationDeleteBookingEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteBookingKitArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteBookingKitEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantAvailabilityArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantAvailabilityInput;
};

export type MutationDeleteConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantOpportunityArgs = {
  issueId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  softDelete: Scalars["Boolean"];
};

export type MutationDeleteConsultantServicePreferenceArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteConsultantWorkStatusArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteConsultantsArgs = {
  ids: Array<Scalars["ObjectId"]>;
};

export type MutationDeleteContactPersonArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteContractPriceTemplateArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteCostCenterArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteCustomerArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractDocumentArgs = {
  customerContractId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractEventArgs = {
  customerContractId: Scalars["ObjectId"];
  eventLogId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractSnapshotArgs = {
  snapshotId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractSubVersionArgs = {
  subVersionId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerDocumentArgs = {
  customerId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteRestoreCustomerContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationDeleteTgRequirementArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteTodoEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDuplicateConsultantToTenantArgs = {
  id: Scalars["ObjectId"];
  toTenant: Scalars["String"];
};

export type MutationDuplicateContractPriceTemplateArgs = {
  data: ContractPriceTemplateInput;
};

export type MutationEditAccommodationArgs = {
  accommodationId: Scalars["ObjectId"];
  data: AccommodationInput;
  img?: InputMaybe<Scalars["Upload"]>;
};

export type MutationEditConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
  data: ConsultantBookingContractFormInput;
};

export type MutationEditConsultantOpportunityArgs = {
  input: EditConsultantOpportunityInput;
  issueId: Scalars["ObjectId"];
};

export type MutationEditUnSignConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
};

export type MutationExtractContactPersonArgs = {
  contactPersonId: Scalars["ObjectId"];
  customerId?: InputMaybe<Scalars["ObjectId"]>;
  data: ContactPersonInput;
};

export type MutationFinaliseConsultantOpportunityArgs = {
  issueId: Scalars["ObjectId"];
  weeksWon: Array<Scalars["Date"]>;
};

export type MutationGenerateCustomerContractSnapshotArgs = {
  snapshotId: Scalars["ObjectId"];
};

export type MutationImportCVArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  file: Scalars["Upload"];
};

export type MutationImportConsultantsArgs = {
  bisnodeLookup?: InputMaybe<Scalars["Boolean"]>;
  checkForDuplicates?: InputMaybe<Scalars["Boolean"]>;
  file: Scalars["Upload"];
};

export type MutationLeaveCallListArgs = {
  callListId: Scalars["ObjectId"];
};

export type MutationMergeConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  mergeWithRefId: Scalars["ObjectId"];
};

export type MutationMoveCardArgs = {
  beforeCardId?: InputMaybe<Scalars["String"]>;
  boardId: Scalars["String"];
  boardType: KanbanBoardType;
  cardId: Scalars["String"];
  columnId: Scalars["String"];
  sessionId?: InputMaybe<Scalars["String"]>;
};

export type MutationMoveCustomerArgs = {
  id: Scalars["ObjectId"];
  parentId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationNullifyConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
  nullify: Scalars["Boolean"];
};

export type MutationNullifyConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
  nullificationReason?: InputMaybe<Scalars["String"]>;
  nullify: Scalars["Boolean"];
};

export type MutationNullifyCustomerContractSnapshotArgs = {
  nullify: Scalars["Boolean"];
  snapshotId: Scalars["ObjectId"];
};

export type MutationPinAccommodationEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationPinConsultantEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationPublishBookingContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationPublishContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationPublishContractViaWorkflowArgs = {
  contractId: Scalars["ObjectId"];
  forcePublish?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationPublishCustomerContractSnapshotArgs = {
  snapshotId: Scalars["ObjectId"];
};

export type MutationPublishPayFormRecordsToFortnoxArgs = {
  bookingId: Scalars["ObjectId"];
  weekDay?: InputMaybe<Scalars["Int"]>;
};

export type MutationPublishSickPayFormToFortnoxArgs = {
  bookingId: Scalars["ObjectId"];
  weekDay?: InputMaybe<Scalars["Int"]>;
};

export type MutationPublishSubcontractorInvoiceWorkflowArgs = {
  bookingId: Scalars["ObjectId"];
};

export type MutationReSendConsultantReferenceFormArgs = {
  consultantReferenceId: Scalars["ObjectId"];
};

export type MutationReactivateQualityItemArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationRefreshFortnoxSalaryCacheArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationRejectBookingKitArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationRejectDoneBookingKitArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationRemoveAccommodationDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationRemoveConsultantAvatarArgs = {
  id: Scalars["ObjectId"];
};

export type MutationRemoveConsultantDocumentArgs = {
  documentId: Scalars["ObjectId"];
};

export type MutationRemoveConsultantTagArgs = {
  consultantId: Scalars["ObjectId"];
  tag: Scalars["String"];
};

export type MutationRemoveCustomerAvatarArgs = {
  id: Scalars["ObjectId"];
};

export type MutationRemoveCustomerContractPriceListArgs = {
  priceListId: Scalars["ObjectId"];
};

export type MutationRemoveFromCallListArgs = {
  callListId: Scalars["ObjectId"];
  nodeId: Scalars["ObjectId"];
};

export type MutationRemoveSearchProfileArgs = {
  searchProfileId: Scalars["ObjectId"];
};

export type MutationRemoveSharedFileArgs = {
  fileId: Scalars["ObjectId"];
};

export type MutationRemoveTravelDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationRenameCallListArgs = {
  callListId: Scalars["ObjectId"];
  newName: Scalars["String"];
};

export type MutationRequestUpdToKvkConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  input: TodoItemInput;
};

export type MutationResetConsultantUnfitArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationRestoreConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
};

export type MutationRestoreCostCenterArgs = {
  id: Scalars["ObjectId"];
};

export type MutationResyncInvoiceArgs = {
  number: Scalars["String"];
  provider: InvoiceProvider;
};

export type MutationRevokeApiTokenArgs = {
  id: Scalars["ID"];
};

export type MutationRunAutoCreateBookingKitArgs = {
  bookingId: Scalars["ObjectId"];
};

export type MutationSaveConsultantSelectionArgs = {
  bisnodeLookup?: InputMaybe<Scalars["Boolean"]>;
  rows: Array<InputMaybe<ConsultantImportRowsInput>>;
};

export type MutationSaveHSAIDStatusParamsArgs = {
  cardNumber: Scalars["String"];
  cardType: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  hsaidNumber: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSaveToFavouriteContractPriceTemplateArgs = {
  data: ContractPriceTemplateInput;
};

export type MutationSendBookingKitToOcArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationSendConsultantBookingContractEmailToBAArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  recipients?: InputMaybe<Array<EmailRecipientInput>>;
  subject: Scalars["String"];
};

export type MutationSendConsultantContractEmailToConsultantArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  subject: Scalars["String"];
};

export type MutationSendConsultantPresentationArgs = {
  attachments?: InputMaybe<Array<Scalars["ObjectId"]>>;
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  presentationId: Scalars["ObjectId"];
  recipients: Array<EmailRecipientInput>;
  subject: Scalars["String"];
};

export type MutationSendConsultantReferenceFormArgs = {
  consultantReferenceId: Scalars["ObjectId"];
};

export type MutationSendConsultantToMedloArgs = {
  consultantId: Scalars["ObjectId"];
  crmCv?: InputMaybe<Scalars["Boolean"]>;
  cvDocuments?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
};

export type MutationSendEmailArgs = {
  input?: InputMaybe<EmailInput>;
};

export type MutationSendEmailToConsultantArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  subject: Scalars["String"];
};

export type MutationSendMassEmailArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  campaign?: InputMaybe<Scalars["Boolean"]>;
  nodeIds: Array<Scalars["ObjectId"]>;
  nodeType: NodeType;
  subject: Scalars["String"];
};

export type MutationSendMassSMSToConsultantsArgs = {
  consultantIds: Array<Scalars["ObjectId"]>;
  message: Scalars["String"];
};

export type MutationSendRequestIVOArgs = {
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  from?: InputMaybe<Scalars["String"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  subject: Scalars["String"];
};

export type MutationSendTimereportToConsultantArgs = {
  bookingId: Scalars["ObjectId"];
  timereportTemplate?: InputMaybe<TimeReportTemplateType>;
};

export type MutationSendTimereportToCustomerArgs = {
  bookingId: Scalars["ObjectId"];
  emailInput: EmailInput;
  fileName: Scalars["String"];
  templateType: TimeReportTemplateType;
  timeReportId: Scalars["ObjectId"];
};

export type MutationSendToKvkConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  input: TodoItemInput;
};

export type MutationSetBookedStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetBookingAdditionalPayoutArgs = {
  amount?: InputMaybe<Scalars["Float"]>;
  bookingId: Scalars["ObjectId"];
  description?: InputMaybe<Scalars["String"]>;
};

export type MutationSetBookingCallNumberArgs = {
  bookingId: Scalars["ObjectId"];
  callNumber: Scalars["String"];
};

export type MutationSetCallListMembersArgs = {
  callListId: Scalars["ObjectId"];
  userIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type MutationSetConsultantNextContactDateArgs = {
  consultantId: Scalars["ObjectId"];
  date: Scalars["Date"];
  reason: Scalars["String"];
  reasonComment?: InputMaybe<Scalars["String"]>;
};

export type MutationSetConsultantPipelineStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
  nextContactDate?: InputMaybe<Scalars["Date"]>;
  nextContactDateReason?: InputMaybe<Scalars["String"]>;
  pipelineStatus: ConsultantPipelineStatus;
};

export type MutationSetConsultantPipelineStatusCommentArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
};

export type MutationSetConsultantResponsiblePersonArgs = {
  consultantId: Scalars["ObjectId"];
  setLeadStatus?: InputMaybe<ConsultantLeadStatus>;
};

export type MutationSetConsultantResponsibleStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetConsultantUnfitArgs = {
  comment: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  unfitType: ConsultantUnfitType;
};

export type MutationSetConsultantWelcomeEmailSentArgs = {
  consultantId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationSetCustomerContractInvoiceStrategyArgs = {
  customerContractId: Scalars["ObjectId"];
  type: InvoicingStrategyType;
};

export type MutationSetCustomerRecommendedPricesArgs = {
  customerId: Scalars["ObjectId"];
  prices: Array<CustomerRecommendedPriceInput>;
};

export type MutationSetOrderedStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  todo?: InputMaybe<TodoInput>;
};

export type MutationSetQualityItemApprovedStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  sendEmail?: InputMaybe<Scalars["Boolean"]>;
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemApprovedWithCommentStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemPausedStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemRequestReceivedStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemRequestSentIVOStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemRequestSentStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  todo?: InputMaybe<TodoInput>;
};

export type MutationSetSkipTimereportReminderArgs = {
  bookingId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationSetSupportTagToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  comment?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Array<Scalars["String"]>>;
};

export type MutationSetTimereportToDraftArgs = {
  approvedBy: Scalars["String"];
  approvedId: Scalars["String"];
  bookingId: Scalars["ObjectId"];
};

export type MutationSetTimereportToSubmittedArgs = {
  submittedBy: Scalars["String"];
  timereportId: Scalars["ObjectId"];
};

export type MutationSetTodoStatusArgs = {
  status: TodoStatus;
  todoId: Scalars["ObjectId"];
};

export type MutationSetUnlockBookingFormsArgs = {
  bookingId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationSubmitConsultantFormArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  data: ConsultantFormInput;
  file?: InputMaybe<Scalars["Upload"]>;
};

export type MutationSubmitConsultantKarensArgs = {
  consultantId: Scalars["ObjectId"];
  data: ConsultantKarensInput;
};

export type MutationSubmitContractPriceTemplateFormArgs = {
  contractPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
  data: ContractPriceTemplateInput;
};

export type MutationSubmitCustomerContractFormArgs = {
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  data: CustomerContractFormInput;
};

export type MutationSubmitCustomerContractInfoArgs = {
  customerContractId: Scalars["ObjectId"];
  info: Scalars["String"];
};

export type MutationSubmitCustomerContractPriceListFormArgs = {
  customerContractId: Scalars["ObjectId"];
  data: PriceListFormInput;
  priceListId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSubmitCustomerContractSnapshotFormArgs = {
  data: CustomerContractSnapshotFormInput;
  snapshotId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSubmitCustomerContractSubVersionFormArgs = {
  customerContractId: Scalars["ObjectId"];
  data: SubVersionFormInput;
  file?: InputMaybe<Scalars["Upload"]>;
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSubmitFortnoxVoucherArgs = {
  date: Scalars["String"];
  description: Scalars["String"];
  provider: InvoiceProvider;
};

export type MutationSubmitSearchProfileFormArgs = {
  data: SearchProfileFormInput;
  searchProfileId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSyncTimeReportsWithBookingSearchArgs = {
  bookingIds: Array<Scalars["String"]>;
};

export type MutationToggleAccommodationConfirmationArgs = {
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
};

export type MutationToggleConsultantFavouriteArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationToggleCostCenterActiveArgs = {
  id: Scalars["ObjectId"];
};

export type MutationToggleCustomerNoApprovalArgs = {
  documentType: CustomerDocumentTypes;
  file?: InputMaybe<Scalars["Upload"]>;
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationToggleCustomerSettingsArgs = {
  id: Scalars["ObjectId"];
  key: CustomerSettingsKey;
  value: Scalars["Boolean"];
};

export type MutationToggleTravelConfirmationArgs = {
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
};

export type MutationTransitionConsultantQualityItemArgs = {
  consultantId: Scalars["ObjectId"];
  qualityCheck: Scalars["String"];
  qualityTemplate: Scalars["String"];
  transition: Scalars["String"];
  transitionParams?: InputMaybe<Scalars["JSON"]>;
};

export type MutationUnAssignFromBookingKitArgs = {
  kitId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationUnAssignToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationUnsetConsultantNextContactDateArgs = {
  consultantId: Scalars["ObjectId"];
  nextPipelineStatus: Scalars["String"];
};

export type MutationUpdateAccommodationConfirmationArgs = {
  id: Scalars["ObjectId"];
  input: ConfirmAccommodationInput;
};

export type MutationUpdateAccommodationEventArgs = {
  desc: Scalars["String"];
  eventId: Scalars["ObjectId"];
  sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateBookingAuditArgs = {
  approved: Scalars["Boolean"];
  bookingId: Scalars["ObjectId"];
};

export type MutationUpdateBookingEventArgs = {
  desc?: InputMaybe<Scalars["String"]>;
  eventId: Scalars["ObjectId"];
  sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateBookingFinanceArgs = {
  bookingId: Scalars["ObjectId"];
  data: UpdateBookingFinanceInput;
};

export type MutationUpdateBookingGroupArgs = {
  bookingGroupId: Scalars["ObjectId"];
  input: BookingGroupInput;
};

export type MutationUpdateBookingKitArgs = {
  input: UpdateBookingKitInput;
};

export type MutationUpdateBookingKitEventArgs = {
  desc?: InputMaybe<Scalars["String"]>;
  eventId: Scalars["ObjectId"];
  sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateBookingKitTagsArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type MutationUpdateBookingProjectArgs = {
  bookingId: Scalars["ObjectId"];
  projectId: Scalars["ObjectId"];
};

export type MutationUpdateCommentForBookingAuditArgs = {
  bookingId: Scalars["ObjectId"];
  comment: Scalars["String"];
};

export type MutationUpdateConsultantEventArgs = {
  desc: Scalars["String"];
  eventId: Scalars["ObjectId"];
};

export type MutationUpdateConsultantGDPRArgs = {
  id: Scalars["ObjectId"];
  input?: InputMaybe<GDPRInput>;
};

export type MutationUpdateConsultantGeneralInterestArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantGeneralInterestInput;
};

export type MutationUpdateConsultantLeadStatusArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantLeadStatusInput;
};

export type MutationUpdateConsultantQualityNoteArgs = {
  consultantId: Scalars["ObjectId"];
  note?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  input: ConsultantReferenceInputNew;
};

export type MutationUpdateConsultantServicePreferenceArgs = {
  id: Scalars["ObjectId"];
  input: UpdateConsultantServicePreferenceInput;
};

export type MutationUpdateConsultantStatusArgs = {
  id: Scalars["ObjectId"];
  status: ConsultantStatus;
};

export type MutationUpdateConsultantUserSettingsArgs = {
  id: Scalars["ObjectId"];
  input?: InputMaybe<UserSettingsInput>;
};

export type MutationUpdateConsultantWorkStatusArgs = {
  id: Scalars["ObjectId"];
  input: UpdateConsultantWorkStatusInput;
};

export type MutationUpdateContactPersonArgs = {
  data: ContactPersonInput;
  id: Scalars["ObjectId"];
};

export type MutationUpdateCostCenterArgs = {
  id: Scalars["ObjectId"];
  input: UpdateCostCenterInput;
};

export type MutationUpdateCustomerArgs = {
  id: Scalars["ObjectId"];
  input: CustomerInput;
};

export type MutationUpdateCustomerContractEventArgs = {
  customerContractId: Scalars["ObjectId"];
  eventLog: CustomerContractEventInput;
};

export type MutationUpdateCustomerEventArgs = {
  desc?: InputMaybe<Scalars["String"]>;
  eventId: Scalars["ObjectId"];
};

export type MutationUpdateCustomerRefsSearchProfilesArgs = {
  customerId?: InputMaybe<Scalars["ObjectId"]>;
  searchProfileIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type MutationUpdateFavoriteTeamArgs = {
  teamName: Scalars["String"];
};

export type MutationUpdateSharedFileArgs = {
  expiresOn?: InputMaybe<Scalars["Date"]>;
  fileName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationUpdateTgRequirementArgs = {
  id: Scalars["ObjectId"];
  input: UpdateTgRequirementInput;
};

export type MutationUpdateTodoEventArgs = {
  desc: Scalars["String"];
  eventId: Scalars["ObjectId"];
};

export type MutationUpdateTravelConfirmationArgs = {
  id: Scalars["ObjectId"];
  input: ConfirmTravelInput;
};

export type MutationUpdateUnfitAccommodationArgs = {
  comment: Scalars["String"];
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationUploadAccommodationDocumentArgs = {
  documentType: AccommodationDocumentType;
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadBlobArgs = {
  file: Scalars["Upload"];
};

export type MutationUploadBookingDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  documentType: BookingWeekDocumentTypes;
  file: Scalars["Upload"];
};

export type MutationUploadConsultantAvatarArgs = {
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadConsultantDocumentArgs = {
  consultantId: Scalars["ObjectId"];
  documentType: Scalars["String"];
  file: Scalars["Upload"];
  statusName?: InputMaybe<Scalars["String"]>;
};

export type MutationUploadConsultantDocumentsArgs = {
  blobRefs: Array<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  documentType: Scalars["String"];
  statusName?: InputMaybe<Scalars["String"]>;
};

export type MutationUploadCustomerAvatarArgs = {
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadCustomerBgPicArgs = {
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadCustomerContractDocumentArgs = {
  customerContractId: Scalars["ObjectId"];
  documentType: CustomerContractDocumentTypes;
  file: Scalars["Upload"];
};

export type MutationUploadCustomerContractSignedDocumentArgs = {
  file: Scalars["Upload"];
  signedOn: Scalars["Date"];
  snapshotId: Scalars["ObjectId"];
};

export type MutationUploadCustomerDocumentArgs = {
  customerId: Scalars["ObjectId"];
  documentType: CustomerDocumentTypes;
  file: Scalars["Upload"];
};

export type MutationUploadDocumentArgs = {
  file: Scalars["Upload"];
};

export type MutationUploadSharedFileArgs = {
  expiresOn: Scalars["Date"];
  file: Scalars["Upload"];
  fileName?: InputMaybe<Scalars["String"]>;
};

export type MutationUploadSignedConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
  file: Scalars["Upload"];
  signedOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationUploadSignedConsultantContractArgs = {
  bankCounselling?: InputMaybe<Scalars["Boolean"]>;
  contractId: Scalars["ObjectId"];
  expectedSalary?: InputMaybe<Scalars["String"]>;
  file?: InputMaybe<Scalars["Upload"]>;
  payoutType?: InputMaybe<ConsultantContractPayoutType>;
  salaryChoice?: InputMaybe<ContractType>;
  signedOn?: InputMaybe<Scalars["Date"]>;
};

export enum NationalQualification {
  Expired = "Expired",
  PresentationReady = "PresentationReady",
  Qualified = "Qualified",
  Unqualified = "Unqualified"
}

export enum NextContactDateReason {
  Other = "Other",
  PermanentEmployment = "PermanentEmployment",
  WorksForCompetitor = "WorksForCompetitor"
}

export type Node = {
  IsValid?: Maybe<Scalars["Boolean"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  ValidationErrors: Array<NodeValidationError>;
  _id: Scalars["ObjectId"];
};

export type NodeRef = {
  Name?: Maybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type NodeRefFullInput = {
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type NodeRefInput = {
  Name?: InputMaybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type NodeRefNew = {
  name: Scalars["String"];
  nodeId: Scalars["ObjectId"];
  nodeType: NodeType;
};

export type NodeRefSimple = {
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export enum NodeType {
  Accommodation = "Accommodation",
  AccommodationRequest = "AccommodationRequest",
  Action = "Action",
  Blacklist = "Blacklist",
  Booking = "Booking",
  CallList = "CallList",
  Consultant = "Consultant",
  ConsultantContractOption = "ConsultantContractOption",
  ContactPerson = "ContactPerson",
  ContractArticle = "ContractArticle",
  Customer = "Customer",
  CustomerContract = "CustomerContract",
  CustomerContractOption = "CustomerContractOption",
  Day = "Day",
  Event = "Event",
  ExternalUser = "ExternalUser",
  File = "File",
  GeoPosition = "GeoPosition",
  Invoice = "Invoice",
  Memo = "Memo",
  Notification = "Notification",
  Project = "Project",
  SMSMessage = "SMSMessage",
  Team = "Team",
  TodoItem = "TodoItem",
  TravelRequest = "TravelRequest",
  User = "User"
}

export type NodeValidationError = {
  Message: Scalars["String"];
  Params?: Maybe<Scalars["JSON"]>;
  Type: NodeValidationErrorType;
};

export enum NodeValidationErrorType {
  CustomerInsufficientBookingProfessions = "CustomerInsufficientBookingProfessions",
  CustomerInsufficientRoles = "CustomerInsufficientRoles",
  Unknown = "Unknown"
}

export enum NorwayConsultantStatus {
  Committed = "Committed",
  NoAnswer = "NoAnswer",
  NotObligated = "NotObligated",
  Pending = "Pending"
}

export type NotApprovedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type NumericRangeInput = {
  from?: InputMaybe<Scalars["Float"]>;
  to?: InputMaybe<Scalars["Float"]>;
};

export type NurseAreasOfExpertise = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type NurseAreasOfExpertiseInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type NurseProfession = ConsultantProfession & {
  areasOfExpertise: Array<NurseAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<NurseSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type NurseProfessionInput = {
  areasOfExpertise: Array<NurseAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<NurseSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type NurseSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type NurseSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type OptionObjectIDInput = {
  description?: InputMaybe<Scalars["String"]>;
  error?: InputMaybe<Scalars["Boolean"]>;
  label?: InputMaybe<Scalars["String"]>;
  parent?: InputMaybe<Scalars["String"]>;
  value: Scalars["ObjectId"];
};

export type OptionObjectIDType = {
  description?: Maybe<Scalars["String"]>;
  error?: Maybe<Scalars["Boolean"]>;
  label?: Maybe<Scalars["String"]>;
  parent?: Maybe<Scalars["String"]>;
  value: Scalars["ObjectId"];
};

export type OptionStringInput = {
  description?: InputMaybe<Scalars["String"]>;
  error?: InputMaybe<Scalars["Boolean"]>;
  label?: InputMaybe<Scalars["String"]>;
  parent?: InputMaybe<Scalars["String"]>;
  value: Scalars["String"];
};

export type OrderedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export enum Organization {
  Bonliva = "Bonliva",
  BonlivaCare = "BonlivaCare"
}

export enum OrganizationType {
  CommercialAssociation = "CommercialAssociation",
  Commune = "Commune",
  County = "County",
  LLC = "LLC",
  NonprofitAssosiation = "NonprofitAssosiation",
  Norway = "Norway",
  Partnership = "Partnership",
  StateUnit = "StateUnit"
}

export type Pagination = {
  limit?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type PausedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
  pausedState?: Maybe<PausedState>;
};

export type PausedState = {
  isPaused: Scalars["Boolean"];
  pausedOn: Scalars["Date"];
  pausedUntil: Scalars["Date"];
  wasPaused: Scalars["Boolean"];
  workflowId?: Maybe<Scalars["String"]>;
};

export enum PayPeriod {
  Daily = "Daily",
  FullPeriod = "FullPeriod"
}

export enum PayUnit {
  EmergencyCall = "EmergencyCall",
  Hour = "Hour",
  Investigation = "Investigation",
  Operation = "Operation",
  Period = "Period",
  Quantity = "Quantity",
  WorkShift = "WorkShift"
}

export enum PreferredCommunication {
  Email = "Email",
  Letter = "Letter",
  Linkedin = "Linkedin",
  Phone = "Phone",
  SMS = "SMS"
}

export type PriceGroupInput = {
  _id: Scalars["ObjectId"];
  highHolidays: Array<HighHolidayInput>;
  professionsPrice: Array<ProfessionPrice>;
  records: Array<ContractPriceTemplateRecordInput>;
};

export enum PriceListDay {
  AllSaintsDay = "AllSaintsDay",
  AnyTime = "AnyTime",
  AscensionDay = "AscensionDay",
  BoxingDay = "BoxingDay",
  BusinessDay = "BusinessDay",
  ChristmasDay = "ChristmasDay",
  ChristmasEve = "ChristmasEve",
  DayAfterEasterMonday = "DayAfterEasterMonday",
  DayAfterHoliday = "DayAfterHoliday",
  DayAfterMajorHoliday = "DayAfterMajorHoliday",
  DayAfterWhitsunMonday = "DayAfterWhitsunMonday",
  DayBeforeChristmasEve = "DayBeforeChristmasEve",
  DayBeforeEasterFriday = "DayBeforeEasterFriday",
  DayBeforeHoliday = "DayBeforeHoliday",
  DayBeforeMajorHoliday = "DayBeforeMajorHoliday",
  DayBeforeMidsummerEve = "DayBeforeMidsummerEve",
  DayBeforeNewYearsEve = "DayBeforeNewYearsEve",
  DayBeforeWhitesunDay = "DayBeforeWhitesunDay",
  EasterFriday = "EasterFriday",
  EasterMonday = "EasterMonday",
  EasterSaturday = "EasterSaturday",
  EasterSunday = "EasterSunday",
  FirstOfMay = "FirstOfMay",
  Fri = "Fri",
  Holiday = "Holiday",
  MajorHoliday = "MajorHoliday",
  MidsummerDay = "MidsummerDay",
  MidsummerEve = "MidsummerEve",
  Mon = "Mon",
  NearestWeekdayAfterGreatHoliday = "NearestWeekdayAfterGreatHoliday",
  NearestWeekdayAfterHoliday = "NearestWeekdayAfterHoliday",
  NearestWeekdayBeforeHoliday = "NearestWeekdayBeforeHoliday",
  NewYearsDay = "NewYearsDay",
  NewYearsEve = "NewYearsEve",
  Sat = "Sat",
  SqueezedDay = "SqueezedDay",
  Sun = "Sun",
  SwedensNationalDay = "SwedensNationalDay",
  Thu = "Thu",
  Tue = "Tue",
  TwelfthDay = "TwelfthDay",
  Wed = "Wed",
  WeekdayAfterAscensionDay = "WeekdayAfterAscensionDay",
  WeekdayAfterBoxingDay = "WeekdayAfterBoxingDay",
  WeekdayAfterFirstOfMay = "WeekdayAfterFirstOfMay",
  WeekdayAfterMidsummerDay = "WeekdayAfterMidsummerDay",
  WeekdayAfterNewYearsDay = "WeekdayAfterNewYearsDay",
  WeekdayAfterSwedensNationalDay = "WeekdayAfterSwedensNationalDay",
  WeekdayAfterTwelfthDay = "WeekdayAfterTwelfthDay",
  WeekdayBeforeAllSaintsDay = "WeekdayBeforeAllSaintsDay",
  WeekdayBeforeAscensionDay = "WeekdayBeforeAscensionDay",
  WeekdayBeforeFirstOfMay = "WeekdayBeforeFirstOfMay",
  WeekdayBeforeSwedensNationalDay = "WeekdayBeforeSwedensNationalDay",
  WeekdayBeforeTwelfthDay = "WeekdayBeforeTwelfthDay",
  Weekends = "Weekends",
  WhitMonday = "WhitMonday",
  WhitSunday = "WhitSunday",
  WhitsunEve = "WhitsunEve"
}

export type PriceListFormInput = {
  administrativeFee?: InputMaybe<Scalars["Float"]>;
  customerIds: Array<Scalars["ObjectId"]>;
  endDate: Scalars["DateTime"];
  name: Scalars["String"];
  priceGroups: Array<PriceGroupInput>;
  startDate: Scalars["DateTime"];
  travelZones: Array<TravelZoneInput>;
};

export enum PriceListWorkType {
  Active = "Active",
  AdultEducationADHDADD = "AdultEducationADHDADD",
  AdultInvestigation = "AdultInvestigation",
  AdultStudiesAutism = "AdultStudiesAutism",
  AutismInvestigation = "AutismInvestigation",
  BasicInvestigation = "BasicInvestigation",
  ChildAndAdolescentInquiryAutism = "ChildAndAdolescentInquiryAutism",
  ChildAndAdolescentInvestigationADHDADD = "ChildAndAdolescentInvestigationADHDADD",
  ChildAndYouthInvestigation = "ChildAndYouthInvestigation",
  InvestigationWithinSchool = "InvestigationWithinSchool",
  MedicalExamination = "MedicalExamination",
  MedicalExaminationAdults = "MedicalExaminationAdults",
  MedicalExaminationChildrenAndYoungPeople = "MedicalExaminationChildrenAndYoungPeople",
  NeuropsychiatricExaminationAdults = "NeuropsychiatricExaminationAdults",
  NeuropsychiatricExaminationChildrenAndYoungPeople = "NeuropsychiatricExaminationChildrenAndYoungPeople",
  NeuropsychiatricExaminationChildrenAndYoungPeopleStep3 = "NeuropsychiatricExaminationChildrenAndYoungPeopleStep3",
  NeuropsychologicalExaminationAdults = "NeuropsychologicalExaminationAdults",
  NeuropsychologicalExaminationAdultsStep3 = "NeuropsychologicalExaminationAdultsStep3",
  Normal = "Normal",
  OnCall = "OnCall",
  OnCallA = "OnCallA",
  OnCallB = "OnCallB",
  OnCallBer = "OnCallBer",
  OnCallJour = "OnCallJour",
  OnCallPassive = "OnCallPassive",
  Overtime = "Overtime",
  PrivateAssessmentCall = "PrivateAssessmentCall",
  PrivateNPAssessmentAdults = "PrivateNPAssessmentAdults",
  PrivateNPAssessmentChildrenAndYoung = "PrivateNPAssessmentChildrenAndYoung",
  PsychologicalInvestigation = "PsychologicalInvestigation",
  PsychologicalInvestigationAdults = "PsychologicalInvestigationAdults",
  PsychologicalInvestigationChildrenAndYoungPeople = "PsychologicalInvestigationChildrenAndYoungPeople"
}

export type PriceRecruitment = {
  Currency?: Maybe<ConsultantContractCurrency>;
  R_0_159?: Maybe<Scalars["Float"]>;
  R_160_499?: Maybe<Scalars["Float"]>;
  R_500_699?: Maybe<Scalars["Float"]>;
  R_700_899?: Maybe<Scalars["Float"]>;
  R_900_1200?: Maybe<Scalars["Float"]>;
};

export type PriceRecruitmentInput = {
  Currency?: InputMaybe<ConsultantContractCurrency>;
  R_0_159?: InputMaybe<Scalars["Float"]>;
  R_160_499?: InputMaybe<Scalars["Float"]>;
  R_500_699?: InputMaybe<Scalars["Float"]>;
  R_700_899?: InputMaybe<Scalars["Float"]>;
  R_900_1200?: InputMaybe<Scalars["Float"]>;
};

export type ProfessionConfig = {
  AreasOfExpertise: Array<ExpertiseConfig>;
  DefaultAreaOfExpertise: Scalars["String"];
  Educations: Array<Scalars["String"]>;
  Machines: Array<Scalars["String"]>;
  Methods: Array<Scalars["String"]>;
  Name: Scalars["String"];
  Systems: Array<Scalars["String"]>;
};

export enum ProfessionInputType {
  DOCTOR = "DOCTOR",
  GENERIC = "GENERIC",
  NURSE = "NURSE",
  PSYKOLOG = "PSYKOLOG",
  RADIOGRAPHERS = "RADIOGRAPHERS",
  SOCIONOM = "SOCIONOM",
  TEACHER = "TEACHER"
}

export type ProfessionPrice = {
  price?: InputMaybe<Scalars["Float"]>;
  profession: Scalars["String"];
};

export type ProfessionsByCountry = {
  country: Scalars["String"];
  professions: Array<Scalars["String"]>;
};

export type Project = {
  Admin?: Maybe<UserRef>;
  Comment: Scalars["String"];
  Description: Scalars["String"];
  Members: Array<UserRef>;
  Name: Scalars["String"];
  Owner?: Maybe<UserRef>;
  ProjectNumber: Scalars["String"];
  Status?: Maybe<ProjectStatus>;
  _id: Scalars["ObjectId"];
};

export enum ProjectStatus {
  COMPLETED = "COMPLETED",
  NOTSTARTED = "NOTSTARTED",
  ONGOING = "ONGOING"
}

export enum ProjectVisibilityContext {
  ACCOMMODATION_REQUEST = "ACCOMMODATION_REQUEST",
  CREATE_BOOKING_FORM = "CREATE_BOOKING_FORM",
  TRAVEL_REQUEST = "TRAVEL_REQUEST"
}

export type PsykologProfession = ConsultantProfession & {
  certifiedFrom?: Maybe<Scalars["String"]>;
  methods?: Maybe<Array<Scalars["String"]>>;
  professionName: Scalars["String"];
  specializations: Array<PsykologSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type PsykologProfessionInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  methods?: InputMaybe<Array<Scalars["String"]>>;
  professionName: Scalars["String"];
  specializations: Array<PsykologSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type PsykologSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type PsykologSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type PublishContractResult = {
  contractUrl: Scalars["String"];
};

export enum QualificationFilter {
  Any = "Any",
  No = "No",
  Yes = "Yes"
}

export type QualityApproval = {
  Approved: Scalars["Boolean"];
  Country: Scalars["String"];
  Profession: Scalars["String"];
  approvalExpiresOn?: Maybe<Scalars["Date"]>;
  baseItems?: Maybe<Array<Maybe<QualityApprovalItem>>>;
  oneOfItems?: Maybe<Array<Maybe<QualityApprovalItem>>>;
};

export type QualityApprovalItem = {
  approvalExpiresOn?: Maybe<Scalars["Date"]>;
  approved: Scalars["Boolean"];
  name: Scalars["String"];
  partiallyExpiresOn?: Maybe<Scalars["Date"]>;
};

export type QualityTemplate = {
  Country: Scalars["String"];
  Items: Array<QualityTemplateItem>;
};

export type QualityTemplateItem = {
  Description?: Maybe<Scalars["String"]>;
  DocumentsFolder?: Maybe<Scalars["String"]>;
  ExpiresInMonths?: Maybe<Scalars["Int"]>;
  Name: Scalars["String"];
};

export type Query = {
  SearchProfiles: SearchProfilesSearchResult;
  accommodationConfirmationById: AccommodationConfirmation;
  accommodationEvents?: Maybe<Array<Maybe<AccommodationEvent>>>;
  accommodationRequestById: AccommodationRequest;
  accommodationRequestSearch: AccommodationRequestSearchResult;
  accommodationRequestSearchTotal: AccommodationRequestSearchTotalResult;
  attestContactPersons: GetAttestContactPersonsResult;
  bisnodeLookupByPhone?: Maybe<BisnodePerson>;
  bisnodeLookupBySSN?: Maybe<BisnodePerson>;
  bookingById?: Maybe<Booking>;
  bookingEvents?: Maybe<Array<Maybe<BookingEvent>>>;
  bookingHospitality: BookingHospitality;
  bookingKit?: Maybe<BookingKit>;
  bookingKitApprovalConfig: BookingKitApprovalConfig;
  bookingKitDraft: BookingKitDraft;
  bookingKitEvents?: Maybe<Array<Maybe<BookingKitEvent>>>;
  bookingKitFormConfig?: Maybe<Array<BookingKitTypeFormConfig>>;
  bookingKitSearch: BookingKitSearchResult;
  bookingKitSearchTotal: BookingKitSearchTotalResult;
  bookingKits?: Maybe<Array<BookingKitSearch>>;
  bookingSyncReport: BookingSyncReport;
  bookingWeeks: BookingWeekQueryResult;
  bookingWeeksByConsultant: Array<BookingWeekCalendarItem>;
  bookingWeeksCSV: BookingWeeksCSVResult;
  bookingWeeksCSVBackground?: Maybe<BookingWeeksCSVBackgroundResult>;
  bookingWeeksKitSupport: BookingWeekQueryResult;
  bookingWeeksTotal: BookingWeeksTotalResult;
  /** Longest typed text a bulk SMS of this sub-type may have; less than 306 when the unsubscribe link is appended. */
  bulkSmsTextMaxLength: Scalars["Int"];
  callListById: CallListOpResult;
  checkBookingCancellable?: Maybe<Array<BookingCannotBeRemovedReason>>;
  checkBookingGroupCancellable: BookingGroupCancellableResult;
  checkBookingGroupCancellableByBookingId: BookingGroupCancellableResult;
  checkConsultantExists: CheckContactExistsResult;
  checkFortnoxSalaryForWeek?: Maybe<FortnoxWeekSalaryCheck>;
  config: ConfigDoc;
  consultantById?: Maybe<Consultant>;
  consultantByWorkExperience: ConsultantByWorkExperienceResult;
  consultantCanDuplicateToTenants?: Maybe<CanDuplicateToTenantsResult>;
  consultantEvents: Array<ConsultantEvent>;
  consultantFormById: ConsultantForm;
  consultantHealthDeclarations: HealthDeclarationsQueryResult;
  consultantKarensById: Consultant;
  consultantMatching: ConsultantMatchingResult;
  consultantOpportunityByConsultantId: Array<ConsultantOpportunity>;
  consultantOpportunityById: ConsultantOpportunity;
  consultantOpportunityIssueWeeks: ConsultantOpportunityIssueWeeks;
  consultantOpportunityStatsByTeam: ConsultantOpportunityStats;
  consultantOpportunityStatsByUser: ConsultantOpportunityStats;
  consultantReferenceDocuments: Array<ConsultantReferenceDocument>;
  consultantReferences: Array<ConsultantReferenceNew>;
  consultantServicePreference?: Maybe<ConsultantServicePreference>;
  consultantServicePreferenceForm?: Maybe<ConsultantServicePreferenceForm>;
  consultantServicePreferences: Array<ConsultantServicePreference>;
  consultantServicePreferencesForBooking: Array<ConsultantServicePreference>;
  consultantUpcomingWorkplaces: Array<ConsultantUpcomingWorkplace>;
  consultantWorkStatuses: Array<ConsultantWorkStatus>;
  consultants: ConsultantsResult;
  consultantsByWeeks: Array<ConsultantAvailableOnWeek>;
  consultantsCSV: ConsultantExportCSVResult;
  consultantsFast: ConsultantsResult;
  consultantsTotal: ConsultantTotalResult;
  contactPersonById: ContactPerson;
  contactPersons: ContactPersonsResult;
  contract: BookingContractInfo;
  contractsPriceTemplateById?: Maybe<ContractsPriceTemplate>;
  contractsPriceTemplates: ContractPriceTemplateSearchResult;
  costCenterConfigItems: Array<CostCenterConfigItem>;
  customerById?: Maybe<Customer>;
  customerContractById?: Maybe<CustomerContract>;
  customerContractPriceListById: CustomerContractPriceList;
  customerContractSnapshotById?: Maybe<CustomerContractSnapshot>;
  customerContractSubVersionById: CustomerContractSubVersion;
  customerContracts: CustomerContractSearchResult;
  customerContractsByBooking: Array<CustomerContractListItem>;
  customerContractsTotal: Total;
  customerEvents: Array<CustomerEvent>;
  customerNumberByAOE?: Maybe<Scalars["String"]>;
  customers: CustomersResult;
  customersPicker: CustomersResult;
  customersTotal: CustomersTotalResult;
  findConsultantDuplicate?: Maybe<Consultant>;
  findConsultantSimilar?: Maybe<Consultant>;
  findContract: BookingContractInfo;
  freshdeskOpenTicketsCountByConsultant: Scalars["Int"];
  freshdeskTicketsByConsultant: Array<FreshdeskTicket>;
  getAccommodationDetails: Accommodation;
  getAccommodations: Array<AccommodationListItem>;
  getAccommodationsCount: Count;
  getAllConsultantTags: AllConsultantTagsResult;
  getBookingAssignedToTotal: BookingWeeksTotalResult;
  getBookingCustomerContacts: Array<CustomerContact>;
  getBookingGroup?: Maybe<BookingGroup>;
  getBookingKitAssignedToTotal: BookingKitSearchTotalResult;
  getChecksForBooking: BookingChecks;
  getConsultantBookingContractDetailInfo: ConsultantBookingContract;
  getConsultantBookingContracts: Array<ConsultantBookingContractListItem>;
  getConsultantBookingContractsByCustomerId: Array<ConsultantBookingContract>;
  getConsultantContractDetailInfo: ConsultantContract;
  getConsultantContracts: Array<ConsultantContractListItem>;
  getConsultantContractsByBooking: Array<ConsultantContractListItem>;
  getConsultantPayoutByYear: Array<Maybe<ConsultantPayoutByYear>>;
  getConsultantQualityItem: ConsultantQualityItem;
  getConsultantSearchQualityItems: Array<ConsultantSearchQualityItem>;
  getContactPersonsByCustomerIds: Array<ContactPerson>;
  getCustomerContractPriceLists: Array<CustomerContract>;
  getCustomerContractSnapshots: Array<CustomerContractSnapshot>;
  getFortnoxSalaryCache?: Maybe<FortnoxSalaryCache>;
  getFreeTimereports?: Maybe<FreeTimereportResult>;
  getHighHolidays: Array<HighHolidayOption>;
  getInvoiceStatusForBooking?: Maybe<BookingInvoicePaymentStatusesResult>;
  getLastAccommodationRequest?: Maybe<AccommodationRequest>;
  getLastSignedConsultantContract?: Maybe<ConsultantContractListItem>;
  getLastWorkflowRun?: Maybe<WorkflowRun>;
  getSystemsByProfession: Array<Scalars["String"]>;
  getTimereportByBookingId?: Maybe<TimereportResult>;
  getTimereportSendFailures?: Maybe<TimereportSendFailuresResult>;
  getTimereportStatusHistory?: Maybe<TimereportStatusHistoryResult>;
  getTimereportToCustomerEmail: GetTimereportToCustomerEmailResult;
  getWorkflowRuns: Array<WorkflowRun>;
  getWorkflowRunsByOwner: WorkflowRunsPaginatedResult;
  invoiceByNumber?: Maybe<Invoice>;
  kanbanBoard?: Maybe<KanbanBoard>;
  kanbanCard?: Maybe<KanbanCard>;
  kanbanCards: Array<KanbanCard>;
  me: Me;
  municipalities: Array<Municipality>;
  myApiTokens: Array<ApiToken>;
  npDirectRequestAvailable: Scalars["Boolean"];
  professionsByCountry: Array<ProfessionsByCountry>;
  projects: Array<Project>;
  searchProfileById?: Maybe<SearchProfile>;
  searchProfilesByCustomerId?: Maybe<Array<SearchProfile>>;
  sharedFileById: SharedFile;
  sharedFiles: SharedFilesResult;
  subcontractorInvoiceByNumber?: Maybe<SubcontractorInvoice>;
  teams: Array<Team>;
  tgRequirements: Array<TgRequirement>;
  todo: TodoItem;
  todoEvents?: Maybe<Array<Maybe<TodoEvent>>>;
  todoSearch: Array<TodoSearchItem>;
  todoTotal: TodoTotalResult;
  travelConfirmationById: TravelConfirmation;
  travelRequestById: TravelRequest;
  travelRequestSearch: TravelRequestSearchResult;
  travelRequestSearchTotal: TravelRequestSearchTotalResult;
  userById?: Maybe<User>;
  userPermissions: Array<Scalars["String"]>;
  users: Array<User>;
  workflowRunById: WorkflowRun;
  workflowRunByWorkflowId?: Maybe<WorkflowRun>;
};

export type QuerySearchProfilesArgs = {
  filter?: InputMaybe<SearchProfilesFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryAccommodationConfirmationByIdArgs = {
  confirmationId: Scalars["ObjectId"];
};

export type QueryAccommodationEventsArgs = {
  accommodationId: Scalars["ObjectId"];
};

export type QueryAccommodationRequestByIdArgs = {
  requestId: Scalars["ObjectId"];
};

export type QueryAccommodationRequestSearchArgs = {
  filter?: InputMaybe<AccommodationRequestQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<AccommodationRequestSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryAccommodationRequestSearchTotalArgs = {
  filter?: InputMaybe<AccommodationRequestQueryInput>;
};

export type QueryAttestContactPersonsArgs = {
  areaOfExpertise: Scalars["String"];
  departmentIds: Array<Scalars["ObjectId"]>;
  hospitalId: Scalars["ObjectId"];
};

export type QueryBisnodeLookupByPhoneArgs = {
  country: Scalars["String"];
  phone: Scalars["String"];
};

export type QueryBisnodeLookupBySSNArgs = {
  country: Scalars["String"];
  ssn: Scalars["String"];
};

export type QueryBookingByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryBookingEventsArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingHospitalityArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingKitArgs = {
  id: Scalars["ObjectId"];
};

export type QueryBookingKitApprovalConfigArgs = {
  id: Scalars["ObjectId"];
};

export type QueryBookingKitDraftArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingKitEventsArgs = {
  kitId: Scalars["ObjectId"];
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  types?: InputMaybe<Array<InputMaybe<BookingKitEventType>>>;
};

export type QueryBookingKitFormConfigArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingKitSearchArgs = {
  filter?: InputMaybe<BookingKitQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<BookingKitSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryBookingKitSearchTotalArgs = {
  filter?: InputMaybe<BookingKitQueryInput>;
};

export type QueryBookingKitsArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingSyncReportArgs = {
  input: BookingWeekQueryInput;
};

export type QueryBookingWeeksArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryBookingWeeksByConsultantArgs = {
  consultantId: Scalars["ObjectId"];
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type QueryBookingWeeksCSVArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  type?: InputMaybe<BookingCSVReportType>;
};

export type QueryBookingWeeksCSVBackgroundArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  type?: InputMaybe<BookingCSVReportType>;
};

export type QueryBookingWeeksKitSupportArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryBookingWeeksTotalArgs = {
  input?: InputMaybe<BookingWeekQueryInput>;
};

export type QueryBulkSmsTextMaxLengthArgs = {
  subType?: InputMaybe<Scalars["String"]>;
};

export type QueryCallListByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryCheckBookingCancellableArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryCheckBookingGroupCancellableArgs = {
  bookingGroupId: Scalars["ObjectId"];
};

export type QueryCheckBookingGroupCancellableByBookingIdArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryCheckConsultantExistsArgs = {
  filter?: InputMaybe<CheckContactExistsInput>;
};

export type QueryCheckFortnoxSalaryForWeekArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryConsultantByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantByWorkExperienceArgs = {
  customerId: Scalars["ObjectId"];
};

export type QueryConsultantCanDuplicateToTenantsArgs = {
  email?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  ssn?: InputMaybe<Scalars["String"]>;
};

export type QueryConsultantEventsArgs = {
  consultantId: Scalars["ObjectId"];
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  type?: InputMaybe<Array<InputMaybe<ConsultantEventType>>>;
};

export type QueryConsultantFormByIdArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryConsultantHealthDeclarationsArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantKarensByIdArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantMatchingArgs = {
  filter: ConsultantsQueryInput;
  limit: Scalars["Int"];
  params: ConsultantMatchingParams;
  skip: Scalars["Int"];
  sortBy: SortBy;
  sortOrder: SortOrder;
};

export type QueryConsultantOpportunityByConsultantIdArgs = {
  consultantId: Scalars["ObjectId"];
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type QueryConsultantOpportunityByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantOpportunityIssueWeeksArgs = {
  issueId: Scalars["ObjectId"];
};

export type QueryConsultantOpportunityStatsByTeamArgs = {
  end: Scalars["Date"];
  start: Scalars["Date"];
  team: Scalars["String"];
};

export type QueryConsultantOpportunityStatsByUserArgs = {
  end: Scalars["Date"];
  start: Scalars["Date"];
  userId: Scalars["ObjectId"];
};

export type QueryConsultantReferenceDocumentsArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantReferencesArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferenceArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferenceFormArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferencesArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferencesForBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryConsultantUpcomingWorkplacesArgs = {
  consultantId: Scalars["ObjectId"];
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type QueryConsultantWorkStatusesArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantsArgs = {
  filter?: InputMaybe<ConsultantsQueryInput>;
  includeEvents?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<ConsultantTableColumns>;
  sortOrder?: InputMaybe<SortOrder>;
  withSecondarySearch?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryConsultantsByWeeksArgs = {
  filter?: InputMaybe<ConsultantsByWeeksQueryInput>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type QueryConsultantsCSVArgs = {
  ids: Array<Scalars["ObjectId"]>;
};

export type QueryConsultantsFastArgs = {
  filter?: InputMaybe<ConsultantsQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryConsultantsTotalArgs = {
  filter?: InputMaybe<ConsultantsQueryInput>;
};

export type QueryContactPersonByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryContactPersonsArgs = {
  filter?: InputMaybe<ContactPersonsFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryContractArgs = {
  id: Scalars["ObjectId"];
};

export type QueryContractsPriceTemplateByIdArgs = {
  contractsPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryContractsPriceTemplatesArgs = {
  filter?: InputMaybe<ContractPriceTemplateFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  onlyPrivate?: InputMaybe<Scalars["Boolean"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryCostCenterConfigItemsArgs = {
  filter?: InputMaybe<CostCenterConfigFilterInput>;
};

export type QueryCustomerByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryCustomerContractByIdArgs = {
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractPriceListByIdArgs = {
  customerContractId: Scalars["ObjectId"];
  priceListId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractSnapshotByIdArgs = {
  snapshotId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractSubVersionByIdArgs = {
  customerContractId: Scalars["ObjectId"];
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractsArgs = {
  filter?: InputMaybe<CustomerContractFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<CustomerContractSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryCustomerContractsByBookingArgs = {
  filter?: InputMaybe<CustomerContractByBookingFilter>;
};

export type QueryCustomerContractsTotalArgs = {
  filter?: InputMaybe<CustomerContractFilter>;
};

export type QueryCustomerEventsArgs = {
  filter: CustomerEventFilter;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryCustomerNumberByAOEArgs = {
  areaOfExpertise: Scalars["String"];
  departmentIds: Array<Scalars["ObjectId"]>;
  hospitalId: Scalars["ObjectId"];
};

export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomersFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryCustomersPickerArgs = {
  filter?: InputMaybe<CustomersFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryCustomersTotalArgs = {
  filter?: InputMaybe<CustomersFilter>;
};

export type QueryFindConsultantDuplicateArgs = {
  filter?: InputMaybe<CheckContactExistsInput>;
};

export type QueryFindConsultantSimilarArgs = {
  filter?: InputMaybe<CheckContactExistsInput>;
};

export type QueryFindContractArgs = {
  id: Scalars["ObjectId"];
};

export type QueryFreshdeskOpenTicketsCountByConsultantArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryFreshdeskTicketsByConsultantArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetAccommodationDetailsArgs = {
  accommodationId: Scalars["ObjectId"];
};

export type QueryGetAccommodationsArgs = {
  input?: InputMaybe<AccommodationFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetAccommodationsCountArgs = {
  input?: InputMaybe<AccommodationFilter>;
};

export type QueryGetBookingCustomerContactsArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetBookingGroupArgs = {
  id: Scalars["ObjectId"];
};

export type QueryGetBookingKitAssignedToTotalArgs = {
  filter?: InputMaybe<BookingKitQueryInput>;
};

export type QueryGetChecksForBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetConsultantBookingContractDetailInfoArgs = {
  contractId: Scalars["ObjectId"];
};

export type QueryGetConsultantBookingContractsArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetConsultantBookingContractsByCustomerIdArgs = {
  consultantId: Scalars["ObjectId"];
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryGetConsultantContractDetailInfoArgs = {
  contractId: Scalars["ObjectId"];
};

export type QueryGetConsultantContractsArgs = {
  consultantId: Scalars["ObjectId"];
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetConsultantContractsByBookingArgs = {
  consultantId: Scalars["ObjectId"];
  dates: Array<InputMaybe<Scalars["Date"]>>;
};

export type QueryGetConsultantPayoutByYearArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetConsultantQualityItemArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  itemName: Scalars["String"];
};

export type QueryGetContactPersonsByCustomerIdsArgs = {
  depIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  hospId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryGetCustomerContractPriceListsArgs = {
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryGetCustomerContractSnapshotsArgs = {
  customerContractId: Scalars["ObjectId"];
};

export type QueryGetFortnoxSalaryCacheArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetFreeTimereportsArgs = {
  consultantId: Scalars["ObjectId"];
  week: Scalars["Int"];
  year: Scalars["Int"];
};

export type QueryGetInvoiceStatusForBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetLastAccommodationRequestArgs = {
  filter?: InputMaybe<AccommodationRequestQueryInput>;
};

export type QueryGetLastSignedConsultantContractArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetLastWorkflowRunArgs = {
  entityId: Scalars["ObjectId"];
  workflowType?: InputMaybe<Scalars["String"]>;
};

export type QueryGetSystemsByProfessionArgs = {
  profession: Scalars["String"];
};

export type QueryGetTimereportByBookingIdArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetTimereportSendFailuresArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetTimereportStatusHistoryArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetTimereportToCustomerEmailArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetWorkflowRunsArgs = {
  entityId: Scalars["ObjectId"];
  workflowType?: InputMaybe<Scalars["String"]>;
};

export type QueryGetWorkflowRunsByOwnerArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<WorkflowStatus>;
  workflowType?: InputMaybe<Scalars["String"]>;
};

export type QueryInvoiceByNumberArgs = {
  number: Scalars["String"];
  provider: InvoiceProvider;
};

export type QueryKanbanBoardArgs = {
  id: Scalars["String"];
  type: KanbanBoardType;
};

export type QueryKanbanCardArgs = {
  boardId: Scalars["String"];
  cardId: Scalars["String"];
  type: KanbanBoardType;
};

export type QueryKanbanCardsArgs = {
  boardId: Scalars["String"];
  filter?: InputMaybe<Scalars["JSON"]>;
  type: KanbanBoardType;
};

export type QueryNpDirectRequestAvailableArgs = {
  customerId: Scalars["ObjectId"];
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryProjectsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  memberIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  shared?: InputMaybe<Scalars["Boolean"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  text?: InputMaybe<Scalars["String"]>;
  visibilityContext?: InputMaybe<ProjectVisibilityContext>;
};

export type QuerySearchProfileByIdArgs = {
  id?: InputMaybe<Scalars["ObjectId"]>;
};

export type QuerySearchProfilesByCustomerIdArgs = {
  id?: InputMaybe<Scalars["ObjectId"]>;
};

export type QuerySharedFileByIdArgs = {
  fileId: Scalars["ObjectId"];
};

export type QuerySharedFilesArgs = {
  filter: SharedFilesFilter;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type QuerySubcontractorInvoiceByNumberArgs = {
  number: Scalars["String"];
  provider: InvoiceProvider;
};

export type QueryTeamsArgs = {
  filter?: InputMaybe<TeamsFilter>;
};

export type QueryTgRequirementsArgs = {
  filter?: InputMaybe<TgRequirementFilterInput>;
};

export type QueryTodoArgs = {
  id: Scalars["ObjectId"];
};

export type QueryTodoEventsArgs = {
  todoId: Scalars["ObjectId"];
};

export type QueryTodoSearchArgs = {
  filter?: InputMaybe<TodoSearchFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<TodoSearchSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryTodoTotalArgs = {
  filter?: InputMaybe<TodoSearchFilter>;
};

export type QueryTravelConfirmationByIdArgs = {
  confirmationId: Scalars["ObjectId"];
};

export type QueryTravelRequestByIdArgs = {
  requestId: Scalars["ObjectId"];
};

export type QueryTravelRequestSearchArgs = {
  filter?: InputMaybe<TravelRequestQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<TravelRequestSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryTravelRequestSearchTotalArgs = {
  filter?: InputMaybe<TravelRequestQueryInput>;
};

export type QueryUserByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryUserPermissionsArgs = {
  id: Scalars["ObjectId"];
};

export type QueryUsersArgs = {
  ids?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryWorkflowRunByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryWorkflowRunByWorkflowIdArgs = {
  workflowId: Scalars["String"];
};

export type RadioNurseProfession = ConsultantProfession & {
  certifiedFrom?: Maybe<Scalars["String"]>;
  machines: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<RadioNurseSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type RadioNurseProfessionInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  machines: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<RadioNurseSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type RadioNurseSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type RadioNurseSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export enum RecruitingPortalType {
  Avropsportalen = "Avropsportalen",
  Bemlo = "Bemlo",
  Inkopio = "Inkopio",
  Medlo = "Medlo",
  Nemo = "Nemo"
}

export type ReferenceDataInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  email?: InputMaybe<Scalars["String"]>;
  formType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type Region = {
  countryCouncilId?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
};

export type RequestReceivedNotProcessedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
};

export type RequestSentQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
};

export enum RideType {
  OneWay = "OneWay",
  RoundTrip = "RoundTrip"
}

export type Role = {
  IsStaffing?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
};

export enum SMSDeliveryStatus {
  Delivered = "Delivered",
  Error = "Error",
  Expired = "Expired",
  Pending = "Pending",
  Rejected = "Rejected",
  Unknown = "Unknown"
}

export type SMSMessage = {
  From: Scalars["String"];
  IsFailed: Scalars["Boolean"];
  IsOk: Scalars["Boolean"];
  IsStatusFinal: Scalars["Boolean"];
  Message: Scalars["String"];
  SentBy?: Maybe<User>;
  SentByRef: UserRef;
  SentOn: Scalars["Date"];
  Status: SMSDeliveryStatus;
  StatusUpdatedOn?: Maybe<Scalars["Date"]>;
  To: Scalars["String"];
  _id: Scalars["ObjectId"];
};

export type Salary = {
  Compensation?: Maybe<Compensation>;
  Workhours?: Maybe<Scalars["String"]>;
};

export type SalaryInput = {
  Compensation: CompensationInput;
  Workhours: Scalars["String"];
};

export type SaveConsultantsResult =
  | SaveConsultantsResultInvalid
  | SaveConsultantsResultOK;

export type SaveConsultantsResultInvalid = {
  IsValid: Scalars["Boolean"];
  Rows: Array<ConsultantImportRow>;
};

export type SaveConsultantsResultOK = {
  Consultants: Array<Consultant>;
  IsValid: Scalars["Boolean"];
  Msg: Scalars["String"];
  Rows: Array<ConsultantImportRow>;
};

export type SearchProfile = {
  _id: Scalars["ObjectId"];
  customerRefs?: Maybe<Array<CustomerRef>>;
  fields: Scalars["JSON"];
  name: Scalars["String"];
  type: SearchProfileType;
};

export type SearchProfileFormInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  customerRefs?: InputMaybe<Array<CustomerRefInput>>;
  fields?: InputMaybe<Scalars["JSON"]>;
  name?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<SearchProfileType>;
};

export enum SearchProfileType {
  AccommodationRequests = "AccommodationRequests",
  Bookings = "Bookings",
  Consultants = "Consultants",
  ConsultantsPipeline = "ConsultantsPipeline",
  Kits = "Kits",
  PipelineBoard = "PipelineBoard",
  TravelRequests = "TravelRequests"
}

export type SearchProfilesFilter = {
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<SearchProfileType>;
};

export type SearchProfilesSearchResult = {
  items: Array<SearchProfile>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export enum SearchQualityCheckStatus {
  Approved = "Approved",
  ApprovedExpired = "ApprovedExpired",
  ApprovedRef = "ApprovedRef",
  ApprovedWithComment = "ApprovedWithComment",
  AwaitingApproval = "AwaitingApproval",
  Booked = "Booked",
  ConsultantResponsible = "ConsultantResponsible",
  Empty = "Empty",
  Expired = "Expired",
  FullyApproved = "FullyApproved",
  NotApproved = "NotApproved",
  NotApprovedRef = "NotApprovedRef",
  OneApproved = "OneApproved",
  Ordered = "Ordered",
  Paused = "Paused",
  RequestExpired = "RequestExpired",
  RequestNotAnswered = "RequestNotAnswered",
  RequestReceivedNotProcessed = "RequestReceivedNotProcessed",
  RequestSent = "RequestSent",
  RequestSentExpired = "RequestSentExpired",
  SentToRef = "SentToRef",
  SigningPeriodExpired = "SigningPeriodExpired"
}

export enum SelectType {
  AND = "AND",
  ANY = "ANY",
  ONLY = "ONLY"
}

export type SelectValueInputString = {
  type: SelectType;
  value: Array<Scalars["String"]>;
};

export enum SelfRegisterOption {
  Bemlo = "Bemlo",
  BonlivaApp = "BonlivaApp",
  EmploymentAgency = "EmploymentAgency",
  HomepageChat = "HomepageChat",
  Lead = "Lead",
  LinkedIn = "LinkedIn",
  Newsletter = "Newsletter",
  PhoneCall = "PhoneCall",
  SearchEngine = "SearchEngine",
  SelfRegisterHemsida = "SelfRegisterHemsida",
  SelfRegisterNotSpecified = "SelfRegisterNotSpecified",
  SelfRegisterPaper = "SelfRegisterPaper",
  SelfRegisterPhone = "SelfRegisterPhone",
  SocialMedia = "SocialMedia"
}

export type SendConsultantToMedloResult = {
  message?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type SendEmailToConsultantResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export type SendMassEmailResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export type SendMassSMSToConsultantsResult = {
  result: Array<ConsultantSMS>;
};

export type SendToKvkConsultantReferencePayload = {
  consultantReference: ConsultantReferenceNew;
};

export type SharedFile = {
  Deleted: Scalars["Boolean"];
  ExpiresOn: Scalars["Date"];
  FileRef: FileRef;
  FileStats: SharedFileStats;
  Name: Scalars["String"];
  ShareURL: Scalars["String"];
  SharedBy: UserRef;
  SharedOn: Scalars["Date"];
  ThumbURL: Scalars["String"];
  _id: Scalars["ObjectId"];
};

export type SharedFileAccessRecord = {
  AccessedOn: Scalars["Date"];
  IP: Scalars["String"];
};

export type SharedFileStats = {
  AccessRecords: Array<SharedFileAccessRecord>;
  AccessedTotal: Scalars["Int"];
};

export type SharedFilesFilter = {
  from?: InputMaybe<Scalars["Date"]>;
  text?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["Date"]>;
  userIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type SharedFilesResult = {
  files: Array<SharedFile>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type SigningPeriodExpiredQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type SocionomAreasOfExpertise = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: Maybe<Scalars["Boolean"]>;
  qualified?: Maybe<Scalars["Boolean"]>;
  specializations: Array<SocionomSpecialization>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type SocionomAreasOfExpertiseInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: InputMaybe<Scalars["Boolean"]>;
  qualified?: InputMaybe<Scalars["Boolean"]>;
  specializations: Array<SocionomSpecializationInput>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type SocionomProfession = ConsultantProfession & {
  areasOfExpertise: Array<SocionomAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  educations: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export type SocionomProfessionInput = {
  areasOfExpertise: Array<SocionomAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  educations: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export enum SocionomSelectOption {
  Socionom1SS = "Socionom1SS",
  SocionomReception = "SocionomReception"
}

export type SocionomSelectOptionEnum = {
  type: SelectType;
  value: Array<SocionomSelectOption>;
};

export type SocionomSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
};

export type SocionomSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
};

export enum SortBy {
  LastContactDate = "LastContactDate",
  Name = "Name",
  OldestContact = "OldestContact",
  Relevance = "Relevance"
}

export enum SortOrder {
  Asc = "Asc",
  Desc = "Desc"
}

export type SpecificPeriodPrice = {
  _id: Scalars["ObjectId"];
  endDate: Scalars["Date"];
  price: Scalars["Float"];
  startDate: Scalars["Date"];
  title?: Maybe<Scalars["String"]>;
};

export type SpecificPeriodPriceInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  endDate: Scalars["Date"];
  price: Scalars["Float"];
  startDate: Scalars["Date"];
  title?: InputMaybe<Scalars["String"]>;
};

export type SubVersionFormInput = {
  basicPrice: Scalars["Float"];
  consultantId: Scalars["ObjectId"];
  endDate: Scalars["DateTime"];
  startDate: Scalars["DateTime"];
};

export type SubcontractorInfo = {
  Address?: Maybe<Address>;
  BusinessNo: Scalars["String"];
  Name: Scalars["String"];
};

export type SubcontractorInvoice = {
  Balance?: Maybe<Scalars["String"]>;
  Booked?: Maybe<Scalars["Boolean"]>;
  CostCenter?: Maybe<Scalars["String"]>;
  Credit?: Maybe<Scalars["Boolean"]>;
  Currency?: Maybe<Scalars["String"]>;
  DueDate?: Maybe<Scalars["String"]>;
  FinalPayDate?: Maybe<Scalars["String"]>;
  GivenNumber?: Maybe<Scalars["String"]>;
  InvoiceDate?: Maybe<Scalars["String"]>;
  InvoiceNumber?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["String"]>;
};

export type Subscription = {
  kanbanCardAdded: KanbanCardActionPayload;
  kanbanCardDeleted: KanbanCardActionPayload;
  kanbanCardMoved: KanbanCardActionPayload;
  myProfileUpdated: MePartial;
  smsMessageUpdated: SMSMessage;
};

export type SubscriptionKanbanCardAddedArgs = {
  boardId: Scalars["ObjectId"];
  sessionId: Scalars["String"];
};

export type SubscriptionKanbanCardDeletedArgs = {
  boardId: Scalars["ObjectId"];
  sessionId: Scalars["String"];
};

export type SubscriptionKanbanCardMovedArgs = {
  boardId: Scalars["ObjectId"];
  sessionId: Scalars["String"];
};

export type SubscriptionSmsMessageUpdatedArgs = {
  id: Scalars["ObjectId"];
};

export enum SuppressionReason {
  Bounce = "Bounce",
  Invalid = "Invalid",
  Manual = "Manual",
  SpamReport = "SpamReport",
  Stop = "Stop",
  Unsubscribe = "Unsubscribe"
}

export enum SuppressionSource {
  CrmManual = "CrmManual",
  CrmUnsubscribeLink = "CrmUnsubscribeLink",
  Reconciliation = "Reconciliation",
  SendgridWebhook = "SendgridWebhook",
  Tele2Webhook = "Tele2Webhook"
}

export type TeacherAreasOfExpertise = {
  certifiedFrom?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  specializations: Array<TeacherSpecialization>;
};

export type TeacherAreasOfExpertiseInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  specializations: Array<TeacherSpecializationInput>;
};

export type TeacherProfession = ConsultantProfession & {
  areasOfExpertise: Array<TeacherAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  digitalCompetence: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  schoolPlatforms: Array<Scalars["String"]>;
  systems: Array<Scalars["String"]>;
};

export type TeacherProfessionInput = {
  areasOfExpertise: Array<TeacherAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  digitalCompetence: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  schoolPlatforms: Array<Scalars["String"]>;
  systems: Array<Scalars["String"]>;
};

export type TeacherSpecialization = {
  experience?: Maybe<Scalars["String"]>;
  interestedIn: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
};

export type TeacherSpecializationInput = {
  experience?: InputMaybe<Scalars["String"]>;
  interestedIn: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
};

export type Team = {
  ADGroups: Array<Scalars["String"]>;
  AreasOfExpertise: Array<Scalars["String"]>;
  Email?: Maybe<Scalars["String"]>;
  KnownSystems: Array<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Tags: Array<Scalars["String"]>;
  TodoGroup?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  workrequestTeamName?: Maybe<Scalars["String"]>;
};

export type TeamsFilter = {
  workrequestTeams: Scalars["Boolean"];
};

export enum Tenant {
  BonlivaAB = "BonlivaAB",
  WCC = "WCC"
}

export type TgRequirement = {
  _id: Scalars["ObjectId"];
  costCenterId: Scalars["String"];
  createdByName: Scalars["String"];
  createdOn: Scalars["Date"];
  deleted: Scalars["Boolean"];
  minRequiredTG: Scalars["Float"];
  profession?: Maybe<Scalars["String"]>;
  tenant: Scalars["String"];
  updatedByName?: Maybe<Scalars["String"]>;
  updatedOn?: Maybe<Scalars["Date"]>;
  validFrom: Scalars["Date"];
  validTo?: Maybe<Scalars["Date"]>;
};

export type TgRequirementFilterInput = {
  activeOnly?: InputMaybe<Scalars["Boolean"]>;
  costCenterId?: InputMaybe<Scalars["String"]>;
  profession?: InputMaybe<Scalars["String"]>;
  professionIsNull?: InputMaybe<Scalars["Boolean"]>;
};

export enum TicketDifficultyLevel {
  Easy = "Easy",
  Hard = "Hard",
  Medium = "Medium"
}

export enum TimeReportRowSource {
  Bemlo = "Bemlo",
  Crm = "Crm",
  Inkopio = "Inkopio",
  Manual = "Manual",
  Medlo = "Medlo",
  MobileApp = "MobileApp",
  Paper = "Paper",
  Unknown = "Unknown"
}

export enum TimeReportStatus {
  ApprovedByCustomer = "ApprovedByCustomer",
  Blank = "Blank",
  Canceled = "Canceled",
  ConsultantPaymentProcessed = "ConsultantPaymentProcessed",
  Disabled = "Disabled",
  Draft = "Draft",
  RejectByFinance = "RejectByFinance",
  RejectByHBA = "RejectByHBA",
  RejectByOC = "RejectByOC",
  RejectedByCustomer = "RejectedByCustomer",
  SentToConsultant = "SentToConsultant",
  SentToCustomer = "SentToCustomer",
  SentToFinance = "SentToFinance",
  SentToHBA = "SentToHBA",
  SentToOC = "SentToOC",
  SubmittedByConsultant = "SubmittedByConsultant"
}

export enum TimeReportTemplateType {
  Basic = "Basic",
  BlekingeLakare = "BlekingeLakare",
  BlekingeSSK = "BlekingeSSK",
  DalarnaLakare = "DalarnaLakare",
  GavleborgLakare = "GavleborgLakare",
  GotlandLakare = "GotlandLakare",
  GotlandSSK = "GotlandSSK",
  HallandLakare = "HallandLakare",
  HallandSSK = "HallandSSK",
  KronobergLakare = "KronobergLakare",
  KronobergSSK = "KronobergSSK",
  OstergotlandLakare = "OstergotlandLakare",
  OstergotlandSSK = "OstergotlandSSK"
}

export enum TimeReportType {
  ActivePreparednessAPeriod = "ActivePreparednessAPeriod",
  ActivePreparednessBPeriod = "ActivePreparednessBPeriod",
  Common = "Common",
  OnCall = "OnCall",
  PassiveOnCall = "PassiveOnCall",
  PreparednessA = "PreparednessA",
  PreparednessB = "PreparednessB",
  SickDay = "SickDay",
  VabDay = "VabDay"
}

export enum TimeReportWorkType {
  OnCall = "OnCall",
  PreparednessA = "PreparednessA",
  PreparednessB = "PreparednessB",
  Work = "Work"
}

export type Timereport = {
  bookingId?: Maybe<Scalars["String"]>;
  consultantId?: Maybe<Scalars["String"]>;
  days: Array<TimereportDay>;
  department?: Maybe<Scalars["String"]>;
  endsOnUtc?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  isAssignedToBooking: Scalars["Boolean"];
  startsOnUtc?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  timereportId: Scalars["String"];
  totalExpenses: Scalars["Float"];
  totalMileage: Scalars["Float"];
  workplace?: Maybe<Scalars["String"]>;
};

export type TimereportDay = {
  comment?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["String"]>;
  dayIndex: Scalars["Int"];
  expenses: Array<TimereportExpense>;
  isLunchModified?: Maybe<Scalars["Boolean"]>;
  lunch?: Maybe<Scalars["Int"]>;
  mileage?: Maybe<Scalars["Float"]>;
  onCallShifts: Array<TimereportOnCallShift>;
  preparednessAShifts: Array<TimereportPreparednessShift>;
  preparednessBShifts: Array<TimereportPreparednessShift>;
  sickTimeShifts: Array<TimereportSickOrVabShift>;
  vabTimeShifts: Array<TimereportSickOrVabShift>;
  workTimeRange?: Maybe<TimereportDayTimeRange>;
  workTimeRanges: Array<TimereportDayTimeRange>;
};

export type TimereportDayTimeRange = {
  from: Scalars["String"];
  to: Scalars["String"];
};

export type TimereportExpense = {
  amount: Scalars["Float"];
  attachments: Array<TimereportExpenseAttachment>;
  comment?: Maybe<Scalars["String"]>;
};

export type TimereportExpenseAttachment = {
  path?: Maybe<Scalars["String"]>;
  previewPath?: Maybe<Scalars["String"]>;
};

export type TimereportOnCallShift = {
  passivePeriods: Array<TimereportDayTimeRange>;
  period: TimereportDayTimeRange;
};

export type TimereportPreparednessShift = {
  activePeriods: Array<TimereportDayTimeRange>;
  period: TimereportDayTimeRange;
};

export type TimereportResult = {
  timereport: Scalars["JSON"];
};

export type TimereportSendFailure = {
  failedOn: Scalars["Date"];
  reason?: Maybe<Scalars["String"]>;
  recipient: Scalars["String"];
};

export type TimereportSendFailuresResult = {
  failures: Array<TimereportSendFailure>;
  partiallySent: Scalars["Boolean"];
};

export enum TimereportSendingToCustomerStatus {
  Approved = "Approved",
  Expired = "Expired",
  Invalid = "Invalid",
  Rejected = "Rejected",
  Sent = "Sent"
}

export type TimereportSickOrVabShift = {
  from: Scalars["String"];
  to: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
};

export type TimereportStatusHistoryResult = {
  history: Scalars["JSON"];
};

export type TimereportTemplateSettings = {
  professions: Array<Scalars["String"]>;
  type: TimeReportTemplateType;
};

export type TodoBadges = {
  Badges: Array<CategoryBadge>;
  TotalUnread: Scalars["Int"];
};

export enum TodoCategory {
  Accommodation = "Accommodation",
  Applications = "Applications",
  Birthday = "Birthday",
  DelegatedByMe = "DelegatedByMe",
  KitAttestation = "KitAttestation",
  MyTask = "MyTask",
  NonAnswers = "NonAnswers",
  NotContacted = "NotContacted",
  Team = "Team",
  Travel = "Travel"
}

export type TodoDateRangeInput = {
  from?: InputMaybe<Scalars["Date"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type TodoEvent = Event & {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Scalars["String"]>>;
  Sticky: Scalars["Boolean"];
  TodoItem?: Maybe<TodoItem>;
  TodoRef?: Maybe<NodeRef>;
  Type: TodoEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum TodoEventType {
  Comment = "Comment",
  Log = "Log",
  Reminder = "Reminder"
}

export type TodoInput = {
  ChargedProjects?: InputMaybe<Scalars["String"]>;
  CriminalRecordType?: InputMaybe<CriminalRecordType>;
  DeliveryPlace?: InputMaybe<Scalars["String"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Due?: InputMaybe<Scalars["Date"]>;
  DueDateText?: InputMaybe<Scalars["String"]>;
  EducationType?: InputMaybe<ConsultantEducationType>;
  Errand?: InputMaybe<ConsultantSITHSErrand>;
  PerfPlace?: InputMaybe<Scalars["String"]>;
  Priority?: InputMaybe<TodoPriority>;
  Reference?: InputMaybe<ReferenceDataInput>;
  Reminder?: InputMaybe<Scalars["Boolean"]>;
  SecondaryText?: InputMaybe<Scalars["String"]>;
  Tags?: InputMaybe<Array<Scalars["String"]>>;
  Text: Scalars["String"];
  WorkInStockholm?: InputMaybe<Scalars["String"]>;
};

export type TodoItem = {
  Accepted?: Maybe<Scalars["Boolean"]>;
  AssignedBy: UserRef;
  AssignedOn: Scalars["Date"];
  AssignedTeam?: Maybe<Scalars["String"]>;
  AssignedTo?: Maybe<UserRef>;
  CanAccept?: Maybe<Scalars["Boolean"]>;
  CanDelete: Scalars["Boolean"];
  Comments: Array<TodoEvent>;
  Completed?: Maybe<Scalars["Date"]>;
  DelegatedBy?: Maybe<UserRef>;
  Deleted: Scalars["Boolean"];
  Description: Scalars["String"];
  Due?: Maybe<Scalars["Date"]>;
  LinkedItems?: Maybe<Array<NodeRef>>;
  NodeName?: Maybe<Scalars["String"]>;
  NodeType?: Maybe<NodeType>;
  Priority?: Maybe<TodoPriority>;
  RelatedTo?: Maybe<NodeRef>;
  SecondaryText: Scalars["String"];
  Status: TodoStatus;
  Tags: Array<Scalars["String"]>;
  Type: TodoItemType;
  URL?: Maybe<Scalars["String"]>;
  ViewMode: Scalars["Boolean"];
  WhoWatched?: Maybe<Array<Maybe<UserRef>>>;
  _id: Scalars["ObjectId"];
  type?: Maybe<NodeType>;
};

export type TodoItemInput = {
  Accepted?: InputMaybe<Scalars["Boolean"]>;
  AssignedTeam?: InputMaybe<Scalars["String"]>;
  AssignedTo?: InputMaybe<UserRefInput>;
  Description?: InputMaybe<Scalars["String"]>;
  Due?: InputMaybe<Scalars["Date"]>;
  LinkedItems?: InputMaybe<Array<InputMaybe<NodeRefFullInput>>>;
  Priority?: InputMaybe<TodoPriority>;
  SecondaryText?: InputMaybe<Scalars["String"]>;
  Tags?: InputMaybe<Array<Scalars["String"]>>;
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export enum TodoItemType {
  AlienItem = "AlienItem",
  AssignedByMe = "AssignedByMe",
  AssignedToMe = "AssignedToMe",
  OwnItem = "OwnItem"
}

export type TodoLinkedItem = {
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Uri: Scalars["String"];
};

export enum TodoPriority {
  High = "High",
  Low = "Low",
  NoStatus = "NoStatus"
}

export type TodoSearchFilter = {
  assignedToTeams?: InputMaybe<Array<Scalars["String"]>>;
  assignedToUsers?: InputMaybe<Array<Scalars["ObjectId"]>>;
  category?: InputMaybe<Array<TodoCategory>>;
  createdBy?: InputMaybe<FilterInput>;
  createdDate?: InputMaybe<TodoDateRangeInput>;
  delegatedBy?: InputMaybe<Array<Scalars["ObjectId"]>>;
  dueDate?: InputMaybe<TodoDateRangeInput>;
  managedBy?: InputMaybe<Array<Scalars["ObjectId"]>>;
  priority?: InputMaybe<TodoPriority>;
  relatedTo?: InputMaybe<Array<Scalars["ObjectId"]>>;
  status?: InputMaybe<Array<TodoStatus>>;
  tags?: InputMaybe<Array<Scalars["String"]>>;
  teamIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  text?: InputMaybe<Scalars["String"]>;
};

export type TodoSearchItem = {
  _id: Scalars["ObjectId"];
  assignedBy?: Maybe<Scalars["String"]>;
  assignedTo?: Maybe<Scalars["String"]>;
  canAccept?: Maybe<Scalars["Boolean"]>;
  canComplete?: Maybe<Scalars["Boolean"]>;
  canDecline?: Maybe<Scalars["Boolean"]>;
  category?: Maybe<TodoCategory>;
  completedOn?: Maybe<Scalars["Date"]>;
  createdBy: Scalars["String"];
  createdOn: Scalars["Date"];
  delegatedBy?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  managedBy?: Maybe<Scalars["String"]>;
  priority?: Maybe<TodoPriority>;
  relatedTo?: Maybe<Array<NodeRef>>;
  search: TodoSearchMeta;
  status: TodoStatus;
  tags: Array<Scalars["String"]>;
  teamIds: Array<Scalars["ObjectId"]>;
  title: Scalars["String"];
  unreadStatuses: Array<TodoUnreadUserStatus>;
};

export type TodoSearchMeta = {
  searchText: Scalars["String"];
  showTop: Scalars["Boolean"];
  unreadComments: Scalars["Float"];
  unreadNew: Scalars["Float"];
};

export enum TodoSearchSortBy {
  Create = "Create",
  Due = "Due",
  NewMessages = "NewMessages",
  NewTickets = "NewTickets"
}

export enum TodoSortBy {
  Create = "Create",
  Due = "Due",
  NewMessages = "NewMessages",
  NewTickets = "NewTickets"
}

export type TodoSortItem = {
  by: TodoSortBy;
  dir?: InputMaybe<Scalars["Int"]>;
};

export enum TodoStatus {
  Accepted = "Accepted",
  Done = "Done",
  InProgress = "InProgress",
  New = "New"
}

export enum TodoStatusForUser {
  Comment = "Comment",
  Done = "Done",
  Expire = "Expire",
  New = "New",
  Watched = "Watched"
}

export type TodoTeamBadges = {
  Badges: Array<CategoryBadge>;
  TeamRef: NodeRef;
  TotalUnread: Scalars["Int"];
};

export type TodoTotalResult = {
  dbTime: Scalars["Float"];
  total: Scalars["Float"];
};

export enum TodoUnreadStatus {
  Comment = "Comment",
  Done = "Done",
  Expire = "Expire",
  New = "New"
}

export type TodoUnreadUserStatus = {
  count: Scalars["Float"];
  type: TodoUnreadStatus;
};

export type TodoUserBadges = {
  TeamBadges: Array<TodoTeamBadges>;
  TotalUnread: Scalars["Boolean"];
};

export type Total = {
  total: Scalars["Int"];
};

export enum TransportationType {
  Any = "Any",
  Boat = "Boat",
  Bus = "Bus",
  Flight = "Flight",
  Taxi = "Taxi",
  Train = "Train"
}

export type TravelConfirmation = {
  _id: Scalars["ObjectId"];
  allWeeks: Array<TravelConfirmationWeek>;
  confirmedBy?: Maybe<UserRef>;
  confirmedOn?: Maybe<Scalars["Date"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  documents: Array<Document>;
  taxWeeks: Array<TravelConfirmationWeek>;
  totalCost?: Maybe<Scalars["Float"]>;
  totalExVAT?: Maybe<Scalars["Boolean"]>;
  weeks: Array<Scalars["Date"]>;
};

export type TravelConfirmationWeek = {
  cost: Scalars["Float"];
  description?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  isTravel: Scalars["Boolean"];
  note?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  weekYear: WeekYear;
};

export type TravelRequest = {
  _id: Scalars["ObjectId"];
  bookingGroup?: Maybe<Scalars["ObjectId"]>;
  consultantId?: Maybe<Scalars["String"]>;
  costCenterId?: Maybe<Scalars["String"]>;
  createdById?: Maybe<Scalars["ObjectId"]>;
  createdByName?: Maybe<Scalars["String"]>;
  createdOn?: Maybe<Scalars["Date"]>;
  deadline?: Maybe<Scalars["Date"]>;
  isCancelable?: Maybe<Scalars["Boolean"]>;
  isFlexible?: Maybe<Scalars["Boolean"]>;
  isReschedule?: Maybe<Scalars["Boolean"]>;
  luggage?: Maybe<Scalars["String"]>;
  luggageType?: Maybe<LuggageType>;
  projectId?: Maybe<Scalars["String"]>;
  rescheduleComment?: Maybe<Scalars["String"]>;
  rides: Array<TravelRequestReturnRide>;
  ticketDifficultyLevel?: Maybe<TicketDifficultyLevel>;
  transportationType?: Maybe<Scalars["String"]>;
  travelPreferences?: Maybe<Scalars["String"]>;
  travelSuggestion?: Maybe<Scalars["String"]>;
};

export type TravelRequestFromInput = {
  city: Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
  country: Scalars["String"];
  date: Scalars["Date"];
  time?: InputMaybe<TravelRequestTime>;
};

export type TravelRequestInfo = {
  confirmations: Array<TravelConfirmation>;
  travelIsOk: Scalars["Boolean"];
  travelRequest: Array<TravelRequest>;
  travelRequested: Scalars["Boolean"];
};

export type TravelRequestInput = {
  consultantId?: InputMaybe<Scalars["String"]>;
  costCenterId?: InputMaybe<Scalars["String"]>;
  deadline?: InputMaybe<Scalars["Date"]>;
  id?: InputMaybe<Scalars["ObjectId"]>;
  isCancelable: Scalars["Boolean"];
  isFlexible: Scalars["Boolean"];
  isReschedule?: InputMaybe<Scalars["Boolean"]>;
  luggageType?: InputMaybe<LuggageType>;
  projectId?: InputMaybe<Scalars["String"]>;
  rescheduleComment?: InputMaybe<Scalars["String"]>;
  rides: Array<TravelRequestReturnRideInput>;
  ticketDifficultyLevel: TicketDifficultyLevel;
  travelPreferences?: InputMaybe<Scalars["String"]>;
  travelSuggestion: Scalars["String"];
};

export type TravelRequestQueryInput = {
  from?: InputMaybe<Scalars["Date"]>;
  responsibleUserIds?: InputMaybe<Array<Scalars["String"]>>;
  senderIds?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<InputMaybe<TravelRequestStatusType>>>;
  text?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type TravelRequestReturnRide = {
  dir1?: Maybe<TravelRequestRide>;
  dir2?: Maybe<TravelRequestRide>;
  rideType?: Maybe<RideType>;
  transportationType?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type TravelRequestReturnRideInput = {
  dir1: TravelRequestFromInput;
  dir2: TravelRequestToInput;
  rideType: RideType;
  transportationType: Array<TransportationType>;
};

export type TravelRequestRide = {
  city?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["Date"]>;
  time?: Maybe<TravelRequestTime>;
};

export type TravelRequestSearch = {
  _id?: Maybe<Scalars["ObjectId"]>;
  city?: Maybe<Scalars["String"]>;
  consultantName?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<UserRef>;
  createdOn?: Maybe<Scalars["Date"]>;
  firstDeparture?: Maybe<Scalars["Date"]>;
  status?: Maybe<TravelRequestStatus>;
  weeks?: Maybe<Array<Maybe<BookingLinks>>>;
};

export type TravelRequestSearchResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<TravelRequestSearch>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type TravelRequestSearchTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum TravelRequestSortBy {
  CreatedOn = "CreatedOn",
  FirstDepartureDate = "FirstDepartureDate"
}

export type TravelRequestStatus = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status?: Maybe<TravelRequestStatusType>;
};

export enum TravelRequestStatusType {
  Closed = "Closed",
  Open = "Open"
}

export enum TravelRequestTableColumns {
  City = "City",
  Consultant = "Consultant",
  CreatedOn = "CreatedOn",
  DepartureDate = "DepartureDate",
  Sender = "Sender",
  Status = "Status",
  Week = "Week"
}

export enum TravelRequestTime {
  Day = "Day",
  Evening = "Evening",
  Morning = "Morning",
  Noon = "Noon"
}

export type TravelRequestToInput = {
  city: Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
  country: Scalars["String"];
  date?: InputMaybe<Scalars["Date"]>;
  time?: InputMaybe<TravelRequestTime>;
};

export type TravelZone = {
  articleNumber: Scalars["String"];
  name: Scalars["String"];
};

export type TravelZoneInput = {
  articleNumber: Scalars["String"];
  name: Scalars["String"];
};

export type TravelsAlt = {
  MaxCost?: Maybe<ConsultantContractTravelsMaxCost>;
  PossibleSupplement?: Maybe<Scalars["String"]>;
  TravelTemplateValue?: Maybe<Scalars["Float"]>;
  Type?: Maybe<ConsultantContractTravelsAlt>;
};

export type TravelsAltInput = {
  MaxCost?: InputMaybe<ConsultantContractTravelsMaxCostInput>;
  PossibleSupplement?: InputMaybe<Scalars["String"]>;
  TravelTemplateValue?: InputMaybe<Scalars["Float"]>;
  Type?: InputMaybe<ConsultantContractTravelsAlt>;
};

export type UnlockFormsResult = {
  unlockForms: Scalars["Boolean"];
};

export type UpdateBookingFinanceInput = {
  AccommodationCost?: InputMaybe<Scalars["Float"]>;
  AdditionalWork?: InputMaybe<Scalars["Boolean"]>;
  AdditionalWorkNote?: InputMaybe<Scalars["String"]>;
  BonlivaCareInvoice?: InputMaybe<BonlivaCareInvoiceInput>;
  BusinessName?: InputMaybe<Scalars["String"]>;
  BusinessSocialSecurityNo?: InputMaybe<Scalars["String"]>;
  ChangedKeys?: InputMaybe<Array<Scalars["String"]>>;
  ContractType?: InputMaybe<ContractType>;
  CustomerFine?: InputMaybe<Scalars["String"]>;
  DeletedSubcontractorDocumentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  EmployeeSalary?: InputMaybe<Scalars["Float"]>;
  GroupInvoiceTotal?: InputMaybe<Scalars["Float"]>;
  Invoices: Array<Scalars["String"]>;
  IsConsultantPayed?: InputMaybe<Scalars["Boolean"]>;
  IsSickPayed?: InputMaybe<Scalars["Boolean"]>;
  LegalPersonType?: InputMaybe<LegalPersonType>;
  NewSubcontractorDocuments?: InputMaybe<Array<Scalars["String"]>>;
  Note?: InputMaybe<Scalars["String"]>;
  PatientId?: InputMaybe<Scalars["String"]>;
  SickPayTotal?: InputMaybe<Scalars["Float"]>;
  SubcontractorInvoiceTotal?: InputMaybe<Scalars["Float"]>;
  TravelCost?: InputMaybe<Scalars["Float"]>;
  UpdateConsultantWithSnapshotData?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateBookingKitInput = {
  bookingId: Scalars["ObjectId"];
  bookingSupportCheckWasValid: Scalars["Boolean"];
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  filesIds: Array<Scalars["ObjectId"]>;
  id: Scalars["ObjectId"];
  managerId?: InputMaybe<Scalars["ObjectId"]>;
  receipts?: InputMaybe<Array<BookingKitExpensesReceiptInput>>;
  responsibleId?: InputMaybe<Scalars["ObjectId"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  tagsNote?: InputMaybe<Scalars["String"]>;
  templateType: TimeReportTemplateType;
  type: BookingKitType;
  withConsultantInvoice: Scalars["Boolean"];
  withCustomerInvoice: Scalars["Boolean"];
  withSickPay: Scalars["Boolean"];
  withSubcontractorPay: Scalars["Boolean"];
  withTimeReport: Scalars["Boolean"];
};

export type UpdateBookingResult = {
  Booking?: Maybe<Booking>;
};

export type UpdateConsultantServicePreferenceInput = {
  customers?: InputMaybe<Array<InputMaybe<CustomerRefInput>>>;
  description: Scalars["String"];
  period: ConsultantServicePreferencePeriodInput;
};

export type UpdateConsultantWorkStatusInput = {
  competitorName?: InputMaybe<Scalars["String"]>;
  reminderDate?: InputMaybe<Scalars["Date"]>;
  startDate: Scalars["Date"];
  type: ConsultantWorkStatusType;
};

export type UpdateContactPersonResult = {
  contactPerson?: Maybe<ContactPerson>;
  validationErrors: Array<ValidationError>;
};

export type UpdateCostCenterInput = {
  isActive?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  organisation?: InputMaybe<Scalars["String"]>;
  tenant?: InputMaybe<Scalars["String"]>;
};

export type UpdateCustomerResult = {
  customer?: Maybe<Customer>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export type UpdateEventInput = {
  Description?: InputMaybe<Scalars["String"]>;
  Sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateMoveCustomerResult = {
  customer?: Maybe<Customer>;
  validationErrors: Array<Scalars["String"]>;
};

export type UpdateTgRequirementInput = {
  minRequiredTG: Scalars["Float"];
};

export type UploadBookingDocumentResult = {
  fileRef: FileRef;
};

export type UploadConsultantDocumentResult = {
  Consultant: Consultant;
  FileRef: FileRef;
};

export type UploadSharedDocumentResult = {
  FileRef: FileRef;
};

export type User = BaseUser & {
  AvatarPic?: Maybe<Scalars["String"]>;
  AzureGroups?: Maybe<Array<Scalars["String"]>>;
  AzureId?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["Date"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  Deleted: Scalars["Boolean"];
  Email: Scalars["String"];
  Enabled: Scalars["Boolean"];
  ManagerId?: Maybe<Scalars["ObjectId"]>;
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Phone?: Maybe<Scalars["String"]>;
  Teams: Array<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
};

export type UserCallList = {
  _id: Scalars["ObjectId"];
  name: Scalars["String"];
};

export type UserPermissions = {
  AllowInProduction?: Maybe<Scalars["Boolean"]>;
  CanAccessCustomers?: Maybe<Scalars["Boolean"]>;
  CanAccessReports?: Maybe<Scalars["Boolean"]>;
  CanAddAccommodation?: Maybe<Scalars["Boolean"]>;
  CanAddCustomer?: Maybe<Scalars["Boolean"]>;
  CanDeleteConsultantBookingContract?: Maybe<Scalars["Boolean"]>;
  CanDeleteConsultantContract?: Maybe<Scalars["Boolean"]>;
  CanDeleteConsultants?: Maybe<Scalars["Boolean"]>;
  CanDeleteCustomers?: Maybe<Scalars["Boolean"]>;
  CanImportConsultants?: Maybe<Scalars["Boolean"]>;
  CanMoveCustomers?: Maybe<Scalars["Boolean"]>;
  CanPose?: Maybe<Scalars["Boolean"]>;
  CanSelectAllInMassActions?: Maybe<Scalars["Boolean"]>;
  CanUpdateConsultantGDPR?: Maybe<Scalars["Boolean"]>;
  CanUpdateConsultantInitialContact?: Maybe<Scalars["Boolean"]>;
  CanUpdateCustomerNumber?: Maybe<Scalars["Boolean"]>;
};

export type UserRef = {
  Name: Scalars["String"];
  PersonId: Scalars["ObjectId"];
};

export type UserRefInput = {
  PersonId: Scalars["ObjectId"];
};

export type UserRefInputStrict = {
  Name: Scalars["String"];
  PersonId: Scalars["ObjectId"];
};

export type UserSettings = {
  Enabled: Scalars["Boolean"];
};

export type UserSettingsInput = {
  Enabled: Scalars["Boolean"];
};

export type ValidationError = {
  Message?: Maybe<Scalars["String"]>;
  Path?: Maybe<Scalars["String"]>;
};

export type ValueLabel = {
  disabled?: InputMaybe<Scalars["Boolean"]>;
  error?: InputMaybe<Scalars["Boolean"]>;
  label: Scalars["String"];
  value: Scalars["String"];
};

export type WeakUserRef = {
  Name?: Maybe<Scalars["String"]>;
  PersonId?: Maybe<Scalars["ObjectId"]>;
};

export enum WebhookDeliveryStatus {
  Completed = "Completed",
  Failed = "Failed",
  FailedPermanently = "FailedPermanently",
  Pending = "Pending"
}

export type WeekYear = {
  Week: Scalars["Int"];
  Year: Scalars["Int"];
};

export type WeekYearInput = {
  Week: Scalars["Int"];
  Year: Scalars["Int"];
};

export type WithTodoInput = {
  assignedTeam?: InputMaybe<Scalars["String"]>;
  assignedUserId?: InputMaybe<Scalars["ObjectId"]>;
  date?: InputMaybe<Scalars["Date"]>;
  priority?: InputMaybe<TodoPriority>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  text: Scalars["String"];
};

export enum WorkedInNorwayOption {
  All = "All",
  No = "No",
  Yes = "Yes",
  YesWithDNumber = "YesWithDNumber",
  YesWithoutDNumber = "YesWithoutDNumber"
}

export type WorkflowRun = {
  _id?: Maybe<Scalars["ObjectId"]>;
  completedAt?: Maybe<Scalars["Date"]>;
  entityId: Scalars["String"];
  entityType: Scalars["String"];
  errorMessage?: Maybe<Scalars["String"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  result?: Maybe<Scalars["JSON"]>;
  scheduledAt: Scalars["Date"];
  startedAt?: Maybe<Scalars["Date"]>;
  status: WorkflowStatus;
  steps: Array<WorkflowStep>;
  workflowId: Scalars["String"];
  workflowType: Scalars["String"];
};

export type WorkflowRunsPaginatedResult = {
  items: Array<WorkflowRun>;
  total: Scalars["Int"];
};

export enum WorkflowStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Failed = "Failed",
  Running = "Running",
  Scheduled = "Scheduled",
  Terminated = "Terminated"
}

export type WorkflowStep = {
  _id: Scalars["ID"];
  completedAt?: Maybe<Scalars["Date"]>;
  description?: Maybe<Scalars["String"]>;
  failedAt?: Maybe<Scalars["Date"]>;
  startedAt?: Maybe<Scalars["Date"]>;
  title: Scalars["String"];
};

export enum Workshift {
  Day = "Day",
  Evening = "Evening",
  Holiday = "Holiday",
  Night = "Night",
  OnCall = "OnCall",
  Weekend = "Weekend"
}

export type TimereportKitSupportSearchItemFragment = {
  _id: string;
  bookingSupportTagComment?: string | null;
  isHighPrior?: number | null;
  AreaOfExpertise: string;
  TimeReportStatus?: TimeReportStatus | null;
  timeReportStatusSetOn?: Date | null;
  ConsultantServicePreferences?: string | null;
  Week: Date;
  CustomerNumber: string;
  ContractType?: ContractType | null;
  ContractTypeAbbr: string;
  CostCenterId?: string | null;
  CostCenterName?: string | null;
  IsCanceled: boolean;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  IsMarked: boolean;
  InvoiceNumbers?: Array<string | null> | null;
  ProjectId?: string | null;
  projectName?: string | null;
  projectNumber?: string | null;
  InvoiceTotalGrossFmt: string;
  InvoicedTotalFmt?: string | null;
  ProfitRatio?: number | null;
  ProfitNetFmt?: string | null;
  isNationalProcurement?: boolean | null;
  lastKitCreationWfFailedAt?: Date | null;
  bookingAssignedTo?: Array<{
    setTo?: { Name: string; PersonId: string } | null;
  } | null> | null;
  bookingSupportTagStatus?: Array<{
    setOn?: Date | null;
    tag?: string | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null> | null;
  timeReportStatusSetBy?: { Name: string; PersonId: string } | null;
  BookingRef: { NodeID: string };
  ConsultantRef: { Name?: string | null; NodeID: string };
  DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  HospitalRef: { Id: string; Name: string; Type: CustomerType };
  OrganizationRef: { Id: string; Name: string };
};

export type TimereportKitSupportSearch_GetQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type TimereportKitSupportSearch_GetQuery = {
  bookingWeeksKitSupport: {
    skip: number;
    limit: number;
    total?: number | null;
    items: Array<{
      _id: string;
      bookingSupportTagComment?: string | null;
      isHighPrior?: number | null;
      AreaOfExpertise: string;
      TimeReportStatus?: TimeReportStatus | null;
      timeReportStatusSetOn?: Date | null;
      ConsultantServicePreferences?: string | null;
      Week: Date;
      CustomerNumber: string;
      ContractType?: ContractType | null;
      ContractTypeAbbr: string;
      CostCenterId?: string | null;
      CostCenterName?: string | null;
      IsCanceled: boolean;
      IsConsultantPayed: boolean;
      IsCustomerBilled: boolean;
      IsMarked: boolean;
      InvoiceNumbers?: Array<string | null> | null;
      ProjectId?: string | null;
      projectName?: string | null;
      projectNumber?: string | null;
      InvoiceTotalGrossFmt: string;
      InvoicedTotalFmt?: string | null;
      ProfitRatio?: number | null;
      ProfitNetFmt?: string | null;
      isNationalProcurement?: boolean | null;
      lastKitCreationWfFailedAt?: Date | null;
      bookingAssignedTo?: Array<{
        setTo?: { Name: string; PersonId: string } | null;
      } | null> | null;
      bookingSupportTagStatus?: Array<{
        setOn?: Date | null;
        tag?: string | null;
        setBy?: { PersonId: string; Name: string } | null;
      } | null> | null;
      timeReportStatusSetBy?: { Name: string; PersonId: string } | null;
      BookingRef: { NodeID: string };
      ConsultantRef: { Name?: string | null; NodeID: string };
      DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      HospitalRef: { Id: string; Name: string; Type: CustomerType };
      OrganizationRef: { Id: string; Name: string };
    }>;
  };
};

export type TimereportKitSupportSearch_GetTotalQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
}>;

export type TimereportKitSupportSearch_GetTotalQuery = {
  bookingWeeksTotal: { dbTime?: number | null; total: number };
};

export type AssignToBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
}>;

export type AssignToBookingMutation = {
  assignToBooking: {
    bookingId?: string | null;
    bookingAssignedTo?: Array<{
      setTo?: { PersonId: string; Name: string } | null;
    }> | null;
  };
};

export type UnAssignToBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
}>;

export type UnAssignToBookingMutation = {
  unAssignToBooking: {
    bookingId?: string | null;
    bookingAssignedTo?: Array<{
      setTo?: { PersonId: string; Name: string } | null;
    }> | null;
  };
};

export type CustomerBillingInstructionsFragment = { billingInstructions?: string | null };

export type BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
}>;

export type BookingKitSupportSearch_GetCustomerBillingInstructionsQuery = {
  customerById?: { billingInstructions?: string | null } | null;
};

export type SyncTimeReportsWithBookingSearchMutationVariables = Exact<{
  ids: Array<Scalars["String"]> | Scalars["String"];
}>;

export type SyncTimeReportsWithBookingSearchMutation = {
  syncTimeReportsWithBookingSearch: Array<string>;
};

export type AccommodationRequestSearchItemFragment = {
  _id?: string | null;
  createdOn?: Date | null;
  consultantName?: string | null;
  city?: string | null;
  firstArrival?: Date | null;
  createdBy?: { PersonId: string; Name: string } | null;
  weeks?: Array<{ name?: string | null; link?: string | null } | null> | null;
  status?: {
    status?: AccommodationRequestStatusType | null;
    setOn?: Date | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null;
};

export type AccommodationRequestSearchQueryVariables = Exact<{
  filter: AccommodationRequestQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<AccommodationRequestSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type AccommodationRequestSearchQuery = {
  accommodationRequestSearch: {
    dbTime?: number | null;
    skip: number;
    limit: number;
    items: Array<{
      _id?: string | null;
      createdOn?: Date | null;
      consultantName?: string | null;
      city?: string | null;
      firstArrival?: Date | null;
      createdBy?: { PersonId: string; Name: string } | null;
      weeks?: Array<{ name?: string | null; link?: string | null } | null> | null;
      status?: {
        status?: AccommodationRequestStatusType | null;
        setOn?: Date | null;
        setBy?: { PersonId: string; Name: string } | null;
      } | null;
    }>;
  };
};

export type AccommodationRequestSearchTotalQueryVariables = Exact<{
  filter: AccommodationRequestQueryInput;
}>;

export type AccommodationRequestSearchTotalQuery = {
  accommodationRequestSearchTotal: { dbTime?: number | null; total: number };
};

export type AccommodationCardDetailsFragment = {
  _id: string;
  Type?: string | null;
  ImgUrl?: string | null;
  Name?: string | null;
  Email?: Array<string> | null;
  Site?: string | null;
  Phone?: Array<string> | null;
  CheckIn?: string | null;
  CheckOut?: string | null;
  CancellationPolicy?: string | null;
  Instruction?: string | null;
  preferredChoice?: boolean | null;
  envCertification?: boolean | null;
  envCertificationName?: string | null;
  Offers?: Array<{
    _id?: string | null;
    Name?: string | null;
    Price?: number | null;
    PriceType?: string | null;
    Options?: Array<string> | null;
    Rooms?: number | null;
    Beds?: number | null;
    Area?: number | null;
  }> | null;
  Address?: {
    StreetName: string;
    City: string;
    Region: string;
    Country: string;
    ZipCode: string;
  } | null;
  ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
  unfit?: {
    value?: boolean | null;
    comment?: string | null;
    userRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type GetAccommodationCardQueryVariables = Exact<{
  accommodationId: Scalars["ObjectId"];
}>;

export type GetAccommodationCardQuery = {
  getAccommodationDetails: {
    _id: string;
    Type?: string | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string> | null;
    Site?: string | null;
    Phone?: Array<string> | null;
    CheckIn?: string | null;
    CheckOut?: string | null;
    CancellationPolicy?: string | null;
    Instruction?: string | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    }> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { Name: string; PersonId: string } | null;
    } | null;
  };
};

export type Accommodation_EditMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  data: AccommodationInput;
  img?: InputMaybe<Scalars["Upload"]>;
}>;

export type Accommodation_EditMutation = {
  editAccommodation: {
    _id: string;
    Type?: string | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string> | null;
    Site?: string | null;
    Phone?: Array<string> | null;
    CheckIn?: string | null;
    CheckOut?: string | null;
    CancellationPolicy?: string | null;
    Instruction?: string | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    }> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { Name: string; PersonId: string } | null;
    } | null;
  };
};

export type Accommodation_AddMutationVariables = Exact<{
  responsiblePersonId: Scalars["ObjectId"];
  data: AccommodationInput;
  img?: InputMaybe<Scalars["Upload"]>;
}>;

export type Accommodation_AddMutation = {
  addAccommodation: {
    _id: string;
    Type?: string | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string> | null;
    Site?: string | null;
    Phone?: Array<string> | null;
    CheckIn?: string | null;
    CheckOut?: string | null;
    CancellationPolicy?: string | null;
    Instruction?: string | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    }> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { Name: string; PersonId: string } | null;
    } | null;
  };
};

export type GetAccommodationFilesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetAccommodationFilesQuery = {
  accommodation: {
    _id: string;
    documents?: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        MimeType: string;
        Size: number;
      };
    }> | null;
  };
};

export type UploadAccommodationFileMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  file: Scalars["Upload"];
  documentType: AccommodationDocumentType;
}>;

export type UploadAccommodationFileMutation = {
  uploadAccommodationDocument: {
    DocumentType?: string | null;
    FileRef: {
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      MimeType: string;
      Size: number;
    };
  };
};

export type DeleteAccommodationDocMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
}>;

export type DeleteAccommodationDocMutation = {
  deleteAccommodationDocument?: boolean | null;
};

export type Accommodation_DetailsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type Accommodation_DetailsQuery = {
  getAccommodationDetails: {
    _id: string;
    Type?: string | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string> | null;
    Site?: string | null;
    Phone?: Array<string> | null;
    CheckIn?: string | null;
    CheckOut?: string | null;
    CancellationPolicy?: string | null;
    Instruction?: string | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    }> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { Name: string; PersonId: string } | null;
    } | null;
  };
};

export type AccommodationUpdateUnfitMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
  comment: Scalars["String"];
}>;

export type AccommodationUpdateUnfitMutation = {
  updateUnfitAccommodation: {
    value?: boolean | null;
    comment?: string | null;
    userRef?: { PersonId: string; Name: string } | null;
  };
};

export type Accommodation_DeleteMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type Accommodation_DeleteMutation = { deleteAccommodation: { _id: string } };

export type AccommodationCardListItemFragment = {
  _id: string;
  Type?: AccommodationType | null;
  ImgUrl?: string | null;
  Name?: string | null;
  Email?: Array<string | null> | null;
  Site?: string | null;
  Phone?: Array<string | null> | null;
  preferredChoice?: boolean | null;
  envCertification?: boolean | null;
  envCertificationName?: string | null;
  Offers?: Array<{
    _id?: string | null;
    Name?: string | null;
    Price?: number | null;
    PriceType?: string | null;
    Options?: Array<string> | null;
    Rooms?: number | null;
    Beds?: number | null;
    Area?: number | null;
  } | null> | null;
  Address?: {
    StreetName: string;
    City: string;
    Region: string;
    Country: string;
    ZipCode: string;
  } | null;
  ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
  unfit?: {
    value?: boolean | null;
    comment?: string | null;
    userRef?: { PersonId: string; Name: string } | null;
  } | null;
};

export type AccommodationSearch_SearchQueryVariables = Exact<{
  input?: InputMaybe<AccommodationFilter>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type AccommodationSearch_SearchQuery = {
  getAccommodations: Array<{
    _id: string;
    Type?: AccommodationType | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string | null> | null;
    Site?: string | null;
    Phone?: Array<string | null> | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    } | null> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { PersonId: string; Name: string } | null;
    } | null;
  }>;
  getAccommodationsCount: { total?: number | null };
};

export type BookingKitAssignedFragment = {
  assignedByUserId?: string | null;
  assignedByUserName?: string | null;
  assignedOn?: Date | null;
  assignedToUserId?: string | null;
  assignedToUserName?: string | null;
};

export type AssignToBookingKitMutationVariables = Exact<{
  kitId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
}>;

export type AssignToBookingKitMutation = { assignToBookingKit: boolean };

export type UnAssignFromBookingKitMutationVariables = Exact<{
  kitId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
}>;

export type UnAssignFromBookingKitMutation = { unAssignFromBookingKit: boolean };

export type BookingKitSearchItemFragment = {
  _id?: string | null;
  bookingId: string;
  createdOn: Date;
  type: BookingKitType;
  week: Date;
  assignedByUserId?: string | null;
  assignedByUserName?: string | null;
  assignedOn?: Date | null;
  assignedToUserId?: string | null;
  assignedToUserName?: string | null;
  consultantId: string;
  consultantName: string;
  regionId: string;
  regionName: string;
  hospitalId: string;
  hospitalName: string;
  departmentId?: string | null;
  departmentName?: string | null;
  areaOfExpertise: string;
  costCenterId?: string | null;
  costCenterName?: string | null;
  projectId?: string | null;
  projectName?: string | null;
  consultantPayoutType?: string | null;
  customerContractType?: string | null;
  isNationalProcurement?: boolean | null;
  isHighPriority?: boolean | null;
  customerBillingInstructions?: string | null;
  lastStatusSetByUserName?: string | null;
  lastStatusType?: BookingKitStatusType | null;
  lastStatusSetOn?: Date | null;
  timereportApprovedOn?: Date | null;
  bookingSupportTagComment: string;
  bookingSupportTagStatus?: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }> | null;
};

export type BookingKitSearchQueryVariables = Exact<{
  filter: BookingKitQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<BookingKitSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type BookingKitSearchQuery = {
  bookingKitSearch: {
    dbTime?: number | null;
    skip: number;
    limit: number;
    items: Array<{
      _id?: string | null;
      bookingId: string;
      createdOn: Date;
      type: BookingKitType;
      week: Date;
      assignedByUserId?: string | null;
      assignedByUserName?: string | null;
      assignedOn?: Date | null;
      assignedToUserId?: string | null;
      assignedToUserName?: string | null;
      consultantId: string;
      consultantName: string;
      regionId: string;
      regionName: string;
      hospitalId: string;
      hospitalName: string;
      departmentId?: string | null;
      departmentName?: string | null;
      areaOfExpertise: string;
      costCenterId?: string | null;
      costCenterName?: string | null;
      projectId?: string | null;
      projectName?: string | null;
      consultantPayoutType?: string | null;
      customerContractType?: string | null;
      isNationalProcurement?: boolean | null;
      isHighPriority?: boolean | null;
      customerBillingInstructions?: string | null;
      lastStatusSetByUserName?: string | null;
      lastStatusType?: BookingKitStatusType | null;
      lastStatusSetOn?: Date | null;
      timereportApprovedOn?: Date | null;
      bookingSupportTagComment: string;
      bookingSupportTagStatus?: Array<{
        tag?: string | null;
        setOn?: Date | null;
        setBy?: { Name: string } | null;
      }> | null;
    }>;
  };
};

export type BookingKitSearchTotalQueryVariables = Exact<{
  filter: BookingKitQueryInput;
}>;

export type BookingKitSearchTotalQuery = {
  bookingKitSearchTotal: { dbTime?: number | null; total: number };
};

export type EventLog_BookingKitEventFragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Type: BookingKitEventType;
  ResultOfAction?: string | null;
  Links?: Array<string | null> | null;
  Warning?: boolean | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
  UserRef?: { Name: string; PersonId: string } | null;
};

export type BookingKitEventLog_GetEventsQueryVariables = Exact<{
  kitId: Scalars["ObjectId"];
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  types?: InputMaybe<
    Array<InputMaybe<BookingKitEventType>> | InputMaybe<BookingKitEventType>
  >;
}>;

export type BookingKitEventLog_GetEventsQuery = {
  bookingKitEvents?: Array<{
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingKitEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null> | null;
};

export type BookingKitEventLog_AddCommentMutationVariables = Exact<{
  kitId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type BookingKitEventLog_AddCommentMutation = {
  addBookingKitCommentEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingKitEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type BookingKitEventLog_UpdateMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
  desc?: InputMaybe<Scalars["String"]>;
  sticky?: InputMaybe<Scalars["Boolean"]>;
}>;

export type BookingKitEventLog_UpdateMutation = {
  updateBookingKitEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingKitEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type BookingKitEventLog_DeleteMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type BookingKitEventLog_DeleteMutation = {
  deleteBookingKitEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingKitEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type KitStatusFragment = {
  setOn?: Date | null;
  status?: BookingKitStatusType | null;
  comment?: string | null;
  setBy?: { PersonId: string; Name: string } | null;
};

export type KitProfileCardFragment = {
  _id?: string | null;
  bookingId: string;
  isDone: boolean;
  week: Date;
  timeReportType?: TimeReportTemplateType | null;
  name?: string | null;
  type?: BookingKitType | null;
  comments?: Array<string> | null;
  withTimeReport?: boolean | null;
  withCustomerInvoice?: boolean | null;
  withConsultantInvoice?: boolean | null;
  withSickPay?: boolean | null;
  withSubcontractorPay?: boolean | null;
  bookingSupportCheckWasValid?: boolean | null;
  bookingSupportTagComment: string;
  customerBillingInstructions?: string | null;
  consultantPayoutType?: string | null;
  deleted: boolean;
  deletedOn?: Date | null;
  deletedByName?: string | null;
  isGroupInvoicing?: boolean | null;
  profitNet: number;
  profitRatio: number;
  assigned?: {
    on?: Date | null;
    by?: { Name: string; PersonId: string } | null;
    to?: { Name: string; PersonId: string } | null;
  } | null;
  responsible?: { _id: string; Name: string } | null;
  manager?: { _id: string; Name: string } | null;
  bookingSupportTagStatus?: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }> | null;
  receipts?: Array<{ uri: string; name: string }> | null;
  documents: Array<{
    _id: string;
    documentType?: string | null;
    name: string;
    pdfUrl: string;
  }>;
  statuses?: Array<{
    setOn?: Date | null;
    status?: BookingKitStatusType | null;
    comment?: string | null;
    setBy?: { PersonId: string; Name: string } | null;
  }> | null;
  hospital?: { _id: string; Name?: string | null } | null;
  department?: { _id: string; Name?: string | null } | null;
  consultant?: { _id: string; Name?: string | null } | null;
  project?: { Name: string; ProjectNumber: string } | null;
  costCenter?: { Id: string; Name?: string | null } | null;
  currentHBAStatus?: {
    setOn?: Date | null;
    status?: BookingKitStatusType | null;
    comment?: string | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null;
  currentOCStatus?: {
    setOn?: Date | null;
    status?: BookingKitStatusType | null;
    comment?: string | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null;
  currentFinancePaymentStatus?: {
    setOn?: Date | null;
    status?: BookingKitStatusType | null;
    comment?: string | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null;
  currentFinanceInvoiceStatus?: {
    setOn?: Date | null;
    status?: BookingKitStatusType | null;
    comment?: string | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null;
};

export type GetKitQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetKitQuery = {
  bookingKit?: {
    _id?: string | null;
    bookingId: string;
    isDone: boolean;
    week: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    bookingSupportTagComment: string;
    customerBillingInstructions?: string | null;
    consultantPayoutType?: string | null;
    deleted: boolean;
    deletedOn?: Date | null;
    deletedByName?: string | null;
    isGroupInvoicing?: boolean | null;
    profitNet: number;
    profitRatio: number;
    assigned?: {
      on?: Date | null;
      by?: { Name: string; PersonId: string } | null;
      to?: { Name: string; PersonId: string } | null;
    } | null;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      comment?: string | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    hospital?: { _id: string; Name?: string | null } | null;
    department?: { _id: string; Name?: string | null } | null;
    consultant?: { _id: string; Name?: string | null } | null;
    project?: { Name: string; ProjectNumber: string } | null;
    costCenter?: { Id: string; Name?: string | null } | null;
    currentHBAStatus?: {
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      comment?: string | null;
      setBy?: { PersonId: string; Name: string } | null;
    } | null;
    currentOCStatus?: {
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      comment?: string | null;
      setBy?: { PersonId: string; Name: string } | null;
    } | null;
    currentFinancePaymentStatus?: {
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      comment?: string | null;
      setBy?: { PersonId: string; Name: string } | null;
    } | null;
    currentFinanceInvoiceStatus?: {
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      comment?: string | null;
      setBy?: { PersonId: string; Name: string } | null;
    } | null;
  } | null;
};

export type GetKitApprovalConfigQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetKitApprovalConfigQuery = {
  bookingKitApprovalConfig: {
    canApprove: boolean;
    canReject: boolean;
    canRejectDone: boolean;
  };
};

export type DeleteBookingKitMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteBookingKitMutation = { deleteBookingKit?: boolean | null };

export type ApproveBookingKitMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  comment?: InputMaybe<Scalars["String"]>;
}>;

export type ApproveBookingKitMutation = {
  approveBookingKit: {
    _id?: string | null;
    createdOn: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    status?: BookingKitStatusType | null;
    bookingSupportTagComment: string;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  };
};

export type RejectBookingKitMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  comment?: InputMaybe<Scalars["String"]>;
}>;

export type RejectBookingKitMutation = {
  rejectBookingKit: {
    _id?: string | null;
    createdOn: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    status?: BookingKitStatusType | null;
    bookingSupportTagComment: string;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  };
};

export type RejectDoneBookingKitMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  comment?: InputMaybe<Scalars["String"]>;
}>;

export type RejectDoneBookingKitMutation = {
  rejectDoneBookingKit: {
    _id?: string | null;
    createdOn: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    status?: BookingKitStatusType | null;
    bookingSupportTagComment: string;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  };
};

export type BookingEdit_EditMutationVariables = Exact<{
  bookingGroupId: Scalars["ObjectId"];
  input: BookingGroupInput;
}>;

export type BookingEdit_EditMutation = { updateBookingGroup: { _id: string } };

export type BookingEdit_CreateMutationVariables = Exact<{
  input: BookingGroupInput;
  duplicateFromBookingId?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type BookingEdit_CreateMutation = {
  createBookingGroup: { _id: string; bookings: Array<{ _id: string }> };
};

export type GetBookingEditTravelZonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookingEditTravelZonesQuery = {
  config: { defaultTravelZones: Array<{ label: string; name: string }> };
};

export type BookingEdit_BookingGroupFragment = {
  _id: string;
  hasClosedBooking: boolean;
  consultantContractId?: string | null;
  customerContractId?: string | null;
  subVersionId?: string | null;
  isNationalProcurement?: boolean | null;
  isDiscount?: boolean | null;
  nationalProcurementTravelRequired?: boolean | null;
  travelTemplateLevel?: string | null;
  authorizedOrderer?: string | null;
  hospital: { _id: string; Name?: string | null };
  department?: { _id: string; Name?: string | null } | null;
  bookings: Array<{
    createdOn?: Date | null;
    isOpen: boolean;
    isCancellable: boolean;
    Week: Date;
    requireTravelInvoicing?: boolean | null;
  }>;
  customerContract?: {
    _id: string;
    parentId?: string | null;
    contractName: string;
    contractType: string;
    contractStart: Date;
    contractEnd: Date;
    isSubVersion: boolean;
    isNationalProcurement: boolean;
    useNationalProcurementInvoicing?: boolean | null;
    priceLists: Array<string>;
    basicPrices: Array<{ price?: string | null; dates?: string | null }>;
  } | null;
};

export type BookingEditFragment = {
  _id: string;
  AreaOfExpertise: string;
  specializations: Array<string>;
  ContractType?: ContractType | null;
  AccommodationRequired: boolean;
  TravelRequired: boolean;
  isFirstWeek?: boolean | null;
  callNumber: string;
  Consultant?: { _id: string } | null;
  Project?: {
    _id: string;
    Comment: string;
    Description: string;
    Name: string;
    ProjectNumber: string;
    Status?: ProjectStatus | null;
    Admin?: { Name: string; PersonId: string } | null;
    Owner?: { Name: string; PersonId: string } | null;
    Members: Array<{ Name: string; PersonId: string }>;
  } | null;
  ConsultantSnapshot: {
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
  };
  BookingGroup: {
    _id: string;
    hasClosedBooking: boolean;
    consultantContractId?: string | null;
    customerContractId?: string | null;
    subVersionId?: string | null;
    isNationalProcurement?: boolean | null;
    isDiscount?: boolean | null;
    nationalProcurementTravelRequired?: boolean | null;
    travelTemplateLevel?: string | null;
    authorizedOrderer?: string | null;
    hospital: { _id: string; Name?: string | null };
    department?: { _id: string; Name?: string | null } | null;
    bookings: Array<{
      createdOn?: Date | null;
      isOpen: boolean;
      isCancellable: boolean;
      Week: Date;
      requireTravelInvoicing?: boolean | null;
    }>;
    customerContract?: {
      _id: string;
      parentId?: string | null;
      contractName: string;
      contractType: string;
      contractStart: Date;
      contractEnd: Date;
      isSubVersion: boolean;
      isNationalProcurement: boolean;
      useNationalProcurementInvoicing?: boolean | null;
      priceLists: Array<string>;
      basicPrices: Array<{ price?: string | null; dates?: string | null }>;
    } | null;
  };
  CostCenter?: {
    OriginalName?: string | null;
    Id: string;
    IsActive: boolean;
    Name?: string | null;
    IsDeleted: boolean;
  } | null;
  bookingIntro?: {
    required?: boolean | null;
    startDate?: Date | null;
    endDate?: Date | null;
    description?: string | null;
  } | null;
};

export type BookingEdit_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingEdit_GetQuery = {
  bookingById?: {
    _id: string;
    AreaOfExpertise: string;
    specializations: Array<string>;
    ContractType?: ContractType | null;
    AccommodationRequired: boolean;
    TravelRequired: boolean;
    isFirstWeek?: boolean | null;
    callNumber: string;
    Consultant?: { _id: string } | null;
    Project?: {
      _id: string;
      Comment: string;
      Description: string;
      Name: string;
      ProjectNumber: string;
      Status?: ProjectStatus | null;
      Admin?: { Name: string; PersonId: string } | null;
      Owner?: { Name: string; PersonId: string } | null;
      Members: Array<{ Name: string; PersonId: string }>;
    } | null;
    ConsultantSnapshot: {
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
    };
    BookingGroup: {
      _id: string;
      hasClosedBooking: boolean;
      consultantContractId?: string | null;
      customerContractId?: string | null;
      subVersionId?: string | null;
      isNationalProcurement?: boolean | null;
      isDiscount?: boolean | null;
      nationalProcurementTravelRequired?: boolean | null;
      travelTemplateLevel?: string | null;
      authorizedOrderer?: string | null;
      hospital: { _id: string; Name?: string | null };
      department?: { _id: string; Name?: string | null } | null;
      bookings: Array<{
        createdOn?: Date | null;
        isOpen: boolean;
        isCancellable: boolean;
        Week: Date;
        requireTravelInvoicing?: boolean | null;
      }>;
      customerContract?: {
        _id: string;
        parentId?: string | null;
        contractName: string;
        contractType: string;
        contractStart: Date;
        contractEnd: Date;
        isSubVersion: boolean;
        isNationalProcurement: boolean;
        useNationalProcurementInvoicing?: boolean | null;
        priceLists: Array<string>;
        basicPrices: Array<{ price?: string | null; dates?: string | null }>;
      } | null;
    };
    CostCenter?: {
      OriginalName?: string | null;
      Id: string;
      IsActive: boolean;
      Name?: string | null;
      IsDeleted: boolean;
    } | null;
    bookingIntro?: {
      required?: boolean | null;
      startDate?: Date | null;
      endDate?: Date | null;
      description?: string | null;
    } | null;
  } | null;
};

export type BookingEdit_GetConsultantQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingEdit_GetConsultantQuery = {
  consultantById?: {
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    AccommodationPreferences: string;
    TravelPreferences: string;
    _id: string;
    AreasOfExpertise: Array<string>;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    LastContactDate?: Date | null;
    Name?: string | null;
    Phone?: string | null;
    Unfit: boolean;
    SocialSecurityNo?: string | null;
    Specializations: Array<string>;
    IsValid?: boolean | null;
    Professions?: Array<string | null> | null;
    PrescriptionCode?: string | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    Address?: { City: string } | null;
    contactType?: {
      employeeSalaryClaim?: string | null;
      subcontractorSalaryClaim?: string | null;
    } | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ValidationErrors: Array<{
      Message: string;
      Params?: any | null;
      Type: NodeValidationErrorType;
    }>;
    expertise: { machines: Array<string>; systems: Array<string | null> };
  } | null;
};

export type BookingEdit_GetCustomerQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingEdit_GetCustomerQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    inLists: boolean;
    RecruitingPortalType?: RecruitingPortalType | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    StaffingContactPersons: Array<{
      _id: string;
      AreasOfExpertise: Array<string | null>;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
    }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type BookingEdit_FetchDeptsQueryVariables = Exact<{
  hospitalId: Scalars["ObjectId"];
}>;

export type BookingEdit_FetchDeptsQuery = {
  hospital?: {
    _id: string;
    forceCallNumber?: boolean | null;
    AOESettings: Array<{
      AreaOfExpertise: string;
      ResponsiblePerson?: { Name: string; PersonId: string } | null;
    }>;
  } | null;
  departments: {
    dbTime?: number | null;
    items: Array<{ _id: string; Name?: string | null }>;
  };
};

export type BookingEdit_GetConsultantContractsQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  dates: Array<InputMaybe<Scalars["Date"]>> | InputMaybe<Scalars["Date"]>;
}>;

export type BookingEdit_GetConsultantContractsQuery = {
  contracts: Array<{
    _id?: string | null;
    ParentId?: string | null;
    Name?: string | null;
    SalaryChoice?: ContractType | null;
    Period?: string | null;
    Type?: ConsultantContractType | null;
  }>;
};

export type BookingEdit_GetCustomerContractsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerContractByBookingFilter>;
}>;

export type BookingEdit_GetCustomerContractsQuery = {
  customerContractsByBooking: Array<{
    _id: string;
    parentId?: string | null;
    contractName: string;
    contractType: string;
    contractStart: Date;
    contractEnd: Date;
    isSubVersion: boolean;
    isNationalProcurement: boolean;
    useNationalProcurementInvoicing?: boolean | null;
    avropsnummer?: string | null;
    priceLists: Array<string>;
    basicPrices: Array<{ price?: string | null; dates?: string | null }>;
  }>;
};

export type BookingEdit_CreateDirectRequestContractMutationVariables = Exact<{
  data: CreateDirectRequestContractInput;
}>;

export type BookingEdit_CreateDirectRequestContractMutation = {
  createDirectRequestContract: {
    errors?: Array<string> | null;
    value?: { _id: string; avropsnummer?: string | null } | null;
  };
};

export type BookingEdit_NpDirectRequestAvailableQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type BookingEdit_NpDirectRequestAvailableQuery = {
  npDirectRequestAvailable: boolean;
};

export type SubVersionOptionFragment = {
  _id: string;
  name?: string | null;
  consultantId?: string | null;
};

export type CustomerContractOptionFragment = {
  _id: string;
  contractName?: string | null;
  contractStart: Date;
  contractEnd: Date;
  subVersions: Array<{ _id: string; name?: string | null; consultantId?: string | null }>;
};

export type BookingEdit_GetAllowedCostCentersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BookingEdit_GetAllowedCostCentersQuery = {
  me: {
    allowedCostCenters: Array<{
      OriginalName?: string | null;
      Id: string;
      IsActive: boolean;
      Name?: string | null;
      IsDeleted: boolean;
    }>;
  };
};

export type BookingFinanceEditor_GroupFragment = {
  _id: string;
  isNationalProcurement?: boolean | null;
  bookings: Array<{ _id: string; Week: Date }>;
};

export type BookingFinanceEditor_ItemFragment = {
  _id: string;
  Week: Date;
  AdditionalWork: boolean;
  AdditionalWorkNote: string;
  AreaOfExpertise: string;
  ContractType?: ContractType | null;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  isSickPayed: boolean;
  timeReportHasSickTime?: boolean | null;
  Note: string;
  PatientId: string;
  GroupInvoicing: boolean;
  GroupInvoiceTotal?: number | null;
  CustomerFine: number;
  AdministrativeFee: number;
  unlockForms: boolean;
  Project?: {
    _id: string;
    ProjectNumber: string;
    Members: Array<{ PersonId: string }>;
  } | null;
  BookingGroup: {
    _id: string;
    isNationalProcurement?: boolean | null;
    hospital: { _id: string; Name?: string | null; billingInstructions?: string | null };
    department?: { _id: string; Name?: string | null } | null;
    bookings: Array<{ _id: string; Week: Date }>;
  };
  Invoices: Array<{
    invoiceNumber: string;
    invoice?: {
      TotalGross?: number | null;
      _id: string;
      CustomerName?: string | null;
      CustomerNumber?: string | null;
      InvoiceNumber: string;
      Provider: InvoiceProvider;
      TotalNet?: number | null;
      InvoiceDate?: Date | null;
      DueDate?: Date | null;
      Notes?: string | null;
      IsCredit: boolean;
      PreviewUrl: string;
    } | null;
  } | null>;
  CostCenter?: { Id: string; Organisation?: string | null; Name?: string | null } | null;
  SubcontractorDocuments: Array<{
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  }>;
  ConsultantSnapshot: {
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
  };
  Consultant?: {
    _id: string;
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    SubcontractorInfo?: { Name: string } | null;
    contactType?: {
      accountNumber?: string | null;
      clearingNumber?: string | null;
      rate?: string | null;
    } | null;
  } | null;
  costs?: {
    employeeSalary: number;
    invoiceTotal: number;
    sickPayTotal: number;
    accommodation: number;
    travel: number;
  } | null;
};

export type BookingFinanceEditor_FetchQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingFinanceEditor_FetchQuery = {
  bookingById?: {
    _id: string;
    Week: Date;
    AdditionalWork: boolean;
    AdditionalWorkNote: string;
    AreaOfExpertise: string;
    ContractType?: ContractType | null;
    IsConsultantPayed: boolean;
    IsCustomerBilled: boolean;
    isSickPayed: boolean;
    timeReportHasSickTime?: boolean | null;
    Note: string;
    PatientId: string;
    GroupInvoicing: boolean;
    GroupInvoiceTotal?: number | null;
    CustomerFine: number;
    AdministrativeFee: number;
    unlockForms: boolean;
    Project?: {
      _id: string;
      ProjectNumber: string;
      Members: Array<{ PersonId: string }>;
    } | null;
    BookingGroup: {
      _id: string;
      isNationalProcurement?: boolean | null;
      hospital: {
        _id: string;
        Name?: string | null;
        billingInstructions?: string | null;
      };
      department?: { _id: string; Name?: string | null } | null;
      bookings: Array<{ _id: string; Week: Date }>;
    };
    Invoices: Array<{
      invoiceNumber: string;
      invoice?: {
        TotalGross?: number | null;
        _id: string;
        CustomerName?: string | null;
        CustomerNumber?: string | null;
        InvoiceNumber: string;
        Provider: InvoiceProvider;
        TotalNet?: number | null;
        InvoiceDate?: Date | null;
        DueDate?: Date | null;
        Notes?: string | null;
        IsCredit: boolean;
        PreviewUrl: string;
      } | null;
    } | null>;
    CostCenter?: {
      Id: string;
      Organisation?: string | null;
      Name?: string | null;
    } | null;
    SubcontractorDocuments: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
    ConsultantSnapshot: {
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
    };
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
      FirstName?: string | null;
      LastName?: string | null;
      SubcontractorInfo?: { Name: string } | null;
      contactType?: {
        accountNumber?: string | null;
        clearingNumber?: string | null;
        rate?: string | null;
      } | null;
    } | null;
    costs?: {
      employeeSalary: number;
      invoiceTotal: number;
      sickPayTotal: number;
      accommodation: number;
      travel: number;
    } | null;
  } | null;
};

export type BookingFinanceEditor_FetchDraftCostsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingFinanceEditor_FetchDraftCostsQuery = {
  bookingById?: {
    draftCosts?: {
      invoiceTotal: number;
      sickPayTotal: number;
      employeeSalary: number;
      travel: number;
      accommodation: number;
    } | null;
  } | null;
};

export type BookingFinanceEditor_UpdateMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  data: UpdateBookingFinanceInput;
}>;

export type BookingFinanceEditor_UpdateMutation = {
  updateBookingFinance: {
    _id: string;
    Week: Date;
    AdditionalWork: boolean;
    AdditionalWorkNote: string;
    AreaOfExpertise: string;
    ContractType?: ContractType | null;
    IsConsultantPayed: boolean;
    IsCustomerBilled: boolean;
    isSickPayed: boolean;
    timeReportHasSickTime?: boolean | null;
    Note: string;
    PatientId: string;
    GroupInvoicing: boolean;
    GroupInvoiceTotal?: number | null;
    CustomerFine: number;
    AdministrativeFee: number;
    unlockForms: boolean;
    Project?: {
      _id: string;
      ProjectNumber: string;
      Members: Array<{ PersonId: string }>;
    } | null;
    BookingGroup: {
      _id: string;
      isNationalProcurement?: boolean | null;
      hospital: {
        _id: string;
        Name?: string | null;
        billingInstructions?: string | null;
      };
      department?: { _id: string; Name?: string | null } | null;
      bookings: Array<{ _id: string; Week: Date }>;
    };
    Invoices: Array<{
      invoiceNumber: string;
      invoice?: {
        TotalGross?: number | null;
        _id: string;
        CustomerName?: string | null;
        CustomerNumber?: string | null;
        InvoiceNumber: string;
        Provider: InvoiceProvider;
        TotalNet?: number | null;
        InvoiceDate?: Date | null;
        DueDate?: Date | null;
        Notes?: string | null;
        IsCredit: boolean;
        PreviewUrl: string;
      } | null;
    } | null>;
    CostCenter?: {
      Id: string;
      Organisation?: string | null;
      Name?: string | null;
    } | null;
    SubcontractorDocuments: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
    ConsultantSnapshot: {
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
    };
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
      FirstName?: string | null;
      LastName?: string | null;
      SubcontractorInfo?: { Name: string } | null;
      contactType?: {
        accountNumber?: string | null;
        clearingNumber?: string | null;
        rate?: string | null;
      } | null;
    } | null;
    costs?: {
      employeeSalary: number;
      invoiceTotal: number;
      sickPayTotal: number;
      accommodation: number;
      travel: number;
    } | null;
  };
};

export type BookingFinanceEditor_UploadDocumentMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type BookingFinanceEditor_UploadDocumentMutation = {
  uploadDocument: {
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  };
};

export type BookingFinanceEditor_UnlockFormsMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
}>;

export type BookingFinanceEditor_UnlockFormsMutation = {
  setUnlockBookingForms: { unlockForms: boolean };
};

export type BookingGroupCardFragment = {
  _id: string;
  isNationalProcurement?: boolean | null;
  consultant?: { _id: string; Name?: string | null } | null;
  hospital: {
    _id: string;
    Name?: string | null;
    AreasOfExpertise: Array<string>;
    Specializations: Array<string>;
    RecruitingPortalType?: RecruitingPortalType | null;
    Address?: { Region: string } | null;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  };
  department?: { _id: string; Name?: string | null } | null;
};

export type BookingGroupCard_GetBookingGroupQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingGroupCard_GetBookingGroupQuery = {
  getBookingGroup?: {
    _id: string;
    isNationalProcurement?: boolean | null;
    consultant?: { _id: string; Name?: string | null } | null;
    hospital: {
      _id: string;
      Name?: string | null;
      AreasOfExpertise: Array<string>;
      Specializations: Array<string>;
      RecruitingPortalType?: RecruitingPortalType | null;
      Address?: { Region: string } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    };
    department?: { _id: string; Name?: string | null } | null;
  } | null;
};

export type GetAccommodationConfirmationByIdQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
}>;

export type GetAccommodationConfirmationByIdQuery = {
  bookingById?: {
    _id: string;
    AreaOfExpertise: string;
    CustomerNumber: string;
    Week: Date;
    callNumber: string;
    erpExportUnitRef?: string | null;
    BookingGroup: {
      _id: string;
      externalId?: string | null;
      bookings: Array<{
        _id: string;
        Week: Date;
        isOpen: boolean;
        IsConsultantPayed: boolean;
      }>;
      hospital: {
        _id: string;
        AreasOfExpertise: Array<string>;
        RecruitingPortalType?: RecruitingPortalType | null;
        Specializations: Array<string>;
        Name?: string | null;
        Address?: { Country: string; Region: string } | null;
        Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      };
      department?: { _id: string; Name?: string | null } | null;
    };
    Consultant?: {
      LegalPersonType?: LegalPersonType | null;
      _id: string;
      Name?: string | null;
    } | null;
  } | null;
  accommodationConfirmationById: {
    _id: string;
    confirmedOn?: Date | null;
    deleted?: boolean | null;
    offerId?: string | null;
    weeks: Array<Date>;
    area?: number | null;
    totalCost?: number | null;
    totalExVAT?: boolean | null;
    city?: string | null;
    squareFootageAttached?: boolean | null;
    source: string;
    taxationId?: string | null;
    syncedAt?: Date | null;
    accommodationRef?: {
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
    } | null;
    confirmedBy?: { Name: string; PersonId: string } | null;
    documents: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
    allWeeks: Array<{
      cost: number;
      extraCost: number;
      extraDescription?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      isTaxed: boolean;
      nights: number;
      tax: number;
      note?: string | null;
      weekYear: { Week: number; Year: number };
      lines: Array<{
        reservationId?: string | null;
        accommodationName: string;
        city: string;
        area: number;
        startDate?: Date | null;
        endDate?: Date | null;
        nights: number;
        stayedNights: number;
        cost: number;
        extraCost: number;
        extraDescription?: string | null;
        tax: number;
        paymentMethod: string;
      }>;
    }>;
  };
};

export type AccommodationConfirmationBookingInfoFragment = {
  _id: string;
  AreaOfExpertise: string;
  CustomerNumber: string;
  Week: Date;
  callNumber: string;
  erpExportUnitRef?: string | null;
  BookingGroup: {
    _id: string;
    externalId?: string | null;
    bookings: Array<{
      _id: string;
      Week: Date;
      isOpen: boolean;
      IsConsultantPayed: boolean;
    }>;
    hospital: {
      _id: string;
      AreasOfExpertise: Array<string>;
      RecruitingPortalType?: RecruitingPortalType | null;
      Specializations: Array<string>;
      Name?: string | null;
      Address?: { Country: string; Region: string } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    };
    department?: { _id: string; Name?: string | null } | null;
  };
  Consultant?: {
    LegalPersonType?: LegalPersonType | null;
    _id: string;
    Name?: string | null;
  } | null;
};

export type GetAccommodationDocUploaderDataQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type GetAccommodationDocUploaderDataQuery = {
  bookingById?: {
    _id: string;
    AreaOfExpertise: string;
    CustomerNumber: string;
    Week: Date;
    callNumber: string;
    erpExportUnitRef?: string | null;
    BookingGroup: {
      _id: string;
      externalId?: string | null;
      bookings: Array<{
        _id: string;
        Week: Date;
        isOpen: boolean;
        IsConsultantPayed: boolean;
      }>;
      hospital: {
        _id: string;
        AreasOfExpertise: Array<string>;
        RecruitingPortalType?: RecruitingPortalType | null;
        Specializations: Array<string>;
        Name?: string | null;
        Address?: { Country: string; Region: string } | null;
        Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      };
      department?: { _id: string; Name?: string | null } | null;
    };
    Consultant?: {
      LegalPersonType?: LegalPersonType | null;
      _id: string;
      Name?: string | null;
    } | null;
  } | null;
};

export type AccommodationConfirmation_GetCityInhabitantsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccommodationConfirmation_GetCityInhabitantsQuery = {
  config: {
    cityInhabitants: Array<{ city: string; inhabitants: number; taxRegion: string }>;
  };
};

export type AddAccommodationDocsMutationVariables = Exact<{
  input: ConfirmAccommodationInput;
}>;

export type AddAccommodationDocsMutation = { confirmAccommodation: { _id: string } };

export type UpdateAccommodationConfirmationMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: ConfirmAccommodationInput;
}>;

export type UpdateAccommodationConfirmationMutation = {
  updateAccommodationConfirmation?: boolean | null;
};

export type AccommodationRequestBookingGroupDataFragment = {
  _id: string;
  isNationalProcurement?: boolean | null;
  accommodationRequestedWeeks: Array<Date>;
  consultant?: {
    _id: string;
    Name?: string | null;
    AccommodationPreferences: string;
  } | null;
  bookings: Array<{
    _id: string;
    AreaOfExpertise: string;
    Week: Date;
    CostCenter?: { Id: string } | null;
  }>;
  hospital: {
    _id: string;
    Name?: string | null;
    AreasOfExpertise: Array<string>;
    Specializations: Array<string>;
    Address?: {
      Region: string;
      ZipCode: string;
      City: string;
      StreetName: string;
    } | null;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  };
  department?: {
    _id: string;
    Name?: string | null;
    Address?: { ZipCode: string; City: string; StreetName: string } | null;
  } | null;
};

export type AccommodationRequest_GetBookingGroupQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type AccommodationRequest_GetBookingGroupQuery = {
  getBookingGroup?: {
    _id: string;
    isNationalProcurement?: boolean | null;
    accommodationRequestedWeeks: Array<Date>;
    consultant?: {
      _id: string;
      Name?: string | null;
      AccommodationPreferences: string;
    } | null;
    bookings: Array<{
      _id: string;
      AreaOfExpertise: string;
      Week: Date;
      CostCenter?: { Id: string } | null;
    }>;
    hospital: {
      _id: string;
      Name?: string | null;
      AreasOfExpertise: Array<string>;
      Specializations: Array<string>;
      Address?: {
        Region: string;
        ZipCode: string;
        City: string;
        StreetName: string;
      } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    };
    department?: {
      _id: string;
      Name?: string | null;
      Address?: { ZipCode: string; City: string; StreetName: string } | null;
    } | null;
  } | null;
};

export type AccommodationRequest_GetLastItemFragment = {
  _id: string;
  accommodationType?: Array<string | null> | null;
  additionalInfo?: string | null;
  budget?: string | null;
  budgetPeriod?: AccommodationPriceType | null;
  carAccess?: string | null;
  hasOwnCar?: boolean | null;
  hasCarAccess?: boolean | null;
  sharedConveniences?: string | null;
  city?: string | null;
  country?: string | null;
  customerAddress?: string | null;
  paidBy?: HospitalityPaidBy | null;
  accommodationSuggestion?: AccommodationTypeOf | null;
  periodInput?: string | null;
  shouldBeBookedDirectly?: string | null;
  walkingDistance?: string | null;
  accommodationPreferences?: string | null;
  zzNumber?: string | null;
  sharedKitchen?: boolean | null;
  sharedBathroom?: boolean | null;
  ticketDifficultyLevel?: TicketDifficultyLevel | null;
  differentCity?: boolean | null;
  specifyCity?: string | null;
  acceptedOveragePercent?: string | null;
  maxAllowedPerNight?: string | null;
  hasAccommodationSuggestion?: boolean | null;
  staffAccommodation?: string | null;
  accommodationLink?: string | null;
  bookingInformation?: string | null;
  parkingMaxPrice?: string | null;
  commentAboutBooking?: string | null;
  consultantId?: string | null;
  costCenterId?: string | null;
  projectId?: string | null;
  isProlongation?: boolean | null;
};

export type AccommodationRequest_GetLastQueryVariables = Exact<{
  filter: AccommodationRequestQueryInput;
}>;

export type AccommodationRequest_GetLastQuery = {
  getLastAccommodationRequest?: {
    _id: string;
    accommodationType?: Array<string | null> | null;
    additionalInfo?: string | null;
    budget?: string | null;
    budgetPeriod?: AccommodationPriceType | null;
    carAccess?: string | null;
    hasOwnCar?: boolean | null;
    hasCarAccess?: boolean | null;
    sharedConveniences?: string | null;
    city?: string | null;
    country?: string | null;
    customerAddress?: string | null;
    paidBy?: HospitalityPaidBy | null;
    accommodationSuggestion?: AccommodationTypeOf | null;
    periodInput?: string | null;
    shouldBeBookedDirectly?: string | null;
    walkingDistance?: string | null;
    accommodationPreferences?: string | null;
    zzNumber?: string | null;
    sharedKitchen?: boolean | null;
    sharedBathroom?: boolean | null;
    ticketDifficultyLevel?: TicketDifficultyLevel | null;
    differentCity?: boolean | null;
    specifyCity?: string | null;
    acceptedOveragePercent?: string | null;
    maxAllowedPerNight?: string | null;
    hasAccommodationSuggestion?: boolean | null;
    staffAccommodation?: string | null;
    accommodationLink?: string | null;
    bookingInformation?: string | null;
    parkingMaxPrice?: string | null;
    commentAboutBooking?: string | null;
    consultantId?: string | null;
    costCenterId?: string | null;
    projectId?: string | null;
    isProlongation?: boolean | null;
  } | null;
};

export type SubmitAccommodationRequestMutationVariables = Exact<{
  bookingGroupId?: InputMaybe<Scalars["ObjectId"]>;
  bookingIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
  input: AccommodationRequestInput;
  file?: InputMaybe<Scalars["String"]>;
}>;

export type SubmitAccommodationRequestMutation = {
  createAccommodationRequest: { _id: string };
};

export type AccommodationRequest_GetAllowedCostCentersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccommodationRequest_GetAllowedCostCentersQuery = {
  me: {
    allowedCostCenters: Array<{
      OriginalName?: string | null;
      Id: string;
      IsActive: boolean;
      Name?: string | null;
      IsDeleted: boolean;
    }>;
  };
};

export type BookingHospitalityFragment = {
  _id: string;
  accommodation: {
    accommodationRequested: boolean;
    accommodationIsOk: boolean;
    accommodationRequest: Array<{
      _id: string;
      createdById?: string | null;
      createdByName?: string | null;
      createdOn?: Date | null;
    }>;
    confirmations: Array<{
      _id: string;
      confirmedOn?: Date | null;
      deleted?: boolean | null;
      offerId?: string | null;
      weeks: Array<Date>;
      source: string;
      taxationId?: string | null;
      accommodationRef?: { Name?: string | null; NodeID: string } | null;
      confirmedBy?: { Name: string; PersonId: string } | null;
    }>;
  };
  travel: {
    travelIsOk: boolean;
    travelRequested: boolean;
    travelRequest: Array<{
      _id: string;
      createdById?: string | null;
      createdByName?: string | null;
      createdOn?: Date | null;
    }>;
    confirmations: Array<{
      _id: string;
      confirmedOn?: Date | null;
      deleted?: boolean | null;
      weeks: Array<Date>;
      confirmedBy?: { Name: string; PersonId: string } | null;
      documents: Array<{
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      }>;
    }>;
  };
};

export type FullAccommodationRequestFragment = {
  _id: string;
  accommodationType?: Array<string | null> | null;
  additionalInfo?: string | null;
  budget?: string | null;
  budgetPeriod?: AccommodationPriceType | null;
  carAccess?: string | null;
  hasOwnCar?: boolean | null;
  hasCarAccess?: boolean | null;
  sharedConveniences?: string | null;
  city?: string | null;
  country?: string | null;
  customerAddress?: string | null;
  deadline?: Date | null;
  paidBy?: HospitalityPaidBy | null;
  accommodationSuggestion?: AccommodationTypeOf | null;
  periodInput?: string | null;
  createdById?: string | null;
  createdByName?: string | null;
  createdOn?: Date | null;
  shouldBeBookedDirectly?: string | null;
  walkingDistance?: string | null;
  accommodationPreferences?: string | null;
  zzNumber?: string | null;
  bookingGroup?: string | null;
  sharedKitchen?: boolean | null;
  sharedBathroom?: boolean | null;
  ticketDifficultyLevel?: TicketDifficultyLevel | null;
  differentCity?: boolean | null;
  specifyCity?: string | null;
  acceptedOveragePercent?: string | null;
  maxAllowedPerNight?: string | null;
  hasAccommodationSuggestion?: boolean | null;
  staffAccommodation?: string | null;
  accommodationLink?: string | null;
  bookingInformation?: string | null;
  parkingMaxPrice?: string | null;
  commentAboutBooking?: string | null;
  consultantId?: string | null;
  costCenterId?: string | null;
  projectId?: string | null;
  isProlongation?: boolean | null;
  isReschedule?: boolean | null;
  rescheduleComment?: string | null;
  periods?: Array<{ start?: Date | null; end?: Date | null } | null> | null;
  bookingConfirmationFile?: {
    _id: string;
    type: CrmDocumentType;
    name: string;
    documentType?: string | null;
    mimeType: string;
    size: number;
    pdfUrl: string;
    thumbUrl: string;
  } | null;
};

export type BookingHospitalityGetQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  week: WeekYearInput;
}>;

export type BookingHospitalityGetQuery = {
  bookingHospitality: {
    _id: string;
    accommodation: {
      accommodationRequested: boolean;
      accommodationIsOk: boolean;
      confirmations: Array<{
        _id: string;
        confirmedOn?: Date | null;
        deleted?: boolean | null;
        offerId?: string | null;
        weeks: Array<Date>;
        source: string;
        taxationId?: string | null;
        documents: Array<{
          DocumentType?: string | null;
          ThumbURL: string;
          PdfURL: string;
          FileRef: {
            MimeType: string;
            Name?: string | null;
            NodeID: string;
            NodeType: NodeType;
            Size: number;
          };
        }>;
        accommodationRef?: { Name?: string | null; NodeID: string } | null;
        confirmedBy?: { Name: string; PersonId: string } | null;
      }>;
      accommodationRequest: Array<{
        _id: string;
        createdById?: string | null;
        createdByName?: string | null;
        createdOn?: Date | null;
      }>;
    };
    travel: {
      travelIsOk: boolean;
      travelRequested: boolean;
      travelRequest: Array<{
        _id: string;
        createdById?: string | null;
        createdByName?: string | null;
        createdOn?: Date | null;
      }>;
      confirmations: Array<{
        _id: string;
        confirmedOn?: Date | null;
        deleted?: boolean | null;
        weeks: Array<Date>;
        confirmedBy?: { Name: string; PersonId: string } | null;
        documents: Array<{
          DocumentType?: string | null;
          ThumbURL: string;
          PdfURL: string;
          FileRef: {
            MimeType: string;
            Name?: string | null;
            NodeID: string;
            NodeType: NodeType;
            Size: number;
          };
        }>;
      }>;
    };
  };
};

export type AccommodationRequestGetQueryVariables = Exact<{
  requestId: Scalars["ObjectId"];
}>;

export type AccommodationRequestGetQuery = {
  accommodationRequestById: {
    _id: string;
    accommodationType?: Array<string | null> | null;
    additionalInfo?: string | null;
    budget?: string | null;
    budgetPeriod?: AccommodationPriceType | null;
    carAccess?: string | null;
    hasOwnCar?: boolean | null;
    hasCarAccess?: boolean | null;
    sharedConveniences?: string | null;
    city?: string | null;
    country?: string | null;
    customerAddress?: string | null;
    deadline?: Date | null;
    paidBy?: HospitalityPaidBy | null;
    accommodationSuggestion?: AccommodationTypeOf | null;
    periodInput?: string | null;
    createdById?: string | null;
    createdByName?: string | null;
    createdOn?: Date | null;
    shouldBeBookedDirectly?: string | null;
    walkingDistance?: string | null;
    accommodationPreferences?: string | null;
    zzNumber?: string | null;
    bookingGroup?: string | null;
    sharedKitchen?: boolean | null;
    sharedBathroom?: boolean | null;
    ticketDifficultyLevel?: TicketDifficultyLevel | null;
    differentCity?: boolean | null;
    specifyCity?: string | null;
    acceptedOveragePercent?: string | null;
    maxAllowedPerNight?: string | null;
    hasAccommodationSuggestion?: boolean | null;
    staffAccommodation?: string | null;
    accommodationLink?: string | null;
    bookingInformation?: string | null;
    parkingMaxPrice?: string | null;
    commentAboutBooking?: string | null;
    consultantId?: string | null;
    costCenterId?: string | null;
    projectId?: string | null;
    isProlongation?: boolean | null;
    isReschedule?: boolean | null;
    rescheduleComment?: string | null;
    periods?: Array<{ start?: Date | null; end?: Date | null } | null> | null;
    bookingConfirmationFile?: {
      _id: string;
      type: CrmDocumentType;
      name: string;
      documentType?: string | null;
      mimeType: string;
      size: number;
      pdfUrl: string;
      thumbUrl: string;
    } | null;
  };
};

export type RemoveAccommodationDocumentMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
}>;

export type RemoveAccommodationDocumentMutation = {
  removeAccommodationDocument?: boolean | null;
};

export type RemoveTravelDocumentMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
}>;

export type RemoveTravelDocumentMutation = { removeTravelDocument?: boolean | null };

export type CreateTravelRequestMutationVariables = Exact<{
  bookingGroupId?: InputMaybe<Scalars["ObjectId"]>;
  input: TravelRequestInput;
  bookingIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type CreateTravelRequestMutation = { createTravelRequest: { _id: string } };

export type ToggleAccommodationConfirmationMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
}>;

export type ToggleAccommodationConfirmationMutation = {
  toggleAccommodationConfirmation?: {
    _id: string;
    accommodation: {
      accommodationRequested: boolean;
      accommodationIsOk: boolean;
      accommodationRequest: Array<{
        _id: string;
        createdById?: string | null;
        createdByName?: string | null;
        createdOn?: Date | null;
      }>;
      confirmations: Array<{
        _id: string;
        confirmedOn?: Date | null;
        deleted?: boolean | null;
        offerId?: string | null;
        weeks: Array<Date>;
        source: string;
        taxationId?: string | null;
        accommodationRef?: { Name?: string | null; NodeID: string } | null;
        confirmedBy?: { Name: string; PersonId: string } | null;
      }>;
    };
    travel: {
      travelIsOk: boolean;
      travelRequested: boolean;
      travelRequest: Array<{
        _id: string;
        createdById?: string | null;
        createdByName?: string | null;
        createdOn?: Date | null;
      }>;
      confirmations: Array<{
        _id: string;
        confirmedOn?: Date | null;
        deleted?: boolean | null;
        weeks: Array<Date>;
        confirmedBy?: { Name: string; PersonId: string } | null;
        documents: Array<{
          DocumentType?: string | null;
          ThumbURL: string;
          PdfURL: string;
          FileRef: {
            MimeType: string;
            Name?: string | null;
            NodeID: string;
            NodeType: NodeType;
            Size: number;
          };
        }>;
      }>;
    };
  } | null;
};

export type ToggleTravelConfirmationMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
}>;

export type ToggleTravelConfirmationMutation = {
  toggleTravelConfirmation?: {
    _id: string;
    accommodation: {
      accommodationRequested: boolean;
      accommodationIsOk: boolean;
      accommodationRequest: Array<{
        _id: string;
        createdById?: string | null;
        createdByName?: string | null;
        createdOn?: Date | null;
      }>;
      confirmations: Array<{
        _id: string;
        confirmedOn?: Date | null;
        deleted?: boolean | null;
        offerId?: string | null;
        weeks: Array<Date>;
        source: string;
        taxationId?: string | null;
        accommodationRef?: { Name?: string | null; NodeID: string } | null;
        confirmedBy?: { Name: string; PersonId: string } | null;
      }>;
    };
    travel: {
      travelIsOk: boolean;
      travelRequested: boolean;
      travelRequest: Array<{
        _id: string;
        createdById?: string | null;
        createdByName?: string | null;
        createdOn?: Date | null;
      }>;
      confirmations: Array<{
        _id: string;
        confirmedOn?: Date | null;
        deleted?: boolean | null;
        weeks: Array<Date>;
        confirmedBy?: { Name: string; PersonId: string } | null;
        documents: Array<{
          DocumentType?: string | null;
          ThumbURL: string;
          PdfURL: string;
          FileRef: {
            MimeType: string;
            Name?: string | null;
            NodeID: string;
            NodeType: NodeType;
            Size: number;
          };
        }>;
      }>;
    };
  } | null;
};

export type GetTravelConfirmationByIdQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
}>;

export type GetTravelConfirmationByIdQuery = {
  bookingById?: {
    _id: string;
    AreaOfExpertise: string;
    CustomerNumber: string;
    Week: Date;
    callNumber: string;
    erpExportUnitRef?: string | null;
    BookingGroup: {
      _id: string;
      externalId?: string | null;
      bookings: Array<{
        _id: string;
        Week: Date;
        isOpen: boolean;
        IsConsultantPayed: boolean;
      }>;
      hospital: {
        _id: string;
        AreasOfExpertise: Array<string>;
        RecruitingPortalType?: RecruitingPortalType | null;
        Specializations: Array<string>;
        Name?: string | null;
        Address?: { Region: string } | null;
        Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      };
      department?: { _id: string; Name?: string | null } | null;
    };
    Consultant?: {
      LegalPersonType?: LegalPersonType | null;
      _id: string;
      Name?: string | null;
    } | null;
  } | null;
  travelConfirmationById: {
    _id: string;
    weeks: Array<Date>;
    totalCost?: number | null;
    totalExVAT?: boolean | null;
    confirmedOn?: Date | null;
    allWeeks: Array<{
      cost: number;
      description?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      isTravel: boolean;
      note?: string | null;
      weekYear: { Week: number; Year: number };
    }>;
    documents: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
    confirmedBy?: { Name: string; PersonId: string } | null;
  };
};

export type GetTravelConfirmationPageDataQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type GetTravelConfirmationPageDataQuery = {
  bookingById?: {
    _id: string;
    AreaOfExpertise: string;
    CustomerNumber: string;
    Week: Date;
    callNumber: string;
    erpExportUnitRef?: string | null;
    BookingGroup: {
      _id: string;
      externalId?: string | null;
      bookings: Array<{
        _id: string;
        Week: Date;
        isOpen: boolean;
        IsConsultantPayed: boolean;
      }>;
      hospital: {
        _id: string;
        AreasOfExpertise: Array<string>;
        RecruitingPortalType?: RecruitingPortalType | null;
        Specializations: Array<string>;
        Name?: string | null;
        Address?: { Region: string } | null;
        Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      };
      department?: { _id: string; Name?: string | null } | null;
    };
    Consultant?: {
      LegalPersonType?: LegalPersonType | null;
      _id: string;
      Name?: string | null;
    } | null;
  } | null;
};

export type ConfimTravelMutationVariables = Exact<{
  input: ConfirmTravelInput;
}>;

export type ConfimTravelMutation = { confirmTravel: { _id: string } };

export type UpdateTravelConfirmationMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: ConfirmTravelInput;
}>;

export type UpdateTravelConfirmationMutation = {
  updateTravelConfirmation?: boolean | null;
};

export type FullTravelRequestFragment = {
  _id: string;
  bookingGroup?: string | null;
  deadline?: Date | null;
  isCancelable?: boolean | null;
  isFlexible?: boolean | null;
  ticketDifficultyLevel?: TicketDifficultyLevel | null;
  luggage?: string | null;
  luggageType?: LuggageType | null;
  createdOn?: Date | null;
  createdByName?: string | null;
  createdById?: string | null;
  transportationType?: string | null;
  travelSuggestion?: string | null;
  travelPreferences?: string | null;
  consultantId?: string | null;
  costCenterId?: string | null;
  projectId?: string | null;
  isReschedule?: boolean | null;
  rescheduleComment?: string | null;
  rides: Array<{
    rideType?: RideType | null;
    transportationType?: Array<string | null> | null;
    dir1?: {
      country?: string | null;
      city?: string | null;
      comment?: string | null;
      date?: Date | null;
      time?: TravelRequestTime | null;
    } | null;
    dir2?: {
      country?: string | null;
      city?: string | null;
      comment?: string | null;
      date?: Date | null;
      time?: TravelRequestTime | null;
    } | null;
  }>;
};

export type GetTravelRequestQueryVariables = Exact<{
  requestId: Scalars["ObjectId"];
}>;

export type GetTravelRequestQuery = {
  travelRequestById: {
    _id: string;
    bookingGroup?: string | null;
    deadline?: Date | null;
    isCancelable?: boolean | null;
    isFlexible?: boolean | null;
    ticketDifficultyLevel?: TicketDifficultyLevel | null;
    luggage?: string | null;
    luggageType?: LuggageType | null;
    createdOn?: Date | null;
    createdByName?: string | null;
    createdById?: string | null;
    transportationType?: string | null;
    travelSuggestion?: string | null;
    travelPreferences?: string | null;
    consultantId?: string | null;
    costCenterId?: string | null;
    projectId?: string | null;
    isReschedule?: boolean | null;
    rescheduleComment?: string | null;
    rides: Array<{
      rideType?: RideType | null;
      transportationType?: Array<string | null> | null;
      dir1?: {
        country?: string | null;
        city?: string | null;
        comment?: string | null;
        date?: Date | null;
        time?: TravelRequestTime | null;
      } | null;
      dir2?: {
        country?: string | null;
        city?: string | null;
        comment?: string | null;
        date?: Date | null;
        time?: TravelRequestTime | null;
      } | null;
    }>;
  };
};

export type TravelRequestBookingGroupDataFragment = {
  _id: string;
  bookings: Array<{ _id: string; Week: Date; CostCenter?: { Id: string } | null }>;
  consultant?: { _id: string; Name?: string | null; TravelPreferences: string } | null;
};

export type TravelRequest_GetBookingGroupQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type TravelRequest_GetBookingGroupQuery = {
  getBookingGroup?: {
    _id: string;
    bookings: Array<{ _id: string; Week: Date; CostCenter?: { Id: string } | null }>;
    consultant?: { _id: string; Name?: string | null; TravelPreferences: string } | null;
  } | null;
};

export type GetInvoiceQueryVariables = Exact<{
  provider: InvoiceProvider;
  number: Scalars["String"];
}>;

export type GetInvoiceQuery = {
  invoiceByNumber?: {
    _id: string;
    CustomerName?: string | null;
    CustomerNumber?: string | null;
    InvoiceNumber: string;
    Provider: InvoiceProvider;
    TotalGross?: number | null;
    TotalNet?: number | null;
    InvoiceDate?: Date | null;
    DueDate?: Date | null;
    Notes?: string | null;
    IsCredit: boolean;
    PreviewUrl: string;
  } | null;
};

export type BookingInvoicingAssignBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  isGroupInvoicing: Scalars["Boolean"];
}>;

export type BookingInvoicingAssignBookingMutation = {
  assignFortnoxInvoiceToBooking: {
    Booking?: {
      _id: string;
      Week: Date;
      AdditionalWork: boolean;
      AdditionalWorkNote: string;
      AreaOfExpertise: string;
      ContractType?: ContractType | null;
      IsConsultantPayed: boolean;
      IsCustomerBilled: boolean;
      isSickPayed: boolean;
      timeReportHasSickTime?: boolean | null;
      Note: string;
      PatientId: string;
      GroupInvoicing: boolean;
      GroupInvoiceTotal?: number | null;
      CustomerFine: number;
      AdministrativeFee: number;
      unlockForms: boolean;
      Project?: {
        _id: string;
        ProjectNumber: string;
        Members: Array<{ PersonId: string }>;
      } | null;
      BookingGroup: {
        _id: string;
        isNationalProcurement?: boolean | null;
        hospital: {
          _id: string;
          Name?: string | null;
          billingInstructions?: string | null;
        };
        department?: { _id: string; Name?: string | null } | null;
        bookings: Array<{ _id: string; Week: Date }>;
      };
      Invoices: Array<{
        invoiceNumber: string;
        invoice?: {
          TotalGross?: number | null;
          _id: string;
          CustomerName?: string | null;
          CustomerNumber?: string | null;
          InvoiceNumber: string;
          Provider: InvoiceProvider;
          TotalNet?: number | null;
          InvoiceDate?: Date | null;
          DueDate?: Date | null;
          Notes?: string | null;
          IsCredit: boolean;
          PreviewUrl: string;
        } | null;
      } | null>;
      CostCenter?: {
        Id: string;
        Organisation?: string | null;
        Name?: string | null;
      } | null;
      SubcontractorDocuments: Array<{
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      }>;
      ConsultantSnapshot: {
        LegalPersonType?: LegalPersonType | null;
        BusinessName?: string | null;
        BusinessSocialSecurityNo?: string | null;
      };
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BusinessName?: string | null;
        BusinessSocialSecurityNo?: string | null;
        FirstName?: string | null;
        LastName?: string | null;
        SubcontractorInfo?: { Name: string } | null;
        contactType?: {
          accountNumber?: string | null;
          clearingNumber?: string | null;
          rate?: string | null;
        } | null;
      } | null;
      costs?: {
        employeeSalary: number;
        invoiceTotal: number;
        sickPayTotal: number;
        accommodation: number;
        travel: number;
      } | null;
    } | null;
  };
};

export type PublishSubcontractorInvoiceMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type PublishSubcontractorInvoiceMutation = {
  publishSubcontractorInvoiceWorkflow: {
    _id?: string | null;
    workflowId: string;
    status: WorkflowStatus;
    errorMessage?: string | null;
    metadata?: any | null;
  };
};

export type PublishPayFormRecordsToFortnoxMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  weekDay?: InputMaybe<Scalars["Int"]>;
}>;

export type PublishPayFormRecordsToFortnoxMutation = {
  publishPayFormRecordsToFortnox: {
    _id?: string | null;
    workflowId: string;
    status: WorkflowStatus;
    errorMessage?: string | null;
    metadata?: any | null;
  };
};

export type PublishSickPayFormToFortnoxMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  weekDay?: InputMaybe<Scalars["Int"]>;
}>;

export type PublishSickPayFormToFortnoxMutation = {
  publishSickPayFormToFortnox: {
    _id?: string | null;
    workflowId: string;
    status: WorkflowStatus;
    errorMessage?: string | null;
    metadata?: any | null;
  };
};

export type CheckFortnoxSalaryForWeekQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type CheckFortnoxSalaryForWeekQuery = {
  checkFortnoxSalaryForWeek?: { employeeId: string; takenWeekDays: Array<number> } | null;
};

export type GetPublishSubcontractorInvoiceStatusQueryVariables = Exact<{
  workflowId: Scalars["String"];
}>;

export type GetPublishSubcontractorInvoiceStatusQuery = {
  workflowRunByWorkflowId?: {
    _id?: string | null;
    status: WorkflowStatus;
    errorMessage?: string | null;
    metadata?: any | null;
  } | null;
};

export type BookingInvoicingBookingFragment = {
  _id: string;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  unlockForms: boolean;
  additionalPayoutAmount?: number | null;
  additionalPayoutDescription?: string | null;
  bookingKits: Array<{
    type?: BookingKitType | null;
    withConsultantInvoice?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    isRejected: boolean;
  }>;
};

export type BookingInvoicing_FetchQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingInvoicing_FetchQuery = {
  bookingById?: {
    _id: string;
    IsConsultantPayed: boolean;
    IsCustomerBilled: boolean;
    unlockForms: boolean;
    additionalPayoutAmount?: number | null;
    additionalPayoutDescription?: string | null;
    bookingKits: Array<{
      type?: BookingKitType | null;
      withConsultantInvoice?: boolean | null;
      withCustomerInvoice?: boolean | null;
      withSickPay?: boolean | null;
      withSubcontractorPay?: boolean | null;
      isRejected: boolean;
    }>;
  } | null;
};

export type SetBookingAdditionalPayoutMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  amount?: InputMaybe<Scalars["Float"]>;
  description?: InputMaybe<Scalars["String"]>;
}>;

export type SetBookingAdditionalPayoutMutation = {
  setBookingAdditionalPayout: {
    _id: string;
    IsConsultantPayed: boolean;
    IsCustomerBilled: boolean;
    unlockForms: boolean;
    additionalPayoutAmount?: number | null;
    additionalPayoutDescription?: string | null;
    bookingKits: Array<{
      type?: BookingKitType | null;
      withConsultantInvoice?: boolean | null;
      withCustomerInvoice?: boolean | null;
      withSickPay?: boolean | null;
      withSubcontractorPay?: boolean | null;
      isRejected: boolean;
    }>;
  };
};

export type GetBookingFilesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetBookingFilesQuery = {
  bookingById?: {
    _id: string;
    attachments?: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        MimeType: string;
        Size: number;
      };
    }> | null;
  } | null;
};

export type UploadBookingDocMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  file: Scalars["Upload"];
  documentType: BookingWeekDocumentTypes;
}>;

export type UploadBookingDocMutation = {
  uploadBookingDocument: {
    fileRef: {
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      MimeType: string;
      Size: number;
    };
  };
};

export type DeleteBookingDocMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
}>;

export type DeleteBookingDocMutation = { deleteBookingDocument: boolean };

export type BookingGroupSectionFragment = {
  _id: string;
  bookings: Array<{ _id: string; Week: Date }>;
};

export type GetBookingGroupSectionQueryVariables = Exact<{
  bookingGroupId: Scalars["ObjectId"];
}>;

export type GetBookingGroupSectionQuery = {
  getBookingGroup?: { _id: string; bookings: Array<{ _id: string; Week: Date }> } | null;
};

export type BookingProfileFragment = {
  _id: string;
  timeReportStatus?: TimeReportStatus | null;
  callNumber: string;
  CustomerNumber: string;
  CustomerFine: number;
  IsCanceled: boolean;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  unlockForms: boolean;
  createdOn?: Date | null;
  updatedOn?: Date | null;
  deletedOn?: Date | null;
  isFirstWeek?: boolean | null;
  duplicateIds?: Array<string | null> | null;
  Week: Date;
  AdditionalWork: boolean;
  AdditionalWorkNote: string;
  AreaOfExpertise: string;
  ContractType?: ContractType | null;
  isSickPayed: boolean;
  timeReportHasSickTime?: boolean | null;
  Note: string;
  PatientId: string;
  GroupInvoicing: boolean;
  GroupInvoiceTotal?: number | null;
  AdministrativeFee: number;
  bookingSupportTagComment?: string | null;
  erpExportUnitRef?: string | null;
  bookingKits: Array<{ _id?: string | null }>;
  rejectedBookingKits: Array<{ _id?: string | null }>;
  bookingStatus: { status: BookingStatusType };
  BookingGroup: {
    _id: string;
    hasOpenBookings: boolean;
    isNationalProcurement?: boolean | null;
    nationalProcurementTravelRequired?: boolean | null;
    travelTemplateLevel?: string | null;
    externalId?: string | null;
    hospital: {
      _id: string;
      Name?: string | null;
      billingInstructions?: string | null;
      AreasOfExpertise: Array<string>;
      RecruitingPortalType?: RecruitingPortalType | null;
      Specializations: Array<string>;
      Address?: { Region: string } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    };
    bookings: Array<{ _id: string; Week: Date }>;
    department?: { _id: string; Name?: string | null } | null;
  };
  Invoices: Array<{
    invoiceNumber: string;
    invoice?: {
      TotalGross?: number | null;
      _id: string;
      CustomerName?: string | null;
      CustomerNumber?: string | null;
      InvoiceNumber: string;
      Provider: InvoiceProvider;
      TotalNet?: number | null;
      InvoiceDate?: Date | null;
      DueDate?: Date | null;
      Notes?: string | null;
      IsCredit: boolean;
      PreviewUrl: string;
    } | null;
  } | null>;
  Project?: {
    _id: string;
    ProjectNumber: string;
    Comment: string;
    Description: string;
    Name: string;
    Status?: ProjectStatus | null;
    Members: Array<{ PersonId: string; Name: string }>;
    Admin?: { Name: string; PersonId: string } | null;
    Owner?: { Name: string; PersonId: string } | null;
  } | null;
  ConsultantSnapshot: {
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
  };
  SubcontractorDocuments: Array<{
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  }>;
  createdBy?: { _id: string; Name: string } | null;
  updatedBy?: { _id: string; Name: string } | null;
  deletedBy?: { _id: string; Name: string } | null;
  Consultant?: {
    care: string;
    _id: string;
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    Name?: string | null;
    SubcontractorInfo?: { Name: string } | null;
    contactType?: {
      accountNumber?: string | null;
      clearingNumber?: string | null;
      rate?: string | null;
    } | null;
  } | null;
  customersWithNoApproval?: {
    needSignature: Array<{ Id: string; Name: string; Type: CustomerType }>;
    needSignatureTROkInApp: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApproval: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApprovalMonthly: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApprovalShortening: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApprovalSpecial: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
  bookingIntro?: {
    description?: string | null;
    endDate?: Date | null;
    startDate?: Date | null;
    required?: boolean | null;
  } | null;
  CostCenter?: { Id: string; Organisation?: string | null; Name?: string | null } | null;
  costs?: {
    employeeSalary: number;
    invoiceTotal: number;
    sickPayTotal: number;
    accommodation: number;
    travel: number;
  } | null;
  bookingSupportTagStatus?: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }> | null;
};

export type BookingSupportTagStatusFragment = {
  tag?: string | null;
  setOn?: Date | null;
  setBy?: { Name: string } | null;
};

export type BookingTagsFragment = {
  bookingTags: Array<{
    code: string;
    label?: string | null;
    color: string;
    booking: boolean;
    bookingKit: boolean;
  }>;
};

export type BookingProfile_GetTagsQueryVariables = Exact<{ [key: string]: never }>;

export type BookingProfile_GetTagsQuery = {
  config: {
    bookingTags: Array<{
      code: string;
      label?: string | null;
      color: string;
      booking: boolean;
      bookingKit: boolean;
    }>;
  };
};

export type BookingProfile_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingProfile_GetQuery = {
  bookingById?: {
    _id: string;
    timeReportStatus?: TimeReportStatus | null;
    callNumber: string;
    CustomerNumber: string;
    CustomerFine: number;
    IsCanceled: boolean;
    IsConsultantPayed: boolean;
    IsCustomerBilled: boolean;
    unlockForms: boolean;
    createdOn?: Date | null;
    updatedOn?: Date | null;
    deletedOn?: Date | null;
    isFirstWeek?: boolean | null;
    duplicateIds?: Array<string | null> | null;
    Week: Date;
    AdditionalWork: boolean;
    AdditionalWorkNote: string;
    AreaOfExpertise: string;
    ContractType?: ContractType | null;
    isSickPayed: boolean;
    timeReportHasSickTime?: boolean | null;
    Note: string;
    PatientId: string;
    GroupInvoicing: boolean;
    GroupInvoiceTotal?: number | null;
    AdministrativeFee: number;
    bookingSupportTagComment?: string | null;
    erpExportUnitRef?: string | null;
    bookingKits: Array<{ _id?: string | null }>;
    rejectedBookingKits: Array<{ _id?: string | null }>;
    bookingStatus: { status: BookingStatusType };
    BookingGroup: {
      _id: string;
      hasOpenBookings: boolean;
      isNationalProcurement?: boolean | null;
      nationalProcurementTravelRequired?: boolean | null;
      travelTemplateLevel?: string | null;
      externalId?: string | null;
      hospital: {
        _id: string;
        Name?: string | null;
        billingInstructions?: string | null;
        AreasOfExpertise: Array<string>;
        RecruitingPortalType?: RecruitingPortalType | null;
        Specializations: Array<string>;
        Address?: { Region: string } | null;
        Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      };
      bookings: Array<{ _id: string; Week: Date }>;
      department?: { _id: string; Name?: string | null } | null;
    };
    Invoices: Array<{
      invoiceNumber: string;
      invoice?: {
        TotalGross?: number | null;
        _id: string;
        CustomerName?: string | null;
        CustomerNumber?: string | null;
        InvoiceNumber: string;
        Provider: InvoiceProvider;
        TotalNet?: number | null;
        InvoiceDate?: Date | null;
        DueDate?: Date | null;
        Notes?: string | null;
        IsCredit: boolean;
        PreviewUrl: string;
      } | null;
    } | null>;
    Project?: {
      _id: string;
      ProjectNumber: string;
      Comment: string;
      Description: string;
      Name: string;
      Status?: ProjectStatus | null;
      Members: Array<{ PersonId: string; Name: string }>;
      Admin?: { Name: string; PersonId: string } | null;
      Owner?: { Name: string; PersonId: string } | null;
    } | null;
    ConsultantSnapshot: {
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
    };
    SubcontractorDocuments: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
    createdBy?: { _id: string; Name: string } | null;
    updatedBy?: { _id: string; Name: string } | null;
    deletedBy?: { _id: string; Name: string } | null;
    Consultant?: {
      care: string;
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
      FirstName?: string | null;
      LastName?: string | null;
      Name?: string | null;
      SubcontractorInfo?: { Name: string } | null;
      contactType?: {
        accountNumber?: string | null;
        clearingNumber?: string | null;
        rate?: string | null;
      } | null;
    } | null;
    customersWithNoApproval?: {
      needSignature: Array<{ Id: string; Name: string; Type: CustomerType }>;
      needSignatureTROkInApp: Array<{ Id: string; Name: string; Type: CustomerType }>;
      noApproval: Array<{ Id: string; Name: string; Type: CustomerType }>;
      noApprovalMonthly: Array<{ Id: string; Name: string; Type: CustomerType }>;
      noApprovalShortening: Array<{ Id: string; Name: string; Type: CustomerType }>;
      noApprovalSpecial: Array<{ Id: string; Name: string; Type: CustomerType }>;
    } | null;
    bookingIntro?: {
      description?: string | null;
      endDate?: Date | null;
      startDate?: Date | null;
      required?: boolean | null;
    } | null;
    CostCenter?: {
      Id: string;
      Organisation?: string | null;
      Name?: string | null;
    } | null;
    costs?: {
      employeeSalary: number;
      invoiceTotal: number;
      sickPayTotal: number;
      accommodation: number;
      travel: number;
    } | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  } | null;
};

export type BookingProfile_GetContactsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingProfile_GetContactsQuery = {
  getBookingCustomerContacts: Array<{
    _id?: string | null;
    AvatarPic?: string | null;
    Name?: string | null;
    Email?: string | null;
    EmailValid: boolean;
    Phone?: string | null;
    PhoneValid: boolean;
    CellPhone?: string | null;
    CellPhoneValid: boolean;
    Title: string;
    Roles: Array<string>;
    ResponsiblePerson?: { Name: string; PersonId: string } | null;
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
    } | null> | null;
  }>;
};

export type BookingProfile_GetTimereportEmailQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingProfile_GetTimereportEmailQuery = {
  getTimereportToCustomerEmail: { Body: string; Subject: string };
};

export type BookingProfile_GetContractQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingProfile_GetContractQuery = { bookingById?: { _id: string } | null };

export type BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  workflowType?: InputMaybe<Scalars["String"]>;
}>;

export type BookingProfile_GetLastCreateBookingKitWfStatusQuery = {
  getLastWorkflowRun?: {
    status: WorkflowStatus;
    startedAt?: Date | null;
    scheduledAt: Date;
    completedAt?: Date | null;
    result?: any | null;
  } | null;
};

export type BookingProfile_GetCreateBookingKitWfStatusesQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  workflowType?: InputMaybe<Scalars["String"]>;
}>;

export type BookingProfile_GetCreateBookingKitWfStatusesQuery = {
  getWorkflowRuns: Array<{
    status: WorkflowStatus;
    startedAt?: Date | null;
    scheduledAt: Date;
    completedAt?: Date | null;
    result?: any | null;
    steps: Array<{
      _id: string;
      title: string;
      description?: string | null;
      startedAt?: Date | null;
      completedAt?: Date | null;
      failedAt?: Date | null;
    }>;
  }>;
};

export type BookingProject_GetQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingProject_GetQuery = {
  bookingById?: {
    _id: string;
    Project?: {
      _id: string;
      Comment: string;
      Description: string;
      Name: string;
      ProjectNumber: string;
      Status?: ProjectStatus | null;
      Admin?: { Name: string; PersonId: string } | null;
      Owner?: { Name: string; PersonId: string } | null;
      Members: Array<{ Name: string; PersonId: string }>;
    } | null;
    CostCenter?: { Id: string; Name?: string | null } | null;
  } | null;
};

export type UpdateBookingProjectMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  projectId: Scalars["ObjectId"];
}>;

export type UpdateBookingProjectMutation = {
  updateBookingProject: {
    Booking?: {
      _id: string;
      Project?: {
        _id: string;
        Comment: string;
        Description: string;
        Name: string;
        ProjectNumber: string;
        Status?: ProjectStatus | null;
        Admin?: { Name: string; PersonId: string } | null;
        Owner?: { Name: string; PersonId: string } | null;
        Members: Array<{ Name: string; PersonId: string }>;
      } | null;
    } | null;
  };
};

export type BookingSupportTagFormDataFragment = {
  _id: string;
  bookingSupportTagComment?: string | null;
  bookingSupportTagStatus?: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }> | null;
};

export type SetSupportTagToBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  tags: Array<Scalars["String"]> | Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
}>;

export type SetSupportTagToBookingMutation = {
  setSupportTagToBooking: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }>;
};

export type UpdateBookingKitTagsMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  tags: Array<Scalars["String"]> | Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateBookingKitTagsMutation = {
  updateBookingKitTags: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }>;
};

export type TimeReportKit_GetInfoQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  consultantId: Scalars["ObjectId"];
}>;

export type TimeReportKit_GetInfoQuery = {
  bookingById?: { _id: string; AreaOfExpertise: string } | null;
  bookingKitDraft: {
    timereportTemplateType?: TimeReportTemplateType | null;
    costCenterId?: string | null;
    documents: Array<{
      _id: string;
      type: CrmDocumentType;
      name: string;
      documentType?: string | null;
      mimeType: string;
      size: number;
      pdfUrl: string;
      thumbUrl: string;
    }>;
  };
  contact?: {
    _id: string;
    LegalPersonType?: LegalPersonType | null;
    ResponsiblePerson?: { Name: string; PersonId: string } | null;
  } | null;
};

export type TimeReportKit_GetManagerOfResponsibleUserQueryVariables = Exact<{
  userId: Scalars["ObjectId"];
}>;

export type TimeReportKit_GetManagerOfResponsibleUserQuery = {
  userById?: { ManagerId?: string | null } | null;
};

export type BookingKitProfileFragment = {
  _id?: string | null;
  createdOn: Date;
  timeReportType?: TimeReportTemplateType | null;
  name?: string | null;
  type?: BookingKitType | null;
  comments?: Array<string> | null;
  withTimeReport?: boolean | null;
  withCustomerInvoice?: boolean | null;
  withConsultantInvoice?: boolean | null;
  withSickPay?: boolean | null;
  withSubcontractorPay?: boolean | null;
  bookingSupportCheckWasValid?: boolean | null;
  status?: BookingKitStatusType | null;
  bookingSupportTagComment: string;
  responsible?: { _id: string; Name: string } | null;
  manager?: { _id: string; Name: string } | null;
  receipts?: Array<{ uri: string; name: string }> | null;
  documents: Array<{
    _id: string;
    documentType?: string | null;
    name: string;
    pdfUrl: string;
  }>;
  statuses?: Array<{
    setOn?: Date | null;
    status?: BookingKitStatusType | null;
    setBy?: { PersonId: string; Name: string } | null;
  }> | null;
  bookingSupportTagStatus?: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }> | null;
};

export type Booking_BookingKitSearchFragment = {
  _id?: string | null;
  name?: string | null;
  type: BookingKitType;
  lastStatusType?: BookingKitStatusType | null;
  createdOn: Date;
  lastStatusSetOn?: Date | null;
  lastStatusSetByUserName?: string | null;
};

export type TimeReportKit_GetKitQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type TimeReportKit_GetKitQuery = {
  bookingKits?: Array<{
    _id?: string | null;
    name?: string | null;
    type: BookingKitType;
    lastStatusType?: BookingKitStatusType | null;
    createdOn: Date;
    lastStatusSetOn?: Date | null;
    lastStatusSetByUserName?: string | null;
  }> | null;
};

export type TimeReportKit_CreateBookingKitMutationVariables = Exact<{
  input: CreateBookingKitInput;
}>;

export type TimeReportKit_CreateBookingKitMutation = {
  createBookingKit: {
    _id?: string | null;
    createdOn: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    status?: BookingKitStatusType | null;
    bookingSupportTagComment: string;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  };
};

export type TimeReportKit_UpdateBookingKitMutationVariables = Exact<{
  input: UpdateBookingKitInput;
}>;

export type TimeReportKit_UpdateBookingKitMutation = {
  updateBookingKit: {
    _id?: string | null;
    createdOn: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    status?: BookingKitStatusType | null;
    bookingSupportTagComment: string;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  };
};

export type TimeReportKit_DeleteBookingKitMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type TimeReportKit_DeleteBookingKitMutation = {
  deleteBookingKit?: boolean | null;
};

export type BookingKit_RunAutoCreateBookingKitMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingKit_RunAutoCreateBookingKitMutation = {
  runAutoCreateBookingKit: boolean;
};

export type BookingKitFormConfigFragment = {
  type: BookingKitType;
  isAvailableForCreation: boolean;
  requirements: {
    payForm: boolean;
    invoiceForm: boolean;
    timeReport: boolean;
    sickPayForm: boolean;
    hbaApproval: boolean;
    ocApproval: boolean;
  };
};

export type BookingKit_GetFormConfigQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingKit_GetFormConfigQuery = {
  bookingKitFormConfig?: Array<{
    type: BookingKitType;
    isAvailableForCreation: boolean;
    requirements: {
      payForm: boolean;
      invoiceForm: boolean;
      timeReport: boolean;
      sickPayForm: boolean;
      hbaApproval: boolean;
      ocApproval: boolean;
    };
  }> | null;
};

export type BookingKit_GetChecksQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingKit_GetChecksQuery = {
  getChecksForBooking: {
    requiredForm?: string | null;
    costCenter?: string | null;
    project?: string | null;
    customerNumber?: string | null;
    orderNumber?: string | null;
    customerContractId?: string | null;
    consultantContractId?: string | null;
    totalInvoice?: string | null;
    hours?: string | null;
    mileage?: string | null;
    expenses?: string | null;
    accommodationSum?: string | null;
    travelSum?: string | null;
    orderId?: string | null;
    attachTimeReport?: string | null;
    groupInvoicing?: string | null;
    contractNumber?: string | null;
  };
};

export type BookingKit_GetUserPermissionsQueryVariables = Exact<{
  userId: Scalars["ObjectId"];
}>;

export type BookingKit_GetUserPermissionsQuery = {
  userPermissions: Array<string>;
  userById?: { ManagerId?: string | null } | null;
};

export type BookingKit_GetUsersQueryVariables = Exact<{
  ids: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type BookingKit_GetUsersQuery = {
  users: Array<{ _id: string; Name: string; AvatarPic?: string | null }>;
};

export type TimeReport_SendToCustomerMutationVariables = Exact<{
  timeReportId: Scalars["ObjectId"];
  bookingId: Scalars["ObjectId"];
  emailInput: EmailInput;
  type: TimeReportTemplateType;
  fileName: Scalars["String"];
}>;

export type TimeReport_SendToCustomerMutation = {
  sendTimereportToCustomer?: { Subject: string } | null;
};

export type TimeReport_ClearDaysMutationVariables = Exact<{
  timeReportId: Scalars["ObjectId"];
}>;

export type TimeReport_ClearDaysMutation = { clearTimereportDays?: boolean | null };

export type BookingInfoForTimeReportFragment = {
  _id: string;
  AreaOfExpertise: string;
  hasKits?: boolean | null;
  Week: Date;
  monthBreakSide?: BookingMonthBreakSide | null;
  skipTimereportReminder: boolean;
  bookingSupportTagComment?: string | null;
  BookingGroup: {
    isNationalProcurement?: boolean | null;
    hospital: { _id: string; Name?: string | null };
    department?: { _id: string; Name?: string | null } | null;
  };
  Consultant?: {
    _id: string;
    FirstName?: string | null;
    LastName?: string | null;
  } | null;
  rejectedBookingKits: Array<{
    _id?: string | null;
    createdOn: Date;
    timeReportType?: TimeReportTemplateType | null;
    name?: string | null;
    type?: BookingKitType | null;
    comments?: Array<string> | null;
    withTimeReport?: boolean | null;
    withCustomerInvoice?: boolean | null;
    withConsultantInvoice?: boolean | null;
    withSickPay?: boolean | null;
    withSubcontractorPay?: boolean | null;
    bookingSupportCheckWasValid?: boolean | null;
    status?: BookingKitStatusType | null;
    bookingSupportTagComment: string;
    responsible?: { _id: string; Name: string } | null;
    manager?: { _id: string; Name: string } | null;
    receipts?: Array<{ uri: string; name: string }> | null;
    documents: Array<{
      _id: string;
      documentType?: string | null;
      name: string;
      pdfUrl: string;
    }>;
    statuses?: Array<{
      setOn?: Date | null;
      status?: BookingKitStatusType | null;
      setBy?: { PersonId: string; Name: string } | null;
    }> | null;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
  }>;
  bookingSupportTagStatus?: Array<{
    tag?: string | null;
    setOn?: Date | null;
    setBy?: { Name: string } | null;
  }> | null;
  bookingKits: Array<{ deleted: boolean }>;
};

export type SetSkipTimereportReminderMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
}>;

export type SetSkipTimereportReminderMutation = {
  setSkipTimereportReminder: { value?: boolean | null };
};

export type SendTimeReportToConsultantMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  timeReportTemplate?: InputMaybe<TimeReportTemplateType>;
}>;

export type SendTimeReportToConsultantMutation = {
  sendTimereportToConsultant?: string | null;
};

export type TimeReport_GetBookingInfoQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type TimeReport_GetBookingInfoQuery = {
  bookingInfo?: {
    _id: string;
    AreaOfExpertise: string;
    hasKits?: boolean | null;
    Week: Date;
    monthBreakSide?: BookingMonthBreakSide | null;
    skipTimereportReminder: boolean;
    bookingSupportTagComment?: string | null;
    BookingGroup: {
      isNationalProcurement?: boolean | null;
      hospital: { _id: string; Name?: string | null };
      department?: { _id: string; Name?: string | null } | null;
    };
    Consultant?: {
      _id: string;
      FirstName?: string | null;
      LastName?: string | null;
    } | null;
    rejectedBookingKits: Array<{
      _id?: string | null;
      createdOn: Date;
      timeReportType?: TimeReportTemplateType | null;
      name?: string | null;
      type?: BookingKitType | null;
      comments?: Array<string> | null;
      withTimeReport?: boolean | null;
      withCustomerInvoice?: boolean | null;
      withConsultantInvoice?: boolean | null;
      withSickPay?: boolean | null;
      withSubcontractorPay?: boolean | null;
      bookingSupportCheckWasValid?: boolean | null;
      status?: BookingKitStatusType | null;
      bookingSupportTagComment: string;
      responsible?: { _id: string; Name: string } | null;
      manager?: { _id: string; Name: string } | null;
      receipts?: Array<{ uri: string; name: string }> | null;
      documents: Array<{
        _id: string;
        documentType?: string | null;
        name: string;
        pdfUrl: string;
      }>;
      statuses?: Array<{
        setOn?: Date | null;
        status?: BookingKitStatusType | null;
        setBy?: { PersonId: string; Name: string } | null;
      }> | null;
      bookingSupportTagStatus?: Array<{
        tag?: string | null;
        setOn?: Date | null;
        setBy?: { Name: string } | null;
      }> | null;
    }>;
    bookingSupportTagStatus?: Array<{
      tag?: string | null;
      setOn?: Date | null;
      setBy?: { Name: string } | null;
    }> | null;
    bookingKits: Array<{ deleted: boolean }>;
  } | null;
};

export type GetTimereportTemplates_ByCustomerIdQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
}>;

export type GetTimereportTemplates_ByCustomerIdQuery = {
  customerById?: {
    _id: string;
    needSignatureTROkInApp: boolean;
    needSignature: boolean;
    noApproval: boolean;
    noApprovalMonthly: boolean;
    noApprovalSpecial: boolean;
    noApprovalShortening: boolean;
    timeReportTemplateSettings?: Array<{
      type: TimeReportTemplateType;
      professions: Array<string>;
    } | null> | null;
  } | null;
};

export type TimeReport_GetCustomerContactsQueryVariables = Exact<{
  depIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
  hospId?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type TimeReport_GetCustomerContactsQuery = {
  contacts: Array<{
    _id: string;
    Title?: string | null;
    Name?: string | null;
    Roles: Array<string>;
    Email?: string | null;
    AreasOfExpertise: Array<string | null>;
    BooksProfessions: Array<string>;
  }>;
};

export type Timereport_GetFreeTimereportsQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  week: Scalars["Int"];
  year: Scalars["Int"];
}>;

export type Timereport_GetFreeTimereportsQuery = {
  getFreeTimereports?: { freeTimereports: Array<any> } | null;
};

export type Timereport_GetStatusHistoryQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type Timereport_GetStatusHistoryQuery = {
  getTimereportStatusHistory?: { history: any } | null;
};

export type Timereport_GetSendFailuresQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type Timereport_GetSendFailuresQuery = {
  getTimereportSendFailures?: {
    partiallySent: boolean;
    failures: Array<{ recipient: string; failedOn: Date; reason?: string | null }>;
  } | null;
};

export type Timereport_GetByBookingIdQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type Timereport_GetByBookingIdQuery = {
  getTimereportByBookingId?: { timereport: any } | null;
};

export type Timereport_GetInvoiceStatusForBookingQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type Timereport_GetInvoiceStatusForBookingQuery = {
  getInvoiceStatusForBooking?: { invoicePaymentStatuses: any } | null;
};

export type Timereport_GetDetailsQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type Timereport_GetDetailsQuery = {
  timereport?: { data: any } | null;
  invoicePaymentStatuses?: { data: any } | null;
};

export type Timereport_AssignToBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  timeReportId: Scalars["ObjectId"];
}>;

export type Timereport_AssignToBookingMutation = {
  assignTimereportToBooking?: boolean | null;
};

export type Timereport_ApproveMutationVariables = Exact<{
  timereportId: Scalars["ObjectId"];
  approvedBy: Scalars["String"];
}>;

export type Timereport_ApproveMutation = { approveTimereport?: boolean | null };

export type Timereport_SetToSubmittedMutationVariables = Exact<{
  timereportId: Scalars["ObjectId"];
  submittedBy: Scalars["String"];
}>;

export type Timereport_SetToSubmittedMutation = {
  setTimereportToSubmitted?: boolean | null;
};

export type Timereport_SetToDraftMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  approvedBy: Scalars["String"];
  approvedId: Scalars["String"];
}>;

export type Timereport_SetToDraftMutation = {
  setTimereportToDraft?: { timereport: any } | null;
};

export type BookingCallNumberForm_GetCustomerQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type BookingCallNumberForm_GetCustomerQuery = {
  customerById?: { Parents: Array<{ Name: string }> } | null;
};

export type SetBookingCallNumberMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  callNumber: Scalars["String"];
}>;

export type SetBookingCallNumberMutation = { setBookingCallNumber?: boolean | null };

export type CancelBookingButtonsBookingQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type CancelBookingButtonsBookingQuery = {
  checkBookingCancellable?: Array<BookingCannotBeRemovedReason> | null;
  bookingById?: { _id: string; IsCustomerBilled: boolean; IsCanceled: boolean } | null;
};

export type CancelBookingButtonsGroupQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type CancelBookingButtonsGroupQuery = {
  checkBookingGroupCancellableByBookingId: {
    isCancellable: boolean;
    nonCancellableReason?: string | null;
  };
  bookingById?: { _id: string; BookingGroup: { _id: string } } | null;
};

export type CancelBookingMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  reason: Scalars["String"];
}>;

export type CancelBookingMutation = { cancelBooking?: boolean | null };

export type CancelBookingGroupMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  reason: Scalars["String"];
}>;

export type CancelBookingGroupMutation = { cancelBookingGroup?: boolean | null };

export type BookingAuditSearch_RecordFragment = {
  Approved?: boolean | null;
  SetOn?: Date | null;
  Comment?: string | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type BookingAuditSearchItemFragment = {
  _id: string;
  AreaOfExpertise: string;
  ProjectId?: string | null;
  projectName?: string | null;
  projectNumber?: string | null;
  Week: Date;
  isNationalProcurement?: boolean | null;
  BookingAudit?: {
    Approved?: boolean | null;
    SetOn?: Date | null;
    Comment?: string | null;
    SetBy?: { Name: string; PersonId: string } | null;
  } | null;
  BookingRef: { NodeID: string };
  ConsultantRef: { Name?: string | null; NodeID: string };
  DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  HospitalRef: { Id: string; Name: string; Type: CustomerType };
  OrganizationRef: { Name: string };
};

export type BookingAuditSearch_GetQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type BookingAuditSearch_GetQuery = {
  bookingWeeks: {
    skip: number;
    limit: number;
    total?: number | null;
    items: Array<{
      _id: string;
      AreaOfExpertise: string;
      ProjectId?: string | null;
      projectName?: string | null;
      projectNumber?: string | null;
      Week: Date;
      isNationalProcurement?: boolean | null;
      BookingAudit?: {
        Approved?: boolean | null;
        SetOn?: Date | null;
        Comment?: string | null;
        SetBy?: { Name: string; PersonId: string } | null;
      } | null;
      BookingRef: { NodeID: string };
      ConsultantRef: { Name?: string | null; NodeID: string };
      DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      HospitalRef: { Id: string; Name: string; Type: CustomerType };
      OrganizationRef: { Name: string };
    }>;
  };
};

export type BookingAuditSearch_SetApproveMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  approved: Scalars["Boolean"];
}>;

export type BookingAuditSearch_SetApproveMutation = {
  updateBookingAudit?: boolean | null;
};

export type BookingAuditSearch_SetCommentMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  comment: Scalars["String"];
}>;

export type BookingAuditSearch_SetCommentMutation = {
  updateCommentForBookingAudit?: boolean | null;
};

export type BookingFinanceSearchItemFragment = {
  _id: string;
  AreaOfExpertise: string;
  ConsultantServicePreferences?: string | null;
  Week: Date;
  CustomerNumber: string;
  ContractType?: ContractType | null;
  ContractTypeAbbr: string;
  CostCenterId?: string | null;
  CostCenterName?: string | null;
  IsCanceled: boolean;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  IsMarked: boolean;
  InvoiceNumbers?: Array<string | null> | null;
  ProjectId?: string | null;
  projectName?: string | null;
  projectNumber?: string | null;
  callNumber?: string | null;
  InvoiceTotalGrossFmt: string;
  InvoicedTotalFmt?: string | null;
  ProfitRatio?: number | null;
  ProfitNetFmt?: string | null;
  isNationalProcurement?: boolean | null;
  BookingRef: { NodeID: string };
  ConsultantRef: { Name?: string | null; NodeID: string };
  DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  HospitalRef: { Id: string; Name: string; Type: CustomerType };
  OrganizationRef: { Name: string };
  bookingStatus?: { status: BookingStatusType } | null;
};

export type BookingFinanceSearch_GetQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type BookingFinanceSearch_GetQuery = {
  bookingWeeks: {
    dbTime?: number | null;
    skip: number;
    limit: number;
    items: Array<{
      _id: string;
      AreaOfExpertise: string;
      ConsultantServicePreferences?: string | null;
      Week: Date;
      CustomerNumber: string;
      ContractType?: ContractType | null;
      ContractTypeAbbr: string;
      CostCenterId?: string | null;
      CostCenterName?: string | null;
      IsCanceled: boolean;
      IsConsultantPayed: boolean;
      IsCustomerBilled: boolean;
      IsMarked: boolean;
      InvoiceNumbers?: Array<string | null> | null;
      ProjectId?: string | null;
      projectName?: string | null;
      projectNumber?: string | null;
      callNumber?: string | null;
      InvoiceTotalGrossFmt: string;
      InvoicedTotalFmt?: string | null;
      ProfitRatio?: number | null;
      ProfitNetFmt?: string | null;
      isNationalProcurement?: boolean | null;
      BookingRef: { NodeID: string };
      ConsultantRef: { Name?: string | null; NodeID: string };
      DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      HospitalRef: { Id: string; Name: string; Type: CustomerType };
      OrganizationRef: { Name: string };
      bookingStatus?: { status: BookingStatusType } | null;
    }>;
  };
};

export type BookingFinanceSearch_GetTotalQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
}>;

export type BookingFinanceSearch_GetTotalQuery = {
  bookingWeeksTotal: { dbTime?: number | null; total: number };
};

export type BookingFinanceSearch_CSVQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
  type: BookingCSVReportType;
}>;

export type BookingFinanceSearch_CSVQuery = {
  bookingWeeksCSV: { URL: string; Filename: string };
};

export type BookingFinanceSearch_CSV_BgQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
  type: BookingCSVReportType;
}>;

export type BookingFinanceSearch_CSV_BgQuery = {
  bookingWeeksCSVBackground?: { result?: string | null } | null;
};

export type BookingScheduleSearchItemFragment = {
  _id: string;
  AreaOfExpertise: string;
  Week: Date;
  ContractType?: ContractType | null;
  ContractTypeAbbr: string;
  AccommodationOK: boolean;
  TravelOK: boolean;
  TimeReportStatus?: TimeReportStatus | null;
  ProjectId?: string | null;
  projectName?: string | null;
  projectNumber?: string | null;
  callNumber?: string | null;
  AccommodationStatus?: AccommodationTravelStatus | null;
  TravelStatus?: AccommodationTravelStatus | null;
  consultantContractId?: string | null;
  customerContractId?: string | null;
  requireTravelInvoicing?: boolean | null;
  isTravelInvoiced?: boolean | null;
  demandSource?: string | null;
  demandSourceUrl?: string | null;
  timeReportRowSources: Array<TimeReportRowSource>;
  BookingRef: { NodeID: string };
  ConsultantRef: { Name?: string | null; NodeID: string };
  DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  HospitalRef: { Id: string; Name: string; Type: CustomerType };
  OrganizationRef: { Name: string };
  AccommodationAudit?: {
    approved?: boolean | null;
    setOn?: Date | null;
    setBy?: { Name: string; PersonId: string } | null;
  } | null;
  TravelAudit?: {
    approved?: boolean | null;
    setOn?: Date | null;
    setBy?: { Name: string; PersonId: string } | null;
  } | null;
};

export type BookingScheduleSearch_GetQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type BookingScheduleSearch_GetQuery = {
  bookingWeeks: {
    skip: number;
    limit: number;
    items: Array<{
      _id: string;
      AreaOfExpertise: string;
      Week: Date;
      ContractType?: ContractType | null;
      ContractTypeAbbr: string;
      AccommodationOK: boolean;
      TravelOK: boolean;
      TimeReportStatus?: TimeReportStatus | null;
      ProjectId?: string | null;
      projectName?: string | null;
      projectNumber?: string | null;
      callNumber?: string | null;
      AccommodationStatus?: AccommodationTravelStatus | null;
      TravelStatus?: AccommodationTravelStatus | null;
      consultantContractId?: string | null;
      customerContractId?: string | null;
      requireTravelInvoicing?: boolean | null;
      isTravelInvoiced?: boolean | null;
      demandSource?: string | null;
      demandSourceUrl?: string | null;
      timeReportRowSources: Array<TimeReportRowSource>;
      BookingRef: { NodeID: string };
      ConsultantRef: { Name?: string | null; NodeID: string };
      DepartmentsRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      HospitalRef: { Id: string; Name: string; Type: CustomerType };
      OrganizationRef: { Name: string };
      AccommodationAudit?: {
        approved?: boolean | null;
        setOn?: Date | null;
        setBy?: { Name: string; PersonId: string } | null;
      } | null;
      TravelAudit?: {
        approved?: boolean | null;
        setOn?: Date | null;
        setBy?: { Name: string; PersonId: string } | null;
      } | null;
    }>;
  };
};

export type BookingScheduleSearch_GetTotalQueryVariables = Exact<{
  filter: BookingWeekQueryInput;
}>;

export type BookingScheduleSearch_GetTotalQuery = {
  bookingWeeksTotal: { dbTime?: number | null; total: number };
};

export type BookingSearch_CloneBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingSearch_CloneBookingMutation = { cloneBooking: string };

export type BookingSyncReportItemFragment = {
  ProjectName: string;
  Score: number;
  UserRef: { PersonId: string; Name: string };
};

export type BookingSyncReportFragment = {
  Total: number;
  Items: Array<{
    ProjectName: string;
    Score: number;
    UserRef: { PersonId: string; Name: string };
  }>;
  Groups: Array<{ Total: number; UserRef: { PersonId: string; Name: string } }>;
};

export type BookingSyncReport_GetQueryVariables = Exact<{
  input: BookingWeekQueryInput;
}>;

export type BookingSyncReport_GetQuery = {
  bookingSyncReport: {
    Total: number;
    Items: Array<{
      ProjectName: string;
      Score: number;
      UserRef: { PersonId: string; Name: string };
    }>;
    Groups: Array<{ Total: number; UserRef: { PersonId: string; Name: string } }>;
  };
};

export type CreateFortnoxVoucherMutationVariables = Exact<{
  provider: InvoiceProvider;
  description: Scalars["String"];
  date: Scalars["String"];
}>;

export type CreateFortnoxVoucherMutation = {
  submitFortnoxVoucher?: { result?: string | null } | null;
};

export type SubcontractorInvoiceFragment = {
  Balance?: string | null;
  Total?: string | null;
  Booked?: boolean | null;
  Credit?: boolean | null;
  CostCenter?: string | null;
  Currency?: string | null;
  FinalPayDate?: string | null;
  GivenNumber?: string | null;
  InvoiceDate?: string | null;
  InvoiceNumber?: string | null;
  DueDate?: string | null;
};

export type GetSubcontractorInvoiceQueryVariables = Exact<{
  provider: InvoiceProvider;
  number: Scalars["String"];
}>;

export type GetSubcontractorInvoiceQuery = {
  subcontractorInvoiceByNumber?: {
    Balance?: string | null;
    Total?: string | null;
    Booked?: boolean | null;
    Credit?: boolean | null;
    CostCenter?: string | null;
    Currency?: string | null;
    FinalPayDate?: string | null;
    GivenNumber?: string | null;
    InvoiceDate?: string | null;
    InvoiceNumber?: string | null;
    DueDate?: string | null;
  } | null;
};

export type BookingWeekCardFragment = {
  _id: string;
  AreaOfExpertise: string;
  CustomerNumber: string;
  Week: Date;
  callNumber: string;
  erpExportUnitRef?: string | null;
  BookingGroup: {
    externalId?: string | null;
    hospital: {
      _id: string;
      AreasOfExpertise: Array<string>;
      RecruitingPortalType?: RecruitingPortalType | null;
      Specializations: Array<string>;
      Name?: string | null;
      Address?: { Region: string } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    };
    department?: { _id: string; Name?: string | null } | null;
  };
  Consultant?: { _id: string; Name?: string | null } | null;
};

export type BookingWeekCardGetQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingWeekCardGetQuery = {
  bookingById?: {
    _id: string;
    AreaOfExpertise: string;
    CustomerNumber: string;
    Week: Date;
    callNumber: string;
    erpExportUnitRef?: string | null;
    BookingGroup: {
      externalId?: string | null;
      hospital: {
        _id: string;
        AreasOfExpertise: Array<string>;
        RecruitingPortalType?: RecruitingPortalType | null;
        Specializations: Array<string>;
        Name?: string | null;
        Address?: { Region: string } | null;
        Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      };
      department?: { _id: string; Name?: string | null } | null;
    };
    Consultant?: { _id: string; Name?: string | null } | null;
  } | null;
};

export type BookingAlertsFragment = {
  _id: string;
  isFirstWeek?: boolean | null;
  duplicateIds?: Array<string | null> | null;
  Consultant?: { care: string } | null;
  customersWithNoApproval?: {
    needSignature: Array<{ Id: string; Name: string; Type: CustomerType }>;
    needSignatureTROkInApp: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApproval: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApprovalMonthly: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApprovalShortening: Array<{ Id: string; Name: string; Type: CustomerType }>;
    noApprovalSpecial: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
  bookingIntro?: {
    description?: string | null;
    endDate?: Date | null;
    startDate?: Date | null;
    required?: boolean | null;
  } | null;
  BookingGroup: {
    nationalProcurementTravelRequired?: boolean | null;
    travelTemplateLevel?: string | null;
  };
};

export type GetConsultantServicePreferencesForBookingQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type GetConsultantServicePreferencesForBookingQuery = {
  consultantServicePreferencesForBooking: Array<{
    _id: string;
    createdOn: Date;
    createdById: string;
    createdByName: string;
    nullifiedById?: string | null;
    nullifiedByName?: string | null;
    nullifiedOn?: Date | null;
    description: string;
    status: ConsultantServicePreferenceStatus;
    deleted: boolean;
    archived: boolean;
    period: { start: Date; end: Date };
    customers: Array<{ Id: string; Name: string; Type: CustomerType } | null>;
    reminders: Array<{ createdAt?: Date | null; sentTo?: string | null }>;
  }>;
};

export type ResyncInvoiceMutationVariables = Exact<{
  provider: InvoiceProvider;
  number: Scalars["String"];
}>;

export type ResyncInvoiceMutation = {
  resyncInvoice?: {
    _id: string;
    CustomerName?: string | null;
    CustomerNumber?: string | null;
    InvoiceNumber: string;
    Provider: InvoiceProvider;
    TotalGross?: number | null;
    TotalNet?: number | null;
    InvoiceDate?: Date | null;
    DueDate?: Date | null;
    Notes?: string | null;
    IsCredit: boolean;
    PreviewUrl: string;
  } | null;
};

export type GetAttestContactPersonsQueryVariables = Exact<{
  hospitalId: Scalars["ObjectId"];
  departmentIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  areaOfExpertise: Scalars["String"];
}>;

export type GetAttestContactPersonsQuery = {
  attestContactPersons: {
    workplaceAllowsDigitalTimereport: boolean;
    items: Array<{
      _id: string;
      CustomerGroups: Array<string>;
      Deleted: boolean;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      CellPhone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerRefs: Array<{ Id: string }>;
      LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
    }>;
  };
};

export type BookingCustomerNumber_GetQueryVariables = Exact<{
  areaOfExpertise: Scalars["String"];
  hospitalId: Scalars["ObjectId"];
  departmentIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type BookingCustomerNumber_GetQuery = { customerNumberByAOE?: string | null };

export type ItemCard_ValidationErrorFragment = {
  Message: string;
  Params?: any | null;
  Type: NodeValidationErrorType;
};

export type BulkActionMutationVariables = Exact<{
  input: BulkActionInput;
}>;

export type BulkActionMutation = {
  bulkAction: { actionId: string; status: BulkActionStatus; error?: string | null };
};

export type ConsultantExportBulkActionMutationVariables = Exact<{
  filter: ConsultantsQueryInput;
}>;

export type ConsultantExportBulkActionMutation = {
  consultantExportBulkAction: {
    actionId: string;
    status: BulkActionStatus;
    error?: string | null;
  };
};

export type ConsultantExportSsnBulkActionMutationVariables = Exact<{
  filter: ConsultantsQueryInput;
}>;

export type ConsultantExportSsnBulkActionMutation = {
  consultantExportSsnBulkAction: {
    actionId: string;
    status: BulkActionStatus;
    error?: string | null;
  };
};

export type BulkSmsTextMaxLengthQueryVariables = Exact<{
  subType?: InputMaybe<Scalars["String"]>;
}>;

export type BulkSmsTextMaxLengthQuery = { bulkSmsTextMaxLength: number };

export type ContractsPriceRecordFragment = {
  _id: string;
  articleNumber?: string | null;
  articleNumberForOtherSpeciality?: string | null;
  indexInWorkType?: number | null;
  startDay?: PriceListDay | null;
  endDay?: PriceListDay | null;
  paidPer?: PayUnit | null;
  currency?: Currency | null;
  workType?: PriceListWorkType | null;
  from?: string | null;
  to?: string | null;
  period?: PayPeriod | null;
  priceMultiplier?: number | null;
  fixedPrice?: number | null;
  customPrice?: number | null;
  deleted?: boolean | null;
  isSecondPass?: boolean | null;
};

export type ContractsPriceTemplateFragment = {
  _id: string;
  name?: string | null;
  type?: string | null;
  private?: boolean | null;
  createdByName?: string | null;
  createdDate?: Date | null;
  updatedByName?: string | null;
  updatedDate?: Date | null;
  records?: Array<{
    _id: string;
    articleNumber?: string | null;
    articleNumberForOtherSpeciality?: string | null;
    indexInWorkType?: number | null;
    startDay?: PriceListDay | null;
    endDay?: PriceListDay | null;
    paidPer?: PayUnit | null;
    currency?: Currency | null;
    workType?: PriceListWorkType | null;
    from?: string | null;
    to?: string | null;
    period?: PayPeriod | null;
    priceMultiplier?: number | null;
    fixedPrice?: number | null;
    customPrice?: number | null;
    deleted?: boolean | null;
    isSecondPass?: boolean | null;
  }> | null;
  highHolidays?: Array<{
    _id: string;
    isGreatHoliday?: boolean | null;
    option: { name?: string | null; listPosition?: number | null; _id: string };
  }> | null;
};

export type ContractsPriceTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<ContractPriceTemplateFilter>;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  onlyPrivate: Scalars["Boolean"];
}>;

export type ContractsPriceTemplatesQuery = {
  list: {
    skip: number;
    limit: number;
    total: number;
    items: Array<{
      _id: string;
      name?: string | null;
      type?: string | null;
      private?: boolean | null;
      createdByName?: string | null;
      createdDate?: Date | null;
      updatedByName?: string | null;
      updatedDate?: Date | null;
      records?: Array<{
        _id: string;
        articleNumber?: string | null;
        articleNumberForOtherSpeciality?: string | null;
        indexInWorkType?: number | null;
        startDay?: PriceListDay | null;
        endDay?: PriceListDay | null;
        paidPer?: PayUnit | null;
        currency?: Currency | null;
        workType?: PriceListWorkType | null;
        from?: string | null;
        to?: string | null;
        period?: PayPeriod | null;
        priceMultiplier?: number | null;
        fixedPrice?: number | null;
        customPrice?: number | null;
        deleted?: boolean | null;
        isSecondPass?: boolean | null;
      }> | null;
      highHolidays?: Array<{
        _id: string;
        isGreatHoliday?: boolean | null;
        option: { name?: string | null; listPosition?: number | null; _id: string };
      }> | null;
    }>;
  };
};

export type ContractsPriceTemplateByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ObjectId"]>;
  skip: Scalars["Boolean"];
}>;

export type ContractsPriceTemplateByIdQuery = {
  getHighHolidays: Array<{
    name?: string | null;
    listPosition?: number | null;
    _id: string;
  }>;
  contractsPriceTemplateById?: {
    _id: string;
    name?: string | null;
    type?: string | null;
    private?: boolean | null;
    createdByName?: string | null;
    createdDate?: Date | null;
    updatedByName?: string | null;
    updatedDate?: Date | null;
    records?: Array<{
      _id: string;
      articleNumber?: string | null;
      articleNumberForOtherSpeciality?: string | null;
      indexInWorkType?: number | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
      deleted?: boolean | null;
      isSecondPass?: boolean | null;
    }> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    }> | null;
  } | null;
};

export type SubmitContractsPriceTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ObjectId"]>;
  data: ContractPriceTemplateInput;
}>;

export type SubmitContractsPriceTemplateMutation = {
  submitContractPriceTemplateForm: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      name?: string | null;
      type?: string | null;
      private?: boolean | null;
      createdByName?: string | null;
      createdDate?: Date | null;
      updatedByName?: string | null;
      updatedDate?: Date | null;
      records?: Array<{
        _id: string;
        articleNumber?: string | null;
        articleNumberForOtherSpeciality?: string | null;
        indexInWorkType?: number | null;
        startDay?: PriceListDay | null;
        endDay?: PriceListDay | null;
        paidPer?: PayUnit | null;
        currency?: Currency | null;
        workType?: PriceListWorkType | null;
        from?: string | null;
        to?: string | null;
        period?: PayPeriod | null;
        priceMultiplier?: number | null;
        fixedPrice?: number | null;
        customPrice?: number | null;
        deleted?: boolean | null;
        isSecondPass?: boolean | null;
      }> | null;
      highHolidays?: Array<{
        _id: string;
        isGreatHoliday?: boolean | null;
        option: { name?: string | null; listPosition?: number | null; _id: string };
      }> | null;
    } | null;
  };
};

export type DuplicateContractsPriceTemplateMutationVariables = Exact<{
  data: ContractPriceTemplateInput;
}>;

export type DuplicateContractsPriceTemplateMutation = {
  duplicateContractPriceTemplate: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      name?: string | null;
      type?: string | null;
      private?: boolean | null;
      createdByName?: string | null;
      createdDate?: Date | null;
      updatedByName?: string | null;
      updatedDate?: Date | null;
      records?: Array<{
        _id: string;
        articleNumber?: string | null;
        articleNumberForOtherSpeciality?: string | null;
        indexInWorkType?: number | null;
        startDay?: PriceListDay | null;
        endDay?: PriceListDay | null;
        paidPer?: PayUnit | null;
        currency?: Currency | null;
        workType?: PriceListWorkType | null;
        from?: string | null;
        to?: string | null;
        period?: PayPeriod | null;
        priceMultiplier?: number | null;
        fixedPrice?: number | null;
        customPrice?: number | null;
        deleted?: boolean | null;
        isSecondPass?: boolean | null;
      }> | null;
      highHolidays?: Array<{
        _id: string;
        isGreatHoliday?: boolean | null;
        option: { name?: string | null; listPosition?: number | null; _id: string };
      }> | null;
    } | null;
  };
};

export type DeleteContractsPriceTemplateMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteContractsPriceTemplateMutation = {
  deleteContractPriceTemplate: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      name?: string | null;
      type?: string | null;
      private?: boolean | null;
      createdByName?: string | null;
      createdDate?: Date | null;
      updatedByName?: string | null;
      updatedDate?: Date | null;
      records?: Array<{
        _id: string;
        articleNumber?: string | null;
        articleNumberForOtherSpeciality?: string | null;
        indexInWorkType?: number | null;
        startDay?: PriceListDay | null;
        endDay?: PriceListDay | null;
        paidPer?: PayUnit | null;
        currency?: Currency | null;
        workType?: PriceListWorkType | null;
        from?: string | null;
        to?: string | null;
        period?: PayPeriod | null;
        priceMultiplier?: number | null;
        fixedPrice?: number | null;
        customPrice?: number | null;
        deleted?: boolean | null;
        isSecondPass?: boolean | null;
      }> | null;
      highHolidays?: Array<{
        _id: string;
        isGreatHoliday?: boolean | null;
        option: { name?: string | null; listPosition?: number | null; _id: string };
      }> | null;
    } | null;
  };
};

export type CostCenterConfigItemFragment = {
  _id: string;
  tenant: string;
  costCenterId: string;
  name: string;
  organisation: string;
  isActive: boolean;
  isDeleted: boolean;
};

export type CostCenterConfigItemsQueryVariables = Exact<{
  filter?: InputMaybe<CostCenterConfigFilterInput>;
}>;

export type CostCenterConfigItemsQuery = {
  costCenterConfigItems: Array<{
    _id: string;
    tenant: string;
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
    isDeleted: boolean;
  }>;
};

export type CreateCostCenterMutationVariables = Exact<{
  input: CreateCostCenterInput;
}>;

export type CreateCostCenterMutation = {
  createCostCenter: {
    _id: string;
    tenant: string;
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
    isDeleted: boolean;
  };
};

export type UpdateCostCenterMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: UpdateCostCenterInput;
}>;

export type UpdateCostCenterMutation = {
  updateCostCenter: {
    _id: string;
    tenant: string;
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
    isDeleted: boolean;
  };
};

export type DeleteCostCenterMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteCostCenterMutation = {
  deleteCostCenter: {
    _id: string;
    tenant: string;
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
    isDeleted: boolean;
  };
};

export type RestoreCostCenterMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type RestoreCostCenterMutation = {
  restoreCostCenter: {
    _id: string;
    tenant: string;
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
    isDeleted: boolean;
  };
};

export type ToggleCostCenterActiveMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ToggleCostCenterActiveMutation = {
  toggleCostCenterActive: {
    _id: string;
    tenant: string;
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
    isDeleted: boolean;
  };
};

export type TgRequirementFragment = {
  _id: string;
  tenant: string;
  costCenterId: string;
  profession?: string | null;
  minRequiredTG: number;
  validFrom: Date;
  validTo?: Date | null;
  createdOn: Date;
  createdByName: string;
  updatedOn?: Date | null;
  updatedByName?: string | null;
  deleted: boolean;
};

export type TgRequirementsQueryVariables = Exact<{
  filter?: InputMaybe<TgRequirementFilterInput>;
}>;

export type TgRequirementsQuery = {
  tgRequirements: Array<{
    _id: string;
    tenant: string;
    costCenterId: string;
    profession?: string | null;
    minRequiredTG: number;
    validFrom: Date;
    validTo?: Date | null;
    createdOn: Date;
    createdByName: string;
    updatedOn?: Date | null;
    updatedByName?: string | null;
    deleted: boolean;
  }>;
};

export type CreateTgRequirementMutationVariables = Exact<{
  input: CreateTgRequirementInput;
}>;

export type CreateTgRequirementMutation = {
  createTgRequirement: {
    _id: string;
    tenant: string;
    costCenterId: string;
    profession?: string | null;
    minRequiredTG: number;
    validFrom: Date;
    validTo?: Date | null;
    createdOn: Date;
    createdByName: string;
    updatedOn?: Date | null;
    updatedByName?: string | null;
    deleted: boolean;
  };
};

export type UpdateTgRequirementMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: UpdateTgRequirementInput;
}>;

export type UpdateTgRequirementMutation = {
  updateTgRequirement: {
    _id: string;
    tenant: string;
    costCenterId: string;
    profession?: string | null;
    minRequiredTG: number;
    validFrom: Date;
    validTo?: Date | null;
    createdOn: Date;
    createdByName: string;
    updatedOn?: Date | null;
    updatedByName?: string | null;
    deleted: boolean;
  };
};

export type DeleteTgRequirementMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteTgRequirementMutation = { deleteTgRequirement: boolean };

export type ProfessionsByCountryQueryVariables = Exact<{ [key: string]: never }>;

export type ProfessionsByCountryQuery = {
  professionsByCountry: Array<{ country: string; professions: Array<string> }>;
};

export type GetConsultantAreaOfExpertisesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantAreaOfExpertisesQuery = {
  consultantById?: { _id: string; AreasOfExpertise: Array<string> } | null;
};

export type GetConsultantOpportunityCreateQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantOpportunityCreateQuery = {
  consultantOpportunityById: {
    areaOfExpertise?: string | null;
    dueDate?: Date | null;
    description?: string | null;
    weeks: Array<Date>;
    consultant?: { _id: string } | null;
    customer?: {
      __typename: "Customer";
      _id: string;
      IsValid?: boolean | null;
      AreasOfExpertise: Array<string>;
      Name?: string | null;
      journalSystem?: string | null;
      Type: CustomerType;
      RegionRef: { Id: string; Name: string; Type: CustomerType };
      Parents: Array<{ Name: string }>;
      Address?: { City: string } | null;
    } | null;
    costCenter?: { Id: string; Name?: string | null } | null;
  };
};

export type CreateConsultantOpportunityMutationVariables = Exact<{
  input: CreateConsultantOpportunityInput;
}>;

export type CreateConsultantOpportunityMutation = {
  createConsultantOpportunity: { _id: string };
};

export type EditConsultantOpportunityMutationVariables = Exact<{
  issueId: Scalars["ObjectId"];
  input: EditConsultantOpportunityInput;
}>;

export type EditConsultantOpportunityMutation = { editConsultantOpportunity: boolean };

export type FinaliseOpportunityDataFragment = {
  _id: string;
  dueDate?: Date | null;
  weeks: Array<Date>;
  customer?: { _id: string; Name?: string | null } | null;
  consultant?: { _id: string; Name?: string | null } | null;
};

export type GetConsultantOpportunityFinalizeQueryVariables = Exact<{
  opportunityId: Scalars["ObjectId"];
}>;

export type GetConsultantOpportunityFinalizeQuery = {
  consultantOpportunityById: {
    _id: string;
    dueDate?: Date | null;
    weeks: Array<Date>;
    customer?: { _id: string; Name?: string | null } | null;
    consultant?: { _id: string; Name?: string | null } | null;
  };
};

export type GetOpportunityIssueWeeksQueryVariables = Exact<{
  issueId: Scalars["ObjectId"];
}>;

export type GetOpportunityIssueWeeksQuery = {
  consultantOpportunityIssueWeeks: {
    wonWeeks: Array<Date>;
    lostWeeks: Array<Date>;
    openWeeks: Array<Date>;
  };
};

export type FinaliseOpportunityMutationVariables = Exact<{
  issueId: Scalars["ObjectId"];
  weeksWon: Array<Scalars["Date"]> | Scalars["Date"];
}>;

export type FinaliseOpportunityMutation = {
  finaliseConsultantOpportunity: {
    won?: { _id: string } | null;
    lost?: { _id: string } | null;
  };
};

export type ConsultantOpportunityCardFragment = {
  _id: string;
  title: string;
  dueDate?: Date | null;
  assignee?: { _id: string; Name: string } | null;
  consultantOpportunity: {
    _id: string;
    createdAt: Date;
    dueDate?: Date | null;
    areaOfExpertise?: string | null;
    weeks: Array<Date>;
    weeksString: string;
    weeksLost?: Array<Date> | null;
    weeksLostString: string;
    weeksWon?: Array<Date> | null;
    weeksWonString: string;
    description?: string | null;
    isShared?: boolean | null;
    consultant?: {
      _id: string;
      AreasOfExpertise: Array<string>;
      Name?: string | null;
      tags: Array<string>;
      Availability: { availableWeeksString: string };
    } | null;
    customer?: { _id: string; Name?: string | null; Type: CustomerType } | null;
    costCenter?: { Id: string; Name?: string | null } | null;
    originalIssue?: { _id: string } | null;
    users: Array<{ _id: string; Name: string }>;
  };
};

export type GetConsultantOpportunityBoardQueryVariables = Exact<{
  ownerId: Scalars["String"];
}>;

export type GetConsultantOpportunityBoardQuery = {
  kanbanBoard?: {
    _id: string;
    type: KanbanBoardType;
    name: string;
    columns: Array<{ _id: string; name: string; order: number }>;
  } | null;
};

export type GetConsultantOpportunityCardsQueryVariables = Exact<{
  boardId: Scalars["String"];
}>;

export type GetConsultantOpportunityCardsQuery = {
  kanbanCards: Array<
    | {
        _id: string;
        title: string;
        dueDate?: Date | null;
        assignee?: { _id: string; Name: string } | null;
        consultantOpportunity: {
          _id: string;
          createdAt: Date;
          dueDate?: Date | null;
          areaOfExpertise?: string | null;
          weeks: Array<Date>;
          weeksString: string;
          weeksLost?: Array<Date> | null;
          weeksLostString: string;
          weeksWon?: Array<Date> | null;
          weeksWonString: string;
          description?: string | null;
          isShared?: boolean | null;
          consultant?: {
            _id: string;
            AreasOfExpertise: Array<string>;
            Name?: string | null;
            tags: Array<string>;
            Availability: { availableWeeksString: string };
          } | null;
          customer?: { _id: string; Name?: string | null; Type: CustomerType } | null;
          costCenter?: { Id: string; Name?: string | null } | null;
          originalIssue?: { _id: string } | null;
          users: Array<{ _id: string; Name: string }>;
        };
      }
    | { _id: string }
  >;
};

export type DeleteConsultantOpportunityCardMutationVariables = Exact<{
  issueId: Scalars["ObjectId"];
}>;

export type DeleteConsultantOpportunityCardMutation = {
  deleteConsultantOpportunity: boolean;
};

export type ConsultantOpportunityStatsDataFragment = {
  presentedWeeks: number;
  openWeeks: number;
  wonWeeks: number;
  lostWeeks: number;
};

export type GetConsultantOpportunityStatsByUserQueryVariables = Exact<{
  userId: Scalars["ObjectId"];
  start: Scalars["Date"];
  end: Scalars["Date"];
}>;

export type GetConsultantOpportunityStatsByUserQuery = {
  consultantOpportunityStatsByUser: {
    presentedWeeks: number;
    openWeeks: number;
    wonWeeks: number;
    lostWeeks: number;
  };
};

export type GetConsultantOpportunityStatsByTeamQueryVariables = Exact<{
  team: Scalars["String"];
  start: Scalars["Date"];
  end: Scalars["Date"];
}>;

export type GetConsultantOpportunityStatsByTeamQuery = {
  consultantOpportunityStatsByTeam: {
    presentedWeeks: number;
    openWeeks: number;
    wonWeeks: number;
    lostWeeks: number;
  };
};

export type ConsultantPipelineCardFragment = {
  _id: string;
  boardId: string;
  description?: string | null;
  dueDate?: Date | null;
  order: number;
  title: string;
  columnId: string;
  assignee?: { _id: string; Name: string } | null;
  consultant: {
    _id: string;
    AreasOfExpertise: Array<string>;
    tags: Array<string>;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    Professions?: Array<string | null> | null;
    nationalQualification?: NationalQualification | null;
    Availability: { availableWeeksString: string };
    qualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    nationalQualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    nextContactDate?: { date?: Date | null; reason?: string | null } | null;
    generalInterest?: { regions: Array<string> } | null;
  };
};

export type GetConsultantPipelineBoardQueryVariables = Exact<{
  ownerId: Scalars["String"];
}>;

export type GetConsultantPipelineBoardQuery = {
  kanbanBoard?: {
    _id: string;
    type: KanbanBoardType;
    name: string;
    columns: Array<{ _id: string; name: string; order: number }>;
  } | null;
};

export type GetConsultantPipelineCardsQueryVariables = Exact<{
  boardId: Scalars["String"];
}>;

export type GetConsultantPipelineCardsQuery = {
  kanbanCards: Array<
    | { _id: string }
    | {
        _id: string;
        boardId: string;
        description?: string | null;
        dueDate?: Date | null;
        order: number;
        title: string;
        columnId: string;
        assignee?: { _id: string; Name: string } | null;
        consultant: {
          _id: string;
          AreasOfExpertise: Array<string>;
          tags: Array<string>;
          isQualityApproved: boolean;
          isQualityExpired: boolean;
          Professions?: Array<string | null> | null;
          nationalQualification?: NationalQualification | null;
          Availability: { availableWeeksString: string };
          qualityApprovals: Array<{
            Country: string;
            Approved: boolean;
            Profession: string;
            approvalExpiresOn?: Date | null;
            baseItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
            oneOfItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
          }>;
          nationalQualityApprovals: Array<{
            Country: string;
            Approved: boolean;
            Profession: string;
            approvalExpiresOn?: Date | null;
            baseItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
            oneOfItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
          }>;
          nextContactDate?: { date?: Date | null; reason?: string | null } | null;
          generalInterest?: { regions: Array<string> } | null;
        };
      }
  >;
};

export type GetConsultantPipelineCardQueryVariables = Exact<{
  boardId: Scalars["String"];
  cardId: Scalars["String"];
}>;

export type GetConsultantPipelineCardQuery = {
  kanbanCard?:
    | { _id: string }
    | {
        _id: string;
        boardId: string;
        description?: string | null;
        dueDate?: Date | null;
        order: number;
        title: string;
        columnId: string;
        assignee?: { _id: string; Name: string } | null;
        consultant: {
          _id: string;
          AreasOfExpertise: Array<string>;
          tags: Array<string>;
          isQualityApproved: boolean;
          isQualityExpired: boolean;
          Professions?: Array<string | null> | null;
          nationalQualification?: NationalQualification | null;
          Availability: { availableWeeksString: string };
          qualityApprovals: Array<{
            Country: string;
            Approved: boolean;
            Profession: string;
            approvalExpiresOn?: Date | null;
            baseItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
            oneOfItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
          }>;
          nationalQualityApprovals: Array<{
            Country: string;
            Approved: boolean;
            Profession: string;
            approvalExpiresOn?: Date | null;
            baseItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
            oneOfItems?: Array<{
              name: string;
              approved: boolean;
              approvalExpiresOn?: Date | null;
              partiallyExpiresOn?: Date | null;
            } | null> | null;
          }>;
          nextContactDate?: { date?: Date | null; reason?: string | null } | null;
          generalInterest?: { regions: Array<string> } | null;
        };
      }
    | null;
};

export type UnsetNextContactDateMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  nextPipelineStatus: Scalars["String"];
}>;

export type UnsetNextContactDateMutation = { unsetConsultantNextContactDate: boolean };

export type PipelineStatusCommentGetDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type PipelineStatusCommentGetDataQuery = {
  consultantById?: { pipelineStatusComment?: string | null } | null;
};

export type SetPipelineStatusCommentMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  comment?: InputMaybe<Scalars["String"]>;
}>;

export type SetPipelineStatusCommentMutation = {
  setConsultantPipelineStatusComment: { pipelineStatusComment?: string | null };
};

export type GetConsultantNextContactDateQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantNextContactDateQuery = {
  consultantById?: {
    _id: string;
    nextContactDate?: { reason?: string | null; date?: Date | null } | null;
  } | null;
};

export type SetConsultantNextContactDateMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  date: Scalars["Date"];
  reason: Scalars["String"];
}>;

export type SetConsultantNextContactDateMutation = {
  setConsultantNextContactDate: boolean;
};

export type UntagConsultantDataFragment = {
  _id: string;
  Name?: string | null;
  leadStatus?: { status: ConsultantLeadStatus } | null;
};

export type UntagConsultantGetDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type UntagConsultantGetDataQuery = {
  consultantById?: {
    _id: string;
    Name?: string | null;
    leadStatus?: { status: ConsultantLeadStatus } | null;
  } | null;
};

export type UntagConsultantClearBAMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  status?: InputMaybe<ConsultantLeadStatus>;
}>;

export type UntagConsultantClearBAMutation = {
  clearConsultantResponsiblePerson: { _id: string };
};

export type DefaultKanbanBoardFragment = {
  _id: string;
  type: KanbanBoardType;
  name: string;
  columns: Array<{ _id: string; name: string; order: number }>;
};

export type MoveCardMutationVariables = Exact<{
  boardId: Scalars["String"];
  boardType: KanbanBoardType;
  cardId: Scalars["String"];
  columnId: Scalars["String"];
  beforeCardId?: InputMaybe<Scalars["String"]>;
  sessionId?: InputMaybe<Scalars["String"]>;
}>;

export type MoveCardMutation = { moveCard: boolean };

export type CardAddedSubscriptionVariables = Exact<{
  sessionId: Scalars["String"];
  boardId: Scalars["ObjectId"];
}>;

export type CardAddedSubscription = { kanbanCardAdded: { cardId: string } };

export type CardMovedSubscriptionVariables = Exact<{
  sessionId: Scalars["String"];
  boardId: Scalars["ObjectId"];
}>;

export type CardMovedSubscription = { kanbanCardMoved: { cardId: string } };

export type CardDeletedSubscriptionVariables = Exact<{
  sessionId: Scalars["String"];
  boardId: Scalars["ObjectId"];
}>;

export type CardDeletedSubscription = { kanbanCardDeleted: { cardId: string } };

export type ContactPerson_ContactInfoFragment = {
  ContactPersons: Array<{
    _id: string;
    Name?: string | null;
    Email?: string | null;
    Phone?: string | null;
    Title?: string | null;
  }>;
};

export type ConsultantBookingContractCustomerFragment = {
  _id: string;
  Name?: string | null;
  Address?: { StreetName: string; City: string; ZipCode: string; Country: string } | null;
  ContactPersons: Array<{
    _id: string;
    Name?: string | null;
    Email?: string | null;
    Phone?: string | null;
    Title?: string | null;
  }>;
};

export type ConsultantBookingContract_GetCustomerQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantBookingContract_GetCustomerQuery = {
  customerById?: {
    _id: string;
    Name?: string | null;
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
    } | null;
    ContactPersons: Array<{
      _id: string;
      Name?: string | null;
      Email?: string | null;
      Phone?: string | null;
      Title?: string | null;
    }>;
  } | null;
};

export type ConsultantBookingContract_FetchDeptsQueryVariables = Exact<{
  hospitalId: Scalars["ObjectId"];
}>;

export type ConsultantBookingContract_FetchDeptsQuery = {
  hospital?: {
    _id: string;
    OrganizationNumber: string;
    ContactPersons: Array<{
      _id: string;
      Name?: string | null;
      Email?: string | null;
      Phone?: string | null;
      Title?: string | null;
    }>;
  } | null;
  departments: {
    dbTime?: number | null;
    items: Array<{
      _id: string;
      Name?: string | null;
      ContactPersons: Array<{
        _id: string;
        Name?: string | null;
        Email?: string | null;
        Phone?: string | null;
        Title?: string | null;
      }>;
    }>;
  };
};

export type ConsultantBookingContractListItem_FragmentFragment = {
  _id?: string | null;
  CustomerCity?: string | null;
  CustomerName?: string | null;
  Dates?: string | null;
  FileUrl?: string | null;
  IsSigned?: boolean | null;
  Type?: ConsultantBookingContractType | null;
  ViewUrl?: string | null;
  Recipients?: Array<string | null> | null;
  IsNullified?: boolean | null;
  Attachment?: {
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  } | null;
  ContactPerson?: { Name?: string | null; Email?: string | null } | null;
};

export type ConsultantBookingContract_EditMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  data: ConsultantBookingContractFormInput;
}>;

export type ConsultantBookingContract_EditMutation = {
  editConsultantBookingContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    ViewUrl?: string | null;
    Recipients?: Array<string | null> | null;
    IsNullified?: boolean | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    ContactPerson?: { Name?: string | null; Email?: string | null } | null;
  };
};

export type ConsultantBookingContract_AddMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantBookingContractFormInput;
}>;

export type ConsultantBookingContract_AddMutation = {
  addConsultantBookingContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    ViewUrl?: string | null;
    Recipients?: Array<string | null> | null;
    IsNullified?: boolean | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    ContactPerson?: { Name?: string | null; Email?: string | null } | null;
  };
};

export type ConsultantBookingContract_SoftDeleteMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantBookingContract_SoftDeleteMutation = {
  deleteConsultantBookingContract: { _id?: string | null };
};

export type ConsultantBookingContract_NullifyMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  nullify: Scalars["Boolean"];
}>;

export type ConsultantBookingContract_NullifyMutation = {
  nullifyConsultantBookingContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    ViewUrl?: string | null;
    Recipients?: Array<string | null> | null;
    IsNullified?: boolean | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    ContactPerson?: { Name?: string | null; Email?: string | null } | null;
  };
};

export type ConsultantBookingContract_GetContractsByConsultantIdQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantBookingContract_GetContractsByConsultantIdQuery = {
  getConsultantBookingContracts: Array<{
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    ViewUrl?: string | null;
    Recipients?: Array<string | null> | null;
    IsNullified?: boolean | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    ContactPerson?: { Name?: string | null; Email?: string | null } | null;
  }>;
};

export type ConsultantBookingContract_UploadSignedMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  file: Scalars["Upload"];
  SignedOn?: InputMaybe<Scalars["Date"]>;
}>;

export type ConsultantBookingContract_UploadSignedMutation = {
  uploadSignedConsultantBookingContract: {
    _id?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    ViewUrl?: string | null;
  };
};

export type ContractBookingAddressFragment = {
  Address?: { StreetName: string; City: string; ZipCode: string; Country: string } | null;
};

export type SalaryBookingContractFragment = {
  BasicPrice?: number | null;
  Bonus?: Array<{
    _id?: string | null;
    Type?: string | null;
    SalaryType?: ConsultantContractBonusType | null;
    Amount?: number | null;
    Currency?: Currency | null;
    Config?: any | null;
  } | null> | null;
  IntroductionPrice?: Array<{
    Currency?: Currency | null;
    Sum?: string | null;
    Description?: string | null;
  } | null> | null;
  SalaryRecords?: Array<{
    _id: string;
    articleNumber?: string | null;
    indexInWorkType?: number | null;
    deleted?: boolean | null;
    startDay?: PriceListDay | null;
    endDay?: PriceListDay | null;
    paidPer?: PayUnit | null;
    currency?: Currency | null;
    workType?: PriceListWorkType | null;
    from?: string | null;
    to?: string | null;
    period?: PayPeriod | null;
    priceMultiplier?: number | null;
    fixedPrice?: number | null;
    customPrice?: number | null;
  } | null> | null;
  highHolidays?: Array<{
    _id: string;
    isGreatHoliday?: boolean | null;
    option: { name?: string | null; listPosition?: number | null; _id: string };
  } | null> | null;
};

export type BookingContractDataForDuplicationFragment = {
  _id?: string | null;
  ConsultantId?: string | null;
  ResponsiblePersonId?: string | null;
  ContractPriceTemplateId?: string | null;
  hideDeptName?: boolean | null;
  hideHospitalName?: boolean | null;
  Type?: ConsultantBookingContractType | null;
  OtherInfo?: string | null;
  AreaOfExpertise?: Array<string | null> | null;
  Price?: string | null;
  Schedule?: string | null;
  Recipients?: Array<string | null> | null;
  SpecificRequirements?: Array<string | null> | null;
  Profession?: string | null;
  sithsCardNumber?: string | null;
  BasicPrice?: number | null;
  DepartmentsRefs?: { Id: string; Name: string } | null;
  HospitalRef?: { Id: string; Name: string } | null;
  ContactPerson?: {
    Name?: string | null;
    Phone?: string | null;
    Email?: string | null;
    Title?: string | null;
  } | null;
  PriceRecruitment?: {
    Currency?: ConsultantContractCurrency | null;
    R_0_159?: number | null;
    R_160_499?: number | null;
    R_500_699?: number | null;
    R_700_899?: number | null;
    R_900_1200?: number | null;
  } | null;
  SpecificPeriodPrices?: Array<{
    _id: string;
    startDate: Date;
    endDate: Date;
    title?: string | null;
    price: number;
  } | null> | null;
  Bonus?: Array<{
    _id?: string | null;
    Type?: string | null;
    SalaryType?: ConsultantContractBonusType | null;
    Amount?: number | null;
    Currency?: Currency | null;
    Config?: any | null;
  } | null> | null;
  Address?: { StreetName: string; City: string; ZipCode: string; Country: string } | null;
  IntroductionPrice?: Array<{
    Currency?: Currency | null;
    Sum?: string | null;
    Description?: string | null;
  } | null> | null;
  SalaryRecords?: Array<{
    _id: string;
    articleNumber?: string | null;
    indexInWorkType?: number | null;
    deleted?: boolean | null;
    startDay?: PriceListDay | null;
    endDay?: PriceListDay | null;
    paidPer?: PayUnit | null;
    currency?: Currency | null;
    workType?: PriceListWorkType | null;
    from?: string | null;
    to?: string | null;
    period?: PayPeriod | null;
    priceMultiplier?: number | null;
    fixedPrice?: number | null;
    customPrice?: number | null;
  } | null> | null;
  highHolidays?: Array<{
    _id: string;
    isGreatHoliday?: boolean | null;
    option: { name?: string | null; listPosition?: number | null; _id: string };
  } | null> | null;
};

export type ConsultantBookingContract_GetByIdForEditQueryVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantBookingContract_GetByIdForEditQuery = {
  getConsultantBookingContractDetailInfo: {
    Period?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;
    ResponsiblePersonId?: string | null;
    SignedOn?: Date | null;
    _id?: string | null;
    ConsultantId?: string | null;
    ContractPriceTemplateId?: string | null;
    hideDeptName?: boolean | null;
    hideHospitalName?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    OtherInfo?: string | null;
    AreaOfExpertise?: Array<string | null> | null;
    Price?: string | null;
    Schedule?: string | null;
    Recipients?: Array<string | null> | null;
    SpecificRequirements?: Array<string | null> | null;
    Profession?: string | null;
    sithsCardNumber?: string | null;
    BasicPrice?: number | null;
    DepartmentsRefs?: { Id: string; Name: string } | null;
    HospitalRef?: { Id: string; Name: string } | null;
    ContactPerson?: {
      Name?: string | null;
      Phone?: string | null;
      Email?: string | null;
      Title?: string | null;
    } | null;
    PriceRecruitment?: {
      Currency?: ConsultantContractCurrency | null;
      R_0_159?: number | null;
      R_160_499?: number | null;
      R_500_699?: number | null;
      R_700_899?: number | null;
      R_900_1200?: number | null;
    } | null;
    SpecificPeriodPrices?: Array<{
      _id: string;
      startDate: Date;
      endDate: Date;
      title?: string | null;
      price: number;
    } | null> | null;
    Bonus?: Array<{
      _id?: string | null;
      Type?: string | null;
      SalaryType?: ConsultantContractBonusType | null;
      Amount?: number | null;
      Currency?: Currency | null;
      Config?: any | null;
    } | null> | null;
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
    } | null;
    IntroductionPrice?: Array<{
      Currency?: Currency | null;
      Sum?: string | null;
      Description?: string | null;
    } | null> | null;
    SalaryRecords?: Array<{
      _id: string;
      articleNumber?: string | null;
      indexInWorkType?: number | null;
      deleted?: boolean | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
    } | null> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    } | null> | null;
  };
};

export type ConsultantBookingContract_GetByIdForDuplicationQueryVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantBookingContract_GetByIdForDuplicationQuery = {
  getConsultantBookingContractDetailInfo: {
    _id?: string | null;
    ConsultantId?: string | null;
    ResponsiblePersonId?: string | null;
    ContractPriceTemplateId?: string | null;
    hideDeptName?: boolean | null;
    hideHospitalName?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    OtherInfo?: string | null;
    AreaOfExpertise?: Array<string | null> | null;
    Price?: string | null;
    Schedule?: string | null;
    Recipients?: Array<string | null> | null;
    SpecificRequirements?: Array<string | null> | null;
    Profession?: string | null;
    sithsCardNumber?: string | null;
    BasicPrice?: number | null;
    DepartmentsRefs?: { Id: string; Name: string } | null;
    HospitalRef?: { Id: string; Name: string } | null;
    ContactPerson?: {
      Name?: string | null;
      Phone?: string | null;
      Email?: string | null;
      Title?: string | null;
    } | null;
    PriceRecruitment?: {
      Currency?: ConsultantContractCurrency | null;
      R_0_159?: number | null;
      R_160_499?: number | null;
      R_500_699?: number | null;
      R_700_899?: number | null;
      R_900_1200?: number | null;
    } | null;
    SpecificPeriodPrices?: Array<{
      _id: string;
      startDate: Date;
      endDate: Date;
      title?: string | null;
      price: number;
    } | null> | null;
    Bonus?: Array<{
      _id?: string | null;
      Type?: string | null;
      SalaryType?: ConsultantContractBonusType | null;
      Amount?: number | null;
      Currency?: Currency | null;
      Config?: any | null;
    } | null> | null;
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
    } | null;
    IntroductionPrice?: Array<{
      Currency?: Currency | null;
      Sum?: string | null;
      Description?: string | null;
    } | null> | null;
    SalaryRecords?: Array<{
      _id: string;
      articleNumber?: string | null;
      indexInWorkType?: number | null;
      deleted?: boolean | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
    } | null> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    } | null> | null;
  };
};

export type ConsultantCardFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  Email?: string | null;
  secondaryEmail?: string | null;
  LastContactDate?: Date | null;
  Name?: string | null;
  Phone?: string | null;
  Unfit: boolean;
  SocialSecurityNo?: string | null;
  Specializations: Array<string>;
  IsValid?: boolean | null;
  Professions?: Array<string | null> | null;
  PrescriptionCode?: string | null;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  Address?: { City: string } | null;
  contactType?: {
    employeeSalaryClaim?: string | null;
    subcontractorSalaryClaim?: string | null;
  } | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
  expertise: { machines: Array<string>; systems: Array<string | null> };
};

export type ConsultantSearchCardFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  Email?: string | null;
  secondaryEmail?: string | null;
  LastContactDate?: Date | null;
  Name?: string | null;
  Phone?: string | null;
  Unfit: boolean;
  SocialSecurityNo?: string | null;
  Specializations: Array<string>;
  IsValid?: boolean | null;
  Professions?: Array<string | null> | null;
  PrescriptionCode?: string | null;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  Availability: { ranges: Array<{ from: Date; to: Date }> };
  Address?: { City: string } | null;
  contactType?: {
    employeeSalaryClaim?: string | null;
    subcontractorSalaryClaim?: string | null;
  } | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
  expertise: { machines: Array<string>; systems: Array<string | null> };
};

export type ConsultantSearchCard_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
  withEvents: Scalars["Boolean"];
}>;

export type ConsultantSearchCard_GetQuery = {
  consultantById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    LastContactDate?: Date | null;
    Name?: string | null;
    Phone?: string | null;
    Unfit: boolean;
    SocialSecurityNo?: string | null;
    Specializations: Array<string>;
    IsValid?: boolean | null;
    Professions?: Array<string | null> | null;
    PrescriptionCode?: string | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    Events?: Array<{
      _id: string;
      CanDelete: boolean;
      CanEdit: boolean;
      CanPin: boolean;
      CreatedOn: Date;
      Deleted: boolean;
      Description: string;
      DescriptionHtml: string;
      Sticky: boolean;
      Warning?: boolean | null;
      Links?: Array<string> | null;
      CreatedBy: { PersonId?: string | null; Name?: string | null };
      UpdatedBy: { Name?: string | null };
    }>;
    Availability: { ranges: Array<{ from: Date; to: Date }> };
    Address?: { City: string } | null;
    contactType?: {
      employeeSalaryClaim?: string | null;
      subcontractorSalaryClaim?: string | null;
    } | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ValidationErrors: Array<{
      Message: string;
      Params?: any | null;
      Type: NodeValidationErrorType;
    }>;
    expertise: { machines: Array<string>; systems: Array<string | null> };
  } | null;
};

export type ConsultantAreasOfExpertiseFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  Professions?: Array<string | null> | null;
  Specializations: Array<string>;
  Name?: string | null;
};

export type UploadConsultantContractDocumentMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type UploadConsultantContractDocumentMutation = {
  uploadDocument: { FileRef: { NodeID: string } };
};

export type ConsultantContractEditorConsultantDataFragment = {
  AvailableForWorkInCountries: Array<string>;
  BirthDate?: Date | null;
  LegalPersonType?: LegalPersonType | null;
  sithsCardNumber?: string | null;
  _id: string;
  AreasOfExpertise: Array<string>;
  Professions?: Array<string | null> | null;
  Specializations: Array<string>;
  Name?: string | null;
  ResponsiblePerson?: { PersonId: string } | null;
  contactType?: { employeeContractType?: ContractType | null } | null;
};

export type ConsultantContract_GetConsultantQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetConsultantQuery = {
  consultantById?: {
    AvailableForWorkInCountries: Array<string>;
    BirthDate?: Date | null;
    LegalPersonType?: LegalPersonType | null;
    sithsCardNumber?: string | null;
    _id: string;
    AreasOfExpertise: Array<string>;
    Professions?: Array<string | null> | null;
    Specializations: Array<string>;
    Name?: string | null;
    ResponsiblePerson?: { PersonId: string } | null;
    contactType?: { employeeContractType?: ContractType | null } | null;
  } | null;
  lastContract?: {
    _id?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    IsSigned?: boolean | null;
  } | null;
};

export type ConsultantContract_GetCustomerQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetCustomerQuery = {
  customerById?: {
    _id: string;
    Parents: Array<{ Id: string; Name: string }>;
    RegionRef: { Id: string; Name: string };
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
      Region: string;
    } | null;
  } | null;
};

export type ConsultantContractCustomerDataFragment = {
  _id: string;
  Parents: Array<{ Id: string; Name: string }>;
  RegionRef: { Id: string; Name: string };
  Address?: {
    StreetName: string;
    City: string;
    ZipCode: string;
    Country: string;
    Region: string;
  } | null;
};

export type ConsultantContract_EditMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
}>;

export type ConsultantContract_EditMutation = {
  editUnSignConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type ConsultantContract_AddUnSignMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
}>;

export type ConsultantContract_AddUnSignMutation = {
  addUnSignConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type ConsultantContract_SoftDeleteMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantContract_SoftDeleteMutation = {
  deleteConsultantContract: { _id?: string | null };
};

export type ConsultantContract_NullifyMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  nullify: Scalars["Boolean"];
}>;

export type ConsultantContract_NullifyMutation = {
  nullifyConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type ConsultantContract_UploadSignedMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  file?: InputMaybe<Scalars["Upload"]>;
  SignedOn?: InputMaybe<Scalars["Date"]>;
  SalaryChoice?: InputMaybe<ContractType>;
  expectedSalary?: InputMaybe<Scalars["String"]>;
  payoutType?: InputMaybe<ConsultantContractPayoutType>;
  bankCounselling?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ConsultantContract_UploadSignedMutation = {
  uploadSignedConsultantContract: {
    _id?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    ViewUrl?: string | null;
  };
};

export type PublishConsultantContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type PublishConsultantContractMutation = {
  publishContract: { contractUrl: string };
};

export type PublishConsultantBookingContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type PublishConsultantBookingContractMutation = {
  publishBookingContract: { contractUrl: string };
};

export type PublishConsultantContractViaWorkflowMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  forcePublish?: InputMaybe<Scalars["Boolean"]>;
}>;

export type PublishConsultantContractViaWorkflowMutation = {
  publishContractViaWorkflow: { contractUrl: string };
};

export type ContractAddressFragment = {
  Address?: { StreetName: string; City: string; ZipCode: string; Country: string } | null;
};

export type ContractDatesFragment = {
  StartDate?: string | null;
  EndDate?: string | null;
  Period?: string | null;
  pensionSolution?: ConsultantContractPensionSolution | null;
};

export type CompensationFragment = {
  Compensation?: {
    Price?: number | null;
    Type?: ConsultantContractPriceType | null;
  } | null;
};

export type SalaryFragment = {
  BasicPrice?: number | null;
  Bonus?: Array<{
    _id?: string | null;
    Type?: string | null;
    SalaryType?: ConsultantContractBonusType | null;
    Amount?: number | null;
    Currency?: Currency | null;
    Config?: any | null;
  } | null> | null;
  IntroductionPrice?: Array<{
    Currency?: Currency | null;
    Sum?: string | null;
    Description?: string | null;
  } | null> | null;
  SalaryRecords?: Array<{
    _id: string;
    articleNumber?: string | null;
    indexInWorkType?: number | null;
    deleted?: boolean | null;
    startDay?: PriceListDay | null;
    endDay?: PriceListDay | null;
    paidPer?: PayUnit | null;
    currency?: Currency | null;
    workType?: PriceListWorkType | null;
    from?: string | null;
    to?: string | null;
    period?: PayPeriod | null;
    priceMultiplier?: number | null;
    fixedPrice?: number | null;
    customPrice?: number | null;
  } | null> | null;
  highHolidays?: Array<{
    _id: string;
    isGreatHoliday?: boolean | null;
    option: { name?: string | null; listPosition?: number | null; _id: string };
  } | null> | null;
};

export type AccommodationTravelsAltFragment = {
  Accommodation?: {
    Type?: ConsultantContractAccommodationAlt | null;
    PossibleSupplement?: string | null;
    MaxCost?: {
      Currency?: Currency | null;
      Period?: ConsultantContractPeriod | null;
      Price?: number | null;
      SalaryType?: ConsultantContractSalaryType | null;
    } | null;
  } | null;
  Travels?: {
    Type?: ConsultantContractTravelsAlt | null;
    PossibleSupplement?: string | null;
    TravelTemplateValue?: number | null;
    MaxCost?: {
      Currency?: Currency | null;
      Period?: ConsultantContractTravelsPeriod | null;
      Price?: number | null;
      SalaryType?: ConsultantContractSalaryType | null;
    } | null;
  } | null;
};

export type ContractDataForDuplicationFragment = {
  _id?: string | null;
  pensionModel?: ContractPensionModel | null;
  ConsultantId?: string | null;
  Type?: ConsultantContractType | null;
  ParentContractId?: string | null;
  ContractPriceTemplateId?: string | null;
  CustomerName?: string | null;
  FileName?: string | null;
  Dates?: string | null;
  ExcludeAddress?: boolean | null;
  showOrgName?: boolean | null;
  hideDeptName?: boolean | null;
  PatientVisits?: string | null;
  InvestigationsNumber?: string | null;
  IsRegionDalarna?: boolean | null;
  ConsultantGetsPaidPer?: ConsultantGetsPaidPer | null;
  Profession?: string | null;
  Country?: string | null;
  Schedule?: string | null;
  Specializations?: Array<string | null> | null;
  DriverLicense?: boolean | null;
  OtherRequirements?: Array<string | null> | null;
  YoEx?: string | null;
  AreaOfExpertise?: string | null;
  Language?: string | null;
  SpecificRequirements?: Array<string | null> | null;
  Currency?: ConsultantContractCurrency | null;
  NotRelevantMonthlyWeeklyPayouts?: boolean | null;
  Overtime?: ConsultantContractOvertimeOpt | null;
  DateFrameworkContractTypeIsSigned?: string | null;
  isNationalProcurementPriceStrategy?: boolean | null;
  BasicPrice?: number | null;
  HospitalRef?: { Id: string; Name: string } | null;
  DepartmentsRefs?: Array<{ Id: string } | null> | null;
  Education?: { Show?: boolean | null; Text?: string | null } | null;
  Address?: { StreetName: string; City: string; ZipCode: string; Country: string } | null;
  Bonus?: Array<{
    _id?: string | null;
    Type?: string | null;
    SalaryType?: ConsultantContractBonusType | null;
    Amount?: number | null;
    Currency?: Currency | null;
    Config?: any | null;
  } | null> | null;
  IntroductionPrice?: Array<{
    Currency?: Currency | null;
    Sum?: string | null;
    Description?: string | null;
  } | null> | null;
  SalaryRecords?: Array<{
    _id: string;
    articleNumber?: string | null;
    indexInWorkType?: number | null;
    deleted?: boolean | null;
    startDay?: PriceListDay | null;
    endDay?: PriceListDay | null;
    paidPer?: PayUnit | null;
    currency?: Currency | null;
    workType?: PriceListWorkType | null;
    from?: string | null;
    to?: string | null;
    period?: PayPeriod | null;
    priceMultiplier?: number | null;
    fixedPrice?: number | null;
    customPrice?: number | null;
  } | null> | null;
  highHolidays?: Array<{
    _id: string;
    isGreatHoliday?: boolean | null;
    option: { name?: string | null; listPosition?: number | null; _id: string };
  } | null> | null;
  Accommodation?: {
    Type?: ConsultantContractAccommodationAlt | null;
    PossibleSupplement?: string | null;
    MaxCost?: {
      Currency?: Currency | null;
      Period?: ConsultantContractPeriod | null;
      Price?: number | null;
      SalaryType?: ConsultantContractSalaryType | null;
    } | null;
  } | null;
  Travels?: {
    Type?: ConsultantContractTravelsAlt | null;
    PossibleSupplement?: string | null;
    TravelTemplateValue?: number | null;
    MaxCost?: {
      Currency?: Currency | null;
      Period?: ConsultantContractTravelsPeriod | null;
      Price?: number | null;
      SalaryType?: ConsultantContractSalaryType | null;
    } | null;
  } | null;
};

export type ConsultantContractDetailsFragment = {
  SalaryChoice?: ContractType | null;
  SignedOn?: Date | null;
  PayoutType?: ConsultantContractPayoutType | null;
  _id?: string | null;
  pensionModel?: ContractPensionModel | null;
  ConsultantId?: string | null;
  Type?: ConsultantContractType | null;
  ParentContractId?: string | null;
  ContractPriceTemplateId?: string | null;
  CustomerName?: string | null;
  FileName?: string | null;
  Dates?: string | null;
  ExcludeAddress?: boolean | null;
  showOrgName?: boolean | null;
  hideDeptName?: boolean | null;
  PatientVisits?: string | null;
  InvestigationsNumber?: string | null;
  IsRegionDalarna?: boolean | null;
  ConsultantGetsPaidPer?: ConsultantGetsPaidPer | null;
  Profession?: string | null;
  Country?: string | null;
  Schedule?: string | null;
  Specializations?: Array<string | null> | null;
  DriverLicense?: boolean | null;
  OtherRequirements?: Array<string | null> | null;
  YoEx?: string | null;
  AreaOfExpertise?: string | null;
  Language?: string | null;
  SpecificRequirements?: Array<string | null> | null;
  Currency?: ConsultantContractCurrency | null;
  NotRelevantMonthlyWeeklyPayouts?: boolean | null;
  Overtime?: ConsultantContractOvertimeOpt | null;
  DateFrameworkContractTypeIsSigned?: string | null;
  isNationalProcurementPriceStrategy?: boolean | null;
  StartDate?: string | null;
  EndDate?: string | null;
  Period?: string | null;
  pensionSolution?: ConsultantContractPensionSolution | null;
  BasicPrice?: number | null;
  SpecificPeriodPrices?: Array<{
    _id: string;
    startDate: Date;
    endDate: Date;
    title?: string | null;
    price: number;
  } | null> | null;
  HospitalRef?: { Id: string; Name: string } | null;
  DepartmentsRefs?: Array<{ Id: string } | null> | null;
  Education?: { Show?: boolean | null; Text?: string | null } | null;
  Address?: { StreetName: string; City: string; ZipCode: string; Country: string } | null;
  Bonus?: Array<{
    _id?: string | null;
    Type?: string | null;
    SalaryType?: ConsultantContractBonusType | null;
    Amount?: number | null;
    Currency?: Currency | null;
    Config?: any | null;
  } | null> | null;
  IntroductionPrice?: Array<{
    Currency?: Currency | null;
    Sum?: string | null;
    Description?: string | null;
  } | null> | null;
  SalaryRecords?: Array<{
    _id: string;
    articleNumber?: string | null;
    indexInWorkType?: number | null;
    deleted?: boolean | null;
    startDay?: PriceListDay | null;
    endDay?: PriceListDay | null;
    paidPer?: PayUnit | null;
    currency?: Currency | null;
    workType?: PriceListWorkType | null;
    from?: string | null;
    to?: string | null;
    period?: PayPeriod | null;
    priceMultiplier?: number | null;
    fixedPrice?: number | null;
    customPrice?: number | null;
  } | null> | null;
  highHolidays?: Array<{
    _id: string;
    isGreatHoliday?: boolean | null;
    option: { name?: string | null; listPosition?: number | null; _id: string };
  } | null> | null;
  Accommodation?: {
    Type?: ConsultantContractAccommodationAlt | null;
    PossibleSupplement?: string | null;
    MaxCost?: {
      Currency?: Currency | null;
      Period?: ConsultantContractPeriod | null;
      Price?: number | null;
      SalaryType?: ConsultantContractSalaryType | null;
    } | null;
  } | null;
  Travels?: {
    Type?: ConsultantContractTravelsAlt | null;
    PossibleSupplement?: string | null;
    TravelTemplateValue?: number | null;
    MaxCost?: {
      Currency?: Currency | null;
      Period?: ConsultantContractTravelsPeriod | null;
      Price?: number | null;
      SalaryType?: ConsultantContractSalaryType | null;
    } | null;
  } | null;
};

export type ConsultantContract_GetByIdForEditQueryVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetByIdForEditQuery = {
  getConsultantContractDetailInfo: {
    _id?: string | null;
    SalaryChoice?: ContractType | null;
    SignedOn?: Date | null;
    PayoutType?: ConsultantContractPayoutType | null;
    pensionModel?: ContractPensionModel | null;
    ConsultantId?: string | null;
    Type?: ConsultantContractType | null;
    ParentContractId?: string | null;
    ContractPriceTemplateId?: string | null;
    CustomerName?: string | null;
    FileName?: string | null;
    Dates?: string | null;
    ExcludeAddress?: boolean | null;
    showOrgName?: boolean | null;
    hideDeptName?: boolean | null;
    PatientVisits?: string | null;
    InvestigationsNumber?: string | null;
    IsRegionDalarna?: boolean | null;
    ConsultantGetsPaidPer?: ConsultantGetsPaidPer | null;
    Profession?: string | null;
    Country?: string | null;
    Schedule?: string | null;
    Specializations?: Array<string | null> | null;
    DriverLicense?: boolean | null;
    OtherRequirements?: Array<string | null> | null;
    YoEx?: string | null;
    AreaOfExpertise?: string | null;
    Language?: string | null;
    SpecificRequirements?: Array<string | null> | null;
    Currency?: ConsultantContractCurrency | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    Overtime?: ConsultantContractOvertimeOpt | null;
    DateFrameworkContractTypeIsSigned?: string | null;
    isNationalProcurementPriceStrategy?: boolean | null;
    StartDate?: string | null;
    EndDate?: string | null;
    Period?: string | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    BasicPrice?: number | null;
    SpecificPeriodPrices?: Array<{
      _id: string;
      startDate: Date;
      endDate: Date;
      title?: string | null;
      price: number;
    } | null> | null;
    HospitalRef?: { Id: string; Name: string } | null;
    DepartmentsRefs?: Array<{ Id: string } | null> | null;
    Education?: { Show?: boolean | null; Text?: string | null } | null;
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
    } | null;
    Bonus?: Array<{
      _id?: string | null;
      Type?: string | null;
      SalaryType?: ConsultantContractBonusType | null;
      Amount?: number | null;
      Currency?: Currency | null;
      Config?: any | null;
    } | null> | null;
    IntroductionPrice?: Array<{
      Currency?: Currency | null;
      Sum?: string | null;
      Description?: string | null;
    } | null> | null;
    SalaryRecords?: Array<{
      _id: string;
      articleNumber?: string | null;
      indexInWorkType?: number | null;
      deleted?: boolean | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
    } | null> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    } | null> | null;
    Accommodation?: {
      Type?: ConsultantContractAccommodationAlt | null;
      PossibleSupplement?: string | null;
      MaxCost?: {
        Currency?: Currency | null;
        Period?: ConsultantContractPeriod | null;
        Price?: number | null;
        SalaryType?: ConsultantContractSalaryType | null;
      } | null;
    } | null;
    Travels?: {
      Type?: ConsultantContractTravelsAlt | null;
      PossibleSupplement?: string | null;
      TravelTemplateValue?: number | null;
      MaxCost?: {
        Currency?: Currency | null;
        Period?: ConsultantContractTravelsPeriod | null;
        Price?: number | null;
        SalaryType?: ConsultantContractSalaryType | null;
      } | null;
    } | null;
  };
};

export type ConsultantContract_GetByIdForDuplicationQueryVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetByIdForDuplicationQuery = {
  getConsultantContractDetailInfo: {
    _id?: string | null;
    pensionModel?: ContractPensionModel | null;
    ConsultantId?: string | null;
    Type?: ConsultantContractType | null;
    ParentContractId?: string | null;
    ContractPriceTemplateId?: string | null;
    CustomerName?: string | null;
    FileName?: string | null;
    Dates?: string | null;
    ExcludeAddress?: boolean | null;
    showOrgName?: boolean | null;
    hideDeptName?: boolean | null;
    PatientVisits?: string | null;
    InvestigationsNumber?: string | null;
    IsRegionDalarna?: boolean | null;
    ConsultantGetsPaidPer?: ConsultantGetsPaidPer | null;
    Profession?: string | null;
    Country?: string | null;
    Schedule?: string | null;
    Specializations?: Array<string | null> | null;
    DriverLicense?: boolean | null;
    OtherRequirements?: Array<string | null> | null;
    YoEx?: string | null;
    AreaOfExpertise?: string | null;
    Language?: string | null;
    SpecificRequirements?: Array<string | null> | null;
    Currency?: ConsultantContractCurrency | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    Overtime?: ConsultantContractOvertimeOpt | null;
    DateFrameworkContractTypeIsSigned?: string | null;
    isNationalProcurementPriceStrategy?: boolean | null;
    BasicPrice?: number | null;
    SpecificPeriodPrices?: Array<{ title?: string | null; price: number } | null> | null;
    HospitalRef?: { Id: string; Name: string } | null;
    DepartmentsRefs?: Array<{ Id: string } | null> | null;
    Education?: { Show?: boolean | null; Text?: string | null } | null;
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
    } | null;
    Bonus?: Array<{
      _id?: string | null;
      Type?: string | null;
      SalaryType?: ConsultantContractBonusType | null;
      Amount?: number | null;
      Currency?: Currency | null;
      Config?: any | null;
    } | null> | null;
    IntroductionPrice?: Array<{
      Currency?: Currency | null;
      Sum?: string | null;
      Description?: string | null;
    } | null> | null;
    SalaryRecords?: Array<{
      _id: string;
      articleNumber?: string | null;
      indexInWorkType?: number | null;
      deleted?: boolean | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
    } | null> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    } | null> | null;
    Accommodation?: {
      Type?: ConsultantContractAccommodationAlt | null;
      PossibleSupplement?: string | null;
      MaxCost?: {
        Currency?: Currency | null;
        Period?: ConsultantContractPeriod | null;
        Price?: number | null;
        SalaryType?: ConsultantContractSalaryType | null;
      } | null;
    } | null;
    Travels?: {
      Type?: ConsultantContractTravelsAlt | null;
      PossibleSupplement?: string | null;
      TravelTemplateValue?: number | null;
      MaxCost?: {
        Currency?: Currency | null;
        Period?: ConsultantContractTravelsPeriod | null;
        Price?: number | null;
        SalaryType?: ConsultantContractSalaryType | null;
      } | null;
    } | null;
  };
};

export type ConsultantContract_GetByIdForConfirmationQueryVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetByIdForConfirmationQuery = {
  getConsultantContractDetailInfo: {
    _id?: string | null;
    Type?: ConsultantContractType | null;
    Profession?: string | null;
    Country?: string | null;
    SignedOn?: Date | null;
    ConsultantId?: string | null;
    SalaryChoice?: ContractType | null;
    isNationalProcurementPriceStrategy?: boolean | null;
    BasicPrice?: number | null;
    SpecificPeriodPrices?: Array<{
      _id: string;
      startDate: Date;
      endDate: Date;
      title?: string | null;
      price: number;
    } | null> | null;
    Bonus?: Array<{
      _id?: string | null;
      Type?: string | null;
      SalaryType?: ConsultantContractBonusType | null;
      Amount?: number | null;
      Currency?: Currency | null;
      Config?: any | null;
    } | null> | null;
    IntroductionPrice?: Array<{
      Currency?: Currency | null;
      Sum?: string | null;
      Description?: string | null;
    } | null> | null;
    SalaryRecords?: Array<{
      _id: string;
      articleNumber?: string | null;
      indexInWorkType?: number | null;
      deleted?: boolean | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
    } | null> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    } | null> | null;
  };
};

export type ConsultantContract_GetHighHolidaysQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ConsultantContract_GetHighHolidaysQuery = {
  getHighHolidays: Array<{
    name?: string | null;
    listPosition?: number | null;
    _id: string;
  }>;
};

export type ConsultantContract_GetCustomerPriceListQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type ConsultantContract_GetCustomerPriceListQuery = {
  getCustomerContractPriceLists: Array<{
    _id: string;
    contractNumber?: string | null;
    priceLists: Array<{
      name?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      priceGroups: Array<{
        _id: string;
        professionsPrice: Array<{
          profession: { areaOfExpertise?: string | null; name?: string | null };
        }>;
        highHolidays: Array<{
          _id: string;
          isGreatHoliday?: boolean | null;
          option: { name?: string | null; listPosition?: number | null; _id: string };
        }>;
        records: Array<{
          _id: string;
          articleNumber?: string | null;
          articleNumberForOtherSpeciality?: string | null;
          indexInWorkType?: number | null;
          startDay?: PriceListDay | null;
          endDay?: PriceListDay | null;
          paidPer?: PayUnit | null;
          currency?: Currency | null;
          workType?: PriceListWorkType | null;
          from?: string | null;
          to?: string | null;
          period?: PayPeriod | null;
          priceMultiplier?: number | null;
          fixedPrice?: number | null;
          customPrice?: number | null;
          deleted?: boolean | null;
          isSecondPass?: boolean | null;
        }>;
      }>;
    }>;
  }>;
  consultantBookingContracts: Array<{
    Period?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;
    ResponsiblePersonId?: string | null;
    SignedOn?: Date | null;
    _id?: string | null;
    ConsultantId?: string | null;
    ContractPriceTemplateId?: string | null;
    hideDeptName?: boolean | null;
    hideHospitalName?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    OtherInfo?: string | null;
    AreaOfExpertise?: Array<string | null> | null;
    Price?: string | null;
    Schedule?: string | null;
    Recipients?: Array<string | null> | null;
    SpecificRequirements?: Array<string | null> | null;
    Profession?: string | null;
    sithsCardNumber?: string | null;
    BasicPrice?: number | null;
    DepartmentsRefs?: { Id: string; Name: string } | null;
    HospitalRef?: { Id: string; Name: string } | null;
    ContactPerson?: {
      Name?: string | null;
      Phone?: string | null;
      Email?: string | null;
      Title?: string | null;
    } | null;
    PriceRecruitment?: {
      Currency?: ConsultantContractCurrency | null;
      R_0_159?: number | null;
      R_160_499?: number | null;
      R_500_699?: number | null;
      R_700_899?: number | null;
      R_900_1200?: number | null;
    } | null;
    SpecificPeriodPrices?: Array<{
      _id: string;
      startDate: Date;
      endDate: Date;
      title?: string | null;
      price: number;
    } | null> | null;
    Bonus?: Array<{
      _id?: string | null;
      Type?: string | null;
      SalaryType?: ConsultantContractBonusType | null;
      Amount?: number | null;
      Currency?: Currency | null;
      Config?: any | null;
    } | null> | null;
    Address?: {
      StreetName: string;
      City: string;
      ZipCode: string;
      Country: string;
    } | null;
    IntroductionPrice?: Array<{
      Currency?: Currency | null;
      Sum?: string | null;
      Description?: string | null;
    } | null> | null;
    SalaryRecords?: Array<{
      _id: string;
      articleNumber?: string | null;
      indexInWorkType?: number | null;
      deleted?: boolean | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
    } | null> | null;
    highHolidays?: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    } | null> | null;
  }>;
};

export type ConsultantContract_GetConsultantPayoutByYearQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetConsultantPayoutByYearQuery = {
  getConsultantPayoutByYear: Array<{
    total: number;
    totalNationalProcurement: number;
    totalNonNationalProcurement: number;
    year: number;
  } | null>;
};

export type SendEmailMutationVariables = Exact<{
  input?: InputMaybe<EmailInput>;
}>;

export type SendEmailMutation = { sendEmail?: string | null };

export type ConsultantContract_GetParentOrganizationTypeQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetParentOrganizationTypeQuery = {
  customerById?: { OrganizationType?: OrganizationType | null } | null;
};

export type ConsultantContract_GetContractsByConsultantIdQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantContract_GetContractsByConsultantIdQuery = {
  getConsultantContracts: Array<{
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  }>;
};

export type ConsultantContract_SendEmailMutationVariables = Exact<{
  subject: Scalars["String"];
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  attachment?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type ConsultantContract_SendEmailMutation = {
  sendConsultantContractEmailToConsultant?: { Subject: string; Body: string } | null;
};

export type ConsultantContract_AddSalaryChoiceMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  salaryChoice: ContractType;
}>;

export type ConsultantContract_AddSalaryChoiceMutation = {
  addSalaryChoiceToConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type ConsultantQuality_ConsultantFragment = {
  _id: string;
  AvailableForWorkInCountries: Array<string>;
  Name?: string | null;
  SocialSecurityNo?: string | null;
  Unfit: boolean;
  UnfitComment: string;
  EmailValid: boolean;
  PhoneValid: boolean;
  CellPhoneValid: boolean;
  AreasOfExpertise: Array<string>;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  QualityPerCountry: Array<{
    Country: string;
    QualityChecks: Array<{
      _id: string;
      Country: string;
      templateName: string;
      Disabled: boolean;
      DisabledMsg?: string | null;
      DocumentType?: string | null;
      Name: string;
      StatusSetOn?: Date | null;
      ExpiresOn?: Date | null;
      HasExpired?: boolean | null;
      ExpiresSoon?: boolean | null;
      HasDocument: boolean;
      AvailableStatuses: Array<{
        IsDocumentRequired: boolean;
        Name: string;
        WithDocument: boolean;
        IsCommentRequired: boolean;
        WithComment: boolean;
        Disabled?: boolean | null;
        DisabledMsg?: string | null;
      }>;
      Status?:
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresInMonths: number;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
            pausedState?: {
              isPaused: boolean;
              wasPaused: boolean;
              pausedOn: Date;
              pausedUntil: Date;
            } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresInMonths: number;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
            pausedState?: {
              isPaused: boolean;
              wasPaused: boolean;
              pausedOn: Date;
              pausedUntil: Date;
            } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | null;
      StatusSetBy?: { Name: string; PersonId: string } | null;
    }>;
  }>;
  UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
};

export type ConsultantProfile_ConsultantFragment = {
  LegalBasis?: LegalBasis | null;
  ContractSigned?: boolean | null;
  canCreateContractCheck: Array<string>;
  LegalPersonType?: LegalPersonType | null;
  Professions?: Array<string | null> | null;
  AvailableForWorkInCountries: Array<string>;
  DocumentTypes: Array<string>;
  Intro?: string | null;
  Teams: Array<string>;
  SocialSecurityNo?: string | null;
  Name?: string | null;
  welcomeEmail?: boolean | null;
  welcomeEmailSetOn?: Date | null;
  welcomeEmailSetBy?: string | null;
  bookingStatus: ConsultantBookingStatus;
  _id: string;
  AreasOfExpertise: Array<string>;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  Email?: string | null;
  secondaryEmail?: string | null;
  LastContactDate?: Date | null;
  Phone?: string | null;
  Unfit: boolean;
  Specializations: Array<string>;
  IsValid?: boolean | null;
  PrescriptionCode?: string | null;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  UnfitComment: string;
  EmailValid: boolean;
  PhoneValid: boolean;
  CellPhoneValid: boolean;
  consultantId: string;
  Availability: { weeks: Array<Date>; ranges: Array<{ from: Date; to: Date }> };
  Documents: Array<{
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  }>;
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
    dateGranted?: Date | null;
    dateRevoked?: Date | null;
    communicationChannel: GDPRCommunicationChannel;
    grantedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    revokedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  } | null> | null;
  UserSettings: { Enabled: boolean };
  Address?: { City: string } | null;
  contactType?: {
    employeeSalaryClaim?: string | null;
    subcontractorSalaryClaim?: string | null;
  } | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
  expertise: { machines: Array<string>; systems: Array<string | null> };
  QualityPerCountry: Array<{
    Country: string;
    QualityChecks: Array<{
      _id: string;
      Country: string;
      templateName: string;
      Disabled: boolean;
      DisabledMsg?: string | null;
      DocumentType?: string | null;
      Name: string;
      StatusSetOn?: Date | null;
      ExpiresOn?: Date | null;
      HasExpired?: boolean | null;
      ExpiresSoon?: boolean | null;
      HasDocument: boolean;
      AvailableStatuses: Array<{
        IsDocumentRequired: boolean;
        Name: string;
        WithDocument: boolean;
        IsCommentRequired: boolean;
        WithComment: boolean;
        Disabled?: boolean | null;
        DisabledMsg?: string | null;
      }>;
      Status?:
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresInMonths: number;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
            pausedState?: {
              isPaused: boolean;
              wasPaused: boolean;
              pausedOn: Date;
              pausedUntil: Date;
            } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresInMonths: number;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
            pausedState?: {
              isPaused: boolean;
              wasPaused: boolean;
              pausedOn: Date;
              pausedUntil: Date;
            } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | null;
      StatusSetBy?: { Name: string; PersonId: string } | null;
    }>;
  }>;
  UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  generalInterest?: {
    __typename: "ConsultantGeneralInterest";
    regions: Array<string>;
    workshifts: Array<Workshift>;
    comment: string;
  } | null;
};

export type GDPRConsentRecordsFragment = {
  type: GDPRConsentType;
  granted?: boolean | null;
  dateGranted?: Date | null;
  dateRevoked?: Date | null;
  communicationChannel: GDPRCommunicationChannel;
  grantedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  revokedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
};

export type ConsultantEditorConsultantDataFragment = {
  _id: string;
  ResponsiblePerson?: { Name: string; PersonId: string } | null;
  expertise: {
    professions?: Array<
      | {
          __typename: "DoctorProfession";
          professionName: string;
          systems: Array<string>;
          certifiedFrom?: string | null;
          code?: string | null;
          areasOfExpertise: Array<{
            name: string;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
            yearFrom?: string | null;
            open?: boolean | null;
            specializations: Array<{
              name: string;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
            }>;
          }>;
        }
      | {
          __typename: "GenericProfession";
          professionName: string;
          systems: Array<string>;
          certifiedFrom?: string | null;
          specializations: Array<{
            name: string;
            yearFrom?: string | null;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
          }>;
        }
      | {
          __typename: "NurseProfession";
          professionName: string;
          systems: Array<string>;
          certifiedFrom?: string | null;
          code?: string | null;
          areasOfExpertise: Array<{
            name: string;
            qualified?: boolean | null;
            yearFrom?: string | null;
            interested: boolean;
            comment?: string | null;
          }>;
          specializations: Array<{
            name: string;
            yearFrom?: string | null;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
          }>;
        }
      | {
          __typename: "PsykologProfession";
          professionName: string;
          systems: Array<string>;
          methods?: Array<string> | null;
          certifiedFrom?: string | null;
          specializations: Array<{
            name: string;
            yearFrom?: string | null;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
          }>;
        }
      | {
          __typename: "RadioNurseProfession";
          professionName: string;
          systems: Array<string>;
          machines: Array<string>;
          certifiedFrom?: string | null;
          specializations: Array<{
            name: string;
            yearFrom?: string | null;
            interested: boolean;
            qualified?: boolean | null;
            comment?: string | null;
          }>;
        }
      | {
          __typename: "SocionomProfession";
          professionName: string;
          systems: Array<string>;
          educations: Array<string>;
          certifiedFrom?: string | null;
          areasOfExpertise: Array<{
            name: string;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
            yearFrom?: string | null;
            open?: boolean | null;
            specializations: Array<{
              name: string;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
            }>;
          }>;
        }
      | {
          __typename: "TeacherProfession";
          professionName: string;
          systems: Array<string>;
          certifiedFrom?: string | null;
          digitalCompetence: Array<string>;
          schoolPlatforms: Array<string>;
          areasOfExpertise: Array<{
            name: string;
            certifiedFrom?: string | null;
            selected: boolean;
            specializations: Array<{
              name: string;
              qualified?: boolean | null;
              interestedIn: boolean;
              experience?: string | null;
            }>;
          }>;
        }
    > | null;
  };
};

export type ConsultantEditor_GetFormQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantEditor_GetFormQuery = {
  consultantFormById: {
    consultantId: string;
    isNew: boolean;
    status?: ConsultantStatus | null;
    knownSystems?: Array<string | null> | null;
    extraCurriculum?: string | null;
    address: { city: string; country: string; streetName: string; zipCode: string };
    competitors: { items: Array<string> };
    contacts: {
      cellPhone: string;
      email: string;
      secondaryEmail: string;
      initialContact?: InitialContact | null;
      selfRegisterOption?: SelfRegisterOption | null;
      phone: string;
      preferredCommunication: Array<PreferredCommunication>;
      recommendedByConsultant?: { label?: string | null; value: string } | null;
    };
    contactType: {
      clearingNumber?: string | null;
      accountNumber?: string | null;
      companyName: string;
      ssn: string;
      type?: LegalPersonType | null;
      externalTaxNumber?: string | null;
      employeeSalaryClaim?: string | null;
      subcontractorSalaryClaim?: string | null;
      receiveWorkBreakdownByEmail?: boolean | null;
      emailForSelfInvoicing?: string | null;
      FTaxChecked?: boolean | null;
      VATChecked?: boolean | null;
      rate?: string | null;
      increasedRate?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      employeeContractType?: ContractType | null;
      businessAddress?: {
        city: string;
        country: string;
        streetName: string;
        zipCode: string;
      } | null;
    };
    education: {
      items: Array<{
        courseLocation: string;
        courseName: string;
        isCourse?: boolean | null;
        fromYear?: string | null;
        fromMonth?: string | null;
        toYear?: string | null;
        toMonth?: string | null;
        educationType?: string | null;
      }>;
    };
    emergencyContacts: {
      items: Array<{ name: string; phone: string; relation: string }>;
    };
    employeeNumber: {
      employeeNumber: string;
      employeeNumber2: string;
      employeeNumber3: string;
    };
    languageSkills?: { items: Array<{ level: LanguageSkillLevel; name: string }> } | null;
    personal: {
      intro: string;
      about: string;
      countries: Array<string>;
      norwayConsultantStatus?: NorwayConsultantStatus | null;
      firstComment: string;
      firstName: string;
      hasDrivingLicence: boolean;
      drivingLicenceType?: DrivingLicenceTypeInput | null;
      important: string;
      lastName: string;
      norwegianSsn: string;
      commentAuthorization: string;
      isWorkedNorway: boolean;
      isApprovedAuthorization: boolean;
      hprNumber: string;
      ssn: string;
      travelPreferences: string;
      accommodationPreferences: string;
      care: string;
    };
    prescriptionCode: { code: string };
    workExperience: {
      items: Array<{
        areaOfExpertise: string;
        roles: string;
        fromYear?: string | null;
        fromMonth?: string | null;
        toYear?: string | null;
        toMonth?: string | null;
        workType: string;
        workPlace: string;
        departmentIds?: Array<string | null> | null;
        competitors?: Array<string | null> | null;
        employmentType?: LegalPersonType | null;
        experience?: string | null;
        excludeFromPresentation?: boolean | null;
        customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
      } | null>;
    };
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
      communicationChannel: GDPRCommunicationChannel;
    } | null> | null;
  };
  consultantById?: {
    _id: string;
    ResponsiblePerson?: { Name: string; PersonId: string } | null;
    expertise: {
      professions?: Array<
        | {
            __typename: "DoctorProfession";
            professionName: string;
            systems: Array<string>;
            certifiedFrom?: string | null;
            code?: string | null;
            areasOfExpertise: Array<{
              name: string;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
              yearFrom?: string | null;
              open?: boolean | null;
              specializations: Array<{
                name: string;
                qualified?: boolean | null;
                interested: boolean;
                comment?: string | null;
              }>;
            }>;
          }
        | {
            __typename: "GenericProfession";
            professionName: string;
            systems: Array<string>;
            certifiedFrom?: string | null;
            specializations: Array<{
              name: string;
              yearFrom?: string | null;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
            }>;
          }
        | {
            __typename: "NurseProfession";
            professionName: string;
            systems: Array<string>;
            certifiedFrom?: string | null;
            code?: string | null;
            areasOfExpertise: Array<{
              name: string;
              qualified?: boolean | null;
              yearFrom?: string | null;
              interested: boolean;
              comment?: string | null;
            }>;
            specializations: Array<{
              name: string;
              yearFrom?: string | null;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
            }>;
          }
        | {
            __typename: "PsykologProfession";
            professionName: string;
            systems: Array<string>;
            methods?: Array<string> | null;
            certifiedFrom?: string | null;
            specializations: Array<{
              name: string;
              yearFrom?: string | null;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
            }>;
          }
        | {
            __typename: "RadioNurseProfession";
            professionName: string;
            systems: Array<string>;
            machines: Array<string>;
            certifiedFrom?: string | null;
            specializations: Array<{
              name: string;
              yearFrom?: string | null;
              interested: boolean;
              qualified?: boolean | null;
              comment?: string | null;
            }>;
          }
        | {
            __typename: "SocionomProfession";
            professionName: string;
            systems: Array<string>;
            educations: Array<string>;
            certifiedFrom?: string | null;
            areasOfExpertise: Array<{
              name: string;
              qualified?: boolean | null;
              interested: boolean;
              comment?: string | null;
              yearFrom?: string | null;
              open?: boolean | null;
              specializations: Array<{
                name: string;
                qualified?: boolean | null;
                interested: boolean;
                comment?: string | null;
              }>;
            }>;
          }
        | {
            __typename: "TeacherProfession";
            professionName: string;
            systems: Array<string>;
            certifiedFrom?: string | null;
            digitalCompetence: Array<string>;
            schoolPlatforms: Array<string>;
            areasOfExpertise: Array<{
              name: string;
              certifiedFrom?: string | null;
              selected: boolean;
              specializations: Array<{
                name: string;
                qualified?: boolean | null;
                interestedIn: boolean;
                experience?: string | null;
              }>;
            }>;
          }
      > | null;
    };
  } | null;
};

export type ConsultantEditor_GetDepartmentsQueryVariables = Exact<{
  hospitalIds?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type ConsultantEditor_GetDepartmentsQuery = {
  departments: {
    dbTime?: number | null;
    items: Array<{
      _id: string;
      Name?: string | null;
      DirectParent?: { Id: string } | null;
    }>;
  };
};

export type ConsultantEditor_UpdateStatusMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  status: ConsultantStatus;
}>;

export type ConsultantEditor_UpdateStatusMutation = {
  updateConsultantStatus?: {
    _id: string;
    Name?: string | null;
    Status?: ConsultantStatus | null;
  } | null;
};

export type ConsultantEditor_ImportCVMutationVariables = Exact<{
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  file: Scalars["Upload"];
}>;

export type ConsultantEditor_ImportCVMutation = {
  importCV: {
    consultantId: string;
    isNew: boolean;
    status?: ConsultantStatus | null;
    knownSystems?: Array<string | null> | null;
    extraCurriculum?: string | null;
    address: { city: string; country: string; streetName: string; zipCode: string };
    competitors: { items: Array<string> };
    contacts: {
      cellPhone: string;
      email: string;
      secondaryEmail: string;
      initialContact?: InitialContact | null;
      selfRegisterOption?: SelfRegisterOption | null;
      phone: string;
      preferredCommunication: Array<PreferredCommunication>;
      recommendedByConsultant?: { label?: string | null; value: string } | null;
    };
    contactType: {
      clearingNumber?: string | null;
      accountNumber?: string | null;
      companyName: string;
      ssn: string;
      type?: LegalPersonType | null;
      externalTaxNumber?: string | null;
      employeeSalaryClaim?: string | null;
      subcontractorSalaryClaim?: string | null;
      receiveWorkBreakdownByEmail?: boolean | null;
      emailForSelfInvoicing?: string | null;
      FTaxChecked?: boolean | null;
      VATChecked?: boolean | null;
      rate?: string | null;
      increasedRate?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      employeeContractType?: ContractType | null;
      businessAddress?: {
        city: string;
        country: string;
        streetName: string;
        zipCode: string;
      } | null;
    };
    education: {
      items: Array<{
        courseLocation: string;
        courseName: string;
        isCourse?: boolean | null;
        fromYear?: string | null;
        fromMonth?: string | null;
        toYear?: string | null;
        toMonth?: string | null;
        educationType?: string | null;
      }>;
    };
    emergencyContacts: {
      items: Array<{ name: string; phone: string; relation: string }>;
    };
    employeeNumber: {
      employeeNumber: string;
      employeeNumber2: string;
      employeeNumber3: string;
    };
    languageSkills?: { items: Array<{ level: LanguageSkillLevel; name: string }> } | null;
    personal: {
      intro: string;
      about: string;
      countries: Array<string>;
      norwayConsultantStatus?: NorwayConsultantStatus | null;
      firstComment: string;
      firstName: string;
      hasDrivingLicence: boolean;
      drivingLicenceType?: DrivingLicenceTypeInput | null;
      important: string;
      lastName: string;
      norwegianSsn: string;
      commentAuthorization: string;
      isWorkedNorway: boolean;
      isApprovedAuthorization: boolean;
      hprNumber: string;
      ssn: string;
      travelPreferences: string;
      accommodationPreferences: string;
      care: string;
    };
    prescriptionCode: { code: string };
    workExperience: {
      items: Array<{
        areaOfExpertise: string;
        roles: string;
        fromYear?: string | null;
        fromMonth?: string | null;
        toYear?: string | null;
        toMonth?: string | null;
        workType: string;
        workPlace: string;
        departmentIds?: Array<string | null> | null;
        competitors?: Array<string | null> | null;
        employmentType?: LegalPersonType | null;
        experience?: string | null;
        excludeFromPresentation?: boolean | null;
        customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
      } | null>;
    };
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
      communicationChannel: GDPRCommunicationChannel;
    } | null> | null;
  };
};

export type ConsultantEditor_SubmitMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantFormInput;
  file?: InputMaybe<Scalars["Upload"]>;
}>;

export type ConsultantEditor_SubmitMutation = {
  submitConsultantForm: {
    OK: boolean;
    Errors?: Array<string> | null;
    Consultant?: {
      LegalBasis?: LegalBasis | null;
      ContractSigned?: boolean | null;
      canCreateContractCheck: Array<string>;
      LegalPersonType?: LegalPersonType | null;
      Professions?: Array<string | null> | null;
      AvailableForWorkInCountries: Array<string>;
      DocumentTypes: Array<string>;
      Intro?: string | null;
      Teams: Array<string>;
      SocialSecurityNo?: string | null;
      Name?: string | null;
      welcomeEmail?: boolean | null;
      welcomeEmailSetOn?: Date | null;
      welcomeEmailSetBy?: string | null;
      bookingStatus: ConsultantBookingStatus;
      _id: string;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Phone?: string | null;
      Unfit: boolean;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      UnfitComment: string;
      EmailValid: boolean;
      PhoneValid: boolean;
      CellPhoneValid: boolean;
      consultantId: string;
      Availability: { weeks: Array<Date>; ranges: Array<{ from: Date; to: Date }> };
      Documents: Array<{
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      }>;
      GDPRConsentRecords?: Array<{
        type: GDPRConsentType;
        granted?: boolean | null;
        dateGranted?: Date | null;
        dateRevoked?: Date | null;
        communicationChannel: GDPRCommunicationChannel;
        grantedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
        revokedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
      } | null> | null;
      UserSettings: { Enabled: boolean };
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: { machines: Array<string>; systems: Array<string | null> };
      QualityPerCountry: Array<{
        Country: string;
        QualityChecks: Array<{
          _id: string;
          Country: string;
          templateName: string;
          Disabled: boolean;
          DisabledMsg?: string | null;
          DocumentType?: string | null;
          Name: string;
          StatusSetOn?: Date | null;
          ExpiresOn?: Date | null;
          HasExpired?: boolean | null;
          ExpiresSoon?: boolean | null;
          HasDocument: boolean;
          AvailableStatuses: Array<{
            IsDocumentRequired: boolean;
            Name: string;
            WithDocument: boolean;
            IsCommentRequired: boolean;
            WithComment: boolean;
            Disabled?: boolean | null;
            DisabledMsg?: string | null;
          }>;
          Status?:
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                ExpiresInMonths: number;
                ExpiresOn?: Date | null;
                params?: any | null;
                SetBy?: { Name: string; PersonId: string } | null;
                pausedState?: {
                  isPaused: boolean;
                  wasPaused: boolean;
                  pausedOn: Date;
                  pausedUntil: Date;
                } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                ExpiresInMonths: number;
                ExpiresOn?: Date | null;
                params?: any | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                ExpiresOn?: Date | null;
                params?: any | null;
                SetBy?: { Name: string; PersonId: string } | null;
                pausedState?: {
                  isPaused: boolean;
                  wasPaused: boolean;
                  pausedOn: Date;
                  pausedUntil: Date;
                } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                params?: any | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                params?: any | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | {
                Name: string;
                Comment: string;
                SetOn?: Date | null;
                ExpiresOn?: Date | null;
                SetBy?: { Name: string; PersonId: string } | null;
              }
            | null;
          StatusSetBy?: { Name: string; PersonId: string } | null;
        }>;
      }>;
      UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
      generalInterest?: {
        __typename: "ConsultantGeneralInterest";
        regions: Array<string>;
        workshifts: Array<Workshift>;
        comment: string;
      } | null;
    } | null;
    ConsultantForm?: {
      consultantId: string;
      isNew: boolean;
      status?: ConsultantStatus | null;
      knownSystems?: Array<string | null> | null;
      extraCurriculum?: string | null;
      address: { city: string; country: string; streetName: string; zipCode: string };
      competitors: { items: Array<string> };
      contacts: {
        cellPhone: string;
        email: string;
        secondaryEmail: string;
        initialContact?: InitialContact | null;
        selfRegisterOption?: SelfRegisterOption | null;
        phone: string;
        preferredCommunication: Array<PreferredCommunication>;
        recommendedByConsultant?: { label?: string | null; value: string } | null;
      };
      contactType: {
        clearingNumber?: string | null;
        accountNumber?: string | null;
        companyName: string;
        ssn: string;
        type?: LegalPersonType | null;
        externalTaxNumber?: string | null;
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
        receiveWorkBreakdownByEmail?: boolean | null;
        emailForSelfInvoicing?: string | null;
        FTaxChecked?: boolean | null;
        VATChecked?: boolean | null;
        rate?: string | null;
        increasedRate?: string | null;
        startDate?: Date | null;
        endDate?: Date | null;
        employeeContractType?: ContractType | null;
        businessAddress?: {
          city: string;
          country: string;
          streetName: string;
          zipCode: string;
        } | null;
      };
      education: {
        items: Array<{
          courseLocation: string;
          courseName: string;
          isCourse?: boolean | null;
          fromYear?: string | null;
          fromMonth?: string | null;
          toYear?: string | null;
          toMonth?: string | null;
          educationType?: string | null;
        }>;
      };
      emergencyContacts: {
        items: Array<{ name: string; phone: string; relation: string }>;
      };
      employeeNumber: {
        employeeNumber: string;
        employeeNumber2: string;
        employeeNumber3: string;
      };
      languageSkills?: {
        items: Array<{ level: LanguageSkillLevel; name: string }>;
      } | null;
      personal: {
        intro: string;
        about: string;
        countries: Array<string>;
        norwayConsultantStatus?: NorwayConsultantStatus | null;
        firstComment: string;
        firstName: string;
        hasDrivingLicence: boolean;
        drivingLicenceType?: DrivingLicenceTypeInput | null;
        important: string;
        lastName: string;
        norwegianSsn: string;
        commentAuthorization: string;
        isWorkedNorway: boolean;
        isApprovedAuthorization: boolean;
        hprNumber: string;
        ssn: string;
        travelPreferences: string;
        accommodationPreferences: string;
        care: string;
      };
      prescriptionCode: { code: string };
      workExperience: {
        items: Array<{
          areaOfExpertise: string;
          roles: string;
          fromYear?: string | null;
          fromMonth?: string | null;
          toYear?: string | null;
          toMonth?: string | null;
          workType: string;
          workPlace: string;
          departmentIds?: Array<string | null> | null;
          competitors?: Array<string | null> | null;
          employmentType?: LegalPersonType | null;
          experience?: string | null;
          excludeFromPresentation?: boolean | null;
          customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
        } | null>;
      };
      GDPRConsentRecords?: Array<{
        type: GDPRConsentType;
        granted?: boolean | null;
        communicationChannel: GDPRCommunicationChannel;
      } | null> | null;
    } | null;
    ValidationErrors?: Array<{ Message?: string | null; Path?: string | null }> | null;
  };
};

export type ConsultantEditor_FindConsultantDuplicateQueryVariables = Exact<{
  filter: CheckContactExistsInput;
}>;

export type ConsultantEditor_FindConsultantDuplicateQuery = {
  findConsultantDuplicate?: {
    _id: string;
    Name?: string | null;
    Email?: string | null;
    SocialSecurityNo?: string | null;
  } | null;
  findConsultantSimilar?: {
    _id: string;
    Name?: string | null;
    Email?: string | null;
  } | null;
};

export type ConsultantEditor_FormFragment = {
  consultantId: string;
  isNew: boolean;
  status?: ConsultantStatus | null;
  knownSystems?: Array<string | null> | null;
  extraCurriculum?: string | null;
  address: { city: string; country: string; streetName: string; zipCode: string };
  competitors: { items: Array<string> };
  contacts: {
    cellPhone: string;
    email: string;
    secondaryEmail: string;
    initialContact?: InitialContact | null;
    selfRegisterOption?: SelfRegisterOption | null;
    phone: string;
    preferredCommunication: Array<PreferredCommunication>;
    recommendedByConsultant?: { label?: string | null; value: string } | null;
  };
  contactType: {
    clearingNumber?: string | null;
    accountNumber?: string | null;
    companyName: string;
    ssn: string;
    type?: LegalPersonType | null;
    externalTaxNumber?: string | null;
    employeeSalaryClaim?: string | null;
    subcontractorSalaryClaim?: string | null;
    receiveWorkBreakdownByEmail?: boolean | null;
    emailForSelfInvoicing?: string | null;
    FTaxChecked?: boolean | null;
    VATChecked?: boolean | null;
    rate?: string | null;
    increasedRate?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    employeeContractType?: ContractType | null;
    businessAddress?: {
      city: string;
      country: string;
      streetName: string;
      zipCode: string;
    } | null;
  };
  education: {
    items: Array<{
      courseLocation: string;
      courseName: string;
      isCourse?: boolean | null;
      fromYear?: string | null;
      fromMonth?: string | null;
      toYear?: string | null;
      toMonth?: string | null;
      educationType?: string | null;
    }>;
  };
  emergencyContacts: { items: Array<{ name: string; phone: string; relation: string }> };
  employeeNumber: {
    employeeNumber: string;
    employeeNumber2: string;
    employeeNumber3: string;
  };
  languageSkills?: { items: Array<{ level: LanguageSkillLevel; name: string }> } | null;
  personal: {
    intro: string;
    about: string;
    countries: Array<string>;
    norwayConsultantStatus?: NorwayConsultantStatus | null;
    firstComment: string;
    firstName: string;
    hasDrivingLicence: boolean;
    drivingLicenceType?: DrivingLicenceTypeInput | null;
    important: string;
    lastName: string;
    norwegianSsn: string;
    commentAuthorization: string;
    isWorkedNorway: boolean;
    isApprovedAuthorization: boolean;
    hprNumber: string;
    ssn: string;
    travelPreferences: string;
    accommodationPreferences: string;
    care: string;
  };
  prescriptionCode: { code: string };
  workExperience: {
    items: Array<{
      areaOfExpertise: string;
      roles: string;
      fromYear?: string | null;
      fromMonth?: string | null;
      toYear?: string | null;
      toMonth?: string | null;
      workType: string;
      workPlace: string;
      departmentIds?: Array<string | null> | null;
      competitors?: Array<string | null> | null;
      employmentType?: LegalPersonType | null;
      experience?: string | null;
      excludeFromPresentation?: boolean | null;
      customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
    } | null>;
  };
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
    communicationChannel: GDPRCommunicationChannel;
  } | null> | null;
};

export type ConsultantForm_CompetitorsFragment = { items: Array<string> };

export type ConsultantForm_ContactsFragment = {
  cellPhone: string;
  email: string;
  secondaryEmail: string;
  initialContact?: InitialContact | null;
  selfRegisterOption?: SelfRegisterOption | null;
  phone: string;
  preferredCommunication: Array<PreferredCommunication>;
  recommendedByConsultant?: { label?: string | null; value: string } | null;
};

export type ConsultantForm_ContactTypeFragment = {
  clearingNumber?: string | null;
  accountNumber?: string | null;
  companyName: string;
  ssn: string;
  type?: LegalPersonType | null;
  externalTaxNumber?: string | null;
  employeeSalaryClaim?: string | null;
  subcontractorSalaryClaim?: string | null;
  receiveWorkBreakdownByEmail?: boolean | null;
  emailForSelfInvoicing?: string | null;
  FTaxChecked?: boolean | null;
  VATChecked?: boolean | null;
  rate?: string | null;
  increasedRate?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  employeeContractType?: ContractType | null;
  businessAddress?: {
    city: string;
    country: string;
    streetName: string;
    zipCode: string;
  } | null;
};

export type ConsultantForm_EducationFragment = {
  items: Array<{
    courseLocation: string;
    courseName: string;
    isCourse?: boolean | null;
    fromYear?: string | null;
    fromMonth?: string | null;
    toYear?: string | null;
    toMonth?: string | null;
    educationType?: string | null;
  }>;
};

export type ConsultantForm_EmergencyContactsFragment = {
  items: Array<{ name: string; phone: string; relation: string }>;
};

export type ConsultantForm_LanguageSkillsFragment = {
  items: Array<{ level: LanguageSkillLevel; name: string }>;
};

export type ConsultantForm_PersonalFragment = {
  intro: string;
  about: string;
  countries: Array<string>;
  norwayConsultantStatus?: NorwayConsultantStatus | null;
  firstComment: string;
  firstName: string;
  hasDrivingLicence: boolean;
  drivingLicenceType?: DrivingLicenceTypeInput | null;
  important: string;
  lastName: string;
  norwegianSsn: string;
  commentAuthorization: string;
  isWorkedNorway: boolean;
  isApprovedAuthorization: boolean;
  hprNumber: string;
  ssn: string;
  travelPreferences: string;
  accommodationPreferences: string;
  care: string;
};

export type ConsultantForm_PrescriptionCodeFragment = { code: string };

export type ConsultantForm_WorkExperienceFragment = {
  items: Array<{
    areaOfExpertise: string;
    roles: string;
    fromYear?: string | null;
    fromMonth?: string | null;
    toYear?: string | null;
    toMonth?: string | null;
    workType: string;
    workPlace: string;
    departmentIds?: Array<string | null> | null;
    competitors?: Array<string | null> | null;
    employmentType?: LegalPersonType | null;
    experience?: string | null;
    excludeFromPresentation?: boolean | null;
    customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
  } | null>;
};

export type ConsultantFormProfession_DoctorProfession_Fragment = {
  __typename: "DoctorProfession";
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  code?: string | null;
  areasOfExpertise: Array<{
    name: string;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
    yearFrom?: string | null;
    open?: boolean | null;
    specializations: Array<{
      name: string;
      qualified?: boolean | null;
      interested: boolean;
      comment?: string | null;
    }>;
  }>;
};

export type ConsultantFormProfession_GenericProfession_Fragment = {
  __typename: "GenericProfession";
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
  }>;
};

export type ConsultantFormProfession_NurseProfession_Fragment = {
  __typename: "NurseProfession";
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  code?: string | null;
  areasOfExpertise: Array<{
    name: string;
    qualified?: boolean | null;
    yearFrom?: string | null;
    interested: boolean;
    comment?: string | null;
  }>;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
  }>;
};

export type ConsultantFormProfession_PsykologProfession_Fragment = {
  __typename: "PsykologProfession";
  professionName: string;
  systems: Array<string>;
  methods?: Array<string> | null;
  certifiedFrom?: string | null;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
  }>;
};

export type ConsultantFormProfession_RadioNurseProfession_Fragment = {
  __typename: "RadioNurseProfession";
  professionName: string;
  systems: Array<string>;
  machines: Array<string>;
  certifiedFrom?: string | null;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    interested: boolean;
    qualified?: boolean | null;
    comment?: string | null;
  }>;
};

export type ConsultantFormProfession_SocionomProfession_Fragment = {
  __typename: "SocionomProfession";
  professionName: string;
  systems: Array<string>;
  educations: Array<string>;
  certifiedFrom?: string | null;
  areasOfExpertise: Array<{
    name: string;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
    yearFrom?: string | null;
    open?: boolean | null;
    specializations: Array<{
      name: string;
      qualified?: boolean | null;
      interested: boolean;
      comment?: string | null;
    }>;
  }>;
};

export type ConsultantFormProfession_TeacherProfession_Fragment = {
  __typename: "TeacherProfession";
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  digitalCompetence: Array<string>;
  schoolPlatforms: Array<string>;
  areasOfExpertise: Array<{
    name: string;
    certifiedFrom?: string | null;
    selected: boolean;
    specializations: Array<{
      name: string;
      qualified?: boolean | null;
      interestedIn: boolean;
      experience?: string | null;
    }>;
  }>;
};

export type ConsultantFormProfessionFragment =
  | ConsultantFormProfession_DoctorProfession_Fragment
  | ConsultantFormProfession_GenericProfession_Fragment
  | ConsultantFormProfession_NurseProfession_Fragment
  | ConsultantFormProfession_PsykologProfession_Fragment
  | ConsultantFormProfession_RadioNurseProfession_Fragment
  | ConsultantFormProfession_SocionomProfession_Fragment
  | ConsultantFormProfession_TeacherProfession_Fragment;

export type ConsultantForm_ExpertiseFragment = {
  professions?: Array<
    | {
        __typename: "DoctorProfession";
        professionName: string;
        systems: Array<string>;
        certifiedFrom?: string | null;
        code?: string | null;
        areasOfExpertise: Array<{
          name: string;
          qualified?: boolean | null;
          interested: boolean;
          comment?: string | null;
          yearFrom?: string | null;
          open?: boolean | null;
          specializations: Array<{
            name: string;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
          }>;
        }>;
      }
    | {
        __typename: "GenericProfession";
        professionName: string;
        systems: Array<string>;
        certifiedFrom?: string | null;
        specializations: Array<{
          name: string;
          yearFrom?: string | null;
          qualified?: boolean | null;
          interested: boolean;
          comment?: string | null;
        }>;
      }
    | {
        __typename: "NurseProfession";
        professionName: string;
        systems: Array<string>;
        certifiedFrom?: string | null;
        code?: string | null;
        areasOfExpertise: Array<{
          name: string;
          qualified?: boolean | null;
          yearFrom?: string | null;
          interested: boolean;
          comment?: string | null;
        }>;
        specializations: Array<{
          name: string;
          yearFrom?: string | null;
          qualified?: boolean | null;
          interested: boolean;
          comment?: string | null;
        }>;
      }
    | {
        __typename: "PsykologProfession";
        professionName: string;
        systems: Array<string>;
        methods?: Array<string> | null;
        certifiedFrom?: string | null;
        specializations: Array<{
          name: string;
          yearFrom?: string | null;
          qualified?: boolean | null;
          interested: boolean;
          comment?: string | null;
        }>;
      }
    | {
        __typename: "RadioNurseProfession";
        professionName: string;
        systems: Array<string>;
        machines: Array<string>;
        certifiedFrom?: string | null;
        specializations: Array<{
          name: string;
          yearFrom?: string | null;
          interested: boolean;
          qualified?: boolean | null;
          comment?: string | null;
        }>;
      }
    | {
        __typename: "SocionomProfession";
        professionName: string;
        systems: Array<string>;
        educations: Array<string>;
        certifiedFrom?: string | null;
        areasOfExpertise: Array<{
          name: string;
          qualified?: boolean | null;
          interested: boolean;
          comment?: string | null;
          yearFrom?: string | null;
          open?: boolean | null;
          specializations: Array<{
            name: string;
            qualified?: boolean | null;
            interested: boolean;
            comment?: string | null;
          }>;
        }>;
      }
    | {
        __typename: "TeacherProfession";
        professionName: string;
        systems: Array<string>;
        certifiedFrom?: string | null;
        digitalCompetence: Array<string>;
        schoolPlatforms: Array<string>;
        areasOfExpertise: Array<{
          name: string;
          certifiedFrom?: string | null;
          selected: boolean;
          specializations: Array<{
            name: string;
            qualified?: boolean | null;
            interestedIn: boolean;
            experience?: string | null;
          }>;
        }>;
      }
  > | null;
};

export type GenericProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
  }>;
};

export type DoctorProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  code?: string | null;
  areasOfExpertise: Array<{
    name: string;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
    yearFrom?: string | null;
    open?: boolean | null;
    specializations: Array<{
      name: string;
      qualified?: boolean | null;
      interested: boolean;
      comment?: string | null;
    }>;
  }>;
};

export type NurseProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  code?: string | null;
  areasOfExpertise: Array<{
    name: string;
    qualified?: boolean | null;
    yearFrom?: string | null;
    interested: boolean;
    comment?: string | null;
  }>;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
  }>;
};

export type RadioNurseProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  machines: Array<string>;
  certifiedFrom?: string | null;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    interested: boolean;
    qualified?: boolean | null;
    comment?: string | null;
  }>;
};

export type TeacherProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  certifiedFrom?: string | null;
  digitalCompetence: Array<string>;
  schoolPlatforms: Array<string>;
  areasOfExpertise: Array<{
    name: string;
    certifiedFrom?: string | null;
    selected: boolean;
    specializations: Array<{
      name: string;
      qualified?: boolean | null;
      interestedIn: boolean;
      experience?: string | null;
    }>;
  }>;
};

export type SocionomProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  educations: Array<string>;
  certifiedFrom?: string | null;
  areasOfExpertise: Array<{
    name: string;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
    yearFrom?: string | null;
    open?: boolean | null;
    specializations: Array<{
      name: string;
      qualified?: boolean | null;
      interested: boolean;
      comment?: string | null;
    }>;
  }>;
};

export type PsykologProfessionFragment = {
  professionName: string;
  systems: Array<string>;
  methods?: Array<string> | null;
  certifiedFrom?: string | null;
  specializations: Array<{
    name: string;
    yearFrom?: string | null;
    qualified?: boolean | null;
    interested: boolean;
    comment?: string | null;
  }>;
};

export type GetConsultantsByWeeksQueryVariables = Exact<{
  filter?: InputMaybe<ConsultantsByWeeksQueryInput>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  withEvents?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GetConsultantsByWeeksQuery = {
  consultantsByWeeks: Array<{
    Week: Date;
    Consultant: {
      _id: string;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Name?: string | null;
      Phone?: string | null;
      Unfit: boolean;
      SocialSecurityNo?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      Professions?: Array<string | null> | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      Events?: Array<{
        _id: string;
        CanDelete: boolean;
        CanEdit: boolean;
        CanPin: boolean;
        CreatedOn: Date;
        Deleted: boolean;
        Description: string;
        DescriptionHtml: string;
        Sticky: boolean;
        Warning?: boolean | null;
        Links?: Array<string> | null;
        CreatedBy: { PersonId?: string | null; Name?: string | null };
        UpdatedBy: { Name?: string | null };
      }>;
      Availability: { ranges: Array<{ from: Date; to: Date }> };
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: { machines: Array<string>; systems: Array<string | null> };
    };
  }>;
};

export type ConsultantsQueryVariables = Exact<{
  filter?: InputMaybe<ConsultantsQueryInput>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  sortBy?: InputMaybe<ConsultantTableColumns>;
  sortOrder?: InputMaybe<SortOrder>;
  withEvents: Scalars["Boolean"];
  filterText: Scalars["String"];
}>;

export type ConsultantsQuery = {
  consultants: {
    skip: number;
    limit: number;
    items: Array<{
      _id: string;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Name?: string | null;
      Phone?: string | null;
      Unfit: boolean;
      SocialSecurityNo?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      Professions?: Array<string | null> | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      Events?: Array<{
        _id: string;
        CanDelete: boolean;
        CanEdit: boolean;
        CanPin: boolean;
        CreatedOn: Date;
        Deleted: boolean;
        Description: string;
        DescriptionHtml: string;
        Sticky: boolean;
        Warning?: boolean | null;
        Links?: Array<string> | null;
        CreatedBy: { PersonId?: string | null; Name?: string | null };
        UpdatedBy: { Name?: string | null };
      }>;
      Availability: { ranges: Array<{ from: Date; to: Date }> };
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: { machines: Array<string>; systems: Array<string | null> };
    }>;
    secondarySearch: Array<{
      _id: string;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Name?: string | null;
      Phone?: string | null;
      Unfit: boolean;
      SocialSecurityNo?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      Professions?: Array<string | null> | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      Events?: Array<{
        _id: string;
        CanDelete: boolean;
        CanEdit: boolean;
        CanPin: boolean;
        CreatedOn: Date;
        Deleted: boolean;
        Description: string;
        DescriptionHtml: string;
        Sticky: boolean;
        Warning?: boolean | null;
        Links?: Array<string> | null;
        CreatedBy: { PersonId?: string | null; Name?: string | null };
        UpdatedBy: { Name?: string | null };
      }>;
      Availability: { ranges: Array<{ from: Date; to: Date }> };
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: { machines: Array<string>; systems: Array<string | null> };
    }>;
  };
};

export type GetConsultantsTotalQueryVariables = Exact<{
  filter?: InputMaybe<ConsultantsQueryInput>;
}>;

export type GetConsultantsTotalQuery = {
  consultantsTotal: { total: number; dbTime?: number | null };
};

export type ConsultantsMassListQueryVariables = Exact<{
  filter?: InputMaybe<ConsultantsQueryInput>;
  limit: Scalars["Int"];
}>;

export type ConsultantsMassListQuery = {
  consultants: {
    total: number;
    items: Array<{
      _id: string;
      AvatarPic?: string | null;
      Name?: string | null;
      Email?: string | null;
      EmailValid: boolean;
      Phone?: string | null;
      PhoneValid: boolean;
      CellPhone?: string | null;
      CellPhoneValid: boolean;
      Title?: string | null;
      Roles?: Array<string> | null;
      ResponsiblePerson?: { Name: string; PersonId: string } | null;
      GDPRConsentRecords?: Array<{
        type: GDPRConsentType;
        granted?: boolean | null;
      } | null> | null;
    }>;
  };
};

export type ConsultantsCountQueryVariables = Exact<{
  filter?: InputMaybe<ConsultantsQueryInput>;
}>;

export type ConsultantsCountQuery = { consultants: { total: number } };

export type ToggleConsultantFavouriteMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ToggleConsultantFavouriteMutation = { toggleConsultantFavourite: boolean };

export type AttachmentDataFragment = {
  NodeID: string;
  Name?: string | null;
  Size: number;
};

export type UploadAttachmentMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type UploadAttachmentMutation = {
  uploadDocument: { FileRef: { NodeID: string; Name?: string | null; Size: number } };
};

export type ConsultantAvailabilityForm_AvailabilityFragment = {
  weeks: Array<Date>;
  ranges: Array<{ from: Date; to: Date }>;
};

export type ConsultantAvailabilityFormDataFragment = { weeks: Array<Date> };

export type ConsultantWorkplaceFragment = {
  bookingId: string;
  department: Array<{ Id: string; Name: string; Type: CustomerType }>;
  organisation?: { Id: string; Name: string; Type: CustomerType } | null;
  workplace?: { Id: string; Name: string; Type: CustomerType } | null;
  week: { Week: number; Year: number };
};

export type GetConsultantAvailabilityFormQueryVariables = Exact<{
  id: Scalars["ObjectId"];
  weeksFrom: Scalars["Date"];
  weeksTo: Scalars["Date"];
}>;

export type GetConsultantAvailabilityFormQuery = {
  consultantById?: { _id: string; Availability: { weeks: Array<Date> } } | null;
  consultantUpcomingWorkplaces: Array<{
    bookingId: string;
    department: Array<{ Id: string; Name: string; Type: CustomerType }>;
    organisation?: { Id: string; Name: string; Type: CustomerType } | null;
    workplace?: { Id: string; Name: string; Type: CustomerType } | null;
    week: { Week: number; Year: number };
  }>;
  bookingWeeksByConsultant: Array<{ _id: string; Week: Date }>;
  consultantOpportunityByConsultantId: Array<{ _id: string; weeks: Array<Date> }>;
};

export type AvailabilityCalendar_AddAvailabilityMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  input: ConsultantAvailabilityInput;
}>;

export type AvailabilityCalendar_AddAvailabilityMutation = {
  addConsultantAvailability: {
    _id: string;
    Availability: { weeks: Array<Date>; ranges: Array<{ from: Date; to: Date }> };
  };
};

export type AvailabilityCalendar_DeleteAvailabilityMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  input: ConsultantAvailabilityInput;
}>;

export type AvailabilityCalendar_DeleteAvailabilityMutation = {
  deleteConsultantAvailability: {
    _id: string;
    Availability: { weeks: Array<Date>; ranges: Array<{ from: Date; to: Date }> };
  };
};

export type CallListDataFragment = {
  __typename: "CallList";
  _id: string;
  deleted: boolean;
  name: string;
  type: NodeType;
  nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
  members: Array<{ PersonId: string; Name: string }>;
};

export type CallContactListDataFragment = {
  __typename: "Me";
  _id: string;
  CallLists: Array<{
    __typename: "CallList";
    _id: string;
    deleted: boolean;
    name: string;
    type: NodeType;
    nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    members: Array<{ PersonId: string; Name: string }>;
  }>;
  ContactLists: Array<{
    __typename: "CallList";
    _id: string;
    deleted: boolean;
    name: string;
    type: NodeType;
    nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    members: Array<{ PersonId: string; Name: string }>;
  }>;
};

export type ConsultantCallListDataFragment = {
  __typename: "Consultant";
  _id: string;
  Name?: string | null;
  Unfit: boolean;
};

export type GetConsultantCallListDataQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantCallListDataQuery = {
  consultantById?: {
    __typename: "Consultant";
    _id: string;
    Name?: string | null;
    Unfit: boolean;
  } | null;
};

export type GetCallContactListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCallContactListQuery = {
  me: {
    __typename: "Me";
    _id: string;
    CallLists: Array<{
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
    ContactLists: Array<{
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
  };
};

export type CreateCallListMutationVariables = Exact<{
  listType: CallListType;
  name: Scalars["String"];
  nodes: Array<NodeRefFullInput> | NodeRefFullInput;
  type: NodeType;
  userIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type CreateCallListMutation = {
  submit: {
    __typename: "CallListOpResult";
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type GetCallListQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCallListQuery = {
  callListById: {
    __typename: "CallListOpResult";
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type RenameCallListMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  newName: Scalars["String"];
}>;

export type RenameCallListMutation = {
  submit: {
    __typename: "CallListOpResult";
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type UpdateCallListMembersMutationVariables = Exact<{
  callListId: Scalars["ObjectId"];
  userIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type UpdateCallListMembersMutation = {
  setCallListMembers: {
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type ConsultantJoinCallListMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  node: NodeRefFullInput;
}>;

export type ConsultantJoinCallListMutation = {
  addToCallList: {
    __typename: "CallListOpResult";
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type ConsultantLeaveCallListMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  nodeId: Scalars["ObjectId"];
}>;

export type ConsultantLeaveCallListMutation = {
  removeFromCallList: {
    __typename: "CallListOpResult";
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type UserLeaveCallListMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type UserLeaveCallListMutation = {
  leaveCallList: {
    __typename: "CallListOpResult";
    callList?: {
      __typename: "CallList";
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type GetConsultantProfileNewQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantProfileNewQuery = {
  consultantById?: {
    __typename: "Consultant";
    _id: string;
    Name?: string | null;
    LastContactDate?: Date | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    Phone?: string | null;
    CellPhone?: string | null;
    SocialSecurityNo?: string | null;
    preferredCommunication: Array<PreferredCommunication>;
    AreasOfExpertise: Array<string>;
    Specializations: Array<string>;
    PrescriptionCode?: string | null;
    Professions?: Array<string | null> | null;
    KnownSystems: Array<string>;
    LegalPersonType?: LegalPersonType | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    nationalQualification?: NationalQualification | null;
    worksForCompetitors: Array<string>;
    bookedPeriodStart?: Date | null;
    bookedPeriodEnd?: Date | null;
    bookingStatus: ConsultantBookingStatus;
    pipelineStatus?: ConsultantPipelineStatus | null;
    tags: Array<string>;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    Unfit: boolean;
    initialContact?: InitialContact | null;
    hasDrivingLicence?: boolean | null;
    drivingLicenceType?: DrivingLicenceType | null;
    Intro?: string | null;
    isCvDataAffected: boolean;
    CellPhoneValid: boolean;
    AvailableForWorkInCountries: Array<string>;
    LegalBasis?: LegalBasis | null;
    ContractSigned?: boolean | null;
    welcomeEmail?: boolean | null;
    UnfitComment: string;
    UnfitedSetOn?: Date | null;
    unfitType?: ConsultantUnfitType | null;
    Address?: { formattedShort: string } | null;
    ResponsiblePerson?: { __typename: "UserRef"; PersonId: string; Name: string } | null;
    expertise: {
      machines: Array<string>;
      methods: Array<string>;
      systems: Array<string | null>;
      educations: Array<string>;
    };
    contracts: Array<{ id: string; startDate?: Date | null; endDate?: Date | null }>;
    qualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    nationalQualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    leadStatus?: { status: ConsultantLeadStatus } | null;
    businessAddress?: { formattedShort: string } | null;
    DocumentsShareable: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    }>;
    generalInterest?: {
      __typename: "ConsultantGeneralInterest";
      regions: Array<string>;
      workshifts: Array<Workshift>;
      comment: string;
    } | null;
    karens?: Array<{
      __typename: "ConsultantKarensItem";
      expDate: string;
      region: string;
    } | null> | null;
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
      dateGranted?: Date | null;
      dateRevoked?: Date | null;
      communicationChannel: GDPRCommunicationChannel;
      grantedBy?: { Name?: string | null } | null;
      revokedBy?: { Name?: string | null } | null;
    } | null> | null;
    UserSettings: { __typename: "UserSettings"; Enabled: boolean };
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  } | null;
  getConsultantPayoutByYear: Array<{
    total: number;
    totalNationalProcurement: number;
    totalNonNationalProcurement: number;
    year: number;
  } | null>;
};

export type CanDuplicateConsultantToTenantQueryVariables = Exact<{
  ssn?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
}>;

export type CanDuplicateConsultantToTenantQuery = {
  consultantCanDuplicateToTenants?: {
    items?: Array<{
      tenant: string;
      canDuplicate: boolean;
      links?: Array<string | null> | null;
    } | null> | null;
  } | null;
};

export type DuplicateConsultantToTenantMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  tenant: Scalars["String"];
}>;

export type DuplicateConsultantToTenantMutation = {
  duplicateConsultantToTenant?: string | null;
};

export type SendToMedloMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  referenceIds?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
  crmCv?: InputMaybe<Scalars["Boolean"]>;
  cvDocuments?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type SendToMedloMutation = {
  sendConsultantToMedlo: { success: boolean; message?: string | null };
};

export type ConsultantProfile_GetConsultantQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantProfile_GetConsultantQuery = {
  consultantById?: {
    LegalBasis?: LegalBasis | null;
    ContractSigned?: boolean | null;
    canCreateContractCheck: Array<string>;
    LegalPersonType?: LegalPersonType | null;
    Professions?: Array<string | null> | null;
    AvailableForWorkInCountries: Array<string>;
    DocumentTypes: Array<string>;
    Intro?: string | null;
    Teams: Array<string>;
    SocialSecurityNo?: string | null;
    Name?: string | null;
    welcomeEmail?: boolean | null;
    welcomeEmailSetOn?: Date | null;
    welcomeEmailSetBy?: string | null;
    bookingStatus: ConsultantBookingStatus;
    _id: string;
    AreasOfExpertise: Array<string>;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    LastContactDate?: Date | null;
    Phone?: string | null;
    Unfit: boolean;
    Specializations: Array<string>;
    IsValid?: boolean | null;
    PrescriptionCode?: string | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    UnfitComment: string;
    EmailValid: boolean;
    PhoneValid: boolean;
    CellPhoneValid: boolean;
    consultantId: string;
    Availability: { weeks: Array<Date>; ranges: Array<{ from: Date; to: Date }> };
    Documents: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
      dateGranted?: Date | null;
      dateRevoked?: Date | null;
      communicationChannel: GDPRCommunicationChannel;
      grantedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
      revokedBy?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    } | null> | null;
    UserSettings: { Enabled: boolean };
    Address?: { City: string } | null;
    contactType?: {
      employeeSalaryClaim?: string | null;
      subcontractorSalaryClaim?: string | null;
    } | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ValidationErrors: Array<{
      Message: string;
      Params?: any | null;
      Type: NodeValidationErrorType;
    }>;
    expertise: { machines: Array<string>; systems: Array<string | null> };
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
    generalInterest?: {
      __typename: "ConsultantGeneralInterest";
      regions: Array<string>;
      workshifts: Array<Workshift>;
      comment: string;
    } | null;
  } | null;
};

export type ConsultantTagsDataFragment = {
  __typename: "Consultant";
  _id: string;
  tags: Array<string>;
};

export type GetConsultantTagsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantTagsQuery = {
  consultantById?: { __typename: "Consultant"; _id: string; tags: Array<string> } | null;
};

export type GetAllConsultantTagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllConsultantTagsQuery = { getAllConsultantTags: { tags: Array<string> } };

export type AddConsultantTagMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  tag: Scalars["String"];
}>;

export type AddConsultantTagMutation = {
  addConsultantTag: { __typename: "Consultant"; _id: string; tags: Array<string> };
};

export type RemoveConsultantTagMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  tag: Scalars["String"];
}>;

export type RemoveConsultantTagMutation = {
  removeConsultantTag: { __typename: "Consultant"; _id: string; tags: Array<string> };
};

export type ConsultantContractTableRowDataFragment = {
  _id?: string | null;
  CustomerCity?: string | null;
  CustomerName?: string | null;
  ParentContractId?: string | null;
  Dates?: string | null;
  FileUrl?: string | null;
  Profession?: string | null;
  Period?: string | null;
  IsSigned?: boolean | null;
  NotRelevantMonthlyWeeklyPayouts?: boolean | null;
  IsNullified?: boolean | null;
  NullificationReason?: string | null;
  Type?: ConsultantContractType | null;
  SalaryChoiceAbbr?: string | null;
  ViewUrl?: string | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  PayoutsAbbr?: string | null;
  SalaryChoice?: ContractType | null;
  PublishedUrl?: string | null;
  canEdit?: boolean | null;
  canDuplicate?: boolean | null;
  canNullify?: boolean | null;
  canPublishToOneflowDirectly?: boolean | null;
  canDownload?: boolean | null;
  canPreview?: boolean | null;
  pensionSolution?: ConsultantContractPensionSolution | null;
  Attachment?: {
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  } | null;
  Consultant?: {
    _id: string;
    LegalPersonType?: LegalPersonType | null;
    BirthDate?: Date | null;
  } | null;
  ChildContracts?: Array<{
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    Type?: ConsultantContractType | null;
    ViewUrl?: string | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
  } | null> | null;
  editsProof?: Array<{
    editOn?: string | null;
    editBy?: { PersonId: string; Name: string } | null;
    fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
  } | null> | null;
};

export type ConsultantContractsPersonalDataFragment = {
  Email?: string | null;
  Name?: string | null;
  LegalPersonType?: LegalPersonType | null;
  canCreateContractCheck: Array<string>;
  canCreateSelfInvoicingContractCheck: Array<ConsultantContractSelfInvoicingCheck>;
};

export type GetConsultantContractsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantContractsQuery = {
  getConsultantContracts: Array<{
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  }>;
};

export type GetConsultantContractsPersonalDataQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantContractsPersonalDataQuery = {
  consultantById?: {
    Email?: string | null;
    Name?: string | null;
    LegalPersonType?: LegalPersonType | null;
    canCreateContractCheck: Array<string>;
    canCreateSelfInvoicingContractCheck: Array<ConsultantContractSelfInvoicingCheck>;
  } | null;
};

export type ConsultantBookingContractListItemDataFragment = {
  __typename: "ConsultantBookingContractListItem";
  _id?: string | null;
  CustomerCity?: string | null;
  CustomerName?: string | null;
  Dates?: string | null;
  FileUrl?: string | null;
  IsSigned?: boolean | null;
  Type?: ConsultantBookingContractType | null;
  ViewUrl?: string | null;
  Recipients?: Array<string | null> | null;
  IsNullified?: boolean | null;
  PublishedUrl?: string | null;
  canEdit?: boolean | null;
  canDuplicate?: boolean | null;
  canDownload?: boolean | null;
  canPreview?: boolean | null;
  Attachment?: {
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  } | null;
  ContactPerson?: { Name?: string | null; Email?: string | null } | null;
};

export type GetConsultantBookingContractsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantBookingContractsQuery = {
  getConsultantBookingContracts: Array<{
    __typename: "ConsultantBookingContractListItem";
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    ViewUrl?: string | null;
    Recipients?: Array<string | null> | null;
    IsNullified?: boolean | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    ContactPerson?: { Name?: string | null; Email?: string | null } | null;
  }>;
};

export type UploadSignedConsultantContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  file?: InputMaybe<Scalars["Upload"]>;
  SignedOn?: InputMaybe<Scalars["Date"]>;
  SalaryChoice?: InputMaybe<ContractType>;
  expectedSalary?: InputMaybe<Scalars["String"]>;
  payoutType?: InputMaybe<ConsultantContractPayoutType>;
  bankCounselling?: InputMaybe<Scalars["Boolean"]>;
}>;

export type UploadSignedConsultantContractMutation = {
  uploadSignedConsultantContract: {
    __typename: "ConsultantContractListItem";
    _id?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    ViewUrl?: string | null;
  };
};

export type UploadSignedConsultantBookingContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  file: Scalars["Upload"];
  SignedOn?: InputMaybe<Scalars["Date"]>;
}>;

export type UploadSignedConsultantBookingContractMutation = {
  uploadSignedConsultantBookingContract: {
    _id?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    ViewUrl?: string | null;
  };
};

export type DeleteConsultantBookingContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type DeleteConsultantBookingContractMutation = {
  deleteConsultantBookingContract: {
    __typename: "ConsultantBookingContract";
    _id?: string | null;
  };
};

export type DeleteConsultantContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type DeleteConsultantContractMutation = {
  deleteConsultantContract: { __typename: "ConsultantContract"; _id?: string | null };
};

export type SendConsultantContractEmailToConsultantMutationVariables = Exact<{
  subject: Scalars["String"];
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  attachment?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type SendConsultantContractEmailToConsultantMutation = {
  sendConsultantContractEmailToConsultant?: { Subject: string; Body: string } | null;
};

export type SendConsultantBookingContractEmailToBAMutationVariables = Exact<{
  subject: Scalars["String"];
  body: Scalars["String"];
  recipients?: InputMaybe<Array<EmailRecipientInput> | EmailRecipientInput>;
  attachment?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type SendConsultantBookingContractEmailToBAMutation = {
  sendConsultantBookingContractEmailToBA?: { Subject: string; Body: string } | null;
};

export type AddSalaryChoiceToConsultantContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  salaryChoice: ContractType;
}>;

export type AddSalaryChoiceToConsultantContractMutation = {
  addSalaryChoiceToConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type NullifyConsultantContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  nullify: Scalars["Boolean"];
  nullificationReason?: InputMaybe<Scalars["String"]>;
}>;

export type NullifyConsultantContractMutation = {
  nullifyConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type NullifyConsultantBookingContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
  nullify: Scalars["Boolean"];
}>;

export type NullifyConsultantBookingContractMutation = {
  nullifyConsultantBookingContract: {
    __typename: "ConsultantBookingContractListItem";
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    IsSigned?: boolean | null;
    Type?: ConsultantBookingContractType | null;
    ViewUrl?: string | null;
    Recipients?: Array<string | null> | null;
    IsNullified?: boolean | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    ContactPerson?: { Name?: string | null; Email?: string | null } | null;
  };
};

export type AddUnsignedConsultantContractMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
}>;

export type AddUnsignedConsultantContractMutation = {
  addUnSignConsultantContract: {
    _id?: string | null;
    CustomerCity?: string | null;
    CustomerName?: string | null;
    ParentContractId?: string | null;
    Dates?: string | null;
    FileUrl?: string | null;
    Profession?: string | null;
    Period?: string | null;
    IsSigned?: boolean | null;
    NotRelevantMonthlyWeeklyPayouts?: boolean | null;
    IsNullified?: boolean | null;
    NullificationReason?: string | null;
    Type?: ConsultantContractType | null;
    SalaryChoiceAbbr?: string | null;
    ViewUrl?: string | null;
    StartDate?: Date | null;
    EndDate?: Date | null;
    PayoutsAbbr?: string | null;
    SalaryChoice?: ContractType | null;
    PublishedUrl?: string | null;
    canEdit?: boolean | null;
    canDuplicate?: boolean | null;
    canNullify?: boolean | null;
    canPublishToOneflowDirectly?: boolean | null;
    canDownload?: boolean | null;
    canPreview?: boolean | null;
    pensionSolution?: ConsultantContractPensionSolution | null;
    Attachment?: {
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    } | null;
    Consultant?: {
      _id: string;
      LegalPersonType?: LegalPersonType | null;
      BirthDate?: Date | null;
    } | null;
    ChildContracts?: Array<{
      _id?: string | null;
      CustomerCity?: string | null;
      CustomerName?: string | null;
      ParentContractId?: string | null;
      Dates?: string | null;
      FileUrl?: string | null;
      Period?: string | null;
      IsSigned?: boolean | null;
      NotRelevantMonthlyWeeklyPayouts?: boolean | null;
      IsNullified?: boolean | null;
      Type?: ConsultantContractType | null;
      ViewUrl?: string | null;
      PublishedUrl?: string | null;
      canEdit?: boolean | null;
      canNullify?: boolean | null;
      canPublishToOneflowDirectly?: boolean | null;
      pensionSolution?: ConsultantContractPensionSolution | null;
      Attachment?: {
        DocumentType?: string | null;
        ThumbURL: string;
        PdfURL: string;
        FileRef: {
          MimeType: string;
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          Size: number;
        };
      } | null;
      Consultant?: {
        _id: string;
        LegalPersonType?: LegalPersonType | null;
        BirthDate?: Date | null;
      } | null;
    } | null> | null;
    editsProof?: Array<{
      editOn?: string | null;
      editBy?: { PersonId: string; Name: string } | null;
      fileRefs?: Array<{ Name?: string | null; NodeID: string }> | null;
    } | null> | null;
  };
};

export type GenerateConsultantPresentationMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  presentationType: ConsultantPresentationType;
  presentationCountry: ConsultantPresentationCountry;
  presentationText?: InputMaybe<Scalars["String"]>;
  fileIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  evaluatesIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  evaluatesThreeMonthsIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  referenceIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  contactPerson?: InputMaybe<Scalars["String"]>;
  generateCV?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GenerateConsultantPresentationMutation = {
  consultantGeneratePresentation: {
    presentation?: { _id: string; ViewURL: string } | null;
    attachmentErrors: Array<{ fileId: string; filename: string; error: string }>;
  };
};

export type SendConsultantPresentationEmailMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  presentationId: Scalars["ObjectId"];
  recipients: Array<EmailRecipientInput> | EmailRecipientInput;
  subject: Scalars["String"];
  body: Scalars["String"];
  attachments?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type SendConsultantPresentationEmailMutation = {
  sendConsultantPresentation: boolean;
};

export type ConsultantShareableFilesNewFragment = {
  _id: string;
  DocumentsShareable: Array<{
    DocumentType?: string | null;
    PreviewURL: string;
    FileRef: { NodeID: string; Name?: string | null };
  }>;
};

export type ConsultantCreatePresentationDataFragment = {
  __typename: "Consultant";
  _id: string;
  Intro?: string | null;
  isCvDataAffected: boolean;
  ResponsiblePerson?: { __typename: "UserRef"; Name: string; PersonId: string } | null;
};

export type ConsultantReferenceDocumentFragment = {
  referenceId: string;
  name: string;
  type: ConsultantReferenceType;
  workRelation?: ConsultantReferenceRelation | null;
  document: { PreviewURL: string };
};

export type GetConsultantShareableFilesQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantShareableFilesQuery = {
  consultantById?: {
    _id: string;
    DocumentsShareable: Array<{
      DocumentType?: string | null;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    }>;
  } | null;
  consultantReferenceDocuments: Array<{
    referenceId: string;
    name: string;
    type: ConsultantReferenceType;
    workRelation?: ConsultantReferenceRelation | null;
    document: { PreviewURL: string };
  }>;
};

export type GetConsultantCreatePresentationDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantCreatePresentationDataQuery = {
  consultantById?: {
    __typename: "Consultant";
    _id: string;
    Intro?: string | null;
    isCvDataAffected: boolean;
    ResponsiblePerson?: { __typename: "UserRef"; Name: string; PersonId: string } | null;
  } | null;
};

export type ContactPersonsEmailSearchDataFragment = {
  __typename: "ContactPerson";
  _id: string;
  Name?: string | null;
  Email?: string | null;
};

export type SearchContactPersonsEmailQueryVariables = Exact<{
  filter?: InputMaybe<ContactPersonsFilter>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type SearchContactPersonsEmailQuery = {
  contactPersons: {
    items: Array<{
      __typename: "ContactPerson";
      _id: string;
      Name?: string | null;
      Email?: string | null;
    }>;
  };
};

export type EventData_AccommodationEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventData_ConsultantEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventData_CustomerContractEventLog_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy?: { Name?: string | null } | null;
};

export type EventData_CustomerEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventData_TodoEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventDataFragment =
  | EventData_AccommodationEvent_Fragment
  | EventData_ConsultantEvent_Fragment
  | EventData_CustomerContractEventLog_Fragment
  | EventData_CustomerEvent_Fragment
  | EventData_TodoEvent_Fragment;

export type ConsultantEventLogDataFragment = {
  Type: ConsultantEventType;
  EmailBody?: any | null;
  EmailSubject?: string | null;
  EmailDescription?: string | null;
  SMSStatusLegacy?: string | null;
  Warning?: boolean | null;
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Links?: Array<string> | null;
  MetBy?: { Name?: string | null; PersonId?: string | null } | null;
  EmailRecipients?: Array<{ Email: string; Name?: string | null }> | null;
  TodoItem?: {
    _id: string;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    Completed?: Date | null;
    Description: string;
    Due?: Date | null;
    AssignedTo?: { Name: string; PersonId: string } | null;
    AssignedBy: { Name: string; PersonId: string };
  } | null;
  SMSMessage?: {
    _id: string;
    IsFailed: boolean;
    IsOk: boolean;
    IsStatusFinal: boolean;
    Status: SMSDeliveryStatus;
    StatusUpdatedOn?: Date | null;
  } | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventLog_ReminderEventTodoFragment = {
  _id: string;
  AssignedOn: Date;
  AssignedTeam?: string | null;
  Completed?: Date | null;
  Description: string;
  Due?: Date | null;
  AssignedTo?: { Name: string; PersonId: string } | null;
  AssignedBy: { Name: string; PersonId: string };
};

export type SMSEvent_MessageFragment = {
  _id: string;
  IsFailed: boolean;
  IsOk: boolean;
  IsStatusFinal: boolean;
  Status: SMSDeliveryStatus;
  StatusUpdatedOn?: Date | null;
};

export type GetConsultantEventLogEventsQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  type?: InputMaybe<
    Array<InputMaybe<ConsultantEventType>> | InputMaybe<ConsultantEventType>
  >;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GetConsultantEventLogEventsQuery = {
  consultantEvents: Array<{
    Type: ConsultantEventType;
    EmailBody?: any | null;
    EmailSubject?: string | null;
    EmailDescription?: string | null;
    SMSStatusLegacy?: string | null;
    Warning?: boolean | null;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Links?: Array<string> | null;
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    EmailRecipients?: Array<{ Email: string; Name?: string | null }> | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    SMSMessage?: {
      _id: string;
      IsFailed: boolean;
      IsOk: boolean;
      IsStatusFinal: boolean;
      Status: SMSDeliveryStatus;
      StatusUpdatedOn?: Date | null;
    } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  }>;
};

export type ConsultantEventLogMetaDataFragment = {
  __typename: "Consultant";
  _id: string;
  Name?: string | null;
  Email?: string | null;
  CellPhoneValid: boolean;
  bookingStatus: ConsultantBookingStatus;
};

export type GetConsultantEventLogMetaDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantEventLogMetaDataQuery = {
  consultantById?: {
    __typename: "Consultant";
    _id: string;
    Name?: string | null;
    Email?: string | null;
    CellPhoneValid: boolean;
    bookingStatus: ConsultantBookingStatus;
  } | null;
};

export type EventLog_ConsultantEventFragment = {
  Type: ConsultantEventType;
  EmailBody?: any | null;
  EmailSubject?: string | null;
  EmailDescription?: string | null;
  SMSStatusLegacy?: string | null;
  Warning?: boolean | null;
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Links?: Array<string> | null;
  MetBy?: { Name?: string | null; PersonId?: string | null } | null;
  EmailRecipients?: Array<{ Email: string; Name?: string | null }> | null;
  TodoItem?: {
    _id: string;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    Completed?: Date | null;
    Description: string;
    Due?: Date | null;
    AssignedTo?: { Name: string; PersonId: string } | null;
    AssignedBy: { Name: string; PersonId: string };
  } | null;
  SMSMessage?: {
    _id: string;
    IsFailed: boolean;
    IsOk: boolean;
    IsStatusFinal: boolean;
    Status: SMSDeliveryStatus;
    StatusUpdatedOn?: Date | null;
  } | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type ConsultantEventLog_ConsultantFragment = {
  _id: string;
  Name?: string | null;
  Email?: string | null;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  CellPhoneValid: boolean;
  secondaryEmail?: string | null;
};

export type ConsultantEventLog_GetEventsQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantEventLog_GetEventsQuery = {
  consultantById?: {
    _id: string;
    Name?: string | null;
    Email?: string | null;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    CellPhoneValid: boolean;
    secondaryEmail?: string | null;
  } | null;
  consultantEvents: Array<{
    Type: ConsultantEventType;
    EmailBody?: any | null;
    EmailSubject?: string | null;
    EmailDescription?: string | null;
    SMSStatusLegacy?: string | null;
    Warning?: boolean | null;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Links?: Array<string> | null;
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    EmailRecipients?: Array<{ Email: string; Name?: string | null }> | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    SMSMessage?: {
      _id: string;
      IsFailed: boolean;
      IsOk: boolean;
      IsStatusFinal: boolean;
      Status: SMSDeliveryStatus;
      StatusUpdatedOn?: Date | null;
    } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  }>;
};

export type AddConsultantEventLogCommentMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type AddConsultantEventLogCommentMutation = {
  addConsultantCommentEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AddConsultantEventLogReminderMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type AddConsultantEventLogReminderMutation = {
  addConsultantReminderEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AddConsultantEventLogMailMutationVariables = Exact<{
  subject: Scalars["String"];
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  attachment?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type AddConsultantEventLogMailMutation = {
  sendEmailToConsultant?: { Subject: string; Body: string } | null;
};

export type AddConsultantEventLogSmsMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type AddConsultantEventLogSmsMutation = {
  addConsultantSMSEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AddConsultantEventLogCallMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type AddConsultantEventLogCallMutation = {
  addConsultantCallEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AddConsultantEventLogNoAnswerMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type AddConsultantEventLogNoAnswerMutation = {
  addConsultantNoanswerEvent?: {
    event?: {
      _id: string;
      CanDelete: boolean;
      CanEdit: boolean;
      CanPin: boolean;
      CreatedOn: Date;
      Deleted: boolean;
      Description: string;
      DescriptionHtml: string;
      Sticky: boolean;
      Warning?: boolean | null;
      Links?: Array<string> | null;
      CreatedBy: { PersonId?: string | null; Name?: string | null };
      UpdatedBy: { Name?: string | null };
    } | null;
  } | null;
};

export type AddConsultantEventLogInterestMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type AddConsultantEventLogInterestMutation = {
  addConsultantInterestEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type UpdateConsultantEventLogPinMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type UpdateConsultantEventLogPinMutation = {
  pinConsultantEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type DeleteConsultantEventLogEntryMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type DeleteConsultantEventLogEntryMutation = {
  deleteConsultantEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type UpdateConsultantEventLogEntryMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type UpdateConsultantEventLogEntryMutation = {
  updateConsultantEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type GetConsultantDocumentListQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantDocumentListQuery = {
  docs?: {
    _id: string;
    Documents: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        MimeType: string;
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        Size: number;
      };
    }>;
  } | null;
};

export type GetConsultantBookingDocumentListQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantBookingDocumentListQuery = {
  consultantById?: {
    _id: string;
    BookingDocuments: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: {
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        MimeType: string;
        Size: number;
      };
    }>;
  } | null;
};

export type UploadBlobMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type UploadBlobMutation = { uploadBlob: string };

export type UploadConsultantDocumentsMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  blobRefs: Array<Scalars["String"]> | Scalars["String"];
  documentType: Scalars["String"];
}>;

export type UploadConsultantDocumentsMutation = {
  uploadConsultantDocuments: Array<{
    DocumentType?: string | null;
    PdfURL: string;
    ThumbURL: string;
    FileRef: {
      __typename: "FileRef";
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  }>;
};

export type RemoveConsultantDocumentMutationVariables = Exact<{
  documentId: Scalars["ObjectId"];
}>;

export type RemoveConsultantDocumentMutation = { removeConsultantDocument: boolean };

export type GetConsultantDocumentTypesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantDocumentTypesQuery = {
  consultantById?: { _id: string; DocumentTypes: Array<string> } | null;
};

export type GetFreshdeskTicketsCountQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetFreshdeskTicketsCountQuery = {
  freshdeskOpenTicketsCountByConsultant: number;
};

export type GetFreshdeskTicketsQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetFreshdeskTicketsQuery = {
  freshdeskTicketsByConsultant: Array<{
    id: number;
    subject: string;
    status: string;
    url: string;
    createdAt: Date;
    updatedAt: Date;
  }>;
};

export type GDPRConsentFragment = {
  type: GDPRConsentType;
  granted?: boolean | null;
  communicationChannel: GDPRCommunicationChannel;
};

export type ConsultantGdprConsentFragment = {
  type: GDPRConsentType;
  granted?: boolean | null;
  dateGranted?: Date | null;
  dateRevoked?: Date | null;
  communicationChannel: GDPRCommunicationChannel;
  grantedBy?: { Name?: string | null } | null;
  revokedBy?: { Name?: string | null } | null;
};

export type ConsultantGdprDataFragment = {
  _id: string;
  LegalBasis?: LegalBasis | null;
  ContractSigned?: boolean | null;
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
    dateGranted?: Date | null;
    dateRevoked?: Date | null;
    communicationChannel: GDPRCommunicationChannel;
    grantedBy?: { Name?: string | null } | null;
    revokedBy?: { Name?: string | null } | null;
  } | null> | null;
};

export type GetConsultantGdprQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantGdprQuery = {
  consultantById?: {
    _id: string;
    LegalBasis?: LegalBasis | null;
    ContractSigned?: boolean | null;
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
      dateGranted?: Date | null;
      dateRevoked?: Date | null;
      communicationChannel: GDPRCommunicationChannel;
      grantedBy?: { Name?: string | null } | null;
      revokedBy?: { Name?: string | null } | null;
    } | null> | null;
  } | null;
};

export type UpdateConsultantGdprMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: GDPRInput;
}>;

export type UpdateConsultantGdprMutation = {
  updateConsultantGDPR?: {
    _id: string;
    LegalBasis?: LegalBasis | null;
    ContractSigned?: boolean | null;
    GDPRConsentRecords?: Array<{
      type: GDPRConsentType;
      granted?: boolean | null;
      dateGranted?: Date | null;
      dateRevoked?: Date | null;
      communicationChannel: GDPRCommunicationChannel;
      grantedBy?: { Name?: string | null } | null;
      revokedBy?: { Name?: string | null } | null;
    } | null> | null;
  } | null;
};

export type ConsultantGeneralInterestFragment = {
  __typename: "ConsultantGeneralInterest";
  regions: Array<string>;
  workshifts: Array<Workshift>;
  comment: string;
};

export type ConsultantGeneralInterestDataFragment = {
  _id: string;
  AvailableForWorkInCountries: Array<string>;
  generalInterest?: {
    __typename: "ConsultantGeneralInterest";
    regions: Array<string>;
    workshifts: Array<Workshift>;
    comment: string;
  } | null;
};

export type GetConsultantGeneralInterestQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantGeneralInterestQuery = {
  consultantById?: {
    _id: string;
    AvailableForWorkInCountries: Array<string>;
    generalInterest?: {
      __typename: "ConsultantGeneralInterest";
      regions: Array<string>;
      workshifts: Array<Workshift>;
      comment: string;
    } | null;
  } | null;
};

export type ConsultantGeneralInterest_UpdateMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  interest: ConsultantGeneralInterestInput;
}>;

export type ConsultantGeneralInterest_UpdateMutation = {
  updateConsultantGeneralInterest: {
    _id: string;
    AvailableForWorkInCountries: Array<string>;
    generalInterest?: {
      __typename: "ConsultantGeneralInterest";
      regions: Array<string>;
      workshifts: Array<Workshift>;
      comment: string;
    } | null;
  };
};

export type KarensDataFragment = {
  karens?: Array<{
    __typename: "ConsultantKarensItem";
    expDate: string;
    region: string;
  } | null> | null;
};

export type ConsultantKarensByIdQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantKarensByIdQuery = {
  consultantKarensById: {
    karens?: Array<{
      __typename: "ConsultantKarensItem";
      expDate: string;
      region: string;
    } | null> | null;
  };
};

export type SubmitConsultantKarensMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantKarensInput;
}>;

export type SubmitConsultantKarensMutation = {
  submitConsultantKarens: {
    karens?: Array<{
      __typename: "ConsultantKarensItem";
      expDate: string;
      region: string;
    } | null> | null;
  };
};

export type PersonalInfoCardDataFragment = {
  _id: string;
  Name?: string | null;
  LastContactDate?: Date | null;
  Email?: string | null;
  secondaryEmail?: string | null;
  Phone?: string | null;
  CellPhone?: string | null;
  SocialSecurityNo?: string | null;
  preferredCommunication: Array<PreferredCommunication>;
  AreasOfExpertise: Array<string>;
  Specializations: Array<string>;
  PrescriptionCode?: string | null;
  Professions?: Array<string | null> | null;
  KnownSystems: Array<string>;
  LegalPersonType?: LegalPersonType | null;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  nationalQualification?: NationalQualification | null;
  worksForCompetitors: Array<string>;
  bookedPeriodStart?: Date | null;
  bookedPeriodEnd?: Date | null;
  bookingStatus: ConsultantBookingStatus;
  pipelineStatus?: ConsultantPipelineStatus | null;
  tags: Array<string>;
  BusinessName?: string | null;
  BusinessSocialSecurityNo?: string | null;
  Unfit: boolean;
  initialContact?: InitialContact | null;
  hasDrivingLicence?: boolean | null;
  drivingLicenceType?: DrivingLicenceType | null;
  Address?: { formattedShort: string } | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  expertise: {
    machines: Array<string>;
    methods: Array<string>;
    systems: Array<string | null>;
    educations: Array<string>;
  };
  contracts: Array<{ id: string; startDate?: Date | null; endDate?: Date | null }>;
  qualityApprovals: Array<{
    Country: string;
    Approved: boolean;
    Profession: string;
    approvalExpiresOn?: Date | null;
    baseItems?: Array<{
      name: string;
      approved: boolean;
      approvalExpiresOn?: Date | null;
      partiallyExpiresOn?: Date | null;
    } | null> | null;
    oneOfItems?: Array<{
      name: string;
      approved: boolean;
      approvalExpiresOn?: Date | null;
      partiallyExpiresOn?: Date | null;
    } | null> | null;
  }>;
  nationalQualityApprovals: Array<{
    Country: string;
    Approved: boolean;
    Profession: string;
    approvalExpiresOn?: Date | null;
    baseItems?: Array<{
      name: string;
      approved: boolean;
      approvalExpiresOn?: Date | null;
      partiallyExpiresOn?: Date | null;
    } | null> | null;
    oneOfItems?: Array<{
      name: string;
      approved: boolean;
      approvalExpiresOn?: Date | null;
      partiallyExpiresOn?: Date | null;
    } | null> | null;
  }>;
  leadStatus?: { status: ConsultantLeadStatus } | null;
  businessAddress?: { formattedShort: string } | null;
  karens?: Array<{
    __typename: "ConsultantKarensItem";
    expDate: string;
    region: string;
  } | null> | null;
};

export type GetPersonalInfoCardDataQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetPersonalInfoCardDataQuery = {
  consultantById?: {
    _id: string;
    Name?: string | null;
    LastContactDate?: Date | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    Phone?: string | null;
    CellPhone?: string | null;
    SocialSecurityNo?: string | null;
    preferredCommunication: Array<PreferredCommunication>;
    AreasOfExpertise: Array<string>;
    Specializations: Array<string>;
    PrescriptionCode?: string | null;
    Professions?: Array<string | null> | null;
    KnownSystems: Array<string>;
    LegalPersonType?: LegalPersonType | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    nationalQualification?: NationalQualification | null;
    worksForCompetitors: Array<string>;
    bookedPeriodStart?: Date | null;
    bookedPeriodEnd?: Date | null;
    bookingStatus: ConsultantBookingStatus;
    pipelineStatus?: ConsultantPipelineStatus | null;
    tags: Array<string>;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    Unfit: boolean;
    initialContact?: InitialContact | null;
    hasDrivingLicence?: boolean | null;
    drivingLicenceType?: DrivingLicenceType | null;
    Address?: { formattedShort: string } | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    expertise: {
      machines: Array<string>;
      methods: Array<string>;
      systems: Array<string | null>;
      educations: Array<string>;
    };
    contracts: Array<{ id: string; startDate?: Date | null; endDate?: Date | null }>;
    qualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    nationalQualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    leadStatus?: { status: ConsultantLeadStatus } | null;
    businessAddress?: { formattedShort: string } | null;
    karens?: Array<{
      __typename: "ConsultantKarensItem";
      expDate: string;
      region: string;
    } | null> | null;
  } | null;
};

export type UpdateConsultantLeadStatusMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantLeadStatusInput;
}>;

export type UpdateConsultantLeadStatusMutation = {
  updateConsultantLeadStatus: {
    _id: string;
    Name?: string | null;
    LastContactDate?: Date | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    Phone?: string | null;
    CellPhone?: string | null;
    SocialSecurityNo?: string | null;
    preferredCommunication: Array<PreferredCommunication>;
    AreasOfExpertise: Array<string>;
    Specializations: Array<string>;
    PrescriptionCode?: string | null;
    Professions?: Array<string | null> | null;
    KnownSystems: Array<string>;
    LegalPersonType?: LegalPersonType | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    nationalQualification?: NationalQualification | null;
    worksForCompetitors: Array<string>;
    bookedPeriodStart?: Date | null;
    bookedPeriodEnd?: Date | null;
    bookingStatus: ConsultantBookingStatus;
    pipelineStatus?: ConsultantPipelineStatus | null;
    tags: Array<string>;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    Unfit: boolean;
    initialContact?: InitialContact | null;
    hasDrivingLicence?: boolean | null;
    drivingLicenceType?: DrivingLicenceType | null;
    Address?: { formattedShort: string } | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    expertise: {
      machines: Array<string>;
      methods: Array<string>;
      systems: Array<string | null>;
      educations: Array<string>;
    };
    contracts: Array<{ id: string; startDate?: Date | null; endDate?: Date | null }>;
    qualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    nationalQualityApprovals: Array<{
      Country: string;
      Approved: boolean;
      Profession: string;
      approvalExpiresOn?: Date | null;
      baseItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
      oneOfItems?: Array<{
        name: string;
        approved: boolean;
        approvalExpiresOn?: Date | null;
        partiallyExpiresOn?: Date | null;
      } | null> | null;
    }>;
    leadStatus?: { status: ConsultantLeadStatus } | null;
    businessAddress?: { formattedShort: string } | null;
    karens?: Array<{
      __typename: "ConsultantKarensItem";
      expDate: string;
      region: string;
    } | null> | null;
  };
};

export type SetConsultantResponsiblePersonMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  status?: InputMaybe<ConsultantLeadStatus>;
}>;

export type SetConsultantResponsiblePersonMutation = {
  setConsultantResponsiblePerson: {
    _id: string;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
  };
};

export type QualityApprovalTooltipDataFragment = {
  Country: string;
  Approved: boolean;
  Profession: string;
  approvalExpiresOn?: Date | null;
  baseItems?: Array<{
    name: string;
    approved: boolean;
    approvalExpiresOn?: Date | null;
    partiallyExpiresOn?: Date | null;
  } | null> | null;
  oneOfItems?: Array<{
    name: string;
    approved: boolean;
    approvalExpiresOn?: Date | null;
    partiallyExpiresOn?: Date | null;
  } | null> | null;
};

export type GetPipelineStatusConsultantQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetPipelineStatusConsultantQuery = {
  consultantById?: {
    _id: string;
    pipelineStatus?: ConsultantPipelineStatus | null;
    pipelineStatusComment?: string | null;
    nextContactDate?: { date?: Date | null; reason?: string | null } | null;
    leadStatus?: { status: ConsultantLeadStatus } | null;
  } | null;
};

export type SetPipelineStatusMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  status: ConsultantPipelineStatus;
  comment?: InputMaybe<Scalars["String"]>;
  nextContactDate?: InputMaybe<Scalars["Date"]>;
  nextContactDateReason?: InputMaybe<Scalars["String"]>;
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
}>;

export type SetPipelineStatusMutation = {
  setConsultantPipelineStatus: {
    _id: string;
    pipelineStatus?: ConsultantPipelineStatus | null;
    pipelineStatusComment?: string | null;
  };
};

export type HealthDeclarationListItemFragment = {
  id: string;
  name: string;
  url: string;
  status: string;
  createdAt: Date;
  signedAt?: Date | null;
};

export type GetConsultantHealthDeclarationsQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantHealthDeclarationsQuery = {
  consultantHealthDeclarations: {
    total: number;
    items: Array<{
      id: string;
      name: string;
      url: string;
      status: string;
      createdAt: Date;
      signedAt?: Date | null;
    }>;
  };
};

export type RequestWithApprovedStatusMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  qualityCheckName: Scalars["String"];
  qualityTemplate: Scalars["String"];
  params: Scalars["JSON"];
}>;

export type RequestWithApprovedStatusMutation = {
  transitionConsultantQualityItem: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type RequestCriminalRecordCheckMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  qualityCheckName: Scalars["String"];
  qualityTemplate: Scalars["String"];
  params: Scalars["JSON"];
}>;

export type RequestCriminalRecordCheckMutation = {
  transitionConsultantQualityItem: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ApproveCriminalRecordCheckMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  qualityCheckName: Scalars["String"];
  qualityTemplate: Scalars["String"];
  params: Scalars["JSON"];
}>;

export type ApproveCriminalRecordCheckMutation = {
  transitionConsultantQualityItem: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type RequestHealthDeclarationViaOneflowNewMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  qualityTemplate: Scalars["String"];
  transitionParams?: InputMaybe<Scalars["JSON"]>;
}>;

export type RequestHealthDeclarationViaOneflowNewMutation = {
  transitionConsultantQualityItem: { _id: string };
};

export type ManuallySetStatus_HDMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  qualityTemplate: Scalars["String"];
  transitionName: Scalars["String"];
  transitionParams?: InputMaybe<Scalars["JSON"]>;
}>;

export type ManuallySetStatus_HDMutation = {
  transitionConsultantQualityItem: { _id: string };
};

export type OrderHlrCheckMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  qualityCheckName: Scalars["String"];
  qualityTemplate: Scalars["String"];
  params: Scalars["JSON"];
}>;

export type OrderHlrCheckMutation = { transitionConsultantQualityItem: { _id: string } };

export type SaveHSAIDParamsMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  hsaidNumber: Scalars["String"];
  cardNumber: Scalars["String"];
  cardType: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
}>;

export type SaveHSAIDParamsMutation = {
  saveHSAIDStatusParams: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityCheckConsultantDataFragment = {
  _id: string;
  SocialSecurityNo?: string | null;
  EmailValid: boolean;
  PhoneValid: boolean;
  CellPhoneValid: boolean;
  Name?: string | null;
  AreasOfExpertise: Array<string>;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
};

export type ConsultantQualityCheckDataFragment = {
  _id: string;
  Country: string;
  templateName: string;
  Disabled: boolean;
  DisabledMsg?: string | null;
  DocumentType?: string | null;
  Name: string;
  StatusSetOn?: Date | null;
  ExpiresOn?: Date | null;
  HasExpired?: boolean | null;
  ExpiresSoon?: boolean | null;
  AvailableStatuses: Array<{ IsDocumentRequired: boolean; Name: string }>;
  Status?:
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | { Name: string; Comment: string }
    | null;
  StatusSetBy?: { Name: string; PersonId: string } | null;
};

export type ConsultantQualityItemEditor_AvailableStatusFragment = {
  IsDocumentRequired: boolean;
  WithDocument: boolean;
  IsCommentRequired: boolean;
  WithComment: boolean;
  Name: string;
  Disabled?: boolean | null;
  DisabledMsg?: string | null;
};

export type ConsultantQualityItemEditorFragment = {
  _id: string;
  Country: string;
  templateName: string;
  DocumentType?: string | null;
  HasDocument: boolean;
  HasExpired?: boolean | null;
  StatusSetOn?: Date | null;
  Disabled: boolean;
  Name: string;
  AvailableStatuses: Array<{
    IsDocumentRequired: boolean;
    WithDocument: boolean;
    IsCommentRequired: boolean;
    WithComment: boolean;
    Name: string;
    Disabled?: boolean | null;
    DisabledMsg?: string | null;
  }>;
  Status?:
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        ExpiresInMonths: number;
        ExpiresOn?: Date | null;
        params?: any | null;
        SetBy?: { Name: string; PersonId: string } | null;
        pausedState?: {
          isPaused: boolean;
          wasPaused: boolean;
          pausedOn: Date;
          pausedUntil: Date;
        } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        ExpiresInMonths: number;
        ExpiresOn?: Date | null;
        params?: any | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        ExpiresOn?: Date | null;
        params?: any | null;
        SetBy?: { Name: string; PersonId: string } | null;
        pausedState?: {
          isPaused: boolean;
          wasPaused: boolean;
          pausedOn: Date;
          pausedUntil: Date;
        } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        params?: any | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        params?: any | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | {
        Name: string;
        Comment: string;
        SetOn?: Date | null;
        ExpiresOn?: Date | null;
        SetBy?: { Name: string; PersonId: string } | null;
      }
    | null;
};

export type ConsultantQualityItemEditor_GetQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  itemName: Scalars["String"];
}>;

export type ConsultantQualityItemEditor_GetQuery = {
  getConsultantQualityItem: {
    _id: string;
    Country: string;
    templateName: string;
    DocumentType?: string | null;
    HasDocument: boolean;
    HasExpired?: boolean | null;
    StatusSetOn?: Date | null;
    Disabled: boolean;
    Name: string;
    AvailableStatuses: Array<{
      IsDocumentRequired: boolean;
      WithDocument: boolean;
      IsCommentRequired: boolean;
      WithComment: boolean;
      Name: string;
      Disabled?: boolean | null;
      DisabledMsg?: string | null;
    }>;
    Status?:
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresInMonths: number;
          ExpiresOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
          pausedState?: {
            isPaused: boolean;
            wasPaused: boolean;
            pausedOn: Date;
            pausedUntil: Date;
          } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresInMonths: number;
          ExpiresOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
          pausedState?: {
            isPaused: boolean;
            wasPaused: boolean;
            pausedOn: Date;
            pausedUntil: Date;
          } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | null;
  };
};

export type ConsultantQualityItemEditor_SetApprovedMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
  comment?: InputMaybe<Scalars["String"]>;
  params?: InputMaybe<Scalars["JSON"]>;
  sendEmail?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ConsultantQualityItemEditor_SetApprovedMutation = {
  setQualityItemApprovedStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
  comment?: InputMaybe<Scalars["String"]>;
  params?: InputMaybe<Scalars["JSON"]>;
}>;

export type ConsultantQualityItemEditor_SetApprovedWithCommentMutation = {
  setQualityItemApprovedWithCommentStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
}>;

export type ConsultantQualityItemEditor_SetRequestSentIVOMutation = {
  setQualityItemRequestSentIVOStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetRequestSentMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
  params?: InputMaybe<Scalars["JSON"]>;
  todo?: InputMaybe<TodoInput>;
}>;

export type ConsultantQualityItemEditor_SetRequestSentMutation = {
  setQualityItemRequestSentStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetRequestReceivedMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
  comment?: InputMaybe<Scalars["String"]>;
  params?: InputMaybe<Scalars["JSON"]>;
}>;

export type ConsultantQualityItemEditor_SetRequestReceivedMutation = {
  setQualityItemRequestReceivedStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetBookedMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
}>;

export type ConsultantQualityItemEditor_SetBookedMutation = {
  setBookedStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetOrderedMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
  todo?: InputMaybe<TodoInput>;
}>;

export type ConsultantQualityItemEditor_SetOrderedMutation = {
  setOrderedStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_SetPausedMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
}>;

export type ConsultantQualityItemEditor_SetPausedMutation = {
  setQualityItemPausedStatus: { _id: string };
};

export type ConsultantQualityItemEditor_ReactivateMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn: Scalars["Date"];
}>;

export type ConsultantQualityItemEditor_ReactivateMutation = {
  reactivateQualityItem: { _id: string };
};

export type ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables =
  Exact<{
    consultantId: Scalars["ObjectId"];
    country: Scalars["String"];
    qualityCheckName: Scalars["String"];
    setOn: Scalars["Date"];
  }>;

export type ConsultantQualityItemEditor_SetConsultantResponsibleMutation = {
  setConsultantResponsibleStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_ClearStatusMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
}>;

export type ConsultantQualityItemEditor_ClearStatusMutation = {
  clearQualityItemStatus: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantQualityItemEditor_UploadMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  documentType: Scalars["String"];
  statusName: Scalars["String"];
  file: Scalars["Upload"];
}>;

export type ConsultantQualityItemEditor_UploadMutation = {
  uploadConsultantDocument: {
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  };
};

export type SendRequestIVOMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  body: Scalars["String"];
  subject: Scalars["String"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  from?: InputMaybe<Scalars["String"]>;
}>;

export type SendRequestIVOMutation = {
  sendRequestIVO: {
    _id: string;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
  };
};

export type ConsultantProfileForQualityItemFragment = {
  _id: string;
  Name?: string | null;
  SocialSecurityNo?: string | null;
  expertise: {
    professions?: Array<
      | { professionName: string; certifiedFrom?: string | null }
      | { professionName: string; certifiedFrom?: string | null }
      | { professionName: string; certifiedFrom?: string | null }
      | { professionName: string; certifiedFrom?: string | null }
      | { professionName: string; certifiedFrom?: string | null }
      | { professionName: string; certifiedFrom?: string | null }
      | { professionName: string; certifiedFrom?: string | null }
    > | null;
  };
};

export type ConsultantProfileForQualityItem_GetConsultantQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantProfileForQualityItem_GetConsultantQuery = {
  consultantById?: {
    _id: string;
    Name?: string | null;
    SocialSecurityNo?: string | null;
    expertise: {
      professions?: Array<
        | { professionName: string; certifiedFrom?: string | null }
        | { professionName: string; certifiedFrom?: string | null }
        | { professionName: string; certifiedFrom?: string | null }
        | { professionName: string; certifiedFrom?: string | null }
        | { professionName: string; certifiedFrom?: string | null }
        | { professionName: string; certifiedFrom?: string | null }
        | { professionName: string; certifiedFrom?: string | null }
      > | null;
    };
  } | null;
};

export type GetConsultantQualityItemEditorDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  itemName: Scalars["String"];
}>;

export type GetConsultantQualityItemEditorDataQuery = {
  getConsultantQualityItem: {
    _id: string;
    Country: string;
    templateName: string;
    DocumentType?: string | null;
    HasDocument: boolean;
    HasExpired?: boolean | null;
    StatusSetOn?: Date | null;
    Disabled: boolean;
    Name: string;
    AvailableStatuses: Array<{
      IsDocumentRequired: boolean;
      WithDocument: boolean;
      IsCommentRequired: boolean;
      WithComment: boolean;
      Name: string;
      Disabled?: boolean | null;
      DisabledMsg?: string | null;
    }>;
    Status?:
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresInMonths: number;
          ExpiresOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
          pausedState?: {
            isPaused: boolean;
            wasPaused: boolean;
            pausedOn: Date;
            pausedUntil: Date;
          } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresInMonths: number;
          ExpiresOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
          pausedState?: {
            isPaused: boolean;
            wasPaused: boolean;
            pausedOn: Date;
            pausedUntil: Date;
          } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          params?: any | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | {
          Name: string;
          Comment: string;
          SetOn?: Date | null;
          ExpiresOn?: Date | null;
          SetBy?: { Name: string; PersonId: string } | null;
        }
      | null;
  };
};

export type PausedStateFragment = {
  isPaused: boolean;
  wasPaused: boolean;
  pausedOn: Date;
  pausedUntil: Date;
};

export type ApprovedQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  ExpiresInMonths: number;
  ExpiresOn?: Date | null;
  params?: any | null;
  SetBy?: { Name: string; PersonId: string } | null;
  pausedState?: {
    isPaused: boolean;
    wasPaused: boolean;
    pausedOn: Date;
    pausedUntil: Date;
  } | null;
};

export type ApprovedWithCommentQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  ExpiresInMonths: number;
  ExpiresOn?: Date | null;
  params?: any | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type AnsweredQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type NotApprovedQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type AwaitingApprovalQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type RequestSentQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  params?: any | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type RequestReceivedNotProcessedQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  params?: any | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type OrderedQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type BookedQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type ConsultantResponsibleQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type SigningPeriodExpiredQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  ExpiresOn?: Date | null;
  SetBy?: { Name: string; PersonId: string } | null;
};

export type PausedQualityStatusFragment = {
  Name: string;
  Comment: string;
  SetOn?: Date | null;
  ExpiresOn?: Date | null;
  params?: any | null;
  SetBy?: { Name: string; PersonId: string } | null;
  pausedState?: {
    isPaused: boolean;
    wasPaused: boolean;
    pausedOn: Date;
    pausedUntil: Date;
  } | null;
};

export type ConsultantQuality_ConsultantNewFragment = {
  _id: string;
  AvailableForWorkInCountries: Array<string>;
  Name?: string | null;
  AreasOfExpertise: Array<string>;
  SocialSecurityNo?: string | null;
  Unfit: boolean;
  UnfitComment: string;
  EmailValid: boolean;
  PhoneValid: boolean;
  CellPhoneValid: boolean;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  QualityPerCountry: Array<{
    Country: string;
    QualityChecks: Array<{
      _id: string;
      Country: string;
      templateName: string;
      Disabled: boolean;
      DisabledMsg?: string | null;
      DocumentType?: string | null;
      Name: string;
      StatusSetOn?: Date | null;
      ExpiresOn?: Date | null;
      HasExpired?: boolean | null;
      ExpiresSoon?: boolean | null;
      HasDocument: boolean;
      AvailableStatuses: Array<{
        IsDocumentRequired: boolean;
        Name: string;
        WithDocument: boolean;
        IsCommentRequired: boolean;
        WithComment: boolean;
        Disabled?: boolean | null;
        DisabledMsg?: string | null;
      }>;
      Status?:
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresInMonths: number;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
            pausedState?: {
              isPaused: boolean;
              wasPaused: boolean;
              pausedOn: Date;
              pausedUntil: Date;
            } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresInMonths: number;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
            pausedState?: {
              isPaused: boolean;
              wasPaused: boolean;
              pausedOn: Date;
              pausedUntil: Date;
            } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            params?: any | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | {
            Name: string;
            Comment: string;
            SetOn?: Date | null;
            ExpiresOn?: Date | null;
            SetBy?: { Name: string; PersonId: string } | null;
          }
        | null;
      StatusSetBy?: { Name: string; PersonId: string } | null;
    }>;
  }>;
  UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
};

export type ConsultantQuality_GetConsultantNewQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantQuality_GetConsultantNewQuery = {
  consultantById?: {
    _id: string;
    AvailableForWorkInCountries: Array<string>;
    Name?: string | null;
    AreasOfExpertise: Array<string>;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    EmailValid: boolean;
    PhoneValid: boolean;
    CellPhoneValid: boolean;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  } | null;
};

export type ConsultantQuality_GetConsultantQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantQuality_GetConsultantQuery = {
  consultantById?: {
    _id: string;
    AvailableForWorkInCountries: Array<string>;
    Name?: string | null;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    EmailValid: boolean;
    PhoneValid: boolean;
    CellPhoneValid: boolean;
    AreasOfExpertise: Array<string>;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        _id: string;
        Country: string;
        templateName: string;
        Disabled: boolean;
        DisabledMsg?: string | null;
        DocumentType?: string | null;
        Name: string;
        StatusSetOn?: Date | null;
        ExpiresOn?: Date | null;
        HasExpired?: boolean | null;
        ExpiresSoon?: boolean | null;
        HasDocument: boolean;
        AvailableStatuses: Array<{
          IsDocumentRequired: boolean;
          Name: string;
          WithDocument: boolean;
          IsCommentRequired: boolean;
          WithComment: boolean;
          Disabled?: boolean | null;
          DisabledMsg?: string | null;
        }>;
        Status?:
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresInMonths: number;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
              pausedState?: {
                isPaused: boolean;
                wasPaused: boolean;
                pausedOn: Date;
                pausedUntil: Date;
              } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              params?: any | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | {
              Name: string;
              Comment: string;
              SetOn?: Date | null;
              ExpiresOn?: Date | null;
              SetBy?: { Name: string; PersonId: string } | null;
            }
          | null;
        StatusSetBy?: { Name: string; PersonId: string } | null;
      }>;
    }>;
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  } | null;
};

export type ReferenceItemFragment = {
  _id: string;
  name: string;
  phone?: string | null;
  email?: string | null;
  position: string;
  workPlace: string;
  workRelation?: ConsultantReferenceRelation | null;
  formType?: ConsultantReferenceType | null;
  formLink?: string | null;
  editLink?: string | null;
  areaOfExpertise: string;
  status: ConsultantReferenceStatus;
  canBeSentToRef: boolean;
  canBeReSentToRef: boolean;
  reShared?: boolean | null;
  deleted: boolean;
  updatedOn?: Date | null;
  migrated?: boolean | null;
  orderedUpdateFromKvk?: boolean | null;
  form?: {
    submittedAt?: Date | null;
    submittedBy?: { name: string; nodeId: string } | null;
  } | null;
  submissionHistory?: Array<{
    submittedAt?: Date | null;
    submittedBy?: string | null;
  } | null> | null;
  lastStatusHistory: {
    changedAt: Date;
    newStatus: ConsultantReferenceStatus;
    changedBy: { name: string; nodeId: string };
  };
  reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
  document?: {
    PdfURL: string;
    PreviewURL: string;
    FileRef: { NodeID: string; Name?: string | null };
  } | null;
};

export type Reference_GetListQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type Reference_GetListQuery = {
  consultantReferences: Array<{
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  }>;
};

export type Reference_GetConsultantQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type Reference_GetConsultantQuery = {
  consultantById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    Name?: string | null;
    QualityPerCountry: Array<{
      Country: string;
      QualityChecks: Array<{
        Name: string;
        Status?:
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | { Name: string }
          | null;
      }>;
    }>;
  } | null;
};

export type Reference_AddMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  input: ConsultantReferenceInputNew;
}>;

export type Reference_AddMutation = {
  createConsultantReference: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type Reference_EditMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
  input: ConsultantReferenceInputNew;
}>;

export type Reference_EditMutation = {
  updateConsultantReference: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type Reference_DeleteMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
  softDelete: Scalars["Boolean"];
}>;

export type Reference_DeleteMutation = { deleteConsultantReference: boolean };

export type Reference_RestoreMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
}>;

export type Reference_RestoreMutation = {
  restoreConsultantReference: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type Reference_SendToRefMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
}>;

export type Reference_SendToRefMutation = {
  sendConsultantReferenceForm: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type Reference_ReSendToRefMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
}>;

export type Reference_ReSendToRefMutation = {
  reSendConsultantReferenceForm: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type Reference_SendToKvkMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
  input: TodoItemInput;
}>;

export type Reference_SendToKvkMutation = {
  sendToKvkConsultantReference: {
    consultantReference: {
      _id: string;
      name: string;
      phone?: string | null;
      email?: string | null;
      position: string;
      workPlace: string;
      workRelation?: ConsultantReferenceRelation | null;
      formType?: ConsultantReferenceType | null;
      formLink?: string | null;
      editLink?: string | null;
      areaOfExpertise: string;
      status: ConsultantReferenceStatus;
      canBeSentToRef: boolean;
      canBeReSentToRef: boolean;
      reShared?: boolean | null;
      deleted: boolean;
      updatedOn?: Date | null;
      migrated?: boolean | null;
      orderedUpdateFromKvk?: boolean | null;
      form?: {
        submittedAt?: Date | null;
        submittedBy?: { name: string; nodeId: string } | null;
      } | null;
      submissionHistory?: Array<{
        submittedAt?: Date | null;
        submittedBy?: string | null;
      } | null> | null;
      lastStatusHistory: {
        changedAt: Date;
        newStatus: ConsultantReferenceStatus;
        changedBy: { name: string; nodeId: string };
      };
      reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
      document?: {
        PdfURL: string;
        PreviewURL: string;
        FileRef: { NodeID: string; Name?: string | null };
      } | null;
    };
  };
};

export type Reference_RequestUpdToKvkMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
  input: TodoItemInput;
}>;

export type Reference_RequestUpdToKvkMutation = {
  requestUpdToKvkConsultantReference: {
    consultantReference: {
      _id: string;
      name: string;
      phone?: string | null;
      email?: string | null;
      position: string;
      workPlace: string;
      workRelation?: ConsultantReferenceRelation | null;
      formType?: ConsultantReferenceType | null;
      formLink?: string | null;
      editLink?: string | null;
      areaOfExpertise: string;
      status: ConsultantReferenceStatus;
      canBeSentToRef: boolean;
      canBeReSentToRef: boolean;
      reShared?: boolean | null;
      deleted: boolean;
      updatedOn?: Date | null;
      migrated?: boolean | null;
      orderedUpdateFromKvk?: boolean | null;
      form?: {
        submittedAt?: Date | null;
        submittedBy?: { name: string; nodeId: string } | null;
      } | null;
      submissionHistory?: Array<{
        submittedAt?: Date | null;
        submittedBy?: string | null;
      } | null> | null;
      lastStatusHistory: {
        changedAt: Date;
        newStatus: ConsultantReferenceStatus;
        changedBy: { name: string; nodeId: string };
      };
      reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
      document?: {
        PdfURL: string;
        PreviewURL: string;
        FileRef: { NodeID: string; Name?: string | null };
      } | null;
    };
  };
};

export type Reference_ChangeStatusMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
  input: ChangeStatusConsultantReferenceInput;
  file?: InputMaybe<Scalars["Upload"]>;
}>;

export type Reference_ChangeStatusMutation = {
  changeStatusConsultantReference: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type Reference_MergeMutationVariables = Exact<{
  refId: Scalars["ObjectId"];
  mergeWithRefId: Scalars["ObjectId"];
}>;

export type Reference_MergeMutation = {
  mergeConsultantReference: {
    _id: string;
    name: string;
    phone?: string | null;
    email?: string | null;
    position: string;
    workPlace: string;
    workRelation?: ConsultantReferenceRelation | null;
    formType?: ConsultantReferenceType | null;
    formLink?: string | null;
    editLink?: string | null;
    areaOfExpertise: string;
    status: ConsultantReferenceStatus;
    canBeSentToRef: boolean;
    canBeReSentToRef: boolean;
    reShared?: boolean | null;
    deleted: boolean;
    updatedOn?: Date | null;
    migrated?: boolean | null;
    orderedUpdateFromKvk?: boolean | null;
    form?: {
      submittedAt?: Date | null;
      submittedBy?: { name: string; nodeId: string } | null;
    } | null;
    submissionHistory?: Array<{
      submittedAt?: Date | null;
      submittedBy?: string | null;
    } | null> | null;
    lastStatusHistory: {
      changedAt: Date;
      newStatus: ConsultantReferenceStatus;
      changedBy: { name: string; nodeId: string };
    };
    reminders?: Array<{ createdAt: Date; sentTo: string }> | null;
    document?: {
      PdfURL: string;
      PreviewURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    } | null;
  };
};

export type ConsultantServicePreferenceFragment = {
  _id: string;
  createdOn: Date;
  createdById: string;
  createdByName: string;
  nullifiedById?: string | null;
  nullifiedByName?: string | null;
  nullifiedOn?: Date | null;
  description: string;
  status: ConsultantServicePreferenceStatus;
  deleted: boolean;
  archived: boolean;
  period: { start: Date; end: Date };
  customers: Array<{ Id: string; Name: string; Type: CustomerType } | null>;
  reminders: Array<{ createdAt?: Date | null; sentTo?: string | null }>;
};

export type ConsultantServicePreferenceFormFragment = {
  _id: string;
  description: string;
  status: ConsultantServicePreferenceStatus;
  period: { start: Date; end: Date };
  customers: Array<{
    __typename: "Customer";
    _id: string;
    IsValid?: boolean | null;
    AreasOfExpertise: Array<string>;
    Name?: string | null;
    journalSystem?: string | null;
    Type: CustomerType;
    RegionRef: { Id: string; Name: string; Type: CustomerType };
    Parents: Array<{ Name: string }>;
    Address?: { City: string } | null;
  } | null>;
};

export type GetConsultantServicePreferencesQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantServicePreferencesQuery = {
  consultantServicePreferences: Array<{
    _id: string;
    createdOn: Date;
    createdById: string;
    createdByName: string;
    nullifiedById?: string | null;
    nullifiedByName?: string | null;
    nullifiedOn?: Date | null;
    description: string;
    status: ConsultantServicePreferenceStatus;
    deleted: boolean;
    archived: boolean;
    period: { start: Date; end: Date };
    customers: Array<{ Id: string; Name: string; Type: CustomerType } | null>;
    reminders: Array<{ createdAt?: Date | null; sentTo?: string | null }>;
  }>;
};

export type GetConsultantServicePreferenceFormQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantServicePreferenceFormQuery = {
  consultantServicePreferenceForm?: {
    _id: string;
    description: string;
    status: ConsultantServicePreferenceStatus;
    period: { start: Date; end: Date };
    customers: Array<{
      __typename: "Customer";
      _id: string;
      IsValid?: boolean | null;
      AreasOfExpertise: Array<string>;
      Name?: string | null;
      journalSystem?: string | null;
      Type: CustomerType;
      RegionRef: { Id: string; Name: string; Type: CustomerType };
      Parents: Array<{ Name: string }>;
      Address?: { City: string } | null;
    } | null>;
  } | null;
};

export type CreateConsultantServicePreferenceMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  input: CreateConsultantServicePreferenceInput;
}>;

export type CreateConsultantServicePreferenceMutation = {
  createConsultantServicePreference: {
    _id: string;
    createdOn: Date;
    createdById: string;
    createdByName: string;
    nullifiedById?: string | null;
    nullifiedByName?: string | null;
    nullifiedOn?: Date | null;
    description: string;
    status: ConsultantServicePreferenceStatus;
    deleted: boolean;
    archived: boolean;
    period: { start: Date; end: Date };
    customers: Array<{ Id: string; Name: string; Type: CustomerType } | null>;
    reminders: Array<{ createdAt?: Date | null; sentTo?: string | null }>;
  };
};

export type UpdateConsultantServicePreferenceMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: UpdateConsultantServicePreferenceInput;
}>;

export type UpdateConsultantServicePreferenceMutation = {
  updateConsultantServicePreference: {
    _id: string;
    createdOn: Date;
    createdById: string;
    createdByName: string;
    nullifiedById?: string | null;
    nullifiedByName?: string | null;
    nullifiedOn?: Date | null;
    description: string;
    status: ConsultantServicePreferenceStatus;
    deleted: boolean;
    archived: boolean;
    period: { start: Date; end: Date };
    customers: Array<{ Id: string; Name: string; Type: CustomerType } | null>;
    reminders: Array<{ createdAt?: Date | null; sentTo?: string | null }>;
  };
};

export type ChangeConsultantServicePreferenceStatusMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  status: ConsultantServicePreferenceStatus;
}>;

export type ChangeConsultantServicePreferenceStatusMutation = {
  changeConsultantServicePreferenceStatus: {
    _id: string;
    createdOn: Date;
    createdById: string;
    createdByName: string;
    nullifiedById?: string | null;
    nullifiedByName?: string | null;
    nullifiedOn?: Date | null;
    description: string;
    status: ConsultantServicePreferenceStatus;
    deleted: boolean;
    archived: boolean;
    period: { start: Date; end: Date };
    customers: Array<{ Id: string; Name: string; Type: CustomerType } | null>;
    reminders: Array<{ createdAt?: Date | null; sentTo?: string | null }>;
  };
};

export type DeleteConsultantServicePreferenceMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteConsultantServicePreferenceMutation = {
  deleteConsultantServicePreference: boolean;
};

export type WelcomeEmailDataFragment = { welcomeEmail?: boolean | null };

export type UserSettingsDataFragment = {
  SocialSecurityNo?: string | null;
  UserSettings: { __typename: "UserSettings"; Enabled: boolean };
};

export type UserSettingsFragment = { Enabled: boolean };

export type UnfitDataFragment = {
  Unfit: boolean;
  UnfitComment: string;
  UnfitedSetOn?: Date | null;
  unfitType?: ConsultantUnfitType | null;
  UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
};

export type SwitchesCardDataFragment = {
  __typename: "Consultant";
  _id: string;
  welcomeEmail?: boolean | null;
  SocialSecurityNo?: string | null;
  Unfit: boolean;
  UnfitComment: string;
  UnfitedSetOn?: Date | null;
  unfitType?: ConsultantUnfitType | null;
  UserSettings: { __typename: "UserSettings"; Enabled: boolean };
  UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
};

export type GetSwitchesDataQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetSwitchesDataQuery = {
  consultantById?: {
    __typename: "Consultant";
    _id: string;
    welcomeEmail?: boolean | null;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    UnfitedSetOn?: Date | null;
    unfitType?: ConsultantUnfitType | null;
    UserSettings: { __typename: "UserSettings"; Enabled: boolean };
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  } | null;
};

export type UpdateWelcomeEmailMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
}>;

export type UpdateWelcomeEmailMutation = {
  setConsultantWelcomeEmailSent: {
    __typename: "Consultant";
    _id: string;
    welcomeEmail?: boolean | null;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    UnfitedSetOn?: Date | null;
    unfitType?: ConsultantUnfitType | null;
    UserSettings: { __typename: "UserSettings"; Enabled: boolean };
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  };
};

export type UpdateUserSettingsMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: UserSettingsInput;
}>;

export type UpdateUserSettingsMutation = {
  updateConsultantUserSettings?: {
    __typename: "Consultant";
    _id: string;
    welcomeEmail?: boolean | null;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    UnfitedSetOn?: Date | null;
    unfitType?: ConsultantUnfitType | null;
    UserSettings: { __typename: "UserSettings"; Enabled: boolean };
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  } | null;
};

export type SetUnfitFlagMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  unfitType: ConsultantUnfitType;
  comment: Scalars["String"];
}>;

export type SetUnfitFlagMutation = {
  setConsultantUnfit: {
    __typename: "Consultant";
    _id: string;
    welcomeEmail?: boolean | null;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    UnfitedSetOn?: Date | null;
    unfitType?: ConsultantUnfitType | null;
    UserSettings: { __typename: "UserSettings"; Enabled: boolean };
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  };
};

export type ResetUnfitFlagMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ResetUnfitFlagMutation = {
  resetConsultantUnfit: {
    __typename: "Consultant";
    _id: string;
    welcomeEmail?: boolean | null;
    SocialSecurityNo?: string | null;
    Unfit: boolean;
    UnfitComment: string;
    UnfitedSetOn?: Date | null;
    unfitType?: ConsultantUnfitType | null;
    UserSettings: { __typename: "UserSettings"; Enabled: boolean };
    UnfitedBy?: { Name?: string | null; PersonId?: string | null } | null;
  };
};

export type UserDataFragment = {
  __typename: "User";
  _id: string;
  Deleted: boolean;
  Enabled: boolean;
  Name: string;
  Teams: Array<string>;
};

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUsersQuery = {
  users: Array<{
    __typename: "User";
    _id: string;
    Deleted: boolean;
    Enabled: boolean;
    Name: string;
    Teams: Array<string>;
  }>;
};

export type WorkExperienceDataFragment = {
  _id: string;
  ConsultantForm?: {
    workExperience: {
      items: Array<{
        areaOfExpertise: string;
        roles: string;
        fromYear?: string | null;
        fromMonth?: string | null;
        toYear?: string | null;
        toMonth?: string | null;
        workType: string;
        workPlace: string;
        departmentIds?: Array<string | null> | null;
        competitors?: Array<string | null> | null;
        employmentType?: LegalPersonType | null;
        experience?: string | null;
        excludeFromPresentation?: boolean | null;
        customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
      } | null>;
    };
  } | null;
};

export type GetConsultantWorkExperienceQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantWorkExperienceQuery = {
  consultantById?: {
    _id: string;
    ConsultantForm?: {
      workExperience: {
        items: Array<{
          areaOfExpertise: string;
          roles: string;
          fromYear?: string | null;
          fromMonth?: string | null;
          toYear?: string | null;
          toMonth?: string | null;
          workType: string;
          workPlace: string;
          departmentIds?: Array<string | null> | null;
          competitors?: Array<string | null> | null;
          employmentType?: LegalPersonType | null;
          experience?: string | null;
          excludeFromPresentation?: boolean | null;
          customerRef?: { Id: string; Name: string; Type: CustomerType } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type AddConsultantWorkExperienceMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  data: ConsultantWorkExperienceItemInput;
}>;

export type AddConsultantWorkExperienceMutation = {
  addConsultantWorkExperience: { OK: boolean };
};

export type DepartmentDataFragment = {
  _id: string;
  Name?: string | null;
  DirectParent?: { Id: string } | null;
};

export type GetCustomerDepartmentsQueryVariables = Exact<{
  customerIds?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
}>;

export type GetCustomerDepartmentsQuery = {
  departments: {
    dbTime?: number | null;
    items: Array<{
      _id: string;
      Name?: string | null;
      DirectParent?: { Id: string } | null;
    }>;
  };
};

export type ConsultantPayoutByYearDataFragment = {
  total: number;
  totalNationalProcurement: number;
  totalNonNationalProcurement: number;
  year: number;
};

export type GetConsultantPayoutByYearQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultantPayoutByYearQuery = {
  getConsultantPayoutByYear: Array<{
    total: number;
    totalNationalProcurement: number;
    totalNonNationalProcurement: number;
    year: number;
  } | null>;
};

export type GetFortnoxSalaryCacheQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetFortnoxSalaryCacheQuery = {
  getFortnoxSalaryCache?: {
    id: string;
    lastFetchedAt?: string | null;
    yearSums: Array<{ year: number; sum: number }>;
  } | null;
};

export type RefreshFortnoxSalaryCacheMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type RefreshFortnoxSalaryCacheMutation = {
  refreshFortnoxSalaryCache: {
    id: string;
    lastFetchedAt?: string | null;
    yearSums: Array<{ year: number; sum: number }>;
  };
};

export type ConsultantWorkStatusFragmentFragment = {
  _id: string;
  type: ConsultantWorkStatusType;
  startDate: Date;
  competitorName?: string | null;
  reminderDate?: Date | null;
  createdByName: string;
  createdOn: Date;
  deleted: boolean;
};

export type GetConsultantWorkStatusesQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantWorkStatusesQuery = {
  consultantWorkStatuses: Array<{
    _id: string;
    type: ConsultantWorkStatusType;
    startDate: Date;
    competitorName?: string | null;
    reminderDate?: Date | null;
    createdByName: string;
    createdOn: Date;
    deleted: boolean;
  }>;
};

export type CreateConsultantWorkStatusMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  input: CreateConsultantWorkStatusInput;
}>;

export type CreateConsultantWorkStatusMutation = {
  createConsultantWorkStatus: {
    _id: string;
    type: ConsultantWorkStatusType;
    startDate: Date;
    competitorName?: string | null;
    reminderDate?: Date | null;
    createdByName: string;
    createdOn: Date;
    deleted: boolean;
  };
};

export type UpdateConsultantWorkStatusMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: UpdateConsultantWorkStatusInput;
}>;

export type UpdateConsultantWorkStatusMutation = {
  updateConsultantWorkStatus: {
    _id: string;
    type: ConsultantWorkStatusType;
    startDate: Date;
    competitorName?: string | null;
    reminderDate?: Date | null;
    createdByName: string;
    createdOn: Date;
    deleted: boolean;
  };
};

export type DeleteConsultantWorkStatusMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteConsultantWorkStatusMutation = { deleteConsultantWorkStatus: boolean };

export type ConsultantReferenceStatusModalDataFragment = {
  _id: string;
  QualityPerCountry: Array<{ Country: string }>;
};

export type GetConsultantReferenceStatusModalDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetConsultantReferenceStatusModalDataQuery = {
  consultantById?: { _id: string; QualityPerCountry: Array<{ Country: string }> } | null;
};

export type UpdateConsultantQualityNoteMutationVariables = Exact<{
  consultantId: Scalars["ObjectId"];
  note?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateConsultantQualityNoteMutation = {
  updateConsultantQualityNote: boolean;
};

export type NpConsultantReferenceStatusModalDataFragment = {
  _id: string;
  QualityPerCountry: Array<{ Country: string }>;
};

export type GetNpConsultantReferenceStatusModalDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetNpConsultantReferenceStatusModalDataQuery = {
  consultantById?: { _id: string; QualityPerCountry: Array<{ Country: string }> } | null;
};

export type GetSaHlrDataQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type GetSaHlrDataQuery = {
  consultantById?: {
    _id: string;
    qualityChecks: Array<{
      country: string;
      itemName: string;
      status?: string | null;
      setDate?: Date | null;
      expirationDate?: Date | null;
    }>;
  } | null;
};

export type GDPRConsentRecordsDataFragment = {
  type: GDPRConsentType;
  granted?: boolean | null;
  dateGranted?: Date | null;
  dateRevoked?: Date | null;
  grantedBy?: { Name?: string | null } | null;
  revokedBy?: { Name?: string | null } | null;
};

export type ConsultantQualityPerCountryDataFragment = {
  Country: string;
  QualityChecks: Array<{
    DocumentType?: string | null;
    Name: string;
    HasExpired?: boolean | null;
    ExpiresOn?: Date | null;
    Status?:
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | { Name: string }
      | null;
  }>;
};

export type ConsultantSearchQualityCheckDataFragment = {
  country: string;
  itemName: string;
  status?: string | null;
  setDate?: Date | null;
  expirationDate?: Date | null;
  comment: string;
  params?: any | null;
  isPartiallyExpired: boolean;
};

export type ConsultantSearchCardDataFragment = {
  _id: string;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  AreasOfExpertise: Array<string>;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  Email?: string | null;
  secondaryEmail?: string | null;
  LastContactDate?: Date | null;
  Name?: string | null;
  Phone?: string | null;
  Unfit: boolean;
  SocialSecurityNo?: string | null;
  Specializations: Array<string>;
  IsValid?: boolean | null;
  Professions?: Array<string | null> | null;
  PrescriptionCode?: string | null;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  isNationalQualityApproved: boolean;
  isNationalQualityExpired: boolean;
  isPresentationReadyQualityApproved: boolean;
  isPresentationReadyQualityExpired: boolean;
  Title?: string | null;
  LegalBasis?: LegalBasis | null;
  AvailableForWorkInCountries: Array<string>;
  worksForCompetitors: Array<string>;
  hasDrivingLicence?: boolean | null;
  drivingLicenceType?: DrivingLicenceType | null;
  tags: Array<string>;
  pipelineStatus?: ConsultantPipelineStatus | null;
  bookingStatus: ConsultantBookingStatus;
  qualityNote?: string | null;
  Address?: { City: string } | null;
  contactType?: {
    employeeSalaryClaim?: string | null;
    subcontractorSalaryClaim?: string | null;
  } | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
  expertise: {
    machines: Array<string>;
    systems: Array<string | null>;
    educations: Array<string>;
    methods: Array<string>;
  };
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
    dateGranted?: Date | null;
    dateRevoked?: Date | null;
    grantedBy?: { Name?: string | null } | null;
    revokedBy?: { Name?: string | null } | null;
  } | null> | null;
  Availability: { ranges: Array<{ from: Date; to: Date }> };
  qualityChecks: Array<{
    country: string;
    itemName: string;
    status?: string | null;
    setDate?: Date | null;
    expirationDate?: Date | null;
    comment: string;
    params?: any | null;
    isPartiallyExpired: boolean;
  }>;
  nextContactDate?: { date?: Date | null } | null;
  generalInterest?: { regions: Array<string> } | null;
};

export type ConsultantSearchNewEventData_AccommodationEvent_Fragment = {
  _id: string;
  DescriptionHtml: string;
  CreatedOn: Date;
  CreatedBy: { Name?: string | null; PersonId?: string | null };
};

export type ConsultantSearchNewEventData_ConsultantEvent_Fragment = {
  _id: string;
  DescriptionHtml: string;
  CreatedOn: Date;
  CreatedBy: { Name?: string | null; PersonId?: string | null };
};

export type ConsultantSearchNewEventData_CustomerContractEventLog_Fragment = {
  _id: string;
  DescriptionHtml: string;
  CreatedOn: Date;
  CreatedBy: { Name?: string | null; PersonId?: string | null };
};

export type ConsultantSearchNewEventData_CustomerEvent_Fragment = {
  _id: string;
  DescriptionHtml: string;
  CreatedOn: Date;
  CreatedBy: { Name?: string | null; PersonId?: string | null };
};

export type ConsultantSearchNewEventData_TodoEvent_Fragment = {
  _id: string;
  DescriptionHtml: string;
  CreatedOn: Date;
  CreatedBy: { Name?: string | null; PersonId?: string | null };
};

export type ConsultantSearchNewEventDataFragment =
  | ConsultantSearchNewEventData_AccommodationEvent_Fragment
  | ConsultantSearchNewEventData_ConsultantEvent_Fragment
  | ConsultantSearchNewEventData_CustomerContractEventLog_Fragment
  | ConsultantSearchNewEventData_CustomerEvent_Fragment
  | ConsultantSearchNewEventData_TodoEvent_Fragment;

export type GetConsultantsQueryVariables = Exact<{
  filter?: InputMaybe<ConsultantsQueryInput>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  sortBy?: InputMaybe<ConsultantTableColumns>;
  sortOrder?: InputMaybe<SortOrder>;
  withEvents: Scalars["Boolean"];
  withCallListStats: Scalars["Boolean"];
  filterText: Scalars["String"];
}>;

export type GetConsultantsQuery = {
  consultants: {
    skip: number;
    limit: number;
    items: Array<{
      callListStats?: number;
      _id: string;
      createdAt?: Date | null;
      updatedAt?: Date | null;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Name?: string | null;
      Phone?: string | null;
      Unfit: boolean;
      SocialSecurityNo?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      Professions?: Array<string | null> | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      isNationalQualityApproved: boolean;
      isNationalQualityExpired: boolean;
      isPresentationReadyQualityApproved: boolean;
      isPresentationReadyQualityExpired: boolean;
      Title?: string | null;
      LegalBasis?: LegalBasis | null;
      AvailableForWorkInCountries: Array<string>;
      worksForCompetitors: Array<string>;
      hasDrivingLicence?: boolean | null;
      drivingLicenceType?: DrivingLicenceType | null;
      tags: Array<string>;
      pipelineStatus?: ConsultantPipelineStatus | null;
      bookingStatus: ConsultantBookingStatus;
      qualityNote?: string | null;
      Events?: Array<{
        _id: string;
        DescriptionHtml: string;
        CreatedOn: Date;
        CreatedBy: { Name?: string | null; PersonId?: string | null };
      }>;
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: {
        machines: Array<string>;
        systems: Array<string | null>;
        educations: Array<string>;
        methods: Array<string>;
      };
      GDPRConsentRecords?: Array<{
        type: GDPRConsentType;
        granted?: boolean | null;
        dateGranted?: Date | null;
        dateRevoked?: Date | null;
        grantedBy?: { Name?: string | null } | null;
        revokedBy?: { Name?: string | null } | null;
      } | null> | null;
      Availability: { ranges: Array<{ from: Date; to: Date }> };
      qualityChecks: Array<{
        country: string;
        itemName: string;
        status?: string | null;
        setDate?: Date | null;
        expirationDate?: Date | null;
        comment: string;
        params?: any | null;
        isPartiallyExpired: boolean;
      }>;
      nextContactDate?: { date?: Date | null } | null;
      generalInterest?: { regions: Array<string> } | null;
    }>;
    secondarySearch: Array<{
      callListStats?: number;
      _id: string;
      createdAt?: Date | null;
      updatedAt?: Date | null;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Name?: string | null;
      Phone?: string | null;
      Unfit: boolean;
      SocialSecurityNo?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      Professions?: Array<string | null> | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      isNationalQualityApproved: boolean;
      isNationalQualityExpired: boolean;
      isPresentationReadyQualityApproved: boolean;
      isPresentationReadyQualityExpired: boolean;
      Title?: string | null;
      LegalBasis?: LegalBasis | null;
      AvailableForWorkInCountries: Array<string>;
      worksForCompetitors: Array<string>;
      hasDrivingLicence?: boolean | null;
      drivingLicenceType?: DrivingLicenceType | null;
      tags: Array<string>;
      pipelineStatus?: ConsultantPipelineStatus | null;
      bookingStatus: ConsultantBookingStatus;
      qualityNote?: string | null;
      Events?: Array<{
        _id: string;
        DescriptionHtml: string;
        CreatedOn: Date;
        CreatedBy: { Name?: string | null; PersonId?: string | null };
      }>;
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: {
        machines: Array<string>;
        systems: Array<string | null>;
        educations: Array<string>;
        methods: Array<string>;
      };
      GDPRConsentRecords?: Array<{
        type: GDPRConsentType;
        granted?: boolean | null;
        dateGranted?: Date | null;
        dateRevoked?: Date | null;
        grantedBy?: { Name?: string | null } | null;
        revokedBy?: { Name?: string | null } | null;
      } | null> | null;
      Availability: { ranges: Array<{ from: Date; to: Date }> };
      qualityChecks: Array<{
        country: string;
        itemName: string;
        status?: string | null;
        setDate?: Date | null;
        expirationDate?: Date | null;
        comment: string;
        params?: any | null;
        isPartiallyExpired: boolean;
      }>;
      nextContactDate?: { date?: Date | null } | null;
      generalInterest?: { regions: Array<string> } | null;
    }>;
  };
};

export type ConsultantImport_RowFragment = {
  RowID?: number | null;
  FirstName: string;
  LastName: string;
  Phone: string;
  CellPhone: string;
  SocialSecurityNo?: string | null;
  SocialSecurityNoSource?: string | null;
  HPRNumber: string;
  isApprovedAuthorization?: boolean | null;
  country?: string | null;
  city?: string | null;
  streetName?: string | null;
  zipCode?: string | null;
  Competitor: string;
  CompetitorSource: string;
  InitialComment: string;
  AreaOfExpertise: Array<string>;
  IsDuplicate?: boolean | null;
  IsLookupSuccess?: boolean | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  ResponsiblePersonSource?: { PersonId?: string | null; Name?: string | null } | null;
  Duplicate?: { _id: string; Name?: string | null } | null;
  Errors: Array<{ Column: string; Message: string } | null>;
  Meta: { importBatch?: string | null; source?: any | null };
};

export type ConsultantImport_ImportConsultantsMutationVariables = Exact<{
  file: Scalars["Upload"];
  checkForDuplicates?: InputMaybe<Scalars["Boolean"]>;
  bisnodeLookup?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ConsultantImport_ImportConsultantsMutation = {
  importConsultants: {
    Rows: Array<{
      RowID?: number | null;
      FirstName: string;
      LastName: string;
      Phone: string;
      CellPhone: string;
      SocialSecurityNo?: string | null;
      SocialSecurityNoSource?: string | null;
      HPRNumber: string;
      isApprovedAuthorization?: boolean | null;
      country?: string | null;
      city?: string | null;
      streetName?: string | null;
      zipCode?: string | null;
      Competitor: string;
      CompetitorSource: string;
      InitialComment: string;
      AreaOfExpertise: Array<string>;
      IsDuplicate?: boolean | null;
      IsLookupSuccess?: boolean | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ResponsiblePersonSource?: { PersonId?: string | null; Name?: string | null } | null;
      Duplicate?: { _id: string; Name?: string | null } | null;
      Errors: Array<{ Column: string; Message: string } | null>;
      Meta: { importBatch?: string | null; source?: any | null };
    } | null>;
  };
};

export type ConsultantImport_Result_SaveConsultantsResultInvalid_Fragment = {
  Rows: Array<{
    RowID?: number | null;
    FirstName: string;
    LastName: string;
    Phone: string;
    CellPhone: string;
    SocialSecurityNo?: string | null;
    Competitor: string;
    CompetitorSource: string;
    InitialComment: string;
    AreaOfExpertise: Array<string>;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ResponsiblePersonSource?: { PersonId?: string | null; Name?: string | null } | null;
    Errors: Array<{ Column: string; Message: string } | null>;
    Meta: { importBatch?: string | null; source?: any | null };
  }>;
};

export type ConsultantImport_Result_SaveConsultantsResultOK_Fragment = {
  Msg: string;
  Consultants: Array<{ _id: string; Name?: string | null }>;
};

export type ConsultantImport_ResultFragment =
  | ConsultantImport_Result_SaveConsultantsResultInvalid_Fragment
  | ConsultantImport_Result_SaveConsultantsResultOK_Fragment;

export type ConsultantImport_SaveConsultantSelectionMutationVariables = Exact<{
  rows:
    | Array<InputMaybe<ConsultantImportRowsInput>>
    | InputMaybe<ConsultantImportRowsInput>;
  bisnodeLookup?: InputMaybe<Scalars["Boolean"]>;
}>;

export type ConsultantImport_SaveConsultantSelectionMutation = {
  saveConsultantSelection:
    | {
        Rows: Array<{
          RowID?: number | null;
          FirstName: string;
          LastName: string;
          Phone: string;
          CellPhone: string;
          SocialSecurityNo?: string | null;
          Competitor: string;
          CompetitorSource: string;
          InitialComment: string;
          AreaOfExpertise: Array<string>;
          ResponsiblePerson?: { PersonId: string; Name: string } | null;
          ResponsiblePersonSource?: {
            PersonId?: string | null;
            Name?: string | null;
          } | null;
          Errors: Array<{ Column: string; Message: string } | null>;
          Meta: { importBatch?: string | null; source?: any | null };
        }>;
      }
    | { Msg: string; Consultants: Array<{ _id: string; Name?: string | null }> };
};

export type ConsultantImport_DedupeMutationVariables = Exact<{
  rows: Array<ConsultantImportRowsInput> | ConsultantImportRowsInput;
}>;

export type ConsultantImport_DedupeMutation = {
  consultantImportDeduplicate: Array<{
    RowID?: number | null;
    FirstName: string;
    LastName: string;
    Phone: string;
    CellPhone: string;
    SocialSecurityNo?: string | null;
    SocialSecurityNoSource?: string | null;
    HPRNumber: string;
    isApprovedAuthorization?: boolean | null;
    country?: string | null;
    city?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
    Competitor: string;
    CompetitorSource: string;
    InitialComment: string;
    AreaOfExpertise: Array<string>;
    IsDuplicate?: boolean | null;
    IsLookupSuccess?: boolean | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ResponsiblePersonSource?: { PersonId?: string | null; Name?: string | null } | null;
    Duplicate?: { _id: string; Name?: string | null } | null;
    Errors: Array<{ Column: string; Message: string } | null>;
    Meta: { importBatch?: string | null; source?: any | null };
  }>;
};

export type ConsultantImport_LookupMutationVariables = Exact<{
  rows: Array<ConsultantImportRowsInput> | ConsultantImportRowsInput;
}>;

export type ConsultantImport_LookupMutation = {
  consultantImportLookupRows: Array<{
    RowID?: number | null;
    FirstName: string;
    LastName: string;
    Phone: string;
    CellPhone: string;
    SocialSecurityNo?: string | null;
    SocialSecurityNoSource?: string | null;
    HPRNumber: string;
    isApprovedAuthorization?: boolean | null;
    country?: string | null;
    city?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
    Competitor: string;
    CompetitorSource: string;
    InitialComment: string;
    AreaOfExpertise: Array<string>;
    IsDuplicate?: boolean | null;
    IsLookupSuccess?: boolean | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ResponsiblePersonSource?: { PersonId?: string | null; Name?: string | null } | null;
    Duplicate?: { _id: string; Name?: string | null } | null;
    Errors: Array<{ Column: string; Message: string } | null>;
    Meta: { importBatch?: string | null; source?: any | null };
  }>;
};

export type MyApiTokensQueryVariables = Exact<{ [key: string]: never }>;

export type MyApiTokensQuery = {
  myApiTokens: Array<{
    id: string;
    name: string;
    createdOn: Date;
    lastUsedOn?: Date | null;
    revoked: boolean;
  }>;
};

export type CreateApiTokenMutationVariables = Exact<{
  name: Scalars["String"];
}>;

export type CreateApiTokenMutation = {
  createApiToken: {
    token: string;
    apiToken: {
      id: string;
      name: string;
      createdOn: Date;
      lastUsedOn?: Date | null;
      revoked: boolean;
    };
  };
};

export type RevokeApiTokenMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RevokeApiTokenMutation = {
  revokeApiToken: {
    id: string;
    name: string;
    createdOn: Date;
    lastUsedOn?: Date | null;
    revoked: boolean;
  };
};

export type AuditFragment = {
  Created?: { Date: Date; User: { Name: string; PersonId: string } } | null;
  Deleted?: { Date: Date; User: { Name: string; PersonId: string } } | null;
  Updated?: { Date: Date; User: { Name: string; PersonId: string } } | null;
};

export type AuditItemFragment = {
  date: Date;
  type: AuditItemType;
  userRef: { PersonId: string; Name: string };
};

export type BisnodePersonFragment = {
  AddressCity?: string | null;
  AddressCountry?: string | null;
  AddressStreetName?: string | null;
  AddressZipCode?: string | null;
  CellPhone?: string | null;
  FirstName?: string | null;
  LastName?: string | null;
  Phone?: string | null;
};

export type BisnodeLookup_SSNQueryVariables = Exact<{
  country: Scalars["String"];
  ssn: Scalars["String"];
}>;

export type BisnodeLookup_SSNQuery = {
  lookup?: {
    AddressCity?: string | null;
    AddressCountry?: string | null;
    AddressStreetName?: string | null;
    AddressZipCode?: string | null;
    CellPhone?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    Phone?: string | null;
  } | null;
};

export type BisnodeLookup_PhoneQueryVariables = Exact<{
  country: Scalars["String"];
  phone: Scalars["String"];
}>;

export type BisnodeLookup_PhoneQuery = {
  lookup?: {
    AddressCity?: string | null;
    AddressCountry?: string | null;
    AddressStreetName?: string | null;
    AddressZipCode?: string | null;
    CellPhone?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    Phone?: string | null;
  } | null;
};

export type CallListEditor_CallListFragment = { _id: string; name: string };

export type CallListEditor_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CallListEditor_GetQuery = {
  callListById: { callList?: { _id: string; name: string } | null };
};

export type CallListEditor_CreateMutationVariables = Exact<{
  listType: CallListType;
  name: Scalars["String"];
  nodes: Array<NodeRefFullInput> | NodeRefFullInput;
  type: NodeType;
}>;

export type CallListEditor_CreateMutation = {
  submit: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type CallListEditor_UpdateMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  newName: Scalars["String"];
}>;

export type CallListEditor_UpdateMutation = {
  submit: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type ConsultantPresentationApproveDialog_GetQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantPresentationApproveDialog_GetQuery = {
  consultantById?: { _id: string; PresentationUrl: string } | null;
};

export type ConsultantShareableFilesFragment = {
  _id: string;
  DocumentsShareable: Array<{
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: { NodeID: string; Name?: string | null };
  }>;
};

export type ConsultantShareableFiles_GetQueryVariables = Exact<{
  consultantId: Scalars["ObjectId"];
}>;

export type ConsultantShareableFiles_GetQuery = {
  consultantById?: {
    _id: string;
    DocumentsShareable: Array<{
      DocumentType?: string | null;
      ThumbURL: string;
      PdfURL: string;
      FileRef: { NodeID: string; Name?: string | null };
    }>;
  } | null;
};

export type ContactPersonEditorFragment = {
  _id: string;
  IsInheritable: boolean;
  AreasOfExpertise: Array<string | null>;
  BooksProfessions: Array<string>;
  CustomerGroups: Array<string>;
  Email?: string | null;
  EmailValid: boolean;
  Name?: string | null;
  CellPhone?: string | null;
  CellPhoneValid: boolean;
  Phone?: string | null;
  PhoneValid: boolean;
  Roles: Array<string>;
  Title?: string | null;
  CustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  RootCustomer: { Id: string; Name: string; Type: CustomerType };
};

export type ContactPersonEditor_CustomerFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  Name?: string | null;
  Type: CustomerType;
  Address?: { Country: string } | null;
  CustomerTree: Array<{
    ParentId?: string | null;
    CustomerRef: { Id: string; Name: string; Type: CustomerType };
    HospitalRef?: { Id: string; Name: string; Type: CustomerType } | null;
  }>;
};

export type ContactPersonEditor_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ContactPersonEditor_GetQuery = {
  contactPersonById: {
    _id: string;
    IsInheritable: boolean;
    AreasOfExpertise: Array<string | null>;
    BooksProfessions: Array<string>;
    CustomerGroups: Array<string>;
    Email?: string | null;
    EmailValid: boolean;
    Name?: string | null;
    CellPhone?: string | null;
    CellPhoneValid: boolean;
    Phone?: string | null;
    PhoneValid: boolean;
    Roles: Array<string>;
    Title?: string | null;
    CustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
    RootCustomer: { Id: string; Name: string; Type: CustomerType };
  };
};

export type ContactPersonEditor_GetCustomerQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
}>;

export type ContactPersonEditor_GetCustomerQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    Name?: string | null;
    Type: CustomerType;
    Address?: { Country: string } | null;
    CustomerTree: Array<{
      ParentId?: string | null;
      CustomerRef: { Id: string; Name: string; Type: CustomerType };
      HospitalRef?: { Id: string; Name: string; Type: CustomerType } | null;
    }>;
  } | null;
};

export type ContactPersonEditor_CreateMutationVariables = Exact<{
  data: ContactPersonInput;
}>;

export type ContactPersonEditor_CreateMutation = {
  result: {
    contactPerson?: {
      _id: string;
      IsInheritable: boolean;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerGroups: Array<string>;
      Email?: string | null;
      EmailValid: boolean;
      Name?: string | null;
      CellPhone?: string | null;
      CellPhoneValid: boolean;
      Phone?: string | null;
      PhoneValid: boolean;
      Roles: Array<string>;
      Title?: string | null;
      CustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      RootCustomer: { Id: string; Name: string; Type: CustomerType };
    } | null;
    validationErrors: Array<{ Message?: string | null; Path?: string | null }>;
  };
};

export type ContactPersonEditor_UpdateMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  data: ContactPersonInput;
}>;

export type ContactPersonEditor_UpdateMutation = {
  result: {
    contactPerson?: {
      _id: string;
      IsInheritable: boolean;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerGroups: Array<string>;
      Email?: string | null;
      EmailValid: boolean;
      Name?: string | null;
      CellPhone?: string | null;
      CellPhoneValid: boolean;
      Phone?: string | null;
      PhoneValid: boolean;
      Roles: Array<string>;
      Title?: string | null;
      CustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      RootCustomer: { Id: string; Name: string; Type: CustomerType };
    } | null;
    validationErrors: Array<{ Message?: string | null; Path?: string | null }>;
  };
};

export type ContactPersonEditor_ExtractMutationVariables = Exact<{
  customerId: Scalars["ObjectId"];
  contactPersonId: Scalars["ObjectId"];
  data: ContactPersonInput;
}>;

export type ContactPersonEditor_ExtractMutation = {
  result: {
    contactPerson?: {
      _id: string;
      IsInheritable: boolean;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerGroups: Array<string>;
      Email?: string | null;
      EmailValid: boolean;
      Name?: string | null;
      CellPhone?: string | null;
      CellPhoneValid: boolean;
      Phone?: string | null;
      PhoneValid: boolean;
      Roles: Array<string>;
      Title?: string | null;
      CustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
      RootCustomer: { Id: string; Name: string; Type: CustomerType };
    } | null;
    validationErrors: Array<{ Message?: string | null; Path?: string | null }>;
  };
};

export type CustomerAutosuggestItemFragment = {
  _id: string;
  Name?: string | null;
  Type: CustomerType;
};

export type CustomerAutosuggest_GetQueryVariables = Exact<{
  text: Scalars["String"];
  skip: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type CustomerAutosuggest_GetQuery = {
  customers: {
    dbTime?: number | null;
    items: Array<{ _id: string; Name?: string | null; Type: CustomerType }>;
  };
};

export type CustomerTreeSelect_ItemFragment = {
  ParentId?: string | null;
  CustomerRef: { Id: string; Name: string; Type: CustomerType };
  HospitalRef?: { Id: string; Name: string; Type: CustomerType } | null;
};

export type DocumentList_ItemFragment = {
  DocumentType?: string | null;
  ThumbURL: string;
  PdfURL: string;
  FileRef: {
    MimeType: string;
    Name?: string | null;
    NodeID: string;
    NodeType: NodeType;
    Size: number;
  };
};

export type EmailEditor_UploadAttachmentMutationVariables = Exact<{
  file: Scalars["Upload"];
}>;

export type EmailEditor_UploadAttachmentMutation = {
  uploadDocument: {
    DocumentType?: string | null;
    ThumbURL: string;
    PdfURL: string;
    FileRef: {
      MimeType: string;
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      Size: number;
    };
  };
};

export type EventLog_AccommodationEventFragment = {
  Links?: Array<string> | null;
  Type: AccommodationEventType;
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type AccommodationEventLog_GetEventsQueryVariables = Exact<{
  accommodationId: Scalars["ObjectId"];
}>;

export type AccommodationEventLog_GetEventsQuery = {
  accommodationEvents?: Array<{
    Links?: Array<string> | null;
    Type: AccommodationEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null> | null;
};

export type AccommodationEventLog_AddCommentMutationVariables = Exact<{
  accommodationId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type AccommodationEventLog_AddCommentMutation = {
  addAccommodationCommentEvent?: {
    Links?: Array<string> | null;
    Type: AccommodationEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AccommodationEventLog_PinMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type AccommodationEventLog_PinMutation = {
  pinAccommodationEvent?: {
    Links?: Array<string> | null;
    Type: AccommodationEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AccommodationEventLog_UpdateMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type AccommodationEventLog_UpdateMutation = {
  updateAccommodationEvent?: {
    Links?: Array<string> | null;
    Type: AccommodationEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type AccommodationEventLog_DeleteMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type AccommodationEventLog_DeleteMutation = {
  deleteAccommodationEvent?: {
    Links?: Array<string> | null;
    Type: AccommodationEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type EventLog_BookingEventFragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Type: BookingEventType;
  ResultOfAction?: string | null;
  Links?: Array<string | null> | null;
  Warning?: boolean | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
  UserRef?: { Name: string; PersonId: string } | null;
};

export type BookingEventLog_GetEventsQueryVariables = Exact<{
  bookingId: Scalars["ObjectId"];
}>;

export type BookingEventLog_GetEventsQuery = {
  bookingEvents?: Array<{
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null> | null;
};

export type BookingEventLog_AddCommentMutationVariables = Exact<{
  bookingId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type BookingEventLog_AddCommentMutation = {
  addBookingCommentEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type BookingEventLog_UpdateMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
  desc?: InputMaybe<Scalars["String"]>;
  sticky?: InputMaybe<Scalars["Boolean"]>;
}>;

export type BookingEventLog_UpdateMutation = {
  updateBookingEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type BookingEventLog_DeleteMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type BookingEventLog_DeleteMutation = {
  deleteBookingEvent?: {
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Type: BookingEventType;
    ResultOfAction?: string | null;
    Links?: Array<string | null> | null;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
    UserRef?: { Name: string; PersonId: string } | null;
  } | null;
};

export type UpdateCustomerContractEventMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  eventLog: CustomerContractEventInput;
}>;

export type UpdateCustomerContractEventMutation = {
  updateCustomerContractEvent: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      eventLogs: Array<{
        Links?: Array<string> | null;
        EventType: CustomerContractEventType;
        _id: string;
        CanDelete: boolean;
        CanEdit: boolean;
        CanPin: boolean;
        CreatedOn: Date;
        Deleted: boolean;
        Description: string;
        DescriptionHtml: string;
        Sticky: boolean;
        Warning?: boolean | null;
        CreatedBy: { PersonId?: string | null; Name?: string | null };
        UpdatedBy?: { Name?: string | null } | null;
      }>;
    } | null;
  };
};

export type DeleteCustomerContractEventMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  eventId: Scalars["ObjectId"];
}>;

export type DeleteCustomerContractEventMutation = {
  deleteCustomerContractEvent: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      eventLogs: Array<{
        Links?: Array<string> | null;
        EventType: CustomerContractEventType;
        _id: string;
        CanDelete: boolean;
        CanEdit: boolean;
        CanPin: boolean;
        CreatedOn: Date;
        Deleted: boolean;
        Description: string;
        DescriptionHtml: string;
        Sticky: boolean;
        Warning?: boolean | null;
        CreatedBy: { PersonId?: string | null; Name?: string | null };
        UpdatedBy?: { Name?: string | null } | null;
      }>;
    } | null;
  };
};

export type EventLog_CustomerContractEventFragment = {
  Links?: Array<string> | null;
  EventType: CustomerContractEventType;
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy?: { Name?: string | null } | null;
};

export type CustomerContractEventLogFragment = {
  _id: string;
  eventLogs: Array<{
    Links?: Array<string> | null;
    EventType: CustomerContractEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy?: { Name?: string | null } | null;
  }>;
};

export type GetCustomerContractEventLogQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type GetCustomerContractEventLogQuery = {
  customerContractById?: {
    _id: string;
    eventLogs: Array<{
      Links?: Array<string> | null;
      EventType: CustomerContractEventType;
      _id: string;
      CanDelete: boolean;
      CanEdit: boolean;
      CanPin: boolean;
      CreatedOn: Date;
      Deleted: boolean;
      Description: string;
      DescriptionHtml: string;
      Sticky: boolean;
      Warning?: boolean | null;
      CreatedBy: { PersonId?: string | null; Name?: string | null };
      UpdatedBy?: { Name?: string | null } | null;
    }>;
  } | null;
};

export type AddCustomerContractCommentEventMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  eventLog: CustomerContractEventInput;
}>;

export type AddCustomerContractCommentEventMutation = {
  addCustomerContractCommentEvent: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      eventLogs: Array<{
        Links?: Array<string> | null;
        EventType: CustomerContractEventType;
        _id: string;
        CanDelete: boolean;
        CanEdit: boolean;
        CanPin: boolean;
        CreatedOn: Date;
        Deleted: boolean;
        Description: string;
        DescriptionHtml: string;
        Sticky: boolean;
        Warning?: boolean | null;
        CreatedBy: { PersonId?: string | null; Name?: string | null };
        UpdatedBy?: { Name?: string | null } | null;
      }>;
    } | null;
  };
};

export type EventLog_CustomerEventFragment = {
  AreasOfExpertise: Array<string>;
  CustomerGroup?: string | null;
  Roles: Array<string>;
  Type: CustomerEventType;
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  ContactPerson: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
  RootCustomer: { Id: string; Name: string; Type: CustomerType };
  MetBy?: { Name?: string | null; PersonId?: string | null } | null;
  TodoItem?: {
    _id: string;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    Completed?: Date | null;
    Description: string;
    Due?: Date | null;
    AssignedTo?: { Name: string; PersonId: string } | null;
    AssignedBy: { Name: string; PersonId: string };
  } | null;
  TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type CustomerEventLog_GetEventsQueryVariables = Exact<{
  filter: CustomerEventFilter;
}>;

export type CustomerEventLog_GetEventsQuery = {
  customerEvents: Array<{
    AreasOfExpertise: Array<string>;
    CustomerGroup?: string | null;
    Roles: Array<string>;
    Type: CustomerEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    ContactPerson: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    RootCustomer: { Id: string; Name: string; Type: CustomerType };
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  }>;
};

export type CustomerEventLog_AddCustomerCommentMutationVariables = Exact<{
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type CustomerEventLog_AddCustomerCommentMutation = {
  addCustomerCommentEvent?: {
    AreasOfExpertise: Array<string>;
    CustomerGroup?: string | null;
    Roles: Array<string>;
    Type: CustomerEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    ContactPerson: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    RootCustomer: { Id: string; Name: string; Type: CustomerType };
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type CustomerEventLog_AddCustomerReminderMutationVariables = Exact<{
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type CustomerEventLog_AddCustomerReminderMutation = {
  addCustomerReminderEvent?: {
    AreasOfExpertise: Array<string>;
    CustomerGroup?: string | null;
    Roles: Array<string>;
    Type: CustomerEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    ContactPerson: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    RootCustomer: { Id: string; Name: string; Type: CustomerType };
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type CustomerEventLog_AddCustomerMetInPersonMutationVariables = Exact<{
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type CustomerEventLog_AddCustomerMetInPersonMutation = {
  addCustomerMetInPersonEvent?: {
    AreasOfExpertise: Array<string>;
    CustomerGroup?: string | null;
    Roles: Array<string>;
    Type: CustomerEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    ContactPerson: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    RootCustomer: { Id: string; Name: string; Type: CustomerType };
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type CustomerEventLog_UpdateMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type CustomerEventLog_UpdateMutation = {
  updateCustomerEvent?: {
    AreasOfExpertise: Array<string>;
    CustomerGroup?: string | null;
    Roles: Array<string>;
    Type: CustomerEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    Links?: Array<string> | null;
    ContactPerson: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    RootCustomer: { Id: string; Name: string; Type: CustomerType };
    MetBy?: { Name?: string | null; PersonId?: string | null } | null;
    TodoItem?: {
      _id: string;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      Completed?: Date | null;
      Description: string;
      Due?: Date | null;
      AssignedTo?: { Name: string; PersonId: string } | null;
      AssignedBy: { Name: string; PersonId: string };
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { Name?: string | null };
  } | null;
};

export type CustomerEventLog_DeleteMutationVariables = Exact<{
  eventId: Scalars["ObjectId"];
}>;

export type CustomerEventLog_DeleteMutation = { deleteCustomerEvent?: boolean | null };

export type EventLog_Event_AccommodationEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventLog_Event_ConsultantEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventLog_Event_CustomerContractEventLog_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy?: { Name?: string | null } | null;
};

export type EventLog_Event_CustomerEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventLog_Event_TodoEvent_Fragment = {
  _id: string;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  Links?: Array<string> | null;
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { Name?: string | null };
};

export type EventLog_EventFragment =
  | EventLog_Event_AccommodationEvent_Fragment
  | EventLog_Event_ConsultantEvent_Fragment
  | EventLog_Event_CustomerContractEventLog_Fragment
  | EventLog_Event_CustomerEvent_Fragment
  | EventLog_Event_TodoEvent_Fragment;

export type TicketEventFragment = {
  Type: TodoEventType;
  _id: string;
  CreatedOn: Date;
  Deleted: boolean;
  Description: string;
  DescriptionHtml: string;
  Sticky: boolean;
  Warning?: boolean | null;
  CanPin: boolean;
  CanEdit: boolean;
  CanDelete: boolean;
  Audit: {
    Created?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    Updated?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    Deleted?: { Date: Date; User: { PersonId: string; Name: string } } | null;
  };
  CreatedBy: { PersonId?: string | null; Name?: string | null };
  DeletedBy: { PersonId?: string | null; Name?: string | null };
  UpdatedBy: { PersonId?: string | null; Name?: string | null };
  TodoItem?: {
    _id: string;
    type?: NodeType | null;
    NodeType?: NodeType | null;
    NodeName?: string | null;
    Accepted?: boolean | null;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    CanAccept?: boolean | null;
    Completed?: Date | null;
    Deleted: boolean;
    Description: string;
    Due?: Date | null;
    SecondaryText: string;
    Status: TodoStatus;
    Tags: Array<string>;
    Type: TodoItemType;
    URL?: string | null;
    Priority?: TodoPriority | null;
    ViewMode: boolean;
    AssignedTo?: { PersonId: string; Name: string } | null;
    AssignedBy: { PersonId: string; Name: string };
    DelegatedBy?: { PersonId: string; Name: string } | null;
    LinkedItems?: Array<{
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
    }> | null;
    RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
    WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
  } | null;
  TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
};

export type GetTicketCommentsQueryVariables = Exact<{
  todoId: Scalars["ObjectId"];
}>;

export type GetTicketCommentsQuery = {
  todoEvents?: Array<{
    Type: TodoEventType;
    _id: string;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CanPin: boolean;
    CanEdit: boolean;
    CanDelete: boolean;
    Audit: {
      Created?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Updated?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Deleted?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    };
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    DeletedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { PersonId?: string | null; Name?: string | null };
    TodoItem?: {
      _id: string;
      type?: NodeType | null;
      NodeType?: NodeType | null;
      NodeName?: string | null;
      Accepted?: boolean | null;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      CanAccept?: boolean | null;
      Completed?: Date | null;
      Deleted: boolean;
      Description: string;
      Due?: Date | null;
      SecondaryText: string;
      Status: TodoStatus;
      Tags: Array<string>;
      Type: TodoItemType;
      URL?: string | null;
      Priority?: TodoPriority | null;
      ViewMode: boolean;
      AssignedTo?: { PersonId: string; Name: string } | null;
      AssignedBy: { PersonId: string; Name: string };
      DelegatedBy?: { PersonId: string; Name: string } | null;
      LinkedItems?: Array<{
        NodeID: string;
        NodeType: NodeType;
        Name?: string | null;
      }> | null;
      RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
      WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  } | null> | null;
};

export type AddTicketCommentMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type AddTicketCommentMutation = {
  addTodoCommentEvent?: {
    Type: TodoEventType;
    _id: string;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CanPin: boolean;
    CanEdit: boolean;
    CanDelete: boolean;
    Audit: {
      Created?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Updated?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Deleted?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    };
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    DeletedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { PersonId?: string | null; Name?: string | null };
    TodoItem?: {
      _id: string;
      type?: NodeType | null;
      NodeType?: NodeType | null;
      NodeName?: string | null;
      Accepted?: boolean | null;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      CanAccept?: boolean | null;
      Completed?: Date | null;
      Deleted: boolean;
      Description: string;
      Due?: Date | null;
      SecondaryText: string;
      Status: TodoStatus;
      Tags: Array<string>;
      Type: TodoItemType;
      URL?: string | null;
      Priority?: TodoPriority | null;
      ViewMode: boolean;
      AssignedTo?: { PersonId: string; Name: string } | null;
      AssignedBy: { PersonId: string; Name: string };
      DelegatedBy?: { PersonId: string; Name: string } | null;
      LinkedItems?: Array<{
        NodeID: string;
        NodeType: NodeType;
        Name?: string | null;
      }> | null;
      RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
      WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  } | null;
};

export type AddTicketCommentWithReminderMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
}>;

export type AddTicketCommentWithReminderMutation = {
  addTodoReminderEvent?: {
    Type: TodoEventType;
    _id: string;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CanPin: boolean;
    CanEdit: boolean;
    CanDelete: boolean;
    Audit: {
      Created?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Updated?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Deleted?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    };
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    DeletedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { PersonId?: string | null; Name?: string | null };
    TodoItem?: {
      _id: string;
      type?: NodeType | null;
      NodeType?: NodeType | null;
      NodeName?: string | null;
      Accepted?: boolean | null;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      CanAccept?: boolean | null;
      Completed?: Date | null;
      Deleted: boolean;
      Description: string;
      Due?: Date | null;
      SecondaryText: string;
      Status: TodoStatus;
      Tags: Array<string>;
      Type: TodoItemType;
      URL?: string | null;
      Priority?: TodoPriority | null;
      ViewMode: boolean;
      AssignedTo?: { PersonId: string; Name: string } | null;
      AssignedBy: { PersonId: string; Name: string };
      DelegatedBy?: { PersonId: string; Name: string } | null;
      LinkedItems?: Array<{
        NodeID: string;
        NodeType: NodeType;
        Name?: string | null;
      }> | null;
      RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
      WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  } | null;
};

export type UpdateTicketCommentMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  desc: Scalars["String"];
}>;

export type UpdateTicketCommentMutation = {
  updateTodoEvent?: {
    Type: TodoEventType;
    _id: string;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CanPin: boolean;
    CanEdit: boolean;
    CanDelete: boolean;
    Audit: {
      Created?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Updated?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Deleted?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    };
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    DeletedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { PersonId?: string | null; Name?: string | null };
    TodoItem?: {
      _id: string;
      type?: NodeType | null;
      NodeType?: NodeType | null;
      NodeName?: string | null;
      Accepted?: boolean | null;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      CanAccept?: boolean | null;
      Completed?: Date | null;
      Deleted: boolean;
      Description: string;
      Due?: Date | null;
      SecondaryText: string;
      Status: TodoStatus;
      Tags: Array<string>;
      Type: TodoItemType;
      URL?: string | null;
      Priority?: TodoPriority | null;
      ViewMode: boolean;
      AssignedTo?: { PersonId: string; Name: string } | null;
      AssignedBy: { PersonId: string; Name: string };
      DelegatedBy?: { PersonId: string; Name: string } | null;
      LinkedItems?: Array<{
        NodeID: string;
        NodeType: NodeType;
        Name?: string | null;
      }> | null;
      RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
      WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  } | null;
};

export type DeleteTicketCommentMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteTicketCommentMutation = {
  deleteTodoEvent?: {
    Type: TodoEventType;
    _id: string;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CanPin: boolean;
    CanEdit: boolean;
    CanDelete: boolean;
    Audit: {
      Created?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Updated?: { Date: Date; User: { PersonId: string; Name: string } } | null;
      Deleted?: { Date: Date; User: { PersonId: string; Name: string } } | null;
    };
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    DeletedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy: { PersonId?: string | null; Name?: string | null };
    TodoItem?: {
      _id: string;
      type?: NodeType | null;
      NodeType?: NodeType | null;
      NodeName?: string | null;
      Accepted?: boolean | null;
      AssignedOn: Date;
      AssignedTeam?: string | null;
      CanAccept?: boolean | null;
      Completed?: Date | null;
      Deleted: boolean;
      Description: string;
      Due?: Date | null;
      SecondaryText: string;
      Status: TodoStatus;
      Tags: Array<string>;
      Type: TodoItemType;
      URL?: string | null;
      Priority?: TodoPriority | null;
      ViewMode: boolean;
      AssignedTo?: { PersonId: string; Name: string } | null;
      AssignedBy: { PersonId: string; Name: string };
      DelegatedBy?: { PersonId: string; Name: string } | null;
      LinkedItems?: Array<{
        NodeID: string;
        NodeType: NodeType;
        Name?: string | null;
      }> | null;
      RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
      WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
    } | null;
    TodoRef?: { Name?: string | null; NodeID: string; NodeType: NodeType } | null;
  } | null;
};

export type GetBookingAssignedToTotalQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookingAssignedToTotalQuery = {
  getBookingAssignedToTotal: { total: number; dbTime?: number | null };
};

export type GetBookingKitAssignedToTotalQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookingKitAssignedToTotalQuery = {
  getBookingKitAssignedToTotal: { total: number; dbTime?: number | null };
};

export type MassContactActions_SMSResultFragment = {
  result: Array<{
    ConsultantId: string;
    SMSMessage: { _id: string; Status: SMSDeliveryStatus };
  }>;
};

export type MassContactActions_SendSMSMutationVariables = Exact<{
  message: Scalars["String"];
  consultantIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type MassContactActions_SendSMSMutation = {
  sendMassSMSToConsultants: {
    result: Array<{
      ConsultantId: string;
      SMSMessage: { _id: string; Status: SMSDeliveryStatus };
    }>;
  };
};

export type MassContactActions_UpdateResponsiblePersonMutationVariables = Exact<{
  ids: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type MassContactActions_UpdateResponsiblePersonMutation = {
  bulkUpdateResponsiblePerson: {
    updated: number;
    consultants: Array<{
      _id: string;
      ResponsiblePerson?: { Name: string; PersonId: string } | null;
    }>;
  };
};

export type MassContactActions_SendEmailMutationVariables = Exact<{
  nodeType: NodeType;
  nodeIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
  subject: Scalars["String"];
  body: Scalars["String"];
  attachment?: InputMaybe<
    Array<InputMaybe<Scalars["ObjectId"]>> | InputMaybe<Scalars["ObjectId"]>
  >;
  campaign?: InputMaybe<Scalars["Boolean"]>;
}>;

export type MassContactActions_SendEmailMutation = {
  sendMassEmail: { Subject: string; Body: string };
};

export type MassContactActions_DeleteMutationVariables = Exact<{
  ids: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type MassContactActions_DeleteMutation = {
  deleteConsultants?: { total: number } | null;
};

export type MassContactActions_SMSSubscriptionVariables = Exact<{
  messageId: Scalars["ObjectId"];
}>;

export type MassContactActions_SMSSubscription = {
  smsMessageUpdated: { _id: string; Status: SMSDeliveryStatus };
};

export type MassContactActions_ExportCSVQueryVariables = Exact<{
  ids: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type MassContactActions_ExportCSVQuery = {
  consultantsCSV: { Filename: string; URL: string };
};

export type ContactListItem_Consultant_Fragment = {
  _id: string;
  AvatarPic?: string | null;
  Name?: string | null;
  Email?: string | null;
  EmailValid: boolean;
  Phone?: string | null;
  PhoneValid: boolean;
  CellPhone?: string | null;
  CellPhoneValid: boolean;
  Title?: string | null;
  Roles?: Array<string> | null;
  ResponsiblePerson?: { Name: string; PersonId: string } | null;
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
  } | null> | null;
};

export type ContactListItem_ContactPerson_Fragment = {
  _id: string;
  AvatarPic?: string | null;
  Name?: string | null;
  Email?: string | null;
  EmailValid: boolean;
  Phone?: string | null;
  PhoneValid: boolean;
  CellPhone?: string | null;
  CellPhoneValid: boolean;
  Title?: string | null;
  Roles: Array<string>;
  ResponsiblePerson?: { Name: string; PersonId: string } | null;
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
  } | null> | null;
};

export type ContactListItem_CustomerContact_Fragment = {
  _id?: string | null;
  AvatarPic?: string | null;
  Name?: string | null;
  Email?: string | null;
  EmailValid: boolean;
  Phone?: string | null;
  PhoneValid: boolean;
  CellPhone?: string | null;
  CellPhoneValid: boolean;
  Title: string;
  Roles: Array<string>;
  ResponsiblePerson?: { Name: string; PersonId: string } | null;
  GDPRConsentRecords?: Array<{
    type: GDPRConsentType;
    granted?: boolean | null;
  } | null> | null;
};

export type ContactListItemFragment =
  | ContactListItem_Consultant_Fragment
  | ContactListItem_ContactPerson_Fragment
  | ContactListItem_CustomerContact_Fragment;

export type NodeCallList_AddMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  node: NodeRefFullInput;
}>;

export type NodeCallList_AddMutation = {
  addToCallList: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type NodeCallList_RemoveMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  nodeId: Scalars["ObjectId"];
}>;

export type NodeCallList_RemoveMutation = {
  removeFromCallList: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type NodeCallList_LeaveListMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type NodeCallList_LeaveListMutation = {
  leaveCallList: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type SetCallListMembrsMutationVariables = Exact<{
  callListId: Scalars["ObjectId"];
  userIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type SetCallListMembrsMutation = {
  setCallListMembers: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type NodeCallList_GetByIdQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type NodeCallList_GetByIdQuery = {
  callListById: {
    callList?: {
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    } | null;
  };
};

export type NodeCallListFragment = {
  _id: string;
  deleted: boolean;
  name: string;
  type: NodeType;
  nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
  members: Array<{ PersonId: string; Name: string }>;
};

export type NodeCallList_GetListsQueryVariables = Exact<{ [key: string]: never }>;

export type NodeCallList_GetListsQuery = {
  me: {
    _id: string;
    CallLists: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
    ContactLists: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
  };
};

export type GetUserSelectorUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSelectorUsersQuery = {
  users: Array<{
    _id: string;
    AzureId?: string | null;
    AvatarPic?: string | null;
    BirthDate?: Date | null;
    CellPhone?: string | null;
    Email: string;
    Enabled: boolean;
    Name: string;
    Phone?: string | null;
    Teams: Array<string>;
    AzureGroups?: Array<string> | null;
    Title?: string | null;
    Deleted: boolean;
    ManagerId?: string | null;
  }>;
  teams: Array<{ _id: string; Name?: string | null }>;
};

export type AccommodationSelectorItemFragment = {
  _id: string;
  Type?: AccommodationType | null;
  ImgUrl?: string | null;
  Name?: string | null;
  Email?: Array<string | null> | null;
  Site?: string | null;
  Phone?: Array<string | null> | null;
  preferredChoice?: boolean | null;
  envCertification?: boolean | null;
  envCertificationName?: string | null;
  Offers?: Array<{
    _id?: string | null;
    Name?: string | null;
    Price?: number | null;
    PriceType?: string | null;
    Options?: Array<string> | null;
    Rooms?: number | null;
    Beds?: number | null;
    Area?: number | null;
  } | null> | null;
  Address?: {
    StreetName: string;
    City: string;
    Region: string;
    Country: string;
    ZipCode: string;
  } | null;
  ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
  unfit?: {
    value?: boolean | null;
    comment?: string | null;
    userRef?: { PersonId: string; Name: string } | null;
  } | null;
};

export type GetAccommodationSelectorItemsQueryVariables = Exact<{
  input: AccommodationFilter;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type GetAccommodationSelectorItemsQuery = {
  getAccommodations: Array<{
    _id: string;
    Type?: AccommodationType | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string | null> | null;
    Site?: string | null;
    Phone?: Array<string | null> | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    } | null> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { PersonId: string; Name: string } | null;
    } | null;
  }>;
};

export type GetAccommodationSelectorValueQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetAccommodationSelectorValueQuery = {
  getAccommodationDetails: {
    _id: string;
    Type?: string | null;
    ImgUrl?: string | null;
    Name?: string | null;
    Email?: Array<string> | null;
    Site?: string | null;
    Phone?: Array<string> | null;
    CheckIn?: string | null;
    CheckOut?: string | null;
    CancellationPolicy?: string | null;
    Instruction?: string | null;
    preferredChoice?: boolean | null;
    envCertification?: boolean | null;
    envCertificationName?: string | null;
    Offers?: Array<{
      _id?: string | null;
      Name?: string | null;
      Price?: number | null;
      PriceType?: string | null;
      Options?: Array<string> | null;
      Rooms?: number | null;
      Beds?: number | null;
      Area?: number | null;
    }> | null;
    Address?: {
      StreetName: string;
      City: string;
      Region: string;
      Country: string;
      ZipCode: string;
    } | null;
    ResponsiblePersonRef?: { PersonId: string; Name: string } | null;
    unfit?: {
      value?: boolean | null;
      comment?: string | null;
      userRef?: { Name: string; PersonId: string } | null;
    } | null;
  };
};

export type ConsultantSelectorSearchCardFragment = {
  LegalPersonType?: LegalPersonType | null;
  BusinessName?: string | null;
  BusinessSocialSecurityNo?: string | null;
  AccommodationPreferences: string;
  TravelPreferences: string;
  _id: string;
  AreasOfExpertise: Array<string>;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  Email?: string | null;
  secondaryEmail?: string | null;
  LastContactDate?: Date | null;
  Name?: string | null;
  Phone?: string | null;
  Unfit: boolean;
  SocialSecurityNo?: string | null;
  Specializations: Array<string>;
  IsValid?: boolean | null;
  Professions?: Array<string | null> | null;
  PrescriptionCode?: string | null;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  Address?: { City: string } | null;
  contactType?: {
    employeeSalaryClaim?: string | null;
    subcontractorSalaryClaim?: string | null;
  } | null;
  ResponsiblePerson?: { PersonId: string; Name: string } | null;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
  expertise: { machines: Array<string>; systems: Array<string | null> };
};

export type ConsultantSelector_GetValueQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type ConsultantSelector_GetValueQuery = {
  consultantById?: {
    LegalPersonType?: LegalPersonType | null;
    BusinessName?: string | null;
    BusinessSocialSecurityNo?: string | null;
    AccommodationPreferences: string;
    TravelPreferences: string;
    _id: string;
    AreasOfExpertise: Array<string>;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    Email?: string | null;
    secondaryEmail?: string | null;
    LastContactDate?: Date | null;
    Name?: string | null;
    Phone?: string | null;
    Unfit: boolean;
    SocialSecurityNo?: string | null;
    Specializations: Array<string>;
    IsValid?: boolean | null;
    Professions?: Array<string | null> | null;
    PrescriptionCode?: string | null;
    isQualityApproved: boolean;
    isQualityExpired: boolean;
    Address?: { City: string } | null;
    contactType?: {
      employeeSalaryClaim?: string | null;
      subcontractorSalaryClaim?: string | null;
    } | null;
    ResponsiblePerson?: { PersonId: string; Name: string } | null;
    ValidationErrors: Array<{
      Message: string;
      Params?: any | null;
      Type: NodeValidationErrorType;
    }>;
    expertise: { machines: Array<string>; systems: Array<string | null> };
  } | null;
};

export type ConsultantSelector_SearchQueryVariables = Exact<{
  filter: ConsultantsQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type ConsultantSelector_SearchQuery = {
  consultantsFast: {
    dbTime?: number | null;
    items: Array<{
      LegalPersonType?: LegalPersonType | null;
      BusinessName?: string | null;
      BusinessSocialSecurityNo?: string | null;
      AccommodationPreferences: string;
      TravelPreferences: string;
      _id: string;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      CellPhone?: string | null;
      Email?: string | null;
      secondaryEmail?: string | null;
      LastContactDate?: Date | null;
      Name?: string | null;
      Phone?: string | null;
      Unfit: boolean;
      SocialSecurityNo?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      Professions?: Array<string | null> | null;
      PrescriptionCode?: string | null;
      isQualityApproved: boolean;
      isQualityExpired: boolean;
      Address?: { City: string } | null;
      contactType?: {
        employeeSalaryClaim?: string | null;
        subcontractorSalaryClaim?: string | null;
      } | null;
      ResponsiblePerson?: { PersonId: string; Name: string } | null;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      expertise: { machines: Array<string>; systems: Array<string | null> };
    }>;
  };
};

export type ContactPersonSelector_ItemFragment = {
  _id: string;
  Name?: string | null;
  Email?: string | null;
  Phone?: string | null;
  CellPhone?: string | null;
};

export type ContactPersonSelector_GetQueryVariables = Exact<{
  text: Scalars["String"];
  skip: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type ContactPersonSelector_GetQuery = {
  contactPersons: {
    items: Array<{
      _id: string;
      Name?: string | null;
      Email?: string | null;
      Phone?: string | null;
      CellPhone?: string | null;
    }>;
  };
};

export type CustomerSelector_GetValueQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerSelector_GetValueQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    inLists: boolean;
    RecruitingPortalType?: RecruitingPortalType | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    StaffingContactPersons: Array<{
      _id: string;
      AreasOfExpertise: Array<string | null>;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
    }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type CustomerPicker_CustomerCardFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  AvatarPic?: string | null;
  Deleted: boolean;
  Description: string;
  LastContactDate?: Date | null;
  Name?: string | null;
  Specializations: Array<string>;
  Type: CustomerType;
  IsValid?: boolean | null;
  journalSystem?: string | null;
  RecruitingPortalType?: RecruitingPortalType | null;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
};

export type CustomerSelector_SearchQueryVariables = Exact<{
  filter: CustomersFilter;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type CustomerSelector_SearchQuery = {
  customersPicker: {
    dbTime?: number | null;
    items: Array<{
      _id: string;
      AreasOfExpertise: Array<string>;
      AvatarPic?: string | null;
      Deleted: boolean;
      Description: string;
      LastContactDate?: Date | null;
      Name?: string | null;
      Specializations: Array<string>;
      Type: CustomerType;
      IsValid?: boolean | null;
      journalSystem?: string | null;
      RecruitingPortalType?: RecruitingPortalType | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
    }>;
  };
};

export type SearchProfileOptionFragment = { _id: string; name: string };

export type SearchProfileFragment = {
  fields: any;
  type: SearchProfileType;
  _id: string;
  name: string;
  customerRefs?: Array<{ Id: string; Name: string; Type: CustomerType }> | null;
};

export type SearchProfile_GetValueQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type SearchProfile_GetValueQuery = {
  searchProfileById?: {
    fields: any;
    type: SearchProfileType;
    _id: string;
    name: string;
    customerRefs?: Array<{ Id: string; Name: string; Type: CustomerType }> | null;
  } | null;
};

export type SearchProfiles_SearchQueryVariables = Exact<{
  filter: SearchProfilesFilter;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type SearchProfiles_SearchQuery = {
  SearchProfiles: { items: Array<{ name: string; _id: string }> };
};

export type SearchProfile_SubmitMutationVariables = Exact<{
  data: SearchProfileFormInput;
  id?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type SearchProfile_SubmitMutation = {
  submitSearchProfileForm: {
    fields: any;
    type: SearchProfileType;
    _id: string;
    name: string;
    customerRefs?: Array<{ Id: string; Name: string; Type: CustomerType }> | null;
  };
};

export type SearchProfile_RemoveMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type SearchProfile_RemoveMutation = { removeSearchProfile: number };

export type SearchProfile_UpdateCustomerRefMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  profileIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type SearchProfile_UpdateCustomerRefMutation = {
  updateCustomerRefsSearchProfiles: Array<{ _id: string; name: string }>;
};

export type ListUserSelectorUserFragment = {
  _id: string;
  Name: string;
  Teams: Array<string>;
};

export type GetListUserSelectorUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetListUserSelectorUsersQuery = {
  users: Array<{ _id: string; Name: string; Teams: Array<string> }>;
};

export type ProjectSelectProjectDataFragment = {
  _id: string;
  Name: string;
  ProjectNumber: string;
};

export type GetProjectSelectProjectsQueryVariables = Exact<{
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  text?: InputMaybe<Scalars["String"]>;
  shared?: InputMaybe<Scalars["Boolean"]>;
  memberIds?: InputMaybe<Array<Scalars["ObjectId"]> | Scalars["ObjectId"]>;
}>;

export type GetProjectSelectProjectsQuery = {
  projects: Array<{ _id: string; Name: string; ProjectNumber: string }>;
};

export type UserSelectFragment = {
  _id: string;
  Name: string;
  Enabled: boolean;
  Teams: Array<string>;
};

export type GetUserSelectUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSelectUsersQuery = {
  users: Array<{ _id: string; Name: string; Enabled: boolean; Teams: Array<string> }>;
};

export type UserSelectorModalUserFragment = {
  _id: string;
  Name: string;
  Teams: Array<string>;
};

export type GetUserSelectorModalUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSelectorModalUsersQuery = {
  users: Array<{ _id: string; Name: string; Teams: Array<string> }>;
};

export type FindContractQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type FindContractQuery = {
  contract: { _id: string; variant: BookingContractVariantType; name?: string | null };
};

export type ContractPriceTemplate_SaveToFavouriteMutationVariables = Exact<{
  data: ContractPriceTemplateInput;
}>;

export type ContractPriceTemplate_SaveToFavouriteMutation = {
  saveToFavouriteContractPriceTemplate: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      name?: string | null;
      type?: string | null;
      private?: boolean | null;
      createdByName?: string | null;
      createdDate?: Date | null;
      updatedByName?: string | null;
      updatedDate?: Date | null;
      records?: Array<{
        _id: string;
        articleNumber?: string | null;
        articleNumberForOtherSpeciality?: string | null;
        indexInWorkType?: number | null;
        startDay?: PriceListDay | null;
        endDay?: PriceListDay | null;
        paidPer?: PayUnit | null;
        currency?: Currency | null;
        workType?: PriceListWorkType | null;
        from?: string | null;
        to?: string | null;
        period?: PayPeriod | null;
        priceMultiplier?: number | null;
        fixedPrice?: number | null;
        customPrice?: number | null;
        deleted?: boolean | null;
        isSecondPass?: boolean | null;
      }> | null;
      highHolidays?: Array<{
        _id: string;
        isGreatHoliday?: boolean | null;
        option: { name?: string | null; listPosition?: number | null; _id: string };
      }> | null;
    } | null;
  };
};

export type CustomerContractCardFragment = {
  _id: string;
  company: CustomerContractCompany;
  dispenseDeadline?: number | null;
  professions: Array<string>;
  contractNumber?: string | null;
  contractName?: string | null;
  contractStart?: Date | null;
  contractEnd?: Date | null;
  currentContractEnd?: Date | null;
  estimatedContractValue?: number | null;
  contractProlongation?: Date | null;
  contractProlongationDeadline?: Date | null;
  contractPriceAdjustmentDate?: Date | null;
  contractPriceAdjustmentDateDeadline?: Date | null;
  introductionInfo?: string | null;
  typeOfAgreement: CustomerContractAgreementType;
  prolongationComment: string;
  adjustmentComment: string;
  overtime?: boolean | null;
  overtimeNote?: string | null;
  possibleInvoiceForAccommodation?: boolean | null;
  possibleInvoiceForAccommodationNote?: string | null;
  possibleInvoiceForTravel?: boolean | null;
  possibleInvoiceForTravelNote?: string | null;
  overtimeOption?: boolean | null;
  overtimeOptionOBNote?: string | null;
  status?: CustomerContractStatus | null;
};

export type GetCustomerContractCardQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerContractCardQuery = {
  customerContractById?: {
    _id: string;
    company: CustomerContractCompany;
    dispenseDeadline?: number | null;
    professions: Array<string>;
    contractNumber?: string | null;
    contractName?: string | null;
    contractStart?: Date | null;
    contractEnd?: Date | null;
    currentContractEnd?: Date | null;
    estimatedContractValue?: number | null;
    contractProlongation?: Date | null;
    contractProlongationDeadline?: Date | null;
    contractPriceAdjustmentDate?: Date | null;
    contractPriceAdjustmentDateDeadline?: Date | null;
    introductionInfo?: string | null;
    typeOfAgreement: CustomerContractAgreementType;
    prolongationComment: string;
    adjustmentComment: string;
    overtime?: boolean | null;
    overtimeNote?: string | null;
    possibleInvoiceForAccommodation?: boolean | null;
    possibleInvoiceForAccommodationNote?: string | null;
    possibleInvoiceForTravel?: boolean | null;
    possibleInvoiceForTravelNote?: string | null;
    overtimeOption?: boolean | null;
    overtimeOptionOBNote?: string | null;
    status?: CustomerContractStatus | null;
  } | null;
};

export type CustomerContractContactPersonFragment = {
  _id: string;
  contactPerson?: Array<{
    title?: string | null;
    email: string;
    name: string;
    phone: string;
  }> | null;
};

export type GetCustomerContractContactPersonQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerContractContactPersonQuery = {
  customerContractById?: {
    _id: string;
    contactPerson?: Array<{
      title?: string | null;
      email: string;
      name: string;
      phone: string;
    }> | null;
  } | null;
};

export type CustomerContractCustomerListFragment = {
  _id: string;
  orgCustomers: Array<{
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  }>;
};

export type GetCustomerContractCustomerListQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerContractCustomerListQuery = {
  customerContractById?: {
    _id: string;
    orgCustomers: Array<{
      _id: string;
      AreasOfExpertise: Array<string>;
      areasOfExpertiseTotal: number;
      AvatarPic?: string | null;
      Deleted: boolean;
      Description: string;
      LastContactDate?: Date | null;
      Name?: string | null;
      Specializations: Array<string>;
      Type: CustomerType;
      IsValid?: boolean | null;
      journalSystem?: string | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    }>;
  } | null;
};

export type GetCustomerContractFilesQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type GetCustomerContractFilesQuery = {
  customerContractById?: {
    _id: string;
    attachments: Array<{
      DocumentType?: string | null;
      ThumbURL?: string | null;
      PdfURL?: string | null;
      FileRef: {
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        MimeType: string;
        Size: number;
      };
    }>;
  } | null;
};

export type UploadCustomerContractDocMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  file: Scalars["Upload"];
  documentType: CustomerContractDocumentTypes;
}>;

export type UploadCustomerContractDocMutation = {
  uploadCustomerContractDocument: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      attachments: Array<{
        DocumentType?: string | null;
        ThumbURL?: string | null;
        PdfURL?: string | null;
        FileRef: {
          Name?: string | null;
          NodeID: string;
          NodeType: NodeType;
          MimeType: string;
          Size: number;
        };
      }>;
    } | null;
  };
};

export type DeleteCustomerContractDocMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
}>;

export type DeleteCustomerContractDocMutation = {
  deleteCustomerContractDocument: { errors?: Array<string> | null };
};

export type CustomerContractResultFragment = {
  errors?: Array<string> | null;
  value?: {
    _id: string;
    company: CustomerContractCompany;
    dispenseDeadline?: number | null;
    contractStart?: Date | null;
    contractEnd?: Date | null;
    currentContractEnd?: Date | null;
    estimatedContractValue?: number | null;
    contractProlongation?: Date | null;
    contractProlongationDeadline?: Date | null;
    prolongationComment: string;
    adjustmentComment: string;
    contractPriceAdjustmentDate?: Date | null;
    contractPriceAdjustmentDateDeadline?: Date | null;
    introductionInfo?: string | null;
    contractNumber?: string | null;
    contractName?: string | null;
    avtalsnummer?: string | null;
    avropsnummer?: string | null;
    extraInvoiceLine?: string | null;
    useNationalProcurementInvoicing?: boolean | null;
    isNationalProcurement?: boolean | null;
    professions: Array<string>;
    typeOfAgreement: CustomerContractAgreementType;
    overtime?: boolean | null;
    overtimeNote?: string | null;
    possibleInvoiceForTravel?: boolean | null;
    possibleInvoiceForTravelNote?: string | null;
    possibleInvoiceForAccommodation?: boolean | null;
    possibleInvoiceForAccommodationNote?: string | null;
    overtimeOption?: boolean | null;
    overtimeOptionOBNote?: string | null;
    otherOption?: boolean | null;
    otherOptionNote?: string | null;
    contactPerson?: Array<{
      _id: string;
      title?: string | null;
      email: string;
      name: string;
      phone: string;
    }> | null;
    orgCustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type HighHolidayOptionFragment = {
  name?: string | null;
  listPosition?: number | null;
  _id: string;
};

export type HighHolidayFragment = {
  _id: string;
  isGreatHoliday?: boolean | null;
  option: { name?: string | null; listPosition?: number | null; _id: string };
};

export type SubmitCustomerContractFormMutationVariables = Exact<{
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  data: CustomerContractFormInput;
}>;

export type SubmitCustomerContractFormMutation = {
  submitCustomerContractForm: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      company: CustomerContractCompany;
      dispenseDeadline?: number | null;
      contractStart?: Date | null;
      contractEnd?: Date | null;
      currentContractEnd?: Date | null;
      estimatedContractValue?: number | null;
      contractProlongation?: Date | null;
      contractProlongationDeadline?: Date | null;
      prolongationComment: string;
      adjustmentComment: string;
      contractPriceAdjustmentDate?: Date | null;
      contractPriceAdjustmentDateDeadline?: Date | null;
      introductionInfo?: string | null;
      contractNumber?: string | null;
      contractName?: string | null;
      avtalsnummer?: string | null;
      avropsnummer?: string | null;
      extraInvoiceLine?: string | null;
      useNationalProcurementInvoicing?: boolean | null;
      isNationalProcurement?: boolean | null;
      professions: Array<string>;
      typeOfAgreement: CustomerContractAgreementType;
      overtime?: boolean | null;
      overtimeNote?: string | null;
      possibleInvoiceForTravel?: boolean | null;
      possibleInvoiceForTravelNote?: string | null;
      possibleInvoiceForAccommodation?: boolean | null;
      possibleInvoiceForAccommodationNote?: string | null;
      overtimeOption?: boolean | null;
      overtimeOptionOBNote?: string | null;
      otherOption?: boolean | null;
      otherOptionNote?: string | null;
      contactPerson?: Array<{
        _id: string;
        title?: string | null;
        email: string;
        name: string;
        phone: string;
      }> | null;
      orgCustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
    } | null;
  };
};

export type CustomerContractEditorDataFragment = {
  _id: string;
  company: CustomerContractCompany;
  dispenseDeadline?: number | null;
  contractStart?: Date | null;
  contractEnd?: Date | null;
  currentContractEnd?: Date | null;
  estimatedContractValue?: number | null;
  contractProlongation?: Date | null;
  contractProlongationDeadline?: Date | null;
  prolongationComment: string;
  adjustmentComment: string;
  contractPriceAdjustmentDate?: Date | null;
  contractPriceAdjustmentDateDeadline?: Date | null;
  introductionInfo?: string | null;
  contractNumber?: string | null;
  contractName?: string | null;
  avtalsnummer?: string | null;
  avropsnummer?: string | null;
  extraInvoiceLine?: string | null;
  useNationalProcurementInvoicing?: boolean | null;
  isNationalProcurement?: boolean | null;
  professions: Array<string>;
  typeOfAgreement: CustomerContractAgreementType;
  overtime?: boolean | null;
  overtimeNote?: string | null;
  possibleInvoiceForTravel?: boolean | null;
  possibleInvoiceForTravelNote?: string | null;
  possibleInvoiceForAccommodation?: boolean | null;
  possibleInvoiceForAccommodationNote?: string | null;
  overtimeOption?: boolean | null;
  overtimeOptionOBNote?: string | null;
  otherOption?: boolean | null;
  otherOptionNote?: string | null;
  contactPerson?: Array<{
    _id: string;
    title?: string | null;
    email: string;
    name: string;
    phone: string;
  }> | null;
  orgCustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
};

export type GetCustomerContractEditorDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ObjectId"]>;
  isNew: Scalars["Boolean"];
}>;

export type GetCustomerContractEditorDataQuery = {
  customerContractById?: {
    _id: string;
    company: CustomerContractCompany;
    dispenseDeadline?: number | null;
    contractStart?: Date | null;
    contractEnd?: Date | null;
    currentContractEnd?: Date | null;
    estimatedContractValue?: number | null;
    contractProlongation?: Date | null;
    contractProlongationDeadline?: Date | null;
    prolongationComment: string;
    adjustmentComment: string;
    contractPriceAdjustmentDate?: Date | null;
    contractPriceAdjustmentDateDeadline?: Date | null;
    introductionInfo?: string | null;
    contractNumber?: string | null;
    contractName?: string | null;
    avtalsnummer?: string | null;
    avropsnummer?: string | null;
    extraInvoiceLine?: string | null;
    useNationalProcurementInvoicing?: boolean | null;
    isNationalProcurement?: boolean | null;
    professions: Array<string>;
    typeOfAgreement: CustomerContractAgreementType;
    overtime?: boolean | null;
    overtimeNote?: string | null;
    possibleInvoiceForTravel?: boolean | null;
    possibleInvoiceForTravelNote?: string | null;
    possibleInvoiceForAccommodation?: boolean | null;
    possibleInvoiceForAccommodationNote?: string | null;
    overtimeOption?: boolean | null;
    overtimeOptionOBNote?: string | null;
    otherOption?: boolean | null;
    otherOptionNote?: string | null;
    contactPerson?: Array<{
      _id: string;
      title?: string | null;
      email: string;
      name: string;
      phone: string;
    }> | null;
    orgCustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type CustomerContractOrgCustomerTreeFragment = {
  _id: string;
  orgCustomerTree: Array<{
    ParentId?: string | null;
    CustomerRef: { Id: string; Name: string; Type: CustomerType };
    HospitalRef?: { Id: string; Name: string; Type: CustomerType } | null;
    ParentRef?: { Id: string; Name: string; Type: CustomerType } | null;
  }>;
};

export type GetCustomerTreeQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type GetCustomerTreeQuery = {
  customerContractById?: {
    _id: string;
    orgCustomerTree: Array<{
      ParentId?: string | null;
      CustomerRef: { Id: string; Name: string; Type: CustomerType };
      HospitalRef?: { Id: string; Name: string; Type: CustomerType } | null;
      ParentRef?: { Id: string; Name: string; Type: CustomerType } | null;
    }>;
  } | null;
};

export type CustomerContractPriceListProfileFragment = {
  _id: string;
  name?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  administrativeFee?: number | null;
  travelZones: Array<{ name: string; articleNumber: string }>;
  customers: Array<{ _id: string; Type: CustomerType; Name?: string | null } | null>;
  priceGroups: Array<{
    _id: string;
    professionsPrice: Array<{
      price?: number | null;
      profession: {
        name?: string | null;
        areaOfExpertise?: string | null;
        specialization?: string | null;
      };
    }>;
    records: Array<{
      _id: string;
      articleNumber?: string | null;
      articleNumberForOtherSpeciality?: string | null;
      indexInWorkType?: number | null;
      startDay?: PriceListDay | null;
      endDay?: PriceListDay | null;
      paidPer?: PayUnit | null;
      currency?: Currency | null;
      workType?: PriceListWorkType | null;
      from?: string | null;
      to?: string | null;
      period?: PayPeriod | null;
      priceMultiplier?: number | null;
      fixedPrice?: number | null;
      customPrice?: number | null;
      deleted?: boolean | null;
      isSecondPass?: boolean | null;
    }>;
    highHolidays: Array<{
      _id: string;
      isGreatHoliday?: boolean | null;
      option: { name?: string | null; listPosition?: number | null; _id: string };
    }>;
  }>;
  customerContract: {
    _id: string;
    contractNumber?: string | null;
    isNationalProcurement?: boolean | null;
    useNationalProcurementInvoicing?: boolean | null;
    company: CustomerContractCompany;
    professions: Array<string>;
  };
};

export type CustomerContractPriceListFormContractDataFragment = {
  _id: string;
  contractNumber?: string | null;
  professions: Array<string>;
  isNationalProcurement?: boolean | null;
  useNationalProcurementInvoicing?: boolean | null;
  company: CustomerContractCompany;
  orgCustomers: Array<{ _id: string; Name?: string | null }>;
};

export type GetCustomerContractProfileDataQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  priceListId?: InputMaybe<Scalars["ObjectId"]>;
  isNew: Scalars["Boolean"];
}>;

export type GetCustomerContractProfileDataQuery = {
  customerContractPriceListById?: {
    _id: string;
    name?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    administrativeFee?: number | null;
    travelZones: Array<{ name: string; articleNumber: string }>;
    customers: Array<{ _id: string; Type: CustomerType; Name?: string | null } | null>;
    priceGroups: Array<{
      _id: string;
      professionsPrice: Array<{
        price?: number | null;
        profession: {
          name?: string | null;
          areaOfExpertise?: string | null;
          specialization?: string | null;
        };
      }>;
      records: Array<{
        _id: string;
        articleNumber?: string | null;
        articleNumberForOtherSpeciality?: string | null;
        indexInWorkType?: number | null;
        startDay?: PriceListDay | null;
        endDay?: PriceListDay | null;
        paidPer?: PayUnit | null;
        currency?: Currency | null;
        workType?: PriceListWorkType | null;
        from?: string | null;
        to?: string | null;
        period?: PayPeriod | null;
        priceMultiplier?: number | null;
        fixedPrice?: number | null;
        customPrice?: number | null;
        deleted?: boolean | null;
        isSecondPass?: boolean | null;
      }>;
      highHolidays: Array<{
        _id: string;
        isGreatHoliday?: boolean | null;
        option: { name?: string | null; listPosition?: number | null; _id: string };
      }>;
    }>;
    customerContract: {
      _id: string;
      contractNumber?: string | null;
      isNationalProcurement?: boolean | null;
      useNationalProcurementInvoicing?: boolean | null;
      company: CustomerContractCompany;
      professions: Array<string>;
    };
  };
  customerContractById?: {
    _id: string;
    contractNumber?: string | null;
    professions: Array<string>;
    isNationalProcurement?: boolean | null;
    useNationalProcurementInvoicing?: boolean | null;
    company: CustomerContractCompany;
    orgCustomers: Array<{ _id: string; Name?: string | null }>;
  } | null;
  getHighHolidays: Array<{
    name?: string | null;
    listPosition?: number | null;
    _id: string;
  }>;
  config: { defaultTravelZones: Array<{ label: string; name: string }> };
};

export type SubmitPriceListEditorFormMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  priceListId?: InputMaybe<Scalars["ObjectId"]>;
  data: PriceListFormInput;
}>;

export type SubmitPriceListEditorFormMutation = {
  submitCustomerContractPriceListForm: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      company: CustomerContractCompany;
      dispenseDeadline?: number | null;
      contractStart?: Date | null;
      contractEnd?: Date | null;
      currentContractEnd?: Date | null;
      estimatedContractValue?: number | null;
      contractProlongation?: Date | null;
      contractProlongationDeadline?: Date | null;
      prolongationComment: string;
      adjustmentComment: string;
      contractPriceAdjustmentDate?: Date | null;
      contractPriceAdjustmentDateDeadline?: Date | null;
      introductionInfo?: string | null;
      contractNumber?: string | null;
      contractName?: string | null;
      avtalsnummer?: string | null;
      avropsnummer?: string | null;
      extraInvoiceLine?: string | null;
      useNationalProcurementInvoicing?: boolean | null;
      isNationalProcurement?: boolean | null;
      professions: Array<string>;
      typeOfAgreement: CustomerContractAgreementType;
      overtime?: boolean | null;
      overtimeNote?: string | null;
      possibleInvoiceForTravel?: boolean | null;
      possibleInvoiceForTravelNote?: string | null;
      possibleInvoiceForAccommodation?: boolean | null;
      possibleInvoiceForAccommodationNote?: string | null;
      overtimeOption?: boolean | null;
      overtimeOptionOBNote?: string | null;
      otherOption?: boolean | null;
      otherOptionNote?: string | null;
      contactPerson?: Array<{
        _id: string;
        title?: string | null;
        email: string;
        name: string;
        phone: string;
      }> | null;
      orgCustomerRefs: Array<{ Id: string; Name: string; Type: CustomerType }>;
    } | null;
  };
};

export type CustomerContractPriceListsFragment = {
  _id: string;
  priceLists: Array<{
    _id: string;
    name?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    customerCount: number;
    customers: Array<{ Name?: string | null } | null>;
  }>;
};

export type GetCustomerContractPriceListsQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerContractPriceListsQuery = {
  customerContractById?: {
    _id: string;
    priceLists: Array<{
      _id: string;
      name?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      customerCount: number;
      customers: Array<{ Name?: string | null } | null>;
    }>;
  } | null;
};

export type RemoveCustomerContractPriceListMutationVariables = Exact<{
  priceListId: Scalars["ObjectId"];
}>;

export type RemoveCustomerContractPriceListMutation = {
  removeCustomerContractPriceList: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      priceLists: Array<{
        _id: string;
        name?: string | null;
        startDate?: Date | null;
        endDate?: Date | null;
        customerCount: number;
        customers: Array<{ Name?: string | null } | null>;
      }>;
    } | null;
  };
};

export type CustomerContract_ProfileFragment = {
  _id: string;
  contractNumber?: string | null;
  invoicingStrategy: InvoicingStrategyType;
  estimatedContractValue?: number | null;
  company: CustomerContractCompany;
  dispenseDeadline?: number | null;
  isNationalProcurement?: boolean | null;
  professions: Array<string>;
  contractName?: string | null;
  contractStart?: Date | null;
  contractEnd?: Date | null;
  currentContractEnd?: Date | null;
  contractProlongation?: Date | null;
  contractProlongationDeadline?: Date | null;
  contractPriceAdjustmentDate?: Date | null;
  contractPriceAdjustmentDateDeadline?: Date | null;
  introductionInfo?: string | null;
  typeOfAgreement: CustomerContractAgreementType;
  prolongationComment: string;
  adjustmentComment: string;
  overtime?: boolean | null;
  overtimeNote?: string | null;
  possibleInvoiceForAccommodation?: boolean | null;
  possibleInvoiceForAccommodationNote?: string | null;
  possibleInvoiceForTravel?: boolean | null;
  possibleInvoiceForTravelNote?: string | null;
  overtimeOption?: boolean | null;
  overtimeOptionOBNote?: string | null;
  status?: CustomerContractStatus | null;
  info: string;
  orgCustomers: Array<{
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  }>;
  priceLists: Array<{
    _id: string;
    name?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    customerCount: number;
    customers: Array<{ Name?: string | null } | null>;
  }>;
  contactPerson?: Array<{
    title?: string | null;
    email: string;
    name: string;
    phone: string;
  }> | null;
  eventLogs: Array<{
    Links?: Array<string> | null;
    EventType: CustomerContractEventType;
    _id: string;
    CanDelete: boolean;
    CanEdit: boolean;
    CanPin: boolean;
    CreatedOn: Date;
    Deleted: boolean;
    Description: string;
    DescriptionHtml: string;
    Sticky: boolean;
    Warning?: boolean | null;
    CreatedBy: { PersonId?: string | null; Name?: string | null };
    UpdatedBy?: { Name?: string | null } | null;
  }>;
};

export type GetCustomerContractProfileQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerContractProfileQuery = {
  customerContractById?: {
    _id: string;
    contractNumber?: string | null;
    invoicingStrategy: InvoicingStrategyType;
    estimatedContractValue?: number | null;
    company: CustomerContractCompany;
    dispenseDeadline?: number | null;
    isNationalProcurement?: boolean | null;
    professions: Array<string>;
    contractName?: string | null;
    contractStart?: Date | null;
    contractEnd?: Date | null;
    currentContractEnd?: Date | null;
    contractProlongation?: Date | null;
    contractProlongationDeadline?: Date | null;
    contractPriceAdjustmentDate?: Date | null;
    contractPriceAdjustmentDateDeadline?: Date | null;
    introductionInfo?: string | null;
    typeOfAgreement: CustomerContractAgreementType;
    prolongationComment: string;
    adjustmentComment: string;
    overtime?: boolean | null;
    overtimeNote?: string | null;
    possibleInvoiceForAccommodation?: boolean | null;
    possibleInvoiceForAccommodationNote?: string | null;
    possibleInvoiceForTravel?: boolean | null;
    possibleInvoiceForTravelNote?: string | null;
    overtimeOption?: boolean | null;
    overtimeOptionOBNote?: string | null;
    status?: CustomerContractStatus | null;
    info: string;
    orgCustomers: Array<{
      _id: string;
      AreasOfExpertise: Array<string>;
      areasOfExpertiseTotal: number;
      AvatarPic?: string | null;
      Deleted: boolean;
      Description: string;
      LastContactDate?: Date | null;
      Name?: string | null;
      Specializations: Array<string>;
      Type: CustomerType;
      IsValid?: boolean | null;
      journalSystem?: string | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    }>;
    priceLists: Array<{
      _id: string;
      name?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      customerCount: number;
      customers: Array<{ Name?: string | null } | null>;
    }>;
    contactPerson?: Array<{
      title?: string | null;
      email: string;
      name: string;
      phone: string;
    }> | null;
    eventLogs: Array<{
      Links?: Array<string> | null;
      EventType: CustomerContractEventType;
      _id: string;
      CanDelete: boolean;
      CanEdit: boolean;
      CanPin: boolean;
      CreatedOn: Date;
      Deleted: boolean;
      Description: string;
      DescriptionHtml: string;
      Sticky: boolean;
      Warning?: boolean | null;
      CreatedBy: { PersonId?: string | null; Name?: string | null };
      UpdatedBy?: { Name?: string | null } | null;
    }>;
  } | null;
};

export type SubmitCustomerContractInfoMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  info: Scalars["String"];
}>;

export type SubmitCustomerContractInfoMutation = {
  submitCustomerContractInfo: {
    errors?: Array<string> | null;
    value?: { _id: string; info: string } | null;
  };
};

export type SetCustomerContractInvoicingStrgMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  type: InvoicingStrategyType;
}>;

export type SetCustomerContractInvoicingStrgMutation = {
  setCustomerContractInvoiceStrategy: {
    errors?: Array<string> | null;
    value?: { invoicingStrategy: InvoicingStrategyType } | null;
  };
};

export type CustomerContractInfoTabFragment = { _id: string; info: string };

export type GetCustomerContractProfileInfoQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerContractProfileInfoQuery = {
  customerContractById?: { _id: string; info: string } | null;
};

export type CustomerContractSnapshotListItemFragment = {
  _id: string;
  parentId?: string | null;
  type: CustomerContractSnapshotTypes;
  name: string;
  signedOn?: Date | null;
  fileUrl?: string | null;
  viewUrl?: string | null;
  isNullified?: boolean | null;
  externalId?: string | null;
  publishedUrl?: string | null;
};

export type CustomerContractSnapshots_ByContractIdQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type CustomerContractSnapshots_ByContractIdQuery = {
  getCustomerContractSnapshots: Array<{
    _id: string;
    parentId?: string | null;
    type: CustomerContractSnapshotTypes;
    name: string;
    signedOn?: Date | null;
    fileUrl?: string | null;
    viewUrl?: string | null;
    isNullified?: boolean | null;
    externalId?: string | null;
    publishedUrl?: string | null;
  }>;
};

export type CustomerContractSnapshots_ContractInfoQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type CustomerContractSnapshots_ContractInfoQuery = {
  customerContractById?: {
    _id: string;
    contractNumber?: string | null;
    professions: Array<string>;
    isNationalProcurement?: boolean | null;
    company: CustomerContractCompany;
    orgCustomers: Array<{ _id: string; Name?: string | null }>;
    contactPerson?: Array<{
      _id: string;
      title?: string | null;
      email: string;
      name: string;
      phone: string;
    }> | null;
  } | null;
};

export type CustomerContractSnapshot_ByIdQueryVariables = Exact<{
  snapshotId: Scalars["ObjectId"];
}>;

export type CustomerContractSnapshot_ByIdQuery = {
  customerContractSnapshotById?: {
    _id: string;
    parentId?: string | null;
    customerContractId: string;
    consultantId?: string | null;
    customerId?: string | null;
    invoiceMarking?: string | null;
    contactPersonId?: string | null;
    responsiblePersonId?: string | null;
    type: CustomerContractSnapshotTypes;
  } | null;
};

export type CustomerContractSnapshot_UploadSignedMutationVariables = Exact<{
  snapshotId: Scalars["ObjectId"];
  signedOn: Scalars["Date"];
  file: Scalars["Upload"];
}>;

export type CustomerContractSnapshot_UploadSignedMutation = {
  uploadCustomerContractSignedDocument: {
    errors?: Array<string> | null;
    value?: { _id: string; name: string } | null;
  };
};

export type CustomerContractSnapshot_SubmitFormMutationVariables = Exact<{
  snapshotId?: InputMaybe<Scalars["ObjectId"]>;
  data: CustomerContractSnapshotFormInput;
}>;

export type CustomerContractSnapshot_SubmitFormMutation = {
  submitCustomerContractSnapshotForm: {
    errors?: Array<string> | null;
    value?: { _id: string; name: string } | null;
  };
};

export type CustomerContractSnapshot_DeleteMutationVariables = Exact<{
  snapshotId: Scalars["ObjectId"];
}>;

export type CustomerContractSnapshot_DeleteMutation = {
  deleteCustomerContractSnapshot: {
    errors?: Array<string> | null;
    value?: { _id: string } | null;
  };
};

export type CustomerContractSnapshot_GenerateMutationVariables = Exact<{
  snapshotId: Scalars["ObjectId"];
}>;

export type CustomerContractSnapshot_GenerateMutation = {
  generateCustomerContractSnapshot: {
    errors?: Array<string> | null;
    value?: { _id: string } | null;
  };
};

export type CustomerContractSnapshot_NullifyMutationVariables = Exact<{
  value: Scalars["Boolean"];
  snapshotId: Scalars["ObjectId"];
}>;

export type CustomerContractSnapshot_NullifyMutation = {
  nullifyCustomerContractSnapshot: {
    errors?: Array<string> | null;
    value?: { _id: string } | null;
  };
};

export type PublishCustomerContractSnapshotMutationVariables = Exact<{
  snapshotId: Scalars["ObjectId"];
}>;

export type PublishCustomerContractSnapshotMutation = {
  publishCustomerContractSnapshot: string;
};

export type CustomerContractSubVersionListItemFragment = {
  _id: string;
  contractName?: string | null;
  subVersions: Array<{
    _id: string;
    customerContractName?: string | null;
    name?: string | null;
    basicPrice: number;
    consultantId?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    fileRef?: { Name?: string | null; NodeID: string } | null;
  }>;
};

export type CustomerContractSubVersionFragment = {
  _id: string;
  customerContractName?: string | null;
  name?: string | null;
  basicPrice: number;
  consultantId?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  fileRef?: { Name?: string | null; NodeID: string } | null;
};

export type CustomerContractSubVersions_ByContractIdQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type CustomerContractSubVersions_ByContractIdQuery = {
  customerContractById?: {
    _id: string;
    contractName?: string | null;
    subVersions: Array<{
      _id: string;
      customerContractName?: string | null;
      name?: string | null;
      basicPrice: number;
      consultantId?: string | null;
      startDate?: Date | null;
      endDate?: Date | null;
      fileRef?: { Name?: string | null; NodeID: string } | null;
    }>;
  } | null;
};

export type CustomerContractInfo_ForSubVersionsQueryVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
}>;

export type CustomerContractInfo_ForSubVersionsQuery = {
  customerContractById?: { _id: string; contractName?: string | null } | null;
};

export type CustomerContractSubVersion_ByIdQueryVariables = Exact<{
  subVersionId: Scalars["ObjectId"];
  customerContractId: Scalars["ObjectId"];
}>;

export type CustomerContractSubVersion_ByIdQuery = {
  customerContractSubVersionById: {
    _id: string;
    customerContractName?: string | null;
    name?: string | null;
    basicPrice: number;
    consultantId?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    fileRef?: { Name?: string | null; NodeID: string } | null;
  };
};

export type CustomerContractSubVersion_SubmitFormMutationVariables = Exact<{
  customerContractId: Scalars["ObjectId"];
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
  data: SubVersionFormInput;
  file?: InputMaybe<Scalars["Upload"]>;
}>;

export type CustomerContractSubVersion_SubmitFormMutation = {
  submitCustomerContractSubVersionForm: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      subVersions: Array<{
        _id: string;
        consultantId?: string | null;
        name?: string | null;
      }>;
    } | null;
  };
};

export type CustomerContractSubVersion_DeleteMutationVariables = Exact<{
  subVersionId: Scalars["ObjectId"];
}>;

export type CustomerContractSubVersion_DeleteMutation = {
  deleteCustomerContractSubVersion: {
    errors?: Array<string> | null;
    value?: { _id: string } | null;
  };
};

export type CustomerContractsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerContractFilter>;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<CustomerContractSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type CustomerContractsQuery = {
  customerContracts: {
    skip: number;
    limit: number;
    items: Array<{
      _id: string;
      contractNumber?: string | null;
      contractName?: string | null;
      contractStart: Date;
      contractEnd: Date;
      currentContractEnd?: Date | null;
      contractProlongation?: Date | null;
      contractPriceAdjustmentDate?: Date | null;
      estimatedContractValue?: number | null;
      professions: Array<string>;
      status?: CustomerContractStatus | null;
      orgCustomerRefs: Array<{ Id: string; Name: string }>;
    }>;
  };
};

export type CustomerContractsTotalQueryVariables = Exact<{
  filter?: InputMaybe<CustomerContractFilter>;
}>;

export type CustomerContractsTotalQuery = { customerContractsTotal: { total: number } };

export type CustomerContractsFragmentFragment = {
  _id: string;
  contractNumber?: string | null;
  contractName?: string | null;
  contractStart: Date;
  contractEnd: Date;
  currentContractEnd?: Date | null;
  contractProlongation?: Date | null;
  contractPriceAdjustmentDate?: Date | null;
  estimatedContractValue?: number | null;
  professions: Array<string>;
  status?: CustomerContractStatus | null;
  orgCustomerRefs: Array<{ Id: string; Name: string }>;
};

export type DeleteRestoreCustomerContractMutationVariables = Exact<{
  contractId: Scalars["ObjectId"];
}>;

export type DeleteRestoreCustomerContractMutation = {
  deleteRestoreCustomerContract: {
    errors?: Array<string> | null;
    value?: {
      _id: string;
      contractName?: string | null;
      deleted?: boolean | null;
    } | null;
  };
};

export type CustomerSearchDataFragment = {
  __typename: "Customer";
  _id: string;
  IsValid?: boolean | null;
  AreasOfExpertise: Array<string>;
  Name?: string | null;
  journalSystem?: string | null;
  Type: CustomerType;
  RegionRef: { Id: string; Name: string; Type: CustomerType };
  Parents: Array<{ Name: string }>;
  Address?: { City: string } | null;
};

export type SearchCustomersQueryVariables = Exact<{
  filter?: InputMaybe<CustomersFilter>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type SearchCustomersQuery = {
  customers: {
    dbTime?: number | null;
    items: Array<{
      __typename: "Customer";
      _id: string;
      IsValid?: boolean | null;
      AreasOfExpertise: Array<string>;
      Name?: string | null;
      journalSystem?: string | null;
      Type: CustomerType;
      RegionRef: { Id: string; Name: string; Type: CustomerType };
      Parents: Array<{ Name: string }>;
      Address?: { City: string } | null;
    }>;
  };
};

export type CustomerAreasOfExpertiseFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
};

export type CustomerAreasOfExpertise_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerAreasOfExpertise_GetQuery = {
  customerById?: { _id: string; AreasOfExpertise: Array<string> } | null;
};

export type CustomerCard_RefFragment = { Id: string; Name: string; Type: CustomerType };

export type SimpleCustomerCardWithoutContactPersonsFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  areasOfExpertiseTotal: number;
  AvatarPic?: string | null;
  Deleted: boolean;
  Description: string;
  LastContactDate?: Date | null;
  Name?: string | null;
  Specializations: Array<string>;
  Type: CustomerType;
  IsValid?: boolean | null;
  journalSystem?: string | null;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
};

export type SimpleCustomerCardFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  areasOfExpertiseTotal: number;
  AvatarPic?: string | null;
  Deleted: boolean;
  Description: string;
  LastContactDate?: Date | null;
  Name?: string | null;
  Specializations: Array<string>;
  Type: CustomerType;
  IsValid?: boolean | null;
  journalSystem?: string | null;
  inLists: boolean;
  RecruitingPortalType?: RecruitingPortalType | null;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  StaffingContactPersons: Array<{
    _id: string;
    AreasOfExpertise: Array<string | null>;
    Email?: string | null;
    Name?: string | null;
    Phone?: string | null;
    Roles: Array<string>;
    Title?: string | null;
  }>;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
};

export type CustomerCardFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  areasOfExpertiseTotal: number;
  AvatarPic?: string | null;
  Deleted: boolean;
  Description: string;
  LastContactDate?: Date | null;
  Name?: string | null;
  Specializations: Array<string>;
  Type: CustomerType;
  IsValid?: boolean | null;
  journalSystem?: string | null;
  inLists: boolean;
  RecruitingPortalType?: RecruitingPortalType | null;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  StaffingContactPersons: Array<{
    _id: string;
    AreasOfExpertise: Array<string | null>;
    Email?: string | null;
    Name?: string | null;
    Phone?: string | null;
    Roles: Array<string>;
    Title?: string | null;
  }>;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
};

export type CustomerCard_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerCard_GetQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    inLists: boolean;
    RecruitingPortalType?: RecruitingPortalType | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    StaffingContactPersons: Array<{
      _id: string;
      AreasOfExpertise: Array<string | null>;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
    }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type SimpleCustomerCard_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type SimpleCustomerCard_GetQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    inLists: boolean;
    RecruitingPortalType?: RecruitingPortalType | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    StaffingContactPersons: Array<{
      _id: string;
      AreasOfExpertise: Array<string | null>;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
    }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type CustomerChildrenList_ItemFragment = {
  _id: string;
  CustomerGroups: Array<string>;
  Name?: string | null;
  Type: CustomerType;
};

export type CustomerChildrenListFragment = {
  _id: string;
  Type: CustomerType;
  DirectChildrenFull: Array<{
    _id: string;
    CustomerGroups: Array<string>;
    Name?: string | null;
    Type: CustomerType;
  }>;
};

export type CustomerChildrenList_GetQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerChildrenList_GetQuery = {
  customerById?: {
    _id: string;
    Type: CustomerType;
    DirectChildrenFull: Array<{
      _id: string;
      CustomerGroups: Array<string>;
      Name?: string | null;
      Type: CustomerType;
    }>;
  } | null;
};

export type CustomerContactList_ItemFragment = {
  _id: string;
  AreasOfExpertise: Array<string | null>;
  Email?: string | null;
  Name?: string | null;
  Phone?: string | null;
  Roles: Array<string>;
  Title?: string | null;
};

export type CustomerContactPersonForm_CustomerFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  areasOfExpertiseTotal: number;
  AvatarPic?: string | null;
  Deleted: boolean;
  Description: string;
  LastContactDate?: Date | null;
  Name?: string | null;
  Specializations: Array<string>;
  Type: CustomerType;
  IsValid?: boolean | null;
  journalSystem?: string | null;
  inLists: boolean;
  RecruitingPortalType?: RecruitingPortalType | null;
  AreasOfExpertiseNoLimit: Array<string>;
  DirectChildrenFull: Array<{ _id: string; CustomerGroups: Array<string> }>;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  StaffingContactPersons: Array<{
    _id: string;
    AreasOfExpertise: Array<string | null>;
    Email?: string | null;
    Name?: string | null;
    Phone?: string | null;
    Roles: Array<string>;
    Title?: string | null;
  }>;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
};

export type CustomerContactPersonForm_GetCustomerQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
}>;

export type CustomerContactPersonForm_GetCustomerQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    Type: CustomerType;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    inLists: boolean;
    RecruitingPortalType?: RecruitingPortalType | null;
    AreasOfExpertiseNoLimit: Array<string>;
    DirectChildrenFull: Array<{ _id: string; CustomerGroups: Array<string> }>;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    StaffingContactPersons: Array<{
      _id: string;
      AreasOfExpertise: Array<string | null>;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
    }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  } | null;
};

export type CustomerContactPersonForm_FindContactPersonsQueryVariables = Exact<{
  skip: Scalars["Int"];
  limit?: InputMaybe<Scalars["Int"]>;
  text: Array<Scalars["String"]> | Scalars["String"];
  rootCustomerId: Scalars["ObjectId"];
}>;

export type CustomerContactPersonForm_FindContactPersonsQuery = {
  contactPersons: {
    items: Array<{
      _id: string;
      CustomerGroups: Array<string>;
      Deleted: boolean;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      CellPhone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerRefs: Array<{ Id: string }>;
      LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
    }>;
  };
};

export type CustomerContactPersonForm_AssignMutationVariables = Exact<{
  contactPersonId: Scalars["ObjectId"];
  customerId: Scalars["ObjectId"];
}>;

export type CustomerContactPersonForm_AssignMutation = {
  assignContactPersonToCustomer: {
    ContactPerson: {
      _id: string;
      CustomerGroups: Array<string>;
      Deleted: boolean;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      CellPhone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerRefs: Array<{ Id: string }>;
      LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
    };
    Customer: {
      _id: string;
      ContactPersons: Array<{
        _id: string;
        CustomerGroups: Array<string>;
        Deleted: boolean;
        Email?: string | null;
        Name?: string | null;
        Phone?: string | null;
        CellPhone?: string | null;
        Roles: Array<string>;
        Title?: string | null;
        AreasOfExpertise: Array<string | null>;
        BooksProfessions: Array<string>;
        CustomerRefs: Array<{ Id: string }>;
        LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
      }>;
    };
  };
};

export type CustomerContactPersonFragment = {
  _id: string;
  CustomerGroups: Array<string>;
  Deleted: boolean;
  Email?: string | null;
  Name?: string | null;
  Phone?: string | null;
  CellPhone?: string | null;
  Roles: Array<string>;
  Title?: string | null;
  AreasOfExpertise: Array<string | null>;
  BooksProfessions: Array<string>;
  CustomerRefs: Array<{ Id: string }>;
  LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
};

export type CustomerEditor_WorkshiftSpanFragment = {
  Profession: string;
  FromMinutes: number;
  ToMinutes: number;
  Workshift: Workshift;
};

export type CustomerEditor_CustomerAOEFragment = {
  Enabled: boolean;
  AreaOfExpertise: string;
  Error?: boolean | null;
  FortnoxId?: string | null;
  Inherited?: boolean | null;
  InvoicingData?: string | null;
  Profession: string;
  GroupInvoicing?: boolean | null;
  timeReport?: boolean | null;
  orderId?: string | null;
  ResponsiblePerson?: { Name: string; PersonId: string } | null;
};

export type CustomerEditor_CustomerFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  CustomerGroups: Array<string>;
  Description: string;
  Name?: string | null;
  OrganizationNumber: string;
  OrganizationType?: OrganizationType | null;
  RecruitingPortalType?: RecruitingPortalType | null;
  OwnProfessions: Array<string>;
  Professions: Array<string>;
  Type: CustomerType;
  forceCallNumber?: boolean | null;
  journalSystem?: string | null;
  billingInstructions?: string | null;
  municipalityId?: string | null;
  bemloOrgId?: string | null;
  bemloUnitId?: string | null;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  AOESettings: Array<{
    Enabled: boolean;
    AreaOfExpertise: string;
    Error?: boolean | null;
    FortnoxId?: string | null;
    Inherited?: boolean | null;
    InvoicingData?: string | null;
    Profession: string;
    GroupInvoicing?: boolean | null;
    timeReport?: boolean | null;
    orderId?: string | null;
    ResponsiblePerson?: { Name: string; PersonId: string } | null;
  }>;
  DirectChildren: Array<{ Id: string; Name: string; Type: CustomerType }>;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  WorkshiftSpans: Array<{
    Profession: string;
    FromMinutes: number;
    ToMinutes: number;
    Workshift: Workshift;
  }>;
};

export type MunicipalityFragment = { _id: string; name: string };

export type GetMunicipalitiesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMunicipalitiesQuery = {
  municipalities: Array<{ _id: string; name: string }>;
};

export type CustomerEditor_FetchQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerEditor_FetchQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    CustomerGroups: Array<string>;
    Description: string;
    Name?: string | null;
    OrganizationNumber: string;
    OrganizationType?: OrganizationType | null;
    RecruitingPortalType?: RecruitingPortalType | null;
    OwnProfessions: Array<string>;
    Professions: Array<string>;
    Type: CustomerType;
    forceCallNumber?: boolean | null;
    journalSystem?: string | null;
    billingInstructions?: string | null;
    municipalityId?: string | null;
    bemloOrgId?: string | null;
    bemloUnitId?: string | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    AOESettings: Array<{
      Enabled: boolean;
      AreaOfExpertise: string;
      Error?: boolean | null;
      FortnoxId?: string | null;
      Inherited?: boolean | null;
      InvoicingData?: string | null;
      Profession: string;
      GroupInvoicing?: boolean | null;
      timeReport?: boolean | null;
      orderId?: string | null;
      ResponsiblePerson?: { Name: string; PersonId: string } | null;
    }>;
    DirectChildren: Array<{ Id: string; Name: string; Type: CustomerType }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    WorkshiftSpans: Array<{
      Profession: string;
      FromMinutes: number;
      ToMinutes: number;
      Workshift: Workshift;
    }>;
  } | null;
};

export type CustomerEditor_LoadRegionsQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerEditor_LoadRegionsQuery = {
  customers: {
    dbTime?: number | null;
    items: Array<{ Ref: { Id: string; Name: string; Type: CustomerType } }>;
  };
};

export type CustomerEditor_LoadHospitalsQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type CustomerEditor_LoadHospitalsQuery = {
  customers: {
    dbTime?: number | null;
    items: Array<{
      _id: string;
      Name?: string | null;
      ShowHospitalAOERewriteWarning: boolean;
      Ref: { Id: string; Name: string; Type: CustomerType };
    }>;
  };
};

export type CustomerEditor_CreateMutationVariables = Exact<{
  input: CustomerInput;
}>;

export type CustomerEditor_CreateMutation = {
  submit: {
    customer?: {
      _id: string;
      AreasOfExpertise: Array<string>;
      CustomerGroups: Array<string>;
      Description: string;
      Name?: string | null;
      OrganizationNumber: string;
      OrganizationType?: OrganizationType | null;
      RecruitingPortalType?: RecruitingPortalType | null;
      OwnProfessions: Array<string>;
      Professions: Array<string>;
      Type: CustomerType;
      forceCallNumber?: boolean | null;
      journalSystem?: string | null;
      billingInstructions?: string | null;
      municipalityId?: string | null;
      bemloOrgId?: string | null;
      bemloUnitId?: string | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      AOESettings: Array<{
        Enabled: boolean;
        AreaOfExpertise: string;
        Error?: boolean | null;
        FortnoxId?: string | null;
        Inherited?: boolean | null;
        InvoicingData?: string | null;
        Profession: string;
        GroupInvoicing?: boolean | null;
        timeReport?: boolean | null;
        orderId?: string | null;
        ResponsiblePerson?: { Name: string; PersonId: string } | null;
      }>;
      DirectChildren: Array<{ Id: string; Name: string; Type: CustomerType }>;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      WorkshiftSpans: Array<{
        Profession: string;
        FromMinutes: number;
        ToMinutes: number;
        Workshift: Workshift;
      }>;
    } | null;
    validationErrors?: Array<{ Message?: string | null; Path?: string | null }> | null;
  };
};

export type CustomerEditor_UpdateMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  input: CustomerInput;
}>;

export type CustomerEditor_UpdateMutation = {
  submit: {
    customer?: {
      _id: string;
      AreasOfExpertise: Array<string>;
      CustomerGroups: Array<string>;
      Description: string;
      Name?: string | null;
      OrganizationNumber: string;
      OrganizationType?: OrganizationType | null;
      RecruitingPortalType?: RecruitingPortalType | null;
      OwnProfessions: Array<string>;
      Professions: Array<string>;
      Type: CustomerType;
      forceCallNumber?: boolean | null;
      journalSystem?: string | null;
      billingInstructions?: string | null;
      municipalityId?: string | null;
      bemloOrgId?: string | null;
      bemloUnitId?: string | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      AOESettings: Array<{
        Enabled: boolean;
        AreaOfExpertise: string;
        Error?: boolean | null;
        FortnoxId?: string | null;
        Inherited?: boolean | null;
        InvoicingData?: string | null;
        Profession: string;
        GroupInvoicing?: boolean | null;
        timeReport?: boolean | null;
        orderId?: string | null;
        ResponsiblePerson?: { Name: string; PersonId: string } | null;
      }>;
      DirectChildren: Array<{ Id: string; Name: string; Type: CustomerType }>;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      WorkshiftSpans: Array<{
        Profession: string;
        FromMinutes: number;
        ToMinutes: number;
        Workshift: Workshift;
      }>;
    } | null;
    validationErrors?: Array<{ Message?: string | null; Path?: string | null }> | null;
  };
};

export type GetCustomerFilesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetCustomerFilesQuery = {
  customerById?: {
    _id: string;
    documents?: Array<{
      DocumentType?: CustomerDocumentTypes | null;
      ThumbURL?: string | null;
      PdfURL?: string | null;
      FileRef: {
        Name?: string | null;
        NodeID: string;
        NodeType: NodeType;
        MimeType: string;
        Size: number;
      };
    }> | null;
  } | null;
};

export type UploadCustomerDocMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  file: Scalars["Upload"];
  documentType: CustomerDocumentTypes;
}>;

export type UploadCustomerDocMutation = {
  uploadCustomerDocument: Array<{
    FileRef: {
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      MimeType: string;
      Size: number;
    };
  }>;
};

export type DeleteCustomerDocMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
}>;

export type DeleteCustomerDocMutation = {
  deleteCustomerDocument: Array<{
    FileRef: {
      Name?: string | null;
      NodeID: string;
      NodeType: NodeType;
      MimeType: string;
      Size: number;
    };
  }>;
};

export type CustomerProfileFragment = {
  _id: string;
  AreasOfExpertise: Array<string>;
  DocumentTypes: Array<string>;
  Type: CustomerType;
  RecruitingPortalType?: RecruitingPortalType | null;
  OrganizationType?: OrganizationType | null;
  noApproval: boolean;
  needSignature: boolean;
  noApprovalMonthly: boolean;
  noApprovalShortening: boolean;
  noApprovalSpecial: boolean;
  needSignatureTROkInApp: boolean;
  Professions: Array<string>;
  forceCallNumber?: boolean | null;
  municipalityId?: string | null;
  areasOfExpertiseTotal: number;
  AvatarPic?: string | null;
  Deleted: boolean;
  Description: string;
  LastContactDate?: Date | null;
  Name?: string | null;
  Specializations: Array<string>;
  IsValid?: boolean | null;
  journalSystem?: string | null;
  inLists: boolean;
  Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
  ValidationErrors: Array<{
    Message: string;
    Params?: any | null;
    Type: NodeValidationErrorType;
  }>;
  timeReportTemplateSettings?: Array<{
    type: TimeReportTemplateType;
    professions: Array<string>;
  } | null> | null;
  documents?: Array<{ DocumentType?: CustomerDocumentTypes | null }> | null;
  Address?: {
    City: string;
    Country: string;
    Region: string;
    StreetName: string;
    ZipCode: string;
  } | null;
  StaffingContactPersons: Array<{
    _id: string;
    AreasOfExpertise: Array<string | null>;
    Email?: string | null;
    Name?: string | null;
    Phone?: string | null;
    Roles: Array<string>;
    Title?: string | null;
  }>;
};

export type CustomerProfile_GetCustomerTreeQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerProfile_GetCustomerTreeQuery = {
  customerById?: {
    _id: string;
    Name?: string | null;
    CustomerTree: Array<{
      ParentId?: string | null;
      CustomerRef: { Id: string; Name: string; Type: CustomerType };
      HospitalRef?: { Id: string; Name: string; Type: CustomerType } | null;
    }>;
  } | null;
};

export type CustomerProfile_GetProfileQueryVariables = Exact<{
  id: Scalars["ObjectId"];
  customerGroup?: InputMaybe<Scalars["String"]>;
  showDeleted?: InputMaybe<Scalars["Boolean"]>;
}>;

export type CustomerProfile_GetProfileQuery = {
  customerById?: {
    _id: string;
    AreasOfExpertise: Array<string>;
    DocumentTypes: Array<string>;
    Type: CustomerType;
    RecruitingPortalType?: RecruitingPortalType | null;
    OrganizationType?: OrganizationType | null;
    noApproval: boolean;
    needSignature: boolean;
    noApprovalMonthly: boolean;
    noApprovalShortening: boolean;
    noApprovalSpecial: boolean;
    needSignatureTROkInApp: boolean;
    Professions: Array<string>;
    forceCallNumber?: boolean | null;
    municipalityId?: string | null;
    areasOfExpertiseTotal: number;
    AvatarPic?: string | null;
    Deleted: boolean;
    Description: string;
    LastContactDate?: Date | null;
    Name?: string | null;
    Specializations: Array<string>;
    IsValid?: boolean | null;
    journalSystem?: string | null;
    inLists: boolean;
    ContactPersons: Array<{
      _id: string;
      CustomerGroups: Array<string>;
      Deleted: boolean;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      CellPhone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
      AreasOfExpertise: Array<string | null>;
      BooksProfessions: Array<string>;
      CustomerRefs: Array<{ Id: string }>;
      LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
    }>;
    Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    ValidationErrors: Array<{
      Message: string;
      Params?: any | null;
      Type: NodeValidationErrorType;
    }>;
    timeReportTemplateSettings?: Array<{
      type: TimeReportTemplateType;
      professions: Array<string>;
    } | null> | null;
    documents?: Array<{ DocumentType?: CustomerDocumentTypes | null }> | null;
    Address?: {
      City: string;
      Country: string;
      Region: string;
      StreetName: string;
      ZipCode: string;
    } | null;
    StaffingContactPersons: Array<{
      _id: string;
      AreasOfExpertise: Array<string | null>;
      Email?: string | null;
      Name?: string | null;
      Phone?: string | null;
      Roles: Array<string>;
      Title?: string | null;
    }>;
  } | null;
  searchProfiles?: Array<{ _id: string; name: string }> | null;
};

export type CustomerProfile_DeleteCustomerMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerProfile_DeleteCustomerMutation = {
  result: { _id: string; Deleted: boolean };
};

export type CustomerProfile_DeleteContactPersonMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerProfile_DeleteContactPersonMutation = { result: boolean };

export type CustomerProfile_MoveCustomerMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  parentId?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type CustomerProfile_MoveCustomerMutation = {
  result: {
    validationErrors: Array<string>;
    customer?: {
      _id: string;
      AreasOfExpertise: Array<string>;
      DocumentTypes: Array<string>;
      Type: CustomerType;
      RecruitingPortalType?: RecruitingPortalType | null;
      OrganizationType?: OrganizationType | null;
      noApproval: boolean;
      needSignature: boolean;
      noApprovalMonthly: boolean;
      noApprovalShortening: boolean;
      noApprovalSpecial: boolean;
      needSignatureTROkInApp: boolean;
      Professions: Array<string>;
      forceCallNumber?: boolean | null;
      municipalityId?: string | null;
      areasOfExpertiseTotal: number;
      AvatarPic?: string | null;
      Deleted: boolean;
      Description: string;
      LastContactDate?: Date | null;
      Name?: string | null;
      Specializations: Array<string>;
      IsValid?: boolean | null;
      journalSystem?: string | null;
      inLists: boolean;
      ContactPersons: Array<{
        _id: string;
        CustomerGroups: Array<string>;
        Deleted: boolean;
        Email?: string | null;
        Name?: string | null;
        Phone?: string | null;
        CellPhone?: string | null;
        Roles: Array<string>;
        Title?: string | null;
        AreasOfExpertise: Array<string | null>;
        BooksProfessions: Array<string>;
        CustomerRefs: Array<{ Id: string }>;
        LastChange: { Date: Date; IsUpdate: boolean; User?: { Name: string } | null };
      }>;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
      ValidationErrors: Array<{
        Message: string;
        Params?: any | null;
        Type: NodeValidationErrorType;
      }>;
      timeReportTemplateSettings?: Array<{
        type: TimeReportTemplateType;
        professions: Array<string>;
      } | null> | null;
      documents?: Array<{ DocumentType?: CustomerDocumentTypes | null }> | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      StaffingContactPersons: Array<{
        _id: string;
        AreasOfExpertise: Array<string | null>;
        Email?: string | null;
        Name?: string | null;
        Phone?: string | null;
        Roles: Array<string>;
        Title?: string | null;
      }>;
    } | null;
  };
};

export type CustomerProfile_ToggleCustomerSettingsMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  key: CustomerSettingsKey;
  value: Scalars["Boolean"];
}>;

export type CustomerProfile_ToggleCustomerSettingsMutation = {
  toggleCustomerSettings: { _id: string };
};

export type CustomerProfile_ToggleCustomerNoApprovalMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
  documentType: CustomerDocumentTypes;
  file?: InputMaybe<Scalars["Upload"]>;
}>;

export type CustomerProfile_ToggleCustomerNoApprovalMutation = {
  toggleCustomerNoApproval: { _id: string };
};

export type DeleteContactPersonDialog_GetQueryVariables = Exact<{
  contactPersonId: Scalars["ObjectId"];
}>;

export type DeleteContactPersonDialog_GetQuery = {
  contactPersonById: {
    _id: string;
    Name?: string | null;
    Customers: Array<{
      _id: string;
      Name?: string | null;
      Type: CustomerType;
      Parents: Array<{ Name: string; Type: CustomerType }>;
    }>;
  };
};

export type DeleteContactPersonDialog_DeleteMutationVariables = Exact<{
  contactPersonId: Scalars["ObjectId"];
}>;

export type DeleteContactPersonDialog_DeleteMutation = { deleteContactPerson: boolean };

export type DeleteContactPersonDialog_DeassignMutationVariables = Exact<{
  contactPersonId: Scalars["ObjectId"];
  customerIds: Array<Scalars["ObjectId"]> | Scalars["ObjectId"];
}>;

export type DeleteContactPersonDialog_DeassignMutation = {
  deassignContactPersonFromCustomers: { _id: string; Deleted: boolean };
};

export type ConsultantMatchingItemDataFragment = {
  _id: string;
  Name?: string | null;
  AreasOfExpertise: Array<string>;
  ResponsiblePerson?: { Name: string; PersonId: string } | null;
};

export type GetCustomerConsultantMatchingQueryVariables = Exact<{
  params: ConsultantMatchingParams;
  filter: ConsultantsQueryInput;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  sortBy: SortBy;
  sortOrder: SortOrder;
}>;

export type GetCustomerConsultantMatchingQuery = {
  consultantMatching: {
    items: Array<{
      weeksTotal: number;
      minutesTotal: number;
      consultant: {
        _id: string;
        Name?: string | null;
        AreasOfExpertise: Array<string>;
        ResponsiblePerson?: { Name: string; PersonId: string } | null;
      };
    }>;
  };
};

export type GetDeclaredConsultantsByCustomerQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
}>;

export type GetDeclaredConsultantsByCustomerQuery = {
  consultantByWorkExperience: {
    items: Array<{
      consultant: { _id: string; Name?: string | null };
      workExperience?: {
        competitors?: Array<string | null> | null;
        employmentType?: LegalPersonType | null;
        from?: Date | null;
        to?: Date | null;
      } | null;
    }>;
  };
};

export type GetCustomerRecommendedPricesQueryVariables = Exact<{
  customerId: Scalars["ObjectId"];
}>;

export type GetCustomerRecommendedPricesQuery = {
  customerById?: {
    _id: string;
    Type: CustomerType;
    recommendedPrices: Array<{
      areaOfExpertise: string;
      profession: string;
      value: string;
    }>;
  } | null;
};

export type SetCustomerRecommendedPricesMutationVariables = Exact<{
  customerId: Scalars["ObjectId"];
  input: Array<CustomerRecommendedPriceInput> | CustomerRecommendedPriceInput;
}>;

export type SetCustomerRecommendedPricesMutation = {
  setCustomerRecommendedPrices: {
    _id: string;
    Type: CustomerType;
    recommendedPrices: Array<{
      areaOfExpertise: string;
      profession: string;
      value: string;
    }>;
  };
};

export type CustomerSearch_SearchQueryVariables = Exact<{
  filter?: InputMaybe<CustomersFilter>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type CustomerSearch_SearchQuery = {
  customers: {
    dbTime?: number | null;
    items: Array<{
      _id: string;
      AreasOfExpertise: Array<string>;
      areasOfExpertiseTotal: number;
      AvatarPic?: string | null;
      Deleted: boolean;
      Description: string;
      LastContactDate?: Date | null;
      Name?: string | null;
      Specializations: Array<string>;
      Type: CustomerType;
      IsValid?: boolean | null;
      journalSystem?: string | null;
      inLists: boolean;
      RecruitingPortalType?: RecruitingPortalType | null;
      Address?: {
        City: string;
        Country: string;
        Region: string;
        StreetName: string;
        ZipCode: string;
      } | null;
      StaffingContactPersons: Array<{
        _id: string;
        AreasOfExpertise: Array<string | null>;
        Email?: string | null;
        Name?: string | null;
        Phone?: string | null;
        Roles: Array<string>;
        Title?: string | null;
      }>;
      Parents: Array<{ Id: string; Name: string; Type: CustomerType }>;
    }>;
  };
};

export type CustomerSearch_CountQueryVariables = Exact<{
  filter?: InputMaybe<CustomersFilter>;
}>;

export type CustomerSearch_CountQuery = { customersTotal: { total: number } };

export type CustomerCard_GetDeleteInfoQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type CustomerCard_GetDeleteInfoQuery = {
  customerById?: { CanBeDeleted: boolean; CantBeDeletedReasons: Array<string> } | null;
};

export type CustomerHeaderFragment = {
  Systems: Array<string>;
  LastContactDate?: Date | null;
  Name?: string | null;
  ContactPersons: Array<{ Name?: string | null; Roles: Array<string> }>;
};

export type DDocumentFragment = {
  DocumentType?: string | null;
  ThumbURL: string;
  PdfURL: string;
  FileRef: {
    MimeType: string;
    Name?: string | null;
    NodeID: string;
    NodeType: NodeType;
    Size: number;
  };
};

export type CrmDocumentFragment = {
  _id: string;
  type: CrmDocumentType;
  name: string;
  documentType?: string | null;
  mimeType: string;
  size: number;
  pdfUrl: string;
  thumbUrl: string;
};

export type CustomerRefFragment = { Id: string; Name: string; Type: CustomerType };

export type UserRefFragment = { PersonId: string; Name: string };

export type UserFragment = {
  _id: string;
  AzureId?: string | null;
  AvatarPic?: string | null;
  BirthDate?: Date | null;
  CellPhone?: string | null;
  Email: string;
  Enabled: boolean;
  Name: string;
  Phone?: string | null;
  Teams: Array<string>;
  AzureGroups?: Array<string> | null;
  Title?: string | null;
  Deleted: boolean;
  ManagerId?: string | null;
};

export type CustomerContractInfoFragment = {
  _id: string;
  contractNumber?: string | null;
  contractStart?: Date | null;
  contractEnd?: Date | null;
  contractProlongation?: Date | null;
};

export type NodeRefFragment = {
  Name?: string | null;
  NodeID: string;
  NodeType: NodeType;
};

export type ProjectFragment = {
  _id: string;
  Comment: string;
  Description: string;
  Name: string;
  ProjectNumber: string;
  Status?: ProjectStatus | null;
  Admin?: { Name: string; PersonId: string } | null;
  Owner?: { Name: string; PersonId: string } | null;
  Members: Array<{ Name: string; PersonId: string }>;
};

export type InvoiceFragment = {
  _id: string;
  CustomerName?: string | null;
  CustomerNumber?: string | null;
  InvoiceNumber: string;
  Provider: InvoiceProvider;
  TotalGross?: number | null;
  TotalNet?: number | null;
  InvoiceDate?: Date | null;
  DueDate?: Date | null;
  Notes?: string | null;
  IsCredit: boolean;
  PreviewUrl: string;
};

export type TeamFragment = {
  ADGroups: Array<string>;
  AreasOfExpertise: Array<string>;
  KnownSystems: Array<string>;
  Name?: string | null;
  Tags: Array<string>;
  TodoGroup?: string | null;
  workrequestTeamName?: string | null;
  _id: string;
};

export type ExpertiseFragment = {
  Aliases: Array<string>;
  Exclusive?: boolean | null;
  Name: string;
  Profession: string;
  Specializations: Array<string>;
  Systems: Array<string>;
  Machines: Array<string>;
  Educations: Array<string>;
  Methods: Array<string>;
  QualityTemplates: Array<{
    Country: string;
    Items: Array<{
      Description?: string | null;
      DocumentsFolder?: string | null;
      ExpiresInMonths?: number | null;
      Name: string;
    }>;
  }>;
};

export type CountryFragment = {
  name: string;
  canWorkIn?: boolean | null;
  countryId: string;
  onTopInSearch?: boolean | null;
  sort?: number | null;
  regions: Array<{ name: string; countryCouncilId?: number | null }>;
};

export type RoleFragment = { IsStaffing?: boolean | null; Name: string };

export type CostCenterFragment = {
  OriginalName?: string | null;
  Id: string;
  IsActive: boolean;
  Name?: string | null;
  IsDeleted: boolean;
};

export type UploadConsultantAvatarMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  file: Scalars["Upload"];
}>;

export type UploadConsultantAvatarMutation = {
  uploadConsultantAvatar?: { _id: string; AvatarPic?: string | null } | null;
};

export type RemoveConsultantAvatarMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type RemoveConsultantAvatarMutation = {
  removeConsultantAvatar?: { _id: string; AvatarPic?: string | null } | null;
};

export type UploadCustomerAvatarMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  file: Scalars["Upload"];
}>;

export type UploadCustomerAvatarMutation = {
  uploadCustomerAvatar?: { _id: string; AvatarPic?: string | null } | null;
};

export type UploadCustomerBgPicMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  file: Scalars["Upload"];
}>;

export type UploadCustomerBgPicMutation = {
  uploadCustomerBgPic?: { _id: string; BgPic?: string | null } | null;
};

export type RemoveCustomerAvatarMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type RemoveCustomerAvatarMutation = {
  removeCustomerAvatar?: { _id: string; AvatarPic?: string | null } | null;
};

export type AddressWithRegionSectionFragment = {
  region: string;
  city: string;
  country: string;
  streetName: string;
  zipCode: string;
};

export type AddressSection_FormAddress_Fragment = {
  city: string;
  country: string;
  streetName: string;
  zipCode: string;
};

export type AddressSection_FormAddressWithRegion_Fragment = {
  city: string;
  country: string;
  streetName: string;
  zipCode: string;
};

export type AddressSectionFragment =
  | AddressSection_FormAddress_Fragment
  | AddressSection_FormAddressWithRegion_Fragment;

export type CallListSelectorListFragment = {
  _id: string;
  deleted: boolean;
  name: string;
  type: NodeType;
  nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
  members: Array<{ PersonId: string; Name: string }>;
};

export type CallListSelector_GetListsQueryVariables = Exact<{ [key: string]: never }>;

export type CallListSelector_GetListsQuery = {
  me: {
    _id: string;
    CallLists: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
    ContactLists: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
  };
};

export type SharedFileFragment = {
  _id: string;
  Deleted: boolean;
  SharedOn: Date;
  ExpiresOn: Date;
  ShareURL: string;
  ThumbURL: string;
  FileRef: {
    NodeID: string;
    NodeType: NodeType;
    Name?: string | null;
    Size: number;
    MimeType: string;
  };
  FileStats: {
    AccessedTotal: number;
    AccessRecords: Array<{ IP: string; AccessedOn: Date }>;
  };
  SharedBy: { PersonId: string; Name: string };
};

export type SharedFilesQueryVariables = Exact<{
  filter: SharedFilesFilter;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
}>;

export type SharedFilesQuery = {
  sharedFiles: {
    skip: number;
    limit: number;
    files: Array<{
      _id: string;
      Deleted: boolean;
      SharedOn: Date;
      ExpiresOn: Date;
      ShareURL: string;
      ThumbURL: string;
      FileRef: {
        NodeID: string;
        NodeType: NodeType;
        Name?: string | null;
        Size: number;
        MimeType: string;
      };
      FileStats: {
        AccessedTotal: number;
        AccessRecords: Array<{ IP: string; AccessedOn: Date }>;
      };
      SharedBy: { PersonId: string; Name: string };
    }>;
  };
};

export type GetSharedFileQueryVariables = Exact<{
  fileId: Scalars["ObjectId"];
}>;

export type GetSharedFileQuery = {
  sharedFileById: {
    _id: string;
    Deleted: boolean;
    SharedOn: Date;
    ExpiresOn: Date;
    ShareURL: string;
    ThumbURL: string;
    FileRef: {
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
      Size: number;
      MimeType: string;
    };
    FileStats: {
      AccessedTotal: number;
      AccessRecords: Array<{ IP: string; AccessedOn: Date }>;
    };
    SharedBy: { PersonId: string; Name: string };
  };
};

export type RemoveSharedFileMutationVariables = Exact<{
  fileId: Scalars["ObjectId"];
}>;

export type RemoveSharedFileMutation = { removeSharedFile: boolean };

export type UpdateSharedFileMutationVariables = Exact<{
  id: Scalars["ObjectId"];
  fileName?: InputMaybe<Scalars["String"]>;
  expiresOn?: InputMaybe<Scalars["Date"]>;
}>;

export type UpdateSharedFileMutation = {
  updateSharedFile: {
    _id: string;
    Deleted: boolean;
    SharedOn: Date;
    ExpiresOn: Date;
    ShareURL: string;
    ThumbURL: string;
    FileRef: {
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
      Size: number;
      MimeType: string;
    };
    FileStats: {
      AccessedTotal: number;
      AccessRecords: Array<{ IP: string; AccessedOn: Date }>;
    };
    SharedBy: { PersonId: string; Name: string };
  };
};

export type SharedFileSearch_UploadMutationVariables = Exact<{
  file: Scalars["Upload"];
  expiresOn: Scalars["Date"];
  fileName?: InputMaybe<Scalars["String"]>;
}>;

export type SharedFileSearch_UploadMutation = {
  uploadSharedFile: {
    Name: string;
    _id: string;
    Deleted: boolean;
    SharedOn: Date;
    ExpiresOn: Date;
    ShareURL: string;
    ThumbURL: string;
    FileRef: {
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
      Size: number;
      MimeType: string;
    };
    FileStats: {
      AccessedTotal: number;
      AccessRecords: Array<{ IP: string; AccessedOn: Date }>;
    };
    SharedBy: { PersonId: string; Name: string };
  };
};

export type FetchStaticDataQueryVariables = Exact<{ [key: string]: never }>;

export type FetchStaticDataQuery = {
  config: {
    competitors: Array<string>;
    customerGroups: Array<string>;
    titles: Array<string>;
    languages: Array<string>;
    nationalProcurementTravelRegions: Array<string>;
    blockBookingCreationForBemloCustomers: boolean;
    bookingTags: Array<{
      color: string;
      code: string;
      label?: string | null;
      bookingKit: boolean;
      booking: boolean;
    }>;
    roles: Array<{ IsStaffing?: boolean | null; Name: string }>;
    expertises: Array<{
      Aliases: Array<string>;
      Exclusive?: boolean | null;
      Name: string;
      Profession: string;
      Specializations: Array<string>;
      Systems: Array<string>;
      Machines: Array<string>;
      Educations: Array<string>;
      Methods: Array<string>;
      QualityTemplates: Array<{
        Country: string;
        Items: Array<{
          Description?: string | null;
          DocumentsFolder?: string | null;
          ExpiresInMonths?: number | null;
          Name: string;
        }>;
      }>;
    }>;
    countries: Array<{
      name: string;
      canWorkIn?: boolean | null;
      countryId: string;
      onTopInSearch?: boolean | null;
      sort?: number | null;
      regions: Array<{ name: string; countryCouncilId?: number | null }>;
    }>;
  };
  teams: Array<{
    ADGroups: Array<string>;
    AreasOfExpertise: Array<string>;
    KnownSystems: Array<string>;
    Name?: string | null;
    Tags: Array<string>;
    TodoGroup?: string | null;
    workrequestTeamName?: string | null;
    _id: string;
  }>;
};

export type FetchStaticData_ProjectsQueryVariables = Exact<{
  visibilityContext?: InputMaybe<ProjectVisibilityContext>;
}>;

export type FetchStaticData_ProjectsQuery = {
  projects: Array<{
    _id: string;
    Comment: string;
    Description: string;
    Name: string;
    ProjectNumber: string;
    Status?: ProjectStatus | null;
    Admin?: { Name: string; PersonId: string } | null;
    Owner?: { Name: string; PersonId: string } | null;
    Members: Array<{ Name: string; PersonId: string }>;
  }>;
};

export type TicketBadgesFragment = {
  TotalUnread: boolean;
  TeamBadges: Array<{
    TotalUnread: number;
    Badges: Array<{
      Category: TodoCategory;
      Read: number;
      Unread: number;
      Done?: number | null;
    }>;
    TeamRef: { Name?: string | null; NodeID: string; NodeType: NodeType };
  }>;
};

export type UserStore_CallListFragment = {
  _id: string;
  deleted: boolean;
  name: string;
  type: NodeType;
  nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
  members: Array<{ PersonId: string; Name: string }>;
};

export type MyProfileFragment = {
  _id: string;
  AvatarPic?: string | null;
  CellPhone?: string | null;
  Phone?: string | null;
  Email: string;
  Name: string;
  Title?: string | null;
  permissions: Array<string>;
  Teams: Array<string>;
  AzureGroups?: Array<string> | null;
  favoriteTeam?: string | null;
  favouriteConsultantIds: Array<string>;
  Permissions: {
    CanAccessCustomers?: boolean | null;
    CanAccessReports?: boolean | null;
    CanAddAccommodation?: boolean | null;
    CanAddCustomer?: boolean | null;
    CanDeleteConsultantBookingContract?: boolean | null;
    CanDeleteConsultantContract?: boolean | null;
    CanDeleteConsultants?: boolean | null;
    CanDeleteCustomers?: boolean | null;
    CanImportConsultants?: boolean | null;
    CanMoveCustomers?: boolean | null;
    CanPose?: boolean | null;
    CanSelectAllInMassActions?: boolean | null;
    CanUpdateConsultantGDPR?: boolean | null;
    CanUpdateConsultantInitialContact?: boolean | null;
    CanUpdateCustomerNumber?: boolean | null;
  };
  todoBadges: {
    TotalUnread: boolean;
    TeamBadges: Array<{
      TotalUnread: number;
      Badges: Array<{
        Category: TodoCategory;
        Read: number;
        Unread: number;
        Done?: number | null;
      }>;
      TeamRef: { Name?: string | null; NodeID: string; NodeType: NodeType };
    }>;
  };
  ExtraAreasOfExpertise: Array<{
    Aliases: Array<string>;
    Exclusive?: boolean | null;
    Name: string;
    Profession: string;
    Specializations: Array<string>;
    Systems: Array<string>;
    Machines: Array<string>;
    Educations: Array<string>;
    Methods: Array<string>;
    QualityTemplates: Array<{
      Country: string;
      Items: Array<{
        Description?: string | null;
        DocumentsFolder?: string | null;
        ExpiresInMonths?: number | null;
        Name: string;
      }>;
    }>;
  }>;
  subordinates: Array<{ _id: string }>;
};

export type MyProfilePartialFragment = {
  CallLists?: Array<{
    _id: string;
    deleted: boolean;
    name: string;
    type: NodeType;
    nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    members: Array<{ PersonId: string; Name: string }>;
  }> | null;
  ContactLists?: Array<{
    _id: string;
    deleted: boolean;
    name: string;
    type: NodeType;
    nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
    members: Array<{ PersonId: string; Name: string }>;
  }> | null;
};

export type GetMyProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyProfileQuery = {
  me: {
    _id: string;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    Phone?: string | null;
    Email: string;
    Name: string;
    Title?: string | null;
    permissions: Array<string>;
    Teams: Array<string>;
    AzureGroups?: Array<string> | null;
    favoriteTeam?: string | null;
    favouriteConsultantIds: Array<string>;
    Permissions: {
      CanAccessCustomers?: boolean | null;
      CanAccessReports?: boolean | null;
      CanAddAccommodation?: boolean | null;
      CanAddCustomer?: boolean | null;
      CanDeleteConsultantBookingContract?: boolean | null;
      CanDeleteConsultantContract?: boolean | null;
      CanDeleteConsultants?: boolean | null;
      CanDeleteCustomers?: boolean | null;
      CanImportConsultants?: boolean | null;
      CanMoveCustomers?: boolean | null;
      CanPose?: boolean | null;
      CanSelectAllInMassActions?: boolean | null;
      CanUpdateConsultantGDPR?: boolean | null;
      CanUpdateConsultantInitialContact?: boolean | null;
      CanUpdateCustomerNumber?: boolean | null;
    };
    todoBadges: {
      TotalUnread: boolean;
      TeamBadges: Array<{
        TotalUnread: number;
        Badges: Array<{
          Category: TodoCategory;
          Read: number;
          Unread: number;
          Done?: number | null;
        }>;
        TeamRef: { Name?: string | null; NodeID: string; NodeType: NodeType };
      }>;
    };
    ExtraAreasOfExpertise: Array<{
      Aliases: Array<string>;
      Exclusive?: boolean | null;
      Name: string;
      Profession: string;
      Specializations: Array<string>;
      Systems: Array<string>;
      Machines: Array<string>;
      Educations: Array<string>;
      Methods: Array<string>;
      QualityTemplates: Array<{
        Country: string;
        Items: Array<{
          Description?: string | null;
          DocumentsFolder?: string | null;
          ExpiresInMonths?: number | null;
          Name: string;
        }>;
      }>;
    }>;
    subordinates: Array<{ _id: string }>;
  };
};

export type MyProfile_GetAllowedCostCentersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyProfile_GetAllowedCostCentersQuery = {
  me: {
    allowedCostCenters: Array<{
      OriginalName?: string | null;
      Id: string;
      IsActive: boolean;
      Name?: string | null;
      IsDeleted: boolean;
    }>;
  };
};

export type UpdateFavoriteTeamMutationVariables = Exact<{
  teamName: Scalars["String"];
}>;

export type UpdateFavoriteTeamMutation = {
  updateFavoriteTeam?: {
    _id: string;
    AvatarPic?: string | null;
    CellPhone?: string | null;
    Phone?: string | null;
    Email: string;
    Name: string;
    Title?: string | null;
    permissions: Array<string>;
    Teams: Array<string>;
    AzureGroups?: Array<string> | null;
    favoriteTeam?: string | null;
    favouriteConsultantIds: Array<string>;
    Permissions: {
      CanAccessCustomers?: boolean | null;
      CanAccessReports?: boolean | null;
      CanAddAccommodation?: boolean | null;
      CanAddCustomer?: boolean | null;
      CanDeleteConsultantBookingContract?: boolean | null;
      CanDeleteConsultantContract?: boolean | null;
      CanDeleteConsultants?: boolean | null;
      CanDeleteCustomers?: boolean | null;
      CanImportConsultants?: boolean | null;
      CanMoveCustomers?: boolean | null;
      CanPose?: boolean | null;
      CanSelectAllInMassActions?: boolean | null;
      CanUpdateConsultantGDPR?: boolean | null;
      CanUpdateConsultantInitialContact?: boolean | null;
      CanUpdateCustomerNumber?: boolean | null;
    };
    todoBadges: {
      TotalUnread: boolean;
      TeamBadges: Array<{
        TotalUnread: number;
        Badges: Array<{
          Category: TodoCategory;
          Read: number;
          Unread: number;
          Done?: number | null;
        }>;
        TeamRef: { Name?: string | null; NodeID: string; NodeType: NodeType };
      }>;
    };
    ExtraAreasOfExpertise: Array<{
      Aliases: Array<string>;
      Exclusive?: boolean | null;
      Name: string;
      Profession: string;
      Specializations: Array<string>;
      Systems: Array<string>;
      Machines: Array<string>;
      Educations: Array<string>;
      Methods: Array<string>;
      QualityTemplates: Array<{
        Country: string;
        Items: Array<{
          Description?: string | null;
          DocumentsFolder?: string | null;
          ExpiresInMonths?: number | null;
          Name: string;
        }>;
      }>;
    }>;
    subordinates: Array<{ _id: string }>;
  } | null;
};

export type MyProfileUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type MyProfileUpdatedSubscription = {
  myProfileUpdated: {
    CallLists?: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }> | null;
    ContactLists?: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }> | null;
  };
};

export type UserStore_GetCallListsQueryVariables = Exact<{ [key: string]: never }>;

export type UserStore_GetCallListsQuery = {
  me: {
    _id: string;
    CallLists: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
  };
};

export type UserStore_GetContactListsQueryVariables = Exact<{ [key: string]: never }>;

export type UserStore_GetContactListsQuery = {
  me: {
    _id: string;
    ContactLists: Array<{
      _id: string;
      deleted: boolean;
      name: string;
      type: NodeType;
      nodes: Array<{ Name?: string | null; NodeID: string; NodeType: NodeType }>;
      members: Array<{ PersonId: string; Name: string }>;
    }>;
  };
};

export type GetTodoQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetTodoQuery = {
  todo: {
    _id: string;
    type?: NodeType | null;
    NodeType?: NodeType | null;
    NodeName?: string | null;
    Accepted?: boolean | null;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    CanAccept?: boolean | null;
    Completed?: Date | null;
    Deleted: boolean;
    Description: string;
    Due?: Date | null;
    SecondaryText: string;
    Status: TodoStatus;
    Tags: Array<string>;
    Type: TodoItemType;
    URL?: string | null;
    Priority?: TodoPriority | null;
    ViewMode: boolean;
    AssignedTo?: { PersonId: string; Name: string } | null;
    AssignedBy: { PersonId: string; Name: string };
    DelegatedBy?: { PersonId: string; Name: string } | null;
    LinkedItems?: Array<{
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
    }> | null;
    RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
    WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
  };
};

export type SetTodoStatusMutationVariables = Exact<{
  todoId: Scalars["ObjectId"];
  status: TodoStatus;
}>;

export type SetTodoStatusMutation = {
  setTodoStatus?: {
    _id: string;
    type?: NodeType | null;
    NodeType?: NodeType | null;
    NodeName?: string | null;
    Accepted?: boolean | null;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    CanAccept?: boolean | null;
    Completed?: Date | null;
    Deleted: boolean;
    Description: string;
    Due?: Date | null;
    SecondaryText: string;
    Status: TodoStatus;
    Tags: Array<string>;
    Type: TodoItemType;
    URL?: string | null;
    Priority?: TodoPriority | null;
    ViewMode: boolean;
    AssignedTo?: { PersonId: string; Name: string } | null;
    AssignedBy: { PersonId: string; Name: string };
    DelegatedBy?: { PersonId: string; Name: string } | null;
    LinkedItems?: Array<{
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
    }> | null;
    RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
    WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
  } | null;
};

export type AssignTodoMutationVariables = Exact<{
  todoId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
}>;

export type AssignTodoMutation = {
  assignTodo?: {
    _id: string;
    type?: NodeType | null;
    NodeType?: NodeType | null;
    NodeName?: string | null;
    Accepted?: boolean | null;
    AssignedOn: Date;
    AssignedTeam?: string | null;
    CanAccept?: boolean | null;
    Completed?: Date | null;
    Deleted: boolean;
    Description: string;
    Due?: Date | null;
    SecondaryText: string;
    Status: TodoStatus;
    Tags: Array<string>;
    Type: TodoItemType;
    URL?: string | null;
    Priority?: TodoPriority | null;
    ViewMode: boolean;
    AssignedTo?: { PersonId: string; Name: string } | null;
    AssignedBy: { PersonId: string; Name: string };
    DelegatedBy?: { PersonId: string; Name: string } | null;
    LinkedItems?: Array<{
      NodeID: string;
      NodeType: NodeType;
      Name?: string | null;
    }> | null;
    RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
    WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
  } | null;
};

export type TicketItemDataFragment = {
  _id: string;
  type?: NodeType | null;
  NodeType?: NodeType | null;
  NodeName?: string | null;
  Accepted?: boolean | null;
  AssignedOn: Date;
  AssignedTeam?: string | null;
  CanAccept?: boolean | null;
  Completed?: Date | null;
  Deleted: boolean;
  Description: string;
  Due?: Date | null;
  SecondaryText: string;
  Status: TodoStatus;
  Tags: Array<string>;
  Type: TodoItemType;
  URL?: string | null;
  Priority?: TodoPriority | null;
  ViewMode: boolean;
  AssignedTo?: { PersonId: string; Name: string } | null;
  AssignedBy: { PersonId: string; Name: string };
  DelegatedBy?: { PersonId: string; Name: string } | null;
  LinkedItems?: Array<{
    NodeID: string;
    NodeType: NodeType;
    Name?: string | null;
  }> | null;
  RelatedTo?: { NodeID: string; Name?: string | null; NodeType: NodeType } | null;
  WhoWatched?: Array<{ PersonId: string; Name: string } | null> | null;
};

export type TodoSearchItemFragment = {
  _id: string;
  createdOn: Date;
  dueDate?: Date | null;
  completedOn?: Date | null;
  createdBy: string;
  delegatedBy?: string | null;
  assignedTo?: string | null;
  assignedBy?: string | null;
  managedBy?: string | null;
  status: TodoStatus;
  priority?: TodoPriority | null;
  title: string;
  tags: Array<string>;
  canAccept?: boolean | null;
  canDecline?: boolean | null;
  canComplete?: boolean | null;
  category?: TodoCategory | null;
  teamIds: Array<string>;
  unreadStatuses: Array<{ type: TodoUnreadStatus; count: number }>;
  relatedTo?: Array<{ NodeID: string; Name?: string | null; NodeType: NodeType }> | null;
  search: { showTop: boolean };
};

export type TodoSearchQueryVariables = Exact<{
  filter?: InputMaybe<TodoSearchFilter>;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<TodoSearchSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type TodoSearchQuery = {
  todoSearch: Array<{
    _id: string;
    createdOn: Date;
    dueDate?: Date | null;
    completedOn?: Date | null;
    createdBy: string;
    delegatedBy?: string | null;
    assignedTo?: string | null;
    assignedBy?: string | null;
    managedBy?: string | null;
    status: TodoStatus;
    priority?: TodoPriority | null;
    title: string;
    tags: Array<string>;
    canAccept?: boolean | null;
    canDecline?: boolean | null;
    canComplete?: boolean | null;
    category?: TodoCategory | null;
    teamIds: Array<string>;
    unreadStatuses: Array<{ type: TodoUnreadStatus; count: number }>;
    relatedTo?: Array<{
      NodeID: string;
      Name?: string | null;
      NodeType: NodeType;
    }> | null;
    search: { showTop: boolean };
  }>;
};

export type GetConsultant_ReferencesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultant_ReferencesQuery = { consultantById?: { _id: string } | null };

export type GetConsultant_AllReferencesQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetConsultant_AllReferencesQuery = {
  consultantById?: { _id: string } | null;
};

export type GetTodoTotalQueryVariables = Exact<{
  filter?: InputMaybe<TodoSearchFilter>;
}>;

export type GetTodoTotalQuery = { todoTotal: { dbTime: number; total: number } };

export type TravelRequestSearchItemFragment = {
  _id?: string | null;
  createdOn?: Date | null;
  consultantName?: string | null;
  city?: string | null;
  firstDeparture?: Date | null;
  createdBy?: { PersonId: string; Name: string } | null;
  weeks?: Array<{ name?: string | null; link?: string | null } | null> | null;
  status?: {
    status?: TravelRequestStatusType | null;
    setOn?: Date | null;
    setBy?: { PersonId: string; Name: string } | null;
  } | null;
};

export type TravelRequestSearchQueryVariables = Exact<{
  filter: TravelRequestQueryInput;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<TravelRequestSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;

export type TravelRequestSearchQuery = {
  travelRequestSearch: {
    dbTime?: number | null;
    skip: number;
    limit: number;
    items: Array<{
      _id?: string | null;
      createdOn?: Date | null;
      consultantName?: string | null;
      city?: string | null;
      firstDeparture?: Date | null;
      createdBy?: { PersonId: string; Name: string } | null;
      weeks?: Array<{ name?: string | null; link?: string | null } | null> | null;
      status?: {
        status?: TravelRequestStatusType | null;
        setOn?: Date | null;
        setBy?: { PersonId: string; Name: string } | null;
      } | null;
    }>;
  };
};

export type TravelRequestSearchTotalQueryVariables = Exact<{
  filter: TravelRequestQueryInput;
}>;

export type TravelRequestSearchTotalQuery = {
  travelRequestSearchTotal: { dbTime?: number | null; total: number };
};

export type GetWorkflowRunsByOwnerQueryVariables = Exact<{
  status?: InputMaybe<WorkflowStatus>;
  workflowType?: InputMaybe<Scalars["String"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type GetWorkflowRunsByOwnerQuery = {
  getWorkflowRunsByOwner: {
    total: number;
    items: Array<{
      _id?: string | null;
      workflowType: string;
      entityId: string;
      entityType: string;
      status: WorkflowStatus;
      errorMessage?: string | null;
      scheduledAt: Date;
      startedAt?: Date | null;
      completedAt?: Date | null;
      metadata?: any | null;
      steps: Array<{
        _id: string;
        title: string;
        startedAt?: Date | null;
        completedAt?: Date | null;
        failedAt?: Date | null;
      }>;
    }>;
  };
};

export type QualityCheckFilterItemFragment = {
  name: string;
  statuses: Array<SearchQualityCheckStatus>;
};

export type GetSearchQualityItemsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSearchQualityItemsQuery = {
  getConsultantSearchQualityItems: Array<{
    name: string;
    statuses: Array<SearchQualityCheckStatus>;
  }>;
};

export type SearchProfileOptionDataFragment = { _id: string; name: string };

export type SearchProfileDataFragment = {
  fields: any;
  type: SearchProfileType;
  _id: string;
  name: string;
  customerRefs?: Array<{ Id: string; Name: string; Type: CustomerType }> | null;
};

export type SearchSearchProfilesQueryVariables = Exact<{
  filter: SearchProfilesFilter;
  skip?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type SearchSearchProfilesQuery = {
  SearchProfiles: { items: Array<{ _id: string; name: string }> };
};

export type GetSearchProfileQueryVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type GetSearchProfileQuery = {
  searchProfileById?: {
    fields: any;
    type: SearchProfileType;
    _id: string;
    name: string;
    customerRefs?: Array<{ Id: string; Name: string; Type: CustomerType }> | null;
  } | null;
};

export type DeleteSearchProfileMutationVariables = Exact<{
  id: Scalars["ObjectId"];
}>;

export type DeleteSearchProfileMutation = { removeSearchProfile: number };

export type UpsertSearchProfileMutationVariables = Exact<{
  data: SearchProfileFormInput;
  id?: InputMaybe<Scalars["ObjectId"]>;
}>;

export type UpsertSearchProfileMutation = {
  submitSearchProfileForm: {
    fields: any;
    type: SearchProfileType;
    _id: string;
    name: string;
    customerRefs?: Array<{ Id: string; Name: string; Type: CustomerType }> | null;
  };
};

export const TimereportKitSupportSearchItemFragmentDoc = gql`
  fragment TimereportKitSupportSearchItem on BookingWeekListItem {
    _id
    bookingAssignedTo {
      setTo {
        Name
        PersonId
      }
    }
    bookingSupportTagStatus {
      setBy {
        PersonId
        Name
      }
      setOn
      tag
    }
    bookingSupportTagComment
    isHighPrior
    AreaOfExpertise
    TimeReportStatus
    timeReportStatusSetBy {
      Name
      PersonId
    }
    timeReportStatusSetOn
    BookingRef {
      NodeID
    }
    ConsultantRef {
      Name
      NodeID
    }
    ConsultantServicePreferences
    DepartmentsRefs {
      Id
      Name
      Type
    }
    HospitalRef {
      Id
      Name
      Type
    }
    OrganizationRef {
      Id
      Name
    }
    Week
    CustomerNumber
    ContractType
    ContractTypeAbbr
    CostCenterId
    CostCenterName
    IsCanceled
    IsConsultantPayed
    IsCustomerBilled
    IsMarked
    InvoiceNumbers
    ProjectId
    projectName
    projectNumber
    InvoiceTotalGrossFmt
    InvoicedTotalFmt
    ProfitRatio
    ProfitNetFmt
    isNationalProcurement
    lastKitCreationWfFailedAt
  }
`;
export const CustomerBillingInstructionsFragmentDoc = gql`
  fragment CustomerBillingInstructions on Customer {
    billingInstructions
  }
`;
export const AccommodationRequestSearchItemFragmentDoc = gql`
  fragment AccommodationRequestSearchItem on AccommodationRequestSearch {
    _id
    createdOn
    createdBy {
      PersonId
      Name
    }
    weeks {
      name
      link
    }
    status {
      status
      setBy {
        PersonId
        Name
      }
      setOn
    }
    consultantName
    city
    firstArrival
  }
`;
export const AccommodationCardDetailsFragmentDoc = gql`
  fragment AccommodationCardDetails on Accommodation {
    _id
    Type
    Offers {
      _id
      Name
      Price
      PriceType
      Options
      Rooms
      Beds
      Area
    }
    ImgUrl
    Name
    Email
    Site
    Phone
    CheckIn
    CheckOut
    CancellationPolicy
    Instruction
    preferredChoice
    envCertification
    envCertificationName
    Address {
      StreetName
      City
      Region
      Country
      ZipCode
    }
    ResponsiblePersonRef {
      PersonId
      Name
    }
    unfit {
      value
      comment
      userRef {
        Name
        PersonId
      }
    }
  }
`;
export const BookingKitAssignedFragmentDoc = gql`
  fragment BookingKitAssigned on BookingKitSearch {
    assignedByUserId
    assignedByUserName
    assignedOn
    assignedToUserId
    assignedToUserName
  }
`;
export const BookingSupportTagStatusFragmentDoc = gql`
  fragment BookingSupportTagStatus on BookingSupportTagStatus {
    tag
    setOn
    setBy {
      Name
    }
  }
`;
export const BookingKitSearchItemFragmentDoc = gql`
  fragment BookingKitSearchItem on BookingKitSearch {
    _id
    bookingId
    createdOn
    type
    week
    assignedByUserId
    assignedByUserName
    assignedOn
    assignedToUserId
    assignedToUserName
    consultantId
    consultantName
    regionId
    regionName
    hospitalId
    hospitalName
    departmentId
    departmentName
    areaOfExpertise
    costCenterId
    costCenterName
    projectId
    projectName
    consultantPayoutType
    customerContractType
    isNationalProcurement
    isHighPriority
    customerBillingInstructions
    lastStatusSetByUserName
    lastStatusType
    lastStatusSetOn
    timereportApprovedOn
    bookingSupportTagStatus {
      ...BookingSupportTagStatus
    }
    bookingSupportTagComment
  }
  ${BookingSupportTagStatusFragmentDoc}
`;
export const EventLog_BookingKitEventFragmentDoc = gql`
  fragment EventLog_BookingKitEvent on BookingKitEvent {
    _id
    CanDelete
    CanEdit
    CanPin
    CreatedBy {
      PersonId
      Name
    }
    CreatedOn
    Deleted
    Description
    DescriptionHtml
    Sticky
    UpdatedBy {
      Name
    }
    Type
    ResultOfAction
    Links
    UserRef {
      Name
      PersonId
    }
    Warning
  }
`;
export const UserRefFragmentDoc = gql`
  fragment UserRef on UserRef {
    PersonId
    Name
  }
`;
export const KitStatusFragmentDoc = gql`
  fragment kitStatus on BookingKitStatus {
    setBy {
      ...UserRef
    }
    setOn
    status
    comment
  }
  ${UserRefFragmentDoc}
`;
export const KitProfileCardFragmentDoc = gql`
  fragment KitProfileCard on BookingKit {
    _id
    bookingId
    isDone
    week
    assigned {
      by {
        Name
        PersonId
      }
      on
      to {
        Name
        PersonId
      }
    }
    timeReportType
    name
    type
    responsible {
      _id
      Name
    }
    manager {
      _id
      Name
    }
    comments
    withTimeReport
    withCustomerInvoice
    withConsultantInvoice
    withSickPay
    withSubcontractorPay
    bookingSupportCheckWasValid
    bookingSupportTagStatus {
      ...BookingSupportTagStatus
    }
    bookingSupportTagComment
    receipts {
      uri
      name
    }
    documents {
      _id
      documentType
      name
      pdfUrl
    }
    statuses {
      ...kitStatus
    }
    customerBillingInstructions
    hospital {
      _id
      Name
    }
    department {
      _id
      Name
    }
    consultant {
      _id
      Name
    }
    project {
      Name
      ProjectNumber
    }
    costCenter {
      Id
      Name
    }
    consultantPayoutType
    deleted
    deletedOn
    deletedByName
    isGroupInvoicing
    profitNet
    profitRatio
    currentHBAStatus {
      ...kitStatus
    }
    currentOCStatus {
      ...kitStatus
    }
    currentFinancePaymentStatus {
      ...kitStatus
    }
    currentFinanceInvoiceStatus {
      ...kitStatus
    }
  }
  ${BookingSupportTagStatusFragmentDoc}
  ${KitStatusFragmentDoc}
`;
export const ProjectFragmentDoc = gql`
  fragment Project on Project {
    _id
    Admin {
      Name
      PersonId
    }
    Comment
    Description
    Owner {
      Name
      PersonId
    }
    Name
    Members {
      Name
      PersonId
    }
    ProjectNumber
    Status
  }
`;
export const BookingEdit_BookingGroupFragmentDoc = gql`
  fragment BookingEdit_BookingGroup on BookingGroup {
    _id
    hasClosedBooking
    consultantContractId
    customerContractId
    subVersionId
    isNationalProcurement
    isDiscount
    nationalProcurementTravelRequired
    travelTemplateLevel
    authorizedOrderer
    hospital {
      _id
      Name
    }
    department {
      _id
      Name
    }
    bookings {
      createdOn
      isOpen
      isCancellable
      Week
      requireTravelInvoicing
    }
    customerContract {
      _id
      parentId
      contractName
      contractType
      contractStart
      contractEnd
      isSubVersion
      isNationalProcurement
      useNationalProcurementInvoicing
      priceLists
      basicPrices {
        price
        dates
      }
    }
  }
`;
export const CostCenterFragmentDoc = gql`
  fragment CostCenter on CostCenter {
    OriginalName
    Id
    IsActive
    Name
    IsDeleted
  }
`;
export const BookingEditFragmentDoc = gql`
  fragment BookingEdit on Booking {
    _id
    AreaOfExpertise
    specializations
    ContractType
    AccommodationRequired
    TravelRequired
    Consultant {
      _id
    }
    Project {
      ...Project
    }
    ConsultantSnapshot {
      LegalPersonType
      BusinessName
      BusinessSocialSecurityNo
    }
    BookingGroup {
      ...BookingEdit_BookingGroup
    }
    CostCenter {
      ...CostCenter
    }
    isFirstWeek
    callNumber
    bookingIntro {
      required
      startDate
      endDate
      description
    }
  }
  ${ProjectFragmentDoc}
  ${BookingEdit_BookingGroupFragmentDoc}
  ${CostCenterFragmentDoc}
`;
export const SubVersionOptionFragmentDoc = gql`
  fragment SubVersionOption on CustomerContractSubVersion {
    _id
    name
    consultantId
  }
`;
export const CustomerContractOptionFragmentDoc = gql`
  fragment CustomerContractOption on CustomerContractSearchRow {
    _id
    contractName
    contractStart
    contractEnd
    subVersions {
      ...SubVersionOption
    }
  }
  ${SubVersionOptionFragmentDoc}
`;
export const BookingGroupCardFragmentDoc = gql`
  fragment BookingGroupCard on BookingGroup {
    _id
    isNationalProcurement
    consultant {
      _id
      Name
    }
    hospital {
      _id
      Name
      Address {
        Region
      }
      Parents {
        Id
        Name
        Type
      }
      AreasOfExpertise
      Specializations
      RecruitingPortalType
    }
    department {
      _id
      Name
    }
  }
`;
export const BookingWeekCardFragmentDoc = gql`
  fragment BookingWeekCard on Booking {
    _id
    AreaOfExpertise
    BookingGroup {
      externalId
      hospital {
        _id
        Address {
          Region
        }
        Parents {
          Id
          Name
          Type
        }
        AreasOfExpertise
        RecruitingPortalType
        Specializations
        Name
      }
      department {
        _id
        Name
      }
    }
    Consultant {
      _id
      Name
    }
    CustomerNumber
    Week
    callNumber
    erpExportUnitRef
  }
`;
export const AccommodationConfirmationBookingInfoFragmentDoc = gql`
  fragment AccommodationConfirmationBookingInfo on Booking {
    _id
    ...BookingWeekCard
    BookingGroup {
      _id
      bookings {
        _id
        Week
        isOpen
        IsConsultantPayed
      }
      hospital {
        _id
        Address {
          Country
        }
      }
    }
    Consultant {
      LegalPersonType
    }
  }
  ${BookingWeekCardFragmentDoc}
`;
export const AccommodationRequestBookingGroupDataFragmentDoc = gql`
  fragment AccommodationRequestBookingGroupData on BookingGroup {
    _id
    isNationalProcurement
    accommodationRequestedWeeks
    consultant {
      _id
      Name
      AccommodationPreferences
    }
    bookings {
      _id
      AreaOfExpertise
      CostCenter {
        Id
      }
      Week
    }
    hospital {
      _id
      Name
      Address {
        Region
        ZipCode
        City
        StreetName
      }
      Parents {
        Id
        Name
        Type
      }
      AreasOfExpertise
      Specializations
    }
    department {
      _id
      Name
      Address {
        ZipCode
        City
        StreetName
      }
    }
  }
`;
export const AccommodationRequest_GetLastItemFragmentDoc = gql`
  fragment AccommodationRequest_getLastItem on AccommodationRequest {
    _id
    accommodationType
    additionalInfo
    budget
    budgetPeriod
    carAccess
    hasOwnCar
    hasCarAccess
    sharedConveniences
    city
    country
    customerAddress
    paidBy
    accommodationSuggestion
    periodInput
    sharedConveniences
    shouldBeBookedDirectly
    walkingDistance
    accommodationPreferences
    zzNumber
    sharedKitchen
    sharedBathroom
    ticketDifficultyLevel
    differentCity
    specifyCity
    acceptedOveragePercent
    maxAllowedPerNight
    hasAccommodationSuggestion
    staffAccommodation
    accommodationLink
    bookingInformation
    parkingMaxPrice
    commentAboutBooking
    consultantId
    costCenterId
    projectId
    isProlongation
  }
`;
export const DDocumentFragmentDoc = gql`
  fragment DDocument on Document {
    DocumentType
    FileRef {
      MimeType
      Name
      NodeID
      NodeType
      Size
    }
    ThumbURL
    PdfURL
  }
`;
export const BookingHospitalityFragmentDoc = gql`
  fragment BookingHospitality on BookingHospitality {
    _id
    accommodation {
      accommodationRequest {
        _id
        createdById
        createdByName
        createdOn
      }
      accommodationRequested
      accommodationIsOk
      confirmations {
        _id
        accommodationRef {
          Name
          NodeID
        }
        confirmedBy {
          Name
          PersonId
        }
        confirmedOn
        deleted
        offerId
        weeks
        source
        taxationId
      }
    }
    travel {
      travelRequest {
        _id
        createdById
        createdByName
        createdOn
      }
      travelIsOk
      travelRequested
      confirmations {
        _id
        confirmedBy {
          Name
          PersonId
        }
        confirmedOn
        deleted
        documents {
          ...DDocument
        }
        weeks
      }
    }
  }
  ${DDocumentFragmentDoc}
`;
export const CrmDocumentFragmentDoc = gql`
  fragment CrmDocument on CrmDocument {
    _id
    type
    name
    documentType
    mimeType
    size
    pdfUrl
    thumbUrl
  }
`;
export const FullAccommodationRequestFragmentDoc = gql`
  fragment FullAccommodationRequest on AccommodationRequest {
    _id
    accommodationType
    additionalInfo
    budget
    budgetPeriod
    carAccess
    hasOwnCar
    hasCarAccess
    sharedConveniences
    city
    country
    customerAddress
    deadline
    paidBy
    accommodationSuggestion
    periods {
      start
      end
    }
    periodInput
    createdById
    createdByName
    createdOn
    sharedConveniences
    shouldBeBookedDirectly
    walkingDistance
    accommodationPreferences
    zzNumber
    bookingGroup
    sharedKitchen
    sharedBathroom
    ticketDifficultyLevel
    bookingConfirmationFile {
      ...CrmDocument
    }
    differentCity
    specifyCity
    acceptedOveragePercent
    maxAllowedPerNight
    hasAccommodationSuggestion
    staffAccommodation
    accommodationLink
    bookingInformation
    parkingMaxPrice
    commentAboutBooking
    consultantId
    costCenterId
    projectId
    isProlongation
    isReschedule
    rescheduleComment
  }
  ${CrmDocumentFragmentDoc}
`;
export const FullTravelRequestFragmentDoc = gql`
  fragment FullTravelRequest on TravelRequest {
    _id
    bookingGroup
    deadline
    isCancelable
    isFlexible
    ticketDifficultyLevel
    luggage
    luggageType
    createdOn
    createdByName
    createdById
    transportationType
    travelSuggestion
    travelPreferences
    consultantId
    costCenterId
    projectId
    isReschedule
    rescheduleComment
    rides {
      rideType
      transportationType
      dir1 {
        country
        city
        comment
        date
        time
      }
      dir2 {
        country
        city
        comment
        date
        time
      }
    }
  }
`;
export const TravelRequestBookingGroupDataFragmentDoc = gql`
  fragment TravelRequestBookingGroupData on BookingGroup {
    _id
    bookings {
      _id
      Week
      CostCenter {
        Id
      }
    }
    consultant {
      _id
      Name
      TravelPreferences
    }
  }
`;
export const BookingInvoicingBookingFragmentDoc = gql`
  fragment BookingInvoicingBooking on Booking {
    _id
    IsConsultantPayed
    IsCustomerBilled
    unlockForms
    additionalPayoutAmount
    additionalPayoutDescription
    bookingKits {
      type
      withConsultantInvoice
      withCustomerInvoice
      withSickPay
      withSubcontractorPay
      isRejected
    }
  }
`;
export const BookingGroupSectionFragmentDoc = gql`
  fragment BookingGroupSection on BookingGroup {
    _id
    bookings {
      _id
      Week
    }
  }
`;
export const CustomerRefFragmentDoc = gql`
  fragment CustomerRef on CustomerRef {
    Id
    Name
    Type
  }
`;
export const BookingAlertsFragmentDoc = gql`
  fragment BookingAlerts on Booking {
    _id
    Consultant {
      care
    }
    customersWithNoApproval {
      needSignature {
        ...CustomerRef
      }
      needSignatureTROkInApp {
        ...CustomerRef
      }
      noApproval {
        ...CustomerRef
      }
      noApprovalMonthly {
        ...CustomerRef
      }
      noApprovalShortening {
        ...CustomerRef
      }
      noApprovalSpecial {
        ...CustomerRef
      }
    }
    isFirstWeek
    duplicateIds
    bookingIntro {
      description
      endDate
      startDate
      required
    }
    BookingGroup {
      nationalProcurementTravelRequired
      travelTemplateLevel
    }
  }
  ${CustomerRefFragmentDoc}
`;
export const BookingFinanceEditor_GroupFragmentDoc = gql`
  fragment BookingFinanceEditor_Group on BookingGroup {
    _id
    isNationalProcurement
    bookings {
      _id
      Week
    }
  }
`;
export const InvoiceFragmentDoc = gql`
  fragment Invoice on Invoice {
    _id
    CustomerName
    CustomerNumber
    InvoiceNumber
    Provider
    TotalGross
    TotalNet
    InvoiceDate
    DueDate
    Notes
    IsCredit
    PreviewUrl
  }
`;
export const BookingFinanceEditor_ItemFragmentDoc = gql`
  fragment BookingFinanceEditor_Item on Booking {
    _id
    Project {
      _id
      ProjectNumber
      Members {
        PersonId
      }
    }
    Week
    AdditionalWork
    AdditionalWorkNote
    AreaOfExpertise
    ContractType
    BookingGroup {
      ...BookingFinanceEditor_Group
      hospital {
        _id
        Name
        billingInstructions
      }
      department {
        _id
        Name
      }
    }
    IsConsultantPayed
    IsCustomerBilled
    isSickPayed
    timeReportHasSickTime
    Note
    PatientId
    GroupInvoicing
    GroupInvoiceTotal
    CustomerFine
    AdministrativeFee
    Invoices {
      invoiceNumber
      invoice {
        TotalGross
      }
    }
    CostCenter {
      Id
      Organisation
      Name
    }
    SubcontractorDocuments {
      ...DDocument
    }
    ConsultantSnapshot {
      LegalPersonType
      BusinessName
      BusinessSocialSecurityNo
    }
    Consultant {
      _id
      SubcontractorInfo {
        Name
      }
      LegalPersonType
      BusinessName
      BusinessSocialSecurityNo
      FirstName
      LastName
      contactType {
        accountNumber
        clearingNumber
        rate
      }
    }
    Invoices {
      invoice {
        ...Invoice
      }
      invoiceNumber
    }
    costs {
      employeeSalary
      invoiceTotal
      sickPayTotal
      accommodation
      travel
    }
    unlockForms
  }
  ${BookingFinanceEditor_GroupFragmentDoc}
  ${DDocumentFragmentDoc}
  ${InvoiceFragmentDoc}
`;
export const BookingSupportTagFormDataFragmentDoc = gql`
  fragment BookingSupportTagFormData on Booking {
    _id
    bookingSupportTagStatus {
      ...BookingSupportTagStatus
    }
    bookingSupportTagComment
  }
  ${BookingSupportTagStatusFragmentDoc}
`;
export const BookingProfileFragmentDoc = gql`
  fragment BookingProfile on Booking {
    _id
    ...BookingAlerts
    ...BookingFinanceEditor_Item
    ...BookingSupportTagFormData
    ...BookingWeekCard
    bookingKits {
      _id
    }
    rejectedBookingKits {
      _id
    }
    timeReportStatus
    bookingStatus {
      status
    }
    callNumber
    BookingGroup {
      _id
      hasOpenBookings
      hospital {
        _id
      }
      bookings {
        _id
        Week
      }
      isNationalProcurement
    }
    CustomerNumber
    CustomerFine
    IsCanceled
    IsConsultantPayed
    IsCustomerBilled
    Invoices {
      invoiceNumber
    }
    Project {
      ...Project
    }
    ConsultantSnapshot {
      LegalPersonType
      BusinessName
      BusinessSocialSecurityNo
    }
    SubcontractorDocuments {
      ...DDocument
    }
    unlockForms
    createdOn
    createdBy {
      _id
      Name
    }
    updatedOn
    updatedBy {
      _id
      Name
    }
    deletedOn
    deletedBy {
      _id
      Name
    }
  }
  ${BookingAlertsFragmentDoc}
  ${BookingFinanceEditor_ItemFragmentDoc}
  ${BookingSupportTagFormDataFragmentDoc}
  ${BookingWeekCardFragmentDoc}
  ${ProjectFragmentDoc}
  ${DDocumentFragmentDoc}
`;
export const BookingTagsFragmentDoc = gql`
  fragment BookingTags on ConfigDoc {
    bookingTags {
      code
      label
      color
      booking
      bookingKit
    }
  }
`;
export const Booking_BookingKitSearchFragmentDoc = gql`
  fragment Booking_BookingKitSearch on BookingKitSearch {
    _id
    name
    type
    lastStatusType
    createdOn
    lastStatusSetOn
    lastStatusSetByUserName
  }
`;
export const BookingKitFormConfigFragmentDoc = gql`
  fragment bookingKitFormConfig on BookingKitTypeFormConfig {
    type
    isAvailableForCreation
    requirements {
      payForm
      invoiceForm
      timeReport
      sickPayForm
      hbaApproval
      ocApproval
    }
  }
`;
export const BookingKitProfileFragmentDoc = gql`
  fragment BookingKitProfile on BookingKit {
    _id
    createdOn
    timeReportType
    name
    type
    responsible {
      _id
      Name
    }
    manager {
      _id
      Name
    }
    comments
    withTimeReport
    withCustomerInvoice
    withConsultantInvoice
    withSickPay
    withSubcontractorPay
    bookingSupportCheckWasValid
    receipts {
      uri
      name
    }
    documents {
      _id
      documentType
      name
      pdfUrl
    }
    statuses {
      setBy {
        ...UserRef
      }
      setOn
      status
    }
    status
    bookingSupportTagStatus {
      ...BookingSupportTagStatus
    }
    bookingSupportTagComment
  }
  ${UserRefFragmentDoc}
  ${BookingSupportTagStatusFragmentDoc}
`;
export const BookingInfoForTimeReportFragmentDoc = gql`
  fragment bookingInfoForTimeReport on Booking {
    _id
    AreaOfExpertise
    BookingGroup {
      hospital {
        _id
        Name
      }
      department {
        _id
        Name
      }
      isNationalProcurement
    }
    Consultant {
      _id
      FirstName
      LastName
    }
    rejectedBookingKits {
      ...BookingKitProfile
    }
    hasKits
    Week
    monthBreakSide
    skipTimereportReminder
    bookingSupportTagStatus {
      ...BookingSupportTagStatus
    }
    bookingSupportTagComment
    bookingKits {
      deleted
    }
  }
  ${BookingKitProfileFragmentDoc}
  ${BookingSupportTagStatusFragmentDoc}
`;
export const BookingAuditSearch_RecordFragmentDoc = gql`
  fragment BookingAuditSearch_Record on BookingAudit {
    Approved
    SetBy {
      Name
      PersonId
    }
    SetOn
    Comment
  }
`;
export const BookingAuditSearchItemFragmentDoc = gql`
  fragment BookingAuditSearchItem on BookingWeekListItem {
    _id
    AreaOfExpertise
    BookingAudit {
      ...BookingAuditSearch_Record
    }
    BookingRef {
      NodeID
    }
    ConsultantRef {
      Name
      NodeID
    }
    DepartmentsRefs {
      Id
      Name
      Type
    }
    HospitalRef {
      Id
      Name
      Type
    }
    OrganizationRef {
      Name
    }
    ProjectId
    projectName
    projectNumber
    Week
    isNationalProcurement
  }
  ${BookingAuditSearch_RecordFragmentDoc}
`;
export const BookingFinanceSearchItemFragmentDoc = gql`
  fragment BookingFinanceSearchItem on BookingWeekListItem {
    _id
    AreaOfExpertise
    BookingRef {
      NodeID
    }
    ConsultantRef {
      Name
      NodeID
    }
    ConsultantServicePreferences
    DepartmentsRefs {
      Id
      Name
      Type
    }
    HospitalRef {
      Id
      Name
      Type
    }
    OrganizationRef {
      Name
    }
    Week
    CustomerNumber
    ContractType
    ContractTypeAbbr
    CostCenterId
    CostCenterName
    IsCanceled
    IsConsultantPayed
    IsCustomerBilled
    IsMarked
    InvoiceNumbers
    ProjectId
    projectName
    projectNumber
    callNumber
    InvoiceTotalGrossFmt
    InvoicedTotalFmt
    ProfitRatio
    ProfitNetFmt
    isNationalProcurement
    bookingStatus {
      status
    }
  }
`;
export const BookingScheduleSearchItemFragmentDoc = gql`
  fragment BookingScheduleSearchItem on BookingWeekListItem {
    _id
    AreaOfExpertise
    BookingRef {
      NodeID
    }
    ConsultantRef {
      Name
      NodeID
    }
    DepartmentsRefs {
      Id
      Name
      Type
    }
    HospitalRef {
      Id
      Name
      Type
    }
    OrganizationRef {
      Name
    }
    Week
    ContractType
    ContractTypeAbbr
    AccommodationOK
    TravelOK
    TimeReportStatus
    ProjectId
    projectName
    projectNumber
    callNumber
    AccommodationStatus
    AccommodationAudit {
      approved
      setBy {
        Name
        PersonId
      }
      setOn
    }
    TravelStatus
    TravelAudit {
      approved
      setBy {
        Name
        PersonId
      }
      setOn
    }
    consultantContractId
    customerContractId
    requireTravelInvoicing
    isTravelInvoiced
    demandSource
    demandSourceUrl
    timeReportRowSources
  }
`;
export const BookingSyncReportItemFragmentDoc = gql`
  fragment BookingSyncReportItem on BookingSyncReportItem {
    UserRef {
      PersonId
      Name
    }
    ProjectName
    Score
  }
`;
export const BookingSyncReportFragmentDoc = gql`
  fragment BookingSyncReport on BookingSyncReport {
    Items {
      ...BookingSyncReportItem
    }
    Groups {
      UserRef {
        PersonId
        Name
      }
      Total
    }
    Total
  }
  ${BookingSyncReportItemFragmentDoc}
`;
export const SubcontractorInvoiceFragmentDoc = gql`
  fragment SubcontractorInvoice on SubcontractorInvoice {
    Balance
    Total
    Booked
    Credit
    CostCenter
    Currency
    FinalPayDate
    GivenNumber
    InvoiceDate
    InvoiceNumber
    DueDate
  }
`;
export const ItemCard_ValidationErrorFragmentDoc = gql`
  fragment ItemCard_ValidationError on NodeValidationError {
    Message
    Params
    Type
  }
`;
export const ContractsPriceRecordFragmentDoc = gql`
  fragment contractsPriceRecord on ContractsPriceRecord {
    _id
    articleNumber
    articleNumberForOtherSpeciality
    indexInWorkType
    startDay
    endDay
    paidPer
    currency
    workType
    from
    to
    period
    priceMultiplier
    fixedPrice
    customPrice
    deleted
    isSecondPass
  }
`;
export const HighHolidayOptionFragmentDoc = gql`
  fragment HighHolidayOption on HighHolidayOption {
    name
    listPosition
    _id
  }
`;
export const HighHolidayFragmentDoc = gql`
  fragment HighHoliday on HighHoliday {
    _id
    option {
      ...HighHolidayOption
    }
    isGreatHoliday
  }
  ${HighHolidayOptionFragmentDoc}
`;
export const ContractsPriceTemplateFragmentDoc = gql`
  fragment contractsPriceTemplate on ContractsPriceTemplate {
    _id
    name
    type
    private
    createdByName
    createdDate
    updatedByName
    updatedDate
    records {
      ...contractsPriceRecord
    }
    highHolidays {
      ...HighHoliday
    }
  }
  ${ContractsPriceRecordFragmentDoc}
  ${HighHolidayFragmentDoc}
`;
export const CostCenterConfigItemFragmentDoc = gql`
  fragment costCenterConfigItem on CostCenterConfigItem {
    _id
    tenant
    costCenterId
    name
    organisation
    isActive
    isDeleted
  }
`;
export const TgRequirementFragmentDoc = gql`
  fragment tgRequirement on TgRequirement {
    _id
    tenant
    costCenterId
    profession
    minRequiredTG
    validFrom
    validTo
    createdOn
    createdByName
    updatedOn
    updatedByName
    deleted
  }
`;
export const FinaliseOpportunityDataFragmentDoc = gql`
  fragment FinaliseOpportunityData on ConsultantOpportunity {
    _id
    dueDate
    customer {
      _id
      Name
    }
    consultant {
      _id
      Name
    }
    weeks
  }
`;
export const ConsultantOpportunityCardFragmentDoc = gql`
  fragment ConsultantOpportunityCard on ConsultantOpportunityCard {
    _id
    title
    assignee {
      _id
      Name
    }
    dueDate
    consultantOpportunity {
      _id
      createdAt
      consultant {
        _id
        AreasOfExpertise
        Availability {
          availableWeeksString
        }
        Name
        tags
      }
      customer {
        _id
        Name
        Type
      }
      costCenter {
        Id
        Name
      }
      dueDate
      areaOfExpertise
      weeks
      weeksString
      weeksLost
      weeksLostString
      weeksWon
      weeksWonString
      description
      isShared
      originalIssue {
        _id
      }
      users {
        _id
        Name
      }
    }
  }
`;
export const ConsultantOpportunityStatsDataFragmentDoc = gql`
  fragment ConsultantOpportunityStatsData on ConsultantOpportunityStats {
    presentedWeeks
    openWeeks
    wonWeeks
    lostWeeks
  }
`;
export const QualityApprovalTooltipDataFragmentDoc = gql`
  fragment QualityApprovalTooltipData on QualityApproval {
    Country
    Approved
    Profession
    approvalExpiresOn
    baseItems {
      name
      approved
      approvalExpiresOn
      partiallyExpiresOn
    }
    oneOfItems {
      name
      approved
      approvalExpiresOn
      partiallyExpiresOn
    }
  }
`;
export const ConsultantPipelineCardFragmentDoc = gql`
  fragment ConsultantPipelineCard on ConsultantPipelineCard {
    _id
    boardId
    assignee {
      _id
      Name
    }
    description
    dueDate
    order
    title
    columnId
    consultant {
      _id
      AreasOfExpertise
      Availability {
        availableWeeksString
      }
      tags
      qualityApprovals {
        ...QualityApprovalTooltipData
      }
      isQualityApproved
      isQualityExpired
      Professions
      nationalQualification
      nationalQualityApprovals {
        ...QualityApprovalTooltipData
      }
      nextContactDate {
        date
        reason
      }
      generalInterest {
        regions
      }
    }
  }
  ${QualityApprovalTooltipDataFragmentDoc}
`;
export const UntagConsultantDataFragmentDoc = gql`
  fragment UntagConsultantData on Consultant {
    _id
    Name
    leadStatus {
      status
    }
  }
`;
export const DefaultKanbanBoardFragmentDoc = gql`
  fragment DefaultKanbanBoard on KanbanBoard {
    _id
    type
    name
    columns {
      _id
      name
      order
    }
  }
`;
export const ContactPerson_ContactInfoFragmentDoc = gql`
  fragment ContactPerson_ContactInfo on Customer {
    ContactPersons {
      _id
      Name
      Email
      Phone
      Title
    }
  }
`;
export const ConsultantBookingContractCustomerFragmentDoc = gql`
  fragment ConsultantBookingContractCustomer on Customer {
    _id
    Name
    Address {
      StreetName
      City
      ZipCode
      Country
    }
    ...ContactPerson_ContactInfo
  }
  ${ContactPerson_ContactInfoFragmentDoc}
`;
export const ConsultantBookingContractListItem_FragmentFragmentDoc = gql`
  fragment ConsultantBookingContractListItem_Fragment on ConsultantBookingContractListItem {
    _id
    CustomerCity
    CustomerName
    Dates
    FileUrl
    IsSigned
    Type
    ViewUrl
    Attachment {
      ...DDocument
    }
    ContactPerson {
      Name
      Email
    }
    Recipients
    IsNullified
  }
  ${DDocumentFragmentDoc}
`;
export const ContractBookingAddressFragmentDoc = gql`
  fragment ContractBookingAddress on ConsultantBookingContract {
    Address {
      StreetName
      City
      ZipCode
      Country
    }
  }
`;
export const SalaryBookingContractFragmentDoc = gql`
  fragment SalaryBookingContract on ConsultantBookingContract {
    BasicPrice
    Bonus {
      _id
      Type
      SalaryType
      Amount
      Currency
      Config
    }
    IntroductionPrice {
      Currency
      Sum
      Description
    }
    SalaryRecords {
      _id
      articleNumber
      indexInWorkType
      deleted
      startDay
      endDay
      paidPer
      currency
      workType
      from
      to
      period
      priceMultiplier
      fixedPrice
      customPrice
    }
    highHolidays {
      ...HighHoliday
    }
  }
  ${HighHolidayFragmentDoc}
`;
export const BookingContractDataForDuplicationFragmentDoc = gql`
  fragment BookingContractDataForDuplication on ConsultantBookingContract {
    _id
    ConsultantId
    ResponsiblePersonId
    ContractPriceTemplateId
    hideDeptName
    hideHospitalName
    Type
    ...ContractBookingAddress
    DepartmentsRefs {
      Id
      Name
    }
    HospitalRef {
      Id
      Name
    }
    ContactPerson {
      Name
      Phone
      Email
      Title
    }
    OtherInfo
    AreaOfExpertise
    Price
    Schedule
    Recipients
    ...SalaryBookingContract
    SpecificRequirements
    Profession
    PriceRecruitment {
      Currency
      R_0_159
      R_160_499
      R_500_699
      R_700_899
      R_900_1200
    }
    SpecificPeriodPrices {
      _id
      startDate
      endDate
      title
      price
    }
    Bonus {
      _id
      Type
      SalaryType
      Amount
      Currency
      Config
    }
    sithsCardNumber
  }
  ${ContractBookingAddressFragmentDoc}
  ${SalaryBookingContractFragmentDoc}
`;
export const ConsultantCardFragmentDoc = gql`
  fragment ConsultantCard on Consultant {
    _id
    Address {
      City
    }
    contactType {
      employeeSalaryClaim
      subcontractorSalaryClaim
    }
    AreasOfExpertise
    AvatarPic
    CellPhone
    Email
    secondaryEmail
    LastContactDate
    Name
    Phone
    Unfit
    ResponsiblePerson {
      PersonId
      Name
    }
    SocialSecurityNo
    Specializations
    IsValid
    ValidationErrors {
      Message
      Params
      Type
    }
    Professions
    PrescriptionCode
    isQualityApproved
    isQualityExpired
    expertise {
      machines
      systems
    }
  }
`;
export const ConsultantSearchCardFragmentDoc = gql`
  fragment ConsultantSearchCard on Consultant {
    ...ConsultantCard
    Availability {
      ranges {
        from
        to
      }
    }
  }
  ${ConsultantCardFragmentDoc}
`;
export const ConsultantAreasOfExpertiseFragmentDoc = gql`
  fragment ConsultantAreasOfExpertise on Consultant {
    _id
    AreasOfExpertise
    Professions
    Specializations
    Name
  }
`;
export const ConsultantContractEditorConsultantDataFragmentDoc = gql`
  fragment ConsultantContractEditorConsultantData on Consultant {
    ...ConsultantAreasOfExpertise
    AvailableForWorkInCountries
    BirthDate
    ResponsiblePerson {
      PersonId
    }
    LegalPersonType
    sithsCardNumber
    contactType {
      employeeContractType
    }
  }
  ${ConsultantAreasOfExpertiseFragmentDoc}
`;
export const ConsultantContractCustomerDataFragmentDoc = gql`
  fragment ConsultantContractCustomerData on Customer {
    _id
    Parents {
      Id
      Name
    }
    RegionRef {
      Id
      Name
    }
    Address {
      StreetName
      City
      ZipCode
      Country
      Region
    }
  }
`;
export const CompensationFragmentDoc = gql`
  fragment Compensation on ConsultantContract {
    Compensation {
      Price
      Type
    }
  }
`;
export const ContractAddressFragmentDoc = gql`
  fragment ContractAddress on ConsultantContract {
    Address {
      StreetName
      City
      ZipCode
      Country
    }
  }
`;
export const SalaryFragmentDoc = gql`
  fragment Salary on ConsultantContract {
    BasicPrice
    Bonus {
      _id
      Type
      SalaryType
      Amount
      Currency
      Config
    }
    IntroductionPrice {
      Currency
      Sum
      Description
    }
    SalaryRecords {
      _id
      articleNumber
      indexInWorkType
      deleted
      startDay
      endDay
      paidPer
      currency
      workType
      from
      to
      period
      priceMultiplier
      fixedPrice
      customPrice
    }
    highHolidays {
      ...HighHoliday
    }
  }
  ${HighHolidayFragmentDoc}
`;
export const AccommodationTravelsAltFragmentDoc = gql`
  fragment AccommodationTravelsAlt on ConsultantContract {
    Accommodation {
      Type
      MaxCost {
        Currency
        Period
        Price
        SalaryType
      }
      PossibleSupplement
    }
    Travels {
      Type
      MaxCost {
        Currency
        Period
        Price
        SalaryType
      }
      PossibleSupplement
      TravelTemplateValue
    }
  }
`;
export const ContractDataForDuplicationFragmentDoc = gql`
  fragment ContractDataForDuplication on ConsultantContract {
    _id
    pensionModel
    ConsultantId
    Type
    ParentContractId
    ContractPriceTemplateId
    CustomerName
    FileName
    Dates
    ExcludeAddress
    showOrgName
    hideDeptName
    ...ContractAddress
    HospitalRef {
      Id
      Name
    }
    DepartmentsRefs {
      Id
    }
    PatientVisits
    InvestigationsNumber
    IsRegionDalarna
    ConsultantGetsPaidPer
    Profession
    Country
    Schedule
    Specializations
    DriverLicense
    Education {
      Show
      Text
    }
    OtherRequirements
    YoEx
    AreaOfExpertise
    Language
    SpecificRequirements
    Currency
    ...Salary
    NotRelevantMonthlyWeeklyPayouts
    Overtime
    ...AccommodationTravelsAlt
    DateFrameworkContractTypeIsSigned
    isNationalProcurementPriceStrategy
  }
  ${ContractAddressFragmentDoc}
  ${SalaryFragmentDoc}
  ${AccommodationTravelsAltFragmentDoc}
`;
export const ContractDatesFragmentDoc = gql`
  fragment ContractDates on ConsultantContract {
    StartDate
    EndDate
    Period
    pensionSolution
  }
`;
export const ConsultantContractDetailsFragmentDoc = gql`
  fragment ConsultantContractDetails on ConsultantContract {
    ...ContractDataForDuplication
    ...ContractDates
    SalaryChoice
    SignedOn
    PayoutType
    SpecificPeriodPrices {
      _id
      startDate
      endDate
      title
      price
    }
  }
  ${ContractDataForDuplicationFragmentDoc}
  ${ContractDatesFragmentDoc}
`;
export const ConsultantQualityCheckDataFragmentDoc = gql`
  fragment ConsultantQualityCheckData on ConsultantQualityItem {
    _id
    AvailableStatuses {
      IsDocumentRequired
      Name
    }
    Country
    templateName
    Disabled
    DisabledMsg
    DocumentType
    Name
    Status {
      Name
      Comment
    }
    StatusSetBy {
      Name
      PersonId
    }
    StatusSetOn
    ExpiresOn
    HasExpired
    ExpiresSoon
  }
`;
export const ConsultantQualityItemEditor_AvailableStatusFragmentDoc = gql`
  fragment ConsultantQualityItemEditor_AvailableStatus on ConsultantQualityItemAvailableStatus {
    IsDocumentRequired
    WithDocument
    IsCommentRequired
    WithComment
    Name
    Disabled
    DisabledMsg
  }
`;
export const PausedStateFragmentDoc = gql`
  fragment PausedState on PausedState {
    isPaused
    wasPaused
    pausedOn
    pausedUntil
  }
`;
export const ApprovedQualityStatusFragmentDoc = gql`
  fragment ApprovedQualityStatus on ApprovedQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
    ExpiresInMonths
    ExpiresOn
    params
    pausedState {
      ...PausedState
    }
  }
  ${PausedStateFragmentDoc}
`;
export const ApprovedWithCommentQualityStatusFragmentDoc = gql`
  fragment ApprovedWithCommentQualityStatus on ApprovedWithCommentQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
    ExpiresInMonths
    ExpiresOn
    params
  }
`;
export const AnsweredQualityStatusFragmentDoc = gql`
  fragment AnsweredQualityStatus on AnsweredQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
  }
`;
export const NotApprovedQualityStatusFragmentDoc = gql`
  fragment NotApprovedQualityStatus on NotApprovedQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
  }
`;
export const AwaitingApprovalQualityStatusFragmentDoc = gql`
  fragment AwaitingApprovalQualityStatus on AwaitingApprovalQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
  }
`;
export const RequestSentQualityStatusFragmentDoc = gql`
  fragment RequestSentQualityStatus on RequestSentQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
    params
  }
`;
export const RequestReceivedNotProcessedQualityStatusFragmentDoc = gql`
  fragment RequestReceivedNotProcessedQualityStatus on RequestReceivedNotProcessedQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
    params
  }
`;
export const BookedQualityStatusFragmentDoc = gql`
  fragment BookedQualityStatus on BookedQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
  }
`;
export const OrderedQualityStatusFragmentDoc = gql`
  fragment OrderedQualityStatus on OrderedQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
  }
`;
export const ConsultantResponsibleQualityStatusFragmentDoc = gql`
  fragment ConsultantResponsibleQualityStatus on ConsultantResponsibleQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
  }
`;
export const SigningPeriodExpiredQualityStatusFragmentDoc = gql`
  fragment SigningPeriodExpiredQualityStatus on SigningPeriodExpiredQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
    ExpiresOn
  }
`;
export const PausedQualityStatusFragmentDoc = gql`
  fragment PausedQualityStatus on PausedQualityStatus {
    Name
    Comment
    SetBy {
      Name
      PersonId
    }
    SetOn
    ExpiresOn
    params
    pausedState {
      ...PausedState
    }
  }
  ${PausedStateFragmentDoc}
`;
export const ConsultantQualityItemEditorFragmentDoc = gql`
  fragment ConsultantQualityItemEditor on ConsultantQualityItem {
    _id
    Country
    templateName
    DocumentType
    HasDocument
    HasExpired
    StatusSetOn
    Disabled
    Name
    AvailableStatuses {
      ...ConsultantQualityItemEditor_AvailableStatus
    }
    Status {
      ...ApprovedQualityStatus
      ...ApprovedWithCommentQualityStatus
      ...AnsweredQualityStatus
      ...NotApprovedQualityStatus
      ...AwaitingApprovalQualityStatus
      ...RequestSentQualityStatus
      ...RequestReceivedNotProcessedQualityStatus
      ...BookedQualityStatus
      ...OrderedQualityStatus
      ...ConsultantResponsibleQualityStatus
      ...SigningPeriodExpiredQualityStatus
      ...PausedQualityStatus
    }
  }
  ${ConsultantQualityItemEditor_AvailableStatusFragmentDoc}
  ${ApprovedQualityStatusFragmentDoc}
  ${ApprovedWithCommentQualityStatusFragmentDoc}
  ${AnsweredQualityStatusFragmentDoc}
  ${NotApprovedQualityStatusFragmentDoc}
  ${AwaitingApprovalQualityStatusFragmentDoc}
  ${RequestSentQualityStatusFragmentDoc}
  ${RequestReceivedNotProcessedQualityStatusFragmentDoc}
  ${BookedQualityStatusFragmentDoc}
  ${OrderedQualityStatusFragmentDoc}
  ${ConsultantResponsibleQualityStatusFragmentDoc}
  ${SigningPeriodExpiredQualityStatusFragmentDoc}
  ${PausedQualityStatusFragmentDoc}
`;
export const ConsultantQualityCheckConsultantDataFragmentDoc = gql`
  fragment ConsultantQualityCheckConsultantData on Consultant {
    _id
    SocialSecurityNo
    ResponsiblePerson {
      PersonId
      Name
    }
    EmailValid
    PhoneValid
    CellPhoneValid
    Name
    AreasOfExpertise
  }
`;
export const ConsultantQuality_ConsultantFragmentDoc = gql`
  fragment ConsultantQuality_Consultant on Consultant {
    _id
    AvailableForWorkInCountries
    Name
    SocialSecurityNo
    ResponsiblePerson {
      PersonId
    }
    QualityPerCountry {
      Country
      QualityChecks {
        ...ConsultantQualityCheckData
        ...ConsultantQualityItemEditor
      }
    }
    Unfit
    UnfitComment
    UnfitedBy {
      Name
      PersonId
    }
    ...ConsultantQualityCheckConsultantData
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
  ${ConsultantQualityCheckConsultantDataFragmentDoc}
`;
export const ConsultantAvailabilityForm_AvailabilityFragmentDoc = gql`
  fragment ConsultantAvailabilityForm_Availability on ConsultantAvailability {
    ranges {
      from
      to
    }
    weeks
  }
`;
export const DocumentList_ItemFragmentDoc = gql`
  fragment DocumentList_Item on Document {
    DocumentType
    FileRef {
      MimeType
      Name
      NodeID
      NodeType
      Size
    }
    ThumbURL
    PdfURL
  }
`;
export const NodeRefFragmentDoc = gql`
  fragment NodeRef on NodeRef {
    Name
    NodeID
    NodeType
  }
`;
export const GDPRConsentRecordsFragmentDoc = gql`
  fragment GDPRConsentRecords on GDPRConsent {
    type
    granted
    grantedBy {
      ...NodeRef
    }
    dateGranted
    dateRevoked
    revokedBy {
      ...NodeRef
    }
    communicationChannel
  }
  ${NodeRefFragmentDoc}
`;
export const UserSettingsFragmentDoc = gql`
  fragment UserSettings on UserSettings {
    Enabled
  }
`;
export const ConsultantGeneralInterestFragmentDoc = gql`
  fragment ConsultantGeneralInterest on ConsultantGeneralInterest {
    __typename
    regions
    workshifts
    comment
  }
`;
export const ConsultantGeneralInterestDataFragmentDoc = gql`
  fragment ConsultantGeneralInterestData on Consultant {
    _id
    AvailableForWorkInCountries
    generalInterest {
      ...ConsultantGeneralInterest
    }
  }
  ${ConsultantGeneralInterestFragmentDoc}
`;
export const ConsultantProfile_ConsultantFragmentDoc = gql`
  fragment ConsultantProfile_Consultant on Consultant {
    ...ConsultantCard
    ...ConsultantQuality_Consultant
    Availability {
      ...ConsultantAvailabilityForm_Availability
    }
    Documents {
      ...DocumentList_Item
    }
    LegalBasis
    ContractSigned
    canCreateContractCheck
    LegalPersonType
    GDPRConsentRecords {
      ...GDPRConsentRecords
    }
    UserSettings {
      ...UserSettings
    }
    Professions
    AvailableForWorkInCountries
    DocumentTypes
    Intro
    Teams
    SocialSecurityNo
    Name
    consultantId: _id
    welcomeEmail
    welcomeEmailSetOn
    welcomeEmailSetBy
    bookingStatus
    ...ConsultantGeneralInterestData
  }
  ${ConsultantCardFragmentDoc}
  ${ConsultantQuality_ConsultantFragmentDoc}
  ${ConsultantAvailabilityForm_AvailabilityFragmentDoc}
  ${DocumentList_ItemFragmentDoc}
  ${GDPRConsentRecordsFragmentDoc}
  ${UserSettingsFragmentDoc}
  ${ConsultantGeneralInterestDataFragmentDoc}
`;
export const GenericProfessionFragmentDoc = gql`
  fragment GenericProfession on GenericProfession {
    professionName
    systems
    certifiedFrom
    specializations {
      name
      yearFrom
      qualified
      interested
      comment
    }
  }
`;
export const DoctorProfessionFragmentDoc = gql`
  fragment DoctorProfession on DoctorProfession {
    professionName
    systems
    certifiedFrom
    code
    areasOfExpertise {
      name
      qualified
      interested
      comment
      yearFrom
      open
      specializations {
        name
        qualified
        interested
        comment
      }
    }
  }
`;
export const NurseProfessionFragmentDoc = gql`
  fragment NurseProfession on NurseProfession {
    professionName
    systems
    certifiedFrom
    code
    areasOfExpertise {
      name
      qualified
      yearFrom
      interested
      comment
    }
    specializations {
      name
      yearFrom
      qualified
      interested
      comment
    }
  }
`;
export const RadioNurseProfessionFragmentDoc = gql`
  fragment RadioNurseProfession on RadioNurseProfession {
    professionName
    systems
    machines
    certifiedFrom
    specializations {
      name
      yearFrom
      interested
      qualified
      comment
    }
  }
`;
export const TeacherProfessionFragmentDoc = gql`
  fragment TeacherProfession on TeacherProfession {
    professionName
    systems
    certifiedFrom
    areasOfExpertise {
      name
      certifiedFrom
      selected
      specializations {
        name
        qualified
        interestedIn
        experience
      }
    }
    digitalCompetence
    schoolPlatforms
  }
`;
export const SocionomProfessionFragmentDoc = gql`
  fragment SocionomProfession on SocionomProfession {
    professionName
    systems
    educations
    certifiedFrom
    areasOfExpertise {
      name
      qualified
      interested
      comment
      yearFrom
      open
      specializations {
        name
        qualified
        interested
        comment
      }
    }
  }
`;
export const PsykologProfessionFragmentDoc = gql`
  fragment PsykologProfession on PsykologProfession {
    professionName
    systems
    methods
    certifiedFrom
    specializations {
      name
      yearFrom
      qualified
      interested
      comment
    }
  }
`;
export const ConsultantFormProfessionFragmentDoc = gql`
  fragment ConsultantFormProfession on ConsultantProfession {
    __typename
    ... on GenericProfession {
      ...GenericProfession
    }
    ... on DoctorProfession {
      ...DoctorProfession
    }
    ... on NurseProfession {
      ...NurseProfession
    }
    ... on RadioNurseProfession {
      ...RadioNurseProfession
    }
    ... on TeacherProfession {
      ...TeacherProfession
    }
    ... on SocionomProfession {
      ...SocionomProfession
    }
    ... on PsykologProfession {
      ...PsykologProfession
    }
  }
  ${GenericProfessionFragmentDoc}
  ${DoctorProfessionFragmentDoc}
  ${NurseProfessionFragmentDoc}
  ${RadioNurseProfessionFragmentDoc}
  ${TeacherProfessionFragmentDoc}
  ${SocionomProfessionFragmentDoc}
  ${PsykologProfessionFragmentDoc}
`;
export const ConsultantForm_ExpertiseFragmentDoc = gql`
  fragment ConsultantForm_Expertise on ConsultantExpertise {
    professions {
      ...ConsultantFormProfession
    }
  }
  ${ConsultantFormProfessionFragmentDoc}
`;
export const ConsultantEditorConsultantDataFragmentDoc = gql`
  fragment ConsultantEditorConsultantData on Consultant {
    _id
    ResponsiblePerson {
      Name
      PersonId
    }
    expertise {
      ...ConsultantForm_Expertise
    }
  }
  ${ConsultantForm_ExpertiseFragmentDoc}
`;
export const AddressSectionFragmentDoc = gql`
  fragment AddressSection on BaseFormAddress {
    city
    country
    streetName
    zipCode
  }
`;
export const ConsultantForm_CompetitorsFragmentDoc = gql`
  fragment ConsultantForm_Competitors on ConsultantCompetitorsSection {
    items
  }
`;
export const ConsultantForm_ContactsFragmentDoc = gql`
  fragment ConsultantForm_Contacts on ConsultantContactsSection {
    cellPhone
    email
    secondaryEmail
    initialContact
    selfRegisterOption
    phone
    preferredCommunication
    recommendedByConsultant {
      label
      value
    }
  }
`;
export const ConsultantForm_ContactTypeFragmentDoc = gql`
  fragment ConsultantForm_ContactType on ConsultantContactTypeSection {
    businessAddress {
      city
      country
      streetName
      zipCode
    }
    clearingNumber
    accountNumber
    companyName
    ssn
    type
    externalTaxNumber
    employeeSalaryClaim
    subcontractorSalaryClaim
    receiveWorkBreakdownByEmail
    emailForSelfInvoicing
    FTaxChecked
    VATChecked
    rate
    increasedRate
    startDate
    endDate
    employeeContractType
  }
`;
export const ConsultantForm_EducationFragmentDoc = gql`
  fragment ConsultantForm_Education on ConsultantEducationSection {
    items {
      courseLocation
      courseName
      isCourse
      fromYear
      fromMonth
      toYear
      toMonth
      educationType
    }
  }
`;
export const ConsultantForm_EmergencyContactsFragmentDoc = gql`
  fragment ConsultantForm_EmergencyContacts on ConsultantEmergencyContactsSection {
    items {
      name
      phone
      relation
    }
  }
`;
export const ConsultantForm_LanguageSkillsFragmentDoc = gql`
  fragment ConsultantForm_LanguageSkills on ConsultantLanguageSkillsSection {
    items {
      level
      name
    }
  }
`;
export const ConsultantForm_PersonalFragmentDoc = gql`
  fragment ConsultantForm_Personal on ConsultantPersonalSection {
    intro
    about
    countries
    norwayConsultantStatus
    firstComment
    firstName
    hasDrivingLicence
    drivingLicenceType
    important
    lastName
    norwegianSsn
    commentAuthorization
    isWorkedNorway
    isApprovedAuthorization
    hprNumber
    ssn
    travelPreferences
    accommodationPreferences
    care
  }
`;
export const ConsultantForm_PrescriptionCodeFragmentDoc = gql`
  fragment ConsultantForm_PrescriptionCode on ConsultantPrescriptionCodeSection {
    code
  }
`;
export const ConsultantForm_WorkExperienceFragmentDoc = gql`
  fragment ConsultantForm_WorkExperience on ConsultantWorkExperienceSection {
    items {
      areaOfExpertise
      roles
      fromYear
      fromMonth
      toYear
      toMonth
      workType
      workPlace
      customerRef {
        Id
        Name
        Type
      }
      departmentIds
      competitors
      employmentType
      experience
      excludeFromPresentation
    }
  }
`;
export const GDPRConsentFragmentDoc = gql`
  fragment GDPRConsent on GDPRConsent {
    type
    granted
    communicationChannel
  }
`;
export const ConsultantEditor_FormFragmentDoc = gql`
  fragment ConsultantEditor_Form on ConsultantForm {
    consultantId
    isNew
    status
    knownSystems
    extraCurriculum
    address {
      ...AddressSection
    }
    competitors {
      ...ConsultantForm_Competitors
    }
    contacts {
      ...ConsultantForm_Contacts
    }
    contactType {
      ...ConsultantForm_ContactType
    }
    education {
      ...ConsultantForm_Education
    }
    emergencyContacts {
      ...ConsultantForm_EmergencyContacts
    }
    employeeNumber {
      employeeNumber
      employeeNumber2
      employeeNumber3
    }
    languageSkills {
      ...ConsultantForm_LanguageSkills
    }
    personal {
      ...ConsultantForm_Personal
    }
    prescriptionCode {
      ...ConsultantForm_PrescriptionCode
    }
    workExperience {
      ...ConsultantForm_WorkExperience
    }
    GDPRConsentRecords {
      ...GDPRConsent
    }
  }
  ${AddressSectionFragmentDoc}
  ${ConsultantForm_CompetitorsFragmentDoc}
  ${ConsultantForm_ContactsFragmentDoc}
  ${ConsultantForm_ContactTypeFragmentDoc}
  ${ConsultantForm_EducationFragmentDoc}
  ${ConsultantForm_EmergencyContactsFragmentDoc}
  ${ConsultantForm_LanguageSkillsFragmentDoc}
  ${ConsultantForm_PersonalFragmentDoc}
  ${ConsultantForm_PrescriptionCodeFragmentDoc}
  ${ConsultantForm_WorkExperienceFragmentDoc}
  ${GDPRConsentFragmentDoc}
`;
export const AttachmentDataFragmentDoc = gql`
  fragment AttachmentData on FileRef {
    NodeID
    Name
    Size
  }
`;
export const ConsultantAvailabilityFormDataFragmentDoc = gql`
  fragment ConsultantAvailabilityFormData on ConsultantAvailability {
    weeks
  }
`;
export const ConsultantWorkplaceFragmentDoc = gql`
  fragment ConsultantWorkplace on ConsultantUpcomingWorkplace {
    bookingId
    department {
      Id
      Name
      Type
    }
    organisation {
      Id
      Name
      Type
    }
    workplace {
      Id
      Name
      Type
    }
    week {
      Week
      Year
    }
  }
`;
export const CallListDataFragmentDoc = gql`
  fragment CallListData on CallList {
    _id
    __typename
    deleted
    name
    type
    nodes {
      Name
      NodeID
      NodeType
    }
    members {
      PersonId
      Name
    }
  }
`;
export const CallContactListDataFragmentDoc = gql`
  fragment CallContactListData on Me {
    _id
    __typename
    CallLists {
      ...CallListData
    }
    ContactLists {
      ...CallListData
    }
  }
  ${CallListDataFragmentDoc}
`;
export const ConsultantCallListDataFragmentDoc = gql`
  fragment ConsultantCallListData on Consultant {
    _id
    __typename
    Name
    Unfit
  }
`;
export const ConsultantTagsDataFragmentDoc = gql`
  fragment ConsultantTagsData on Consultant {
    __typename
    _id
    tags
  }
`;
export const ConsultantContractTableRowDataFragmentDoc = gql`
  fragment ConsultantContractTableRowData on ConsultantContractListItem {
    _id
    CustomerCity
    CustomerName
    ParentContractId
    Dates
    FileUrl
    Attachment {
      ...DDocument
    }
    Profession
    Period
    IsSigned
    NotRelevantMonthlyWeeklyPayouts
    IsNullified
    NullificationReason
    Type
    SalaryChoiceAbbr
    ViewUrl
    StartDate
    EndDate
    PayoutsAbbr
    SalaryChoice
    Consultant {
      _id
      LegalPersonType
      BirthDate
    }
    PublishedUrl
    ChildContracts {
      _id
      CustomerCity
      CustomerName
      ParentContractId
      Dates
      FileUrl
      Attachment {
        ...DDocument
      }
      Period
      IsSigned
      NotRelevantMonthlyWeeklyPayouts
      IsNullified
      Type
      ViewUrl
      PublishedUrl
      Consultant {
        _id
        LegalPersonType
        BirthDate
      }
      canEdit
      canNullify
      canPublishToOneflowDirectly
      pensionSolution
    }
    editsProof {
      editBy {
        PersonId
        Name
      }
      editOn
      fileRefs {
        Name
        NodeID
      }
    }
    canEdit
    canDuplicate
    canNullify
    canPublishToOneflowDirectly
    canDownload
    canPreview
    pensionSolution
  }
  ${DDocumentFragmentDoc}
`;
export const ConsultantContractsPersonalDataFragmentDoc = gql`
  fragment ConsultantContractsPersonalData on Consultant {
    Email
    Name
    LegalPersonType
    canCreateContractCheck
    canCreateSelfInvoicingContractCheck
  }
`;
export const ConsultantBookingContractListItemDataFragmentDoc = gql`
  fragment ConsultantBookingContractListItemData on ConsultantBookingContractListItem {
    _id
    __typename
    CustomerCity
    CustomerName
    Dates
    FileUrl
    IsSigned
    Type
    ViewUrl
    Attachment {
      ...DDocument
    }
    ContactPerson {
      Name
      Email
    }
    Recipients
    IsNullified
    PublishedUrl
    canEdit
    canDuplicate
    canDownload
    canPreview
  }
  ${DDocumentFragmentDoc}
`;
export const ConsultantShareableFilesNewFragmentDoc = gql`
  fragment ConsultantShareableFilesNew on Consultant {
    _id
    DocumentsShareable {
      DocumentType
      FileRef {
        NodeID
        Name
      }
      PreviewURL
    }
  }
`;
export const ConsultantCreatePresentationDataFragmentDoc = gql`
  fragment ConsultantCreatePresentationData on Consultant {
    _id
    __typename
    ResponsiblePerson {
      __typename
      Name
      PersonId
    }
    Intro
    isCvDataAffected
  }
`;
export const ConsultantReferenceDocumentFragmentDoc = gql`
  fragment ConsultantReferenceDocument on ConsultantReferenceDocument {
    referenceId
    name
    type
    workRelation
    document {
      PreviewURL
    }
  }
`;
export const ContactPersonsEmailSearchDataFragmentDoc = gql`
  fragment ContactPersonsEmailSearchData on ContactPerson {
    _id
    __typename
    Name
    Email
  }
`;
export const EventDataFragmentDoc = gql`
  fragment EventData on Event {
    _id
    CanDelete
    CanEdit
    CanPin
    CreatedBy {
      PersonId
      Name
    }
    CreatedOn
    Deleted
    Description
    DescriptionHtml
    Sticky
    Warning
    UpdatedBy {
      Name
    }
    Links
  }
`;
export const EventLog_ReminderEventTodoFragmentDoc = gql`
  fragment EventLog_ReminderEventTodo on TodoItem {
    _id
    AssignedTo {
      Name
      PersonId
    }
    AssignedOn
    AssignedTeam
    AssignedBy {
      Name
      PersonId
    }
    Completed
    Description
    Due
  }
`;
export const SMSEvent_MessageFragmentDoc = gql`
  fragment SMSEvent_Message on SMSMessage {
    _id
    IsFailed
    IsOk
    IsStatusFinal
    Status
    StatusUpdatedOn
  }
`;
export const ConsultantEventLogDataFragmentDoc = gql`
  fragment ConsultantEventLogData on ConsultantEvent {
    ...EventData
    Type
    MetBy {
      Name
      PersonId
    }
    EmailBody
    EmailSubject
    EmailDescription
    EmailRecipients {
      Email
      Name
    }
    TodoItem {
      ...EventLog_ReminderEventTodo
    }
    SMSStatusLegacy
    SMSMessage {
      ...SMSEvent_Message
    }
    Warning
  }
  ${EventDataFragmentDoc}
  ${EventLog_ReminderEventTodoFragmentDoc}
  ${SMSEvent_MessageFragmentDoc}
`;
export const ConsultantEventLogMetaDataFragmentDoc = gql`
  fragment ConsultantEventLogMetaData on Consultant {
    _id
    __typename
    Name
    Email
    CellPhoneValid
    bookingStatus
  }
`;
export const EventLog_EventFragmentDoc = gql`
  fragment EventLog_Event on Event {
    _id
    CanDelete
    CanEdit
    CanPin
    CreatedBy {
      PersonId
      Name
    }
    CreatedOn
    Deleted
    Description
    DescriptionHtml
    Sticky
    Warning
    UpdatedBy {
      Name
    }
    Links
  }
`;
export const EventLog_ConsultantEventFragmentDoc = gql`
  fragment EventLog_ConsultantEvent on ConsultantEvent {
    ...EventLog_Event
    Type
    MetBy {
      Name
      PersonId
    }
    EmailBody
    EmailSubject
    EmailDescription
    EmailRecipients {
      Email
      Name
    }
    TodoItem {
      ...EventLog_ReminderEventTodo
    }
    SMSStatusLegacy
    SMSMessage {
      ...SMSEvent_Message
    }
    Warning
  }
  ${EventLog_EventFragmentDoc}
  ${EventLog_ReminderEventTodoFragmentDoc}
  ${SMSEvent_MessageFragmentDoc}
`;
export const ConsultantEventLog_ConsultantFragmentDoc = gql`
  fragment ConsultantEventLog_Consultant on Consultant {
    _id
    Name
    Email
    AvatarPic
    CellPhone
    CellPhoneValid
    secondaryEmail
  }
`;
export const ConsultantGdprConsentFragmentDoc = gql`
  fragment ConsultantGdprConsent on GDPRConsent {
    type
    granted
    grantedBy {
      Name
    }
    dateGranted
    revokedBy {
      Name
    }
    dateRevoked
    communicationChannel
  }
`;
export const ConsultantGdprDataFragmentDoc = gql`
  fragment ConsultantGdprData on Consultant {
    _id
    LegalBasis
    ContractSigned
    GDPRConsentRecords {
      ...ConsultantGdprConsent
    }
  }
  ${ConsultantGdprConsentFragmentDoc}
`;
export const KarensDataFragmentDoc = gql`
  fragment KarensData on Consultant {
    karens {
      __typename
      expDate
      region
    }
  }
`;
export const PersonalInfoCardDataFragmentDoc = gql`
  fragment PersonalInfoCardData on Consultant {
    _id
    Name
    LastContactDate
    Email
    secondaryEmail
    Phone
    CellPhone
    Address {
      formattedShort
    }
    SocialSecurityNo
    ResponsiblePerson {
      PersonId
      Name
    }
    preferredCommunication
    AreasOfExpertise
    Specializations
    PrescriptionCode
    Professions
    KnownSystems
    LegalPersonType
    expertise {
      machines
      methods
      systems
      educations
    }
    contracts(params: { isActive: true, isSigned: true }) {
      id
      startDate
      endDate
    }
    qualityApprovals {
      ...QualityApprovalTooltipData
    }
    nationalQualityApprovals {
      ...QualityApprovalTooltipData
    }
    isQualityApproved
    isQualityExpired
    nationalQualification
    worksForCompetitors
    bookedPeriodStart
    bookedPeriodEnd
    bookingStatus
    leadStatus {
      status
    }
    pipelineStatus
    tags
    BusinessName
    BusinessSocialSecurityNo
    businessAddress {
      formattedShort
    }
    Unfit
    initialContact
    hasDrivingLicence
    drivingLicenceType
    ...KarensData
  }
  ${QualityApprovalTooltipDataFragmentDoc}
  ${KarensDataFragmentDoc}
`;
export const HealthDeclarationListItemFragmentDoc = gql`
  fragment HealthDeclarationListItem on HealthDeclarationDocument {
    id
    name
    url
    status
    createdAt
    signedAt
  }
`;
export const ConsultantProfileForQualityItemFragmentDoc = gql`
  fragment ConsultantProfileForQualityItem on Consultant {
    _id
    Name
    SocialSecurityNo
    expertise {
      professions {
        professionName
        certifiedFrom
      }
    }
  }
`;
export const ConsultantQuality_ConsultantNewFragmentDoc = gql`
  fragment ConsultantQuality_ConsultantNew on Consultant {
    _id
    AvailableForWorkInCountries
    Name
    AreasOfExpertise
    SocialSecurityNo
    ResponsiblePerson {
      PersonId
    }
    QualityPerCountry {
      Country
      QualityChecks {
        ...ConsultantQualityCheckData
        ...ConsultantQualityItemEditor
      }
    }
    Unfit
    UnfitComment
    UnfitedBy {
      Name
      PersonId
    }
    ...ConsultantQualityCheckConsultantData
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
  ${ConsultantQualityCheckConsultantDataFragmentDoc}
`;
export const ReferenceItemFragmentDoc = gql`
  fragment ReferenceItem on ConsultantReferenceNew {
    _id
    name
    phone
    email
    position
    workPlace
    workRelation
    form {
      submittedAt
      submittedBy {
        name
        nodeId
      }
    }
    submissionHistory {
      submittedAt
      submittedBy
    }
    formType
    formLink
    editLink
    areaOfExpertise
    status
    lastStatusHistory {
      changedAt
      changedBy {
        name
        nodeId
      }
      newStatus
    }
    reminders {
      createdAt
      sentTo
    }
    document {
      FileRef {
        NodeID
        Name
      }
      PdfURL
      PreviewURL
    }
    canBeSentToRef
    canBeReSentToRef
    reShared
    deleted
    updatedOn
    migrated
    orderedUpdateFromKvk
  }
`;
export const ConsultantServicePreferenceFragmentDoc = gql`
  fragment ConsultantServicePreference on ConsultantServicePreference {
    _id
    createdOn
    createdById
    createdByName
    nullifiedById
    nullifiedByName
    nullifiedOn
    description
    period {
      start
      end
    }
    customers {
      Id
      Name
      Type
    }
    reminders {
      createdAt
      sentTo
    }
    status
    deleted
    archived
  }
`;
export const CustomerSearchDataFragmentDoc = gql`
  fragment CustomerSearchData on Customer {
    _id
    __typename
    IsValid
    AreasOfExpertise
    Name
    RegionRef {
      Id
      Name
      Type
    }
    Parents {
      Name
    }
    journalSystem
    Type
    Address {
      City
    }
  }
`;
export const ConsultantServicePreferenceFormFragmentDoc = gql`
  fragment ConsultantServicePreferenceForm on ConsultantServicePreferenceForm {
    _id
    description
    period {
      start
      end
    }
    status
    customers {
      ...CustomerSearchData
    }
  }
  ${CustomerSearchDataFragmentDoc}
`;
export const WelcomeEmailDataFragmentDoc = gql`
  fragment WelcomeEmailData on Consultant {
    welcomeEmail
  }
`;
export const UserSettingsDataFragmentDoc = gql`
  fragment UserSettingsData on Consultant {
    SocialSecurityNo
    UserSettings {
      __typename
      Enabled
    }
  }
`;
export const UnfitDataFragmentDoc = gql`
  fragment UnfitData on Consultant {
    Unfit
    UnfitComment
    UnfitedBy {
      Name
      PersonId
    }
    UnfitedSetOn
    unfitType
  }
`;
export const SwitchesCardDataFragmentDoc = gql`
  fragment SwitchesCardData on Consultant {
    _id
    __typename
    ...WelcomeEmailData
    ...UserSettingsData
    ...UnfitData
  }
  ${WelcomeEmailDataFragmentDoc}
  ${UserSettingsDataFragmentDoc}
  ${UnfitDataFragmentDoc}
`;
export const UserDataFragmentDoc = gql`
  fragment UserData on User {
    _id
    __typename
    Deleted
    Enabled
    Name
    Teams
  }
`;
export const WorkExperienceDataFragmentDoc = gql`
  fragment WorkExperienceData on Consultant {
    _id
    ConsultantForm {
      workExperience {
        items {
          areaOfExpertise
          roles
          fromYear
          fromMonth
          toYear
          toMonth
          workType
          workPlace
          customerRef {
            Id
            Name
            Type
          }
          departmentIds
          competitors
          employmentType
          experience
          excludeFromPresentation
        }
      }
    }
  }
`;
export const DepartmentDataFragmentDoc = gql`
  fragment DepartmentData on Customer {
    _id
    Name
    DirectParent {
      Id
    }
  }
`;
export const ConsultantPayoutByYearDataFragmentDoc = gql`
  fragment ConsultantPayoutByYearData on ConsultantPayoutByYear {
    total
    totalNationalProcurement
    totalNonNationalProcurement
    year
  }
`;
export const ConsultantWorkStatusFragmentFragmentDoc = gql`
  fragment ConsultantWorkStatusFragment on ConsultantWorkStatus {
    _id
    type
    startDate
    competitorName
    reminderDate
    createdByName
    createdOn
    deleted
  }
`;
export const ConsultantReferenceStatusModalDataFragmentDoc = gql`
  fragment ConsultantReferenceStatusModalData on Consultant {
    _id
    QualityPerCountry {
      Country
    }
  }
`;
export const NpConsultantReferenceStatusModalDataFragmentDoc = gql`
  fragment NpConsultantReferenceStatusModalData on Consultant {
    _id
    QualityPerCountry {
      Country
    }
  }
`;
export const ConsultantQualityPerCountryDataFragmentDoc = gql`
  fragment ConsultantQualityPerCountryData on ConsultantQualityPerCountry {
    Country
    QualityChecks {
      Status {
        Name
      }
      DocumentType
      Name
      HasExpired
      ExpiresOn
    }
  }
`;
export const GDPRConsentRecordsDataFragmentDoc = gql`
  fragment GDPRConsentRecordsData on GDPRConsent {
    type
    granted
    dateGranted
    dateRevoked
    grantedBy {
      Name
    }
    revokedBy {
      Name
    }
  }
`;
export const ConsultantSearchQualityCheckDataFragmentDoc = gql`
  fragment ConsultantSearchQualityCheckData on ConsultantQualityCheck {
    country
    itemName
    status
    setDate
    expirationDate
    comment
    params
    isPartiallyExpired
  }
`;
export const ConsultantSearchCardDataFragmentDoc = gql`
  fragment ConsultantSearchCardData on Consultant {
    _id
    createdAt
    updatedAt
    Address {
      City
    }
    contactType {
      employeeSalaryClaim
      subcontractorSalaryClaim
    }
    AreasOfExpertise
    AvatarPic
    CellPhone
    Email
    secondaryEmail
    LastContactDate
    Name
    Phone
    Unfit
    ResponsiblePerson {
      PersonId
      Name
    }
    SocialSecurityNo
    Specializations
    IsValid
    ValidationErrors {
      Message
      Params
      Type
    }
    expertise {
      machines
      systems
      educations
      methods
    }
    Professions
    PrescriptionCode
    isQualityApproved
    isQualityExpired
    isNationalQualityApproved
    isNationalQualityExpired
    isPresentationReadyQualityApproved
    isPresentationReadyQualityExpired
    GDPRConsentRecords {
      ...GDPRConsentRecordsData
    }
    Title
    LegalBasis
    AvailableForWorkInCountries
    Availability {
      ranges {
        from
        to
      }
    }
    worksForCompetitors
    qualityChecks {
      ...ConsultantSearchQualityCheckData
    }
    hasDrivingLicence
    drivingLicenceType
    tags
    nextContactDate {
      date
    }
    generalInterest {
      regions
    }
    pipelineStatus
    bookingStatus
    qualityNote
  }
  ${GDPRConsentRecordsDataFragmentDoc}
  ${ConsultantSearchQualityCheckDataFragmentDoc}
`;
export const ConsultantSearchNewEventDataFragmentDoc = gql`
  fragment ConsultantSearchNewEventData on Event {
    _id
    DescriptionHtml
    CreatedOn
    CreatedBy {
      Name
      PersonId
    }
  }
`;
export const ConsultantImport_RowFragmentDoc = gql`
  fragment ConsultantImport_Row on ConsultantImportRow {
    RowID
    FirstName
    LastName
    Phone
    CellPhone
    SocialSecurityNo
    SocialSecurityNoSource
    HPRNumber
    isApprovedAuthorization
    country
    city
    streetName
    zipCode
    Competitor
    CompetitorSource
    ResponsiblePerson {
      PersonId
      Name
    }
    ResponsiblePersonSource {
      PersonId
      Name
    }
    InitialComment
    AreaOfExpertise
    IsDuplicate
    Duplicate {
      _id
      Name
    }
    IsLookupSuccess
    Errors {
      Column
      Message
    }
    Meta {
      importBatch
      source
    }
  }
`;
export const ConsultantImport_ResultFragmentDoc = gql`
  fragment ConsultantImport_Result on SaveConsultantsResult {
    ... on SaveConsultantsResultInvalid {
      Rows {
        RowID
        FirstName
        LastName
        Phone
        CellPhone
        SocialSecurityNo
        Competitor
        CompetitorSource
        ResponsiblePerson {
          PersonId
          Name
        }
        ResponsiblePersonSource {
          PersonId
          Name
        }
        InitialComment
        AreaOfExpertise
        Errors {
          Column
          Message
        }
        Meta {
          importBatch
          source
        }
      }
    }
    ... on SaveConsultantsResultOK {
      Msg
      Consultants {
        _id
        Name
      }
    }
  }
`;
export const AuditFragmentDoc = gql`
  fragment Audit on Audit {
    Created {
      Date
      User {
        Name
        PersonId
      }
    }
    Deleted {
      Date
      User {
        Name
        PersonId
      }
    }
    Updated {
      Date
      User {
        Name
        PersonId
      }
    }
  }
`;
export const AuditItemFragmentDoc = gql`
  fragment AuditItem on AuditItem {
    date
    type
    userRef {
      PersonId
      Name
    }
  }
`;
export const BisnodePersonFragmentDoc = gql`
  fragment BisnodePerson on BisnodePerson {
    AddressCity
    AddressCountry
    AddressStreetName
    AddressZipCode
    CellPhone
    FirstName
    LastName
    Phone
  }
`;
export const CallListEditor_CallListFragmentDoc = gql`
  fragment CallListEditor_CallList on CallList {
    _id
    name
  }
`;
export const ConsultantShareableFilesFragmentDoc = gql`
  fragment ConsultantShareableFiles on Consultant {
    _id
    DocumentsShareable {
      DocumentType
      FileRef {
        NodeID
        Name
      }
      ThumbURL
      PdfURL
    }
  }
`;
export const ContactPersonEditorFragmentDoc = gql`
  fragment ContactPersonEditor on ContactPerson {
    _id
    IsInheritable
    AreasOfExpertise
    BooksProfessions
    CustomerRefs {
      ...CustomerRef
    }
    CustomerGroups
    Email
    EmailValid
    Name
    CellPhone
    CellPhoneValid
    Phone
    PhoneValid
    Roles
    RootCustomer {
      Id
      Name
      Type
    }
    Title
  }
  ${CustomerRefFragmentDoc}
`;
export const CustomerTreeSelect_ItemFragmentDoc = gql`
  fragment CustomerTreeSelect_Item on CustomerTreeItem {
    CustomerRef {
      Id
      Name
      Type
    }
    CustomerRef {
      Id
      Name
      Type
    }
    HospitalRef {
      Id
      Name
      Type
    }
    ParentId
  }
`;
export const ContactPersonEditor_CustomerFragmentDoc = gql`
  fragment ContactPersonEditor_Customer on Customer {
    _id
    AreasOfExpertise
    Name
    Type
    Address {
      Country
    }
    CustomerTree {
      ...CustomerTreeSelect_Item
    }
  }
  ${CustomerTreeSelect_ItemFragmentDoc}
`;
export const CustomerAutosuggestItemFragmentDoc = gql`
  fragment CustomerAutosuggestItem on Customer {
    _id
    Name
    Type
  }
`;
export const EventLog_AccommodationEventFragmentDoc = gql`
  fragment EventLog_AccommodationEvent on AccommodationEvent {
    ...EventLog_Event
    Links
    Type
  }
  ${EventLog_EventFragmentDoc}
`;
export const EventLog_BookingEventFragmentDoc = gql`
  fragment EventLog_BookingEvent on BookingEvent {
    _id
    CanDelete
    CanEdit
    CanPin
    CreatedBy {
      PersonId
      Name
    }
    CreatedOn
    Deleted
    Description
    DescriptionHtml
    Sticky
    UpdatedBy {
      Name
    }
    Type
    ResultOfAction
    Links
    UserRef {
      Name
      PersonId
    }
    Warning
  }
`;
export const EventLog_CustomerEventFragmentDoc = gql`
  fragment EventLog_CustomerEvent on CustomerEvent {
    ...EventLog_Event
    AreasOfExpertise
    ContactPerson {
      Name
      NodeID
      NodeType
    }
    CustomerGroup
    RootCustomer {
      Id
      Name
      Type
    }
    Roles
    MetBy {
      Name
      PersonId
    }
    TodoItem {
      ...EventLog_ReminderEventTodo
    }
    TodoRef {
      ...NodeRef
    }
    Type
  }
  ${EventLog_EventFragmentDoc}
  ${EventLog_ReminderEventTodoFragmentDoc}
  ${NodeRefFragmentDoc}
`;
export const TicketItemDataFragmentDoc = gql`
  fragment TicketItemData on TodoItem {
    _id
    type
    NodeType
    NodeName
    Accepted
    AssignedOn
    AssignedTeam
    AssignedTo {
      PersonId
      Name
    }
    CanAccept
    AssignedBy {
      PersonId
      Name
    }
    Completed
    DelegatedBy {
      PersonId
      Name
    }
    Deleted
    Description
    Due
    LinkedItems {
      NodeID
      NodeType
      Name
    }
    SecondaryText
    Status
    Tags
    Type
    URL
    RelatedTo {
      NodeID
      Name
      NodeType
    }
    Priority
    ViewMode
    WhoWatched {
      PersonId
      Name
    }
  }
`;
export const TicketEventFragmentDoc = gql`
  fragment TicketEvent on TodoEvent {
    Type
    _id
    Audit {
      Created {
        Date
        User {
          PersonId
          Name
        }
      }
      Updated {
        Date
        User {
          PersonId
          Name
        }
      }
      Deleted {
        Date
        User {
          PersonId
          Name
        }
      }
    }
    CreatedBy {
      PersonId
      Name
    }
    CreatedOn
    Deleted
    DeletedBy {
      PersonId
      Name
    }
    Description
    DescriptionHtml
    Sticky
    Warning
    UpdatedBy {
      PersonId
      Name
    }
    CanPin
    CanEdit
    CanDelete
    TodoItem {
      ...TicketItemData
    }
    TodoRef {
      Name
      NodeID
      NodeType
    }
  }
  ${TicketItemDataFragmentDoc}
`;
export const MassContactActions_SMSResultFragmentDoc = gql`
  fragment MassContactActions_SMSResult on SendMassSMSToConsultantsResult {
    result {
      ConsultantId
      SMSMessage {
        _id
        Status
      }
    }
  }
`;
export const ContactListItemFragmentDoc = gql`
  fragment ContactListItem on IContact {
    _id
    AvatarPic
    Name
    Email
    EmailValid
    Phone
    PhoneValid
    CellPhone
    CellPhoneValid
    Title
    Roles
    ResponsiblePerson {
      Name
      PersonId
    }
    GDPRConsentRecords {
      type
      granted
    }
  }
`;
export const NodeCallListFragmentDoc = gql`
  fragment NodeCallList on CallList {
    _id
    deleted
    name
    type
    nodes {
      Name
      NodeID
      NodeType
    }
    members {
      PersonId
      Name
    }
  }
`;
export const AccommodationCardListItemFragmentDoc = gql`
  fragment AccommodationCardListItem on AccommodationListItem {
    _id
    Type
    Offers {
      _id
      Name
      Price
      PriceType
      Options
      Rooms
      Beds
      Area
    }
    ImgUrl
    Name
    Email
    Site
    Phone
    preferredChoice
    envCertification
    envCertificationName
    Address {
      StreetName
      City
      Region
      Country
      ZipCode
    }
    ResponsiblePersonRef {
      PersonId
      Name
    }
    unfit {
      value
      comment
      userRef {
        PersonId
        Name
      }
    }
  }
`;
export const AccommodationSelectorItemFragmentDoc = gql`
  fragment AccommodationSelectorItem on AccommodationListItem {
    _id
    ...AccommodationCardListItem
  }
  ${AccommodationCardListItemFragmentDoc}
`;
export const ConsultantSelectorSearchCardFragmentDoc = gql`
  fragment ConsultantSelectorSearchCard on Consultant {
    ...ConsultantCard
    LegalPersonType
    BusinessName
    BusinessSocialSecurityNo
    AccommodationPreferences
    TravelPreferences
  }
  ${ConsultantCardFragmentDoc}
`;
export const ContactPersonSelector_ItemFragmentDoc = gql`
  fragment ContactPersonSelector_Item on ContactPerson {
    _id
    Name
    Email
    Phone
    CellPhone
  }
`;
export const CustomerCard_RefFragmentDoc = gql`
  fragment CustomerCard_Ref on CustomerRef {
    Id
    Name
    Type
  }
`;
export const CustomerPicker_CustomerCardFragmentDoc = gql`
  fragment CustomerPicker_CustomerCard on Customer {
    _id
    Address {
      City
      Country
      Region
      StreetName
      ZipCode
    }
    AreasOfExpertise
    AvatarPic
    Deleted
    Description
    LastContactDate
    Name
    Specializations
    Type
    Parents {
      ...CustomerCard_Ref
    }
    IsValid
    ValidationErrors {
      Message
      Params
      Type
    }
    journalSystem
    RecruitingPortalType
  }
  ${CustomerCard_RefFragmentDoc}
`;
export const SearchProfileOptionFragmentDoc = gql`
  fragment SearchProfileOption on SearchProfile {
    _id
    name
  }
`;
export const SearchProfileFragmentDoc = gql`
  fragment SearchProfile on SearchProfile {
    fields
    ...SearchProfileOption
    type
    customerRefs {
      Id
      Name
      Type
    }
  }
  ${SearchProfileOptionFragmentDoc}
`;
export const ListUserSelectorUserFragmentDoc = gql`
  fragment ListUserSelectorUser on User {
    _id
    Name
    Teams
  }
`;
export const ProjectSelectProjectDataFragmentDoc = gql`
  fragment ProjectSelectProjectData on Project {
    _id
    Name
    ProjectNumber
  }
`;
export const UserSelectFragmentDoc = gql`
  fragment UserSelect on User {
    _id
    Name
    Enabled
    Teams
  }
`;
export const UserSelectorModalUserFragmentDoc = gql`
  fragment UserSelectorModalUser on User {
    _id
    Name
    Teams
  }
`;
export const CustomerContractEditorDataFragmentDoc = gql`
  fragment CustomerContractEditorData on CustomerContract {
    _id
    company
    dispenseDeadline
    contractStart
    contractEnd
    currentContractEnd
    estimatedContractValue
    contractProlongation
    contractProlongationDeadline
    prolongationComment
    adjustmentComment
    contractPriceAdjustmentDate
    contractPriceAdjustmentDateDeadline
    introductionInfo
    contactPerson {
      _id
      title
      email
      name
      phone
    }
    orgCustomerRefs {
      Id
      Name
      Type
    }
    contractNumber
    contractName
    avtalsnummer
    avropsnummer
    extraInvoiceLine
    useNationalProcurementInvoicing
    isNationalProcurement
    professions
    typeOfAgreement
    overtime
    overtimeNote
    possibleInvoiceForTravel
    possibleInvoiceForTravelNote
    possibleInvoiceForAccommodation
    possibleInvoiceForAccommodationNote
    overtimeOption
    overtimeOptionOBNote
    otherOption
    otherOptionNote
  }
`;
export const CustomerContractResultFragmentDoc = gql`
  fragment CustomerContractResult on CustomerContractOpResult {
    value {
      ...CustomerContractEditorData
    }
    errors
  }
  ${CustomerContractEditorDataFragmentDoc}
`;
export const CustomerContractOrgCustomerTreeFragmentDoc = gql`
  fragment CustomerContractOrgCustomerTree on CustomerContract {
    _id
    orgCustomerTree {
      CustomerRef {
        Id
        Name
        Type
      }
      HospitalRef {
        Id
        Name
        Type
      }
      ParentId
      ParentRef {
        Id
        Name
        Type
      }
    }
  }
`;
export const CustomerContractPriceListProfileFragmentDoc = gql`
  fragment CustomerContractPriceListProfile on CustomerContractPriceList {
    _id
    name
    travelZones {
      name
      articleNumber
    }
    customers {
      _id
      Type
      Name
    }
    startDate
    endDate
    administrativeFee
    priceGroups {
      _id
      professionsPrice {
        profession {
          name
          areaOfExpertise
          specialization
        }
        price
      }
      records {
        ...contractsPriceRecord
      }
      highHolidays {
        ...HighHoliday
      }
    }
    customerContract {
      _id
      contractNumber
      isNationalProcurement
      useNationalProcurementInvoicing
      company
      professions
    }
  }
  ${ContractsPriceRecordFragmentDoc}
  ${HighHolidayFragmentDoc}
`;
export const CustomerContractPriceListFormContractDataFragmentDoc = gql`
  fragment CustomerContractPriceListFormContractData on CustomerContract {
    _id
    contractNumber
    orgCustomers {
      _id
      Name
    }
    professions
    isNationalProcurement
    useNationalProcurementInvoicing
    company
  }
`;
export const CustomerContractCardFragmentDoc = gql`
  fragment CustomerContractCard on CustomerContract {
    _id
    company
    dispenseDeadline
    professions
    contractNumber
    contractName
    contractStart
    contractEnd
    currentContractEnd
    estimatedContractValue
    contractProlongation
    contractProlongationDeadline
    contractPriceAdjustmentDate
    contractPriceAdjustmentDateDeadline
    introductionInfo
    typeOfAgreement
    prolongationComment
    adjustmentComment
    overtime
    overtimeNote
    possibleInvoiceForAccommodation
    possibleInvoiceForAccommodationNote
    possibleInvoiceForTravel
    possibleInvoiceForTravelNote
    overtimeOption
    overtimeOptionOBNote
    status
  }
`;
export const SimpleCustomerCardWithoutContactPersonsFragmentDoc = gql`
  fragment SimpleCustomerCardWithoutContactPersons on Customer {
    _id
    Address {
      City
      Country
      Region
      StreetName
      ZipCode
    }
    AreasOfExpertise(limit: 0)
    areasOfExpertiseTotal
    AvatarPic
    Deleted
    Description
    LastContactDate
    Name
    Specializations
    Type
    Parents {
      ...CustomerCard_Ref
    }
    IsValid
    journalSystem
  }
  ${CustomerCard_RefFragmentDoc}
`;
export const CustomerContractCustomerListFragmentDoc = gql`
  fragment CustomerContractCustomerList on CustomerContract {
    _id
    orgCustomers {
      _id
      ...SimpleCustomerCardWithoutContactPersons
    }
  }
  ${SimpleCustomerCardWithoutContactPersonsFragmentDoc}
`;
export const CustomerContractPriceListsFragmentDoc = gql`
  fragment CustomerContractPriceLists on CustomerContract {
    _id
    priceLists {
      _id
      name
      startDate
      endDate
      customers(limit: 3) {
        Name
      }
      customerCount
    }
  }
`;
export const CustomerContractContactPersonFragmentDoc = gql`
  fragment CustomerContractContactPerson on CustomerContract {
    _id
    contactPerson {
      title
      email
      name
      phone
    }
  }
`;
export const CustomerContractInfoTabFragmentDoc = gql`
  fragment CustomerContractInfoTab on CustomerContract {
    _id
    info
  }
`;
export const EventLog_CustomerContractEventFragmentDoc = gql`
  fragment EventLog_CustomerContractEvent on CustomerContractEventLog {
    ...EventLog_Event
    Links
    EventType
  }
  ${EventLog_EventFragmentDoc}
`;
export const CustomerContractEventLogFragmentDoc = gql`
  fragment CustomerContractEventLog on CustomerContract {
    _id
    eventLogs {
      ...EventLog_CustomerContractEvent
    }
  }
  ${EventLog_CustomerContractEventFragmentDoc}
`;
export const CustomerContract_ProfileFragmentDoc = gql`
  fragment CustomerContract_Profile on CustomerContract {
    _id
    contractNumber
    invoicingStrategy
    estimatedContractValue
    company
    dispenseDeadline
    isNationalProcurement
    ...CustomerContractCard
    ...CustomerContractCustomerList
    ...CustomerContractPriceLists
    ...CustomerContractContactPerson
    ...CustomerContractInfoTab
    ...CustomerContractEventLog
  }
  ${CustomerContractCardFragmentDoc}
  ${CustomerContractCustomerListFragmentDoc}
  ${CustomerContractPriceListsFragmentDoc}
  ${CustomerContractContactPersonFragmentDoc}
  ${CustomerContractInfoTabFragmentDoc}
  ${CustomerContractEventLogFragmentDoc}
`;
export const CustomerContractSnapshotListItemFragmentDoc = gql`
  fragment CustomerContractSnapshotListItem on CustomerContractSnapshot {
    _id
    parentId
    type
    name
    signedOn
    fileUrl
    viewUrl
    isNullified
    externalId
    publishedUrl
  }
`;
export const CustomerContractSubVersionFragmentDoc = gql`
  fragment CustomerContractSubVersion on CustomerContractSubVersion {
    _id
    customerContractName
    name
    basicPrice
    consultantId
    startDate
    endDate
    fileRef {
      Name
      NodeID
    }
  }
`;
export const CustomerContractSubVersionListItemFragmentDoc = gql`
  fragment CustomerContractSubVersionListItem on CustomerContract {
    _id
    contractName
    subVersions {
      ...CustomerContractSubVersion
    }
  }
  ${CustomerContractSubVersionFragmentDoc}
`;
export const CustomerContractsFragmentFragmentDoc = gql`
  fragment CustomerContractsFragment on CustomerContractSearchRow {
    _id
    contractNumber
    contractName
    contractStart
    contractEnd
    currentContractEnd
    contractProlongation
    contractPriceAdjustmentDate
    estimatedContractValue
    professions
    status
    orgCustomerRefs {
      Id
      Name
    }
  }
`;
export const CustomerChildrenList_ItemFragmentDoc = gql`
  fragment CustomerChildrenList_Item on Customer {
    _id
    CustomerGroups
    Name
    Type
  }
`;
export const CustomerChildrenListFragmentDoc = gql`
  fragment CustomerChildrenList on Customer {
    _id
    DirectChildrenFull {
      ...CustomerChildrenList_Item
    }
    Type
  }
  ${CustomerChildrenList_ItemFragmentDoc}
`;
export const CustomerContactList_ItemFragmentDoc = gql`
  fragment CustomerContactList_Item on ContactPerson {
    _id
    AreasOfExpertise
    Email
    Name
    Phone
    Roles
    Title
  }
`;
export const SimpleCustomerCardFragmentDoc = gql`
  fragment SimpleCustomerCard on Customer {
    _id
    Address {
      City
      Country
      Region
      StreetName
      ZipCode
    }
    AreasOfExpertise(limit: 0)
    areasOfExpertiseTotal
    AvatarPic
    Deleted
    Description
    LastContactDate
    Name
    StaffingContactPersons {
      ...CustomerContactList_Item
    }
    Specializations
    Type
    Parents {
      ...CustomerCard_Ref
    }
    IsValid
    journalSystem
    inLists
    RecruitingPortalType
  }
  ${CustomerContactList_ItemFragmentDoc}
  ${CustomerCard_RefFragmentDoc}
`;
export const CustomerCardFragmentDoc = gql`
  fragment CustomerCard on Customer {
    ...SimpleCustomerCard
  }
  ${SimpleCustomerCardFragmentDoc}
`;
export const CustomerContactPersonForm_CustomerFragmentDoc = gql`
  fragment CustomerContactPersonForm_Customer on Customer {
    _id
    ...CustomerCard
    AreasOfExpertiseNoLimit: AreasOfExpertise
    DirectChildrenFull {
      _id
      CustomerGroups
    }
  }
  ${CustomerCardFragmentDoc}
`;
export const CustomerContactPersonFragmentDoc = gql`
  fragment CustomerContactPerson on ContactPerson {
    _id
    CustomerGroups
    Deleted
    Email
    Name
    Phone
    CellPhone
    Roles
    Title
    AreasOfExpertise
    BooksProfessions
    CustomerRefs {
      Id
    }
    LastChange {
      Date
      IsUpdate
      User {
        Name
      }
    }
  }
`;
export const CustomerEditor_CustomerAOEFragmentDoc = gql`
  fragment CustomerEditor_CustomerAOE on CustomerAOESettings {
    Enabled
    AreaOfExpertise
    Error
    FortnoxId
    Inherited
    InvoicingData
    Profession
    ResponsiblePerson {
      Name
      PersonId
    }
    GroupInvoicing
    timeReport
    orderId
  }
`;
export const CustomerEditor_WorkshiftSpanFragmentDoc = gql`
  fragment CustomerEditor_WorkshiftSpan on CustomerWorkshiftSpan {
    Profession
    FromMinutes
    ToMinutes
    Workshift
  }
`;
export const CustomerEditor_CustomerFragmentDoc = gql`
  fragment CustomerEditor_Customer on Customer {
    _id
    Address {
      City
      Country
      Region
      StreetName
      ZipCode
    }
    AreasOfExpertise
    AOESettings {
      ...CustomerEditor_CustomerAOE
    }
    CustomerGroups
    DirectChildren {
      Id
      Name
      Type
    }
    Description
    Name
    OrganizationNumber
    OrganizationType
    RecruitingPortalType
    OwnProfessions
    Parents {
      ...CustomerRef
    }
    Professions
    Type
    WorkshiftSpans {
      ...CustomerEditor_WorkshiftSpan
    }
    forceCallNumber
    journalSystem
    billingInstructions
    municipalityId
    bemloOrgId
    bemloUnitId
  }
  ${CustomerEditor_CustomerAOEFragmentDoc}
  ${CustomerRefFragmentDoc}
  ${CustomerEditor_WorkshiftSpanFragmentDoc}
`;
export const MunicipalityFragmentDoc = gql`
  fragment Municipality on Municipality {
    _id
    name
  }
`;
export const CustomerAreasOfExpertiseFragmentDoc = gql`
  fragment CustomerAreasOfExpertise on Customer {
    _id
    AreasOfExpertise(limit: 0)
  }
`;
export const CustomerProfileFragmentDoc = gql`
  fragment CustomerProfile on Customer {
    _id
    AreasOfExpertise(limit: 0)
    DocumentTypes
    Parents {
      ...CustomerRef
    }
    ValidationErrors {
      Message
      Params
      Type
    }
    Type
    RecruitingPortalType
    OrganizationType
    ...CustomerAreasOfExpertise
    ...SimpleCustomerCard
    noApproval
    needSignature
    noApprovalMonthly
    noApprovalShortening
    noApprovalSpecial
    needSignatureTROkInApp
    timeReportTemplateSettings {
      type
      professions
    }
    Professions
    documents {
      DocumentType
    }
    forceCallNumber
    municipalityId
  }
  ${CustomerRefFragmentDoc}
  ${CustomerAreasOfExpertiseFragmentDoc}
  ${SimpleCustomerCardFragmentDoc}
`;
export const ConsultantMatchingItemDataFragmentDoc = gql`
  fragment ConsultantMatchingItemData on Consultant {
    _id
    Name
    ResponsiblePerson {
      Name
      PersonId
    }
    AreasOfExpertise
  }
`;
export const CustomerHeaderFragmentDoc = gql`
  fragment CustomerHeader on Customer {
    Systems
    LastContactDate
    Name
    ContactPersons {
      Name
      Roles
    }
  }
`;
export const UserFragmentDoc = gql`
  fragment User on User {
    _id
    AzureId
    AvatarPic
    BirthDate
    CellPhone
    Email
    Enabled
    Name
    Phone
    Teams
    AzureGroups
    Title
    Deleted
    ManagerId
  }
`;
export const CustomerContractInfoFragmentDoc = gql`
  fragment CustomerContractInfo on CustomerContract {
    _id
    contractNumber
    contractStart
    contractEnd
    contractProlongation
  }
`;
export const TeamFragmentDoc = gql`
  fragment Team on Team {
    ADGroups
    AreasOfExpertise
    KnownSystems
    Name
    Tags
    TodoGroup
    workrequestTeamName
    _id
  }
`;
export const CountryFragmentDoc = gql`
  fragment Country on Country {
    name
    canWorkIn
    countryId
    onTopInSearch
    sort
    regions {
      name
      countryCouncilId
    }
  }
`;
export const RoleFragmentDoc = gql`
  fragment Role on Role {
    IsStaffing
    Name
  }
`;
export const AddressWithRegionSectionFragmentDoc = gql`
  fragment AddressWithRegionSection on FormAddressWithRegion {
    ...AddressSection
    region
  }
  ${AddressSectionFragmentDoc}
`;
export const CallListSelectorListFragmentDoc = gql`
  fragment CallListSelectorList on CallList {
    _id
    deleted
    name
    type
    nodes {
      Name
      NodeID
      NodeType
    }
    members {
      PersonId
      Name
    }
  }
`;
export const SharedFileFragmentDoc = gql`
  fragment SharedFile on SharedFile {
    _id
    Deleted
    FileRef {
      NodeID
      NodeType
      Name
      Size
      MimeType
    }
    FileStats {
      AccessedTotal
      AccessRecords {
        IP
        AccessedOn
      }
    }
    SharedBy {
      PersonId
      Name
    }
    SharedOn
    ExpiresOn
    ShareURL
    ThumbURL
  }
`;
export const TicketBadgesFragmentDoc = gql`
  fragment TicketBadges on TodoUserBadges {
    TeamBadges {
      Badges {
        Category
        Read
        Unread
        Done
      }
      TotalUnread
      TeamRef {
        Name
        NodeID
        NodeType
      }
    }
    TotalUnread
  }
`;
export const ExpertiseFragmentDoc = gql`
  fragment Expertise on Expertise {
    Aliases
    Exclusive
    Name
    Profession
    QualityTemplates {
      Country
      Items {
        Description
        DocumentsFolder
        ExpiresInMonths
        Name
      }
    }
    Specializations
    Systems
    Machines
    Educations
    Methods
  }
`;
export const MyProfileFragmentDoc = gql`
  fragment MyProfile on Me {
    _id
    AvatarPic
    CellPhone
    Phone
    Email
    Name
    Title
    Permissions {
      CanAccessCustomers
      CanAccessReports
      CanAddAccommodation
      CanAddCustomer
      CanDeleteConsultantBookingContract
      CanDeleteConsultantContract
      CanDeleteConsultants
      CanDeleteCustomers
      CanImportConsultants
      CanMoveCustomers
      CanPose
      CanSelectAllInMassActions
      CanUpdateConsultantGDPR
      CanUpdateConsultantInitialContact
      CanUpdateCustomerNumber
    }
    permissions
    Teams
    AzureGroups
    todoBadges {
      ...TicketBadges
    }
    favoriteTeam
    favouriteConsultantIds
    ExtraAreasOfExpertise {
      ...Expertise
    }
    subordinates {
      _id
    }
  }
  ${TicketBadgesFragmentDoc}
  ${ExpertiseFragmentDoc}
`;
export const UserStore_CallListFragmentDoc = gql`
  fragment UserStore_CallList on CallList {
    _id
    deleted
    name
    type
    nodes {
      Name
      NodeID
      NodeType
    }
    members {
      PersonId
      Name
    }
  }
`;
export const MyProfilePartialFragmentDoc = gql`
  fragment MyProfilePartial on MePartial {
    CallLists {
      ...UserStore_CallList
    }
    ContactLists {
      ...UserStore_CallList
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export const TodoSearchItemFragmentDoc = gql`
  fragment TodoSearchItem on TodoSearchItem {
    _id
    createdOn
    dueDate
    completedOn
    createdBy
    delegatedBy
    assignedTo
    assignedBy
    managedBy
    status
    priority
    title
    tags
    canAccept
    canDecline
    canComplete
    category
    unreadStatuses {
      type
      count
    }
    relatedTo {
      NodeID
      Name
      NodeType
    }
    search {
      showTop
    }
    teamIds
  }
`;
export const TravelRequestSearchItemFragmentDoc = gql`
  fragment TravelRequestSearchItem on TravelRequestSearch {
    _id
    createdOn
    createdBy {
      PersonId
      Name
    }
    weeks {
      name
      link
    }
    status {
      status
      setBy {
        PersonId
        Name
      }
      setOn
    }
    consultantName
    city
    firstDeparture
  }
`;
export const QualityCheckFilterItemFragmentDoc = gql`
  fragment QualityCheckFilterItem on ConsultantSearchQualityItem {
    name
    statuses
  }
`;
export const SearchProfileOptionDataFragmentDoc = gql`
  fragment SearchProfileOptionData on SearchProfile {
    _id
    name
  }
`;
export const SearchProfileDataFragmentDoc = gql`
  fragment SearchProfileData on SearchProfile {
    fields
    ...SearchProfileOptionData
    type
    customerRefs {
      Id
      Name
      Type
    }
  }
  ${SearchProfileOptionDataFragmentDoc}
`;
export const TimereportKitSupportSearch_GetDocument = gql`
  query TimereportKitSupportSearch_Get(
    $filter: BookingWeekQueryInput!
    $skip: Int
    $limit: Int
    $sortOrder: SortOrder
  ) {
    bookingWeeksKitSupport(
      filter: $filter
      skip: $skip
      limit: $limit
      sortOrder: $sortOrder
    ) {
      items {
        ...TimereportKitSupportSearchItem
      }
      skip
      limit
      total
    }
  }
  ${TimereportKitSupportSearchItemFragmentDoc}
`;
export type TimereportKitSupportSearch_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimereportKitSupportSearch_GetQuery,
    TimereportKitSupportSearch_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: TimereportKitSupportSearch_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const TimereportKitSupportSearch_GetComponent = (
  props: TimereportKitSupportSearch_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    TimereportKitSupportSearch_GetQuery,
    TimereportKitSupportSearch_GetQueryVariables
  >
    query={TimereportKitSupportSearch_GetDocument}
    {...props}
  />
);

/**
 * __useTimereportKitSupportSearch_GetQuery__
 *
 * To run a query within a React component, call `useTimereportKitSupportSearch_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereportKitSupportSearch_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereportKitSupportSearch_GetQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useTimereportKitSupportSearch_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimereportKitSupportSearch_GetQuery,
    TimereportKitSupportSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TimereportKitSupportSearch_GetQuery,
    TimereportKitSupportSearch_GetQueryVariables
  >(TimereportKitSupportSearch_GetDocument, options);
}
export function useTimereportKitSupportSearch_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimereportKitSupportSearch_GetQuery,
    TimereportKitSupportSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimereportKitSupportSearch_GetQuery,
    TimereportKitSupportSearch_GetQueryVariables
  >(TimereportKitSupportSearch_GetDocument, options);
}
export type TimereportKitSupportSearch_GetQueryHookResult = ReturnType<
  typeof useTimereportKitSupportSearch_GetQuery
>;
export type TimereportKitSupportSearch_GetLazyQueryHookResult = ReturnType<
  typeof useTimereportKitSupportSearch_GetLazyQuery
>;
export namespace TimereportKitSupportSearch_Get {
  export type Return = TimereportKitSupportSearch_GetQuery;
  export type Variables = TimereportKitSupportSearch_GetQueryVariables;
  export const OperationName = "TimereportKitSupportSearch_Get";

  export const Document = TimereportKitSupportSearch_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TimereportKitSupportSearch_GetTotalDocument = gql`
  query TimereportKitSupportSearch_GetTotal($filter: BookingWeekQueryInput!) {
    bookingWeeksTotal(input: $filter) {
      dbTime
      total
    }
  }
`;
export type TimereportKitSupportSearch_GetTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimereportKitSupportSearch_GetTotalQuery,
    TimereportKitSupportSearch_GetTotalQueryVariables
  >,
  "query"
> &
  (
    | { variables: TimereportKitSupportSearch_GetTotalQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const TimereportKitSupportSearch_GetTotalComponent = (
  props: TimereportKitSupportSearch_GetTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    TimereportKitSupportSearch_GetTotalQuery,
    TimereportKitSupportSearch_GetTotalQueryVariables
  >
    query={TimereportKitSupportSearch_GetTotalDocument}
    {...props}
  />
);

/**
 * __useTimereportKitSupportSearch_GetTotalQuery__
 *
 * To run a query within a React component, call `useTimereportKitSupportSearch_GetTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereportKitSupportSearch_GetTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereportKitSupportSearch_GetTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTimereportKitSupportSearch_GetTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimereportKitSupportSearch_GetTotalQuery,
    TimereportKitSupportSearch_GetTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TimereportKitSupportSearch_GetTotalQuery,
    TimereportKitSupportSearch_GetTotalQueryVariables
  >(TimereportKitSupportSearch_GetTotalDocument, options);
}
export function useTimereportKitSupportSearch_GetTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimereportKitSupportSearch_GetTotalQuery,
    TimereportKitSupportSearch_GetTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimereportKitSupportSearch_GetTotalQuery,
    TimereportKitSupportSearch_GetTotalQueryVariables
  >(TimereportKitSupportSearch_GetTotalDocument, options);
}
export type TimereportKitSupportSearch_GetTotalQueryHookResult = ReturnType<
  typeof useTimereportKitSupportSearch_GetTotalQuery
>;
export type TimereportKitSupportSearch_GetTotalLazyQueryHookResult = ReturnType<
  typeof useTimereportKitSupportSearch_GetTotalLazyQuery
>;
export namespace TimereportKitSupportSearch_GetTotal {
  export type Return = TimereportKitSupportSearch_GetTotalQuery;
  export type Variables = TimereportKitSupportSearch_GetTotalQueryVariables;
  export const OperationName = "TimereportKitSupportSearch_GetTotal";

  export const Document = TimereportKitSupportSearch_GetTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AssignToBookingDocument = gql`
  mutation assignToBooking($bookingId: ObjectId!, $userId: ObjectId!) {
    assignToBooking(bookingId: $bookingId, userId: $userId) {
      bookingAssignedTo {
        setTo {
          PersonId
          Name
        }
      }
      bookingId
    }
  }
`;
export type AssignToBookingMutationFn = Apollo.MutationFunction<
  AssignToBookingMutation,
  AssignToBookingMutationVariables
>;
export type AssignToBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AssignToBookingMutation,
    AssignToBookingMutationVariables
  >,
  "mutation"
>;

export const AssignToBookingComponent = (props: AssignToBookingComponentProps) => (
  <ApolloReactComponents.Mutation<
    AssignToBookingMutation,
    AssignToBookingMutationVariables
  >
    mutation={AssignToBookingDocument}
    {...props}
  />
);

/**
 * __useAssignToBookingMutation__
 *
 * To run a mutation, you first call `useAssignToBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignToBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignToBookingMutation, { data, loading, error }] = useAssignToBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignToBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignToBookingMutation,
    AssignToBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignToBookingMutation, AssignToBookingMutationVariables>(
    AssignToBookingDocument,
    options
  );
}
export type AssignToBookingMutationHookResult = ReturnType<
  typeof useAssignToBookingMutation
>;
export namespace AssignToBooking {
  export type Return = AssignToBookingMutation;
  export type Variables = AssignToBookingMutationVariables;
  export const OperationName = "assignToBooking";

  export const Document = AssignToBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UnAssignToBookingDocument = gql`
  mutation unAssignToBooking($bookingId: ObjectId!, $userId: ObjectId!) {
    unAssignToBooking(bookingId: $bookingId, userId: $userId) {
      bookingAssignedTo {
        setTo {
          PersonId
          Name
        }
      }
      bookingId
    }
  }
`;
export type UnAssignToBookingMutationFn = Apollo.MutationFunction<
  UnAssignToBookingMutation,
  UnAssignToBookingMutationVariables
>;
export type UnAssignToBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UnAssignToBookingMutation,
    UnAssignToBookingMutationVariables
  >,
  "mutation"
>;

export const UnAssignToBookingComponent = (props: UnAssignToBookingComponentProps) => (
  <ApolloReactComponents.Mutation<
    UnAssignToBookingMutation,
    UnAssignToBookingMutationVariables
  >
    mutation={UnAssignToBookingDocument}
    {...props}
  />
);

/**
 * __useUnAssignToBookingMutation__
 *
 * To run a mutation, you first call `useUnAssignToBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnAssignToBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unAssignToBookingMutation, { data, loading, error }] = useUnAssignToBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnAssignToBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnAssignToBookingMutation,
    UnAssignToBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnAssignToBookingMutation,
    UnAssignToBookingMutationVariables
  >(UnAssignToBookingDocument, options);
}
export type UnAssignToBookingMutationHookResult = ReturnType<
  typeof useUnAssignToBookingMutation
>;
export namespace UnAssignToBooking {
  export type Return = UnAssignToBookingMutation;
  export type Variables = UnAssignToBookingMutationVariables;
  export const OperationName = "unAssignToBooking";

  export const Document = UnAssignToBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingKitSupportSearch_GetCustomerBillingInstructionsDocument = gql`
  query BookingKitSupportSearch_GetCustomerBillingInstructions($customerId: ObjectId!) {
    customerById(id: $customerId) {
      ...CustomerBillingInstructions
    }
  }
  ${CustomerBillingInstructionsFragmentDoc}
`;
export type BookingKitSupportSearch_GetCustomerBillingInstructionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKitSupportSearch_GetCustomerBillingInstructionsQuery,
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const BookingKitSupportSearch_GetCustomerBillingInstructionsComponent = (
  props: BookingKitSupportSearch_GetCustomerBillingInstructionsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKitSupportSearch_GetCustomerBillingInstructionsQuery,
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables
  >
    query={BookingKitSupportSearch_GetCustomerBillingInstructionsDocument}
    {...props}
  />
);

/**
 * __useBookingKitSupportSearch_GetCustomerBillingInstructionsQuery__
 *
 * To run a query within a React component, call `useBookingKitSupportSearch_GetCustomerBillingInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKitSupportSearch_GetCustomerBillingInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKitSupportSearch_GetCustomerBillingInstructionsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useBookingKitSupportSearch_GetCustomerBillingInstructionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKitSupportSearch_GetCustomerBillingInstructionsQuery,
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingKitSupportSearch_GetCustomerBillingInstructionsQuery,
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables
  >(BookingKitSupportSearch_GetCustomerBillingInstructionsDocument, options);
}
export function useBookingKitSupportSearch_GetCustomerBillingInstructionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKitSupportSearch_GetCustomerBillingInstructionsQuery,
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingKitSupportSearch_GetCustomerBillingInstructionsQuery,
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables
  >(BookingKitSupportSearch_GetCustomerBillingInstructionsDocument, options);
}
export type BookingKitSupportSearch_GetCustomerBillingInstructionsQueryHookResult =
  ReturnType<typeof useBookingKitSupportSearch_GetCustomerBillingInstructionsQuery>;
export type BookingKitSupportSearch_GetCustomerBillingInstructionsLazyQueryHookResult =
  ReturnType<typeof useBookingKitSupportSearch_GetCustomerBillingInstructionsLazyQuery>;
export namespace BookingKitSupportSearch_GetCustomerBillingInstructions {
  export type Return = BookingKitSupportSearch_GetCustomerBillingInstructionsQuery;
  export type Variables =
    BookingKitSupportSearch_GetCustomerBillingInstructionsQueryVariables;
  export const OperationName = "BookingKitSupportSearch_GetCustomerBillingInstructions";

  export const Document = BookingKitSupportSearch_GetCustomerBillingInstructionsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SyncTimeReportsWithBookingSearchDocument = gql`
  mutation SyncTimeReportsWithBookingSearch($ids: [String!]!) {
    syncTimeReportsWithBookingSearch(bookingIds: $ids)
  }
`;
export type SyncTimeReportsWithBookingSearchMutationFn = Apollo.MutationFunction<
  SyncTimeReportsWithBookingSearchMutation,
  SyncTimeReportsWithBookingSearchMutationVariables
>;
export type SyncTimeReportsWithBookingSearchComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SyncTimeReportsWithBookingSearchMutation,
    SyncTimeReportsWithBookingSearchMutationVariables
  >,
  "mutation"
>;

export const SyncTimeReportsWithBookingSearchComponent = (
  props: SyncTimeReportsWithBookingSearchComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SyncTimeReportsWithBookingSearchMutation,
    SyncTimeReportsWithBookingSearchMutationVariables
  >
    mutation={SyncTimeReportsWithBookingSearchDocument}
    {...props}
  />
);

/**
 * __useSyncTimeReportsWithBookingSearchMutation__
 *
 * To run a mutation, you first call `useSyncTimeReportsWithBookingSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncTimeReportsWithBookingSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncTimeReportsWithBookingSearchMutation, { data, loading, error }] = useSyncTimeReportsWithBookingSearchMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSyncTimeReportsWithBookingSearchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncTimeReportsWithBookingSearchMutation,
    SyncTimeReportsWithBookingSearchMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SyncTimeReportsWithBookingSearchMutation,
    SyncTimeReportsWithBookingSearchMutationVariables
  >(SyncTimeReportsWithBookingSearchDocument, options);
}
export type SyncTimeReportsWithBookingSearchMutationHookResult = ReturnType<
  typeof useSyncTimeReportsWithBookingSearchMutation
>;
export namespace SyncTimeReportsWithBookingSearch {
  export type Return = SyncTimeReportsWithBookingSearchMutation;
  export type Variables = SyncTimeReportsWithBookingSearchMutationVariables;
  export const OperationName = "SyncTimeReportsWithBookingSearch";

  export const Document = SyncTimeReportsWithBookingSearchDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationRequestSearchDocument = gql`
  query AccommodationRequestSearch(
    $filter: AccommodationRequestQueryInput!
    $skip: Int
    $limit: Int
    $sortBy: AccommodationRequestSortBy
    $sortOrder: SortOrder
  ) {
    accommodationRequestSearch(
      filter: $filter
      skip: $skip
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      dbTime
      items {
        ...AccommodationRequestSearchItem
      }
      skip
      limit
    }
  }
  ${AccommodationRequestSearchItemFragmentDoc}
`;
export type AccommodationRequestSearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationRequestSearchQuery,
    AccommodationRequestSearchQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationRequestSearchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationRequestSearchComponent = (
  props: AccommodationRequestSearchComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationRequestSearchQuery,
    AccommodationRequestSearchQueryVariables
  >
    query={AccommodationRequestSearchDocument}
    {...props}
  />
);

/**
 * __useAccommodationRequestSearchQuery__
 *
 * To run a query within a React component, call `useAccommodationRequestSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationRequestSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationRequestSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAccommodationRequestSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationRequestSearchQuery,
    AccommodationRequestSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationRequestSearchQuery,
    AccommodationRequestSearchQueryVariables
  >(AccommodationRequestSearchDocument, options);
}
export function useAccommodationRequestSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationRequestSearchQuery,
    AccommodationRequestSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationRequestSearchQuery,
    AccommodationRequestSearchQueryVariables
  >(AccommodationRequestSearchDocument, options);
}
export type AccommodationRequestSearchQueryHookResult = ReturnType<
  typeof useAccommodationRequestSearchQuery
>;
export type AccommodationRequestSearchLazyQueryHookResult = ReturnType<
  typeof useAccommodationRequestSearchLazyQuery
>;
export namespace AccommodationRequestSearch {
  export type Return = AccommodationRequestSearchQuery;
  export type Variables = AccommodationRequestSearchQueryVariables;
  export const OperationName = "AccommodationRequestSearch";

  export const Document = AccommodationRequestSearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AccommodationRequestSearchTotalDocument = gql`
  query AccommodationRequestSearchTotal($filter: AccommodationRequestQueryInput!) {
    accommodationRequestSearchTotal(filter: $filter) {
      dbTime
      total
    }
  }
`;
export type AccommodationRequestSearchTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationRequestSearchTotalQuery,
    AccommodationRequestSearchTotalQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationRequestSearchTotalQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationRequestSearchTotalComponent = (
  props: AccommodationRequestSearchTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationRequestSearchTotalQuery,
    AccommodationRequestSearchTotalQueryVariables
  >
    query={AccommodationRequestSearchTotalDocument}
    {...props}
  />
);

/**
 * __useAccommodationRequestSearchTotalQuery__
 *
 * To run a query within a React component, call `useAccommodationRequestSearchTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationRequestSearchTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationRequestSearchTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccommodationRequestSearchTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationRequestSearchTotalQuery,
    AccommodationRequestSearchTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationRequestSearchTotalQuery,
    AccommodationRequestSearchTotalQueryVariables
  >(AccommodationRequestSearchTotalDocument, options);
}
export function useAccommodationRequestSearchTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationRequestSearchTotalQuery,
    AccommodationRequestSearchTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationRequestSearchTotalQuery,
    AccommodationRequestSearchTotalQueryVariables
  >(AccommodationRequestSearchTotalDocument, options);
}
export type AccommodationRequestSearchTotalQueryHookResult = ReturnType<
  typeof useAccommodationRequestSearchTotalQuery
>;
export type AccommodationRequestSearchTotalLazyQueryHookResult = ReturnType<
  typeof useAccommodationRequestSearchTotalLazyQuery
>;
export namespace AccommodationRequestSearchTotal {
  export type Return = AccommodationRequestSearchTotalQuery;
  export type Variables = AccommodationRequestSearchTotalQueryVariables;
  export const OperationName = "AccommodationRequestSearchTotal";

  export const Document = AccommodationRequestSearchTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetAccommodationCardDocument = gql`
  query getAccommodationCard($accommodationId: ObjectId!) {
    getAccommodationDetails(accommodationId: $accommodationId) {
      ...AccommodationCardDetails
    }
  }
  ${AccommodationCardDetailsFragmentDoc}
`;
export type GetAccommodationCardComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAccommodationCardQuery,
    GetAccommodationCardQueryVariables
  >,
  "query"
> &
  ({ variables: GetAccommodationCardQueryVariables; skip?: boolean } | { skip: boolean });

export const GetAccommodationCardComponent = (
  props: GetAccommodationCardComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAccommodationCardQuery,
    GetAccommodationCardQueryVariables
  >
    query={GetAccommodationCardDocument}
    {...props}
  />
);

/**
 * __useGetAccommodationCardQuery__
 *
 * To run a query within a React component, call `useGetAccommodationCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccommodationCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccommodationCardQuery({
 *   variables: {
 *      accommodationId: // value for 'accommodationId'
 *   },
 * });
 */
export function useGetAccommodationCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccommodationCardQuery,
    GetAccommodationCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccommodationCardQuery, GetAccommodationCardQueryVariables>(
    GetAccommodationCardDocument,
    options
  );
}
export function useGetAccommodationCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccommodationCardQuery,
    GetAccommodationCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccommodationCardQuery,
    GetAccommodationCardQueryVariables
  >(GetAccommodationCardDocument, options);
}
export type GetAccommodationCardQueryHookResult = ReturnType<
  typeof useGetAccommodationCardQuery
>;
export type GetAccommodationCardLazyQueryHookResult = ReturnType<
  typeof useGetAccommodationCardLazyQuery
>;
export namespace GetAccommodationCard {
  export type Return = GetAccommodationCardQuery;
  export type Variables = GetAccommodationCardQueryVariables;
  export const OperationName = "getAccommodationCard";

  export const Document = GetAccommodationCardDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Accommodation_EditDocument = gql`
  mutation Accommodation_Edit($id: ObjectId!, $data: AccommodationInput!, $img: Upload) {
    editAccommodation(accommodationId: $id, data: $data, img: $img) {
      ...AccommodationCardDetails
    }
  }
  ${AccommodationCardDetailsFragmentDoc}
`;
export type Accommodation_EditMutationFn = Apollo.MutationFunction<
  Accommodation_EditMutation,
  Accommodation_EditMutationVariables
>;
export type Accommodation_EditComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Accommodation_EditMutation,
    Accommodation_EditMutationVariables
  >,
  "mutation"
>;

export const Accommodation_EditComponent = (props: Accommodation_EditComponentProps) => (
  <ApolloReactComponents.Mutation<
    Accommodation_EditMutation,
    Accommodation_EditMutationVariables
  >
    mutation={Accommodation_EditDocument}
    {...props}
  />
);

/**
 * __useAccommodation_EditMutation__
 *
 * To run a mutation, you first call `useAccommodation_EditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodation_EditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationEditMutation, { data, loading, error }] = useAccommodation_EditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      img: // value for 'img'
 *   },
 * });
 */
export function useAccommodation_EditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Accommodation_EditMutation,
    Accommodation_EditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Accommodation_EditMutation,
    Accommodation_EditMutationVariables
  >(Accommodation_EditDocument, options);
}
export type Accommodation_EditMutationHookResult = ReturnType<
  typeof useAccommodation_EditMutation
>;
export namespace Accommodation_Edit {
  export type Return = Accommodation_EditMutation;
  export type Variables = Accommodation_EditMutationVariables;
  export const OperationName = "Accommodation_Edit";

  export const Document = Accommodation_EditDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Accommodation_AddDocument = gql`
  mutation Accommodation_Add(
    $responsiblePersonId: ObjectId!
    $data: AccommodationInput!
    $img: Upload
  ) {
    addAccommodation(responsiblePersonId: $responsiblePersonId, data: $data, img: $img) {
      ...AccommodationCardDetails
    }
  }
  ${AccommodationCardDetailsFragmentDoc}
`;
export type Accommodation_AddMutationFn = Apollo.MutationFunction<
  Accommodation_AddMutation,
  Accommodation_AddMutationVariables
>;
export type Accommodation_AddComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Accommodation_AddMutation,
    Accommodation_AddMutationVariables
  >,
  "mutation"
>;

export const Accommodation_AddComponent = (props: Accommodation_AddComponentProps) => (
  <ApolloReactComponents.Mutation<
    Accommodation_AddMutation,
    Accommodation_AddMutationVariables
  >
    mutation={Accommodation_AddDocument}
    {...props}
  />
);

/**
 * __useAccommodation_AddMutation__
 *
 * To run a mutation, you first call `useAccommodation_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodation_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationAddMutation, { data, loading, error }] = useAccommodation_AddMutation({
 *   variables: {
 *      responsiblePersonId: // value for 'responsiblePersonId'
 *      data: // value for 'data'
 *      img: // value for 'img'
 *   },
 * });
 */
export function useAccommodation_AddMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Accommodation_AddMutation,
    Accommodation_AddMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Accommodation_AddMutation,
    Accommodation_AddMutationVariables
  >(Accommodation_AddDocument, options);
}
export type Accommodation_AddMutationHookResult = ReturnType<
  typeof useAccommodation_AddMutation
>;
export namespace Accommodation_Add {
  export type Return = Accommodation_AddMutation;
  export type Variables = Accommodation_AddMutationVariables;
  export const OperationName = "Accommodation_Add";

  export const Document = Accommodation_AddDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetAccommodationFilesDocument = gql`
  query getAccommodationFiles($id: ObjectId!) {
    accommodation: getAccommodationDetails(accommodationId: $id) {
      _id
      documents {
        DocumentType
        ThumbURL
        PdfURL
        FileRef {
          Name
          NodeID
          NodeType
          MimeType
          Size
        }
      }
    }
  }
`;
export type GetAccommodationFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAccommodationFilesQuery,
    GetAccommodationFilesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetAccommodationFilesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetAccommodationFilesComponent = (
  props: GetAccommodationFilesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAccommodationFilesQuery,
    GetAccommodationFilesQueryVariables
  >
    query={GetAccommodationFilesDocument}
    {...props}
  />
);

/**
 * __useGetAccommodationFilesQuery__
 *
 * To run a query within a React component, call `useGetAccommodationFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccommodationFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccommodationFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccommodationFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccommodationFilesQuery,
    GetAccommodationFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccommodationFilesQuery, GetAccommodationFilesQueryVariables>(
    GetAccommodationFilesDocument,
    options
  );
}
export function useGetAccommodationFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccommodationFilesQuery,
    GetAccommodationFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccommodationFilesQuery,
    GetAccommodationFilesQueryVariables
  >(GetAccommodationFilesDocument, options);
}
export type GetAccommodationFilesQueryHookResult = ReturnType<
  typeof useGetAccommodationFilesQuery
>;
export type GetAccommodationFilesLazyQueryHookResult = ReturnType<
  typeof useGetAccommodationFilesLazyQuery
>;
export namespace GetAccommodationFiles {
  export type Return = GetAccommodationFilesQuery;
  export type Variables = GetAccommodationFilesQueryVariables;
  export const OperationName = "getAccommodationFiles";

  export const Document = GetAccommodationFilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadAccommodationFileDocument = gql`
  mutation uploadAccommodationFile(
    $id: ObjectId!
    $file: Upload!
    $documentType: AccommodationDocumentType!
  ) {
    uploadAccommodationDocument(id: $id, file: $file, documentType: $documentType) {
      DocumentType
      FileRef {
        Name
        NodeID
        NodeType
        MimeType
        Size
      }
    }
  }
`;
export type UploadAccommodationFileMutationFn = Apollo.MutationFunction<
  UploadAccommodationFileMutation,
  UploadAccommodationFileMutationVariables
>;
export type UploadAccommodationFileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadAccommodationFileMutation,
    UploadAccommodationFileMutationVariables
  >,
  "mutation"
>;

export const UploadAccommodationFileComponent = (
  props: UploadAccommodationFileComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadAccommodationFileMutation,
    UploadAccommodationFileMutationVariables
  >
    mutation={UploadAccommodationFileDocument}
    {...props}
  />
);

/**
 * __useUploadAccommodationFileMutation__
 *
 * To run a mutation, you first call `useUploadAccommodationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAccommodationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAccommodationFileMutation, { data, loading, error }] = useUploadAccommodationFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadAccommodationFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAccommodationFileMutation,
    UploadAccommodationFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadAccommodationFileMutation,
    UploadAccommodationFileMutationVariables
  >(UploadAccommodationFileDocument, options);
}
export type UploadAccommodationFileMutationHookResult = ReturnType<
  typeof useUploadAccommodationFileMutation
>;
export namespace UploadAccommodationFile {
  export type Return = UploadAccommodationFileMutation;
  export type Variables = UploadAccommodationFileMutationVariables;
  export const OperationName = "uploadAccommodationFile";

  export const Document = UploadAccommodationFileDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteAccommodationDocDocument = gql`
  mutation deleteAccommodationDoc($id: ObjectId!, $fileId: ObjectId!) {
    deleteAccommodationDocument(id: $id, fileId: $fileId)
  }
`;
export type DeleteAccommodationDocMutationFn = Apollo.MutationFunction<
  DeleteAccommodationDocMutation,
  DeleteAccommodationDocMutationVariables
>;
export type DeleteAccommodationDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteAccommodationDocMutation,
    DeleteAccommodationDocMutationVariables
  >,
  "mutation"
>;

export const DeleteAccommodationDocComponent = (
  props: DeleteAccommodationDocComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteAccommodationDocMutation,
    DeleteAccommodationDocMutationVariables
  >
    mutation={DeleteAccommodationDocDocument}
    {...props}
  />
);

/**
 * __useDeleteAccommodationDocMutation__
 *
 * To run a mutation, you first call `useDeleteAccommodationDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccommodationDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccommodationDocMutation, { data, loading, error }] = useDeleteAccommodationDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteAccommodationDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAccommodationDocMutation,
    DeleteAccommodationDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAccommodationDocMutation,
    DeleteAccommodationDocMutationVariables
  >(DeleteAccommodationDocDocument, options);
}
export type DeleteAccommodationDocMutationHookResult = ReturnType<
  typeof useDeleteAccommodationDocMutation
>;
export namespace DeleteAccommodationDoc {
  export type Return = DeleteAccommodationDocMutation;
  export type Variables = DeleteAccommodationDocMutationVariables;
  export const OperationName = "deleteAccommodationDoc";

  export const Document = DeleteAccommodationDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Accommodation_DetailsDocument = gql`
  query Accommodation_Details($id: ObjectId!) {
    getAccommodationDetails(accommodationId: $id) {
      ...AccommodationCardDetails
    }
  }
  ${AccommodationCardDetailsFragmentDoc}
`;
export type Accommodation_DetailsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Accommodation_DetailsQuery,
    Accommodation_DetailsQueryVariables
  >,
  "query"
> &
  (
    | { variables: Accommodation_DetailsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Accommodation_DetailsComponent = (
  props: Accommodation_DetailsComponentProps
) => (
  <ApolloReactComponents.Query<
    Accommodation_DetailsQuery,
    Accommodation_DetailsQueryVariables
  >
    query={Accommodation_DetailsDocument}
    {...props}
  />
);

/**
 * __useAccommodation_DetailsQuery__
 *
 * To run a query within a React component, call `useAccommodation_DetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodation_DetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodation_DetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodation_DetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Accommodation_DetailsQuery,
    Accommodation_DetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Accommodation_DetailsQuery, Accommodation_DetailsQueryVariables>(
    Accommodation_DetailsDocument,
    options
  );
}
export function useAccommodation_DetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Accommodation_DetailsQuery,
    Accommodation_DetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Accommodation_DetailsQuery,
    Accommodation_DetailsQueryVariables
  >(Accommodation_DetailsDocument, options);
}
export type Accommodation_DetailsQueryHookResult = ReturnType<
  typeof useAccommodation_DetailsQuery
>;
export type Accommodation_DetailsLazyQueryHookResult = ReturnType<
  typeof useAccommodation_DetailsLazyQuery
>;
export namespace Accommodation_Details {
  export type Return = Accommodation_DetailsQuery;
  export type Variables = Accommodation_DetailsQueryVariables;
  export const OperationName = "Accommodation_Details";

  export const Document = Accommodation_DetailsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AccommodationUpdateUnfitDocument = gql`
  mutation AccommodationUpdateUnfit($id: ObjectId!, $value: Boolean!, $comment: String!) {
    updateUnfitAccommodation(id: $id, value: $value, comment: $comment) {
      value
      comment
      userRef {
        PersonId
        Name
      }
    }
  }
`;
export type AccommodationUpdateUnfitMutationFn = Apollo.MutationFunction<
  AccommodationUpdateUnfitMutation,
  AccommodationUpdateUnfitMutationVariables
>;
export type AccommodationUpdateUnfitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AccommodationUpdateUnfitMutation,
    AccommodationUpdateUnfitMutationVariables
  >,
  "mutation"
>;

export const AccommodationUpdateUnfitComponent = (
  props: AccommodationUpdateUnfitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AccommodationUpdateUnfitMutation,
    AccommodationUpdateUnfitMutationVariables
  >
    mutation={AccommodationUpdateUnfitDocument}
    {...props}
  />
);

/**
 * __useAccommodationUpdateUnfitMutation__
 *
 * To run a mutation, you first call `useAccommodationUpdateUnfitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationUpdateUnfitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationUpdateUnfitMutation, { data, loading, error }] = useAccommodationUpdateUnfitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAccommodationUpdateUnfitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccommodationUpdateUnfitMutation,
    AccommodationUpdateUnfitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AccommodationUpdateUnfitMutation,
    AccommodationUpdateUnfitMutationVariables
  >(AccommodationUpdateUnfitDocument, options);
}
export type AccommodationUpdateUnfitMutationHookResult = ReturnType<
  typeof useAccommodationUpdateUnfitMutation
>;
export namespace AccommodationUpdateUnfit {
  export type Return = AccommodationUpdateUnfitMutation;
  export type Variables = AccommodationUpdateUnfitMutationVariables;
  export const OperationName = "AccommodationUpdateUnfit";

  export const Document = AccommodationUpdateUnfitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Accommodation_DeleteDocument = gql`
  mutation Accommodation_delete($id: ObjectId!) {
    deleteAccommodation(accommodationId: $id) {
      _id
    }
  }
`;
export type Accommodation_DeleteMutationFn = Apollo.MutationFunction<
  Accommodation_DeleteMutation,
  Accommodation_DeleteMutationVariables
>;
export type Accommodation_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Accommodation_DeleteMutation,
    Accommodation_DeleteMutationVariables
  >,
  "mutation"
>;

export const Accommodation_DeleteComponent = (
  props: Accommodation_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Accommodation_DeleteMutation,
    Accommodation_DeleteMutationVariables
  >
    mutation={Accommodation_DeleteDocument}
    {...props}
  />
);

/**
 * __useAccommodation_DeleteMutation__
 *
 * To run a mutation, you first call `useAccommodation_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodation_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationDeleteMutation, { data, loading, error }] = useAccommodation_DeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodation_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Accommodation_DeleteMutation,
    Accommodation_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Accommodation_DeleteMutation,
    Accommodation_DeleteMutationVariables
  >(Accommodation_DeleteDocument, options);
}
export type Accommodation_DeleteMutationHookResult = ReturnType<
  typeof useAccommodation_DeleteMutation
>;
export namespace Accommodation_delete {
  export type Return = Accommodation_DeleteMutation;
  export type Variables = Accommodation_DeleteMutationVariables;
  export const OperationName = "Accommodation_delete";

  export const Document = Accommodation_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationSearch_SearchDocument = gql`
  query AccommodationSearch_Search(
    $input: AccommodationFilter
    $skip: Int!
    $limit: Int!
  ) {
    getAccommodations(input: $input, limit: $limit, skip: $skip) {
      ...AccommodationCardListItem
    }
    getAccommodationsCount(input: $input) {
      total
    }
  }
  ${AccommodationCardListItemFragmentDoc}
`;
export type AccommodationSearch_SearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationSearch_SearchQuery,
    AccommodationSearch_SearchQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationSearch_SearchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationSearch_SearchComponent = (
  props: AccommodationSearch_SearchComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationSearch_SearchQuery,
    AccommodationSearch_SearchQueryVariables
  >
    query={AccommodationSearch_SearchDocument}
    {...props}
  />
);

/**
 * __useAccommodationSearch_SearchQuery__
 *
 * To run a query within a React component, call `useAccommodationSearch_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationSearch_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationSearch_SearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAccommodationSearch_SearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationSearch_SearchQuery,
    AccommodationSearch_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationSearch_SearchQuery,
    AccommodationSearch_SearchQueryVariables
  >(AccommodationSearch_SearchDocument, options);
}
export function useAccommodationSearch_SearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationSearch_SearchQuery,
    AccommodationSearch_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationSearch_SearchQuery,
    AccommodationSearch_SearchQueryVariables
  >(AccommodationSearch_SearchDocument, options);
}
export type AccommodationSearch_SearchQueryHookResult = ReturnType<
  typeof useAccommodationSearch_SearchQuery
>;
export type AccommodationSearch_SearchLazyQueryHookResult = ReturnType<
  typeof useAccommodationSearch_SearchLazyQuery
>;
export namespace AccommodationSearch_Search {
  export type Return = AccommodationSearch_SearchQuery;
  export type Variables = AccommodationSearch_SearchQueryVariables;
  export const OperationName = "AccommodationSearch_Search";

  export const Document = AccommodationSearch_SearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AssignToBookingKitDocument = gql`
  mutation AssignToBookingKit($kitId: ObjectId!, $userId: ObjectId!) {
    assignToBookingKit(kitId: $kitId, userId: $userId)
  }
`;
export type AssignToBookingKitMutationFn = Apollo.MutationFunction<
  AssignToBookingKitMutation,
  AssignToBookingKitMutationVariables
>;
export type AssignToBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AssignToBookingKitMutation,
    AssignToBookingKitMutationVariables
  >,
  "mutation"
>;

export const AssignToBookingKitComponent = (props: AssignToBookingKitComponentProps) => (
  <ApolloReactComponents.Mutation<
    AssignToBookingKitMutation,
    AssignToBookingKitMutationVariables
  >
    mutation={AssignToBookingKitDocument}
    {...props}
  />
);

/**
 * __useAssignToBookingKitMutation__
 *
 * To run a mutation, you first call `useAssignToBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignToBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignToBookingKitMutation, { data, loading, error }] = useAssignToBookingKitMutation({
 *   variables: {
 *      kitId: // value for 'kitId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignToBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignToBookingKitMutation,
    AssignToBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignToBookingKitMutation,
    AssignToBookingKitMutationVariables
  >(AssignToBookingKitDocument, options);
}
export type AssignToBookingKitMutationHookResult = ReturnType<
  typeof useAssignToBookingKitMutation
>;
export namespace AssignToBookingKit {
  export type Return = AssignToBookingKitMutation;
  export type Variables = AssignToBookingKitMutationVariables;
  export const OperationName = "AssignToBookingKit";

  export const Document = AssignToBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UnAssignFromBookingKitDocument = gql`
  mutation UnAssignFromBookingKit($kitId: ObjectId!, $userId: ObjectId!) {
    unAssignFromBookingKit(kitId: $kitId, userId: $userId)
  }
`;
export type UnAssignFromBookingKitMutationFn = Apollo.MutationFunction<
  UnAssignFromBookingKitMutation,
  UnAssignFromBookingKitMutationVariables
>;
export type UnAssignFromBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UnAssignFromBookingKitMutation,
    UnAssignFromBookingKitMutationVariables
  >,
  "mutation"
>;

export const UnAssignFromBookingKitComponent = (
  props: UnAssignFromBookingKitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UnAssignFromBookingKitMutation,
    UnAssignFromBookingKitMutationVariables
  >
    mutation={UnAssignFromBookingKitDocument}
    {...props}
  />
);

/**
 * __useUnAssignFromBookingKitMutation__
 *
 * To run a mutation, you first call `useUnAssignFromBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnAssignFromBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unAssignFromBookingKitMutation, { data, loading, error }] = useUnAssignFromBookingKitMutation({
 *   variables: {
 *      kitId: // value for 'kitId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnAssignFromBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnAssignFromBookingKitMutation,
    UnAssignFromBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnAssignFromBookingKitMutation,
    UnAssignFromBookingKitMutationVariables
  >(UnAssignFromBookingKitDocument, options);
}
export type UnAssignFromBookingKitMutationHookResult = ReturnType<
  typeof useUnAssignFromBookingKitMutation
>;
export namespace UnAssignFromBookingKit {
  export type Return = UnAssignFromBookingKitMutation;
  export type Variables = UnAssignFromBookingKitMutationVariables;
  export const OperationName = "UnAssignFromBookingKit";

  export const Document = UnAssignFromBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingKitSearchDocument = gql`
  query BookingKitSearch(
    $filter: BookingKitQueryInput!
    $skip: Int
    $limit: Int
    $sortBy: BookingKitSortBy
    $sortOrder: SortOrder
  ) {
    bookingKitSearch(
      filter: $filter
      skip: $skip
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      dbTime
      items {
        ...BookingKitSearchItem
      }
      skip
      limit
    }
  }
  ${BookingKitSearchItemFragmentDoc}
`;
export type BookingKitSearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKitSearchQuery,
    BookingKitSearchQueryVariables
  >,
  "query"
> &
  ({ variables: BookingKitSearchQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingKitSearchComponent = (props: BookingKitSearchComponentProps) => (
  <ApolloReactComponents.Query<BookingKitSearchQuery, BookingKitSearchQueryVariables>
    query={BookingKitSearchDocument}
    {...props}
  />
);

/**
 * __useBookingKitSearchQuery__
 *
 * To run a query within a React component, call `useBookingKitSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKitSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKitSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useBookingKitSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKitSearchQuery,
    BookingKitSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingKitSearchQuery, BookingKitSearchQueryVariables>(
    BookingKitSearchDocument,
    options
  );
}
export function useBookingKitSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKitSearchQuery,
    BookingKitSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingKitSearchQuery, BookingKitSearchQueryVariables>(
    BookingKitSearchDocument,
    options
  );
}
export type BookingKitSearchQueryHookResult = ReturnType<typeof useBookingKitSearchQuery>;
export type BookingKitSearchLazyQueryHookResult = ReturnType<
  typeof useBookingKitSearchLazyQuery
>;
export namespace BookingKitSearch {
  export type Return = BookingKitSearchQuery;
  export type Variables = BookingKitSearchQueryVariables;
  export const OperationName = "BookingKitSearch";

  export const Document = BookingKitSearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingKitSearchTotalDocument = gql`
  query BookingKitSearchTotal($filter: BookingKitQueryInput!) {
    bookingKitSearchTotal(filter: $filter) {
      dbTime
      total
    }
  }
`;
export type BookingKitSearchTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKitSearchTotalQuery,
    BookingKitSearchTotalQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingKitSearchTotalQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingKitSearchTotalComponent = (
  props: BookingKitSearchTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKitSearchTotalQuery,
    BookingKitSearchTotalQueryVariables
  >
    query={BookingKitSearchTotalDocument}
    {...props}
  />
);

/**
 * __useBookingKitSearchTotalQuery__
 *
 * To run a query within a React component, call `useBookingKitSearchTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKitSearchTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKitSearchTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookingKitSearchTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKitSearchTotalQuery,
    BookingKitSearchTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingKitSearchTotalQuery, BookingKitSearchTotalQueryVariables>(
    BookingKitSearchTotalDocument,
    options
  );
}
export function useBookingKitSearchTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKitSearchTotalQuery,
    BookingKitSearchTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingKitSearchTotalQuery,
    BookingKitSearchTotalQueryVariables
  >(BookingKitSearchTotalDocument, options);
}
export type BookingKitSearchTotalQueryHookResult = ReturnType<
  typeof useBookingKitSearchTotalQuery
>;
export type BookingKitSearchTotalLazyQueryHookResult = ReturnType<
  typeof useBookingKitSearchTotalLazyQuery
>;
export namespace BookingKitSearchTotal {
  export type Return = BookingKitSearchTotalQuery;
  export type Variables = BookingKitSearchTotalQueryVariables;
  export const OperationName = "BookingKitSearchTotal";

  export const Document = BookingKitSearchTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingKitEventLog_GetEventsDocument = gql`
  query BookingKitEventLog_GetEvents(
    $kitId: ObjectId!
    $skip: Int
    $limit: Int
    $types: [BookingKitEventType]
  ) {
    bookingKitEvents(kitId: $kitId, skip: $skip, limit: $limit, types: $types) {
      ...EventLog_BookingKitEvent
    }
  }
  ${EventLog_BookingKitEventFragmentDoc}
`;
export type BookingKitEventLog_GetEventsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKitEventLog_GetEventsQuery,
    BookingKitEventLog_GetEventsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingKitEventLog_GetEventsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingKitEventLog_GetEventsComponent = (
  props: BookingKitEventLog_GetEventsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKitEventLog_GetEventsQuery,
    BookingKitEventLog_GetEventsQueryVariables
  >
    query={BookingKitEventLog_GetEventsDocument}
    {...props}
  />
);

/**
 * __useBookingKitEventLog_GetEventsQuery__
 *
 * To run a query within a React component, call `useBookingKitEventLog_GetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKitEventLog_GetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKitEventLog_GetEventsQuery({
 *   variables: {
 *      kitId: // value for 'kitId'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useBookingKitEventLog_GetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKitEventLog_GetEventsQuery,
    BookingKitEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingKitEventLog_GetEventsQuery,
    BookingKitEventLog_GetEventsQueryVariables
  >(BookingKitEventLog_GetEventsDocument, options);
}
export function useBookingKitEventLog_GetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKitEventLog_GetEventsQuery,
    BookingKitEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingKitEventLog_GetEventsQuery,
    BookingKitEventLog_GetEventsQueryVariables
  >(BookingKitEventLog_GetEventsDocument, options);
}
export type BookingKitEventLog_GetEventsQueryHookResult = ReturnType<
  typeof useBookingKitEventLog_GetEventsQuery
>;
export type BookingKitEventLog_GetEventsLazyQueryHookResult = ReturnType<
  typeof useBookingKitEventLog_GetEventsLazyQuery
>;
export namespace BookingKitEventLog_GetEvents {
  export type Return = BookingKitEventLog_GetEventsQuery;
  export type Variables = BookingKitEventLog_GetEventsQueryVariables;
  export const OperationName = "BookingKitEventLog_GetEvents";

  export const Document = BookingKitEventLog_GetEventsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingKitEventLog_AddCommentDocument = gql`
  mutation BookingKitEventLog_AddComment($kitId: ObjectId!, $desc: String!) {
    addBookingKitCommentEvent(kitId: $kitId, desc: $desc) {
      ...EventLog_BookingKitEvent
    }
  }
  ${EventLog_BookingKitEventFragmentDoc}
`;
export type BookingKitEventLog_AddCommentMutationFn = Apollo.MutationFunction<
  BookingKitEventLog_AddCommentMutation,
  BookingKitEventLog_AddCommentMutationVariables
>;
export type BookingKitEventLog_AddCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingKitEventLog_AddCommentMutation,
    BookingKitEventLog_AddCommentMutationVariables
  >,
  "mutation"
>;

export const BookingKitEventLog_AddCommentComponent = (
  props: BookingKitEventLog_AddCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingKitEventLog_AddCommentMutation,
    BookingKitEventLog_AddCommentMutationVariables
  >
    mutation={BookingKitEventLog_AddCommentDocument}
    {...props}
  />
);

/**
 * __useBookingKitEventLog_AddCommentMutation__
 *
 * To run a mutation, you first call `useBookingKitEventLog_AddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingKitEventLog_AddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingKitEventLogAddCommentMutation, { data, loading, error }] = useBookingKitEventLog_AddCommentMutation({
 *   variables: {
 *      kitId: // value for 'kitId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useBookingKitEventLog_AddCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingKitEventLog_AddCommentMutation,
    BookingKitEventLog_AddCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingKitEventLog_AddCommentMutation,
    BookingKitEventLog_AddCommentMutationVariables
  >(BookingKitEventLog_AddCommentDocument, options);
}
export type BookingKitEventLog_AddCommentMutationHookResult = ReturnType<
  typeof useBookingKitEventLog_AddCommentMutation
>;
export namespace BookingKitEventLog_AddComment {
  export type Return = BookingKitEventLog_AddCommentMutation;
  export type Variables = BookingKitEventLog_AddCommentMutationVariables;
  export const OperationName = "BookingKitEventLog_AddComment";

  export const Document = BookingKitEventLog_AddCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingKitEventLog_UpdateDocument = gql`
  mutation BookingKitEventLog_Update(
    $eventId: ObjectId!
    $desc: String
    $sticky: Boolean
  ) {
    updateBookingKitEvent(eventId: $eventId, desc: $desc, sticky: $sticky) {
      ...EventLog_BookingKitEvent
    }
  }
  ${EventLog_BookingKitEventFragmentDoc}
`;
export type BookingKitEventLog_UpdateMutationFn = Apollo.MutationFunction<
  BookingKitEventLog_UpdateMutation,
  BookingKitEventLog_UpdateMutationVariables
>;
export type BookingKitEventLog_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingKitEventLog_UpdateMutation,
    BookingKitEventLog_UpdateMutationVariables
  >,
  "mutation"
>;

export const BookingKitEventLog_UpdateComponent = (
  props: BookingKitEventLog_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingKitEventLog_UpdateMutation,
    BookingKitEventLog_UpdateMutationVariables
  >
    mutation={BookingKitEventLog_UpdateDocument}
    {...props}
  />
);

/**
 * __useBookingKitEventLog_UpdateMutation__
 *
 * To run a mutation, you first call `useBookingKitEventLog_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingKitEventLog_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingKitEventLogUpdateMutation, { data, loading, error }] = useBookingKitEventLog_UpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      desc: // value for 'desc'
 *      sticky: // value for 'sticky'
 *   },
 * });
 */
export function useBookingKitEventLog_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingKitEventLog_UpdateMutation,
    BookingKitEventLog_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingKitEventLog_UpdateMutation,
    BookingKitEventLog_UpdateMutationVariables
  >(BookingKitEventLog_UpdateDocument, options);
}
export type BookingKitEventLog_UpdateMutationHookResult = ReturnType<
  typeof useBookingKitEventLog_UpdateMutation
>;
export namespace BookingKitEventLog_Update {
  export type Return = BookingKitEventLog_UpdateMutation;
  export type Variables = BookingKitEventLog_UpdateMutationVariables;
  export const OperationName = "BookingKitEventLog_Update";

  export const Document = BookingKitEventLog_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingKitEventLog_DeleteDocument = gql`
  mutation BookingKitEventLog_Delete($eventId: ObjectId!) {
    deleteBookingKitEvent(eventId: $eventId) {
      ...EventLog_BookingKitEvent
    }
  }
  ${EventLog_BookingKitEventFragmentDoc}
`;
export type BookingKitEventLog_DeleteMutationFn = Apollo.MutationFunction<
  BookingKitEventLog_DeleteMutation,
  BookingKitEventLog_DeleteMutationVariables
>;
export type BookingKitEventLog_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingKitEventLog_DeleteMutation,
    BookingKitEventLog_DeleteMutationVariables
  >,
  "mutation"
>;

export const BookingKitEventLog_DeleteComponent = (
  props: BookingKitEventLog_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingKitEventLog_DeleteMutation,
    BookingKitEventLog_DeleteMutationVariables
  >
    mutation={BookingKitEventLog_DeleteDocument}
    {...props}
  />
);

/**
 * __useBookingKitEventLog_DeleteMutation__
 *
 * To run a mutation, you first call `useBookingKitEventLog_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingKitEventLog_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingKitEventLogDeleteMutation, { data, loading, error }] = useBookingKitEventLog_DeleteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useBookingKitEventLog_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingKitEventLog_DeleteMutation,
    BookingKitEventLog_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingKitEventLog_DeleteMutation,
    BookingKitEventLog_DeleteMutationVariables
  >(BookingKitEventLog_DeleteDocument, options);
}
export type BookingKitEventLog_DeleteMutationHookResult = ReturnType<
  typeof useBookingKitEventLog_DeleteMutation
>;
export namespace BookingKitEventLog_Delete {
  export type Return = BookingKitEventLog_DeleteMutation;
  export type Variables = BookingKitEventLog_DeleteMutationVariables;
  export const OperationName = "BookingKitEventLog_Delete";

  export const Document = BookingKitEventLog_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetKitDocument = gql`
  query getKit($id: ObjectId!) {
    bookingKit(id: $id) {
      ...KitProfileCard
    }
  }
  ${KitProfileCardFragmentDoc}
`;
export type GetKitComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetKitQuery, GetKitQueryVariables>,
  "query"
> &
  ({ variables: GetKitQueryVariables; skip?: boolean } | { skip: boolean });

export const GetKitComponent = (props: GetKitComponentProps) => (
  <ApolloReactComponents.Query<GetKitQuery, GetKitQueryVariables>
    query={GetKitDocument}
    {...props}
  />
);

/**
 * __useGetKitQuery__
 *
 * To run a query within a React component, call `useGetKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKitQuery(
  baseOptions?: Apollo.QueryHookOptions<GetKitQuery, GetKitQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKitQuery, GetKitQueryVariables>(GetKitDocument, options);
}
export function useGetKitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetKitQuery, GetKitQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetKitQuery, GetKitQueryVariables>(GetKitDocument, options);
}
export type GetKitQueryHookResult = ReturnType<typeof useGetKitQuery>;
export type GetKitLazyQueryHookResult = ReturnType<typeof useGetKitLazyQuery>;
export namespace GetKit {
  export type Return = GetKitQuery;
  export type Variables = GetKitQueryVariables;
  export const OperationName = "getKit";

  export const Document = GetKitDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetKitApprovalConfigDocument = gql`
  query getKitApprovalConfig($id: ObjectId!) {
    bookingKitApprovalConfig(id: $id) {
      canApprove
      canReject
      canRejectDone
    }
  }
`;
export type GetKitApprovalConfigComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetKitApprovalConfigQuery,
    GetKitApprovalConfigQueryVariables
  >,
  "query"
> &
  ({ variables: GetKitApprovalConfigQueryVariables; skip?: boolean } | { skip: boolean });

export const GetKitApprovalConfigComponent = (
  props: GetKitApprovalConfigComponentProps
) => (
  <ApolloReactComponents.Query<
    GetKitApprovalConfigQuery,
    GetKitApprovalConfigQueryVariables
  >
    query={GetKitApprovalConfigDocument}
    {...props}
  />
);

/**
 * __useGetKitApprovalConfigQuery__
 *
 * To run a query within a React component, call `useGetKitApprovalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKitApprovalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKitApprovalConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKitApprovalConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetKitApprovalConfigQuery,
    GetKitApprovalConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKitApprovalConfigQuery, GetKitApprovalConfigQueryVariables>(
    GetKitApprovalConfigDocument,
    options
  );
}
export function useGetKitApprovalConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetKitApprovalConfigQuery,
    GetKitApprovalConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetKitApprovalConfigQuery,
    GetKitApprovalConfigQueryVariables
  >(GetKitApprovalConfigDocument, options);
}
export type GetKitApprovalConfigQueryHookResult = ReturnType<
  typeof useGetKitApprovalConfigQuery
>;
export type GetKitApprovalConfigLazyQueryHookResult = ReturnType<
  typeof useGetKitApprovalConfigLazyQuery
>;
export namespace GetKitApprovalConfig {
  export type Return = GetKitApprovalConfigQuery;
  export type Variables = GetKitApprovalConfigQueryVariables;
  export const OperationName = "getKitApprovalConfig";

  export const Document = GetKitApprovalConfigDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const DeleteBookingKitDocument = gql`
  mutation deleteBookingKit($id: ObjectId!) {
    deleteBookingKit(id: $id)
  }
`;
export type DeleteBookingKitMutationFn = Apollo.MutationFunction<
  DeleteBookingKitMutation,
  DeleteBookingKitMutationVariables
>;
export type DeleteBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteBookingKitMutation,
    DeleteBookingKitMutationVariables
  >,
  "mutation"
>;

export const DeleteBookingKitComponent = (props: DeleteBookingKitComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteBookingKitMutation,
    DeleteBookingKitMutationVariables
  >
    mutation={DeleteBookingKitDocument}
    {...props}
  />
);

/**
 * __useDeleteBookingKitMutation__
 *
 * To run a mutation, you first call `useDeleteBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingKitMutation, { data, loading, error }] = useDeleteBookingKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBookingKitMutation,
    DeleteBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBookingKitMutation, DeleteBookingKitMutationVariables>(
    DeleteBookingKitDocument,
    options
  );
}
export type DeleteBookingKitMutationHookResult = ReturnType<
  typeof useDeleteBookingKitMutation
>;
export namespace DeleteBookingKit {
  export type Return = DeleteBookingKitMutation;
  export type Variables = DeleteBookingKitMutationVariables;
  export const OperationName = "deleteBookingKit";

  export const Document = DeleteBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ApproveBookingKitDocument = gql`
  mutation approveBookingKit($id: ObjectId!, $comment: String) {
    approveBookingKit(id: $id, comment: $comment) {
      ...BookingKitProfile
    }
  }
  ${BookingKitProfileFragmentDoc}
`;
export type ApproveBookingKitMutationFn = Apollo.MutationFunction<
  ApproveBookingKitMutation,
  ApproveBookingKitMutationVariables
>;
export type ApproveBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ApproveBookingKitMutation,
    ApproveBookingKitMutationVariables
  >,
  "mutation"
>;

export const ApproveBookingKitComponent = (props: ApproveBookingKitComponentProps) => (
  <ApolloReactComponents.Mutation<
    ApproveBookingKitMutation,
    ApproveBookingKitMutationVariables
  >
    mutation={ApproveBookingKitDocument}
    {...props}
  />
);

/**
 * __useApproveBookingKitMutation__
 *
 * To run a mutation, you first call `useApproveBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBookingKitMutation, { data, loading, error }] = useApproveBookingKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useApproveBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveBookingKitMutation,
    ApproveBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveBookingKitMutation,
    ApproveBookingKitMutationVariables
  >(ApproveBookingKitDocument, options);
}
export type ApproveBookingKitMutationHookResult = ReturnType<
  typeof useApproveBookingKitMutation
>;
export namespace ApproveBookingKit {
  export type Return = ApproveBookingKitMutation;
  export type Variables = ApproveBookingKitMutationVariables;
  export const OperationName = "approveBookingKit";

  export const Document = ApproveBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RejectBookingKitDocument = gql`
  mutation rejectBookingKit($id: ObjectId!, $comment: String) {
    rejectBookingKit(id: $id, comment: $comment) {
      ...BookingKitProfile
    }
  }
  ${BookingKitProfileFragmentDoc}
`;
export type RejectBookingKitMutationFn = Apollo.MutationFunction<
  RejectBookingKitMutation,
  RejectBookingKitMutationVariables
>;
export type RejectBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RejectBookingKitMutation,
    RejectBookingKitMutationVariables
  >,
  "mutation"
>;

export const RejectBookingKitComponent = (props: RejectBookingKitComponentProps) => (
  <ApolloReactComponents.Mutation<
    RejectBookingKitMutation,
    RejectBookingKitMutationVariables
  >
    mutation={RejectBookingKitDocument}
    {...props}
  />
);

/**
 * __useRejectBookingKitMutation__
 *
 * To run a mutation, you first call `useRejectBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectBookingKitMutation, { data, loading, error }] = useRejectBookingKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRejectBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectBookingKitMutation,
    RejectBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RejectBookingKitMutation, RejectBookingKitMutationVariables>(
    RejectBookingKitDocument,
    options
  );
}
export type RejectBookingKitMutationHookResult = ReturnType<
  typeof useRejectBookingKitMutation
>;
export namespace RejectBookingKit {
  export type Return = RejectBookingKitMutation;
  export type Variables = RejectBookingKitMutationVariables;
  export const OperationName = "rejectBookingKit";

  export const Document = RejectBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RejectDoneBookingKitDocument = gql`
  mutation rejectDoneBookingKit($id: ObjectId!, $comment: String) {
    rejectDoneBookingKit(id: $id, comment: $comment) {
      ...BookingKitProfile
    }
  }
  ${BookingKitProfileFragmentDoc}
`;
export type RejectDoneBookingKitMutationFn = Apollo.MutationFunction<
  RejectDoneBookingKitMutation,
  RejectDoneBookingKitMutationVariables
>;
export type RejectDoneBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RejectDoneBookingKitMutation,
    RejectDoneBookingKitMutationVariables
  >,
  "mutation"
>;

export const RejectDoneBookingKitComponent = (
  props: RejectDoneBookingKitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RejectDoneBookingKitMutation,
    RejectDoneBookingKitMutationVariables
  >
    mutation={RejectDoneBookingKitDocument}
    {...props}
  />
);

/**
 * __useRejectDoneBookingKitMutation__
 *
 * To run a mutation, you first call `useRejectDoneBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDoneBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDoneBookingKitMutation, { data, loading, error }] = useRejectDoneBookingKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRejectDoneBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectDoneBookingKitMutation,
    RejectDoneBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RejectDoneBookingKitMutation,
    RejectDoneBookingKitMutationVariables
  >(RejectDoneBookingKitDocument, options);
}
export type RejectDoneBookingKitMutationHookResult = ReturnType<
  typeof useRejectDoneBookingKitMutation
>;
export namespace RejectDoneBookingKit {
  export type Return = RejectDoneBookingKitMutation;
  export type Variables = RejectDoneBookingKitMutationVariables;
  export const OperationName = "rejectDoneBookingKit";

  export const Document = RejectDoneBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingEdit_EditDocument = gql`
  mutation BookingEdit_Edit($bookingGroupId: ObjectId!, $input: BookingGroupInput!) {
    updateBookingGroup(bookingGroupId: $bookingGroupId, input: $input) {
      _id
    }
  }
`;
export type BookingEdit_EditMutationFn = Apollo.MutationFunction<
  BookingEdit_EditMutation,
  BookingEdit_EditMutationVariables
>;
export type BookingEdit_EditComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingEdit_EditMutation,
    BookingEdit_EditMutationVariables
  >,
  "mutation"
>;

export const BookingEdit_EditComponent = (props: BookingEdit_EditComponentProps) => (
  <ApolloReactComponents.Mutation<
    BookingEdit_EditMutation,
    BookingEdit_EditMutationVariables
  >
    mutation={BookingEdit_EditDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_EditMutation__
 *
 * To run a mutation, you first call `useBookingEdit_EditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_EditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingEditEditMutation, { data, loading, error }] = useBookingEdit_EditMutation({
 *   variables: {
 *      bookingGroupId: // value for 'bookingGroupId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookingEdit_EditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingEdit_EditMutation,
    BookingEdit_EditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BookingEdit_EditMutation, BookingEdit_EditMutationVariables>(
    BookingEdit_EditDocument,
    options
  );
}
export type BookingEdit_EditMutationHookResult = ReturnType<
  typeof useBookingEdit_EditMutation
>;
export namespace BookingEdit_Edit {
  export type Return = BookingEdit_EditMutation;
  export type Variables = BookingEdit_EditMutationVariables;
  export const OperationName = "BookingEdit_Edit";

  export const Document = BookingEdit_EditDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingEdit_CreateDocument = gql`
  mutation BookingEdit_Create(
    $input: BookingGroupInput!
    $duplicateFromBookingId: ObjectId
  ) {
    createBookingGroup(input: $input, duplicateFromBookingId: $duplicateFromBookingId) {
      _id
      bookings {
        _id
      }
    }
  }
`;
export type BookingEdit_CreateMutationFn = Apollo.MutationFunction<
  BookingEdit_CreateMutation,
  BookingEdit_CreateMutationVariables
>;
export type BookingEdit_CreateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingEdit_CreateMutation,
    BookingEdit_CreateMutationVariables
  >,
  "mutation"
>;

export const BookingEdit_CreateComponent = (props: BookingEdit_CreateComponentProps) => (
  <ApolloReactComponents.Mutation<
    BookingEdit_CreateMutation,
    BookingEdit_CreateMutationVariables
  >
    mutation={BookingEdit_CreateDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_CreateMutation__
 *
 * To run a mutation, you first call `useBookingEdit_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingEditCreateMutation, { data, loading, error }] = useBookingEdit_CreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      duplicateFromBookingId: // value for 'duplicateFromBookingId'
 *   },
 * });
 */
export function useBookingEdit_CreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingEdit_CreateMutation,
    BookingEdit_CreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingEdit_CreateMutation,
    BookingEdit_CreateMutationVariables
  >(BookingEdit_CreateDocument, options);
}
export type BookingEdit_CreateMutationHookResult = ReturnType<
  typeof useBookingEdit_CreateMutation
>;
export namespace BookingEdit_Create {
  export type Return = BookingEdit_CreateMutation;
  export type Variables = BookingEdit_CreateMutationVariables;
  export const OperationName = "BookingEdit_Create";

  export const Document = BookingEdit_CreateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetBookingEditTravelZonesDocument = gql`
  query getBookingEditTravelZones {
    config {
      defaultTravelZones {
        label
        name
      }
    }
  }
`;
export type GetBookingEditTravelZonesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetBookingEditTravelZonesQuery,
    GetBookingEditTravelZonesQueryVariables
  >,
  "query"
>;

export const GetBookingEditTravelZonesComponent = (
  props: GetBookingEditTravelZonesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetBookingEditTravelZonesQuery,
    GetBookingEditTravelZonesQueryVariables
  >
    query={GetBookingEditTravelZonesDocument}
    {...props}
  />
);

/**
 * __useGetBookingEditTravelZonesQuery__
 *
 * To run a query within a React component, call `useGetBookingEditTravelZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingEditTravelZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingEditTravelZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingEditTravelZonesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBookingEditTravelZonesQuery,
    GetBookingEditTravelZonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingEditTravelZonesQuery,
    GetBookingEditTravelZonesQueryVariables
  >(GetBookingEditTravelZonesDocument, options);
}
export function useGetBookingEditTravelZonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingEditTravelZonesQuery,
    GetBookingEditTravelZonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingEditTravelZonesQuery,
    GetBookingEditTravelZonesQueryVariables
  >(GetBookingEditTravelZonesDocument, options);
}
export type GetBookingEditTravelZonesQueryHookResult = ReturnType<
  typeof useGetBookingEditTravelZonesQuery
>;
export type GetBookingEditTravelZonesLazyQueryHookResult = ReturnType<
  typeof useGetBookingEditTravelZonesLazyQuery
>;
export namespace GetBookingEditTravelZones {
  export type Return = GetBookingEditTravelZonesQuery;
  export type Variables = GetBookingEditTravelZonesQueryVariables;
  export const OperationName = "getBookingEditTravelZones";

  export const Document = GetBookingEditTravelZonesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_GetDocument = gql`
  query BookingEdit_Get($id: ObjectId!) {
    bookingById(id: $id) {
      _id
      ...BookingEdit
    }
  }
  ${BookingEditFragmentDoc}
`;
export type BookingEdit_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_GetQuery,
    BookingEdit_GetQueryVariables
  >,
  "query"
> &
  ({ variables: BookingEdit_GetQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingEdit_GetComponent = (props: BookingEdit_GetComponentProps) => (
  <ApolloReactComponents.Query<BookingEdit_GetQuery, BookingEdit_GetQueryVariables>
    query={BookingEdit_GetDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_GetQuery__
 *
 * To run a query within a React component, call `useBookingEdit_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingEdit_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_GetQuery,
    BookingEdit_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingEdit_GetQuery, BookingEdit_GetQueryVariables>(
    BookingEdit_GetDocument,
    options
  );
}
export function useBookingEdit_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_GetQuery,
    BookingEdit_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingEdit_GetQuery, BookingEdit_GetQueryVariables>(
    BookingEdit_GetDocument,
    options
  );
}
export type BookingEdit_GetQueryHookResult = ReturnType<typeof useBookingEdit_GetQuery>;
export type BookingEdit_GetLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_GetLazyQuery
>;
export namespace BookingEdit_Get {
  export type Return = BookingEdit_GetQuery;
  export type Variables = BookingEdit_GetQueryVariables;
  export const OperationName = "BookingEdit_Get";

  export const Document = BookingEdit_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_GetConsultantDocument = gql`
  query BookingEdit_GetConsultant($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantCard
      LegalPersonType
      BusinessName
      BusinessSocialSecurityNo
      AccommodationPreferences
      TravelPreferences
    }
  }
  ${ConsultantCardFragmentDoc}
`;
export type BookingEdit_GetConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_GetConsultantQuery,
    BookingEdit_GetConsultantQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingEdit_GetConsultantQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingEdit_GetConsultantComponent = (
  props: BookingEdit_GetConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_GetConsultantQuery,
    BookingEdit_GetConsultantQueryVariables
  >
    query={BookingEdit_GetConsultantDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_GetConsultantQuery__
 *
 * To run a query within a React component, call `useBookingEdit_GetConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_GetConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_GetConsultantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingEdit_GetConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_GetConsultantQuery,
    BookingEdit_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_GetConsultantQuery,
    BookingEdit_GetConsultantQueryVariables
  >(BookingEdit_GetConsultantDocument, options);
}
export function useBookingEdit_GetConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_GetConsultantQuery,
    BookingEdit_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_GetConsultantQuery,
    BookingEdit_GetConsultantQueryVariables
  >(BookingEdit_GetConsultantDocument, options);
}
export type BookingEdit_GetConsultantQueryHookResult = ReturnType<
  typeof useBookingEdit_GetConsultantQuery
>;
export type BookingEdit_GetConsultantLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_GetConsultantLazyQuery
>;
export namespace BookingEdit_GetConsultant {
  export type Return = BookingEdit_GetConsultantQuery;
  export type Variables = BookingEdit_GetConsultantQueryVariables;
  export const OperationName = "BookingEdit_GetConsultant";

  export const Document = BookingEdit_GetConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_GetCustomerDocument = gql`
  query BookingEdit_GetCustomer($id: ObjectId!) {
    customerById(id: $id) {
      ...SimpleCustomerCard
    }
  }
  ${SimpleCustomerCardFragmentDoc}
`;
export type BookingEdit_GetCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_GetCustomerQuery,
    BookingEdit_GetCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingEdit_GetCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingEdit_GetCustomerComponent = (
  props: BookingEdit_GetCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_GetCustomerQuery,
    BookingEdit_GetCustomerQueryVariables
  >
    query={BookingEdit_GetCustomerDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_GetCustomerQuery__
 *
 * To run a query within a React component, call `useBookingEdit_GetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_GetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_GetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingEdit_GetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_GetCustomerQuery,
    BookingEdit_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_GetCustomerQuery,
    BookingEdit_GetCustomerQueryVariables
  >(BookingEdit_GetCustomerDocument, options);
}
export function useBookingEdit_GetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_GetCustomerQuery,
    BookingEdit_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_GetCustomerQuery,
    BookingEdit_GetCustomerQueryVariables
  >(BookingEdit_GetCustomerDocument, options);
}
export type BookingEdit_GetCustomerQueryHookResult = ReturnType<
  typeof useBookingEdit_GetCustomerQuery
>;
export type BookingEdit_GetCustomerLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_GetCustomerLazyQuery
>;
export namespace BookingEdit_GetCustomer {
  export type Return = BookingEdit_GetCustomerQuery;
  export type Variables = BookingEdit_GetCustomerQueryVariables;
  export const OperationName = "BookingEdit_GetCustomer";

  export const Document = BookingEdit_GetCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_FetchDeptsDocument = gql`
  query BookingEdit_FetchDepts($hospitalId: ObjectId!) {
    hospital: customerById(id: $hospitalId) {
      _id
      AOESettings {
        AreaOfExpertise
        ResponsiblePerson {
          Name
          PersonId
        }
      }
      forceCallNumber
    }
    departments: customers(
      filter: { parentId: [$hospitalId], type: [Department] }
      limit: 1000
      skip: 0
    ) {
      items {
        _id
        Name
      }
      dbTime
    }
  }
`;
export type BookingEdit_FetchDeptsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_FetchDeptsQuery,
    BookingEdit_FetchDeptsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingEdit_FetchDeptsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingEdit_FetchDeptsComponent = (
  props: BookingEdit_FetchDeptsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_FetchDeptsQuery,
    BookingEdit_FetchDeptsQueryVariables
  >
    query={BookingEdit_FetchDeptsDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_FetchDeptsQuery__
 *
 * To run a query within a React component, call `useBookingEdit_FetchDeptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_FetchDeptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_FetchDeptsQuery({
 *   variables: {
 *      hospitalId: // value for 'hospitalId'
 *   },
 * });
 */
export function useBookingEdit_FetchDeptsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_FetchDeptsQuery,
    BookingEdit_FetchDeptsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_FetchDeptsQuery,
    BookingEdit_FetchDeptsQueryVariables
  >(BookingEdit_FetchDeptsDocument, options);
}
export function useBookingEdit_FetchDeptsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_FetchDeptsQuery,
    BookingEdit_FetchDeptsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_FetchDeptsQuery,
    BookingEdit_FetchDeptsQueryVariables
  >(BookingEdit_FetchDeptsDocument, options);
}
export type BookingEdit_FetchDeptsQueryHookResult = ReturnType<
  typeof useBookingEdit_FetchDeptsQuery
>;
export type BookingEdit_FetchDeptsLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_FetchDeptsLazyQuery
>;
export namespace BookingEdit_FetchDepts {
  export type Return = BookingEdit_FetchDeptsQuery;
  export type Variables = BookingEdit_FetchDeptsQueryVariables;
  export const OperationName = "BookingEdit_FetchDepts";

  export const Document = BookingEdit_FetchDeptsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_GetConsultantContractsDocument = gql`
  query BookingEdit_GetConsultantContracts($consultantId: ObjectId!, $dates: [Date]!) {
    contracts: getConsultantContractsByBooking(
      consultantId: $consultantId
      dates: $dates
    ) {
      _id
      ParentId
      Name
      SalaryChoice
      Period
      Type
    }
  }
`;
export type BookingEdit_GetConsultantContractsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_GetConsultantContractsQuery,
    BookingEdit_GetConsultantContractsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingEdit_GetConsultantContractsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingEdit_GetConsultantContractsComponent = (
  props: BookingEdit_GetConsultantContractsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_GetConsultantContractsQuery,
    BookingEdit_GetConsultantContractsQueryVariables
  >
    query={BookingEdit_GetConsultantContractsDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_GetConsultantContractsQuery__
 *
 * To run a query within a React component, call `useBookingEdit_GetConsultantContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_GetConsultantContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_GetConsultantContractsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useBookingEdit_GetConsultantContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_GetConsultantContractsQuery,
    BookingEdit_GetConsultantContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_GetConsultantContractsQuery,
    BookingEdit_GetConsultantContractsQueryVariables
  >(BookingEdit_GetConsultantContractsDocument, options);
}
export function useBookingEdit_GetConsultantContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_GetConsultantContractsQuery,
    BookingEdit_GetConsultantContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_GetConsultantContractsQuery,
    BookingEdit_GetConsultantContractsQueryVariables
  >(BookingEdit_GetConsultantContractsDocument, options);
}
export type BookingEdit_GetConsultantContractsQueryHookResult = ReturnType<
  typeof useBookingEdit_GetConsultantContractsQuery
>;
export type BookingEdit_GetConsultantContractsLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_GetConsultantContractsLazyQuery
>;
export namespace BookingEdit_GetConsultantContracts {
  export type Return = BookingEdit_GetConsultantContractsQuery;
  export type Variables = BookingEdit_GetConsultantContractsQueryVariables;
  export const OperationName = "BookingEdit_GetConsultantContracts";

  export const Document = BookingEdit_GetConsultantContractsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_GetCustomerContractsDocument = gql`
  query BookingEdit_GetCustomerContracts($filter: CustomerContractByBookingFilter) {
    customerContractsByBooking(filter: $filter) {
      _id
      parentId
      contractName
      contractType
      contractStart
      contractEnd
      isSubVersion
      isNationalProcurement
      useNationalProcurementInvoicing
      avropsnummer
      priceLists
      basicPrices {
        price
        dates
      }
    }
  }
`;
export type BookingEdit_GetCustomerContractsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_GetCustomerContractsQuery,
    BookingEdit_GetCustomerContractsQueryVariables
  >,
  "query"
>;

export const BookingEdit_GetCustomerContractsComponent = (
  props: BookingEdit_GetCustomerContractsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_GetCustomerContractsQuery,
    BookingEdit_GetCustomerContractsQueryVariables
  >
    query={BookingEdit_GetCustomerContractsDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_GetCustomerContractsQuery__
 *
 * To run a query within a React component, call `useBookingEdit_GetCustomerContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_GetCustomerContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_GetCustomerContractsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookingEdit_GetCustomerContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_GetCustomerContractsQuery,
    BookingEdit_GetCustomerContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_GetCustomerContractsQuery,
    BookingEdit_GetCustomerContractsQueryVariables
  >(BookingEdit_GetCustomerContractsDocument, options);
}
export function useBookingEdit_GetCustomerContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_GetCustomerContractsQuery,
    BookingEdit_GetCustomerContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_GetCustomerContractsQuery,
    BookingEdit_GetCustomerContractsQueryVariables
  >(BookingEdit_GetCustomerContractsDocument, options);
}
export type BookingEdit_GetCustomerContractsQueryHookResult = ReturnType<
  typeof useBookingEdit_GetCustomerContractsQuery
>;
export type BookingEdit_GetCustomerContractsLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_GetCustomerContractsLazyQuery
>;
export namespace BookingEdit_GetCustomerContracts {
  export type Return = BookingEdit_GetCustomerContractsQuery;
  export type Variables = BookingEdit_GetCustomerContractsQueryVariables;
  export const OperationName = "BookingEdit_GetCustomerContracts";

  export const Document = BookingEdit_GetCustomerContractsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_CreateDirectRequestContractDocument = gql`
  mutation BookingEdit_CreateDirectRequestContract(
    $data: CreateDirectRequestContractInput!
  ) {
    createDirectRequestContract(data: $data) {
      value {
        _id
        avropsnummer
      }
      errors
    }
  }
`;
export type BookingEdit_CreateDirectRequestContractMutationFn = Apollo.MutationFunction<
  BookingEdit_CreateDirectRequestContractMutation,
  BookingEdit_CreateDirectRequestContractMutationVariables
>;
export type BookingEdit_CreateDirectRequestContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingEdit_CreateDirectRequestContractMutation,
    BookingEdit_CreateDirectRequestContractMutationVariables
  >,
  "mutation"
>;

export const BookingEdit_CreateDirectRequestContractComponent = (
  props: BookingEdit_CreateDirectRequestContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingEdit_CreateDirectRequestContractMutation,
    BookingEdit_CreateDirectRequestContractMutationVariables
  >
    mutation={BookingEdit_CreateDirectRequestContractDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_CreateDirectRequestContractMutation__
 *
 * To run a mutation, you first call `useBookingEdit_CreateDirectRequestContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_CreateDirectRequestContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingEditCreateDirectRequestContractMutation, { data, loading, error }] = useBookingEdit_CreateDirectRequestContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBookingEdit_CreateDirectRequestContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingEdit_CreateDirectRequestContractMutation,
    BookingEdit_CreateDirectRequestContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingEdit_CreateDirectRequestContractMutation,
    BookingEdit_CreateDirectRequestContractMutationVariables
  >(BookingEdit_CreateDirectRequestContractDocument, options);
}
export type BookingEdit_CreateDirectRequestContractMutationHookResult = ReturnType<
  typeof useBookingEdit_CreateDirectRequestContractMutation
>;
export namespace BookingEdit_CreateDirectRequestContract {
  export type Return = BookingEdit_CreateDirectRequestContractMutation;
  export type Variables = BookingEdit_CreateDirectRequestContractMutationVariables;
  export const OperationName = "BookingEdit_CreateDirectRequestContract";

  export const Document = BookingEdit_CreateDirectRequestContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingEdit_NpDirectRequestAvailableDocument = gql`
  query BookingEdit_NpDirectRequestAvailable(
    $customerId: ObjectId!
    $departmentIds: [ObjectId!]
  ) {
    npDirectRequestAvailable(customerId: $customerId, departmentIds: $departmentIds)
  }
`;
export type BookingEdit_NpDirectRequestAvailableComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_NpDirectRequestAvailableQuery,
    BookingEdit_NpDirectRequestAvailableQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingEdit_NpDirectRequestAvailableQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingEdit_NpDirectRequestAvailableComponent = (
  props: BookingEdit_NpDirectRequestAvailableComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_NpDirectRequestAvailableQuery,
    BookingEdit_NpDirectRequestAvailableQueryVariables
  >
    query={BookingEdit_NpDirectRequestAvailableDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_NpDirectRequestAvailableQuery__
 *
 * To run a query within a React component, call `useBookingEdit_NpDirectRequestAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_NpDirectRequestAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_NpDirectRequestAvailableQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useBookingEdit_NpDirectRequestAvailableQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_NpDirectRequestAvailableQuery,
    BookingEdit_NpDirectRequestAvailableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_NpDirectRequestAvailableQuery,
    BookingEdit_NpDirectRequestAvailableQueryVariables
  >(BookingEdit_NpDirectRequestAvailableDocument, options);
}
export function useBookingEdit_NpDirectRequestAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_NpDirectRequestAvailableQuery,
    BookingEdit_NpDirectRequestAvailableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_NpDirectRequestAvailableQuery,
    BookingEdit_NpDirectRequestAvailableQueryVariables
  >(BookingEdit_NpDirectRequestAvailableDocument, options);
}
export type BookingEdit_NpDirectRequestAvailableQueryHookResult = ReturnType<
  typeof useBookingEdit_NpDirectRequestAvailableQuery
>;
export type BookingEdit_NpDirectRequestAvailableLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_NpDirectRequestAvailableLazyQuery
>;
export namespace BookingEdit_NpDirectRequestAvailable {
  export type Return = BookingEdit_NpDirectRequestAvailableQuery;
  export type Variables = BookingEdit_NpDirectRequestAvailableQueryVariables;
  export const OperationName = "BookingEdit_NpDirectRequestAvailable";

  export const Document = BookingEdit_NpDirectRequestAvailableDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEdit_GetAllowedCostCentersDocument = gql`
  query BookingEdit_GetAllowedCostCenters {
    me {
      allowedCostCenters {
        ...CostCenter
      }
    }
  }
  ${CostCenterFragmentDoc}
`;
export type BookingEdit_GetAllowedCostCentersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEdit_GetAllowedCostCentersQuery,
    BookingEdit_GetAllowedCostCentersQueryVariables
  >,
  "query"
>;

export const BookingEdit_GetAllowedCostCentersComponent = (
  props: BookingEdit_GetAllowedCostCentersComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEdit_GetAllowedCostCentersQuery,
    BookingEdit_GetAllowedCostCentersQueryVariables
  >
    query={BookingEdit_GetAllowedCostCentersDocument}
    {...props}
  />
);

/**
 * __useBookingEdit_GetAllowedCostCentersQuery__
 *
 * To run a query within a React component, call `useBookingEdit_GetAllowedCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEdit_GetAllowedCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEdit_GetAllowedCostCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingEdit_GetAllowedCostCentersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEdit_GetAllowedCostCentersQuery,
    BookingEdit_GetAllowedCostCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEdit_GetAllowedCostCentersQuery,
    BookingEdit_GetAllowedCostCentersQueryVariables
  >(BookingEdit_GetAllowedCostCentersDocument, options);
}
export function useBookingEdit_GetAllowedCostCentersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEdit_GetAllowedCostCentersQuery,
    BookingEdit_GetAllowedCostCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEdit_GetAllowedCostCentersQuery,
    BookingEdit_GetAllowedCostCentersQueryVariables
  >(BookingEdit_GetAllowedCostCentersDocument, options);
}
export type BookingEdit_GetAllowedCostCentersQueryHookResult = ReturnType<
  typeof useBookingEdit_GetAllowedCostCentersQuery
>;
export type BookingEdit_GetAllowedCostCentersLazyQueryHookResult = ReturnType<
  typeof useBookingEdit_GetAllowedCostCentersLazyQuery
>;
export namespace BookingEdit_GetAllowedCostCenters {
  export type Return = BookingEdit_GetAllowedCostCentersQuery;
  export type Variables = BookingEdit_GetAllowedCostCentersQueryVariables;
  export const OperationName = "BookingEdit_GetAllowedCostCenters";

  export const Document = BookingEdit_GetAllowedCostCentersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingFinanceEditor_FetchDocument = gql`
  query BookingFinanceEditor_Fetch($id: ObjectId!) {
    bookingById(id: $id) {
      ...BookingFinanceEditor_Item
    }
  }
  ${BookingFinanceEditor_ItemFragmentDoc}
`;
export type BookingFinanceEditor_FetchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingFinanceEditor_FetchQuery,
    BookingFinanceEditor_FetchQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingFinanceEditor_FetchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingFinanceEditor_FetchComponent = (
  props: BookingFinanceEditor_FetchComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingFinanceEditor_FetchQuery,
    BookingFinanceEditor_FetchQueryVariables
  >
    query={BookingFinanceEditor_FetchDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceEditor_FetchQuery__
 *
 * To run a query within a React component, call `useBookingFinanceEditor_FetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceEditor_FetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceEditor_FetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingFinanceEditor_FetchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingFinanceEditor_FetchQuery,
    BookingFinanceEditor_FetchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingFinanceEditor_FetchQuery,
    BookingFinanceEditor_FetchQueryVariables
  >(BookingFinanceEditor_FetchDocument, options);
}
export function useBookingFinanceEditor_FetchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingFinanceEditor_FetchQuery,
    BookingFinanceEditor_FetchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingFinanceEditor_FetchQuery,
    BookingFinanceEditor_FetchQueryVariables
  >(BookingFinanceEditor_FetchDocument, options);
}
export type BookingFinanceEditor_FetchQueryHookResult = ReturnType<
  typeof useBookingFinanceEditor_FetchQuery
>;
export type BookingFinanceEditor_FetchLazyQueryHookResult = ReturnType<
  typeof useBookingFinanceEditor_FetchLazyQuery
>;
export namespace BookingFinanceEditor_Fetch {
  export type Return = BookingFinanceEditor_FetchQuery;
  export type Variables = BookingFinanceEditor_FetchQueryVariables;
  export const OperationName = "BookingFinanceEditor_Fetch";

  export const Document = BookingFinanceEditor_FetchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingFinanceEditor_FetchDraftCostsDocument = gql`
  query BookingFinanceEditor_FetchDraftCosts($id: ObjectId!) {
    bookingById(id: $id) {
      draftCosts {
        invoiceTotal
        sickPayTotal
        employeeSalary
        travel
        accommodation
      }
    }
  }
`;
export type BookingFinanceEditor_FetchDraftCostsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingFinanceEditor_FetchDraftCostsQuery,
    BookingFinanceEditor_FetchDraftCostsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingFinanceEditor_FetchDraftCostsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingFinanceEditor_FetchDraftCostsComponent = (
  props: BookingFinanceEditor_FetchDraftCostsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingFinanceEditor_FetchDraftCostsQuery,
    BookingFinanceEditor_FetchDraftCostsQueryVariables
  >
    query={BookingFinanceEditor_FetchDraftCostsDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceEditor_FetchDraftCostsQuery__
 *
 * To run a query within a React component, call `useBookingFinanceEditor_FetchDraftCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceEditor_FetchDraftCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceEditor_FetchDraftCostsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingFinanceEditor_FetchDraftCostsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingFinanceEditor_FetchDraftCostsQuery,
    BookingFinanceEditor_FetchDraftCostsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingFinanceEditor_FetchDraftCostsQuery,
    BookingFinanceEditor_FetchDraftCostsQueryVariables
  >(BookingFinanceEditor_FetchDraftCostsDocument, options);
}
export function useBookingFinanceEditor_FetchDraftCostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingFinanceEditor_FetchDraftCostsQuery,
    BookingFinanceEditor_FetchDraftCostsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingFinanceEditor_FetchDraftCostsQuery,
    BookingFinanceEditor_FetchDraftCostsQueryVariables
  >(BookingFinanceEditor_FetchDraftCostsDocument, options);
}
export type BookingFinanceEditor_FetchDraftCostsQueryHookResult = ReturnType<
  typeof useBookingFinanceEditor_FetchDraftCostsQuery
>;
export type BookingFinanceEditor_FetchDraftCostsLazyQueryHookResult = ReturnType<
  typeof useBookingFinanceEditor_FetchDraftCostsLazyQuery
>;
export namespace BookingFinanceEditor_FetchDraftCosts {
  export type Return = BookingFinanceEditor_FetchDraftCostsQuery;
  export type Variables = BookingFinanceEditor_FetchDraftCostsQueryVariables;
  export const OperationName = "BookingFinanceEditor_FetchDraftCosts";

  export const Document = BookingFinanceEditor_FetchDraftCostsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingFinanceEditor_UpdateDocument = gql`
  mutation BookingFinanceEditor_Update(
    $bookingId: ObjectId!
    $data: UpdateBookingFinanceInput!
  ) {
    updateBookingFinance(bookingId: $bookingId, data: $data) {
      ...BookingFinanceEditor_Item
    }
  }
  ${BookingFinanceEditor_ItemFragmentDoc}
`;
export type BookingFinanceEditor_UpdateMutationFn = Apollo.MutationFunction<
  BookingFinanceEditor_UpdateMutation,
  BookingFinanceEditor_UpdateMutationVariables
>;
export type BookingFinanceEditor_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingFinanceEditor_UpdateMutation,
    BookingFinanceEditor_UpdateMutationVariables
  >,
  "mutation"
>;

export const BookingFinanceEditor_UpdateComponent = (
  props: BookingFinanceEditor_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingFinanceEditor_UpdateMutation,
    BookingFinanceEditor_UpdateMutationVariables
  >
    mutation={BookingFinanceEditor_UpdateDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceEditor_UpdateMutation__
 *
 * To run a mutation, you first call `useBookingFinanceEditor_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceEditor_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingFinanceEditorUpdateMutation, { data, loading, error }] = useBookingFinanceEditor_UpdateMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBookingFinanceEditor_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingFinanceEditor_UpdateMutation,
    BookingFinanceEditor_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingFinanceEditor_UpdateMutation,
    BookingFinanceEditor_UpdateMutationVariables
  >(BookingFinanceEditor_UpdateDocument, options);
}
export type BookingFinanceEditor_UpdateMutationHookResult = ReturnType<
  typeof useBookingFinanceEditor_UpdateMutation
>;
export namespace BookingFinanceEditor_Update {
  export type Return = BookingFinanceEditor_UpdateMutation;
  export type Variables = BookingFinanceEditor_UpdateMutationVariables;
  export const OperationName = "BookingFinanceEditor_Update";

  export const Document = BookingFinanceEditor_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingFinanceEditor_UploadDocumentDocument = gql`
  mutation BookingFinanceEditor_UploadDocument($file: Upload!) {
    uploadDocument(file: $file) {
      ...DDocument
    }
  }
  ${DDocumentFragmentDoc}
`;
export type BookingFinanceEditor_UploadDocumentMutationFn = Apollo.MutationFunction<
  BookingFinanceEditor_UploadDocumentMutation,
  BookingFinanceEditor_UploadDocumentMutationVariables
>;
export type BookingFinanceEditor_UploadDocumentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingFinanceEditor_UploadDocumentMutation,
    BookingFinanceEditor_UploadDocumentMutationVariables
  >,
  "mutation"
>;

export const BookingFinanceEditor_UploadDocumentComponent = (
  props: BookingFinanceEditor_UploadDocumentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingFinanceEditor_UploadDocumentMutation,
    BookingFinanceEditor_UploadDocumentMutationVariables
  >
    mutation={BookingFinanceEditor_UploadDocumentDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceEditor_UploadDocumentMutation__
 *
 * To run a mutation, you first call `useBookingFinanceEditor_UploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceEditor_UploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingFinanceEditorUploadDocumentMutation, { data, loading, error }] = useBookingFinanceEditor_UploadDocumentMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBookingFinanceEditor_UploadDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingFinanceEditor_UploadDocumentMutation,
    BookingFinanceEditor_UploadDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingFinanceEditor_UploadDocumentMutation,
    BookingFinanceEditor_UploadDocumentMutationVariables
  >(BookingFinanceEditor_UploadDocumentDocument, options);
}
export type BookingFinanceEditor_UploadDocumentMutationHookResult = ReturnType<
  typeof useBookingFinanceEditor_UploadDocumentMutation
>;
export namespace BookingFinanceEditor_UploadDocument {
  export type Return = BookingFinanceEditor_UploadDocumentMutation;
  export type Variables = BookingFinanceEditor_UploadDocumentMutationVariables;
  export const OperationName = "BookingFinanceEditor_UploadDocument";

  export const Document = BookingFinanceEditor_UploadDocumentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingFinanceEditor_UnlockFormsDocument = gql`
  mutation BookingFinanceEditor_UnlockForms($bookingId: ObjectId!, $value: Boolean!) {
    setUnlockBookingForms(bookingId: $bookingId, value: $value) {
      unlockForms
    }
  }
`;
export type BookingFinanceEditor_UnlockFormsMutationFn = Apollo.MutationFunction<
  BookingFinanceEditor_UnlockFormsMutation,
  BookingFinanceEditor_UnlockFormsMutationVariables
>;
export type BookingFinanceEditor_UnlockFormsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingFinanceEditor_UnlockFormsMutation,
    BookingFinanceEditor_UnlockFormsMutationVariables
  >,
  "mutation"
>;

export const BookingFinanceEditor_UnlockFormsComponent = (
  props: BookingFinanceEditor_UnlockFormsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingFinanceEditor_UnlockFormsMutation,
    BookingFinanceEditor_UnlockFormsMutationVariables
  >
    mutation={BookingFinanceEditor_UnlockFormsDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceEditor_UnlockFormsMutation__
 *
 * To run a mutation, you first call `useBookingFinanceEditor_UnlockFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceEditor_UnlockFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingFinanceEditorUnlockFormsMutation, { data, loading, error }] = useBookingFinanceEditor_UnlockFormsMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useBookingFinanceEditor_UnlockFormsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingFinanceEditor_UnlockFormsMutation,
    BookingFinanceEditor_UnlockFormsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingFinanceEditor_UnlockFormsMutation,
    BookingFinanceEditor_UnlockFormsMutationVariables
  >(BookingFinanceEditor_UnlockFormsDocument, options);
}
export type BookingFinanceEditor_UnlockFormsMutationHookResult = ReturnType<
  typeof useBookingFinanceEditor_UnlockFormsMutation
>;
export namespace BookingFinanceEditor_UnlockForms {
  export type Return = BookingFinanceEditor_UnlockFormsMutation;
  export type Variables = BookingFinanceEditor_UnlockFormsMutationVariables;
  export const OperationName = "BookingFinanceEditor_UnlockForms";

  export const Document = BookingFinanceEditor_UnlockFormsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingGroupCard_GetBookingGroupDocument = gql`
  query BookingGroupCard_getBookingGroup($id: ObjectId!) {
    getBookingGroup(id: $id) {
      ...BookingGroupCard
    }
  }
  ${BookingGroupCardFragmentDoc}
`;
export type BookingGroupCard_GetBookingGroupComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingGroupCard_GetBookingGroupQuery,
    BookingGroupCard_GetBookingGroupQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingGroupCard_GetBookingGroupQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingGroupCard_GetBookingGroupComponent = (
  props: BookingGroupCard_GetBookingGroupComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingGroupCard_GetBookingGroupQuery,
    BookingGroupCard_GetBookingGroupQueryVariables
  >
    query={BookingGroupCard_GetBookingGroupDocument}
    {...props}
  />
);

/**
 * __useBookingGroupCard_GetBookingGroupQuery__
 *
 * To run a query within a React component, call `useBookingGroupCard_GetBookingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingGroupCard_GetBookingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingGroupCard_GetBookingGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingGroupCard_GetBookingGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingGroupCard_GetBookingGroupQuery,
    BookingGroupCard_GetBookingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingGroupCard_GetBookingGroupQuery,
    BookingGroupCard_GetBookingGroupQueryVariables
  >(BookingGroupCard_GetBookingGroupDocument, options);
}
export function useBookingGroupCard_GetBookingGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingGroupCard_GetBookingGroupQuery,
    BookingGroupCard_GetBookingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingGroupCard_GetBookingGroupQuery,
    BookingGroupCard_GetBookingGroupQueryVariables
  >(BookingGroupCard_GetBookingGroupDocument, options);
}
export type BookingGroupCard_GetBookingGroupQueryHookResult = ReturnType<
  typeof useBookingGroupCard_GetBookingGroupQuery
>;
export type BookingGroupCard_GetBookingGroupLazyQueryHookResult = ReturnType<
  typeof useBookingGroupCard_GetBookingGroupLazyQuery
>;
export namespace BookingGroupCard_getBookingGroup {
  export type Return = BookingGroupCard_GetBookingGroupQuery;
  export type Variables = BookingGroupCard_GetBookingGroupQueryVariables;
  export const OperationName = "BookingGroupCard_getBookingGroup";

  export const Document = BookingGroupCard_GetBookingGroupDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetAccommodationConfirmationByIdDocument = gql`
  query getAccommodationConfirmationById(
    $bookingId: ObjectId!
    $confirmationId: ObjectId!
  ) {
    bookingById(id: $bookingId) {
      _id
      ...AccommodationConfirmationBookingInfo
    }
    accommodationConfirmationById(confirmationId: $confirmationId) {
      _id
      accommodationRef {
        Name
        NodeID
        NodeType
      }
      confirmedBy {
        Name
        PersonId
      }
      confirmedOn
      deleted
      documents {
        ...DocumentList_Item
      }
      offerId
      weeks
      allWeeks {
        weekYear {
          Week
          Year
        }
        cost
        extraCost
        extraDescription
        startDate
        endDate
        isTaxed
        nights
        tax
        note
        lines {
          reservationId
          accommodationName
          city
          area
          startDate
          endDate
          nights
          stayedNights
          cost
          extraCost
          extraDescription
          tax
          paymentMethod
        }
      }
      area
      totalCost
      totalExVAT
      city
      squareFootageAttached
      source
      taxationId
      syncedAt
    }
  }
  ${AccommodationConfirmationBookingInfoFragmentDoc}
  ${DocumentList_ItemFragmentDoc}
`;
export type GetAccommodationConfirmationByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAccommodationConfirmationByIdQuery,
    GetAccommodationConfirmationByIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetAccommodationConfirmationByIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetAccommodationConfirmationByIdComponent = (
  props: GetAccommodationConfirmationByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAccommodationConfirmationByIdQuery,
    GetAccommodationConfirmationByIdQueryVariables
  >
    query={GetAccommodationConfirmationByIdDocument}
    {...props}
  />
);

/**
 * __useGetAccommodationConfirmationByIdQuery__
 *
 * To run a query within a React component, call `useGetAccommodationConfirmationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccommodationConfirmationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccommodationConfirmationByIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      confirmationId: // value for 'confirmationId'
 *   },
 * });
 */
export function useGetAccommodationConfirmationByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccommodationConfirmationByIdQuery,
    GetAccommodationConfirmationByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccommodationConfirmationByIdQuery,
    GetAccommodationConfirmationByIdQueryVariables
  >(GetAccommodationConfirmationByIdDocument, options);
}
export function useGetAccommodationConfirmationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccommodationConfirmationByIdQuery,
    GetAccommodationConfirmationByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccommodationConfirmationByIdQuery,
    GetAccommodationConfirmationByIdQueryVariables
  >(GetAccommodationConfirmationByIdDocument, options);
}
export type GetAccommodationConfirmationByIdQueryHookResult = ReturnType<
  typeof useGetAccommodationConfirmationByIdQuery
>;
export type GetAccommodationConfirmationByIdLazyQueryHookResult = ReturnType<
  typeof useGetAccommodationConfirmationByIdLazyQuery
>;
export namespace GetAccommodationConfirmationById {
  export type Return = GetAccommodationConfirmationByIdQuery;
  export type Variables = GetAccommodationConfirmationByIdQueryVariables;
  export const OperationName = "getAccommodationConfirmationById";

  export const Document = GetAccommodationConfirmationByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetAccommodationDocUploaderDataDocument = gql`
  query getAccommodationDocUploaderData($bookingId: ObjectId!) {
    bookingById(id: $bookingId) {
      ...AccommodationConfirmationBookingInfo
    }
  }
  ${AccommodationConfirmationBookingInfoFragmentDoc}
`;
export type GetAccommodationDocUploaderDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAccommodationDocUploaderDataQuery,
    GetAccommodationDocUploaderDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetAccommodationDocUploaderDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetAccommodationDocUploaderDataComponent = (
  props: GetAccommodationDocUploaderDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAccommodationDocUploaderDataQuery,
    GetAccommodationDocUploaderDataQueryVariables
  >
    query={GetAccommodationDocUploaderDataDocument}
    {...props}
  />
);

/**
 * __useGetAccommodationDocUploaderDataQuery__
 *
 * To run a query within a React component, call `useGetAccommodationDocUploaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccommodationDocUploaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccommodationDocUploaderDataQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetAccommodationDocUploaderDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccommodationDocUploaderDataQuery,
    GetAccommodationDocUploaderDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccommodationDocUploaderDataQuery,
    GetAccommodationDocUploaderDataQueryVariables
  >(GetAccommodationDocUploaderDataDocument, options);
}
export function useGetAccommodationDocUploaderDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccommodationDocUploaderDataQuery,
    GetAccommodationDocUploaderDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccommodationDocUploaderDataQuery,
    GetAccommodationDocUploaderDataQueryVariables
  >(GetAccommodationDocUploaderDataDocument, options);
}
export type GetAccommodationDocUploaderDataQueryHookResult = ReturnType<
  typeof useGetAccommodationDocUploaderDataQuery
>;
export type GetAccommodationDocUploaderDataLazyQueryHookResult = ReturnType<
  typeof useGetAccommodationDocUploaderDataLazyQuery
>;
export namespace GetAccommodationDocUploaderData {
  export type Return = GetAccommodationDocUploaderDataQuery;
  export type Variables = GetAccommodationDocUploaderDataQueryVariables;
  export const OperationName = "getAccommodationDocUploaderData";

  export const Document = GetAccommodationDocUploaderDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AccommodationConfirmation_GetCityInhabitantsDocument = gql`
  query AccommodationConfirmation_GetCityInhabitants {
    config {
      cityInhabitants {
        city
        inhabitants
        taxRegion
      }
    }
  }
`;
export type AccommodationConfirmation_GetCityInhabitantsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationConfirmation_GetCityInhabitantsQuery,
    AccommodationConfirmation_GetCityInhabitantsQueryVariables
  >,
  "query"
>;

export const AccommodationConfirmation_GetCityInhabitantsComponent = (
  props: AccommodationConfirmation_GetCityInhabitantsComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationConfirmation_GetCityInhabitantsQuery,
    AccommodationConfirmation_GetCityInhabitantsQueryVariables
  >
    query={AccommodationConfirmation_GetCityInhabitantsDocument}
    {...props}
  />
);

/**
 * __useAccommodationConfirmation_GetCityInhabitantsQuery__
 *
 * To run a query within a React component, call `useAccommodationConfirmation_GetCityInhabitantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationConfirmation_GetCityInhabitantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationConfirmation_GetCityInhabitantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccommodationConfirmation_GetCityInhabitantsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationConfirmation_GetCityInhabitantsQuery,
    AccommodationConfirmation_GetCityInhabitantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationConfirmation_GetCityInhabitantsQuery,
    AccommodationConfirmation_GetCityInhabitantsQueryVariables
  >(AccommodationConfirmation_GetCityInhabitantsDocument, options);
}
export function useAccommodationConfirmation_GetCityInhabitantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationConfirmation_GetCityInhabitantsQuery,
    AccommodationConfirmation_GetCityInhabitantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationConfirmation_GetCityInhabitantsQuery,
    AccommodationConfirmation_GetCityInhabitantsQueryVariables
  >(AccommodationConfirmation_GetCityInhabitantsDocument, options);
}
export type AccommodationConfirmation_GetCityInhabitantsQueryHookResult = ReturnType<
  typeof useAccommodationConfirmation_GetCityInhabitantsQuery
>;
export type AccommodationConfirmation_GetCityInhabitantsLazyQueryHookResult = ReturnType<
  typeof useAccommodationConfirmation_GetCityInhabitantsLazyQuery
>;
export namespace AccommodationConfirmation_GetCityInhabitants {
  export type Return = AccommodationConfirmation_GetCityInhabitantsQuery;
  export type Variables = AccommodationConfirmation_GetCityInhabitantsQueryVariables;
  export const OperationName = "AccommodationConfirmation_GetCityInhabitants";

  export const Document = AccommodationConfirmation_GetCityInhabitantsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AddAccommodationDocsDocument = gql`
  mutation addAccommodationDocs($input: ConfirmAccommodationInput!) {
    confirmAccommodation(input: $input) {
      _id
    }
  }
`;
export type AddAccommodationDocsMutationFn = Apollo.MutationFunction<
  AddAccommodationDocsMutation,
  AddAccommodationDocsMutationVariables
>;
export type AddAccommodationDocsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddAccommodationDocsMutation,
    AddAccommodationDocsMutationVariables
  >,
  "mutation"
>;

export const AddAccommodationDocsComponent = (
  props: AddAccommodationDocsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddAccommodationDocsMutation,
    AddAccommodationDocsMutationVariables
  >
    mutation={AddAccommodationDocsDocument}
    {...props}
  />
);

/**
 * __useAddAccommodationDocsMutation__
 *
 * To run a mutation, you first call `useAddAccommodationDocsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccommodationDocsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccommodationDocsMutation, { data, loading, error }] = useAddAccommodationDocsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccommodationDocsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAccommodationDocsMutation,
    AddAccommodationDocsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddAccommodationDocsMutation,
    AddAccommodationDocsMutationVariables
  >(AddAccommodationDocsDocument, options);
}
export type AddAccommodationDocsMutationHookResult = ReturnType<
  typeof useAddAccommodationDocsMutation
>;
export namespace AddAccommodationDocs {
  export type Return = AddAccommodationDocsMutation;
  export type Variables = AddAccommodationDocsMutationVariables;
  export const OperationName = "addAccommodationDocs";

  export const Document = AddAccommodationDocsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateAccommodationConfirmationDocument = gql`
  mutation updateAccommodationConfirmation(
    $id: ObjectId!
    $input: ConfirmAccommodationInput!
  ) {
    updateAccommodationConfirmation(id: $id, input: $input)
  }
`;
export type UpdateAccommodationConfirmationMutationFn = Apollo.MutationFunction<
  UpdateAccommodationConfirmationMutation,
  UpdateAccommodationConfirmationMutationVariables
>;
export type UpdateAccommodationConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateAccommodationConfirmationMutation,
    UpdateAccommodationConfirmationMutationVariables
  >,
  "mutation"
>;

export const UpdateAccommodationConfirmationComponent = (
  props: UpdateAccommodationConfirmationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateAccommodationConfirmationMutation,
    UpdateAccommodationConfirmationMutationVariables
  >
    mutation={UpdateAccommodationConfirmationDocument}
    {...props}
  />
);

/**
 * __useUpdateAccommodationConfirmationMutation__
 *
 * To run a mutation, you first call `useUpdateAccommodationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccommodationConfirmationMutation, { data, loading, error }] = useUpdateAccommodationConfirmationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccommodationConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccommodationConfirmationMutation,
    UpdateAccommodationConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccommodationConfirmationMutation,
    UpdateAccommodationConfirmationMutationVariables
  >(UpdateAccommodationConfirmationDocument, options);
}
export type UpdateAccommodationConfirmationMutationHookResult = ReturnType<
  typeof useUpdateAccommodationConfirmationMutation
>;
export namespace UpdateAccommodationConfirmation {
  export type Return = UpdateAccommodationConfirmationMutation;
  export type Variables = UpdateAccommodationConfirmationMutationVariables;
  export const OperationName = "updateAccommodationConfirmation";

  export const Document = UpdateAccommodationConfirmationDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationRequest_GetBookingGroupDocument = gql`
  query AccommodationRequest_getBookingGroup($id: ObjectId!) {
    getBookingGroup(id: $id) {
      ...AccommodationRequestBookingGroupData
    }
  }
  ${AccommodationRequestBookingGroupDataFragmentDoc}
`;
export type AccommodationRequest_GetBookingGroupComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationRequest_GetBookingGroupQuery,
    AccommodationRequest_GetBookingGroupQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationRequest_GetBookingGroupQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationRequest_GetBookingGroupComponent = (
  props: AccommodationRequest_GetBookingGroupComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationRequest_GetBookingGroupQuery,
    AccommodationRequest_GetBookingGroupQueryVariables
  >
    query={AccommodationRequest_GetBookingGroupDocument}
    {...props}
  />
);

/**
 * __useAccommodationRequest_GetBookingGroupQuery__
 *
 * To run a query within a React component, call `useAccommodationRequest_GetBookingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationRequest_GetBookingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationRequest_GetBookingGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationRequest_GetBookingGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationRequest_GetBookingGroupQuery,
    AccommodationRequest_GetBookingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationRequest_GetBookingGroupQuery,
    AccommodationRequest_GetBookingGroupQueryVariables
  >(AccommodationRequest_GetBookingGroupDocument, options);
}
export function useAccommodationRequest_GetBookingGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationRequest_GetBookingGroupQuery,
    AccommodationRequest_GetBookingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationRequest_GetBookingGroupQuery,
    AccommodationRequest_GetBookingGroupQueryVariables
  >(AccommodationRequest_GetBookingGroupDocument, options);
}
export type AccommodationRequest_GetBookingGroupQueryHookResult = ReturnType<
  typeof useAccommodationRequest_GetBookingGroupQuery
>;
export type AccommodationRequest_GetBookingGroupLazyQueryHookResult = ReturnType<
  typeof useAccommodationRequest_GetBookingGroupLazyQuery
>;
export namespace AccommodationRequest_getBookingGroup {
  export type Return = AccommodationRequest_GetBookingGroupQuery;
  export type Variables = AccommodationRequest_GetBookingGroupQueryVariables;
  export const OperationName = "AccommodationRequest_getBookingGroup";

  export const Document = AccommodationRequest_GetBookingGroupDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AccommodationRequest_GetLastDocument = gql`
  query AccommodationRequest_getLast($filter: AccommodationRequestQueryInput!) {
    getLastAccommodationRequest(filter: $filter) {
      ...AccommodationRequest_getLastItem
    }
  }
  ${AccommodationRequest_GetLastItemFragmentDoc}
`;
export type AccommodationRequest_GetLastComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationRequest_GetLastQuery,
    AccommodationRequest_GetLastQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationRequest_GetLastQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationRequest_GetLastComponent = (
  props: AccommodationRequest_GetLastComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationRequest_GetLastQuery,
    AccommodationRequest_GetLastQueryVariables
  >
    query={AccommodationRequest_GetLastDocument}
    {...props}
  />
);

/**
 * __useAccommodationRequest_GetLastQuery__
 *
 * To run a query within a React component, call `useAccommodationRequest_GetLastQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationRequest_GetLastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationRequest_GetLastQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAccommodationRequest_GetLastQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationRequest_GetLastQuery,
    AccommodationRequest_GetLastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationRequest_GetLastQuery,
    AccommodationRequest_GetLastQueryVariables
  >(AccommodationRequest_GetLastDocument, options);
}
export function useAccommodationRequest_GetLastLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationRequest_GetLastQuery,
    AccommodationRequest_GetLastQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationRequest_GetLastQuery,
    AccommodationRequest_GetLastQueryVariables
  >(AccommodationRequest_GetLastDocument, options);
}
export type AccommodationRequest_GetLastQueryHookResult = ReturnType<
  typeof useAccommodationRequest_GetLastQuery
>;
export type AccommodationRequest_GetLastLazyQueryHookResult = ReturnType<
  typeof useAccommodationRequest_GetLastLazyQuery
>;
export namespace AccommodationRequest_getLast {
  export type Return = AccommodationRequest_GetLastQuery;
  export type Variables = AccommodationRequest_GetLastQueryVariables;
  export const OperationName = "AccommodationRequest_getLast";

  export const Document = AccommodationRequest_GetLastDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SubmitAccommodationRequestDocument = gql`
  mutation submitAccommodationRequest(
    $bookingGroupId: ObjectId
    $bookingIds: [ObjectId!]
    $input: AccommodationRequestInput!
    $file: String
  ) {
    createAccommodationRequest(
      bookingGroupId: $bookingGroupId
      bookingIds: $bookingIds
      data: $input
      file: $file
    ) {
      _id
    }
  }
`;
export type SubmitAccommodationRequestMutationFn = Apollo.MutationFunction<
  SubmitAccommodationRequestMutation,
  SubmitAccommodationRequestMutationVariables
>;
export type SubmitAccommodationRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitAccommodationRequestMutation,
    SubmitAccommodationRequestMutationVariables
  >,
  "mutation"
>;

export const SubmitAccommodationRequestComponent = (
  props: SubmitAccommodationRequestComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitAccommodationRequestMutation,
    SubmitAccommodationRequestMutationVariables
  >
    mutation={SubmitAccommodationRequestDocument}
    {...props}
  />
);

/**
 * __useSubmitAccommodationRequestMutation__
 *
 * To run a mutation, you first call `useSubmitAccommodationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAccommodationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAccommodationRequestMutation, { data, loading, error }] = useSubmitAccommodationRequestMutation({
 *   variables: {
 *      bookingGroupId: // value for 'bookingGroupId'
 *      bookingIds: // value for 'bookingIds'
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSubmitAccommodationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitAccommodationRequestMutation,
    SubmitAccommodationRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitAccommodationRequestMutation,
    SubmitAccommodationRequestMutationVariables
  >(SubmitAccommodationRequestDocument, options);
}
export type SubmitAccommodationRequestMutationHookResult = ReturnType<
  typeof useSubmitAccommodationRequestMutation
>;
export namespace SubmitAccommodationRequest {
  export type Return = SubmitAccommodationRequestMutation;
  export type Variables = SubmitAccommodationRequestMutationVariables;
  export const OperationName = "submitAccommodationRequest";

  export const Document = SubmitAccommodationRequestDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationRequest_GetAllowedCostCentersDocument = gql`
  query AccommodationRequest_GetAllowedCostCenters {
    me {
      allowedCostCenters {
        ...CostCenter
      }
    }
  }
  ${CostCenterFragmentDoc}
`;
export type AccommodationRequest_GetAllowedCostCentersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationRequest_GetAllowedCostCentersQuery,
    AccommodationRequest_GetAllowedCostCentersQueryVariables
  >,
  "query"
>;

export const AccommodationRequest_GetAllowedCostCentersComponent = (
  props: AccommodationRequest_GetAllowedCostCentersComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationRequest_GetAllowedCostCentersQuery,
    AccommodationRequest_GetAllowedCostCentersQueryVariables
  >
    query={AccommodationRequest_GetAllowedCostCentersDocument}
    {...props}
  />
);

/**
 * __useAccommodationRequest_GetAllowedCostCentersQuery__
 *
 * To run a query within a React component, call `useAccommodationRequest_GetAllowedCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationRequest_GetAllowedCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationRequest_GetAllowedCostCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccommodationRequest_GetAllowedCostCentersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationRequest_GetAllowedCostCentersQuery,
    AccommodationRequest_GetAllowedCostCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationRequest_GetAllowedCostCentersQuery,
    AccommodationRequest_GetAllowedCostCentersQueryVariables
  >(AccommodationRequest_GetAllowedCostCentersDocument, options);
}
export function useAccommodationRequest_GetAllowedCostCentersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationRequest_GetAllowedCostCentersQuery,
    AccommodationRequest_GetAllowedCostCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationRequest_GetAllowedCostCentersQuery,
    AccommodationRequest_GetAllowedCostCentersQueryVariables
  >(AccommodationRequest_GetAllowedCostCentersDocument, options);
}
export type AccommodationRequest_GetAllowedCostCentersQueryHookResult = ReturnType<
  typeof useAccommodationRequest_GetAllowedCostCentersQuery
>;
export type AccommodationRequest_GetAllowedCostCentersLazyQueryHookResult = ReturnType<
  typeof useAccommodationRequest_GetAllowedCostCentersLazyQuery
>;
export namespace AccommodationRequest_GetAllowedCostCenters {
  export type Return = AccommodationRequest_GetAllowedCostCentersQuery;
  export type Variables = AccommodationRequest_GetAllowedCostCentersQueryVariables;
  export const OperationName = "AccommodationRequest_GetAllowedCostCenters";

  export const Document = AccommodationRequest_GetAllowedCostCentersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingHospitalityGetDocument = gql`
  query bookingHospitalityGet($bookingId: ObjectId!, $week: WeekYearInput!) {
    bookingHospitality(bookingId: $bookingId) {
      ...BookingHospitality
      accommodation {
        confirmations {
          _id
          documents(week: $week) {
            ...DDocument
          }
        }
      }
    }
  }
  ${BookingHospitalityFragmentDoc}
  ${DDocumentFragmentDoc}
`;
export type BookingHospitalityGetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingHospitalityGetQuery,
    BookingHospitalityGetQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingHospitalityGetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingHospitalityGetComponent = (
  props: BookingHospitalityGetComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingHospitalityGetQuery,
    BookingHospitalityGetQueryVariables
  >
    query={BookingHospitalityGetDocument}
    {...props}
  />
);

/**
 * __useBookingHospitalityGetQuery__
 *
 * To run a query within a React component, call `useBookingHospitalityGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingHospitalityGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingHospitalityGetQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      week: // value for 'week'
 *   },
 * });
 */
export function useBookingHospitalityGetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingHospitalityGetQuery,
    BookingHospitalityGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingHospitalityGetQuery, BookingHospitalityGetQueryVariables>(
    BookingHospitalityGetDocument,
    options
  );
}
export function useBookingHospitalityGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingHospitalityGetQuery,
    BookingHospitalityGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingHospitalityGetQuery,
    BookingHospitalityGetQueryVariables
  >(BookingHospitalityGetDocument, options);
}
export type BookingHospitalityGetQueryHookResult = ReturnType<
  typeof useBookingHospitalityGetQuery
>;
export type BookingHospitalityGetLazyQueryHookResult = ReturnType<
  typeof useBookingHospitalityGetLazyQuery
>;
export namespace BookingHospitalityGet {
  export type Return = BookingHospitalityGetQuery;
  export type Variables = BookingHospitalityGetQueryVariables;
  export const OperationName = "bookingHospitalityGet";

  export const Document = BookingHospitalityGetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AccommodationRequestGetDocument = gql`
  query accommodationRequestGet($requestId: ObjectId!) {
    accommodationRequestById(requestId: $requestId) {
      _id
      ...FullAccommodationRequest
    }
  }
  ${FullAccommodationRequestFragmentDoc}
`;
export type AccommodationRequestGetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationRequestGetQuery,
    AccommodationRequestGetQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationRequestGetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationRequestGetComponent = (
  props: AccommodationRequestGetComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationRequestGetQuery,
    AccommodationRequestGetQueryVariables
  >
    query={AccommodationRequestGetDocument}
    {...props}
  />
);

/**
 * __useAccommodationRequestGetQuery__
 *
 * To run a query within a React component, call `useAccommodationRequestGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationRequestGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationRequestGetQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAccommodationRequestGetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationRequestGetQuery,
    AccommodationRequestGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationRequestGetQuery,
    AccommodationRequestGetQueryVariables
  >(AccommodationRequestGetDocument, options);
}
export function useAccommodationRequestGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationRequestGetQuery,
    AccommodationRequestGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationRequestGetQuery,
    AccommodationRequestGetQueryVariables
  >(AccommodationRequestGetDocument, options);
}
export type AccommodationRequestGetQueryHookResult = ReturnType<
  typeof useAccommodationRequestGetQuery
>;
export type AccommodationRequestGetLazyQueryHookResult = ReturnType<
  typeof useAccommodationRequestGetLazyQuery
>;
export namespace AccommodationRequestGet {
  export type Return = AccommodationRequestGetQuery;
  export type Variables = AccommodationRequestGetQueryVariables;
  export const OperationName = "accommodationRequestGet";

  export const Document = AccommodationRequestGetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const RemoveAccommodationDocumentDocument = gql`
  mutation removeAccommodationDocument($bookingId: ObjectId!, $fileId: ObjectId!) {
    removeAccommodationDocument(bookingId: $bookingId, fileId: $fileId)
  }
`;
export type RemoveAccommodationDocumentMutationFn = Apollo.MutationFunction<
  RemoveAccommodationDocumentMutation,
  RemoveAccommodationDocumentMutationVariables
>;
export type RemoveAccommodationDocumentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveAccommodationDocumentMutation,
    RemoveAccommodationDocumentMutationVariables
  >,
  "mutation"
>;

export const RemoveAccommodationDocumentComponent = (
  props: RemoveAccommodationDocumentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveAccommodationDocumentMutation,
    RemoveAccommodationDocumentMutationVariables
  >
    mutation={RemoveAccommodationDocumentDocument}
    {...props}
  />
);

/**
 * __useRemoveAccommodationDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveAccommodationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccommodationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccommodationDocumentMutation, { data, loading, error }] = useRemoveAccommodationDocumentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRemoveAccommodationDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAccommodationDocumentMutation,
    RemoveAccommodationDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveAccommodationDocumentMutation,
    RemoveAccommodationDocumentMutationVariables
  >(RemoveAccommodationDocumentDocument, options);
}
export type RemoveAccommodationDocumentMutationHookResult = ReturnType<
  typeof useRemoveAccommodationDocumentMutation
>;
export namespace RemoveAccommodationDocument {
  export type Return = RemoveAccommodationDocumentMutation;
  export type Variables = RemoveAccommodationDocumentMutationVariables;
  export const OperationName = "removeAccommodationDocument";

  export const Document = RemoveAccommodationDocumentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RemoveTravelDocumentDocument = gql`
  mutation removeTravelDocument($bookingId: ObjectId!, $fileId: ObjectId!) {
    removeTravelDocument(bookingId: $bookingId, fileId: $fileId)
  }
`;
export type RemoveTravelDocumentMutationFn = Apollo.MutationFunction<
  RemoveTravelDocumentMutation,
  RemoveTravelDocumentMutationVariables
>;
export type RemoveTravelDocumentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveTravelDocumentMutation,
    RemoveTravelDocumentMutationVariables
  >,
  "mutation"
>;

export const RemoveTravelDocumentComponent = (
  props: RemoveTravelDocumentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveTravelDocumentMutation,
    RemoveTravelDocumentMutationVariables
  >
    mutation={RemoveTravelDocumentDocument}
    {...props}
  />
);

/**
 * __useRemoveTravelDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveTravelDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTravelDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTravelDocumentMutation, { data, loading, error }] = useRemoveTravelDocumentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRemoveTravelDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTravelDocumentMutation,
    RemoveTravelDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveTravelDocumentMutation,
    RemoveTravelDocumentMutationVariables
  >(RemoveTravelDocumentDocument, options);
}
export type RemoveTravelDocumentMutationHookResult = ReturnType<
  typeof useRemoveTravelDocumentMutation
>;
export namespace RemoveTravelDocument {
  export type Return = RemoveTravelDocumentMutation;
  export type Variables = RemoveTravelDocumentMutationVariables;
  export const OperationName = "removeTravelDocument";

  export const Document = RemoveTravelDocumentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CreateTravelRequestDocument = gql`
  mutation createTravelRequest(
    $bookingGroupId: ObjectId
    $input: TravelRequestInput!
    $bookingIds: [ObjectId!]
  ) {
    createTravelRequest(
      bookingGroupId: $bookingGroupId
      data: $input
      bookingIds: $bookingIds
    ) {
      _id
    }
  }
`;
export type CreateTravelRequestMutationFn = Apollo.MutationFunction<
  CreateTravelRequestMutation,
  CreateTravelRequestMutationVariables
>;
export type CreateTravelRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateTravelRequestMutation,
    CreateTravelRequestMutationVariables
  >,
  "mutation"
>;

export const CreateTravelRequestComponent = (
  props: CreateTravelRequestComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateTravelRequestMutation,
    CreateTravelRequestMutationVariables
  >
    mutation={CreateTravelRequestDocument}
    {...props}
  />
);

/**
 * __useCreateTravelRequestMutation__
 *
 * To run a mutation, you first call `useCreateTravelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTravelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTravelRequestMutation, { data, loading, error }] = useCreateTravelRequestMutation({
 *   variables: {
 *      bookingGroupId: // value for 'bookingGroupId'
 *      input: // value for 'input'
 *      bookingIds: // value for 'bookingIds'
 *   },
 * });
 */
export function useCreateTravelRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTravelRequestMutation,
    CreateTravelRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTravelRequestMutation,
    CreateTravelRequestMutationVariables
  >(CreateTravelRequestDocument, options);
}
export type CreateTravelRequestMutationHookResult = ReturnType<
  typeof useCreateTravelRequestMutation
>;
export namespace CreateTravelRequest {
  export type Return = CreateTravelRequestMutation;
  export type Variables = CreateTravelRequestMutationVariables;
  export const OperationName = "createTravelRequest";

  export const Document = CreateTravelRequestDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ToggleAccommodationConfirmationDocument = gql`
  mutation toggleAccommodationConfirmation(
    $bookingId: ObjectId!
    $confirmationId: ObjectId!
  ) {
    toggleAccommodationConfirmation(
      bookingId: $bookingId
      confirmationId: $confirmationId
    ) {
      ...BookingHospitality
    }
  }
  ${BookingHospitalityFragmentDoc}
`;
export type ToggleAccommodationConfirmationMutationFn = Apollo.MutationFunction<
  ToggleAccommodationConfirmationMutation,
  ToggleAccommodationConfirmationMutationVariables
>;
export type ToggleAccommodationConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ToggleAccommodationConfirmationMutation,
    ToggleAccommodationConfirmationMutationVariables
  >,
  "mutation"
>;

export const ToggleAccommodationConfirmationComponent = (
  props: ToggleAccommodationConfirmationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ToggleAccommodationConfirmationMutation,
    ToggleAccommodationConfirmationMutationVariables
  >
    mutation={ToggleAccommodationConfirmationDocument}
    {...props}
  />
);

/**
 * __useToggleAccommodationConfirmationMutation__
 *
 * To run a mutation, you first call `useToggleAccommodationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAccommodationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAccommodationConfirmationMutation, { data, loading, error }] = useToggleAccommodationConfirmationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      confirmationId: // value for 'confirmationId'
 *   },
 * });
 */
export function useToggleAccommodationConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleAccommodationConfirmationMutation,
    ToggleAccommodationConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleAccommodationConfirmationMutation,
    ToggleAccommodationConfirmationMutationVariables
  >(ToggleAccommodationConfirmationDocument, options);
}
export type ToggleAccommodationConfirmationMutationHookResult = ReturnType<
  typeof useToggleAccommodationConfirmationMutation
>;
export namespace ToggleAccommodationConfirmation {
  export type Return = ToggleAccommodationConfirmationMutation;
  export type Variables = ToggleAccommodationConfirmationMutationVariables;
  export const OperationName = "toggleAccommodationConfirmation";

  export const Document = ToggleAccommodationConfirmationDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ToggleTravelConfirmationDocument = gql`
  mutation toggleTravelConfirmation($bookingId: ObjectId!, $confirmationId: ObjectId!) {
    toggleTravelConfirmation(bookingId: $bookingId, confirmationId: $confirmationId) {
      ...BookingHospitality
    }
  }
  ${BookingHospitalityFragmentDoc}
`;
export type ToggleTravelConfirmationMutationFn = Apollo.MutationFunction<
  ToggleTravelConfirmationMutation,
  ToggleTravelConfirmationMutationVariables
>;
export type ToggleTravelConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ToggleTravelConfirmationMutation,
    ToggleTravelConfirmationMutationVariables
  >,
  "mutation"
>;

export const ToggleTravelConfirmationComponent = (
  props: ToggleTravelConfirmationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ToggleTravelConfirmationMutation,
    ToggleTravelConfirmationMutationVariables
  >
    mutation={ToggleTravelConfirmationDocument}
    {...props}
  />
);

/**
 * __useToggleTravelConfirmationMutation__
 *
 * To run a mutation, you first call `useToggleTravelConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTravelConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTravelConfirmationMutation, { data, loading, error }] = useToggleTravelConfirmationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      confirmationId: // value for 'confirmationId'
 *   },
 * });
 */
export function useToggleTravelConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleTravelConfirmationMutation,
    ToggleTravelConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleTravelConfirmationMutation,
    ToggleTravelConfirmationMutationVariables
  >(ToggleTravelConfirmationDocument, options);
}
export type ToggleTravelConfirmationMutationHookResult = ReturnType<
  typeof useToggleTravelConfirmationMutation
>;
export namespace ToggleTravelConfirmation {
  export type Return = ToggleTravelConfirmationMutation;
  export type Variables = ToggleTravelConfirmationMutationVariables;
  export const OperationName = "toggleTravelConfirmation";

  export const Document = ToggleTravelConfirmationDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetTravelConfirmationByIdDocument = gql`
  query getTravelConfirmationById($bookingId: ObjectId!, $confirmationId: ObjectId!) {
    bookingById(id: $bookingId) {
      _id
      ...BookingWeekCard
      BookingGroup {
        _id
        bookings {
          _id
          Week
          isOpen
          IsConsultantPayed
        }
      }
      Consultant {
        LegalPersonType
      }
    }
    travelConfirmationById(confirmationId: $confirmationId) {
      _id
      weeks
      allWeeks {
        weekYear {
          Week
          Year
        }
        cost
        description
        startDate
        endDate
        isTravel
        note
      }
      totalCost
      totalExVAT
      documents {
        ...DocumentList_Item
      }
      confirmedBy {
        Name
        PersonId
      }
      confirmedOn
    }
  }
  ${BookingWeekCardFragmentDoc}
  ${DocumentList_ItemFragmentDoc}
`;
export type GetTravelConfirmationByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetTravelConfirmationByIdQuery,
    GetTravelConfirmationByIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetTravelConfirmationByIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetTravelConfirmationByIdComponent = (
  props: GetTravelConfirmationByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    GetTravelConfirmationByIdQuery,
    GetTravelConfirmationByIdQueryVariables
  >
    query={GetTravelConfirmationByIdDocument}
    {...props}
  />
);

/**
 * __useGetTravelConfirmationByIdQuery__
 *
 * To run a query within a React component, call `useGetTravelConfirmationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelConfirmationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelConfirmationByIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      confirmationId: // value for 'confirmationId'
 *   },
 * });
 */
export function useGetTravelConfirmationByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTravelConfirmationByIdQuery,
    GetTravelConfirmationByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTravelConfirmationByIdQuery,
    GetTravelConfirmationByIdQueryVariables
  >(GetTravelConfirmationByIdDocument, options);
}
export function useGetTravelConfirmationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTravelConfirmationByIdQuery,
    GetTravelConfirmationByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTravelConfirmationByIdQuery,
    GetTravelConfirmationByIdQueryVariables
  >(GetTravelConfirmationByIdDocument, options);
}
export type GetTravelConfirmationByIdQueryHookResult = ReturnType<
  typeof useGetTravelConfirmationByIdQuery
>;
export type GetTravelConfirmationByIdLazyQueryHookResult = ReturnType<
  typeof useGetTravelConfirmationByIdLazyQuery
>;
export namespace GetTravelConfirmationById {
  export type Return = GetTravelConfirmationByIdQuery;
  export type Variables = GetTravelConfirmationByIdQueryVariables;
  export const OperationName = "getTravelConfirmationById";

  export const Document = GetTravelConfirmationByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetTravelConfirmationPageDataDocument = gql`
  query getTravelConfirmationPageData($bookingId: ObjectId!) {
    bookingById(id: $bookingId) {
      _id
      ...BookingWeekCard
      BookingGroup {
        _id
        bookings {
          _id
          Week
          isOpen
          IsConsultantPayed
        }
      }
      Consultant {
        LegalPersonType
      }
    }
  }
  ${BookingWeekCardFragmentDoc}
`;
export type GetTravelConfirmationPageDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetTravelConfirmationPageDataQuery,
    GetTravelConfirmationPageDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetTravelConfirmationPageDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetTravelConfirmationPageDataComponent = (
  props: GetTravelConfirmationPageDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetTravelConfirmationPageDataQuery,
    GetTravelConfirmationPageDataQueryVariables
  >
    query={GetTravelConfirmationPageDataDocument}
    {...props}
  />
);

/**
 * __useGetTravelConfirmationPageDataQuery__
 *
 * To run a query within a React component, call `useGetTravelConfirmationPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelConfirmationPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelConfirmationPageDataQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetTravelConfirmationPageDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTravelConfirmationPageDataQuery,
    GetTravelConfirmationPageDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTravelConfirmationPageDataQuery,
    GetTravelConfirmationPageDataQueryVariables
  >(GetTravelConfirmationPageDataDocument, options);
}
export function useGetTravelConfirmationPageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTravelConfirmationPageDataQuery,
    GetTravelConfirmationPageDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTravelConfirmationPageDataQuery,
    GetTravelConfirmationPageDataQueryVariables
  >(GetTravelConfirmationPageDataDocument, options);
}
export type GetTravelConfirmationPageDataQueryHookResult = ReturnType<
  typeof useGetTravelConfirmationPageDataQuery
>;
export type GetTravelConfirmationPageDataLazyQueryHookResult = ReturnType<
  typeof useGetTravelConfirmationPageDataLazyQuery
>;
export namespace GetTravelConfirmationPageData {
  export type Return = GetTravelConfirmationPageDataQuery;
  export type Variables = GetTravelConfirmationPageDataQueryVariables;
  export const OperationName = "getTravelConfirmationPageData";

  export const Document = GetTravelConfirmationPageDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConfimTravelDocument = gql`
  mutation confimTravel($input: ConfirmTravelInput!) {
    confirmTravel(input: $input) {
      _id
    }
  }
`;
export type ConfimTravelMutationFn = Apollo.MutationFunction<
  ConfimTravelMutation,
  ConfimTravelMutationVariables
>;
export type ConfimTravelComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConfimTravelMutation,
    ConfimTravelMutationVariables
  >,
  "mutation"
>;

export const ConfimTravelComponent = (props: ConfimTravelComponentProps) => (
  <ApolloReactComponents.Mutation<ConfimTravelMutation, ConfimTravelMutationVariables>
    mutation={ConfimTravelDocument}
    {...props}
  />
);

/**
 * __useConfimTravelMutation__
 *
 * To run a mutation, you first call `useConfimTravelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfimTravelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confimTravelMutation, { data, loading, error }] = useConfimTravelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfimTravelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfimTravelMutation,
    ConfimTravelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfimTravelMutation, ConfimTravelMutationVariables>(
    ConfimTravelDocument,
    options
  );
}
export type ConfimTravelMutationHookResult = ReturnType<typeof useConfimTravelMutation>;
export namespace ConfimTravel {
  export type Return = ConfimTravelMutation;
  export type Variables = ConfimTravelMutationVariables;
  export const OperationName = "confimTravel";

  export const Document = ConfimTravelDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateTravelConfirmationDocument = gql`
  mutation updateTravelConfirmation($id: ObjectId!, $input: ConfirmTravelInput!) {
    updateTravelConfirmation(id: $id, input: $input)
  }
`;
export type UpdateTravelConfirmationMutationFn = Apollo.MutationFunction<
  UpdateTravelConfirmationMutation,
  UpdateTravelConfirmationMutationVariables
>;
export type UpdateTravelConfirmationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateTravelConfirmationMutation,
    UpdateTravelConfirmationMutationVariables
  >,
  "mutation"
>;

export const UpdateTravelConfirmationComponent = (
  props: UpdateTravelConfirmationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateTravelConfirmationMutation,
    UpdateTravelConfirmationMutationVariables
  >
    mutation={UpdateTravelConfirmationDocument}
    {...props}
  />
);

/**
 * __useUpdateTravelConfirmationMutation__
 *
 * To run a mutation, you first call `useUpdateTravelConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelConfirmationMutation, { data, loading, error }] = useUpdateTravelConfirmationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTravelConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTravelConfirmationMutation,
    UpdateTravelConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTravelConfirmationMutation,
    UpdateTravelConfirmationMutationVariables
  >(UpdateTravelConfirmationDocument, options);
}
export type UpdateTravelConfirmationMutationHookResult = ReturnType<
  typeof useUpdateTravelConfirmationMutation
>;
export namespace UpdateTravelConfirmation {
  export type Return = UpdateTravelConfirmationMutation;
  export type Variables = UpdateTravelConfirmationMutationVariables;
  export const OperationName = "updateTravelConfirmation";

  export const Document = UpdateTravelConfirmationDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetTravelRequestDocument = gql`
  query getTravelRequest($requestId: ObjectId!) {
    travelRequestById(requestId: $requestId) {
      ...FullTravelRequest
    }
  }
  ${FullTravelRequestFragmentDoc}
`;
export type GetTravelRequestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetTravelRequestQuery,
    GetTravelRequestQueryVariables
  >,
  "query"
> &
  ({ variables: GetTravelRequestQueryVariables; skip?: boolean } | { skip: boolean });

export const GetTravelRequestComponent = (props: GetTravelRequestComponentProps) => (
  <ApolloReactComponents.Query<GetTravelRequestQuery, GetTravelRequestQueryVariables>
    query={GetTravelRequestDocument}
    {...props}
  />
);

/**
 * __useGetTravelRequestQuery__
 *
 * To run a query within a React component, call `useGetTravelRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetTravelRequestQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTravelRequestQuery,
    GetTravelRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTravelRequestQuery, GetTravelRequestQueryVariables>(
    GetTravelRequestDocument,
    options
  );
}
export function useGetTravelRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTravelRequestQuery,
    GetTravelRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTravelRequestQuery, GetTravelRequestQueryVariables>(
    GetTravelRequestDocument,
    options
  );
}
export type GetTravelRequestQueryHookResult = ReturnType<typeof useGetTravelRequestQuery>;
export type GetTravelRequestLazyQueryHookResult = ReturnType<
  typeof useGetTravelRequestLazyQuery
>;
export namespace GetTravelRequest {
  export type Return = GetTravelRequestQuery;
  export type Variables = GetTravelRequestQueryVariables;
  export const OperationName = "getTravelRequest";

  export const Document = GetTravelRequestDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TravelRequest_GetBookingGroupDocument = gql`
  query TravelRequest_getBookingGroup($id: ObjectId!) {
    getBookingGroup(id: $id) {
      ...TravelRequestBookingGroupData
    }
  }
  ${TravelRequestBookingGroupDataFragmentDoc}
`;
export type TravelRequest_GetBookingGroupComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TravelRequest_GetBookingGroupQuery,
    TravelRequest_GetBookingGroupQueryVariables
  >,
  "query"
> &
  (
    | { variables: TravelRequest_GetBookingGroupQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const TravelRequest_GetBookingGroupComponent = (
  props: TravelRequest_GetBookingGroupComponentProps
) => (
  <ApolloReactComponents.Query<
    TravelRequest_GetBookingGroupQuery,
    TravelRequest_GetBookingGroupQueryVariables
  >
    query={TravelRequest_GetBookingGroupDocument}
    {...props}
  />
);

/**
 * __useTravelRequest_GetBookingGroupQuery__
 *
 * To run a query within a React component, call `useTravelRequest_GetBookingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRequest_GetBookingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRequest_GetBookingGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTravelRequest_GetBookingGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TravelRequest_GetBookingGroupQuery,
    TravelRequest_GetBookingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TravelRequest_GetBookingGroupQuery,
    TravelRequest_GetBookingGroupQueryVariables
  >(TravelRequest_GetBookingGroupDocument, options);
}
export function useTravelRequest_GetBookingGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TravelRequest_GetBookingGroupQuery,
    TravelRequest_GetBookingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TravelRequest_GetBookingGroupQuery,
    TravelRequest_GetBookingGroupQueryVariables
  >(TravelRequest_GetBookingGroupDocument, options);
}
export type TravelRequest_GetBookingGroupQueryHookResult = ReturnType<
  typeof useTravelRequest_GetBookingGroupQuery
>;
export type TravelRequest_GetBookingGroupLazyQueryHookResult = ReturnType<
  typeof useTravelRequest_GetBookingGroupLazyQuery
>;
export namespace TravelRequest_getBookingGroup {
  export type Return = TravelRequest_GetBookingGroupQuery;
  export type Variables = TravelRequest_GetBookingGroupQueryVariables;
  export const OperationName = "TravelRequest_getBookingGroup";

  export const Document = TravelRequest_GetBookingGroupDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetInvoiceDocument = gql`
  query getInvoice($provider: InvoiceProvider!, $number: String!) {
    invoiceByNumber(provider: $provider, number: $number) {
      ...Invoice
    }
  }
  ${InvoiceFragmentDoc}
`;
export type GetInvoiceComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetInvoiceQuery, GetInvoiceQueryVariables>,
  "query"
> &
  ({ variables: GetInvoiceQueryVariables; skip?: boolean } | { skip: boolean });

export const GetInvoiceComponent = (props: GetInvoiceComponentProps) => (
  <ApolloReactComponents.Query<GetInvoiceQuery, GetInvoiceQueryVariables>
    query={GetInvoiceDocument}
    {...props}
  />
);

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useGetInvoiceQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(
    GetInvoiceDocument,
    options
  );
}
export function useGetInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(
    GetInvoiceDocument,
    options
  );
}
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export namespace GetInvoice {
  export type Return = GetInvoiceQuery;
  export type Variables = GetInvoiceQueryVariables;
  export const OperationName = "getInvoice";

  export const Document = GetInvoiceDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingInvoicingAssignBookingDocument = gql`
  mutation bookingInvoicingAssignBooking(
    $bookingId: ObjectId!
    $isGroupInvoicing: Boolean!
  ) {
    assignFortnoxInvoiceToBooking(
      bookingId: $bookingId
      isGroupInvoicing: $isGroupInvoicing
    ) {
      Booking {
        _id
        ...BookingFinanceEditor_Item
      }
    }
  }
  ${BookingFinanceEditor_ItemFragmentDoc}
`;
export type BookingInvoicingAssignBookingMutationFn = Apollo.MutationFunction<
  BookingInvoicingAssignBookingMutation,
  BookingInvoicingAssignBookingMutationVariables
>;
export type BookingInvoicingAssignBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingInvoicingAssignBookingMutation,
    BookingInvoicingAssignBookingMutationVariables
  >,
  "mutation"
>;

export const BookingInvoicingAssignBookingComponent = (
  props: BookingInvoicingAssignBookingComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingInvoicingAssignBookingMutation,
    BookingInvoicingAssignBookingMutationVariables
  >
    mutation={BookingInvoicingAssignBookingDocument}
    {...props}
  />
);

/**
 * __useBookingInvoicingAssignBookingMutation__
 *
 * To run a mutation, you first call `useBookingInvoicingAssignBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingInvoicingAssignBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingInvoicingAssignBookingMutation, { data, loading, error }] = useBookingInvoicingAssignBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      isGroupInvoicing: // value for 'isGroupInvoicing'
 *   },
 * });
 */
export function useBookingInvoicingAssignBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingInvoicingAssignBookingMutation,
    BookingInvoicingAssignBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingInvoicingAssignBookingMutation,
    BookingInvoicingAssignBookingMutationVariables
  >(BookingInvoicingAssignBookingDocument, options);
}
export type BookingInvoicingAssignBookingMutationHookResult = ReturnType<
  typeof useBookingInvoicingAssignBookingMutation
>;
export namespace BookingInvoicingAssignBooking {
  export type Return = BookingInvoicingAssignBookingMutation;
  export type Variables = BookingInvoicingAssignBookingMutationVariables;
  export const OperationName = "bookingInvoicingAssignBooking";

  export const Document = BookingInvoicingAssignBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishSubcontractorInvoiceDocument = gql`
  mutation publishSubcontractorInvoice($bookingId: ObjectId!) {
    publishSubcontractorInvoiceWorkflow(bookingId: $bookingId) {
      _id
      workflowId
      status
      errorMessage
      metadata
    }
  }
`;
export type PublishSubcontractorInvoiceMutationFn = Apollo.MutationFunction<
  PublishSubcontractorInvoiceMutation,
  PublishSubcontractorInvoiceMutationVariables
>;
export type PublishSubcontractorInvoiceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishSubcontractorInvoiceMutation,
    PublishSubcontractorInvoiceMutationVariables
  >,
  "mutation"
>;

export const PublishSubcontractorInvoiceComponent = (
  props: PublishSubcontractorInvoiceComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishSubcontractorInvoiceMutation,
    PublishSubcontractorInvoiceMutationVariables
  >
    mutation={PublishSubcontractorInvoiceDocument}
    {...props}
  />
);

/**
 * __usePublishSubcontractorInvoiceMutation__
 *
 * To run a mutation, you first call `usePublishSubcontractorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSubcontractorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSubcontractorInvoiceMutation, { data, loading, error }] = usePublishSubcontractorInvoiceMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function usePublishSubcontractorInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishSubcontractorInvoiceMutation,
    PublishSubcontractorInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishSubcontractorInvoiceMutation,
    PublishSubcontractorInvoiceMutationVariables
  >(PublishSubcontractorInvoiceDocument, options);
}
export type PublishSubcontractorInvoiceMutationHookResult = ReturnType<
  typeof usePublishSubcontractorInvoiceMutation
>;
export namespace PublishSubcontractorInvoice {
  export type Return = PublishSubcontractorInvoiceMutation;
  export type Variables = PublishSubcontractorInvoiceMutationVariables;
  export const OperationName = "publishSubcontractorInvoice";

  export const Document = PublishSubcontractorInvoiceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishPayFormRecordsToFortnoxDocument = gql`
  mutation PublishPayFormRecordsToFortnox($bookingId: ObjectId!, $weekDay: Int) {
    publishPayFormRecordsToFortnox(bookingId: $bookingId, weekDay: $weekDay) {
      _id
      workflowId
      status
      errorMessage
      metadata
    }
  }
`;
export type PublishPayFormRecordsToFortnoxMutationFn = Apollo.MutationFunction<
  PublishPayFormRecordsToFortnoxMutation,
  PublishPayFormRecordsToFortnoxMutationVariables
>;
export type PublishPayFormRecordsToFortnoxComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishPayFormRecordsToFortnoxMutation,
    PublishPayFormRecordsToFortnoxMutationVariables
  >,
  "mutation"
>;

export const PublishPayFormRecordsToFortnoxComponent = (
  props: PublishPayFormRecordsToFortnoxComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishPayFormRecordsToFortnoxMutation,
    PublishPayFormRecordsToFortnoxMutationVariables
  >
    mutation={PublishPayFormRecordsToFortnoxDocument}
    {...props}
  />
);

/**
 * __usePublishPayFormRecordsToFortnoxMutation__
 *
 * To run a mutation, you first call `usePublishPayFormRecordsToFortnoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPayFormRecordsToFortnoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPayFormRecordsToFortnoxMutation, { data, loading, error }] = usePublishPayFormRecordsToFortnoxMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      weekDay: // value for 'weekDay'
 *   },
 * });
 */
export function usePublishPayFormRecordsToFortnoxMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishPayFormRecordsToFortnoxMutation,
    PublishPayFormRecordsToFortnoxMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishPayFormRecordsToFortnoxMutation,
    PublishPayFormRecordsToFortnoxMutationVariables
  >(PublishPayFormRecordsToFortnoxDocument, options);
}
export type PublishPayFormRecordsToFortnoxMutationHookResult = ReturnType<
  typeof usePublishPayFormRecordsToFortnoxMutation
>;
export namespace PublishPayFormRecordsToFortnox {
  export type Return = PublishPayFormRecordsToFortnoxMutation;
  export type Variables = PublishPayFormRecordsToFortnoxMutationVariables;
  export const OperationName = "PublishPayFormRecordsToFortnox";

  export const Document = PublishPayFormRecordsToFortnoxDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishSickPayFormToFortnoxDocument = gql`
  mutation PublishSickPayFormToFortnox($bookingId: ObjectId!, $weekDay: Int) {
    publishSickPayFormToFortnox(bookingId: $bookingId, weekDay: $weekDay) {
      _id
      workflowId
      status
      errorMessage
      metadata
    }
  }
`;
export type PublishSickPayFormToFortnoxMutationFn = Apollo.MutationFunction<
  PublishSickPayFormToFortnoxMutation,
  PublishSickPayFormToFortnoxMutationVariables
>;
export type PublishSickPayFormToFortnoxComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishSickPayFormToFortnoxMutation,
    PublishSickPayFormToFortnoxMutationVariables
  >,
  "mutation"
>;

export const PublishSickPayFormToFortnoxComponent = (
  props: PublishSickPayFormToFortnoxComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishSickPayFormToFortnoxMutation,
    PublishSickPayFormToFortnoxMutationVariables
  >
    mutation={PublishSickPayFormToFortnoxDocument}
    {...props}
  />
);

/**
 * __usePublishSickPayFormToFortnoxMutation__
 *
 * To run a mutation, you first call `usePublishSickPayFormToFortnoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSickPayFormToFortnoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSickPayFormToFortnoxMutation, { data, loading, error }] = usePublishSickPayFormToFortnoxMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      weekDay: // value for 'weekDay'
 *   },
 * });
 */
export function usePublishSickPayFormToFortnoxMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishSickPayFormToFortnoxMutation,
    PublishSickPayFormToFortnoxMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishSickPayFormToFortnoxMutation,
    PublishSickPayFormToFortnoxMutationVariables
  >(PublishSickPayFormToFortnoxDocument, options);
}
export type PublishSickPayFormToFortnoxMutationHookResult = ReturnType<
  typeof usePublishSickPayFormToFortnoxMutation
>;
export namespace PublishSickPayFormToFortnox {
  export type Return = PublishSickPayFormToFortnoxMutation;
  export type Variables = PublishSickPayFormToFortnoxMutationVariables;
  export const OperationName = "PublishSickPayFormToFortnox";

  export const Document = PublishSickPayFormToFortnoxDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CheckFortnoxSalaryForWeekDocument = gql`
  query CheckFortnoxSalaryForWeek($bookingId: ObjectId!) {
    checkFortnoxSalaryForWeek(bookingId: $bookingId) {
      employeeId
      takenWeekDays
    }
  }
`;
export type CheckFortnoxSalaryForWeekComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CheckFortnoxSalaryForWeekQuery,
    CheckFortnoxSalaryForWeekQueryVariables
  >,
  "query"
> &
  (
    | { variables: CheckFortnoxSalaryForWeekQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CheckFortnoxSalaryForWeekComponent = (
  props: CheckFortnoxSalaryForWeekComponentProps
) => (
  <ApolloReactComponents.Query<
    CheckFortnoxSalaryForWeekQuery,
    CheckFortnoxSalaryForWeekQueryVariables
  >
    query={CheckFortnoxSalaryForWeekDocument}
    {...props}
  />
);

/**
 * __useCheckFortnoxSalaryForWeekQuery__
 *
 * To run a query within a React component, call `useCheckFortnoxSalaryForWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckFortnoxSalaryForWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckFortnoxSalaryForWeekQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCheckFortnoxSalaryForWeekQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckFortnoxSalaryForWeekQuery,
    CheckFortnoxSalaryForWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckFortnoxSalaryForWeekQuery,
    CheckFortnoxSalaryForWeekQueryVariables
  >(CheckFortnoxSalaryForWeekDocument, options);
}
export function useCheckFortnoxSalaryForWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckFortnoxSalaryForWeekQuery,
    CheckFortnoxSalaryForWeekQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckFortnoxSalaryForWeekQuery,
    CheckFortnoxSalaryForWeekQueryVariables
  >(CheckFortnoxSalaryForWeekDocument, options);
}
export type CheckFortnoxSalaryForWeekQueryHookResult = ReturnType<
  typeof useCheckFortnoxSalaryForWeekQuery
>;
export type CheckFortnoxSalaryForWeekLazyQueryHookResult = ReturnType<
  typeof useCheckFortnoxSalaryForWeekLazyQuery
>;
export namespace CheckFortnoxSalaryForWeek {
  export type Return = CheckFortnoxSalaryForWeekQuery;
  export type Variables = CheckFortnoxSalaryForWeekQueryVariables;
  export const OperationName = "CheckFortnoxSalaryForWeek";

  export const Document = CheckFortnoxSalaryForWeekDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetPublishSubcontractorInvoiceStatusDocument = gql`
  query getPublishSubcontractorInvoiceStatus($workflowId: String!) {
    workflowRunByWorkflowId(workflowId: $workflowId) {
      _id
      status
      errorMessage
      metadata
    }
  }
`;
export type GetPublishSubcontractorInvoiceStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetPublishSubcontractorInvoiceStatusQuery,
    GetPublishSubcontractorInvoiceStatusQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetPublishSubcontractorInvoiceStatusQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetPublishSubcontractorInvoiceStatusComponent = (
  props: GetPublishSubcontractorInvoiceStatusComponentProps
) => (
  <ApolloReactComponents.Query<
    GetPublishSubcontractorInvoiceStatusQuery,
    GetPublishSubcontractorInvoiceStatusQueryVariables
  >
    query={GetPublishSubcontractorInvoiceStatusDocument}
    {...props}
  />
);

/**
 * __useGetPublishSubcontractorInvoiceStatusQuery__
 *
 * To run a query within a React component, call `useGetPublishSubcontractorInvoiceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishSubcontractorInvoiceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishSubcontractorInvoiceStatusQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetPublishSubcontractorInvoiceStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPublishSubcontractorInvoiceStatusQuery,
    GetPublishSubcontractorInvoiceStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPublishSubcontractorInvoiceStatusQuery,
    GetPublishSubcontractorInvoiceStatusQueryVariables
  >(GetPublishSubcontractorInvoiceStatusDocument, options);
}
export function useGetPublishSubcontractorInvoiceStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublishSubcontractorInvoiceStatusQuery,
    GetPublishSubcontractorInvoiceStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublishSubcontractorInvoiceStatusQuery,
    GetPublishSubcontractorInvoiceStatusQueryVariables
  >(GetPublishSubcontractorInvoiceStatusDocument, options);
}
export type GetPublishSubcontractorInvoiceStatusQueryHookResult = ReturnType<
  typeof useGetPublishSubcontractorInvoiceStatusQuery
>;
export type GetPublishSubcontractorInvoiceStatusLazyQueryHookResult = ReturnType<
  typeof useGetPublishSubcontractorInvoiceStatusLazyQuery
>;
export namespace GetPublishSubcontractorInvoiceStatus {
  export type Return = GetPublishSubcontractorInvoiceStatusQuery;
  export type Variables = GetPublishSubcontractorInvoiceStatusQueryVariables;
  export const OperationName = "getPublishSubcontractorInvoiceStatus";

  export const Document = GetPublishSubcontractorInvoiceStatusDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingInvoicing_FetchDocument = gql`
  query BookingInvoicing_Fetch($id: ObjectId!) {
    bookingById(id: $id) {
      ...BookingInvoicingBooking
    }
  }
  ${BookingInvoicingBookingFragmentDoc}
`;
export type BookingInvoicing_FetchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingInvoicing_FetchQuery,
    BookingInvoicing_FetchQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingInvoicing_FetchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingInvoicing_FetchComponent = (
  props: BookingInvoicing_FetchComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingInvoicing_FetchQuery,
    BookingInvoicing_FetchQueryVariables
  >
    query={BookingInvoicing_FetchDocument}
    {...props}
  />
);

/**
 * __useBookingInvoicing_FetchQuery__
 *
 * To run a query within a React component, call `useBookingInvoicing_FetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingInvoicing_FetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingInvoicing_FetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingInvoicing_FetchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingInvoicing_FetchQuery,
    BookingInvoicing_FetchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingInvoicing_FetchQuery,
    BookingInvoicing_FetchQueryVariables
  >(BookingInvoicing_FetchDocument, options);
}
export function useBookingInvoicing_FetchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingInvoicing_FetchQuery,
    BookingInvoicing_FetchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingInvoicing_FetchQuery,
    BookingInvoicing_FetchQueryVariables
  >(BookingInvoicing_FetchDocument, options);
}
export type BookingInvoicing_FetchQueryHookResult = ReturnType<
  typeof useBookingInvoicing_FetchQuery
>;
export type BookingInvoicing_FetchLazyQueryHookResult = ReturnType<
  typeof useBookingInvoicing_FetchLazyQuery
>;
export namespace BookingInvoicing_Fetch {
  export type Return = BookingInvoicing_FetchQuery;
  export type Variables = BookingInvoicing_FetchQueryVariables;
  export const OperationName = "BookingInvoicing_Fetch";

  export const Document = BookingInvoicing_FetchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetBookingAdditionalPayoutDocument = gql`
  mutation SetBookingAdditionalPayout(
    $bookingId: ObjectId!
    $amount: Float
    $description: String
  ) {
    setBookingAdditionalPayout(
      bookingId: $bookingId
      amount: $amount
      description: $description
    ) {
      ...BookingInvoicingBooking
    }
  }
  ${BookingInvoicingBookingFragmentDoc}
`;
export type SetBookingAdditionalPayoutMutationFn = Apollo.MutationFunction<
  SetBookingAdditionalPayoutMutation,
  SetBookingAdditionalPayoutMutationVariables
>;
export type SetBookingAdditionalPayoutComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetBookingAdditionalPayoutMutation,
    SetBookingAdditionalPayoutMutationVariables
  >,
  "mutation"
>;

export const SetBookingAdditionalPayoutComponent = (
  props: SetBookingAdditionalPayoutComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetBookingAdditionalPayoutMutation,
    SetBookingAdditionalPayoutMutationVariables
  >
    mutation={SetBookingAdditionalPayoutDocument}
    {...props}
  />
);

/**
 * __useSetBookingAdditionalPayoutMutation__
 *
 * To run a mutation, you first call `useSetBookingAdditionalPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBookingAdditionalPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBookingAdditionalPayoutMutation, { data, loading, error }] = useSetBookingAdditionalPayoutMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      amount: // value for 'amount'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSetBookingAdditionalPayoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBookingAdditionalPayoutMutation,
    SetBookingAdditionalPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBookingAdditionalPayoutMutation,
    SetBookingAdditionalPayoutMutationVariables
  >(SetBookingAdditionalPayoutDocument, options);
}
export type SetBookingAdditionalPayoutMutationHookResult = ReturnType<
  typeof useSetBookingAdditionalPayoutMutation
>;
export namespace SetBookingAdditionalPayout {
  export type Return = SetBookingAdditionalPayoutMutation;
  export type Variables = SetBookingAdditionalPayoutMutationVariables;
  export const OperationName = "SetBookingAdditionalPayout";

  export const Document = SetBookingAdditionalPayoutDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetBookingFilesDocument = gql`
  query getBookingFiles($id: ObjectId!) {
    bookingById(id: $id) {
      _id
      attachments {
        DocumentType
        ThumbURL
        PdfURL
        FileRef {
          Name
          NodeID
          NodeType
          MimeType
          Size
        }
      }
    }
  }
`;
export type GetBookingFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetBookingFilesQuery,
    GetBookingFilesQueryVariables
  >,
  "query"
> &
  ({ variables: GetBookingFilesQueryVariables; skip?: boolean } | { skip: boolean });

export const GetBookingFilesComponent = (props: GetBookingFilesComponentProps) => (
  <ApolloReactComponents.Query<GetBookingFilesQuery, GetBookingFilesQueryVariables>
    query={GetBookingFilesDocument}
    {...props}
  />
);

/**
 * __useGetBookingFilesQuery__
 *
 * To run a query within a React component, call `useGetBookingFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBookingFilesQuery,
    GetBookingFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBookingFilesQuery, GetBookingFilesQueryVariables>(
    GetBookingFilesDocument,
    options
  );
}
export function useGetBookingFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingFilesQuery,
    GetBookingFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBookingFilesQuery, GetBookingFilesQueryVariables>(
    GetBookingFilesDocument,
    options
  );
}
export type GetBookingFilesQueryHookResult = ReturnType<typeof useGetBookingFilesQuery>;
export type GetBookingFilesLazyQueryHookResult = ReturnType<
  typeof useGetBookingFilesLazyQuery
>;
export namespace GetBookingFiles {
  export type Return = GetBookingFilesQuery;
  export type Variables = GetBookingFilesQueryVariables;
  export const OperationName = "getBookingFiles";

  export const Document = GetBookingFilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadBookingDocDocument = gql`
  mutation uploadBookingDoc(
    $id: ObjectId!
    $file: Upload!
    $documentType: BookingWeekDocumentTypes!
  ) {
    uploadBookingDocument(bookingId: $id, file: $file, documentType: $documentType) {
      fileRef {
        Name
        NodeID
        NodeType
        MimeType
        Size
      }
    }
  }
`;
export type UploadBookingDocMutationFn = Apollo.MutationFunction<
  UploadBookingDocMutation,
  UploadBookingDocMutationVariables
>;
export type UploadBookingDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadBookingDocMutation,
    UploadBookingDocMutationVariables
  >,
  "mutation"
>;

export const UploadBookingDocComponent = (props: UploadBookingDocComponentProps) => (
  <ApolloReactComponents.Mutation<
    UploadBookingDocMutation,
    UploadBookingDocMutationVariables
  >
    mutation={UploadBookingDocDocument}
    {...props}
  />
);

/**
 * __useUploadBookingDocMutation__
 *
 * To run a mutation, you first call `useUploadBookingDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBookingDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBookingDocMutation, { data, loading, error }] = useUploadBookingDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadBookingDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadBookingDocMutation,
    UploadBookingDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadBookingDocMutation, UploadBookingDocMutationVariables>(
    UploadBookingDocDocument,
    options
  );
}
export type UploadBookingDocMutationHookResult = ReturnType<
  typeof useUploadBookingDocMutation
>;
export namespace UploadBookingDoc {
  export type Return = UploadBookingDocMutation;
  export type Variables = UploadBookingDocMutationVariables;
  export const OperationName = "uploadBookingDoc";

  export const Document = UploadBookingDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteBookingDocDocument = gql`
  mutation deleteBookingDoc($id: ObjectId!, $fileId: ObjectId!) {
    deleteBookingDocument(bookingId: $id, fileId: $fileId)
  }
`;
export type DeleteBookingDocMutationFn = Apollo.MutationFunction<
  DeleteBookingDocMutation,
  DeleteBookingDocMutationVariables
>;
export type DeleteBookingDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteBookingDocMutation,
    DeleteBookingDocMutationVariables
  >,
  "mutation"
>;

export const DeleteBookingDocComponent = (props: DeleteBookingDocComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteBookingDocMutation,
    DeleteBookingDocMutationVariables
  >
    mutation={DeleteBookingDocDocument}
    {...props}
  />
);

/**
 * __useDeleteBookingDocMutation__
 *
 * To run a mutation, you first call `useDeleteBookingDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingDocMutation, { data, loading, error }] = useDeleteBookingDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteBookingDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBookingDocMutation,
    DeleteBookingDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBookingDocMutation, DeleteBookingDocMutationVariables>(
    DeleteBookingDocDocument,
    options
  );
}
export type DeleteBookingDocMutationHookResult = ReturnType<
  typeof useDeleteBookingDocMutation
>;
export namespace DeleteBookingDoc {
  export type Return = DeleteBookingDocMutation;
  export type Variables = DeleteBookingDocMutationVariables;
  export const OperationName = "deleteBookingDoc";

  export const Document = DeleteBookingDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetBookingGroupSectionDocument = gql`
  query getBookingGroupSection($bookingGroupId: ObjectId!) {
    getBookingGroup(id: $bookingGroupId) {
      ...BookingGroupSection
    }
  }
  ${BookingGroupSectionFragmentDoc}
`;
export type GetBookingGroupSectionComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetBookingGroupSectionQuery,
    GetBookingGroupSectionQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetBookingGroupSectionQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetBookingGroupSectionComponent = (
  props: GetBookingGroupSectionComponentProps
) => (
  <ApolloReactComponents.Query<
    GetBookingGroupSectionQuery,
    GetBookingGroupSectionQueryVariables
  >
    query={GetBookingGroupSectionDocument}
    {...props}
  />
);

/**
 * __useGetBookingGroupSectionQuery__
 *
 * To run a query within a React component, call `useGetBookingGroupSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingGroupSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingGroupSectionQuery({
 *   variables: {
 *      bookingGroupId: // value for 'bookingGroupId'
 *   },
 * });
 */
export function useGetBookingGroupSectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBookingGroupSectionQuery,
    GetBookingGroupSectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingGroupSectionQuery,
    GetBookingGroupSectionQueryVariables
  >(GetBookingGroupSectionDocument, options);
}
export function useGetBookingGroupSectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingGroupSectionQuery,
    GetBookingGroupSectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingGroupSectionQuery,
    GetBookingGroupSectionQueryVariables
  >(GetBookingGroupSectionDocument, options);
}
export type GetBookingGroupSectionQueryHookResult = ReturnType<
  typeof useGetBookingGroupSectionQuery
>;
export type GetBookingGroupSectionLazyQueryHookResult = ReturnType<
  typeof useGetBookingGroupSectionLazyQuery
>;
export namespace GetBookingGroupSection {
  export type Return = GetBookingGroupSectionQuery;
  export type Variables = GetBookingGroupSectionQueryVariables;
  export const OperationName = "getBookingGroupSection";

  export const Document = GetBookingGroupSectionDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetTagsDocument = gql`
  query BookingProfile_GetTags {
    config {
      ...BookingTags
    }
  }
  ${BookingTagsFragmentDoc}
`;
export type BookingProfile_GetTagsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetTagsQuery,
    BookingProfile_GetTagsQueryVariables
  >,
  "query"
>;

export const BookingProfile_GetTagsComponent = (
  props: BookingProfile_GetTagsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingProfile_GetTagsQuery,
    BookingProfile_GetTagsQueryVariables
  >
    query={BookingProfile_GetTagsDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetTagsQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingProfile_GetTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetTagsQuery,
    BookingProfile_GetTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingProfile_GetTagsQuery,
    BookingProfile_GetTagsQueryVariables
  >(BookingProfile_GetTagsDocument, options);
}
export function useBookingProfile_GetTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetTagsQuery,
    BookingProfile_GetTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingProfile_GetTagsQuery,
    BookingProfile_GetTagsQueryVariables
  >(BookingProfile_GetTagsDocument, options);
}
export type BookingProfile_GetTagsQueryHookResult = ReturnType<
  typeof useBookingProfile_GetTagsQuery
>;
export type BookingProfile_GetTagsLazyQueryHookResult = ReturnType<
  typeof useBookingProfile_GetTagsLazyQuery
>;
export namespace BookingProfile_GetTags {
  export type Return = BookingProfile_GetTagsQuery;
  export type Variables = BookingProfile_GetTagsQueryVariables;
  export const OperationName = "BookingProfile_GetTags";

  export const Document = BookingProfile_GetTagsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetDocument = gql`
  query BookingProfile_Get($id: ObjectId!) {
    bookingById(id: $id) {
      _id
      ...BookingProfile
    }
  }
  ${BookingProfileFragmentDoc}
`;
export type BookingProfile_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetQuery,
    BookingProfile_GetQueryVariables
  >,
  "query"
> &
  ({ variables: BookingProfile_GetQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingProfile_GetComponent = (props: BookingProfile_GetComponentProps) => (
  <ApolloReactComponents.Query<BookingProfile_GetQuery, BookingProfile_GetQueryVariables>
    query={BookingProfile_GetDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingProfile_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetQuery,
    BookingProfile_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingProfile_GetQuery, BookingProfile_GetQueryVariables>(
    BookingProfile_GetDocument,
    options
  );
}
export function useBookingProfile_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetQuery,
    BookingProfile_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingProfile_GetQuery, BookingProfile_GetQueryVariables>(
    BookingProfile_GetDocument,
    options
  );
}
export type BookingProfile_GetQueryHookResult = ReturnType<
  typeof useBookingProfile_GetQuery
>;
export type BookingProfile_GetLazyQueryHookResult = ReturnType<
  typeof useBookingProfile_GetLazyQuery
>;
export namespace BookingProfile_Get {
  export type Return = BookingProfile_GetQuery;
  export type Variables = BookingProfile_GetQueryVariables;
  export const OperationName = "BookingProfile_Get";

  export const Document = BookingProfile_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetContactsDocument = gql`
  query BookingProfile_GetContacts($id: ObjectId!) {
    getBookingCustomerContacts(bookingId: $id) {
      ...ContactListItem
    }
  }
  ${ContactListItemFragmentDoc}
`;
export type BookingProfile_GetContactsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetContactsQuery,
    BookingProfile_GetContactsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingProfile_GetContactsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingProfile_GetContactsComponent = (
  props: BookingProfile_GetContactsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingProfile_GetContactsQuery,
    BookingProfile_GetContactsQueryVariables
  >
    query={BookingProfile_GetContactsDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetContactsQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingProfile_GetContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetContactsQuery,
    BookingProfile_GetContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingProfile_GetContactsQuery,
    BookingProfile_GetContactsQueryVariables
  >(BookingProfile_GetContactsDocument, options);
}
export function useBookingProfile_GetContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetContactsQuery,
    BookingProfile_GetContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingProfile_GetContactsQuery,
    BookingProfile_GetContactsQueryVariables
  >(BookingProfile_GetContactsDocument, options);
}
export type BookingProfile_GetContactsQueryHookResult = ReturnType<
  typeof useBookingProfile_GetContactsQuery
>;
export type BookingProfile_GetContactsLazyQueryHookResult = ReturnType<
  typeof useBookingProfile_GetContactsLazyQuery
>;
export namespace BookingProfile_GetContacts {
  export type Return = BookingProfile_GetContactsQuery;
  export type Variables = BookingProfile_GetContactsQueryVariables;
  export const OperationName = "BookingProfile_GetContacts";

  export const Document = BookingProfile_GetContactsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetTimereportEmailDocument = gql`
  query BookingProfile_GetTimereportEmail($bookingId: ObjectId!) {
    getTimereportToCustomerEmail(bookingId: $bookingId) {
      Body
      Subject
    }
  }
`;
export type BookingProfile_GetTimereportEmailComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetTimereportEmailQuery,
    BookingProfile_GetTimereportEmailQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingProfile_GetTimereportEmailQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingProfile_GetTimereportEmailComponent = (
  props: BookingProfile_GetTimereportEmailComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingProfile_GetTimereportEmailQuery,
    BookingProfile_GetTimereportEmailQueryVariables
  >
    query={BookingProfile_GetTimereportEmailDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetTimereportEmailQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetTimereportEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetTimereportEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetTimereportEmailQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingProfile_GetTimereportEmailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetTimereportEmailQuery,
    BookingProfile_GetTimereportEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingProfile_GetTimereportEmailQuery,
    BookingProfile_GetTimereportEmailQueryVariables
  >(BookingProfile_GetTimereportEmailDocument, options);
}
export function useBookingProfile_GetTimereportEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetTimereportEmailQuery,
    BookingProfile_GetTimereportEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingProfile_GetTimereportEmailQuery,
    BookingProfile_GetTimereportEmailQueryVariables
  >(BookingProfile_GetTimereportEmailDocument, options);
}
export type BookingProfile_GetTimereportEmailQueryHookResult = ReturnType<
  typeof useBookingProfile_GetTimereportEmailQuery
>;
export type BookingProfile_GetTimereportEmailLazyQueryHookResult = ReturnType<
  typeof useBookingProfile_GetTimereportEmailLazyQuery
>;
export namespace BookingProfile_GetTimereportEmail {
  export type Return = BookingProfile_GetTimereportEmailQuery;
  export type Variables = BookingProfile_GetTimereportEmailQueryVariables;
  export const OperationName = "BookingProfile_GetTimereportEmail";

  export const Document = BookingProfile_GetTimereportEmailDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetContractDocument = gql`
  query BookingProfile_GetContract($bookingId: ObjectId!) {
    bookingById(id: $bookingId) {
      _id
    }
  }
`;
export type BookingProfile_GetContractComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetContractQuery,
    BookingProfile_GetContractQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingProfile_GetContractQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingProfile_GetContractComponent = (
  props: BookingProfile_GetContractComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingProfile_GetContractQuery,
    BookingProfile_GetContractQueryVariables
  >
    query={BookingProfile_GetContractDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetContractQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetContractQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingProfile_GetContractQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetContractQuery,
    BookingProfile_GetContractQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingProfile_GetContractQuery,
    BookingProfile_GetContractQueryVariables
  >(BookingProfile_GetContractDocument, options);
}
export function useBookingProfile_GetContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetContractQuery,
    BookingProfile_GetContractQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingProfile_GetContractQuery,
    BookingProfile_GetContractQueryVariables
  >(BookingProfile_GetContractDocument, options);
}
export type BookingProfile_GetContractQueryHookResult = ReturnType<
  typeof useBookingProfile_GetContractQuery
>;
export type BookingProfile_GetContractLazyQueryHookResult = ReturnType<
  typeof useBookingProfile_GetContractLazyQuery
>;
export namespace BookingProfile_GetContract {
  export type Return = BookingProfile_GetContractQuery;
  export type Variables = BookingProfile_GetContractQueryVariables;
  export const OperationName = "BookingProfile_GetContract";

  export const Document = BookingProfile_GetContractDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetLastCreateBookingKitWfStatusDocument = gql`
  query BookingProfile_GetLastCreateBookingKitWfStatus(
    $bookingId: ObjectId!
    $workflowType: String
  ) {
    getLastWorkflowRun(entityId: $bookingId, workflowType: $workflowType) {
      status
      startedAt
      scheduledAt
      completedAt
      result
    }
  }
`;
export type BookingProfile_GetLastCreateBookingKitWfStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetLastCreateBookingKitWfStatusQuery,
    BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const BookingProfile_GetLastCreateBookingKitWfStatusComponent = (
  props: BookingProfile_GetLastCreateBookingKitWfStatusComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingProfile_GetLastCreateBookingKitWfStatusQuery,
    BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables
  >
    query={BookingProfile_GetLastCreateBookingKitWfStatusDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetLastCreateBookingKitWfStatusQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetLastCreateBookingKitWfStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetLastCreateBookingKitWfStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetLastCreateBookingKitWfStatusQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      workflowType: // value for 'workflowType'
 *   },
 * });
 */
export function useBookingProfile_GetLastCreateBookingKitWfStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetLastCreateBookingKitWfStatusQuery,
    BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingProfile_GetLastCreateBookingKitWfStatusQuery,
    BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables
  >(BookingProfile_GetLastCreateBookingKitWfStatusDocument, options);
}
export function useBookingProfile_GetLastCreateBookingKitWfStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetLastCreateBookingKitWfStatusQuery,
    BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingProfile_GetLastCreateBookingKitWfStatusQuery,
    BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables
  >(BookingProfile_GetLastCreateBookingKitWfStatusDocument, options);
}
export type BookingProfile_GetLastCreateBookingKitWfStatusQueryHookResult = ReturnType<
  typeof useBookingProfile_GetLastCreateBookingKitWfStatusQuery
>;
export type BookingProfile_GetLastCreateBookingKitWfStatusLazyQueryHookResult =
  ReturnType<typeof useBookingProfile_GetLastCreateBookingKitWfStatusLazyQuery>;
export namespace BookingProfile_GetLastCreateBookingKitWfStatus {
  export type Return = BookingProfile_GetLastCreateBookingKitWfStatusQuery;
  export type Variables = BookingProfile_GetLastCreateBookingKitWfStatusQueryVariables;
  export const OperationName = "BookingProfile_GetLastCreateBookingKitWfStatus";

  export const Document = BookingProfile_GetLastCreateBookingKitWfStatusDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProfile_GetCreateBookingKitWfStatusesDocument = gql`
  query BookingProfile_GetCreateBookingKitWfStatuses(
    $bookingId: ObjectId!
    $workflowType: String
  ) {
    getWorkflowRuns(entityId: $bookingId, workflowType: $workflowType) {
      status
      startedAt
      scheduledAt
      completedAt
      result
      steps {
        _id
        title
        description
        startedAt
        completedAt
        failedAt
      }
    }
  }
`;
export type BookingProfile_GetCreateBookingKitWfStatusesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProfile_GetCreateBookingKitWfStatusesQuery,
    BookingProfile_GetCreateBookingKitWfStatusesQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: BookingProfile_GetCreateBookingKitWfStatusesQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const BookingProfile_GetCreateBookingKitWfStatusesComponent = (
  props: BookingProfile_GetCreateBookingKitWfStatusesComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingProfile_GetCreateBookingKitWfStatusesQuery,
    BookingProfile_GetCreateBookingKitWfStatusesQueryVariables
  >
    query={BookingProfile_GetCreateBookingKitWfStatusesDocument}
    {...props}
  />
);

/**
 * __useBookingProfile_GetCreateBookingKitWfStatusesQuery__
 *
 * To run a query within a React component, call `useBookingProfile_GetCreateBookingKitWfStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProfile_GetCreateBookingKitWfStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProfile_GetCreateBookingKitWfStatusesQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      workflowType: // value for 'workflowType'
 *   },
 * });
 */
export function useBookingProfile_GetCreateBookingKitWfStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProfile_GetCreateBookingKitWfStatusesQuery,
    BookingProfile_GetCreateBookingKitWfStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingProfile_GetCreateBookingKitWfStatusesQuery,
    BookingProfile_GetCreateBookingKitWfStatusesQueryVariables
  >(BookingProfile_GetCreateBookingKitWfStatusesDocument, options);
}
export function useBookingProfile_GetCreateBookingKitWfStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProfile_GetCreateBookingKitWfStatusesQuery,
    BookingProfile_GetCreateBookingKitWfStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingProfile_GetCreateBookingKitWfStatusesQuery,
    BookingProfile_GetCreateBookingKitWfStatusesQueryVariables
  >(BookingProfile_GetCreateBookingKitWfStatusesDocument, options);
}
export type BookingProfile_GetCreateBookingKitWfStatusesQueryHookResult = ReturnType<
  typeof useBookingProfile_GetCreateBookingKitWfStatusesQuery
>;
export type BookingProfile_GetCreateBookingKitWfStatusesLazyQueryHookResult = ReturnType<
  typeof useBookingProfile_GetCreateBookingKitWfStatusesLazyQuery
>;
export namespace BookingProfile_GetCreateBookingKitWfStatuses {
  export type Return = BookingProfile_GetCreateBookingKitWfStatusesQuery;
  export type Variables = BookingProfile_GetCreateBookingKitWfStatusesQueryVariables;
  export const OperationName = "BookingProfile_GetCreateBookingKitWfStatuses";

  export const Document = BookingProfile_GetCreateBookingKitWfStatusesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingProject_GetDocument = gql`
  query BookingProject_Get($bookingId: ObjectId!) {
    bookingById(id: $bookingId) {
      _id
      Project {
        ...Project
      }
      CostCenter {
        Id
        Name
      }
    }
  }
  ${ProjectFragmentDoc}
`;
export type BookingProject_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingProject_GetQuery,
    BookingProject_GetQueryVariables
  >,
  "query"
> &
  ({ variables: BookingProject_GetQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingProject_GetComponent = (props: BookingProject_GetComponentProps) => (
  <ApolloReactComponents.Query<BookingProject_GetQuery, BookingProject_GetQueryVariables>
    query={BookingProject_GetDocument}
    {...props}
  />
);

/**
 * __useBookingProject_GetQuery__
 *
 * To run a query within a React component, call `useBookingProject_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingProject_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingProject_GetQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingProject_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingProject_GetQuery,
    BookingProject_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingProject_GetQuery, BookingProject_GetQueryVariables>(
    BookingProject_GetDocument,
    options
  );
}
export function useBookingProject_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingProject_GetQuery,
    BookingProject_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingProject_GetQuery, BookingProject_GetQueryVariables>(
    BookingProject_GetDocument,
    options
  );
}
export type BookingProject_GetQueryHookResult = ReturnType<
  typeof useBookingProject_GetQuery
>;
export type BookingProject_GetLazyQueryHookResult = ReturnType<
  typeof useBookingProject_GetLazyQuery
>;
export namespace BookingProject_Get {
  export type Return = BookingProject_GetQuery;
  export type Variables = BookingProject_GetQueryVariables;
  export const OperationName = "BookingProject_Get";

  export const Document = BookingProject_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UpdateBookingProjectDocument = gql`
  mutation updateBookingProject($bookingId: ObjectId!, $projectId: ObjectId!) {
    updateBookingProject(bookingId: $bookingId, projectId: $projectId) {
      Booking {
        _id
        Project {
          ...Project
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`;
export type UpdateBookingProjectMutationFn = Apollo.MutationFunction<
  UpdateBookingProjectMutation,
  UpdateBookingProjectMutationVariables
>;
export type UpdateBookingProjectComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateBookingProjectMutation,
    UpdateBookingProjectMutationVariables
  >,
  "mutation"
>;

export const UpdateBookingProjectComponent = (
  props: UpdateBookingProjectComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateBookingProjectMutation,
    UpdateBookingProjectMutationVariables
  >
    mutation={UpdateBookingProjectDocument}
    {...props}
  />
);

/**
 * __useUpdateBookingProjectMutation__
 *
 * To run a mutation, you first call `useUpdateBookingProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingProjectMutation, { data, loading, error }] = useUpdateBookingProjectMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateBookingProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBookingProjectMutation,
    UpdateBookingProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateBookingProjectMutation,
    UpdateBookingProjectMutationVariables
  >(UpdateBookingProjectDocument, options);
}
export type UpdateBookingProjectMutationHookResult = ReturnType<
  typeof useUpdateBookingProjectMutation
>;
export namespace UpdateBookingProject {
  export type Return = UpdateBookingProjectMutation;
  export type Variables = UpdateBookingProjectMutationVariables;
  export const OperationName = "updateBookingProject";

  export const Document = UpdateBookingProjectDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SetSupportTagToBookingDocument = gql`
  mutation SetSupportTagToBooking(
    $bookingId: ObjectId!
    $tags: [String!]!
    $comment: String
  ) {
    setSupportTagToBooking(bookingId: $bookingId, tags: $tags, comment: $comment) {
      ...BookingSupportTagStatus
    }
  }
  ${BookingSupportTagStatusFragmentDoc}
`;
export type SetSupportTagToBookingMutationFn = Apollo.MutationFunction<
  SetSupportTagToBookingMutation,
  SetSupportTagToBookingMutationVariables
>;
export type SetSupportTagToBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetSupportTagToBookingMutation,
    SetSupportTagToBookingMutationVariables
  >,
  "mutation"
>;

export const SetSupportTagToBookingComponent = (
  props: SetSupportTagToBookingComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetSupportTagToBookingMutation,
    SetSupportTagToBookingMutationVariables
  >
    mutation={SetSupportTagToBookingDocument}
    {...props}
  />
);

/**
 * __useSetSupportTagToBookingMutation__
 *
 * To run a mutation, you first call `useSetSupportTagToBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSupportTagToBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSupportTagToBookingMutation, { data, loading, error }] = useSetSupportTagToBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      tags: // value for 'tags'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetSupportTagToBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSupportTagToBookingMutation,
    SetSupportTagToBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSupportTagToBookingMutation,
    SetSupportTagToBookingMutationVariables
  >(SetSupportTagToBookingDocument, options);
}
export type SetSupportTagToBookingMutationHookResult = ReturnType<
  typeof useSetSupportTagToBookingMutation
>;
export namespace SetSupportTagToBooking {
  export type Return = SetSupportTagToBookingMutation;
  export type Variables = SetSupportTagToBookingMutationVariables;
  export const OperationName = "SetSupportTagToBooking";

  export const Document = SetSupportTagToBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateBookingKitTagsDocument = gql`
  mutation UpdateBookingKitTags($id: ObjectId!, $tags: [String!]!, $comment: String) {
    updateBookingKitTags(id: $id, tags: $tags, comment: $comment) {
      ...BookingSupportTagStatus
    }
  }
  ${BookingSupportTagStatusFragmentDoc}
`;
export type UpdateBookingKitTagsMutationFn = Apollo.MutationFunction<
  UpdateBookingKitTagsMutation,
  UpdateBookingKitTagsMutationVariables
>;
export type UpdateBookingKitTagsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateBookingKitTagsMutation,
    UpdateBookingKitTagsMutationVariables
  >,
  "mutation"
>;

export const UpdateBookingKitTagsComponent = (
  props: UpdateBookingKitTagsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateBookingKitTagsMutation,
    UpdateBookingKitTagsMutationVariables
  >
    mutation={UpdateBookingKitTagsDocument}
    {...props}
  />
);

/**
 * __useUpdateBookingKitTagsMutation__
 *
 * To run a mutation, you first call `useUpdateBookingKitTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingKitTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingKitTagsMutation, { data, loading, error }] = useUpdateBookingKitTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateBookingKitTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBookingKitTagsMutation,
    UpdateBookingKitTagsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateBookingKitTagsMutation,
    UpdateBookingKitTagsMutationVariables
  >(UpdateBookingKitTagsDocument, options);
}
export type UpdateBookingKitTagsMutationHookResult = ReturnType<
  typeof useUpdateBookingKitTagsMutation
>;
export namespace UpdateBookingKitTags {
  export type Return = UpdateBookingKitTagsMutation;
  export type Variables = UpdateBookingKitTagsMutationVariables;
  export const OperationName = "UpdateBookingKitTags";

  export const Document = UpdateBookingKitTagsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TimeReportKit_GetInfoDocument = gql`
  query TimeReportKit_GetInfo($bookingId: ObjectId!, $consultantId: ObjectId!) {
    bookingById(id: $bookingId) {
      _id
      AreaOfExpertise
    }
    bookingKitDraft(bookingId: $bookingId) {
      documents {
        ...CrmDocument
      }
      timereportTemplateType
      costCenterId
    }
    contact: consultantById(id: $consultantId) {
      _id
      LegalPersonType
      ResponsiblePerson {
        Name
        PersonId
      }
    }
  }
  ${CrmDocumentFragmentDoc}
`;
export type TimeReportKit_GetInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimeReportKit_GetInfoQuery,
    TimeReportKit_GetInfoQueryVariables
  >,
  "query"
> &
  (
    | { variables: TimeReportKit_GetInfoQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const TimeReportKit_GetInfoComponent = (
  props: TimeReportKit_GetInfoComponentProps
) => (
  <ApolloReactComponents.Query<
    TimeReportKit_GetInfoQuery,
    TimeReportKit_GetInfoQueryVariables
  >
    query={TimeReportKit_GetInfoDocument}
    {...props}
  />
);

/**
 * __useTimeReportKit_GetInfoQuery__
 *
 * To run a query within a React component, call `useTimeReportKit_GetInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportKit_GetInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportKit_GetInfoQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useTimeReportKit_GetInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimeReportKit_GetInfoQuery,
    TimeReportKit_GetInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TimeReportKit_GetInfoQuery, TimeReportKit_GetInfoQueryVariables>(
    TimeReportKit_GetInfoDocument,
    options
  );
}
export function useTimeReportKit_GetInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimeReportKit_GetInfoQuery,
    TimeReportKit_GetInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimeReportKit_GetInfoQuery,
    TimeReportKit_GetInfoQueryVariables
  >(TimeReportKit_GetInfoDocument, options);
}
export type TimeReportKit_GetInfoQueryHookResult = ReturnType<
  typeof useTimeReportKit_GetInfoQuery
>;
export type TimeReportKit_GetInfoLazyQueryHookResult = ReturnType<
  typeof useTimeReportKit_GetInfoLazyQuery
>;
export namespace TimeReportKit_GetInfo {
  export type Return = TimeReportKit_GetInfoQuery;
  export type Variables = TimeReportKit_GetInfoQueryVariables;
  export const OperationName = "TimeReportKit_GetInfo";

  export const Document = TimeReportKit_GetInfoDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TimeReportKit_GetManagerOfResponsibleUserDocument = gql`
  query TimeReportKit_GetManagerOfResponsibleUser($userId: ObjectId!) {
    userById(id: $userId) {
      ManagerId
    }
  }
`;
export type TimeReportKit_GetManagerOfResponsibleUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimeReportKit_GetManagerOfResponsibleUserQuery,
    TimeReportKit_GetManagerOfResponsibleUserQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: TimeReportKit_GetManagerOfResponsibleUserQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const TimeReportKit_GetManagerOfResponsibleUserComponent = (
  props: TimeReportKit_GetManagerOfResponsibleUserComponentProps
) => (
  <ApolloReactComponents.Query<
    TimeReportKit_GetManagerOfResponsibleUserQuery,
    TimeReportKit_GetManagerOfResponsibleUserQueryVariables
  >
    query={TimeReportKit_GetManagerOfResponsibleUserDocument}
    {...props}
  />
);

/**
 * __useTimeReportKit_GetManagerOfResponsibleUserQuery__
 *
 * To run a query within a React component, call `useTimeReportKit_GetManagerOfResponsibleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportKit_GetManagerOfResponsibleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportKit_GetManagerOfResponsibleUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTimeReportKit_GetManagerOfResponsibleUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimeReportKit_GetManagerOfResponsibleUserQuery,
    TimeReportKit_GetManagerOfResponsibleUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TimeReportKit_GetManagerOfResponsibleUserQuery,
    TimeReportKit_GetManagerOfResponsibleUserQueryVariables
  >(TimeReportKit_GetManagerOfResponsibleUserDocument, options);
}
export function useTimeReportKit_GetManagerOfResponsibleUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimeReportKit_GetManagerOfResponsibleUserQuery,
    TimeReportKit_GetManagerOfResponsibleUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimeReportKit_GetManagerOfResponsibleUserQuery,
    TimeReportKit_GetManagerOfResponsibleUserQueryVariables
  >(TimeReportKit_GetManagerOfResponsibleUserDocument, options);
}
export type TimeReportKit_GetManagerOfResponsibleUserQueryHookResult = ReturnType<
  typeof useTimeReportKit_GetManagerOfResponsibleUserQuery
>;
export type TimeReportKit_GetManagerOfResponsibleUserLazyQueryHookResult = ReturnType<
  typeof useTimeReportKit_GetManagerOfResponsibleUserLazyQuery
>;
export namespace TimeReportKit_GetManagerOfResponsibleUser {
  export type Return = TimeReportKit_GetManagerOfResponsibleUserQuery;
  export type Variables = TimeReportKit_GetManagerOfResponsibleUserQueryVariables;
  export const OperationName = "TimeReportKit_GetManagerOfResponsibleUser";

  export const Document = TimeReportKit_GetManagerOfResponsibleUserDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TimeReportKit_GetKitDocument = gql`
  query TimeReportKit_GetKit($bookingId: ObjectId!) {
    bookingKits(bookingId: $bookingId) {
      ...Booking_BookingKitSearch
    }
  }
  ${Booking_BookingKitSearchFragmentDoc}
`;
export type TimeReportKit_GetKitComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimeReportKit_GetKitQuery,
    TimeReportKit_GetKitQueryVariables
  >,
  "query"
> &
  ({ variables: TimeReportKit_GetKitQueryVariables; skip?: boolean } | { skip: boolean });

export const TimeReportKit_GetKitComponent = (
  props: TimeReportKit_GetKitComponentProps
) => (
  <ApolloReactComponents.Query<
    TimeReportKit_GetKitQuery,
    TimeReportKit_GetKitQueryVariables
  >
    query={TimeReportKit_GetKitDocument}
    {...props}
  />
);

/**
 * __useTimeReportKit_GetKitQuery__
 *
 * To run a query within a React component, call `useTimeReportKit_GetKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportKit_GetKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportKit_GetKitQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTimeReportKit_GetKitQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimeReportKit_GetKitQuery,
    TimeReportKit_GetKitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TimeReportKit_GetKitQuery, TimeReportKit_GetKitQueryVariables>(
    TimeReportKit_GetKitDocument,
    options
  );
}
export function useTimeReportKit_GetKitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimeReportKit_GetKitQuery,
    TimeReportKit_GetKitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimeReportKit_GetKitQuery,
    TimeReportKit_GetKitQueryVariables
  >(TimeReportKit_GetKitDocument, options);
}
export type TimeReportKit_GetKitQueryHookResult = ReturnType<
  typeof useTimeReportKit_GetKitQuery
>;
export type TimeReportKit_GetKitLazyQueryHookResult = ReturnType<
  typeof useTimeReportKit_GetKitLazyQuery
>;
export namespace TimeReportKit_GetKit {
  export type Return = TimeReportKit_GetKitQuery;
  export type Variables = TimeReportKit_GetKitQueryVariables;
  export const OperationName = "TimeReportKit_GetKit";

  export const Document = TimeReportKit_GetKitDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TimeReportKit_CreateBookingKitDocument = gql`
  mutation TimeReportKit_createBookingKit($input: CreateBookingKitInput!) {
    createBookingKit(input: $input) {
      ...BookingKitProfile
    }
  }
  ${BookingKitProfileFragmentDoc}
`;
export type TimeReportKit_CreateBookingKitMutationFn = Apollo.MutationFunction<
  TimeReportKit_CreateBookingKitMutation,
  TimeReportKit_CreateBookingKitMutationVariables
>;
export type TimeReportKit_CreateBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TimeReportKit_CreateBookingKitMutation,
    TimeReportKit_CreateBookingKitMutationVariables
  >,
  "mutation"
>;

export const TimeReportKit_CreateBookingKitComponent = (
  props: TimeReportKit_CreateBookingKitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    TimeReportKit_CreateBookingKitMutation,
    TimeReportKit_CreateBookingKitMutationVariables
  >
    mutation={TimeReportKit_CreateBookingKitDocument}
    {...props}
  />
);

/**
 * __useTimeReportKit_CreateBookingKitMutation__
 *
 * To run a mutation, you first call `useTimeReportKit_CreateBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportKit_CreateBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportKitCreateBookingKitMutation, { data, loading, error }] = useTimeReportKit_CreateBookingKitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReportKit_CreateBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TimeReportKit_CreateBookingKitMutation,
    TimeReportKit_CreateBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TimeReportKit_CreateBookingKitMutation,
    TimeReportKit_CreateBookingKitMutationVariables
  >(TimeReportKit_CreateBookingKitDocument, options);
}
export type TimeReportKit_CreateBookingKitMutationHookResult = ReturnType<
  typeof useTimeReportKit_CreateBookingKitMutation
>;
export namespace TimeReportKit_createBookingKit {
  export type Return = TimeReportKit_CreateBookingKitMutation;
  export type Variables = TimeReportKit_CreateBookingKitMutationVariables;
  export const OperationName = "TimeReportKit_createBookingKit";

  export const Document = TimeReportKit_CreateBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TimeReportKit_UpdateBookingKitDocument = gql`
  mutation TimeReportKit_updateBookingKit($input: UpdateBookingKitInput!) {
    updateBookingKit(input: $input) {
      ...BookingKitProfile
    }
  }
  ${BookingKitProfileFragmentDoc}
`;
export type TimeReportKit_UpdateBookingKitMutationFn = Apollo.MutationFunction<
  TimeReportKit_UpdateBookingKitMutation,
  TimeReportKit_UpdateBookingKitMutationVariables
>;
export type TimeReportKit_UpdateBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TimeReportKit_UpdateBookingKitMutation,
    TimeReportKit_UpdateBookingKitMutationVariables
  >,
  "mutation"
>;

export const TimeReportKit_UpdateBookingKitComponent = (
  props: TimeReportKit_UpdateBookingKitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    TimeReportKit_UpdateBookingKitMutation,
    TimeReportKit_UpdateBookingKitMutationVariables
  >
    mutation={TimeReportKit_UpdateBookingKitDocument}
    {...props}
  />
);

/**
 * __useTimeReportKit_UpdateBookingKitMutation__
 *
 * To run a mutation, you first call `useTimeReportKit_UpdateBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportKit_UpdateBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportKitUpdateBookingKitMutation, { data, loading, error }] = useTimeReportKit_UpdateBookingKitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReportKit_UpdateBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TimeReportKit_UpdateBookingKitMutation,
    TimeReportKit_UpdateBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TimeReportKit_UpdateBookingKitMutation,
    TimeReportKit_UpdateBookingKitMutationVariables
  >(TimeReportKit_UpdateBookingKitDocument, options);
}
export type TimeReportKit_UpdateBookingKitMutationHookResult = ReturnType<
  typeof useTimeReportKit_UpdateBookingKitMutation
>;
export namespace TimeReportKit_updateBookingKit {
  export type Return = TimeReportKit_UpdateBookingKitMutation;
  export type Variables = TimeReportKit_UpdateBookingKitMutationVariables;
  export const OperationName = "TimeReportKit_updateBookingKit";

  export const Document = TimeReportKit_UpdateBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TimeReportKit_DeleteBookingKitDocument = gql`
  mutation TimeReportKit_deleteBookingKit($id: ObjectId!) {
    deleteBookingKit(id: $id)
  }
`;
export type TimeReportKit_DeleteBookingKitMutationFn = Apollo.MutationFunction<
  TimeReportKit_DeleteBookingKitMutation,
  TimeReportKit_DeleteBookingKitMutationVariables
>;
export type TimeReportKit_DeleteBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TimeReportKit_DeleteBookingKitMutation,
    TimeReportKit_DeleteBookingKitMutationVariables
  >,
  "mutation"
>;

export const TimeReportKit_DeleteBookingKitComponent = (
  props: TimeReportKit_DeleteBookingKitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    TimeReportKit_DeleteBookingKitMutation,
    TimeReportKit_DeleteBookingKitMutationVariables
  >
    mutation={TimeReportKit_DeleteBookingKitDocument}
    {...props}
  />
);

/**
 * __useTimeReportKit_DeleteBookingKitMutation__
 *
 * To run a mutation, you first call `useTimeReportKit_DeleteBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportKit_DeleteBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportKitDeleteBookingKitMutation, { data, loading, error }] = useTimeReportKit_DeleteBookingKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeReportKit_DeleteBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TimeReportKit_DeleteBookingKitMutation,
    TimeReportKit_DeleteBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TimeReportKit_DeleteBookingKitMutation,
    TimeReportKit_DeleteBookingKitMutationVariables
  >(TimeReportKit_DeleteBookingKitDocument, options);
}
export type TimeReportKit_DeleteBookingKitMutationHookResult = ReturnType<
  typeof useTimeReportKit_DeleteBookingKitMutation
>;
export namespace TimeReportKit_deleteBookingKit {
  export type Return = TimeReportKit_DeleteBookingKitMutation;
  export type Variables = TimeReportKit_DeleteBookingKitMutationVariables;
  export const OperationName = "TimeReportKit_deleteBookingKit";

  export const Document = TimeReportKit_DeleteBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingKit_RunAutoCreateBookingKitDocument = gql`
  mutation BookingKit_runAutoCreateBookingKit($bookingId: ObjectId!) {
    runAutoCreateBookingKit(bookingId: $bookingId)
  }
`;
export type BookingKit_RunAutoCreateBookingKitMutationFn = Apollo.MutationFunction<
  BookingKit_RunAutoCreateBookingKitMutation,
  BookingKit_RunAutoCreateBookingKitMutationVariables
>;
export type BookingKit_RunAutoCreateBookingKitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingKit_RunAutoCreateBookingKitMutation,
    BookingKit_RunAutoCreateBookingKitMutationVariables
  >,
  "mutation"
>;

export const BookingKit_RunAutoCreateBookingKitComponent = (
  props: BookingKit_RunAutoCreateBookingKitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingKit_RunAutoCreateBookingKitMutation,
    BookingKit_RunAutoCreateBookingKitMutationVariables
  >
    mutation={BookingKit_RunAutoCreateBookingKitDocument}
    {...props}
  />
);

/**
 * __useBookingKit_RunAutoCreateBookingKitMutation__
 *
 * To run a mutation, you first call `useBookingKit_RunAutoCreateBookingKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingKit_RunAutoCreateBookingKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingKitRunAutoCreateBookingKitMutation, { data, loading, error }] = useBookingKit_RunAutoCreateBookingKitMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingKit_RunAutoCreateBookingKitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingKit_RunAutoCreateBookingKitMutation,
    BookingKit_RunAutoCreateBookingKitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingKit_RunAutoCreateBookingKitMutation,
    BookingKit_RunAutoCreateBookingKitMutationVariables
  >(BookingKit_RunAutoCreateBookingKitDocument, options);
}
export type BookingKit_RunAutoCreateBookingKitMutationHookResult = ReturnType<
  typeof useBookingKit_RunAutoCreateBookingKitMutation
>;
export namespace BookingKit_runAutoCreateBookingKit {
  export type Return = BookingKit_RunAutoCreateBookingKitMutation;
  export type Variables = BookingKit_RunAutoCreateBookingKitMutationVariables;
  export const OperationName = "BookingKit_runAutoCreateBookingKit";

  export const Document = BookingKit_RunAutoCreateBookingKitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingKit_GetFormConfigDocument = gql`
  query BookingKit_GetFormConfig($bookingId: ObjectId!) {
    bookingKitFormConfig(bookingId: $bookingId) {
      ...bookingKitFormConfig
    }
  }
  ${BookingKitFormConfigFragmentDoc}
`;
export type BookingKit_GetFormConfigComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKit_GetFormConfigQuery,
    BookingKit_GetFormConfigQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingKit_GetFormConfigQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingKit_GetFormConfigComponent = (
  props: BookingKit_GetFormConfigComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKit_GetFormConfigQuery,
    BookingKit_GetFormConfigQueryVariables
  >
    query={BookingKit_GetFormConfigDocument}
    {...props}
  />
);

/**
 * __useBookingKit_GetFormConfigQuery__
 *
 * To run a query within a React component, call `useBookingKit_GetFormConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKit_GetFormConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKit_GetFormConfigQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingKit_GetFormConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKit_GetFormConfigQuery,
    BookingKit_GetFormConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingKit_GetFormConfigQuery,
    BookingKit_GetFormConfigQueryVariables
  >(BookingKit_GetFormConfigDocument, options);
}
export function useBookingKit_GetFormConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKit_GetFormConfigQuery,
    BookingKit_GetFormConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingKit_GetFormConfigQuery,
    BookingKit_GetFormConfigQueryVariables
  >(BookingKit_GetFormConfigDocument, options);
}
export type BookingKit_GetFormConfigQueryHookResult = ReturnType<
  typeof useBookingKit_GetFormConfigQuery
>;
export type BookingKit_GetFormConfigLazyQueryHookResult = ReturnType<
  typeof useBookingKit_GetFormConfigLazyQuery
>;
export namespace BookingKit_GetFormConfig {
  export type Return = BookingKit_GetFormConfigQuery;
  export type Variables = BookingKit_GetFormConfigQueryVariables;
  export const OperationName = "BookingKit_GetFormConfig";

  export const Document = BookingKit_GetFormConfigDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingKit_GetChecksDocument = gql`
  query BookingKit_GetChecks($bookingId: ObjectId!) {
    getChecksForBooking(bookingId: $bookingId) {
      requiredForm
      costCenter
      project
      customerNumber
      orderNumber
      customerContractId
      consultantContractId
      totalInvoice
      hours
      mileage
      expenses
      accommodationSum
      travelSum
      orderId
      attachTimeReport
      groupInvoicing
      contractNumber
    }
  }
`;
export type BookingKit_GetChecksComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKit_GetChecksQuery,
    BookingKit_GetChecksQueryVariables
  >,
  "query"
> &
  ({ variables: BookingKit_GetChecksQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingKit_GetChecksComponent = (
  props: BookingKit_GetChecksComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKit_GetChecksQuery,
    BookingKit_GetChecksQueryVariables
  >
    query={BookingKit_GetChecksDocument}
    {...props}
  />
);

/**
 * __useBookingKit_GetChecksQuery__
 *
 * To run a query within a React component, call `useBookingKit_GetChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKit_GetChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKit_GetChecksQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingKit_GetChecksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKit_GetChecksQuery,
    BookingKit_GetChecksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingKit_GetChecksQuery, BookingKit_GetChecksQueryVariables>(
    BookingKit_GetChecksDocument,
    options
  );
}
export function useBookingKit_GetChecksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKit_GetChecksQuery,
    BookingKit_GetChecksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingKit_GetChecksQuery,
    BookingKit_GetChecksQueryVariables
  >(BookingKit_GetChecksDocument, options);
}
export type BookingKit_GetChecksQueryHookResult = ReturnType<
  typeof useBookingKit_GetChecksQuery
>;
export type BookingKit_GetChecksLazyQueryHookResult = ReturnType<
  typeof useBookingKit_GetChecksLazyQuery
>;
export namespace BookingKit_GetChecks {
  export type Return = BookingKit_GetChecksQuery;
  export type Variables = BookingKit_GetChecksQueryVariables;
  export const OperationName = "BookingKit_GetChecks";

  export const Document = BookingKit_GetChecksDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingKit_GetUserPermissionsDocument = gql`
  query BookingKit_GetUserPermissions($userId: ObjectId!) {
    userPermissions(id: $userId)
    userById(id: $userId) {
      ManagerId
    }
  }
`;
export type BookingKit_GetUserPermissionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKit_GetUserPermissionsQuery,
    BookingKit_GetUserPermissionsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingKit_GetUserPermissionsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingKit_GetUserPermissionsComponent = (
  props: BookingKit_GetUserPermissionsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKit_GetUserPermissionsQuery,
    BookingKit_GetUserPermissionsQueryVariables
  >
    query={BookingKit_GetUserPermissionsDocument}
    {...props}
  />
);

/**
 * __useBookingKit_GetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useBookingKit_GetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKit_GetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKit_GetUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBookingKit_GetUserPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKit_GetUserPermissionsQuery,
    BookingKit_GetUserPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingKit_GetUserPermissionsQuery,
    BookingKit_GetUserPermissionsQueryVariables
  >(BookingKit_GetUserPermissionsDocument, options);
}
export function useBookingKit_GetUserPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKit_GetUserPermissionsQuery,
    BookingKit_GetUserPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingKit_GetUserPermissionsQuery,
    BookingKit_GetUserPermissionsQueryVariables
  >(BookingKit_GetUserPermissionsDocument, options);
}
export type BookingKit_GetUserPermissionsQueryHookResult = ReturnType<
  typeof useBookingKit_GetUserPermissionsQuery
>;
export type BookingKit_GetUserPermissionsLazyQueryHookResult = ReturnType<
  typeof useBookingKit_GetUserPermissionsLazyQuery
>;
export namespace BookingKit_GetUserPermissions {
  export type Return = BookingKit_GetUserPermissionsQuery;
  export type Variables = BookingKit_GetUserPermissionsQueryVariables;
  export const OperationName = "BookingKit_GetUserPermissions";

  export const Document = BookingKit_GetUserPermissionsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingKit_GetUsersDocument = gql`
  query BookingKit_GetUsers($ids: [ObjectId!]!) {
    users(ids: $ids) {
      _id
      Name
      AvatarPic
    }
  }
`;
export type BookingKit_GetUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingKit_GetUsersQuery,
    BookingKit_GetUsersQueryVariables
  >,
  "query"
> &
  ({ variables: BookingKit_GetUsersQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingKit_GetUsersComponent = (
  props: BookingKit_GetUsersComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingKit_GetUsersQuery,
    BookingKit_GetUsersQueryVariables
  >
    query={BookingKit_GetUsersDocument}
    {...props}
  />
);

/**
 * __useBookingKit_GetUsersQuery__
 *
 * To run a query within a React component, call `useBookingKit_GetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingKit_GetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingKit_GetUsersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBookingKit_GetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingKit_GetUsersQuery,
    BookingKit_GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingKit_GetUsersQuery, BookingKit_GetUsersQueryVariables>(
    BookingKit_GetUsersDocument,
    options
  );
}
export function useBookingKit_GetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingKit_GetUsersQuery,
    BookingKit_GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingKit_GetUsersQuery, BookingKit_GetUsersQueryVariables>(
    BookingKit_GetUsersDocument,
    options
  );
}
export type BookingKit_GetUsersQueryHookResult = ReturnType<
  typeof useBookingKit_GetUsersQuery
>;
export type BookingKit_GetUsersLazyQueryHookResult = ReturnType<
  typeof useBookingKit_GetUsersLazyQuery
>;
export namespace BookingKit_GetUsers {
  export type Return = BookingKit_GetUsersQuery;
  export type Variables = BookingKit_GetUsersQueryVariables;
  export const OperationName = "BookingKit_GetUsers";

  export const Document = BookingKit_GetUsersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TimeReport_SendToCustomerDocument = gql`
  mutation TimeReport_SendToCustomer(
    $timeReportId: ObjectId!
    $bookingId: ObjectId!
    $emailInput: EmailInput!
    $type: TimeReportTemplateType!
    $fileName: String!
  ) {
    sendTimereportToCustomer(
      emailInput: $emailInput
      bookingId: $bookingId
      timeReportId: $timeReportId
      templateType: $type
      fileName: $fileName
    ) {
      Subject
    }
  }
`;
export type TimeReport_SendToCustomerMutationFn = Apollo.MutationFunction<
  TimeReport_SendToCustomerMutation,
  TimeReport_SendToCustomerMutationVariables
>;
export type TimeReport_SendToCustomerComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TimeReport_SendToCustomerMutation,
    TimeReport_SendToCustomerMutationVariables
  >,
  "mutation"
>;

export const TimeReport_SendToCustomerComponent = (
  props: TimeReport_SendToCustomerComponentProps
) => (
  <ApolloReactComponents.Mutation<
    TimeReport_SendToCustomerMutation,
    TimeReport_SendToCustomerMutationVariables
  >
    mutation={TimeReport_SendToCustomerDocument}
    {...props}
  />
);

/**
 * __useTimeReport_SendToCustomerMutation__
 *
 * To run a mutation, you first call `useTimeReport_SendToCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReport_SendToCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportSendToCustomerMutation, { data, loading, error }] = useTimeReport_SendToCustomerMutation({
 *   variables: {
 *      timeReportId: // value for 'timeReportId'
 *      bookingId: // value for 'bookingId'
 *      emailInput: // value for 'emailInput'
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useTimeReport_SendToCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TimeReport_SendToCustomerMutation,
    TimeReport_SendToCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TimeReport_SendToCustomerMutation,
    TimeReport_SendToCustomerMutationVariables
  >(TimeReport_SendToCustomerDocument, options);
}
export type TimeReport_SendToCustomerMutationHookResult = ReturnType<
  typeof useTimeReport_SendToCustomerMutation
>;
export namespace TimeReport_SendToCustomer {
  export type Return = TimeReport_SendToCustomerMutation;
  export type Variables = TimeReport_SendToCustomerMutationVariables;
  export const OperationName = "TimeReport_SendToCustomer";

  export const Document = TimeReport_SendToCustomerDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TimeReport_ClearDaysDocument = gql`
  mutation TimeReport_ClearDays($timeReportId: ObjectId!) {
    clearTimereportDays(timeReportId: $timeReportId)
  }
`;
export type TimeReport_ClearDaysMutationFn = Apollo.MutationFunction<
  TimeReport_ClearDaysMutation,
  TimeReport_ClearDaysMutationVariables
>;
export type TimeReport_ClearDaysComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    TimeReport_ClearDaysMutation,
    TimeReport_ClearDaysMutationVariables
  >,
  "mutation"
>;

export const TimeReport_ClearDaysComponent = (
  props: TimeReport_ClearDaysComponentProps
) => (
  <ApolloReactComponents.Mutation<
    TimeReport_ClearDaysMutation,
    TimeReport_ClearDaysMutationVariables
  >
    mutation={TimeReport_ClearDaysDocument}
    {...props}
  />
);

/**
 * __useTimeReport_ClearDaysMutation__
 *
 * To run a mutation, you first call `useTimeReport_ClearDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReport_ClearDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportClearDaysMutation, { data, loading, error }] = useTimeReport_ClearDaysMutation({
 *   variables: {
 *      timeReportId: // value for 'timeReportId'
 *   },
 * });
 */
export function useTimeReport_ClearDaysMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TimeReport_ClearDaysMutation,
    TimeReport_ClearDaysMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TimeReport_ClearDaysMutation,
    TimeReport_ClearDaysMutationVariables
  >(TimeReport_ClearDaysDocument, options);
}
export type TimeReport_ClearDaysMutationHookResult = ReturnType<
  typeof useTimeReport_ClearDaysMutation
>;
export namespace TimeReport_ClearDays {
  export type Return = TimeReport_ClearDaysMutation;
  export type Variables = TimeReport_ClearDaysMutationVariables;
  export const OperationName = "TimeReport_ClearDays";

  export const Document = TimeReport_ClearDaysDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SetSkipTimereportReminderDocument = gql`
  mutation setSkipTimereportReminder($bookingId: ObjectId!, $value: Boolean!) {
    setSkipTimereportReminder(bookingId: $bookingId, value: $value) {
      value
    }
  }
`;
export type SetSkipTimereportReminderMutationFn = Apollo.MutationFunction<
  SetSkipTimereportReminderMutation,
  SetSkipTimereportReminderMutationVariables
>;
export type SetSkipTimereportReminderComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetSkipTimereportReminderMutation,
    SetSkipTimereportReminderMutationVariables
  >,
  "mutation"
>;

export const SetSkipTimereportReminderComponent = (
  props: SetSkipTimereportReminderComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetSkipTimereportReminderMutation,
    SetSkipTimereportReminderMutationVariables
  >
    mutation={SetSkipTimereportReminderDocument}
    {...props}
  />
);

/**
 * __useSetSkipTimereportReminderMutation__
 *
 * To run a mutation, you first call `useSetSkipTimereportReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSkipTimereportReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSkipTimereportReminderMutation, { data, loading, error }] = useSetSkipTimereportReminderMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetSkipTimereportReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSkipTimereportReminderMutation,
    SetSkipTimereportReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSkipTimereportReminderMutation,
    SetSkipTimereportReminderMutationVariables
  >(SetSkipTimereportReminderDocument, options);
}
export type SetSkipTimereportReminderMutationHookResult = ReturnType<
  typeof useSetSkipTimereportReminderMutation
>;
export namespace SetSkipTimereportReminder {
  export type Return = SetSkipTimereportReminderMutation;
  export type Variables = SetSkipTimereportReminderMutationVariables;
  export const OperationName = "setSkipTimereportReminder";

  export const Document = SetSkipTimereportReminderDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SendTimeReportToConsultantDocument = gql`
  mutation SendTimeReportToConsultant(
    $bookingId: ObjectId!
    $timeReportTemplate: TimeReportTemplateType
  ) {
    sendTimereportToConsultant(
      bookingId: $bookingId
      timereportTemplate: $timeReportTemplate
    )
  }
`;
export type SendTimeReportToConsultantMutationFn = Apollo.MutationFunction<
  SendTimeReportToConsultantMutation,
  SendTimeReportToConsultantMutationVariables
>;
export type SendTimeReportToConsultantComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendTimeReportToConsultantMutation,
    SendTimeReportToConsultantMutationVariables
  >,
  "mutation"
>;

export const SendTimeReportToConsultantComponent = (
  props: SendTimeReportToConsultantComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SendTimeReportToConsultantMutation,
    SendTimeReportToConsultantMutationVariables
  >
    mutation={SendTimeReportToConsultantDocument}
    {...props}
  />
);

/**
 * __useSendTimeReportToConsultantMutation__
 *
 * To run a mutation, you first call `useSendTimeReportToConsultantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTimeReportToConsultantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTimeReportToConsultantMutation, { data, loading, error }] = useSendTimeReportToConsultantMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      timeReportTemplate: // value for 'timeReportTemplate'
 *   },
 * });
 */
export function useSendTimeReportToConsultantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendTimeReportToConsultantMutation,
    SendTimeReportToConsultantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendTimeReportToConsultantMutation,
    SendTimeReportToConsultantMutationVariables
  >(SendTimeReportToConsultantDocument, options);
}
export type SendTimeReportToConsultantMutationHookResult = ReturnType<
  typeof useSendTimeReportToConsultantMutation
>;
export namespace SendTimeReportToConsultant {
  export type Return = SendTimeReportToConsultantMutation;
  export type Variables = SendTimeReportToConsultantMutationVariables;
  export const OperationName = "SendTimeReportToConsultant";

  export const Document = SendTimeReportToConsultantDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TimeReport_GetBookingInfoDocument = gql`
  query TimeReport_GetBookingInfo($id: ObjectId!) {
    bookingInfo: bookingById(id: $id) {
      ...bookingInfoForTimeReport
    }
  }
  ${BookingInfoForTimeReportFragmentDoc}
`;
export type TimeReport_GetBookingInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimeReport_GetBookingInfoQuery,
    TimeReport_GetBookingInfoQueryVariables
  >,
  "query"
> &
  (
    | { variables: TimeReport_GetBookingInfoQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const TimeReport_GetBookingInfoComponent = (
  props: TimeReport_GetBookingInfoComponentProps
) => (
  <ApolloReactComponents.Query<
    TimeReport_GetBookingInfoQuery,
    TimeReport_GetBookingInfoQueryVariables
  >
    query={TimeReport_GetBookingInfoDocument}
    {...props}
  />
);

/**
 * __useTimeReport_GetBookingInfoQuery__
 *
 * To run a query within a React component, call `useTimeReport_GetBookingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReport_GetBookingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReport_GetBookingInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeReport_GetBookingInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimeReport_GetBookingInfoQuery,
    TimeReport_GetBookingInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TimeReport_GetBookingInfoQuery,
    TimeReport_GetBookingInfoQueryVariables
  >(TimeReport_GetBookingInfoDocument, options);
}
export function useTimeReport_GetBookingInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimeReport_GetBookingInfoQuery,
    TimeReport_GetBookingInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimeReport_GetBookingInfoQuery,
    TimeReport_GetBookingInfoQueryVariables
  >(TimeReport_GetBookingInfoDocument, options);
}
export type TimeReport_GetBookingInfoQueryHookResult = ReturnType<
  typeof useTimeReport_GetBookingInfoQuery
>;
export type TimeReport_GetBookingInfoLazyQueryHookResult = ReturnType<
  typeof useTimeReport_GetBookingInfoLazyQuery
>;
export namespace TimeReport_GetBookingInfo {
  export type Return = TimeReport_GetBookingInfoQuery;
  export type Variables = TimeReport_GetBookingInfoQueryVariables;
  export const OperationName = "TimeReport_GetBookingInfo";

  export const Document = TimeReport_GetBookingInfoDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetTimereportTemplates_ByCustomerIdDocument = gql`
  query getTimereportTemplates_ByCustomerId($customerId: ObjectId!) {
    customerById(id: $customerId) {
      _id
      timeReportTemplateSettings {
        type
        professions
      }
      needSignatureTROkInApp
      needSignature
      noApproval
      noApprovalMonthly
      noApprovalSpecial
      noApprovalShortening
    }
  }
`;
export type GetTimereportTemplates_ByCustomerIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetTimereportTemplates_ByCustomerIdQuery,
    GetTimereportTemplates_ByCustomerIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetTimereportTemplates_ByCustomerIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetTimereportTemplates_ByCustomerIdComponent = (
  props: GetTimereportTemplates_ByCustomerIdComponentProps
) => (
  <ApolloReactComponents.Query<
    GetTimereportTemplates_ByCustomerIdQuery,
    GetTimereportTemplates_ByCustomerIdQueryVariables
  >
    query={GetTimereportTemplates_ByCustomerIdDocument}
    {...props}
  />
);

/**
 * __useGetTimereportTemplates_ByCustomerIdQuery__
 *
 * To run a query within a React component, call `useGetTimereportTemplates_ByCustomerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimereportTemplates_ByCustomerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimereportTemplates_ByCustomerIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetTimereportTemplates_ByCustomerIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTimereportTemplates_ByCustomerIdQuery,
    GetTimereportTemplates_ByCustomerIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTimereportTemplates_ByCustomerIdQuery,
    GetTimereportTemplates_ByCustomerIdQueryVariables
  >(GetTimereportTemplates_ByCustomerIdDocument, options);
}
export function useGetTimereportTemplates_ByCustomerIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTimereportTemplates_ByCustomerIdQuery,
    GetTimereportTemplates_ByCustomerIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTimereportTemplates_ByCustomerIdQuery,
    GetTimereportTemplates_ByCustomerIdQueryVariables
  >(GetTimereportTemplates_ByCustomerIdDocument, options);
}
export type GetTimereportTemplates_ByCustomerIdQueryHookResult = ReturnType<
  typeof useGetTimereportTemplates_ByCustomerIdQuery
>;
export type GetTimereportTemplates_ByCustomerIdLazyQueryHookResult = ReturnType<
  typeof useGetTimereportTemplates_ByCustomerIdLazyQuery
>;
export namespace GetTimereportTemplates_ByCustomerId {
  export type Return = GetTimereportTemplates_ByCustomerIdQuery;
  export type Variables = GetTimereportTemplates_ByCustomerIdQueryVariables;
  export const OperationName = "getTimereportTemplates_ByCustomerId";

  export const Document = GetTimereportTemplates_ByCustomerIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TimeReport_GetCustomerContactsDocument = gql`
  query TimeReport_GetCustomerContacts($depIds: [ObjectId!], $hospId: ObjectId) {
    contacts: getContactPersonsByCustomerIds(depIds: $depIds, hospId: $hospId) {
      _id
      Title
      Name
      Roles
      Email
      AreasOfExpertise
      BooksProfessions
    }
  }
`;
export type TimeReport_GetCustomerContactsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TimeReport_GetCustomerContactsQuery,
    TimeReport_GetCustomerContactsQueryVariables
  >,
  "query"
>;

export const TimeReport_GetCustomerContactsComponent = (
  props: TimeReport_GetCustomerContactsComponentProps
) => (
  <ApolloReactComponents.Query<
    TimeReport_GetCustomerContactsQuery,
    TimeReport_GetCustomerContactsQueryVariables
  >
    query={TimeReport_GetCustomerContactsDocument}
    {...props}
  />
);

/**
 * __useTimeReport_GetCustomerContactsQuery__
 *
 * To run a query within a React component, call `useTimeReport_GetCustomerContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReport_GetCustomerContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReport_GetCustomerContactsQuery({
 *   variables: {
 *      depIds: // value for 'depIds'
 *      hospId: // value for 'hospId'
 *   },
 * });
 */
export function useTimeReport_GetCustomerContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TimeReport_GetCustomerContactsQuery,
    TimeReport_GetCustomerContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TimeReport_GetCustomerContactsQuery,
    TimeReport_GetCustomerContactsQueryVariables
  >(TimeReport_GetCustomerContactsDocument, options);
}
export function useTimeReport_GetCustomerContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimeReport_GetCustomerContactsQuery,
    TimeReport_GetCustomerContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimeReport_GetCustomerContactsQuery,
    TimeReport_GetCustomerContactsQueryVariables
  >(TimeReport_GetCustomerContactsDocument, options);
}
export type TimeReport_GetCustomerContactsQueryHookResult = ReturnType<
  typeof useTimeReport_GetCustomerContactsQuery
>;
export type TimeReport_GetCustomerContactsLazyQueryHookResult = ReturnType<
  typeof useTimeReport_GetCustomerContactsLazyQuery
>;
export namespace TimeReport_GetCustomerContacts {
  export type Return = TimeReport_GetCustomerContactsQuery;
  export type Variables = TimeReport_GetCustomerContactsQueryVariables;
  export const OperationName = "TimeReport_GetCustomerContacts";

  export const Document = TimeReport_GetCustomerContactsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_GetFreeTimereportsDocument = gql`
  query Timereport_GetFreeTimereports(
    $consultantId: ObjectId!
    $week: Int!
    $year: Int!
  ) {
    getFreeTimereports(consultantId: $consultantId, week: $week, year: $year) {
      freeTimereports
    }
  }
`;
export type Timereport_GetFreeTimereportsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Timereport_GetFreeTimereportsQuery,
    Timereport_GetFreeTimereportsQueryVariables
  >,
  "query"
> &
  (
    | { variables: Timereport_GetFreeTimereportsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Timereport_GetFreeTimereportsComponent = (
  props: Timereport_GetFreeTimereportsComponentProps
) => (
  <ApolloReactComponents.Query<
    Timereport_GetFreeTimereportsQuery,
    Timereport_GetFreeTimereportsQueryVariables
  >
    query={Timereport_GetFreeTimereportsDocument}
    {...props}
  />
);

/**
 * __useTimereport_GetFreeTimereportsQuery__
 *
 * To run a query within a React component, call `useTimereport_GetFreeTimereportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereport_GetFreeTimereportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereport_GetFreeTimereportsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      week: // value for 'week'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useTimereport_GetFreeTimereportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Timereport_GetFreeTimereportsQuery,
    Timereport_GetFreeTimereportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Timereport_GetFreeTimereportsQuery,
    Timereport_GetFreeTimereportsQueryVariables
  >(Timereport_GetFreeTimereportsDocument, options);
}
export function useTimereport_GetFreeTimereportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Timereport_GetFreeTimereportsQuery,
    Timereport_GetFreeTimereportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Timereport_GetFreeTimereportsQuery,
    Timereport_GetFreeTimereportsQueryVariables
  >(Timereport_GetFreeTimereportsDocument, options);
}
export type Timereport_GetFreeTimereportsQueryHookResult = ReturnType<
  typeof useTimereport_GetFreeTimereportsQuery
>;
export type Timereport_GetFreeTimereportsLazyQueryHookResult = ReturnType<
  typeof useTimereport_GetFreeTimereportsLazyQuery
>;
export namespace Timereport_GetFreeTimereports {
  export type Return = Timereport_GetFreeTimereportsQuery;
  export type Variables = Timereport_GetFreeTimereportsQueryVariables;
  export const OperationName = "Timereport_GetFreeTimereports";

  export const Document = Timereport_GetFreeTimereportsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_GetStatusHistoryDocument = gql`
  query Timereport_GetStatusHistory($bookingId: ObjectId!) {
    getTimereportStatusHistory(bookingId: $bookingId) {
      history
    }
  }
`;
export type Timereport_GetStatusHistoryComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Timereport_GetStatusHistoryQuery,
    Timereport_GetStatusHistoryQueryVariables
  >,
  "query"
> &
  (
    | { variables: Timereport_GetStatusHistoryQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Timereport_GetStatusHistoryComponent = (
  props: Timereport_GetStatusHistoryComponentProps
) => (
  <ApolloReactComponents.Query<
    Timereport_GetStatusHistoryQuery,
    Timereport_GetStatusHistoryQueryVariables
  >
    query={Timereport_GetStatusHistoryDocument}
    {...props}
  />
);

/**
 * __useTimereport_GetStatusHistoryQuery__
 *
 * To run a query within a React component, call `useTimereport_GetStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereport_GetStatusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereport_GetStatusHistoryQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTimereport_GetStatusHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Timereport_GetStatusHistoryQuery,
    Timereport_GetStatusHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Timereport_GetStatusHistoryQuery,
    Timereport_GetStatusHistoryQueryVariables
  >(Timereport_GetStatusHistoryDocument, options);
}
export function useTimereport_GetStatusHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Timereport_GetStatusHistoryQuery,
    Timereport_GetStatusHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Timereport_GetStatusHistoryQuery,
    Timereport_GetStatusHistoryQueryVariables
  >(Timereport_GetStatusHistoryDocument, options);
}
export type Timereport_GetStatusHistoryQueryHookResult = ReturnType<
  typeof useTimereport_GetStatusHistoryQuery
>;
export type Timereport_GetStatusHistoryLazyQueryHookResult = ReturnType<
  typeof useTimereport_GetStatusHistoryLazyQuery
>;
export namespace Timereport_GetStatusHistory {
  export type Return = Timereport_GetStatusHistoryQuery;
  export type Variables = Timereport_GetStatusHistoryQueryVariables;
  export const OperationName = "Timereport_GetStatusHistory";

  export const Document = Timereport_GetStatusHistoryDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_GetSendFailuresDocument = gql`
  query Timereport_GetSendFailures($bookingId: ObjectId!) {
    getTimereportSendFailures(bookingId: $bookingId) {
      partiallySent
      failures {
        recipient
        failedOn
        reason
      }
    }
  }
`;
export type Timereport_GetSendFailuresComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Timereport_GetSendFailuresQuery,
    Timereport_GetSendFailuresQueryVariables
  >,
  "query"
> &
  (
    | { variables: Timereport_GetSendFailuresQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Timereport_GetSendFailuresComponent = (
  props: Timereport_GetSendFailuresComponentProps
) => (
  <ApolloReactComponents.Query<
    Timereport_GetSendFailuresQuery,
    Timereport_GetSendFailuresQueryVariables
  >
    query={Timereport_GetSendFailuresDocument}
    {...props}
  />
);

/**
 * __useTimereport_GetSendFailuresQuery__
 *
 * To run a query within a React component, call `useTimereport_GetSendFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereport_GetSendFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereport_GetSendFailuresQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTimereport_GetSendFailuresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Timereport_GetSendFailuresQuery,
    Timereport_GetSendFailuresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Timereport_GetSendFailuresQuery,
    Timereport_GetSendFailuresQueryVariables
  >(Timereport_GetSendFailuresDocument, options);
}
export function useTimereport_GetSendFailuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Timereport_GetSendFailuresQuery,
    Timereport_GetSendFailuresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Timereport_GetSendFailuresQuery,
    Timereport_GetSendFailuresQueryVariables
  >(Timereport_GetSendFailuresDocument, options);
}
export type Timereport_GetSendFailuresQueryHookResult = ReturnType<
  typeof useTimereport_GetSendFailuresQuery
>;
export type Timereport_GetSendFailuresLazyQueryHookResult = ReturnType<
  typeof useTimereport_GetSendFailuresLazyQuery
>;
export namespace Timereport_GetSendFailures {
  export type Return = Timereport_GetSendFailuresQuery;
  export type Variables = Timereport_GetSendFailuresQueryVariables;
  export const OperationName = "Timereport_GetSendFailures";

  export const Document = Timereport_GetSendFailuresDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_GetByBookingIdDocument = gql`
  query Timereport_GetByBookingId($bookingId: ObjectId!) {
    getTimereportByBookingId(bookingId: $bookingId) {
      timereport
    }
  }
`;
export type Timereport_GetByBookingIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Timereport_GetByBookingIdQuery,
    Timereport_GetByBookingIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: Timereport_GetByBookingIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Timereport_GetByBookingIdComponent = (
  props: Timereport_GetByBookingIdComponentProps
) => (
  <ApolloReactComponents.Query<
    Timereport_GetByBookingIdQuery,
    Timereport_GetByBookingIdQueryVariables
  >
    query={Timereport_GetByBookingIdDocument}
    {...props}
  />
);

/**
 * __useTimereport_GetByBookingIdQuery__
 *
 * To run a query within a React component, call `useTimereport_GetByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereport_GetByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereport_GetByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTimereport_GetByBookingIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Timereport_GetByBookingIdQuery,
    Timereport_GetByBookingIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Timereport_GetByBookingIdQuery,
    Timereport_GetByBookingIdQueryVariables
  >(Timereport_GetByBookingIdDocument, options);
}
export function useTimereport_GetByBookingIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Timereport_GetByBookingIdQuery,
    Timereport_GetByBookingIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Timereport_GetByBookingIdQuery,
    Timereport_GetByBookingIdQueryVariables
  >(Timereport_GetByBookingIdDocument, options);
}
export type Timereport_GetByBookingIdQueryHookResult = ReturnType<
  typeof useTimereport_GetByBookingIdQuery
>;
export type Timereport_GetByBookingIdLazyQueryHookResult = ReturnType<
  typeof useTimereport_GetByBookingIdLazyQuery
>;
export namespace Timereport_GetByBookingId {
  export type Return = Timereport_GetByBookingIdQuery;
  export type Variables = Timereport_GetByBookingIdQueryVariables;
  export const OperationName = "Timereport_GetByBookingId";

  export const Document = Timereport_GetByBookingIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_GetInvoiceStatusForBookingDocument = gql`
  query Timereport_GetInvoiceStatusForBooking($bookingId: ObjectId!) {
    getInvoiceStatusForBooking(bookingId: $bookingId) {
      invoicePaymentStatuses
    }
  }
`;
export type Timereport_GetInvoiceStatusForBookingComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Timereport_GetInvoiceStatusForBookingQuery,
    Timereport_GetInvoiceStatusForBookingQueryVariables
  >,
  "query"
> &
  (
    | { variables: Timereport_GetInvoiceStatusForBookingQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Timereport_GetInvoiceStatusForBookingComponent = (
  props: Timereport_GetInvoiceStatusForBookingComponentProps
) => (
  <ApolloReactComponents.Query<
    Timereport_GetInvoiceStatusForBookingQuery,
    Timereport_GetInvoiceStatusForBookingQueryVariables
  >
    query={Timereport_GetInvoiceStatusForBookingDocument}
    {...props}
  />
);

/**
 * __useTimereport_GetInvoiceStatusForBookingQuery__
 *
 * To run a query within a React component, call `useTimereport_GetInvoiceStatusForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereport_GetInvoiceStatusForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereport_GetInvoiceStatusForBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTimereport_GetInvoiceStatusForBookingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Timereport_GetInvoiceStatusForBookingQuery,
    Timereport_GetInvoiceStatusForBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Timereport_GetInvoiceStatusForBookingQuery,
    Timereport_GetInvoiceStatusForBookingQueryVariables
  >(Timereport_GetInvoiceStatusForBookingDocument, options);
}
export function useTimereport_GetInvoiceStatusForBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Timereport_GetInvoiceStatusForBookingQuery,
    Timereport_GetInvoiceStatusForBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Timereport_GetInvoiceStatusForBookingQuery,
    Timereport_GetInvoiceStatusForBookingQueryVariables
  >(Timereport_GetInvoiceStatusForBookingDocument, options);
}
export type Timereport_GetInvoiceStatusForBookingQueryHookResult = ReturnType<
  typeof useTimereport_GetInvoiceStatusForBookingQuery
>;
export type Timereport_GetInvoiceStatusForBookingLazyQueryHookResult = ReturnType<
  typeof useTimereport_GetInvoiceStatusForBookingLazyQuery
>;
export namespace Timereport_GetInvoiceStatusForBooking {
  export type Return = Timereport_GetInvoiceStatusForBookingQuery;
  export type Variables = Timereport_GetInvoiceStatusForBookingQueryVariables;
  export const OperationName = "Timereport_GetInvoiceStatusForBooking";

  export const Document = Timereport_GetInvoiceStatusForBookingDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_GetDetailsDocument = gql`
  query Timereport_GetDetails($bookingId: ObjectId!) {
    timereport: getTimereportByBookingId(bookingId: $bookingId) {
      data: timereport
    }
    invoicePaymentStatuses: getInvoiceStatusForBooking(bookingId: $bookingId) {
      data: invoicePaymentStatuses
    }
  }
`;
export type Timereport_GetDetailsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Timereport_GetDetailsQuery,
    Timereport_GetDetailsQueryVariables
  >,
  "query"
> &
  (
    | { variables: Timereport_GetDetailsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Timereport_GetDetailsComponent = (
  props: Timereport_GetDetailsComponentProps
) => (
  <ApolloReactComponents.Query<
    Timereport_GetDetailsQuery,
    Timereport_GetDetailsQueryVariables
  >
    query={Timereport_GetDetailsDocument}
    {...props}
  />
);

/**
 * __useTimereport_GetDetailsQuery__
 *
 * To run a query within a React component, call `useTimereport_GetDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimereport_GetDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimereport_GetDetailsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTimereport_GetDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Timereport_GetDetailsQuery,
    Timereport_GetDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Timereport_GetDetailsQuery, Timereport_GetDetailsQueryVariables>(
    Timereport_GetDetailsDocument,
    options
  );
}
export function useTimereport_GetDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Timereport_GetDetailsQuery,
    Timereport_GetDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Timereport_GetDetailsQuery,
    Timereport_GetDetailsQueryVariables
  >(Timereport_GetDetailsDocument, options);
}
export type Timereport_GetDetailsQueryHookResult = ReturnType<
  typeof useTimereport_GetDetailsQuery
>;
export type Timereport_GetDetailsLazyQueryHookResult = ReturnType<
  typeof useTimereport_GetDetailsLazyQuery
>;
export namespace Timereport_GetDetails {
  export type Return = Timereport_GetDetailsQuery;
  export type Variables = Timereport_GetDetailsQueryVariables;
  export const OperationName = "Timereport_GetDetails";

  export const Document = Timereport_GetDetailsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Timereport_AssignToBookingDocument = gql`
  mutation Timereport_AssignToBooking($bookingId: ObjectId!, $timeReportId: ObjectId!) {
    assignTimereportToBooking(bookingId: $bookingId, timeReportId: $timeReportId)
  }
`;
export type Timereport_AssignToBookingMutationFn = Apollo.MutationFunction<
  Timereport_AssignToBookingMutation,
  Timereport_AssignToBookingMutationVariables
>;
export type Timereport_AssignToBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Timereport_AssignToBookingMutation,
    Timereport_AssignToBookingMutationVariables
  >,
  "mutation"
>;

export const Timereport_AssignToBookingComponent = (
  props: Timereport_AssignToBookingComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Timereport_AssignToBookingMutation,
    Timereport_AssignToBookingMutationVariables
  >
    mutation={Timereport_AssignToBookingDocument}
    {...props}
  />
);

/**
 * __useTimereport_AssignToBookingMutation__
 *
 * To run a mutation, you first call `useTimereport_AssignToBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimereport_AssignToBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timereportAssignToBookingMutation, { data, loading, error }] = useTimereport_AssignToBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      timeReportId: // value for 'timeReportId'
 *   },
 * });
 */
export function useTimereport_AssignToBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Timereport_AssignToBookingMutation,
    Timereport_AssignToBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Timereport_AssignToBookingMutation,
    Timereport_AssignToBookingMutationVariables
  >(Timereport_AssignToBookingDocument, options);
}
export type Timereport_AssignToBookingMutationHookResult = ReturnType<
  typeof useTimereport_AssignToBookingMutation
>;
export namespace Timereport_AssignToBooking {
  export type Return = Timereport_AssignToBookingMutation;
  export type Variables = Timereport_AssignToBookingMutationVariables;
  export const OperationName = "Timereport_AssignToBooking";

  export const Document = Timereport_AssignToBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Timereport_ApproveDocument = gql`
  mutation Timereport_Approve($timereportId: ObjectId!, $approvedBy: String!) {
    approveTimereport(timereportId: $timereportId, approvedBy: $approvedBy)
  }
`;
export type Timereport_ApproveMutationFn = Apollo.MutationFunction<
  Timereport_ApproveMutation,
  Timereport_ApproveMutationVariables
>;
export type Timereport_ApproveComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Timereport_ApproveMutation,
    Timereport_ApproveMutationVariables
  >,
  "mutation"
>;

export const Timereport_ApproveComponent = (props: Timereport_ApproveComponentProps) => (
  <ApolloReactComponents.Mutation<
    Timereport_ApproveMutation,
    Timereport_ApproveMutationVariables
  >
    mutation={Timereport_ApproveDocument}
    {...props}
  />
);

/**
 * __useTimereport_ApproveMutation__
 *
 * To run a mutation, you first call `useTimereport_ApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimereport_ApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timereportApproveMutation, { data, loading, error }] = useTimereport_ApproveMutation({
 *   variables: {
 *      timereportId: // value for 'timereportId'
 *      approvedBy: // value for 'approvedBy'
 *   },
 * });
 */
export function useTimereport_ApproveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Timereport_ApproveMutation,
    Timereport_ApproveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Timereport_ApproveMutation,
    Timereport_ApproveMutationVariables
  >(Timereport_ApproveDocument, options);
}
export type Timereport_ApproveMutationHookResult = ReturnType<
  typeof useTimereport_ApproveMutation
>;
export namespace Timereport_Approve {
  export type Return = Timereport_ApproveMutation;
  export type Variables = Timereport_ApproveMutationVariables;
  export const OperationName = "Timereport_Approve";

  export const Document = Timereport_ApproveDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Timereport_SetToSubmittedDocument = gql`
  mutation Timereport_SetToSubmitted($timereportId: ObjectId!, $submittedBy: String!) {
    setTimereportToSubmitted(timereportId: $timereportId, submittedBy: $submittedBy)
  }
`;
export type Timereport_SetToSubmittedMutationFn = Apollo.MutationFunction<
  Timereport_SetToSubmittedMutation,
  Timereport_SetToSubmittedMutationVariables
>;
export type Timereport_SetToSubmittedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Timereport_SetToSubmittedMutation,
    Timereport_SetToSubmittedMutationVariables
  >,
  "mutation"
>;

export const Timereport_SetToSubmittedComponent = (
  props: Timereport_SetToSubmittedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Timereport_SetToSubmittedMutation,
    Timereport_SetToSubmittedMutationVariables
  >
    mutation={Timereport_SetToSubmittedDocument}
    {...props}
  />
);

/**
 * __useTimereport_SetToSubmittedMutation__
 *
 * To run a mutation, you first call `useTimereport_SetToSubmittedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimereport_SetToSubmittedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timereportSetToSubmittedMutation, { data, loading, error }] = useTimereport_SetToSubmittedMutation({
 *   variables: {
 *      timereportId: // value for 'timereportId'
 *      submittedBy: // value for 'submittedBy'
 *   },
 * });
 */
export function useTimereport_SetToSubmittedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Timereport_SetToSubmittedMutation,
    Timereport_SetToSubmittedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Timereport_SetToSubmittedMutation,
    Timereport_SetToSubmittedMutationVariables
  >(Timereport_SetToSubmittedDocument, options);
}
export type Timereport_SetToSubmittedMutationHookResult = ReturnType<
  typeof useTimereport_SetToSubmittedMutation
>;
export namespace Timereport_SetToSubmitted {
  export type Return = Timereport_SetToSubmittedMutation;
  export type Variables = Timereport_SetToSubmittedMutationVariables;
  export const OperationName = "Timereport_SetToSubmitted";

  export const Document = Timereport_SetToSubmittedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Timereport_SetToDraftDocument = gql`
  mutation Timereport_SetToDraft(
    $bookingId: ObjectId!
    $approvedBy: String!
    $approvedId: String!
  ) {
    setTimereportToDraft(
      bookingId: $bookingId
      approvedBy: $approvedBy
      approvedId: $approvedId
    ) {
      timereport
    }
  }
`;
export type Timereport_SetToDraftMutationFn = Apollo.MutationFunction<
  Timereport_SetToDraftMutation,
  Timereport_SetToDraftMutationVariables
>;
export type Timereport_SetToDraftComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Timereport_SetToDraftMutation,
    Timereport_SetToDraftMutationVariables
  >,
  "mutation"
>;

export const Timereport_SetToDraftComponent = (
  props: Timereport_SetToDraftComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Timereport_SetToDraftMutation,
    Timereport_SetToDraftMutationVariables
  >
    mutation={Timereport_SetToDraftDocument}
    {...props}
  />
);

/**
 * __useTimereport_SetToDraftMutation__
 *
 * To run a mutation, you first call `useTimereport_SetToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimereport_SetToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timereportSetToDraftMutation, { data, loading, error }] = useTimereport_SetToDraftMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      approvedBy: // value for 'approvedBy'
 *      approvedId: // value for 'approvedId'
 *   },
 * });
 */
export function useTimereport_SetToDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Timereport_SetToDraftMutation,
    Timereport_SetToDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Timereport_SetToDraftMutation,
    Timereport_SetToDraftMutationVariables
  >(Timereport_SetToDraftDocument, options);
}
export type Timereport_SetToDraftMutationHookResult = ReturnType<
  typeof useTimereport_SetToDraftMutation
>;
export namespace Timereport_SetToDraft {
  export type Return = Timereport_SetToDraftMutation;
  export type Variables = Timereport_SetToDraftMutationVariables;
  export const OperationName = "Timereport_SetToDraft";

  export const Document = Timereport_SetToDraftDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingCallNumberForm_GetCustomerDocument = gql`
  query BookingCallNumberForm_GetCustomer($id: ObjectId!) {
    customerById(id: $id) {
      Parents {
        Name
      }
    }
  }
`;
export type BookingCallNumberForm_GetCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingCallNumberForm_GetCustomerQuery,
    BookingCallNumberForm_GetCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingCallNumberForm_GetCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingCallNumberForm_GetCustomerComponent = (
  props: BookingCallNumberForm_GetCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingCallNumberForm_GetCustomerQuery,
    BookingCallNumberForm_GetCustomerQueryVariables
  >
    query={BookingCallNumberForm_GetCustomerDocument}
    {...props}
  />
);

/**
 * __useBookingCallNumberForm_GetCustomerQuery__
 *
 * To run a query within a React component, call `useBookingCallNumberForm_GetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCallNumberForm_GetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCallNumberForm_GetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingCallNumberForm_GetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingCallNumberForm_GetCustomerQuery,
    BookingCallNumberForm_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingCallNumberForm_GetCustomerQuery,
    BookingCallNumberForm_GetCustomerQueryVariables
  >(BookingCallNumberForm_GetCustomerDocument, options);
}
export function useBookingCallNumberForm_GetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingCallNumberForm_GetCustomerQuery,
    BookingCallNumberForm_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingCallNumberForm_GetCustomerQuery,
    BookingCallNumberForm_GetCustomerQueryVariables
  >(BookingCallNumberForm_GetCustomerDocument, options);
}
export type BookingCallNumberForm_GetCustomerQueryHookResult = ReturnType<
  typeof useBookingCallNumberForm_GetCustomerQuery
>;
export type BookingCallNumberForm_GetCustomerLazyQueryHookResult = ReturnType<
  typeof useBookingCallNumberForm_GetCustomerLazyQuery
>;
export namespace BookingCallNumberForm_GetCustomer {
  export type Return = BookingCallNumberForm_GetCustomerQuery;
  export type Variables = BookingCallNumberForm_GetCustomerQueryVariables;
  export const OperationName = "BookingCallNumberForm_GetCustomer";

  export const Document = BookingCallNumberForm_GetCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetBookingCallNumberDocument = gql`
  mutation SetBookingCallNumber($bookingId: ObjectId!, $callNumber: String!) {
    setBookingCallNumber(bookingId: $bookingId, callNumber: $callNumber)
  }
`;
export type SetBookingCallNumberMutationFn = Apollo.MutationFunction<
  SetBookingCallNumberMutation,
  SetBookingCallNumberMutationVariables
>;
export type SetBookingCallNumberComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetBookingCallNumberMutation,
    SetBookingCallNumberMutationVariables
  >,
  "mutation"
>;

export const SetBookingCallNumberComponent = (
  props: SetBookingCallNumberComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetBookingCallNumberMutation,
    SetBookingCallNumberMutationVariables
  >
    mutation={SetBookingCallNumberDocument}
    {...props}
  />
);

/**
 * __useSetBookingCallNumberMutation__
 *
 * To run a mutation, you first call `useSetBookingCallNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBookingCallNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBookingCallNumberMutation, { data, loading, error }] = useSetBookingCallNumberMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      callNumber: // value for 'callNumber'
 *   },
 * });
 */
export function useSetBookingCallNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBookingCallNumberMutation,
    SetBookingCallNumberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBookingCallNumberMutation,
    SetBookingCallNumberMutationVariables
  >(SetBookingCallNumberDocument, options);
}
export type SetBookingCallNumberMutationHookResult = ReturnType<
  typeof useSetBookingCallNumberMutation
>;
export namespace SetBookingCallNumber {
  export type Return = SetBookingCallNumberMutation;
  export type Variables = SetBookingCallNumberMutationVariables;
  export const OperationName = "SetBookingCallNumber";

  export const Document = SetBookingCallNumberDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CancelBookingButtonsBookingDocument = gql`
  query cancelBookingButtonsBooking($bookingId: ObjectId!) {
    checkBookingCancellable(bookingId: $bookingId)
    bookingById(id: $bookingId) {
      _id
      IsCustomerBilled
      IsCanceled
    }
  }
`;
export type CancelBookingButtonsBookingComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CancelBookingButtonsBookingQuery,
    CancelBookingButtonsBookingQueryVariables
  >,
  "query"
> &
  (
    | { variables: CancelBookingButtonsBookingQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CancelBookingButtonsBookingComponent = (
  props: CancelBookingButtonsBookingComponentProps
) => (
  <ApolloReactComponents.Query<
    CancelBookingButtonsBookingQuery,
    CancelBookingButtonsBookingQueryVariables
  >
    query={CancelBookingButtonsBookingDocument}
    {...props}
  />
);

/**
 * __useCancelBookingButtonsBookingQuery__
 *
 * To run a query within a React component, call `useCancelBookingButtonsBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingButtonsBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelBookingButtonsBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCancelBookingButtonsBookingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CancelBookingButtonsBookingQuery,
    CancelBookingButtonsBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CancelBookingButtonsBookingQuery,
    CancelBookingButtonsBookingQueryVariables
  >(CancelBookingButtonsBookingDocument, options);
}
export function useCancelBookingButtonsBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CancelBookingButtonsBookingQuery,
    CancelBookingButtonsBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CancelBookingButtonsBookingQuery,
    CancelBookingButtonsBookingQueryVariables
  >(CancelBookingButtonsBookingDocument, options);
}
export type CancelBookingButtonsBookingQueryHookResult = ReturnType<
  typeof useCancelBookingButtonsBookingQuery
>;
export type CancelBookingButtonsBookingLazyQueryHookResult = ReturnType<
  typeof useCancelBookingButtonsBookingLazyQuery
>;
export namespace CancelBookingButtonsBooking {
  export type Return = CancelBookingButtonsBookingQuery;
  export type Variables = CancelBookingButtonsBookingQueryVariables;
  export const OperationName = "cancelBookingButtonsBooking";

  export const Document = CancelBookingButtonsBookingDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CancelBookingButtonsGroupDocument = gql`
  query cancelBookingButtonsGroup($bookingId: ObjectId!) {
    checkBookingGroupCancellableByBookingId(bookingId: $bookingId) {
      isCancellable
      nonCancellableReason
    }
    bookingById(id: $bookingId) {
      _id
      BookingGroup {
        _id
      }
    }
  }
`;
export type CancelBookingButtonsGroupComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CancelBookingButtonsGroupQuery,
    CancelBookingButtonsGroupQueryVariables
  >,
  "query"
> &
  (
    | { variables: CancelBookingButtonsGroupQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CancelBookingButtonsGroupComponent = (
  props: CancelBookingButtonsGroupComponentProps
) => (
  <ApolloReactComponents.Query<
    CancelBookingButtonsGroupQuery,
    CancelBookingButtonsGroupQueryVariables
  >
    query={CancelBookingButtonsGroupDocument}
    {...props}
  />
);

/**
 * __useCancelBookingButtonsGroupQuery__
 *
 * To run a query within a React component, call `useCancelBookingButtonsGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingButtonsGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelBookingButtonsGroupQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCancelBookingButtonsGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CancelBookingButtonsGroupQuery,
    CancelBookingButtonsGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CancelBookingButtonsGroupQuery,
    CancelBookingButtonsGroupQueryVariables
  >(CancelBookingButtonsGroupDocument, options);
}
export function useCancelBookingButtonsGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CancelBookingButtonsGroupQuery,
    CancelBookingButtonsGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CancelBookingButtonsGroupQuery,
    CancelBookingButtonsGroupQueryVariables
  >(CancelBookingButtonsGroupDocument, options);
}
export type CancelBookingButtonsGroupQueryHookResult = ReturnType<
  typeof useCancelBookingButtonsGroupQuery
>;
export type CancelBookingButtonsGroupLazyQueryHookResult = ReturnType<
  typeof useCancelBookingButtonsGroupLazyQuery
>;
export namespace CancelBookingButtonsGroup {
  export type Return = CancelBookingButtonsGroupQuery;
  export type Variables = CancelBookingButtonsGroupQueryVariables;
  export const OperationName = "cancelBookingButtonsGroup";

  export const Document = CancelBookingButtonsGroupDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CancelBookingDocument = gql`
  mutation cancelBooking($id: ObjectId!, $reason: String!) {
    cancelBooking(bookingId: $id, reason: $reason)
  }
`;
export type CancelBookingMutationFn = Apollo.MutationFunction<
  CancelBookingMutation,
  CancelBookingMutationVariables
>;
export type CancelBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CancelBookingMutation,
    CancelBookingMutationVariables
  >,
  "mutation"
>;

export const CancelBookingComponent = (props: CancelBookingComponentProps) => (
  <ApolloReactComponents.Mutation<CancelBookingMutation, CancelBookingMutationVariables>
    mutation={CancelBookingDocument}
    {...props}
  />
);

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingMutation, { data, loading, error }] = useCancelBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelBookingMutation,
    CancelBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(
    CancelBookingDocument,
    options
  );
}
export type CancelBookingMutationHookResult = ReturnType<typeof useCancelBookingMutation>;
export namespace CancelBooking {
  export type Return = CancelBookingMutation;
  export type Variables = CancelBookingMutationVariables;
  export const OperationName = "cancelBooking";

  export const Document = CancelBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CancelBookingGroupDocument = gql`
  mutation cancelBookingGroup($id: ObjectId!, $reason: String!) {
    cancelBookingGroup(bookingGroupId: $id, reason: $reason)
  }
`;
export type CancelBookingGroupMutationFn = Apollo.MutationFunction<
  CancelBookingGroupMutation,
  CancelBookingGroupMutationVariables
>;
export type CancelBookingGroupComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CancelBookingGroupMutation,
    CancelBookingGroupMutationVariables
  >,
  "mutation"
>;

export const CancelBookingGroupComponent = (props: CancelBookingGroupComponentProps) => (
  <ApolloReactComponents.Mutation<
    CancelBookingGroupMutation,
    CancelBookingGroupMutationVariables
  >
    mutation={CancelBookingGroupDocument}
    {...props}
  />
);

/**
 * __useCancelBookingGroupMutation__
 *
 * To run a mutation, you first call `useCancelBookingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingGroupMutation, { data, loading, error }] = useCancelBookingGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelBookingGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelBookingGroupMutation,
    CancelBookingGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelBookingGroupMutation,
    CancelBookingGroupMutationVariables
  >(CancelBookingGroupDocument, options);
}
export type CancelBookingGroupMutationHookResult = ReturnType<
  typeof useCancelBookingGroupMutation
>;
export namespace CancelBookingGroup {
  export type Return = CancelBookingGroupMutation;
  export type Variables = CancelBookingGroupMutationVariables;
  export const OperationName = "cancelBookingGroup";

  export const Document = CancelBookingGroupDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingAuditSearch_GetDocument = gql`
  query BookingAuditSearch_Get($filter: BookingWeekQueryInput!, $skip: Int, $limit: Int) {
    bookingWeeks(filter: $filter, skip: $skip, limit: $limit) {
      items {
        ...BookingAuditSearchItem
      }
      skip
      limit
      total
    }
  }
  ${BookingAuditSearchItemFragmentDoc}
`;
export type BookingAuditSearch_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingAuditSearch_GetQuery,
    BookingAuditSearch_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingAuditSearch_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingAuditSearch_GetComponent = (
  props: BookingAuditSearch_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingAuditSearch_GetQuery,
    BookingAuditSearch_GetQueryVariables
  >
    query={BookingAuditSearch_GetDocument}
    {...props}
  />
);

/**
 * __useBookingAuditSearch_GetQuery__
 *
 * To run a query within a React component, call `useBookingAuditSearch_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAuditSearch_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAuditSearch_GetQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBookingAuditSearch_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingAuditSearch_GetQuery,
    BookingAuditSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingAuditSearch_GetQuery,
    BookingAuditSearch_GetQueryVariables
  >(BookingAuditSearch_GetDocument, options);
}
export function useBookingAuditSearch_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingAuditSearch_GetQuery,
    BookingAuditSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingAuditSearch_GetQuery,
    BookingAuditSearch_GetQueryVariables
  >(BookingAuditSearch_GetDocument, options);
}
export type BookingAuditSearch_GetQueryHookResult = ReturnType<
  typeof useBookingAuditSearch_GetQuery
>;
export type BookingAuditSearch_GetLazyQueryHookResult = ReturnType<
  typeof useBookingAuditSearch_GetLazyQuery
>;
export namespace BookingAuditSearch_Get {
  export type Return = BookingAuditSearch_GetQuery;
  export type Variables = BookingAuditSearch_GetQueryVariables;
  export const OperationName = "BookingAuditSearch_Get";

  export const Document = BookingAuditSearch_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingAuditSearch_SetApproveDocument = gql`
  mutation BookingAuditSearch_SetApprove($bookingId: ObjectId!, $approved: Boolean!) {
    updateBookingAudit(bookingId: $bookingId, approved: $approved)
  }
`;
export type BookingAuditSearch_SetApproveMutationFn = Apollo.MutationFunction<
  BookingAuditSearch_SetApproveMutation,
  BookingAuditSearch_SetApproveMutationVariables
>;
export type BookingAuditSearch_SetApproveComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingAuditSearch_SetApproveMutation,
    BookingAuditSearch_SetApproveMutationVariables
  >,
  "mutation"
>;

export const BookingAuditSearch_SetApproveComponent = (
  props: BookingAuditSearch_SetApproveComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingAuditSearch_SetApproveMutation,
    BookingAuditSearch_SetApproveMutationVariables
  >
    mutation={BookingAuditSearch_SetApproveDocument}
    {...props}
  />
);

/**
 * __useBookingAuditSearch_SetApproveMutation__
 *
 * To run a mutation, you first call `useBookingAuditSearch_SetApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingAuditSearch_SetApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingAuditSearchSetApproveMutation, { data, loading, error }] = useBookingAuditSearch_SetApproveMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useBookingAuditSearch_SetApproveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingAuditSearch_SetApproveMutation,
    BookingAuditSearch_SetApproveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingAuditSearch_SetApproveMutation,
    BookingAuditSearch_SetApproveMutationVariables
  >(BookingAuditSearch_SetApproveDocument, options);
}
export type BookingAuditSearch_SetApproveMutationHookResult = ReturnType<
  typeof useBookingAuditSearch_SetApproveMutation
>;
export namespace BookingAuditSearch_SetApprove {
  export type Return = BookingAuditSearch_SetApproveMutation;
  export type Variables = BookingAuditSearch_SetApproveMutationVariables;
  export const OperationName = "BookingAuditSearch_SetApprove";

  export const Document = BookingAuditSearch_SetApproveDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingAuditSearch_SetCommentDocument = gql`
  mutation BookingAuditSearch_SetComment($bookingId: ObjectId!, $comment: String!) {
    updateCommentForBookingAudit(bookingId: $bookingId, comment: $comment)
  }
`;
export type BookingAuditSearch_SetCommentMutationFn = Apollo.MutationFunction<
  BookingAuditSearch_SetCommentMutation,
  BookingAuditSearch_SetCommentMutationVariables
>;
export type BookingAuditSearch_SetCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingAuditSearch_SetCommentMutation,
    BookingAuditSearch_SetCommentMutationVariables
  >,
  "mutation"
>;

export const BookingAuditSearch_SetCommentComponent = (
  props: BookingAuditSearch_SetCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingAuditSearch_SetCommentMutation,
    BookingAuditSearch_SetCommentMutationVariables
  >
    mutation={BookingAuditSearch_SetCommentDocument}
    {...props}
  />
);

/**
 * __useBookingAuditSearch_SetCommentMutation__
 *
 * To run a mutation, you first call `useBookingAuditSearch_SetCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingAuditSearch_SetCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingAuditSearchSetCommentMutation, { data, loading, error }] = useBookingAuditSearch_SetCommentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useBookingAuditSearch_SetCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingAuditSearch_SetCommentMutation,
    BookingAuditSearch_SetCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingAuditSearch_SetCommentMutation,
    BookingAuditSearch_SetCommentMutationVariables
  >(BookingAuditSearch_SetCommentDocument, options);
}
export type BookingAuditSearch_SetCommentMutationHookResult = ReturnType<
  typeof useBookingAuditSearch_SetCommentMutation
>;
export namespace BookingAuditSearch_SetComment {
  export type Return = BookingAuditSearch_SetCommentMutation;
  export type Variables = BookingAuditSearch_SetCommentMutationVariables;
  export const OperationName = "BookingAuditSearch_SetComment";

  export const Document = BookingAuditSearch_SetCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingFinanceSearch_GetDocument = gql`
  query BookingFinanceSearch_Get(
    $filter: BookingWeekQueryInput!
    $skip: Int
    $limit: Int
  ) {
    bookingWeeks(filter: $filter, skip: $skip, limit: $limit) {
      items {
        ...BookingFinanceSearchItem
      }
      dbTime
      skip
      limit
    }
  }
  ${BookingFinanceSearchItemFragmentDoc}
`;
export type BookingFinanceSearch_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingFinanceSearch_GetQuery,
    BookingFinanceSearch_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingFinanceSearch_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingFinanceSearch_GetComponent = (
  props: BookingFinanceSearch_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingFinanceSearch_GetQuery,
    BookingFinanceSearch_GetQueryVariables
  >
    query={BookingFinanceSearch_GetDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceSearch_GetQuery__
 *
 * To run a query within a React component, call `useBookingFinanceSearch_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceSearch_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceSearch_GetQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBookingFinanceSearch_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingFinanceSearch_GetQuery,
    BookingFinanceSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingFinanceSearch_GetQuery,
    BookingFinanceSearch_GetQueryVariables
  >(BookingFinanceSearch_GetDocument, options);
}
export function useBookingFinanceSearch_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingFinanceSearch_GetQuery,
    BookingFinanceSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingFinanceSearch_GetQuery,
    BookingFinanceSearch_GetQueryVariables
  >(BookingFinanceSearch_GetDocument, options);
}
export type BookingFinanceSearch_GetQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_GetQuery
>;
export type BookingFinanceSearch_GetLazyQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_GetLazyQuery
>;
export namespace BookingFinanceSearch_Get {
  export type Return = BookingFinanceSearch_GetQuery;
  export type Variables = BookingFinanceSearch_GetQueryVariables;
  export const OperationName = "BookingFinanceSearch_Get";

  export const Document = BookingFinanceSearch_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingFinanceSearch_GetTotalDocument = gql`
  query BookingFinanceSearch_GetTotal($filter: BookingWeekQueryInput!) {
    bookingWeeksTotal(input: $filter) {
      dbTime
      total
    }
  }
`;
export type BookingFinanceSearch_GetTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingFinanceSearch_GetTotalQuery,
    BookingFinanceSearch_GetTotalQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingFinanceSearch_GetTotalQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingFinanceSearch_GetTotalComponent = (
  props: BookingFinanceSearch_GetTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingFinanceSearch_GetTotalQuery,
    BookingFinanceSearch_GetTotalQueryVariables
  >
    query={BookingFinanceSearch_GetTotalDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceSearch_GetTotalQuery__
 *
 * To run a query within a React component, call `useBookingFinanceSearch_GetTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceSearch_GetTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceSearch_GetTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookingFinanceSearch_GetTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingFinanceSearch_GetTotalQuery,
    BookingFinanceSearch_GetTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingFinanceSearch_GetTotalQuery,
    BookingFinanceSearch_GetTotalQueryVariables
  >(BookingFinanceSearch_GetTotalDocument, options);
}
export function useBookingFinanceSearch_GetTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingFinanceSearch_GetTotalQuery,
    BookingFinanceSearch_GetTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingFinanceSearch_GetTotalQuery,
    BookingFinanceSearch_GetTotalQueryVariables
  >(BookingFinanceSearch_GetTotalDocument, options);
}
export type BookingFinanceSearch_GetTotalQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_GetTotalQuery
>;
export type BookingFinanceSearch_GetTotalLazyQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_GetTotalLazyQuery
>;
export namespace BookingFinanceSearch_GetTotal {
  export type Return = BookingFinanceSearch_GetTotalQuery;
  export type Variables = BookingFinanceSearch_GetTotalQueryVariables;
  export const OperationName = "BookingFinanceSearch_GetTotal";

  export const Document = BookingFinanceSearch_GetTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingFinanceSearch_CSVDocument = gql`
  query BookingFinanceSearch_CSV(
    $filter: BookingWeekQueryInput!
    $type: BookingCSVReportType!
  ) {
    bookingWeeksCSV(filter: $filter, type: $type) {
      URL
      Filename
    }
  }
`;
export type BookingFinanceSearch_CSVComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingFinanceSearch_CSVQuery,
    BookingFinanceSearch_CSVQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingFinanceSearch_CSVQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingFinanceSearch_CSVComponent = (
  props: BookingFinanceSearch_CSVComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingFinanceSearch_CSVQuery,
    BookingFinanceSearch_CSVQueryVariables
  >
    query={BookingFinanceSearch_CSVDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceSearch_CSVQuery__
 *
 * To run a query within a React component, call `useBookingFinanceSearch_CSVQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceSearch_CSVQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceSearch_CSVQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBookingFinanceSearch_CSVQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingFinanceSearch_CSVQuery,
    BookingFinanceSearch_CSVQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingFinanceSearch_CSVQuery,
    BookingFinanceSearch_CSVQueryVariables
  >(BookingFinanceSearch_CSVDocument, options);
}
export function useBookingFinanceSearch_CSVLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingFinanceSearch_CSVQuery,
    BookingFinanceSearch_CSVQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingFinanceSearch_CSVQuery,
    BookingFinanceSearch_CSVQueryVariables
  >(BookingFinanceSearch_CSVDocument, options);
}
export type BookingFinanceSearch_CSVQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_CSVQuery
>;
export type BookingFinanceSearch_CSVLazyQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_CSVLazyQuery
>;
export namespace BookingFinanceSearch_CSV {
  export type Return = BookingFinanceSearch_CSVQuery;
  export type Variables = BookingFinanceSearch_CSVQueryVariables;
  export const OperationName = "BookingFinanceSearch_CSV";

  export const Document = BookingFinanceSearch_CSVDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingFinanceSearch_CSV_BgDocument = gql`
  query BookingFinanceSearch_CSV_bg(
    $filter: BookingWeekQueryInput!
    $type: BookingCSVReportType!
  ) {
    bookingWeeksCSVBackground(filter: $filter, type: $type) {
      result
    }
  }
`;
export type BookingFinanceSearch_CSV_BgComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingFinanceSearch_CSV_BgQuery,
    BookingFinanceSearch_CSV_BgQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingFinanceSearch_CSV_BgQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingFinanceSearch_CSV_BgComponent = (
  props: BookingFinanceSearch_CSV_BgComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingFinanceSearch_CSV_BgQuery,
    BookingFinanceSearch_CSV_BgQueryVariables
  >
    query={BookingFinanceSearch_CSV_BgDocument}
    {...props}
  />
);

/**
 * __useBookingFinanceSearch_CSV_BgQuery__
 *
 * To run a query within a React component, call `useBookingFinanceSearch_CSV_BgQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceSearch_CSV_BgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceSearch_CSV_BgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBookingFinanceSearch_CSV_BgQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingFinanceSearch_CSV_BgQuery,
    BookingFinanceSearch_CSV_BgQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingFinanceSearch_CSV_BgQuery,
    BookingFinanceSearch_CSV_BgQueryVariables
  >(BookingFinanceSearch_CSV_BgDocument, options);
}
export function useBookingFinanceSearch_CSV_BgLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingFinanceSearch_CSV_BgQuery,
    BookingFinanceSearch_CSV_BgQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingFinanceSearch_CSV_BgQuery,
    BookingFinanceSearch_CSV_BgQueryVariables
  >(BookingFinanceSearch_CSV_BgDocument, options);
}
export type BookingFinanceSearch_CSV_BgQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_CSV_BgQuery
>;
export type BookingFinanceSearch_CSV_BgLazyQueryHookResult = ReturnType<
  typeof useBookingFinanceSearch_CSV_BgLazyQuery
>;
export namespace BookingFinanceSearch_CSV_bg {
  export type Return = BookingFinanceSearch_CSV_BgQuery;
  export type Variables = BookingFinanceSearch_CSV_BgQueryVariables;
  export const OperationName = "BookingFinanceSearch_CSV_bg";

  export const Document = BookingFinanceSearch_CSV_BgDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingScheduleSearch_GetDocument = gql`
  query BookingScheduleSearch_Get(
    $filter: BookingWeekQueryInput!
    $skip: Int
    $limit: Int
  ) {
    bookingWeeks(filter: $filter, skip: $skip, limit: $limit) {
      items {
        ...BookingScheduleSearchItem
      }
      skip
      limit
    }
  }
  ${BookingScheduleSearchItemFragmentDoc}
`;
export type BookingScheduleSearch_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingScheduleSearch_GetQuery,
    BookingScheduleSearch_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingScheduleSearch_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingScheduleSearch_GetComponent = (
  props: BookingScheduleSearch_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingScheduleSearch_GetQuery,
    BookingScheduleSearch_GetQueryVariables
  >
    query={BookingScheduleSearch_GetDocument}
    {...props}
  />
);

/**
 * __useBookingScheduleSearch_GetQuery__
 *
 * To run a query within a React component, call `useBookingScheduleSearch_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingScheduleSearch_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingScheduleSearch_GetQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBookingScheduleSearch_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingScheduleSearch_GetQuery,
    BookingScheduleSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingScheduleSearch_GetQuery,
    BookingScheduleSearch_GetQueryVariables
  >(BookingScheduleSearch_GetDocument, options);
}
export function useBookingScheduleSearch_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingScheduleSearch_GetQuery,
    BookingScheduleSearch_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingScheduleSearch_GetQuery,
    BookingScheduleSearch_GetQueryVariables
  >(BookingScheduleSearch_GetDocument, options);
}
export type BookingScheduleSearch_GetQueryHookResult = ReturnType<
  typeof useBookingScheduleSearch_GetQuery
>;
export type BookingScheduleSearch_GetLazyQueryHookResult = ReturnType<
  typeof useBookingScheduleSearch_GetLazyQuery
>;
export namespace BookingScheduleSearch_Get {
  export type Return = BookingScheduleSearch_GetQuery;
  export type Variables = BookingScheduleSearch_GetQueryVariables;
  export const OperationName = "BookingScheduleSearch_Get";

  export const Document = BookingScheduleSearch_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingScheduleSearch_GetTotalDocument = gql`
  query BookingScheduleSearch_GetTotal($filter: BookingWeekQueryInput!) {
    bookingWeeksTotal(input: $filter) {
      dbTime
      total
    }
  }
`;
export type BookingScheduleSearch_GetTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingScheduleSearch_GetTotalQuery,
    BookingScheduleSearch_GetTotalQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingScheduleSearch_GetTotalQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingScheduleSearch_GetTotalComponent = (
  props: BookingScheduleSearch_GetTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingScheduleSearch_GetTotalQuery,
    BookingScheduleSearch_GetTotalQueryVariables
  >
    query={BookingScheduleSearch_GetTotalDocument}
    {...props}
  />
);

/**
 * __useBookingScheduleSearch_GetTotalQuery__
 *
 * To run a query within a React component, call `useBookingScheduleSearch_GetTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingScheduleSearch_GetTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingScheduleSearch_GetTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookingScheduleSearch_GetTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingScheduleSearch_GetTotalQuery,
    BookingScheduleSearch_GetTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingScheduleSearch_GetTotalQuery,
    BookingScheduleSearch_GetTotalQueryVariables
  >(BookingScheduleSearch_GetTotalDocument, options);
}
export function useBookingScheduleSearch_GetTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingScheduleSearch_GetTotalQuery,
    BookingScheduleSearch_GetTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingScheduleSearch_GetTotalQuery,
    BookingScheduleSearch_GetTotalQueryVariables
  >(BookingScheduleSearch_GetTotalDocument, options);
}
export type BookingScheduleSearch_GetTotalQueryHookResult = ReturnType<
  typeof useBookingScheduleSearch_GetTotalQuery
>;
export type BookingScheduleSearch_GetTotalLazyQueryHookResult = ReturnType<
  typeof useBookingScheduleSearch_GetTotalLazyQuery
>;
export namespace BookingScheduleSearch_GetTotal {
  export type Return = BookingScheduleSearch_GetTotalQuery;
  export type Variables = BookingScheduleSearch_GetTotalQueryVariables;
  export const OperationName = "BookingScheduleSearch_GetTotal";

  export const Document = BookingScheduleSearch_GetTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingSearch_CloneBookingDocument = gql`
  mutation BookingSearch_CloneBooking($bookingId: ObjectId!) {
    cloneBooking(bookingId: $bookingId)
  }
`;
export type BookingSearch_CloneBookingMutationFn = Apollo.MutationFunction<
  BookingSearch_CloneBookingMutation,
  BookingSearch_CloneBookingMutationVariables
>;
export type BookingSearch_CloneBookingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingSearch_CloneBookingMutation,
    BookingSearch_CloneBookingMutationVariables
  >,
  "mutation"
>;

export const BookingSearch_CloneBookingComponent = (
  props: BookingSearch_CloneBookingComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingSearch_CloneBookingMutation,
    BookingSearch_CloneBookingMutationVariables
  >
    mutation={BookingSearch_CloneBookingDocument}
    {...props}
  />
);

/**
 * __useBookingSearch_CloneBookingMutation__
 *
 * To run a mutation, you first call `useBookingSearch_CloneBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingSearch_CloneBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingSearchCloneBookingMutation, { data, loading, error }] = useBookingSearch_CloneBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingSearch_CloneBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingSearch_CloneBookingMutation,
    BookingSearch_CloneBookingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingSearch_CloneBookingMutation,
    BookingSearch_CloneBookingMutationVariables
  >(BookingSearch_CloneBookingDocument, options);
}
export type BookingSearch_CloneBookingMutationHookResult = ReturnType<
  typeof useBookingSearch_CloneBookingMutation
>;
export namespace BookingSearch_CloneBooking {
  export type Return = BookingSearch_CloneBookingMutation;
  export type Variables = BookingSearch_CloneBookingMutationVariables;
  export const OperationName = "BookingSearch_CloneBooking";

  export const Document = BookingSearch_CloneBookingDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingSyncReport_GetDocument = gql`
  query BookingSyncReport_Get($input: BookingWeekQueryInput!) {
    bookingSyncReport(input: $input) {
      ...BookingSyncReport
    }
  }
  ${BookingSyncReportFragmentDoc}
`;
export type BookingSyncReport_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingSyncReport_GetQuery,
    BookingSyncReport_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingSyncReport_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingSyncReport_GetComponent = (
  props: BookingSyncReport_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingSyncReport_GetQuery,
    BookingSyncReport_GetQueryVariables
  >
    query={BookingSyncReport_GetDocument}
    {...props}
  />
);

/**
 * __useBookingSyncReport_GetQuery__
 *
 * To run a query within a React component, call `useBookingSyncReport_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingSyncReport_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingSyncReport_GetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookingSyncReport_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingSyncReport_GetQuery,
    BookingSyncReport_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingSyncReport_GetQuery, BookingSyncReport_GetQueryVariables>(
    BookingSyncReport_GetDocument,
    options
  );
}
export function useBookingSyncReport_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingSyncReport_GetQuery,
    BookingSyncReport_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingSyncReport_GetQuery,
    BookingSyncReport_GetQueryVariables
  >(BookingSyncReport_GetDocument, options);
}
export type BookingSyncReport_GetQueryHookResult = ReturnType<
  typeof useBookingSyncReport_GetQuery
>;
export type BookingSyncReport_GetLazyQueryHookResult = ReturnType<
  typeof useBookingSyncReport_GetLazyQuery
>;
export namespace BookingSyncReport_Get {
  export type Return = BookingSyncReport_GetQuery;
  export type Variables = BookingSyncReport_GetQueryVariables;
  export const OperationName = "BookingSyncReport_Get";

  export const Document = BookingSyncReport_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateFortnoxVoucherDocument = gql`
  mutation createFortnoxVoucher(
    $provider: InvoiceProvider!
    $description: String!
    $date: String!
  ) {
    submitFortnoxVoucher(provider: $provider, description: $description, date: $date) {
      result
    }
  }
`;
export type CreateFortnoxVoucherMutationFn = Apollo.MutationFunction<
  CreateFortnoxVoucherMutation,
  CreateFortnoxVoucherMutationVariables
>;
export type CreateFortnoxVoucherComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateFortnoxVoucherMutation,
    CreateFortnoxVoucherMutationVariables
  >,
  "mutation"
>;

export const CreateFortnoxVoucherComponent = (
  props: CreateFortnoxVoucherComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateFortnoxVoucherMutation,
    CreateFortnoxVoucherMutationVariables
  >
    mutation={CreateFortnoxVoucherDocument}
    {...props}
  />
);

/**
 * __useCreateFortnoxVoucherMutation__
 *
 * To run a mutation, you first call `useCreateFortnoxVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFortnoxVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFortnoxVoucherMutation, { data, loading, error }] = useCreateFortnoxVoucherMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      description: // value for 'description'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCreateFortnoxVoucherMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFortnoxVoucherMutation,
    CreateFortnoxVoucherMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFortnoxVoucherMutation,
    CreateFortnoxVoucherMutationVariables
  >(CreateFortnoxVoucherDocument, options);
}
export type CreateFortnoxVoucherMutationHookResult = ReturnType<
  typeof useCreateFortnoxVoucherMutation
>;
export namespace CreateFortnoxVoucher {
  export type Return = CreateFortnoxVoucherMutation;
  export type Variables = CreateFortnoxVoucherMutationVariables;
  export const OperationName = "createFortnoxVoucher";

  export const Document = CreateFortnoxVoucherDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetSubcontractorInvoiceDocument = gql`
  query getSubcontractorInvoice($provider: InvoiceProvider!, $number: String!) {
    subcontractorInvoiceByNumber(provider: $provider, number: $number) {
      ...SubcontractorInvoice
    }
  }
  ${SubcontractorInvoiceFragmentDoc}
`;
export type GetSubcontractorInvoiceComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSubcontractorInvoiceQuery,
    GetSubcontractorInvoiceQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetSubcontractorInvoiceQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetSubcontractorInvoiceComponent = (
  props: GetSubcontractorInvoiceComponentProps
) => (
  <ApolloReactComponents.Query<
    GetSubcontractorInvoiceQuery,
    GetSubcontractorInvoiceQueryVariables
  >
    query={GetSubcontractorInvoiceDocument}
    {...props}
  />
);

/**
 * __useGetSubcontractorInvoiceQuery__
 *
 * To run a query within a React component, call `useGetSubcontractorInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubcontractorInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubcontractorInvoiceQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useGetSubcontractorInvoiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubcontractorInvoiceQuery,
    GetSubcontractorInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubcontractorInvoiceQuery,
    GetSubcontractorInvoiceQueryVariables
  >(GetSubcontractorInvoiceDocument, options);
}
export function useGetSubcontractorInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubcontractorInvoiceQuery,
    GetSubcontractorInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubcontractorInvoiceQuery,
    GetSubcontractorInvoiceQueryVariables
  >(GetSubcontractorInvoiceDocument, options);
}
export type GetSubcontractorInvoiceQueryHookResult = ReturnType<
  typeof useGetSubcontractorInvoiceQuery
>;
export type GetSubcontractorInvoiceLazyQueryHookResult = ReturnType<
  typeof useGetSubcontractorInvoiceLazyQuery
>;
export namespace GetSubcontractorInvoice {
  export type Return = GetSubcontractorInvoiceQuery;
  export type Variables = GetSubcontractorInvoiceQueryVariables;
  export const OperationName = "getSubcontractorInvoice";

  export const Document = GetSubcontractorInvoiceDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingWeekCardGetDocument = gql`
  query bookingWeekCardGet($bookingId: ObjectId!) {
    bookingById(id: $bookingId) {
      ...BookingWeekCard
    }
  }
  ${BookingWeekCardFragmentDoc}
`;
export type BookingWeekCardGetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingWeekCardGetQuery,
    BookingWeekCardGetQueryVariables
  >,
  "query"
> &
  ({ variables: BookingWeekCardGetQueryVariables; skip?: boolean } | { skip: boolean });

export const BookingWeekCardGetComponent = (props: BookingWeekCardGetComponentProps) => (
  <ApolloReactComponents.Query<BookingWeekCardGetQuery, BookingWeekCardGetQueryVariables>
    query={BookingWeekCardGetDocument}
    {...props}
  />
);

/**
 * __useBookingWeekCardGetQuery__
 *
 * To run a query within a React component, call `useBookingWeekCardGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingWeekCardGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingWeekCardGetQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingWeekCardGetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingWeekCardGetQuery,
    BookingWeekCardGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingWeekCardGetQuery, BookingWeekCardGetQueryVariables>(
    BookingWeekCardGetDocument,
    options
  );
}
export function useBookingWeekCardGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingWeekCardGetQuery,
    BookingWeekCardGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingWeekCardGetQuery, BookingWeekCardGetQueryVariables>(
    BookingWeekCardGetDocument,
    options
  );
}
export type BookingWeekCardGetQueryHookResult = ReturnType<
  typeof useBookingWeekCardGetQuery
>;
export type BookingWeekCardGetLazyQueryHookResult = ReturnType<
  typeof useBookingWeekCardGetLazyQuery
>;
export namespace BookingWeekCardGet {
  export type Return = BookingWeekCardGetQuery;
  export type Variables = BookingWeekCardGetQueryVariables;
  export const OperationName = "bookingWeekCardGet";

  export const Document = BookingWeekCardGetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantServicePreferencesForBookingDocument = gql`
  query getConsultantServicePreferencesForBooking($bookingId: ObjectId!) {
    consultantServicePreferencesForBooking(bookingId: $bookingId) {
      ...ConsultantServicePreference
    }
  }
  ${ConsultantServicePreferenceFragmentDoc}
`;
export type GetConsultantServicePreferencesForBookingComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantServicePreferencesForBookingQuery,
    GetConsultantServicePreferencesForBookingQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: GetConsultantServicePreferencesForBookingQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const GetConsultantServicePreferencesForBookingComponent = (
  props: GetConsultantServicePreferencesForBookingComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantServicePreferencesForBookingQuery,
    GetConsultantServicePreferencesForBookingQueryVariables
  >
    query={GetConsultantServicePreferencesForBookingDocument}
    {...props}
  />
);

/**
 * __useGetConsultantServicePreferencesForBookingQuery__
 *
 * To run a query within a React component, call `useGetConsultantServicePreferencesForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantServicePreferencesForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantServicePreferencesForBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetConsultantServicePreferencesForBookingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantServicePreferencesForBookingQuery,
    GetConsultantServicePreferencesForBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantServicePreferencesForBookingQuery,
    GetConsultantServicePreferencesForBookingQueryVariables
  >(GetConsultantServicePreferencesForBookingDocument, options);
}
export function useGetConsultantServicePreferencesForBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantServicePreferencesForBookingQuery,
    GetConsultantServicePreferencesForBookingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantServicePreferencesForBookingQuery,
    GetConsultantServicePreferencesForBookingQueryVariables
  >(GetConsultantServicePreferencesForBookingDocument, options);
}
export type GetConsultantServicePreferencesForBookingQueryHookResult = ReturnType<
  typeof useGetConsultantServicePreferencesForBookingQuery
>;
export type GetConsultantServicePreferencesForBookingLazyQueryHookResult = ReturnType<
  typeof useGetConsultantServicePreferencesForBookingLazyQuery
>;
export namespace GetConsultantServicePreferencesForBooking {
  export type Return = GetConsultantServicePreferencesForBookingQuery;
  export type Variables = GetConsultantServicePreferencesForBookingQueryVariables;
  export const OperationName = "getConsultantServicePreferencesForBooking";

  export const Document = GetConsultantServicePreferencesForBookingDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ResyncInvoiceDocument = gql`
  mutation resyncInvoice($provider: InvoiceProvider!, $number: String!) {
    resyncInvoice(provider: $provider, number: $number) {
      ...Invoice
    }
  }
  ${InvoiceFragmentDoc}
`;
export type ResyncInvoiceMutationFn = Apollo.MutationFunction<
  ResyncInvoiceMutation,
  ResyncInvoiceMutationVariables
>;
export type ResyncInvoiceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ResyncInvoiceMutation,
    ResyncInvoiceMutationVariables
  >,
  "mutation"
>;

export const ResyncInvoiceComponent = (props: ResyncInvoiceComponentProps) => (
  <ApolloReactComponents.Mutation<ResyncInvoiceMutation, ResyncInvoiceMutationVariables>
    mutation={ResyncInvoiceDocument}
    {...props}
  />
);

/**
 * __useResyncInvoiceMutation__
 *
 * To run a mutation, you first call `useResyncInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncInvoiceMutation, { data, loading, error }] = useResyncInvoiceMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useResyncInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResyncInvoiceMutation,
    ResyncInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResyncInvoiceMutation, ResyncInvoiceMutationVariables>(
    ResyncInvoiceDocument,
    options
  );
}
export type ResyncInvoiceMutationHookResult = ReturnType<typeof useResyncInvoiceMutation>;
export namespace ResyncInvoice {
  export type Return = ResyncInvoiceMutation;
  export type Variables = ResyncInvoiceMutationVariables;
  export const OperationName = "resyncInvoice";

  export const Document = ResyncInvoiceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetAttestContactPersonsDocument = gql`
  query getAttestContactPersons(
    $hospitalId: ObjectId!
    $departmentIds: [ObjectId!]!
    $areaOfExpertise: String!
  ) {
    attestContactPersons(
      hospitalId: $hospitalId
      departmentIds: $departmentIds
      areaOfExpertise: $areaOfExpertise
    ) {
      items {
        ...CustomerContactPerson
      }
      workplaceAllowsDigitalTimereport
    }
  }
  ${CustomerContactPersonFragmentDoc}
`;
export type GetAttestContactPersonsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAttestContactPersonsQuery,
    GetAttestContactPersonsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetAttestContactPersonsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetAttestContactPersonsComponent = (
  props: GetAttestContactPersonsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAttestContactPersonsQuery,
    GetAttestContactPersonsQueryVariables
  >
    query={GetAttestContactPersonsDocument}
    {...props}
  />
);

/**
 * __useGetAttestContactPersonsQuery__
 *
 * To run a query within a React component, call `useGetAttestContactPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttestContactPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttestContactPersonsQuery({
 *   variables: {
 *      hospitalId: // value for 'hospitalId'
 *      departmentIds: // value for 'departmentIds'
 *      areaOfExpertise: // value for 'areaOfExpertise'
 *   },
 * });
 */
export function useGetAttestContactPersonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAttestContactPersonsQuery,
    GetAttestContactPersonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAttestContactPersonsQuery,
    GetAttestContactPersonsQueryVariables
  >(GetAttestContactPersonsDocument, options);
}
export function useGetAttestContactPersonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAttestContactPersonsQuery,
    GetAttestContactPersonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAttestContactPersonsQuery,
    GetAttestContactPersonsQueryVariables
  >(GetAttestContactPersonsDocument, options);
}
export type GetAttestContactPersonsQueryHookResult = ReturnType<
  typeof useGetAttestContactPersonsQuery
>;
export type GetAttestContactPersonsLazyQueryHookResult = ReturnType<
  typeof useGetAttestContactPersonsLazyQuery
>;
export namespace GetAttestContactPersons {
  export type Return = GetAttestContactPersonsQuery;
  export type Variables = GetAttestContactPersonsQueryVariables;
  export const OperationName = "getAttestContactPersons";

  export const Document = GetAttestContactPersonsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingCustomerNumber_GetDocument = gql`
  query BookingCustomerNumber_Get(
    $areaOfExpertise: String!
    $hospitalId: ObjectId!
    $departmentIds: [ObjectId!]!
  ) {
    customerNumberByAOE(
      areaOfExpertise: $areaOfExpertise
      hospitalId: $hospitalId
      departmentIds: $departmentIds
    )
  }
`;
export type BookingCustomerNumber_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingCustomerNumber_GetQuery,
    BookingCustomerNumber_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingCustomerNumber_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingCustomerNumber_GetComponent = (
  props: BookingCustomerNumber_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingCustomerNumber_GetQuery,
    BookingCustomerNumber_GetQueryVariables
  >
    query={BookingCustomerNumber_GetDocument}
    {...props}
  />
);

/**
 * __useBookingCustomerNumber_GetQuery__
 *
 * To run a query within a React component, call `useBookingCustomerNumber_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCustomerNumber_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCustomerNumber_GetQuery({
 *   variables: {
 *      areaOfExpertise: // value for 'areaOfExpertise'
 *      hospitalId: // value for 'hospitalId'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useBookingCustomerNumber_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingCustomerNumber_GetQuery,
    BookingCustomerNumber_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingCustomerNumber_GetQuery,
    BookingCustomerNumber_GetQueryVariables
  >(BookingCustomerNumber_GetDocument, options);
}
export function useBookingCustomerNumber_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingCustomerNumber_GetQuery,
    BookingCustomerNumber_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingCustomerNumber_GetQuery,
    BookingCustomerNumber_GetQueryVariables
  >(BookingCustomerNumber_GetDocument, options);
}
export type BookingCustomerNumber_GetQueryHookResult = ReturnType<
  typeof useBookingCustomerNumber_GetQuery
>;
export type BookingCustomerNumber_GetLazyQueryHookResult = ReturnType<
  typeof useBookingCustomerNumber_GetLazyQuery
>;
export namespace BookingCustomerNumber_Get {
  export type Return = BookingCustomerNumber_GetQuery;
  export type Variables = BookingCustomerNumber_GetQueryVariables;
  export const OperationName = "BookingCustomerNumber_Get";

  export const Document = BookingCustomerNumber_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BulkActionDocument = gql`
  mutation bulkAction($input: BulkActionInput!) {
    bulkAction(input: $input) {
      actionId
      status
      error
    }
  }
`;
export type BulkActionMutationFn = Apollo.MutationFunction<
  BulkActionMutation,
  BulkActionMutationVariables
>;
export type BulkActionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BulkActionMutation,
    BulkActionMutationVariables
  >,
  "mutation"
>;

export const BulkActionComponent = (props: BulkActionComponentProps) => (
  <ApolloReactComponents.Mutation<BulkActionMutation, BulkActionMutationVariables>
    mutation={BulkActionDocument}
    {...props}
  />
);

/**
 * __useBulkActionMutation__
 *
 * To run a mutation, you first call `useBulkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkActionMutation, { data, loading, error }] = useBulkActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkActionMutation,
    BulkActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkActionMutation, BulkActionMutationVariables>(
    BulkActionDocument,
    options
  );
}
export type BulkActionMutationHookResult = ReturnType<typeof useBulkActionMutation>;
export namespace BulkAction {
  export type Return = BulkActionMutation;
  export type Variables = BulkActionMutationVariables;
  export const OperationName = "bulkAction";

  export const Document = BulkActionDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantExportBulkActionDocument = gql`
  mutation consultantExportBulkAction($filter: ConsultantsQueryInput!) {
    consultantExportBulkAction(filter: $filter) {
      actionId
      status
      error
    }
  }
`;
export type ConsultantExportBulkActionMutationFn = Apollo.MutationFunction<
  ConsultantExportBulkActionMutation,
  ConsultantExportBulkActionMutationVariables
>;
export type ConsultantExportBulkActionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantExportBulkActionMutation,
    ConsultantExportBulkActionMutationVariables
  >,
  "mutation"
>;

export const ConsultantExportBulkActionComponent = (
  props: ConsultantExportBulkActionComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantExportBulkActionMutation,
    ConsultantExportBulkActionMutationVariables
  >
    mutation={ConsultantExportBulkActionDocument}
    {...props}
  />
);

/**
 * __useConsultantExportBulkActionMutation__
 *
 * To run a mutation, you first call `useConsultantExportBulkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantExportBulkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantExportBulkActionMutation, { data, loading, error }] = useConsultantExportBulkActionMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConsultantExportBulkActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantExportBulkActionMutation,
    ConsultantExportBulkActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantExportBulkActionMutation,
    ConsultantExportBulkActionMutationVariables
  >(ConsultantExportBulkActionDocument, options);
}
export type ConsultantExportBulkActionMutationHookResult = ReturnType<
  typeof useConsultantExportBulkActionMutation
>;
export namespace ConsultantExportBulkAction {
  export type Return = ConsultantExportBulkActionMutation;
  export type Variables = ConsultantExportBulkActionMutationVariables;
  export const OperationName = "consultantExportBulkAction";

  export const Document = ConsultantExportBulkActionDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantExportSsnBulkActionDocument = gql`
  mutation consultantExportSsnBulkAction($filter: ConsultantsQueryInput!) {
    consultantExportSsnBulkAction(filter: $filter) {
      actionId
      status
      error
    }
  }
`;
export type ConsultantExportSsnBulkActionMutationFn = Apollo.MutationFunction<
  ConsultantExportSsnBulkActionMutation,
  ConsultantExportSsnBulkActionMutationVariables
>;
export type ConsultantExportSsnBulkActionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantExportSsnBulkActionMutation,
    ConsultantExportSsnBulkActionMutationVariables
  >,
  "mutation"
>;

export const ConsultantExportSsnBulkActionComponent = (
  props: ConsultantExportSsnBulkActionComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantExportSsnBulkActionMutation,
    ConsultantExportSsnBulkActionMutationVariables
  >
    mutation={ConsultantExportSsnBulkActionDocument}
    {...props}
  />
);

/**
 * __useConsultantExportSsnBulkActionMutation__
 *
 * To run a mutation, you first call `useConsultantExportSsnBulkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantExportSsnBulkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantExportSsnBulkActionMutation, { data, loading, error }] = useConsultantExportSsnBulkActionMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConsultantExportSsnBulkActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantExportSsnBulkActionMutation,
    ConsultantExportSsnBulkActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantExportSsnBulkActionMutation,
    ConsultantExportSsnBulkActionMutationVariables
  >(ConsultantExportSsnBulkActionDocument, options);
}
export type ConsultantExportSsnBulkActionMutationHookResult = ReturnType<
  typeof useConsultantExportSsnBulkActionMutation
>;
export namespace ConsultantExportSsnBulkAction {
  export type Return = ConsultantExportSsnBulkActionMutation;
  export type Variables = ConsultantExportSsnBulkActionMutationVariables;
  export const OperationName = "consultantExportSsnBulkAction";

  export const Document = ConsultantExportSsnBulkActionDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BulkSmsTextMaxLengthDocument = gql`
  query bulkSmsTextMaxLength($subType: String) {
    bulkSmsTextMaxLength(subType: $subType)
  }
`;
export type BulkSmsTextMaxLengthComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BulkSmsTextMaxLengthQuery,
    BulkSmsTextMaxLengthQueryVariables
  >,
  "query"
>;

export const BulkSmsTextMaxLengthComponent = (
  props: BulkSmsTextMaxLengthComponentProps
) => (
  <ApolloReactComponents.Query<
    BulkSmsTextMaxLengthQuery,
    BulkSmsTextMaxLengthQueryVariables
  >
    query={BulkSmsTextMaxLengthDocument}
    {...props}
  />
);

/**
 * __useBulkSmsTextMaxLengthQuery__
 *
 * To run a query within a React component, call `useBulkSmsTextMaxLengthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkSmsTextMaxLengthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkSmsTextMaxLengthQuery({
 *   variables: {
 *      subType: // value for 'subType'
 *   },
 * });
 */
export function useBulkSmsTextMaxLengthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BulkSmsTextMaxLengthQuery,
    BulkSmsTextMaxLengthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BulkSmsTextMaxLengthQuery, BulkSmsTextMaxLengthQueryVariables>(
    BulkSmsTextMaxLengthDocument,
    options
  );
}
export function useBulkSmsTextMaxLengthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BulkSmsTextMaxLengthQuery,
    BulkSmsTextMaxLengthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BulkSmsTextMaxLengthQuery,
    BulkSmsTextMaxLengthQueryVariables
  >(BulkSmsTextMaxLengthDocument, options);
}
export type BulkSmsTextMaxLengthQueryHookResult = ReturnType<
  typeof useBulkSmsTextMaxLengthQuery
>;
export type BulkSmsTextMaxLengthLazyQueryHookResult = ReturnType<
  typeof useBulkSmsTextMaxLengthLazyQuery
>;
export namespace BulkSmsTextMaxLength {
  export type Return = BulkSmsTextMaxLengthQuery;
  export type Variables = BulkSmsTextMaxLengthQueryVariables;
  export const OperationName = "bulkSmsTextMaxLength";

  export const Document = BulkSmsTextMaxLengthDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContractsPriceTemplatesDocument = gql`
  query contractsPriceTemplates(
    $filter: ContractPriceTemplateFilter
    $skip: Int
    $limit: Int
    $onlyPrivate: Boolean!
  ) {
    list: contractsPriceTemplates(
      filter: $filter
      skip: $skip
      limit: $limit
      onlyPrivate: $onlyPrivate
    ) {
      skip
      limit
      items {
        ...contractsPriceTemplate
      }
      total
    }
  }
  ${ContractsPriceTemplateFragmentDoc}
`;
export type ContractsPriceTemplatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ContractsPriceTemplatesQuery,
    ContractsPriceTemplatesQueryVariables
  >,
  "query"
> &
  (
    | { variables: ContractsPriceTemplatesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ContractsPriceTemplatesComponent = (
  props: ContractsPriceTemplatesComponentProps
) => (
  <ApolloReactComponents.Query<
    ContractsPriceTemplatesQuery,
    ContractsPriceTemplatesQueryVariables
  >
    query={ContractsPriceTemplatesDocument}
    {...props}
  />
);

/**
 * __useContractsPriceTemplatesQuery__
 *
 * To run a query within a React component, call `useContractsPriceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsPriceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsPriceTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      onlyPrivate: // value for 'onlyPrivate'
 *   },
 * });
 */
export function useContractsPriceTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContractsPriceTemplatesQuery,
    ContractsPriceTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContractsPriceTemplatesQuery,
    ContractsPriceTemplatesQueryVariables
  >(ContractsPriceTemplatesDocument, options);
}
export function useContractsPriceTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractsPriceTemplatesQuery,
    ContractsPriceTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContractsPriceTemplatesQuery,
    ContractsPriceTemplatesQueryVariables
  >(ContractsPriceTemplatesDocument, options);
}
export type ContractsPriceTemplatesQueryHookResult = ReturnType<
  typeof useContractsPriceTemplatesQuery
>;
export type ContractsPriceTemplatesLazyQueryHookResult = ReturnType<
  typeof useContractsPriceTemplatesLazyQuery
>;
export namespace ContractsPriceTemplates {
  export type Return = ContractsPriceTemplatesQuery;
  export type Variables = ContractsPriceTemplatesQueryVariables;
  export const OperationName = "contractsPriceTemplates";

  export const Document = ContractsPriceTemplatesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContractsPriceTemplateByIdDocument = gql`
  query contractsPriceTemplateById($id: ObjectId, $skip: Boolean!) {
    getHighHolidays {
      ...HighHolidayOption
    }
    contractsPriceTemplateById(contractsPriceTemplateId: $id) @skip(if: $skip) {
      ...contractsPriceTemplate
    }
  }
  ${HighHolidayOptionFragmentDoc}
  ${ContractsPriceTemplateFragmentDoc}
`;
export type ContractsPriceTemplateByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ContractsPriceTemplateByIdQuery,
    ContractsPriceTemplateByIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: ContractsPriceTemplateByIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ContractsPriceTemplateByIdComponent = (
  props: ContractsPriceTemplateByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    ContractsPriceTemplateByIdQuery,
    ContractsPriceTemplateByIdQueryVariables
  >
    query={ContractsPriceTemplateByIdDocument}
    {...props}
  />
);

/**
 * __useContractsPriceTemplateByIdQuery__
 *
 * To run a query within a React component, call `useContractsPriceTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsPriceTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsPriceTemplateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useContractsPriceTemplateByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContractsPriceTemplateByIdQuery,
    ContractsPriceTemplateByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContractsPriceTemplateByIdQuery,
    ContractsPriceTemplateByIdQueryVariables
  >(ContractsPriceTemplateByIdDocument, options);
}
export function useContractsPriceTemplateByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractsPriceTemplateByIdQuery,
    ContractsPriceTemplateByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContractsPriceTemplateByIdQuery,
    ContractsPriceTemplateByIdQueryVariables
  >(ContractsPriceTemplateByIdDocument, options);
}
export type ContractsPriceTemplateByIdQueryHookResult = ReturnType<
  typeof useContractsPriceTemplateByIdQuery
>;
export type ContractsPriceTemplateByIdLazyQueryHookResult = ReturnType<
  typeof useContractsPriceTemplateByIdLazyQuery
>;
export namespace ContractsPriceTemplateById {
  export type Return = ContractsPriceTemplateByIdQuery;
  export type Variables = ContractsPriceTemplateByIdQueryVariables;
  export const OperationName = "contractsPriceTemplateById";

  export const Document = ContractsPriceTemplateByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SubmitContractsPriceTemplateDocument = gql`
  mutation submitContractsPriceTemplate(
    $id: ObjectId
    $data: ContractPriceTemplateInput!
  ) {
    submitContractPriceTemplateForm(data: $data, contractPriceTemplateId: $id) {
      value {
        ...contractsPriceTemplate
      }
      errors
    }
  }
  ${ContractsPriceTemplateFragmentDoc}
`;
export type SubmitContractsPriceTemplateMutationFn = Apollo.MutationFunction<
  SubmitContractsPriceTemplateMutation,
  SubmitContractsPriceTemplateMutationVariables
>;
export type SubmitContractsPriceTemplateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitContractsPriceTemplateMutation,
    SubmitContractsPriceTemplateMutationVariables
  >,
  "mutation"
>;

export const SubmitContractsPriceTemplateComponent = (
  props: SubmitContractsPriceTemplateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitContractsPriceTemplateMutation,
    SubmitContractsPriceTemplateMutationVariables
  >
    mutation={SubmitContractsPriceTemplateDocument}
    {...props}
  />
);

/**
 * __useSubmitContractsPriceTemplateMutation__
 *
 * To run a mutation, you first call `useSubmitContractsPriceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContractsPriceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitContractsPriceTemplateMutation, { data, loading, error }] = useSubmitContractsPriceTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitContractsPriceTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitContractsPriceTemplateMutation,
    SubmitContractsPriceTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitContractsPriceTemplateMutation,
    SubmitContractsPriceTemplateMutationVariables
  >(SubmitContractsPriceTemplateDocument, options);
}
export type SubmitContractsPriceTemplateMutationHookResult = ReturnType<
  typeof useSubmitContractsPriceTemplateMutation
>;
export namespace SubmitContractsPriceTemplate {
  export type Return = SubmitContractsPriceTemplateMutation;
  export type Variables = SubmitContractsPriceTemplateMutationVariables;
  export const OperationName = "submitContractsPriceTemplate";

  export const Document = SubmitContractsPriceTemplateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DuplicateContractsPriceTemplateDocument = gql`
  mutation duplicateContractsPriceTemplate($data: ContractPriceTemplateInput!) {
    duplicateContractPriceTemplate(data: $data) {
      value {
        ...contractsPriceTemplate
      }
      errors
    }
  }
  ${ContractsPriceTemplateFragmentDoc}
`;
export type DuplicateContractsPriceTemplateMutationFn = Apollo.MutationFunction<
  DuplicateContractsPriceTemplateMutation,
  DuplicateContractsPriceTemplateMutationVariables
>;
export type DuplicateContractsPriceTemplateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DuplicateContractsPriceTemplateMutation,
    DuplicateContractsPriceTemplateMutationVariables
  >,
  "mutation"
>;

export const DuplicateContractsPriceTemplateComponent = (
  props: DuplicateContractsPriceTemplateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DuplicateContractsPriceTemplateMutation,
    DuplicateContractsPriceTemplateMutationVariables
  >
    mutation={DuplicateContractsPriceTemplateDocument}
    {...props}
  />
);

/**
 * __useDuplicateContractsPriceTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateContractsPriceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateContractsPriceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateContractsPriceTemplateMutation, { data, loading, error }] = useDuplicateContractsPriceTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDuplicateContractsPriceTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateContractsPriceTemplateMutation,
    DuplicateContractsPriceTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateContractsPriceTemplateMutation,
    DuplicateContractsPriceTemplateMutationVariables
  >(DuplicateContractsPriceTemplateDocument, options);
}
export type DuplicateContractsPriceTemplateMutationHookResult = ReturnType<
  typeof useDuplicateContractsPriceTemplateMutation
>;
export namespace DuplicateContractsPriceTemplate {
  export type Return = DuplicateContractsPriceTemplateMutation;
  export type Variables = DuplicateContractsPriceTemplateMutationVariables;
  export const OperationName = "duplicateContractsPriceTemplate";

  export const Document = DuplicateContractsPriceTemplateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteContractsPriceTemplateDocument = gql`
  mutation deleteContractsPriceTemplate($id: ObjectId!) {
    deleteContractPriceTemplate(id: $id) {
      value {
        ...contractsPriceTemplate
      }
      errors
    }
  }
  ${ContractsPriceTemplateFragmentDoc}
`;
export type DeleteContractsPriceTemplateMutationFn = Apollo.MutationFunction<
  DeleteContractsPriceTemplateMutation,
  DeleteContractsPriceTemplateMutationVariables
>;
export type DeleteContractsPriceTemplateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteContractsPriceTemplateMutation,
    DeleteContractsPriceTemplateMutationVariables
  >,
  "mutation"
>;

export const DeleteContractsPriceTemplateComponent = (
  props: DeleteContractsPriceTemplateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteContractsPriceTemplateMutation,
    DeleteContractsPriceTemplateMutationVariables
  >
    mutation={DeleteContractsPriceTemplateDocument}
    {...props}
  />
);

/**
 * __useDeleteContractsPriceTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteContractsPriceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractsPriceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractsPriceTemplateMutation, { data, loading, error }] = useDeleteContractsPriceTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractsPriceTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContractsPriceTemplateMutation,
    DeleteContractsPriceTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteContractsPriceTemplateMutation,
    DeleteContractsPriceTemplateMutationVariables
  >(DeleteContractsPriceTemplateDocument, options);
}
export type DeleteContractsPriceTemplateMutationHookResult = ReturnType<
  typeof useDeleteContractsPriceTemplateMutation
>;
export namespace DeleteContractsPriceTemplate {
  export type Return = DeleteContractsPriceTemplateMutation;
  export type Variables = DeleteContractsPriceTemplateMutationVariables;
  export const OperationName = "deleteContractsPriceTemplate";

  export const Document = DeleteContractsPriceTemplateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CostCenterConfigItemsDocument = gql`
  query costCenterConfigItems($filter: CostCenterConfigFilterInput) {
    costCenterConfigItems(filter: $filter) {
      ...costCenterConfigItem
    }
  }
  ${CostCenterConfigItemFragmentDoc}
`;
export type CostCenterConfigItemsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CostCenterConfigItemsQuery,
    CostCenterConfigItemsQueryVariables
  >,
  "query"
>;

export const CostCenterConfigItemsComponent = (
  props: CostCenterConfigItemsComponentProps
) => (
  <ApolloReactComponents.Query<
    CostCenterConfigItemsQuery,
    CostCenterConfigItemsQueryVariables
  >
    query={CostCenterConfigItemsDocument}
    {...props}
  />
);

/**
 * __useCostCenterConfigItemsQuery__
 *
 * To run a query within a React component, call `useCostCenterConfigItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCenterConfigItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCenterConfigItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCostCenterConfigItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CostCenterConfigItemsQuery,
    CostCenterConfigItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CostCenterConfigItemsQuery, CostCenterConfigItemsQueryVariables>(
    CostCenterConfigItemsDocument,
    options
  );
}
export function useCostCenterConfigItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CostCenterConfigItemsQuery,
    CostCenterConfigItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CostCenterConfigItemsQuery,
    CostCenterConfigItemsQueryVariables
  >(CostCenterConfigItemsDocument, options);
}
export type CostCenterConfigItemsQueryHookResult = ReturnType<
  typeof useCostCenterConfigItemsQuery
>;
export type CostCenterConfigItemsLazyQueryHookResult = ReturnType<
  typeof useCostCenterConfigItemsLazyQuery
>;
export namespace CostCenterConfigItems {
  export type Return = CostCenterConfigItemsQuery;
  export type Variables = CostCenterConfigItemsQueryVariables;
  export const OperationName = "costCenterConfigItems";

  export const Document = CostCenterConfigItemsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateCostCenterDocument = gql`
  mutation createCostCenter($input: CreateCostCenterInput!) {
    createCostCenter(input: $input) {
      ...costCenterConfigItem
    }
  }
  ${CostCenterConfigItemFragmentDoc}
`;
export type CreateCostCenterMutationFn = Apollo.MutationFunction<
  CreateCostCenterMutation,
  CreateCostCenterMutationVariables
>;
export type CreateCostCenterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCostCenterMutation,
    CreateCostCenterMutationVariables
  >,
  "mutation"
>;

export const CreateCostCenterComponent = (props: CreateCostCenterComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateCostCenterMutation,
    CreateCostCenterMutationVariables
  >
    mutation={CreateCostCenterDocument}
    {...props}
  />
);

/**
 * __useCreateCostCenterMutation__
 *
 * To run a mutation, you first call `useCreateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCostCenterMutation, { data, loading, error }] = useCreateCostCenterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCostCenterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCostCenterMutation,
    CreateCostCenterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCostCenterMutation, CreateCostCenterMutationVariables>(
    CreateCostCenterDocument,
    options
  );
}
export type CreateCostCenterMutationHookResult = ReturnType<
  typeof useCreateCostCenterMutation
>;
export namespace CreateCostCenter {
  export type Return = CreateCostCenterMutation;
  export type Variables = CreateCostCenterMutationVariables;
  export const OperationName = "createCostCenter";

  export const Document = CreateCostCenterDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateCostCenterDocument = gql`
  mutation updateCostCenter($id: ObjectId!, $input: UpdateCostCenterInput!) {
    updateCostCenter(id: $id, input: $input) {
      ...costCenterConfigItem
    }
  }
  ${CostCenterConfigItemFragmentDoc}
`;
export type UpdateCostCenterMutationFn = Apollo.MutationFunction<
  UpdateCostCenterMutation,
  UpdateCostCenterMutationVariables
>;
export type UpdateCostCenterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCostCenterMutation,
    UpdateCostCenterMutationVariables
  >,
  "mutation"
>;

export const UpdateCostCenterComponent = (props: UpdateCostCenterComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateCostCenterMutation,
    UpdateCostCenterMutationVariables
  >
    mutation={UpdateCostCenterDocument}
    {...props}
  />
);

/**
 * __useUpdateCostCenterMutation__
 *
 * To run a mutation, you first call `useUpdateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostCenterMutation, { data, loading, error }] = useUpdateCostCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCostCenterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCostCenterMutation,
    UpdateCostCenterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCostCenterMutation, UpdateCostCenterMutationVariables>(
    UpdateCostCenterDocument,
    options
  );
}
export type UpdateCostCenterMutationHookResult = ReturnType<
  typeof useUpdateCostCenterMutation
>;
export namespace UpdateCostCenter {
  export type Return = UpdateCostCenterMutation;
  export type Variables = UpdateCostCenterMutationVariables;
  export const OperationName = "updateCostCenter";

  export const Document = UpdateCostCenterDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteCostCenterDocument = gql`
  mutation deleteCostCenter($id: ObjectId!) {
    deleteCostCenter(id: $id) {
      ...costCenterConfigItem
    }
  }
  ${CostCenterConfigItemFragmentDoc}
`;
export type DeleteCostCenterMutationFn = Apollo.MutationFunction<
  DeleteCostCenterMutation,
  DeleteCostCenterMutationVariables
>;
export type DeleteCostCenterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteCostCenterMutation,
    DeleteCostCenterMutationVariables
  >,
  "mutation"
>;

export const DeleteCostCenterComponent = (props: DeleteCostCenterComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteCostCenterMutation,
    DeleteCostCenterMutationVariables
  >
    mutation={DeleteCostCenterDocument}
    {...props}
  />
);

/**
 * __useDeleteCostCenterMutation__
 *
 * To run a mutation, you first call `useDeleteCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCostCenterMutation, { data, loading, error }] = useDeleteCostCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCostCenterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCostCenterMutation,
    DeleteCostCenterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCostCenterMutation, DeleteCostCenterMutationVariables>(
    DeleteCostCenterDocument,
    options
  );
}
export type DeleteCostCenterMutationHookResult = ReturnType<
  typeof useDeleteCostCenterMutation
>;
export namespace DeleteCostCenter {
  export type Return = DeleteCostCenterMutation;
  export type Variables = DeleteCostCenterMutationVariables;
  export const OperationName = "deleteCostCenter";

  export const Document = DeleteCostCenterDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RestoreCostCenterDocument = gql`
  mutation restoreCostCenter($id: ObjectId!) {
    restoreCostCenter(id: $id) {
      ...costCenterConfigItem
    }
  }
  ${CostCenterConfigItemFragmentDoc}
`;
export type RestoreCostCenterMutationFn = Apollo.MutationFunction<
  RestoreCostCenterMutation,
  RestoreCostCenterMutationVariables
>;
export type RestoreCostCenterComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RestoreCostCenterMutation,
    RestoreCostCenterMutationVariables
  >,
  "mutation"
>;

export const RestoreCostCenterComponent = (props: RestoreCostCenterComponentProps) => (
  <ApolloReactComponents.Mutation<
    RestoreCostCenterMutation,
    RestoreCostCenterMutationVariables
  >
    mutation={RestoreCostCenterDocument}
    {...props}
  />
);

/**
 * __useRestoreCostCenterMutation__
 *
 * To run a mutation, you first call `useRestoreCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCostCenterMutation, { data, loading, error }] = useRestoreCostCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCostCenterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreCostCenterMutation,
    RestoreCostCenterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreCostCenterMutation,
    RestoreCostCenterMutationVariables
  >(RestoreCostCenterDocument, options);
}
export type RestoreCostCenterMutationHookResult = ReturnType<
  typeof useRestoreCostCenterMutation
>;
export namespace RestoreCostCenter {
  export type Return = RestoreCostCenterMutation;
  export type Variables = RestoreCostCenterMutationVariables;
  export const OperationName = "restoreCostCenter";

  export const Document = RestoreCostCenterDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ToggleCostCenterActiveDocument = gql`
  mutation toggleCostCenterActive($id: ObjectId!) {
    toggleCostCenterActive(id: $id) {
      ...costCenterConfigItem
    }
  }
  ${CostCenterConfigItemFragmentDoc}
`;
export type ToggleCostCenterActiveMutationFn = Apollo.MutationFunction<
  ToggleCostCenterActiveMutation,
  ToggleCostCenterActiveMutationVariables
>;
export type ToggleCostCenterActiveComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ToggleCostCenterActiveMutation,
    ToggleCostCenterActiveMutationVariables
  >,
  "mutation"
>;

export const ToggleCostCenterActiveComponent = (
  props: ToggleCostCenterActiveComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ToggleCostCenterActiveMutation,
    ToggleCostCenterActiveMutationVariables
  >
    mutation={ToggleCostCenterActiveDocument}
    {...props}
  />
);

/**
 * __useToggleCostCenterActiveMutation__
 *
 * To run a mutation, you first call `useToggleCostCenterActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCostCenterActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCostCenterActiveMutation, { data, loading, error }] = useToggleCostCenterActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCostCenterActiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleCostCenterActiveMutation,
    ToggleCostCenterActiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleCostCenterActiveMutation,
    ToggleCostCenterActiveMutationVariables
  >(ToggleCostCenterActiveDocument, options);
}
export type ToggleCostCenterActiveMutationHookResult = ReturnType<
  typeof useToggleCostCenterActiveMutation
>;
export namespace ToggleCostCenterActive {
  export type Return = ToggleCostCenterActiveMutation;
  export type Variables = ToggleCostCenterActiveMutationVariables;
  export const OperationName = "toggleCostCenterActive";

  export const Document = ToggleCostCenterActiveDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TgRequirementsDocument = gql`
  query tgRequirements($filter: TgRequirementFilterInput) {
    tgRequirements(filter: $filter) {
      ...tgRequirement
    }
  }
  ${TgRequirementFragmentDoc}
`;
export type TgRequirementsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TgRequirementsQuery,
    TgRequirementsQueryVariables
  >,
  "query"
>;

export const TgRequirementsComponent = (props: TgRequirementsComponentProps) => (
  <ApolloReactComponents.Query<TgRequirementsQuery, TgRequirementsQueryVariables>
    query={TgRequirementsDocument}
    {...props}
  />
);

/**
 * __useTgRequirementsQuery__
 *
 * To run a query within a React component, call `useTgRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTgRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTgRequirementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTgRequirementsQuery(
  baseOptions?: Apollo.QueryHookOptions<TgRequirementsQuery, TgRequirementsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TgRequirementsQuery, TgRequirementsQueryVariables>(
    TgRequirementsDocument,
    options
  );
}
export function useTgRequirementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TgRequirementsQuery,
    TgRequirementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TgRequirementsQuery, TgRequirementsQueryVariables>(
    TgRequirementsDocument,
    options
  );
}
export type TgRequirementsQueryHookResult = ReturnType<typeof useTgRequirementsQuery>;
export type TgRequirementsLazyQueryHookResult = ReturnType<
  typeof useTgRequirementsLazyQuery
>;
export namespace TgRequirements {
  export type Return = TgRequirementsQuery;
  export type Variables = TgRequirementsQueryVariables;
  export const OperationName = "tgRequirements";

  export const Document = TgRequirementsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateTgRequirementDocument = gql`
  mutation createTgRequirement($input: CreateTgRequirementInput!) {
    createTgRequirement(input: $input) {
      ...tgRequirement
    }
  }
  ${TgRequirementFragmentDoc}
`;
export type CreateTgRequirementMutationFn = Apollo.MutationFunction<
  CreateTgRequirementMutation,
  CreateTgRequirementMutationVariables
>;
export type CreateTgRequirementComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateTgRequirementMutation,
    CreateTgRequirementMutationVariables
  >,
  "mutation"
>;

export const CreateTgRequirementComponent = (
  props: CreateTgRequirementComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateTgRequirementMutation,
    CreateTgRequirementMutationVariables
  >
    mutation={CreateTgRequirementDocument}
    {...props}
  />
);

/**
 * __useCreateTgRequirementMutation__
 *
 * To run a mutation, you first call `useCreateTgRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTgRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTgRequirementMutation, { data, loading, error }] = useCreateTgRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTgRequirementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTgRequirementMutation,
    CreateTgRequirementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTgRequirementMutation,
    CreateTgRequirementMutationVariables
  >(CreateTgRequirementDocument, options);
}
export type CreateTgRequirementMutationHookResult = ReturnType<
  typeof useCreateTgRequirementMutation
>;
export namespace CreateTgRequirement {
  export type Return = CreateTgRequirementMutation;
  export type Variables = CreateTgRequirementMutationVariables;
  export const OperationName = "createTgRequirement";

  export const Document = CreateTgRequirementDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateTgRequirementDocument = gql`
  mutation updateTgRequirement($id: ObjectId!, $input: UpdateTgRequirementInput!) {
    updateTgRequirement(id: $id, input: $input) {
      ...tgRequirement
    }
  }
  ${TgRequirementFragmentDoc}
`;
export type UpdateTgRequirementMutationFn = Apollo.MutationFunction<
  UpdateTgRequirementMutation,
  UpdateTgRequirementMutationVariables
>;
export type UpdateTgRequirementComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateTgRequirementMutation,
    UpdateTgRequirementMutationVariables
  >,
  "mutation"
>;

export const UpdateTgRequirementComponent = (
  props: UpdateTgRequirementComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateTgRequirementMutation,
    UpdateTgRequirementMutationVariables
  >
    mutation={UpdateTgRequirementDocument}
    {...props}
  />
);

/**
 * __useUpdateTgRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateTgRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTgRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTgRequirementMutation, { data, loading, error }] = useUpdateTgRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTgRequirementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTgRequirementMutation,
    UpdateTgRequirementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTgRequirementMutation,
    UpdateTgRequirementMutationVariables
  >(UpdateTgRequirementDocument, options);
}
export type UpdateTgRequirementMutationHookResult = ReturnType<
  typeof useUpdateTgRequirementMutation
>;
export namespace UpdateTgRequirement {
  export type Return = UpdateTgRequirementMutation;
  export type Variables = UpdateTgRequirementMutationVariables;
  export const OperationName = "updateTgRequirement";

  export const Document = UpdateTgRequirementDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteTgRequirementDocument = gql`
  mutation deleteTgRequirement($id: ObjectId!) {
    deleteTgRequirement(id: $id)
  }
`;
export type DeleteTgRequirementMutationFn = Apollo.MutationFunction<
  DeleteTgRequirementMutation,
  DeleteTgRequirementMutationVariables
>;
export type DeleteTgRequirementComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteTgRequirementMutation,
    DeleteTgRequirementMutationVariables
  >,
  "mutation"
>;

export const DeleteTgRequirementComponent = (
  props: DeleteTgRequirementComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteTgRequirementMutation,
    DeleteTgRequirementMutationVariables
  >
    mutation={DeleteTgRequirementDocument}
    {...props}
  />
);

/**
 * __useDeleteTgRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteTgRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTgRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTgRequirementMutation, { data, loading, error }] = useDeleteTgRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTgRequirementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTgRequirementMutation,
    DeleteTgRequirementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTgRequirementMutation,
    DeleteTgRequirementMutationVariables
  >(DeleteTgRequirementDocument, options);
}
export type DeleteTgRequirementMutationHookResult = ReturnType<
  typeof useDeleteTgRequirementMutation
>;
export namespace DeleteTgRequirement {
  export type Return = DeleteTgRequirementMutation;
  export type Variables = DeleteTgRequirementMutationVariables;
  export const OperationName = "deleteTgRequirement";

  export const Document = DeleteTgRequirementDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ProfessionsByCountryDocument = gql`
  query professionsByCountry {
    professionsByCountry {
      country
      professions
    }
  }
`;
export type ProfessionsByCountryComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ProfessionsByCountryQuery,
    ProfessionsByCountryQueryVariables
  >,
  "query"
>;

export const ProfessionsByCountryComponent = (
  props: ProfessionsByCountryComponentProps
) => (
  <ApolloReactComponents.Query<
    ProfessionsByCountryQuery,
    ProfessionsByCountryQueryVariables
  >
    query={ProfessionsByCountryDocument}
    {...props}
  />
);

/**
 * __useProfessionsByCountryQuery__
 *
 * To run a query within a React component, call `useProfessionsByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfessionsByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfessionsByCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfessionsByCountryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProfessionsByCountryQuery,
    ProfessionsByCountryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProfessionsByCountryQuery, ProfessionsByCountryQueryVariables>(
    ProfessionsByCountryDocument,
    options
  );
}
export function useProfessionsByCountryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfessionsByCountryQuery,
    ProfessionsByCountryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProfessionsByCountryQuery,
    ProfessionsByCountryQueryVariables
  >(ProfessionsByCountryDocument, options);
}
export type ProfessionsByCountryQueryHookResult = ReturnType<
  typeof useProfessionsByCountryQuery
>;
export type ProfessionsByCountryLazyQueryHookResult = ReturnType<
  typeof useProfessionsByCountryLazyQuery
>;
export namespace ProfessionsByCountry {
  export type Return = ProfessionsByCountryQuery;
  export type Variables = ProfessionsByCountryQueryVariables;
  export const OperationName = "professionsByCountry";

  export const Document = ProfessionsByCountryDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantAreaOfExpertisesDocument = gql`
  query getConsultantAreaOfExpertises($id: ObjectId!) {
    consultantById(id: $id) {
      _id
      AreasOfExpertise
    }
  }
`;
export type GetConsultantAreaOfExpertisesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantAreaOfExpertisesQuery,
    GetConsultantAreaOfExpertisesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantAreaOfExpertisesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantAreaOfExpertisesComponent = (
  props: GetConsultantAreaOfExpertisesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantAreaOfExpertisesQuery,
    GetConsultantAreaOfExpertisesQueryVariables
  >
    query={GetConsultantAreaOfExpertisesDocument}
    {...props}
  />
);

/**
 * __useGetConsultantAreaOfExpertisesQuery__
 *
 * To run a query within a React component, call `useGetConsultantAreaOfExpertisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantAreaOfExpertisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantAreaOfExpertisesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantAreaOfExpertisesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantAreaOfExpertisesQuery,
    GetConsultantAreaOfExpertisesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantAreaOfExpertisesQuery,
    GetConsultantAreaOfExpertisesQueryVariables
  >(GetConsultantAreaOfExpertisesDocument, options);
}
export function useGetConsultantAreaOfExpertisesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantAreaOfExpertisesQuery,
    GetConsultantAreaOfExpertisesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantAreaOfExpertisesQuery,
    GetConsultantAreaOfExpertisesQueryVariables
  >(GetConsultantAreaOfExpertisesDocument, options);
}
export type GetConsultantAreaOfExpertisesQueryHookResult = ReturnType<
  typeof useGetConsultantAreaOfExpertisesQuery
>;
export type GetConsultantAreaOfExpertisesLazyQueryHookResult = ReturnType<
  typeof useGetConsultantAreaOfExpertisesLazyQuery
>;
export namespace GetConsultantAreaOfExpertises {
  export type Return = GetConsultantAreaOfExpertisesQuery;
  export type Variables = GetConsultantAreaOfExpertisesQueryVariables;
  export const OperationName = "getConsultantAreaOfExpertises";

  export const Document = GetConsultantAreaOfExpertisesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantOpportunityCreateDocument = gql`
  query getConsultantOpportunityCreate($id: ObjectId!) {
    consultantOpportunityById(id: $id) {
      consultant {
        _id
      }
      customer {
        __typename
        ...CustomerSearchData
      }
      areaOfExpertise
      costCenter {
        Id
        Name
      }
      dueDate
      description
      weeks
      dueDate
    }
  }
  ${CustomerSearchDataFragmentDoc}
`;
export type GetConsultantOpportunityCreateComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantOpportunityCreateQuery,
    GetConsultantOpportunityCreateQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantOpportunityCreateQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantOpportunityCreateComponent = (
  props: GetConsultantOpportunityCreateComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantOpportunityCreateQuery,
    GetConsultantOpportunityCreateQueryVariables
  >
    query={GetConsultantOpportunityCreateDocument}
    {...props}
  />
);

/**
 * __useGetConsultantOpportunityCreateQuery__
 *
 * To run a query within a React component, call `useGetConsultantOpportunityCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantOpportunityCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantOpportunityCreateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantOpportunityCreateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantOpportunityCreateQuery,
    GetConsultantOpportunityCreateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantOpportunityCreateQuery,
    GetConsultantOpportunityCreateQueryVariables
  >(GetConsultantOpportunityCreateDocument, options);
}
export function useGetConsultantOpportunityCreateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantOpportunityCreateQuery,
    GetConsultantOpportunityCreateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantOpportunityCreateQuery,
    GetConsultantOpportunityCreateQueryVariables
  >(GetConsultantOpportunityCreateDocument, options);
}
export type GetConsultantOpportunityCreateQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityCreateQuery
>;
export type GetConsultantOpportunityCreateLazyQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityCreateLazyQuery
>;
export namespace GetConsultantOpportunityCreate {
  export type Return = GetConsultantOpportunityCreateQuery;
  export type Variables = GetConsultantOpportunityCreateQueryVariables;
  export const OperationName = "getConsultantOpportunityCreate";

  export const Document = GetConsultantOpportunityCreateDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateConsultantOpportunityDocument = gql`
  mutation createConsultantOpportunity($input: CreateConsultantOpportunityInput!) {
    createConsultantOpportunity(input: $input) {
      _id
    }
  }
`;
export type CreateConsultantOpportunityMutationFn = Apollo.MutationFunction<
  CreateConsultantOpportunityMutation,
  CreateConsultantOpportunityMutationVariables
>;
export type CreateConsultantOpportunityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateConsultantOpportunityMutation,
    CreateConsultantOpportunityMutationVariables
  >,
  "mutation"
>;

export const CreateConsultantOpportunityComponent = (
  props: CreateConsultantOpportunityComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateConsultantOpportunityMutation,
    CreateConsultantOpportunityMutationVariables
  >
    mutation={CreateConsultantOpportunityDocument}
    {...props}
  />
);

/**
 * __useCreateConsultantOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateConsultantOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsultantOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsultantOpportunityMutation, { data, loading, error }] = useCreateConsultantOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsultantOpportunityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsultantOpportunityMutation,
    CreateConsultantOpportunityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsultantOpportunityMutation,
    CreateConsultantOpportunityMutationVariables
  >(CreateConsultantOpportunityDocument, options);
}
export type CreateConsultantOpportunityMutationHookResult = ReturnType<
  typeof useCreateConsultantOpportunityMutation
>;
export namespace CreateConsultantOpportunity {
  export type Return = CreateConsultantOpportunityMutation;
  export type Variables = CreateConsultantOpportunityMutationVariables;
  export const OperationName = "createConsultantOpportunity";

  export const Document = CreateConsultantOpportunityDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const EditConsultantOpportunityDocument = gql`
  mutation editConsultantOpportunity(
    $issueId: ObjectId!
    $input: EditConsultantOpportunityInput!
  ) {
    editConsultantOpportunity(issueId: $issueId, input: $input)
  }
`;
export type EditConsultantOpportunityMutationFn = Apollo.MutationFunction<
  EditConsultantOpportunityMutation,
  EditConsultantOpportunityMutationVariables
>;
export type EditConsultantOpportunityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    EditConsultantOpportunityMutation,
    EditConsultantOpportunityMutationVariables
  >,
  "mutation"
>;

export const EditConsultantOpportunityComponent = (
  props: EditConsultantOpportunityComponentProps
) => (
  <ApolloReactComponents.Mutation<
    EditConsultantOpportunityMutation,
    EditConsultantOpportunityMutationVariables
  >
    mutation={EditConsultantOpportunityDocument}
    {...props}
  />
);

/**
 * __useEditConsultantOpportunityMutation__
 *
 * To run a mutation, you first call `useEditConsultantOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditConsultantOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editConsultantOpportunityMutation, { data, loading, error }] = useEditConsultantOpportunityMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditConsultantOpportunityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditConsultantOpportunityMutation,
    EditConsultantOpportunityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditConsultantOpportunityMutation,
    EditConsultantOpportunityMutationVariables
  >(EditConsultantOpportunityDocument, options);
}
export type EditConsultantOpportunityMutationHookResult = ReturnType<
  typeof useEditConsultantOpportunityMutation
>;
export namespace EditConsultantOpportunity {
  export type Return = EditConsultantOpportunityMutation;
  export type Variables = EditConsultantOpportunityMutationVariables;
  export const OperationName = "editConsultantOpportunity";

  export const Document = EditConsultantOpportunityDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantOpportunityFinalizeDocument = gql`
  query getConsultantOpportunityFinalize($opportunityId: ObjectId!) {
    consultantOpportunityById(id: $opportunityId) {
      _id
      ...FinaliseOpportunityData
    }
  }
  ${FinaliseOpportunityDataFragmentDoc}
`;
export type GetConsultantOpportunityFinalizeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantOpportunityFinalizeQuery,
    GetConsultantOpportunityFinalizeQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantOpportunityFinalizeQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantOpportunityFinalizeComponent = (
  props: GetConsultantOpportunityFinalizeComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantOpportunityFinalizeQuery,
    GetConsultantOpportunityFinalizeQueryVariables
  >
    query={GetConsultantOpportunityFinalizeDocument}
    {...props}
  />
);

/**
 * __useGetConsultantOpportunityFinalizeQuery__
 *
 * To run a query within a React component, call `useGetConsultantOpportunityFinalizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantOpportunityFinalizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantOpportunityFinalizeQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useGetConsultantOpportunityFinalizeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantOpportunityFinalizeQuery,
    GetConsultantOpportunityFinalizeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantOpportunityFinalizeQuery,
    GetConsultantOpportunityFinalizeQueryVariables
  >(GetConsultantOpportunityFinalizeDocument, options);
}
export function useGetConsultantOpportunityFinalizeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantOpportunityFinalizeQuery,
    GetConsultantOpportunityFinalizeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantOpportunityFinalizeQuery,
    GetConsultantOpportunityFinalizeQueryVariables
  >(GetConsultantOpportunityFinalizeDocument, options);
}
export type GetConsultantOpportunityFinalizeQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityFinalizeQuery
>;
export type GetConsultantOpportunityFinalizeLazyQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityFinalizeLazyQuery
>;
export namespace GetConsultantOpportunityFinalize {
  export type Return = GetConsultantOpportunityFinalizeQuery;
  export type Variables = GetConsultantOpportunityFinalizeQueryVariables;
  export const OperationName = "getConsultantOpportunityFinalize";

  export const Document = GetConsultantOpportunityFinalizeDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetOpportunityIssueWeeksDocument = gql`
  query getOpportunityIssueWeeks($issueId: ObjectId!) {
    consultantOpportunityIssueWeeks(issueId: $issueId) {
      wonWeeks
      lostWeeks
      openWeeks
    }
  }
`;
export type GetOpportunityIssueWeeksComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetOpportunityIssueWeeksQuery,
    GetOpportunityIssueWeeksQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetOpportunityIssueWeeksQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetOpportunityIssueWeeksComponent = (
  props: GetOpportunityIssueWeeksComponentProps
) => (
  <ApolloReactComponents.Query<
    GetOpportunityIssueWeeksQuery,
    GetOpportunityIssueWeeksQueryVariables
  >
    query={GetOpportunityIssueWeeksDocument}
    {...props}
  />
);

/**
 * __useGetOpportunityIssueWeeksQuery__
 *
 * To run a query within a React component, call `useGetOpportunityIssueWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityIssueWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityIssueWeeksQuery({
 *   variables: {
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useGetOpportunityIssueWeeksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOpportunityIssueWeeksQuery,
    GetOpportunityIssueWeeksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOpportunityIssueWeeksQuery,
    GetOpportunityIssueWeeksQueryVariables
  >(GetOpportunityIssueWeeksDocument, options);
}
export function useGetOpportunityIssueWeeksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOpportunityIssueWeeksQuery,
    GetOpportunityIssueWeeksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOpportunityIssueWeeksQuery,
    GetOpportunityIssueWeeksQueryVariables
  >(GetOpportunityIssueWeeksDocument, options);
}
export type GetOpportunityIssueWeeksQueryHookResult = ReturnType<
  typeof useGetOpportunityIssueWeeksQuery
>;
export type GetOpportunityIssueWeeksLazyQueryHookResult = ReturnType<
  typeof useGetOpportunityIssueWeeksLazyQuery
>;
export namespace GetOpportunityIssueWeeks {
  export type Return = GetOpportunityIssueWeeksQuery;
  export type Variables = GetOpportunityIssueWeeksQueryVariables;
  export const OperationName = "getOpportunityIssueWeeks";

  export const Document = GetOpportunityIssueWeeksDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const FinaliseOpportunityDocument = gql`
  mutation finaliseOpportunity($issueId: ObjectId!, $weeksWon: [Date!]!) {
    finaliseConsultantOpportunity(issueId: $issueId, weeksWon: $weeksWon) {
      won {
        _id
      }
      lost {
        _id
      }
    }
  }
`;
export type FinaliseOpportunityMutationFn = Apollo.MutationFunction<
  FinaliseOpportunityMutation,
  FinaliseOpportunityMutationVariables
>;
export type FinaliseOpportunityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    FinaliseOpportunityMutation,
    FinaliseOpportunityMutationVariables
  >,
  "mutation"
>;

export const FinaliseOpportunityComponent = (
  props: FinaliseOpportunityComponentProps
) => (
  <ApolloReactComponents.Mutation<
    FinaliseOpportunityMutation,
    FinaliseOpportunityMutationVariables
  >
    mutation={FinaliseOpportunityDocument}
    {...props}
  />
);

/**
 * __useFinaliseOpportunityMutation__
 *
 * To run a mutation, you first call `useFinaliseOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinaliseOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finaliseOpportunityMutation, { data, loading, error }] = useFinaliseOpportunityMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      weeksWon: // value for 'weeksWon'
 *   },
 * });
 */
export function useFinaliseOpportunityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinaliseOpportunityMutation,
    FinaliseOpportunityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FinaliseOpportunityMutation,
    FinaliseOpportunityMutationVariables
  >(FinaliseOpportunityDocument, options);
}
export type FinaliseOpportunityMutationHookResult = ReturnType<
  typeof useFinaliseOpportunityMutation
>;
export namespace FinaliseOpportunity {
  export type Return = FinaliseOpportunityMutation;
  export type Variables = FinaliseOpportunityMutationVariables;
  export const OperationName = "finaliseOpportunity";

  export const Document = FinaliseOpportunityDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantOpportunityBoardDocument = gql`
  query getConsultantOpportunityBoard($ownerId: String!) {
    kanbanBoard(type: ConsultantOpportunity, id: $ownerId) {
      _id
      ...DefaultKanbanBoard
    }
  }
  ${DefaultKanbanBoardFragmentDoc}
`;
export type GetConsultantOpportunityBoardComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantOpportunityBoardQuery,
    GetConsultantOpportunityBoardQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantOpportunityBoardQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantOpportunityBoardComponent = (
  props: GetConsultantOpportunityBoardComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantOpportunityBoardQuery,
    GetConsultantOpportunityBoardQueryVariables
  >
    query={GetConsultantOpportunityBoardDocument}
    {...props}
  />
);

/**
 * __useGetConsultantOpportunityBoardQuery__
 *
 * To run a query within a React component, call `useGetConsultantOpportunityBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantOpportunityBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantOpportunityBoardQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useGetConsultantOpportunityBoardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantOpportunityBoardQuery,
    GetConsultantOpportunityBoardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantOpportunityBoardQuery,
    GetConsultantOpportunityBoardQueryVariables
  >(GetConsultantOpportunityBoardDocument, options);
}
export function useGetConsultantOpportunityBoardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantOpportunityBoardQuery,
    GetConsultantOpportunityBoardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantOpportunityBoardQuery,
    GetConsultantOpportunityBoardQueryVariables
  >(GetConsultantOpportunityBoardDocument, options);
}
export type GetConsultantOpportunityBoardQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityBoardQuery
>;
export type GetConsultantOpportunityBoardLazyQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityBoardLazyQuery
>;
export namespace GetConsultantOpportunityBoard {
  export type Return = GetConsultantOpportunityBoardQuery;
  export type Variables = GetConsultantOpportunityBoardQueryVariables;
  export const OperationName = "getConsultantOpportunityBoard";

  export const Document = GetConsultantOpportunityBoardDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantOpportunityCardsDocument = gql`
  query getConsultantOpportunityCards($boardId: String!) {
    kanbanCards(type: ConsultantOpportunity, boardId: $boardId) {
      _id
      ...ConsultantOpportunityCard
    }
  }
  ${ConsultantOpportunityCardFragmentDoc}
`;
export type GetConsultantOpportunityCardsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantOpportunityCardsQuery,
    GetConsultantOpportunityCardsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantOpportunityCardsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantOpportunityCardsComponent = (
  props: GetConsultantOpportunityCardsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantOpportunityCardsQuery,
    GetConsultantOpportunityCardsQueryVariables
  >
    query={GetConsultantOpportunityCardsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantOpportunityCardsQuery__
 *
 * To run a query within a React component, call `useGetConsultantOpportunityCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantOpportunityCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantOpportunityCardsQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useGetConsultantOpportunityCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantOpportunityCardsQuery,
    GetConsultantOpportunityCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantOpportunityCardsQuery,
    GetConsultantOpportunityCardsQueryVariables
  >(GetConsultantOpportunityCardsDocument, options);
}
export function useGetConsultantOpportunityCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantOpportunityCardsQuery,
    GetConsultantOpportunityCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantOpportunityCardsQuery,
    GetConsultantOpportunityCardsQueryVariables
  >(GetConsultantOpportunityCardsDocument, options);
}
export type GetConsultantOpportunityCardsQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityCardsQuery
>;
export type GetConsultantOpportunityCardsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityCardsLazyQuery
>;
export namespace GetConsultantOpportunityCards {
  export type Return = GetConsultantOpportunityCardsQuery;
  export type Variables = GetConsultantOpportunityCardsQueryVariables;
  export const OperationName = "getConsultantOpportunityCards";

  export const Document = GetConsultantOpportunityCardsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const DeleteConsultantOpportunityCardDocument = gql`
  mutation deleteConsultantOpportunityCard($issueId: ObjectId!) {
    deleteConsultantOpportunity(issueId: $issueId)
  }
`;
export type DeleteConsultantOpportunityCardMutationFn = Apollo.MutationFunction<
  DeleteConsultantOpportunityCardMutation,
  DeleteConsultantOpportunityCardMutationVariables
>;
export type DeleteConsultantOpportunityCardComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteConsultantOpportunityCardMutation,
    DeleteConsultantOpportunityCardMutationVariables
  >,
  "mutation"
>;

export const DeleteConsultantOpportunityCardComponent = (
  props: DeleteConsultantOpportunityCardComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteConsultantOpportunityCardMutation,
    DeleteConsultantOpportunityCardMutationVariables
  >
    mutation={DeleteConsultantOpportunityCardDocument}
    {...props}
  />
);

/**
 * __useDeleteConsultantOpportunityCardMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantOpportunityCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantOpportunityCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantOpportunityCardMutation, { data, loading, error }] = useDeleteConsultantOpportunityCardMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useDeleteConsultantOpportunityCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsultantOpportunityCardMutation,
    DeleteConsultantOpportunityCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsultantOpportunityCardMutation,
    DeleteConsultantOpportunityCardMutationVariables
  >(DeleteConsultantOpportunityCardDocument, options);
}
export type DeleteConsultantOpportunityCardMutationHookResult = ReturnType<
  typeof useDeleteConsultantOpportunityCardMutation
>;
export namespace DeleteConsultantOpportunityCard {
  export type Return = DeleteConsultantOpportunityCardMutation;
  export type Variables = DeleteConsultantOpportunityCardMutationVariables;
  export const OperationName = "deleteConsultantOpportunityCard";

  export const Document = DeleteConsultantOpportunityCardDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantOpportunityStatsByUserDocument = gql`
  query getConsultantOpportunityStatsByUser(
    $userId: ObjectId!
    $start: Date!
    $end: Date!
  ) {
    consultantOpportunityStatsByUser(userId: $userId, start: $start, end: $end) {
      ...ConsultantOpportunityStatsData
    }
  }
  ${ConsultantOpportunityStatsDataFragmentDoc}
`;
export type GetConsultantOpportunityStatsByUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantOpportunityStatsByUserQuery,
    GetConsultantOpportunityStatsByUserQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantOpportunityStatsByUserQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantOpportunityStatsByUserComponent = (
  props: GetConsultantOpportunityStatsByUserComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantOpportunityStatsByUserQuery,
    GetConsultantOpportunityStatsByUserQueryVariables
  >
    query={GetConsultantOpportunityStatsByUserDocument}
    {...props}
  />
);

/**
 * __useGetConsultantOpportunityStatsByUserQuery__
 *
 * To run a query within a React component, call `useGetConsultantOpportunityStatsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantOpportunityStatsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantOpportunityStatsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetConsultantOpportunityStatsByUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantOpportunityStatsByUserQuery,
    GetConsultantOpportunityStatsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantOpportunityStatsByUserQuery,
    GetConsultantOpportunityStatsByUserQueryVariables
  >(GetConsultantOpportunityStatsByUserDocument, options);
}
export function useGetConsultantOpportunityStatsByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantOpportunityStatsByUserQuery,
    GetConsultantOpportunityStatsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantOpportunityStatsByUserQuery,
    GetConsultantOpportunityStatsByUserQueryVariables
  >(GetConsultantOpportunityStatsByUserDocument, options);
}
export type GetConsultantOpportunityStatsByUserQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityStatsByUserQuery
>;
export type GetConsultantOpportunityStatsByUserLazyQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityStatsByUserLazyQuery
>;
export namespace GetConsultantOpportunityStatsByUser {
  export type Return = GetConsultantOpportunityStatsByUserQuery;
  export type Variables = GetConsultantOpportunityStatsByUserQueryVariables;
  export const OperationName = "getConsultantOpportunityStatsByUser";

  export const Document = GetConsultantOpportunityStatsByUserDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantOpportunityStatsByTeamDocument = gql`
  query getConsultantOpportunityStatsByTeam($team: String!, $start: Date!, $end: Date!) {
    consultantOpportunityStatsByTeam(team: $team, start: $start, end: $end) {
      ...ConsultantOpportunityStatsData
    }
  }
  ${ConsultantOpportunityStatsDataFragmentDoc}
`;
export type GetConsultantOpportunityStatsByTeamComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantOpportunityStatsByTeamQuery,
    GetConsultantOpportunityStatsByTeamQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantOpportunityStatsByTeamQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantOpportunityStatsByTeamComponent = (
  props: GetConsultantOpportunityStatsByTeamComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantOpportunityStatsByTeamQuery,
    GetConsultantOpportunityStatsByTeamQueryVariables
  >
    query={GetConsultantOpportunityStatsByTeamDocument}
    {...props}
  />
);

/**
 * __useGetConsultantOpportunityStatsByTeamQuery__
 *
 * To run a query within a React component, call `useGetConsultantOpportunityStatsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantOpportunityStatsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantOpportunityStatsByTeamQuery({
 *   variables: {
 *      team: // value for 'team'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetConsultantOpportunityStatsByTeamQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantOpportunityStatsByTeamQuery,
    GetConsultantOpportunityStatsByTeamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantOpportunityStatsByTeamQuery,
    GetConsultantOpportunityStatsByTeamQueryVariables
  >(GetConsultantOpportunityStatsByTeamDocument, options);
}
export function useGetConsultantOpportunityStatsByTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantOpportunityStatsByTeamQuery,
    GetConsultantOpportunityStatsByTeamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantOpportunityStatsByTeamQuery,
    GetConsultantOpportunityStatsByTeamQueryVariables
  >(GetConsultantOpportunityStatsByTeamDocument, options);
}
export type GetConsultantOpportunityStatsByTeamQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityStatsByTeamQuery
>;
export type GetConsultantOpportunityStatsByTeamLazyQueryHookResult = ReturnType<
  typeof useGetConsultantOpportunityStatsByTeamLazyQuery
>;
export namespace GetConsultantOpportunityStatsByTeam {
  export type Return = GetConsultantOpportunityStatsByTeamQuery;
  export type Variables = GetConsultantOpportunityStatsByTeamQueryVariables;
  export const OperationName = "getConsultantOpportunityStatsByTeam";

  export const Document = GetConsultantOpportunityStatsByTeamDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantPipelineBoardDocument = gql`
  query getConsultantPipelineBoard($ownerId: String!) {
    kanbanBoard(type: ConsultantPipeline, id: $ownerId) {
      _id
      ...DefaultKanbanBoard
    }
  }
  ${DefaultKanbanBoardFragmentDoc}
`;
export type GetConsultantPipelineBoardComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantPipelineBoardQuery,
    GetConsultantPipelineBoardQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantPipelineBoardQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantPipelineBoardComponent = (
  props: GetConsultantPipelineBoardComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantPipelineBoardQuery,
    GetConsultantPipelineBoardQueryVariables
  >
    query={GetConsultantPipelineBoardDocument}
    {...props}
  />
);

/**
 * __useGetConsultantPipelineBoardQuery__
 *
 * To run a query within a React component, call `useGetConsultantPipelineBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantPipelineBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantPipelineBoardQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useGetConsultantPipelineBoardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantPipelineBoardQuery,
    GetConsultantPipelineBoardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantPipelineBoardQuery,
    GetConsultantPipelineBoardQueryVariables
  >(GetConsultantPipelineBoardDocument, options);
}
export function useGetConsultantPipelineBoardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantPipelineBoardQuery,
    GetConsultantPipelineBoardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantPipelineBoardQuery,
    GetConsultantPipelineBoardQueryVariables
  >(GetConsultantPipelineBoardDocument, options);
}
export type GetConsultantPipelineBoardQueryHookResult = ReturnType<
  typeof useGetConsultantPipelineBoardQuery
>;
export type GetConsultantPipelineBoardLazyQueryHookResult = ReturnType<
  typeof useGetConsultantPipelineBoardLazyQuery
>;
export namespace GetConsultantPipelineBoard {
  export type Return = GetConsultantPipelineBoardQuery;
  export type Variables = GetConsultantPipelineBoardQueryVariables;
  export const OperationName = "getConsultantPipelineBoard";

  export const Document = GetConsultantPipelineBoardDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantPipelineCardsDocument = gql`
  query getConsultantPipelineCards($boardId: String!) {
    kanbanCards(type: ConsultantPipeline, boardId: $boardId) {
      _id
      ...ConsultantPipelineCard
    }
  }
  ${ConsultantPipelineCardFragmentDoc}
`;
export type GetConsultantPipelineCardsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantPipelineCardsQuery,
    GetConsultantPipelineCardsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantPipelineCardsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantPipelineCardsComponent = (
  props: GetConsultantPipelineCardsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantPipelineCardsQuery,
    GetConsultantPipelineCardsQueryVariables
  >
    query={GetConsultantPipelineCardsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantPipelineCardsQuery__
 *
 * To run a query within a React component, call `useGetConsultantPipelineCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantPipelineCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantPipelineCardsQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useGetConsultantPipelineCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantPipelineCardsQuery,
    GetConsultantPipelineCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantPipelineCardsQuery,
    GetConsultantPipelineCardsQueryVariables
  >(GetConsultantPipelineCardsDocument, options);
}
export function useGetConsultantPipelineCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantPipelineCardsQuery,
    GetConsultantPipelineCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantPipelineCardsQuery,
    GetConsultantPipelineCardsQueryVariables
  >(GetConsultantPipelineCardsDocument, options);
}
export type GetConsultantPipelineCardsQueryHookResult = ReturnType<
  typeof useGetConsultantPipelineCardsQuery
>;
export type GetConsultantPipelineCardsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantPipelineCardsLazyQuery
>;
export namespace GetConsultantPipelineCards {
  export type Return = GetConsultantPipelineCardsQuery;
  export type Variables = GetConsultantPipelineCardsQueryVariables;
  export const OperationName = "getConsultantPipelineCards";

  export const Document = GetConsultantPipelineCardsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantPipelineCardDocument = gql`
  query getConsultantPipelineCard($boardId: String!, $cardId: String!) {
    kanbanCard(type: ConsultantPipeline, boardId: $boardId, cardId: $cardId) {
      _id
      ...ConsultantPipelineCard
    }
  }
  ${ConsultantPipelineCardFragmentDoc}
`;
export type GetConsultantPipelineCardComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantPipelineCardQuery,
    GetConsultantPipelineCardQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantPipelineCardQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantPipelineCardComponent = (
  props: GetConsultantPipelineCardComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantPipelineCardQuery,
    GetConsultantPipelineCardQueryVariables
  >
    query={GetConsultantPipelineCardDocument}
    {...props}
  />
);

/**
 * __useGetConsultantPipelineCardQuery__
 *
 * To run a query within a React component, call `useGetConsultantPipelineCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantPipelineCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantPipelineCardQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetConsultantPipelineCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantPipelineCardQuery,
    GetConsultantPipelineCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantPipelineCardQuery,
    GetConsultantPipelineCardQueryVariables
  >(GetConsultantPipelineCardDocument, options);
}
export function useGetConsultantPipelineCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantPipelineCardQuery,
    GetConsultantPipelineCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantPipelineCardQuery,
    GetConsultantPipelineCardQueryVariables
  >(GetConsultantPipelineCardDocument, options);
}
export type GetConsultantPipelineCardQueryHookResult = ReturnType<
  typeof useGetConsultantPipelineCardQuery
>;
export type GetConsultantPipelineCardLazyQueryHookResult = ReturnType<
  typeof useGetConsultantPipelineCardLazyQuery
>;
export namespace GetConsultantPipelineCard {
  export type Return = GetConsultantPipelineCardQuery;
  export type Variables = GetConsultantPipelineCardQueryVariables;
  export const OperationName = "getConsultantPipelineCard";

  export const Document = GetConsultantPipelineCardDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UnsetNextContactDateDocument = gql`
  mutation unsetNextContactDate($consultantId: ObjectId!, $nextPipelineStatus: String!) {
    unsetConsultantNextContactDate(
      consultantId: $consultantId
      nextPipelineStatus: $nextPipelineStatus
    )
  }
`;
export type UnsetNextContactDateMutationFn = Apollo.MutationFunction<
  UnsetNextContactDateMutation,
  UnsetNextContactDateMutationVariables
>;
export type UnsetNextContactDateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UnsetNextContactDateMutation,
    UnsetNextContactDateMutationVariables
  >,
  "mutation"
>;

export const UnsetNextContactDateComponent = (
  props: UnsetNextContactDateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UnsetNextContactDateMutation,
    UnsetNextContactDateMutationVariables
  >
    mutation={UnsetNextContactDateDocument}
    {...props}
  />
);

/**
 * __useUnsetNextContactDateMutation__
 *
 * To run a mutation, you first call `useUnsetNextContactDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetNextContactDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetNextContactDateMutation, { data, loading, error }] = useUnsetNextContactDateMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      nextPipelineStatus: // value for 'nextPipelineStatus'
 *   },
 * });
 */
export function useUnsetNextContactDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnsetNextContactDateMutation,
    UnsetNextContactDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnsetNextContactDateMutation,
    UnsetNextContactDateMutationVariables
  >(UnsetNextContactDateDocument, options);
}
export type UnsetNextContactDateMutationHookResult = ReturnType<
  typeof useUnsetNextContactDateMutation
>;
export namespace UnsetNextContactDate {
  export type Return = UnsetNextContactDateMutation;
  export type Variables = UnsetNextContactDateMutationVariables;
  export const OperationName = "unsetNextContactDate";

  export const Document = UnsetNextContactDateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PipelineStatusCommentGetDataDocument = gql`
  query pipelineStatusCommentGetData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      pipelineStatusComment
    }
  }
`;
export type PipelineStatusCommentGetDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PipelineStatusCommentGetDataQuery,
    PipelineStatusCommentGetDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: PipelineStatusCommentGetDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const PipelineStatusCommentGetDataComponent = (
  props: PipelineStatusCommentGetDataComponentProps
) => (
  <ApolloReactComponents.Query<
    PipelineStatusCommentGetDataQuery,
    PipelineStatusCommentGetDataQueryVariables
  >
    query={PipelineStatusCommentGetDataDocument}
    {...props}
  />
);

/**
 * __usePipelineStatusCommentGetDataQuery__
 *
 * To run a query within a React component, call `usePipelineStatusCommentGetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineStatusCommentGetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineStatusCommentGetDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function usePipelineStatusCommentGetDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PipelineStatusCommentGetDataQuery,
    PipelineStatusCommentGetDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PipelineStatusCommentGetDataQuery,
    PipelineStatusCommentGetDataQueryVariables
  >(PipelineStatusCommentGetDataDocument, options);
}
export function usePipelineStatusCommentGetDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PipelineStatusCommentGetDataQuery,
    PipelineStatusCommentGetDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PipelineStatusCommentGetDataQuery,
    PipelineStatusCommentGetDataQueryVariables
  >(PipelineStatusCommentGetDataDocument, options);
}
export type PipelineStatusCommentGetDataQueryHookResult = ReturnType<
  typeof usePipelineStatusCommentGetDataQuery
>;
export type PipelineStatusCommentGetDataLazyQueryHookResult = ReturnType<
  typeof usePipelineStatusCommentGetDataLazyQuery
>;
export namespace PipelineStatusCommentGetData {
  export type Return = PipelineStatusCommentGetDataQuery;
  export type Variables = PipelineStatusCommentGetDataQueryVariables;
  export const OperationName = "pipelineStatusCommentGetData";

  export const Document = PipelineStatusCommentGetDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetPipelineStatusCommentDocument = gql`
  mutation setPipelineStatusComment($consultantId: ObjectId!, $comment: String) {
    setConsultantPipelineStatusComment(consultantId: $consultantId, comment: $comment) {
      pipelineStatusComment
    }
  }
`;
export type SetPipelineStatusCommentMutationFn = Apollo.MutationFunction<
  SetPipelineStatusCommentMutation,
  SetPipelineStatusCommentMutationVariables
>;
export type SetPipelineStatusCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetPipelineStatusCommentMutation,
    SetPipelineStatusCommentMutationVariables
  >,
  "mutation"
>;

export const SetPipelineStatusCommentComponent = (
  props: SetPipelineStatusCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetPipelineStatusCommentMutation,
    SetPipelineStatusCommentMutationVariables
  >
    mutation={SetPipelineStatusCommentDocument}
    {...props}
  />
);

/**
 * __useSetPipelineStatusCommentMutation__
 *
 * To run a mutation, you first call `useSetPipelineStatusCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPipelineStatusCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPipelineStatusCommentMutation, { data, loading, error }] = useSetPipelineStatusCommentMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetPipelineStatusCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetPipelineStatusCommentMutation,
    SetPipelineStatusCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetPipelineStatusCommentMutation,
    SetPipelineStatusCommentMutationVariables
  >(SetPipelineStatusCommentDocument, options);
}
export type SetPipelineStatusCommentMutationHookResult = ReturnType<
  typeof useSetPipelineStatusCommentMutation
>;
export namespace SetPipelineStatusComment {
  export type Return = SetPipelineStatusCommentMutation;
  export type Variables = SetPipelineStatusCommentMutationVariables;
  export const OperationName = "setPipelineStatusComment";

  export const Document = SetPipelineStatusCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantNextContactDateDocument = gql`
  query getConsultantNextContactDate($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      _id
      nextContactDate {
        reason
        date
      }
    }
  }
`;
export type GetConsultantNextContactDateComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantNextContactDateQuery,
    GetConsultantNextContactDateQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantNextContactDateQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantNextContactDateComponent = (
  props: GetConsultantNextContactDateComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantNextContactDateQuery,
    GetConsultantNextContactDateQueryVariables
  >
    query={GetConsultantNextContactDateDocument}
    {...props}
  />
);

/**
 * __useGetConsultantNextContactDateQuery__
 *
 * To run a query within a React component, call `useGetConsultantNextContactDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantNextContactDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantNextContactDateQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantNextContactDateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantNextContactDateQuery,
    GetConsultantNextContactDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantNextContactDateQuery,
    GetConsultantNextContactDateQueryVariables
  >(GetConsultantNextContactDateDocument, options);
}
export function useGetConsultantNextContactDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantNextContactDateQuery,
    GetConsultantNextContactDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantNextContactDateQuery,
    GetConsultantNextContactDateQueryVariables
  >(GetConsultantNextContactDateDocument, options);
}
export type GetConsultantNextContactDateQueryHookResult = ReturnType<
  typeof useGetConsultantNextContactDateQuery
>;
export type GetConsultantNextContactDateLazyQueryHookResult = ReturnType<
  typeof useGetConsultantNextContactDateLazyQuery
>;
export namespace GetConsultantNextContactDate {
  export type Return = GetConsultantNextContactDateQuery;
  export type Variables = GetConsultantNextContactDateQueryVariables;
  export const OperationName = "getConsultantNextContactDate";

  export const Document = GetConsultantNextContactDateDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetConsultantNextContactDateDocument = gql`
  mutation setConsultantNextContactDate(
    $consultantId: ObjectId!
    $date: Date!
    $reason: String!
  ) {
    setConsultantNextContactDate(
      consultantId: $consultantId
      date: $date
      reason: $reason
    )
  }
`;
export type SetConsultantNextContactDateMutationFn = Apollo.MutationFunction<
  SetConsultantNextContactDateMutation,
  SetConsultantNextContactDateMutationVariables
>;
export type SetConsultantNextContactDateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetConsultantNextContactDateMutation,
    SetConsultantNextContactDateMutationVariables
  >,
  "mutation"
>;

export const SetConsultantNextContactDateComponent = (
  props: SetConsultantNextContactDateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetConsultantNextContactDateMutation,
    SetConsultantNextContactDateMutationVariables
  >
    mutation={SetConsultantNextContactDateDocument}
    {...props}
  />
);

/**
 * __useSetConsultantNextContactDateMutation__
 *
 * To run a mutation, you first call `useSetConsultantNextContactDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConsultantNextContactDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConsultantNextContactDateMutation, { data, loading, error }] = useSetConsultantNextContactDateMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      date: // value for 'date'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSetConsultantNextContactDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetConsultantNextContactDateMutation,
    SetConsultantNextContactDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetConsultantNextContactDateMutation,
    SetConsultantNextContactDateMutationVariables
  >(SetConsultantNextContactDateDocument, options);
}
export type SetConsultantNextContactDateMutationHookResult = ReturnType<
  typeof useSetConsultantNextContactDateMutation
>;
export namespace SetConsultantNextContactDate {
  export type Return = SetConsultantNextContactDateMutation;
  export type Variables = SetConsultantNextContactDateMutationVariables;
  export const OperationName = "setConsultantNextContactDate";

  export const Document = SetConsultantNextContactDateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UntagConsultantGetDataDocument = gql`
  query untagConsultantGetData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...UntagConsultantData
    }
  }
  ${UntagConsultantDataFragmentDoc}
`;
export type UntagConsultantGetDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    UntagConsultantGetDataQuery,
    UntagConsultantGetDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: UntagConsultantGetDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const UntagConsultantGetDataComponent = (
  props: UntagConsultantGetDataComponentProps
) => (
  <ApolloReactComponents.Query<
    UntagConsultantGetDataQuery,
    UntagConsultantGetDataQueryVariables
  >
    query={UntagConsultantGetDataDocument}
    {...props}
  />
);

/**
 * __useUntagConsultantGetDataQuery__
 *
 * To run a query within a React component, call `useUntagConsultantGetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUntagConsultantGetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUntagConsultantGetDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useUntagConsultantGetDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UntagConsultantGetDataQuery,
    UntagConsultantGetDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UntagConsultantGetDataQuery,
    UntagConsultantGetDataQueryVariables
  >(UntagConsultantGetDataDocument, options);
}
export function useUntagConsultantGetDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UntagConsultantGetDataQuery,
    UntagConsultantGetDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UntagConsultantGetDataQuery,
    UntagConsultantGetDataQueryVariables
  >(UntagConsultantGetDataDocument, options);
}
export type UntagConsultantGetDataQueryHookResult = ReturnType<
  typeof useUntagConsultantGetDataQuery
>;
export type UntagConsultantGetDataLazyQueryHookResult = ReturnType<
  typeof useUntagConsultantGetDataLazyQuery
>;
export namespace UntagConsultantGetData {
  export type Return = UntagConsultantGetDataQuery;
  export type Variables = UntagConsultantGetDataQueryVariables;
  export const OperationName = "untagConsultantGetData";

  export const Document = UntagConsultantGetDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UntagConsultantClearBADocument = gql`
  mutation untagConsultantClearBA(
    $consultantId: ObjectId!
    $status: ConsultantLeadStatus
  ) {
    clearConsultantResponsiblePerson(
      consultantId: $consultantId
      setLeadStatus: $status
    ) {
      _id
    }
  }
`;
export type UntagConsultantClearBAMutationFn = Apollo.MutationFunction<
  UntagConsultantClearBAMutation,
  UntagConsultantClearBAMutationVariables
>;
export type UntagConsultantClearBAComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UntagConsultantClearBAMutation,
    UntagConsultantClearBAMutationVariables
  >,
  "mutation"
>;

export const UntagConsultantClearBAComponent = (
  props: UntagConsultantClearBAComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UntagConsultantClearBAMutation,
    UntagConsultantClearBAMutationVariables
  >
    mutation={UntagConsultantClearBADocument}
    {...props}
  />
);

/**
 * __useUntagConsultantClearBAMutation__
 *
 * To run a mutation, you first call `useUntagConsultantClearBAMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntagConsultantClearBAMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untagConsultantClearBaMutation, { data, loading, error }] = useUntagConsultantClearBAMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUntagConsultantClearBAMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UntagConsultantClearBAMutation,
    UntagConsultantClearBAMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UntagConsultantClearBAMutation,
    UntagConsultantClearBAMutationVariables
  >(UntagConsultantClearBADocument, options);
}
export type UntagConsultantClearBAMutationHookResult = ReturnType<
  typeof useUntagConsultantClearBAMutation
>;
export namespace UntagConsultantClearBA {
  export type Return = UntagConsultantClearBAMutation;
  export type Variables = UntagConsultantClearBAMutationVariables;
  export const OperationName = "untagConsultantClearBA";

  export const Document = UntagConsultantClearBADocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MoveCardDocument = gql`
  mutation moveCard(
    $boardId: String!
    $boardType: KanbanBoardType!
    $cardId: String!
    $columnId: String!
    $beforeCardId: String
    $sessionId: String
  ) {
    moveCard(
      boardId: $boardId
      boardType: $boardType
      cardId: $cardId
      columnId: $columnId
      beforeCardId: $beforeCardId
      sessionId: $sessionId
    )
  }
`;
export type MoveCardMutationFn = Apollo.MutationFunction<
  MoveCardMutation,
  MoveCardMutationVariables
>;
export type MoveCardComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MoveCardMutation,
    MoveCardMutationVariables
  >,
  "mutation"
>;

export const MoveCardComponent = (props: MoveCardComponentProps) => (
  <ApolloReactComponents.Mutation<MoveCardMutation, MoveCardMutationVariables>
    mutation={MoveCardDocument}
    {...props}
  />
);

/**
 * __useMoveCardMutation__
 *
 * To run a mutation, you first call `useMoveCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCardMutation, { data, loading, error }] = useMoveCardMutation({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      boardType: // value for 'boardType'
 *      cardId: // value for 'cardId'
 *      columnId: // value for 'columnId'
 *      beforeCardId: // value for 'beforeCardId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useMoveCardMutation(
  baseOptions?: Apollo.MutationHookOptions<MoveCardMutation, MoveCardMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MoveCardMutation, MoveCardMutationVariables>(
    MoveCardDocument,
    options
  );
}
export type MoveCardMutationHookResult = ReturnType<typeof useMoveCardMutation>;
export namespace MoveCard {
  export type Return = MoveCardMutation;
  export type Variables = MoveCardMutationVariables;
  export const OperationName = "moveCard";

  export const Document = MoveCardDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CardAddedDocument = gql`
  subscription cardAdded($sessionId: String!, $boardId: ObjectId!) {
    kanbanCardAdded(sessionId: $sessionId, boardId: $boardId) {
      cardId
    }
  }
`;
export type CardAddedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    CardAddedSubscription,
    CardAddedSubscriptionVariables
  >,
  "subscription"
>;

export const CardAddedComponent = (props: CardAddedComponentProps) => (
  <ApolloReactComponents.Subscription<
    CardAddedSubscription,
    CardAddedSubscriptionVariables
  >
    subscription={CardAddedDocument}
    {...props}
  />
);

/**
 * __useCardAddedSubscription__
 *
 * To run a query within a React component, call `useCardAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCardAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardAddedSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useCardAddedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CardAddedSubscription,
    CardAddedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<CardAddedSubscription, CardAddedSubscriptionVariables>(
    CardAddedDocument,
    options
  );
}
export type CardAddedSubscriptionHookResult = ReturnType<typeof useCardAddedSubscription>;
export namespace CardAdded {
  export type Return = CardAddedSubscription;
  export type Variables = CardAddedSubscriptionVariables;
  export const OperationName = "cardAdded";

  export const Document = CardAddedDocument;
  export const { func } = subscription<Variables, Return>(Document, getClient);
}
export const CardMovedDocument = gql`
  subscription cardMoved($sessionId: String!, $boardId: ObjectId!) {
    kanbanCardMoved(sessionId: $sessionId, boardId: $boardId) {
      cardId
    }
  }
`;
export type CardMovedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    CardMovedSubscription,
    CardMovedSubscriptionVariables
  >,
  "subscription"
>;

export const CardMovedComponent = (props: CardMovedComponentProps) => (
  <ApolloReactComponents.Subscription<
    CardMovedSubscription,
    CardMovedSubscriptionVariables
  >
    subscription={CardMovedDocument}
    {...props}
  />
);

/**
 * __useCardMovedSubscription__
 *
 * To run a query within a React component, call `useCardMovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCardMovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardMovedSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useCardMovedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CardMovedSubscription,
    CardMovedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<CardMovedSubscription, CardMovedSubscriptionVariables>(
    CardMovedDocument,
    options
  );
}
export type CardMovedSubscriptionHookResult = ReturnType<typeof useCardMovedSubscription>;
export namespace CardMoved {
  export type Return = CardMovedSubscription;
  export type Variables = CardMovedSubscriptionVariables;
  export const OperationName = "cardMoved";

  export const Document = CardMovedDocument;
  export const { func } = subscription<Variables, Return>(Document, getClient);
}
export const CardDeletedDocument = gql`
  subscription cardDeleted($sessionId: String!, $boardId: ObjectId!) {
    kanbanCardDeleted(sessionId: $sessionId, boardId: $boardId) {
      cardId
    }
  }
`;
export type CardDeletedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    CardDeletedSubscription,
    CardDeletedSubscriptionVariables
  >,
  "subscription"
>;

export const CardDeletedComponent = (props: CardDeletedComponentProps) => (
  <ApolloReactComponents.Subscription<
    CardDeletedSubscription,
    CardDeletedSubscriptionVariables
  >
    subscription={CardDeletedDocument}
    {...props}
  />
);

/**
 * __useCardDeletedSubscription__
 *
 * To run a query within a React component, call `useCardDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCardDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardDeletedSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useCardDeletedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CardDeletedSubscription,
    CardDeletedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CardDeletedSubscription,
    CardDeletedSubscriptionVariables
  >(CardDeletedDocument, options);
}
export type CardDeletedSubscriptionHookResult = ReturnType<
  typeof useCardDeletedSubscription
>;
export namespace CardDeleted {
  export type Return = CardDeletedSubscription;
  export type Variables = CardDeletedSubscriptionVariables;
  export const OperationName = "cardDeleted";

  export const Document = CardDeletedDocument;
  export const { func } = subscription<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_GetCustomerDocument = gql`
  query ConsultantBookingContract_GetCustomer($id: ObjectId!) {
    customerById(id: $id) {
      ...ConsultantBookingContractCustomer
    }
  }
  ${ConsultantBookingContractCustomerFragmentDoc}
`;
export type ConsultantBookingContract_GetCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantBookingContract_GetCustomerQuery,
    ConsultantBookingContract_GetCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantBookingContract_GetCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantBookingContract_GetCustomerComponent = (
  props: ConsultantBookingContract_GetCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantBookingContract_GetCustomerQuery,
    ConsultantBookingContract_GetCustomerQueryVariables
  >
    query={ConsultantBookingContract_GetCustomerDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_GetCustomerQuery__
 *
 * To run a query within a React component, call `useConsultantBookingContract_GetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_GetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantBookingContract_GetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantBookingContract_GetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantBookingContract_GetCustomerQuery,
    ConsultantBookingContract_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantBookingContract_GetCustomerQuery,
    ConsultantBookingContract_GetCustomerQueryVariables
  >(ConsultantBookingContract_GetCustomerDocument, options);
}
export function useConsultantBookingContract_GetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantBookingContract_GetCustomerQuery,
    ConsultantBookingContract_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantBookingContract_GetCustomerQuery,
    ConsultantBookingContract_GetCustomerQueryVariables
  >(ConsultantBookingContract_GetCustomerDocument, options);
}
export type ConsultantBookingContract_GetCustomerQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_GetCustomerQuery
>;
export type ConsultantBookingContract_GetCustomerLazyQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_GetCustomerLazyQuery
>;
export namespace ConsultantBookingContract_GetCustomer {
  export type Return = ConsultantBookingContract_GetCustomerQuery;
  export type Variables = ConsultantBookingContract_GetCustomerQueryVariables;
  export const OperationName = "ConsultantBookingContract_GetCustomer";

  export const Document = ConsultantBookingContract_GetCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_FetchDeptsDocument = gql`
  query ConsultantBookingContract_FetchDepts($hospitalId: ObjectId!) {
    hospital: customerById(id: $hospitalId) {
      _id
      OrganizationNumber
      ...ContactPerson_ContactInfo
    }
    departments: customers(
      filter: { parentId: [$hospitalId], type: [Department] }
      limit: 1000
      skip: 0
    ) {
      items {
        _id
        Name
        ...ContactPerson_ContactInfo
      }
      dbTime
    }
  }
  ${ContactPerson_ContactInfoFragmentDoc}
`;
export type ConsultantBookingContract_FetchDeptsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantBookingContract_FetchDeptsQuery,
    ConsultantBookingContract_FetchDeptsQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantBookingContract_FetchDeptsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantBookingContract_FetchDeptsComponent = (
  props: ConsultantBookingContract_FetchDeptsComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantBookingContract_FetchDeptsQuery,
    ConsultantBookingContract_FetchDeptsQueryVariables
  >
    query={ConsultantBookingContract_FetchDeptsDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_FetchDeptsQuery__
 *
 * To run a query within a React component, call `useConsultantBookingContract_FetchDeptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_FetchDeptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantBookingContract_FetchDeptsQuery({
 *   variables: {
 *      hospitalId: // value for 'hospitalId'
 *   },
 * });
 */
export function useConsultantBookingContract_FetchDeptsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantBookingContract_FetchDeptsQuery,
    ConsultantBookingContract_FetchDeptsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantBookingContract_FetchDeptsQuery,
    ConsultantBookingContract_FetchDeptsQueryVariables
  >(ConsultantBookingContract_FetchDeptsDocument, options);
}
export function useConsultantBookingContract_FetchDeptsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantBookingContract_FetchDeptsQuery,
    ConsultantBookingContract_FetchDeptsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantBookingContract_FetchDeptsQuery,
    ConsultantBookingContract_FetchDeptsQueryVariables
  >(ConsultantBookingContract_FetchDeptsDocument, options);
}
export type ConsultantBookingContract_FetchDeptsQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_FetchDeptsQuery
>;
export type ConsultantBookingContract_FetchDeptsLazyQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_FetchDeptsLazyQuery
>;
export namespace ConsultantBookingContract_FetchDepts {
  export type Return = ConsultantBookingContract_FetchDeptsQuery;
  export type Variables = ConsultantBookingContract_FetchDeptsQueryVariables;
  export const OperationName = "ConsultantBookingContract_FetchDepts";

  export const Document = ConsultantBookingContract_FetchDeptsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_EditDocument = gql`
  mutation ConsultantBookingContract_Edit(
    $contractId: ObjectId!
    $data: ConsultantBookingContractFormInput!
  ) {
    editConsultantBookingContract(contractId: $contractId, data: $data) {
      ...ConsultantBookingContractListItem_Fragment
    }
  }
  ${ConsultantBookingContractListItem_FragmentFragmentDoc}
`;
export type ConsultantBookingContract_EditMutationFn = Apollo.MutationFunction<
  ConsultantBookingContract_EditMutation,
  ConsultantBookingContract_EditMutationVariables
>;
export type ConsultantBookingContract_EditComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantBookingContract_EditMutation,
    ConsultantBookingContract_EditMutationVariables
  >,
  "mutation"
>;

export const ConsultantBookingContract_EditComponent = (
  props: ConsultantBookingContract_EditComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantBookingContract_EditMutation,
    ConsultantBookingContract_EditMutationVariables
  >
    mutation={ConsultantBookingContract_EditDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_EditMutation__
 *
 * To run a mutation, you first call `useConsultantBookingContract_EditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_EditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantBookingContractEditMutation, { data, loading, error }] = useConsultantBookingContract_EditMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConsultantBookingContract_EditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantBookingContract_EditMutation,
    ConsultantBookingContract_EditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantBookingContract_EditMutation,
    ConsultantBookingContract_EditMutationVariables
  >(ConsultantBookingContract_EditDocument, options);
}
export type ConsultantBookingContract_EditMutationHookResult = ReturnType<
  typeof useConsultantBookingContract_EditMutation
>;
export namespace ConsultantBookingContract_Edit {
  export type Return = ConsultantBookingContract_EditMutation;
  export type Variables = ConsultantBookingContract_EditMutationVariables;
  export const OperationName = "ConsultantBookingContract_Edit";

  export const Document = ConsultantBookingContract_EditDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_AddDocument = gql`
  mutation ConsultantBookingContract_Add(
    $consultantId: ObjectId!
    $data: ConsultantBookingContractFormInput!
  ) {
    addConsultantBookingContract(consultantId: $consultantId, data: $data) {
      ...ConsultantBookingContractListItem_Fragment
    }
  }
  ${ConsultantBookingContractListItem_FragmentFragmentDoc}
`;
export type ConsultantBookingContract_AddMutationFn = Apollo.MutationFunction<
  ConsultantBookingContract_AddMutation,
  ConsultantBookingContract_AddMutationVariables
>;
export type ConsultantBookingContract_AddComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantBookingContract_AddMutation,
    ConsultantBookingContract_AddMutationVariables
  >,
  "mutation"
>;

export const ConsultantBookingContract_AddComponent = (
  props: ConsultantBookingContract_AddComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantBookingContract_AddMutation,
    ConsultantBookingContract_AddMutationVariables
  >
    mutation={ConsultantBookingContract_AddDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_AddMutation__
 *
 * To run a mutation, you first call `useConsultantBookingContract_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantBookingContractAddMutation, { data, loading, error }] = useConsultantBookingContract_AddMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConsultantBookingContract_AddMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantBookingContract_AddMutation,
    ConsultantBookingContract_AddMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantBookingContract_AddMutation,
    ConsultantBookingContract_AddMutationVariables
  >(ConsultantBookingContract_AddDocument, options);
}
export type ConsultantBookingContract_AddMutationHookResult = ReturnType<
  typeof useConsultantBookingContract_AddMutation
>;
export namespace ConsultantBookingContract_Add {
  export type Return = ConsultantBookingContract_AddMutation;
  export type Variables = ConsultantBookingContract_AddMutationVariables;
  export const OperationName = "ConsultantBookingContract_Add";

  export const Document = ConsultantBookingContract_AddDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_SoftDeleteDocument = gql`
  mutation ConsultantBookingContract_softDelete($contractId: ObjectId!) {
    deleteConsultantBookingContract(contractId: $contractId) {
      _id
    }
  }
`;
export type ConsultantBookingContract_SoftDeleteMutationFn = Apollo.MutationFunction<
  ConsultantBookingContract_SoftDeleteMutation,
  ConsultantBookingContract_SoftDeleteMutationVariables
>;
export type ConsultantBookingContract_SoftDeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantBookingContract_SoftDeleteMutation,
    ConsultantBookingContract_SoftDeleteMutationVariables
  >,
  "mutation"
>;

export const ConsultantBookingContract_SoftDeleteComponent = (
  props: ConsultantBookingContract_SoftDeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantBookingContract_SoftDeleteMutation,
    ConsultantBookingContract_SoftDeleteMutationVariables
  >
    mutation={ConsultantBookingContract_SoftDeleteDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_SoftDeleteMutation__
 *
 * To run a mutation, you first call `useConsultantBookingContract_SoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_SoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantBookingContractSoftDeleteMutation, { data, loading, error }] = useConsultantBookingContract_SoftDeleteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantBookingContract_SoftDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantBookingContract_SoftDeleteMutation,
    ConsultantBookingContract_SoftDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantBookingContract_SoftDeleteMutation,
    ConsultantBookingContract_SoftDeleteMutationVariables
  >(ConsultantBookingContract_SoftDeleteDocument, options);
}
export type ConsultantBookingContract_SoftDeleteMutationHookResult = ReturnType<
  typeof useConsultantBookingContract_SoftDeleteMutation
>;
export namespace ConsultantBookingContract_softDelete {
  export type Return = ConsultantBookingContract_SoftDeleteMutation;
  export type Variables = ConsultantBookingContract_SoftDeleteMutationVariables;
  export const OperationName = "ConsultantBookingContract_softDelete";

  export const Document = ConsultantBookingContract_SoftDeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_NullifyDocument = gql`
  mutation ConsultantBookingContract_nullify($contractId: ObjectId!, $nullify: Boolean!) {
    nullifyConsultantBookingContract(contractId: $contractId, nullify: $nullify) {
      ...ConsultantBookingContractListItem_Fragment
    }
  }
  ${ConsultantBookingContractListItem_FragmentFragmentDoc}
`;
export type ConsultantBookingContract_NullifyMutationFn = Apollo.MutationFunction<
  ConsultantBookingContract_NullifyMutation,
  ConsultantBookingContract_NullifyMutationVariables
>;
export type ConsultantBookingContract_NullifyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantBookingContract_NullifyMutation,
    ConsultantBookingContract_NullifyMutationVariables
  >,
  "mutation"
>;

export const ConsultantBookingContract_NullifyComponent = (
  props: ConsultantBookingContract_NullifyComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantBookingContract_NullifyMutation,
    ConsultantBookingContract_NullifyMutationVariables
  >
    mutation={ConsultantBookingContract_NullifyDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_NullifyMutation__
 *
 * To run a mutation, you first call `useConsultantBookingContract_NullifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_NullifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantBookingContractNullifyMutation, { data, loading, error }] = useConsultantBookingContract_NullifyMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      nullify: // value for 'nullify'
 *   },
 * });
 */
export function useConsultantBookingContract_NullifyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantBookingContract_NullifyMutation,
    ConsultantBookingContract_NullifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantBookingContract_NullifyMutation,
    ConsultantBookingContract_NullifyMutationVariables
  >(ConsultantBookingContract_NullifyDocument, options);
}
export type ConsultantBookingContract_NullifyMutationHookResult = ReturnType<
  typeof useConsultantBookingContract_NullifyMutation
>;
export namespace ConsultantBookingContract_nullify {
  export type Return = ConsultantBookingContract_NullifyMutation;
  export type Variables = ConsultantBookingContract_NullifyMutationVariables;
  export const OperationName = "ConsultantBookingContract_nullify";

  export const Document = ConsultantBookingContract_NullifyDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_GetContractsByConsultantIdDocument = gql`
  query ConsultantBookingContract_getContractsByConsultantId($consultantId: ObjectId!) {
    getConsultantBookingContracts(consultantId: $consultantId) {
      ...ConsultantBookingContractListItem_Fragment
    }
  }
  ${ConsultantBookingContractListItem_FragmentFragmentDoc}
`;
export type ConsultantBookingContract_GetContractsByConsultantIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantBookingContract_GetContractsByConsultantIdQuery,
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantBookingContract_GetContractsByConsultantIdQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantBookingContract_GetContractsByConsultantIdComponent = (
  props: ConsultantBookingContract_GetContractsByConsultantIdComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantBookingContract_GetContractsByConsultantIdQuery,
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables
  >
    query={ConsultantBookingContract_GetContractsByConsultantIdDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_GetContractsByConsultantIdQuery__
 *
 * To run a query within a React component, call `useConsultantBookingContract_GetContractsByConsultantIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_GetContractsByConsultantIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantBookingContract_GetContractsByConsultantIdQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantBookingContract_GetContractsByConsultantIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantBookingContract_GetContractsByConsultantIdQuery,
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantBookingContract_GetContractsByConsultantIdQuery,
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables
  >(ConsultantBookingContract_GetContractsByConsultantIdDocument, options);
}
export function useConsultantBookingContract_GetContractsByConsultantIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantBookingContract_GetContractsByConsultantIdQuery,
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantBookingContract_GetContractsByConsultantIdQuery,
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables
  >(ConsultantBookingContract_GetContractsByConsultantIdDocument, options);
}
export type ConsultantBookingContract_GetContractsByConsultantIdQueryHookResult =
  ReturnType<typeof useConsultantBookingContract_GetContractsByConsultantIdQuery>;
export type ConsultantBookingContract_GetContractsByConsultantIdLazyQueryHookResult =
  ReturnType<typeof useConsultantBookingContract_GetContractsByConsultantIdLazyQuery>;
export namespace ConsultantBookingContract_getContractsByConsultantId {
  export type Return = ConsultantBookingContract_GetContractsByConsultantIdQuery;
  export type Variables =
    ConsultantBookingContract_GetContractsByConsultantIdQueryVariables;
  export const OperationName = "ConsultantBookingContract_getContractsByConsultantId";

  export const Document = ConsultantBookingContract_GetContractsByConsultantIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_UploadSignedDocument = gql`
  mutation ConsultantBookingContract_uploadSigned(
    $contractId: ObjectId!
    $file: Upload!
    $SignedOn: Date
  ) {
    uploadSignedConsultantBookingContract(
      contractId: $contractId
      file: $file
      signedOn: $SignedOn
    ) {
      _id
      FileUrl
      IsSigned
      ViewUrl
    }
  }
`;
export type ConsultantBookingContract_UploadSignedMutationFn = Apollo.MutationFunction<
  ConsultantBookingContract_UploadSignedMutation,
  ConsultantBookingContract_UploadSignedMutationVariables
>;
export type ConsultantBookingContract_UploadSignedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantBookingContract_UploadSignedMutation,
    ConsultantBookingContract_UploadSignedMutationVariables
  >,
  "mutation"
>;

export const ConsultantBookingContract_UploadSignedComponent = (
  props: ConsultantBookingContract_UploadSignedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantBookingContract_UploadSignedMutation,
    ConsultantBookingContract_UploadSignedMutationVariables
  >
    mutation={ConsultantBookingContract_UploadSignedDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_UploadSignedMutation__
 *
 * To run a mutation, you first call `useConsultantBookingContract_UploadSignedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_UploadSignedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantBookingContractUploadSignedMutation, { data, loading, error }] = useConsultantBookingContract_UploadSignedMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      file: // value for 'file'
 *      SignedOn: // value for 'SignedOn'
 *   },
 * });
 */
export function useConsultantBookingContract_UploadSignedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantBookingContract_UploadSignedMutation,
    ConsultantBookingContract_UploadSignedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantBookingContract_UploadSignedMutation,
    ConsultantBookingContract_UploadSignedMutationVariables
  >(ConsultantBookingContract_UploadSignedDocument, options);
}
export type ConsultantBookingContract_UploadSignedMutationHookResult = ReturnType<
  typeof useConsultantBookingContract_UploadSignedMutation
>;
export namespace ConsultantBookingContract_uploadSigned {
  export type Return = ConsultantBookingContract_UploadSignedMutation;
  export type Variables = ConsultantBookingContract_UploadSignedMutationVariables;
  export const OperationName = "ConsultantBookingContract_uploadSigned";

  export const Document = ConsultantBookingContract_UploadSignedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_GetByIdForEditDocument = gql`
  query ConsultantBookingContract_getByIdForEdit($contractId: ObjectId!) {
    getConsultantBookingContractDetailInfo(contractId: $contractId) {
      ...BookingContractDataForDuplication
      ...ContractBookingAddress
      Period
      StartDate
      EndDate
      ResponsiblePersonId
      SignedOn
    }
  }
  ${BookingContractDataForDuplicationFragmentDoc}
  ${ContractBookingAddressFragmentDoc}
`;
export type ConsultantBookingContract_GetByIdForEditComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantBookingContract_GetByIdForEditQuery,
    ConsultantBookingContract_GetByIdForEditQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantBookingContract_GetByIdForEditQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantBookingContract_GetByIdForEditComponent = (
  props: ConsultantBookingContract_GetByIdForEditComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantBookingContract_GetByIdForEditQuery,
    ConsultantBookingContract_GetByIdForEditQueryVariables
  >
    query={ConsultantBookingContract_GetByIdForEditDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_GetByIdForEditQuery__
 *
 * To run a query within a React component, call `useConsultantBookingContract_GetByIdForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_GetByIdForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantBookingContract_GetByIdForEditQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantBookingContract_GetByIdForEditQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantBookingContract_GetByIdForEditQuery,
    ConsultantBookingContract_GetByIdForEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantBookingContract_GetByIdForEditQuery,
    ConsultantBookingContract_GetByIdForEditQueryVariables
  >(ConsultantBookingContract_GetByIdForEditDocument, options);
}
export function useConsultantBookingContract_GetByIdForEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantBookingContract_GetByIdForEditQuery,
    ConsultantBookingContract_GetByIdForEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantBookingContract_GetByIdForEditQuery,
    ConsultantBookingContract_GetByIdForEditQueryVariables
  >(ConsultantBookingContract_GetByIdForEditDocument, options);
}
export type ConsultantBookingContract_GetByIdForEditQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_GetByIdForEditQuery
>;
export type ConsultantBookingContract_GetByIdForEditLazyQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_GetByIdForEditLazyQuery
>;
export namespace ConsultantBookingContract_getByIdForEdit {
  export type Return = ConsultantBookingContract_GetByIdForEditQuery;
  export type Variables = ConsultantBookingContract_GetByIdForEditQueryVariables;
  export const OperationName = "ConsultantBookingContract_getByIdForEdit";

  export const Document = ConsultantBookingContract_GetByIdForEditDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantBookingContract_GetByIdForDuplicationDocument = gql`
  query ConsultantBookingContract_getByIdForDuplication($contractId: ObjectId!) {
    getConsultantBookingContractDetailInfo(contractId: $contractId) {
      ...BookingContractDataForDuplication
    }
  }
  ${BookingContractDataForDuplicationFragmentDoc}
`;
export type ConsultantBookingContract_GetByIdForDuplicationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantBookingContract_GetByIdForDuplicationQuery,
    ConsultantBookingContract_GetByIdForDuplicationQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantBookingContract_GetByIdForDuplicationQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantBookingContract_GetByIdForDuplicationComponent = (
  props: ConsultantBookingContract_GetByIdForDuplicationComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantBookingContract_GetByIdForDuplicationQuery,
    ConsultantBookingContract_GetByIdForDuplicationQueryVariables
  >
    query={ConsultantBookingContract_GetByIdForDuplicationDocument}
    {...props}
  />
);

/**
 * __useConsultantBookingContract_GetByIdForDuplicationQuery__
 *
 * To run a query within a React component, call `useConsultantBookingContract_GetByIdForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantBookingContract_GetByIdForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantBookingContract_GetByIdForDuplicationQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantBookingContract_GetByIdForDuplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantBookingContract_GetByIdForDuplicationQuery,
    ConsultantBookingContract_GetByIdForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantBookingContract_GetByIdForDuplicationQuery,
    ConsultantBookingContract_GetByIdForDuplicationQueryVariables
  >(ConsultantBookingContract_GetByIdForDuplicationDocument, options);
}
export function useConsultantBookingContract_GetByIdForDuplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantBookingContract_GetByIdForDuplicationQuery,
    ConsultantBookingContract_GetByIdForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantBookingContract_GetByIdForDuplicationQuery,
    ConsultantBookingContract_GetByIdForDuplicationQueryVariables
  >(ConsultantBookingContract_GetByIdForDuplicationDocument, options);
}
export type ConsultantBookingContract_GetByIdForDuplicationQueryHookResult = ReturnType<
  typeof useConsultantBookingContract_GetByIdForDuplicationQuery
>;
export type ConsultantBookingContract_GetByIdForDuplicationLazyQueryHookResult =
  ReturnType<typeof useConsultantBookingContract_GetByIdForDuplicationLazyQuery>;
export namespace ConsultantBookingContract_getByIdForDuplication {
  export type Return = ConsultantBookingContract_GetByIdForDuplicationQuery;
  export type Variables = ConsultantBookingContract_GetByIdForDuplicationQueryVariables;
  export const OperationName = "ConsultantBookingContract_getByIdForDuplication";

  export const Document = ConsultantBookingContract_GetByIdForDuplicationDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantSearchCard_GetDocument = gql`
  query ConsultantSearchCard_Get($id: ObjectId!, $withEvents: Boolean!) {
    consultantById(id: $id) {
      ...ConsultantSearchCard
      Events @include(if: $withEvents) {
        ...EventLog_Event
      }
    }
  }
  ${ConsultantSearchCardFragmentDoc}
  ${EventLog_EventFragmentDoc}
`;
export type ConsultantSearchCard_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantSearchCard_GetQuery,
    ConsultantSearchCard_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantSearchCard_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantSearchCard_GetComponent = (
  props: ConsultantSearchCard_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantSearchCard_GetQuery,
    ConsultantSearchCard_GetQueryVariables
  >
    query={ConsultantSearchCard_GetDocument}
    {...props}
  />
);

/**
 * __useConsultantSearchCard_GetQuery__
 *
 * To run a query within a React component, call `useConsultantSearchCard_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantSearchCard_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantSearchCard_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withEvents: // value for 'withEvents'
 *   },
 * });
 */
export function useConsultantSearchCard_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantSearchCard_GetQuery,
    ConsultantSearchCard_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantSearchCard_GetQuery,
    ConsultantSearchCard_GetQueryVariables
  >(ConsultantSearchCard_GetDocument, options);
}
export function useConsultantSearchCard_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantSearchCard_GetQuery,
    ConsultantSearchCard_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantSearchCard_GetQuery,
    ConsultantSearchCard_GetQueryVariables
  >(ConsultantSearchCard_GetDocument, options);
}
export type ConsultantSearchCard_GetQueryHookResult = ReturnType<
  typeof useConsultantSearchCard_GetQuery
>;
export type ConsultantSearchCard_GetLazyQueryHookResult = ReturnType<
  typeof useConsultantSearchCard_GetLazyQuery
>;
export namespace ConsultantSearchCard_Get {
  export type Return = ConsultantSearchCard_GetQuery;
  export type Variables = ConsultantSearchCard_GetQueryVariables;
  export const OperationName = "ConsultantSearchCard_Get";

  export const Document = ConsultantSearchCard_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadConsultantContractDocumentDocument = gql`
  mutation UploadConsultantContractDocument($file: Upload!) {
    uploadDocument(file: $file) {
      FileRef {
        NodeID
      }
    }
  }
`;
export type UploadConsultantContractDocumentMutationFn = Apollo.MutationFunction<
  UploadConsultantContractDocumentMutation,
  UploadConsultantContractDocumentMutationVariables
>;
export type UploadConsultantContractDocumentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadConsultantContractDocumentMutation,
    UploadConsultantContractDocumentMutationVariables
  >,
  "mutation"
>;

export const UploadConsultantContractDocumentComponent = (
  props: UploadConsultantContractDocumentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadConsultantContractDocumentMutation,
    UploadConsultantContractDocumentMutationVariables
  >
    mutation={UploadConsultantContractDocumentDocument}
    {...props}
  />
);

/**
 * __useUploadConsultantContractDocumentMutation__
 *
 * To run a mutation, you first call `useUploadConsultantContractDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadConsultantContractDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadConsultantContractDocumentMutation, { data, loading, error }] = useUploadConsultantContractDocumentMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadConsultantContractDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadConsultantContractDocumentMutation,
    UploadConsultantContractDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadConsultantContractDocumentMutation,
    UploadConsultantContractDocumentMutationVariables
  >(UploadConsultantContractDocumentDocument, options);
}
export type UploadConsultantContractDocumentMutationHookResult = ReturnType<
  typeof useUploadConsultantContractDocumentMutation
>;
export namespace UploadConsultantContractDocument {
  export type Return = UploadConsultantContractDocumentMutation;
  export type Variables = UploadConsultantContractDocumentMutationVariables;
  export const OperationName = "UploadConsultantContractDocument";

  export const Document = UploadConsultantContractDocumentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetConsultantDocument = gql`
  query ConsultantContract_GetConsultant($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantContractEditorConsultantData
    }
    lastContract: getLastSignedConsultantContract(consultantId: $id) {
      _id
      StartDate
      EndDate
      IsSigned
    }
  }
  ${ConsultantContractEditorConsultantDataFragmentDoc}
`;
export type ConsultantContract_GetConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetConsultantQuery,
    ConsultantContract_GetConsultantQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantContract_GetConsultantQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantContract_GetConsultantComponent = (
  props: ConsultantContract_GetConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetConsultantQuery,
    ConsultantContract_GetConsultantQueryVariables
  >
    query={ConsultantContract_GetConsultantDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetConsultantQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetConsultantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantContract_GetConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetConsultantQuery,
    ConsultantContract_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetConsultantQuery,
    ConsultantContract_GetConsultantQueryVariables
  >(ConsultantContract_GetConsultantDocument, options);
}
export function useConsultantContract_GetConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetConsultantQuery,
    ConsultantContract_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetConsultantQuery,
    ConsultantContract_GetConsultantQueryVariables
  >(ConsultantContract_GetConsultantDocument, options);
}
export type ConsultantContract_GetConsultantQueryHookResult = ReturnType<
  typeof useConsultantContract_GetConsultantQuery
>;
export type ConsultantContract_GetConsultantLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetConsultantLazyQuery
>;
export namespace ConsultantContract_GetConsultant {
  export type Return = ConsultantContract_GetConsultantQuery;
  export type Variables = ConsultantContract_GetConsultantQueryVariables;
  export const OperationName = "ConsultantContract_GetConsultant";

  export const Document = ConsultantContract_GetConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetCustomerDocument = gql`
  query ConsultantContract_GetCustomer($id: ObjectId!) {
    customerById(id: $id) {
      ...ConsultantContractCustomerData
    }
  }
  ${ConsultantContractCustomerDataFragmentDoc}
`;
export type ConsultantContract_GetCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetCustomerQuery,
    ConsultantContract_GetCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantContract_GetCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantContract_GetCustomerComponent = (
  props: ConsultantContract_GetCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetCustomerQuery,
    ConsultantContract_GetCustomerQueryVariables
  >
    query={ConsultantContract_GetCustomerDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetCustomerQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantContract_GetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetCustomerQuery,
    ConsultantContract_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetCustomerQuery,
    ConsultantContract_GetCustomerQueryVariables
  >(ConsultantContract_GetCustomerDocument, options);
}
export function useConsultantContract_GetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetCustomerQuery,
    ConsultantContract_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetCustomerQuery,
    ConsultantContract_GetCustomerQueryVariables
  >(ConsultantContract_GetCustomerDocument, options);
}
export type ConsultantContract_GetCustomerQueryHookResult = ReturnType<
  typeof useConsultantContract_GetCustomerQuery
>;
export type ConsultantContract_GetCustomerLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetCustomerLazyQuery
>;
export namespace ConsultantContract_GetCustomer {
  export type Return = ConsultantContract_GetCustomerQuery;
  export type Variables = ConsultantContract_GetCustomerQueryVariables;
  export const OperationName = "ConsultantContract_GetCustomer";

  export const Document = ConsultantContract_GetCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_EditDocument = gql`
  mutation ConsultantContract_Edit(
    $contractId: ObjectId!
    $data: ConsultantContractFormInput!
  ) {
    editUnSignConsultantContract(contractId: $contractId, data: $data) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type ConsultantContract_EditMutationFn = Apollo.MutationFunction<
  ConsultantContract_EditMutation,
  ConsultantContract_EditMutationVariables
>;
export type ConsultantContract_EditComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_EditMutation,
    ConsultantContract_EditMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_EditComponent = (
  props: ConsultantContract_EditComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_EditMutation,
    ConsultantContract_EditMutationVariables
  >
    mutation={ConsultantContract_EditDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_EditMutation__
 *
 * To run a mutation, you first call `useConsultantContract_EditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_EditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractEditMutation, { data, loading, error }] = useConsultantContract_EditMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConsultantContract_EditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_EditMutation,
    ConsultantContract_EditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_EditMutation,
    ConsultantContract_EditMutationVariables
  >(ConsultantContract_EditDocument, options);
}
export type ConsultantContract_EditMutationHookResult = ReturnType<
  typeof useConsultantContract_EditMutation
>;
export namespace ConsultantContract_Edit {
  export type Return = ConsultantContract_EditMutation;
  export type Variables = ConsultantContract_EditMutationVariables;
  export const OperationName = "ConsultantContract_Edit";

  export const Document = ConsultantContract_EditDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_AddUnSignDocument = gql`
  mutation ConsultantContract_AddUnSign(
    $consultantId: ObjectId!
    $data: ConsultantContractFormInput!
  ) {
    addUnSignConsultantContract(consultantId: $consultantId, data: $data) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type ConsultantContract_AddUnSignMutationFn = Apollo.MutationFunction<
  ConsultantContract_AddUnSignMutation,
  ConsultantContract_AddUnSignMutationVariables
>;
export type ConsultantContract_AddUnSignComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_AddUnSignMutation,
    ConsultantContract_AddUnSignMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_AddUnSignComponent = (
  props: ConsultantContract_AddUnSignComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_AddUnSignMutation,
    ConsultantContract_AddUnSignMutationVariables
  >
    mutation={ConsultantContract_AddUnSignDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_AddUnSignMutation__
 *
 * To run a mutation, you first call `useConsultantContract_AddUnSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_AddUnSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractAddUnSignMutation, { data, loading, error }] = useConsultantContract_AddUnSignMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConsultantContract_AddUnSignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_AddUnSignMutation,
    ConsultantContract_AddUnSignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_AddUnSignMutation,
    ConsultantContract_AddUnSignMutationVariables
  >(ConsultantContract_AddUnSignDocument, options);
}
export type ConsultantContract_AddUnSignMutationHookResult = ReturnType<
  typeof useConsultantContract_AddUnSignMutation
>;
export namespace ConsultantContract_AddUnSign {
  export type Return = ConsultantContract_AddUnSignMutation;
  export type Variables = ConsultantContract_AddUnSignMutationVariables;
  export const OperationName = "ConsultantContract_AddUnSign";

  export const Document = ConsultantContract_AddUnSignDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_SoftDeleteDocument = gql`
  mutation ConsultantContract_softDelete($contractId: ObjectId!) {
    deleteConsultantContract(contractId: $contractId) {
      _id
    }
  }
`;
export type ConsultantContract_SoftDeleteMutationFn = Apollo.MutationFunction<
  ConsultantContract_SoftDeleteMutation,
  ConsultantContract_SoftDeleteMutationVariables
>;
export type ConsultantContract_SoftDeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_SoftDeleteMutation,
    ConsultantContract_SoftDeleteMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_SoftDeleteComponent = (
  props: ConsultantContract_SoftDeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_SoftDeleteMutation,
    ConsultantContract_SoftDeleteMutationVariables
  >
    mutation={ConsultantContract_SoftDeleteDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_SoftDeleteMutation__
 *
 * To run a mutation, you first call `useConsultantContract_SoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_SoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractSoftDeleteMutation, { data, loading, error }] = useConsultantContract_SoftDeleteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantContract_SoftDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_SoftDeleteMutation,
    ConsultantContract_SoftDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_SoftDeleteMutation,
    ConsultantContract_SoftDeleteMutationVariables
  >(ConsultantContract_SoftDeleteDocument, options);
}
export type ConsultantContract_SoftDeleteMutationHookResult = ReturnType<
  typeof useConsultantContract_SoftDeleteMutation
>;
export namespace ConsultantContract_softDelete {
  export type Return = ConsultantContract_SoftDeleteMutation;
  export type Variables = ConsultantContract_SoftDeleteMutationVariables;
  export const OperationName = "ConsultantContract_softDelete";

  export const Document = ConsultantContract_SoftDeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_NullifyDocument = gql`
  mutation ConsultantContract_nullify($contractId: ObjectId!, $nullify: Boolean!) {
    nullifyConsultantContract(contractId: $contractId, nullify: $nullify) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type ConsultantContract_NullifyMutationFn = Apollo.MutationFunction<
  ConsultantContract_NullifyMutation,
  ConsultantContract_NullifyMutationVariables
>;
export type ConsultantContract_NullifyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_NullifyMutation,
    ConsultantContract_NullifyMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_NullifyComponent = (
  props: ConsultantContract_NullifyComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_NullifyMutation,
    ConsultantContract_NullifyMutationVariables
  >
    mutation={ConsultantContract_NullifyDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_NullifyMutation__
 *
 * To run a mutation, you first call `useConsultantContract_NullifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_NullifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractNullifyMutation, { data, loading, error }] = useConsultantContract_NullifyMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      nullify: // value for 'nullify'
 *   },
 * });
 */
export function useConsultantContract_NullifyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_NullifyMutation,
    ConsultantContract_NullifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_NullifyMutation,
    ConsultantContract_NullifyMutationVariables
  >(ConsultantContract_NullifyDocument, options);
}
export type ConsultantContract_NullifyMutationHookResult = ReturnType<
  typeof useConsultantContract_NullifyMutation
>;
export namespace ConsultantContract_nullify {
  export type Return = ConsultantContract_NullifyMutation;
  export type Variables = ConsultantContract_NullifyMutationVariables;
  export const OperationName = "ConsultantContract_nullify";

  export const Document = ConsultantContract_NullifyDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_UploadSignedDocument = gql`
  mutation ConsultantContract_uploadSigned(
    $contractId: ObjectId!
    $file: Upload
    $SignedOn: Date
    $SalaryChoice: ContractType
    $expectedSalary: String
    $payoutType: ConsultantContractPayoutType
    $bankCounselling: Boolean
  ) {
    uploadSignedConsultantContract(
      contractId: $contractId
      file: $file
      salaryChoice: $SalaryChoice
      signedOn: $SignedOn
      expectedSalary: $expectedSalary
      payoutType: $payoutType
      bankCounselling: $bankCounselling
    ) {
      _id
      FileUrl
      IsSigned
      ViewUrl
    }
  }
`;
export type ConsultantContract_UploadSignedMutationFn = Apollo.MutationFunction<
  ConsultantContract_UploadSignedMutation,
  ConsultantContract_UploadSignedMutationVariables
>;
export type ConsultantContract_UploadSignedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_UploadSignedMutation,
    ConsultantContract_UploadSignedMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_UploadSignedComponent = (
  props: ConsultantContract_UploadSignedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_UploadSignedMutation,
    ConsultantContract_UploadSignedMutationVariables
  >
    mutation={ConsultantContract_UploadSignedDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_UploadSignedMutation__
 *
 * To run a mutation, you first call `useConsultantContract_UploadSignedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_UploadSignedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractUploadSignedMutation, { data, loading, error }] = useConsultantContract_UploadSignedMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      file: // value for 'file'
 *      SignedOn: // value for 'SignedOn'
 *      SalaryChoice: // value for 'SalaryChoice'
 *      expectedSalary: // value for 'expectedSalary'
 *      payoutType: // value for 'payoutType'
 *      bankCounselling: // value for 'bankCounselling'
 *   },
 * });
 */
export function useConsultantContract_UploadSignedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_UploadSignedMutation,
    ConsultantContract_UploadSignedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_UploadSignedMutation,
    ConsultantContract_UploadSignedMutationVariables
  >(ConsultantContract_UploadSignedDocument, options);
}
export type ConsultantContract_UploadSignedMutationHookResult = ReturnType<
  typeof useConsultantContract_UploadSignedMutation
>;
export namespace ConsultantContract_uploadSigned {
  export type Return = ConsultantContract_UploadSignedMutation;
  export type Variables = ConsultantContract_UploadSignedMutationVariables;
  export const OperationName = "ConsultantContract_uploadSigned";

  export const Document = ConsultantContract_UploadSignedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishConsultantContractDocument = gql`
  mutation publishConsultantContract($contractId: ObjectId!) {
    publishContract(contractId: $contractId) {
      contractUrl
    }
  }
`;
export type PublishConsultantContractMutationFn = Apollo.MutationFunction<
  PublishConsultantContractMutation,
  PublishConsultantContractMutationVariables
>;
export type PublishConsultantContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishConsultantContractMutation,
    PublishConsultantContractMutationVariables
  >,
  "mutation"
>;

export const PublishConsultantContractComponent = (
  props: PublishConsultantContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishConsultantContractMutation,
    PublishConsultantContractMutationVariables
  >
    mutation={PublishConsultantContractDocument}
    {...props}
  />
);

/**
 * __usePublishConsultantContractMutation__
 *
 * To run a mutation, you first call `usePublishConsultantContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishConsultantContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishConsultantContractMutation, { data, loading, error }] = usePublishConsultantContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function usePublishConsultantContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishConsultantContractMutation,
    PublishConsultantContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishConsultantContractMutation,
    PublishConsultantContractMutationVariables
  >(PublishConsultantContractDocument, options);
}
export type PublishConsultantContractMutationHookResult = ReturnType<
  typeof usePublishConsultantContractMutation
>;
export namespace PublishConsultantContract {
  export type Return = PublishConsultantContractMutation;
  export type Variables = PublishConsultantContractMutationVariables;
  export const OperationName = "publishConsultantContract";

  export const Document = PublishConsultantContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishConsultantBookingContractDocument = gql`
  mutation publishConsultantBookingContract($contractId: ObjectId!) {
    publishBookingContract(contractId: $contractId) {
      contractUrl
    }
  }
`;
export type PublishConsultantBookingContractMutationFn = Apollo.MutationFunction<
  PublishConsultantBookingContractMutation,
  PublishConsultantBookingContractMutationVariables
>;
export type PublishConsultantBookingContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishConsultantBookingContractMutation,
    PublishConsultantBookingContractMutationVariables
  >,
  "mutation"
>;

export const PublishConsultantBookingContractComponent = (
  props: PublishConsultantBookingContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishConsultantBookingContractMutation,
    PublishConsultantBookingContractMutationVariables
  >
    mutation={PublishConsultantBookingContractDocument}
    {...props}
  />
);

/**
 * __usePublishConsultantBookingContractMutation__
 *
 * To run a mutation, you first call `usePublishConsultantBookingContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishConsultantBookingContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishConsultantBookingContractMutation, { data, loading, error }] = usePublishConsultantBookingContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function usePublishConsultantBookingContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishConsultantBookingContractMutation,
    PublishConsultantBookingContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishConsultantBookingContractMutation,
    PublishConsultantBookingContractMutationVariables
  >(PublishConsultantBookingContractDocument, options);
}
export type PublishConsultantBookingContractMutationHookResult = ReturnType<
  typeof usePublishConsultantBookingContractMutation
>;
export namespace PublishConsultantBookingContract {
  export type Return = PublishConsultantBookingContractMutation;
  export type Variables = PublishConsultantBookingContractMutationVariables;
  export const OperationName = "publishConsultantBookingContract";

  export const Document = PublishConsultantBookingContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishConsultantContractViaWorkflowDocument = gql`
  mutation publishConsultantContractViaWorkflow(
    $contractId: ObjectId!
    $forcePublish: Boolean
  ) {
    publishContractViaWorkflow(contractId: $contractId, forcePublish: $forcePublish) {
      contractUrl
    }
  }
`;
export type PublishConsultantContractViaWorkflowMutationFn = Apollo.MutationFunction<
  PublishConsultantContractViaWorkflowMutation,
  PublishConsultantContractViaWorkflowMutationVariables
>;
export type PublishConsultantContractViaWorkflowComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishConsultantContractViaWorkflowMutation,
    PublishConsultantContractViaWorkflowMutationVariables
  >,
  "mutation"
>;

export const PublishConsultantContractViaWorkflowComponent = (
  props: PublishConsultantContractViaWorkflowComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishConsultantContractViaWorkflowMutation,
    PublishConsultantContractViaWorkflowMutationVariables
  >
    mutation={PublishConsultantContractViaWorkflowDocument}
    {...props}
  />
);

/**
 * __usePublishConsultantContractViaWorkflowMutation__
 *
 * To run a mutation, you first call `usePublishConsultantContractViaWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishConsultantContractViaWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishConsultantContractViaWorkflowMutation, { data, loading, error }] = usePublishConsultantContractViaWorkflowMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      forcePublish: // value for 'forcePublish'
 *   },
 * });
 */
export function usePublishConsultantContractViaWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishConsultantContractViaWorkflowMutation,
    PublishConsultantContractViaWorkflowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishConsultantContractViaWorkflowMutation,
    PublishConsultantContractViaWorkflowMutationVariables
  >(PublishConsultantContractViaWorkflowDocument, options);
}
export type PublishConsultantContractViaWorkflowMutationHookResult = ReturnType<
  typeof usePublishConsultantContractViaWorkflowMutation
>;
export namespace PublishConsultantContractViaWorkflow {
  export type Return = PublishConsultantContractViaWorkflowMutation;
  export type Variables = PublishConsultantContractViaWorkflowMutationVariables;
  export const OperationName = "publishConsultantContractViaWorkflow";

  export const Document = PublishConsultantContractViaWorkflowDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetByIdForEditDocument = gql`
  query ConsultantContract_getByIdForEdit($contractId: ObjectId!) {
    getConsultantContractDetailInfo(contractId: $contractId) {
      _id
      ...ConsultantContractDetails
    }
  }
  ${ConsultantContractDetailsFragmentDoc}
`;
export type ConsultantContract_GetByIdForEditComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetByIdForEditQuery,
    ConsultantContract_GetByIdForEditQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantContract_GetByIdForEditQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantContract_GetByIdForEditComponent = (
  props: ConsultantContract_GetByIdForEditComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetByIdForEditQuery,
    ConsultantContract_GetByIdForEditQueryVariables
  >
    query={ConsultantContract_GetByIdForEditDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetByIdForEditQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetByIdForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetByIdForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetByIdForEditQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantContract_GetByIdForEditQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetByIdForEditQuery,
    ConsultantContract_GetByIdForEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetByIdForEditQuery,
    ConsultantContract_GetByIdForEditQueryVariables
  >(ConsultantContract_GetByIdForEditDocument, options);
}
export function useConsultantContract_GetByIdForEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetByIdForEditQuery,
    ConsultantContract_GetByIdForEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetByIdForEditQuery,
    ConsultantContract_GetByIdForEditQueryVariables
  >(ConsultantContract_GetByIdForEditDocument, options);
}
export type ConsultantContract_GetByIdForEditQueryHookResult = ReturnType<
  typeof useConsultantContract_GetByIdForEditQuery
>;
export type ConsultantContract_GetByIdForEditLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetByIdForEditLazyQuery
>;
export namespace ConsultantContract_getByIdForEdit {
  export type Return = ConsultantContract_GetByIdForEditQuery;
  export type Variables = ConsultantContract_GetByIdForEditQueryVariables;
  export const OperationName = "ConsultantContract_getByIdForEdit";

  export const Document = ConsultantContract_GetByIdForEditDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetByIdForDuplicationDocument = gql`
  query ConsultantContract_getByIdForDuplication($contractId: ObjectId!) {
    getConsultantContractDetailInfo(contractId: $contractId) {
      ...ContractDataForDuplication
      SpecificPeriodPrices {
        title
        price
      }
    }
  }
  ${ContractDataForDuplicationFragmentDoc}
`;
export type ConsultantContract_GetByIdForDuplicationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetByIdForDuplicationQuery,
    ConsultantContract_GetByIdForDuplicationQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantContract_GetByIdForDuplicationQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantContract_GetByIdForDuplicationComponent = (
  props: ConsultantContract_GetByIdForDuplicationComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetByIdForDuplicationQuery,
    ConsultantContract_GetByIdForDuplicationQueryVariables
  >
    query={ConsultantContract_GetByIdForDuplicationDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetByIdForDuplicationQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetByIdForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetByIdForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetByIdForDuplicationQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantContract_GetByIdForDuplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetByIdForDuplicationQuery,
    ConsultantContract_GetByIdForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetByIdForDuplicationQuery,
    ConsultantContract_GetByIdForDuplicationQueryVariables
  >(ConsultantContract_GetByIdForDuplicationDocument, options);
}
export function useConsultantContract_GetByIdForDuplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetByIdForDuplicationQuery,
    ConsultantContract_GetByIdForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetByIdForDuplicationQuery,
    ConsultantContract_GetByIdForDuplicationQueryVariables
  >(ConsultantContract_GetByIdForDuplicationDocument, options);
}
export type ConsultantContract_GetByIdForDuplicationQueryHookResult = ReturnType<
  typeof useConsultantContract_GetByIdForDuplicationQuery
>;
export type ConsultantContract_GetByIdForDuplicationLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetByIdForDuplicationLazyQuery
>;
export namespace ConsultantContract_getByIdForDuplication {
  export type Return = ConsultantContract_GetByIdForDuplicationQuery;
  export type Variables = ConsultantContract_GetByIdForDuplicationQueryVariables;
  export const OperationName = "ConsultantContract_getByIdForDuplication";

  export const Document = ConsultantContract_GetByIdForDuplicationDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetByIdForConfirmationDocument = gql`
  query ConsultantContract_getByIdForConfirmation($contractId: ObjectId!) {
    getConsultantContractDetailInfo(contractId: $contractId) {
      _id
      Type
      Profession
      Country
      SignedOn
      ConsultantId
      SalaryChoice
      ...Salary
      SpecificPeriodPrices {
        _id
        startDate
        endDate
        title
        price
      }
      isNationalProcurementPriceStrategy
    }
  }
  ${SalaryFragmentDoc}
`;
export type ConsultantContract_GetByIdForConfirmationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetByIdForConfirmationQuery,
    ConsultantContract_GetByIdForConfirmationQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantContract_GetByIdForConfirmationQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantContract_GetByIdForConfirmationComponent = (
  props: ConsultantContract_GetByIdForConfirmationComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetByIdForConfirmationQuery,
    ConsultantContract_GetByIdForConfirmationQueryVariables
  >
    query={ConsultantContract_GetByIdForConfirmationDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetByIdForConfirmationQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetByIdForConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetByIdForConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetByIdForConfirmationQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useConsultantContract_GetByIdForConfirmationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetByIdForConfirmationQuery,
    ConsultantContract_GetByIdForConfirmationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetByIdForConfirmationQuery,
    ConsultantContract_GetByIdForConfirmationQueryVariables
  >(ConsultantContract_GetByIdForConfirmationDocument, options);
}
export function useConsultantContract_GetByIdForConfirmationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetByIdForConfirmationQuery,
    ConsultantContract_GetByIdForConfirmationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetByIdForConfirmationQuery,
    ConsultantContract_GetByIdForConfirmationQueryVariables
  >(ConsultantContract_GetByIdForConfirmationDocument, options);
}
export type ConsultantContract_GetByIdForConfirmationQueryHookResult = ReturnType<
  typeof useConsultantContract_GetByIdForConfirmationQuery
>;
export type ConsultantContract_GetByIdForConfirmationLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetByIdForConfirmationLazyQuery
>;
export namespace ConsultantContract_getByIdForConfirmation {
  export type Return = ConsultantContract_GetByIdForConfirmationQuery;
  export type Variables = ConsultantContract_GetByIdForConfirmationQueryVariables;
  export const OperationName = "ConsultantContract_getByIdForConfirmation";

  export const Document = ConsultantContract_GetByIdForConfirmationDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetHighHolidaysDocument = gql`
  query ConsultantContract_getHighHolidays {
    getHighHolidays {
      ...HighHolidayOption
    }
  }
  ${HighHolidayOptionFragmentDoc}
`;
export type ConsultantContract_GetHighHolidaysComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetHighHolidaysQuery,
    ConsultantContract_GetHighHolidaysQueryVariables
  >,
  "query"
>;

export const ConsultantContract_GetHighHolidaysComponent = (
  props: ConsultantContract_GetHighHolidaysComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetHighHolidaysQuery,
    ConsultantContract_GetHighHolidaysQueryVariables
  >
    query={ConsultantContract_GetHighHolidaysDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetHighHolidaysQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetHighHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetHighHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetHighHolidaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultantContract_GetHighHolidaysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetHighHolidaysQuery,
    ConsultantContract_GetHighHolidaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetHighHolidaysQuery,
    ConsultantContract_GetHighHolidaysQueryVariables
  >(ConsultantContract_GetHighHolidaysDocument, options);
}
export function useConsultantContract_GetHighHolidaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetHighHolidaysQuery,
    ConsultantContract_GetHighHolidaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetHighHolidaysQuery,
    ConsultantContract_GetHighHolidaysQueryVariables
  >(ConsultantContract_GetHighHolidaysDocument, options);
}
export type ConsultantContract_GetHighHolidaysQueryHookResult = ReturnType<
  typeof useConsultantContract_GetHighHolidaysQuery
>;
export type ConsultantContract_GetHighHolidaysLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetHighHolidaysLazyQuery
>;
export namespace ConsultantContract_getHighHolidays {
  export type Return = ConsultantContract_GetHighHolidaysQuery;
  export type Variables = ConsultantContract_GetHighHolidaysQueryVariables;
  export const OperationName = "ConsultantContract_getHighHolidays";

  export const Document = ConsultantContract_GetHighHolidaysDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetCustomerPriceListDocument = gql`
  query ConsultantContract_getCustomerPriceList(
    $consultantId: ObjectId!
    $customerIds: [ObjectId!]
  ) {
    getCustomerContractPriceLists(customerIds: $customerIds) {
      _id
      contractNumber
      priceLists {
        priceGroups {
          _id
          professionsPrice {
            profession {
              areaOfExpertise
              name
            }
          }
          highHolidays {
            ...HighHoliday
          }
          records {
            ...contractsPriceRecord
          }
        }
        name
        startDate
        endDate
      }
    }
    consultantBookingContracts: getConsultantBookingContractsByCustomerId(
      consultantId: $consultantId
      customerIds: $customerIds
    ) {
      ...BookingContractDataForDuplication
      ...ContractBookingAddress
      Period
      StartDate
      EndDate
      ResponsiblePersonId
      SignedOn
    }
  }
  ${HighHolidayFragmentDoc}
  ${ContractsPriceRecordFragmentDoc}
  ${BookingContractDataForDuplicationFragmentDoc}
  ${ContractBookingAddressFragmentDoc}
`;
export type ConsultantContract_GetCustomerPriceListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetCustomerPriceListQuery,
    ConsultantContract_GetCustomerPriceListQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantContract_GetCustomerPriceListQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantContract_GetCustomerPriceListComponent = (
  props: ConsultantContract_GetCustomerPriceListComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetCustomerPriceListQuery,
    ConsultantContract_GetCustomerPriceListQueryVariables
  >
    query={ConsultantContract_GetCustomerPriceListDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetCustomerPriceListQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetCustomerPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetCustomerPriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetCustomerPriceListQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useConsultantContract_GetCustomerPriceListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetCustomerPriceListQuery,
    ConsultantContract_GetCustomerPriceListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetCustomerPriceListQuery,
    ConsultantContract_GetCustomerPriceListQueryVariables
  >(ConsultantContract_GetCustomerPriceListDocument, options);
}
export function useConsultantContract_GetCustomerPriceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetCustomerPriceListQuery,
    ConsultantContract_GetCustomerPriceListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetCustomerPriceListQuery,
    ConsultantContract_GetCustomerPriceListQueryVariables
  >(ConsultantContract_GetCustomerPriceListDocument, options);
}
export type ConsultantContract_GetCustomerPriceListQueryHookResult = ReturnType<
  typeof useConsultantContract_GetCustomerPriceListQuery
>;
export type ConsultantContract_GetCustomerPriceListLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetCustomerPriceListLazyQuery
>;
export namespace ConsultantContract_getCustomerPriceList {
  export type Return = ConsultantContract_GetCustomerPriceListQuery;
  export type Variables = ConsultantContract_GetCustomerPriceListQueryVariables;
  export const OperationName = "ConsultantContract_getCustomerPriceList";

  export const Document = ConsultantContract_GetCustomerPriceListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetConsultantPayoutByYearDocument = gql`
  query ConsultantContract_getConsultantPayoutByYear($consultantId: ObjectId!) {
    getConsultantPayoutByYear(consultantId: $consultantId) {
      total
      totalNationalProcurement
      totalNonNationalProcurement
      year
    }
  }
`;
export type ConsultantContract_GetConsultantPayoutByYearComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetConsultantPayoutByYearQuery,
    ConsultantContract_GetConsultantPayoutByYearQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantContract_GetConsultantPayoutByYearQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantContract_GetConsultantPayoutByYearComponent = (
  props: ConsultantContract_GetConsultantPayoutByYearComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetConsultantPayoutByYearQuery,
    ConsultantContract_GetConsultantPayoutByYearQueryVariables
  >
    query={ConsultantContract_GetConsultantPayoutByYearDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetConsultantPayoutByYearQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetConsultantPayoutByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetConsultantPayoutByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetConsultantPayoutByYearQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantContract_GetConsultantPayoutByYearQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetConsultantPayoutByYearQuery,
    ConsultantContract_GetConsultantPayoutByYearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetConsultantPayoutByYearQuery,
    ConsultantContract_GetConsultantPayoutByYearQueryVariables
  >(ConsultantContract_GetConsultantPayoutByYearDocument, options);
}
export function useConsultantContract_GetConsultantPayoutByYearLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetConsultantPayoutByYearQuery,
    ConsultantContract_GetConsultantPayoutByYearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetConsultantPayoutByYearQuery,
    ConsultantContract_GetConsultantPayoutByYearQueryVariables
  >(ConsultantContract_GetConsultantPayoutByYearDocument, options);
}
export type ConsultantContract_GetConsultantPayoutByYearQueryHookResult = ReturnType<
  typeof useConsultantContract_GetConsultantPayoutByYearQuery
>;
export type ConsultantContract_GetConsultantPayoutByYearLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetConsultantPayoutByYearLazyQuery
>;
export namespace ConsultantContract_getConsultantPayoutByYear {
  export type Return = ConsultantContract_GetConsultantPayoutByYearQuery;
  export type Variables = ConsultantContract_GetConsultantPayoutByYearQueryVariables;
  export const OperationName = "ConsultantContract_getConsultantPayoutByYear";

  export const Document = ConsultantContract_GetConsultantPayoutByYearDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SendEmailDocument = gql`
  mutation sendEmail($input: EmailInput) {
    sendEmail(input: $input)
  }
`;
export type SendEmailMutationFn = Apollo.MutationFunction<
  SendEmailMutation,
  SendEmailMutationVariables
>;
export type SendEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendEmailMutation,
    SendEmailMutationVariables
  >,
  "mutation"
>;

export const SendEmailComponent = (props: SendEmailComponentProps) => (
  <ApolloReactComponents.Mutation<SendEmailMutation, SendEmailMutationVariables>
    mutation={SendEmailDocument}
    {...props}
  />
);

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(
    SendEmailDocument,
    options
  );
}
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export namespace SendEmail {
  export type Return = SendEmailMutation;
  export type Variables = SendEmailMutationVariables;
  export const OperationName = "sendEmail";

  export const Document = SendEmailDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetParentOrganizationTypeDocument = gql`
  query ConsultantContract_GetParentOrganizationType($id: ObjectId!) {
    customerById(id: $id) {
      OrganizationType
    }
  }
`;
export type ConsultantContract_GetParentOrganizationTypeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetParentOrganizationTypeQuery,
    ConsultantContract_GetParentOrganizationTypeQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantContract_GetParentOrganizationTypeQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantContract_GetParentOrganizationTypeComponent = (
  props: ConsultantContract_GetParentOrganizationTypeComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetParentOrganizationTypeQuery,
    ConsultantContract_GetParentOrganizationTypeQueryVariables
  >
    query={ConsultantContract_GetParentOrganizationTypeDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetParentOrganizationTypeQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetParentOrganizationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetParentOrganizationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetParentOrganizationTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantContract_GetParentOrganizationTypeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetParentOrganizationTypeQuery,
    ConsultantContract_GetParentOrganizationTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetParentOrganizationTypeQuery,
    ConsultantContract_GetParentOrganizationTypeQueryVariables
  >(ConsultantContract_GetParentOrganizationTypeDocument, options);
}
export function useConsultantContract_GetParentOrganizationTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetParentOrganizationTypeQuery,
    ConsultantContract_GetParentOrganizationTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetParentOrganizationTypeQuery,
    ConsultantContract_GetParentOrganizationTypeQueryVariables
  >(ConsultantContract_GetParentOrganizationTypeDocument, options);
}
export type ConsultantContract_GetParentOrganizationTypeQueryHookResult = ReturnType<
  typeof useConsultantContract_GetParentOrganizationTypeQuery
>;
export type ConsultantContract_GetParentOrganizationTypeLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetParentOrganizationTypeLazyQuery
>;
export namespace ConsultantContract_GetParentOrganizationType {
  export type Return = ConsultantContract_GetParentOrganizationTypeQuery;
  export type Variables = ConsultantContract_GetParentOrganizationTypeQueryVariables;
  export const OperationName = "ConsultantContract_GetParentOrganizationType";

  export const Document = ConsultantContract_GetParentOrganizationTypeDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_GetContractsByConsultantIdDocument = gql`
  query ConsultantContract_getContractsByConsultantId($consultantId: ObjectId!) {
    getConsultantContracts(consultantId: $consultantId) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type ConsultantContract_GetContractsByConsultantIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantContract_GetContractsByConsultantIdQuery,
    ConsultantContract_GetContractsByConsultantIdQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantContract_GetContractsByConsultantIdQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantContract_GetContractsByConsultantIdComponent = (
  props: ConsultantContract_GetContractsByConsultantIdComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantContract_GetContractsByConsultantIdQuery,
    ConsultantContract_GetContractsByConsultantIdQueryVariables
  >
    query={ConsultantContract_GetContractsByConsultantIdDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_GetContractsByConsultantIdQuery__
 *
 * To run a query within a React component, call `useConsultantContract_GetContractsByConsultantIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_GetContractsByConsultantIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantContract_GetContractsByConsultantIdQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantContract_GetContractsByConsultantIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantContract_GetContractsByConsultantIdQuery,
    ConsultantContract_GetContractsByConsultantIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantContract_GetContractsByConsultantIdQuery,
    ConsultantContract_GetContractsByConsultantIdQueryVariables
  >(ConsultantContract_GetContractsByConsultantIdDocument, options);
}
export function useConsultantContract_GetContractsByConsultantIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantContract_GetContractsByConsultantIdQuery,
    ConsultantContract_GetContractsByConsultantIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantContract_GetContractsByConsultantIdQuery,
    ConsultantContract_GetContractsByConsultantIdQueryVariables
  >(ConsultantContract_GetContractsByConsultantIdDocument, options);
}
export type ConsultantContract_GetContractsByConsultantIdQueryHookResult = ReturnType<
  typeof useConsultantContract_GetContractsByConsultantIdQuery
>;
export type ConsultantContract_GetContractsByConsultantIdLazyQueryHookResult = ReturnType<
  typeof useConsultantContract_GetContractsByConsultantIdLazyQuery
>;
export namespace ConsultantContract_getContractsByConsultantId {
  export type Return = ConsultantContract_GetContractsByConsultantIdQuery;
  export type Variables = ConsultantContract_GetContractsByConsultantIdQueryVariables;
  export const OperationName = "ConsultantContract_getContractsByConsultantId";

  export const Document = ConsultantContract_GetContractsByConsultantIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantContract_SendEmailDocument = gql`
  mutation ConsultantContract_sendEmail(
    $subject: String!
    $body: String!
    $consultantId: ObjectId!
    $attachment: [ObjectId]
  ) {
    sendConsultantContractEmailToConsultant(
      subject: $subject
      body: $body
      consultantId: $consultantId
      attachment: $attachment
    ) {
      Subject
      Body
    }
  }
`;
export type ConsultantContract_SendEmailMutationFn = Apollo.MutationFunction<
  ConsultantContract_SendEmailMutation,
  ConsultantContract_SendEmailMutationVariables
>;
export type ConsultantContract_SendEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_SendEmailMutation,
    ConsultantContract_SendEmailMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_SendEmailComponent = (
  props: ConsultantContract_SendEmailComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_SendEmailMutation,
    ConsultantContract_SendEmailMutationVariables
  >
    mutation={ConsultantContract_SendEmailDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_SendEmailMutation__
 *
 * To run a mutation, you first call `useConsultantContract_SendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_SendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractSendEmailMutation, { data, loading, error }] = useConsultantContract_SendEmailMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      consultantId: // value for 'consultantId'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useConsultantContract_SendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_SendEmailMutation,
    ConsultantContract_SendEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_SendEmailMutation,
    ConsultantContract_SendEmailMutationVariables
  >(ConsultantContract_SendEmailDocument, options);
}
export type ConsultantContract_SendEmailMutationHookResult = ReturnType<
  typeof useConsultantContract_SendEmailMutation
>;
export namespace ConsultantContract_sendEmail {
  export type Return = ConsultantContract_SendEmailMutation;
  export type Variables = ConsultantContract_SendEmailMutationVariables;
  export const OperationName = "ConsultantContract_sendEmail";

  export const Document = ConsultantContract_SendEmailDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantContract_AddSalaryChoiceDocument = gql`
  mutation ConsultantContract_addSalaryChoice(
    $contractId: ObjectId!
    $salaryChoice: ContractType!
  ) {
    addSalaryChoiceToConsultantContract(
      contractId: $contractId
      salaryChoice: $salaryChoice
    ) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type ConsultantContract_AddSalaryChoiceMutationFn = Apollo.MutationFunction<
  ConsultantContract_AddSalaryChoiceMutation,
  ConsultantContract_AddSalaryChoiceMutationVariables
>;
export type ConsultantContract_AddSalaryChoiceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantContract_AddSalaryChoiceMutation,
    ConsultantContract_AddSalaryChoiceMutationVariables
  >,
  "mutation"
>;

export const ConsultantContract_AddSalaryChoiceComponent = (
  props: ConsultantContract_AddSalaryChoiceComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantContract_AddSalaryChoiceMutation,
    ConsultantContract_AddSalaryChoiceMutationVariables
  >
    mutation={ConsultantContract_AddSalaryChoiceDocument}
    {...props}
  />
);

/**
 * __useConsultantContract_AddSalaryChoiceMutation__
 *
 * To run a mutation, you first call `useConsultantContract_AddSalaryChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantContract_AddSalaryChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantContractAddSalaryChoiceMutation, { data, loading, error }] = useConsultantContract_AddSalaryChoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      salaryChoice: // value for 'salaryChoice'
 *   },
 * });
 */
export function useConsultantContract_AddSalaryChoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantContract_AddSalaryChoiceMutation,
    ConsultantContract_AddSalaryChoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantContract_AddSalaryChoiceMutation,
    ConsultantContract_AddSalaryChoiceMutationVariables
  >(ConsultantContract_AddSalaryChoiceDocument, options);
}
export type ConsultantContract_AddSalaryChoiceMutationHookResult = ReturnType<
  typeof useConsultantContract_AddSalaryChoiceMutation
>;
export namespace ConsultantContract_addSalaryChoice {
  export type Return = ConsultantContract_AddSalaryChoiceMutation;
  export type Variables = ConsultantContract_AddSalaryChoiceMutationVariables;
  export const OperationName = "ConsultantContract_addSalaryChoice";

  export const Document = ConsultantContract_AddSalaryChoiceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantEditor_GetFormDocument = gql`
  query ConsultantEditor_GetForm($consultantId: ObjectId!) {
    consultantFormById(consultantId: $consultantId) {
      ...ConsultantEditor_Form
    }
    consultantById(id: $consultantId) {
      ...ConsultantEditorConsultantData
    }
  }
  ${ConsultantEditor_FormFragmentDoc}
  ${ConsultantEditorConsultantDataFragmentDoc}
`;
export type ConsultantEditor_GetFormComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantEditor_GetFormQuery,
    ConsultantEditor_GetFormQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantEditor_GetFormQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantEditor_GetFormComponent = (
  props: ConsultantEditor_GetFormComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantEditor_GetFormQuery,
    ConsultantEditor_GetFormQueryVariables
  >
    query={ConsultantEditor_GetFormDocument}
    {...props}
  />
);

/**
 * __useConsultantEditor_GetFormQuery__
 *
 * To run a query within a React component, call `useConsultantEditor_GetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantEditor_GetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantEditor_GetFormQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantEditor_GetFormQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantEditor_GetFormQuery,
    ConsultantEditor_GetFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantEditor_GetFormQuery,
    ConsultantEditor_GetFormQueryVariables
  >(ConsultantEditor_GetFormDocument, options);
}
export function useConsultantEditor_GetFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantEditor_GetFormQuery,
    ConsultantEditor_GetFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantEditor_GetFormQuery,
    ConsultantEditor_GetFormQueryVariables
  >(ConsultantEditor_GetFormDocument, options);
}
export type ConsultantEditor_GetFormQueryHookResult = ReturnType<
  typeof useConsultantEditor_GetFormQuery
>;
export type ConsultantEditor_GetFormLazyQueryHookResult = ReturnType<
  typeof useConsultantEditor_GetFormLazyQuery
>;
export namespace ConsultantEditor_GetForm {
  export type Return = ConsultantEditor_GetFormQuery;
  export type Variables = ConsultantEditor_GetFormQueryVariables;
  export const OperationName = "ConsultantEditor_GetForm";

  export const Document = ConsultantEditor_GetFormDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantEditor_GetDepartmentsDocument = gql`
  query ConsultantEditor_GetDepartments($hospitalIds: [ObjectId]) {
    departments: customers(
      filter: { parentId: $hospitalIds, type: [Department] }
      limit: 1000
      skip: 0
    ) {
      items {
        _id
        Name
        DirectParent {
          Id
        }
      }
      dbTime
    }
  }
`;
export type ConsultantEditor_GetDepartmentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantEditor_GetDepartmentsQuery,
    ConsultantEditor_GetDepartmentsQueryVariables
  >,
  "query"
>;

export const ConsultantEditor_GetDepartmentsComponent = (
  props: ConsultantEditor_GetDepartmentsComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantEditor_GetDepartmentsQuery,
    ConsultantEditor_GetDepartmentsQueryVariables
  >
    query={ConsultantEditor_GetDepartmentsDocument}
    {...props}
  />
);

/**
 * __useConsultantEditor_GetDepartmentsQuery__
 *
 * To run a query within a React component, call `useConsultantEditor_GetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantEditor_GetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantEditor_GetDepartmentsQuery({
 *   variables: {
 *      hospitalIds: // value for 'hospitalIds'
 *   },
 * });
 */
export function useConsultantEditor_GetDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantEditor_GetDepartmentsQuery,
    ConsultantEditor_GetDepartmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantEditor_GetDepartmentsQuery,
    ConsultantEditor_GetDepartmentsQueryVariables
  >(ConsultantEditor_GetDepartmentsDocument, options);
}
export function useConsultantEditor_GetDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantEditor_GetDepartmentsQuery,
    ConsultantEditor_GetDepartmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantEditor_GetDepartmentsQuery,
    ConsultantEditor_GetDepartmentsQueryVariables
  >(ConsultantEditor_GetDepartmentsDocument, options);
}
export type ConsultantEditor_GetDepartmentsQueryHookResult = ReturnType<
  typeof useConsultantEditor_GetDepartmentsQuery
>;
export type ConsultantEditor_GetDepartmentsLazyQueryHookResult = ReturnType<
  typeof useConsultantEditor_GetDepartmentsLazyQuery
>;
export namespace ConsultantEditor_GetDepartments {
  export type Return = ConsultantEditor_GetDepartmentsQuery;
  export type Variables = ConsultantEditor_GetDepartmentsQueryVariables;
  export const OperationName = "ConsultantEditor_GetDepartments";

  export const Document = ConsultantEditor_GetDepartmentsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantEditor_UpdateStatusDocument = gql`
  mutation ConsultantEditor_UpdateStatus($id: ObjectId!, $status: ConsultantStatus!) {
    updateConsultantStatus(id: $id, status: $status) {
      _id
      Name
      Status
    }
  }
`;
export type ConsultantEditor_UpdateStatusMutationFn = Apollo.MutationFunction<
  ConsultantEditor_UpdateStatusMutation,
  ConsultantEditor_UpdateStatusMutationVariables
>;
export type ConsultantEditor_UpdateStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantEditor_UpdateStatusMutation,
    ConsultantEditor_UpdateStatusMutationVariables
  >,
  "mutation"
>;

export const ConsultantEditor_UpdateStatusComponent = (
  props: ConsultantEditor_UpdateStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantEditor_UpdateStatusMutation,
    ConsultantEditor_UpdateStatusMutationVariables
  >
    mutation={ConsultantEditor_UpdateStatusDocument}
    {...props}
  />
);

/**
 * __useConsultantEditor_UpdateStatusMutation__
 *
 * To run a mutation, you first call `useConsultantEditor_UpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantEditor_UpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantEditorUpdateStatusMutation, { data, loading, error }] = useConsultantEditor_UpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useConsultantEditor_UpdateStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantEditor_UpdateStatusMutation,
    ConsultantEditor_UpdateStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantEditor_UpdateStatusMutation,
    ConsultantEditor_UpdateStatusMutationVariables
  >(ConsultantEditor_UpdateStatusDocument, options);
}
export type ConsultantEditor_UpdateStatusMutationHookResult = ReturnType<
  typeof useConsultantEditor_UpdateStatusMutation
>;
export namespace ConsultantEditor_UpdateStatus {
  export type Return = ConsultantEditor_UpdateStatusMutation;
  export type Variables = ConsultantEditor_UpdateStatusMutationVariables;
  export const OperationName = "ConsultantEditor_UpdateStatus";

  export const Document = ConsultantEditor_UpdateStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantEditor_ImportCVDocument = gql`
  mutation ConsultantEditor_ImportCV($consultantId: ObjectId, $file: Upload!) {
    importCV(consultantId: $consultantId, file: $file) {
      ...ConsultantEditor_Form
    }
  }
  ${ConsultantEditor_FormFragmentDoc}
`;
export type ConsultantEditor_ImportCVMutationFn = Apollo.MutationFunction<
  ConsultantEditor_ImportCVMutation,
  ConsultantEditor_ImportCVMutationVariables
>;
export type ConsultantEditor_ImportCVComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantEditor_ImportCVMutation,
    ConsultantEditor_ImportCVMutationVariables
  >,
  "mutation"
>;

export const ConsultantEditor_ImportCVComponent = (
  props: ConsultantEditor_ImportCVComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantEditor_ImportCVMutation,
    ConsultantEditor_ImportCVMutationVariables
  >
    mutation={ConsultantEditor_ImportCVDocument}
    {...props}
  />
);

/**
 * __useConsultantEditor_ImportCVMutation__
 *
 * To run a mutation, you first call `useConsultantEditor_ImportCVMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantEditor_ImportCVMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantEditorImportCvMutation, { data, loading, error }] = useConsultantEditor_ImportCVMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useConsultantEditor_ImportCVMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantEditor_ImportCVMutation,
    ConsultantEditor_ImportCVMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantEditor_ImportCVMutation,
    ConsultantEditor_ImportCVMutationVariables
  >(ConsultantEditor_ImportCVDocument, options);
}
export type ConsultantEditor_ImportCVMutationHookResult = ReturnType<
  typeof useConsultantEditor_ImportCVMutation
>;
export namespace ConsultantEditor_ImportCV {
  export type Return = ConsultantEditor_ImportCVMutation;
  export type Variables = ConsultantEditor_ImportCVMutationVariables;
  export const OperationName = "ConsultantEditor_ImportCV";

  export const Document = ConsultantEditor_ImportCVDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantEditor_SubmitDocument = gql`
  mutation ConsultantEditor_Submit(
    $consultantId: ObjectId!
    $data: ConsultantFormInput!
    $file: Upload
  ) {
    submitConsultantForm(consultantId: $consultantId, data: $data, file: $file) {
      OK
      Consultant {
        ...ConsultantProfile_Consultant
      }
      ConsultantForm {
        ...ConsultantEditor_Form
      }
      ValidationErrors {
        Message
        Path
      }
      Errors
    }
  }
  ${ConsultantProfile_ConsultantFragmentDoc}
  ${ConsultantEditor_FormFragmentDoc}
`;
export type ConsultantEditor_SubmitMutationFn = Apollo.MutationFunction<
  ConsultantEditor_SubmitMutation,
  ConsultantEditor_SubmitMutationVariables
>;
export type ConsultantEditor_SubmitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantEditor_SubmitMutation,
    ConsultantEditor_SubmitMutationVariables
  >,
  "mutation"
>;

export const ConsultantEditor_SubmitComponent = (
  props: ConsultantEditor_SubmitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantEditor_SubmitMutation,
    ConsultantEditor_SubmitMutationVariables
  >
    mutation={ConsultantEditor_SubmitDocument}
    {...props}
  />
);

/**
 * __useConsultantEditor_SubmitMutation__
 *
 * To run a mutation, you first call `useConsultantEditor_SubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantEditor_SubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantEditorSubmitMutation, { data, loading, error }] = useConsultantEditor_SubmitMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useConsultantEditor_SubmitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantEditor_SubmitMutation,
    ConsultantEditor_SubmitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantEditor_SubmitMutation,
    ConsultantEditor_SubmitMutationVariables
  >(ConsultantEditor_SubmitDocument, options);
}
export type ConsultantEditor_SubmitMutationHookResult = ReturnType<
  typeof useConsultantEditor_SubmitMutation
>;
export namespace ConsultantEditor_Submit {
  export type Return = ConsultantEditor_SubmitMutation;
  export type Variables = ConsultantEditor_SubmitMutationVariables;
  export const OperationName = "ConsultantEditor_Submit";

  export const Document = ConsultantEditor_SubmitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantEditor_FindConsultantDuplicateDocument = gql`
  query ConsultantEditor_FindConsultantDuplicate($filter: CheckContactExistsInput!) {
    findConsultantDuplicate(filter: $filter) {
      _id
      Name
      Email
      SocialSecurityNo
    }
    findConsultantSimilar(filter: $filter) {
      _id
      Name
      Email
    }
  }
`;
export type ConsultantEditor_FindConsultantDuplicateComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantEditor_FindConsultantDuplicateQuery,
    ConsultantEditor_FindConsultantDuplicateQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantEditor_FindConsultantDuplicateQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantEditor_FindConsultantDuplicateComponent = (
  props: ConsultantEditor_FindConsultantDuplicateComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantEditor_FindConsultantDuplicateQuery,
    ConsultantEditor_FindConsultantDuplicateQueryVariables
  >
    query={ConsultantEditor_FindConsultantDuplicateDocument}
    {...props}
  />
);

/**
 * __useConsultantEditor_FindConsultantDuplicateQuery__
 *
 * To run a query within a React component, call `useConsultantEditor_FindConsultantDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantEditor_FindConsultantDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantEditor_FindConsultantDuplicateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConsultantEditor_FindConsultantDuplicateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantEditor_FindConsultantDuplicateQuery,
    ConsultantEditor_FindConsultantDuplicateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantEditor_FindConsultantDuplicateQuery,
    ConsultantEditor_FindConsultantDuplicateQueryVariables
  >(ConsultantEditor_FindConsultantDuplicateDocument, options);
}
export function useConsultantEditor_FindConsultantDuplicateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantEditor_FindConsultantDuplicateQuery,
    ConsultantEditor_FindConsultantDuplicateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantEditor_FindConsultantDuplicateQuery,
    ConsultantEditor_FindConsultantDuplicateQueryVariables
  >(ConsultantEditor_FindConsultantDuplicateDocument, options);
}
export type ConsultantEditor_FindConsultantDuplicateQueryHookResult = ReturnType<
  typeof useConsultantEditor_FindConsultantDuplicateQuery
>;
export type ConsultantEditor_FindConsultantDuplicateLazyQueryHookResult = ReturnType<
  typeof useConsultantEditor_FindConsultantDuplicateLazyQuery
>;
export namespace ConsultantEditor_FindConsultantDuplicate {
  export type Return = ConsultantEditor_FindConsultantDuplicateQuery;
  export type Variables = ConsultantEditor_FindConsultantDuplicateQueryVariables;
  export const OperationName = "ConsultantEditor_FindConsultantDuplicate";

  export const Document = ConsultantEditor_FindConsultantDuplicateDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantsByWeeksDocument = gql`
  query GetConsultantsByWeeks(
    $filter: ConsultantsByWeeksQueryInput
    $skip: Int!
    $limit: Int!
    $withEvents: Boolean = false
  ) {
    consultantsByWeeks(filter: $filter, skip: $skip, limit: $limit) {
      Week
      Consultant {
        ...ConsultantSearchCard
        Events @include(if: $withEvents) {
          ...EventLog_Event
        }
      }
    }
  }
  ${ConsultantSearchCardFragmentDoc}
  ${EventLog_EventFragmentDoc}
`;
export type GetConsultantsByWeeksComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantsByWeeksQuery,
    GetConsultantsByWeeksQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantsByWeeksQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantsByWeeksComponent = (
  props: GetConsultantsByWeeksComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantsByWeeksQuery,
    GetConsultantsByWeeksQueryVariables
  >
    query={GetConsultantsByWeeksDocument}
    {...props}
  />
);

/**
 * __useGetConsultantsByWeeksQuery__
 *
 * To run a query within a React component, call `useGetConsultantsByWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantsByWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantsByWeeksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      withEvents: // value for 'withEvents'
 *   },
 * });
 */
export function useGetConsultantsByWeeksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantsByWeeksQuery,
    GetConsultantsByWeeksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConsultantsByWeeksQuery, GetConsultantsByWeeksQueryVariables>(
    GetConsultantsByWeeksDocument,
    options
  );
}
export function useGetConsultantsByWeeksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantsByWeeksQuery,
    GetConsultantsByWeeksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantsByWeeksQuery,
    GetConsultantsByWeeksQueryVariables
  >(GetConsultantsByWeeksDocument, options);
}
export type GetConsultantsByWeeksQueryHookResult = ReturnType<
  typeof useGetConsultantsByWeeksQuery
>;
export type GetConsultantsByWeeksLazyQueryHookResult = ReturnType<
  typeof useGetConsultantsByWeeksLazyQuery
>;
export namespace GetConsultantsByWeeks {
  export type Return = GetConsultantsByWeeksQuery;
  export type Variables = GetConsultantsByWeeksQueryVariables;
  export const OperationName = "GetConsultantsByWeeks";

  export const Document = GetConsultantsByWeeksDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantsDocument = gql`
  query Consultants(
    $filter: ConsultantsQueryInput
    $skip: Int!
    $limit: Int!
    $sortBy: ConsultantTableColumns
    $sortOrder: SortOrder
    $withEvents: Boolean!
    $filterText: String!
  ) {
    consultants(
      filter: $filter
      includeEvents: $withEvents
      limit: $limit
      skip: $skip
      sortBy: $sortBy
      sortOrder: $sortOrder
      withSecondarySearch: true
    ) {
      items {
        ...ConsultantSearchCard
        Events(text: $filterText) @include(if: $withEvents) {
          ...EventLog_Event
        }
      }
      secondarySearch {
        ...ConsultantSearchCard
        Events(text: $filterText) @include(if: $withEvents) {
          ...EventLog_Event
        }
      }
      skip
      limit
    }
  }
  ${ConsultantSearchCardFragmentDoc}
  ${EventLog_EventFragmentDoc}
`;
export type ConsultantsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantsQuery,
    ConsultantsQueryVariables
  >,
  "query"
> &
  ({ variables: ConsultantsQueryVariables; skip?: boolean } | { skip: boolean });

export const ConsultantsComponent = (props: ConsultantsComponentProps) => (
  <ApolloReactComponents.Query<ConsultantsQuery, ConsultantsQueryVariables>
    query={ConsultantsDocument}
    {...props}
  />
);

/**
 * __useConsultantsQuery__
 *
 * To run a query within a React component, call `useConsultantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      withEvents: // value for 'withEvents'
 *      filterText: // value for 'filterText'
 *   },
 * });
 */
export function useConsultantsQuery(
  baseOptions?: Apollo.QueryHookOptions<ConsultantsQuery, ConsultantsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConsultantsQuery, ConsultantsQueryVariables>(
    ConsultantsDocument,
    options
  );
}
export function useConsultantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConsultantsQuery, ConsultantsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConsultantsQuery, ConsultantsQueryVariables>(
    ConsultantsDocument,
    options
  );
}
export type ConsultantsQueryHookResult = ReturnType<typeof useConsultantsQuery>;
export type ConsultantsLazyQueryHookResult = ReturnType<typeof useConsultantsLazyQuery>;
export namespace Consultants {
  export type Return = ConsultantsQuery;
  export type Variables = ConsultantsQueryVariables;
  export const OperationName = "Consultants";

  export const Document = ConsultantsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantsTotalDocument = gql`
  query getConsultantsTotal($filter: ConsultantsQueryInput) {
    consultantsTotal(filter: $filter) {
      total
      dbTime
    }
  }
`;
export type GetConsultantsTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantsTotalQuery,
    GetConsultantsTotalQueryVariables
  >,
  "query"
>;

export const GetConsultantsTotalComponent = (
  props: GetConsultantsTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantsTotalQuery,
    GetConsultantsTotalQueryVariables
  >
    query={GetConsultantsTotalDocument}
    {...props}
  />
);

/**
 * __useGetConsultantsTotalQuery__
 *
 * To run a query within a React component, call `useGetConsultantsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantsTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetConsultantsTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantsTotalQuery,
    GetConsultantsTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConsultantsTotalQuery, GetConsultantsTotalQueryVariables>(
    GetConsultantsTotalDocument,
    options
  );
}
export function useGetConsultantsTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantsTotalQuery,
    GetConsultantsTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConsultantsTotalQuery, GetConsultantsTotalQueryVariables>(
    GetConsultantsTotalDocument,
    options
  );
}
export type GetConsultantsTotalQueryHookResult = ReturnType<
  typeof useGetConsultantsTotalQuery
>;
export type GetConsultantsTotalLazyQueryHookResult = ReturnType<
  typeof useGetConsultantsTotalLazyQuery
>;
export namespace GetConsultantsTotal {
  export type Return = GetConsultantsTotalQuery;
  export type Variables = GetConsultantsTotalQueryVariables;
  export const OperationName = "getConsultantsTotal";

  export const Document = GetConsultantsTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantsMassListDocument = gql`
  query ConsultantsMassList($filter: ConsultantsQueryInput, $limit: Int!) {
    consultants(filter: $filter, limit: $limit, skip: 0) {
      items {
        ...ContactListItem
      }
      total
    }
  }
  ${ContactListItemFragmentDoc}
`;
export type ConsultantsMassListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantsMassListQuery,
    ConsultantsMassListQueryVariables
  >,
  "query"
> &
  ({ variables: ConsultantsMassListQueryVariables; skip?: boolean } | { skip: boolean });

export const ConsultantsMassListComponent = (
  props: ConsultantsMassListComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantsMassListQuery,
    ConsultantsMassListQueryVariables
  >
    query={ConsultantsMassListDocument}
    {...props}
  />
);

/**
 * __useConsultantsMassListQuery__
 *
 * To run a query within a React component, call `useConsultantsMassListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantsMassListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantsMassListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useConsultantsMassListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantsMassListQuery,
    ConsultantsMassListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConsultantsMassListQuery, ConsultantsMassListQueryVariables>(
    ConsultantsMassListDocument,
    options
  );
}
export function useConsultantsMassListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantsMassListQuery,
    ConsultantsMassListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConsultantsMassListQuery, ConsultantsMassListQueryVariables>(
    ConsultantsMassListDocument,
    options
  );
}
export type ConsultantsMassListQueryHookResult = ReturnType<
  typeof useConsultantsMassListQuery
>;
export type ConsultantsMassListLazyQueryHookResult = ReturnType<
  typeof useConsultantsMassListLazyQuery
>;
export namespace ConsultantsMassList {
  export type Return = ConsultantsMassListQuery;
  export type Variables = ConsultantsMassListQueryVariables;
  export const OperationName = "ConsultantsMassList";

  export const Document = ConsultantsMassListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantsCountDocument = gql`
  query ConsultantsCount($filter: ConsultantsQueryInput) {
    consultants(filter: $filter) {
      total
    }
  }
`;
export type ConsultantsCountComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantsCountQuery,
    ConsultantsCountQueryVariables
  >,
  "query"
>;

export const ConsultantsCountComponent = (props: ConsultantsCountComponentProps) => (
  <ApolloReactComponents.Query<ConsultantsCountQuery, ConsultantsCountQueryVariables>
    query={ConsultantsCountDocument}
    {...props}
  />
);

/**
 * __useConsultantsCountQuery__
 *
 * To run a query within a React component, call `useConsultantsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConsultantsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantsCountQuery,
    ConsultantsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConsultantsCountQuery, ConsultantsCountQueryVariables>(
    ConsultantsCountDocument,
    options
  );
}
export function useConsultantsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantsCountQuery,
    ConsultantsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConsultantsCountQuery, ConsultantsCountQueryVariables>(
    ConsultantsCountDocument,
    options
  );
}
export type ConsultantsCountQueryHookResult = ReturnType<typeof useConsultantsCountQuery>;
export type ConsultantsCountLazyQueryHookResult = ReturnType<
  typeof useConsultantsCountLazyQuery
>;
export namespace ConsultantsCount {
  export type Return = ConsultantsCountQuery;
  export type Variables = ConsultantsCountQueryVariables;
  export const OperationName = "ConsultantsCount";

  export const Document = ConsultantsCountDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ToggleConsultantFavouriteDocument = gql`
  mutation ToggleConsultantFavourite($consultantId: ObjectId!) {
    toggleConsultantFavourite(consultantId: $consultantId)
  }
`;
export type ToggleConsultantFavouriteMutationFn = Apollo.MutationFunction<
  ToggleConsultantFavouriteMutation,
  ToggleConsultantFavouriteMutationVariables
>;
export type ToggleConsultantFavouriteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ToggleConsultantFavouriteMutation,
    ToggleConsultantFavouriteMutationVariables
  >,
  "mutation"
>;

export const ToggleConsultantFavouriteComponent = (
  props: ToggleConsultantFavouriteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ToggleConsultantFavouriteMutation,
    ToggleConsultantFavouriteMutationVariables
  >
    mutation={ToggleConsultantFavouriteDocument}
    {...props}
  />
);

/**
 * __useToggleConsultantFavouriteMutation__
 *
 * To run a mutation, you first call `useToggleConsultantFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleConsultantFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleConsultantFavouriteMutation, { data, loading, error }] = useToggleConsultantFavouriteMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useToggleConsultantFavouriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleConsultantFavouriteMutation,
    ToggleConsultantFavouriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleConsultantFavouriteMutation,
    ToggleConsultantFavouriteMutationVariables
  >(ToggleConsultantFavouriteDocument, options);
}
export type ToggleConsultantFavouriteMutationHookResult = ReturnType<
  typeof useToggleConsultantFavouriteMutation
>;
export namespace ToggleConsultantFavourite {
  export type Return = ToggleConsultantFavouriteMutation;
  export type Variables = ToggleConsultantFavouriteMutationVariables;
  export const OperationName = "ToggleConsultantFavourite";

  export const Document = ToggleConsultantFavouriteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UploadAttachmentDocument = gql`
  mutation uploadAttachment($file: Upload!) {
    uploadDocument(file: $file) {
      FileRef {
        ...AttachmentData
      }
    }
  }
  ${AttachmentDataFragmentDoc}
`;
export type UploadAttachmentMutationFn = Apollo.MutationFunction<
  UploadAttachmentMutation,
  UploadAttachmentMutationVariables
>;
export type UploadAttachmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadAttachmentMutation,
    UploadAttachmentMutationVariables
  >,
  "mutation"
>;

export const UploadAttachmentComponent = (props: UploadAttachmentComponentProps) => (
  <ApolloReactComponents.Mutation<
    UploadAttachmentMutation,
    UploadAttachmentMutationVariables
  >
    mutation={UploadAttachmentDocument}
    {...props}
  />
);

/**
 * __useUploadAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentMutation, { data, loading, error }] = useUploadAttachmentMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAttachmentMutation,
    UploadAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadAttachmentMutation, UploadAttachmentMutationVariables>(
    UploadAttachmentDocument,
    options
  );
}
export type UploadAttachmentMutationHookResult = ReturnType<
  typeof useUploadAttachmentMutation
>;
export namespace UploadAttachment {
  export type Return = UploadAttachmentMutation;
  export type Variables = UploadAttachmentMutationVariables;
  export const OperationName = "uploadAttachment";

  export const Document = UploadAttachmentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantAvailabilityFormDocument = gql`
  query getConsultantAvailabilityForm(
    $id: ObjectId!
    $weeksFrom: Date!
    $weeksTo: Date!
  ) {
    consultantById(id: $id) {
      _id
      Availability {
        ...ConsultantAvailabilityFormData
      }
    }
    consultantUpcomingWorkplaces(consultantId: $id, from: $weeksFrom, to: $weeksTo) {
      ...ConsultantWorkplace
    }
    bookingWeeksByConsultant(consultantId: $id, from: $weeksFrom, to: $weeksTo) {
      _id
      Week
    }
    consultantOpportunityByConsultantId(
      consultantId: $id
      from: $weeksFrom
      to: $weeksTo
    ) {
      _id
      weeks
    }
  }
  ${ConsultantAvailabilityFormDataFragmentDoc}
  ${ConsultantWorkplaceFragmentDoc}
`;
export type GetConsultantAvailabilityFormComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantAvailabilityFormQuery,
    GetConsultantAvailabilityFormQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantAvailabilityFormQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantAvailabilityFormComponent = (
  props: GetConsultantAvailabilityFormComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantAvailabilityFormQuery,
    GetConsultantAvailabilityFormQueryVariables
  >
    query={GetConsultantAvailabilityFormDocument}
    {...props}
  />
);

/**
 * __useGetConsultantAvailabilityFormQuery__
 *
 * To run a query within a React component, call `useGetConsultantAvailabilityFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantAvailabilityFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantAvailabilityFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *      weeksFrom: // value for 'weeksFrom'
 *      weeksTo: // value for 'weeksTo'
 *   },
 * });
 */
export function useGetConsultantAvailabilityFormQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantAvailabilityFormQuery,
    GetConsultantAvailabilityFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantAvailabilityFormQuery,
    GetConsultantAvailabilityFormQueryVariables
  >(GetConsultantAvailabilityFormDocument, options);
}
export function useGetConsultantAvailabilityFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantAvailabilityFormQuery,
    GetConsultantAvailabilityFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantAvailabilityFormQuery,
    GetConsultantAvailabilityFormQueryVariables
  >(GetConsultantAvailabilityFormDocument, options);
}
export type GetConsultantAvailabilityFormQueryHookResult = ReturnType<
  typeof useGetConsultantAvailabilityFormQuery
>;
export type GetConsultantAvailabilityFormLazyQueryHookResult = ReturnType<
  typeof useGetConsultantAvailabilityFormLazyQuery
>;
export namespace GetConsultantAvailabilityForm {
  export type Return = GetConsultantAvailabilityFormQuery;
  export type Variables = GetConsultantAvailabilityFormQueryVariables;
  export const OperationName = "getConsultantAvailabilityForm";

  export const Document = GetConsultantAvailabilityFormDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AvailabilityCalendar_AddAvailabilityDocument = gql`
  mutation AvailabilityCalendar_AddAvailability(
    $consultantId: ObjectId!
    $input: ConsultantAvailabilityInput!
  ) {
    addConsultantAvailability(consultantId: $consultantId, input: $input) {
      _id
      Availability {
        ...ConsultantAvailabilityForm_Availability
      }
    }
  }
  ${ConsultantAvailabilityForm_AvailabilityFragmentDoc}
`;
export type AvailabilityCalendar_AddAvailabilityMutationFn = Apollo.MutationFunction<
  AvailabilityCalendar_AddAvailabilityMutation,
  AvailabilityCalendar_AddAvailabilityMutationVariables
>;
export type AvailabilityCalendar_AddAvailabilityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AvailabilityCalendar_AddAvailabilityMutation,
    AvailabilityCalendar_AddAvailabilityMutationVariables
  >,
  "mutation"
>;

export const AvailabilityCalendar_AddAvailabilityComponent = (
  props: AvailabilityCalendar_AddAvailabilityComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AvailabilityCalendar_AddAvailabilityMutation,
    AvailabilityCalendar_AddAvailabilityMutationVariables
  >
    mutation={AvailabilityCalendar_AddAvailabilityDocument}
    {...props}
  />
);

/**
 * __useAvailabilityCalendar_AddAvailabilityMutation__
 *
 * To run a mutation, you first call `useAvailabilityCalendar_AddAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityCalendar_AddAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [availabilityCalendarAddAvailabilityMutation, { data, loading, error }] = useAvailabilityCalendar_AddAvailabilityMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailabilityCalendar_AddAvailabilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AvailabilityCalendar_AddAvailabilityMutation,
    AvailabilityCalendar_AddAvailabilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AvailabilityCalendar_AddAvailabilityMutation,
    AvailabilityCalendar_AddAvailabilityMutationVariables
  >(AvailabilityCalendar_AddAvailabilityDocument, options);
}
export type AvailabilityCalendar_AddAvailabilityMutationHookResult = ReturnType<
  typeof useAvailabilityCalendar_AddAvailabilityMutation
>;
export namespace AvailabilityCalendar_AddAvailability {
  export type Return = AvailabilityCalendar_AddAvailabilityMutation;
  export type Variables = AvailabilityCalendar_AddAvailabilityMutationVariables;
  export const OperationName = "AvailabilityCalendar_AddAvailability";

  export const Document = AvailabilityCalendar_AddAvailabilityDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AvailabilityCalendar_DeleteAvailabilityDocument = gql`
  mutation AvailabilityCalendar_DeleteAvailability(
    $consultantId: ObjectId!
    $input: ConsultantAvailabilityInput!
  ) {
    deleteConsultantAvailability(consultantId: $consultantId, input: $input) {
      _id
      Availability {
        ...ConsultantAvailabilityForm_Availability
      }
    }
  }
  ${ConsultantAvailabilityForm_AvailabilityFragmentDoc}
`;
export type AvailabilityCalendar_DeleteAvailabilityMutationFn = Apollo.MutationFunction<
  AvailabilityCalendar_DeleteAvailabilityMutation,
  AvailabilityCalendar_DeleteAvailabilityMutationVariables
>;
export type AvailabilityCalendar_DeleteAvailabilityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AvailabilityCalendar_DeleteAvailabilityMutation,
    AvailabilityCalendar_DeleteAvailabilityMutationVariables
  >,
  "mutation"
>;

export const AvailabilityCalendar_DeleteAvailabilityComponent = (
  props: AvailabilityCalendar_DeleteAvailabilityComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AvailabilityCalendar_DeleteAvailabilityMutation,
    AvailabilityCalendar_DeleteAvailabilityMutationVariables
  >
    mutation={AvailabilityCalendar_DeleteAvailabilityDocument}
    {...props}
  />
);

/**
 * __useAvailabilityCalendar_DeleteAvailabilityMutation__
 *
 * To run a mutation, you first call `useAvailabilityCalendar_DeleteAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityCalendar_DeleteAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [availabilityCalendarDeleteAvailabilityMutation, { data, loading, error }] = useAvailabilityCalendar_DeleteAvailabilityMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailabilityCalendar_DeleteAvailabilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AvailabilityCalendar_DeleteAvailabilityMutation,
    AvailabilityCalendar_DeleteAvailabilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AvailabilityCalendar_DeleteAvailabilityMutation,
    AvailabilityCalendar_DeleteAvailabilityMutationVariables
  >(AvailabilityCalendar_DeleteAvailabilityDocument, options);
}
export type AvailabilityCalendar_DeleteAvailabilityMutationHookResult = ReturnType<
  typeof useAvailabilityCalendar_DeleteAvailabilityMutation
>;
export namespace AvailabilityCalendar_DeleteAvailability {
  export type Return = AvailabilityCalendar_DeleteAvailabilityMutation;
  export type Variables = AvailabilityCalendar_DeleteAvailabilityMutationVariables;
  export const OperationName = "AvailabilityCalendar_DeleteAvailability";

  export const Document = AvailabilityCalendar_DeleteAvailabilityDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantCallListDataDocument = gql`
  query getConsultantCallListData($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantCallListData
    }
  }
  ${ConsultantCallListDataFragmentDoc}
`;
export type GetConsultantCallListDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantCallListDataQuery,
    GetConsultantCallListDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantCallListDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantCallListDataComponent = (
  props: GetConsultantCallListDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantCallListDataQuery,
    GetConsultantCallListDataQueryVariables
  >
    query={GetConsultantCallListDataDocument}
    {...props}
  />
);

/**
 * __useGetConsultantCallListDataQuery__
 *
 * To run a query within a React component, call `useGetConsultantCallListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantCallListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantCallListDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantCallListDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantCallListDataQuery,
    GetConsultantCallListDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantCallListDataQuery,
    GetConsultantCallListDataQueryVariables
  >(GetConsultantCallListDataDocument, options);
}
export function useGetConsultantCallListDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantCallListDataQuery,
    GetConsultantCallListDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantCallListDataQuery,
    GetConsultantCallListDataQueryVariables
  >(GetConsultantCallListDataDocument, options);
}
export type GetConsultantCallListDataQueryHookResult = ReturnType<
  typeof useGetConsultantCallListDataQuery
>;
export type GetConsultantCallListDataLazyQueryHookResult = ReturnType<
  typeof useGetConsultantCallListDataLazyQuery
>;
export namespace GetConsultantCallListData {
  export type Return = GetConsultantCallListDataQuery;
  export type Variables = GetConsultantCallListDataQueryVariables;
  export const OperationName = "getConsultantCallListData";

  export const Document = GetConsultantCallListDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCallContactListDocument = gql`
  query getCallContactList {
    me {
      ...CallContactListData
    }
  }
  ${CallContactListDataFragmentDoc}
`;
export type GetCallContactListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCallContactListQuery,
    GetCallContactListQueryVariables
  >,
  "query"
>;

export const GetCallContactListComponent = (props: GetCallContactListComponentProps) => (
  <ApolloReactComponents.Query<GetCallContactListQuery, GetCallContactListQueryVariables>
    query={GetCallContactListDocument}
    {...props}
  />
);

/**
 * __useGetCallContactListQuery__
 *
 * To run a query within a React component, call `useGetCallContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallContactListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCallContactListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCallContactListQuery,
    GetCallContactListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallContactListQuery, GetCallContactListQueryVariables>(
    GetCallContactListDocument,
    options
  );
}
export function useGetCallContactListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCallContactListQuery,
    GetCallContactListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallContactListQuery, GetCallContactListQueryVariables>(
    GetCallContactListDocument,
    options
  );
}
export type GetCallContactListQueryHookResult = ReturnType<
  typeof useGetCallContactListQuery
>;
export type GetCallContactListLazyQueryHookResult = ReturnType<
  typeof useGetCallContactListLazyQuery
>;
export namespace GetCallContactList {
  export type Return = GetCallContactListQuery;
  export type Variables = GetCallContactListQueryVariables;
  export const OperationName = "getCallContactList";

  export const Document = GetCallContactListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateCallListDocument = gql`
  mutation createCallList(
    $listType: CallListType!
    $name: String!
    $nodes: [NodeRefFullInput!]!
    $type: NodeType!
    $userIds: [ObjectId!]
  ) {
    submit: createCallList(
      type: $listType
      data: { name: $name, nodes: $nodes, type: $type, userIds: $userIds }
    ) {
      __typename
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type CreateCallListMutationFn = Apollo.MutationFunction<
  CreateCallListMutation,
  CreateCallListMutationVariables
>;
export type CreateCallListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCallListMutation,
    CreateCallListMutationVariables
  >,
  "mutation"
>;

export const CreateCallListComponent = (props: CreateCallListComponentProps) => (
  <ApolloReactComponents.Mutation<CreateCallListMutation, CreateCallListMutationVariables>
    mutation={CreateCallListDocument}
    {...props}
  />
);

/**
 * __useCreateCallListMutation__
 *
 * To run a mutation, you first call `useCreateCallListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallListMutation, { data, loading, error }] = useCreateCallListMutation({
 *   variables: {
 *      listType: // value for 'listType'
 *      name: // value for 'name'
 *      nodes: // value for 'nodes'
 *      type: // value for 'type'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useCreateCallListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCallListMutation,
    CreateCallListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCallListMutation, CreateCallListMutationVariables>(
    CreateCallListDocument,
    options
  );
}
export type CreateCallListMutationHookResult = ReturnType<
  typeof useCreateCallListMutation
>;
export namespace CreateCallList {
  export type Return = CreateCallListMutation;
  export type Variables = CreateCallListMutationVariables;
  export const OperationName = "createCallList";

  export const Document = CreateCallListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCallListDocument = gql`
  query getCallList($id: ObjectId!) {
    callListById(id: $id) {
      __typename
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type GetCallListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCallListQuery,
    GetCallListQueryVariables
  >,
  "query"
> &
  ({ variables: GetCallListQueryVariables; skip?: boolean } | { skip: boolean });

export const GetCallListComponent = (props: GetCallListComponentProps) => (
  <ApolloReactComponents.Query<GetCallListQuery, GetCallListQueryVariables>
    query={GetCallListDocument}
    {...props}
  />
);

/**
 * __useGetCallListQuery__
 *
 * To run a query within a React component, call `useGetCallListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCallListQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCallListQuery, GetCallListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCallListQuery, GetCallListQueryVariables>(
    GetCallListDocument,
    options
  );
}
export function useGetCallListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCallListQuery, GetCallListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCallListQuery, GetCallListQueryVariables>(
    GetCallListDocument,
    options
  );
}
export type GetCallListQueryHookResult = ReturnType<typeof useGetCallListQuery>;
export type GetCallListLazyQueryHookResult = ReturnType<typeof useGetCallListLazyQuery>;
export namespace GetCallList {
  export type Return = GetCallListQuery;
  export type Variables = GetCallListQueryVariables;
  export const OperationName = "getCallList";

  export const Document = GetCallListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const RenameCallListDocument = gql`
  mutation renameCallList($id: ObjectId!, $newName: String!) {
    submit: renameCallList(callListId: $id, newName: $newName) {
      __typename
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type RenameCallListMutationFn = Apollo.MutationFunction<
  RenameCallListMutation,
  RenameCallListMutationVariables
>;
export type RenameCallListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RenameCallListMutation,
    RenameCallListMutationVariables
  >,
  "mutation"
>;

export const RenameCallListComponent = (props: RenameCallListComponentProps) => (
  <ApolloReactComponents.Mutation<RenameCallListMutation, RenameCallListMutationVariables>
    mutation={RenameCallListDocument}
    {...props}
  />
);

/**
 * __useRenameCallListMutation__
 *
 * To run a mutation, you first call `useRenameCallListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCallListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCallListMutation, { data, loading, error }] = useRenameCallListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameCallListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameCallListMutation,
    RenameCallListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenameCallListMutation, RenameCallListMutationVariables>(
    RenameCallListDocument,
    options
  );
}
export type RenameCallListMutationHookResult = ReturnType<
  typeof useRenameCallListMutation
>;
export namespace RenameCallList {
  export type Return = RenameCallListMutation;
  export type Variables = RenameCallListMutationVariables;
  export const OperationName = "renameCallList";

  export const Document = RenameCallListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateCallListMembersDocument = gql`
  mutation updateCallListMembers($callListId: ObjectId!, $userIds: [ObjectId!]!) {
    setCallListMembers(callListId: $callListId, userIds: $userIds) {
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type UpdateCallListMembersMutationFn = Apollo.MutationFunction<
  UpdateCallListMembersMutation,
  UpdateCallListMembersMutationVariables
>;
export type UpdateCallListMembersComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCallListMembersMutation,
    UpdateCallListMembersMutationVariables
  >,
  "mutation"
>;

export const UpdateCallListMembersComponent = (
  props: UpdateCallListMembersComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateCallListMembersMutation,
    UpdateCallListMembersMutationVariables
  >
    mutation={UpdateCallListMembersDocument}
    {...props}
  />
);

/**
 * __useUpdateCallListMembersMutation__
 *
 * To run a mutation, you first call `useUpdateCallListMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallListMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallListMembersMutation, { data, loading, error }] = useUpdateCallListMembersMutation({
 *   variables: {
 *      callListId: // value for 'callListId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUpdateCallListMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCallListMembersMutation,
    UpdateCallListMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCallListMembersMutation,
    UpdateCallListMembersMutationVariables
  >(UpdateCallListMembersDocument, options);
}
export type UpdateCallListMembersMutationHookResult = ReturnType<
  typeof useUpdateCallListMembersMutation
>;
export namespace UpdateCallListMembers {
  export type Return = UpdateCallListMembersMutation;
  export type Variables = UpdateCallListMembersMutationVariables;
  export const OperationName = "updateCallListMembers";

  export const Document = UpdateCallListMembersDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantJoinCallListDocument = gql`
  mutation consultantJoinCallList($id: ObjectId!, $node: NodeRefFullInput!) {
    addToCallList(callListId: $id, node: $node) {
      __typename
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type ConsultantJoinCallListMutationFn = Apollo.MutationFunction<
  ConsultantJoinCallListMutation,
  ConsultantJoinCallListMutationVariables
>;
export type ConsultantJoinCallListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantJoinCallListMutation,
    ConsultantJoinCallListMutationVariables
  >,
  "mutation"
>;

export const ConsultantJoinCallListComponent = (
  props: ConsultantJoinCallListComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantJoinCallListMutation,
    ConsultantJoinCallListMutationVariables
  >
    mutation={ConsultantJoinCallListDocument}
    {...props}
  />
);

/**
 * __useConsultantJoinCallListMutation__
 *
 * To run a mutation, you first call `useConsultantJoinCallListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantJoinCallListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantJoinCallListMutation, { data, loading, error }] = useConsultantJoinCallListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      node: // value for 'node'
 *   },
 * });
 */
export function useConsultantJoinCallListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantJoinCallListMutation,
    ConsultantJoinCallListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantJoinCallListMutation,
    ConsultantJoinCallListMutationVariables
  >(ConsultantJoinCallListDocument, options);
}
export type ConsultantJoinCallListMutationHookResult = ReturnType<
  typeof useConsultantJoinCallListMutation
>;
export namespace ConsultantJoinCallList {
  export type Return = ConsultantJoinCallListMutation;
  export type Variables = ConsultantJoinCallListMutationVariables;
  export const OperationName = "consultantJoinCallList";

  export const Document = ConsultantJoinCallListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantLeaveCallListDocument = gql`
  mutation consultantLeaveCallList($id: ObjectId!, $nodeId: ObjectId!) {
    removeFromCallList(callListId: $id, nodeId: $nodeId) {
      __typename
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type ConsultantLeaveCallListMutationFn = Apollo.MutationFunction<
  ConsultantLeaveCallListMutation,
  ConsultantLeaveCallListMutationVariables
>;
export type ConsultantLeaveCallListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantLeaveCallListMutation,
    ConsultantLeaveCallListMutationVariables
  >,
  "mutation"
>;

export const ConsultantLeaveCallListComponent = (
  props: ConsultantLeaveCallListComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantLeaveCallListMutation,
    ConsultantLeaveCallListMutationVariables
  >
    mutation={ConsultantLeaveCallListDocument}
    {...props}
  />
);

/**
 * __useConsultantLeaveCallListMutation__
 *
 * To run a mutation, you first call `useConsultantLeaveCallListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantLeaveCallListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantLeaveCallListMutation, { data, loading, error }] = useConsultantLeaveCallListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useConsultantLeaveCallListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantLeaveCallListMutation,
    ConsultantLeaveCallListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantLeaveCallListMutation,
    ConsultantLeaveCallListMutationVariables
  >(ConsultantLeaveCallListDocument, options);
}
export type ConsultantLeaveCallListMutationHookResult = ReturnType<
  typeof useConsultantLeaveCallListMutation
>;
export namespace ConsultantLeaveCallList {
  export type Return = ConsultantLeaveCallListMutation;
  export type Variables = ConsultantLeaveCallListMutationVariables;
  export const OperationName = "consultantLeaveCallList";

  export const Document = ConsultantLeaveCallListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UserLeaveCallListDocument = gql`
  mutation userLeaveCallList($id: ObjectId!) {
    leaveCallList(callListId: $id) {
      __typename
      callList {
        ...CallListData
      }
    }
  }
  ${CallListDataFragmentDoc}
`;
export type UserLeaveCallListMutationFn = Apollo.MutationFunction<
  UserLeaveCallListMutation,
  UserLeaveCallListMutationVariables
>;
export type UserLeaveCallListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UserLeaveCallListMutation,
    UserLeaveCallListMutationVariables
  >,
  "mutation"
>;

export const UserLeaveCallListComponent = (props: UserLeaveCallListComponentProps) => (
  <ApolloReactComponents.Mutation<
    UserLeaveCallListMutation,
    UserLeaveCallListMutationVariables
  >
    mutation={UserLeaveCallListDocument}
    {...props}
  />
);

/**
 * __useUserLeaveCallListMutation__
 *
 * To run a mutation, you first call `useUserLeaveCallListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLeaveCallListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLeaveCallListMutation, { data, loading, error }] = useUserLeaveCallListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserLeaveCallListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserLeaveCallListMutation,
    UserLeaveCallListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserLeaveCallListMutation,
    UserLeaveCallListMutationVariables
  >(UserLeaveCallListDocument, options);
}
export type UserLeaveCallListMutationHookResult = ReturnType<
  typeof useUserLeaveCallListMutation
>;
export namespace UserLeaveCallList {
  export type Return = UserLeaveCallListMutation;
  export type Variables = UserLeaveCallListMutationVariables;
  export const OperationName = "userLeaveCallList";

  export const Document = UserLeaveCallListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantProfileNewDocument = gql`
  query getConsultantProfileNew($id: ObjectId!) {
    consultantById(id: $id) {
      _id
      ...PersonalInfoCardData
      ...SwitchesCardData
      ...ConsultantTagsData
      ...ConsultantCallListData
      ...ConsultantShareableFiles
      ...ConsultantCreatePresentationData
      ...ConsultantEventLogMetaData
      ...ConsultantGeneralInterestData
      ...KarensData
      ...ConsultantGdprData
    }
    getConsultantPayoutByYear(consultantId: $id) {
      ...ConsultantPayoutByYearData
    }
  }
  ${PersonalInfoCardDataFragmentDoc}
  ${SwitchesCardDataFragmentDoc}
  ${ConsultantTagsDataFragmentDoc}
  ${ConsultantCallListDataFragmentDoc}
  ${ConsultantShareableFilesFragmentDoc}
  ${ConsultantCreatePresentationDataFragmentDoc}
  ${ConsultantEventLogMetaDataFragmentDoc}
  ${ConsultantGeneralInterestDataFragmentDoc}
  ${KarensDataFragmentDoc}
  ${ConsultantGdprDataFragmentDoc}
  ${ConsultantPayoutByYearDataFragmentDoc}
`;
export type GetConsultantProfileNewComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantProfileNewQuery,
    GetConsultantProfileNewQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantProfileNewQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantProfileNewComponent = (
  props: GetConsultantProfileNewComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantProfileNewQuery,
    GetConsultantProfileNewQueryVariables
  >
    query={GetConsultantProfileNewDocument}
    {...props}
  />
);

/**
 * __useGetConsultantProfileNewQuery__
 *
 * To run a query within a React component, call `useGetConsultantProfileNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantProfileNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantProfileNewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantProfileNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantProfileNewQuery,
    GetConsultantProfileNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantProfileNewQuery,
    GetConsultantProfileNewQueryVariables
  >(GetConsultantProfileNewDocument, options);
}
export function useGetConsultantProfileNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantProfileNewQuery,
    GetConsultantProfileNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantProfileNewQuery,
    GetConsultantProfileNewQueryVariables
  >(GetConsultantProfileNewDocument, options);
}
export type GetConsultantProfileNewQueryHookResult = ReturnType<
  typeof useGetConsultantProfileNewQuery
>;
export type GetConsultantProfileNewLazyQueryHookResult = ReturnType<
  typeof useGetConsultantProfileNewLazyQuery
>;
export namespace GetConsultantProfileNew {
  export type Return = GetConsultantProfileNewQuery;
  export type Variables = GetConsultantProfileNewQueryVariables;
  export const OperationName = "getConsultantProfileNew";

  export const Document = GetConsultantProfileNewDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CanDuplicateConsultantToTenantDocument = gql`
  query canDuplicateConsultantToTenant($ssn: String, $email: String, $phone: String) {
    consultantCanDuplicateToTenants(ssn: $ssn, email: $email, phone: $phone) {
      items {
        tenant
        canDuplicate
        links
      }
    }
  }
`;
export type CanDuplicateConsultantToTenantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CanDuplicateConsultantToTenantQuery,
    CanDuplicateConsultantToTenantQueryVariables
  >,
  "query"
>;

export const CanDuplicateConsultantToTenantComponent = (
  props: CanDuplicateConsultantToTenantComponentProps
) => (
  <ApolloReactComponents.Query<
    CanDuplicateConsultantToTenantQuery,
    CanDuplicateConsultantToTenantQueryVariables
  >
    query={CanDuplicateConsultantToTenantDocument}
    {...props}
  />
);

/**
 * __useCanDuplicateConsultantToTenantQuery__
 *
 * To run a query within a React component, call `useCanDuplicateConsultantToTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDuplicateConsultantToTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDuplicateConsultantToTenantQuery({
 *   variables: {
 *      ssn: // value for 'ssn'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCanDuplicateConsultantToTenantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CanDuplicateConsultantToTenantQuery,
    CanDuplicateConsultantToTenantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CanDuplicateConsultantToTenantQuery,
    CanDuplicateConsultantToTenantQueryVariables
  >(CanDuplicateConsultantToTenantDocument, options);
}
export function useCanDuplicateConsultantToTenantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CanDuplicateConsultantToTenantQuery,
    CanDuplicateConsultantToTenantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CanDuplicateConsultantToTenantQuery,
    CanDuplicateConsultantToTenantQueryVariables
  >(CanDuplicateConsultantToTenantDocument, options);
}
export type CanDuplicateConsultantToTenantQueryHookResult = ReturnType<
  typeof useCanDuplicateConsultantToTenantQuery
>;
export type CanDuplicateConsultantToTenantLazyQueryHookResult = ReturnType<
  typeof useCanDuplicateConsultantToTenantLazyQuery
>;
export namespace CanDuplicateConsultantToTenant {
  export type Return = CanDuplicateConsultantToTenantQuery;
  export type Variables = CanDuplicateConsultantToTenantQueryVariables;
  export const OperationName = "canDuplicateConsultantToTenant";

  export const Document = CanDuplicateConsultantToTenantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const DuplicateConsultantToTenantDocument = gql`
  mutation duplicateConsultantToTenant($consultantId: ObjectId!, $tenant: String!) {
    duplicateConsultantToTenant(id: $consultantId, toTenant: $tenant)
  }
`;
export type DuplicateConsultantToTenantMutationFn = Apollo.MutationFunction<
  DuplicateConsultantToTenantMutation,
  DuplicateConsultantToTenantMutationVariables
>;
export type DuplicateConsultantToTenantComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DuplicateConsultantToTenantMutation,
    DuplicateConsultantToTenantMutationVariables
  >,
  "mutation"
>;

export const DuplicateConsultantToTenantComponent = (
  props: DuplicateConsultantToTenantComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DuplicateConsultantToTenantMutation,
    DuplicateConsultantToTenantMutationVariables
  >
    mutation={DuplicateConsultantToTenantDocument}
    {...props}
  />
);

/**
 * __useDuplicateConsultantToTenantMutation__
 *
 * To run a mutation, you first call `useDuplicateConsultantToTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateConsultantToTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateConsultantToTenantMutation, { data, loading, error }] = useDuplicateConsultantToTenantMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useDuplicateConsultantToTenantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateConsultantToTenantMutation,
    DuplicateConsultantToTenantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateConsultantToTenantMutation,
    DuplicateConsultantToTenantMutationVariables
  >(DuplicateConsultantToTenantDocument, options);
}
export type DuplicateConsultantToTenantMutationHookResult = ReturnType<
  typeof useDuplicateConsultantToTenantMutation
>;
export namespace DuplicateConsultantToTenant {
  export type Return = DuplicateConsultantToTenantMutation;
  export type Variables = DuplicateConsultantToTenantMutationVariables;
  export const OperationName = "duplicateConsultantToTenant";

  export const Document = DuplicateConsultantToTenantDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SendToMedloDocument = gql`
  mutation sendToMedlo(
    $consultantId: ObjectId!
    $referenceIds: [ObjectId]
    $crmCv: Boolean
    $cvDocuments: [ObjectId]
  ) {
    sendConsultantToMedlo(
      consultantId: $consultantId
      referenceIds: $referenceIds
      crmCv: $crmCv
      cvDocuments: $cvDocuments
    ) {
      success
      message
    }
  }
`;
export type SendToMedloMutationFn = Apollo.MutationFunction<
  SendToMedloMutation,
  SendToMedloMutationVariables
>;
export type SendToMedloComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendToMedloMutation,
    SendToMedloMutationVariables
  >,
  "mutation"
>;

export const SendToMedloComponent = (props: SendToMedloComponentProps) => (
  <ApolloReactComponents.Mutation<SendToMedloMutation, SendToMedloMutationVariables>
    mutation={SendToMedloDocument}
    {...props}
  />
);

/**
 * __useSendToMedloMutation__
 *
 * To run a mutation, you first call `useSendToMedloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendToMedloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendToMedloMutation, { data, loading, error }] = useSendToMedloMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      referenceIds: // value for 'referenceIds'
 *      crmCv: // value for 'crmCv'
 *      cvDocuments: // value for 'cvDocuments'
 *   },
 * });
 */
export function useSendToMedloMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendToMedloMutation,
    SendToMedloMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendToMedloMutation, SendToMedloMutationVariables>(
    SendToMedloDocument,
    options
  );
}
export type SendToMedloMutationHookResult = ReturnType<typeof useSendToMedloMutation>;
export namespace SendToMedlo {
  export type Return = SendToMedloMutation;
  export type Variables = SendToMedloMutationVariables;
  export const OperationName = "sendToMedlo";

  export const Document = SendToMedloDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantProfile_GetConsultantDocument = gql`
  query ConsultantProfile_GetConsultant($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantProfile_Consultant
    }
  }
  ${ConsultantProfile_ConsultantFragmentDoc}
`;
export type ConsultantProfile_GetConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantProfile_GetConsultantQuery,
    ConsultantProfile_GetConsultantQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantProfile_GetConsultantQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantProfile_GetConsultantComponent = (
  props: ConsultantProfile_GetConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantProfile_GetConsultantQuery,
    ConsultantProfile_GetConsultantQueryVariables
  >
    query={ConsultantProfile_GetConsultantDocument}
    {...props}
  />
);

/**
 * __useConsultantProfile_GetConsultantQuery__
 *
 * To run a query within a React component, call `useConsultantProfile_GetConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantProfile_GetConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantProfile_GetConsultantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantProfile_GetConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantProfile_GetConsultantQuery,
    ConsultantProfile_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantProfile_GetConsultantQuery,
    ConsultantProfile_GetConsultantQueryVariables
  >(ConsultantProfile_GetConsultantDocument, options);
}
export function useConsultantProfile_GetConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantProfile_GetConsultantQuery,
    ConsultantProfile_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantProfile_GetConsultantQuery,
    ConsultantProfile_GetConsultantQueryVariables
  >(ConsultantProfile_GetConsultantDocument, options);
}
export type ConsultantProfile_GetConsultantQueryHookResult = ReturnType<
  typeof useConsultantProfile_GetConsultantQuery
>;
export type ConsultantProfile_GetConsultantLazyQueryHookResult = ReturnType<
  typeof useConsultantProfile_GetConsultantLazyQuery
>;
export namespace ConsultantProfile_GetConsultant {
  export type Return = ConsultantProfile_GetConsultantQuery;
  export type Variables = ConsultantProfile_GetConsultantQueryVariables;
  export const OperationName = "ConsultantProfile_GetConsultant";

  export const Document = ConsultantProfile_GetConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantTagsDocument = gql`
  query getConsultantTags($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantTagsData
    }
  }
  ${ConsultantTagsDataFragmentDoc}
`;
export type GetConsultantTagsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantTagsQuery,
    GetConsultantTagsQueryVariables
  >,
  "query"
> &
  ({ variables: GetConsultantTagsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetConsultantTagsComponent = (props: GetConsultantTagsComponentProps) => (
  <ApolloReactComponents.Query<GetConsultantTagsQuery, GetConsultantTagsQueryVariables>
    query={GetConsultantTagsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantTagsQuery__
 *
 * To run a query within a React component, call `useGetConsultantTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantTagsQuery,
    GetConsultantTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConsultantTagsQuery, GetConsultantTagsQueryVariables>(
    GetConsultantTagsDocument,
    options
  );
}
export function useGetConsultantTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantTagsQuery,
    GetConsultantTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConsultantTagsQuery, GetConsultantTagsQueryVariables>(
    GetConsultantTagsDocument,
    options
  );
}
export type GetConsultantTagsQueryHookResult = ReturnType<
  typeof useGetConsultantTagsQuery
>;
export type GetConsultantTagsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantTagsLazyQuery
>;
export namespace GetConsultantTags {
  export type Return = GetConsultantTagsQuery;
  export type Variables = GetConsultantTagsQueryVariables;
  export const OperationName = "getConsultantTags";

  export const Document = GetConsultantTagsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetAllConsultantTagsDocument = gql`
  query getAllConsultantTags {
    getAllConsultantTags {
      tags
    }
  }
`;
export type GetAllConsultantTagsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAllConsultantTagsQuery,
    GetAllConsultantTagsQueryVariables
  >,
  "query"
>;

export const GetAllConsultantTagsComponent = (
  props: GetAllConsultantTagsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAllConsultantTagsQuery,
    GetAllConsultantTagsQueryVariables
  >
    query={GetAllConsultantTagsDocument}
    {...props}
  />
);

/**
 * __useGetAllConsultantTagsQuery__
 *
 * To run a query within a React component, call `useGetAllConsultantTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllConsultantTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllConsultantTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllConsultantTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllConsultantTagsQuery,
    GetAllConsultantTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllConsultantTagsQuery, GetAllConsultantTagsQueryVariables>(
    GetAllConsultantTagsDocument,
    options
  );
}
export function useGetAllConsultantTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllConsultantTagsQuery,
    GetAllConsultantTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllConsultantTagsQuery,
    GetAllConsultantTagsQueryVariables
  >(GetAllConsultantTagsDocument, options);
}
export type GetAllConsultantTagsQueryHookResult = ReturnType<
  typeof useGetAllConsultantTagsQuery
>;
export type GetAllConsultantTagsLazyQueryHookResult = ReturnType<
  typeof useGetAllConsultantTagsLazyQuery
>;
export namespace GetAllConsultantTags {
  export type Return = GetAllConsultantTagsQuery;
  export type Variables = GetAllConsultantTagsQueryVariables;
  export const OperationName = "getAllConsultantTags";

  export const Document = GetAllConsultantTagsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AddConsultantTagDocument = gql`
  mutation addConsultantTag($id: ObjectId!, $tag: String!) {
    addConsultantTag(consultantId: $id, tag: $tag) {
      ...ConsultantTagsData
    }
  }
  ${ConsultantTagsDataFragmentDoc}
`;
export type AddConsultantTagMutationFn = Apollo.MutationFunction<
  AddConsultantTagMutation,
  AddConsultantTagMutationVariables
>;
export type AddConsultantTagComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantTagMutation,
    AddConsultantTagMutationVariables
  >,
  "mutation"
>;

export const AddConsultantTagComponent = (props: AddConsultantTagComponentProps) => (
  <ApolloReactComponents.Mutation<
    AddConsultantTagMutation,
    AddConsultantTagMutationVariables
  >
    mutation={AddConsultantTagDocument}
    {...props}
  />
);

/**
 * __useAddConsultantTagMutation__
 *
 * To run a mutation, you first call `useAddConsultantTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantTagMutation, { data, loading, error }] = useAddConsultantTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useAddConsultantTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantTagMutation,
    AddConsultantTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddConsultantTagMutation, AddConsultantTagMutationVariables>(
    AddConsultantTagDocument,
    options
  );
}
export type AddConsultantTagMutationHookResult = ReturnType<
  typeof useAddConsultantTagMutation
>;
export namespace AddConsultantTag {
  export type Return = AddConsultantTagMutation;
  export type Variables = AddConsultantTagMutationVariables;
  export const OperationName = "addConsultantTag";

  export const Document = AddConsultantTagDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RemoveConsultantTagDocument = gql`
  mutation removeConsultantTag($id: ObjectId!, $tag: String!) {
    removeConsultantTag(consultantId: $id, tag: $tag) {
      ...ConsultantTagsData
    }
  }
  ${ConsultantTagsDataFragmentDoc}
`;
export type RemoveConsultantTagMutationFn = Apollo.MutationFunction<
  RemoveConsultantTagMutation,
  RemoveConsultantTagMutationVariables
>;
export type RemoveConsultantTagComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveConsultantTagMutation,
    RemoveConsultantTagMutationVariables
  >,
  "mutation"
>;

export const RemoveConsultantTagComponent = (
  props: RemoveConsultantTagComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveConsultantTagMutation,
    RemoveConsultantTagMutationVariables
  >
    mutation={RemoveConsultantTagDocument}
    {...props}
  />
);

/**
 * __useRemoveConsultantTagMutation__
 *
 * To run a mutation, you first call `useRemoveConsultantTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConsultantTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConsultantTagMutation, { data, loading, error }] = useRemoveConsultantTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useRemoveConsultantTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveConsultantTagMutation,
    RemoveConsultantTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveConsultantTagMutation,
    RemoveConsultantTagMutationVariables
  >(RemoveConsultantTagDocument, options);
}
export type RemoveConsultantTagMutationHookResult = ReturnType<
  typeof useRemoveConsultantTagMutation
>;
export namespace RemoveConsultantTag {
  export type Return = RemoveConsultantTagMutation;
  export type Variables = RemoveConsultantTagMutationVariables;
  export const OperationName = "removeConsultantTag";

  export const Document = RemoveConsultantTagDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantContractsDocument = gql`
  query getConsultantContracts($id: ObjectId!) {
    getConsultantContracts(consultantId: $id) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type GetConsultantContractsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantContractsQuery,
    GetConsultantContractsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantContractsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantContractsComponent = (
  props: GetConsultantContractsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantContractsQuery,
    GetConsultantContractsQueryVariables
  >
    query={GetConsultantContractsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantContractsQuery__
 *
 * To run a query within a React component, call `useGetConsultantContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantContractsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantContractsQuery,
    GetConsultantContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantContractsQuery,
    GetConsultantContractsQueryVariables
  >(GetConsultantContractsDocument, options);
}
export function useGetConsultantContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantContractsQuery,
    GetConsultantContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantContractsQuery,
    GetConsultantContractsQueryVariables
  >(GetConsultantContractsDocument, options);
}
export type GetConsultantContractsQueryHookResult = ReturnType<
  typeof useGetConsultantContractsQuery
>;
export type GetConsultantContractsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantContractsLazyQuery
>;
export namespace GetConsultantContracts {
  export type Return = GetConsultantContractsQuery;
  export type Variables = GetConsultantContractsQueryVariables;
  export const OperationName = "getConsultantContracts";

  export const Document = GetConsultantContractsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantContractsPersonalDataDocument = gql`
  query getConsultantContractsPersonalData($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantContractsPersonalData
    }
  }
  ${ConsultantContractsPersonalDataFragmentDoc}
`;
export type GetConsultantContractsPersonalDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantContractsPersonalDataQuery,
    GetConsultantContractsPersonalDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantContractsPersonalDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantContractsPersonalDataComponent = (
  props: GetConsultantContractsPersonalDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantContractsPersonalDataQuery,
    GetConsultantContractsPersonalDataQueryVariables
  >
    query={GetConsultantContractsPersonalDataDocument}
    {...props}
  />
);

/**
 * __useGetConsultantContractsPersonalDataQuery__
 *
 * To run a query within a React component, call `useGetConsultantContractsPersonalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantContractsPersonalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantContractsPersonalDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantContractsPersonalDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantContractsPersonalDataQuery,
    GetConsultantContractsPersonalDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantContractsPersonalDataQuery,
    GetConsultantContractsPersonalDataQueryVariables
  >(GetConsultantContractsPersonalDataDocument, options);
}
export function useGetConsultantContractsPersonalDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantContractsPersonalDataQuery,
    GetConsultantContractsPersonalDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantContractsPersonalDataQuery,
    GetConsultantContractsPersonalDataQueryVariables
  >(GetConsultantContractsPersonalDataDocument, options);
}
export type GetConsultantContractsPersonalDataQueryHookResult = ReturnType<
  typeof useGetConsultantContractsPersonalDataQuery
>;
export type GetConsultantContractsPersonalDataLazyQueryHookResult = ReturnType<
  typeof useGetConsultantContractsPersonalDataLazyQuery
>;
export namespace GetConsultantContractsPersonalData {
  export type Return = GetConsultantContractsPersonalDataQuery;
  export type Variables = GetConsultantContractsPersonalDataQueryVariables;
  export const OperationName = "getConsultantContractsPersonalData";

  export const Document = GetConsultantContractsPersonalDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantBookingContractsDocument = gql`
  query getConsultantBookingContracts($id: ObjectId!) {
    getConsultantBookingContracts(consultantId: $id) {
      ...ConsultantBookingContractListItemData
    }
  }
  ${ConsultantBookingContractListItemDataFragmentDoc}
`;
export type GetConsultantBookingContractsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantBookingContractsQuery,
    GetConsultantBookingContractsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantBookingContractsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantBookingContractsComponent = (
  props: GetConsultantBookingContractsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantBookingContractsQuery,
    GetConsultantBookingContractsQueryVariables
  >
    query={GetConsultantBookingContractsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantBookingContractsQuery__
 *
 * To run a query within a React component, call `useGetConsultantBookingContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantBookingContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantBookingContractsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantBookingContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantBookingContractsQuery,
    GetConsultantBookingContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantBookingContractsQuery,
    GetConsultantBookingContractsQueryVariables
  >(GetConsultantBookingContractsDocument, options);
}
export function useGetConsultantBookingContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantBookingContractsQuery,
    GetConsultantBookingContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantBookingContractsQuery,
    GetConsultantBookingContractsQueryVariables
  >(GetConsultantBookingContractsDocument, options);
}
export type GetConsultantBookingContractsQueryHookResult = ReturnType<
  typeof useGetConsultantBookingContractsQuery
>;
export type GetConsultantBookingContractsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantBookingContractsLazyQuery
>;
export namespace GetConsultantBookingContracts {
  export type Return = GetConsultantBookingContractsQuery;
  export type Variables = GetConsultantBookingContractsQueryVariables;
  export const OperationName = "getConsultantBookingContracts";

  export const Document = GetConsultantBookingContractsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadSignedConsultantContractDocument = gql`
  mutation uploadSignedConsultantContract(
    $contractId: ObjectId!
    $file: Upload
    $SignedOn: Date
    $SalaryChoice: ContractType
    $expectedSalary: String
    $payoutType: ConsultantContractPayoutType
    $bankCounselling: Boolean
  ) {
    uploadSignedConsultantContract(
      contractId: $contractId
      file: $file
      salaryChoice: $SalaryChoice
      signedOn: $SignedOn
      expectedSalary: $expectedSalary
      payoutType: $payoutType
      bankCounselling: $bankCounselling
    ) {
      _id
      __typename
      FileUrl
      IsSigned
      ViewUrl
    }
  }
`;
export type UploadSignedConsultantContractMutationFn = Apollo.MutationFunction<
  UploadSignedConsultantContractMutation,
  UploadSignedConsultantContractMutationVariables
>;
export type UploadSignedConsultantContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadSignedConsultantContractMutation,
    UploadSignedConsultantContractMutationVariables
  >,
  "mutation"
>;

export const UploadSignedConsultantContractComponent = (
  props: UploadSignedConsultantContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadSignedConsultantContractMutation,
    UploadSignedConsultantContractMutationVariables
  >
    mutation={UploadSignedConsultantContractDocument}
    {...props}
  />
);

/**
 * __useUploadSignedConsultantContractMutation__
 *
 * To run a mutation, you first call `useUploadSignedConsultantContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSignedConsultantContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSignedConsultantContractMutation, { data, loading, error }] = useUploadSignedConsultantContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      file: // value for 'file'
 *      SignedOn: // value for 'SignedOn'
 *      SalaryChoice: // value for 'SalaryChoice'
 *      expectedSalary: // value for 'expectedSalary'
 *      payoutType: // value for 'payoutType'
 *      bankCounselling: // value for 'bankCounselling'
 *   },
 * });
 */
export function useUploadSignedConsultantContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadSignedConsultantContractMutation,
    UploadSignedConsultantContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadSignedConsultantContractMutation,
    UploadSignedConsultantContractMutationVariables
  >(UploadSignedConsultantContractDocument, options);
}
export type UploadSignedConsultantContractMutationHookResult = ReturnType<
  typeof useUploadSignedConsultantContractMutation
>;
export namespace UploadSignedConsultantContract {
  export type Return = UploadSignedConsultantContractMutation;
  export type Variables = UploadSignedConsultantContractMutationVariables;
  export const OperationName = "uploadSignedConsultantContract";

  export const Document = UploadSignedConsultantContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UploadSignedConsultantBookingContractDocument = gql`
  mutation uploadSignedConsultantBookingContract(
    $contractId: ObjectId!
    $file: Upload!
    $SignedOn: Date
  ) {
    uploadSignedConsultantBookingContract(
      contractId: $contractId
      file: $file
      signedOn: $SignedOn
    ) {
      _id
      FileUrl
      IsSigned
      ViewUrl
    }
  }
`;
export type UploadSignedConsultantBookingContractMutationFn = Apollo.MutationFunction<
  UploadSignedConsultantBookingContractMutation,
  UploadSignedConsultantBookingContractMutationVariables
>;
export type UploadSignedConsultantBookingContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadSignedConsultantBookingContractMutation,
    UploadSignedConsultantBookingContractMutationVariables
  >,
  "mutation"
>;

export const UploadSignedConsultantBookingContractComponent = (
  props: UploadSignedConsultantBookingContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadSignedConsultantBookingContractMutation,
    UploadSignedConsultantBookingContractMutationVariables
  >
    mutation={UploadSignedConsultantBookingContractDocument}
    {...props}
  />
);

/**
 * __useUploadSignedConsultantBookingContractMutation__
 *
 * To run a mutation, you first call `useUploadSignedConsultantBookingContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSignedConsultantBookingContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSignedConsultantBookingContractMutation, { data, loading, error }] = useUploadSignedConsultantBookingContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      file: // value for 'file'
 *      SignedOn: // value for 'SignedOn'
 *   },
 * });
 */
export function useUploadSignedConsultantBookingContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadSignedConsultantBookingContractMutation,
    UploadSignedConsultantBookingContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadSignedConsultantBookingContractMutation,
    UploadSignedConsultantBookingContractMutationVariables
  >(UploadSignedConsultantBookingContractDocument, options);
}
export type UploadSignedConsultantBookingContractMutationHookResult = ReturnType<
  typeof useUploadSignedConsultantBookingContractMutation
>;
export namespace UploadSignedConsultantBookingContract {
  export type Return = UploadSignedConsultantBookingContractMutation;
  export type Variables = UploadSignedConsultantBookingContractMutationVariables;
  export const OperationName = "uploadSignedConsultantBookingContract";

  export const Document = UploadSignedConsultantBookingContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteConsultantBookingContractDocument = gql`
  mutation deleteConsultantBookingContract($contractId: ObjectId!) {
    deleteConsultantBookingContract(contractId: $contractId) {
      _id
      __typename
    }
  }
`;
export type DeleteConsultantBookingContractMutationFn = Apollo.MutationFunction<
  DeleteConsultantBookingContractMutation,
  DeleteConsultantBookingContractMutationVariables
>;
export type DeleteConsultantBookingContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteConsultantBookingContractMutation,
    DeleteConsultantBookingContractMutationVariables
  >,
  "mutation"
>;

export const DeleteConsultantBookingContractComponent = (
  props: DeleteConsultantBookingContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteConsultantBookingContractMutation,
    DeleteConsultantBookingContractMutationVariables
  >
    mutation={DeleteConsultantBookingContractDocument}
    {...props}
  />
);

/**
 * __useDeleteConsultantBookingContractMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantBookingContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantBookingContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantBookingContractMutation, { data, loading, error }] = useDeleteConsultantBookingContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useDeleteConsultantBookingContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsultantBookingContractMutation,
    DeleteConsultantBookingContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsultantBookingContractMutation,
    DeleteConsultantBookingContractMutationVariables
  >(DeleteConsultantBookingContractDocument, options);
}
export type DeleteConsultantBookingContractMutationHookResult = ReturnType<
  typeof useDeleteConsultantBookingContractMutation
>;
export namespace DeleteConsultantBookingContract {
  export type Return = DeleteConsultantBookingContractMutation;
  export type Variables = DeleteConsultantBookingContractMutationVariables;
  export const OperationName = "deleteConsultantBookingContract";

  export const Document = DeleteConsultantBookingContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteConsultantContractDocument = gql`
  mutation deleteConsultantContract($contractId: ObjectId!) {
    deleteConsultantContract(contractId: $contractId) {
      _id
      __typename
    }
  }
`;
export type DeleteConsultantContractMutationFn = Apollo.MutationFunction<
  DeleteConsultantContractMutation,
  DeleteConsultantContractMutationVariables
>;
export type DeleteConsultantContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteConsultantContractMutation,
    DeleteConsultantContractMutationVariables
  >,
  "mutation"
>;

export const DeleteConsultantContractComponent = (
  props: DeleteConsultantContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteConsultantContractMutation,
    DeleteConsultantContractMutationVariables
  >
    mutation={DeleteConsultantContractDocument}
    {...props}
  />
);

/**
 * __useDeleteConsultantContractMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantContractMutation, { data, loading, error }] = useDeleteConsultantContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useDeleteConsultantContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsultantContractMutation,
    DeleteConsultantContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsultantContractMutation,
    DeleteConsultantContractMutationVariables
  >(DeleteConsultantContractDocument, options);
}
export type DeleteConsultantContractMutationHookResult = ReturnType<
  typeof useDeleteConsultantContractMutation
>;
export namespace DeleteConsultantContract {
  export type Return = DeleteConsultantContractMutation;
  export type Variables = DeleteConsultantContractMutationVariables;
  export const OperationName = "deleteConsultantContract";

  export const Document = DeleteConsultantContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SendConsultantContractEmailToConsultantDocument = gql`
  mutation sendConsultantContractEmailToConsultant(
    $subject: String!
    $body: String!
    $consultantId: ObjectId!
    $attachment: [ObjectId]
  ) {
    sendConsultantContractEmailToConsultant(
      subject: $subject
      body: $body
      consultantId: $consultantId
      attachment: $attachment
    ) {
      Subject
      Body
    }
  }
`;
export type SendConsultantContractEmailToConsultantMutationFn = Apollo.MutationFunction<
  SendConsultantContractEmailToConsultantMutation,
  SendConsultantContractEmailToConsultantMutationVariables
>;
export type SendConsultantContractEmailToConsultantComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendConsultantContractEmailToConsultantMutation,
    SendConsultantContractEmailToConsultantMutationVariables
  >,
  "mutation"
>;

export const SendConsultantContractEmailToConsultantComponent = (
  props: SendConsultantContractEmailToConsultantComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SendConsultantContractEmailToConsultantMutation,
    SendConsultantContractEmailToConsultantMutationVariables
  >
    mutation={SendConsultantContractEmailToConsultantDocument}
    {...props}
  />
);

/**
 * __useSendConsultantContractEmailToConsultantMutation__
 *
 * To run a mutation, you first call `useSendConsultantContractEmailToConsultantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConsultantContractEmailToConsultantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConsultantContractEmailToConsultantMutation, { data, loading, error }] = useSendConsultantContractEmailToConsultantMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      consultantId: // value for 'consultantId'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useSendConsultantContractEmailToConsultantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendConsultantContractEmailToConsultantMutation,
    SendConsultantContractEmailToConsultantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendConsultantContractEmailToConsultantMutation,
    SendConsultantContractEmailToConsultantMutationVariables
  >(SendConsultantContractEmailToConsultantDocument, options);
}
export type SendConsultantContractEmailToConsultantMutationHookResult = ReturnType<
  typeof useSendConsultantContractEmailToConsultantMutation
>;
export namespace SendConsultantContractEmailToConsultant {
  export type Return = SendConsultantContractEmailToConsultantMutation;
  export type Variables = SendConsultantContractEmailToConsultantMutationVariables;
  export const OperationName = "sendConsultantContractEmailToConsultant";

  export const Document = SendConsultantContractEmailToConsultantDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SendConsultantBookingContractEmailToBADocument = gql`
  mutation sendConsultantBookingContractEmailToBA(
    $subject: String!
    $body: String!
    $recipients: [EmailRecipientInput!]
    $attachment: [ObjectId]
  ) {
    sendConsultantBookingContractEmailToBA(
      subject: $subject
      body: $body
      recipients: $recipients
      attachment: $attachment
    ) {
      Subject
      Body
    }
  }
`;
export type SendConsultantBookingContractEmailToBAMutationFn = Apollo.MutationFunction<
  SendConsultantBookingContractEmailToBAMutation,
  SendConsultantBookingContractEmailToBAMutationVariables
>;
export type SendConsultantBookingContractEmailToBAComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendConsultantBookingContractEmailToBAMutation,
    SendConsultantBookingContractEmailToBAMutationVariables
  >,
  "mutation"
>;

export const SendConsultantBookingContractEmailToBAComponent = (
  props: SendConsultantBookingContractEmailToBAComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SendConsultantBookingContractEmailToBAMutation,
    SendConsultantBookingContractEmailToBAMutationVariables
  >
    mutation={SendConsultantBookingContractEmailToBADocument}
    {...props}
  />
);

/**
 * __useSendConsultantBookingContractEmailToBAMutation__
 *
 * To run a mutation, you first call `useSendConsultantBookingContractEmailToBAMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConsultantBookingContractEmailToBAMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConsultantBookingContractEmailToBaMutation, { data, loading, error }] = useSendConsultantBookingContractEmailToBAMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      recipients: // value for 'recipients'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useSendConsultantBookingContractEmailToBAMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendConsultantBookingContractEmailToBAMutation,
    SendConsultantBookingContractEmailToBAMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendConsultantBookingContractEmailToBAMutation,
    SendConsultantBookingContractEmailToBAMutationVariables
  >(SendConsultantBookingContractEmailToBADocument, options);
}
export type SendConsultantBookingContractEmailToBAMutationHookResult = ReturnType<
  typeof useSendConsultantBookingContractEmailToBAMutation
>;
export namespace SendConsultantBookingContractEmailToBA {
  export type Return = SendConsultantBookingContractEmailToBAMutation;
  export type Variables = SendConsultantBookingContractEmailToBAMutationVariables;
  export const OperationName = "sendConsultantBookingContractEmailToBA";

  export const Document = SendConsultantBookingContractEmailToBADocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddSalaryChoiceToConsultantContractDocument = gql`
  mutation addSalaryChoiceToConsultantContract(
    $contractId: ObjectId!
    $salaryChoice: ContractType!
  ) {
    addSalaryChoiceToConsultantContract(
      contractId: $contractId
      salaryChoice: $salaryChoice
    ) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type AddSalaryChoiceToConsultantContractMutationFn = Apollo.MutationFunction<
  AddSalaryChoiceToConsultantContractMutation,
  AddSalaryChoiceToConsultantContractMutationVariables
>;
export type AddSalaryChoiceToConsultantContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddSalaryChoiceToConsultantContractMutation,
    AddSalaryChoiceToConsultantContractMutationVariables
  >,
  "mutation"
>;

export const AddSalaryChoiceToConsultantContractComponent = (
  props: AddSalaryChoiceToConsultantContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddSalaryChoiceToConsultantContractMutation,
    AddSalaryChoiceToConsultantContractMutationVariables
  >
    mutation={AddSalaryChoiceToConsultantContractDocument}
    {...props}
  />
);

/**
 * __useAddSalaryChoiceToConsultantContractMutation__
 *
 * To run a mutation, you first call `useAddSalaryChoiceToConsultantContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalaryChoiceToConsultantContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalaryChoiceToConsultantContractMutation, { data, loading, error }] = useAddSalaryChoiceToConsultantContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      salaryChoice: // value for 'salaryChoice'
 *   },
 * });
 */
export function useAddSalaryChoiceToConsultantContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSalaryChoiceToConsultantContractMutation,
    AddSalaryChoiceToConsultantContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSalaryChoiceToConsultantContractMutation,
    AddSalaryChoiceToConsultantContractMutationVariables
  >(AddSalaryChoiceToConsultantContractDocument, options);
}
export type AddSalaryChoiceToConsultantContractMutationHookResult = ReturnType<
  typeof useAddSalaryChoiceToConsultantContractMutation
>;
export namespace AddSalaryChoiceToConsultantContract {
  export type Return = AddSalaryChoiceToConsultantContractMutation;
  export type Variables = AddSalaryChoiceToConsultantContractMutationVariables;
  export const OperationName = "addSalaryChoiceToConsultantContract";

  export const Document = AddSalaryChoiceToConsultantContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const NullifyConsultantContractDocument = gql`
  mutation nullifyConsultantContract(
    $contractId: ObjectId!
    $nullify: Boolean!
    $nullificationReason: String
  ) {
    nullifyConsultantContract(
      contractId: $contractId
      nullify: $nullify
      nullificationReason: $nullificationReason
    ) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type NullifyConsultantContractMutationFn = Apollo.MutationFunction<
  NullifyConsultantContractMutation,
  NullifyConsultantContractMutationVariables
>;
export type NullifyConsultantContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NullifyConsultantContractMutation,
    NullifyConsultantContractMutationVariables
  >,
  "mutation"
>;

export const NullifyConsultantContractComponent = (
  props: NullifyConsultantContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    NullifyConsultantContractMutation,
    NullifyConsultantContractMutationVariables
  >
    mutation={NullifyConsultantContractDocument}
    {...props}
  />
);

/**
 * __useNullifyConsultantContractMutation__
 *
 * To run a mutation, you first call `useNullifyConsultantContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNullifyConsultantContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nullifyConsultantContractMutation, { data, loading, error }] = useNullifyConsultantContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      nullify: // value for 'nullify'
 *      nullificationReason: // value for 'nullificationReason'
 *   },
 * });
 */
export function useNullifyConsultantContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NullifyConsultantContractMutation,
    NullifyConsultantContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NullifyConsultantContractMutation,
    NullifyConsultantContractMutationVariables
  >(NullifyConsultantContractDocument, options);
}
export type NullifyConsultantContractMutationHookResult = ReturnType<
  typeof useNullifyConsultantContractMutation
>;
export namespace NullifyConsultantContract {
  export type Return = NullifyConsultantContractMutation;
  export type Variables = NullifyConsultantContractMutationVariables;
  export const OperationName = "nullifyConsultantContract";

  export const Document = NullifyConsultantContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const NullifyConsultantBookingContractDocument = gql`
  mutation nullifyConsultantBookingContract($contractId: ObjectId!, $nullify: Boolean!) {
    nullifyConsultantBookingContract(contractId: $contractId, nullify: $nullify) {
      ...ConsultantBookingContractListItemData
    }
  }
  ${ConsultantBookingContractListItemDataFragmentDoc}
`;
export type NullifyConsultantBookingContractMutationFn = Apollo.MutationFunction<
  NullifyConsultantBookingContractMutation,
  NullifyConsultantBookingContractMutationVariables
>;
export type NullifyConsultantBookingContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NullifyConsultantBookingContractMutation,
    NullifyConsultantBookingContractMutationVariables
  >,
  "mutation"
>;

export const NullifyConsultantBookingContractComponent = (
  props: NullifyConsultantBookingContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    NullifyConsultantBookingContractMutation,
    NullifyConsultantBookingContractMutationVariables
  >
    mutation={NullifyConsultantBookingContractDocument}
    {...props}
  />
);

/**
 * __useNullifyConsultantBookingContractMutation__
 *
 * To run a mutation, you first call `useNullifyConsultantBookingContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNullifyConsultantBookingContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nullifyConsultantBookingContractMutation, { data, loading, error }] = useNullifyConsultantBookingContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      nullify: // value for 'nullify'
 *   },
 * });
 */
export function useNullifyConsultantBookingContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NullifyConsultantBookingContractMutation,
    NullifyConsultantBookingContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NullifyConsultantBookingContractMutation,
    NullifyConsultantBookingContractMutationVariables
  >(NullifyConsultantBookingContractDocument, options);
}
export type NullifyConsultantBookingContractMutationHookResult = ReturnType<
  typeof useNullifyConsultantBookingContractMutation
>;
export namespace NullifyConsultantBookingContract {
  export type Return = NullifyConsultantBookingContractMutation;
  export type Variables = NullifyConsultantBookingContractMutationVariables;
  export const OperationName = "nullifyConsultantBookingContract";

  export const Document = NullifyConsultantBookingContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddUnsignedConsultantContractDocument = gql`
  mutation addUnsignedConsultantContract(
    $consultantId: ObjectId!
    $data: ConsultantContractFormInput!
  ) {
    addUnSignConsultantContract(consultantId: $consultantId, data: $data) {
      ...ConsultantContractTableRowData
    }
  }
  ${ConsultantContractTableRowDataFragmentDoc}
`;
export type AddUnsignedConsultantContractMutationFn = Apollo.MutationFunction<
  AddUnsignedConsultantContractMutation,
  AddUnsignedConsultantContractMutationVariables
>;
export type AddUnsignedConsultantContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddUnsignedConsultantContractMutation,
    AddUnsignedConsultantContractMutationVariables
  >,
  "mutation"
>;

export const AddUnsignedConsultantContractComponent = (
  props: AddUnsignedConsultantContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddUnsignedConsultantContractMutation,
    AddUnsignedConsultantContractMutationVariables
  >
    mutation={AddUnsignedConsultantContractDocument}
    {...props}
  />
);

/**
 * __useAddUnsignedConsultantContractMutation__
 *
 * To run a mutation, you first call `useAddUnsignedConsultantContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUnsignedConsultantContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUnsignedConsultantContractMutation, { data, loading, error }] = useAddUnsignedConsultantContractMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUnsignedConsultantContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUnsignedConsultantContractMutation,
    AddUnsignedConsultantContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddUnsignedConsultantContractMutation,
    AddUnsignedConsultantContractMutationVariables
  >(AddUnsignedConsultantContractDocument, options);
}
export type AddUnsignedConsultantContractMutationHookResult = ReturnType<
  typeof useAddUnsignedConsultantContractMutation
>;
export namespace AddUnsignedConsultantContract {
  export type Return = AddUnsignedConsultantContractMutation;
  export type Variables = AddUnsignedConsultantContractMutationVariables;
  export const OperationName = "addUnsignedConsultantContract";

  export const Document = AddUnsignedConsultantContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GenerateConsultantPresentationDocument = gql`
  mutation generateConsultantPresentation(
    $consultantId: ObjectId!
    $presentationType: ConsultantPresentationType!
    $presentationCountry: ConsultantPresentationCountry!
    $presentationText: String
    $fileIds: [ObjectId!]!
    $evaluatesIds: [ObjectId!]!
    $evaluatesThreeMonthsIds: [ObjectId!]!
    $referenceIds: [ObjectId!]!
    $contactPerson: String
    $generateCV: Boolean
  ) {
    consultantGeneratePresentation(
      consultantId: $consultantId
      presentationType: $presentationType
      presentationCountry: $presentationCountry
      presentationText: $presentationText
      fileIds: $fileIds
      evaluatesIds: $evaluatesIds
      evaluatesThreeMonthsIds: $evaluatesThreeMonthsIds
      referenceIds: $referenceIds
      contactPerson: $contactPerson
      generateCV: $generateCV
    ) {
      presentation {
        _id
        ViewURL
      }
      attachmentErrors {
        fileId
        filename
        error
      }
    }
  }
`;
export type GenerateConsultantPresentationMutationFn = Apollo.MutationFunction<
  GenerateConsultantPresentationMutation,
  GenerateConsultantPresentationMutationVariables
>;
export type GenerateConsultantPresentationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    GenerateConsultantPresentationMutation,
    GenerateConsultantPresentationMutationVariables
  >,
  "mutation"
>;

export const GenerateConsultantPresentationComponent = (
  props: GenerateConsultantPresentationComponentProps
) => (
  <ApolloReactComponents.Mutation<
    GenerateConsultantPresentationMutation,
    GenerateConsultantPresentationMutationVariables
  >
    mutation={GenerateConsultantPresentationDocument}
    {...props}
  />
);

/**
 * __useGenerateConsultantPresentationMutation__
 *
 * To run a mutation, you first call `useGenerateConsultantPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateConsultantPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateConsultantPresentationMutation, { data, loading, error }] = useGenerateConsultantPresentationMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      presentationType: // value for 'presentationType'
 *      presentationCountry: // value for 'presentationCountry'
 *      presentationText: // value for 'presentationText'
 *      fileIds: // value for 'fileIds'
 *      evaluatesIds: // value for 'evaluatesIds'
 *      evaluatesThreeMonthsIds: // value for 'evaluatesThreeMonthsIds'
 *      referenceIds: // value for 'referenceIds'
 *      contactPerson: // value for 'contactPerson'
 *      generateCV: // value for 'generateCV'
 *   },
 * });
 */
export function useGenerateConsultantPresentationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateConsultantPresentationMutation,
    GenerateConsultantPresentationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateConsultantPresentationMutation,
    GenerateConsultantPresentationMutationVariables
  >(GenerateConsultantPresentationDocument, options);
}
export type GenerateConsultantPresentationMutationHookResult = ReturnType<
  typeof useGenerateConsultantPresentationMutation
>;
export namespace GenerateConsultantPresentation {
  export type Return = GenerateConsultantPresentationMutation;
  export type Variables = GenerateConsultantPresentationMutationVariables;
  export const OperationName = "generateConsultantPresentation";

  export const Document = GenerateConsultantPresentationDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SendConsultantPresentationEmailDocument = gql`
  mutation sendConsultantPresentationEmail(
    $consultantId: ObjectId!
    $presentationId: ObjectId!
    $recipients: [EmailRecipientInput!]!
    $subject: String!
    $body: String!
    $attachments: [ObjectId!]
  ) {
    sendConsultantPresentation(
      consultantId: $consultantId
      presentationId: $presentationId
      recipients: $recipients
      subject: $subject
      body: $body
      attachments: $attachments
    )
  }
`;
export type SendConsultantPresentationEmailMutationFn = Apollo.MutationFunction<
  SendConsultantPresentationEmailMutation,
  SendConsultantPresentationEmailMutationVariables
>;
export type SendConsultantPresentationEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendConsultantPresentationEmailMutation,
    SendConsultantPresentationEmailMutationVariables
  >,
  "mutation"
>;

export const SendConsultantPresentationEmailComponent = (
  props: SendConsultantPresentationEmailComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SendConsultantPresentationEmailMutation,
    SendConsultantPresentationEmailMutationVariables
  >
    mutation={SendConsultantPresentationEmailDocument}
    {...props}
  />
);

/**
 * __useSendConsultantPresentationEmailMutation__
 *
 * To run a mutation, you first call `useSendConsultantPresentationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConsultantPresentationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConsultantPresentationEmailMutation, { data, loading, error }] = useSendConsultantPresentationEmailMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      presentationId: // value for 'presentationId'
 *      recipients: // value for 'recipients'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendConsultantPresentationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendConsultantPresentationEmailMutation,
    SendConsultantPresentationEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendConsultantPresentationEmailMutation,
    SendConsultantPresentationEmailMutationVariables
  >(SendConsultantPresentationEmailDocument, options);
}
export type SendConsultantPresentationEmailMutationHookResult = ReturnType<
  typeof useSendConsultantPresentationEmailMutation
>;
export namespace SendConsultantPresentationEmail {
  export type Return = SendConsultantPresentationEmailMutation;
  export type Variables = SendConsultantPresentationEmailMutationVariables;
  export const OperationName = "sendConsultantPresentationEmail";

  export const Document = SendConsultantPresentationEmailDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantShareableFilesDocument = gql`
  query getConsultantShareableFiles($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantShareableFilesNew
    }
    consultantReferenceDocuments(consultantId: $consultantId) {
      ...ConsultantReferenceDocument
    }
  }
  ${ConsultantShareableFilesNewFragmentDoc}
  ${ConsultantReferenceDocumentFragmentDoc}
`;
export type GetConsultantShareableFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantShareableFilesQuery,
    GetConsultantShareableFilesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantShareableFilesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantShareableFilesComponent = (
  props: GetConsultantShareableFilesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantShareableFilesQuery,
    GetConsultantShareableFilesQueryVariables
  >
    query={GetConsultantShareableFilesDocument}
    {...props}
  />
);

/**
 * __useGetConsultantShareableFilesQuery__
 *
 * To run a query within a React component, call `useGetConsultantShareableFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantShareableFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantShareableFilesQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantShareableFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantShareableFilesQuery,
    GetConsultantShareableFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantShareableFilesQuery,
    GetConsultantShareableFilesQueryVariables
  >(GetConsultantShareableFilesDocument, options);
}
export function useGetConsultantShareableFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantShareableFilesQuery,
    GetConsultantShareableFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantShareableFilesQuery,
    GetConsultantShareableFilesQueryVariables
  >(GetConsultantShareableFilesDocument, options);
}
export type GetConsultantShareableFilesQueryHookResult = ReturnType<
  typeof useGetConsultantShareableFilesQuery
>;
export type GetConsultantShareableFilesLazyQueryHookResult = ReturnType<
  typeof useGetConsultantShareableFilesLazyQuery
>;
export namespace GetConsultantShareableFiles {
  export type Return = GetConsultantShareableFilesQuery;
  export type Variables = GetConsultantShareableFilesQueryVariables;
  export const OperationName = "getConsultantShareableFiles";

  export const Document = GetConsultantShareableFilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantCreatePresentationDataDocument = gql`
  query getConsultantCreatePresentationData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantCreatePresentationData
    }
  }
  ${ConsultantCreatePresentationDataFragmentDoc}
`;
export type GetConsultantCreatePresentationDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantCreatePresentationDataQuery,
    GetConsultantCreatePresentationDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantCreatePresentationDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantCreatePresentationDataComponent = (
  props: GetConsultantCreatePresentationDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantCreatePresentationDataQuery,
    GetConsultantCreatePresentationDataQueryVariables
  >
    query={GetConsultantCreatePresentationDataDocument}
    {...props}
  />
);

/**
 * __useGetConsultantCreatePresentationDataQuery__
 *
 * To run a query within a React component, call `useGetConsultantCreatePresentationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantCreatePresentationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantCreatePresentationDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantCreatePresentationDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantCreatePresentationDataQuery,
    GetConsultantCreatePresentationDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantCreatePresentationDataQuery,
    GetConsultantCreatePresentationDataQueryVariables
  >(GetConsultantCreatePresentationDataDocument, options);
}
export function useGetConsultantCreatePresentationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantCreatePresentationDataQuery,
    GetConsultantCreatePresentationDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantCreatePresentationDataQuery,
    GetConsultantCreatePresentationDataQueryVariables
  >(GetConsultantCreatePresentationDataDocument, options);
}
export type GetConsultantCreatePresentationDataQueryHookResult = ReturnType<
  typeof useGetConsultantCreatePresentationDataQuery
>;
export type GetConsultantCreatePresentationDataLazyQueryHookResult = ReturnType<
  typeof useGetConsultantCreatePresentationDataLazyQuery
>;
export namespace GetConsultantCreatePresentationData {
  export type Return = GetConsultantCreatePresentationDataQuery;
  export type Variables = GetConsultantCreatePresentationDataQueryVariables;
  export const OperationName = "getConsultantCreatePresentationData";

  export const Document = GetConsultantCreatePresentationDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SearchContactPersonsEmailDocument = gql`
  query searchContactPersonsEmail(
    $filter: ContactPersonsFilter
    $skip: Int!
    $limit: Int!
  ) {
    contactPersons(filter: $filter, limit: $limit, skip: $skip) {
      items {
        ...ContactPersonsEmailSearchData
      }
    }
  }
  ${ContactPersonsEmailSearchDataFragmentDoc}
`;
export type SearchContactPersonsEmailComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SearchContactPersonsEmailQuery,
    SearchContactPersonsEmailQueryVariables
  >,
  "query"
> &
  (
    | { variables: SearchContactPersonsEmailQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SearchContactPersonsEmailComponent = (
  props: SearchContactPersonsEmailComponentProps
) => (
  <ApolloReactComponents.Query<
    SearchContactPersonsEmailQuery,
    SearchContactPersonsEmailQueryVariables
  >
    query={SearchContactPersonsEmailDocument}
    {...props}
  />
);

/**
 * __useSearchContactPersonsEmailQuery__
 *
 * To run a query within a React component, call `useSearchContactPersonsEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactPersonsEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactPersonsEmailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchContactPersonsEmailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchContactPersonsEmailQuery,
    SearchContactPersonsEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchContactPersonsEmailQuery,
    SearchContactPersonsEmailQueryVariables
  >(SearchContactPersonsEmailDocument, options);
}
export function useSearchContactPersonsEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchContactPersonsEmailQuery,
    SearchContactPersonsEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchContactPersonsEmailQuery,
    SearchContactPersonsEmailQueryVariables
  >(SearchContactPersonsEmailDocument, options);
}
export type SearchContactPersonsEmailQueryHookResult = ReturnType<
  typeof useSearchContactPersonsEmailQuery
>;
export type SearchContactPersonsEmailLazyQueryHookResult = ReturnType<
  typeof useSearchContactPersonsEmailLazyQuery
>;
export namespace SearchContactPersonsEmail {
  export type Return = SearchContactPersonsEmailQuery;
  export type Variables = SearchContactPersonsEmailQueryVariables;
  export const OperationName = "searchContactPersonsEmail";

  export const Document = SearchContactPersonsEmailDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantEventLogEventsDocument = gql`
  query getConsultantEventLogEvents(
    $consultantId: ObjectId!
    $skip: Int
    $limit: Int
    $type: [ConsultantEventType]
    $includeDeleted: Boolean
  ) {
    consultantEvents(
      consultantId: $consultantId
      skip: $skip
      limit: $limit
      type: $type
      includeDeleted: $includeDeleted
    ) {
      ...ConsultantEventLogData
    }
  }
  ${ConsultantEventLogDataFragmentDoc}
`;
export type GetConsultantEventLogEventsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantEventLogEventsQuery,
    GetConsultantEventLogEventsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantEventLogEventsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantEventLogEventsComponent = (
  props: GetConsultantEventLogEventsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantEventLogEventsQuery,
    GetConsultantEventLogEventsQueryVariables
  >
    query={GetConsultantEventLogEventsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantEventLogEventsQuery__
 *
 * To run a query within a React component, call `useGetConsultantEventLogEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantEventLogEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantEventLogEventsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetConsultantEventLogEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantEventLogEventsQuery,
    GetConsultantEventLogEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantEventLogEventsQuery,
    GetConsultantEventLogEventsQueryVariables
  >(GetConsultantEventLogEventsDocument, options);
}
export function useGetConsultantEventLogEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantEventLogEventsQuery,
    GetConsultantEventLogEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantEventLogEventsQuery,
    GetConsultantEventLogEventsQueryVariables
  >(GetConsultantEventLogEventsDocument, options);
}
export type GetConsultantEventLogEventsQueryHookResult = ReturnType<
  typeof useGetConsultantEventLogEventsQuery
>;
export type GetConsultantEventLogEventsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantEventLogEventsLazyQuery
>;
export namespace GetConsultantEventLogEvents {
  export type Return = GetConsultantEventLogEventsQuery;
  export type Variables = GetConsultantEventLogEventsQueryVariables;
  export const OperationName = "getConsultantEventLogEvents";

  export const Document = GetConsultantEventLogEventsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantEventLogMetaDataDocument = gql`
  query getConsultantEventLogMetaData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantEventLogMetaData
    }
  }
  ${ConsultantEventLogMetaDataFragmentDoc}
`;
export type GetConsultantEventLogMetaDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantEventLogMetaDataQuery,
    GetConsultantEventLogMetaDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantEventLogMetaDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantEventLogMetaDataComponent = (
  props: GetConsultantEventLogMetaDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantEventLogMetaDataQuery,
    GetConsultantEventLogMetaDataQueryVariables
  >
    query={GetConsultantEventLogMetaDataDocument}
    {...props}
  />
);

/**
 * __useGetConsultantEventLogMetaDataQuery__
 *
 * To run a query within a React component, call `useGetConsultantEventLogMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantEventLogMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantEventLogMetaDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantEventLogMetaDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantEventLogMetaDataQuery,
    GetConsultantEventLogMetaDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantEventLogMetaDataQuery,
    GetConsultantEventLogMetaDataQueryVariables
  >(GetConsultantEventLogMetaDataDocument, options);
}
export function useGetConsultantEventLogMetaDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantEventLogMetaDataQuery,
    GetConsultantEventLogMetaDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantEventLogMetaDataQuery,
    GetConsultantEventLogMetaDataQueryVariables
  >(GetConsultantEventLogMetaDataDocument, options);
}
export type GetConsultantEventLogMetaDataQueryHookResult = ReturnType<
  typeof useGetConsultantEventLogMetaDataQuery
>;
export type GetConsultantEventLogMetaDataLazyQueryHookResult = ReturnType<
  typeof useGetConsultantEventLogMetaDataLazyQuery
>;
export namespace GetConsultantEventLogMetaData {
  export type Return = GetConsultantEventLogMetaDataQuery;
  export type Variables = GetConsultantEventLogMetaDataQueryVariables;
  export const OperationName = "getConsultantEventLogMetaData";

  export const Document = GetConsultantEventLogMetaDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantEventLog_GetEventsDocument = gql`
  query ConsultantEventLog_GetEvents($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantEventLog_Consultant
    }
    consultantEvents(consultantId: $consultantId, limit: 500) {
      ...EventLog_ConsultantEvent
    }
  }
  ${ConsultantEventLog_ConsultantFragmentDoc}
  ${EventLog_ConsultantEventFragmentDoc}
`;
export type ConsultantEventLog_GetEventsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantEventLog_GetEventsQuery,
    ConsultantEventLog_GetEventsQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantEventLog_GetEventsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantEventLog_GetEventsComponent = (
  props: ConsultantEventLog_GetEventsComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantEventLog_GetEventsQuery,
    ConsultantEventLog_GetEventsQueryVariables
  >
    query={ConsultantEventLog_GetEventsDocument}
    {...props}
  />
);

/**
 * __useConsultantEventLog_GetEventsQuery__
 *
 * To run a query within a React component, call `useConsultantEventLog_GetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantEventLog_GetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantEventLog_GetEventsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantEventLog_GetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantEventLog_GetEventsQuery,
    ConsultantEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantEventLog_GetEventsQuery,
    ConsultantEventLog_GetEventsQueryVariables
  >(ConsultantEventLog_GetEventsDocument, options);
}
export function useConsultantEventLog_GetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantEventLog_GetEventsQuery,
    ConsultantEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantEventLog_GetEventsQuery,
    ConsultantEventLog_GetEventsQueryVariables
  >(ConsultantEventLog_GetEventsDocument, options);
}
export type ConsultantEventLog_GetEventsQueryHookResult = ReturnType<
  typeof useConsultantEventLog_GetEventsQuery
>;
export type ConsultantEventLog_GetEventsLazyQueryHookResult = ReturnType<
  typeof useConsultantEventLog_GetEventsLazyQuery
>;
export namespace ConsultantEventLog_GetEvents {
  export type Return = ConsultantEventLog_GetEventsQuery;
  export type Variables = ConsultantEventLog_GetEventsQueryVariables;
  export const OperationName = "ConsultantEventLog_GetEvents";

  export const Document = ConsultantEventLog_GetEventsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogCommentDocument = gql`
  mutation addConsultantEventLogComment(
    $consultantId: ObjectId!
    $desc: String!
    $withTodo: WithTodoInput
  ) {
    addConsultantCommentEvent(
      consultantId: $consultantId
      desc: $desc
      withTodo: $withTodo
    ) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type AddConsultantEventLogCommentMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogCommentMutation,
  AddConsultantEventLogCommentMutationVariables
>;
export type AddConsultantEventLogCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogCommentMutation,
    AddConsultantEventLogCommentMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogCommentComponent = (
  props: AddConsultantEventLogCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogCommentMutation,
    AddConsultantEventLogCommentMutationVariables
  >
    mutation={AddConsultantEventLogCommentDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogCommentMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogCommentMutation, { data, loading, error }] = useAddConsultantEventLogCommentMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      desc: // value for 'desc'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useAddConsultantEventLogCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogCommentMutation,
    AddConsultantEventLogCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogCommentMutation,
    AddConsultantEventLogCommentMutationVariables
  >(AddConsultantEventLogCommentDocument, options);
}
export type AddConsultantEventLogCommentMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogCommentMutation
>;
export namespace AddConsultantEventLogComment {
  export type Return = AddConsultantEventLogCommentMutation;
  export type Variables = AddConsultantEventLogCommentMutationVariables;
  export const OperationName = "addConsultantEventLogComment";

  export const Document = AddConsultantEventLogCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogReminderDocument = gql`
  mutation addConsultantEventLogReminder(
    $consultantId: ObjectId!
    $desc: String!
    $withTodo: WithTodoInput
  ) {
    addConsultantReminderEvent(
      consultantId: $consultantId
      desc: $desc
      withTodo: $withTodo
    ) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type AddConsultantEventLogReminderMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogReminderMutation,
  AddConsultantEventLogReminderMutationVariables
>;
export type AddConsultantEventLogReminderComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogReminderMutation,
    AddConsultantEventLogReminderMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogReminderComponent = (
  props: AddConsultantEventLogReminderComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogReminderMutation,
    AddConsultantEventLogReminderMutationVariables
  >
    mutation={AddConsultantEventLogReminderDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogReminderMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogReminderMutation, { data, loading, error }] = useAddConsultantEventLogReminderMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      desc: // value for 'desc'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useAddConsultantEventLogReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogReminderMutation,
    AddConsultantEventLogReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogReminderMutation,
    AddConsultantEventLogReminderMutationVariables
  >(AddConsultantEventLogReminderDocument, options);
}
export type AddConsultantEventLogReminderMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogReminderMutation
>;
export namespace AddConsultantEventLogReminder {
  export type Return = AddConsultantEventLogReminderMutation;
  export type Variables = AddConsultantEventLogReminderMutationVariables;
  export const OperationName = "addConsultantEventLogReminder";

  export const Document = AddConsultantEventLogReminderDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogMailDocument = gql`
  mutation addConsultantEventLogMail(
    $subject: String!
    $body: String!
    $consultantId: ObjectId!
    $attachment: [ObjectId]
  ) {
    sendEmailToConsultant(
      subject: $subject
      body: $body
      consultantId: $consultantId
      attachment: $attachment
    ) {
      Subject
      Body
    }
  }
`;
export type AddConsultantEventLogMailMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogMailMutation,
  AddConsultantEventLogMailMutationVariables
>;
export type AddConsultantEventLogMailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogMailMutation,
    AddConsultantEventLogMailMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogMailComponent = (
  props: AddConsultantEventLogMailComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogMailMutation,
    AddConsultantEventLogMailMutationVariables
  >
    mutation={AddConsultantEventLogMailDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogMailMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogMailMutation, { data, loading, error }] = useAddConsultantEventLogMailMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      consultantId: // value for 'consultantId'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useAddConsultantEventLogMailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogMailMutation,
    AddConsultantEventLogMailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogMailMutation,
    AddConsultantEventLogMailMutationVariables
  >(AddConsultantEventLogMailDocument, options);
}
export type AddConsultantEventLogMailMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogMailMutation
>;
export namespace AddConsultantEventLogMail {
  export type Return = AddConsultantEventLogMailMutation;
  export type Variables = AddConsultantEventLogMailMutationVariables;
  export const OperationName = "addConsultantEventLogMail";

  export const Document = AddConsultantEventLogMailDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogSmsDocument = gql`
  mutation addConsultantEventLogSms($consultantId: ObjectId!, $desc: String!) {
    addConsultantSMSEvent(consultantId: $consultantId, desc: $desc) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type AddConsultantEventLogSmsMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogSmsMutation,
  AddConsultantEventLogSmsMutationVariables
>;
export type AddConsultantEventLogSmsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogSmsMutation,
    AddConsultantEventLogSmsMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogSmsComponent = (
  props: AddConsultantEventLogSmsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogSmsMutation,
    AddConsultantEventLogSmsMutationVariables
  >
    mutation={AddConsultantEventLogSmsDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogSmsMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogSmsMutation, { data, loading, error }] = useAddConsultantEventLogSmsMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useAddConsultantEventLogSmsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogSmsMutation,
    AddConsultantEventLogSmsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogSmsMutation,
    AddConsultantEventLogSmsMutationVariables
  >(AddConsultantEventLogSmsDocument, options);
}
export type AddConsultantEventLogSmsMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogSmsMutation
>;
export namespace AddConsultantEventLogSms {
  export type Return = AddConsultantEventLogSmsMutation;
  export type Variables = AddConsultantEventLogSmsMutationVariables;
  export const OperationName = "addConsultantEventLogSms";

  export const Document = AddConsultantEventLogSmsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogCallDocument = gql`
  mutation addConsultantEventLogCall($consultantId: ObjectId!, $desc: String!) {
    addConsultantCallEvent(consultantId: $consultantId, desc: $desc) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type AddConsultantEventLogCallMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogCallMutation,
  AddConsultantEventLogCallMutationVariables
>;
export type AddConsultantEventLogCallComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogCallMutation,
    AddConsultantEventLogCallMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogCallComponent = (
  props: AddConsultantEventLogCallComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogCallMutation,
    AddConsultantEventLogCallMutationVariables
  >
    mutation={AddConsultantEventLogCallDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogCallMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogCallMutation, { data, loading, error }] = useAddConsultantEventLogCallMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useAddConsultantEventLogCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogCallMutation,
    AddConsultantEventLogCallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogCallMutation,
    AddConsultantEventLogCallMutationVariables
  >(AddConsultantEventLogCallDocument, options);
}
export type AddConsultantEventLogCallMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogCallMutation
>;
export namespace AddConsultantEventLogCall {
  export type Return = AddConsultantEventLogCallMutation;
  export type Variables = AddConsultantEventLogCallMutationVariables;
  export const OperationName = "addConsultantEventLogCall";

  export const Document = AddConsultantEventLogCallDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogNoAnswerDocument = gql`
  mutation addConsultantEventLogNoAnswer($consultantId: ObjectId!) {
    addConsultantNoanswerEvent(consultantId: $consultantId) {
      event {
        ...EventData
      }
    }
  }
  ${EventDataFragmentDoc}
`;
export type AddConsultantEventLogNoAnswerMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogNoAnswerMutation,
  AddConsultantEventLogNoAnswerMutationVariables
>;
export type AddConsultantEventLogNoAnswerComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogNoAnswerMutation,
    AddConsultantEventLogNoAnswerMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogNoAnswerComponent = (
  props: AddConsultantEventLogNoAnswerComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogNoAnswerMutation,
    AddConsultantEventLogNoAnswerMutationVariables
  >
    mutation={AddConsultantEventLogNoAnswerDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogNoAnswerMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogNoAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogNoAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogNoAnswerMutation, { data, loading, error }] = useAddConsultantEventLogNoAnswerMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useAddConsultantEventLogNoAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogNoAnswerMutation,
    AddConsultantEventLogNoAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogNoAnswerMutation,
    AddConsultantEventLogNoAnswerMutationVariables
  >(AddConsultantEventLogNoAnswerDocument, options);
}
export type AddConsultantEventLogNoAnswerMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogNoAnswerMutation
>;
export namespace AddConsultantEventLogNoAnswer {
  export type Return = AddConsultantEventLogNoAnswerMutation;
  export type Variables = AddConsultantEventLogNoAnswerMutationVariables;
  export const OperationName = "addConsultantEventLogNoAnswer";

  export const Document = AddConsultantEventLogNoAnswerDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddConsultantEventLogInterestDocument = gql`
  mutation addConsultantEventLogInterest($consultantId: ObjectId!) {
    addConsultantInterestEvent(consultantId: $consultantId) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type AddConsultantEventLogInterestMutationFn = Apollo.MutationFunction<
  AddConsultantEventLogInterestMutation,
  AddConsultantEventLogInterestMutationVariables
>;
export type AddConsultantEventLogInterestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantEventLogInterestMutation,
    AddConsultantEventLogInterestMutationVariables
  >,
  "mutation"
>;

export const AddConsultantEventLogInterestComponent = (
  props: AddConsultantEventLogInterestComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantEventLogInterestMutation,
    AddConsultantEventLogInterestMutationVariables
  >
    mutation={AddConsultantEventLogInterestDocument}
    {...props}
  />
);

/**
 * __useAddConsultantEventLogInterestMutation__
 *
 * To run a mutation, you first call `useAddConsultantEventLogInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantEventLogInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantEventLogInterestMutation, { data, loading, error }] = useAddConsultantEventLogInterestMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useAddConsultantEventLogInterestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantEventLogInterestMutation,
    AddConsultantEventLogInterestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantEventLogInterestMutation,
    AddConsultantEventLogInterestMutationVariables
  >(AddConsultantEventLogInterestDocument, options);
}
export type AddConsultantEventLogInterestMutationHookResult = ReturnType<
  typeof useAddConsultantEventLogInterestMutation
>;
export namespace AddConsultantEventLogInterest {
  export type Return = AddConsultantEventLogInterestMutation;
  export type Variables = AddConsultantEventLogInterestMutationVariables;
  export const OperationName = "addConsultantEventLogInterest";

  export const Document = AddConsultantEventLogInterestDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateConsultantEventLogPinDocument = gql`
  mutation updateConsultantEventLogPin($eventId: ObjectId!) {
    pinConsultantEvent(eventId: $eventId) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type UpdateConsultantEventLogPinMutationFn = Apollo.MutationFunction<
  UpdateConsultantEventLogPinMutation,
  UpdateConsultantEventLogPinMutationVariables
>;
export type UpdateConsultantEventLogPinComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantEventLogPinMutation,
    UpdateConsultantEventLogPinMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantEventLogPinComponent = (
  props: UpdateConsultantEventLogPinComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantEventLogPinMutation,
    UpdateConsultantEventLogPinMutationVariables
  >
    mutation={UpdateConsultantEventLogPinDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantEventLogPinMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantEventLogPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantEventLogPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantEventLogPinMutation, { data, loading, error }] = useUpdateConsultantEventLogPinMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUpdateConsultantEventLogPinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantEventLogPinMutation,
    UpdateConsultantEventLogPinMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantEventLogPinMutation,
    UpdateConsultantEventLogPinMutationVariables
  >(UpdateConsultantEventLogPinDocument, options);
}
export type UpdateConsultantEventLogPinMutationHookResult = ReturnType<
  typeof useUpdateConsultantEventLogPinMutation
>;
export namespace UpdateConsultantEventLogPin {
  export type Return = UpdateConsultantEventLogPinMutation;
  export type Variables = UpdateConsultantEventLogPinMutationVariables;
  export const OperationName = "updateConsultantEventLogPin";

  export const Document = UpdateConsultantEventLogPinDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteConsultantEventLogEntryDocument = gql`
  mutation deleteConsultantEventLogEntry($eventId: ObjectId!) {
    deleteConsultantEvent(eventId: $eventId) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type DeleteConsultantEventLogEntryMutationFn = Apollo.MutationFunction<
  DeleteConsultantEventLogEntryMutation,
  DeleteConsultantEventLogEntryMutationVariables
>;
export type DeleteConsultantEventLogEntryComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteConsultantEventLogEntryMutation,
    DeleteConsultantEventLogEntryMutationVariables
  >,
  "mutation"
>;

export const DeleteConsultantEventLogEntryComponent = (
  props: DeleteConsultantEventLogEntryComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteConsultantEventLogEntryMutation,
    DeleteConsultantEventLogEntryMutationVariables
  >
    mutation={DeleteConsultantEventLogEntryDocument}
    {...props}
  />
);

/**
 * __useDeleteConsultantEventLogEntryMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantEventLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantEventLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantEventLogEntryMutation, { data, loading, error }] = useDeleteConsultantEventLogEntryMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteConsultantEventLogEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsultantEventLogEntryMutation,
    DeleteConsultantEventLogEntryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsultantEventLogEntryMutation,
    DeleteConsultantEventLogEntryMutationVariables
  >(DeleteConsultantEventLogEntryDocument, options);
}
export type DeleteConsultantEventLogEntryMutationHookResult = ReturnType<
  typeof useDeleteConsultantEventLogEntryMutation
>;
export namespace DeleteConsultantEventLogEntry {
  export type Return = DeleteConsultantEventLogEntryMutation;
  export type Variables = DeleteConsultantEventLogEntryMutationVariables;
  export const OperationName = "deleteConsultantEventLogEntry";

  export const Document = DeleteConsultantEventLogEntryDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateConsultantEventLogEntryDocument = gql`
  mutation updateConsultantEventLogEntry($eventId: ObjectId!, $desc: String!) {
    updateConsultantEvent(eventId: $eventId, desc: $desc) {
      ...EventData
    }
  }
  ${EventDataFragmentDoc}
`;
export type UpdateConsultantEventLogEntryMutationFn = Apollo.MutationFunction<
  UpdateConsultantEventLogEntryMutation,
  UpdateConsultantEventLogEntryMutationVariables
>;
export type UpdateConsultantEventLogEntryComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantEventLogEntryMutation,
    UpdateConsultantEventLogEntryMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantEventLogEntryComponent = (
  props: UpdateConsultantEventLogEntryComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantEventLogEntryMutation,
    UpdateConsultantEventLogEntryMutationVariables
  >
    mutation={UpdateConsultantEventLogEntryDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantEventLogEntryMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantEventLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantEventLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantEventLogEntryMutation, { data, loading, error }] = useUpdateConsultantEventLogEntryMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useUpdateConsultantEventLogEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantEventLogEntryMutation,
    UpdateConsultantEventLogEntryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantEventLogEntryMutation,
    UpdateConsultantEventLogEntryMutationVariables
  >(UpdateConsultantEventLogEntryDocument, options);
}
export type UpdateConsultantEventLogEntryMutationHookResult = ReturnType<
  typeof useUpdateConsultantEventLogEntryMutation
>;
export namespace UpdateConsultantEventLogEntry {
  export type Return = UpdateConsultantEventLogEntryMutation;
  export type Variables = UpdateConsultantEventLogEntryMutationVariables;
  export const OperationName = "updateConsultantEventLogEntry";

  export const Document = UpdateConsultantEventLogEntryDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantDocumentListDocument = gql`
  query getConsultantDocumentList($id: ObjectId!) {
    docs: consultantById(id: $id) {
      _id
      Documents {
        ...DocumentList_Item
      }
    }
  }
  ${DocumentList_ItemFragmentDoc}
`;
export type GetConsultantDocumentListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantDocumentListQuery,
    GetConsultantDocumentListQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantDocumentListQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantDocumentListComponent = (
  props: GetConsultantDocumentListComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantDocumentListQuery,
    GetConsultantDocumentListQueryVariables
  >
    query={GetConsultantDocumentListDocument}
    {...props}
  />
);

/**
 * __useGetConsultantDocumentListQuery__
 *
 * To run a query within a React component, call `useGetConsultantDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantDocumentListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantDocumentListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantDocumentListQuery,
    GetConsultantDocumentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantDocumentListQuery,
    GetConsultantDocumentListQueryVariables
  >(GetConsultantDocumentListDocument, options);
}
export function useGetConsultantDocumentListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantDocumentListQuery,
    GetConsultantDocumentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantDocumentListQuery,
    GetConsultantDocumentListQueryVariables
  >(GetConsultantDocumentListDocument, options);
}
export type GetConsultantDocumentListQueryHookResult = ReturnType<
  typeof useGetConsultantDocumentListQuery
>;
export type GetConsultantDocumentListLazyQueryHookResult = ReturnType<
  typeof useGetConsultantDocumentListLazyQuery
>;
export namespace GetConsultantDocumentList {
  export type Return = GetConsultantDocumentListQuery;
  export type Variables = GetConsultantDocumentListQueryVariables;
  export const OperationName = "getConsultantDocumentList";

  export const Document = GetConsultantDocumentListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantBookingDocumentListDocument = gql`
  query getConsultantBookingDocumentList($id: ObjectId!) {
    consultantById(id: $id) {
      _id
      BookingDocuments {
        DocumentType
        ThumbURL
        PdfURL
        FileRef {
          Name
          NodeID
          NodeType
          MimeType
          Size
        }
      }
    }
  }
`;
export type GetConsultantBookingDocumentListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantBookingDocumentListQuery,
    GetConsultantBookingDocumentListQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantBookingDocumentListQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantBookingDocumentListComponent = (
  props: GetConsultantBookingDocumentListComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantBookingDocumentListQuery,
    GetConsultantBookingDocumentListQueryVariables
  >
    query={GetConsultantBookingDocumentListDocument}
    {...props}
  />
);

/**
 * __useGetConsultantBookingDocumentListQuery__
 *
 * To run a query within a React component, call `useGetConsultantBookingDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantBookingDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantBookingDocumentListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantBookingDocumentListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantBookingDocumentListQuery,
    GetConsultantBookingDocumentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantBookingDocumentListQuery,
    GetConsultantBookingDocumentListQueryVariables
  >(GetConsultantBookingDocumentListDocument, options);
}
export function useGetConsultantBookingDocumentListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantBookingDocumentListQuery,
    GetConsultantBookingDocumentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantBookingDocumentListQuery,
    GetConsultantBookingDocumentListQueryVariables
  >(GetConsultantBookingDocumentListDocument, options);
}
export type GetConsultantBookingDocumentListQueryHookResult = ReturnType<
  typeof useGetConsultantBookingDocumentListQuery
>;
export type GetConsultantBookingDocumentListLazyQueryHookResult = ReturnType<
  typeof useGetConsultantBookingDocumentListLazyQuery
>;
export namespace GetConsultantBookingDocumentList {
  export type Return = GetConsultantBookingDocumentListQuery;
  export type Variables = GetConsultantBookingDocumentListQueryVariables;
  export const OperationName = "getConsultantBookingDocumentList";

  export const Document = GetConsultantBookingDocumentListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadBlobDocument = gql`
  mutation uploadBlob($file: Upload!) {
    uploadBlob(file: $file)
  }
`;
export type UploadBlobMutationFn = Apollo.MutationFunction<
  UploadBlobMutation,
  UploadBlobMutationVariables
>;
export type UploadBlobComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadBlobMutation,
    UploadBlobMutationVariables
  >,
  "mutation"
>;

export const UploadBlobComponent = (props: UploadBlobComponentProps) => (
  <ApolloReactComponents.Mutation<UploadBlobMutation, UploadBlobMutationVariables>
    mutation={UploadBlobDocument}
    {...props}
  />
);

/**
 * __useUploadBlobMutation__
 *
 * To run a mutation, you first call `useUploadBlobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBlobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBlobMutation, { data, loading, error }] = useUploadBlobMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBlobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadBlobMutation,
    UploadBlobMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadBlobMutation, UploadBlobMutationVariables>(
    UploadBlobDocument,
    options
  );
}
export type UploadBlobMutationHookResult = ReturnType<typeof useUploadBlobMutation>;
export namespace UploadBlob {
  export type Return = UploadBlobMutation;
  export type Variables = UploadBlobMutationVariables;
  export const OperationName = "uploadBlob";

  export const Document = UploadBlobDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UploadConsultantDocumentsDocument = gql`
  mutation uploadConsultantDocuments(
    $consultantId: ObjectId!
    $blobRefs: [String!]!
    $documentType: String!
  ) {
    uploadConsultantDocuments(
      consultantId: $consultantId
      blobRefs: $blobRefs
      documentType: $documentType
    ) {
      DocumentType
      PdfURL
      ThumbURL
      FileRef {
        MimeType
        Name
        NodeID
        NodeType
        Size
        __typename
      }
    }
  }
`;
export type UploadConsultantDocumentsMutationFn = Apollo.MutationFunction<
  UploadConsultantDocumentsMutation,
  UploadConsultantDocumentsMutationVariables
>;
export type UploadConsultantDocumentsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadConsultantDocumentsMutation,
    UploadConsultantDocumentsMutationVariables
  >,
  "mutation"
>;

export const UploadConsultantDocumentsComponent = (
  props: UploadConsultantDocumentsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadConsultantDocumentsMutation,
    UploadConsultantDocumentsMutationVariables
  >
    mutation={UploadConsultantDocumentsDocument}
    {...props}
  />
);

/**
 * __useUploadConsultantDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadConsultantDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadConsultantDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadConsultantDocumentsMutation, { data, loading, error }] = useUploadConsultantDocumentsMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      blobRefs: // value for 'blobRefs'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadConsultantDocumentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadConsultantDocumentsMutation,
    UploadConsultantDocumentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadConsultantDocumentsMutation,
    UploadConsultantDocumentsMutationVariables
  >(UploadConsultantDocumentsDocument, options);
}
export type UploadConsultantDocumentsMutationHookResult = ReturnType<
  typeof useUploadConsultantDocumentsMutation
>;
export namespace UploadConsultantDocuments {
  export type Return = UploadConsultantDocumentsMutation;
  export type Variables = UploadConsultantDocumentsMutationVariables;
  export const OperationName = "uploadConsultantDocuments";

  export const Document = UploadConsultantDocumentsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RemoveConsultantDocumentDocument = gql`
  mutation removeConsultantDocument($documentId: ObjectId!) {
    removeConsultantDocument(documentId: $documentId)
  }
`;
export type RemoveConsultantDocumentMutationFn = Apollo.MutationFunction<
  RemoveConsultantDocumentMutation,
  RemoveConsultantDocumentMutationVariables
>;
export type RemoveConsultantDocumentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveConsultantDocumentMutation,
    RemoveConsultantDocumentMutationVariables
  >,
  "mutation"
>;

export const RemoveConsultantDocumentComponent = (
  props: RemoveConsultantDocumentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveConsultantDocumentMutation,
    RemoveConsultantDocumentMutationVariables
  >
    mutation={RemoveConsultantDocumentDocument}
    {...props}
  />
);

/**
 * __useRemoveConsultantDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveConsultantDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConsultantDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConsultantDocumentMutation, { data, loading, error }] = useRemoveConsultantDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveConsultantDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveConsultantDocumentMutation,
    RemoveConsultantDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveConsultantDocumentMutation,
    RemoveConsultantDocumentMutationVariables
  >(RemoveConsultantDocumentDocument, options);
}
export type RemoveConsultantDocumentMutationHookResult = ReturnType<
  typeof useRemoveConsultantDocumentMutation
>;
export namespace RemoveConsultantDocument {
  export type Return = RemoveConsultantDocumentMutation;
  export type Variables = RemoveConsultantDocumentMutationVariables;
  export const OperationName = "removeConsultantDocument";

  export const Document = RemoveConsultantDocumentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantDocumentTypesDocument = gql`
  query getConsultantDocumentTypes($id: ObjectId!) {
    consultantById(id: $id) {
      _id
      DocumentTypes
    }
  }
`;
export type GetConsultantDocumentTypesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantDocumentTypesQuery,
    GetConsultantDocumentTypesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantDocumentTypesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantDocumentTypesComponent = (
  props: GetConsultantDocumentTypesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantDocumentTypesQuery,
    GetConsultantDocumentTypesQueryVariables
  >
    query={GetConsultantDocumentTypesDocument}
    {...props}
  />
);

/**
 * __useGetConsultantDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetConsultantDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantDocumentTypesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantDocumentTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantDocumentTypesQuery,
    GetConsultantDocumentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantDocumentTypesQuery,
    GetConsultantDocumentTypesQueryVariables
  >(GetConsultantDocumentTypesDocument, options);
}
export function useGetConsultantDocumentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantDocumentTypesQuery,
    GetConsultantDocumentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantDocumentTypesQuery,
    GetConsultantDocumentTypesQueryVariables
  >(GetConsultantDocumentTypesDocument, options);
}
export type GetConsultantDocumentTypesQueryHookResult = ReturnType<
  typeof useGetConsultantDocumentTypesQuery
>;
export type GetConsultantDocumentTypesLazyQueryHookResult = ReturnType<
  typeof useGetConsultantDocumentTypesLazyQuery
>;
export namespace GetConsultantDocumentTypes {
  export type Return = GetConsultantDocumentTypesQuery;
  export type Variables = GetConsultantDocumentTypesQueryVariables;
  export const OperationName = "getConsultantDocumentTypes";

  export const Document = GetConsultantDocumentTypesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetFreshdeskTicketsCountDocument = gql`
  query getFreshdeskTicketsCount($consultantId: ObjectId!) {
    freshdeskOpenTicketsCountByConsultant(consultantId: $consultantId)
  }
`;
export type GetFreshdeskTicketsCountComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetFreshdeskTicketsCountQuery,
    GetFreshdeskTicketsCountQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetFreshdeskTicketsCountQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetFreshdeskTicketsCountComponent = (
  props: GetFreshdeskTicketsCountComponentProps
) => (
  <ApolloReactComponents.Query<
    GetFreshdeskTicketsCountQuery,
    GetFreshdeskTicketsCountQueryVariables
  >
    query={GetFreshdeskTicketsCountDocument}
    {...props}
  />
);

/**
 * __useGetFreshdeskTicketsCountQuery__
 *
 * To run a query within a React component, call `useGetFreshdeskTicketsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreshdeskTicketsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreshdeskTicketsCountQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetFreshdeskTicketsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFreshdeskTicketsCountQuery,
    GetFreshdeskTicketsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFreshdeskTicketsCountQuery,
    GetFreshdeskTicketsCountQueryVariables
  >(GetFreshdeskTicketsCountDocument, options);
}
export function useGetFreshdeskTicketsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFreshdeskTicketsCountQuery,
    GetFreshdeskTicketsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFreshdeskTicketsCountQuery,
    GetFreshdeskTicketsCountQueryVariables
  >(GetFreshdeskTicketsCountDocument, options);
}
export type GetFreshdeskTicketsCountQueryHookResult = ReturnType<
  typeof useGetFreshdeskTicketsCountQuery
>;
export type GetFreshdeskTicketsCountLazyQueryHookResult = ReturnType<
  typeof useGetFreshdeskTicketsCountLazyQuery
>;
export namespace GetFreshdeskTicketsCount {
  export type Return = GetFreshdeskTicketsCountQuery;
  export type Variables = GetFreshdeskTicketsCountQueryVariables;
  export const OperationName = "getFreshdeskTicketsCount";

  export const Document = GetFreshdeskTicketsCountDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetFreshdeskTicketsDocument = gql`
  query getFreshdeskTickets($consultantId: ObjectId!) {
    freshdeskTicketsByConsultant(consultantId: $consultantId) {
      id
      subject
      status
      url
      createdAt
      updatedAt
    }
  }
`;
export type GetFreshdeskTicketsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetFreshdeskTicketsQuery,
    GetFreshdeskTicketsQueryVariables
  >,
  "query"
> &
  ({ variables: GetFreshdeskTicketsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetFreshdeskTicketsComponent = (
  props: GetFreshdeskTicketsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetFreshdeskTicketsQuery,
    GetFreshdeskTicketsQueryVariables
  >
    query={GetFreshdeskTicketsDocument}
    {...props}
  />
);

/**
 * __useGetFreshdeskTicketsQuery__
 *
 * To run a query within a React component, call `useGetFreshdeskTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreshdeskTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreshdeskTicketsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetFreshdeskTicketsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFreshdeskTicketsQuery,
    GetFreshdeskTicketsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFreshdeskTicketsQuery, GetFreshdeskTicketsQueryVariables>(
    GetFreshdeskTicketsDocument,
    options
  );
}
export function useGetFreshdeskTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFreshdeskTicketsQuery,
    GetFreshdeskTicketsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFreshdeskTicketsQuery, GetFreshdeskTicketsQueryVariables>(
    GetFreshdeskTicketsDocument,
    options
  );
}
export type GetFreshdeskTicketsQueryHookResult = ReturnType<
  typeof useGetFreshdeskTicketsQuery
>;
export type GetFreshdeskTicketsLazyQueryHookResult = ReturnType<
  typeof useGetFreshdeskTicketsLazyQuery
>;
export namespace GetFreshdeskTickets {
  export type Return = GetFreshdeskTicketsQuery;
  export type Variables = GetFreshdeskTicketsQueryVariables;
  export const OperationName = "getFreshdeskTickets";

  export const Document = GetFreshdeskTicketsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantGdprDocument = gql`
  query getConsultantGdpr($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantGdprData
    }
  }
  ${ConsultantGdprDataFragmentDoc}
`;
export type GetConsultantGdprComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantGdprQuery,
    GetConsultantGdprQueryVariables
  >,
  "query"
> &
  ({ variables: GetConsultantGdprQueryVariables; skip?: boolean } | { skip: boolean });

export const GetConsultantGdprComponent = (props: GetConsultantGdprComponentProps) => (
  <ApolloReactComponents.Query<GetConsultantGdprQuery, GetConsultantGdprQueryVariables>
    query={GetConsultantGdprDocument}
    {...props}
  />
);

/**
 * __useGetConsultantGdprQuery__
 *
 * To run a query within a React component, call `useGetConsultantGdprQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantGdprQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantGdprQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantGdprQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantGdprQuery,
    GetConsultantGdprQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConsultantGdprQuery, GetConsultantGdprQueryVariables>(
    GetConsultantGdprDocument,
    options
  );
}
export function useGetConsultantGdprLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantGdprQuery,
    GetConsultantGdprQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConsultantGdprQuery, GetConsultantGdprQueryVariables>(
    GetConsultantGdprDocument,
    options
  );
}
export type GetConsultantGdprQueryHookResult = ReturnType<
  typeof useGetConsultantGdprQuery
>;
export type GetConsultantGdprLazyQueryHookResult = ReturnType<
  typeof useGetConsultantGdprLazyQuery
>;
export namespace GetConsultantGdpr {
  export type Return = GetConsultantGdprQuery;
  export type Variables = GetConsultantGdprQueryVariables;
  export const OperationName = "getConsultantGdpr";

  export const Document = GetConsultantGdprDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UpdateConsultantGdprDocument = gql`
  mutation updateConsultantGdpr($id: ObjectId!, $input: GDPRInput!) {
    updateConsultantGDPR(id: $id, input: $input) {
      ...ConsultantGdprData
    }
  }
  ${ConsultantGdprDataFragmentDoc}
`;
export type UpdateConsultantGdprMutationFn = Apollo.MutationFunction<
  UpdateConsultantGdprMutation,
  UpdateConsultantGdprMutationVariables
>;
export type UpdateConsultantGdprComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantGdprMutation,
    UpdateConsultantGdprMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantGdprComponent = (
  props: UpdateConsultantGdprComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantGdprMutation,
    UpdateConsultantGdprMutationVariables
  >
    mutation={UpdateConsultantGdprDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantGdprMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantGdprMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantGdprMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantGdprMutation, { data, loading, error }] = useUpdateConsultantGdprMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConsultantGdprMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantGdprMutation,
    UpdateConsultantGdprMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantGdprMutation,
    UpdateConsultantGdprMutationVariables
  >(UpdateConsultantGdprDocument, options);
}
export type UpdateConsultantGdprMutationHookResult = ReturnType<
  typeof useUpdateConsultantGdprMutation
>;
export namespace UpdateConsultantGdpr {
  export type Return = UpdateConsultantGdprMutation;
  export type Variables = UpdateConsultantGdprMutationVariables;
  export const OperationName = "updateConsultantGdpr";

  export const Document = UpdateConsultantGdprDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantGeneralInterestDocument = gql`
  query getConsultantGeneralInterest($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantGeneralInterestData
    }
  }
  ${ConsultantGeneralInterestDataFragmentDoc}
`;
export type GetConsultantGeneralInterestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantGeneralInterestQuery,
    GetConsultantGeneralInterestQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantGeneralInterestQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantGeneralInterestComponent = (
  props: GetConsultantGeneralInterestComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantGeneralInterestQuery,
    GetConsultantGeneralInterestQueryVariables
  >
    query={GetConsultantGeneralInterestDocument}
    {...props}
  />
);

/**
 * __useGetConsultantGeneralInterestQuery__
 *
 * To run a query within a React component, call `useGetConsultantGeneralInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantGeneralInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantGeneralInterestQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantGeneralInterestQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantGeneralInterestQuery,
    GetConsultantGeneralInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantGeneralInterestQuery,
    GetConsultantGeneralInterestQueryVariables
  >(GetConsultantGeneralInterestDocument, options);
}
export function useGetConsultantGeneralInterestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantGeneralInterestQuery,
    GetConsultantGeneralInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantGeneralInterestQuery,
    GetConsultantGeneralInterestQueryVariables
  >(GetConsultantGeneralInterestDocument, options);
}
export type GetConsultantGeneralInterestQueryHookResult = ReturnType<
  typeof useGetConsultantGeneralInterestQuery
>;
export type GetConsultantGeneralInterestLazyQueryHookResult = ReturnType<
  typeof useGetConsultantGeneralInterestLazyQuery
>;
export namespace GetConsultantGeneralInterest {
  export type Return = GetConsultantGeneralInterestQuery;
  export type Variables = GetConsultantGeneralInterestQueryVariables;
  export const OperationName = "getConsultantGeneralInterest";

  export const Document = GetConsultantGeneralInterestDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantGeneralInterest_UpdateDocument = gql`
  mutation ConsultantGeneralInterest_Update(
    $consultantId: ObjectId!
    $interest: ConsultantGeneralInterestInput!
  ) {
    updateConsultantGeneralInterest(consultantId: $consultantId, input: $interest) {
      ...ConsultantGeneralInterestData
    }
  }
  ${ConsultantGeneralInterestDataFragmentDoc}
`;
export type ConsultantGeneralInterest_UpdateMutationFn = Apollo.MutationFunction<
  ConsultantGeneralInterest_UpdateMutation,
  ConsultantGeneralInterest_UpdateMutationVariables
>;
export type ConsultantGeneralInterest_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantGeneralInterest_UpdateMutation,
    ConsultantGeneralInterest_UpdateMutationVariables
  >,
  "mutation"
>;

export const ConsultantGeneralInterest_UpdateComponent = (
  props: ConsultantGeneralInterest_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantGeneralInterest_UpdateMutation,
    ConsultantGeneralInterest_UpdateMutationVariables
  >
    mutation={ConsultantGeneralInterest_UpdateDocument}
    {...props}
  />
);

/**
 * __useConsultantGeneralInterest_UpdateMutation__
 *
 * To run a mutation, you first call `useConsultantGeneralInterest_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantGeneralInterest_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantGeneralInterestUpdateMutation, { data, loading, error }] = useConsultantGeneralInterest_UpdateMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      interest: // value for 'interest'
 *   },
 * });
 */
export function useConsultantGeneralInterest_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantGeneralInterest_UpdateMutation,
    ConsultantGeneralInterest_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantGeneralInterest_UpdateMutation,
    ConsultantGeneralInterest_UpdateMutationVariables
  >(ConsultantGeneralInterest_UpdateDocument, options);
}
export type ConsultantGeneralInterest_UpdateMutationHookResult = ReturnType<
  typeof useConsultantGeneralInterest_UpdateMutation
>;
export namespace ConsultantGeneralInterest_Update {
  export type Return = ConsultantGeneralInterest_UpdateMutation;
  export type Variables = ConsultantGeneralInterest_UpdateMutationVariables;
  export const OperationName = "ConsultantGeneralInterest_Update";

  export const Document = ConsultantGeneralInterest_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantKarensByIdDocument = gql`
  query consultantKarensById($consultantId: ObjectId!) {
    consultantKarensById(consultantId: $consultantId) {
      ...KarensData
    }
  }
  ${KarensDataFragmentDoc}
`;
export type ConsultantKarensByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantKarensByIdQuery,
    ConsultantKarensByIdQueryVariables
  >,
  "query"
> &
  ({ variables: ConsultantKarensByIdQueryVariables; skip?: boolean } | { skip: boolean });

export const ConsultantKarensByIdComponent = (
  props: ConsultantKarensByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantKarensByIdQuery,
    ConsultantKarensByIdQueryVariables
  >
    query={ConsultantKarensByIdDocument}
    {...props}
  />
);

/**
 * __useConsultantKarensByIdQuery__
 *
 * To run a query within a React component, call `useConsultantKarensByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantKarensByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantKarensByIdQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantKarensByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantKarensByIdQuery,
    ConsultantKarensByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConsultantKarensByIdQuery, ConsultantKarensByIdQueryVariables>(
    ConsultantKarensByIdDocument,
    options
  );
}
export function useConsultantKarensByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantKarensByIdQuery,
    ConsultantKarensByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantKarensByIdQuery,
    ConsultantKarensByIdQueryVariables
  >(ConsultantKarensByIdDocument, options);
}
export type ConsultantKarensByIdQueryHookResult = ReturnType<
  typeof useConsultantKarensByIdQuery
>;
export type ConsultantKarensByIdLazyQueryHookResult = ReturnType<
  typeof useConsultantKarensByIdLazyQuery
>;
export namespace ConsultantKarensById {
  export type Return = ConsultantKarensByIdQuery;
  export type Variables = ConsultantKarensByIdQueryVariables;
  export const OperationName = "consultantKarensById";

  export const Document = ConsultantKarensByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SubmitConsultantKarensDocument = gql`
  mutation submitConsultantKarens(
    $consultantId: ObjectId!
    $data: ConsultantKarensInput!
  ) {
    submitConsultantKarens(consultantId: $consultantId, data: $data) {
      ...KarensData
    }
  }
  ${KarensDataFragmentDoc}
`;
export type SubmitConsultantKarensMutationFn = Apollo.MutationFunction<
  SubmitConsultantKarensMutation,
  SubmitConsultantKarensMutationVariables
>;
export type SubmitConsultantKarensComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitConsultantKarensMutation,
    SubmitConsultantKarensMutationVariables
  >,
  "mutation"
>;

export const SubmitConsultantKarensComponent = (
  props: SubmitConsultantKarensComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitConsultantKarensMutation,
    SubmitConsultantKarensMutationVariables
  >
    mutation={SubmitConsultantKarensDocument}
    {...props}
  />
);

/**
 * __useSubmitConsultantKarensMutation__
 *
 * To run a mutation, you first call `useSubmitConsultantKarensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitConsultantKarensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitConsultantKarensMutation, { data, loading, error }] = useSubmitConsultantKarensMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitConsultantKarensMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitConsultantKarensMutation,
    SubmitConsultantKarensMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitConsultantKarensMutation,
    SubmitConsultantKarensMutationVariables
  >(SubmitConsultantKarensDocument, options);
}
export type SubmitConsultantKarensMutationHookResult = ReturnType<
  typeof useSubmitConsultantKarensMutation
>;
export namespace SubmitConsultantKarens {
  export type Return = SubmitConsultantKarensMutation;
  export type Variables = SubmitConsultantKarensMutationVariables;
  export const OperationName = "submitConsultantKarens";

  export const Document = SubmitConsultantKarensDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetPersonalInfoCardDataDocument = gql`
  query getPersonalInfoCardData($id: ObjectId!) {
    consultantById(id: $id) {
      ...PersonalInfoCardData
    }
  }
  ${PersonalInfoCardDataFragmentDoc}
`;
export type GetPersonalInfoCardDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetPersonalInfoCardDataQuery,
    GetPersonalInfoCardDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetPersonalInfoCardDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetPersonalInfoCardDataComponent = (
  props: GetPersonalInfoCardDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetPersonalInfoCardDataQuery,
    GetPersonalInfoCardDataQueryVariables
  >
    query={GetPersonalInfoCardDataDocument}
    {...props}
  />
);

/**
 * __useGetPersonalInfoCardDataQuery__
 *
 * To run a query within a React component, call `useGetPersonalInfoCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalInfoCardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalInfoCardDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonalInfoCardDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalInfoCardDataQuery,
    GetPersonalInfoCardDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalInfoCardDataQuery,
    GetPersonalInfoCardDataQueryVariables
  >(GetPersonalInfoCardDataDocument, options);
}
export function useGetPersonalInfoCardDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalInfoCardDataQuery,
    GetPersonalInfoCardDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalInfoCardDataQuery,
    GetPersonalInfoCardDataQueryVariables
  >(GetPersonalInfoCardDataDocument, options);
}
export type GetPersonalInfoCardDataQueryHookResult = ReturnType<
  typeof useGetPersonalInfoCardDataQuery
>;
export type GetPersonalInfoCardDataLazyQueryHookResult = ReturnType<
  typeof useGetPersonalInfoCardDataLazyQuery
>;
export namespace GetPersonalInfoCardData {
  export type Return = GetPersonalInfoCardDataQuery;
  export type Variables = GetPersonalInfoCardDataQueryVariables;
  export const OperationName = "getPersonalInfoCardData";

  export const Document = GetPersonalInfoCardDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UpdateConsultantLeadStatusDocument = gql`
  mutation updateConsultantLeadStatus(
    $consultantId: ObjectId!
    $data: ConsultantLeadStatusInput!
  ) {
    updateConsultantLeadStatus(consultantId: $consultantId, input: $data) {
      ...PersonalInfoCardData
    }
  }
  ${PersonalInfoCardDataFragmentDoc}
`;
export type UpdateConsultantLeadStatusMutationFn = Apollo.MutationFunction<
  UpdateConsultantLeadStatusMutation,
  UpdateConsultantLeadStatusMutationVariables
>;
export type UpdateConsultantLeadStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantLeadStatusMutation,
    UpdateConsultantLeadStatusMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantLeadStatusComponent = (
  props: UpdateConsultantLeadStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantLeadStatusMutation,
    UpdateConsultantLeadStatusMutationVariables
  >
    mutation={UpdateConsultantLeadStatusDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantLeadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantLeadStatusMutation, { data, loading, error }] = useUpdateConsultantLeadStatusMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateConsultantLeadStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantLeadStatusMutation,
    UpdateConsultantLeadStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantLeadStatusMutation,
    UpdateConsultantLeadStatusMutationVariables
  >(UpdateConsultantLeadStatusDocument, options);
}
export type UpdateConsultantLeadStatusMutationHookResult = ReturnType<
  typeof useUpdateConsultantLeadStatusMutation
>;
export namespace UpdateConsultantLeadStatus {
  export type Return = UpdateConsultantLeadStatusMutation;
  export type Variables = UpdateConsultantLeadStatusMutationVariables;
  export const OperationName = "updateConsultantLeadStatus";

  export const Document = UpdateConsultantLeadStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SetConsultantResponsiblePersonDocument = gql`
  mutation setConsultantResponsiblePerson(
    $consultantId: ObjectId!
    $status: ConsultantLeadStatus
  ) {
    setConsultantResponsiblePerson(consultantId: $consultantId, setLeadStatus: $status) {
      _id
      ResponsiblePerson {
        PersonId
        Name
      }
    }
  }
`;
export type SetConsultantResponsiblePersonMutationFn = Apollo.MutationFunction<
  SetConsultantResponsiblePersonMutation,
  SetConsultantResponsiblePersonMutationVariables
>;
export type SetConsultantResponsiblePersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetConsultantResponsiblePersonMutation,
    SetConsultantResponsiblePersonMutationVariables
  >,
  "mutation"
>;

export const SetConsultantResponsiblePersonComponent = (
  props: SetConsultantResponsiblePersonComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetConsultantResponsiblePersonMutation,
    SetConsultantResponsiblePersonMutationVariables
  >
    mutation={SetConsultantResponsiblePersonDocument}
    {...props}
  />
);

/**
 * __useSetConsultantResponsiblePersonMutation__
 *
 * To run a mutation, you first call `useSetConsultantResponsiblePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConsultantResponsiblePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConsultantResponsiblePersonMutation, { data, loading, error }] = useSetConsultantResponsiblePersonMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetConsultantResponsiblePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetConsultantResponsiblePersonMutation,
    SetConsultantResponsiblePersonMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetConsultantResponsiblePersonMutation,
    SetConsultantResponsiblePersonMutationVariables
  >(SetConsultantResponsiblePersonDocument, options);
}
export type SetConsultantResponsiblePersonMutationHookResult = ReturnType<
  typeof useSetConsultantResponsiblePersonMutation
>;
export namespace SetConsultantResponsiblePerson {
  export type Return = SetConsultantResponsiblePersonMutation;
  export type Variables = SetConsultantResponsiblePersonMutationVariables;
  export const OperationName = "setConsultantResponsiblePerson";

  export const Document = SetConsultantResponsiblePersonDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetPipelineStatusConsultantDocument = gql`
  query getPipelineStatusConsultant($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      _id
      pipelineStatus
      pipelineStatusComment
      nextContactDate {
        date
        reason
      }
      leadStatus {
        status
      }
    }
  }
`;
export type GetPipelineStatusConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetPipelineStatusConsultantQuery,
    GetPipelineStatusConsultantQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetPipelineStatusConsultantQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetPipelineStatusConsultantComponent = (
  props: GetPipelineStatusConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    GetPipelineStatusConsultantQuery,
    GetPipelineStatusConsultantQueryVariables
  >
    query={GetPipelineStatusConsultantDocument}
    {...props}
  />
);

/**
 * __useGetPipelineStatusConsultantQuery__
 *
 * To run a query within a React component, call `useGetPipelineStatusConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineStatusConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineStatusConsultantQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetPipelineStatusConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPipelineStatusConsultantQuery,
    GetPipelineStatusConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPipelineStatusConsultantQuery,
    GetPipelineStatusConsultantQueryVariables
  >(GetPipelineStatusConsultantDocument, options);
}
export function useGetPipelineStatusConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPipelineStatusConsultantQuery,
    GetPipelineStatusConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPipelineStatusConsultantQuery,
    GetPipelineStatusConsultantQueryVariables
  >(GetPipelineStatusConsultantDocument, options);
}
export type GetPipelineStatusConsultantQueryHookResult = ReturnType<
  typeof useGetPipelineStatusConsultantQuery
>;
export type GetPipelineStatusConsultantLazyQueryHookResult = ReturnType<
  typeof useGetPipelineStatusConsultantLazyQuery
>;
export namespace GetPipelineStatusConsultant {
  export type Return = GetPipelineStatusConsultantQuery;
  export type Variables = GetPipelineStatusConsultantQueryVariables;
  export const OperationName = "getPipelineStatusConsultant";

  export const Document = GetPipelineStatusConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetPipelineStatusDocument = gql`
  mutation setPipelineStatus(
    $consultantId: ObjectId!
    $status: ConsultantPipelineStatus!
    $comment: String
    $nextContactDate: Date
    $nextContactDateReason: String
    $leadStatus: ConsultantLeadStatus
  ) {
    setConsultantPipelineStatus(
      consultantId: $consultantId
      pipelineStatus: $status
      comment: $comment
      nextContactDate: $nextContactDate
      nextContactDateReason: $nextContactDateReason
      leadStatus: $leadStatus
    ) {
      _id
      pipelineStatus
      pipelineStatusComment
    }
  }
`;
export type SetPipelineStatusMutationFn = Apollo.MutationFunction<
  SetPipelineStatusMutation,
  SetPipelineStatusMutationVariables
>;
export type SetPipelineStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetPipelineStatusMutation,
    SetPipelineStatusMutationVariables
  >,
  "mutation"
>;

export const SetPipelineStatusComponent = (props: SetPipelineStatusComponentProps) => (
  <ApolloReactComponents.Mutation<
    SetPipelineStatusMutation,
    SetPipelineStatusMutationVariables
  >
    mutation={SetPipelineStatusDocument}
    {...props}
  />
);

/**
 * __useSetPipelineStatusMutation__
 *
 * To run a mutation, you first call `useSetPipelineStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPipelineStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPipelineStatusMutation, { data, loading, error }] = useSetPipelineStatusMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *      nextContactDate: // value for 'nextContactDate'
 *      nextContactDateReason: // value for 'nextContactDateReason'
 *      leadStatus: // value for 'leadStatus'
 *   },
 * });
 */
export function useSetPipelineStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetPipelineStatusMutation,
    SetPipelineStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetPipelineStatusMutation,
    SetPipelineStatusMutationVariables
  >(SetPipelineStatusDocument, options);
}
export type SetPipelineStatusMutationHookResult = ReturnType<
  typeof useSetPipelineStatusMutation
>;
export namespace SetPipelineStatus {
  export type Return = SetPipelineStatusMutation;
  export type Variables = SetPipelineStatusMutationVariables;
  export const OperationName = "setPipelineStatus";

  export const Document = SetPipelineStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantHealthDeclarationsDocument = gql`
  query getConsultantHealthDeclarations($consultantId: ObjectId!) {
    consultantHealthDeclarations(consultantId: $consultantId) {
      total
      items {
        ...HealthDeclarationListItem
      }
    }
  }
  ${HealthDeclarationListItemFragmentDoc}
`;
export type GetConsultantHealthDeclarationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantHealthDeclarationsQuery,
    GetConsultantHealthDeclarationsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantHealthDeclarationsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantHealthDeclarationsComponent = (
  props: GetConsultantHealthDeclarationsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantHealthDeclarationsQuery,
    GetConsultantHealthDeclarationsQueryVariables
  >
    query={GetConsultantHealthDeclarationsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantHealthDeclarationsQuery__
 *
 * To run a query within a React component, call `useGetConsultantHealthDeclarationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantHealthDeclarationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantHealthDeclarationsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantHealthDeclarationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantHealthDeclarationsQuery,
    GetConsultantHealthDeclarationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantHealthDeclarationsQuery,
    GetConsultantHealthDeclarationsQueryVariables
  >(GetConsultantHealthDeclarationsDocument, options);
}
export function useGetConsultantHealthDeclarationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantHealthDeclarationsQuery,
    GetConsultantHealthDeclarationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantHealthDeclarationsQuery,
    GetConsultantHealthDeclarationsQueryVariables
  >(GetConsultantHealthDeclarationsDocument, options);
}
export type GetConsultantHealthDeclarationsQueryHookResult = ReturnType<
  typeof useGetConsultantHealthDeclarationsQuery
>;
export type GetConsultantHealthDeclarationsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantHealthDeclarationsLazyQuery
>;
export namespace GetConsultantHealthDeclarations {
  export type Return = GetConsultantHealthDeclarationsQuery;
  export type Variables = GetConsultantHealthDeclarationsQueryVariables;
  export const OperationName = "getConsultantHealthDeclarations";

  export const Document = GetConsultantHealthDeclarationsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const RequestWithApprovedStatusDocument = gql`
  mutation requestWithApprovedStatus(
    $consultantId: ObjectId!
    $qualityCheckName: String!
    $qualityTemplate: String!
    $params: JSON!
  ) {
    transitionConsultantQualityItem(
      consultantId: $consultantId
      qualityCheck: $qualityCheckName
      qualityTemplate: $qualityTemplate
      transition: "ApprovedWithRequest"
      transitionParams: $params
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type RequestWithApprovedStatusMutationFn = Apollo.MutationFunction<
  RequestWithApprovedStatusMutation,
  RequestWithApprovedStatusMutationVariables
>;
export type RequestWithApprovedStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RequestWithApprovedStatusMutation,
    RequestWithApprovedStatusMutationVariables
  >,
  "mutation"
>;

export const RequestWithApprovedStatusComponent = (
  props: RequestWithApprovedStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RequestWithApprovedStatusMutation,
    RequestWithApprovedStatusMutationVariables
  >
    mutation={RequestWithApprovedStatusDocument}
    {...props}
  />
);

/**
 * __useRequestWithApprovedStatusMutation__
 *
 * To run a mutation, you first call `useRequestWithApprovedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestWithApprovedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestWithApprovedStatusMutation, { data, loading, error }] = useRequestWithApprovedStatusMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      qualityTemplate: // value for 'qualityTemplate'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRequestWithApprovedStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestWithApprovedStatusMutation,
    RequestWithApprovedStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestWithApprovedStatusMutation,
    RequestWithApprovedStatusMutationVariables
  >(RequestWithApprovedStatusDocument, options);
}
export type RequestWithApprovedStatusMutationHookResult = ReturnType<
  typeof useRequestWithApprovedStatusMutation
>;
export namespace RequestWithApprovedStatus {
  export type Return = RequestWithApprovedStatusMutation;
  export type Variables = RequestWithApprovedStatusMutationVariables;
  export const OperationName = "requestWithApprovedStatus";

  export const Document = RequestWithApprovedStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RequestCriminalRecordCheckDocument = gql`
  mutation requestCriminalRecordCheck(
    $consultantId: ObjectId!
    $qualityCheckName: String!
    $qualityTemplate: String!
    $params: JSON!
  ) {
    transitionConsultantQualityItem(
      consultantId: $consultantId
      qualityCheck: $qualityCheckName
      qualityTemplate: $qualityTemplate
      transition: "RequestCriminalRecordCheck"
      transitionParams: $params
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type RequestCriminalRecordCheckMutationFn = Apollo.MutationFunction<
  RequestCriminalRecordCheckMutation,
  RequestCriminalRecordCheckMutationVariables
>;
export type RequestCriminalRecordCheckComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RequestCriminalRecordCheckMutation,
    RequestCriminalRecordCheckMutationVariables
  >,
  "mutation"
>;

export const RequestCriminalRecordCheckComponent = (
  props: RequestCriminalRecordCheckComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RequestCriminalRecordCheckMutation,
    RequestCriminalRecordCheckMutationVariables
  >
    mutation={RequestCriminalRecordCheckDocument}
    {...props}
  />
);

/**
 * __useRequestCriminalRecordCheckMutation__
 *
 * To run a mutation, you first call `useRequestCriminalRecordCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCriminalRecordCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCriminalRecordCheckMutation, { data, loading, error }] = useRequestCriminalRecordCheckMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      qualityTemplate: // value for 'qualityTemplate'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRequestCriminalRecordCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestCriminalRecordCheckMutation,
    RequestCriminalRecordCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestCriminalRecordCheckMutation,
    RequestCriminalRecordCheckMutationVariables
  >(RequestCriminalRecordCheckDocument, options);
}
export type RequestCriminalRecordCheckMutationHookResult = ReturnType<
  typeof useRequestCriminalRecordCheckMutation
>;
export namespace RequestCriminalRecordCheck {
  export type Return = RequestCriminalRecordCheckMutation;
  export type Variables = RequestCriminalRecordCheckMutationVariables;
  export const OperationName = "requestCriminalRecordCheck";

  export const Document = RequestCriminalRecordCheckDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ApproveCriminalRecordCheckDocument = gql`
  mutation approveCriminalRecordCheck(
    $consultantId: ObjectId!
    $qualityCheckName: String!
    $qualityTemplate: String!
    $params: JSON!
  ) {
    transitionConsultantQualityItem(
      consultantId: $consultantId
      qualityCheck: $qualityCheckName
      qualityTemplate: $qualityTemplate
      transition: "ApproveCriminalRecordCheck"
      transitionParams: $params
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ApproveCriminalRecordCheckMutationFn = Apollo.MutationFunction<
  ApproveCriminalRecordCheckMutation,
  ApproveCriminalRecordCheckMutationVariables
>;
export type ApproveCriminalRecordCheckComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ApproveCriminalRecordCheckMutation,
    ApproveCriminalRecordCheckMutationVariables
  >,
  "mutation"
>;

export const ApproveCriminalRecordCheckComponent = (
  props: ApproveCriminalRecordCheckComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ApproveCriminalRecordCheckMutation,
    ApproveCriminalRecordCheckMutationVariables
  >
    mutation={ApproveCriminalRecordCheckDocument}
    {...props}
  />
);

/**
 * __useApproveCriminalRecordCheckMutation__
 *
 * To run a mutation, you first call `useApproveCriminalRecordCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCriminalRecordCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCriminalRecordCheckMutation, { data, loading, error }] = useApproveCriminalRecordCheckMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      qualityTemplate: // value for 'qualityTemplate'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useApproveCriminalRecordCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveCriminalRecordCheckMutation,
    ApproveCriminalRecordCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveCriminalRecordCheckMutation,
    ApproveCriminalRecordCheckMutationVariables
  >(ApproveCriminalRecordCheckDocument, options);
}
export type ApproveCriminalRecordCheckMutationHookResult = ReturnType<
  typeof useApproveCriminalRecordCheckMutation
>;
export namespace ApproveCriminalRecordCheck {
  export type Return = ApproveCriminalRecordCheckMutation;
  export type Variables = ApproveCriminalRecordCheckMutationVariables;
  export const OperationName = "approveCriminalRecordCheck";

  export const Document = ApproveCriminalRecordCheckDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RequestHealthDeclarationViaOneflowNewDocument = gql`
  mutation requestHealthDeclarationViaOneflowNew(
    $consultantId: ObjectId!
    $qualityTemplate: String!
    $transitionParams: JSON
  ) {
    transitionConsultantQualityItem(
      consultantId: $consultantId
      qualityCheck: "Hälsodeklaration"
      qualityTemplate: $qualityTemplate
      transition: "RequestViaOneflow"
      transitionParams: $transitionParams
    ) {
      _id
    }
  }
`;
export type RequestHealthDeclarationViaOneflowNewMutationFn = Apollo.MutationFunction<
  RequestHealthDeclarationViaOneflowNewMutation,
  RequestHealthDeclarationViaOneflowNewMutationVariables
>;
export type RequestHealthDeclarationViaOneflowNewComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RequestHealthDeclarationViaOneflowNewMutation,
    RequestHealthDeclarationViaOneflowNewMutationVariables
  >,
  "mutation"
>;

export const RequestHealthDeclarationViaOneflowNewComponent = (
  props: RequestHealthDeclarationViaOneflowNewComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RequestHealthDeclarationViaOneflowNewMutation,
    RequestHealthDeclarationViaOneflowNewMutationVariables
  >
    mutation={RequestHealthDeclarationViaOneflowNewDocument}
    {...props}
  />
);

/**
 * __useRequestHealthDeclarationViaOneflowNewMutation__
 *
 * To run a mutation, you first call `useRequestHealthDeclarationViaOneflowNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestHealthDeclarationViaOneflowNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestHealthDeclarationViaOneflowNewMutation, { data, loading, error }] = useRequestHealthDeclarationViaOneflowNewMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      qualityTemplate: // value for 'qualityTemplate'
 *      transitionParams: // value for 'transitionParams'
 *   },
 * });
 */
export function useRequestHealthDeclarationViaOneflowNewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestHealthDeclarationViaOneflowNewMutation,
    RequestHealthDeclarationViaOneflowNewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestHealthDeclarationViaOneflowNewMutation,
    RequestHealthDeclarationViaOneflowNewMutationVariables
  >(RequestHealthDeclarationViaOneflowNewDocument, options);
}
export type RequestHealthDeclarationViaOneflowNewMutationHookResult = ReturnType<
  typeof useRequestHealthDeclarationViaOneflowNewMutation
>;
export namespace RequestHealthDeclarationViaOneflowNew {
  export type Return = RequestHealthDeclarationViaOneflowNewMutation;
  export type Variables = RequestHealthDeclarationViaOneflowNewMutationVariables;
  export const OperationName = "requestHealthDeclarationViaOneflowNew";

  export const Document = RequestHealthDeclarationViaOneflowNewDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ManuallySetStatus_HDDocument = gql`
  mutation manuallySetStatus_HD(
    $consultantId: ObjectId!
    $qualityTemplate: String!
    $transitionName: String!
    $transitionParams: JSON
  ) {
    transitionConsultantQualityItem(
      consultantId: $consultantId
      qualityCheck: "Hälsodeklaration"
      qualityTemplate: $qualityTemplate
      transition: $transitionName
      transitionParams: $transitionParams
    ) {
      _id
    }
  }
`;
export type ManuallySetStatus_HDMutationFn = Apollo.MutationFunction<
  ManuallySetStatus_HDMutation,
  ManuallySetStatus_HDMutationVariables
>;
export type ManuallySetStatus_HDComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ManuallySetStatus_HDMutation,
    ManuallySetStatus_HDMutationVariables
  >,
  "mutation"
>;

export const ManuallySetStatus_HDComponent = (
  props: ManuallySetStatus_HDComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ManuallySetStatus_HDMutation,
    ManuallySetStatus_HDMutationVariables
  >
    mutation={ManuallySetStatus_HDDocument}
    {...props}
  />
);

/**
 * __useManuallySetStatus_HDMutation__
 *
 * To run a mutation, you first call `useManuallySetStatus_HDMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallySetStatus_HDMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallySetStatusHdMutation, { data, loading, error }] = useManuallySetStatus_HDMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      qualityTemplate: // value for 'qualityTemplate'
 *      transitionName: // value for 'transitionName'
 *      transitionParams: // value for 'transitionParams'
 *   },
 * });
 */
export function useManuallySetStatus_HDMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManuallySetStatus_HDMutation,
    ManuallySetStatus_HDMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ManuallySetStatus_HDMutation,
    ManuallySetStatus_HDMutationVariables
  >(ManuallySetStatus_HDDocument, options);
}
export type ManuallySetStatus_HDMutationHookResult = ReturnType<
  typeof useManuallySetStatus_HDMutation
>;
export namespace ManuallySetStatus_HD {
  export type Return = ManuallySetStatus_HDMutation;
  export type Variables = ManuallySetStatus_HDMutationVariables;
  export const OperationName = "manuallySetStatus_HD";

  export const Document = ManuallySetStatus_HDDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const OrderHlrCheckDocument = gql`
  mutation orderHlrCheck(
    $consultantId: ObjectId!
    $qualityCheckName: String!
    $qualityTemplate: String!
    $params: JSON!
  ) {
    transitionConsultantQualityItem(
      consultantId: $consultantId
      qualityCheck: $qualityCheckName
      qualityTemplate: $qualityTemplate
      transition: "OrderFromKvk"
      transitionParams: $params
    ) {
      _id
    }
  }
`;
export type OrderHlrCheckMutationFn = Apollo.MutationFunction<
  OrderHlrCheckMutation,
  OrderHlrCheckMutationVariables
>;
export type OrderHlrCheckComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    OrderHlrCheckMutation,
    OrderHlrCheckMutationVariables
  >,
  "mutation"
>;

export const OrderHlrCheckComponent = (props: OrderHlrCheckComponentProps) => (
  <ApolloReactComponents.Mutation<OrderHlrCheckMutation, OrderHlrCheckMutationVariables>
    mutation={OrderHlrCheckDocument}
    {...props}
  />
);

/**
 * __useOrderHlrCheckMutation__
 *
 * To run a mutation, you first call `useOrderHlrCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderHlrCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderHlrCheckMutation, { data, loading, error }] = useOrderHlrCheckMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      qualityTemplate: // value for 'qualityTemplate'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useOrderHlrCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderHlrCheckMutation,
    OrderHlrCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OrderHlrCheckMutation, OrderHlrCheckMutationVariables>(
    OrderHlrCheckDocument,
    options
  );
}
export type OrderHlrCheckMutationHookResult = ReturnType<typeof useOrderHlrCheckMutation>;
export namespace OrderHlrCheck {
  export type Return = OrderHlrCheckMutation;
  export type Variables = OrderHlrCheckMutationVariables;
  export const OperationName = "orderHlrCheck";

  export const Document = OrderHlrCheckDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SaveHSAIDParamsDocument = gql`
  mutation saveHSAIDParams(
    $consultantId: ObjectId!
    $country: String!
    $hsaidNumber: String!
    $cardNumber: String!
    $cardType: String!
    $setOn: Date
  ) {
    saveHSAIDStatusParams(
      consultantId: $consultantId
      country: $country
      cardNumber: $cardNumber
      cardType: $cardType
      hsaidNumber: $hsaidNumber
      setOn: $setOn
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type SaveHSAIDParamsMutationFn = Apollo.MutationFunction<
  SaveHSAIDParamsMutation,
  SaveHSAIDParamsMutationVariables
>;
export type SaveHSAIDParamsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SaveHSAIDParamsMutation,
    SaveHSAIDParamsMutationVariables
  >,
  "mutation"
>;

export const SaveHSAIDParamsComponent = (props: SaveHSAIDParamsComponentProps) => (
  <ApolloReactComponents.Mutation<
    SaveHSAIDParamsMutation,
    SaveHSAIDParamsMutationVariables
  >
    mutation={SaveHSAIDParamsDocument}
    {...props}
  />
);

/**
 * __useSaveHSAIDParamsMutation__
 *
 * To run a mutation, you first call `useSaveHSAIDParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHSAIDParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHsaidParamsMutation, { data, loading, error }] = useSaveHSAIDParamsMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      hsaidNumber: // value for 'hsaidNumber'
 *      cardNumber: // value for 'cardNumber'
 *      cardType: // value for 'cardType'
 *      setOn: // value for 'setOn'
 *   },
 * });
 */
export function useSaveHSAIDParamsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveHSAIDParamsMutation,
    SaveHSAIDParamsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveHSAIDParamsMutation, SaveHSAIDParamsMutationVariables>(
    SaveHSAIDParamsDocument,
    options
  );
}
export type SaveHSAIDParamsMutationHookResult = ReturnType<
  typeof useSaveHSAIDParamsMutation
>;
export namespace SaveHSAIDParams {
  export type Return = SaveHSAIDParamsMutation;
  export type Variables = SaveHSAIDParamsMutationVariables;
  export const OperationName = "saveHSAIDParams";

  export const Document = SaveHSAIDParamsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_GetDocument = gql`
  query ConsultantQualityItemEditor_Get(
    $consultantId: ObjectId!
    $country: String!
    $itemName: String!
  ) {
    getConsultantQualityItem(
      consultantId: $consultantId
      country: $country
      itemName: $itemName
    ) {
      ...ConsultantQualityItemEditor
    }
  }
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantQualityItemEditor_GetQuery,
    ConsultantQualityItemEditor_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantQualityItemEditor_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantQualityItemEditor_GetComponent = (
  props: ConsultantQualityItemEditor_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantQualityItemEditor_GetQuery,
    ConsultantQualityItemEditor_GetQueryVariables
  >
    query={ConsultantQualityItemEditor_GetDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_GetQuery__
 *
 * To run a query within a React component, call `useConsultantQualityItemEditor_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantQualityItemEditor_GetQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      itemName: // value for 'itemName'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantQualityItemEditor_GetQuery,
    ConsultantQualityItemEditor_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantQualityItemEditor_GetQuery,
    ConsultantQualityItemEditor_GetQueryVariables
  >(ConsultantQualityItemEditor_GetDocument, options);
}
export function useConsultantQualityItemEditor_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantQualityItemEditor_GetQuery,
    ConsultantQualityItemEditor_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantQualityItemEditor_GetQuery,
    ConsultantQualityItemEditor_GetQueryVariables
  >(ConsultantQualityItemEditor_GetDocument, options);
}
export type ConsultantQualityItemEditor_GetQueryHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_GetQuery
>;
export type ConsultantQualityItemEditor_GetLazyQueryHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_GetLazyQuery
>;
export namespace ConsultantQualityItemEditor_Get {
  export type Return = ConsultantQualityItemEditor_GetQuery;
  export type Variables = ConsultantQualityItemEditor_GetQueryVariables;
  export const OperationName = "ConsultantQualityItemEditor_Get";

  export const Document = ConsultantQualityItemEditor_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetApprovedDocument = gql`
  mutation ConsultantQualityItemEditor_SetApproved(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
    $comment: String
    $params: JSON
    $sendEmail: Boolean
  ) {
    setQualityItemApprovedStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
      comment: $comment
      params: $params
      sendEmail: $sendEmail
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetApprovedMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_SetApprovedMutation,
  ConsultantQualityItemEditor_SetApprovedMutationVariables
>;
export type ConsultantQualityItemEditor_SetApprovedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetApprovedMutation,
    ConsultantQualityItemEditor_SetApprovedMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetApprovedComponent = (
  props: ConsultantQualityItemEditor_SetApprovedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetApprovedMutation,
    ConsultantQualityItemEditor_SetApprovedMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetApprovedDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetApprovedMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetApprovedMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetApprovedMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *      comment: // value for 'comment'
 *      params: // value for 'params'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetApprovedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetApprovedMutation,
    ConsultantQualityItemEditor_SetApprovedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetApprovedMutation,
    ConsultantQualityItemEditor_SetApprovedMutationVariables
  >(ConsultantQualityItemEditor_SetApprovedDocument, options);
}
export type ConsultantQualityItemEditor_SetApprovedMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetApprovedMutation
>;
export namespace ConsultantQualityItemEditor_SetApproved {
  export type Return = ConsultantQualityItemEditor_SetApprovedMutation;
  export type Variables = ConsultantQualityItemEditor_SetApprovedMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetApproved";

  export const Document = ConsultantQualityItemEditor_SetApprovedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetApprovedWithCommentDocument = gql`
  mutation ConsultantQualityItemEditor_SetApprovedWithComment(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
    $comment: String
    $params: JSON
  ) {
    setQualityItemApprovedWithCommentStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
      comment: $comment
      params: $params
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetApprovedWithCommentMutationFn =
  Apollo.MutationFunction<
    ConsultantQualityItemEditor_SetApprovedWithCommentMutation,
    ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables
  >;
export type ConsultantQualityItemEditor_SetApprovedWithCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetApprovedWithCommentMutation,
    ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetApprovedWithCommentComponent = (
  props: ConsultantQualityItemEditor_SetApprovedWithCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetApprovedWithCommentMutation,
    ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetApprovedWithCommentDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetApprovedWithCommentMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetApprovedWithCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetApprovedWithCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetApprovedWithCommentMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetApprovedWithCommentMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *      comment: // value for 'comment'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetApprovedWithCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetApprovedWithCommentMutation,
    ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetApprovedWithCommentMutation,
    ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables
  >(ConsultantQualityItemEditor_SetApprovedWithCommentDocument, options);
}
export type ConsultantQualityItemEditor_SetApprovedWithCommentMutationHookResult =
  ReturnType<typeof useConsultantQualityItemEditor_SetApprovedWithCommentMutation>;
export namespace ConsultantQualityItemEditor_SetApprovedWithComment {
  export type Return = ConsultantQualityItemEditor_SetApprovedWithCommentMutation;
  export type Variables =
    ConsultantQualityItemEditor_SetApprovedWithCommentMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetApprovedWithComment";

  export const Document = ConsultantQualityItemEditor_SetApprovedWithCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetRequestSentIVODocument = gql`
  mutation ConsultantQualityItemEditor_SetRequestSentIVO(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
  ) {
    setQualityItemRequestSentIVOStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetRequestSentIVOMutationFn =
  Apollo.MutationFunction<
    ConsultantQualityItemEditor_SetRequestSentIVOMutation,
    ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables
  >;
export type ConsultantQualityItemEditor_SetRequestSentIVOComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetRequestSentIVOMutation,
    ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetRequestSentIVOComponent = (
  props: ConsultantQualityItemEditor_SetRequestSentIVOComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetRequestSentIVOMutation,
    ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetRequestSentIVODocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetRequestSentIVOMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetRequestSentIVOMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetRequestSentIVOMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetRequestSentIvoMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetRequestSentIVOMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetRequestSentIVOMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetRequestSentIVOMutation,
    ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetRequestSentIVOMutation,
    ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables
  >(ConsultantQualityItemEditor_SetRequestSentIVODocument, options);
}
export type ConsultantQualityItemEditor_SetRequestSentIVOMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetRequestSentIVOMutation
>;
export namespace ConsultantQualityItemEditor_SetRequestSentIVO {
  export type Return = ConsultantQualityItemEditor_SetRequestSentIVOMutation;
  export type Variables = ConsultantQualityItemEditor_SetRequestSentIVOMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetRequestSentIVO";

  export const Document = ConsultantQualityItemEditor_SetRequestSentIVODocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetRequestSentDocument = gql`
  mutation ConsultantQualityItemEditor_SetRequestSent(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
    $params: JSON
    $todo: TodoInput
  ) {
    setQualityItemRequestSentStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
      params: $params
      todo: $todo
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetRequestSentMutationFn =
  Apollo.MutationFunction<
    ConsultantQualityItemEditor_SetRequestSentMutation,
    ConsultantQualityItemEditor_SetRequestSentMutationVariables
  >;
export type ConsultantQualityItemEditor_SetRequestSentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetRequestSentMutation,
    ConsultantQualityItemEditor_SetRequestSentMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetRequestSentComponent = (
  props: ConsultantQualityItemEditor_SetRequestSentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetRequestSentMutation,
    ConsultantQualityItemEditor_SetRequestSentMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetRequestSentDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetRequestSentMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetRequestSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetRequestSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetRequestSentMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetRequestSentMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *      params: // value for 'params'
 *      todo: // value for 'todo'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetRequestSentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetRequestSentMutation,
    ConsultantQualityItemEditor_SetRequestSentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetRequestSentMutation,
    ConsultantQualityItemEditor_SetRequestSentMutationVariables
  >(ConsultantQualityItemEditor_SetRequestSentDocument, options);
}
export type ConsultantQualityItemEditor_SetRequestSentMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetRequestSentMutation
>;
export namespace ConsultantQualityItemEditor_SetRequestSent {
  export type Return = ConsultantQualityItemEditor_SetRequestSentMutation;
  export type Variables = ConsultantQualityItemEditor_SetRequestSentMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetRequestSent";

  export const Document = ConsultantQualityItemEditor_SetRequestSentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetRequestReceivedDocument = gql`
  mutation ConsultantQualityItemEditor_SetRequestReceived(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
    $comment: String
    $params: JSON
  ) {
    setQualityItemRequestReceivedStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
      comment: $comment
      params: $params
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetRequestReceivedMutationFn =
  Apollo.MutationFunction<
    ConsultantQualityItemEditor_SetRequestReceivedMutation,
    ConsultantQualityItemEditor_SetRequestReceivedMutationVariables
  >;
export type ConsultantQualityItemEditor_SetRequestReceivedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetRequestReceivedMutation,
    ConsultantQualityItemEditor_SetRequestReceivedMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetRequestReceivedComponent = (
  props: ConsultantQualityItemEditor_SetRequestReceivedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetRequestReceivedMutation,
    ConsultantQualityItemEditor_SetRequestReceivedMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetRequestReceivedDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetRequestReceivedMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetRequestReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetRequestReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetRequestReceivedMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetRequestReceivedMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *      comment: // value for 'comment'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetRequestReceivedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetRequestReceivedMutation,
    ConsultantQualityItemEditor_SetRequestReceivedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetRequestReceivedMutation,
    ConsultantQualityItemEditor_SetRequestReceivedMutationVariables
  >(ConsultantQualityItemEditor_SetRequestReceivedDocument, options);
}
export type ConsultantQualityItemEditor_SetRequestReceivedMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetRequestReceivedMutation
>;
export namespace ConsultantQualityItemEditor_SetRequestReceived {
  export type Return = ConsultantQualityItemEditor_SetRequestReceivedMutation;
  export type Variables = ConsultantQualityItemEditor_SetRequestReceivedMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetRequestReceived";

  export const Document = ConsultantQualityItemEditor_SetRequestReceivedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetBookedDocument = gql`
  mutation ConsultantQualityItemEditor_SetBooked(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
  ) {
    setBookedStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetBookedMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_SetBookedMutation,
  ConsultantQualityItemEditor_SetBookedMutationVariables
>;
export type ConsultantQualityItemEditor_SetBookedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetBookedMutation,
    ConsultantQualityItemEditor_SetBookedMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetBookedComponent = (
  props: ConsultantQualityItemEditor_SetBookedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetBookedMutation,
    ConsultantQualityItemEditor_SetBookedMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetBookedDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetBookedMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetBookedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetBookedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetBookedMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetBookedMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetBookedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetBookedMutation,
    ConsultantQualityItemEditor_SetBookedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetBookedMutation,
    ConsultantQualityItemEditor_SetBookedMutationVariables
  >(ConsultantQualityItemEditor_SetBookedDocument, options);
}
export type ConsultantQualityItemEditor_SetBookedMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetBookedMutation
>;
export namespace ConsultantQualityItemEditor_SetBooked {
  export type Return = ConsultantQualityItemEditor_SetBookedMutation;
  export type Variables = ConsultantQualityItemEditor_SetBookedMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetBooked";

  export const Document = ConsultantQualityItemEditor_SetBookedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetOrderedDocument = gql`
  mutation ConsultantQualityItemEditor_SetOrdered(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
    $todo: TodoInput
  ) {
    setOrderedStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
      todo: $todo
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetOrderedMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_SetOrderedMutation,
  ConsultantQualityItemEditor_SetOrderedMutationVariables
>;
export type ConsultantQualityItemEditor_SetOrderedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetOrderedMutation,
    ConsultantQualityItemEditor_SetOrderedMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetOrderedComponent = (
  props: ConsultantQualityItemEditor_SetOrderedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetOrderedMutation,
    ConsultantQualityItemEditor_SetOrderedMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetOrderedDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetOrderedMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetOrderedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetOrderedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetOrderedMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetOrderedMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *      todo: // value for 'todo'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetOrderedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetOrderedMutation,
    ConsultantQualityItemEditor_SetOrderedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetOrderedMutation,
    ConsultantQualityItemEditor_SetOrderedMutationVariables
  >(ConsultantQualityItemEditor_SetOrderedDocument, options);
}
export type ConsultantQualityItemEditor_SetOrderedMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetOrderedMutation
>;
export namespace ConsultantQualityItemEditor_SetOrdered {
  export type Return = ConsultantQualityItemEditor_SetOrderedMutation;
  export type Variables = ConsultantQualityItemEditor_SetOrderedMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetOrdered";

  export const Document = ConsultantQualityItemEditor_SetOrderedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetPausedDocument = gql`
  mutation ConsultantQualityItemEditor_SetPaused(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
  ) {
    setQualityItemPausedStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
    ) {
      _id
    }
  }
`;
export type ConsultantQualityItemEditor_SetPausedMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_SetPausedMutation,
  ConsultantQualityItemEditor_SetPausedMutationVariables
>;
export type ConsultantQualityItemEditor_SetPausedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetPausedMutation,
    ConsultantQualityItemEditor_SetPausedMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetPausedComponent = (
  props: ConsultantQualityItemEditor_SetPausedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetPausedMutation,
    ConsultantQualityItemEditor_SetPausedMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetPausedDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetPausedMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetPausedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetPausedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetPausedMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetPausedMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetPausedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetPausedMutation,
    ConsultantQualityItemEditor_SetPausedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetPausedMutation,
    ConsultantQualityItemEditor_SetPausedMutationVariables
  >(ConsultantQualityItemEditor_SetPausedDocument, options);
}
export type ConsultantQualityItemEditor_SetPausedMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_SetPausedMutation
>;
export namespace ConsultantQualityItemEditor_SetPaused {
  export type Return = ConsultantQualityItemEditor_SetPausedMutation;
  export type Variables = ConsultantQualityItemEditor_SetPausedMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetPaused";

  export const Document = ConsultantQualityItemEditor_SetPausedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_ReactivateDocument = gql`
  mutation ConsultantQualityItemEditor_Reactivate(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
  ) {
    reactivateQualityItem(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
    ) {
      _id
    }
  }
`;
export type ConsultantQualityItemEditor_ReactivateMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_ReactivateMutation,
  ConsultantQualityItemEditor_ReactivateMutationVariables
>;
export type ConsultantQualityItemEditor_ReactivateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_ReactivateMutation,
    ConsultantQualityItemEditor_ReactivateMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_ReactivateComponent = (
  props: ConsultantQualityItemEditor_ReactivateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_ReactivateMutation,
    ConsultantQualityItemEditor_ReactivateMutationVariables
  >
    mutation={ConsultantQualityItemEditor_ReactivateDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_ReactivateMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_ReactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_ReactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorReactivateMutation, { data, loading, error }] = useConsultantQualityItemEditor_ReactivateMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_ReactivateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_ReactivateMutation,
    ConsultantQualityItemEditor_ReactivateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_ReactivateMutation,
    ConsultantQualityItemEditor_ReactivateMutationVariables
  >(ConsultantQualityItemEditor_ReactivateDocument, options);
}
export type ConsultantQualityItemEditor_ReactivateMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_ReactivateMutation
>;
export namespace ConsultantQualityItemEditor_Reactivate {
  export type Return = ConsultantQualityItemEditor_ReactivateMutation;
  export type Variables = ConsultantQualityItemEditor_ReactivateMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_Reactivate";

  export const Document = ConsultantQualityItemEditor_ReactivateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_SetConsultantResponsibleDocument = gql`
  mutation ConsultantQualityItemEditor_SetConsultantResponsible(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date!
  ) {
    setConsultantResponsibleStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_SetConsultantResponsibleMutationFn =
  Apollo.MutationFunction<
    ConsultantQualityItemEditor_SetConsultantResponsibleMutation,
    ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables
  >;
export type ConsultantQualityItemEditor_SetConsultantResponsibleComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_SetConsultantResponsibleMutation,
    ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_SetConsultantResponsibleComponent = (
  props: ConsultantQualityItemEditor_SetConsultantResponsibleComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_SetConsultantResponsibleMutation,
    ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables
  >
    mutation={ConsultantQualityItemEditor_SetConsultantResponsibleDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_SetConsultantResponsibleMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_SetConsultantResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_SetConsultantResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorSetConsultantResponsibleMutation, { data, loading, error }] = useConsultantQualityItemEditor_SetConsultantResponsibleMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_SetConsultantResponsibleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_SetConsultantResponsibleMutation,
    ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_SetConsultantResponsibleMutation,
    ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables
  >(ConsultantQualityItemEditor_SetConsultantResponsibleDocument, options);
}
export type ConsultantQualityItemEditor_SetConsultantResponsibleMutationHookResult =
  ReturnType<typeof useConsultantQualityItemEditor_SetConsultantResponsibleMutation>;
export namespace ConsultantQualityItemEditor_SetConsultantResponsible {
  export type Return = ConsultantQualityItemEditor_SetConsultantResponsibleMutation;
  export type Variables =
    ConsultantQualityItemEditor_SetConsultantResponsibleMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_SetConsultantResponsible";

  export const Document = ConsultantQualityItemEditor_SetConsultantResponsibleDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_ClearStatusDocument = gql`
  mutation ConsultantQualityItemEditor_ClearStatus(
    $consultantId: ObjectId!
    $country: String!
    $qualityCheckName: String!
  ) {
    clearQualityItemStatus(
      consultantId: $consultantId
      country: $country
      qualityCheckName: $qualityCheckName
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type ConsultantQualityItemEditor_ClearStatusMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_ClearStatusMutation,
  ConsultantQualityItemEditor_ClearStatusMutationVariables
>;
export type ConsultantQualityItemEditor_ClearStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_ClearStatusMutation,
    ConsultantQualityItemEditor_ClearStatusMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_ClearStatusComponent = (
  props: ConsultantQualityItemEditor_ClearStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_ClearStatusMutation,
    ConsultantQualityItemEditor_ClearStatusMutationVariables
  >
    mutation={ConsultantQualityItemEditor_ClearStatusDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_ClearStatusMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_ClearStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_ClearStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorClearStatusMutation, { data, loading, error }] = useConsultantQualityItemEditor_ClearStatusMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_ClearStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_ClearStatusMutation,
    ConsultantQualityItemEditor_ClearStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_ClearStatusMutation,
    ConsultantQualityItemEditor_ClearStatusMutationVariables
  >(ConsultantQualityItemEditor_ClearStatusDocument, options);
}
export type ConsultantQualityItemEditor_ClearStatusMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_ClearStatusMutation
>;
export namespace ConsultantQualityItemEditor_ClearStatus {
  export type Return = ConsultantQualityItemEditor_ClearStatusMutation;
  export type Variables = ConsultantQualityItemEditor_ClearStatusMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_ClearStatus";

  export const Document = ConsultantQualityItemEditor_ClearStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantQualityItemEditor_UploadDocument = gql`
  mutation ConsultantQualityItemEditor_Upload(
    $consultantId: ObjectId!
    $documentType: String!
    $statusName: String!
    $file: Upload!
  ) {
    uploadConsultantDocument(
      consultantId: $consultantId
      documentType: $documentType
      statusName: $statusName
      file: $file
    ) {
      FileRef {
        MimeType
        Name
        NodeID
        NodeType
        Size
      }
    }
  }
`;
export type ConsultantQualityItemEditor_UploadMutationFn = Apollo.MutationFunction<
  ConsultantQualityItemEditor_UploadMutation,
  ConsultantQualityItemEditor_UploadMutationVariables
>;
export type ConsultantQualityItemEditor_UploadComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantQualityItemEditor_UploadMutation,
    ConsultantQualityItemEditor_UploadMutationVariables
  >,
  "mutation"
>;

export const ConsultantQualityItemEditor_UploadComponent = (
  props: ConsultantQualityItemEditor_UploadComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantQualityItemEditor_UploadMutation,
    ConsultantQualityItemEditor_UploadMutationVariables
  >
    mutation={ConsultantQualityItemEditor_UploadDocument}
    {...props}
  />
);

/**
 * __useConsultantQualityItemEditor_UploadMutation__
 *
 * To run a mutation, you first call `useConsultantQualityItemEditor_UploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantQualityItemEditor_UploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantQualityItemEditorUploadMutation, { data, loading, error }] = useConsultantQualityItemEditor_UploadMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      documentType: // value for 'documentType'
 *      statusName: // value for 'statusName'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useConsultantQualityItemEditor_UploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantQualityItemEditor_UploadMutation,
    ConsultantQualityItemEditor_UploadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantQualityItemEditor_UploadMutation,
    ConsultantQualityItemEditor_UploadMutationVariables
  >(ConsultantQualityItemEditor_UploadDocument, options);
}
export type ConsultantQualityItemEditor_UploadMutationHookResult = ReturnType<
  typeof useConsultantQualityItemEditor_UploadMutation
>;
export namespace ConsultantQualityItemEditor_Upload {
  export type Return = ConsultantQualityItemEditor_UploadMutation;
  export type Variables = ConsultantQualityItemEditor_UploadMutationVariables;
  export const OperationName = "ConsultantQualityItemEditor_Upload";

  export const Document = ConsultantQualityItemEditor_UploadDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SendRequestIVODocument = gql`
  mutation SendRequestIVO(
    $consultantId: ObjectId!
    $body: String!
    $subject: String!
    $country: String!
    $qualityCheckName: String!
    $setOn: Date
    $from: String
  ) {
    sendRequestIVO(
      consultantId: $consultantId
      body: $body
      subject: $subject
      country: $country
      qualityCheckName: $qualityCheckName
      setOn: $setOn
      from: $from
    ) {
      _id
      QualityPerCountry {
        Country
        QualityChecks {
          ...ConsultantQualityCheckData
          ...ConsultantQualityItemEditor
        }
      }
    }
  }
  ${ConsultantQualityCheckDataFragmentDoc}
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type SendRequestIVOMutationFn = Apollo.MutationFunction<
  SendRequestIVOMutation,
  SendRequestIVOMutationVariables
>;
export type SendRequestIVOComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendRequestIVOMutation,
    SendRequestIVOMutationVariables
  >,
  "mutation"
>;

export const SendRequestIVOComponent = (props: SendRequestIVOComponentProps) => (
  <ApolloReactComponents.Mutation<SendRequestIVOMutation, SendRequestIVOMutationVariables>
    mutation={SendRequestIVODocument}
    {...props}
  />
);

/**
 * __useSendRequestIVOMutation__
 *
 * To run a mutation, you first call `useSendRequestIVOMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRequestIVOMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRequestIvoMutation, { data, loading, error }] = useSendRequestIVOMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      body: // value for 'body'
 *      subject: // value for 'subject'
 *      country: // value for 'country'
 *      qualityCheckName: // value for 'qualityCheckName'
 *      setOn: // value for 'setOn'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useSendRequestIVOMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendRequestIVOMutation,
    SendRequestIVOMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendRequestIVOMutation, SendRequestIVOMutationVariables>(
    SendRequestIVODocument,
    options
  );
}
export type SendRequestIVOMutationHookResult = ReturnType<
  typeof useSendRequestIVOMutation
>;
export namespace SendRequestIVO {
  export type Return = SendRequestIVOMutation;
  export type Variables = SendRequestIVOMutationVariables;
  export const OperationName = "SendRequestIVO";

  export const Document = SendRequestIVODocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantProfileForQualityItem_GetConsultantDocument = gql`
  query ConsultantProfileForQualityItem_GetConsultant($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantProfileForQualityItem
    }
  }
  ${ConsultantProfileForQualityItemFragmentDoc}
`;
export type ConsultantProfileForQualityItem_GetConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantProfileForQualityItem_GetConsultantQuery,
    ConsultantProfileForQualityItem_GetConsultantQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: ConsultantProfileForQualityItem_GetConsultantQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const ConsultantProfileForQualityItem_GetConsultantComponent = (
  props: ConsultantProfileForQualityItem_GetConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantProfileForQualityItem_GetConsultantQuery,
    ConsultantProfileForQualityItem_GetConsultantQueryVariables
  >
    query={ConsultantProfileForQualityItem_GetConsultantDocument}
    {...props}
  />
);

/**
 * __useConsultantProfileForQualityItem_GetConsultantQuery__
 *
 * To run a query within a React component, call `useConsultantProfileForQualityItem_GetConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantProfileForQualityItem_GetConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantProfileForQualityItem_GetConsultantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantProfileForQualityItem_GetConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantProfileForQualityItem_GetConsultantQuery,
    ConsultantProfileForQualityItem_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantProfileForQualityItem_GetConsultantQuery,
    ConsultantProfileForQualityItem_GetConsultantQueryVariables
  >(ConsultantProfileForQualityItem_GetConsultantDocument, options);
}
export function useConsultantProfileForQualityItem_GetConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantProfileForQualityItem_GetConsultantQuery,
    ConsultantProfileForQualityItem_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantProfileForQualityItem_GetConsultantQuery,
    ConsultantProfileForQualityItem_GetConsultantQueryVariables
  >(ConsultantProfileForQualityItem_GetConsultantDocument, options);
}
export type ConsultantProfileForQualityItem_GetConsultantQueryHookResult = ReturnType<
  typeof useConsultantProfileForQualityItem_GetConsultantQuery
>;
export type ConsultantProfileForQualityItem_GetConsultantLazyQueryHookResult = ReturnType<
  typeof useConsultantProfileForQualityItem_GetConsultantLazyQuery
>;
export namespace ConsultantProfileForQualityItem_GetConsultant {
  export type Return = ConsultantProfileForQualityItem_GetConsultantQuery;
  export type Variables = ConsultantProfileForQualityItem_GetConsultantQueryVariables;
  export const OperationName = "ConsultantProfileForQualityItem_GetConsultant";

  export const Document = ConsultantProfileForQualityItem_GetConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantQualityItemEditorDataDocument = gql`
  query getConsultantQualityItemEditorData(
    $consultantId: ObjectId!
    $country: String!
    $itemName: String!
  ) {
    getConsultantQualityItem(
      consultantId: $consultantId
      country: $country
      itemName: $itemName
    ) {
      ...ConsultantQualityItemEditor
    }
  }
  ${ConsultantQualityItemEditorFragmentDoc}
`;
export type GetConsultantQualityItemEditorDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantQualityItemEditorDataQuery,
    GetConsultantQualityItemEditorDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantQualityItemEditorDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantQualityItemEditorDataComponent = (
  props: GetConsultantQualityItemEditorDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantQualityItemEditorDataQuery,
    GetConsultantQualityItemEditorDataQueryVariables
  >
    query={GetConsultantQualityItemEditorDataDocument}
    {...props}
  />
);

/**
 * __useGetConsultantQualityItemEditorDataQuery__
 *
 * To run a query within a React component, call `useGetConsultantQualityItemEditorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantQualityItemEditorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantQualityItemEditorDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      country: // value for 'country'
 *      itemName: // value for 'itemName'
 *   },
 * });
 */
export function useGetConsultantQualityItemEditorDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantQualityItemEditorDataQuery,
    GetConsultantQualityItemEditorDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantQualityItemEditorDataQuery,
    GetConsultantQualityItemEditorDataQueryVariables
  >(GetConsultantQualityItemEditorDataDocument, options);
}
export function useGetConsultantQualityItemEditorDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantQualityItemEditorDataQuery,
    GetConsultantQualityItemEditorDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantQualityItemEditorDataQuery,
    GetConsultantQualityItemEditorDataQueryVariables
  >(GetConsultantQualityItemEditorDataDocument, options);
}
export type GetConsultantQualityItemEditorDataQueryHookResult = ReturnType<
  typeof useGetConsultantQualityItemEditorDataQuery
>;
export type GetConsultantQualityItemEditorDataLazyQueryHookResult = ReturnType<
  typeof useGetConsultantQualityItemEditorDataLazyQuery
>;
export namespace GetConsultantQualityItemEditorData {
  export type Return = GetConsultantQualityItemEditorDataQuery;
  export type Variables = GetConsultantQualityItemEditorDataQueryVariables;
  export const OperationName = "getConsultantQualityItemEditorData";

  export const Document = GetConsultantQualityItemEditorDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantQuality_GetConsultantNewDocument = gql`
  query ConsultantQuality_GetConsultantNew($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantQuality_ConsultantNew
    }
  }
  ${ConsultantQuality_ConsultantNewFragmentDoc}
`;
export type ConsultantQuality_GetConsultantNewComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantQuality_GetConsultantNewQuery,
    ConsultantQuality_GetConsultantNewQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantQuality_GetConsultantNewQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantQuality_GetConsultantNewComponent = (
  props: ConsultantQuality_GetConsultantNewComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantQuality_GetConsultantNewQuery,
    ConsultantQuality_GetConsultantNewQueryVariables
  >
    query={ConsultantQuality_GetConsultantNewDocument}
    {...props}
  />
);

/**
 * __useConsultantQuality_GetConsultantNewQuery__
 *
 * To run a query within a React component, call `useConsultantQuality_GetConsultantNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantQuality_GetConsultantNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantQuality_GetConsultantNewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantQuality_GetConsultantNewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantQuality_GetConsultantNewQuery,
    ConsultantQuality_GetConsultantNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantQuality_GetConsultantNewQuery,
    ConsultantQuality_GetConsultantNewQueryVariables
  >(ConsultantQuality_GetConsultantNewDocument, options);
}
export function useConsultantQuality_GetConsultantNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantQuality_GetConsultantNewQuery,
    ConsultantQuality_GetConsultantNewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantQuality_GetConsultantNewQuery,
    ConsultantQuality_GetConsultantNewQueryVariables
  >(ConsultantQuality_GetConsultantNewDocument, options);
}
export type ConsultantQuality_GetConsultantNewQueryHookResult = ReturnType<
  typeof useConsultantQuality_GetConsultantNewQuery
>;
export type ConsultantQuality_GetConsultantNewLazyQueryHookResult = ReturnType<
  typeof useConsultantQuality_GetConsultantNewLazyQuery
>;
export namespace ConsultantQuality_GetConsultantNew {
  export type Return = ConsultantQuality_GetConsultantNewQuery;
  export type Variables = ConsultantQuality_GetConsultantNewQueryVariables;
  export const OperationName = "ConsultantQuality_GetConsultantNew";

  export const Document = ConsultantQuality_GetConsultantNewDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantQuality_GetConsultantDocument = gql`
  query ConsultantQuality_GetConsultant($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantQuality_Consultant
    }
  }
  ${ConsultantQuality_ConsultantFragmentDoc}
`;
export type ConsultantQuality_GetConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantQuality_GetConsultantQuery,
    ConsultantQuality_GetConsultantQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantQuality_GetConsultantQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantQuality_GetConsultantComponent = (
  props: ConsultantQuality_GetConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantQuality_GetConsultantQuery,
    ConsultantQuality_GetConsultantQueryVariables
  >
    query={ConsultantQuality_GetConsultantDocument}
    {...props}
  />
);

/**
 * __useConsultantQuality_GetConsultantQuery__
 *
 * To run a query within a React component, call `useConsultantQuality_GetConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantQuality_GetConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantQuality_GetConsultantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantQuality_GetConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantQuality_GetConsultantQuery,
    ConsultantQuality_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantQuality_GetConsultantQuery,
    ConsultantQuality_GetConsultantQueryVariables
  >(ConsultantQuality_GetConsultantDocument, options);
}
export function useConsultantQuality_GetConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantQuality_GetConsultantQuery,
    ConsultantQuality_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantQuality_GetConsultantQuery,
    ConsultantQuality_GetConsultantQueryVariables
  >(ConsultantQuality_GetConsultantDocument, options);
}
export type ConsultantQuality_GetConsultantQueryHookResult = ReturnType<
  typeof useConsultantQuality_GetConsultantQuery
>;
export type ConsultantQuality_GetConsultantLazyQueryHookResult = ReturnType<
  typeof useConsultantQuality_GetConsultantLazyQuery
>;
export namespace ConsultantQuality_GetConsultant {
  export type Return = ConsultantQuality_GetConsultantQuery;
  export type Variables = ConsultantQuality_GetConsultantQueryVariables;
  export const OperationName = "ConsultantQuality_GetConsultant";

  export const Document = ConsultantQuality_GetConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Reference_GetListDocument = gql`
  query Reference_getList($id: ObjectId!) {
    consultantReferences(consultantId: $id) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_GetListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Reference_GetListQuery,
    Reference_GetListQueryVariables
  >,
  "query"
> &
  ({ variables: Reference_GetListQueryVariables; skip?: boolean } | { skip: boolean });

export const Reference_GetListComponent = (props: Reference_GetListComponentProps) => (
  <ApolloReactComponents.Query<Reference_GetListQuery, Reference_GetListQueryVariables>
    query={Reference_GetListDocument}
    {...props}
  />
);

/**
 * __useReference_GetListQuery__
 *
 * To run a query within a React component, call `useReference_GetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReference_GetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReference_GetListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReference_GetListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Reference_GetListQuery,
    Reference_GetListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Reference_GetListQuery, Reference_GetListQueryVariables>(
    Reference_GetListDocument,
    options
  );
}
export function useReference_GetListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Reference_GetListQuery,
    Reference_GetListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Reference_GetListQuery, Reference_GetListQueryVariables>(
    Reference_GetListDocument,
    options
  );
}
export type Reference_GetListQueryHookResult = ReturnType<
  typeof useReference_GetListQuery
>;
export type Reference_GetListLazyQueryHookResult = ReturnType<
  typeof useReference_GetListLazyQuery
>;
export namespace Reference_getList {
  export type Return = Reference_GetListQuery;
  export type Variables = Reference_GetListQueryVariables;
  export const OperationName = "Reference_getList";

  export const Document = Reference_GetListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Reference_GetConsultantDocument = gql`
  query Reference_getConsultant($id: ObjectId!) {
    consultantById(id: $id) {
      _id
      AreasOfExpertise
      Name
      QualityPerCountry {
        Country
        QualityChecks {
          Name
          Status {
            Name
          }
        }
      }
    }
  }
`;
export type Reference_GetConsultantComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    Reference_GetConsultantQuery,
    Reference_GetConsultantQueryVariables
  >,
  "query"
> &
  (
    | { variables: Reference_GetConsultantQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const Reference_GetConsultantComponent = (
  props: Reference_GetConsultantComponentProps
) => (
  <ApolloReactComponents.Query<
    Reference_GetConsultantQuery,
    Reference_GetConsultantQueryVariables
  >
    query={Reference_GetConsultantDocument}
    {...props}
  />
);

/**
 * __useReference_GetConsultantQuery__
 *
 * To run a query within a React component, call `useReference_GetConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useReference_GetConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReference_GetConsultantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReference_GetConsultantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Reference_GetConsultantQuery,
    Reference_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Reference_GetConsultantQuery,
    Reference_GetConsultantQueryVariables
  >(Reference_GetConsultantDocument, options);
}
export function useReference_GetConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Reference_GetConsultantQuery,
    Reference_GetConsultantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Reference_GetConsultantQuery,
    Reference_GetConsultantQueryVariables
  >(Reference_GetConsultantDocument, options);
}
export type Reference_GetConsultantQueryHookResult = ReturnType<
  typeof useReference_GetConsultantQuery
>;
export type Reference_GetConsultantLazyQueryHookResult = ReturnType<
  typeof useReference_GetConsultantLazyQuery
>;
export namespace Reference_getConsultant {
  export type Return = Reference_GetConsultantQuery;
  export type Variables = Reference_GetConsultantQueryVariables;
  export const OperationName = "Reference_getConsultant";

  export const Document = Reference_GetConsultantDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const Reference_AddDocument = gql`
  mutation Reference_add($consultantId: ObjectId!, $input: ConsultantReferenceInputNew!) {
    createConsultantReference(consultantId: $consultantId, input: $input) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_AddMutationFn = Apollo.MutationFunction<
  Reference_AddMutation,
  Reference_AddMutationVariables
>;
export type Reference_AddComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_AddMutation,
    Reference_AddMutationVariables
  >,
  "mutation"
>;

export const Reference_AddComponent = (props: Reference_AddComponentProps) => (
  <ApolloReactComponents.Mutation<Reference_AddMutation, Reference_AddMutationVariables>
    mutation={Reference_AddDocument}
    {...props}
  />
);

/**
 * __useReference_AddMutation__
 *
 * To run a mutation, you first call `useReference_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceAddMutation, { data, loading, error }] = useReference_AddMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReference_AddMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_AddMutation,
    Reference_AddMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Reference_AddMutation, Reference_AddMutationVariables>(
    Reference_AddDocument,
    options
  );
}
export type Reference_AddMutationHookResult = ReturnType<typeof useReference_AddMutation>;
export namespace Reference_add {
  export type Return = Reference_AddMutation;
  export type Variables = Reference_AddMutationVariables;
  export const OperationName = "Reference_add";

  export const Document = Reference_AddDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_EditDocument = gql`
  mutation Reference_edit($refId: ObjectId!, $input: ConsultantReferenceInputNew!) {
    updateConsultantReference(consultantReferenceId: $refId, input: $input) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_EditMutationFn = Apollo.MutationFunction<
  Reference_EditMutation,
  Reference_EditMutationVariables
>;
export type Reference_EditComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_EditMutation,
    Reference_EditMutationVariables
  >,
  "mutation"
>;

export const Reference_EditComponent = (props: Reference_EditComponentProps) => (
  <ApolloReactComponents.Mutation<Reference_EditMutation, Reference_EditMutationVariables>
    mutation={Reference_EditDocument}
    {...props}
  />
);

/**
 * __useReference_EditMutation__
 *
 * To run a mutation, you first call `useReference_EditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_EditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceEditMutation, { data, loading, error }] = useReference_EditMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReference_EditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_EditMutation,
    Reference_EditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Reference_EditMutation, Reference_EditMutationVariables>(
    Reference_EditDocument,
    options
  );
}
export type Reference_EditMutationHookResult = ReturnType<
  typeof useReference_EditMutation
>;
export namespace Reference_edit {
  export type Return = Reference_EditMutation;
  export type Variables = Reference_EditMutationVariables;
  export const OperationName = "Reference_edit";

  export const Document = Reference_EditDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_DeleteDocument = gql`
  mutation Reference_delete($refId: ObjectId!, $softDelete: Boolean!) {
    deleteConsultantReference(consultantReferenceId: $refId, softDelete: $softDelete)
  }
`;
export type Reference_DeleteMutationFn = Apollo.MutationFunction<
  Reference_DeleteMutation,
  Reference_DeleteMutationVariables
>;
export type Reference_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_DeleteMutation,
    Reference_DeleteMutationVariables
  >,
  "mutation"
>;

export const Reference_DeleteComponent = (props: Reference_DeleteComponentProps) => (
  <ApolloReactComponents.Mutation<
    Reference_DeleteMutation,
    Reference_DeleteMutationVariables
  >
    mutation={Reference_DeleteDocument}
    {...props}
  />
);

/**
 * __useReference_DeleteMutation__
 *
 * To run a mutation, you first call `useReference_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceDeleteMutation, { data, loading, error }] = useReference_DeleteMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      softDelete: // value for 'softDelete'
 *   },
 * });
 */
export function useReference_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_DeleteMutation,
    Reference_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Reference_DeleteMutation, Reference_DeleteMutationVariables>(
    Reference_DeleteDocument,
    options
  );
}
export type Reference_DeleteMutationHookResult = ReturnType<
  typeof useReference_DeleteMutation
>;
export namespace Reference_delete {
  export type Return = Reference_DeleteMutation;
  export type Variables = Reference_DeleteMutationVariables;
  export const OperationName = "Reference_delete";

  export const Document = Reference_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_RestoreDocument = gql`
  mutation Reference_restore($refId: ObjectId!) {
    restoreConsultantReference(consultantReferenceId: $refId) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_RestoreMutationFn = Apollo.MutationFunction<
  Reference_RestoreMutation,
  Reference_RestoreMutationVariables
>;
export type Reference_RestoreComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_RestoreMutation,
    Reference_RestoreMutationVariables
  >,
  "mutation"
>;

export const Reference_RestoreComponent = (props: Reference_RestoreComponentProps) => (
  <ApolloReactComponents.Mutation<
    Reference_RestoreMutation,
    Reference_RestoreMutationVariables
  >
    mutation={Reference_RestoreDocument}
    {...props}
  />
);

/**
 * __useReference_RestoreMutation__
 *
 * To run a mutation, you first call `useReference_RestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_RestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceRestoreMutation, { data, loading, error }] = useReference_RestoreMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useReference_RestoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_RestoreMutation,
    Reference_RestoreMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Reference_RestoreMutation,
    Reference_RestoreMutationVariables
  >(Reference_RestoreDocument, options);
}
export type Reference_RestoreMutationHookResult = ReturnType<
  typeof useReference_RestoreMutation
>;
export namespace Reference_restore {
  export type Return = Reference_RestoreMutation;
  export type Variables = Reference_RestoreMutationVariables;
  export const OperationName = "Reference_restore";

  export const Document = Reference_RestoreDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_SendToRefDocument = gql`
  mutation Reference_sendToRef($refId: ObjectId!) {
    sendConsultantReferenceForm(consultantReferenceId: $refId) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_SendToRefMutationFn = Apollo.MutationFunction<
  Reference_SendToRefMutation,
  Reference_SendToRefMutationVariables
>;
export type Reference_SendToRefComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_SendToRefMutation,
    Reference_SendToRefMutationVariables
  >,
  "mutation"
>;

export const Reference_SendToRefComponent = (
  props: Reference_SendToRefComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Reference_SendToRefMutation,
    Reference_SendToRefMutationVariables
  >
    mutation={Reference_SendToRefDocument}
    {...props}
  />
);

/**
 * __useReference_SendToRefMutation__
 *
 * To run a mutation, you first call `useReference_SendToRefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_SendToRefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceSendToRefMutation, { data, loading, error }] = useReference_SendToRefMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useReference_SendToRefMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_SendToRefMutation,
    Reference_SendToRefMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Reference_SendToRefMutation,
    Reference_SendToRefMutationVariables
  >(Reference_SendToRefDocument, options);
}
export type Reference_SendToRefMutationHookResult = ReturnType<
  typeof useReference_SendToRefMutation
>;
export namespace Reference_sendToRef {
  export type Return = Reference_SendToRefMutation;
  export type Variables = Reference_SendToRefMutationVariables;
  export const OperationName = "Reference_sendToRef";

  export const Document = Reference_SendToRefDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_ReSendToRefDocument = gql`
  mutation Reference_reSendToRef($refId: ObjectId!) {
    reSendConsultantReferenceForm(consultantReferenceId: $refId) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_ReSendToRefMutationFn = Apollo.MutationFunction<
  Reference_ReSendToRefMutation,
  Reference_ReSendToRefMutationVariables
>;
export type Reference_ReSendToRefComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_ReSendToRefMutation,
    Reference_ReSendToRefMutationVariables
  >,
  "mutation"
>;

export const Reference_ReSendToRefComponent = (
  props: Reference_ReSendToRefComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Reference_ReSendToRefMutation,
    Reference_ReSendToRefMutationVariables
  >
    mutation={Reference_ReSendToRefDocument}
    {...props}
  />
);

/**
 * __useReference_ReSendToRefMutation__
 *
 * To run a mutation, you first call `useReference_ReSendToRefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_ReSendToRefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceReSendToRefMutation, { data, loading, error }] = useReference_ReSendToRefMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useReference_ReSendToRefMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_ReSendToRefMutation,
    Reference_ReSendToRefMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Reference_ReSendToRefMutation,
    Reference_ReSendToRefMutationVariables
  >(Reference_ReSendToRefDocument, options);
}
export type Reference_ReSendToRefMutationHookResult = ReturnType<
  typeof useReference_ReSendToRefMutation
>;
export namespace Reference_reSendToRef {
  export type Return = Reference_ReSendToRefMutation;
  export type Variables = Reference_ReSendToRefMutationVariables;
  export const OperationName = "Reference_reSendToRef";

  export const Document = Reference_ReSendToRefDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_SendToKvkDocument = gql`
  mutation Reference_sendToKvk($refId: ObjectId!, $input: TodoItemInput!) {
    sendToKvkConsultantReference(consultantReferenceId: $refId, input: $input) {
      consultantReference {
        ...ReferenceItem
      }
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_SendToKvkMutationFn = Apollo.MutationFunction<
  Reference_SendToKvkMutation,
  Reference_SendToKvkMutationVariables
>;
export type Reference_SendToKvkComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_SendToKvkMutation,
    Reference_SendToKvkMutationVariables
  >,
  "mutation"
>;

export const Reference_SendToKvkComponent = (
  props: Reference_SendToKvkComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Reference_SendToKvkMutation,
    Reference_SendToKvkMutationVariables
  >
    mutation={Reference_SendToKvkDocument}
    {...props}
  />
);

/**
 * __useReference_SendToKvkMutation__
 *
 * To run a mutation, you first call `useReference_SendToKvkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_SendToKvkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceSendToKvkMutation, { data, loading, error }] = useReference_SendToKvkMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReference_SendToKvkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_SendToKvkMutation,
    Reference_SendToKvkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Reference_SendToKvkMutation,
    Reference_SendToKvkMutationVariables
  >(Reference_SendToKvkDocument, options);
}
export type Reference_SendToKvkMutationHookResult = ReturnType<
  typeof useReference_SendToKvkMutation
>;
export namespace Reference_sendToKvk {
  export type Return = Reference_SendToKvkMutation;
  export type Variables = Reference_SendToKvkMutationVariables;
  export const OperationName = "Reference_sendToKvk";

  export const Document = Reference_SendToKvkDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_RequestUpdToKvkDocument = gql`
  mutation Reference_requestUpdToKvk($refId: ObjectId!, $input: TodoItemInput!) {
    requestUpdToKvkConsultantReference(consultantReferenceId: $refId, input: $input) {
      consultantReference {
        ...ReferenceItem
      }
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_RequestUpdToKvkMutationFn = Apollo.MutationFunction<
  Reference_RequestUpdToKvkMutation,
  Reference_RequestUpdToKvkMutationVariables
>;
export type Reference_RequestUpdToKvkComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_RequestUpdToKvkMutation,
    Reference_RequestUpdToKvkMutationVariables
  >,
  "mutation"
>;

export const Reference_RequestUpdToKvkComponent = (
  props: Reference_RequestUpdToKvkComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Reference_RequestUpdToKvkMutation,
    Reference_RequestUpdToKvkMutationVariables
  >
    mutation={Reference_RequestUpdToKvkDocument}
    {...props}
  />
);

/**
 * __useReference_RequestUpdToKvkMutation__
 *
 * To run a mutation, you first call `useReference_RequestUpdToKvkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_RequestUpdToKvkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceRequestUpdToKvkMutation, { data, loading, error }] = useReference_RequestUpdToKvkMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReference_RequestUpdToKvkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_RequestUpdToKvkMutation,
    Reference_RequestUpdToKvkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Reference_RequestUpdToKvkMutation,
    Reference_RequestUpdToKvkMutationVariables
  >(Reference_RequestUpdToKvkDocument, options);
}
export type Reference_RequestUpdToKvkMutationHookResult = ReturnType<
  typeof useReference_RequestUpdToKvkMutation
>;
export namespace Reference_requestUpdToKvk {
  export type Return = Reference_RequestUpdToKvkMutation;
  export type Variables = Reference_RequestUpdToKvkMutationVariables;
  export const OperationName = "Reference_requestUpdToKvk";

  export const Document = Reference_RequestUpdToKvkDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_ChangeStatusDocument = gql`
  mutation Reference_changeStatus(
    $refId: ObjectId!
    $input: ChangeStatusConsultantReferenceInput!
    $file: Upload
  ) {
    changeStatusConsultantReference(
      consultantReferenceId: $refId
      input: $input
      file: $file
    ) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_ChangeStatusMutationFn = Apollo.MutationFunction<
  Reference_ChangeStatusMutation,
  Reference_ChangeStatusMutationVariables
>;
export type Reference_ChangeStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_ChangeStatusMutation,
    Reference_ChangeStatusMutationVariables
  >,
  "mutation"
>;

export const Reference_ChangeStatusComponent = (
  props: Reference_ChangeStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    Reference_ChangeStatusMutation,
    Reference_ChangeStatusMutationVariables
  >
    mutation={Reference_ChangeStatusDocument}
    {...props}
  />
);

/**
 * __useReference_ChangeStatusMutation__
 *
 * To run a mutation, you first call `useReference_ChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_ChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceChangeStatusMutation, { data, loading, error }] = useReference_ChangeStatusMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useReference_ChangeStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_ChangeStatusMutation,
    Reference_ChangeStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Reference_ChangeStatusMutation,
    Reference_ChangeStatusMutationVariables
  >(Reference_ChangeStatusDocument, options);
}
export type Reference_ChangeStatusMutationHookResult = ReturnType<
  typeof useReference_ChangeStatusMutation
>;
export namespace Reference_changeStatus {
  export type Return = Reference_ChangeStatusMutation;
  export type Variables = Reference_ChangeStatusMutationVariables;
  export const OperationName = "Reference_changeStatus";

  export const Document = Reference_ChangeStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const Reference_MergeDocument = gql`
  mutation Reference_merge($refId: ObjectId!, $mergeWithRefId: ObjectId!) {
    mergeConsultantReference(
      consultantReferenceId: $refId
      mergeWithRefId: $mergeWithRefId
    ) {
      ...ReferenceItem
    }
  }
  ${ReferenceItemFragmentDoc}
`;
export type Reference_MergeMutationFn = Apollo.MutationFunction<
  Reference_MergeMutation,
  Reference_MergeMutationVariables
>;
export type Reference_MergeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    Reference_MergeMutation,
    Reference_MergeMutationVariables
  >,
  "mutation"
>;

export const Reference_MergeComponent = (props: Reference_MergeComponentProps) => (
  <ApolloReactComponents.Mutation<
    Reference_MergeMutation,
    Reference_MergeMutationVariables
  >
    mutation={Reference_MergeDocument}
    {...props}
  />
);

/**
 * __useReference_MergeMutation__
 *
 * To run a mutation, you first call `useReference_MergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReference_MergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referenceMergeMutation, { data, loading, error }] = useReference_MergeMutation({
 *   variables: {
 *      refId: // value for 'refId'
 *      mergeWithRefId: // value for 'mergeWithRefId'
 *   },
 * });
 */
export function useReference_MergeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Reference_MergeMutation,
    Reference_MergeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Reference_MergeMutation, Reference_MergeMutationVariables>(
    Reference_MergeDocument,
    options
  );
}
export type Reference_MergeMutationHookResult = ReturnType<
  typeof useReference_MergeMutation
>;
export namespace Reference_merge {
  export type Return = Reference_MergeMutation;
  export type Variables = Reference_MergeMutationVariables;
  export const OperationName = "Reference_merge";

  export const Document = Reference_MergeDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantServicePreferencesDocument = gql`
  query getConsultantServicePreferences($consultantId: ObjectId!) {
    consultantServicePreferences(consultantId: $consultantId) {
      ...ConsultantServicePreference
    }
  }
  ${ConsultantServicePreferenceFragmentDoc}
`;
export type GetConsultantServicePreferencesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantServicePreferencesQuery,
    GetConsultantServicePreferencesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantServicePreferencesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantServicePreferencesComponent = (
  props: GetConsultantServicePreferencesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantServicePreferencesQuery,
    GetConsultantServicePreferencesQueryVariables
  >
    query={GetConsultantServicePreferencesDocument}
    {...props}
  />
);

/**
 * __useGetConsultantServicePreferencesQuery__
 *
 * To run a query within a React component, call `useGetConsultantServicePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantServicePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantServicePreferencesQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantServicePreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantServicePreferencesQuery,
    GetConsultantServicePreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantServicePreferencesQuery,
    GetConsultantServicePreferencesQueryVariables
  >(GetConsultantServicePreferencesDocument, options);
}
export function useGetConsultantServicePreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantServicePreferencesQuery,
    GetConsultantServicePreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantServicePreferencesQuery,
    GetConsultantServicePreferencesQueryVariables
  >(GetConsultantServicePreferencesDocument, options);
}
export type GetConsultantServicePreferencesQueryHookResult = ReturnType<
  typeof useGetConsultantServicePreferencesQuery
>;
export type GetConsultantServicePreferencesLazyQueryHookResult = ReturnType<
  typeof useGetConsultantServicePreferencesLazyQuery
>;
export namespace GetConsultantServicePreferences {
  export type Return = GetConsultantServicePreferencesQuery;
  export type Variables = GetConsultantServicePreferencesQueryVariables;
  export const OperationName = "getConsultantServicePreferences";

  export const Document = GetConsultantServicePreferencesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantServicePreferenceFormDocument = gql`
  query getConsultantServicePreferenceForm($id: ObjectId!) {
    consultantServicePreferenceForm(id: $id) {
      ...ConsultantServicePreferenceForm
    }
  }
  ${ConsultantServicePreferenceFormFragmentDoc}
`;
export type GetConsultantServicePreferenceFormComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantServicePreferenceFormQuery,
    GetConsultantServicePreferenceFormQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantServicePreferenceFormQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantServicePreferenceFormComponent = (
  props: GetConsultantServicePreferenceFormComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantServicePreferenceFormQuery,
    GetConsultantServicePreferenceFormQueryVariables
  >
    query={GetConsultantServicePreferenceFormDocument}
    {...props}
  />
);

/**
 * __useGetConsultantServicePreferenceFormQuery__
 *
 * To run a query within a React component, call `useGetConsultantServicePreferenceFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantServicePreferenceFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantServicePreferenceFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantServicePreferenceFormQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantServicePreferenceFormQuery,
    GetConsultantServicePreferenceFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantServicePreferenceFormQuery,
    GetConsultantServicePreferenceFormQueryVariables
  >(GetConsultantServicePreferenceFormDocument, options);
}
export function useGetConsultantServicePreferenceFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantServicePreferenceFormQuery,
    GetConsultantServicePreferenceFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantServicePreferenceFormQuery,
    GetConsultantServicePreferenceFormQueryVariables
  >(GetConsultantServicePreferenceFormDocument, options);
}
export type GetConsultantServicePreferenceFormQueryHookResult = ReturnType<
  typeof useGetConsultantServicePreferenceFormQuery
>;
export type GetConsultantServicePreferenceFormLazyQueryHookResult = ReturnType<
  typeof useGetConsultantServicePreferenceFormLazyQuery
>;
export namespace GetConsultantServicePreferenceForm {
  export type Return = GetConsultantServicePreferenceFormQuery;
  export type Variables = GetConsultantServicePreferenceFormQueryVariables;
  export const OperationName = "getConsultantServicePreferenceForm";

  export const Document = GetConsultantServicePreferenceFormDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateConsultantServicePreferenceDocument = gql`
  mutation createConsultantServicePreference(
    $consultantId: ObjectId!
    $input: CreateConsultantServicePreferenceInput!
  ) {
    createConsultantServicePreference(consultantId: $consultantId, input: $input) {
      ...ConsultantServicePreference
    }
  }
  ${ConsultantServicePreferenceFragmentDoc}
`;
export type CreateConsultantServicePreferenceMutationFn = Apollo.MutationFunction<
  CreateConsultantServicePreferenceMutation,
  CreateConsultantServicePreferenceMutationVariables
>;
export type CreateConsultantServicePreferenceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateConsultantServicePreferenceMutation,
    CreateConsultantServicePreferenceMutationVariables
  >,
  "mutation"
>;

export const CreateConsultantServicePreferenceComponent = (
  props: CreateConsultantServicePreferenceComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateConsultantServicePreferenceMutation,
    CreateConsultantServicePreferenceMutationVariables
  >
    mutation={CreateConsultantServicePreferenceDocument}
    {...props}
  />
);

/**
 * __useCreateConsultantServicePreferenceMutation__
 *
 * To run a mutation, you first call `useCreateConsultantServicePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsultantServicePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsultantServicePreferenceMutation, { data, loading, error }] = useCreateConsultantServicePreferenceMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsultantServicePreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsultantServicePreferenceMutation,
    CreateConsultantServicePreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsultantServicePreferenceMutation,
    CreateConsultantServicePreferenceMutationVariables
  >(CreateConsultantServicePreferenceDocument, options);
}
export type CreateConsultantServicePreferenceMutationHookResult = ReturnType<
  typeof useCreateConsultantServicePreferenceMutation
>;
export namespace CreateConsultantServicePreference {
  export type Return = CreateConsultantServicePreferenceMutation;
  export type Variables = CreateConsultantServicePreferenceMutationVariables;
  export const OperationName = "createConsultantServicePreference";

  export const Document = CreateConsultantServicePreferenceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateConsultantServicePreferenceDocument = gql`
  mutation updateConsultantServicePreference(
    $id: ObjectId!
    $input: UpdateConsultantServicePreferenceInput!
  ) {
    updateConsultantServicePreference(id: $id, input: $input) {
      ...ConsultantServicePreference
    }
  }
  ${ConsultantServicePreferenceFragmentDoc}
`;
export type UpdateConsultantServicePreferenceMutationFn = Apollo.MutationFunction<
  UpdateConsultantServicePreferenceMutation,
  UpdateConsultantServicePreferenceMutationVariables
>;
export type UpdateConsultantServicePreferenceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantServicePreferenceMutation,
    UpdateConsultantServicePreferenceMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantServicePreferenceComponent = (
  props: UpdateConsultantServicePreferenceComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantServicePreferenceMutation,
    UpdateConsultantServicePreferenceMutationVariables
  >
    mutation={UpdateConsultantServicePreferenceDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantServicePreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantServicePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantServicePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantServicePreferenceMutation, { data, loading, error }] = useUpdateConsultantServicePreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConsultantServicePreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantServicePreferenceMutation,
    UpdateConsultantServicePreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantServicePreferenceMutation,
    UpdateConsultantServicePreferenceMutationVariables
  >(UpdateConsultantServicePreferenceDocument, options);
}
export type UpdateConsultantServicePreferenceMutationHookResult = ReturnType<
  typeof useUpdateConsultantServicePreferenceMutation
>;
export namespace UpdateConsultantServicePreference {
  export type Return = UpdateConsultantServicePreferenceMutation;
  export type Variables = UpdateConsultantServicePreferenceMutationVariables;
  export const OperationName = "updateConsultantServicePreference";

  export const Document = UpdateConsultantServicePreferenceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ChangeConsultantServicePreferenceStatusDocument = gql`
  mutation changeConsultantServicePreferenceStatus(
    $id: ObjectId!
    $status: ConsultantServicePreferenceStatus!
  ) {
    changeConsultantServicePreferenceStatus(id: $id, status: $status) {
      ...ConsultantServicePreference
    }
  }
  ${ConsultantServicePreferenceFragmentDoc}
`;
export type ChangeConsultantServicePreferenceStatusMutationFn = Apollo.MutationFunction<
  ChangeConsultantServicePreferenceStatusMutation,
  ChangeConsultantServicePreferenceStatusMutationVariables
>;
export type ChangeConsultantServicePreferenceStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ChangeConsultantServicePreferenceStatusMutation,
    ChangeConsultantServicePreferenceStatusMutationVariables
  >,
  "mutation"
>;

export const ChangeConsultantServicePreferenceStatusComponent = (
  props: ChangeConsultantServicePreferenceStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ChangeConsultantServicePreferenceStatusMutation,
    ChangeConsultantServicePreferenceStatusMutationVariables
  >
    mutation={ChangeConsultantServicePreferenceStatusDocument}
    {...props}
  />
);

/**
 * __useChangeConsultantServicePreferenceStatusMutation__
 *
 * To run a mutation, you first call `useChangeConsultantServicePreferenceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeConsultantServicePreferenceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeConsultantServicePreferenceStatusMutation, { data, loading, error }] = useChangeConsultantServicePreferenceStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeConsultantServicePreferenceStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeConsultantServicePreferenceStatusMutation,
    ChangeConsultantServicePreferenceStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeConsultantServicePreferenceStatusMutation,
    ChangeConsultantServicePreferenceStatusMutationVariables
  >(ChangeConsultantServicePreferenceStatusDocument, options);
}
export type ChangeConsultantServicePreferenceStatusMutationHookResult = ReturnType<
  typeof useChangeConsultantServicePreferenceStatusMutation
>;
export namespace ChangeConsultantServicePreferenceStatus {
  export type Return = ChangeConsultantServicePreferenceStatusMutation;
  export type Variables = ChangeConsultantServicePreferenceStatusMutationVariables;
  export const OperationName = "changeConsultantServicePreferenceStatus";

  export const Document = ChangeConsultantServicePreferenceStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteConsultantServicePreferenceDocument = gql`
  mutation deleteConsultantServicePreference($id: ObjectId!) {
    deleteConsultantServicePreference(id: $id)
  }
`;
export type DeleteConsultantServicePreferenceMutationFn = Apollo.MutationFunction<
  DeleteConsultantServicePreferenceMutation,
  DeleteConsultantServicePreferenceMutationVariables
>;
export type DeleteConsultantServicePreferenceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteConsultantServicePreferenceMutation,
    DeleteConsultantServicePreferenceMutationVariables
  >,
  "mutation"
>;

export const DeleteConsultantServicePreferenceComponent = (
  props: DeleteConsultantServicePreferenceComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteConsultantServicePreferenceMutation,
    DeleteConsultantServicePreferenceMutationVariables
  >
    mutation={DeleteConsultantServicePreferenceDocument}
    {...props}
  />
);

/**
 * __useDeleteConsultantServicePreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantServicePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantServicePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantServicePreferenceMutation, { data, loading, error }] = useDeleteConsultantServicePreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsultantServicePreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsultantServicePreferenceMutation,
    DeleteConsultantServicePreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsultantServicePreferenceMutation,
    DeleteConsultantServicePreferenceMutationVariables
  >(DeleteConsultantServicePreferenceDocument, options);
}
export type DeleteConsultantServicePreferenceMutationHookResult = ReturnType<
  typeof useDeleteConsultantServicePreferenceMutation
>;
export namespace DeleteConsultantServicePreference {
  export type Return = DeleteConsultantServicePreferenceMutation;
  export type Variables = DeleteConsultantServicePreferenceMutationVariables;
  export const OperationName = "deleteConsultantServicePreference";

  export const Document = DeleteConsultantServicePreferenceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetSwitchesDataDocument = gql`
  query getSwitchesData($id: ObjectId!) {
    consultantById(id: $id) {
      ...SwitchesCardData
    }
  }
  ${SwitchesCardDataFragmentDoc}
`;
export type GetSwitchesDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSwitchesDataQuery,
    GetSwitchesDataQueryVariables
  >,
  "query"
> &
  ({ variables: GetSwitchesDataQueryVariables; skip?: boolean } | { skip: boolean });

export const GetSwitchesDataComponent = (props: GetSwitchesDataComponentProps) => (
  <ApolloReactComponents.Query<GetSwitchesDataQuery, GetSwitchesDataQueryVariables>
    query={GetSwitchesDataDocument}
    {...props}
  />
);

/**
 * __useGetSwitchesDataQuery__
 *
 * To run a query within a React component, call `useGetSwitchesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchesDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSwitchesDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSwitchesDataQuery,
    GetSwitchesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSwitchesDataQuery, GetSwitchesDataQueryVariables>(
    GetSwitchesDataDocument,
    options
  );
}
export function useGetSwitchesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSwitchesDataQuery,
    GetSwitchesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSwitchesDataQuery, GetSwitchesDataQueryVariables>(
    GetSwitchesDataDocument,
    options
  );
}
export type GetSwitchesDataQueryHookResult = ReturnType<typeof useGetSwitchesDataQuery>;
export type GetSwitchesDataLazyQueryHookResult = ReturnType<
  typeof useGetSwitchesDataLazyQuery
>;
export namespace GetSwitchesData {
  export type Return = GetSwitchesDataQuery;
  export type Variables = GetSwitchesDataQueryVariables;
  export const OperationName = "getSwitchesData";

  export const Document = GetSwitchesDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UpdateWelcomeEmailDocument = gql`
  mutation updateWelcomeEmail($id: ObjectId!, $value: Boolean!) {
    setConsultantWelcomeEmailSent(consultantId: $id, value: $value) {
      ...SwitchesCardData
    }
  }
  ${SwitchesCardDataFragmentDoc}
`;
export type UpdateWelcomeEmailMutationFn = Apollo.MutationFunction<
  UpdateWelcomeEmailMutation,
  UpdateWelcomeEmailMutationVariables
>;
export type UpdateWelcomeEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateWelcomeEmailMutation,
    UpdateWelcomeEmailMutationVariables
  >,
  "mutation"
>;

export const UpdateWelcomeEmailComponent = (props: UpdateWelcomeEmailComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateWelcomeEmailMutation,
    UpdateWelcomeEmailMutationVariables
  >
    mutation={UpdateWelcomeEmailDocument}
    {...props}
  />
);

/**
 * __useUpdateWelcomeEmailMutation__
 *
 * To run a mutation, you first call `useUpdateWelcomeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelcomeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWelcomeEmailMutation, { data, loading, error }] = useUpdateWelcomeEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateWelcomeEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWelcomeEmailMutation,
    UpdateWelcomeEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWelcomeEmailMutation,
    UpdateWelcomeEmailMutationVariables
  >(UpdateWelcomeEmailDocument, options);
}
export type UpdateWelcomeEmailMutationHookResult = ReturnType<
  typeof useUpdateWelcomeEmailMutation
>;
export namespace UpdateWelcomeEmail {
  export type Return = UpdateWelcomeEmailMutation;
  export type Variables = UpdateWelcomeEmailMutationVariables;
  export const OperationName = "updateWelcomeEmail";

  export const Document = UpdateWelcomeEmailDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateUserSettingsDocument = gql`
  mutation updateUserSettings($id: ObjectId!, $input: UserSettingsInput!) {
    updateConsultantUserSettings(id: $id, input: $input) {
      ...SwitchesCardData
    }
  }
  ${SwitchesCardDataFragmentDoc}
`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;
export type UpdateUserSettingsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >,
  "mutation"
>;

export const UpdateUserSettingsComponent = (props: UpdateUserSettingsComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >
    mutation={UpdateUserSettingsDocument}
    {...props}
  />
);

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >(UpdateUserSettingsDocument, options);
}
export type UpdateUserSettingsMutationHookResult = ReturnType<
  typeof useUpdateUserSettingsMutation
>;
export namespace UpdateUserSettings {
  export type Return = UpdateUserSettingsMutation;
  export type Variables = UpdateUserSettingsMutationVariables;
  export const OperationName = "updateUserSettings";

  export const Document = UpdateUserSettingsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SetUnfitFlagDocument = gql`
  mutation setUnfitFlag(
    $consultantId: ObjectId!
    $unfitType: ConsultantUnfitType!
    $comment: String!
  ) {
    setConsultantUnfit(
      consultantId: $consultantId
      unfitType: $unfitType
      comment: $comment
    ) {
      ...SwitchesCardData
    }
  }
  ${SwitchesCardDataFragmentDoc}
`;
export type SetUnfitFlagMutationFn = Apollo.MutationFunction<
  SetUnfitFlagMutation,
  SetUnfitFlagMutationVariables
>;
export type SetUnfitFlagComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetUnfitFlagMutation,
    SetUnfitFlagMutationVariables
  >,
  "mutation"
>;

export const SetUnfitFlagComponent = (props: SetUnfitFlagComponentProps) => (
  <ApolloReactComponents.Mutation<SetUnfitFlagMutation, SetUnfitFlagMutationVariables>
    mutation={SetUnfitFlagDocument}
    {...props}
  />
);

/**
 * __useSetUnfitFlagMutation__
 *
 * To run a mutation, you first call `useSetUnfitFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUnfitFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUnfitFlagMutation, { data, loading, error }] = useSetUnfitFlagMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      unfitType: // value for 'unfitType'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetUnfitFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetUnfitFlagMutation,
    SetUnfitFlagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetUnfitFlagMutation, SetUnfitFlagMutationVariables>(
    SetUnfitFlagDocument,
    options
  );
}
export type SetUnfitFlagMutationHookResult = ReturnType<typeof useSetUnfitFlagMutation>;
export namespace SetUnfitFlag {
  export type Return = SetUnfitFlagMutation;
  export type Variables = SetUnfitFlagMutationVariables;
  export const OperationName = "setUnfitFlag";

  export const Document = SetUnfitFlagDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ResetUnfitFlagDocument = gql`
  mutation resetUnfitFlag($consultantId: ObjectId!) {
    resetConsultantUnfit(consultantId: $consultantId) {
      ...SwitchesCardData
    }
  }
  ${SwitchesCardDataFragmentDoc}
`;
export type ResetUnfitFlagMutationFn = Apollo.MutationFunction<
  ResetUnfitFlagMutation,
  ResetUnfitFlagMutationVariables
>;
export type ResetUnfitFlagComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ResetUnfitFlagMutation,
    ResetUnfitFlagMutationVariables
  >,
  "mutation"
>;

export const ResetUnfitFlagComponent = (props: ResetUnfitFlagComponentProps) => (
  <ApolloReactComponents.Mutation<ResetUnfitFlagMutation, ResetUnfitFlagMutationVariables>
    mutation={ResetUnfitFlagDocument}
    {...props}
  />
);

/**
 * __useResetUnfitFlagMutation__
 *
 * To run a mutation, you first call `useResetUnfitFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUnfitFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUnfitFlagMutation, { data, loading, error }] = useResetUnfitFlagMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useResetUnfitFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetUnfitFlagMutation,
    ResetUnfitFlagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetUnfitFlagMutation, ResetUnfitFlagMutationVariables>(
    ResetUnfitFlagDocument,
    options
  );
}
export type ResetUnfitFlagMutationHookResult = ReturnType<
  typeof useResetUnfitFlagMutation
>;
export namespace ResetUnfitFlag {
  export type Return = ResetUnfitFlagMutation;
  export type Variables = ResetUnfitFlagMutationVariables;
  export const OperationName = "resetUnfitFlag";

  export const Document = ResetUnfitFlagDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetAllUsersDocument = gql`
  query getAllUsers {
    users {
      ...UserData
    }
  }
  ${UserDataFragmentDoc}
`;
export type GetAllUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAllUsersQuery,
    GetAllUsersQueryVariables
  >,
  "query"
>;

export const GetAllUsersComponent = (props: GetAllUsersComponentProps) => (
  <ApolloReactComponents.Query<GetAllUsersQuery, GetAllUsersQueryVariables>
    query={GetAllUsersDocument}
    {...props}
  />
);

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
    GetAllUsersDocument,
    options
  );
}
export function useGetAllUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
    GetAllUsersDocument,
    options
  );
}
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export namespace GetAllUsers {
  export type Return = GetAllUsersQuery;
  export type Variables = GetAllUsersQueryVariables;
  export const OperationName = "getAllUsers";

  export const Document = GetAllUsersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantWorkExperienceDocument = gql`
  query getConsultantWorkExperience($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...WorkExperienceData
    }
  }
  ${WorkExperienceDataFragmentDoc}
`;
export type GetConsultantWorkExperienceComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantWorkExperienceQuery,
    GetConsultantWorkExperienceQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantWorkExperienceQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantWorkExperienceComponent = (
  props: GetConsultantWorkExperienceComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantWorkExperienceQuery,
    GetConsultantWorkExperienceQueryVariables
  >
    query={GetConsultantWorkExperienceDocument}
    {...props}
  />
);

/**
 * __useGetConsultantWorkExperienceQuery__
 *
 * To run a query within a React component, call `useGetConsultantWorkExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantWorkExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantWorkExperienceQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantWorkExperienceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantWorkExperienceQuery,
    GetConsultantWorkExperienceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantWorkExperienceQuery,
    GetConsultantWorkExperienceQueryVariables
  >(GetConsultantWorkExperienceDocument, options);
}
export function useGetConsultantWorkExperienceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantWorkExperienceQuery,
    GetConsultantWorkExperienceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantWorkExperienceQuery,
    GetConsultantWorkExperienceQueryVariables
  >(GetConsultantWorkExperienceDocument, options);
}
export type GetConsultantWorkExperienceQueryHookResult = ReturnType<
  typeof useGetConsultantWorkExperienceQuery
>;
export type GetConsultantWorkExperienceLazyQueryHookResult = ReturnType<
  typeof useGetConsultantWorkExperienceLazyQuery
>;
export namespace GetConsultantWorkExperience {
  export type Return = GetConsultantWorkExperienceQuery;
  export type Variables = GetConsultantWorkExperienceQueryVariables;
  export const OperationName = "getConsultantWorkExperience";

  export const Document = GetConsultantWorkExperienceDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AddConsultantWorkExperienceDocument = gql`
  mutation addConsultantWorkExperience(
    $consultantId: ObjectId!
    $data: ConsultantWorkExperienceItemInput!
  ) {
    addConsultantWorkExperience(consultantId: $consultantId, data: $data) {
      OK
    }
  }
`;
export type AddConsultantWorkExperienceMutationFn = Apollo.MutationFunction<
  AddConsultantWorkExperienceMutation,
  AddConsultantWorkExperienceMutationVariables
>;
export type AddConsultantWorkExperienceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddConsultantWorkExperienceMutation,
    AddConsultantWorkExperienceMutationVariables
  >,
  "mutation"
>;

export const AddConsultantWorkExperienceComponent = (
  props: AddConsultantWorkExperienceComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddConsultantWorkExperienceMutation,
    AddConsultantWorkExperienceMutationVariables
  >
    mutation={AddConsultantWorkExperienceDocument}
    {...props}
  />
);

/**
 * __useAddConsultantWorkExperienceMutation__
 *
 * To run a mutation, you first call `useAddConsultantWorkExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsultantWorkExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsultantWorkExperienceMutation, { data, loading, error }] = useAddConsultantWorkExperienceMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddConsultantWorkExperienceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddConsultantWorkExperienceMutation,
    AddConsultantWorkExperienceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddConsultantWorkExperienceMutation,
    AddConsultantWorkExperienceMutationVariables
  >(AddConsultantWorkExperienceDocument, options);
}
export type AddConsultantWorkExperienceMutationHookResult = ReturnType<
  typeof useAddConsultantWorkExperienceMutation
>;
export namespace AddConsultantWorkExperience {
  export type Return = AddConsultantWorkExperienceMutation;
  export type Variables = AddConsultantWorkExperienceMutationVariables;
  export const OperationName = "addConsultantWorkExperience";

  export const Document = AddConsultantWorkExperienceDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerDepartmentsDocument = gql`
  query getCustomerDepartments($customerIds: [ObjectId]) {
    departments: customers(
      filter: { parentId: $customerIds, type: [Department] }
      limit: 1000
      skip: 0
    ) {
      items {
        ...DepartmentData
      }
      dbTime
    }
  }
  ${DepartmentDataFragmentDoc}
`;
export type GetCustomerDepartmentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerDepartmentsQuery,
    GetCustomerDepartmentsQueryVariables
  >,
  "query"
>;

export const GetCustomerDepartmentsComponent = (
  props: GetCustomerDepartmentsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerDepartmentsQuery,
    GetCustomerDepartmentsQueryVariables
  >
    query={GetCustomerDepartmentsDocument}
    {...props}
  />
);

/**
 * __useGetCustomerDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDepartmentsQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useGetCustomerDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerDepartmentsQuery,
    GetCustomerDepartmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerDepartmentsQuery,
    GetCustomerDepartmentsQueryVariables
  >(GetCustomerDepartmentsDocument, options);
}
export function useGetCustomerDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerDepartmentsQuery,
    GetCustomerDepartmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerDepartmentsQuery,
    GetCustomerDepartmentsQueryVariables
  >(GetCustomerDepartmentsDocument, options);
}
export type GetCustomerDepartmentsQueryHookResult = ReturnType<
  typeof useGetCustomerDepartmentsQuery
>;
export type GetCustomerDepartmentsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerDepartmentsLazyQuery
>;
export namespace GetCustomerDepartments {
  export type Return = GetCustomerDepartmentsQuery;
  export type Variables = GetCustomerDepartmentsQueryVariables;
  export const OperationName = "getCustomerDepartments";

  export const Document = GetCustomerDepartmentsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantPayoutByYearDocument = gql`
  query getConsultantPayoutByYear($id: ObjectId!) {
    getConsultantPayoutByYear(consultantId: $id) {
      ...ConsultantPayoutByYearData
    }
  }
  ${ConsultantPayoutByYearDataFragmentDoc}
`;
export type GetConsultantPayoutByYearComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantPayoutByYearQuery,
    GetConsultantPayoutByYearQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantPayoutByYearQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantPayoutByYearComponent = (
  props: GetConsultantPayoutByYearComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantPayoutByYearQuery,
    GetConsultantPayoutByYearQueryVariables
  >
    query={GetConsultantPayoutByYearDocument}
    {...props}
  />
);

/**
 * __useGetConsultantPayoutByYearQuery__
 *
 * To run a query within a React component, call `useGetConsultantPayoutByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantPayoutByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantPayoutByYearQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantPayoutByYearQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantPayoutByYearQuery,
    GetConsultantPayoutByYearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantPayoutByYearQuery,
    GetConsultantPayoutByYearQueryVariables
  >(GetConsultantPayoutByYearDocument, options);
}
export function useGetConsultantPayoutByYearLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantPayoutByYearQuery,
    GetConsultantPayoutByYearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantPayoutByYearQuery,
    GetConsultantPayoutByYearQueryVariables
  >(GetConsultantPayoutByYearDocument, options);
}
export type GetConsultantPayoutByYearQueryHookResult = ReturnType<
  typeof useGetConsultantPayoutByYearQuery
>;
export type GetConsultantPayoutByYearLazyQueryHookResult = ReturnType<
  typeof useGetConsultantPayoutByYearLazyQuery
>;
export namespace GetConsultantPayoutByYear {
  export type Return = GetConsultantPayoutByYearQuery;
  export type Variables = GetConsultantPayoutByYearQueryVariables;
  export const OperationName = "getConsultantPayoutByYear";

  export const Document = GetConsultantPayoutByYearDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetFortnoxSalaryCacheDocument = gql`
  query getFortnoxSalaryCache($id: ObjectId!) {
    getFortnoxSalaryCache(consultantId: $id) {
      id
      yearSums {
        year
        sum
      }
      lastFetchedAt
    }
  }
`;
export type GetFortnoxSalaryCacheComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetFortnoxSalaryCacheQuery,
    GetFortnoxSalaryCacheQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetFortnoxSalaryCacheQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetFortnoxSalaryCacheComponent = (
  props: GetFortnoxSalaryCacheComponentProps
) => (
  <ApolloReactComponents.Query<
    GetFortnoxSalaryCacheQuery,
    GetFortnoxSalaryCacheQueryVariables
  >
    query={GetFortnoxSalaryCacheDocument}
    {...props}
  />
);

/**
 * __useGetFortnoxSalaryCacheQuery__
 *
 * To run a query within a React component, call `useGetFortnoxSalaryCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFortnoxSalaryCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFortnoxSalaryCacheQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFortnoxSalaryCacheQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFortnoxSalaryCacheQuery,
    GetFortnoxSalaryCacheQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFortnoxSalaryCacheQuery, GetFortnoxSalaryCacheQueryVariables>(
    GetFortnoxSalaryCacheDocument,
    options
  );
}
export function useGetFortnoxSalaryCacheLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFortnoxSalaryCacheQuery,
    GetFortnoxSalaryCacheQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFortnoxSalaryCacheQuery,
    GetFortnoxSalaryCacheQueryVariables
  >(GetFortnoxSalaryCacheDocument, options);
}
export type GetFortnoxSalaryCacheQueryHookResult = ReturnType<
  typeof useGetFortnoxSalaryCacheQuery
>;
export type GetFortnoxSalaryCacheLazyQueryHookResult = ReturnType<
  typeof useGetFortnoxSalaryCacheLazyQuery
>;
export namespace GetFortnoxSalaryCache {
  export type Return = GetFortnoxSalaryCacheQuery;
  export type Variables = GetFortnoxSalaryCacheQueryVariables;
  export const OperationName = "getFortnoxSalaryCache";

  export const Document = GetFortnoxSalaryCacheDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const RefreshFortnoxSalaryCacheDocument = gql`
  mutation refreshFortnoxSalaryCache($id: ObjectId!) {
    refreshFortnoxSalaryCache(consultantId: $id) {
      id
      yearSums {
        year
        sum
      }
      lastFetchedAt
    }
  }
`;
export type RefreshFortnoxSalaryCacheMutationFn = Apollo.MutationFunction<
  RefreshFortnoxSalaryCacheMutation,
  RefreshFortnoxSalaryCacheMutationVariables
>;
export type RefreshFortnoxSalaryCacheComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RefreshFortnoxSalaryCacheMutation,
    RefreshFortnoxSalaryCacheMutationVariables
  >,
  "mutation"
>;

export const RefreshFortnoxSalaryCacheComponent = (
  props: RefreshFortnoxSalaryCacheComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RefreshFortnoxSalaryCacheMutation,
    RefreshFortnoxSalaryCacheMutationVariables
  >
    mutation={RefreshFortnoxSalaryCacheDocument}
    {...props}
  />
);

/**
 * __useRefreshFortnoxSalaryCacheMutation__
 *
 * To run a mutation, you first call `useRefreshFortnoxSalaryCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshFortnoxSalaryCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshFortnoxSalaryCacheMutation, { data, loading, error }] = useRefreshFortnoxSalaryCacheMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshFortnoxSalaryCacheMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshFortnoxSalaryCacheMutation,
    RefreshFortnoxSalaryCacheMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshFortnoxSalaryCacheMutation,
    RefreshFortnoxSalaryCacheMutationVariables
  >(RefreshFortnoxSalaryCacheDocument, options);
}
export type RefreshFortnoxSalaryCacheMutationHookResult = ReturnType<
  typeof useRefreshFortnoxSalaryCacheMutation
>;
export namespace RefreshFortnoxSalaryCache {
  export type Return = RefreshFortnoxSalaryCacheMutation;
  export type Variables = RefreshFortnoxSalaryCacheMutationVariables;
  export const OperationName = "refreshFortnoxSalaryCache";

  export const Document = RefreshFortnoxSalaryCacheDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantWorkStatusesDocument = gql`
  query getConsultantWorkStatuses($consultantId: ObjectId!) {
    consultantWorkStatuses(consultantId: $consultantId) {
      ...ConsultantWorkStatusFragment
    }
  }
  ${ConsultantWorkStatusFragmentFragmentDoc}
`;
export type GetConsultantWorkStatusesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantWorkStatusesQuery,
    GetConsultantWorkStatusesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantWorkStatusesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantWorkStatusesComponent = (
  props: GetConsultantWorkStatusesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantWorkStatusesQuery,
    GetConsultantWorkStatusesQueryVariables
  >
    query={GetConsultantWorkStatusesDocument}
    {...props}
  />
);

/**
 * __useGetConsultantWorkStatusesQuery__
 *
 * To run a query within a React component, call `useGetConsultantWorkStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantWorkStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantWorkStatusesQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantWorkStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantWorkStatusesQuery,
    GetConsultantWorkStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantWorkStatusesQuery,
    GetConsultantWorkStatusesQueryVariables
  >(GetConsultantWorkStatusesDocument, options);
}
export function useGetConsultantWorkStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantWorkStatusesQuery,
    GetConsultantWorkStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantWorkStatusesQuery,
    GetConsultantWorkStatusesQueryVariables
  >(GetConsultantWorkStatusesDocument, options);
}
export type GetConsultantWorkStatusesQueryHookResult = ReturnType<
  typeof useGetConsultantWorkStatusesQuery
>;
export type GetConsultantWorkStatusesLazyQueryHookResult = ReturnType<
  typeof useGetConsultantWorkStatusesLazyQuery
>;
export namespace GetConsultantWorkStatuses {
  export type Return = GetConsultantWorkStatusesQuery;
  export type Variables = GetConsultantWorkStatusesQueryVariables;
  export const OperationName = "getConsultantWorkStatuses";

  export const Document = GetConsultantWorkStatusesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateConsultantWorkStatusDocument = gql`
  mutation createConsultantWorkStatus(
    $consultantId: ObjectId!
    $input: CreateConsultantWorkStatusInput!
  ) {
    createConsultantWorkStatus(consultantId: $consultantId, input: $input) {
      ...ConsultantWorkStatusFragment
    }
  }
  ${ConsultantWorkStatusFragmentFragmentDoc}
`;
export type CreateConsultantWorkStatusMutationFn = Apollo.MutationFunction<
  CreateConsultantWorkStatusMutation,
  CreateConsultantWorkStatusMutationVariables
>;
export type CreateConsultantWorkStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateConsultantWorkStatusMutation,
    CreateConsultantWorkStatusMutationVariables
  >,
  "mutation"
>;

export const CreateConsultantWorkStatusComponent = (
  props: CreateConsultantWorkStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CreateConsultantWorkStatusMutation,
    CreateConsultantWorkStatusMutationVariables
  >
    mutation={CreateConsultantWorkStatusDocument}
    {...props}
  />
);

/**
 * __useCreateConsultantWorkStatusMutation__
 *
 * To run a mutation, you first call `useCreateConsultantWorkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsultantWorkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsultantWorkStatusMutation, { data, loading, error }] = useCreateConsultantWorkStatusMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsultantWorkStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsultantWorkStatusMutation,
    CreateConsultantWorkStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsultantWorkStatusMutation,
    CreateConsultantWorkStatusMutationVariables
  >(CreateConsultantWorkStatusDocument, options);
}
export type CreateConsultantWorkStatusMutationHookResult = ReturnType<
  typeof useCreateConsultantWorkStatusMutation
>;
export namespace CreateConsultantWorkStatus {
  export type Return = CreateConsultantWorkStatusMutation;
  export type Variables = CreateConsultantWorkStatusMutationVariables;
  export const OperationName = "createConsultantWorkStatus";

  export const Document = CreateConsultantWorkStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateConsultantWorkStatusDocument = gql`
  mutation updateConsultantWorkStatus(
    $id: ObjectId!
    $input: UpdateConsultantWorkStatusInput!
  ) {
    updateConsultantWorkStatus(id: $id, input: $input) {
      ...ConsultantWorkStatusFragment
    }
  }
  ${ConsultantWorkStatusFragmentFragmentDoc}
`;
export type UpdateConsultantWorkStatusMutationFn = Apollo.MutationFunction<
  UpdateConsultantWorkStatusMutation,
  UpdateConsultantWorkStatusMutationVariables
>;
export type UpdateConsultantWorkStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantWorkStatusMutation,
    UpdateConsultantWorkStatusMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantWorkStatusComponent = (
  props: UpdateConsultantWorkStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantWorkStatusMutation,
    UpdateConsultantWorkStatusMutationVariables
  >
    mutation={UpdateConsultantWorkStatusDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantWorkStatusMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantWorkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantWorkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantWorkStatusMutation, { data, loading, error }] = useUpdateConsultantWorkStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConsultantWorkStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantWorkStatusMutation,
    UpdateConsultantWorkStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantWorkStatusMutation,
    UpdateConsultantWorkStatusMutationVariables
  >(UpdateConsultantWorkStatusDocument, options);
}
export type UpdateConsultantWorkStatusMutationHookResult = ReturnType<
  typeof useUpdateConsultantWorkStatusMutation
>;
export namespace UpdateConsultantWorkStatus {
  export type Return = UpdateConsultantWorkStatusMutation;
  export type Variables = UpdateConsultantWorkStatusMutationVariables;
  export const OperationName = "updateConsultantWorkStatus";

  export const Document = UpdateConsultantWorkStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteConsultantWorkStatusDocument = gql`
  mutation deleteConsultantWorkStatus($id: ObjectId!) {
    deleteConsultantWorkStatus(id: $id)
  }
`;
export type DeleteConsultantWorkStatusMutationFn = Apollo.MutationFunction<
  DeleteConsultantWorkStatusMutation,
  DeleteConsultantWorkStatusMutationVariables
>;
export type DeleteConsultantWorkStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteConsultantWorkStatusMutation,
    DeleteConsultantWorkStatusMutationVariables
  >,
  "mutation"
>;

export const DeleteConsultantWorkStatusComponent = (
  props: DeleteConsultantWorkStatusComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteConsultantWorkStatusMutation,
    DeleteConsultantWorkStatusMutationVariables
  >
    mutation={DeleteConsultantWorkStatusDocument}
    {...props}
  />
);

/**
 * __useDeleteConsultantWorkStatusMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantWorkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantWorkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantWorkStatusMutation, { data, loading, error }] = useDeleteConsultantWorkStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsultantWorkStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsultantWorkStatusMutation,
    DeleteConsultantWorkStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsultantWorkStatusMutation,
    DeleteConsultantWorkStatusMutationVariables
  >(DeleteConsultantWorkStatusDocument, options);
}
export type DeleteConsultantWorkStatusMutationHookResult = ReturnType<
  typeof useDeleteConsultantWorkStatusMutation
>;
export namespace DeleteConsultantWorkStatus {
  export type Return = DeleteConsultantWorkStatusMutation;
  export type Variables = DeleteConsultantWorkStatusMutationVariables;
  export const OperationName = "deleteConsultantWorkStatus";

  export const Document = DeleteConsultantWorkStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetConsultantReferenceStatusModalDataDocument = gql`
  query getConsultantReferenceStatusModalData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantReferenceStatusModalData
    }
  }
  ${ConsultantReferenceStatusModalDataFragmentDoc}
`;
export type GetConsultantReferenceStatusModalDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantReferenceStatusModalDataQuery,
    GetConsultantReferenceStatusModalDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultantReferenceStatusModalDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultantReferenceStatusModalDataComponent = (
  props: GetConsultantReferenceStatusModalDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultantReferenceStatusModalDataQuery,
    GetConsultantReferenceStatusModalDataQueryVariables
  >
    query={GetConsultantReferenceStatusModalDataDocument}
    {...props}
  />
);

/**
 * __useGetConsultantReferenceStatusModalDataQuery__
 *
 * To run a query within a React component, call `useGetConsultantReferenceStatusModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantReferenceStatusModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantReferenceStatusModalDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetConsultantReferenceStatusModalDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultantReferenceStatusModalDataQuery,
    GetConsultantReferenceStatusModalDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultantReferenceStatusModalDataQuery,
    GetConsultantReferenceStatusModalDataQueryVariables
  >(GetConsultantReferenceStatusModalDataDocument, options);
}
export function useGetConsultantReferenceStatusModalDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantReferenceStatusModalDataQuery,
    GetConsultantReferenceStatusModalDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultantReferenceStatusModalDataQuery,
    GetConsultantReferenceStatusModalDataQueryVariables
  >(GetConsultantReferenceStatusModalDataDocument, options);
}
export type GetConsultantReferenceStatusModalDataQueryHookResult = ReturnType<
  typeof useGetConsultantReferenceStatusModalDataQuery
>;
export type GetConsultantReferenceStatusModalDataLazyQueryHookResult = ReturnType<
  typeof useGetConsultantReferenceStatusModalDataLazyQuery
>;
export namespace GetConsultantReferenceStatusModalData {
  export type Return = GetConsultantReferenceStatusModalDataQuery;
  export type Variables = GetConsultantReferenceStatusModalDataQueryVariables;
  export const OperationName = "getConsultantReferenceStatusModalData";

  export const Document = GetConsultantReferenceStatusModalDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UpdateConsultantQualityNoteDocument = gql`
  mutation updateConsultantQualityNote($consultantId: ObjectId!, $note: String) {
    updateConsultantQualityNote(consultantId: $consultantId, note: $note)
  }
`;
export type UpdateConsultantQualityNoteMutationFn = Apollo.MutationFunction<
  UpdateConsultantQualityNoteMutation,
  UpdateConsultantQualityNoteMutationVariables
>;
export type UpdateConsultantQualityNoteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateConsultantQualityNoteMutation,
    UpdateConsultantQualityNoteMutationVariables
  >,
  "mutation"
>;

export const UpdateConsultantQualityNoteComponent = (
  props: UpdateConsultantQualityNoteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateConsultantQualityNoteMutation,
    UpdateConsultantQualityNoteMutationVariables
  >
    mutation={UpdateConsultantQualityNoteDocument}
    {...props}
  />
);

/**
 * __useUpdateConsultantQualityNoteMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantQualityNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantQualityNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantQualityNoteMutation, { data, loading, error }] = useUpdateConsultantQualityNoteMutation({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateConsultantQualityNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsultantQualityNoteMutation,
    UpdateConsultantQualityNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsultantQualityNoteMutation,
    UpdateConsultantQualityNoteMutationVariables
  >(UpdateConsultantQualityNoteDocument, options);
}
export type UpdateConsultantQualityNoteMutationHookResult = ReturnType<
  typeof useUpdateConsultantQualityNoteMutation
>;
export namespace UpdateConsultantQualityNote {
  export type Return = UpdateConsultantQualityNoteMutation;
  export type Variables = UpdateConsultantQualityNoteMutationVariables;
  export const OperationName = "updateConsultantQualityNote";

  export const Document = UpdateConsultantQualityNoteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetNpConsultantReferenceStatusModalDataDocument = gql`
  query getNpConsultantReferenceStatusModalData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...NpConsultantReferenceStatusModalData
    }
  }
  ${NpConsultantReferenceStatusModalDataFragmentDoc}
`;
export type GetNpConsultantReferenceStatusModalDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetNpConsultantReferenceStatusModalDataQuery,
    GetNpConsultantReferenceStatusModalDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetNpConsultantReferenceStatusModalDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetNpConsultantReferenceStatusModalDataComponent = (
  props: GetNpConsultantReferenceStatusModalDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetNpConsultantReferenceStatusModalDataQuery,
    GetNpConsultantReferenceStatusModalDataQueryVariables
  >
    query={GetNpConsultantReferenceStatusModalDataDocument}
    {...props}
  />
);

/**
 * __useGetNpConsultantReferenceStatusModalDataQuery__
 *
 * To run a query within a React component, call `useGetNpConsultantReferenceStatusModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNpConsultantReferenceStatusModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNpConsultantReferenceStatusModalDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetNpConsultantReferenceStatusModalDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNpConsultantReferenceStatusModalDataQuery,
    GetNpConsultantReferenceStatusModalDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNpConsultantReferenceStatusModalDataQuery,
    GetNpConsultantReferenceStatusModalDataQueryVariables
  >(GetNpConsultantReferenceStatusModalDataDocument, options);
}
export function useGetNpConsultantReferenceStatusModalDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNpConsultantReferenceStatusModalDataQuery,
    GetNpConsultantReferenceStatusModalDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNpConsultantReferenceStatusModalDataQuery,
    GetNpConsultantReferenceStatusModalDataQueryVariables
  >(GetNpConsultantReferenceStatusModalDataDocument, options);
}
export type GetNpConsultantReferenceStatusModalDataQueryHookResult = ReturnType<
  typeof useGetNpConsultantReferenceStatusModalDataQuery
>;
export type GetNpConsultantReferenceStatusModalDataLazyQueryHookResult = ReturnType<
  typeof useGetNpConsultantReferenceStatusModalDataLazyQuery
>;
export namespace GetNpConsultantReferenceStatusModalData {
  export type Return = GetNpConsultantReferenceStatusModalDataQuery;
  export type Variables = GetNpConsultantReferenceStatusModalDataQueryVariables;
  export const OperationName = "getNpConsultantReferenceStatusModalData";

  export const Document = GetNpConsultantReferenceStatusModalDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetSaHlrDataDocument = gql`
  query getSaHlrData($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      _id
      qualityChecks {
        country
        itemName
        status
        setDate
        expirationDate
      }
    }
  }
`;
export type GetSaHlrDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSaHlrDataQuery,
    GetSaHlrDataQueryVariables
  >,
  "query"
> &
  ({ variables: GetSaHlrDataQueryVariables; skip?: boolean } | { skip: boolean });

export const GetSaHlrDataComponent = (props: GetSaHlrDataComponentProps) => (
  <ApolloReactComponents.Query<GetSaHlrDataQuery, GetSaHlrDataQueryVariables>
    query={GetSaHlrDataDocument}
    {...props}
  />
);

/**
 * __useGetSaHlrDataQuery__
 *
 * To run a query within a React component, call `useGetSaHlrDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaHlrDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaHlrDataQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetSaHlrDataQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSaHlrDataQuery, GetSaHlrDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSaHlrDataQuery, GetSaHlrDataQueryVariables>(
    GetSaHlrDataDocument,
    options
  );
}
export function useGetSaHlrDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSaHlrDataQuery, GetSaHlrDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSaHlrDataQuery, GetSaHlrDataQueryVariables>(
    GetSaHlrDataDocument,
    options
  );
}
export type GetSaHlrDataQueryHookResult = ReturnType<typeof useGetSaHlrDataQuery>;
export type GetSaHlrDataLazyQueryHookResult = ReturnType<typeof useGetSaHlrDataLazyQuery>;
export namespace GetSaHlrData {
  export type Return = GetSaHlrDataQuery;
  export type Variables = GetSaHlrDataQueryVariables;
  export const OperationName = "getSaHlrData";

  export const Document = GetSaHlrDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultantsDocument = gql`
  query getConsultants(
    $filter: ConsultantsQueryInput
    $skip: Int!
    $limit: Int!
    $sortBy: ConsultantTableColumns
    $sortOrder: SortOrder
    $withEvents: Boolean!
    $withCallListStats: Boolean!
    $filterText: String!
  ) {
    consultants(
      filter: $filter
      includeEvents: $withEvents
      limit: $limit
      skip: $skip
      sortBy: $sortBy
      sortOrder: $sortOrder
      withSecondarySearch: true
    ) {
      items {
        ...ConsultantSearchCardData
        callListStats @include(if: $withCallListStats)
        Events(text: $filterText) @include(if: $withEvents) {
          ...ConsultantSearchNewEventData
        }
      }
      secondarySearch {
        ...ConsultantSearchCardData
        callListStats @include(if: $withCallListStats)
        Events(text: $filterText) @include(if: $withEvents) {
          ...ConsultantSearchNewEventData
        }
      }
      skip
      limit
    }
  }
  ${ConsultantSearchCardDataFragmentDoc}
  ${ConsultantSearchNewEventDataFragmentDoc}
`;
export type GetConsultantsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultantsQuery,
    GetConsultantsQueryVariables
  >,
  "query"
> &
  ({ variables: GetConsultantsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetConsultantsComponent = (props: GetConsultantsComponentProps) => (
  <ApolloReactComponents.Query<GetConsultantsQuery, GetConsultantsQueryVariables>
    query={GetConsultantsDocument}
    {...props}
  />
);

/**
 * __useGetConsultantsQuery__
 *
 * To run a query within a React component, call `useGetConsultantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      withEvents: // value for 'withEvents'
 *      withCallListStats: // value for 'withCallListStats'
 *      filterText: // value for 'filterText'
 *   },
 * });
 */
export function useGetConsultantsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetConsultantsQuery, GetConsultantsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConsultantsQuery, GetConsultantsQueryVariables>(
    GetConsultantsDocument,
    options
  );
}
export function useGetConsultantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultantsQuery,
    GetConsultantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConsultantsQuery, GetConsultantsQueryVariables>(
    GetConsultantsDocument,
    options
  );
}
export type GetConsultantsQueryHookResult = ReturnType<typeof useGetConsultantsQuery>;
export type GetConsultantsLazyQueryHookResult = ReturnType<
  typeof useGetConsultantsLazyQuery
>;
export namespace GetConsultants {
  export type Return = GetConsultantsQuery;
  export type Variables = GetConsultantsQueryVariables;
  export const OperationName = "getConsultants";

  export const Document = GetConsultantsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantImport_ImportConsultantsDocument = gql`
  mutation ConsultantImport_ImportConsultants(
    $file: Upload!
    $checkForDuplicates: Boolean
    $bisnodeLookup: Boolean
  ) {
    importConsultants(
      file: $file
      checkForDuplicates: $checkForDuplicates
      bisnodeLookup: $bisnodeLookup
    ) {
      Rows {
        ...ConsultantImport_Row
      }
    }
  }
  ${ConsultantImport_RowFragmentDoc}
`;
export type ConsultantImport_ImportConsultantsMutationFn = Apollo.MutationFunction<
  ConsultantImport_ImportConsultantsMutation,
  ConsultantImport_ImportConsultantsMutationVariables
>;
export type ConsultantImport_ImportConsultantsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantImport_ImportConsultantsMutation,
    ConsultantImport_ImportConsultantsMutationVariables
  >,
  "mutation"
>;

export const ConsultantImport_ImportConsultantsComponent = (
  props: ConsultantImport_ImportConsultantsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantImport_ImportConsultantsMutation,
    ConsultantImport_ImportConsultantsMutationVariables
  >
    mutation={ConsultantImport_ImportConsultantsDocument}
    {...props}
  />
);

/**
 * __useConsultantImport_ImportConsultantsMutation__
 *
 * To run a mutation, you first call `useConsultantImport_ImportConsultantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantImport_ImportConsultantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantImportImportConsultantsMutation, { data, loading, error }] = useConsultantImport_ImportConsultantsMutation({
 *   variables: {
 *      file: // value for 'file'
 *      checkForDuplicates: // value for 'checkForDuplicates'
 *      bisnodeLookup: // value for 'bisnodeLookup'
 *   },
 * });
 */
export function useConsultantImport_ImportConsultantsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantImport_ImportConsultantsMutation,
    ConsultantImport_ImportConsultantsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantImport_ImportConsultantsMutation,
    ConsultantImport_ImportConsultantsMutationVariables
  >(ConsultantImport_ImportConsultantsDocument, options);
}
export type ConsultantImport_ImportConsultantsMutationHookResult = ReturnType<
  typeof useConsultantImport_ImportConsultantsMutation
>;
export namespace ConsultantImport_ImportConsultants {
  export type Return = ConsultantImport_ImportConsultantsMutation;
  export type Variables = ConsultantImport_ImportConsultantsMutationVariables;
  export const OperationName = "ConsultantImport_ImportConsultants";

  export const Document = ConsultantImport_ImportConsultantsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantImport_SaveConsultantSelectionDocument = gql`
  mutation ConsultantImport_SaveConsultantSelection(
    $rows: [ConsultantImportRowsInput]!
    $bisnodeLookup: Boolean
  ) {
    saveConsultantSelection(rows: $rows, bisnodeLookup: $bisnodeLookup) {
      ...ConsultantImport_Result
    }
  }
  ${ConsultantImport_ResultFragmentDoc}
`;
export type ConsultantImport_SaveConsultantSelectionMutationFn = Apollo.MutationFunction<
  ConsultantImport_SaveConsultantSelectionMutation,
  ConsultantImport_SaveConsultantSelectionMutationVariables
>;
export type ConsultantImport_SaveConsultantSelectionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantImport_SaveConsultantSelectionMutation,
    ConsultantImport_SaveConsultantSelectionMutationVariables
  >,
  "mutation"
>;

export const ConsultantImport_SaveConsultantSelectionComponent = (
  props: ConsultantImport_SaveConsultantSelectionComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantImport_SaveConsultantSelectionMutation,
    ConsultantImport_SaveConsultantSelectionMutationVariables
  >
    mutation={ConsultantImport_SaveConsultantSelectionDocument}
    {...props}
  />
);

/**
 * __useConsultantImport_SaveConsultantSelectionMutation__
 *
 * To run a mutation, you first call `useConsultantImport_SaveConsultantSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantImport_SaveConsultantSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantImportSaveConsultantSelectionMutation, { data, loading, error }] = useConsultantImport_SaveConsultantSelectionMutation({
 *   variables: {
 *      rows: // value for 'rows'
 *      bisnodeLookup: // value for 'bisnodeLookup'
 *   },
 * });
 */
export function useConsultantImport_SaveConsultantSelectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantImport_SaveConsultantSelectionMutation,
    ConsultantImport_SaveConsultantSelectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantImport_SaveConsultantSelectionMutation,
    ConsultantImport_SaveConsultantSelectionMutationVariables
  >(ConsultantImport_SaveConsultantSelectionDocument, options);
}
export type ConsultantImport_SaveConsultantSelectionMutationHookResult = ReturnType<
  typeof useConsultantImport_SaveConsultantSelectionMutation
>;
export namespace ConsultantImport_SaveConsultantSelection {
  export type Return = ConsultantImport_SaveConsultantSelectionMutation;
  export type Variables = ConsultantImport_SaveConsultantSelectionMutationVariables;
  export const OperationName = "ConsultantImport_SaveConsultantSelection";

  export const Document = ConsultantImport_SaveConsultantSelectionDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantImport_DedupeDocument = gql`
  mutation ConsultantImport_Dedupe($rows: [ConsultantImportRowsInput!]!) {
    consultantImportDeduplicate(rows: $rows) {
      ...ConsultantImport_Row
    }
  }
  ${ConsultantImport_RowFragmentDoc}
`;
export type ConsultantImport_DedupeMutationFn = Apollo.MutationFunction<
  ConsultantImport_DedupeMutation,
  ConsultantImport_DedupeMutationVariables
>;
export type ConsultantImport_DedupeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantImport_DedupeMutation,
    ConsultantImport_DedupeMutationVariables
  >,
  "mutation"
>;

export const ConsultantImport_DedupeComponent = (
  props: ConsultantImport_DedupeComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantImport_DedupeMutation,
    ConsultantImport_DedupeMutationVariables
  >
    mutation={ConsultantImport_DedupeDocument}
    {...props}
  />
);

/**
 * __useConsultantImport_DedupeMutation__
 *
 * To run a mutation, you first call `useConsultantImport_DedupeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantImport_DedupeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantImportDedupeMutation, { data, loading, error }] = useConsultantImport_DedupeMutation({
 *   variables: {
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useConsultantImport_DedupeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantImport_DedupeMutation,
    ConsultantImport_DedupeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantImport_DedupeMutation,
    ConsultantImport_DedupeMutationVariables
  >(ConsultantImport_DedupeDocument, options);
}
export type ConsultantImport_DedupeMutationHookResult = ReturnType<
  typeof useConsultantImport_DedupeMutation
>;
export namespace ConsultantImport_Dedupe {
  export type Return = ConsultantImport_DedupeMutation;
  export type Variables = ConsultantImport_DedupeMutationVariables;
  export const OperationName = "ConsultantImport_Dedupe";

  export const Document = ConsultantImport_DedupeDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantImport_LookupDocument = gql`
  mutation ConsultantImport_Lookup($rows: [ConsultantImportRowsInput!]!) {
    consultantImportLookupRows(rows: $rows) {
      ...ConsultantImport_Row
    }
  }
  ${ConsultantImport_RowFragmentDoc}
`;
export type ConsultantImport_LookupMutationFn = Apollo.MutationFunction<
  ConsultantImport_LookupMutation,
  ConsultantImport_LookupMutationVariables
>;
export type ConsultantImport_LookupComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ConsultantImport_LookupMutation,
    ConsultantImport_LookupMutationVariables
  >,
  "mutation"
>;

export const ConsultantImport_LookupComponent = (
  props: ConsultantImport_LookupComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ConsultantImport_LookupMutation,
    ConsultantImport_LookupMutationVariables
  >
    mutation={ConsultantImport_LookupDocument}
    {...props}
  />
);

/**
 * __useConsultantImport_LookupMutation__
 *
 * To run a mutation, you first call `useConsultantImport_LookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsultantImport_LookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consultantImportLookupMutation, { data, loading, error }] = useConsultantImport_LookupMutation({
 *   variables: {
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useConsultantImport_LookupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsultantImport_LookupMutation,
    ConsultantImport_LookupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsultantImport_LookupMutation,
    ConsultantImport_LookupMutationVariables
  >(ConsultantImport_LookupDocument, options);
}
export type ConsultantImport_LookupMutationHookResult = ReturnType<
  typeof useConsultantImport_LookupMutation
>;
export namespace ConsultantImport_Lookup {
  export type Return = ConsultantImport_LookupMutation;
  export type Variables = ConsultantImport_LookupMutationVariables;
  export const OperationName = "ConsultantImport_Lookup";

  export const Document = ConsultantImport_LookupDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MyApiTokensDocument = gql`
  query MyApiTokens {
    myApiTokens {
      id
      name
      createdOn
      lastUsedOn
      revoked
    }
  }
`;
export type MyApiTokensComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    MyApiTokensQuery,
    MyApiTokensQueryVariables
  >,
  "query"
>;

export const MyApiTokensComponent = (props: MyApiTokensComponentProps) => (
  <ApolloReactComponents.Query<MyApiTokensQuery, MyApiTokensQueryVariables>
    query={MyApiTokensDocument}
    {...props}
  />
);

/**
 * __useMyApiTokensQuery__
 *
 * To run a query within a React component, call `useMyApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyApiTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyApiTokensQuery(
  baseOptions?: Apollo.QueryHookOptions<MyApiTokensQuery, MyApiTokensQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyApiTokensQuery, MyApiTokensQueryVariables>(
    MyApiTokensDocument,
    options
  );
}
export function useMyApiTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyApiTokensQuery, MyApiTokensQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyApiTokensQuery, MyApiTokensQueryVariables>(
    MyApiTokensDocument,
    options
  );
}
export type MyApiTokensQueryHookResult = ReturnType<typeof useMyApiTokensQuery>;
export type MyApiTokensLazyQueryHookResult = ReturnType<typeof useMyApiTokensLazyQuery>;
export namespace MyApiTokens {
  export type Return = MyApiTokensQuery;
  export type Variables = MyApiTokensQueryVariables;
  export const OperationName = "MyApiTokens";

  export const Document = MyApiTokensDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CreateApiTokenDocument = gql`
  mutation CreateApiToken($name: String!) {
    createApiToken(name: $name) {
      token
      apiToken {
        id
        name
        createdOn
        lastUsedOn
        revoked
      }
    }
  }
`;
export type CreateApiTokenMutationFn = Apollo.MutationFunction<
  CreateApiTokenMutation,
  CreateApiTokenMutationVariables
>;
export type CreateApiTokenComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateApiTokenMutation,
    CreateApiTokenMutationVariables
  >,
  "mutation"
>;

export const CreateApiTokenComponent = (props: CreateApiTokenComponentProps) => (
  <ApolloReactComponents.Mutation<CreateApiTokenMutation, CreateApiTokenMutationVariables>
    mutation={CreateApiTokenDocument}
    {...props}
  />
);

/**
 * __useCreateApiTokenMutation__
 *
 * To run a mutation, you first call `useCreateApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiTokenMutation, { data, loading, error }] = useCreateApiTokenMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApiTokenMutation,
    CreateApiTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateApiTokenMutation, CreateApiTokenMutationVariables>(
    CreateApiTokenDocument,
    options
  );
}
export type CreateApiTokenMutationHookResult = ReturnType<
  typeof useCreateApiTokenMutation
>;
export namespace CreateApiToken {
  export type Return = CreateApiTokenMutation;
  export type Variables = CreateApiTokenMutationVariables;
  export const OperationName = "CreateApiToken";

  export const Document = CreateApiTokenDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RevokeApiTokenDocument = gql`
  mutation RevokeApiToken($id: ID!) {
    revokeApiToken(id: $id) {
      id
      name
      createdOn
      lastUsedOn
      revoked
    }
  }
`;
export type RevokeApiTokenMutationFn = Apollo.MutationFunction<
  RevokeApiTokenMutation,
  RevokeApiTokenMutationVariables
>;
export type RevokeApiTokenComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RevokeApiTokenMutation,
    RevokeApiTokenMutationVariables
  >,
  "mutation"
>;

export const RevokeApiTokenComponent = (props: RevokeApiTokenComponentProps) => (
  <ApolloReactComponents.Mutation<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>
    mutation={RevokeApiTokenDocument}
    {...props}
  />
);

/**
 * __useRevokeApiTokenMutation__
 *
 * To run a mutation, you first call `useRevokeApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiTokenMutation, { data, loading, error }] = useRevokeApiTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeApiTokenMutation,
    RevokeApiTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>(
    RevokeApiTokenDocument,
    options
  );
}
export type RevokeApiTokenMutationHookResult = ReturnType<
  typeof useRevokeApiTokenMutation
>;
export namespace RevokeApiToken {
  export type Return = RevokeApiTokenMutation;
  export type Variables = RevokeApiTokenMutationVariables;
  export const OperationName = "RevokeApiToken";

  export const Document = RevokeApiTokenDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BisnodeLookup_SSNDocument = gql`
  query BisnodeLookup_SSN($country: String!, $ssn: String!) {
    lookup: bisnodeLookupBySSN(country: $country, ssn: $ssn) {
      ...BisnodePerson
    }
  }
  ${BisnodePersonFragmentDoc}
`;
export type BisnodeLookup_SSNComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BisnodeLookup_SSNQuery,
    BisnodeLookup_SSNQueryVariables
  >,
  "query"
> &
  ({ variables: BisnodeLookup_SSNQueryVariables; skip?: boolean } | { skip: boolean });

export const BisnodeLookup_SSNComponent = (props: BisnodeLookup_SSNComponentProps) => (
  <ApolloReactComponents.Query<BisnodeLookup_SSNQuery, BisnodeLookup_SSNQueryVariables>
    query={BisnodeLookup_SSNDocument}
    {...props}
  />
);

/**
 * __useBisnodeLookup_SSNQuery__
 *
 * To run a query within a React component, call `useBisnodeLookup_SSNQuery` and pass it any options that fit your needs.
 * When your component renders, `useBisnodeLookup_SSNQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBisnodeLookup_SSNQuery({
 *   variables: {
 *      country: // value for 'country'
 *      ssn: // value for 'ssn'
 *   },
 * });
 */
export function useBisnodeLookup_SSNQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BisnodeLookup_SSNQuery,
    BisnodeLookup_SSNQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BisnodeLookup_SSNQuery, BisnodeLookup_SSNQueryVariables>(
    BisnodeLookup_SSNDocument,
    options
  );
}
export function useBisnodeLookup_SSNLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BisnodeLookup_SSNQuery,
    BisnodeLookup_SSNQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BisnodeLookup_SSNQuery, BisnodeLookup_SSNQueryVariables>(
    BisnodeLookup_SSNDocument,
    options
  );
}
export type BisnodeLookup_SSNQueryHookResult = ReturnType<
  typeof useBisnodeLookup_SSNQuery
>;
export type BisnodeLookup_SSNLazyQueryHookResult = ReturnType<
  typeof useBisnodeLookup_SSNLazyQuery
>;
export namespace BisnodeLookup_SSN {
  export type Return = BisnodeLookup_SSNQuery;
  export type Variables = BisnodeLookup_SSNQueryVariables;
  export const OperationName = "BisnodeLookup_SSN";

  export const Document = BisnodeLookup_SSNDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BisnodeLookup_PhoneDocument = gql`
  query BisnodeLookup_Phone($country: String!, $phone: String!) {
    lookup: bisnodeLookupByPhone(country: $country, phone: $phone) {
      ...BisnodePerson
    }
  }
  ${BisnodePersonFragmentDoc}
`;
export type BisnodeLookup_PhoneComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BisnodeLookup_PhoneQuery,
    BisnodeLookup_PhoneQueryVariables
  >,
  "query"
> &
  ({ variables: BisnodeLookup_PhoneQueryVariables; skip?: boolean } | { skip: boolean });

export const BisnodeLookup_PhoneComponent = (
  props: BisnodeLookup_PhoneComponentProps
) => (
  <ApolloReactComponents.Query<
    BisnodeLookup_PhoneQuery,
    BisnodeLookup_PhoneQueryVariables
  >
    query={BisnodeLookup_PhoneDocument}
    {...props}
  />
);

/**
 * __useBisnodeLookup_PhoneQuery__
 *
 * To run a query within a React component, call `useBisnodeLookup_PhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useBisnodeLookup_PhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBisnodeLookup_PhoneQuery({
 *   variables: {
 *      country: // value for 'country'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useBisnodeLookup_PhoneQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BisnodeLookup_PhoneQuery,
    BisnodeLookup_PhoneQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BisnodeLookup_PhoneQuery, BisnodeLookup_PhoneQueryVariables>(
    BisnodeLookup_PhoneDocument,
    options
  );
}
export function useBisnodeLookup_PhoneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BisnodeLookup_PhoneQuery,
    BisnodeLookup_PhoneQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BisnodeLookup_PhoneQuery, BisnodeLookup_PhoneQueryVariables>(
    BisnodeLookup_PhoneDocument,
    options
  );
}
export type BisnodeLookup_PhoneQueryHookResult = ReturnType<
  typeof useBisnodeLookup_PhoneQuery
>;
export type BisnodeLookup_PhoneLazyQueryHookResult = ReturnType<
  typeof useBisnodeLookup_PhoneLazyQuery
>;
export namespace BisnodeLookup_Phone {
  export type Return = BisnodeLookup_PhoneQuery;
  export type Variables = BisnodeLookup_PhoneQueryVariables;
  export const OperationName = "BisnodeLookup_Phone";

  export const Document = BisnodeLookup_PhoneDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CallListEditor_GetDocument = gql`
  query CallListEditor_Get($id: ObjectId!) {
    callListById(id: $id) {
      callList {
        ...CallListEditor_CallList
      }
    }
  }
  ${CallListEditor_CallListFragmentDoc}
`;
export type CallListEditor_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CallListEditor_GetQuery,
    CallListEditor_GetQueryVariables
  >,
  "query"
> &
  ({ variables: CallListEditor_GetQueryVariables; skip?: boolean } | { skip: boolean });

export const CallListEditor_GetComponent = (props: CallListEditor_GetComponentProps) => (
  <ApolloReactComponents.Query<CallListEditor_GetQuery, CallListEditor_GetQueryVariables>
    query={CallListEditor_GetDocument}
    {...props}
  />
);

/**
 * __useCallListEditor_GetQuery__
 *
 * To run a query within a React component, call `useCallListEditor_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallListEditor_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallListEditor_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCallListEditor_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CallListEditor_GetQuery,
    CallListEditor_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CallListEditor_GetQuery, CallListEditor_GetQueryVariables>(
    CallListEditor_GetDocument,
    options
  );
}
export function useCallListEditor_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CallListEditor_GetQuery,
    CallListEditor_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CallListEditor_GetQuery, CallListEditor_GetQueryVariables>(
    CallListEditor_GetDocument,
    options
  );
}
export type CallListEditor_GetQueryHookResult = ReturnType<
  typeof useCallListEditor_GetQuery
>;
export type CallListEditor_GetLazyQueryHookResult = ReturnType<
  typeof useCallListEditor_GetLazyQuery
>;
export namespace CallListEditor_Get {
  export type Return = CallListEditor_GetQuery;
  export type Variables = CallListEditor_GetQueryVariables;
  export const OperationName = "CallListEditor_Get";

  export const Document = CallListEditor_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CallListEditor_CreateDocument = gql`
  mutation CallListEditor_Create(
    $listType: CallListType!
    $name: String!
    $nodes: [NodeRefFullInput!]!
    $type: NodeType!
  ) {
    submit: createCallList(
      type: $listType
      data: { name: $name, nodes: $nodes, type: $type }
    ) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type CallListEditor_CreateMutationFn = Apollo.MutationFunction<
  CallListEditor_CreateMutation,
  CallListEditor_CreateMutationVariables
>;
export type CallListEditor_CreateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CallListEditor_CreateMutation,
    CallListEditor_CreateMutationVariables
  >,
  "mutation"
>;

export const CallListEditor_CreateComponent = (
  props: CallListEditor_CreateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CallListEditor_CreateMutation,
    CallListEditor_CreateMutationVariables
  >
    mutation={CallListEditor_CreateDocument}
    {...props}
  />
);

/**
 * __useCallListEditor_CreateMutation__
 *
 * To run a mutation, you first call `useCallListEditor_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallListEditor_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callListEditorCreateMutation, { data, loading, error }] = useCallListEditor_CreateMutation({
 *   variables: {
 *      listType: // value for 'listType'
 *      name: // value for 'name'
 *      nodes: // value for 'nodes'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCallListEditor_CreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CallListEditor_CreateMutation,
    CallListEditor_CreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CallListEditor_CreateMutation,
    CallListEditor_CreateMutationVariables
  >(CallListEditor_CreateDocument, options);
}
export type CallListEditor_CreateMutationHookResult = ReturnType<
  typeof useCallListEditor_CreateMutation
>;
export namespace CallListEditor_Create {
  export type Return = CallListEditor_CreateMutation;
  export type Variables = CallListEditor_CreateMutationVariables;
  export const OperationName = "CallListEditor_Create";

  export const Document = CallListEditor_CreateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CallListEditor_UpdateDocument = gql`
  mutation CallListEditor_Update($id: ObjectId!, $newName: String!) {
    submit: renameCallList(callListId: $id, newName: $newName) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type CallListEditor_UpdateMutationFn = Apollo.MutationFunction<
  CallListEditor_UpdateMutation,
  CallListEditor_UpdateMutationVariables
>;
export type CallListEditor_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CallListEditor_UpdateMutation,
    CallListEditor_UpdateMutationVariables
  >,
  "mutation"
>;

export const CallListEditor_UpdateComponent = (
  props: CallListEditor_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CallListEditor_UpdateMutation,
    CallListEditor_UpdateMutationVariables
  >
    mutation={CallListEditor_UpdateDocument}
    {...props}
  />
);

/**
 * __useCallListEditor_UpdateMutation__
 *
 * To run a mutation, you first call `useCallListEditor_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallListEditor_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callListEditorUpdateMutation, { data, loading, error }] = useCallListEditor_UpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useCallListEditor_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CallListEditor_UpdateMutation,
    CallListEditor_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CallListEditor_UpdateMutation,
    CallListEditor_UpdateMutationVariables
  >(CallListEditor_UpdateDocument, options);
}
export type CallListEditor_UpdateMutationHookResult = ReturnType<
  typeof useCallListEditor_UpdateMutation
>;
export namespace CallListEditor_Update {
  export type Return = CallListEditor_UpdateMutation;
  export type Variables = CallListEditor_UpdateMutationVariables;
  export const OperationName = "CallListEditor_Update";

  export const Document = CallListEditor_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ConsultantPresentationApproveDialog_GetDocument = gql`
  query ConsultantPresentationApproveDialog_Get($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      _id
      PresentationUrl
    }
  }
`;
export type ConsultantPresentationApproveDialog_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantPresentationApproveDialog_GetQuery,
    ConsultantPresentationApproveDialog_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantPresentationApproveDialog_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantPresentationApproveDialog_GetComponent = (
  props: ConsultantPresentationApproveDialog_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantPresentationApproveDialog_GetQuery,
    ConsultantPresentationApproveDialog_GetQueryVariables
  >
    query={ConsultantPresentationApproveDialog_GetDocument}
    {...props}
  />
);

/**
 * __useConsultantPresentationApproveDialog_GetQuery__
 *
 * To run a query within a React component, call `useConsultantPresentationApproveDialog_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantPresentationApproveDialog_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantPresentationApproveDialog_GetQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantPresentationApproveDialog_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantPresentationApproveDialog_GetQuery,
    ConsultantPresentationApproveDialog_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantPresentationApproveDialog_GetQuery,
    ConsultantPresentationApproveDialog_GetQueryVariables
  >(ConsultantPresentationApproveDialog_GetDocument, options);
}
export function useConsultantPresentationApproveDialog_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantPresentationApproveDialog_GetQuery,
    ConsultantPresentationApproveDialog_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantPresentationApproveDialog_GetQuery,
    ConsultantPresentationApproveDialog_GetQueryVariables
  >(ConsultantPresentationApproveDialog_GetDocument, options);
}
export type ConsultantPresentationApproveDialog_GetQueryHookResult = ReturnType<
  typeof useConsultantPresentationApproveDialog_GetQuery
>;
export type ConsultantPresentationApproveDialog_GetLazyQueryHookResult = ReturnType<
  typeof useConsultantPresentationApproveDialog_GetLazyQuery
>;
export namespace ConsultantPresentationApproveDialog_Get {
  export type Return = ConsultantPresentationApproveDialog_GetQuery;
  export type Variables = ConsultantPresentationApproveDialog_GetQueryVariables;
  export const OperationName = "ConsultantPresentationApproveDialog_Get";

  export const Document = ConsultantPresentationApproveDialog_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantShareableFiles_GetDocument = gql`
  query ConsultantShareableFiles_Get($consultantId: ObjectId!) {
    consultantById(id: $consultantId) {
      ...ConsultantShareableFiles
    }
  }
  ${ConsultantShareableFilesFragmentDoc}
`;
export type ConsultantShareableFiles_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantShareableFiles_GetQuery,
    ConsultantShareableFiles_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantShareableFiles_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantShareableFiles_GetComponent = (
  props: ConsultantShareableFiles_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantShareableFiles_GetQuery,
    ConsultantShareableFiles_GetQueryVariables
  >
    query={ConsultantShareableFiles_GetDocument}
    {...props}
  />
);

/**
 * __useConsultantShareableFiles_GetQuery__
 *
 * To run a query within a React component, call `useConsultantShareableFiles_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantShareableFiles_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantShareableFiles_GetQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useConsultantShareableFiles_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantShareableFiles_GetQuery,
    ConsultantShareableFiles_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantShareableFiles_GetQuery,
    ConsultantShareableFiles_GetQueryVariables
  >(ConsultantShareableFiles_GetDocument, options);
}
export function useConsultantShareableFiles_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantShareableFiles_GetQuery,
    ConsultantShareableFiles_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantShareableFiles_GetQuery,
    ConsultantShareableFiles_GetQueryVariables
  >(ConsultantShareableFiles_GetDocument, options);
}
export type ConsultantShareableFiles_GetQueryHookResult = ReturnType<
  typeof useConsultantShareableFiles_GetQuery
>;
export type ConsultantShareableFiles_GetLazyQueryHookResult = ReturnType<
  typeof useConsultantShareableFiles_GetLazyQuery
>;
export namespace ConsultantShareableFiles_Get {
  export type Return = ConsultantShareableFiles_GetQuery;
  export type Variables = ConsultantShareableFiles_GetQueryVariables;
  export const OperationName = "ConsultantShareableFiles_Get";

  export const Document = ConsultantShareableFiles_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContactPersonEditor_GetDocument = gql`
  query ContactPersonEditor_Get($id: ObjectId!) {
    contactPersonById(id: $id) {
      ...ContactPersonEditor
    }
  }
  ${ContactPersonEditorFragmentDoc}
`;
export type ContactPersonEditor_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ContactPersonEditor_GetQuery,
    ContactPersonEditor_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: ContactPersonEditor_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ContactPersonEditor_GetComponent = (
  props: ContactPersonEditor_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    ContactPersonEditor_GetQuery,
    ContactPersonEditor_GetQueryVariables
  >
    query={ContactPersonEditor_GetDocument}
    {...props}
  />
);

/**
 * __useContactPersonEditor_GetQuery__
 *
 * To run a query within a React component, call `useContactPersonEditor_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPersonEditor_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPersonEditor_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactPersonEditor_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContactPersonEditor_GetQuery,
    ContactPersonEditor_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContactPersonEditor_GetQuery,
    ContactPersonEditor_GetQueryVariables
  >(ContactPersonEditor_GetDocument, options);
}
export function useContactPersonEditor_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContactPersonEditor_GetQuery,
    ContactPersonEditor_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContactPersonEditor_GetQuery,
    ContactPersonEditor_GetQueryVariables
  >(ContactPersonEditor_GetDocument, options);
}
export type ContactPersonEditor_GetQueryHookResult = ReturnType<
  typeof useContactPersonEditor_GetQuery
>;
export type ContactPersonEditor_GetLazyQueryHookResult = ReturnType<
  typeof useContactPersonEditor_GetLazyQuery
>;
export namespace ContactPersonEditor_Get {
  export type Return = ContactPersonEditor_GetQuery;
  export type Variables = ContactPersonEditor_GetQueryVariables;
  export const OperationName = "ContactPersonEditor_Get";

  export const Document = ContactPersonEditor_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContactPersonEditor_GetCustomerDocument = gql`
  query ContactPersonEditor_GetCustomer($customerId: ObjectId!) {
    customerById(id: $customerId) {
      ...ContactPersonEditor_Customer
    }
  }
  ${ContactPersonEditor_CustomerFragmentDoc}
`;
export type ContactPersonEditor_GetCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ContactPersonEditor_GetCustomerQuery,
    ContactPersonEditor_GetCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: ContactPersonEditor_GetCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ContactPersonEditor_GetCustomerComponent = (
  props: ContactPersonEditor_GetCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    ContactPersonEditor_GetCustomerQuery,
    ContactPersonEditor_GetCustomerQueryVariables
  >
    query={ContactPersonEditor_GetCustomerDocument}
    {...props}
  />
);

/**
 * __useContactPersonEditor_GetCustomerQuery__
 *
 * To run a query within a React component, call `useContactPersonEditor_GetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPersonEditor_GetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPersonEditor_GetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useContactPersonEditor_GetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContactPersonEditor_GetCustomerQuery,
    ContactPersonEditor_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContactPersonEditor_GetCustomerQuery,
    ContactPersonEditor_GetCustomerQueryVariables
  >(ContactPersonEditor_GetCustomerDocument, options);
}
export function useContactPersonEditor_GetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContactPersonEditor_GetCustomerQuery,
    ContactPersonEditor_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContactPersonEditor_GetCustomerQuery,
    ContactPersonEditor_GetCustomerQueryVariables
  >(ContactPersonEditor_GetCustomerDocument, options);
}
export type ContactPersonEditor_GetCustomerQueryHookResult = ReturnType<
  typeof useContactPersonEditor_GetCustomerQuery
>;
export type ContactPersonEditor_GetCustomerLazyQueryHookResult = ReturnType<
  typeof useContactPersonEditor_GetCustomerLazyQuery
>;
export namespace ContactPersonEditor_GetCustomer {
  export type Return = ContactPersonEditor_GetCustomerQuery;
  export type Variables = ContactPersonEditor_GetCustomerQueryVariables;
  export const OperationName = "ContactPersonEditor_GetCustomer";

  export const Document = ContactPersonEditor_GetCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContactPersonEditor_CreateDocument = gql`
  mutation ContactPersonEditor_Create($data: ContactPersonInput!) {
    result: createContactPerson(data: $data) {
      contactPerson {
        ...ContactPersonEditor
      }
      validationErrors {
        Message
        Path
      }
    }
  }
  ${ContactPersonEditorFragmentDoc}
`;
export type ContactPersonEditor_CreateMutationFn = Apollo.MutationFunction<
  ContactPersonEditor_CreateMutation,
  ContactPersonEditor_CreateMutationVariables
>;
export type ContactPersonEditor_CreateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ContactPersonEditor_CreateMutation,
    ContactPersonEditor_CreateMutationVariables
  >,
  "mutation"
>;

export const ContactPersonEditor_CreateComponent = (
  props: ContactPersonEditor_CreateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ContactPersonEditor_CreateMutation,
    ContactPersonEditor_CreateMutationVariables
  >
    mutation={ContactPersonEditor_CreateDocument}
    {...props}
  />
);

/**
 * __useContactPersonEditor_CreateMutation__
 *
 * To run a mutation, you first call `useContactPersonEditor_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPersonEditor_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPersonEditorCreateMutation, { data, loading, error }] = useContactPersonEditor_CreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContactPersonEditor_CreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContactPersonEditor_CreateMutation,
    ContactPersonEditor_CreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContactPersonEditor_CreateMutation,
    ContactPersonEditor_CreateMutationVariables
  >(ContactPersonEditor_CreateDocument, options);
}
export type ContactPersonEditor_CreateMutationHookResult = ReturnType<
  typeof useContactPersonEditor_CreateMutation
>;
export namespace ContactPersonEditor_Create {
  export type Return = ContactPersonEditor_CreateMutation;
  export type Variables = ContactPersonEditor_CreateMutationVariables;
  export const OperationName = "ContactPersonEditor_Create";

  export const Document = ContactPersonEditor_CreateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ContactPersonEditor_UpdateDocument = gql`
  mutation ContactPersonEditor_Update($id: ObjectId!, $data: ContactPersonInput!) {
    result: updateContactPerson(id: $id, data: $data) {
      contactPerson {
        ...ContactPersonEditor
      }
      validationErrors {
        Message
        Path
      }
    }
  }
  ${ContactPersonEditorFragmentDoc}
`;
export type ContactPersonEditor_UpdateMutationFn = Apollo.MutationFunction<
  ContactPersonEditor_UpdateMutation,
  ContactPersonEditor_UpdateMutationVariables
>;
export type ContactPersonEditor_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ContactPersonEditor_UpdateMutation,
    ContactPersonEditor_UpdateMutationVariables
  >,
  "mutation"
>;

export const ContactPersonEditor_UpdateComponent = (
  props: ContactPersonEditor_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ContactPersonEditor_UpdateMutation,
    ContactPersonEditor_UpdateMutationVariables
  >
    mutation={ContactPersonEditor_UpdateDocument}
    {...props}
  />
);

/**
 * __useContactPersonEditor_UpdateMutation__
 *
 * To run a mutation, you first call `useContactPersonEditor_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPersonEditor_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPersonEditorUpdateMutation, { data, loading, error }] = useContactPersonEditor_UpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContactPersonEditor_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContactPersonEditor_UpdateMutation,
    ContactPersonEditor_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContactPersonEditor_UpdateMutation,
    ContactPersonEditor_UpdateMutationVariables
  >(ContactPersonEditor_UpdateDocument, options);
}
export type ContactPersonEditor_UpdateMutationHookResult = ReturnType<
  typeof useContactPersonEditor_UpdateMutation
>;
export namespace ContactPersonEditor_Update {
  export type Return = ContactPersonEditor_UpdateMutation;
  export type Variables = ContactPersonEditor_UpdateMutationVariables;
  export const OperationName = "ContactPersonEditor_Update";

  export const Document = ContactPersonEditor_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const ContactPersonEditor_ExtractDocument = gql`
  mutation ContactPersonEditor_Extract(
    $customerId: ObjectId!
    $contactPersonId: ObjectId!
    $data: ContactPersonInput!
  ) {
    result: extractContactPerson(
      customerId: $customerId
      contactPersonId: $contactPersonId
      data: $data
    ) {
      contactPerson {
        ...ContactPersonEditor
      }
      validationErrors {
        Message
        Path
      }
    }
  }
  ${ContactPersonEditorFragmentDoc}
`;
export type ContactPersonEditor_ExtractMutationFn = Apollo.MutationFunction<
  ContactPersonEditor_ExtractMutation,
  ContactPersonEditor_ExtractMutationVariables
>;
export type ContactPersonEditor_ExtractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ContactPersonEditor_ExtractMutation,
    ContactPersonEditor_ExtractMutationVariables
  >,
  "mutation"
>;

export const ContactPersonEditor_ExtractComponent = (
  props: ContactPersonEditor_ExtractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ContactPersonEditor_ExtractMutation,
    ContactPersonEditor_ExtractMutationVariables
  >
    mutation={ContactPersonEditor_ExtractDocument}
    {...props}
  />
);

/**
 * __useContactPersonEditor_ExtractMutation__
 *
 * To run a mutation, you first call `useContactPersonEditor_ExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPersonEditor_ExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPersonEditorExtractMutation, { data, loading, error }] = useContactPersonEditor_ExtractMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      contactPersonId: // value for 'contactPersonId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContactPersonEditor_ExtractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContactPersonEditor_ExtractMutation,
    ContactPersonEditor_ExtractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContactPersonEditor_ExtractMutation,
    ContactPersonEditor_ExtractMutationVariables
  >(ContactPersonEditor_ExtractDocument, options);
}
export type ContactPersonEditor_ExtractMutationHookResult = ReturnType<
  typeof useContactPersonEditor_ExtractMutation
>;
export namespace ContactPersonEditor_Extract {
  export type Return = ContactPersonEditor_ExtractMutation;
  export type Variables = ContactPersonEditor_ExtractMutationVariables;
  export const OperationName = "ContactPersonEditor_Extract";

  export const Document = ContactPersonEditor_ExtractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerAutosuggest_GetDocument = gql`
  query CustomerAutosuggest_Get($text: String!, $skip: Int!, $limit: Int!) {
    customers(
      filter: { nameStartsWith: $text, type: [Hospital, Region] }
      skip: $skip
      limit: $limit
    ) {
      items {
        ...CustomerAutosuggestItem
      }
      dbTime
    }
  }
  ${CustomerAutosuggestItemFragmentDoc}
`;
export type CustomerAutosuggest_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerAutosuggest_GetQuery,
    CustomerAutosuggest_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerAutosuggest_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerAutosuggest_GetComponent = (
  props: CustomerAutosuggest_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerAutosuggest_GetQuery,
    CustomerAutosuggest_GetQueryVariables
  >
    query={CustomerAutosuggest_GetDocument}
    {...props}
  />
);

/**
 * __useCustomerAutosuggest_GetQuery__
 *
 * To run a query within a React component, call `useCustomerAutosuggest_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAutosuggest_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAutosuggest_GetQuery({
 *   variables: {
 *      text: // value for 'text'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerAutosuggest_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerAutosuggest_GetQuery,
    CustomerAutosuggest_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerAutosuggest_GetQuery,
    CustomerAutosuggest_GetQueryVariables
  >(CustomerAutosuggest_GetDocument, options);
}
export function useCustomerAutosuggest_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerAutosuggest_GetQuery,
    CustomerAutosuggest_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerAutosuggest_GetQuery,
    CustomerAutosuggest_GetQueryVariables
  >(CustomerAutosuggest_GetDocument, options);
}
export type CustomerAutosuggest_GetQueryHookResult = ReturnType<
  typeof useCustomerAutosuggest_GetQuery
>;
export type CustomerAutosuggest_GetLazyQueryHookResult = ReturnType<
  typeof useCustomerAutosuggest_GetLazyQuery
>;
export namespace CustomerAutosuggest_Get {
  export type Return = CustomerAutosuggest_GetQuery;
  export type Variables = CustomerAutosuggest_GetQueryVariables;
  export const OperationName = "CustomerAutosuggest_Get";

  export const Document = CustomerAutosuggest_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const EmailEditor_UploadAttachmentDocument = gql`
  mutation EmailEditor_UploadAttachment($file: Upload!) {
    uploadDocument(file: $file) {
      ...DDocument
    }
  }
  ${DDocumentFragmentDoc}
`;
export type EmailEditor_UploadAttachmentMutationFn = Apollo.MutationFunction<
  EmailEditor_UploadAttachmentMutation,
  EmailEditor_UploadAttachmentMutationVariables
>;
export type EmailEditor_UploadAttachmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    EmailEditor_UploadAttachmentMutation,
    EmailEditor_UploadAttachmentMutationVariables
  >,
  "mutation"
>;

export const EmailEditor_UploadAttachmentComponent = (
  props: EmailEditor_UploadAttachmentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    EmailEditor_UploadAttachmentMutation,
    EmailEditor_UploadAttachmentMutationVariables
  >
    mutation={EmailEditor_UploadAttachmentDocument}
    {...props}
  />
);

/**
 * __useEmailEditor_UploadAttachmentMutation__
 *
 * To run a mutation, you first call `useEmailEditor_UploadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailEditor_UploadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailEditorUploadAttachmentMutation, { data, loading, error }] = useEmailEditor_UploadAttachmentMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useEmailEditor_UploadAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmailEditor_UploadAttachmentMutation,
    EmailEditor_UploadAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EmailEditor_UploadAttachmentMutation,
    EmailEditor_UploadAttachmentMutationVariables
  >(EmailEditor_UploadAttachmentDocument, options);
}
export type EmailEditor_UploadAttachmentMutationHookResult = ReturnType<
  typeof useEmailEditor_UploadAttachmentMutation
>;
export namespace EmailEditor_UploadAttachment {
  export type Return = EmailEditor_UploadAttachmentMutation;
  export type Variables = EmailEditor_UploadAttachmentMutationVariables;
  export const OperationName = "EmailEditor_UploadAttachment";

  export const Document = EmailEditor_UploadAttachmentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationEventLog_GetEventsDocument = gql`
  query AccommodationEventLog_GetEvents($accommodationId: ObjectId!) {
    accommodationEvents(accommodationId: $accommodationId) {
      ...EventLog_AccommodationEvent
    }
  }
  ${EventLog_AccommodationEventFragmentDoc}
`;
export type AccommodationEventLog_GetEventsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AccommodationEventLog_GetEventsQuery,
    AccommodationEventLog_GetEventsQueryVariables
  >,
  "query"
> &
  (
    | { variables: AccommodationEventLog_GetEventsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AccommodationEventLog_GetEventsComponent = (
  props: AccommodationEventLog_GetEventsComponentProps
) => (
  <ApolloReactComponents.Query<
    AccommodationEventLog_GetEventsQuery,
    AccommodationEventLog_GetEventsQueryVariables
  >
    query={AccommodationEventLog_GetEventsDocument}
    {...props}
  />
);

/**
 * __useAccommodationEventLog_GetEventsQuery__
 *
 * To run a query within a React component, call `useAccommodationEventLog_GetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationEventLog_GetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationEventLog_GetEventsQuery({
 *   variables: {
 *      accommodationId: // value for 'accommodationId'
 *   },
 * });
 */
export function useAccommodationEventLog_GetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccommodationEventLog_GetEventsQuery,
    AccommodationEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccommodationEventLog_GetEventsQuery,
    AccommodationEventLog_GetEventsQueryVariables
  >(AccommodationEventLog_GetEventsDocument, options);
}
export function useAccommodationEventLog_GetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccommodationEventLog_GetEventsQuery,
    AccommodationEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccommodationEventLog_GetEventsQuery,
    AccommodationEventLog_GetEventsQueryVariables
  >(AccommodationEventLog_GetEventsDocument, options);
}
export type AccommodationEventLog_GetEventsQueryHookResult = ReturnType<
  typeof useAccommodationEventLog_GetEventsQuery
>;
export type AccommodationEventLog_GetEventsLazyQueryHookResult = ReturnType<
  typeof useAccommodationEventLog_GetEventsLazyQuery
>;
export namespace AccommodationEventLog_GetEvents {
  export type Return = AccommodationEventLog_GetEventsQuery;
  export type Variables = AccommodationEventLog_GetEventsQueryVariables;
  export const OperationName = "AccommodationEventLog_GetEvents";

  export const Document = AccommodationEventLog_GetEventsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AccommodationEventLog_AddCommentDocument = gql`
  mutation AccommodationEventLog_AddComment(
    $accommodationId: ObjectId!
    $desc: String!
    $withTodo: WithTodoInput
  ) {
    addAccommodationCommentEvent(
      accommodationId: $accommodationId
      desc: $desc
      withTodo: $withTodo
    ) {
      ...EventLog_AccommodationEvent
    }
  }
  ${EventLog_AccommodationEventFragmentDoc}
`;
export type AccommodationEventLog_AddCommentMutationFn = Apollo.MutationFunction<
  AccommodationEventLog_AddCommentMutation,
  AccommodationEventLog_AddCommentMutationVariables
>;
export type AccommodationEventLog_AddCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AccommodationEventLog_AddCommentMutation,
    AccommodationEventLog_AddCommentMutationVariables
  >,
  "mutation"
>;

export const AccommodationEventLog_AddCommentComponent = (
  props: AccommodationEventLog_AddCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AccommodationEventLog_AddCommentMutation,
    AccommodationEventLog_AddCommentMutationVariables
  >
    mutation={AccommodationEventLog_AddCommentDocument}
    {...props}
  />
);

/**
 * __useAccommodationEventLog_AddCommentMutation__
 *
 * To run a mutation, you first call `useAccommodationEventLog_AddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationEventLog_AddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationEventLogAddCommentMutation, { data, loading, error }] = useAccommodationEventLog_AddCommentMutation({
 *   variables: {
 *      accommodationId: // value for 'accommodationId'
 *      desc: // value for 'desc'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useAccommodationEventLog_AddCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccommodationEventLog_AddCommentMutation,
    AccommodationEventLog_AddCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AccommodationEventLog_AddCommentMutation,
    AccommodationEventLog_AddCommentMutationVariables
  >(AccommodationEventLog_AddCommentDocument, options);
}
export type AccommodationEventLog_AddCommentMutationHookResult = ReturnType<
  typeof useAccommodationEventLog_AddCommentMutation
>;
export namespace AccommodationEventLog_AddComment {
  export type Return = AccommodationEventLog_AddCommentMutation;
  export type Variables = AccommodationEventLog_AddCommentMutationVariables;
  export const OperationName = "AccommodationEventLog_AddComment";

  export const Document = AccommodationEventLog_AddCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationEventLog_PinDocument = gql`
  mutation AccommodationEventLog_Pin($eventId: ObjectId!) {
    pinAccommodationEvent(eventId: $eventId) {
      ...EventLog_AccommodationEvent
    }
  }
  ${EventLog_AccommodationEventFragmentDoc}
`;
export type AccommodationEventLog_PinMutationFn = Apollo.MutationFunction<
  AccommodationEventLog_PinMutation,
  AccommodationEventLog_PinMutationVariables
>;
export type AccommodationEventLog_PinComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AccommodationEventLog_PinMutation,
    AccommodationEventLog_PinMutationVariables
  >,
  "mutation"
>;

export const AccommodationEventLog_PinComponent = (
  props: AccommodationEventLog_PinComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AccommodationEventLog_PinMutation,
    AccommodationEventLog_PinMutationVariables
  >
    mutation={AccommodationEventLog_PinDocument}
    {...props}
  />
);

/**
 * __useAccommodationEventLog_PinMutation__
 *
 * To run a mutation, you first call `useAccommodationEventLog_PinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationEventLog_PinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationEventLogPinMutation, { data, loading, error }] = useAccommodationEventLog_PinMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAccommodationEventLog_PinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccommodationEventLog_PinMutation,
    AccommodationEventLog_PinMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AccommodationEventLog_PinMutation,
    AccommodationEventLog_PinMutationVariables
  >(AccommodationEventLog_PinDocument, options);
}
export type AccommodationEventLog_PinMutationHookResult = ReturnType<
  typeof useAccommodationEventLog_PinMutation
>;
export namespace AccommodationEventLog_Pin {
  export type Return = AccommodationEventLog_PinMutation;
  export type Variables = AccommodationEventLog_PinMutationVariables;
  export const OperationName = "AccommodationEventLog_Pin";

  export const Document = AccommodationEventLog_PinDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationEventLog_UpdateDocument = gql`
  mutation AccommodationEventLog_Update($eventId: ObjectId!, $desc: String!) {
    updateAccommodationEvent(eventId: $eventId, desc: $desc) {
      ...EventLog_AccommodationEvent
    }
  }
  ${EventLog_AccommodationEventFragmentDoc}
`;
export type AccommodationEventLog_UpdateMutationFn = Apollo.MutationFunction<
  AccommodationEventLog_UpdateMutation,
  AccommodationEventLog_UpdateMutationVariables
>;
export type AccommodationEventLog_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AccommodationEventLog_UpdateMutation,
    AccommodationEventLog_UpdateMutationVariables
  >,
  "mutation"
>;

export const AccommodationEventLog_UpdateComponent = (
  props: AccommodationEventLog_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AccommodationEventLog_UpdateMutation,
    AccommodationEventLog_UpdateMutationVariables
  >
    mutation={AccommodationEventLog_UpdateDocument}
    {...props}
  />
);

/**
 * __useAccommodationEventLog_UpdateMutation__
 *
 * To run a mutation, you first call `useAccommodationEventLog_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationEventLog_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationEventLogUpdateMutation, { data, loading, error }] = useAccommodationEventLog_UpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useAccommodationEventLog_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccommodationEventLog_UpdateMutation,
    AccommodationEventLog_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AccommodationEventLog_UpdateMutation,
    AccommodationEventLog_UpdateMutationVariables
  >(AccommodationEventLog_UpdateDocument, options);
}
export type AccommodationEventLog_UpdateMutationHookResult = ReturnType<
  typeof useAccommodationEventLog_UpdateMutation
>;
export namespace AccommodationEventLog_Update {
  export type Return = AccommodationEventLog_UpdateMutation;
  export type Variables = AccommodationEventLog_UpdateMutationVariables;
  export const OperationName = "AccommodationEventLog_Update";

  export const Document = AccommodationEventLog_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AccommodationEventLog_DeleteDocument = gql`
  mutation AccommodationEventLog_Delete($eventId: ObjectId!) {
    deleteAccommodationEvent(eventId: $eventId) {
      ...EventLog_AccommodationEvent
    }
  }
  ${EventLog_AccommodationEventFragmentDoc}
`;
export type AccommodationEventLog_DeleteMutationFn = Apollo.MutationFunction<
  AccommodationEventLog_DeleteMutation,
  AccommodationEventLog_DeleteMutationVariables
>;
export type AccommodationEventLog_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AccommodationEventLog_DeleteMutation,
    AccommodationEventLog_DeleteMutationVariables
  >,
  "mutation"
>;

export const AccommodationEventLog_DeleteComponent = (
  props: AccommodationEventLog_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AccommodationEventLog_DeleteMutation,
    AccommodationEventLog_DeleteMutationVariables
  >
    mutation={AccommodationEventLog_DeleteDocument}
    {...props}
  />
);

/**
 * __useAccommodationEventLog_DeleteMutation__
 *
 * To run a mutation, you first call `useAccommodationEventLog_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationEventLog_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationEventLogDeleteMutation, { data, loading, error }] = useAccommodationEventLog_DeleteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAccommodationEventLog_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccommodationEventLog_DeleteMutation,
    AccommodationEventLog_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AccommodationEventLog_DeleteMutation,
    AccommodationEventLog_DeleteMutationVariables
  >(AccommodationEventLog_DeleteDocument, options);
}
export type AccommodationEventLog_DeleteMutationHookResult = ReturnType<
  typeof useAccommodationEventLog_DeleteMutation
>;
export namespace AccommodationEventLog_Delete {
  export type Return = AccommodationEventLog_DeleteMutation;
  export type Variables = AccommodationEventLog_DeleteMutationVariables;
  export const OperationName = "AccommodationEventLog_Delete";

  export const Document = AccommodationEventLog_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingEventLog_GetEventsDocument = gql`
  query BookingEventLog_GetEvents($bookingId: ObjectId!) {
    bookingEvents(bookingId: $bookingId) {
      ...EventLog_BookingEvent
    }
  }
  ${EventLog_BookingEventFragmentDoc}
`;
export type BookingEventLog_GetEventsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BookingEventLog_GetEventsQuery,
    BookingEventLog_GetEventsQueryVariables
  >,
  "query"
> &
  (
    | { variables: BookingEventLog_GetEventsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const BookingEventLog_GetEventsComponent = (
  props: BookingEventLog_GetEventsComponentProps
) => (
  <ApolloReactComponents.Query<
    BookingEventLog_GetEventsQuery,
    BookingEventLog_GetEventsQueryVariables
  >
    query={BookingEventLog_GetEventsDocument}
    {...props}
  />
);

/**
 * __useBookingEventLog_GetEventsQuery__
 *
 * To run a query within a React component, call `useBookingEventLog_GetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEventLog_GetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEventLog_GetEventsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingEventLog_GetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingEventLog_GetEventsQuery,
    BookingEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingEventLog_GetEventsQuery,
    BookingEventLog_GetEventsQueryVariables
  >(BookingEventLog_GetEventsDocument, options);
}
export function useBookingEventLog_GetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingEventLog_GetEventsQuery,
    BookingEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingEventLog_GetEventsQuery,
    BookingEventLog_GetEventsQueryVariables
  >(BookingEventLog_GetEventsDocument, options);
}
export type BookingEventLog_GetEventsQueryHookResult = ReturnType<
  typeof useBookingEventLog_GetEventsQuery
>;
export type BookingEventLog_GetEventsLazyQueryHookResult = ReturnType<
  typeof useBookingEventLog_GetEventsLazyQuery
>;
export namespace BookingEventLog_GetEvents {
  export type Return = BookingEventLog_GetEventsQuery;
  export type Variables = BookingEventLog_GetEventsQueryVariables;
  export const OperationName = "BookingEventLog_GetEvents";

  export const Document = BookingEventLog_GetEventsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const BookingEventLog_AddCommentDocument = gql`
  mutation BookingEventLog_AddComment($bookingId: ObjectId!, $desc: String!) {
    addBookingCommentEvent(bookingId: $bookingId, desc: $desc) {
      ...EventLog_BookingEvent
    }
  }
  ${EventLog_BookingEventFragmentDoc}
`;
export type BookingEventLog_AddCommentMutationFn = Apollo.MutationFunction<
  BookingEventLog_AddCommentMutation,
  BookingEventLog_AddCommentMutationVariables
>;
export type BookingEventLog_AddCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingEventLog_AddCommentMutation,
    BookingEventLog_AddCommentMutationVariables
  >,
  "mutation"
>;

export const BookingEventLog_AddCommentComponent = (
  props: BookingEventLog_AddCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingEventLog_AddCommentMutation,
    BookingEventLog_AddCommentMutationVariables
  >
    mutation={BookingEventLog_AddCommentDocument}
    {...props}
  />
);

/**
 * __useBookingEventLog_AddCommentMutation__
 *
 * To run a mutation, you first call `useBookingEventLog_AddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingEventLog_AddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingEventLogAddCommentMutation, { data, loading, error }] = useBookingEventLog_AddCommentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useBookingEventLog_AddCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingEventLog_AddCommentMutation,
    BookingEventLog_AddCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingEventLog_AddCommentMutation,
    BookingEventLog_AddCommentMutationVariables
  >(BookingEventLog_AddCommentDocument, options);
}
export type BookingEventLog_AddCommentMutationHookResult = ReturnType<
  typeof useBookingEventLog_AddCommentMutation
>;
export namespace BookingEventLog_AddComment {
  export type Return = BookingEventLog_AddCommentMutation;
  export type Variables = BookingEventLog_AddCommentMutationVariables;
  export const OperationName = "BookingEventLog_AddComment";

  export const Document = BookingEventLog_AddCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingEventLog_UpdateDocument = gql`
  mutation BookingEventLog_Update($eventId: ObjectId!, $desc: String, $sticky: Boolean) {
    updateBookingEvent(eventId: $eventId, desc: $desc, sticky: $sticky) {
      ...EventLog_BookingEvent
    }
  }
  ${EventLog_BookingEventFragmentDoc}
`;
export type BookingEventLog_UpdateMutationFn = Apollo.MutationFunction<
  BookingEventLog_UpdateMutation,
  BookingEventLog_UpdateMutationVariables
>;
export type BookingEventLog_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingEventLog_UpdateMutation,
    BookingEventLog_UpdateMutationVariables
  >,
  "mutation"
>;

export const BookingEventLog_UpdateComponent = (
  props: BookingEventLog_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingEventLog_UpdateMutation,
    BookingEventLog_UpdateMutationVariables
  >
    mutation={BookingEventLog_UpdateDocument}
    {...props}
  />
);

/**
 * __useBookingEventLog_UpdateMutation__
 *
 * To run a mutation, you first call `useBookingEventLog_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingEventLog_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingEventLogUpdateMutation, { data, loading, error }] = useBookingEventLog_UpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      desc: // value for 'desc'
 *      sticky: // value for 'sticky'
 *   },
 * });
 */
export function useBookingEventLog_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingEventLog_UpdateMutation,
    BookingEventLog_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingEventLog_UpdateMutation,
    BookingEventLog_UpdateMutationVariables
  >(BookingEventLog_UpdateDocument, options);
}
export type BookingEventLog_UpdateMutationHookResult = ReturnType<
  typeof useBookingEventLog_UpdateMutation
>;
export namespace BookingEventLog_Update {
  export type Return = BookingEventLog_UpdateMutation;
  export type Variables = BookingEventLog_UpdateMutationVariables;
  export const OperationName = "BookingEventLog_Update";

  export const Document = BookingEventLog_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const BookingEventLog_DeleteDocument = gql`
  mutation BookingEventLog_Delete($eventId: ObjectId!) {
    deleteBookingEvent(eventId: $eventId) {
      ...EventLog_BookingEvent
    }
  }
  ${EventLog_BookingEventFragmentDoc}
`;
export type BookingEventLog_DeleteMutationFn = Apollo.MutationFunction<
  BookingEventLog_DeleteMutation,
  BookingEventLog_DeleteMutationVariables
>;
export type BookingEventLog_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BookingEventLog_DeleteMutation,
    BookingEventLog_DeleteMutationVariables
  >,
  "mutation"
>;

export const BookingEventLog_DeleteComponent = (
  props: BookingEventLog_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    BookingEventLog_DeleteMutation,
    BookingEventLog_DeleteMutationVariables
  >
    mutation={BookingEventLog_DeleteDocument}
    {...props}
  />
);

/**
 * __useBookingEventLog_DeleteMutation__
 *
 * To run a mutation, you first call `useBookingEventLog_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingEventLog_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingEventLogDeleteMutation, { data, loading, error }] = useBookingEventLog_DeleteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useBookingEventLog_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookingEventLog_DeleteMutation,
    BookingEventLog_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookingEventLog_DeleteMutation,
    BookingEventLog_DeleteMutationVariables
  >(BookingEventLog_DeleteDocument, options);
}
export type BookingEventLog_DeleteMutationHookResult = ReturnType<
  typeof useBookingEventLog_DeleteMutation
>;
export namespace BookingEventLog_Delete {
  export type Return = BookingEventLog_DeleteMutation;
  export type Variables = BookingEventLog_DeleteMutationVariables;
  export const OperationName = "BookingEventLog_Delete";

  export const Document = BookingEventLog_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateCustomerContractEventDocument = gql`
  mutation UpdateCustomerContractEvent(
    $customerContractId: ObjectId!
    $eventLog: CustomerContractEventInput!
  ) {
    updateCustomerContractEvent(
      customerContractId: $customerContractId
      eventLog: $eventLog
    ) {
      value {
        ...CustomerContractEventLog
      }
      errors
    }
  }
  ${CustomerContractEventLogFragmentDoc}
`;
export type UpdateCustomerContractEventMutationFn = Apollo.MutationFunction<
  UpdateCustomerContractEventMutation,
  UpdateCustomerContractEventMutationVariables
>;
export type UpdateCustomerContractEventComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCustomerContractEventMutation,
    UpdateCustomerContractEventMutationVariables
  >,
  "mutation"
>;

export const UpdateCustomerContractEventComponent = (
  props: UpdateCustomerContractEventComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateCustomerContractEventMutation,
    UpdateCustomerContractEventMutationVariables
  >
    mutation={UpdateCustomerContractEventDocument}
    {...props}
  />
);

/**
 * __useUpdateCustomerContractEventMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerContractEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerContractEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerContractEventMutation, { data, loading, error }] = useUpdateCustomerContractEventMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      eventLog: // value for 'eventLog'
 *   },
 * });
 */
export function useUpdateCustomerContractEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerContractEventMutation,
    UpdateCustomerContractEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerContractEventMutation,
    UpdateCustomerContractEventMutationVariables
  >(UpdateCustomerContractEventDocument, options);
}
export type UpdateCustomerContractEventMutationHookResult = ReturnType<
  typeof useUpdateCustomerContractEventMutation
>;
export namespace UpdateCustomerContractEvent {
  export type Return = UpdateCustomerContractEventMutation;
  export type Variables = UpdateCustomerContractEventMutationVariables;
  export const OperationName = "UpdateCustomerContractEvent";

  export const Document = UpdateCustomerContractEventDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteCustomerContractEventDocument = gql`
  mutation DeleteCustomerContractEvent(
    $customerContractId: ObjectId!
    $eventId: ObjectId!
  ) {
    deleteCustomerContractEvent(
      customerContractId: $customerContractId
      eventLogId: $eventId
    ) {
      value {
        ...CustomerContractEventLog
      }
      errors
    }
  }
  ${CustomerContractEventLogFragmentDoc}
`;
export type DeleteCustomerContractEventMutationFn = Apollo.MutationFunction<
  DeleteCustomerContractEventMutation,
  DeleteCustomerContractEventMutationVariables
>;
export type DeleteCustomerContractEventComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteCustomerContractEventMutation,
    DeleteCustomerContractEventMutationVariables
  >,
  "mutation"
>;

export const DeleteCustomerContractEventComponent = (
  props: DeleteCustomerContractEventComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteCustomerContractEventMutation,
    DeleteCustomerContractEventMutationVariables
  >
    mutation={DeleteCustomerContractEventDocument}
    {...props}
  />
);

/**
 * __useDeleteCustomerContractEventMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerContractEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerContractEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerContractEventMutation, { data, loading, error }] = useDeleteCustomerContractEventMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteCustomerContractEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerContractEventMutation,
    DeleteCustomerContractEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerContractEventMutation,
    DeleteCustomerContractEventMutationVariables
  >(DeleteCustomerContractEventDocument, options);
}
export type DeleteCustomerContractEventMutationHookResult = ReturnType<
  typeof useDeleteCustomerContractEventMutation
>;
export namespace DeleteCustomerContractEvent {
  export type Return = DeleteCustomerContractEventMutation;
  export type Variables = DeleteCustomerContractEventMutationVariables;
  export const OperationName = "DeleteCustomerContractEvent";

  export const Document = DeleteCustomerContractEventDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerContractEventLogDocument = gql`
  query GetCustomerContractEventLog($customerContractId: ObjectId!) {
    customerContractById(customerContractId: $customerContractId) {
      ...CustomerContractEventLog
    }
  }
  ${CustomerContractEventLogFragmentDoc}
`;
export type GetCustomerContractEventLogComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractEventLogQuery,
    GetCustomerContractEventLogQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractEventLogQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractEventLogComponent = (
  props: GetCustomerContractEventLogComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractEventLogQuery,
    GetCustomerContractEventLogQueryVariables
  >
    query={GetCustomerContractEventLogDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractEventLogQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractEventLogQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useGetCustomerContractEventLogQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractEventLogQuery,
    GetCustomerContractEventLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractEventLogQuery,
    GetCustomerContractEventLogQueryVariables
  >(GetCustomerContractEventLogDocument, options);
}
export function useGetCustomerContractEventLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractEventLogQuery,
    GetCustomerContractEventLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractEventLogQuery,
    GetCustomerContractEventLogQueryVariables
  >(GetCustomerContractEventLogDocument, options);
}
export type GetCustomerContractEventLogQueryHookResult = ReturnType<
  typeof useGetCustomerContractEventLogQuery
>;
export type GetCustomerContractEventLogLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractEventLogLazyQuery
>;
export namespace GetCustomerContractEventLog {
  export type Return = GetCustomerContractEventLogQuery;
  export type Variables = GetCustomerContractEventLogQueryVariables;
  export const OperationName = "GetCustomerContractEventLog";

  export const Document = GetCustomerContractEventLogDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AddCustomerContractCommentEventDocument = gql`
  mutation AddCustomerContractCommentEvent(
    $customerContractId: ObjectId!
    $eventLog: CustomerContractEventInput!
  ) {
    addCustomerContractCommentEvent(
      customerContractId: $customerContractId
      eventLog: $eventLog
    ) {
      value {
        ...CustomerContractEventLog
      }
      errors
    }
  }
  ${CustomerContractEventLogFragmentDoc}
`;
export type AddCustomerContractCommentEventMutationFn = Apollo.MutationFunction<
  AddCustomerContractCommentEventMutation,
  AddCustomerContractCommentEventMutationVariables
>;
export type AddCustomerContractCommentEventComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddCustomerContractCommentEventMutation,
    AddCustomerContractCommentEventMutationVariables
  >,
  "mutation"
>;

export const AddCustomerContractCommentEventComponent = (
  props: AddCustomerContractCommentEventComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddCustomerContractCommentEventMutation,
    AddCustomerContractCommentEventMutationVariables
  >
    mutation={AddCustomerContractCommentEventDocument}
    {...props}
  />
);

/**
 * __useAddCustomerContractCommentEventMutation__
 *
 * To run a mutation, you first call `useAddCustomerContractCommentEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerContractCommentEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerContractCommentEventMutation, { data, loading, error }] = useAddCustomerContractCommentEventMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      eventLog: // value for 'eventLog'
 *   },
 * });
 */
export function useAddCustomerContractCommentEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCustomerContractCommentEventMutation,
    AddCustomerContractCommentEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCustomerContractCommentEventMutation,
    AddCustomerContractCommentEventMutationVariables
  >(AddCustomerContractCommentEventDocument, options);
}
export type AddCustomerContractCommentEventMutationHookResult = ReturnType<
  typeof useAddCustomerContractCommentEventMutation
>;
export namespace AddCustomerContractCommentEvent {
  export type Return = AddCustomerContractCommentEventMutation;
  export type Variables = AddCustomerContractCommentEventMutationVariables;
  export const OperationName = "AddCustomerContractCommentEvent";

  export const Document = AddCustomerContractCommentEventDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerEventLog_GetEventsDocument = gql`
  query CustomerEventLog_GetEvents($filter: CustomerEventFilter!) {
    customerEvents(filter: $filter) {
      ...EventLog_CustomerEvent
    }
  }
  ${EventLog_CustomerEventFragmentDoc}
`;
export type CustomerEventLog_GetEventsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerEventLog_GetEventsQuery,
    CustomerEventLog_GetEventsQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerEventLog_GetEventsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerEventLog_GetEventsComponent = (
  props: CustomerEventLog_GetEventsComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerEventLog_GetEventsQuery,
    CustomerEventLog_GetEventsQueryVariables
  >
    query={CustomerEventLog_GetEventsDocument}
    {...props}
  />
);

/**
 * __useCustomerEventLog_GetEventsQuery__
 *
 * To run a query within a React component, call `useCustomerEventLog_GetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerEventLog_GetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerEventLog_GetEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerEventLog_GetEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerEventLog_GetEventsQuery,
    CustomerEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerEventLog_GetEventsQuery,
    CustomerEventLog_GetEventsQueryVariables
  >(CustomerEventLog_GetEventsDocument, options);
}
export function useCustomerEventLog_GetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerEventLog_GetEventsQuery,
    CustomerEventLog_GetEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerEventLog_GetEventsQuery,
    CustomerEventLog_GetEventsQueryVariables
  >(CustomerEventLog_GetEventsDocument, options);
}
export type CustomerEventLog_GetEventsQueryHookResult = ReturnType<
  typeof useCustomerEventLog_GetEventsQuery
>;
export type CustomerEventLog_GetEventsLazyQueryHookResult = ReturnType<
  typeof useCustomerEventLog_GetEventsLazyQuery
>;
export namespace CustomerEventLog_GetEvents {
  export type Return = CustomerEventLog_GetEventsQuery;
  export type Variables = CustomerEventLog_GetEventsQueryVariables;
  export const OperationName = "CustomerEventLog_GetEvents";

  export const Document = CustomerEventLog_GetEventsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerEventLog_AddCustomerCommentDocument = gql`
  mutation CustomerEventLog_AddCustomerComment(
    $input: CustomerEventInput!
    $withTodo: WithTodoInput
  ) {
    addCustomerCommentEvent(input: $input, withTodo: $withTodo) {
      ...EventLog_CustomerEvent
    }
  }
  ${EventLog_CustomerEventFragmentDoc}
`;
export type CustomerEventLog_AddCustomerCommentMutationFn = Apollo.MutationFunction<
  CustomerEventLog_AddCustomerCommentMutation,
  CustomerEventLog_AddCustomerCommentMutationVariables
>;
export type CustomerEventLog_AddCustomerCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEventLog_AddCustomerCommentMutation,
    CustomerEventLog_AddCustomerCommentMutationVariables
  >,
  "mutation"
>;

export const CustomerEventLog_AddCustomerCommentComponent = (
  props: CustomerEventLog_AddCustomerCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEventLog_AddCustomerCommentMutation,
    CustomerEventLog_AddCustomerCommentMutationVariables
  >
    mutation={CustomerEventLog_AddCustomerCommentDocument}
    {...props}
  />
);

/**
 * __useCustomerEventLog_AddCustomerCommentMutation__
 *
 * To run a mutation, you first call `useCustomerEventLog_AddCustomerCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEventLog_AddCustomerCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEventLogAddCustomerCommentMutation, { data, loading, error }] = useCustomerEventLog_AddCustomerCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useCustomerEventLog_AddCustomerCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEventLog_AddCustomerCommentMutation,
    CustomerEventLog_AddCustomerCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEventLog_AddCustomerCommentMutation,
    CustomerEventLog_AddCustomerCommentMutationVariables
  >(CustomerEventLog_AddCustomerCommentDocument, options);
}
export type CustomerEventLog_AddCustomerCommentMutationHookResult = ReturnType<
  typeof useCustomerEventLog_AddCustomerCommentMutation
>;
export namespace CustomerEventLog_AddCustomerComment {
  export type Return = CustomerEventLog_AddCustomerCommentMutation;
  export type Variables = CustomerEventLog_AddCustomerCommentMutationVariables;
  export const OperationName = "CustomerEventLog_AddCustomerComment";

  export const Document = CustomerEventLog_AddCustomerCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerEventLog_AddCustomerReminderDocument = gql`
  mutation CustomerEventLog_AddCustomerReminder(
    $input: CustomerEventInput!
    $withTodo: WithTodoInput
  ) {
    addCustomerReminderEvent(input: $input, withTodo: $withTodo) {
      ...EventLog_CustomerEvent
    }
  }
  ${EventLog_CustomerEventFragmentDoc}
`;
export type CustomerEventLog_AddCustomerReminderMutationFn = Apollo.MutationFunction<
  CustomerEventLog_AddCustomerReminderMutation,
  CustomerEventLog_AddCustomerReminderMutationVariables
>;
export type CustomerEventLog_AddCustomerReminderComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEventLog_AddCustomerReminderMutation,
    CustomerEventLog_AddCustomerReminderMutationVariables
  >,
  "mutation"
>;

export const CustomerEventLog_AddCustomerReminderComponent = (
  props: CustomerEventLog_AddCustomerReminderComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEventLog_AddCustomerReminderMutation,
    CustomerEventLog_AddCustomerReminderMutationVariables
  >
    mutation={CustomerEventLog_AddCustomerReminderDocument}
    {...props}
  />
);

/**
 * __useCustomerEventLog_AddCustomerReminderMutation__
 *
 * To run a mutation, you first call `useCustomerEventLog_AddCustomerReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEventLog_AddCustomerReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEventLogAddCustomerReminderMutation, { data, loading, error }] = useCustomerEventLog_AddCustomerReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useCustomerEventLog_AddCustomerReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEventLog_AddCustomerReminderMutation,
    CustomerEventLog_AddCustomerReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEventLog_AddCustomerReminderMutation,
    CustomerEventLog_AddCustomerReminderMutationVariables
  >(CustomerEventLog_AddCustomerReminderDocument, options);
}
export type CustomerEventLog_AddCustomerReminderMutationHookResult = ReturnType<
  typeof useCustomerEventLog_AddCustomerReminderMutation
>;
export namespace CustomerEventLog_AddCustomerReminder {
  export type Return = CustomerEventLog_AddCustomerReminderMutation;
  export type Variables = CustomerEventLog_AddCustomerReminderMutationVariables;
  export const OperationName = "CustomerEventLog_AddCustomerReminder";

  export const Document = CustomerEventLog_AddCustomerReminderDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerEventLog_AddCustomerMetInPersonDocument = gql`
  mutation CustomerEventLog_AddCustomerMetInPerson(
    $input: CustomerEventInput!
    $withTodo: WithTodoInput
  ) {
    addCustomerMetInPersonEvent(input: $input, withTodo: $withTodo) {
      ...EventLog_CustomerEvent
    }
  }
  ${EventLog_CustomerEventFragmentDoc}
`;
export type CustomerEventLog_AddCustomerMetInPersonMutationFn = Apollo.MutationFunction<
  CustomerEventLog_AddCustomerMetInPersonMutation,
  CustomerEventLog_AddCustomerMetInPersonMutationVariables
>;
export type CustomerEventLog_AddCustomerMetInPersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEventLog_AddCustomerMetInPersonMutation,
    CustomerEventLog_AddCustomerMetInPersonMutationVariables
  >,
  "mutation"
>;

export const CustomerEventLog_AddCustomerMetInPersonComponent = (
  props: CustomerEventLog_AddCustomerMetInPersonComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEventLog_AddCustomerMetInPersonMutation,
    CustomerEventLog_AddCustomerMetInPersonMutationVariables
  >
    mutation={CustomerEventLog_AddCustomerMetInPersonDocument}
    {...props}
  />
);

/**
 * __useCustomerEventLog_AddCustomerMetInPersonMutation__
 *
 * To run a mutation, you first call `useCustomerEventLog_AddCustomerMetInPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEventLog_AddCustomerMetInPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEventLogAddCustomerMetInPersonMutation, { data, loading, error }] = useCustomerEventLog_AddCustomerMetInPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useCustomerEventLog_AddCustomerMetInPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEventLog_AddCustomerMetInPersonMutation,
    CustomerEventLog_AddCustomerMetInPersonMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEventLog_AddCustomerMetInPersonMutation,
    CustomerEventLog_AddCustomerMetInPersonMutationVariables
  >(CustomerEventLog_AddCustomerMetInPersonDocument, options);
}
export type CustomerEventLog_AddCustomerMetInPersonMutationHookResult = ReturnType<
  typeof useCustomerEventLog_AddCustomerMetInPersonMutation
>;
export namespace CustomerEventLog_AddCustomerMetInPerson {
  export type Return = CustomerEventLog_AddCustomerMetInPersonMutation;
  export type Variables = CustomerEventLog_AddCustomerMetInPersonMutationVariables;
  export const OperationName = "CustomerEventLog_AddCustomerMetInPerson";

  export const Document = CustomerEventLog_AddCustomerMetInPersonDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerEventLog_UpdateDocument = gql`
  mutation CustomerEventLog_Update($eventId: ObjectId!, $desc: String!) {
    updateCustomerEvent(eventId: $eventId, desc: $desc) {
      ...EventLog_CustomerEvent
    }
  }
  ${EventLog_CustomerEventFragmentDoc}
`;
export type CustomerEventLog_UpdateMutationFn = Apollo.MutationFunction<
  CustomerEventLog_UpdateMutation,
  CustomerEventLog_UpdateMutationVariables
>;
export type CustomerEventLog_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEventLog_UpdateMutation,
    CustomerEventLog_UpdateMutationVariables
  >,
  "mutation"
>;

export const CustomerEventLog_UpdateComponent = (
  props: CustomerEventLog_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEventLog_UpdateMutation,
    CustomerEventLog_UpdateMutationVariables
  >
    mutation={CustomerEventLog_UpdateDocument}
    {...props}
  />
);

/**
 * __useCustomerEventLog_UpdateMutation__
 *
 * To run a mutation, you first call `useCustomerEventLog_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEventLog_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEventLogUpdateMutation, { data, loading, error }] = useCustomerEventLog_UpdateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useCustomerEventLog_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEventLog_UpdateMutation,
    CustomerEventLog_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEventLog_UpdateMutation,
    CustomerEventLog_UpdateMutationVariables
  >(CustomerEventLog_UpdateDocument, options);
}
export type CustomerEventLog_UpdateMutationHookResult = ReturnType<
  typeof useCustomerEventLog_UpdateMutation
>;
export namespace CustomerEventLog_Update {
  export type Return = CustomerEventLog_UpdateMutation;
  export type Variables = CustomerEventLog_UpdateMutationVariables;
  export const OperationName = "CustomerEventLog_Update";

  export const Document = CustomerEventLog_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerEventLog_DeleteDocument = gql`
  mutation CustomerEventLog_Delete($eventId: ObjectId!) {
    deleteCustomerEvent(eventId: $eventId)
  }
`;
export type CustomerEventLog_DeleteMutationFn = Apollo.MutationFunction<
  CustomerEventLog_DeleteMutation,
  CustomerEventLog_DeleteMutationVariables
>;
export type CustomerEventLog_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEventLog_DeleteMutation,
    CustomerEventLog_DeleteMutationVariables
  >,
  "mutation"
>;

export const CustomerEventLog_DeleteComponent = (
  props: CustomerEventLog_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEventLog_DeleteMutation,
    CustomerEventLog_DeleteMutationVariables
  >
    mutation={CustomerEventLog_DeleteDocument}
    {...props}
  />
);

/**
 * __useCustomerEventLog_DeleteMutation__
 *
 * To run a mutation, you first call `useCustomerEventLog_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEventLog_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEventLogDeleteMutation, { data, loading, error }] = useCustomerEventLog_DeleteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCustomerEventLog_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEventLog_DeleteMutation,
    CustomerEventLog_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEventLog_DeleteMutation,
    CustomerEventLog_DeleteMutationVariables
  >(CustomerEventLog_DeleteDocument, options);
}
export type CustomerEventLog_DeleteMutationHookResult = ReturnType<
  typeof useCustomerEventLog_DeleteMutation
>;
export namespace CustomerEventLog_Delete {
  export type Return = CustomerEventLog_DeleteMutation;
  export type Variables = CustomerEventLog_DeleteMutationVariables;
  export const OperationName = "CustomerEventLog_Delete";

  export const Document = CustomerEventLog_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetTicketCommentsDocument = gql`
  query GetTicketComments($todoId: ObjectId!) {
    todoEvents(todoId: $todoId) {
      ...TicketEvent
    }
  }
  ${TicketEventFragmentDoc}
`;
export type GetTicketCommentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetTicketCommentsQuery,
    GetTicketCommentsQueryVariables
  >,
  "query"
> &
  ({ variables: GetTicketCommentsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetTicketCommentsComponent = (props: GetTicketCommentsComponentProps) => (
  <ApolloReactComponents.Query<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>
    query={GetTicketCommentsDocument}
    {...props}
  />
);

/**
 * __useGetTicketCommentsQuery__
 *
 * To run a query within a React component, call `useGetTicketCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketCommentsQuery({
 *   variables: {
 *      todoId: // value for 'todoId'
 *   },
 * });
 */
export function useGetTicketCommentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTicketCommentsQuery,
    GetTicketCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>(
    GetTicketCommentsDocument,
    options
  );
}
export function useGetTicketCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTicketCommentsQuery,
    GetTicketCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>(
    GetTicketCommentsDocument,
    options
  );
}
export type GetTicketCommentsQueryHookResult = ReturnType<
  typeof useGetTicketCommentsQuery
>;
export type GetTicketCommentsLazyQueryHookResult = ReturnType<
  typeof useGetTicketCommentsLazyQuery
>;
export namespace GetTicketComments {
  export type Return = GetTicketCommentsQuery;
  export type Variables = GetTicketCommentsQueryVariables;
  export const OperationName = "GetTicketComments";

  export const Document = GetTicketCommentsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const AddTicketCommentDocument = gql`
  mutation AddTicketComment($id: ObjectId!, $desc: String!) {
    addTodoCommentEvent(todoId: $id, desc: $desc) {
      ...TicketEvent
    }
  }
  ${TicketEventFragmentDoc}
`;
export type AddTicketCommentMutationFn = Apollo.MutationFunction<
  AddTicketCommentMutation,
  AddTicketCommentMutationVariables
>;
export type AddTicketCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddTicketCommentMutation,
    AddTicketCommentMutationVariables
  >,
  "mutation"
>;

export const AddTicketCommentComponent = (props: AddTicketCommentComponentProps) => (
  <ApolloReactComponents.Mutation<
    AddTicketCommentMutation,
    AddTicketCommentMutationVariables
  >
    mutation={AddTicketCommentDocument}
    {...props}
  />
);

/**
 * __useAddTicketCommentMutation__
 *
 * To run a mutation, you first call `useAddTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTicketCommentMutation, { data, loading, error }] = useAddTicketCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useAddTicketCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddTicketCommentMutation,
    AddTicketCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddTicketCommentMutation, AddTicketCommentMutationVariables>(
    AddTicketCommentDocument,
    options
  );
}
export type AddTicketCommentMutationHookResult = ReturnType<
  typeof useAddTicketCommentMutation
>;
export namespace AddTicketComment {
  export type Return = AddTicketCommentMutation;
  export type Variables = AddTicketCommentMutationVariables;
  export const OperationName = "AddTicketComment";

  export const Document = AddTicketCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AddTicketCommentWithReminderDocument = gql`
  mutation AddTicketCommentWithReminder(
    $id: ObjectId!
    $desc: String!
    $withTodo: WithTodoInput
  ) {
    addTodoReminderEvent(todoId: $id, desc: $desc, withTodo: $withTodo) {
      ...TicketEvent
    }
  }
  ${TicketEventFragmentDoc}
`;
export type AddTicketCommentWithReminderMutationFn = Apollo.MutationFunction<
  AddTicketCommentWithReminderMutation,
  AddTicketCommentWithReminderMutationVariables
>;
export type AddTicketCommentWithReminderComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AddTicketCommentWithReminderMutation,
    AddTicketCommentWithReminderMutationVariables
  >,
  "mutation"
>;

export const AddTicketCommentWithReminderComponent = (
  props: AddTicketCommentWithReminderComponentProps
) => (
  <ApolloReactComponents.Mutation<
    AddTicketCommentWithReminderMutation,
    AddTicketCommentWithReminderMutationVariables
  >
    mutation={AddTicketCommentWithReminderDocument}
    {...props}
  />
);

/**
 * __useAddTicketCommentWithReminderMutation__
 *
 * To run a mutation, you first call `useAddTicketCommentWithReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTicketCommentWithReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTicketCommentWithReminderMutation, { data, loading, error }] = useAddTicketCommentWithReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      desc: // value for 'desc'
 *      withTodo: // value for 'withTodo'
 *   },
 * });
 */
export function useAddTicketCommentWithReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddTicketCommentWithReminderMutation,
    AddTicketCommentWithReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddTicketCommentWithReminderMutation,
    AddTicketCommentWithReminderMutationVariables
  >(AddTicketCommentWithReminderDocument, options);
}
export type AddTicketCommentWithReminderMutationHookResult = ReturnType<
  typeof useAddTicketCommentWithReminderMutation
>;
export namespace AddTicketCommentWithReminder {
  export type Return = AddTicketCommentWithReminderMutation;
  export type Variables = AddTicketCommentWithReminderMutationVariables;
  export const OperationName = "AddTicketCommentWithReminder";

  export const Document = AddTicketCommentWithReminderDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateTicketCommentDocument = gql`
  mutation UpdateTicketComment($id: ObjectId!, $desc: String!) {
    updateTodoEvent(eventId: $id, desc: $desc) {
      ...TicketEvent
    }
  }
  ${TicketEventFragmentDoc}
`;
export type UpdateTicketCommentMutationFn = Apollo.MutationFunction<
  UpdateTicketCommentMutation,
  UpdateTicketCommentMutationVariables
>;
export type UpdateTicketCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateTicketCommentMutation,
    UpdateTicketCommentMutationVariables
  >,
  "mutation"
>;

export const UpdateTicketCommentComponent = (
  props: UpdateTicketCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpdateTicketCommentMutation,
    UpdateTicketCommentMutationVariables
  >
    mutation={UpdateTicketCommentDocument}
    {...props}
  />
);

/**
 * __useUpdateTicketCommentMutation__
 *
 * To run a mutation, you first call `useUpdateTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketCommentMutation, { data, loading, error }] = useUpdateTicketCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useUpdateTicketCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTicketCommentMutation,
    UpdateTicketCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTicketCommentMutation,
    UpdateTicketCommentMutationVariables
  >(UpdateTicketCommentDocument, options);
}
export type UpdateTicketCommentMutationHookResult = ReturnType<
  typeof useUpdateTicketCommentMutation
>;
export namespace UpdateTicketComment {
  export type Return = UpdateTicketCommentMutation;
  export type Variables = UpdateTicketCommentMutationVariables;
  export const OperationName = "UpdateTicketComment";

  export const Document = UpdateTicketCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteTicketCommentDocument = gql`
  mutation DeleteTicketComment($id: ObjectId!) {
    deleteTodoEvent(eventId: $id) {
      ...TicketEvent
    }
  }
  ${TicketEventFragmentDoc}
`;
export type DeleteTicketCommentMutationFn = Apollo.MutationFunction<
  DeleteTicketCommentMutation,
  DeleteTicketCommentMutationVariables
>;
export type DeleteTicketCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteTicketCommentMutation,
    DeleteTicketCommentMutationVariables
  >,
  "mutation"
>;

export const DeleteTicketCommentComponent = (
  props: DeleteTicketCommentComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteTicketCommentMutation,
    DeleteTicketCommentMutationVariables
  >
    mutation={DeleteTicketCommentDocument}
    {...props}
  />
);

/**
 * __useDeleteTicketCommentMutation__
 *
 * To run a mutation, you first call `useDeleteTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTicketCommentMutation, { data, loading, error }] = useDeleteTicketCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTicketCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTicketCommentMutation,
    DeleteTicketCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTicketCommentMutation,
    DeleteTicketCommentMutationVariables
  >(DeleteTicketCommentDocument, options);
}
export type DeleteTicketCommentMutationHookResult = ReturnType<
  typeof useDeleteTicketCommentMutation
>;
export namespace DeleteTicketComment {
  export type Return = DeleteTicketCommentMutation;
  export type Variables = DeleteTicketCommentMutationVariables;
  export const OperationName = "DeleteTicketComment";

  export const Document = DeleteTicketCommentDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetBookingAssignedToTotalDocument = gql`
  query getBookingAssignedToTotal {
    getBookingAssignedToTotal {
      total
      dbTime
    }
  }
`;
export type GetBookingAssignedToTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetBookingAssignedToTotalQuery,
    GetBookingAssignedToTotalQueryVariables
  >,
  "query"
>;

export const GetBookingAssignedToTotalComponent = (
  props: GetBookingAssignedToTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    GetBookingAssignedToTotalQuery,
    GetBookingAssignedToTotalQueryVariables
  >
    query={GetBookingAssignedToTotalDocument}
    {...props}
  />
);

/**
 * __useGetBookingAssignedToTotalQuery__
 *
 * To run a query within a React component, call `useGetBookingAssignedToTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAssignedToTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAssignedToTotalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingAssignedToTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBookingAssignedToTotalQuery,
    GetBookingAssignedToTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingAssignedToTotalQuery,
    GetBookingAssignedToTotalQueryVariables
  >(GetBookingAssignedToTotalDocument, options);
}
export function useGetBookingAssignedToTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingAssignedToTotalQuery,
    GetBookingAssignedToTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingAssignedToTotalQuery,
    GetBookingAssignedToTotalQueryVariables
  >(GetBookingAssignedToTotalDocument, options);
}
export type GetBookingAssignedToTotalQueryHookResult = ReturnType<
  typeof useGetBookingAssignedToTotalQuery
>;
export type GetBookingAssignedToTotalLazyQueryHookResult = ReturnType<
  typeof useGetBookingAssignedToTotalLazyQuery
>;
export namespace GetBookingAssignedToTotal {
  export type Return = GetBookingAssignedToTotalQuery;
  export type Variables = GetBookingAssignedToTotalQueryVariables;
  export const OperationName = "getBookingAssignedToTotal";

  export const Document = GetBookingAssignedToTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetBookingKitAssignedToTotalDocument = gql`
  query getBookingKitAssignedToTotal {
    getBookingKitAssignedToTotal {
      total
      dbTime
    }
  }
`;
export type GetBookingKitAssignedToTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetBookingKitAssignedToTotalQuery,
    GetBookingKitAssignedToTotalQueryVariables
  >,
  "query"
>;

export const GetBookingKitAssignedToTotalComponent = (
  props: GetBookingKitAssignedToTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    GetBookingKitAssignedToTotalQuery,
    GetBookingKitAssignedToTotalQueryVariables
  >
    query={GetBookingKitAssignedToTotalDocument}
    {...props}
  />
);

/**
 * __useGetBookingKitAssignedToTotalQuery__
 *
 * To run a query within a React component, call `useGetBookingKitAssignedToTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingKitAssignedToTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingKitAssignedToTotalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingKitAssignedToTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBookingKitAssignedToTotalQuery,
    GetBookingKitAssignedToTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingKitAssignedToTotalQuery,
    GetBookingKitAssignedToTotalQueryVariables
  >(GetBookingKitAssignedToTotalDocument, options);
}
export function useGetBookingKitAssignedToTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingKitAssignedToTotalQuery,
    GetBookingKitAssignedToTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingKitAssignedToTotalQuery,
    GetBookingKitAssignedToTotalQueryVariables
  >(GetBookingKitAssignedToTotalDocument, options);
}
export type GetBookingKitAssignedToTotalQueryHookResult = ReturnType<
  typeof useGetBookingKitAssignedToTotalQuery
>;
export type GetBookingKitAssignedToTotalLazyQueryHookResult = ReturnType<
  typeof useGetBookingKitAssignedToTotalLazyQuery
>;
export namespace GetBookingKitAssignedToTotal {
  export type Return = GetBookingKitAssignedToTotalQuery;
  export type Variables = GetBookingKitAssignedToTotalQueryVariables;
  export const OperationName = "getBookingKitAssignedToTotal";

  export const Document = GetBookingKitAssignedToTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const MassContactActions_SendSMSDocument = gql`
  mutation MassContactActions_SendSMS($message: String!, $consultantIds: [ObjectId!]!) {
    sendMassSMSToConsultants(message: $message, consultantIds: $consultantIds) {
      ...MassContactActions_SMSResult
    }
  }
  ${MassContactActions_SMSResultFragmentDoc}
`;
export type MassContactActions_SendSMSMutationFn = Apollo.MutationFunction<
  MassContactActions_SendSMSMutation,
  MassContactActions_SendSMSMutationVariables
>;
export type MassContactActions_SendSMSComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MassContactActions_SendSMSMutation,
    MassContactActions_SendSMSMutationVariables
  >,
  "mutation"
>;

export const MassContactActions_SendSMSComponent = (
  props: MassContactActions_SendSMSComponentProps
) => (
  <ApolloReactComponents.Mutation<
    MassContactActions_SendSMSMutation,
    MassContactActions_SendSMSMutationVariables
  >
    mutation={MassContactActions_SendSMSDocument}
    {...props}
  />
);

/**
 * __useMassContactActions_SendSMSMutation__
 *
 * To run a mutation, you first call `useMassContactActions_SendSMSMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassContactActions_SendSMSMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massContactActionsSendSmsMutation, { data, loading, error }] = useMassContactActions_SendSMSMutation({
 *   variables: {
 *      message: // value for 'message'
 *      consultantIds: // value for 'consultantIds'
 *   },
 * });
 */
export function useMassContactActions_SendSMSMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MassContactActions_SendSMSMutation,
    MassContactActions_SendSMSMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MassContactActions_SendSMSMutation,
    MassContactActions_SendSMSMutationVariables
  >(MassContactActions_SendSMSDocument, options);
}
export type MassContactActions_SendSMSMutationHookResult = ReturnType<
  typeof useMassContactActions_SendSMSMutation
>;
export namespace MassContactActions_SendSMS {
  export type Return = MassContactActions_SendSMSMutation;
  export type Variables = MassContactActions_SendSMSMutationVariables;
  export const OperationName = "MassContactActions_SendSMS";

  export const Document = MassContactActions_SendSMSDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MassContactActions_UpdateResponsiblePersonDocument = gql`
  mutation MassContactActions_UpdateResponsiblePerson(
    $ids: [ObjectId!]!
    $responsiblePersonId: ObjectId
  ) {
    bulkUpdateResponsiblePerson(ids: $ids, responsiblePersonId: $responsiblePersonId) {
      consultants {
        _id
        ResponsiblePerson {
          Name
          PersonId
        }
      }
      updated
    }
  }
`;
export type MassContactActions_UpdateResponsiblePersonMutationFn =
  Apollo.MutationFunction<
    MassContactActions_UpdateResponsiblePersonMutation,
    MassContactActions_UpdateResponsiblePersonMutationVariables
  >;
export type MassContactActions_UpdateResponsiblePersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MassContactActions_UpdateResponsiblePersonMutation,
    MassContactActions_UpdateResponsiblePersonMutationVariables
  >,
  "mutation"
>;

export const MassContactActions_UpdateResponsiblePersonComponent = (
  props: MassContactActions_UpdateResponsiblePersonComponentProps
) => (
  <ApolloReactComponents.Mutation<
    MassContactActions_UpdateResponsiblePersonMutation,
    MassContactActions_UpdateResponsiblePersonMutationVariables
  >
    mutation={MassContactActions_UpdateResponsiblePersonDocument}
    {...props}
  />
);

/**
 * __useMassContactActions_UpdateResponsiblePersonMutation__
 *
 * To run a mutation, you first call `useMassContactActions_UpdateResponsiblePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassContactActions_UpdateResponsiblePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massContactActionsUpdateResponsiblePersonMutation, { data, loading, error }] = useMassContactActions_UpdateResponsiblePersonMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      responsiblePersonId: // value for 'responsiblePersonId'
 *   },
 * });
 */
export function useMassContactActions_UpdateResponsiblePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MassContactActions_UpdateResponsiblePersonMutation,
    MassContactActions_UpdateResponsiblePersonMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MassContactActions_UpdateResponsiblePersonMutation,
    MassContactActions_UpdateResponsiblePersonMutationVariables
  >(MassContactActions_UpdateResponsiblePersonDocument, options);
}
export type MassContactActions_UpdateResponsiblePersonMutationHookResult = ReturnType<
  typeof useMassContactActions_UpdateResponsiblePersonMutation
>;
export namespace MassContactActions_UpdateResponsiblePerson {
  export type Return = MassContactActions_UpdateResponsiblePersonMutation;
  export type Variables = MassContactActions_UpdateResponsiblePersonMutationVariables;
  export const OperationName = "MassContactActions_UpdateResponsiblePerson";

  export const Document = MassContactActions_UpdateResponsiblePersonDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MassContactActions_SendEmailDocument = gql`
  mutation MassContactActions_SendEmail(
    $nodeType: NodeType!
    $nodeIds: [ObjectId!]!
    $subject: String!
    $body: String!
    $attachment: [ObjectId]
    $campaign: Boolean
  ) {
    sendMassEmail(
      nodeType: $nodeType
      nodeIds: $nodeIds
      subject: $subject
      body: $body
      attachment: $attachment
      campaign: $campaign
    ) {
      Subject
      Body
    }
  }
`;
export type MassContactActions_SendEmailMutationFn = Apollo.MutationFunction<
  MassContactActions_SendEmailMutation,
  MassContactActions_SendEmailMutationVariables
>;
export type MassContactActions_SendEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MassContactActions_SendEmailMutation,
    MassContactActions_SendEmailMutationVariables
  >,
  "mutation"
>;

export const MassContactActions_SendEmailComponent = (
  props: MassContactActions_SendEmailComponentProps
) => (
  <ApolloReactComponents.Mutation<
    MassContactActions_SendEmailMutation,
    MassContactActions_SendEmailMutationVariables
  >
    mutation={MassContactActions_SendEmailDocument}
    {...props}
  />
);

/**
 * __useMassContactActions_SendEmailMutation__
 *
 * To run a mutation, you first call `useMassContactActions_SendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassContactActions_SendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massContactActionsSendEmailMutation, { data, loading, error }] = useMassContactActions_SendEmailMutation({
 *   variables: {
 *      nodeType: // value for 'nodeType'
 *      nodeIds: // value for 'nodeIds'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      attachment: // value for 'attachment'
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useMassContactActions_SendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MassContactActions_SendEmailMutation,
    MassContactActions_SendEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MassContactActions_SendEmailMutation,
    MassContactActions_SendEmailMutationVariables
  >(MassContactActions_SendEmailDocument, options);
}
export type MassContactActions_SendEmailMutationHookResult = ReturnType<
  typeof useMassContactActions_SendEmailMutation
>;
export namespace MassContactActions_SendEmail {
  export type Return = MassContactActions_SendEmailMutation;
  export type Variables = MassContactActions_SendEmailMutationVariables;
  export const OperationName = "MassContactActions_SendEmail";

  export const Document = MassContactActions_SendEmailDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MassContactActions_DeleteDocument = gql`
  mutation MassContactActions_Delete($ids: [ObjectId!]!) {
    deleteConsultants(ids: $ids) {
      total
    }
  }
`;
export type MassContactActions_DeleteMutationFn = Apollo.MutationFunction<
  MassContactActions_DeleteMutation,
  MassContactActions_DeleteMutationVariables
>;
export type MassContactActions_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MassContactActions_DeleteMutation,
    MassContactActions_DeleteMutationVariables
  >,
  "mutation"
>;

export const MassContactActions_DeleteComponent = (
  props: MassContactActions_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    MassContactActions_DeleteMutation,
    MassContactActions_DeleteMutationVariables
  >
    mutation={MassContactActions_DeleteDocument}
    {...props}
  />
);

/**
 * __useMassContactActions_DeleteMutation__
 *
 * To run a mutation, you first call `useMassContactActions_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassContactActions_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massContactActionsDeleteMutation, { data, loading, error }] = useMassContactActions_DeleteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMassContactActions_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MassContactActions_DeleteMutation,
    MassContactActions_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MassContactActions_DeleteMutation,
    MassContactActions_DeleteMutationVariables
  >(MassContactActions_DeleteDocument, options);
}
export type MassContactActions_DeleteMutationHookResult = ReturnType<
  typeof useMassContactActions_DeleteMutation
>;
export namespace MassContactActions_Delete {
  export type Return = MassContactActions_DeleteMutation;
  export type Variables = MassContactActions_DeleteMutationVariables;
  export const OperationName = "MassContactActions_Delete";

  export const Document = MassContactActions_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MassContactActions_SMSDocument = gql`
  subscription MassContactActions_SMS($messageId: ObjectId!) {
    smsMessageUpdated(id: $messageId) {
      _id
      Status
    }
  }
`;
export type MassContactActions_SMSComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    MassContactActions_SMSSubscription,
    MassContactActions_SMSSubscriptionVariables
  >,
  "subscription"
>;

export const MassContactActions_SMSComponent = (
  props: MassContactActions_SMSComponentProps
) => (
  <ApolloReactComponents.Subscription<
    MassContactActions_SMSSubscription,
    MassContactActions_SMSSubscriptionVariables
  >
    subscription={MassContactActions_SMSDocument}
    {...props}
  />
);

/**
 * __useMassContactActions_SMSSubscription__
 *
 * To run a query within a React component, call `useMassContactActions_SMSSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMassContactActions_SMSSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassContactActions_SMSSubscription({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMassContactActions_SMSSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MassContactActions_SMSSubscription,
    MassContactActions_SMSSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MassContactActions_SMSSubscription,
    MassContactActions_SMSSubscriptionVariables
  >(MassContactActions_SMSDocument, options);
}
export type MassContactActions_SMSSubscriptionHookResult = ReturnType<
  typeof useMassContactActions_SMSSubscription
>;
export namespace MassContactActions_SMS {
  export type Return = MassContactActions_SMSSubscription;
  export type Variables = MassContactActions_SMSSubscriptionVariables;
  export const OperationName = "MassContactActions_SMS";

  export const Document = MassContactActions_SMSDocument;
  export const { func } = subscription<Variables, Return>(Document, getClient);
}
export const MassContactActions_ExportCSVDocument = gql`
  query MassContactActions_exportCSV($ids: [ObjectId!]!) {
    consultantsCSV(ids: $ids) {
      Filename
      URL
    }
  }
`;
export type MassContactActions_ExportCSVComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    MassContactActions_ExportCSVQuery,
    MassContactActions_ExportCSVQueryVariables
  >,
  "query"
> &
  (
    | { variables: MassContactActions_ExportCSVQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const MassContactActions_ExportCSVComponent = (
  props: MassContactActions_ExportCSVComponentProps
) => (
  <ApolloReactComponents.Query<
    MassContactActions_ExportCSVQuery,
    MassContactActions_ExportCSVQueryVariables
  >
    query={MassContactActions_ExportCSVDocument}
    {...props}
  />
);

/**
 * __useMassContactActions_ExportCSVQuery__
 *
 * To run a query within a React component, call `useMassContactActions_ExportCSVQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassContactActions_ExportCSVQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassContactActions_ExportCSVQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMassContactActions_ExportCSVQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MassContactActions_ExportCSVQuery,
    MassContactActions_ExportCSVQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MassContactActions_ExportCSVQuery,
    MassContactActions_ExportCSVQueryVariables
  >(MassContactActions_ExportCSVDocument, options);
}
export function useMassContactActions_ExportCSVLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MassContactActions_ExportCSVQuery,
    MassContactActions_ExportCSVQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MassContactActions_ExportCSVQuery,
    MassContactActions_ExportCSVQueryVariables
  >(MassContactActions_ExportCSVDocument, options);
}
export type MassContactActions_ExportCSVQueryHookResult = ReturnType<
  typeof useMassContactActions_ExportCSVQuery
>;
export type MassContactActions_ExportCSVLazyQueryHookResult = ReturnType<
  typeof useMassContactActions_ExportCSVLazyQuery
>;
export namespace MassContactActions_exportCSV {
  export type Return = MassContactActions_ExportCSVQuery;
  export type Variables = MassContactActions_ExportCSVQueryVariables;
  export const OperationName = "MassContactActions_exportCSV";

  export const Document = MassContactActions_ExportCSVDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const NodeCallList_AddDocument = gql`
  mutation NodeCallList_Add($id: ObjectId!, $node: NodeRefFullInput!) {
    addToCallList(callListId: $id, node: $node) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type NodeCallList_AddMutationFn = Apollo.MutationFunction<
  NodeCallList_AddMutation,
  NodeCallList_AddMutationVariables
>;
export type NodeCallList_AddComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NodeCallList_AddMutation,
    NodeCallList_AddMutationVariables
  >,
  "mutation"
>;

export const NodeCallList_AddComponent = (props: NodeCallList_AddComponentProps) => (
  <ApolloReactComponents.Mutation<
    NodeCallList_AddMutation,
    NodeCallList_AddMutationVariables
  >
    mutation={NodeCallList_AddDocument}
    {...props}
  />
);

/**
 * __useNodeCallList_AddMutation__
 *
 * To run a mutation, you first call `useNodeCallList_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNodeCallList_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nodeCallListAddMutation, { data, loading, error }] = useNodeCallList_AddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      node: // value for 'node'
 *   },
 * });
 */
export function useNodeCallList_AddMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NodeCallList_AddMutation,
    NodeCallList_AddMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<NodeCallList_AddMutation, NodeCallList_AddMutationVariables>(
    NodeCallList_AddDocument,
    options
  );
}
export type NodeCallList_AddMutationHookResult = ReturnType<
  typeof useNodeCallList_AddMutation
>;
export namespace NodeCallList_Add {
  export type Return = NodeCallList_AddMutation;
  export type Variables = NodeCallList_AddMutationVariables;
  export const OperationName = "NodeCallList_Add";

  export const Document = NodeCallList_AddDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const NodeCallList_RemoveDocument = gql`
  mutation NodeCallList_Remove($id: ObjectId!, $nodeId: ObjectId!) {
    removeFromCallList(callListId: $id, nodeId: $nodeId) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type NodeCallList_RemoveMutationFn = Apollo.MutationFunction<
  NodeCallList_RemoveMutation,
  NodeCallList_RemoveMutationVariables
>;
export type NodeCallList_RemoveComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NodeCallList_RemoveMutation,
    NodeCallList_RemoveMutationVariables
  >,
  "mutation"
>;

export const NodeCallList_RemoveComponent = (
  props: NodeCallList_RemoveComponentProps
) => (
  <ApolloReactComponents.Mutation<
    NodeCallList_RemoveMutation,
    NodeCallList_RemoveMutationVariables
  >
    mutation={NodeCallList_RemoveDocument}
    {...props}
  />
);

/**
 * __useNodeCallList_RemoveMutation__
 *
 * To run a mutation, you first call `useNodeCallList_RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNodeCallList_RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nodeCallListRemoveMutation, { data, loading, error }] = useNodeCallList_RemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useNodeCallList_RemoveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NodeCallList_RemoveMutation,
    NodeCallList_RemoveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NodeCallList_RemoveMutation,
    NodeCallList_RemoveMutationVariables
  >(NodeCallList_RemoveDocument, options);
}
export type NodeCallList_RemoveMutationHookResult = ReturnType<
  typeof useNodeCallList_RemoveMutation
>;
export namespace NodeCallList_Remove {
  export type Return = NodeCallList_RemoveMutation;
  export type Variables = NodeCallList_RemoveMutationVariables;
  export const OperationName = "NodeCallList_Remove";

  export const Document = NodeCallList_RemoveDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const NodeCallList_LeaveListDocument = gql`
  mutation NodeCallList_LeaveList($id: ObjectId!) {
    leaveCallList(callListId: $id) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type NodeCallList_LeaveListMutationFn = Apollo.MutationFunction<
  NodeCallList_LeaveListMutation,
  NodeCallList_LeaveListMutationVariables
>;
export type NodeCallList_LeaveListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    NodeCallList_LeaveListMutation,
    NodeCallList_LeaveListMutationVariables
  >,
  "mutation"
>;

export const NodeCallList_LeaveListComponent = (
  props: NodeCallList_LeaveListComponentProps
) => (
  <ApolloReactComponents.Mutation<
    NodeCallList_LeaveListMutation,
    NodeCallList_LeaveListMutationVariables
  >
    mutation={NodeCallList_LeaveListDocument}
    {...props}
  />
);

/**
 * __useNodeCallList_LeaveListMutation__
 *
 * To run a mutation, you first call `useNodeCallList_LeaveListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNodeCallList_LeaveListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nodeCallListLeaveListMutation, { data, loading, error }] = useNodeCallList_LeaveListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNodeCallList_LeaveListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NodeCallList_LeaveListMutation,
    NodeCallList_LeaveListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NodeCallList_LeaveListMutation,
    NodeCallList_LeaveListMutationVariables
  >(NodeCallList_LeaveListDocument, options);
}
export type NodeCallList_LeaveListMutationHookResult = ReturnType<
  typeof useNodeCallList_LeaveListMutation
>;
export namespace NodeCallList_LeaveList {
  export type Return = NodeCallList_LeaveListMutation;
  export type Variables = NodeCallList_LeaveListMutationVariables;
  export const OperationName = "NodeCallList_LeaveList";

  export const Document = NodeCallList_LeaveListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SetCallListMembrsDocument = gql`
  mutation SetCallListMembrs($callListId: ObjectId!, $userIds: [ObjectId!]!) {
    setCallListMembers(callListId: $callListId, userIds: $userIds) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type SetCallListMembrsMutationFn = Apollo.MutationFunction<
  SetCallListMembrsMutation,
  SetCallListMembrsMutationVariables
>;
export type SetCallListMembrsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetCallListMembrsMutation,
    SetCallListMembrsMutationVariables
  >,
  "mutation"
>;

export const SetCallListMembrsComponent = (props: SetCallListMembrsComponentProps) => (
  <ApolloReactComponents.Mutation<
    SetCallListMembrsMutation,
    SetCallListMembrsMutationVariables
  >
    mutation={SetCallListMembrsDocument}
    {...props}
  />
);

/**
 * __useSetCallListMembrsMutation__
 *
 * To run a mutation, you first call `useSetCallListMembrsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCallListMembrsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCallListMembrsMutation, { data, loading, error }] = useSetCallListMembrsMutation({
 *   variables: {
 *      callListId: // value for 'callListId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useSetCallListMembrsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCallListMembrsMutation,
    SetCallListMembrsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCallListMembrsMutation,
    SetCallListMembrsMutationVariables
  >(SetCallListMembrsDocument, options);
}
export type SetCallListMembrsMutationHookResult = ReturnType<
  typeof useSetCallListMembrsMutation
>;
export namespace SetCallListMembrs {
  export type Return = SetCallListMembrsMutation;
  export type Variables = SetCallListMembrsMutationVariables;
  export const OperationName = "SetCallListMembrs";

  export const Document = SetCallListMembrsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const NodeCallList_GetByIdDocument = gql`
  query NodeCallList_GetById($id: ObjectId!) {
    callListById(id: $id) {
      callList {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type NodeCallList_GetByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    NodeCallList_GetByIdQuery,
    NodeCallList_GetByIdQueryVariables
  >,
  "query"
> &
  ({ variables: NodeCallList_GetByIdQueryVariables; skip?: boolean } | { skip: boolean });

export const NodeCallList_GetByIdComponent = (
  props: NodeCallList_GetByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    NodeCallList_GetByIdQuery,
    NodeCallList_GetByIdQueryVariables
  >
    query={NodeCallList_GetByIdDocument}
    {...props}
  />
);

/**
 * __useNodeCallList_GetByIdQuery__
 *
 * To run a query within a React component, call `useNodeCallList_GetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeCallList_GetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeCallList_GetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNodeCallList_GetByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NodeCallList_GetByIdQuery,
    NodeCallList_GetByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NodeCallList_GetByIdQuery, NodeCallList_GetByIdQueryVariables>(
    NodeCallList_GetByIdDocument,
    options
  );
}
export function useNodeCallList_GetByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeCallList_GetByIdQuery,
    NodeCallList_GetByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NodeCallList_GetByIdQuery,
    NodeCallList_GetByIdQueryVariables
  >(NodeCallList_GetByIdDocument, options);
}
export type NodeCallList_GetByIdQueryHookResult = ReturnType<
  typeof useNodeCallList_GetByIdQuery
>;
export type NodeCallList_GetByIdLazyQueryHookResult = ReturnType<
  typeof useNodeCallList_GetByIdLazyQuery
>;
export namespace NodeCallList_GetById {
  export type Return = NodeCallList_GetByIdQuery;
  export type Variables = NodeCallList_GetByIdQueryVariables;
  export const OperationName = "NodeCallList_GetById";

  export const Document = NodeCallList_GetByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const NodeCallList_GetListsDocument = gql`
  query NodeCallList_GetLists {
    me {
      _id
      CallLists {
        ...NodeCallList
      }
      ContactLists {
        ...NodeCallList
      }
    }
  }
  ${NodeCallListFragmentDoc}
`;
export type NodeCallList_GetListsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    NodeCallList_GetListsQuery,
    NodeCallList_GetListsQueryVariables
  >,
  "query"
>;

export const NodeCallList_GetListsComponent = (
  props: NodeCallList_GetListsComponentProps
) => (
  <ApolloReactComponents.Query<
    NodeCallList_GetListsQuery,
    NodeCallList_GetListsQueryVariables
  >
    query={NodeCallList_GetListsDocument}
    {...props}
  />
);

/**
 * __useNodeCallList_GetListsQuery__
 *
 * To run a query within a React component, call `useNodeCallList_GetListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeCallList_GetListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeCallList_GetListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNodeCallList_GetListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NodeCallList_GetListsQuery,
    NodeCallList_GetListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NodeCallList_GetListsQuery, NodeCallList_GetListsQueryVariables>(
    NodeCallList_GetListsDocument,
    options
  );
}
export function useNodeCallList_GetListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeCallList_GetListsQuery,
    NodeCallList_GetListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NodeCallList_GetListsQuery,
    NodeCallList_GetListsQueryVariables
  >(NodeCallList_GetListsDocument, options);
}
export type NodeCallList_GetListsQueryHookResult = ReturnType<
  typeof useNodeCallList_GetListsQuery
>;
export type NodeCallList_GetListsLazyQueryHookResult = ReturnType<
  typeof useNodeCallList_GetListsLazyQuery
>;
export namespace NodeCallList_GetLists {
  export type Return = NodeCallList_GetListsQuery;
  export type Variables = NodeCallList_GetListsQueryVariables;
  export const OperationName = "NodeCallList_GetLists";

  export const Document = NodeCallList_GetListsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetUserSelectorUsersDocument = gql`
  query getUserSelectorUsers {
    users {
      ...User
    }
    teams {
      _id
      Name
    }
  }
  ${UserFragmentDoc}
`;
export type GetUserSelectorUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserSelectorUsersQuery,
    GetUserSelectorUsersQueryVariables
  >,
  "query"
>;

export const GetUserSelectorUsersComponent = (
  props: GetUserSelectorUsersComponentProps
) => (
  <ApolloReactComponents.Query<
    GetUserSelectorUsersQuery,
    GetUserSelectorUsersQueryVariables
  >
    query={GetUserSelectorUsersDocument}
    {...props}
  />
);

/**
 * __useGetUserSelectorUsersQuery__
 *
 * To run a query within a React component, call `useGetUserSelectorUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSelectorUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSelectorUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSelectorUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserSelectorUsersQuery,
    GetUserSelectorUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserSelectorUsersQuery, GetUserSelectorUsersQueryVariables>(
    GetUserSelectorUsersDocument,
    options
  );
}
export function useGetUserSelectorUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserSelectorUsersQuery,
    GetUserSelectorUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserSelectorUsersQuery,
    GetUserSelectorUsersQueryVariables
  >(GetUserSelectorUsersDocument, options);
}
export type GetUserSelectorUsersQueryHookResult = ReturnType<
  typeof useGetUserSelectorUsersQuery
>;
export type GetUserSelectorUsersLazyQueryHookResult = ReturnType<
  typeof useGetUserSelectorUsersLazyQuery
>;
export namespace GetUserSelectorUsers {
  export type Return = GetUserSelectorUsersQuery;
  export type Variables = GetUserSelectorUsersQueryVariables;
  export const OperationName = "getUserSelectorUsers";

  export const Document = GetUserSelectorUsersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetAccommodationSelectorItemsDocument = gql`
  query getAccommodationSelectorItems(
    $input: AccommodationFilter!
    $skip: Int!
    $limit: Int!
  ) {
    getAccommodations(input: $input, skip: $skip, limit: $limit) {
      ...AccommodationSelectorItem
    }
  }
  ${AccommodationSelectorItemFragmentDoc}
`;
export type GetAccommodationSelectorItemsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAccommodationSelectorItemsQuery,
    GetAccommodationSelectorItemsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetAccommodationSelectorItemsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetAccommodationSelectorItemsComponent = (
  props: GetAccommodationSelectorItemsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAccommodationSelectorItemsQuery,
    GetAccommodationSelectorItemsQueryVariables
  >
    query={GetAccommodationSelectorItemsDocument}
    {...props}
  />
);

/**
 * __useGetAccommodationSelectorItemsQuery__
 *
 * To run a query within a React component, call `useGetAccommodationSelectorItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccommodationSelectorItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccommodationSelectorItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccommodationSelectorItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccommodationSelectorItemsQuery,
    GetAccommodationSelectorItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccommodationSelectorItemsQuery,
    GetAccommodationSelectorItemsQueryVariables
  >(GetAccommodationSelectorItemsDocument, options);
}
export function useGetAccommodationSelectorItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccommodationSelectorItemsQuery,
    GetAccommodationSelectorItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccommodationSelectorItemsQuery,
    GetAccommodationSelectorItemsQueryVariables
  >(GetAccommodationSelectorItemsDocument, options);
}
export type GetAccommodationSelectorItemsQueryHookResult = ReturnType<
  typeof useGetAccommodationSelectorItemsQuery
>;
export type GetAccommodationSelectorItemsLazyQueryHookResult = ReturnType<
  typeof useGetAccommodationSelectorItemsLazyQuery
>;
export namespace GetAccommodationSelectorItems {
  export type Return = GetAccommodationSelectorItemsQuery;
  export type Variables = GetAccommodationSelectorItemsQueryVariables;
  export const OperationName = "getAccommodationSelectorItems";

  export const Document = GetAccommodationSelectorItemsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetAccommodationSelectorValueDocument = gql`
  query getAccommodationSelectorValue($id: ObjectId!) {
    getAccommodationDetails(accommodationId: $id) {
      _id
      ...AccommodationCardDetails
    }
  }
  ${AccommodationCardDetailsFragmentDoc}
`;
export type GetAccommodationSelectorValueComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAccommodationSelectorValueQuery,
    GetAccommodationSelectorValueQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetAccommodationSelectorValueQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetAccommodationSelectorValueComponent = (
  props: GetAccommodationSelectorValueComponentProps
) => (
  <ApolloReactComponents.Query<
    GetAccommodationSelectorValueQuery,
    GetAccommodationSelectorValueQueryVariables
  >
    query={GetAccommodationSelectorValueDocument}
    {...props}
  />
);

/**
 * __useGetAccommodationSelectorValueQuery__
 *
 * To run a query within a React component, call `useGetAccommodationSelectorValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccommodationSelectorValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccommodationSelectorValueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccommodationSelectorValueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccommodationSelectorValueQuery,
    GetAccommodationSelectorValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccommodationSelectorValueQuery,
    GetAccommodationSelectorValueQueryVariables
  >(GetAccommodationSelectorValueDocument, options);
}
export function useGetAccommodationSelectorValueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccommodationSelectorValueQuery,
    GetAccommodationSelectorValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccommodationSelectorValueQuery,
    GetAccommodationSelectorValueQueryVariables
  >(GetAccommodationSelectorValueDocument, options);
}
export type GetAccommodationSelectorValueQueryHookResult = ReturnType<
  typeof useGetAccommodationSelectorValueQuery
>;
export type GetAccommodationSelectorValueLazyQueryHookResult = ReturnType<
  typeof useGetAccommodationSelectorValueLazyQuery
>;
export namespace GetAccommodationSelectorValue {
  export type Return = GetAccommodationSelectorValueQuery;
  export type Variables = GetAccommodationSelectorValueQueryVariables;
  export const OperationName = "getAccommodationSelectorValue";

  export const Document = GetAccommodationSelectorValueDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantSelector_GetValueDocument = gql`
  query ConsultantSelector_GetValue($id: ObjectId!) {
    consultantById(id: $id) {
      ...ConsultantSelectorSearchCard
    }
  }
  ${ConsultantSelectorSearchCardFragmentDoc}
`;
export type ConsultantSelector_GetValueComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantSelector_GetValueQuery,
    ConsultantSelector_GetValueQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantSelector_GetValueQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantSelector_GetValueComponent = (
  props: ConsultantSelector_GetValueComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantSelector_GetValueQuery,
    ConsultantSelector_GetValueQueryVariables
  >
    query={ConsultantSelector_GetValueDocument}
    {...props}
  />
);

/**
 * __useConsultantSelector_GetValueQuery__
 *
 * To run a query within a React component, call `useConsultantSelector_GetValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantSelector_GetValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantSelector_GetValueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultantSelector_GetValueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantSelector_GetValueQuery,
    ConsultantSelector_GetValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantSelector_GetValueQuery,
    ConsultantSelector_GetValueQueryVariables
  >(ConsultantSelector_GetValueDocument, options);
}
export function useConsultantSelector_GetValueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantSelector_GetValueQuery,
    ConsultantSelector_GetValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantSelector_GetValueQuery,
    ConsultantSelector_GetValueQueryVariables
  >(ConsultantSelector_GetValueDocument, options);
}
export type ConsultantSelector_GetValueQueryHookResult = ReturnType<
  typeof useConsultantSelector_GetValueQuery
>;
export type ConsultantSelector_GetValueLazyQueryHookResult = ReturnType<
  typeof useConsultantSelector_GetValueLazyQuery
>;
export namespace ConsultantSelector_GetValue {
  export type Return = ConsultantSelector_GetValueQuery;
  export type Variables = ConsultantSelector_GetValueQueryVariables;
  export const OperationName = "ConsultantSelector_GetValue";

  export const Document = ConsultantSelector_GetValueDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ConsultantSelector_SearchDocument = gql`
  query ConsultantSelector_Search(
    $filter: ConsultantsQueryInput!
    $skip: Int
    $limit: Int
  ) {
    consultantsFast(filter: $filter, limit: $limit, skip: $skip) {
      items {
        ...ConsultantSelectorSearchCard
      }
      dbTime
    }
  }
  ${ConsultantSelectorSearchCardFragmentDoc}
`;
export type ConsultantSelector_SearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ConsultantSelector_SearchQuery,
    ConsultantSelector_SearchQueryVariables
  >,
  "query"
> &
  (
    | { variables: ConsultantSelector_SearchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ConsultantSelector_SearchComponent = (
  props: ConsultantSelector_SearchComponentProps
) => (
  <ApolloReactComponents.Query<
    ConsultantSelector_SearchQuery,
    ConsultantSelector_SearchQueryVariables
  >
    query={ConsultantSelector_SearchDocument}
    {...props}
  />
);

/**
 * __useConsultantSelector_SearchQuery__
 *
 * To run a query within a React component, call `useConsultantSelector_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantSelector_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantSelector_SearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useConsultantSelector_SearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConsultantSelector_SearchQuery,
    ConsultantSelector_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConsultantSelector_SearchQuery,
    ConsultantSelector_SearchQueryVariables
  >(ConsultantSelector_SearchDocument, options);
}
export function useConsultantSelector_SearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsultantSelector_SearchQuery,
    ConsultantSelector_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConsultantSelector_SearchQuery,
    ConsultantSelector_SearchQueryVariables
  >(ConsultantSelector_SearchDocument, options);
}
export type ConsultantSelector_SearchQueryHookResult = ReturnType<
  typeof useConsultantSelector_SearchQuery
>;
export type ConsultantSelector_SearchLazyQueryHookResult = ReturnType<
  typeof useConsultantSelector_SearchLazyQuery
>;
export namespace ConsultantSelector_Search {
  export type Return = ConsultantSelector_SearchQuery;
  export type Variables = ConsultantSelector_SearchQueryVariables;
  export const OperationName = "ConsultantSelector_Search";

  export const Document = ConsultantSelector_SearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContactPersonSelector_GetDocument = gql`
  query ContactPersonSelector_Get($text: String!, $skip: Int!, $limit: Int!) {
    contactPersons(filter: { text: [$text] }, limit: $limit, skip: $skip) {
      items {
        ...ContactPersonSelector_Item
      }
    }
  }
  ${ContactPersonSelector_ItemFragmentDoc}
`;
export type ContactPersonSelector_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ContactPersonSelector_GetQuery,
    ContactPersonSelector_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: ContactPersonSelector_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ContactPersonSelector_GetComponent = (
  props: ContactPersonSelector_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    ContactPersonSelector_GetQuery,
    ContactPersonSelector_GetQueryVariables
  >
    query={ContactPersonSelector_GetDocument}
    {...props}
  />
);

/**
 * __useContactPersonSelector_GetQuery__
 *
 * To run a query within a React component, call `useContactPersonSelector_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPersonSelector_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPersonSelector_GetQuery({
 *   variables: {
 *      text: // value for 'text'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactPersonSelector_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContactPersonSelector_GetQuery,
    ContactPersonSelector_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContactPersonSelector_GetQuery,
    ContactPersonSelector_GetQueryVariables
  >(ContactPersonSelector_GetDocument, options);
}
export function useContactPersonSelector_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContactPersonSelector_GetQuery,
    ContactPersonSelector_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContactPersonSelector_GetQuery,
    ContactPersonSelector_GetQueryVariables
  >(ContactPersonSelector_GetDocument, options);
}
export type ContactPersonSelector_GetQueryHookResult = ReturnType<
  typeof useContactPersonSelector_GetQuery
>;
export type ContactPersonSelector_GetLazyQueryHookResult = ReturnType<
  typeof useContactPersonSelector_GetLazyQuery
>;
export namespace ContactPersonSelector_Get {
  export type Return = ContactPersonSelector_GetQuery;
  export type Variables = ContactPersonSelector_GetQueryVariables;
  export const OperationName = "ContactPersonSelector_Get";

  export const Document = ContactPersonSelector_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerSelector_GetValueDocument = gql`
  query CustomerSelector_GetValue($id: ObjectId!) {
    customerById(id: $id) {
      ...SimpleCustomerCard
    }
  }
  ${SimpleCustomerCardFragmentDoc}
`;
export type CustomerSelector_GetValueComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerSelector_GetValueQuery,
    CustomerSelector_GetValueQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerSelector_GetValueQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerSelector_GetValueComponent = (
  props: CustomerSelector_GetValueComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerSelector_GetValueQuery,
    CustomerSelector_GetValueQueryVariables
  >
    query={CustomerSelector_GetValueDocument}
    {...props}
  />
);

/**
 * __useCustomerSelector_GetValueQuery__
 *
 * To run a query within a React component, call `useCustomerSelector_GetValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSelector_GetValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSelector_GetValueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerSelector_GetValueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerSelector_GetValueQuery,
    CustomerSelector_GetValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerSelector_GetValueQuery,
    CustomerSelector_GetValueQueryVariables
  >(CustomerSelector_GetValueDocument, options);
}
export function useCustomerSelector_GetValueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerSelector_GetValueQuery,
    CustomerSelector_GetValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerSelector_GetValueQuery,
    CustomerSelector_GetValueQueryVariables
  >(CustomerSelector_GetValueDocument, options);
}
export type CustomerSelector_GetValueQueryHookResult = ReturnType<
  typeof useCustomerSelector_GetValueQuery
>;
export type CustomerSelector_GetValueLazyQueryHookResult = ReturnType<
  typeof useCustomerSelector_GetValueLazyQuery
>;
export namespace CustomerSelector_GetValue {
  export type Return = CustomerSelector_GetValueQuery;
  export type Variables = CustomerSelector_GetValueQueryVariables;
  export const OperationName = "CustomerSelector_GetValue";

  export const Document = CustomerSelector_GetValueDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerSelector_SearchDocument = gql`
  query CustomerSelector_Search($filter: CustomersFilter!, $skip: Int, $limit: Int) {
    customersPicker(filter: $filter, limit: $limit, skip: $skip) {
      items {
        ...CustomerPicker_CustomerCard
      }
      dbTime
    }
  }
  ${CustomerPicker_CustomerCardFragmentDoc}
`;
export type CustomerSelector_SearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerSelector_SearchQuery,
    CustomerSelector_SearchQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerSelector_SearchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerSelector_SearchComponent = (
  props: CustomerSelector_SearchComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerSelector_SearchQuery,
    CustomerSelector_SearchQueryVariables
  >
    query={CustomerSelector_SearchDocument}
    {...props}
  />
);

/**
 * __useCustomerSelector_SearchQuery__
 *
 * To run a query within a React component, call `useCustomerSelector_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSelector_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSelector_SearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomerSelector_SearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerSelector_SearchQuery,
    CustomerSelector_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerSelector_SearchQuery,
    CustomerSelector_SearchQueryVariables
  >(CustomerSelector_SearchDocument, options);
}
export function useCustomerSelector_SearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerSelector_SearchQuery,
    CustomerSelector_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerSelector_SearchQuery,
    CustomerSelector_SearchQueryVariables
  >(CustomerSelector_SearchDocument, options);
}
export type CustomerSelector_SearchQueryHookResult = ReturnType<
  typeof useCustomerSelector_SearchQuery
>;
export type CustomerSelector_SearchLazyQueryHookResult = ReturnType<
  typeof useCustomerSelector_SearchLazyQuery
>;
export namespace CustomerSelector_Search {
  export type Return = CustomerSelector_SearchQuery;
  export type Variables = CustomerSelector_SearchQueryVariables;
  export const OperationName = "CustomerSelector_Search";

  export const Document = CustomerSelector_SearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SearchProfile_GetValueDocument = gql`
  query SearchProfile_GetValue($id: ObjectId!) {
    searchProfileById(id: $id) {
      ...SearchProfile
    }
  }
  ${SearchProfileFragmentDoc}
`;
export type SearchProfile_GetValueComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SearchProfile_GetValueQuery,
    SearchProfile_GetValueQueryVariables
  >,
  "query"
> &
  (
    | { variables: SearchProfile_GetValueQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SearchProfile_GetValueComponent = (
  props: SearchProfile_GetValueComponentProps
) => (
  <ApolloReactComponents.Query<
    SearchProfile_GetValueQuery,
    SearchProfile_GetValueQueryVariables
  >
    query={SearchProfile_GetValueDocument}
    {...props}
  />
);

/**
 * __useSearchProfile_GetValueQuery__
 *
 * To run a query within a React component, call `useSearchProfile_GetValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfile_GetValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfile_GetValueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSearchProfile_GetValueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchProfile_GetValueQuery,
    SearchProfile_GetValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchProfile_GetValueQuery,
    SearchProfile_GetValueQueryVariables
  >(SearchProfile_GetValueDocument, options);
}
export function useSearchProfile_GetValueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchProfile_GetValueQuery,
    SearchProfile_GetValueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchProfile_GetValueQuery,
    SearchProfile_GetValueQueryVariables
  >(SearchProfile_GetValueDocument, options);
}
export type SearchProfile_GetValueQueryHookResult = ReturnType<
  typeof useSearchProfile_GetValueQuery
>;
export type SearchProfile_GetValueLazyQueryHookResult = ReturnType<
  typeof useSearchProfile_GetValueLazyQuery
>;
export namespace SearchProfile_GetValue {
  export type Return = SearchProfile_GetValueQuery;
  export type Variables = SearchProfile_GetValueQueryVariables;
  export const OperationName = "SearchProfile_GetValue";

  export const Document = SearchProfile_GetValueDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SearchProfiles_SearchDocument = gql`
  query SearchProfiles_Search($filter: SearchProfilesFilter!, $skip: Int, $limit: Int) {
    SearchProfiles(filter: $filter, limit: $limit, skip: $skip) {
      items {
        name
        _id
      }
    }
  }
`;
export type SearchProfiles_SearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SearchProfiles_SearchQuery,
    SearchProfiles_SearchQueryVariables
  >,
  "query"
> &
  (
    | { variables: SearchProfiles_SearchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SearchProfiles_SearchComponent = (
  props: SearchProfiles_SearchComponentProps
) => (
  <ApolloReactComponents.Query<
    SearchProfiles_SearchQuery,
    SearchProfiles_SearchQueryVariables
  >
    query={SearchProfiles_SearchDocument}
    {...props}
  />
);

/**
 * __useSearchProfiles_SearchQuery__
 *
 * To run a query within a React component, call `useSearchProfiles_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfiles_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfiles_SearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchProfiles_SearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchProfiles_SearchQuery,
    SearchProfiles_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchProfiles_SearchQuery, SearchProfiles_SearchQueryVariables>(
    SearchProfiles_SearchDocument,
    options
  );
}
export function useSearchProfiles_SearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchProfiles_SearchQuery,
    SearchProfiles_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchProfiles_SearchQuery,
    SearchProfiles_SearchQueryVariables
  >(SearchProfiles_SearchDocument, options);
}
export type SearchProfiles_SearchQueryHookResult = ReturnType<
  typeof useSearchProfiles_SearchQuery
>;
export type SearchProfiles_SearchLazyQueryHookResult = ReturnType<
  typeof useSearchProfiles_SearchLazyQuery
>;
export namespace SearchProfiles_Search {
  export type Return = SearchProfiles_SearchQuery;
  export type Variables = SearchProfiles_SearchQueryVariables;
  export const OperationName = "SearchProfiles_Search";

  export const Document = SearchProfiles_SearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SearchProfile_SubmitDocument = gql`
  mutation SearchProfile_Submit($data: SearchProfileFormInput!, $id: ObjectId) {
    submitSearchProfileForm(data: $data, searchProfileId: $id) {
      ...SearchProfile
    }
  }
  ${SearchProfileFragmentDoc}
`;
export type SearchProfile_SubmitMutationFn = Apollo.MutationFunction<
  SearchProfile_SubmitMutation,
  SearchProfile_SubmitMutationVariables
>;
export type SearchProfile_SubmitComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SearchProfile_SubmitMutation,
    SearchProfile_SubmitMutationVariables
  >,
  "mutation"
>;

export const SearchProfile_SubmitComponent = (
  props: SearchProfile_SubmitComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SearchProfile_SubmitMutation,
    SearchProfile_SubmitMutationVariables
  >
    mutation={SearchProfile_SubmitDocument}
    {...props}
  />
);

/**
 * __useSearchProfile_SubmitMutation__
 *
 * To run a mutation, you first call `useSearchProfile_SubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchProfile_SubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchProfileSubmitMutation, { data, loading, error }] = useSearchProfile_SubmitMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSearchProfile_SubmitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SearchProfile_SubmitMutation,
    SearchProfile_SubmitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SearchProfile_SubmitMutation,
    SearchProfile_SubmitMutationVariables
  >(SearchProfile_SubmitDocument, options);
}
export type SearchProfile_SubmitMutationHookResult = ReturnType<
  typeof useSearchProfile_SubmitMutation
>;
export namespace SearchProfile_Submit {
  export type Return = SearchProfile_SubmitMutation;
  export type Variables = SearchProfile_SubmitMutationVariables;
  export const OperationName = "SearchProfile_Submit";

  export const Document = SearchProfile_SubmitDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SearchProfile_RemoveDocument = gql`
  mutation SearchProfile_Remove($id: ObjectId!) {
    removeSearchProfile(searchProfileId: $id)
  }
`;
export type SearchProfile_RemoveMutationFn = Apollo.MutationFunction<
  SearchProfile_RemoveMutation,
  SearchProfile_RemoveMutationVariables
>;
export type SearchProfile_RemoveComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SearchProfile_RemoveMutation,
    SearchProfile_RemoveMutationVariables
  >,
  "mutation"
>;

export const SearchProfile_RemoveComponent = (
  props: SearchProfile_RemoveComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SearchProfile_RemoveMutation,
    SearchProfile_RemoveMutationVariables
  >
    mutation={SearchProfile_RemoveDocument}
    {...props}
  />
);

/**
 * __useSearchProfile_RemoveMutation__
 *
 * To run a mutation, you first call `useSearchProfile_RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchProfile_RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchProfileRemoveMutation, { data, loading, error }] = useSearchProfile_RemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSearchProfile_RemoveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SearchProfile_RemoveMutation,
    SearchProfile_RemoveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SearchProfile_RemoveMutation,
    SearchProfile_RemoveMutationVariables
  >(SearchProfile_RemoveDocument, options);
}
export type SearchProfile_RemoveMutationHookResult = ReturnType<
  typeof useSearchProfile_RemoveMutation
>;
export namespace SearchProfile_Remove {
  export type Return = SearchProfile_RemoveMutation;
  export type Variables = SearchProfile_RemoveMutationVariables;
  export const OperationName = "SearchProfile_Remove";

  export const Document = SearchProfile_RemoveDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SearchProfile_UpdateCustomerRefDocument = gql`
  mutation SearchProfile_UpdateCustomerRef($id: ObjectId!, $profileIds: [ObjectId!]) {
    updateCustomerRefsSearchProfiles(customerId: $id, searchProfileIds: $profileIds) {
      ...SearchProfileOption
    }
  }
  ${SearchProfileOptionFragmentDoc}
`;
export type SearchProfile_UpdateCustomerRefMutationFn = Apollo.MutationFunction<
  SearchProfile_UpdateCustomerRefMutation,
  SearchProfile_UpdateCustomerRefMutationVariables
>;
export type SearchProfile_UpdateCustomerRefComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SearchProfile_UpdateCustomerRefMutation,
    SearchProfile_UpdateCustomerRefMutationVariables
  >,
  "mutation"
>;

export const SearchProfile_UpdateCustomerRefComponent = (
  props: SearchProfile_UpdateCustomerRefComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SearchProfile_UpdateCustomerRefMutation,
    SearchProfile_UpdateCustomerRefMutationVariables
  >
    mutation={SearchProfile_UpdateCustomerRefDocument}
    {...props}
  />
);

/**
 * __useSearchProfile_UpdateCustomerRefMutation__
 *
 * To run a mutation, you first call `useSearchProfile_UpdateCustomerRefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchProfile_UpdateCustomerRefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchProfileUpdateCustomerRefMutation, { data, loading, error }] = useSearchProfile_UpdateCustomerRefMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profileIds: // value for 'profileIds'
 *   },
 * });
 */
export function useSearchProfile_UpdateCustomerRefMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SearchProfile_UpdateCustomerRefMutation,
    SearchProfile_UpdateCustomerRefMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SearchProfile_UpdateCustomerRefMutation,
    SearchProfile_UpdateCustomerRefMutationVariables
  >(SearchProfile_UpdateCustomerRefDocument, options);
}
export type SearchProfile_UpdateCustomerRefMutationHookResult = ReturnType<
  typeof useSearchProfile_UpdateCustomerRefMutation
>;
export namespace SearchProfile_UpdateCustomerRef {
  export type Return = SearchProfile_UpdateCustomerRefMutation;
  export type Variables = SearchProfile_UpdateCustomerRefMutationVariables;
  export const OperationName = "SearchProfile_UpdateCustomerRef";

  export const Document = SearchProfile_UpdateCustomerRefDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetListUserSelectorUsersDocument = gql`
  query getListUserSelectorUsers {
    users {
      ...ListUserSelectorUser
    }
  }
  ${ListUserSelectorUserFragmentDoc}
`;
export type GetListUserSelectorUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetListUserSelectorUsersQuery,
    GetListUserSelectorUsersQueryVariables
  >,
  "query"
>;

export const GetListUserSelectorUsersComponent = (
  props: GetListUserSelectorUsersComponentProps
) => (
  <ApolloReactComponents.Query<
    GetListUserSelectorUsersQuery,
    GetListUserSelectorUsersQueryVariables
  >
    query={GetListUserSelectorUsersDocument}
    {...props}
  />
);

/**
 * __useGetListUserSelectorUsersQuery__
 *
 * To run a query within a React component, call `useGetListUserSelectorUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListUserSelectorUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListUserSelectorUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListUserSelectorUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetListUserSelectorUsersQuery,
    GetListUserSelectorUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetListUserSelectorUsersQuery,
    GetListUserSelectorUsersQueryVariables
  >(GetListUserSelectorUsersDocument, options);
}
export function useGetListUserSelectorUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListUserSelectorUsersQuery,
    GetListUserSelectorUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetListUserSelectorUsersQuery,
    GetListUserSelectorUsersQueryVariables
  >(GetListUserSelectorUsersDocument, options);
}
export type GetListUserSelectorUsersQueryHookResult = ReturnType<
  typeof useGetListUserSelectorUsersQuery
>;
export type GetListUserSelectorUsersLazyQueryHookResult = ReturnType<
  typeof useGetListUserSelectorUsersLazyQuery
>;
export namespace GetListUserSelectorUsers {
  export type Return = GetListUserSelectorUsersQuery;
  export type Variables = GetListUserSelectorUsersQueryVariables;
  export const OperationName = "getListUserSelectorUsers";

  export const Document = GetListUserSelectorUsersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetProjectSelectProjectsDocument = gql`
  query getProjectSelectProjects(
    $skip: Int!
    $limit: Int!
    $text: String
    $shared: Boolean
    $memberIds: [ObjectId!]
  ) {
    projects(
      skip: $skip
      limit: $limit
      text: $text
      shared: $shared
      memberIds: $memberIds
    ) {
      ...ProjectSelectProjectData
    }
  }
  ${ProjectSelectProjectDataFragmentDoc}
`;
export type GetProjectSelectProjectsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetProjectSelectProjectsQuery,
    GetProjectSelectProjectsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetProjectSelectProjectsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetProjectSelectProjectsComponent = (
  props: GetProjectSelectProjectsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetProjectSelectProjectsQuery,
    GetProjectSelectProjectsQueryVariables
  >
    query={GetProjectSelectProjectsDocument}
    {...props}
  />
);

/**
 * __useGetProjectSelectProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectSelectProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSelectProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSelectProjectsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      text: // value for 'text'
 *      shared: // value for 'shared'
 *      memberIds: // value for 'memberIds'
 *   },
 * });
 */
export function useGetProjectSelectProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProjectSelectProjectsQuery,
    GetProjectSelectProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectSelectProjectsQuery,
    GetProjectSelectProjectsQueryVariables
  >(GetProjectSelectProjectsDocument, options);
}
export function useGetProjectSelectProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectSelectProjectsQuery,
    GetProjectSelectProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectSelectProjectsQuery,
    GetProjectSelectProjectsQueryVariables
  >(GetProjectSelectProjectsDocument, options);
}
export type GetProjectSelectProjectsQueryHookResult = ReturnType<
  typeof useGetProjectSelectProjectsQuery
>;
export type GetProjectSelectProjectsLazyQueryHookResult = ReturnType<
  typeof useGetProjectSelectProjectsLazyQuery
>;
export namespace GetProjectSelectProjects {
  export type Return = GetProjectSelectProjectsQuery;
  export type Variables = GetProjectSelectProjectsQueryVariables;
  export const OperationName = "getProjectSelectProjects";

  export const Document = GetProjectSelectProjectsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetUserSelectUsersDocument = gql`
  query getUserSelectUsers {
    users {
      ...UserSelect
    }
  }
  ${UserSelectFragmentDoc}
`;
export type GetUserSelectUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserSelectUsersQuery,
    GetUserSelectUsersQueryVariables
  >,
  "query"
>;

export const GetUserSelectUsersComponent = (props: GetUserSelectUsersComponentProps) => (
  <ApolloReactComponents.Query<GetUserSelectUsersQuery, GetUserSelectUsersQueryVariables>
    query={GetUserSelectUsersDocument}
    {...props}
  />
);

/**
 * __useGetUserSelectUsersQuery__
 *
 * To run a query within a React component, call `useGetUserSelectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSelectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSelectUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSelectUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserSelectUsersQuery,
    GetUserSelectUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserSelectUsersQuery, GetUserSelectUsersQueryVariables>(
    GetUserSelectUsersDocument,
    options
  );
}
export function useGetUserSelectUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserSelectUsersQuery,
    GetUserSelectUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserSelectUsersQuery, GetUserSelectUsersQueryVariables>(
    GetUserSelectUsersDocument,
    options
  );
}
export type GetUserSelectUsersQueryHookResult = ReturnType<
  typeof useGetUserSelectUsersQuery
>;
export type GetUserSelectUsersLazyQueryHookResult = ReturnType<
  typeof useGetUserSelectUsersLazyQuery
>;
export namespace GetUserSelectUsers {
  export type Return = GetUserSelectUsersQuery;
  export type Variables = GetUserSelectUsersQueryVariables;
  export const OperationName = "getUserSelectUsers";

  export const Document = GetUserSelectUsersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetUserSelectorModalUsersDocument = gql`
  query getUserSelectorModalUsers {
    users {
      ...UserSelectorModalUser
    }
  }
  ${UserSelectorModalUserFragmentDoc}
`;
export type GetUserSelectorModalUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserSelectorModalUsersQuery,
    GetUserSelectorModalUsersQueryVariables
  >,
  "query"
>;

export const GetUserSelectorModalUsersComponent = (
  props: GetUserSelectorModalUsersComponentProps
) => (
  <ApolloReactComponents.Query<
    GetUserSelectorModalUsersQuery,
    GetUserSelectorModalUsersQueryVariables
  >
    query={GetUserSelectorModalUsersDocument}
    {...props}
  />
);

/**
 * __useGetUserSelectorModalUsersQuery__
 *
 * To run a query within a React component, call `useGetUserSelectorModalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSelectorModalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSelectorModalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSelectorModalUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserSelectorModalUsersQuery,
    GetUserSelectorModalUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserSelectorModalUsersQuery,
    GetUserSelectorModalUsersQueryVariables
  >(GetUserSelectorModalUsersDocument, options);
}
export function useGetUserSelectorModalUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserSelectorModalUsersQuery,
    GetUserSelectorModalUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserSelectorModalUsersQuery,
    GetUserSelectorModalUsersQueryVariables
  >(GetUserSelectorModalUsersDocument, options);
}
export type GetUserSelectorModalUsersQueryHookResult = ReturnType<
  typeof useGetUserSelectorModalUsersQuery
>;
export type GetUserSelectorModalUsersLazyQueryHookResult = ReturnType<
  typeof useGetUserSelectorModalUsersLazyQuery
>;
export namespace GetUserSelectorModalUsers {
  export type Return = GetUserSelectorModalUsersQuery;
  export type Variables = GetUserSelectorModalUsersQueryVariables;
  export const OperationName = "getUserSelectorModalUsers";

  export const Document = GetUserSelectorModalUsersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const FindContractDocument = gql`
  query FindContract($id: ObjectId!) {
    contract(id: $id) {
      _id
      variant
      name
    }
  }
`;
export type FindContractComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    FindContractQuery,
    FindContractQueryVariables
  >,
  "query"
> &
  ({ variables: FindContractQueryVariables; skip?: boolean } | { skip: boolean });

export const FindContractComponent = (props: FindContractComponentProps) => (
  <ApolloReactComponents.Query<FindContractQuery, FindContractQueryVariables>
    query={FindContractDocument}
    {...props}
  />
);

/**
 * __useFindContractQuery__
 *
 * To run a query within a React component, call `useFindContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindContractQuery(
  baseOptions?: Apollo.QueryHookOptions<FindContractQuery, FindContractQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FindContractQuery, FindContractQueryVariables>(
    FindContractDocument,
    options
  );
}
export function useFindContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FindContractQuery, FindContractQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FindContractQuery, FindContractQueryVariables>(
    FindContractDocument,
    options
  );
}
export type FindContractQueryHookResult = ReturnType<typeof useFindContractQuery>;
export type FindContractLazyQueryHookResult = ReturnType<typeof useFindContractLazyQuery>;
export namespace FindContract {
  export type Return = FindContractQuery;
  export type Variables = FindContractQueryVariables;
  export const OperationName = "FindContract";

  export const Document = FindContractDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const ContractPriceTemplate_SaveToFavouriteDocument = gql`
  mutation ContractPriceTemplate_SaveToFavourite($data: ContractPriceTemplateInput!) {
    saveToFavouriteContractPriceTemplate(data: $data) {
      value {
        ...contractsPriceTemplate
      }
      errors
    }
  }
  ${ContractsPriceTemplateFragmentDoc}
`;
export type ContractPriceTemplate_SaveToFavouriteMutationFn = Apollo.MutationFunction<
  ContractPriceTemplate_SaveToFavouriteMutation,
  ContractPriceTemplate_SaveToFavouriteMutationVariables
>;
export type ContractPriceTemplate_SaveToFavouriteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ContractPriceTemplate_SaveToFavouriteMutation,
    ContractPriceTemplate_SaveToFavouriteMutationVariables
  >,
  "mutation"
>;

export const ContractPriceTemplate_SaveToFavouriteComponent = (
  props: ContractPriceTemplate_SaveToFavouriteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    ContractPriceTemplate_SaveToFavouriteMutation,
    ContractPriceTemplate_SaveToFavouriteMutationVariables
  >
    mutation={ContractPriceTemplate_SaveToFavouriteDocument}
    {...props}
  />
);

/**
 * __useContractPriceTemplate_SaveToFavouriteMutation__
 *
 * To run a mutation, you first call `useContractPriceTemplate_SaveToFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractPriceTemplate_SaveToFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractPriceTemplateSaveToFavouriteMutation, { data, loading, error }] = useContractPriceTemplate_SaveToFavouriteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContractPriceTemplate_SaveToFavouriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContractPriceTemplate_SaveToFavouriteMutation,
    ContractPriceTemplate_SaveToFavouriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContractPriceTemplate_SaveToFavouriteMutation,
    ContractPriceTemplate_SaveToFavouriteMutationVariables
  >(ContractPriceTemplate_SaveToFavouriteDocument, options);
}
export type ContractPriceTemplate_SaveToFavouriteMutationHookResult = ReturnType<
  typeof useContractPriceTemplate_SaveToFavouriteMutation
>;
export namespace ContractPriceTemplate_SaveToFavourite {
  export type Return = ContractPriceTemplate_SaveToFavouriteMutation;
  export type Variables = ContractPriceTemplate_SaveToFavouriteMutationVariables;
  export const OperationName = "ContractPriceTemplate_SaveToFavourite";

  export const Document = ContractPriceTemplate_SaveToFavouriteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerContractCardDocument = gql`
  query getCustomerContractCard($id: ObjectId!) {
    customerContractById(customerContractId: $id) {
      ...CustomerContractCard
    }
  }
  ${CustomerContractCardFragmentDoc}
`;
export type GetCustomerContractCardComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractCardQuery,
    GetCustomerContractCardQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractCardQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractCardComponent = (
  props: GetCustomerContractCardComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractCardQuery,
    GetCustomerContractCardQueryVariables
  >
    query={GetCustomerContractCardDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractCardQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerContractCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractCardQuery,
    GetCustomerContractCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractCardQuery,
    GetCustomerContractCardQueryVariables
  >(GetCustomerContractCardDocument, options);
}
export function useGetCustomerContractCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractCardQuery,
    GetCustomerContractCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractCardQuery,
    GetCustomerContractCardQueryVariables
  >(GetCustomerContractCardDocument, options);
}
export type GetCustomerContractCardQueryHookResult = ReturnType<
  typeof useGetCustomerContractCardQuery
>;
export type GetCustomerContractCardLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractCardLazyQuery
>;
export namespace GetCustomerContractCard {
  export type Return = GetCustomerContractCardQuery;
  export type Variables = GetCustomerContractCardQueryVariables;
  export const OperationName = "getCustomerContractCard";

  export const Document = GetCustomerContractCardDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCustomerContractContactPersonDocument = gql`
  query getCustomerContractContactPerson($id: ObjectId!) {
    customerContractById(customerContractId: $id) {
      ...CustomerContractContactPerson
    }
  }
  ${CustomerContractContactPersonFragmentDoc}
`;
export type GetCustomerContractContactPersonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractContactPersonQuery,
    GetCustomerContractContactPersonQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractContactPersonQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractContactPersonComponent = (
  props: GetCustomerContractContactPersonComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractContactPersonQuery,
    GetCustomerContractContactPersonQueryVariables
  >
    query={GetCustomerContractContactPersonDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractContactPersonQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractContactPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractContactPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractContactPersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerContractContactPersonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractContactPersonQuery,
    GetCustomerContractContactPersonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractContactPersonQuery,
    GetCustomerContractContactPersonQueryVariables
  >(GetCustomerContractContactPersonDocument, options);
}
export function useGetCustomerContractContactPersonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractContactPersonQuery,
    GetCustomerContractContactPersonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractContactPersonQuery,
    GetCustomerContractContactPersonQueryVariables
  >(GetCustomerContractContactPersonDocument, options);
}
export type GetCustomerContractContactPersonQueryHookResult = ReturnType<
  typeof useGetCustomerContractContactPersonQuery
>;
export type GetCustomerContractContactPersonLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractContactPersonLazyQuery
>;
export namespace GetCustomerContractContactPerson {
  export type Return = GetCustomerContractContactPersonQuery;
  export type Variables = GetCustomerContractContactPersonQueryVariables;
  export const OperationName = "getCustomerContractContactPerson";

  export const Document = GetCustomerContractContactPersonDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCustomerContractCustomerListDocument = gql`
  query getCustomerContractCustomerList($id: ObjectId!) {
    customerContractById(customerContractId: $id) {
      ...CustomerContractCustomerList
    }
  }
  ${CustomerContractCustomerListFragmentDoc}
`;
export type GetCustomerContractCustomerListComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractCustomerListQuery,
    GetCustomerContractCustomerListQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractCustomerListQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractCustomerListComponent = (
  props: GetCustomerContractCustomerListComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractCustomerListQuery,
    GetCustomerContractCustomerListQueryVariables
  >
    query={GetCustomerContractCustomerListDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractCustomerListQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractCustomerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractCustomerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractCustomerListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerContractCustomerListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractCustomerListQuery,
    GetCustomerContractCustomerListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractCustomerListQuery,
    GetCustomerContractCustomerListQueryVariables
  >(GetCustomerContractCustomerListDocument, options);
}
export function useGetCustomerContractCustomerListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractCustomerListQuery,
    GetCustomerContractCustomerListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractCustomerListQuery,
    GetCustomerContractCustomerListQueryVariables
  >(GetCustomerContractCustomerListDocument, options);
}
export type GetCustomerContractCustomerListQueryHookResult = ReturnType<
  typeof useGetCustomerContractCustomerListQuery
>;
export type GetCustomerContractCustomerListLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractCustomerListLazyQuery
>;
export namespace GetCustomerContractCustomerList {
  export type Return = GetCustomerContractCustomerListQuery;
  export type Variables = GetCustomerContractCustomerListQueryVariables;
  export const OperationName = "getCustomerContractCustomerList";

  export const Document = GetCustomerContractCustomerListDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCustomerContractFilesDocument = gql`
  query getCustomerContractFiles($customerContractId: ObjectId!) {
    customerContractById(customerContractId: $customerContractId) {
      _id
      attachments {
        DocumentType
        ThumbURL
        PdfURL
        FileRef {
          Name
          NodeID
          NodeType
          MimeType
          Size
        }
      }
    }
  }
`;
export type GetCustomerContractFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractFilesQuery,
    GetCustomerContractFilesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractFilesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractFilesComponent = (
  props: GetCustomerContractFilesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractFilesQuery,
    GetCustomerContractFilesQueryVariables
  >
    query={GetCustomerContractFilesDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractFilesQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractFilesQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useGetCustomerContractFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractFilesQuery,
    GetCustomerContractFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractFilesQuery,
    GetCustomerContractFilesQueryVariables
  >(GetCustomerContractFilesDocument, options);
}
export function useGetCustomerContractFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractFilesQuery,
    GetCustomerContractFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractFilesQuery,
    GetCustomerContractFilesQueryVariables
  >(GetCustomerContractFilesDocument, options);
}
export type GetCustomerContractFilesQueryHookResult = ReturnType<
  typeof useGetCustomerContractFilesQuery
>;
export type GetCustomerContractFilesLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractFilesLazyQuery
>;
export namespace GetCustomerContractFiles {
  export type Return = GetCustomerContractFilesQuery;
  export type Variables = GetCustomerContractFilesQueryVariables;
  export const OperationName = "getCustomerContractFiles";

  export const Document = GetCustomerContractFilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadCustomerContractDocDocument = gql`
  mutation uploadCustomerContractDoc(
    $customerContractId: ObjectId!
    $file: Upload!
    $documentType: CustomerContractDocumentTypes!
  ) {
    uploadCustomerContractDocument(
      customerContractId: $customerContractId
      file: $file
      documentType: $documentType
    ) {
      errors
      value {
        _id
        attachments {
          DocumentType
          ThumbURL
          PdfURL
          FileRef {
            Name
            NodeID
            NodeType
            MimeType
            Size
          }
        }
      }
    }
  }
`;
export type UploadCustomerContractDocMutationFn = Apollo.MutationFunction<
  UploadCustomerContractDocMutation,
  UploadCustomerContractDocMutationVariables
>;
export type UploadCustomerContractDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadCustomerContractDocMutation,
    UploadCustomerContractDocMutationVariables
  >,
  "mutation"
>;

export const UploadCustomerContractDocComponent = (
  props: UploadCustomerContractDocComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadCustomerContractDocMutation,
    UploadCustomerContractDocMutationVariables
  >
    mutation={UploadCustomerContractDocDocument}
    {...props}
  />
);

/**
 * __useUploadCustomerContractDocMutation__
 *
 * To run a mutation, you first call `useUploadCustomerContractDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomerContractDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomerContractDocMutation, { data, loading, error }] = useUploadCustomerContractDocMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      file: // value for 'file'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadCustomerContractDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadCustomerContractDocMutation,
    UploadCustomerContractDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadCustomerContractDocMutation,
    UploadCustomerContractDocMutationVariables
  >(UploadCustomerContractDocDocument, options);
}
export type UploadCustomerContractDocMutationHookResult = ReturnType<
  typeof useUploadCustomerContractDocMutation
>;
export namespace UploadCustomerContractDoc {
  export type Return = UploadCustomerContractDocMutation;
  export type Variables = UploadCustomerContractDocMutationVariables;
  export const OperationName = "uploadCustomerContractDoc";

  export const Document = UploadCustomerContractDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteCustomerContractDocDocument = gql`
  mutation deleteCustomerContractDoc($customerContractId: ObjectId!, $fileId: ObjectId!) {
    deleteCustomerContractDocument(
      customerContractId: $customerContractId
      fileId: $fileId
    ) {
      errors
    }
  }
`;
export type DeleteCustomerContractDocMutationFn = Apollo.MutationFunction<
  DeleteCustomerContractDocMutation,
  DeleteCustomerContractDocMutationVariables
>;
export type DeleteCustomerContractDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteCustomerContractDocMutation,
    DeleteCustomerContractDocMutationVariables
  >,
  "mutation"
>;

export const DeleteCustomerContractDocComponent = (
  props: DeleteCustomerContractDocComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteCustomerContractDocMutation,
    DeleteCustomerContractDocMutationVariables
  >
    mutation={DeleteCustomerContractDocDocument}
    {...props}
  />
);

/**
 * __useDeleteCustomerContractDocMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerContractDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerContractDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerContractDocMutation, { data, loading, error }] = useDeleteCustomerContractDocMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteCustomerContractDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerContractDocMutation,
    DeleteCustomerContractDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerContractDocMutation,
    DeleteCustomerContractDocMutationVariables
  >(DeleteCustomerContractDocDocument, options);
}
export type DeleteCustomerContractDocMutationHookResult = ReturnType<
  typeof useDeleteCustomerContractDocMutation
>;
export namespace DeleteCustomerContractDoc {
  export type Return = DeleteCustomerContractDocMutation;
  export type Variables = DeleteCustomerContractDocMutationVariables;
  export const OperationName = "deleteCustomerContractDoc";

  export const Document = DeleteCustomerContractDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SubmitCustomerContractFormDocument = gql`
  mutation SubmitCustomerContractForm(
    $customerContractId: ObjectId
    $data: CustomerContractFormInput!
  ) {
    submitCustomerContractForm(customerContractId: $customerContractId, data: $data) {
      ...CustomerContractResult
    }
  }
  ${CustomerContractResultFragmentDoc}
`;
export type SubmitCustomerContractFormMutationFn = Apollo.MutationFunction<
  SubmitCustomerContractFormMutation,
  SubmitCustomerContractFormMutationVariables
>;
export type SubmitCustomerContractFormComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitCustomerContractFormMutation,
    SubmitCustomerContractFormMutationVariables
  >,
  "mutation"
>;

export const SubmitCustomerContractFormComponent = (
  props: SubmitCustomerContractFormComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitCustomerContractFormMutation,
    SubmitCustomerContractFormMutationVariables
  >
    mutation={SubmitCustomerContractFormDocument}
    {...props}
  />
);

/**
 * __useSubmitCustomerContractFormMutation__
 *
 * To run a mutation, you first call `useSubmitCustomerContractFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCustomerContractFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCustomerContractFormMutation, { data, loading, error }] = useSubmitCustomerContractFormMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitCustomerContractFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitCustomerContractFormMutation,
    SubmitCustomerContractFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitCustomerContractFormMutation,
    SubmitCustomerContractFormMutationVariables
  >(SubmitCustomerContractFormDocument, options);
}
export type SubmitCustomerContractFormMutationHookResult = ReturnType<
  typeof useSubmitCustomerContractFormMutation
>;
export namespace SubmitCustomerContractForm {
  export type Return = SubmitCustomerContractFormMutation;
  export type Variables = SubmitCustomerContractFormMutationVariables;
  export const OperationName = "SubmitCustomerContractForm";

  export const Document = SubmitCustomerContractFormDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerContractEditorDataDocument = gql`
  query getCustomerContractEditorData($id: ObjectId, $isNew: Boolean!) {
    customerContractById(customerContractId: $id) @skip(if: $isNew) {
      ...CustomerContractEditorData
    }
  }
  ${CustomerContractEditorDataFragmentDoc}
`;
export type GetCustomerContractEditorDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractEditorDataQuery,
    GetCustomerContractEditorDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractEditorDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractEditorDataComponent = (
  props: GetCustomerContractEditorDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractEditorDataQuery,
    GetCustomerContractEditorDataQueryVariables
  >
    query={GetCustomerContractEditorDataDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractEditorDataQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractEditorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractEditorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractEditorDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isNew: // value for 'isNew'
 *   },
 * });
 */
export function useGetCustomerContractEditorDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractEditorDataQuery,
    GetCustomerContractEditorDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractEditorDataQuery,
    GetCustomerContractEditorDataQueryVariables
  >(GetCustomerContractEditorDataDocument, options);
}
export function useGetCustomerContractEditorDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractEditorDataQuery,
    GetCustomerContractEditorDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractEditorDataQuery,
    GetCustomerContractEditorDataQueryVariables
  >(GetCustomerContractEditorDataDocument, options);
}
export type GetCustomerContractEditorDataQueryHookResult = ReturnType<
  typeof useGetCustomerContractEditorDataQuery
>;
export type GetCustomerContractEditorDataLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractEditorDataLazyQuery
>;
export namespace GetCustomerContractEditorData {
  export type Return = GetCustomerContractEditorDataQuery;
  export type Variables = GetCustomerContractEditorDataQueryVariables;
  export const OperationName = "getCustomerContractEditorData";

  export const Document = GetCustomerContractEditorDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCustomerTreeDocument = gql`
  query getCustomerTree($customerContractId: ObjectId!) {
    customerContractById(customerContractId: $customerContractId) {
      ...CustomerContractOrgCustomerTree
    }
  }
  ${CustomerContractOrgCustomerTreeFragmentDoc}
`;
export type GetCustomerTreeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerTreeQuery,
    GetCustomerTreeQueryVariables
  >,
  "query"
> &
  ({ variables: GetCustomerTreeQueryVariables; skip?: boolean } | { skip: boolean });

export const GetCustomerTreeComponent = (props: GetCustomerTreeComponentProps) => (
  <ApolloReactComponents.Query<GetCustomerTreeQuery, GetCustomerTreeQueryVariables>
    query={GetCustomerTreeDocument}
    {...props}
  />
);

/**
 * __useGetCustomerTreeQuery__
 *
 * To run a query within a React component, call `useGetCustomerTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerTreeQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useGetCustomerTreeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerTreeQuery,
    GetCustomerTreeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerTreeQuery, GetCustomerTreeQueryVariables>(
    GetCustomerTreeDocument,
    options
  );
}
export function useGetCustomerTreeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerTreeQuery,
    GetCustomerTreeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerTreeQuery, GetCustomerTreeQueryVariables>(
    GetCustomerTreeDocument,
    options
  );
}
export type GetCustomerTreeQueryHookResult = ReturnType<typeof useGetCustomerTreeQuery>;
export type GetCustomerTreeLazyQueryHookResult = ReturnType<
  typeof useGetCustomerTreeLazyQuery
>;
export namespace GetCustomerTree {
  export type Return = GetCustomerTreeQuery;
  export type Variables = GetCustomerTreeQueryVariables;
  export const OperationName = "getCustomerTree";

  export const Document = GetCustomerTreeDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCustomerContractProfileDataDocument = gql`
  query getCustomerContractProfileData(
    $customerContractId: ObjectId!
    $priceListId: ObjectId
    $isNew: Boolean!
  ) {
    customerContractPriceListById(
      customerContractId: $customerContractId
      priceListId: $priceListId
    ) @skip(if: $isNew) {
      ...CustomerContractPriceListProfile
    }
    customerContractById(customerContractId: $customerContractId) @include(if: $isNew) {
      ...CustomerContractPriceListFormContractData
    }
    getHighHolidays {
      ...HighHolidayOption
    }
    config {
      defaultTravelZones {
        label
        name
      }
    }
  }
  ${CustomerContractPriceListProfileFragmentDoc}
  ${CustomerContractPriceListFormContractDataFragmentDoc}
  ${HighHolidayOptionFragmentDoc}
`;
export type GetCustomerContractProfileDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractProfileDataQuery,
    GetCustomerContractProfileDataQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractProfileDataQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractProfileDataComponent = (
  props: GetCustomerContractProfileDataComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractProfileDataQuery,
    GetCustomerContractProfileDataQueryVariables
  >
    query={GetCustomerContractProfileDataDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractProfileDataQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractProfileDataQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      priceListId: // value for 'priceListId'
 *      isNew: // value for 'isNew'
 *   },
 * });
 */
export function useGetCustomerContractProfileDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractProfileDataQuery,
    GetCustomerContractProfileDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractProfileDataQuery,
    GetCustomerContractProfileDataQueryVariables
  >(GetCustomerContractProfileDataDocument, options);
}
export function useGetCustomerContractProfileDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractProfileDataQuery,
    GetCustomerContractProfileDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractProfileDataQuery,
    GetCustomerContractProfileDataQueryVariables
  >(GetCustomerContractProfileDataDocument, options);
}
export type GetCustomerContractProfileDataQueryHookResult = ReturnType<
  typeof useGetCustomerContractProfileDataQuery
>;
export type GetCustomerContractProfileDataLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractProfileDataLazyQuery
>;
export namespace GetCustomerContractProfileData {
  export type Return = GetCustomerContractProfileDataQuery;
  export type Variables = GetCustomerContractProfileDataQueryVariables;
  export const OperationName = "getCustomerContractProfileData";

  export const Document = GetCustomerContractProfileDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SubmitPriceListEditorFormDocument = gql`
  mutation submitPriceListEditorForm(
    $customerContractId: ObjectId!
    $priceListId: ObjectId
    $data: PriceListFormInput!
  ) {
    submitCustomerContractPriceListForm(
      customerContractId: $customerContractId
      priceListId: $priceListId
      data: $data
    ) {
      ...CustomerContractResult
    }
  }
  ${CustomerContractResultFragmentDoc}
`;
export type SubmitPriceListEditorFormMutationFn = Apollo.MutationFunction<
  SubmitPriceListEditorFormMutation,
  SubmitPriceListEditorFormMutationVariables
>;
export type SubmitPriceListEditorFormComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitPriceListEditorFormMutation,
    SubmitPriceListEditorFormMutationVariables
  >,
  "mutation"
>;

export const SubmitPriceListEditorFormComponent = (
  props: SubmitPriceListEditorFormComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitPriceListEditorFormMutation,
    SubmitPriceListEditorFormMutationVariables
  >
    mutation={SubmitPriceListEditorFormDocument}
    {...props}
  />
);

/**
 * __useSubmitPriceListEditorFormMutation__
 *
 * To run a mutation, you first call `useSubmitPriceListEditorFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPriceListEditorFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPriceListEditorFormMutation, { data, loading, error }] = useSubmitPriceListEditorFormMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      priceListId: // value for 'priceListId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitPriceListEditorFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitPriceListEditorFormMutation,
    SubmitPriceListEditorFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitPriceListEditorFormMutation,
    SubmitPriceListEditorFormMutationVariables
  >(SubmitPriceListEditorFormDocument, options);
}
export type SubmitPriceListEditorFormMutationHookResult = ReturnType<
  typeof useSubmitPriceListEditorFormMutation
>;
export namespace SubmitPriceListEditorForm {
  export type Return = SubmitPriceListEditorFormMutation;
  export type Variables = SubmitPriceListEditorFormMutationVariables;
  export const OperationName = "submitPriceListEditorForm";

  export const Document = SubmitPriceListEditorFormDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerContractPriceListsDocument = gql`
  query getCustomerContractPriceLists($id: ObjectId!) {
    customerContractById(customerContractId: $id) {
      ...CustomerContractPriceLists
    }
  }
  ${CustomerContractPriceListsFragmentDoc}
`;
export type GetCustomerContractPriceListsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractPriceListsQuery,
    GetCustomerContractPriceListsQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractPriceListsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractPriceListsComponent = (
  props: GetCustomerContractPriceListsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractPriceListsQuery,
    GetCustomerContractPriceListsQueryVariables
  >
    query={GetCustomerContractPriceListsDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractPriceListsQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractPriceListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractPriceListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractPriceListsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerContractPriceListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractPriceListsQuery,
    GetCustomerContractPriceListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractPriceListsQuery,
    GetCustomerContractPriceListsQueryVariables
  >(GetCustomerContractPriceListsDocument, options);
}
export function useGetCustomerContractPriceListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractPriceListsQuery,
    GetCustomerContractPriceListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractPriceListsQuery,
    GetCustomerContractPriceListsQueryVariables
  >(GetCustomerContractPriceListsDocument, options);
}
export type GetCustomerContractPriceListsQueryHookResult = ReturnType<
  typeof useGetCustomerContractPriceListsQuery
>;
export type GetCustomerContractPriceListsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractPriceListsLazyQuery
>;
export namespace GetCustomerContractPriceLists {
  export type Return = GetCustomerContractPriceListsQuery;
  export type Variables = GetCustomerContractPriceListsQueryVariables;
  export const OperationName = "getCustomerContractPriceLists";

  export const Document = GetCustomerContractPriceListsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const RemoveCustomerContractPriceListDocument = gql`
  mutation removeCustomerContractPriceList($priceListId: ObjectId!) {
    removeCustomerContractPriceList(priceListId: $priceListId) {
      errors
      value {
        ...CustomerContractPriceLists
      }
    }
  }
  ${CustomerContractPriceListsFragmentDoc}
`;
export type RemoveCustomerContractPriceListMutationFn = Apollo.MutationFunction<
  RemoveCustomerContractPriceListMutation,
  RemoveCustomerContractPriceListMutationVariables
>;
export type RemoveCustomerContractPriceListComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveCustomerContractPriceListMutation,
    RemoveCustomerContractPriceListMutationVariables
  >,
  "mutation"
>;

export const RemoveCustomerContractPriceListComponent = (
  props: RemoveCustomerContractPriceListComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveCustomerContractPriceListMutation,
    RemoveCustomerContractPriceListMutationVariables
  >
    mutation={RemoveCustomerContractPriceListDocument}
    {...props}
  />
);

/**
 * __useRemoveCustomerContractPriceListMutation__
 *
 * To run a mutation, you first call `useRemoveCustomerContractPriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomerContractPriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomerContractPriceListMutation, { data, loading, error }] = useRemoveCustomerContractPriceListMutation({
 *   variables: {
 *      priceListId: // value for 'priceListId'
 *   },
 * });
 */
export function useRemoveCustomerContractPriceListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCustomerContractPriceListMutation,
    RemoveCustomerContractPriceListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveCustomerContractPriceListMutation,
    RemoveCustomerContractPriceListMutationVariables
  >(RemoveCustomerContractPriceListDocument, options);
}
export type RemoveCustomerContractPriceListMutationHookResult = ReturnType<
  typeof useRemoveCustomerContractPriceListMutation
>;
export namespace RemoveCustomerContractPriceList {
  export type Return = RemoveCustomerContractPriceListMutation;
  export type Variables = RemoveCustomerContractPriceListMutationVariables;
  export const OperationName = "removeCustomerContractPriceList";

  export const Document = RemoveCustomerContractPriceListDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerContractProfileDocument = gql`
  query getCustomerContractProfile($id: ObjectId!) {
    customerContractById(customerContractId: $id) {
      ...CustomerContract_Profile
    }
  }
  ${CustomerContract_ProfileFragmentDoc}
`;
export type GetCustomerContractProfileComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractProfileQuery,
    GetCustomerContractProfileQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractProfileQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractProfileComponent = (
  props: GetCustomerContractProfileComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractProfileQuery,
    GetCustomerContractProfileQueryVariables
  >
    query={GetCustomerContractProfileDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractProfileQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerContractProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractProfileQuery,
    GetCustomerContractProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractProfileQuery,
    GetCustomerContractProfileQueryVariables
  >(GetCustomerContractProfileDocument, options);
}
export function useGetCustomerContractProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractProfileQuery,
    GetCustomerContractProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractProfileQuery,
    GetCustomerContractProfileQueryVariables
  >(GetCustomerContractProfileDocument, options);
}
export type GetCustomerContractProfileQueryHookResult = ReturnType<
  typeof useGetCustomerContractProfileQuery
>;
export type GetCustomerContractProfileLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractProfileLazyQuery
>;
export namespace GetCustomerContractProfile {
  export type Return = GetCustomerContractProfileQuery;
  export type Variables = GetCustomerContractProfileQueryVariables;
  export const OperationName = "getCustomerContractProfile";

  export const Document = GetCustomerContractProfileDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SubmitCustomerContractInfoDocument = gql`
  mutation SubmitCustomerContractInfo($id: ObjectId!, $info: String!) {
    submitCustomerContractInfo(customerContractId: $id, info: $info) {
      value {
        ...CustomerContractInfoTab
      }
      errors
    }
  }
  ${CustomerContractInfoTabFragmentDoc}
`;
export type SubmitCustomerContractInfoMutationFn = Apollo.MutationFunction<
  SubmitCustomerContractInfoMutation,
  SubmitCustomerContractInfoMutationVariables
>;
export type SubmitCustomerContractInfoComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SubmitCustomerContractInfoMutation,
    SubmitCustomerContractInfoMutationVariables
  >,
  "mutation"
>;

export const SubmitCustomerContractInfoComponent = (
  props: SubmitCustomerContractInfoComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SubmitCustomerContractInfoMutation,
    SubmitCustomerContractInfoMutationVariables
  >
    mutation={SubmitCustomerContractInfoDocument}
    {...props}
  />
);

/**
 * __useSubmitCustomerContractInfoMutation__
 *
 * To run a mutation, you first call `useSubmitCustomerContractInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCustomerContractInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCustomerContractInfoMutation, { data, loading, error }] = useSubmitCustomerContractInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      info: // value for 'info'
 *   },
 * });
 */
export function useSubmitCustomerContractInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitCustomerContractInfoMutation,
    SubmitCustomerContractInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitCustomerContractInfoMutation,
    SubmitCustomerContractInfoMutationVariables
  >(SubmitCustomerContractInfoDocument, options);
}
export type SubmitCustomerContractInfoMutationHookResult = ReturnType<
  typeof useSubmitCustomerContractInfoMutation
>;
export namespace SubmitCustomerContractInfo {
  export type Return = SubmitCustomerContractInfoMutation;
  export type Variables = SubmitCustomerContractInfoMutationVariables;
  export const OperationName = "SubmitCustomerContractInfo";

  export const Document = SubmitCustomerContractInfoDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SetCustomerContractInvoicingStrgDocument = gql`
  mutation SetCustomerContractInvoicingStrg(
    $id: ObjectId!
    $type: InvoicingStrategyType!
  ) {
    setCustomerContractInvoiceStrategy(customerContractId: $id, type: $type) {
      value {
        invoicingStrategy
      }
      errors
    }
  }
`;
export type SetCustomerContractInvoicingStrgMutationFn = Apollo.MutationFunction<
  SetCustomerContractInvoicingStrgMutation,
  SetCustomerContractInvoicingStrgMutationVariables
>;
export type SetCustomerContractInvoicingStrgComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetCustomerContractInvoicingStrgMutation,
    SetCustomerContractInvoicingStrgMutationVariables
  >,
  "mutation"
>;

export const SetCustomerContractInvoicingStrgComponent = (
  props: SetCustomerContractInvoicingStrgComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetCustomerContractInvoicingStrgMutation,
    SetCustomerContractInvoicingStrgMutationVariables
  >
    mutation={SetCustomerContractInvoicingStrgDocument}
    {...props}
  />
);

/**
 * __useSetCustomerContractInvoicingStrgMutation__
 *
 * To run a mutation, you first call `useSetCustomerContractInvoicingStrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerContractInvoicingStrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerContractInvoicingStrgMutation, { data, loading, error }] = useSetCustomerContractInvoicingStrgMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSetCustomerContractInvoicingStrgMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCustomerContractInvoicingStrgMutation,
    SetCustomerContractInvoicingStrgMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCustomerContractInvoicingStrgMutation,
    SetCustomerContractInvoicingStrgMutationVariables
  >(SetCustomerContractInvoicingStrgDocument, options);
}
export type SetCustomerContractInvoicingStrgMutationHookResult = ReturnType<
  typeof useSetCustomerContractInvoicingStrgMutation
>;
export namespace SetCustomerContractInvoicingStrg {
  export type Return = SetCustomerContractInvoicingStrgMutation;
  export type Variables = SetCustomerContractInvoicingStrgMutationVariables;
  export const OperationName = "SetCustomerContractInvoicingStrg";

  export const Document = SetCustomerContractInvoicingStrgDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerContractProfileInfoDocument = gql`
  query getCustomerContractProfileInfo($id: ObjectId!) {
    customerContractById(customerContractId: $id) {
      ...CustomerContractInfoTab
    }
  }
  ${CustomerContractInfoTabFragmentDoc}
`;
export type GetCustomerContractProfileInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerContractProfileInfoQuery,
    GetCustomerContractProfileInfoQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerContractProfileInfoQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerContractProfileInfoComponent = (
  props: GetCustomerContractProfileInfoComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerContractProfileInfoQuery,
    GetCustomerContractProfileInfoQueryVariables
  >
    query={GetCustomerContractProfileInfoDocument}
    {...props}
  />
);

/**
 * __useGetCustomerContractProfileInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomerContractProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerContractProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerContractProfileInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerContractProfileInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerContractProfileInfoQuery,
    GetCustomerContractProfileInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerContractProfileInfoQuery,
    GetCustomerContractProfileInfoQueryVariables
  >(GetCustomerContractProfileInfoDocument, options);
}
export function useGetCustomerContractProfileInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerContractProfileInfoQuery,
    GetCustomerContractProfileInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerContractProfileInfoQuery,
    GetCustomerContractProfileInfoQueryVariables
  >(GetCustomerContractProfileInfoDocument, options);
}
export type GetCustomerContractProfileInfoQueryHookResult = ReturnType<
  typeof useGetCustomerContractProfileInfoQuery
>;
export type GetCustomerContractProfileInfoLazyQueryHookResult = ReturnType<
  typeof useGetCustomerContractProfileInfoLazyQuery
>;
export namespace GetCustomerContractProfileInfo {
  export type Return = GetCustomerContractProfileInfoQuery;
  export type Variables = GetCustomerContractProfileInfoQueryVariables;
  export const OperationName = "getCustomerContractProfileInfo";

  export const Document = GetCustomerContractProfileInfoDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshots_ByContractIdDocument = gql`
  query CustomerContractSnapshots_ByContractId($customerContractId: ObjectId!) {
    getCustomerContractSnapshots(customerContractId: $customerContractId) {
      ...CustomerContractSnapshotListItem
    }
  }
  ${CustomerContractSnapshotListItemFragmentDoc}
`;
export type CustomerContractSnapshots_ByContractIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractSnapshots_ByContractIdQuery,
    CustomerContractSnapshots_ByContractIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerContractSnapshots_ByContractIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerContractSnapshots_ByContractIdComponent = (
  props: CustomerContractSnapshots_ByContractIdComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractSnapshots_ByContractIdQuery,
    CustomerContractSnapshots_ByContractIdQueryVariables
  >
    query={CustomerContractSnapshots_ByContractIdDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshots_ByContractIdQuery__
 *
 * To run a query within a React component, call `useCustomerContractSnapshots_ByContractIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshots_ByContractIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractSnapshots_ByContractIdQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useCustomerContractSnapshots_ByContractIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractSnapshots_ByContractIdQuery,
    CustomerContractSnapshots_ByContractIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractSnapshots_ByContractIdQuery,
    CustomerContractSnapshots_ByContractIdQueryVariables
  >(CustomerContractSnapshots_ByContractIdDocument, options);
}
export function useCustomerContractSnapshots_ByContractIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractSnapshots_ByContractIdQuery,
    CustomerContractSnapshots_ByContractIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractSnapshots_ByContractIdQuery,
    CustomerContractSnapshots_ByContractIdQueryVariables
  >(CustomerContractSnapshots_ByContractIdDocument, options);
}
export type CustomerContractSnapshots_ByContractIdQueryHookResult = ReturnType<
  typeof useCustomerContractSnapshots_ByContractIdQuery
>;
export type CustomerContractSnapshots_ByContractIdLazyQueryHookResult = ReturnType<
  typeof useCustomerContractSnapshots_ByContractIdLazyQuery
>;
export namespace CustomerContractSnapshots_ByContractId {
  export type Return = CustomerContractSnapshots_ByContractIdQuery;
  export type Variables = CustomerContractSnapshots_ByContractIdQueryVariables;
  export const OperationName = "CustomerContractSnapshots_ByContractId";

  export const Document = CustomerContractSnapshots_ByContractIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshots_ContractInfoDocument = gql`
  query CustomerContractSnapshots_ContractInfo($customerContractId: ObjectId!) {
    customerContractById(customerContractId: $customerContractId) {
      _id
      contractNumber
      orgCustomers {
        _id
        Name
      }
      professions
      isNationalProcurement
      company
      contactPerson {
        _id
        title
        email
        name
        phone
      }
    }
  }
`;
export type CustomerContractSnapshots_ContractInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractSnapshots_ContractInfoQuery,
    CustomerContractSnapshots_ContractInfoQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerContractSnapshots_ContractInfoQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerContractSnapshots_ContractInfoComponent = (
  props: CustomerContractSnapshots_ContractInfoComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractSnapshots_ContractInfoQuery,
    CustomerContractSnapshots_ContractInfoQueryVariables
  >
    query={CustomerContractSnapshots_ContractInfoDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshots_ContractInfoQuery__
 *
 * To run a query within a React component, call `useCustomerContractSnapshots_ContractInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshots_ContractInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractSnapshots_ContractInfoQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useCustomerContractSnapshots_ContractInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractSnapshots_ContractInfoQuery,
    CustomerContractSnapshots_ContractInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractSnapshots_ContractInfoQuery,
    CustomerContractSnapshots_ContractInfoQueryVariables
  >(CustomerContractSnapshots_ContractInfoDocument, options);
}
export function useCustomerContractSnapshots_ContractInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractSnapshots_ContractInfoQuery,
    CustomerContractSnapshots_ContractInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractSnapshots_ContractInfoQuery,
    CustomerContractSnapshots_ContractInfoQueryVariables
  >(CustomerContractSnapshots_ContractInfoDocument, options);
}
export type CustomerContractSnapshots_ContractInfoQueryHookResult = ReturnType<
  typeof useCustomerContractSnapshots_ContractInfoQuery
>;
export type CustomerContractSnapshots_ContractInfoLazyQueryHookResult = ReturnType<
  typeof useCustomerContractSnapshots_ContractInfoLazyQuery
>;
export namespace CustomerContractSnapshots_ContractInfo {
  export type Return = CustomerContractSnapshots_ContractInfoQuery;
  export type Variables = CustomerContractSnapshots_ContractInfoQueryVariables;
  export const OperationName = "CustomerContractSnapshots_ContractInfo";

  export const Document = CustomerContractSnapshots_ContractInfoDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshot_ByIdDocument = gql`
  query CustomerContractSnapshot_ById($snapshotId: ObjectId!) {
    customerContractSnapshotById(snapshotId: $snapshotId) {
      _id
      parentId
      customerContractId
      consultantId
      customerId
      invoiceMarking
      contactPersonId
      responsiblePersonId
      type
    }
  }
`;
export type CustomerContractSnapshot_ByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractSnapshot_ByIdQuery,
    CustomerContractSnapshot_ByIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerContractSnapshot_ByIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerContractSnapshot_ByIdComponent = (
  props: CustomerContractSnapshot_ByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractSnapshot_ByIdQuery,
    CustomerContractSnapshot_ByIdQueryVariables
  >
    query={CustomerContractSnapshot_ByIdDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshot_ByIdQuery__
 *
 * To run a query within a React component, call `useCustomerContractSnapshot_ByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshot_ByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractSnapshot_ByIdQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useCustomerContractSnapshot_ByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractSnapshot_ByIdQuery,
    CustomerContractSnapshot_ByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractSnapshot_ByIdQuery,
    CustomerContractSnapshot_ByIdQueryVariables
  >(CustomerContractSnapshot_ByIdDocument, options);
}
export function useCustomerContractSnapshot_ByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractSnapshot_ByIdQuery,
    CustomerContractSnapshot_ByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractSnapshot_ByIdQuery,
    CustomerContractSnapshot_ByIdQueryVariables
  >(CustomerContractSnapshot_ByIdDocument, options);
}
export type CustomerContractSnapshot_ByIdQueryHookResult = ReturnType<
  typeof useCustomerContractSnapshot_ByIdQuery
>;
export type CustomerContractSnapshot_ByIdLazyQueryHookResult = ReturnType<
  typeof useCustomerContractSnapshot_ByIdLazyQuery
>;
export namespace CustomerContractSnapshot_ById {
  export type Return = CustomerContractSnapshot_ByIdQuery;
  export type Variables = CustomerContractSnapshot_ByIdQueryVariables;
  export const OperationName = "CustomerContractSnapshot_ById";

  export const Document = CustomerContractSnapshot_ByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshot_UploadSignedDocument = gql`
  mutation CustomerContractSnapshot_UploadSigned(
    $snapshotId: ObjectId!
    $signedOn: Date!
    $file: Upload!
  ) {
    uploadCustomerContractSignedDocument(
      snapshotId: $snapshotId
      file: $file
      signedOn: $signedOn
    ) {
      errors
      value {
        _id
        name
      }
    }
  }
`;
export type CustomerContractSnapshot_UploadSignedMutationFn = Apollo.MutationFunction<
  CustomerContractSnapshot_UploadSignedMutation,
  CustomerContractSnapshot_UploadSignedMutationVariables
>;
export type CustomerContractSnapshot_UploadSignedComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSnapshot_UploadSignedMutation,
    CustomerContractSnapshot_UploadSignedMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSnapshot_UploadSignedComponent = (
  props: CustomerContractSnapshot_UploadSignedComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSnapshot_UploadSignedMutation,
    CustomerContractSnapshot_UploadSignedMutationVariables
  >
    mutation={CustomerContractSnapshot_UploadSignedDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshot_UploadSignedMutation__
 *
 * To run a mutation, you first call `useCustomerContractSnapshot_UploadSignedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshot_UploadSignedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSnapshotUploadSignedMutation, { data, loading, error }] = useCustomerContractSnapshot_UploadSignedMutation({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      signedOn: // value for 'signedOn'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCustomerContractSnapshot_UploadSignedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSnapshot_UploadSignedMutation,
    CustomerContractSnapshot_UploadSignedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSnapshot_UploadSignedMutation,
    CustomerContractSnapshot_UploadSignedMutationVariables
  >(CustomerContractSnapshot_UploadSignedDocument, options);
}
export type CustomerContractSnapshot_UploadSignedMutationHookResult = ReturnType<
  typeof useCustomerContractSnapshot_UploadSignedMutation
>;
export namespace CustomerContractSnapshot_UploadSigned {
  export type Return = CustomerContractSnapshot_UploadSignedMutation;
  export type Variables = CustomerContractSnapshot_UploadSignedMutationVariables;
  export const OperationName = "CustomerContractSnapshot_UploadSigned";

  export const Document = CustomerContractSnapshot_UploadSignedDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshot_SubmitFormDocument = gql`
  mutation CustomerContractSnapshot_SubmitForm(
    $snapshotId: ObjectId
    $data: CustomerContractSnapshotFormInput!
  ) {
    submitCustomerContractSnapshotForm(snapshotId: $snapshotId, data: $data) {
      errors
      value {
        _id
        name
      }
    }
  }
`;
export type CustomerContractSnapshot_SubmitFormMutationFn = Apollo.MutationFunction<
  CustomerContractSnapshot_SubmitFormMutation,
  CustomerContractSnapshot_SubmitFormMutationVariables
>;
export type CustomerContractSnapshot_SubmitFormComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSnapshot_SubmitFormMutation,
    CustomerContractSnapshot_SubmitFormMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSnapshot_SubmitFormComponent = (
  props: CustomerContractSnapshot_SubmitFormComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSnapshot_SubmitFormMutation,
    CustomerContractSnapshot_SubmitFormMutationVariables
  >
    mutation={CustomerContractSnapshot_SubmitFormDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshot_SubmitFormMutation__
 *
 * To run a mutation, you first call `useCustomerContractSnapshot_SubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshot_SubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSnapshotSubmitFormMutation, { data, loading, error }] = useCustomerContractSnapshot_SubmitFormMutation({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCustomerContractSnapshot_SubmitFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSnapshot_SubmitFormMutation,
    CustomerContractSnapshot_SubmitFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSnapshot_SubmitFormMutation,
    CustomerContractSnapshot_SubmitFormMutationVariables
  >(CustomerContractSnapshot_SubmitFormDocument, options);
}
export type CustomerContractSnapshot_SubmitFormMutationHookResult = ReturnType<
  typeof useCustomerContractSnapshot_SubmitFormMutation
>;
export namespace CustomerContractSnapshot_SubmitForm {
  export type Return = CustomerContractSnapshot_SubmitFormMutation;
  export type Variables = CustomerContractSnapshot_SubmitFormMutationVariables;
  export const OperationName = "CustomerContractSnapshot_SubmitForm";

  export const Document = CustomerContractSnapshot_SubmitFormDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshot_DeleteDocument = gql`
  mutation CustomerContractSnapshot_Delete($snapshotId: ObjectId!) {
    deleteCustomerContractSnapshot(snapshotId: $snapshotId) {
      errors
      value {
        _id
      }
    }
  }
`;
export type CustomerContractSnapshot_DeleteMutationFn = Apollo.MutationFunction<
  CustomerContractSnapshot_DeleteMutation,
  CustomerContractSnapshot_DeleteMutationVariables
>;
export type CustomerContractSnapshot_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSnapshot_DeleteMutation,
    CustomerContractSnapshot_DeleteMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSnapshot_DeleteComponent = (
  props: CustomerContractSnapshot_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSnapshot_DeleteMutation,
    CustomerContractSnapshot_DeleteMutationVariables
  >
    mutation={CustomerContractSnapshot_DeleteDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshot_DeleteMutation__
 *
 * To run a mutation, you first call `useCustomerContractSnapshot_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshot_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSnapshotDeleteMutation, { data, loading, error }] = useCustomerContractSnapshot_DeleteMutation({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useCustomerContractSnapshot_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSnapshot_DeleteMutation,
    CustomerContractSnapshot_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSnapshot_DeleteMutation,
    CustomerContractSnapshot_DeleteMutationVariables
  >(CustomerContractSnapshot_DeleteDocument, options);
}
export type CustomerContractSnapshot_DeleteMutationHookResult = ReturnType<
  typeof useCustomerContractSnapshot_DeleteMutation
>;
export namespace CustomerContractSnapshot_Delete {
  export type Return = CustomerContractSnapshot_DeleteMutation;
  export type Variables = CustomerContractSnapshot_DeleteMutationVariables;
  export const OperationName = "CustomerContractSnapshot_Delete";

  export const Document = CustomerContractSnapshot_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshot_GenerateDocument = gql`
  mutation CustomerContractSnapshot_Generate($snapshotId: ObjectId!) {
    generateCustomerContractSnapshot(snapshotId: $snapshotId) {
      errors
      value {
        _id
      }
    }
  }
`;
export type CustomerContractSnapshot_GenerateMutationFn = Apollo.MutationFunction<
  CustomerContractSnapshot_GenerateMutation,
  CustomerContractSnapshot_GenerateMutationVariables
>;
export type CustomerContractSnapshot_GenerateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSnapshot_GenerateMutation,
    CustomerContractSnapshot_GenerateMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSnapshot_GenerateComponent = (
  props: CustomerContractSnapshot_GenerateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSnapshot_GenerateMutation,
    CustomerContractSnapshot_GenerateMutationVariables
  >
    mutation={CustomerContractSnapshot_GenerateDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshot_GenerateMutation__
 *
 * To run a mutation, you first call `useCustomerContractSnapshot_GenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshot_GenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSnapshotGenerateMutation, { data, loading, error }] = useCustomerContractSnapshot_GenerateMutation({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useCustomerContractSnapshot_GenerateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSnapshot_GenerateMutation,
    CustomerContractSnapshot_GenerateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSnapshot_GenerateMutation,
    CustomerContractSnapshot_GenerateMutationVariables
  >(CustomerContractSnapshot_GenerateDocument, options);
}
export type CustomerContractSnapshot_GenerateMutationHookResult = ReturnType<
  typeof useCustomerContractSnapshot_GenerateMutation
>;
export namespace CustomerContractSnapshot_Generate {
  export type Return = CustomerContractSnapshot_GenerateMutation;
  export type Variables = CustomerContractSnapshot_GenerateMutationVariables;
  export const OperationName = "CustomerContractSnapshot_Generate";

  export const Document = CustomerContractSnapshot_GenerateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractSnapshot_NullifyDocument = gql`
  mutation CustomerContractSnapshot_Nullify($value: Boolean!, $snapshotId: ObjectId!) {
    nullifyCustomerContractSnapshot(nullify: $value, snapshotId: $snapshotId) {
      errors
      value {
        _id
      }
    }
  }
`;
export type CustomerContractSnapshot_NullifyMutationFn = Apollo.MutationFunction<
  CustomerContractSnapshot_NullifyMutation,
  CustomerContractSnapshot_NullifyMutationVariables
>;
export type CustomerContractSnapshot_NullifyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSnapshot_NullifyMutation,
    CustomerContractSnapshot_NullifyMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSnapshot_NullifyComponent = (
  props: CustomerContractSnapshot_NullifyComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSnapshot_NullifyMutation,
    CustomerContractSnapshot_NullifyMutationVariables
  >
    mutation={CustomerContractSnapshot_NullifyDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSnapshot_NullifyMutation__
 *
 * To run a mutation, you first call `useCustomerContractSnapshot_NullifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSnapshot_NullifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSnapshotNullifyMutation, { data, loading, error }] = useCustomerContractSnapshot_NullifyMutation({
 *   variables: {
 *      value: // value for 'value'
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useCustomerContractSnapshot_NullifyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSnapshot_NullifyMutation,
    CustomerContractSnapshot_NullifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSnapshot_NullifyMutation,
    CustomerContractSnapshot_NullifyMutationVariables
  >(CustomerContractSnapshot_NullifyDocument, options);
}
export type CustomerContractSnapshot_NullifyMutationHookResult = ReturnType<
  typeof useCustomerContractSnapshot_NullifyMutation
>;
export namespace CustomerContractSnapshot_Nullify {
  export type Return = CustomerContractSnapshot_NullifyMutation;
  export type Variables = CustomerContractSnapshot_NullifyMutationVariables;
  export const OperationName = "CustomerContractSnapshot_Nullify";

  export const Document = CustomerContractSnapshot_NullifyDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const PublishCustomerContractSnapshotDocument = gql`
  mutation publishCustomerContractSnapshot($snapshotId: ObjectId!) {
    publishCustomerContractSnapshot(snapshotId: $snapshotId)
  }
`;
export type PublishCustomerContractSnapshotMutationFn = Apollo.MutationFunction<
  PublishCustomerContractSnapshotMutation,
  PublishCustomerContractSnapshotMutationVariables
>;
export type PublishCustomerContractSnapshotComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    PublishCustomerContractSnapshotMutation,
    PublishCustomerContractSnapshotMutationVariables
  >,
  "mutation"
>;

export const PublishCustomerContractSnapshotComponent = (
  props: PublishCustomerContractSnapshotComponentProps
) => (
  <ApolloReactComponents.Mutation<
    PublishCustomerContractSnapshotMutation,
    PublishCustomerContractSnapshotMutationVariables
  >
    mutation={PublishCustomerContractSnapshotDocument}
    {...props}
  />
);

/**
 * __usePublishCustomerContractSnapshotMutation__
 *
 * To run a mutation, you first call `usePublishCustomerContractSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCustomerContractSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCustomerContractSnapshotMutation, { data, loading, error }] = usePublishCustomerContractSnapshotMutation({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function usePublishCustomerContractSnapshotMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishCustomerContractSnapshotMutation,
    PublishCustomerContractSnapshotMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishCustomerContractSnapshotMutation,
    PublishCustomerContractSnapshotMutationVariables
  >(PublishCustomerContractSnapshotDocument, options);
}
export type PublishCustomerContractSnapshotMutationHookResult = ReturnType<
  typeof usePublishCustomerContractSnapshotMutation
>;
export namespace PublishCustomerContractSnapshot {
  export type Return = PublishCustomerContractSnapshotMutation;
  export type Variables = PublishCustomerContractSnapshotMutationVariables;
  export const OperationName = "publishCustomerContractSnapshot";

  export const Document = PublishCustomerContractSnapshotDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractSubVersions_ByContractIdDocument = gql`
  query CustomerContractSubVersions_ByContractId($customerContractId: ObjectId!) {
    customerContractById(customerContractId: $customerContractId) {
      ...CustomerContractSubVersionListItem
    }
  }
  ${CustomerContractSubVersionListItemFragmentDoc}
`;
export type CustomerContractSubVersions_ByContractIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractSubVersions_ByContractIdQuery,
    CustomerContractSubVersions_ByContractIdQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: CustomerContractSubVersions_ByContractIdQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const CustomerContractSubVersions_ByContractIdComponent = (
  props: CustomerContractSubVersions_ByContractIdComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractSubVersions_ByContractIdQuery,
    CustomerContractSubVersions_ByContractIdQueryVariables
  >
    query={CustomerContractSubVersions_ByContractIdDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSubVersions_ByContractIdQuery__
 *
 * To run a query within a React component, call `useCustomerContractSubVersions_ByContractIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSubVersions_ByContractIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractSubVersions_ByContractIdQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useCustomerContractSubVersions_ByContractIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractSubVersions_ByContractIdQuery,
    CustomerContractSubVersions_ByContractIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractSubVersions_ByContractIdQuery,
    CustomerContractSubVersions_ByContractIdQueryVariables
  >(CustomerContractSubVersions_ByContractIdDocument, options);
}
export function useCustomerContractSubVersions_ByContractIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractSubVersions_ByContractIdQuery,
    CustomerContractSubVersions_ByContractIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractSubVersions_ByContractIdQuery,
    CustomerContractSubVersions_ByContractIdQueryVariables
  >(CustomerContractSubVersions_ByContractIdDocument, options);
}
export type CustomerContractSubVersions_ByContractIdQueryHookResult = ReturnType<
  typeof useCustomerContractSubVersions_ByContractIdQuery
>;
export type CustomerContractSubVersions_ByContractIdLazyQueryHookResult = ReturnType<
  typeof useCustomerContractSubVersions_ByContractIdLazyQuery
>;
export namespace CustomerContractSubVersions_ByContractId {
  export type Return = CustomerContractSubVersions_ByContractIdQuery;
  export type Variables = CustomerContractSubVersions_ByContractIdQueryVariables;
  export const OperationName = "CustomerContractSubVersions_ByContractId";

  export const Document = CustomerContractSubVersions_ByContractIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractInfo_ForSubVersionsDocument = gql`
  query CustomerContractInfo_ForSubVersions($customerContractId: ObjectId!) {
    customerContractById(customerContractId: $customerContractId) {
      _id
      contractName
    }
  }
`;
export type CustomerContractInfo_ForSubVersionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractInfo_ForSubVersionsQuery,
    CustomerContractInfo_ForSubVersionsQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerContractInfo_ForSubVersionsQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerContractInfo_ForSubVersionsComponent = (
  props: CustomerContractInfo_ForSubVersionsComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractInfo_ForSubVersionsQuery,
    CustomerContractInfo_ForSubVersionsQueryVariables
  >
    query={CustomerContractInfo_ForSubVersionsDocument}
    {...props}
  />
);

/**
 * __useCustomerContractInfo_ForSubVersionsQuery__
 *
 * To run a query within a React component, call `useCustomerContractInfo_ForSubVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractInfo_ForSubVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractInfo_ForSubVersionsQuery({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useCustomerContractInfo_ForSubVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractInfo_ForSubVersionsQuery,
    CustomerContractInfo_ForSubVersionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractInfo_ForSubVersionsQuery,
    CustomerContractInfo_ForSubVersionsQueryVariables
  >(CustomerContractInfo_ForSubVersionsDocument, options);
}
export function useCustomerContractInfo_ForSubVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractInfo_ForSubVersionsQuery,
    CustomerContractInfo_ForSubVersionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractInfo_ForSubVersionsQuery,
    CustomerContractInfo_ForSubVersionsQueryVariables
  >(CustomerContractInfo_ForSubVersionsDocument, options);
}
export type CustomerContractInfo_ForSubVersionsQueryHookResult = ReturnType<
  typeof useCustomerContractInfo_ForSubVersionsQuery
>;
export type CustomerContractInfo_ForSubVersionsLazyQueryHookResult = ReturnType<
  typeof useCustomerContractInfo_ForSubVersionsLazyQuery
>;
export namespace CustomerContractInfo_ForSubVersions {
  export type Return = CustomerContractInfo_ForSubVersionsQuery;
  export type Variables = CustomerContractInfo_ForSubVersionsQueryVariables;
  export const OperationName = "CustomerContractInfo_ForSubVersions";

  export const Document = CustomerContractInfo_ForSubVersionsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractSubVersion_ByIdDocument = gql`
  query CustomerContractSubVersion_ById(
    $subVersionId: ObjectId!
    $customerContractId: ObjectId!
  ) {
    customerContractSubVersionById(
      customerContractId: $customerContractId
      subVersionId: $subVersionId
    ) {
      ...CustomerContractSubVersion
    }
  }
  ${CustomerContractSubVersionFragmentDoc}
`;
export type CustomerContractSubVersion_ByIdComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractSubVersion_ByIdQuery,
    CustomerContractSubVersion_ByIdQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerContractSubVersion_ByIdQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerContractSubVersion_ByIdComponent = (
  props: CustomerContractSubVersion_ByIdComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractSubVersion_ByIdQuery,
    CustomerContractSubVersion_ByIdQueryVariables
  >
    query={CustomerContractSubVersion_ByIdDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSubVersion_ByIdQuery__
 *
 * To run a query within a React component, call `useCustomerContractSubVersion_ByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSubVersion_ByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractSubVersion_ByIdQuery({
 *   variables: {
 *      subVersionId: // value for 'subVersionId'
 *      customerContractId: // value for 'customerContractId'
 *   },
 * });
 */
export function useCustomerContractSubVersion_ByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractSubVersion_ByIdQuery,
    CustomerContractSubVersion_ByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractSubVersion_ByIdQuery,
    CustomerContractSubVersion_ByIdQueryVariables
  >(CustomerContractSubVersion_ByIdDocument, options);
}
export function useCustomerContractSubVersion_ByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractSubVersion_ByIdQuery,
    CustomerContractSubVersion_ByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractSubVersion_ByIdQuery,
    CustomerContractSubVersion_ByIdQueryVariables
  >(CustomerContractSubVersion_ByIdDocument, options);
}
export type CustomerContractSubVersion_ByIdQueryHookResult = ReturnType<
  typeof useCustomerContractSubVersion_ByIdQuery
>;
export type CustomerContractSubVersion_ByIdLazyQueryHookResult = ReturnType<
  typeof useCustomerContractSubVersion_ByIdLazyQuery
>;
export namespace CustomerContractSubVersion_ById {
  export type Return = CustomerContractSubVersion_ByIdQuery;
  export type Variables = CustomerContractSubVersion_ByIdQueryVariables;
  export const OperationName = "CustomerContractSubVersion_ById";

  export const Document = CustomerContractSubVersion_ByIdDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractSubVersion_SubmitFormDocument = gql`
  mutation CustomerContractSubVersion_SubmitForm(
    $customerContractId: ObjectId!
    $subVersionId: ObjectId
    $data: SubVersionFormInput!
    $file: Upload
  ) {
    submitCustomerContractSubVersionForm(
      customerContractId: $customerContractId
      subVersionId: $subVersionId
      data: $data
      file: $file
    ) {
      errors
      value {
        _id
        subVersions {
          _id
          consultantId
          name
        }
      }
    }
  }
`;
export type CustomerContractSubVersion_SubmitFormMutationFn = Apollo.MutationFunction<
  CustomerContractSubVersion_SubmitFormMutation,
  CustomerContractSubVersion_SubmitFormMutationVariables
>;
export type CustomerContractSubVersion_SubmitFormComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSubVersion_SubmitFormMutation,
    CustomerContractSubVersion_SubmitFormMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSubVersion_SubmitFormComponent = (
  props: CustomerContractSubVersion_SubmitFormComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSubVersion_SubmitFormMutation,
    CustomerContractSubVersion_SubmitFormMutationVariables
  >
    mutation={CustomerContractSubVersion_SubmitFormDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSubVersion_SubmitFormMutation__
 *
 * To run a mutation, you first call `useCustomerContractSubVersion_SubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSubVersion_SubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSubVersionSubmitFormMutation, { data, loading, error }] = useCustomerContractSubVersion_SubmitFormMutation({
 *   variables: {
 *      customerContractId: // value for 'customerContractId'
 *      subVersionId: // value for 'subVersionId'
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCustomerContractSubVersion_SubmitFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSubVersion_SubmitFormMutation,
    CustomerContractSubVersion_SubmitFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSubVersion_SubmitFormMutation,
    CustomerContractSubVersion_SubmitFormMutationVariables
  >(CustomerContractSubVersion_SubmitFormDocument, options);
}
export type CustomerContractSubVersion_SubmitFormMutationHookResult = ReturnType<
  typeof useCustomerContractSubVersion_SubmitFormMutation
>;
export namespace CustomerContractSubVersion_SubmitForm {
  export type Return = CustomerContractSubVersion_SubmitFormMutation;
  export type Variables = CustomerContractSubVersion_SubmitFormMutationVariables;
  export const OperationName = "CustomerContractSubVersion_SubmitForm";

  export const Document = CustomerContractSubVersion_SubmitFormDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractSubVersion_DeleteDocument = gql`
  mutation CustomerContractSubVersion_Delete($subVersionId: ObjectId!) {
    deleteCustomerContractSubVersion(subVersionId: $subVersionId) {
      errors
      value {
        _id
      }
    }
  }
`;
export type CustomerContractSubVersion_DeleteMutationFn = Apollo.MutationFunction<
  CustomerContractSubVersion_DeleteMutation,
  CustomerContractSubVersion_DeleteMutationVariables
>;
export type CustomerContractSubVersion_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContractSubVersion_DeleteMutation,
    CustomerContractSubVersion_DeleteMutationVariables
  >,
  "mutation"
>;

export const CustomerContractSubVersion_DeleteComponent = (
  props: CustomerContractSubVersion_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContractSubVersion_DeleteMutation,
    CustomerContractSubVersion_DeleteMutationVariables
  >
    mutation={CustomerContractSubVersion_DeleteDocument}
    {...props}
  />
);

/**
 * __useCustomerContractSubVersion_DeleteMutation__
 *
 * To run a mutation, you first call `useCustomerContractSubVersion_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractSubVersion_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContractSubVersionDeleteMutation, { data, loading, error }] = useCustomerContractSubVersion_DeleteMutation({
 *   variables: {
 *      subVersionId: // value for 'subVersionId'
 *   },
 * });
 */
export function useCustomerContractSubVersion_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContractSubVersion_DeleteMutation,
    CustomerContractSubVersion_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContractSubVersion_DeleteMutation,
    CustomerContractSubVersion_DeleteMutationVariables
  >(CustomerContractSubVersion_DeleteDocument, options);
}
export type CustomerContractSubVersion_DeleteMutationHookResult = ReturnType<
  typeof useCustomerContractSubVersion_DeleteMutation
>;
export namespace CustomerContractSubVersion_Delete {
  export type Return = CustomerContractSubVersion_DeleteMutation;
  export type Variables = CustomerContractSubVersion_DeleteMutationVariables;
  export const OperationName = "CustomerContractSubVersion_Delete";

  export const Document = CustomerContractSubVersion_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerContractsDocument = gql`
  query CustomerContracts(
    $filter: CustomerContractFilter
    $skip: Int = 0
    $limit: Int = 20
    $sortBy: CustomerContractSortBy = CustomerName
    $sortOrder: SortOrder = Asc
  ) {
    customerContracts(
      filter: $filter
      skip: $skip
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      items {
        ...CustomerContractsFragment
      }
      skip
      limit
    }
  }
  ${CustomerContractsFragmentFragmentDoc}
`;
export type CustomerContractsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractsQuery,
    CustomerContractsQueryVariables
  >,
  "query"
>;

export const CustomerContractsComponent = (props: CustomerContractsComponentProps) => (
  <ApolloReactComponents.Query<CustomerContractsQuery, CustomerContractsQueryVariables>
    query={CustomerContractsDocument}
    {...props}
  />
);

/**
 * __useCustomerContractsQuery__
 *
 * To run a query within a React component, call `useCustomerContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useCustomerContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractsQuery,
    CustomerContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerContractsQuery, CustomerContractsQueryVariables>(
    CustomerContractsDocument,
    options
  );
}
export function useCustomerContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractsQuery,
    CustomerContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomerContractsQuery, CustomerContractsQueryVariables>(
    CustomerContractsDocument,
    options
  );
}
export type CustomerContractsQueryHookResult = ReturnType<
  typeof useCustomerContractsQuery
>;
export type CustomerContractsLazyQueryHookResult = ReturnType<
  typeof useCustomerContractsLazyQuery
>;
export namespace CustomerContracts {
  export type Return = CustomerContractsQuery;
  export type Variables = CustomerContractsQueryVariables;
  export const OperationName = "CustomerContracts";

  export const Document = CustomerContractsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContractsTotalDocument = gql`
  query CustomerContractsTotal($filter: CustomerContractFilter) {
    customerContractsTotal(filter: $filter) {
      total
    }
  }
`;
export type CustomerContractsTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContractsTotalQuery,
    CustomerContractsTotalQueryVariables
  >,
  "query"
>;

export const CustomerContractsTotalComponent = (
  props: CustomerContractsTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContractsTotalQuery,
    CustomerContractsTotalQueryVariables
  >
    query={CustomerContractsTotalDocument}
    {...props}
  />
);

/**
 * __useCustomerContractsTotalQuery__
 *
 * To run a query within a React component, call `useCustomerContractsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractsTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerContractsTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContractsTotalQuery,
    CustomerContractsTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContractsTotalQuery,
    CustomerContractsTotalQueryVariables
  >(CustomerContractsTotalDocument, options);
}
export function useCustomerContractsTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContractsTotalQuery,
    CustomerContractsTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContractsTotalQuery,
    CustomerContractsTotalQueryVariables
  >(CustomerContractsTotalDocument, options);
}
export type CustomerContractsTotalQueryHookResult = ReturnType<
  typeof useCustomerContractsTotalQuery
>;
export type CustomerContractsTotalLazyQueryHookResult = ReturnType<
  typeof useCustomerContractsTotalLazyQuery
>;
export namespace CustomerContractsTotal {
  export type Return = CustomerContractsTotalQuery;
  export type Variables = CustomerContractsTotalQueryVariables;
  export const OperationName = "CustomerContractsTotal";

  export const Document = CustomerContractsTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const DeleteRestoreCustomerContractDocument = gql`
  mutation deleteRestoreCustomerContract($contractId: ObjectId!) {
    deleteRestoreCustomerContract(contractId: $contractId) {
      value {
        _id
        contractName
        deleted
      }
      errors
    }
  }
`;
export type DeleteRestoreCustomerContractMutationFn = Apollo.MutationFunction<
  DeleteRestoreCustomerContractMutation,
  DeleteRestoreCustomerContractMutationVariables
>;
export type DeleteRestoreCustomerContractComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteRestoreCustomerContractMutation,
    DeleteRestoreCustomerContractMutationVariables
  >,
  "mutation"
>;

export const DeleteRestoreCustomerContractComponent = (
  props: DeleteRestoreCustomerContractComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteRestoreCustomerContractMutation,
    DeleteRestoreCustomerContractMutationVariables
  >
    mutation={DeleteRestoreCustomerContractDocument}
    {...props}
  />
);

/**
 * __useDeleteRestoreCustomerContractMutation__
 *
 * To run a mutation, you first call `useDeleteRestoreCustomerContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRestoreCustomerContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRestoreCustomerContractMutation, { data, loading, error }] = useDeleteRestoreCustomerContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useDeleteRestoreCustomerContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRestoreCustomerContractMutation,
    DeleteRestoreCustomerContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRestoreCustomerContractMutation,
    DeleteRestoreCustomerContractMutationVariables
  >(DeleteRestoreCustomerContractDocument, options);
}
export type DeleteRestoreCustomerContractMutationHookResult = ReturnType<
  typeof useDeleteRestoreCustomerContractMutation
>;
export namespace DeleteRestoreCustomerContract {
  export type Return = DeleteRestoreCustomerContractMutation;
  export type Variables = DeleteRestoreCustomerContractMutationVariables;
  export const OperationName = "deleteRestoreCustomerContract";

  export const Document = DeleteRestoreCustomerContractDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SearchCustomersDocument = gql`
  query searchCustomers(
    $filter: CustomersFilter
    $skip: Int!
    $limit: Int!
    $sortBy: SortBy
    $sortOrder: SortOrder
  ) {
    customers(
      filter: $filter
      limit: $limit
      skip: $skip
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      dbTime
      items {
        ...CustomerSearchData
      }
    }
  }
  ${CustomerSearchDataFragmentDoc}
`;
export type SearchCustomersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SearchCustomersQuery,
    SearchCustomersQueryVariables
  >,
  "query"
> &
  ({ variables: SearchCustomersQueryVariables; skip?: boolean } | { skip: boolean });

export const SearchCustomersComponent = (props: SearchCustomersComponentProps) => (
  <ApolloReactComponents.Query<SearchCustomersQuery, SearchCustomersQueryVariables>
    query={SearchCustomersDocument}
    {...props}
  />
);

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSearchCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchCustomersQuery,
    SearchCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(
    SearchCustomersDocument,
    options
  );
}
export function useSearchCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchCustomersQuery,
    SearchCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(
    SearchCustomersDocument,
    options
  );
}
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<
  typeof useSearchCustomersLazyQuery
>;
export namespace SearchCustomers {
  export type Return = SearchCustomersQuery;
  export type Variables = SearchCustomersQueryVariables;
  export const OperationName = "searchCustomers";

  export const Document = SearchCustomersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerAreasOfExpertise_GetDocument = gql`
  query CustomerAreasOfExpertise_Get($id: ObjectId!) {
    customerById(id: $id) {
      ...CustomerAreasOfExpertise
    }
  }
  ${CustomerAreasOfExpertiseFragmentDoc}
`;
export type CustomerAreasOfExpertise_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerAreasOfExpertise_GetQuery,
    CustomerAreasOfExpertise_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerAreasOfExpertise_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerAreasOfExpertise_GetComponent = (
  props: CustomerAreasOfExpertise_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerAreasOfExpertise_GetQuery,
    CustomerAreasOfExpertise_GetQueryVariables
  >
    query={CustomerAreasOfExpertise_GetDocument}
    {...props}
  />
);

/**
 * __useCustomerAreasOfExpertise_GetQuery__
 *
 * To run a query within a React component, call `useCustomerAreasOfExpertise_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAreasOfExpertise_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAreasOfExpertise_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerAreasOfExpertise_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerAreasOfExpertise_GetQuery,
    CustomerAreasOfExpertise_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerAreasOfExpertise_GetQuery,
    CustomerAreasOfExpertise_GetQueryVariables
  >(CustomerAreasOfExpertise_GetDocument, options);
}
export function useCustomerAreasOfExpertise_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerAreasOfExpertise_GetQuery,
    CustomerAreasOfExpertise_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerAreasOfExpertise_GetQuery,
    CustomerAreasOfExpertise_GetQueryVariables
  >(CustomerAreasOfExpertise_GetDocument, options);
}
export type CustomerAreasOfExpertise_GetQueryHookResult = ReturnType<
  typeof useCustomerAreasOfExpertise_GetQuery
>;
export type CustomerAreasOfExpertise_GetLazyQueryHookResult = ReturnType<
  typeof useCustomerAreasOfExpertise_GetLazyQuery
>;
export namespace CustomerAreasOfExpertise_Get {
  export type Return = CustomerAreasOfExpertise_GetQuery;
  export type Variables = CustomerAreasOfExpertise_GetQueryVariables;
  export const OperationName = "CustomerAreasOfExpertise_Get";

  export const Document = CustomerAreasOfExpertise_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerCard_GetDocument = gql`
  query CustomerCard_Get($id: ObjectId!) {
    customerById(id: $id) {
      ...SimpleCustomerCard
    }
  }
  ${SimpleCustomerCardFragmentDoc}
`;
export type CustomerCard_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerCard_GetQuery,
    CustomerCard_GetQueryVariables
  >,
  "query"
> &
  ({ variables: CustomerCard_GetQueryVariables; skip?: boolean } | { skip: boolean });

export const CustomerCard_GetComponent = (props: CustomerCard_GetComponentProps) => (
  <ApolloReactComponents.Query<CustomerCard_GetQuery, CustomerCard_GetQueryVariables>
    query={CustomerCard_GetDocument}
    {...props}
  />
);

/**
 * __useCustomerCard_GetQuery__
 *
 * To run a query within a React component, call `useCustomerCard_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCard_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCard_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerCard_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerCard_GetQuery,
    CustomerCard_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerCard_GetQuery, CustomerCard_GetQueryVariables>(
    CustomerCard_GetDocument,
    options
  );
}
export function useCustomerCard_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerCard_GetQuery,
    CustomerCard_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomerCard_GetQuery, CustomerCard_GetQueryVariables>(
    CustomerCard_GetDocument,
    options
  );
}
export type CustomerCard_GetQueryHookResult = ReturnType<typeof useCustomerCard_GetQuery>;
export type CustomerCard_GetLazyQueryHookResult = ReturnType<
  typeof useCustomerCard_GetLazyQuery
>;
export namespace CustomerCard_Get {
  export type Return = CustomerCard_GetQuery;
  export type Variables = CustomerCard_GetQueryVariables;
  export const OperationName = "CustomerCard_Get";

  export const Document = CustomerCard_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SimpleCustomerCard_GetDocument = gql`
  query SimpleCustomerCard_Get($id: ObjectId!) {
    customerById(id: $id) {
      ...SimpleCustomerCard
    }
  }
  ${SimpleCustomerCardFragmentDoc}
`;
export type SimpleCustomerCard_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SimpleCustomerCard_GetQuery,
    SimpleCustomerCard_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: SimpleCustomerCard_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const SimpleCustomerCard_GetComponent = (
  props: SimpleCustomerCard_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    SimpleCustomerCard_GetQuery,
    SimpleCustomerCard_GetQueryVariables
  >
    query={SimpleCustomerCard_GetDocument}
    {...props}
  />
);

/**
 * __useSimpleCustomerCard_GetQuery__
 *
 * To run a query within a React component, call `useSimpleCustomerCard_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleCustomerCard_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleCustomerCard_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSimpleCustomerCard_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SimpleCustomerCard_GetQuery,
    SimpleCustomerCard_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SimpleCustomerCard_GetQuery,
    SimpleCustomerCard_GetQueryVariables
  >(SimpleCustomerCard_GetDocument, options);
}
export function useSimpleCustomerCard_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SimpleCustomerCard_GetQuery,
    SimpleCustomerCard_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SimpleCustomerCard_GetQuery,
    SimpleCustomerCard_GetQueryVariables
  >(SimpleCustomerCard_GetDocument, options);
}
export type SimpleCustomerCard_GetQueryHookResult = ReturnType<
  typeof useSimpleCustomerCard_GetQuery
>;
export type SimpleCustomerCard_GetLazyQueryHookResult = ReturnType<
  typeof useSimpleCustomerCard_GetLazyQuery
>;
export namespace SimpleCustomerCard_Get {
  export type Return = SimpleCustomerCard_GetQuery;
  export type Variables = SimpleCustomerCard_GetQueryVariables;
  export const OperationName = "SimpleCustomerCard_Get";

  export const Document = SimpleCustomerCard_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerChildrenList_GetDocument = gql`
  query CustomerChildrenList_Get($id: ObjectId!) {
    customerById(id: $id) {
      ...CustomerChildrenList
    }
  }
  ${CustomerChildrenListFragmentDoc}
`;
export type CustomerChildrenList_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerChildrenList_GetQuery,
    CustomerChildrenList_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerChildrenList_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerChildrenList_GetComponent = (
  props: CustomerChildrenList_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerChildrenList_GetQuery,
    CustomerChildrenList_GetQueryVariables
  >
    query={CustomerChildrenList_GetDocument}
    {...props}
  />
);

/**
 * __useCustomerChildrenList_GetQuery__
 *
 * To run a query within a React component, call `useCustomerChildrenList_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerChildrenList_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerChildrenList_GetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerChildrenList_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerChildrenList_GetQuery,
    CustomerChildrenList_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerChildrenList_GetQuery,
    CustomerChildrenList_GetQueryVariables
  >(CustomerChildrenList_GetDocument, options);
}
export function useCustomerChildrenList_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerChildrenList_GetQuery,
    CustomerChildrenList_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerChildrenList_GetQuery,
    CustomerChildrenList_GetQueryVariables
  >(CustomerChildrenList_GetDocument, options);
}
export type CustomerChildrenList_GetQueryHookResult = ReturnType<
  typeof useCustomerChildrenList_GetQuery
>;
export type CustomerChildrenList_GetLazyQueryHookResult = ReturnType<
  typeof useCustomerChildrenList_GetLazyQuery
>;
export namespace CustomerChildrenList_Get {
  export type Return = CustomerChildrenList_GetQuery;
  export type Variables = CustomerChildrenList_GetQueryVariables;
  export const OperationName = "CustomerChildrenList_Get";

  export const Document = CustomerChildrenList_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContactPersonForm_GetCustomerDocument = gql`
  query CustomerContactPersonForm_GetCustomer($customerId: ObjectId!) {
    customerById(id: $customerId) {
      ...CustomerContactPersonForm_Customer
    }
  }
  ${CustomerContactPersonForm_CustomerFragmentDoc}
`;
export type CustomerContactPersonForm_GetCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContactPersonForm_GetCustomerQuery,
    CustomerContactPersonForm_GetCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerContactPersonForm_GetCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerContactPersonForm_GetCustomerComponent = (
  props: CustomerContactPersonForm_GetCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContactPersonForm_GetCustomerQuery,
    CustomerContactPersonForm_GetCustomerQueryVariables
  >
    query={CustomerContactPersonForm_GetCustomerDocument}
    {...props}
  />
);

/**
 * __useCustomerContactPersonForm_GetCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerContactPersonForm_GetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContactPersonForm_GetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContactPersonForm_GetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerContactPersonForm_GetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContactPersonForm_GetCustomerQuery,
    CustomerContactPersonForm_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContactPersonForm_GetCustomerQuery,
    CustomerContactPersonForm_GetCustomerQueryVariables
  >(CustomerContactPersonForm_GetCustomerDocument, options);
}
export function useCustomerContactPersonForm_GetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContactPersonForm_GetCustomerQuery,
    CustomerContactPersonForm_GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContactPersonForm_GetCustomerQuery,
    CustomerContactPersonForm_GetCustomerQueryVariables
  >(CustomerContactPersonForm_GetCustomerDocument, options);
}
export type CustomerContactPersonForm_GetCustomerQueryHookResult = ReturnType<
  typeof useCustomerContactPersonForm_GetCustomerQuery
>;
export type CustomerContactPersonForm_GetCustomerLazyQueryHookResult = ReturnType<
  typeof useCustomerContactPersonForm_GetCustomerLazyQuery
>;
export namespace CustomerContactPersonForm_GetCustomer {
  export type Return = CustomerContactPersonForm_GetCustomerQuery;
  export type Variables = CustomerContactPersonForm_GetCustomerQueryVariables;
  export const OperationName = "CustomerContactPersonForm_GetCustomer";

  export const Document = CustomerContactPersonForm_GetCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContactPersonForm_FindContactPersonsDocument = gql`
  query CustomerContactPersonForm_FindContactPersons(
    $skip: Int!
    $limit: Int
    $text: [String!]!
    $rootCustomerId: ObjectId!
  ) {
    contactPersons(
      skip: $skip
      limit: $limit
      filter: { rootCustomerId: $rootCustomerId, text: $text }
    ) {
      items {
        ...CustomerContactPerson
      }
    }
  }
  ${CustomerContactPersonFragmentDoc}
`;
export type CustomerContactPersonForm_FindContactPersonsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerContactPersonForm_FindContactPersonsQuery,
    CustomerContactPersonForm_FindContactPersonsQueryVariables
  >,
  "query"
> &
  (
    | {
        variables: CustomerContactPersonForm_FindContactPersonsQueryVariables;
        skip?: boolean;
      }
    | { skip: boolean }
  );

export const CustomerContactPersonForm_FindContactPersonsComponent = (
  props: CustomerContactPersonForm_FindContactPersonsComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerContactPersonForm_FindContactPersonsQuery,
    CustomerContactPersonForm_FindContactPersonsQueryVariables
  >
    query={CustomerContactPersonForm_FindContactPersonsDocument}
    {...props}
  />
);

/**
 * __useCustomerContactPersonForm_FindContactPersonsQuery__
 *
 * To run a query within a React component, call `useCustomerContactPersonForm_FindContactPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContactPersonForm_FindContactPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContactPersonForm_FindContactPersonsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      text: // value for 'text'
 *      rootCustomerId: // value for 'rootCustomerId'
 *   },
 * });
 */
export function useCustomerContactPersonForm_FindContactPersonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerContactPersonForm_FindContactPersonsQuery,
    CustomerContactPersonForm_FindContactPersonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerContactPersonForm_FindContactPersonsQuery,
    CustomerContactPersonForm_FindContactPersonsQueryVariables
  >(CustomerContactPersonForm_FindContactPersonsDocument, options);
}
export function useCustomerContactPersonForm_FindContactPersonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerContactPersonForm_FindContactPersonsQuery,
    CustomerContactPersonForm_FindContactPersonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerContactPersonForm_FindContactPersonsQuery,
    CustomerContactPersonForm_FindContactPersonsQueryVariables
  >(CustomerContactPersonForm_FindContactPersonsDocument, options);
}
export type CustomerContactPersonForm_FindContactPersonsQueryHookResult = ReturnType<
  typeof useCustomerContactPersonForm_FindContactPersonsQuery
>;
export type CustomerContactPersonForm_FindContactPersonsLazyQueryHookResult = ReturnType<
  typeof useCustomerContactPersonForm_FindContactPersonsLazyQuery
>;
export namespace CustomerContactPersonForm_FindContactPersons {
  export type Return = CustomerContactPersonForm_FindContactPersonsQuery;
  export type Variables = CustomerContactPersonForm_FindContactPersonsQueryVariables;
  export const OperationName = "CustomerContactPersonForm_FindContactPersons";

  export const Document = CustomerContactPersonForm_FindContactPersonsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerContactPersonForm_AssignDocument = gql`
  mutation CustomerContactPersonForm_Assign(
    $contactPersonId: ObjectId!
    $customerId: ObjectId!
  ) {
    assignContactPersonToCustomer(
      contactPersonId: $contactPersonId
      customerId: $customerId
    ) {
      ContactPerson {
        ...CustomerContactPerson
      }
      Customer {
        _id
        ContactPersons {
          ...CustomerContactPerson
        }
      }
    }
  }
  ${CustomerContactPersonFragmentDoc}
`;
export type CustomerContactPersonForm_AssignMutationFn = Apollo.MutationFunction<
  CustomerContactPersonForm_AssignMutation,
  CustomerContactPersonForm_AssignMutationVariables
>;
export type CustomerContactPersonForm_AssignComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerContactPersonForm_AssignMutation,
    CustomerContactPersonForm_AssignMutationVariables
  >,
  "mutation"
>;

export const CustomerContactPersonForm_AssignComponent = (
  props: CustomerContactPersonForm_AssignComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerContactPersonForm_AssignMutation,
    CustomerContactPersonForm_AssignMutationVariables
  >
    mutation={CustomerContactPersonForm_AssignDocument}
    {...props}
  />
);

/**
 * __useCustomerContactPersonForm_AssignMutation__
 *
 * To run a mutation, you first call `useCustomerContactPersonForm_AssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerContactPersonForm_AssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerContactPersonFormAssignMutation, { data, loading, error }] = useCustomerContactPersonForm_AssignMutation({
 *   variables: {
 *      contactPersonId: // value for 'contactPersonId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerContactPersonForm_AssignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerContactPersonForm_AssignMutation,
    CustomerContactPersonForm_AssignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerContactPersonForm_AssignMutation,
    CustomerContactPersonForm_AssignMutationVariables
  >(CustomerContactPersonForm_AssignDocument, options);
}
export type CustomerContactPersonForm_AssignMutationHookResult = ReturnType<
  typeof useCustomerContactPersonForm_AssignMutation
>;
export namespace CustomerContactPersonForm_Assign {
  export type Return = CustomerContactPersonForm_AssignMutation;
  export type Variables = CustomerContactPersonForm_AssignMutationVariables;
  export const OperationName = "CustomerContactPersonForm_Assign";

  export const Document = CustomerContactPersonForm_AssignDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetMunicipalitiesDocument = gql`
  query getMunicipalities {
    municipalities {
      ...Municipality
    }
  }
  ${MunicipalityFragmentDoc}
`;
export type GetMunicipalitiesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetMunicipalitiesQuery,
    GetMunicipalitiesQueryVariables
  >,
  "query"
>;

export const GetMunicipalitiesComponent = (props: GetMunicipalitiesComponentProps) => (
  <ApolloReactComponents.Query<GetMunicipalitiesQuery, GetMunicipalitiesQueryVariables>
    query={GetMunicipalitiesDocument}
    {...props}
  />
);

/**
 * __useGetMunicipalitiesQuery__
 *
 * To run a query within a React component, call `useGetMunicipalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMunicipalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMunicipalitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMunicipalitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMunicipalitiesQuery,
    GetMunicipalitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMunicipalitiesQuery, GetMunicipalitiesQueryVariables>(
    GetMunicipalitiesDocument,
    options
  );
}
export function useGetMunicipalitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMunicipalitiesQuery,
    GetMunicipalitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMunicipalitiesQuery, GetMunicipalitiesQueryVariables>(
    GetMunicipalitiesDocument,
    options
  );
}
export type GetMunicipalitiesQueryHookResult = ReturnType<
  typeof useGetMunicipalitiesQuery
>;
export type GetMunicipalitiesLazyQueryHookResult = ReturnType<
  typeof useGetMunicipalitiesLazyQuery
>;
export namespace GetMunicipalities {
  export type Return = GetMunicipalitiesQuery;
  export type Variables = GetMunicipalitiesQueryVariables;
  export const OperationName = "getMunicipalities";

  export const Document = GetMunicipalitiesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerEditor_FetchDocument = gql`
  query CustomerEditor_Fetch($id: ObjectId!) {
    customerById(id: $id) {
      ...CustomerEditor_Customer
    }
  }
  ${CustomerEditor_CustomerFragmentDoc}
`;
export type CustomerEditor_FetchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerEditor_FetchQuery,
    CustomerEditor_FetchQueryVariables
  >,
  "query"
> &
  ({ variables: CustomerEditor_FetchQueryVariables; skip?: boolean } | { skip: boolean });

export const CustomerEditor_FetchComponent = (
  props: CustomerEditor_FetchComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerEditor_FetchQuery,
    CustomerEditor_FetchQueryVariables
  >
    query={CustomerEditor_FetchDocument}
    {...props}
  />
);

/**
 * __useCustomerEditor_FetchQuery__
 *
 * To run a query within a React component, call `useCustomerEditor_FetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerEditor_FetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerEditor_FetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerEditor_FetchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerEditor_FetchQuery,
    CustomerEditor_FetchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerEditor_FetchQuery, CustomerEditor_FetchQueryVariables>(
    CustomerEditor_FetchDocument,
    options
  );
}
export function useCustomerEditor_FetchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerEditor_FetchQuery,
    CustomerEditor_FetchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerEditor_FetchQuery,
    CustomerEditor_FetchQueryVariables
  >(CustomerEditor_FetchDocument, options);
}
export type CustomerEditor_FetchQueryHookResult = ReturnType<
  typeof useCustomerEditor_FetchQuery
>;
export type CustomerEditor_FetchLazyQueryHookResult = ReturnType<
  typeof useCustomerEditor_FetchLazyQuery
>;
export namespace CustomerEditor_Fetch {
  export type Return = CustomerEditor_FetchQuery;
  export type Variables = CustomerEditor_FetchQueryVariables;
  export const OperationName = "CustomerEditor_Fetch";

  export const Document = CustomerEditor_FetchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerEditor_LoadRegionsDocument = gql`
  query CustomerEditor_LoadRegions {
    customers(filter: { type: [Region] }, sortBy: Name, sortOrder: Asc) {
      items {
        Ref {
          ...CustomerRef
        }
      }
      dbTime
    }
  }
  ${CustomerRefFragmentDoc}
`;
export type CustomerEditor_LoadRegionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerEditor_LoadRegionsQuery,
    CustomerEditor_LoadRegionsQueryVariables
  >,
  "query"
>;

export const CustomerEditor_LoadRegionsComponent = (
  props: CustomerEditor_LoadRegionsComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerEditor_LoadRegionsQuery,
    CustomerEditor_LoadRegionsQueryVariables
  >
    query={CustomerEditor_LoadRegionsDocument}
    {...props}
  />
);

/**
 * __useCustomerEditor_LoadRegionsQuery__
 *
 * To run a query within a React component, call `useCustomerEditor_LoadRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerEditor_LoadRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerEditor_LoadRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerEditor_LoadRegionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerEditor_LoadRegionsQuery,
    CustomerEditor_LoadRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerEditor_LoadRegionsQuery,
    CustomerEditor_LoadRegionsQueryVariables
  >(CustomerEditor_LoadRegionsDocument, options);
}
export function useCustomerEditor_LoadRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerEditor_LoadRegionsQuery,
    CustomerEditor_LoadRegionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerEditor_LoadRegionsQuery,
    CustomerEditor_LoadRegionsQueryVariables
  >(CustomerEditor_LoadRegionsDocument, options);
}
export type CustomerEditor_LoadRegionsQueryHookResult = ReturnType<
  typeof useCustomerEditor_LoadRegionsQuery
>;
export type CustomerEditor_LoadRegionsLazyQueryHookResult = ReturnType<
  typeof useCustomerEditor_LoadRegionsLazyQuery
>;
export namespace CustomerEditor_LoadRegions {
  export type Return = CustomerEditor_LoadRegionsQuery;
  export type Variables = CustomerEditor_LoadRegionsQueryVariables;
  export const OperationName = "CustomerEditor_LoadRegions";

  export const Document = CustomerEditor_LoadRegionsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerEditor_LoadHospitalsDocument = gql`
  query CustomerEditor_LoadHospitals($regionId: ObjectId) {
    customers(filter: { parentId: [$regionId], type: [Hospital] }) {
      items {
        _id
        Name
        ShowHospitalAOERewriteWarning
        Ref {
          ...CustomerRef
        }
      }
      dbTime
    }
  }
  ${CustomerRefFragmentDoc}
`;
export type CustomerEditor_LoadHospitalsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerEditor_LoadHospitalsQuery,
    CustomerEditor_LoadHospitalsQueryVariables
  >,
  "query"
>;

export const CustomerEditor_LoadHospitalsComponent = (
  props: CustomerEditor_LoadHospitalsComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerEditor_LoadHospitalsQuery,
    CustomerEditor_LoadHospitalsQueryVariables
  >
    query={CustomerEditor_LoadHospitalsDocument}
    {...props}
  />
);

/**
 * __useCustomerEditor_LoadHospitalsQuery__
 *
 * To run a query within a React component, call `useCustomerEditor_LoadHospitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerEditor_LoadHospitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerEditor_LoadHospitalsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCustomerEditor_LoadHospitalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerEditor_LoadHospitalsQuery,
    CustomerEditor_LoadHospitalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerEditor_LoadHospitalsQuery,
    CustomerEditor_LoadHospitalsQueryVariables
  >(CustomerEditor_LoadHospitalsDocument, options);
}
export function useCustomerEditor_LoadHospitalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerEditor_LoadHospitalsQuery,
    CustomerEditor_LoadHospitalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerEditor_LoadHospitalsQuery,
    CustomerEditor_LoadHospitalsQueryVariables
  >(CustomerEditor_LoadHospitalsDocument, options);
}
export type CustomerEditor_LoadHospitalsQueryHookResult = ReturnType<
  typeof useCustomerEditor_LoadHospitalsQuery
>;
export type CustomerEditor_LoadHospitalsLazyQueryHookResult = ReturnType<
  typeof useCustomerEditor_LoadHospitalsLazyQuery
>;
export namespace CustomerEditor_LoadHospitals {
  export type Return = CustomerEditor_LoadHospitalsQuery;
  export type Variables = CustomerEditor_LoadHospitalsQueryVariables;
  export const OperationName = "CustomerEditor_LoadHospitals";

  export const Document = CustomerEditor_LoadHospitalsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerEditor_CreateDocument = gql`
  mutation CustomerEditor_Create($input: CustomerInput!) {
    submit: createCustomer(input: $input) {
      customer {
        ...CustomerEditor_Customer
      }
      validationErrors {
        Message
        Path
      }
    }
  }
  ${CustomerEditor_CustomerFragmentDoc}
`;
export type CustomerEditor_CreateMutationFn = Apollo.MutationFunction<
  CustomerEditor_CreateMutation,
  CustomerEditor_CreateMutationVariables
>;
export type CustomerEditor_CreateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEditor_CreateMutation,
    CustomerEditor_CreateMutationVariables
  >,
  "mutation"
>;

export const CustomerEditor_CreateComponent = (
  props: CustomerEditor_CreateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEditor_CreateMutation,
    CustomerEditor_CreateMutationVariables
  >
    mutation={CustomerEditor_CreateDocument}
    {...props}
  />
);

/**
 * __useCustomerEditor_CreateMutation__
 *
 * To run a mutation, you first call `useCustomerEditor_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEditor_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEditorCreateMutation, { data, loading, error }] = useCustomerEditor_CreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerEditor_CreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEditor_CreateMutation,
    CustomerEditor_CreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEditor_CreateMutation,
    CustomerEditor_CreateMutationVariables
  >(CustomerEditor_CreateDocument, options);
}
export type CustomerEditor_CreateMutationHookResult = ReturnType<
  typeof useCustomerEditor_CreateMutation
>;
export namespace CustomerEditor_Create {
  export type Return = CustomerEditor_CreateMutation;
  export type Variables = CustomerEditor_CreateMutationVariables;
  export const OperationName = "CustomerEditor_Create";

  export const Document = CustomerEditor_CreateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerEditor_UpdateDocument = gql`
  mutation CustomerEditor_Update($id: ObjectId!, $input: CustomerInput!) {
    submit: updateCustomer(id: $id, input: $input) {
      customer {
        ...CustomerEditor_Customer
      }
      validationErrors {
        Message
        Path
      }
    }
  }
  ${CustomerEditor_CustomerFragmentDoc}
`;
export type CustomerEditor_UpdateMutationFn = Apollo.MutationFunction<
  CustomerEditor_UpdateMutation,
  CustomerEditor_UpdateMutationVariables
>;
export type CustomerEditor_UpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerEditor_UpdateMutation,
    CustomerEditor_UpdateMutationVariables
  >,
  "mutation"
>;

export const CustomerEditor_UpdateComponent = (
  props: CustomerEditor_UpdateComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerEditor_UpdateMutation,
    CustomerEditor_UpdateMutationVariables
  >
    mutation={CustomerEditor_UpdateDocument}
    {...props}
  />
);

/**
 * __useCustomerEditor_UpdateMutation__
 *
 * To run a mutation, you first call `useCustomerEditor_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEditor_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEditorUpdateMutation, { data, loading, error }] = useCustomerEditor_UpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerEditor_UpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerEditor_UpdateMutation,
    CustomerEditor_UpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerEditor_UpdateMutation,
    CustomerEditor_UpdateMutationVariables
  >(CustomerEditor_UpdateDocument, options);
}
export type CustomerEditor_UpdateMutationHookResult = ReturnType<
  typeof useCustomerEditor_UpdateMutation
>;
export namespace CustomerEditor_Update {
  export type Return = CustomerEditor_UpdateMutation;
  export type Variables = CustomerEditor_UpdateMutationVariables;
  export const OperationName = "CustomerEditor_Update";

  export const Document = CustomerEditor_UpdateDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerFilesDocument = gql`
  query getCustomerFiles($id: ObjectId!) {
    customerById(id: $id) {
      _id
      documents {
        DocumentType
        ThumbURL
        PdfURL
        FileRef {
          Name
          NodeID
          NodeType
          MimeType
          Size
        }
      }
    }
  }
`;
export type GetCustomerFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerFilesQuery,
    GetCustomerFilesQueryVariables
  >,
  "query"
> &
  ({ variables: GetCustomerFilesQueryVariables; skip?: boolean } | { skip: boolean });

export const GetCustomerFilesComponent = (props: GetCustomerFilesComponentProps) => (
  <ApolloReactComponents.Query<GetCustomerFilesQuery, GetCustomerFilesQueryVariables>
    query={GetCustomerFilesDocument}
    {...props}
  />
);

/**
 * __useGetCustomerFilesQuery__
 *
 * To run a query within a React component, call `useGetCustomerFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerFilesQuery,
    GetCustomerFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerFilesQuery, GetCustomerFilesQueryVariables>(
    GetCustomerFilesDocument,
    options
  );
}
export function useGetCustomerFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerFilesQuery,
    GetCustomerFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerFilesQuery, GetCustomerFilesQueryVariables>(
    GetCustomerFilesDocument,
    options
  );
}
export type GetCustomerFilesQueryHookResult = ReturnType<typeof useGetCustomerFilesQuery>;
export type GetCustomerFilesLazyQueryHookResult = ReturnType<
  typeof useGetCustomerFilesLazyQuery
>;
export namespace GetCustomerFiles {
  export type Return = GetCustomerFilesQuery;
  export type Variables = GetCustomerFilesQueryVariables;
  export const OperationName = "getCustomerFiles";

  export const Document = GetCustomerFilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadCustomerDocDocument = gql`
  mutation uploadCustomerDoc(
    $id: ObjectId!
    $file: Upload!
    $documentType: CustomerDocumentTypes!
  ) {
    uploadCustomerDocument(customerId: $id, file: $file, documentType: $documentType) {
      FileRef {
        Name
        NodeID
        NodeType
        MimeType
        Size
      }
    }
  }
`;
export type UploadCustomerDocMutationFn = Apollo.MutationFunction<
  UploadCustomerDocMutation,
  UploadCustomerDocMutationVariables
>;
export type UploadCustomerDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadCustomerDocMutation,
    UploadCustomerDocMutationVariables
  >,
  "mutation"
>;

export const UploadCustomerDocComponent = (props: UploadCustomerDocComponentProps) => (
  <ApolloReactComponents.Mutation<
    UploadCustomerDocMutation,
    UploadCustomerDocMutationVariables
  >
    mutation={UploadCustomerDocDocument}
    {...props}
  />
);

/**
 * __useUploadCustomerDocMutation__
 *
 * To run a mutation, you first call `useUploadCustomerDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomerDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomerDocMutation, { data, loading, error }] = useUploadCustomerDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadCustomerDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadCustomerDocMutation,
    UploadCustomerDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadCustomerDocMutation,
    UploadCustomerDocMutationVariables
  >(UploadCustomerDocDocument, options);
}
export type UploadCustomerDocMutationHookResult = ReturnType<
  typeof useUploadCustomerDocMutation
>;
export namespace UploadCustomerDoc {
  export type Return = UploadCustomerDocMutation;
  export type Variables = UploadCustomerDocMutationVariables;
  export const OperationName = "uploadCustomerDoc";

  export const Document = UploadCustomerDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteCustomerDocDocument = gql`
  mutation deleteCustomerDoc($id: ObjectId!, $fileId: ObjectId!) {
    deleteCustomerDocument(customerId: $id, fileId: $fileId) {
      FileRef {
        Name
        NodeID
        NodeType
        MimeType
        Size
      }
    }
  }
`;
export type DeleteCustomerDocMutationFn = Apollo.MutationFunction<
  DeleteCustomerDocMutation,
  DeleteCustomerDocMutationVariables
>;
export type DeleteCustomerDocComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteCustomerDocMutation,
    DeleteCustomerDocMutationVariables
  >,
  "mutation"
>;

export const DeleteCustomerDocComponent = (props: DeleteCustomerDocComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteCustomerDocMutation,
    DeleteCustomerDocMutationVariables
  >
    mutation={DeleteCustomerDocDocument}
    {...props}
  />
);

/**
 * __useDeleteCustomerDocMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerDocMutation, { data, loading, error }] = useDeleteCustomerDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteCustomerDocMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerDocMutation,
    DeleteCustomerDocMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerDocMutation,
    DeleteCustomerDocMutationVariables
  >(DeleteCustomerDocDocument, options);
}
export type DeleteCustomerDocMutationHookResult = ReturnType<
  typeof useDeleteCustomerDocMutation
>;
export namespace DeleteCustomerDoc {
  export type Return = DeleteCustomerDocMutation;
  export type Variables = DeleteCustomerDocMutationVariables;
  export const OperationName = "deleteCustomerDoc";

  export const Document = DeleteCustomerDocDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerProfile_GetCustomerTreeDocument = gql`
  query CustomerProfile_GetCustomerTree($id: ObjectId!) {
    customerById(id: $id) {
      _id
      Name
      CustomerTree {
        ...CustomerTreeSelect_Item
      }
    }
  }
  ${CustomerTreeSelect_ItemFragmentDoc}
`;
export type CustomerProfile_GetCustomerTreeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerProfile_GetCustomerTreeQuery,
    CustomerProfile_GetCustomerTreeQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerProfile_GetCustomerTreeQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerProfile_GetCustomerTreeComponent = (
  props: CustomerProfile_GetCustomerTreeComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerProfile_GetCustomerTreeQuery,
    CustomerProfile_GetCustomerTreeQueryVariables
  >
    query={CustomerProfile_GetCustomerTreeDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_GetCustomerTreeQuery__
 *
 * To run a query within a React component, call `useCustomerProfile_GetCustomerTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_GetCustomerTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProfile_GetCustomerTreeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerProfile_GetCustomerTreeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerProfile_GetCustomerTreeQuery,
    CustomerProfile_GetCustomerTreeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerProfile_GetCustomerTreeQuery,
    CustomerProfile_GetCustomerTreeQueryVariables
  >(CustomerProfile_GetCustomerTreeDocument, options);
}
export function useCustomerProfile_GetCustomerTreeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerProfile_GetCustomerTreeQuery,
    CustomerProfile_GetCustomerTreeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerProfile_GetCustomerTreeQuery,
    CustomerProfile_GetCustomerTreeQueryVariables
  >(CustomerProfile_GetCustomerTreeDocument, options);
}
export type CustomerProfile_GetCustomerTreeQueryHookResult = ReturnType<
  typeof useCustomerProfile_GetCustomerTreeQuery
>;
export type CustomerProfile_GetCustomerTreeLazyQueryHookResult = ReturnType<
  typeof useCustomerProfile_GetCustomerTreeLazyQuery
>;
export namespace CustomerProfile_GetCustomerTree {
  export type Return = CustomerProfile_GetCustomerTreeQuery;
  export type Variables = CustomerProfile_GetCustomerTreeQueryVariables;
  export const OperationName = "CustomerProfile_GetCustomerTree";

  export const Document = CustomerProfile_GetCustomerTreeDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerProfile_GetProfileDocument = gql`
  query CustomerProfile_GetProfile(
    $id: ObjectId!
    $customerGroup: String
    $showDeleted: Boolean
  ) {
    customerById(id: $id) {
      ...CustomerProfile
      ContactPersons(customerGroup: $customerGroup, showDeleted: $showDeleted) {
        ...CustomerContactPerson
      }
    }
    searchProfiles: searchProfilesByCustomerId(id: $id) {
      _id
      name
    }
  }
  ${CustomerProfileFragmentDoc}
  ${CustomerContactPersonFragmentDoc}
`;
export type CustomerProfile_GetProfileComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerProfile_GetProfileQuery,
    CustomerProfile_GetProfileQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerProfile_GetProfileQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerProfile_GetProfileComponent = (
  props: CustomerProfile_GetProfileComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerProfile_GetProfileQuery,
    CustomerProfile_GetProfileQueryVariables
  >
    query={CustomerProfile_GetProfileDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_GetProfileQuery__
 *
 * To run a query within a React component, call `useCustomerProfile_GetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_GetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProfile_GetProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      customerGroup: // value for 'customerGroup'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useCustomerProfile_GetProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerProfile_GetProfileQuery,
    CustomerProfile_GetProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerProfile_GetProfileQuery,
    CustomerProfile_GetProfileQueryVariables
  >(CustomerProfile_GetProfileDocument, options);
}
export function useCustomerProfile_GetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerProfile_GetProfileQuery,
    CustomerProfile_GetProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerProfile_GetProfileQuery,
    CustomerProfile_GetProfileQueryVariables
  >(CustomerProfile_GetProfileDocument, options);
}
export type CustomerProfile_GetProfileQueryHookResult = ReturnType<
  typeof useCustomerProfile_GetProfileQuery
>;
export type CustomerProfile_GetProfileLazyQueryHookResult = ReturnType<
  typeof useCustomerProfile_GetProfileLazyQuery
>;
export namespace CustomerProfile_GetProfile {
  export type Return = CustomerProfile_GetProfileQuery;
  export type Variables = CustomerProfile_GetProfileQueryVariables;
  export const OperationName = "CustomerProfile_GetProfile";

  export const Document = CustomerProfile_GetProfileDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerProfile_DeleteCustomerDocument = gql`
  mutation CustomerProfile_DeleteCustomer($id: ObjectId!) {
    result: deleteCustomer(id: $id) {
      _id
      Deleted
    }
  }
`;
export type CustomerProfile_DeleteCustomerMutationFn = Apollo.MutationFunction<
  CustomerProfile_DeleteCustomerMutation,
  CustomerProfile_DeleteCustomerMutationVariables
>;
export type CustomerProfile_DeleteCustomerComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerProfile_DeleteCustomerMutation,
    CustomerProfile_DeleteCustomerMutationVariables
  >,
  "mutation"
>;

export const CustomerProfile_DeleteCustomerComponent = (
  props: CustomerProfile_DeleteCustomerComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerProfile_DeleteCustomerMutation,
    CustomerProfile_DeleteCustomerMutationVariables
  >
    mutation={CustomerProfile_DeleteCustomerDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_DeleteCustomerMutation__
 *
 * To run a mutation, you first call `useCustomerProfile_DeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_DeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerProfileDeleteCustomerMutation, { data, loading, error }] = useCustomerProfile_DeleteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerProfile_DeleteCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerProfile_DeleteCustomerMutation,
    CustomerProfile_DeleteCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerProfile_DeleteCustomerMutation,
    CustomerProfile_DeleteCustomerMutationVariables
  >(CustomerProfile_DeleteCustomerDocument, options);
}
export type CustomerProfile_DeleteCustomerMutationHookResult = ReturnType<
  typeof useCustomerProfile_DeleteCustomerMutation
>;
export namespace CustomerProfile_DeleteCustomer {
  export type Return = CustomerProfile_DeleteCustomerMutation;
  export type Variables = CustomerProfile_DeleteCustomerMutationVariables;
  export const OperationName = "CustomerProfile_DeleteCustomer";

  export const Document = CustomerProfile_DeleteCustomerDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerProfile_DeleteContactPersonDocument = gql`
  mutation CustomerProfile_DeleteContactPerson($id: ObjectId!) {
    result: deleteContactPerson(id: $id)
  }
`;
export type CustomerProfile_DeleteContactPersonMutationFn = Apollo.MutationFunction<
  CustomerProfile_DeleteContactPersonMutation,
  CustomerProfile_DeleteContactPersonMutationVariables
>;
export type CustomerProfile_DeleteContactPersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerProfile_DeleteContactPersonMutation,
    CustomerProfile_DeleteContactPersonMutationVariables
  >,
  "mutation"
>;

export const CustomerProfile_DeleteContactPersonComponent = (
  props: CustomerProfile_DeleteContactPersonComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerProfile_DeleteContactPersonMutation,
    CustomerProfile_DeleteContactPersonMutationVariables
  >
    mutation={CustomerProfile_DeleteContactPersonDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_DeleteContactPersonMutation__
 *
 * To run a mutation, you first call `useCustomerProfile_DeleteContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_DeleteContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerProfileDeleteContactPersonMutation, { data, loading, error }] = useCustomerProfile_DeleteContactPersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerProfile_DeleteContactPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerProfile_DeleteContactPersonMutation,
    CustomerProfile_DeleteContactPersonMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerProfile_DeleteContactPersonMutation,
    CustomerProfile_DeleteContactPersonMutationVariables
  >(CustomerProfile_DeleteContactPersonDocument, options);
}
export type CustomerProfile_DeleteContactPersonMutationHookResult = ReturnType<
  typeof useCustomerProfile_DeleteContactPersonMutation
>;
export namespace CustomerProfile_DeleteContactPerson {
  export type Return = CustomerProfile_DeleteContactPersonMutation;
  export type Variables = CustomerProfile_DeleteContactPersonMutationVariables;
  export const OperationName = "CustomerProfile_DeleteContactPerson";

  export const Document = CustomerProfile_DeleteContactPersonDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerProfile_MoveCustomerDocument = gql`
  mutation CustomerProfile_MoveCustomer($id: ObjectId!, $parentId: ObjectId) {
    result: moveCustomer(id: $id, parentId: $parentId) {
      customer {
        ...CustomerProfile
        ContactPersons {
          ...CustomerContactPerson
        }
      }
      validationErrors
    }
  }
  ${CustomerProfileFragmentDoc}
  ${CustomerContactPersonFragmentDoc}
`;
export type CustomerProfile_MoveCustomerMutationFn = Apollo.MutationFunction<
  CustomerProfile_MoveCustomerMutation,
  CustomerProfile_MoveCustomerMutationVariables
>;
export type CustomerProfile_MoveCustomerComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerProfile_MoveCustomerMutation,
    CustomerProfile_MoveCustomerMutationVariables
  >,
  "mutation"
>;

export const CustomerProfile_MoveCustomerComponent = (
  props: CustomerProfile_MoveCustomerComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerProfile_MoveCustomerMutation,
    CustomerProfile_MoveCustomerMutationVariables
  >
    mutation={CustomerProfile_MoveCustomerDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_MoveCustomerMutation__
 *
 * To run a mutation, you first call `useCustomerProfile_MoveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_MoveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerProfileMoveCustomerMutation, { data, loading, error }] = useCustomerProfile_MoveCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCustomerProfile_MoveCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerProfile_MoveCustomerMutation,
    CustomerProfile_MoveCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerProfile_MoveCustomerMutation,
    CustomerProfile_MoveCustomerMutationVariables
  >(CustomerProfile_MoveCustomerDocument, options);
}
export type CustomerProfile_MoveCustomerMutationHookResult = ReturnType<
  typeof useCustomerProfile_MoveCustomerMutation
>;
export namespace CustomerProfile_MoveCustomer {
  export type Return = CustomerProfile_MoveCustomerMutation;
  export type Variables = CustomerProfile_MoveCustomerMutationVariables;
  export const OperationName = "CustomerProfile_MoveCustomer";

  export const Document = CustomerProfile_MoveCustomerDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerProfile_ToggleCustomerSettingsDocument = gql`
  mutation CustomerProfile_ToggleCustomerSettings(
    $id: ObjectId!
    $key: CustomerSettingsKey!
    $value: Boolean!
  ) {
    toggleCustomerSettings(id: $id, key: $key, value: $value) {
      _id
    }
  }
`;
export type CustomerProfile_ToggleCustomerSettingsMutationFn = Apollo.MutationFunction<
  CustomerProfile_ToggleCustomerSettingsMutation,
  CustomerProfile_ToggleCustomerSettingsMutationVariables
>;
export type CustomerProfile_ToggleCustomerSettingsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerProfile_ToggleCustomerSettingsMutation,
    CustomerProfile_ToggleCustomerSettingsMutationVariables
  >,
  "mutation"
>;

export const CustomerProfile_ToggleCustomerSettingsComponent = (
  props: CustomerProfile_ToggleCustomerSettingsComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerProfile_ToggleCustomerSettingsMutation,
    CustomerProfile_ToggleCustomerSettingsMutationVariables
  >
    mutation={CustomerProfile_ToggleCustomerSettingsDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_ToggleCustomerSettingsMutation__
 *
 * To run a mutation, you first call `useCustomerProfile_ToggleCustomerSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_ToggleCustomerSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerProfileToggleCustomerSettingsMutation, { data, loading, error }] = useCustomerProfile_ToggleCustomerSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCustomerProfile_ToggleCustomerSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerProfile_ToggleCustomerSettingsMutation,
    CustomerProfile_ToggleCustomerSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerProfile_ToggleCustomerSettingsMutation,
    CustomerProfile_ToggleCustomerSettingsMutationVariables
  >(CustomerProfile_ToggleCustomerSettingsDocument, options);
}
export type CustomerProfile_ToggleCustomerSettingsMutationHookResult = ReturnType<
  typeof useCustomerProfile_ToggleCustomerSettingsMutation
>;
export namespace CustomerProfile_ToggleCustomerSettings {
  export type Return = CustomerProfile_ToggleCustomerSettingsMutation;
  export type Variables = CustomerProfile_ToggleCustomerSettingsMutationVariables;
  export const OperationName = "CustomerProfile_ToggleCustomerSettings";

  export const Document = CustomerProfile_ToggleCustomerSettingsDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerProfile_ToggleCustomerNoApprovalDocument = gql`
  mutation CustomerProfile_ToggleCustomerNoApproval(
    $id: ObjectId!
    $value: Boolean!
    $documentType: CustomerDocumentTypes!
    $file: Upload
  ) {
    toggleCustomerNoApproval(
      id: $id
      value: $value
      documentType: $documentType
      file: $file
    ) {
      _id
    }
  }
`;
export type CustomerProfile_ToggleCustomerNoApprovalMutationFn = Apollo.MutationFunction<
  CustomerProfile_ToggleCustomerNoApprovalMutation,
  CustomerProfile_ToggleCustomerNoApprovalMutationVariables
>;
export type CustomerProfile_ToggleCustomerNoApprovalComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CustomerProfile_ToggleCustomerNoApprovalMutation,
    CustomerProfile_ToggleCustomerNoApprovalMutationVariables
  >,
  "mutation"
>;

export const CustomerProfile_ToggleCustomerNoApprovalComponent = (
  props: CustomerProfile_ToggleCustomerNoApprovalComponentProps
) => (
  <ApolloReactComponents.Mutation<
    CustomerProfile_ToggleCustomerNoApprovalMutation,
    CustomerProfile_ToggleCustomerNoApprovalMutationVariables
  >
    mutation={CustomerProfile_ToggleCustomerNoApprovalDocument}
    {...props}
  />
);

/**
 * __useCustomerProfile_ToggleCustomerNoApprovalMutation__
 *
 * To run a mutation, you first call `useCustomerProfile_ToggleCustomerNoApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfile_ToggleCustomerNoApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerProfileToggleCustomerNoApprovalMutation, { data, loading, error }] = useCustomerProfile_ToggleCustomerNoApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *      documentType: // value for 'documentType'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCustomerProfile_ToggleCustomerNoApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerProfile_ToggleCustomerNoApprovalMutation,
    CustomerProfile_ToggleCustomerNoApprovalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerProfile_ToggleCustomerNoApprovalMutation,
    CustomerProfile_ToggleCustomerNoApprovalMutationVariables
  >(CustomerProfile_ToggleCustomerNoApprovalDocument, options);
}
export type CustomerProfile_ToggleCustomerNoApprovalMutationHookResult = ReturnType<
  typeof useCustomerProfile_ToggleCustomerNoApprovalMutation
>;
export namespace CustomerProfile_ToggleCustomerNoApproval {
  export type Return = CustomerProfile_ToggleCustomerNoApprovalMutation;
  export type Variables = CustomerProfile_ToggleCustomerNoApprovalMutationVariables;
  export const OperationName = "CustomerProfile_ToggleCustomerNoApproval";

  export const Document = CustomerProfile_ToggleCustomerNoApprovalDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteContactPersonDialog_GetDocument = gql`
  query DeleteContactPersonDialog_Get($contactPersonId: ObjectId!) {
    contactPersonById(id: $contactPersonId) {
      _id
      Name
      Customers {
        _id
        Name
        Type
        Parents {
          Name
          Type
        }
      }
    }
  }
`;
export type DeleteContactPersonDialog_GetComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    DeleteContactPersonDialog_GetQuery,
    DeleteContactPersonDialog_GetQueryVariables
  >,
  "query"
> &
  (
    | { variables: DeleteContactPersonDialog_GetQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const DeleteContactPersonDialog_GetComponent = (
  props: DeleteContactPersonDialog_GetComponentProps
) => (
  <ApolloReactComponents.Query<
    DeleteContactPersonDialog_GetQuery,
    DeleteContactPersonDialog_GetQueryVariables
  >
    query={DeleteContactPersonDialog_GetDocument}
    {...props}
  />
);

/**
 * __useDeleteContactPersonDialog_GetQuery__
 *
 * To run a query within a React component, call `useDeleteContactPersonDialog_GetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPersonDialog_GetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteContactPersonDialog_GetQuery({
 *   variables: {
 *      contactPersonId: // value for 'contactPersonId'
 *   },
 * });
 */
export function useDeleteContactPersonDialog_GetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DeleteContactPersonDialog_GetQuery,
    DeleteContactPersonDialog_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DeleteContactPersonDialog_GetQuery,
    DeleteContactPersonDialog_GetQueryVariables
  >(DeleteContactPersonDialog_GetDocument, options);
}
export function useDeleteContactPersonDialog_GetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeleteContactPersonDialog_GetQuery,
    DeleteContactPersonDialog_GetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DeleteContactPersonDialog_GetQuery,
    DeleteContactPersonDialog_GetQueryVariables
  >(DeleteContactPersonDialog_GetDocument, options);
}
export type DeleteContactPersonDialog_GetQueryHookResult = ReturnType<
  typeof useDeleteContactPersonDialog_GetQuery
>;
export type DeleteContactPersonDialog_GetLazyQueryHookResult = ReturnType<
  typeof useDeleteContactPersonDialog_GetLazyQuery
>;
export namespace DeleteContactPersonDialog_Get {
  export type Return = DeleteContactPersonDialog_GetQuery;
  export type Variables = DeleteContactPersonDialog_GetQueryVariables;
  export const OperationName = "DeleteContactPersonDialog_Get";

  export const Document = DeleteContactPersonDialog_GetDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const DeleteContactPersonDialog_DeleteDocument = gql`
  mutation DeleteContactPersonDialog_Delete($contactPersonId: ObjectId!) {
    deleteContactPerson(id: $contactPersonId)
  }
`;
export type DeleteContactPersonDialog_DeleteMutationFn = Apollo.MutationFunction<
  DeleteContactPersonDialog_DeleteMutation,
  DeleteContactPersonDialog_DeleteMutationVariables
>;
export type DeleteContactPersonDialog_DeleteComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteContactPersonDialog_DeleteMutation,
    DeleteContactPersonDialog_DeleteMutationVariables
  >,
  "mutation"
>;

export const DeleteContactPersonDialog_DeleteComponent = (
  props: DeleteContactPersonDialog_DeleteComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteContactPersonDialog_DeleteMutation,
    DeleteContactPersonDialog_DeleteMutationVariables
  >
    mutation={DeleteContactPersonDialog_DeleteDocument}
    {...props}
  />
);

/**
 * __useDeleteContactPersonDialog_DeleteMutation__
 *
 * To run a mutation, you first call `useDeleteContactPersonDialog_DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPersonDialog_DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactPersonDialogDeleteMutation, { data, loading, error }] = useDeleteContactPersonDialog_DeleteMutation({
 *   variables: {
 *      contactPersonId: // value for 'contactPersonId'
 *   },
 * });
 */
export function useDeleteContactPersonDialog_DeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContactPersonDialog_DeleteMutation,
    DeleteContactPersonDialog_DeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteContactPersonDialog_DeleteMutation,
    DeleteContactPersonDialog_DeleteMutationVariables
  >(DeleteContactPersonDialog_DeleteDocument, options);
}
export type DeleteContactPersonDialog_DeleteMutationHookResult = ReturnType<
  typeof useDeleteContactPersonDialog_DeleteMutation
>;
export namespace DeleteContactPersonDialog_Delete {
  export type Return = DeleteContactPersonDialog_DeleteMutation;
  export type Variables = DeleteContactPersonDialog_DeleteMutationVariables;
  export const OperationName = "DeleteContactPersonDialog_Delete";

  export const Document = DeleteContactPersonDialog_DeleteDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const DeleteContactPersonDialog_DeassignDocument = gql`
  mutation DeleteContactPersonDialog_Deassign(
    $contactPersonId: ObjectId!
    $customerIds: [ObjectId!]!
  ) {
    deassignContactPersonFromCustomers(
      contactPersonId: $contactPersonId
      customerIds: $customerIds
    ) {
      _id
      Deleted
    }
  }
`;
export type DeleteContactPersonDialog_DeassignMutationFn = Apollo.MutationFunction<
  DeleteContactPersonDialog_DeassignMutation,
  DeleteContactPersonDialog_DeassignMutationVariables
>;
export type DeleteContactPersonDialog_DeassignComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteContactPersonDialog_DeassignMutation,
    DeleteContactPersonDialog_DeassignMutationVariables
  >,
  "mutation"
>;

export const DeleteContactPersonDialog_DeassignComponent = (
  props: DeleteContactPersonDialog_DeassignComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteContactPersonDialog_DeassignMutation,
    DeleteContactPersonDialog_DeassignMutationVariables
  >
    mutation={DeleteContactPersonDialog_DeassignDocument}
    {...props}
  />
);

/**
 * __useDeleteContactPersonDialog_DeassignMutation__
 *
 * To run a mutation, you first call `useDeleteContactPersonDialog_DeassignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPersonDialog_DeassignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactPersonDialogDeassignMutation, { data, loading, error }] = useDeleteContactPersonDialog_DeassignMutation({
 *   variables: {
 *      contactPersonId: // value for 'contactPersonId'
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useDeleteContactPersonDialog_DeassignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContactPersonDialog_DeassignMutation,
    DeleteContactPersonDialog_DeassignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteContactPersonDialog_DeassignMutation,
    DeleteContactPersonDialog_DeassignMutationVariables
  >(DeleteContactPersonDialog_DeassignDocument, options);
}
export type DeleteContactPersonDialog_DeassignMutationHookResult = ReturnType<
  typeof useDeleteContactPersonDialog_DeassignMutation
>;
export namespace DeleteContactPersonDialog_Deassign {
  export type Return = DeleteContactPersonDialog_DeassignMutation;
  export type Variables = DeleteContactPersonDialog_DeassignMutationVariables;
  export const OperationName = "DeleteContactPersonDialog_Deassign";

  export const Document = DeleteContactPersonDialog_DeassignDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const GetCustomerConsultantMatchingDocument = gql`
  query getCustomerConsultantMatching(
    $params: ConsultantMatchingParams!
    $filter: ConsultantsQueryInput!
    $limit: Int!
    $skip: Int!
    $sortBy: SortBy!
    $sortOrder: SortOrder!
  ) {
    consultantMatching(
      params: $params
      filter: $filter
      limit: $limit
      skip: $skip
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      items {
        consultant {
          ...ConsultantMatchingItemData
        }
        weeksTotal
        minutesTotal
      }
    }
  }
  ${ConsultantMatchingItemDataFragmentDoc}
`;
export type GetCustomerConsultantMatchingComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerConsultantMatchingQuery,
    GetCustomerConsultantMatchingQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerConsultantMatchingQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerConsultantMatchingComponent = (
  props: GetCustomerConsultantMatchingComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerConsultantMatchingQuery,
    GetCustomerConsultantMatchingQueryVariables
  >
    query={GetCustomerConsultantMatchingDocument}
    {...props}
  />
);

/**
 * __useGetCustomerConsultantMatchingQuery__
 *
 * To run a query within a React component, call `useGetCustomerConsultantMatchingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerConsultantMatchingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerConsultantMatchingQuery({
 *   variables: {
 *      params: // value for 'params'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetCustomerConsultantMatchingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerConsultantMatchingQuery,
    GetCustomerConsultantMatchingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerConsultantMatchingQuery,
    GetCustomerConsultantMatchingQueryVariables
  >(GetCustomerConsultantMatchingDocument, options);
}
export function useGetCustomerConsultantMatchingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerConsultantMatchingQuery,
    GetCustomerConsultantMatchingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerConsultantMatchingQuery,
    GetCustomerConsultantMatchingQueryVariables
  >(GetCustomerConsultantMatchingDocument, options);
}
export type GetCustomerConsultantMatchingQueryHookResult = ReturnType<
  typeof useGetCustomerConsultantMatchingQuery
>;
export type GetCustomerConsultantMatchingLazyQueryHookResult = ReturnType<
  typeof useGetCustomerConsultantMatchingLazyQuery
>;
export namespace GetCustomerConsultantMatching {
  export type Return = GetCustomerConsultantMatchingQuery;
  export type Variables = GetCustomerConsultantMatchingQueryVariables;
  export const OperationName = "getCustomerConsultantMatching";

  export const Document = GetCustomerConsultantMatchingDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetDeclaredConsultantsByCustomerDocument = gql`
  query getDeclaredConsultantsByCustomer($customerId: ObjectId!) {
    consultantByWorkExperience(customerId: $customerId) {
      items {
        consultant {
          _id
          Name
        }
        workExperience {
          competitors
          employmentType
          from
          to
        }
      }
    }
  }
`;
export type GetDeclaredConsultantsByCustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetDeclaredConsultantsByCustomerQuery,
    GetDeclaredConsultantsByCustomerQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetDeclaredConsultantsByCustomerQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetDeclaredConsultantsByCustomerComponent = (
  props: GetDeclaredConsultantsByCustomerComponentProps
) => (
  <ApolloReactComponents.Query<
    GetDeclaredConsultantsByCustomerQuery,
    GetDeclaredConsultantsByCustomerQueryVariables
  >
    query={GetDeclaredConsultantsByCustomerDocument}
    {...props}
  />
);

/**
 * __useGetDeclaredConsultantsByCustomerQuery__
 *
 * To run a query within a React component, call `useGetDeclaredConsultantsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeclaredConsultantsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeclaredConsultantsByCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetDeclaredConsultantsByCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeclaredConsultantsByCustomerQuery,
    GetDeclaredConsultantsByCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeclaredConsultantsByCustomerQuery,
    GetDeclaredConsultantsByCustomerQueryVariables
  >(GetDeclaredConsultantsByCustomerDocument, options);
}
export function useGetDeclaredConsultantsByCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeclaredConsultantsByCustomerQuery,
    GetDeclaredConsultantsByCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeclaredConsultantsByCustomerQuery,
    GetDeclaredConsultantsByCustomerQueryVariables
  >(GetDeclaredConsultantsByCustomerDocument, options);
}
export type GetDeclaredConsultantsByCustomerQueryHookResult = ReturnType<
  typeof useGetDeclaredConsultantsByCustomerQuery
>;
export type GetDeclaredConsultantsByCustomerLazyQueryHookResult = ReturnType<
  typeof useGetDeclaredConsultantsByCustomerLazyQuery
>;
export namespace GetDeclaredConsultantsByCustomer {
  export type Return = GetDeclaredConsultantsByCustomerQuery;
  export type Variables = GetDeclaredConsultantsByCustomerQueryVariables;
  export const OperationName = "getDeclaredConsultantsByCustomer";

  export const Document = GetDeclaredConsultantsByCustomerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetCustomerRecommendedPricesDocument = gql`
  query getCustomerRecommendedPrices($customerId: ObjectId!) {
    customerById(id: $customerId) {
      _id
      Type
      recommendedPrices {
        areaOfExpertise
        profession
        value
      }
    }
  }
`;
export type GetCustomerRecommendedPricesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCustomerRecommendedPricesQuery,
    GetCustomerRecommendedPricesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetCustomerRecommendedPricesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetCustomerRecommendedPricesComponent = (
  props: GetCustomerRecommendedPricesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetCustomerRecommendedPricesQuery,
    GetCustomerRecommendedPricesQueryVariables
  >
    query={GetCustomerRecommendedPricesDocument}
    {...props}
  />
);

/**
 * __useGetCustomerRecommendedPricesQuery__
 *
 * To run a query within a React component, call `useGetCustomerRecommendedPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerRecommendedPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerRecommendedPricesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerRecommendedPricesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerRecommendedPricesQuery,
    GetCustomerRecommendedPricesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerRecommendedPricesQuery,
    GetCustomerRecommendedPricesQueryVariables
  >(GetCustomerRecommendedPricesDocument, options);
}
export function useGetCustomerRecommendedPricesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerRecommendedPricesQuery,
    GetCustomerRecommendedPricesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerRecommendedPricesQuery,
    GetCustomerRecommendedPricesQueryVariables
  >(GetCustomerRecommendedPricesDocument, options);
}
export type GetCustomerRecommendedPricesQueryHookResult = ReturnType<
  typeof useGetCustomerRecommendedPricesQuery
>;
export type GetCustomerRecommendedPricesLazyQueryHookResult = ReturnType<
  typeof useGetCustomerRecommendedPricesLazyQuery
>;
export namespace GetCustomerRecommendedPrices {
  export type Return = GetCustomerRecommendedPricesQuery;
  export type Variables = GetCustomerRecommendedPricesQueryVariables;
  export const OperationName = "getCustomerRecommendedPrices";

  export const Document = GetCustomerRecommendedPricesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetCustomerRecommendedPricesDocument = gql`
  mutation setCustomerRecommendedPrices(
    $customerId: ObjectId!
    $input: [CustomerRecommendedPriceInput!]!
  ) {
    setCustomerRecommendedPrices(customerId: $customerId, prices: $input) {
      _id
      Type
      recommendedPrices {
        areaOfExpertise
        profession
        value
      }
    }
  }
`;
export type SetCustomerRecommendedPricesMutationFn = Apollo.MutationFunction<
  SetCustomerRecommendedPricesMutation,
  SetCustomerRecommendedPricesMutationVariables
>;
export type SetCustomerRecommendedPricesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetCustomerRecommendedPricesMutation,
    SetCustomerRecommendedPricesMutationVariables
  >,
  "mutation"
>;

export const SetCustomerRecommendedPricesComponent = (
  props: SetCustomerRecommendedPricesComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SetCustomerRecommendedPricesMutation,
    SetCustomerRecommendedPricesMutationVariables
  >
    mutation={SetCustomerRecommendedPricesDocument}
    {...props}
  />
);

/**
 * __useSetCustomerRecommendedPricesMutation__
 *
 * To run a mutation, you first call `useSetCustomerRecommendedPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerRecommendedPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerRecommendedPricesMutation, { data, loading, error }] = useSetCustomerRecommendedPricesMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomerRecommendedPricesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCustomerRecommendedPricesMutation,
    SetCustomerRecommendedPricesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCustomerRecommendedPricesMutation,
    SetCustomerRecommendedPricesMutationVariables
  >(SetCustomerRecommendedPricesDocument, options);
}
export type SetCustomerRecommendedPricesMutationHookResult = ReturnType<
  typeof useSetCustomerRecommendedPricesMutation
>;
export namespace SetCustomerRecommendedPrices {
  export type Return = SetCustomerRecommendedPricesMutation;
  export type Variables = SetCustomerRecommendedPricesMutationVariables;
  export const OperationName = "setCustomerRecommendedPrices";

  export const Document = SetCustomerRecommendedPricesDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CustomerSearch_SearchDocument = gql`
  query CustomerSearch_Search(
    $filter: CustomersFilter
    $skip: Int!
    $limit: Int!
    $sortBy: SortBy
    $sortOrder: SortOrder
  ) {
    customers(
      filter: $filter
      limit: $limit
      skip: $skip
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      dbTime
      items {
        ...SimpleCustomerCard
      }
    }
  }
  ${SimpleCustomerCardFragmentDoc}
`;
export type CustomerSearch_SearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerSearch_SearchQuery,
    CustomerSearch_SearchQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerSearch_SearchQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerSearch_SearchComponent = (
  props: CustomerSearch_SearchComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerSearch_SearchQuery,
    CustomerSearch_SearchQueryVariables
  >
    query={CustomerSearch_SearchDocument}
    {...props}
  />
);

/**
 * __useCustomerSearch_SearchQuery__
 *
 * To run a query within a React component, call `useCustomerSearch_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSearch_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSearch_SearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useCustomerSearch_SearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerSearch_SearchQuery,
    CustomerSearch_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerSearch_SearchQuery, CustomerSearch_SearchQueryVariables>(
    CustomerSearch_SearchDocument,
    options
  );
}
export function useCustomerSearch_SearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerSearch_SearchQuery,
    CustomerSearch_SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerSearch_SearchQuery,
    CustomerSearch_SearchQueryVariables
  >(CustomerSearch_SearchDocument, options);
}
export type CustomerSearch_SearchQueryHookResult = ReturnType<
  typeof useCustomerSearch_SearchQuery
>;
export type CustomerSearch_SearchLazyQueryHookResult = ReturnType<
  typeof useCustomerSearch_SearchLazyQuery
>;
export namespace CustomerSearch_Search {
  export type Return = CustomerSearch_SearchQuery;
  export type Variables = CustomerSearch_SearchQueryVariables;
  export const OperationName = "CustomerSearch_Search";

  export const Document = CustomerSearch_SearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerSearch_CountDocument = gql`
  query CustomerSearch_Count($filter: CustomersFilter) {
    customersTotal(filter: $filter) {
      total
    }
  }
`;
export type CustomerSearch_CountComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerSearch_CountQuery,
    CustomerSearch_CountQueryVariables
  >,
  "query"
>;

export const CustomerSearch_CountComponent = (
  props: CustomerSearch_CountComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerSearch_CountQuery,
    CustomerSearch_CountQueryVariables
  >
    query={CustomerSearch_CountDocument}
    {...props}
  />
);

/**
 * __useCustomerSearch_CountQuery__
 *
 * To run a query within a React component, call `useCustomerSearch_CountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSearch_CountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSearch_CountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerSearch_CountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerSearch_CountQuery,
    CustomerSearch_CountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerSearch_CountQuery, CustomerSearch_CountQueryVariables>(
    CustomerSearch_CountDocument,
    options
  );
}
export function useCustomerSearch_CountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerSearch_CountQuery,
    CustomerSearch_CountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerSearch_CountQuery,
    CustomerSearch_CountQueryVariables
  >(CustomerSearch_CountDocument, options);
}
export type CustomerSearch_CountQueryHookResult = ReturnType<
  typeof useCustomerSearch_CountQuery
>;
export type CustomerSearch_CountLazyQueryHookResult = ReturnType<
  typeof useCustomerSearch_CountLazyQuery
>;
export namespace CustomerSearch_Count {
  export type Return = CustomerSearch_CountQuery;
  export type Variables = CustomerSearch_CountQueryVariables;
  export const OperationName = "CustomerSearch_Count";

  export const Document = CustomerSearch_CountDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const CustomerCard_GetDeleteInfoDocument = gql`
  query CustomerCard_GetDeleteInfo($id: ObjectId!) {
    customerById(id: $id) {
      CanBeDeleted
      CantBeDeletedReasons
    }
  }
`;
export type CustomerCard_GetDeleteInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerCard_GetDeleteInfoQuery,
    CustomerCard_GetDeleteInfoQueryVariables
  >,
  "query"
> &
  (
    | { variables: CustomerCard_GetDeleteInfoQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CustomerCard_GetDeleteInfoComponent = (
  props: CustomerCard_GetDeleteInfoComponentProps
) => (
  <ApolloReactComponents.Query<
    CustomerCard_GetDeleteInfoQuery,
    CustomerCard_GetDeleteInfoQueryVariables
  >
    query={CustomerCard_GetDeleteInfoDocument}
    {...props}
  />
);

/**
 * __useCustomerCard_GetDeleteInfoQuery__
 *
 * To run a query within a React component, call `useCustomerCard_GetDeleteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCard_GetDeleteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCard_GetDeleteInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerCard_GetDeleteInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerCard_GetDeleteInfoQuery,
    CustomerCard_GetDeleteInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomerCard_GetDeleteInfoQuery,
    CustomerCard_GetDeleteInfoQueryVariables
  >(CustomerCard_GetDeleteInfoDocument, options);
}
export function useCustomerCard_GetDeleteInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerCard_GetDeleteInfoQuery,
    CustomerCard_GetDeleteInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomerCard_GetDeleteInfoQuery,
    CustomerCard_GetDeleteInfoQueryVariables
  >(CustomerCard_GetDeleteInfoDocument, options);
}
export type CustomerCard_GetDeleteInfoQueryHookResult = ReturnType<
  typeof useCustomerCard_GetDeleteInfoQuery
>;
export type CustomerCard_GetDeleteInfoLazyQueryHookResult = ReturnType<
  typeof useCustomerCard_GetDeleteInfoLazyQuery
>;
export namespace CustomerCard_GetDeleteInfo {
  export type Return = CustomerCard_GetDeleteInfoQuery;
  export type Variables = CustomerCard_GetDeleteInfoQueryVariables;
  export const OperationName = "CustomerCard_GetDeleteInfo";

  export const Document = CustomerCard_GetDeleteInfoDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UploadConsultantAvatarDocument = gql`
  mutation UploadConsultantAvatar($id: ObjectId!, $file: Upload!) {
    uploadConsultantAvatar(id: $id, file: $file) {
      _id
      AvatarPic
    }
  }
`;
export type UploadConsultantAvatarMutationFn = Apollo.MutationFunction<
  UploadConsultantAvatarMutation,
  UploadConsultantAvatarMutationVariables
>;
export type UploadConsultantAvatarComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadConsultantAvatarMutation,
    UploadConsultantAvatarMutationVariables
  >,
  "mutation"
>;

export const UploadConsultantAvatarComponent = (
  props: UploadConsultantAvatarComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadConsultantAvatarMutation,
    UploadConsultantAvatarMutationVariables
  >
    mutation={UploadConsultantAvatarDocument}
    {...props}
  />
);

/**
 * __useUploadConsultantAvatarMutation__
 *
 * To run a mutation, you first call `useUploadConsultantAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadConsultantAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadConsultantAvatarMutation, { data, loading, error }] = useUploadConsultantAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadConsultantAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadConsultantAvatarMutation,
    UploadConsultantAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadConsultantAvatarMutation,
    UploadConsultantAvatarMutationVariables
  >(UploadConsultantAvatarDocument, options);
}
export type UploadConsultantAvatarMutationHookResult = ReturnType<
  typeof useUploadConsultantAvatarMutation
>;
export namespace UploadConsultantAvatar {
  export type Return = UploadConsultantAvatarMutation;
  export type Variables = UploadConsultantAvatarMutationVariables;
  export const OperationName = "UploadConsultantAvatar";

  export const Document = UploadConsultantAvatarDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RemoveConsultantAvatarDocument = gql`
  mutation RemoveConsultantAvatar($id: ObjectId!) {
    removeConsultantAvatar(id: $id) {
      _id
      AvatarPic
    }
  }
`;
export type RemoveConsultantAvatarMutationFn = Apollo.MutationFunction<
  RemoveConsultantAvatarMutation,
  RemoveConsultantAvatarMutationVariables
>;
export type RemoveConsultantAvatarComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveConsultantAvatarMutation,
    RemoveConsultantAvatarMutationVariables
  >,
  "mutation"
>;

export const RemoveConsultantAvatarComponent = (
  props: RemoveConsultantAvatarComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveConsultantAvatarMutation,
    RemoveConsultantAvatarMutationVariables
  >
    mutation={RemoveConsultantAvatarDocument}
    {...props}
  />
);

/**
 * __useRemoveConsultantAvatarMutation__
 *
 * To run a mutation, you first call `useRemoveConsultantAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConsultantAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConsultantAvatarMutation, { data, loading, error }] = useRemoveConsultantAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveConsultantAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveConsultantAvatarMutation,
    RemoveConsultantAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveConsultantAvatarMutation,
    RemoveConsultantAvatarMutationVariables
  >(RemoveConsultantAvatarDocument, options);
}
export type RemoveConsultantAvatarMutationHookResult = ReturnType<
  typeof useRemoveConsultantAvatarMutation
>;
export namespace RemoveConsultantAvatar {
  export type Return = RemoveConsultantAvatarMutation;
  export type Variables = RemoveConsultantAvatarMutationVariables;
  export const OperationName = "RemoveConsultantAvatar";

  export const Document = RemoveConsultantAvatarDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UploadCustomerAvatarDocument = gql`
  mutation UploadCustomerAvatar($id: ObjectId!, $file: Upload!) {
    uploadCustomerAvatar(id: $id, file: $file) {
      _id
      AvatarPic
    }
  }
`;
export type UploadCustomerAvatarMutationFn = Apollo.MutationFunction<
  UploadCustomerAvatarMutation,
  UploadCustomerAvatarMutationVariables
>;
export type UploadCustomerAvatarComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadCustomerAvatarMutation,
    UploadCustomerAvatarMutationVariables
  >,
  "mutation"
>;

export const UploadCustomerAvatarComponent = (
  props: UploadCustomerAvatarComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadCustomerAvatarMutation,
    UploadCustomerAvatarMutationVariables
  >
    mutation={UploadCustomerAvatarDocument}
    {...props}
  />
);

/**
 * __useUploadCustomerAvatarMutation__
 *
 * To run a mutation, you first call `useUploadCustomerAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomerAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomerAvatarMutation, { data, loading, error }] = useUploadCustomerAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadCustomerAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadCustomerAvatarMutation,
    UploadCustomerAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadCustomerAvatarMutation,
    UploadCustomerAvatarMutationVariables
  >(UploadCustomerAvatarDocument, options);
}
export type UploadCustomerAvatarMutationHookResult = ReturnType<
  typeof useUploadCustomerAvatarMutation
>;
export namespace UploadCustomerAvatar {
  export type Return = UploadCustomerAvatarMutation;
  export type Variables = UploadCustomerAvatarMutationVariables;
  export const OperationName = "UploadCustomerAvatar";

  export const Document = UploadCustomerAvatarDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UploadCustomerBgPicDocument = gql`
  mutation UploadCustomerBgPic($id: ObjectId!, $file: Upload!) {
    uploadCustomerBgPic(id: $id, file: $file) {
      _id
      BgPic
    }
  }
`;
export type UploadCustomerBgPicMutationFn = Apollo.MutationFunction<
  UploadCustomerBgPicMutation,
  UploadCustomerBgPicMutationVariables
>;
export type UploadCustomerBgPicComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UploadCustomerBgPicMutation,
    UploadCustomerBgPicMutationVariables
  >,
  "mutation"
>;

export const UploadCustomerBgPicComponent = (
  props: UploadCustomerBgPicComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UploadCustomerBgPicMutation,
    UploadCustomerBgPicMutationVariables
  >
    mutation={UploadCustomerBgPicDocument}
    {...props}
  />
);

/**
 * __useUploadCustomerBgPicMutation__
 *
 * To run a mutation, you first call `useUploadCustomerBgPicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomerBgPicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomerBgPicMutation, { data, loading, error }] = useUploadCustomerBgPicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadCustomerBgPicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadCustomerBgPicMutation,
    UploadCustomerBgPicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadCustomerBgPicMutation,
    UploadCustomerBgPicMutationVariables
  >(UploadCustomerBgPicDocument, options);
}
export type UploadCustomerBgPicMutationHookResult = ReturnType<
  typeof useUploadCustomerBgPicMutation
>;
export namespace UploadCustomerBgPic {
  export type Return = UploadCustomerBgPicMutation;
  export type Variables = UploadCustomerBgPicMutationVariables;
  export const OperationName = "UploadCustomerBgPic";

  export const Document = UploadCustomerBgPicDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const RemoveCustomerAvatarDocument = gql`
  mutation RemoveCustomerAvatar($id: ObjectId!) {
    removeCustomerAvatar(id: $id) {
      _id
      AvatarPic
    }
  }
`;
export type RemoveCustomerAvatarMutationFn = Apollo.MutationFunction<
  RemoveCustomerAvatarMutation,
  RemoveCustomerAvatarMutationVariables
>;
export type RemoveCustomerAvatarComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveCustomerAvatarMutation,
    RemoveCustomerAvatarMutationVariables
  >,
  "mutation"
>;

export const RemoveCustomerAvatarComponent = (
  props: RemoveCustomerAvatarComponentProps
) => (
  <ApolloReactComponents.Mutation<
    RemoveCustomerAvatarMutation,
    RemoveCustomerAvatarMutationVariables
  >
    mutation={RemoveCustomerAvatarDocument}
    {...props}
  />
);

/**
 * __useRemoveCustomerAvatarMutation__
 *
 * To run a mutation, you first call `useRemoveCustomerAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomerAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomerAvatarMutation, { data, loading, error }] = useRemoveCustomerAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCustomerAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCustomerAvatarMutation,
    RemoveCustomerAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveCustomerAvatarMutation,
    RemoveCustomerAvatarMutationVariables
  >(RemoveCustomerAvatarDocument, options);
}
export type RemoveCustomerAvatarMutationHookResult = ReturnType<
  typeof useRemoveCustomerAvatarMutation
>;
export namespace RemoveCustomerAvatar {
  export type Return = RemoveCustomerAvatarMutation;
  export type Variables = RemoveCustomerAvatarMutationVariables;
  export const OperationName = "RemoveCustomerAvatar";

  export const Document = RemoveCustomerAvatarDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const CallListSelector_GetListsDocument = gql`
  query CallListSelector_GetLists {
    me {
      _id
      CallLists {
        ...CallListSelectorList
      }
      ContactLists {
        ...CallListSelectorList
      }
    }
  }
  ${CallListSelectorListFragmentDoc}
`;
export type CallListSelector_GetListsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CallListSelector_GetListsQuery,
    CallListSelector_GetListsQueryVariables
  >,
  "query"
>;

export const CallListSelector_GetListsComponent = (
  props: CallListSelector_GetListsComponentProps
) => (
  <ApolloReactComponents.Query<
    CallListSelector_GetListsQuery,
    CallListSelector_GetListsQueryVariables
  >
    query={CallListSelector_GetListsDocument}
    {...props}
  />
);

/**
 * __useCallListSelector_GetListsQuery__
 *
 * To run a query within a React component, call `useCallListSelector_GetListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallListSelector_GetListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallListSelector_GetListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCallListSelector_GetListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CallListSelector_GetListsQuery,
    CallListSelector_GetListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CallListSelector_GetListsQuery,
    CallListSelector_GetListsQueryVariables
  >(CallListSelector_GetListsDocument, options);
}
export function useCallListSelector_GetListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CallListSelector_GetListsQuery,
    CallListSelector_GetListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CallListSelector_GetListsQuery,
    CallListSelector_GetListsQueryVariables
  >(CallListSelector_GetListsDocument, options);
}
export type CallListSelector_GetListsQueryHookResult = ReturnType<
  typeof useCallListSelector_GetListsQuery
>;
export type CallListSelector_GetListsLazyQueryHookResult = ReturnType<
  typeof useCallListSelector_GetListsLazyQuery
>;
export namespace CallListSelector_GetLists {
  export type Return = CallListSelector_GetListsQuery;
  export type Variables = CallListSelector_GetListsQueryVariables;
  export const OperationName = "CallListSelector_GetLists";

  export const Document = CallListSelector_GetListsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SharedFilesDocument = gql`
  query SharedFiles($filter: SharedFilesFilter!, $skip: Int!, $limit: Int!) {
    sharedFiles(filter: $filter, skip: $skip, limit: $limit) {
      files {
        ...SharedFile
      }
      skip
      limit
    }
  }
  ${SharedFileFragmentDoc}
`;
export type SharedFilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SharedFilesQuery,
    SharedFilesQueryVariables
  >,
  "query"
> &
  ({ variables: SharedFilesQueryVariables; skip?: boolean } | { skip: boolean });

export const SharedFilesComponent = (props: SharedFilesComponentProps) => (
  <ApolloReactComponents.Query<SharedFilesQuery, SharedFilesQueryVariables>
    query={SharedFilesDocument}
    {...props}
  />
);

/**
 * __useSharedFilesQuery__
 *
 * To run a query within a React component, call `useSharedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSharedFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<SharedFilesQuery, SharedFilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SharedFilesQuery, SharedFilesQueryVariables>(
    SharedFilesDocument,
    options
  );
}
export function useSharedFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SharedFilesQuery, SharedFilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SharedFilesQuery, SharedFilesQueryVariables>(
    SharedFilesDocument,
    options
  );
}
export type SharedFilesQueryHookResult = ReturnType<typeof useSharedFilesQuery>;
export type SharedFilesLazyQueryHookResult = ReturnType<typeof useSharedFilesLazyQuery>;
export namespace SharedFiles {
  export type Return = SharedFilesQuery;
  export type Variables = SharedFilesQueryVariables;
  export const OperationName = "SharedFiles";

  export const Document = SharedFilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetSharedFileDocument = gql`
  query GetSharedFile($fileId: ObjectId!) {
    sharedFileById(fileId: $fileId) {
      ...SharedFile
    }
  }
  ${SharedFileFragmentDoc}
`;
export type GetSharedFileComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSharedFileQuery,
    GetSharedFileQueryVariables
  >,
  "query"
> &
  ({ variables: GetSharedFileQueryVariables; skip?: boolean } | { skip: boolean });

export const GetSharedFileComponent = (props: GetSharedFileComponentProps) => (
  <ApolloReactComponents.Query<GetSharedFileQuery, GetSharedFileQueryVariables>
    query={GetSharedFileDocument}
    {...props}
  />
);

/**
 * __useGetSharedFileQuery__
 *
 * To run a query within a React component, call `useGetSharedFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetSharedFileQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSharedFileQuery, GetSharedFileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSharedFileQuery, GetSharedFileQueryVariables>(
    GetSharedFileDocument,
    options
  );
}
export function useGetSharedFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSharedFileQuery,
    GetSharedFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSharedFileQuery, GetSharedFileQueryVariables>(
    GetSharedFileDocument,
    options
  );
}
export type GetSharedFileQueryHookResult = ReturnType<typeof useGetSharedFileQuery>;
export type GetSharedFileLazyQueryHookResult = ReturnType<
  typeof useGetSharedFileLazyQuery
>;
export namespace GetSharedFile {
  export type Return = GetSharedFileQuery;
  export type Variables = GetSharedFileQueryVariables;
  export const OperationName = "GetSharedFile";

  export const Document = GetSharedFileDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const RemoveSharedFileDocument = gql`
  mutation RemoveSharedFile($fileId: ObjectId!) {
    removeSharedFile(fileId: $fileId)
  }
`;
export type RemoveSharedFileMutationFn = Apollo.MutationFunction<
  RemoveSharedFileMutation,
  RemoveSharedFileMutationVariables
>;
export type RemoveSharedFileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    RemoveSharedFileMutation,
    RemoveSharedFileMutationVariables
  >,
  "mutation"
>;

export const RemoveSharedFileComponent = (props: RemoveSharedFileComponentProps) => (
  <ApolloReactComponents.Mutation<
    RemoveSharedFileMutation,
    RemoveSharedFileMutationVariables
  >
    mutation={RemoveSharedFileDocument}
    {...props}
  />
);

/**
 * __useRemoveSharedFileMutation__
 *
 * To run a mutation, you first call `useRemoveSharedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSharedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSharedFileMutation, { data, loading, error }] = useRemoveSharedFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRemoveSharedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSharedFileMutation,
    RemoveSharedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveSharedFileMutation, RemoveSharedFileMutationVariables>(
    RemoveSharedFileDocument,
    options
  );
}
export type RemoveSharedFileMutationHookResult = ReturnType<
  typeof useRemoveSharedFileMutation
>;
export namespace RemoveSharedFile {
  export type Return = RemoveSharedFileMutation;
  export type Variables = RemoveSharedFileMutationVariables;
  export const OperationName = "RemoveSharedFile";

  export const Document = RemoveSharedFileDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpdateSharedFileDocument = gql`
  mutation UpdateSharedFile($id: ObjectId!, $fileName: String, $expiresOn: Date) {
    updateSharedFile(id: $id, fileName: $fileName, expiresOn: $expiresOn) {
      ...SharedFile
    }
  }
  ${SharedFileFragmentDoc}
`;
export type UpdateSharedFileMutationFn = Apollo.MutationFunction<
  UpdateSharedFileMutation,
  UpdateSharedFileMutationVariables
>;
export type UpdateSharedFileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateSharedFileMutation,
    UpdateSharedFileMutationVariables
  >,
  "mutation"
>;

export const UpdateSharedFileComponent = (props: UpdateSharedFileComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateSharedFileMutation,
    UpdateSharedFileMutationVariables
  >
    mutation={UpdateSharedFileDocument}
    {...props}
  />
);

/**
 * __useUpdateSharedFileMutation__
 *
 * To run a mutation, you first call `useUpdateSharedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedFileMutation, { data, loading, error }] = useUpdateSharedFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileName: // value for 'fileName'
 *      expiresOn: // value for 'expiresOn'
 *   },
 * });
 */
export function useUpdateSharedFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSharedFileMutation,
    UpdateSharedFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSharedFileMutation, UpdateSharedFileMutationVariables>(
    UpdateSharedFileDocument,
    options
  );
}
export type UpdateSharedFileMutationHookResult = ReturnType<
  typeof useUpdateSharedFileMutation
>;
export namespace UpdateSharedFile {
  export type Return = UpdateSharedFileMutation;
  export type Variables = UpdateSharedFileMutationVariables;
  export const OperationName = "UpdateSharedFile";

  export const Document = UpdateSharedFileDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const SharedFileSearch_UploadDocument = gql`
  mutation SharedFileSearch_Upload($file: Upload!, $expiresOn: Date!, $fileName: String) {
    uploadSharedFile(expiresOn: $expiresOn, file: $file, fileName: $fileName) {
      ...SharedFile
      Name
    }
  }
  ${SharedFileFragmentDoc}
`;
export type SharedFileSearch_UploadMutationFn = Apollo.MutationFunction<
  SharedFileSearch_UploadMutation,
  SharedFileSearch_UploadMutationVariables
>;
export type SharedFileSearch_UploadComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SharedFileSearch_UploadMutation,
    SharedFileSearch_UploadMutationVariables
  >,
  "mutation"
>;

export const SharedFileSearch_UploadComponent = (
  props: SharedFileSearch_UploadComponentProps
) => (
  <ApolloReactComponents.Mutation<
    SharedFileSearch_UploadMutation,
    SharedFileSearch_UploadMutationVariables
  >
    mutation={SharedFileSearch_UploadDocument}
    {...props}
  />
);

/**
 * __useSharedFileSearch_UploadMutation__
 *
 * To run a mutation, you first call `useSharedFileSearch_UploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharedFileSearch_UploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharedFileSearchUploadMutation, { data, loading, error }] = useSharedFileSearch_UploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      expiresOn: // value for 'expiresOn'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useSharedFileSearch_UploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SharedFileSearch_UploadMutation,
    SharedFileSearch_UploadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SharedFileSearch_UploadMutation,
    SharedFileSearch_UploadMutationVariables
  >(SharedFileSearch_UploadDocument, options);
}
export type SharedFileSearch_UploadMutationHookResult = ReturnType<
  typeof useSharedFileSearch_UploadMutation
>;
export namespace SharedFileSearch_Upload {
  export type Return = SharedFileSearch_UploadMutation;
  export type Variables = SharedFileSearch_UploadMutationVariables;
  export const OperationName = "SharedFileSearch_Upload";

  export const Document = SharedFileSearch_UploadDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const FetchStaticDataDocument = gql`
  query FetchStaticData {
    config {
      bookingTags {
        color
        code
        label
        bookingKit
        booking
      }
      competitors
      customerGroups
      roles {
        ...Role
      }
      titles
      expertises {
        ...Expertise
      }
      countries {
        ...Country
      }
      languages
      nationalProcurementTravelRegions
      blockBookingCreationForBemloCustomers
    }
    teams {
      ...Team
    }
  }
  ${RoleFragmentDoc}
  ${ExpertiseFragmentDoc}
  ${CountryFragmentDoc}
  ${TeamFragmentDoc}
`;
export type FetchStaticDataComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    FetchStaticDataQuery,
    FetchStaticDataQueryVariables
  >,
  "query"
>;

export const FetchStaticDataComponent = (props: FetchStaticDataComponentProps) => (
  <ApolloReactComponents.Query<FetchStaticDataQuery, FetchStaticDataQueryVariables>
    query={FetchStaticDataDocument}
    {...props}
  />
);

/**
 * __useFetchStaticDataQuery__
 *
 * To run a query within a React component, call `useFetchStaticDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchStaticDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStaticDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchStaticDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchStaticDataQuery,
    FetchStaticDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchStaticDataQuery, FetchStaticDataQueryVariables>(
    FetchStaticDataDocument,
    options
  );
}
export function useFetchStaticDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchStaticDataQuery,
    FetchStaticDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchStaticDataQuery, FetchStaticDataQueryVariables>(
    FetchStaticDataDocument,
    options
  );
}
export type FetchStaticDataQueryHookResult = ReturnType<typeof useFetchStaticDataQuery>;
export type FetchStaticDataLazyQueryHookResult = ReturnType<
  typeof useFetchStaticDataLazyQuery
>;
export namespace FetchStaticData {
  export type Return = FetchStaticDataQuery;
  export type Variables = FetchStaticDataQueryVariables;
  export const OperationName = "FetchStaticData";

  export const Document = FetchStaticDataDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const FetchStaticData_ProjectsDocument = gql`
  query FetchStaticData_Projects($visibilityContext: ProjectVisibilityContext) {
    projects(skip: 0, limit: 2000, visibilityContext: $visibilityContext) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`;
export type FetchStaticData_ProjectsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    FetchStaticData_ProjectsQuery,
    FetchStaticData_ProjectsQueryVariables
  >,
  "query"
>;

export const FetchStaticData_ProjectsComponent = (
  props: FetchStaticData_ProjectsComponentProps
) => (
  <ApolloReactComponents.Query<
    FetchStaticData_ProjectsQuery,
    FetchStaticData_ProjectsQueryVariables
  >
    query={FetchStaticData_ProjectsDocument}
    {...props}
  />
);

/**
 * __useFetchStaticData_ProjectsQuery__
 *
 * To run a query within a React component, call `useFetchStaticData_ProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchStaticData_ProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStaticData_ProjectsQuery({
 *   variables: {
 *      visibilityContext: // value for 'visibilityContext'
 *   },
 * });
 */
export function useFetchStaticData_ProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchStaticData_ProjectsQuery,
    FetchStaticData_ProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchStaticData_ProjectsQuery,
    FetchStaticData_ProjectsQueryVariables
  >(FetchStaticData_ProjectsDocument, options);
}
export function useFetchStaticData_ProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchStaticData_ProjectsQuery,
    FetchStaticData_ProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchStaticData_ProjectsQuery,
    FetchStaticData_ProjectsQueryVariables
  >(FetchStaticData_ProjectsDocument, options);
}
export type FetchStaticData_ProjectsQueryHookResult = ReturnType<
  typeof useFetchStaticData_ProjectsQuery
>;
export type FetchStaticData_ProjectsLazyQueryHookResult = ReturnType<
  typeof useFetchStaticData_ProjectsLazyQuery
>;
export namespace FetchStaticData_Projects {
  export type Return = FetchStaticData_ProjectsQuery;
  export type Variables = FetchStaticData_ProjectsQueryVariables;
  export const OperationName = "FetchStaticData_Projects";

  export const Document = FetchStaticData_ProjectsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetMyProfileDocument = gql`
  query GetMyProfile {
    me {
      ...MyProfile
    }
  }
  ${MyProfileFragmentDoc}
`;
export type GetMyProfileComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetMyProfileQuery,
    GetMyProfileQueryVariables
  >,
  "query"
>;

export const GetMyProfileComponent = (props: GetMyProfileComponentProps) => (
  <ApolloReactComponents.Query<GetMyProfileQuery, GetMyProfileQueryVariables>
    query={GetMyProfileDocument}
    {...props}
  />
);

/**
 * __useGetMyProfileQuery__
 *
 * To run a query within a React component, call `useGetMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(
    GetMyProfileDocument,
    options
  );
}
export function useGetMyProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(
    GetMyProfileDocument,
    options
  );
}
export type GetMyProfileQueryHookResult = ReturnType<typeof useGetMyProfileQuery>;
export type GetMyProfileLazyQueryHookResult = ReturnType<typeof useGetMyProfileLazyQuery>;
export namespace GetMyProfile {
  export type Return = GetMyProfileQuery;
  export type Variables = GetMyProfileQueryVariables;
  export const OperationName = "GetMyProfile";

  export const Document = GetMyProfileDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const MyProfile_GetAllowedCostCentersDocument = gql`
  query MyProfile_GetAllowedCostCenters {
    me {
      allowedCostCenters {
        ...CostCenter
      }
    }
  }
  ${CostCenterFragmentDoc}
`;
export type MyProfile_GetAllowedCostCentersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    MyProfile_GetAllowedCostCentersQuery,
    MyProfile_GetAllowedCostCentersQueryVariables
  >,
  "query"
>;

export const MyProfile_GetAllowedCostCentersComponent = (
  props: MyProfile_GetAllowedCostCentersComponentProps
) => (
  <ApolloReactComponents.Query<
    MyProfile_GetAllowedCostCentersQuery,
    MyProfile_GetAllowedCostCentersQueryVariables
  >
    query={MyProfile_GetAllowedCostCentersDocument}
    {...props}
  />
);

/**
 * __useMyProfile_GetAllowedCostCentersQuery__
 *
 * To run a query within a React component, call `useMyProfile_GetAllowedCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfile_GetAllowedCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfile_GetAllowedCostCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfile_GetAllowedCostCentersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyProfile_GetAllowedCostCentersQuery,
    MyProfile_GetAllowedCostCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyProfile_GetAllowedCostCentersQuery,
    MyProfile_GetAllowedCostCentersQueryVariables
  >(MyProfile_GetAllowedCostCentersDocument, options);
}
export function useMyProfile_GetAllowedCostCentersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyProfile_GetAllowedCostCentersQuery,
    MyProfile_GetAllowedCostCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyProfile_GetAllowedCostCentersQuery,
    MyProfile_GetAllowedCostCentersQueryVariables
  >(MyProfile_GetAllowedCostCentersDocument, options);
}
export type MyProfile_GetAllowedCostCentersQueryHookResult = ReturnType<
  typeof useMyProfile_GetAllowedCostCentersQuery
>;
export type MyProfile_GetAllowedCostCentersLazyQueryHookResult = ReturnType<
  typeof useMyProfile_GetAllowedCostCentersLazyQuery
>;
export namespace MyProfile_GetAllowedCostCenters {
  export type Return = MyProfile_GetAllowedCostCentersQuery;
  export type Variables = MyProfile_GetAllowedCostCentersQueryVariables;
  export const OperationName = "MyProfile_GetAllowedCostCenters";

  export const Document = MyProfile_GetAllowedCostCentersDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UpdateFavoriteTeamDocument = gql`
  mutation UpdateFavoriteTeam($teamName: String!) {
    updateFavoriteTeam(teamName: $teamName) {
      ...MyProfile
    }
  }
  ${MyProfileFragmentDoc}
`;
export type UpdateFavoriteTeamMutationFn = Apollo.MutationFunction<
  UpdateFavoriteTeamMutation,
  UpdateFavoriteTeamMutationVariables
>;
export type UpdateFavoriteTeamComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateFavoriteTeamMutation,
    UpdateFavoriteTeamMutationVariables
  >,
  "mutation"
>;

export const UpdateFavoriteTeamComponent = (props: UpdateFavoriteTeamComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateFavoriteTeamMutation,
    UpdateFavoriteTeamMutationVariables
  >
    mutation={UpdateFavoriteTeamDocument}
    {...props}
  />
);

/**
 * __useUpdateFavoriteTeamMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteTeamMutation, { data, loading, error }] = useUpdateFavoriteTeamMutation({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useUpdateFavoriteTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFavoriteTeamMutation,
    UpdateFavoriteTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFavoriteTeamMutation,
    UpdateFavoriteTeamMutationVariables
  >(UpdateFavoriteTeamDocument, options);
}
export type UpdateFavoriteTeamMutationHookResult = ReturnType<
  typeof useUpdateFavoriteTeamMutation
>;
export namespace UpdateFavoriteTeam {
  export type Return = UpdateFavoriteTeamMutation;
  export type Variables = UpdateFavoriteTeamMutationVariables;
  export const OperationName = "UpdateFavoriteTeam";

  export const Document = UpdateFavoriteTeamDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const MyProfileUpdatedDocument = gql`
  subscription MyProfileUpdated {
    myProfileUpdated {
      ...MyProfilePartial
    }
  }
  ${MyProfilePartialFragmentDoc}
`;
export type MyProfileUpdatedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    MyProfileUpdatedSubscription,
    MyProfileUpdatedSubscriptionVariables
  >,
  "subscription"
>;

export const MyProfileUpdatedComponent = (props: MyProfileUpdatedComponentProps) => (
  <ApolloReactComponents.Subscription<
    MyProfileUpdatedSubscription,
    MyProfileUpdatedSubscriptionVariables
  >
    subscription={MyProfileUpdatedDocument}
    {...props}
  />
);

/**
 * __useMyProfileUpdatedSubscription__
 *
 * To run a query within a React component, call `useMyProfileUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MyProfileUpdatedSubscription,
    MyProfileUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MyProfileUpdatedSubscription,
    MyProfileUpdatedSubscriptionVariables
  >(MyProfileUpdatedDocument, options);
}
export type MyProfileUpdatedSubscriptionHookResult = ReturnType<
  typeof useMyProfileUpdatedSubscription
>;
export namespace MyProfileUpdated {
  export type Return = MyProfileUpdatedSubscription;
  export type Variables = MyProfileUpdatedSubscriptionVariables;
  export const OperationName = "MyProfileUpdated";

  export const Document = MyProfileUpdatedDocument;
  export const { func } = subscription<Variables, Return>(Document, getClient);
}
export const UserStore_GetCallListsDocument = gql`
  query UserStore_GetCallLists {
    me {
      _id
      CallLists {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type UserStore_GetCallListsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    UserStore_GetCallListsQuery,
    UserStore_GetCallListsQueryVariables
  >,
  "query"
>;

export const UserStore_GetCallListsComponent = (
  props: UserStore_GetCallListsComponentProps
) => (
  <ApolloReactComponents.Query<
    UserStore_GetCallListsQuery,
    UserStore_GetCallListsQueryVariables
  >
    query={UserStore_GetCallListsDocument}
    {...props}
  />
);

/**
 * __useUserStore_GetCallListsQuery__
 *
 * To run a query within a React component, call `useUserStore_GetCallListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStore_GetCallListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStore_GetCallListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStore_GetCallListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserStore_GetCallListsQuery,
    UserStore_GetCallListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserStore_GetCallListsQuery,
    UserStore_GetCallListsQueryVariables
  >(UserStore_GetCallListsDocument, options);
}
export function useUserStore_GetCallListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserStore_GetCallListsQuery,
    UserStore_GetCallListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserStore_GetCallListsQuery,
    UserStore_GetCallListsQueryVariables
  >(UserStore_GetCallListsDocument, options);
}
export type UserStore_GetCallListsQueryHookResult = ReturnType<
  typeof useUserStore_GetCallListsQuery
>;
export type UserStore_GetCallListsLazyQueryHookResult = ReturnType<
  typeof useUserStore_GetCallListsLazyQuery
>;
export namespace UserStore_GetCallLists {
  export type Return = UserStore_GetCallListsQuery;
  export type Variables = UserStore_GetCallListsQueryVariables;
  export const OperationName = "UserStore_GetCallLists";

  export const Document = UserStore_GetCallListsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const UserStore_GetContactListsDocument = gql`
  query UserStore_GetContactLists {
    me {
      _id
      ContactLists {
        ...UserStore_CallList
      }
    }
  }
  ${UserStore_CallListFragmentDoc}
`;
export type UserStore_GetContactListsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    UserStore_GetContactListsQuery,
    UserStore_GetContactListsQueryVariables
  >,
  "query"
>;

export const UserStore_GetContactListsComponent = (
  props: UserStore_GetContactListsComponentProps
) => (
  <ApolloReactComponents.Query<
    UserStore_GetContactListsQuery,
    UserStore_GetContactListsQueryVariables
  >
    query={UserStore_GetContactListsDocument}
    {...props}
  />
);

/**
 * __useUserStore_GetContactListsQuery__
 *
 * To run a query within a React component, call `useUserStore_GetContactListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStore_GetContactListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStore_GetContactListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStore_GetContactListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserStore_GetContactListsQuery,
    UserStore_GetContactListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserStore_GetContactListsQuery,
    UserStore_GetContactListsQueryVariables
  >(UserStore_GetContactListsDocument, options);
}
export function useUserStore_GetContactListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserStore_GetContactListsQuery,
    UserStore_GetContactListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserStore_GetContactListsQuery,
    UserStore_GetContactListsQueryVariables
  >(UserStore_GetContactListsDocument, options);
}
export type UserStore_GetContactListsQueryHookResult = ReturnType<
  typeof useUserStore_GetContactListsQuery
>;
export type UserStore_GetContactListsLazyQueryHookResult = ReturnType<
  typeof useUserStore_GetContactListsLazyQuery
>;
export namespace UserStore_GetContactLists {
  export type Return = UserStore_GetContactListsQuery;
  export type Variables = UserStore_GetContactListsQueryVariables;
  export const OperationName = "UserStore_GetContactLists";

  export const Document = UserStore_GetContactListsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetTodoDocument = gql`
  query getTodo($id: ObjectId!) {
    todo(id: $id) {
      ...TicketItemData
    }
  }
  ${TicketItemDataFragmentDoc}
`;
export type GetTodoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetTodoQuery, GetTodoQueryVariables>,
  "query"
> &
  ({ variables: GetTodoQueryVariables; skip?: boolean } | { skip: boolean });

export const GetTodoComponent = (props: GetTodoComponentProps) => (
  <ApolloReactComponents.Query<GetTodoQuery, GetTodoQueryVariables>
    query={GetTodoDocument}
    {...props}
  />
);

/**
 * __useGetTodoQuery__
 *
 * To run a query within a React component, call `useGetTodoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTodoQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTodoQuery, GetTodoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTodoQuery, GetTodoQueryVariables>(GetTodoDocument, options);
}
export function useGetTodoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTodoQuery, GetTodoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTodoQuery, GetTodoQueryVariables>(
    GetTodoDocument,
    options
  );
}
export type GetTodoQueryHookResult = ReturnType<typeof useGetTodoQuery>;
export type GetTodoLazyQueryHookResult = ReturnType<typeof useGetTodoLazyQuery>;
export namespace GetTodo {
  export type Return = GetTodoQuery;
  export type Variables = GetTodoQueryVariables;
  export const OperationName = "getTodo";

  export const Document = GetTodoDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SetTodoStatusDocument = gql`
  mutation setTodoStatus($todoId: ObjectId!, $status: TodoStatus!) {
    setTodoStatus(todoId: $todoId, status: $status) {
      ...TicketItemData
    }
  }
  ${TicketItemDataFragmentDoc}
`;
export type SetTodoStatusMutationFn = Apollo.MutationFunction<
  SetTodoStatusMutation,
  SetTodoStatusMutationVariables
>;
export type SetTodoStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SetTodoStatusMutation,
    SetTodoStatusMutationVariables
  >,
  "mutation"
>;

export const SetTodoStatusComponent = (props: SetTodoStatusComponentProps) => (
  <ApolloReactComponents.Mutation<SetTodoStatusMutation, SetTodoStatusMutationVariables>
    mutation={SetTodoStatusDocument}
    {...props}
  />
);

/**
 * __useSetTodoStatusMutation__
 *
 * To run a mutation, you first call `useSetTodoStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTodoStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTodoStatusMutation, { data, loading, error }] = useSetTodoStatusMutation({
 *   variables: {
 *      todoId: // value for 'todoId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetTodoStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetTodoStatusMutation,
    SetTodoStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTodoStatusMutation, SetTodoStatusMutationVariables>(
    SetTodoStatusDocument,
    options
  );
}
export type SetTodoStatusMutationHookResult = ReturnType<typeof useSetTodoStatusMutation>;
export namespace SetTodoStatus {
  export type Return = SetTodoStatusMutation;
  export type Variables = SetTodoStatusMutationVariables;
  export const OperationName = "setTodoStatus";

  export const Document = SetTodoStatusDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const AssignTodoDocument = gql`
  mutation assignTodo($todoId: ObjectId!, $userId: ObjectId!) {
    assignTodo(todoId: $todoId, userId: $userId) {
      ...TicketItemData
    }
  }
  ${TicketItemDataFragmentDoc}
`;
export type AssignTodoMutationFn = Apollo.MutationFunction<
  AssignTodoMutation,
  AssignTodoMutationVariables
>;
export type AssignTodoComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AssignTodoMutation,
    AssignTodoMutationVariables
  >,
  "mutation"
>;

export const AssignTodoComponent = (props: AssignTodoComponentProps) => (
  <ApolloReactComponents.Mutation<AssignTodoMutation, AssignTodoMutationVariables>
    mutation={AssignTodoDocument}
    {...props}
  />
);

/**
 * __useAssignTodoMutation__
 *
 * To run a mutation, you first call `useAssignTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTodoMutation, { data, loading, error }] = useAssignTodoMutation({
 *   variables: {
 *      todoId: // value for 'todoId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignTodoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTodoMutation,
    AssignTodoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignTodoMutation, AssignTodoMutationVariables>(
    AssignTodoDocument,
    options
  );
}
export type AssignTodoMutationHookResult = ReturnType<typeof useAssignTodoMutation>;
export namespace AssignTodo {
  export type Return = AssignTodoMutation;
  export type Variables = AssignTodoMutationVariables;
  export const OperationName = "assignTodo";

  export const Document = AssignTodoDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const TodoSearchDocument = gql`
  query TodoSearch(
    $filter: TodoSearchFilter
    $skip: Int = 0
    $limit: Int = 20
    $sortBy: TodoSearchSortBy
    $sortOrder: SortOrder
  ) {
    todoSearch(
      filter: $filter
      skip: $skip
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      ...TodoSearchItem
    }
  }
  ${TodoSearchItemFragmentDoc}
`;
export type TodoSearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TodoSearchQuery, TodoSearchQueryVariables>,
  "query"
>;

export const TodoSearchComponent = (props: TodoSearchComponentProps) => (
  <ApolloReactComponents.Query<TodoSearchQuery, TodoSearchQueryVariables>
    query={TodoSearchDocument}
    {...props}
  />
);

/**
 * __useTodoSearchQuery__
 *
 * To run a query within a React component, call `useTodoSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodoSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodoSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useTodoSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<TodoSearchQuery, TodoSearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TodoSearchQuery, TodoSearchQueryVariables>(
    TodoSearchDocument,
    options
  );
}
export function useTodoSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TodoSearchQuery, TodoSearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TodoSearchQuery, TodoSearchQueryVariables>(
    TodoSearchDocument,
    options
  );
}
export type TodoSearchQueryHookResult = ReturnType<typeof useTodoSearchQuery>;
export type TodoSearchLazyQueryHookResult = ReturnType<typeof useTodoSearchLazyQuery>;
export namespace TodoSearch {
  export type Return = TodoSearchQuery;
  export type Variables = TodoSearchQueryVariables;
  export const OperationName = "TodoSearch";

  export const Document = TodoSearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultant_ReferencesDocument = gql`
  query getConsultant_references($id: ObjectId!) {
    consultantById(id: $id) {
      _id
    }
  }
`;
export type GetConsultant_ReferencesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultant_ReferencesQuery,
    GetConsultant_ReferencesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultant_ReferencesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultant_ReferencesComponent = (
  props: GetConsultant_ReferencesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultant_ReferencesQuery,
    GetConsultant_ReferencesQueryVariables
  >
    query={GetConsultant_ReferencesDocument}
    {...props}
  />
);

/**
 * __useGetConsultant_ReferencesQuery__
 *
 * To run a query within a React component, call `useGetConsultant_ReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultant_ReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultant_ReferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultant_ReferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultant_ReferencesQuery,
    GetConsultant_ReferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultant_ReferencesQuery,
    GetConsultant_ReferencesQueryVariables
  >(GetConsultant_ReferencesDocument, options);
}
export function useGetConsultant_ReferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultant_ReferencesQuery,
    GetConsultant_ReferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultant_ReferencesQuery,
    GetConsultant_ReferencesQueryVariables
  >(GetConsultant_ReferencesDocument, options);
}
export type GetConsultant_ReferencesQueryHookResult = ReturnType<
  typeof useGetConsultant_ReferencesQuery
>;
export type GetConsultant_ReferencesLazyQueryHookResult = ReturnType<
  typeof useGetConsultant_ReferencesLazyQuery
>;
export namespace GetConsultant_references {
  export type Return = GetConsultant_ReferencesQuery;
  export type Variables = GetConsultant_ReferencesQueryVariables;
  export const OperationName = "getConsultant_references";

  export const Document = GetConsultant_ReferencesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetConsultant_AllReferencesDocument = gql`
  query getConsultant_allReferences($id: ObjectId!) {
    consultantById(id: $id) {
      _id
    }
  }
`;
export type GetConsultant_AllReferencesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetConsultant_AllReferencesQuery,
    GetConsultant_AllReferencesQueryVariables
  >,
  "query"
> &
  (
    | { variables: GetConsultant_AllReferencesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const GetConsultant_AllReferencesComponent = (
  props: GetConsultant_AllReferencesComponentProps
) => (
  <ApolloReactComponents.Query<
    GetConsultant_AllReferencesQuery,
    GetConsultant_AllReferencesQueryVariables
  >
    query={GetConsultant_AllReferencesDocument}
    {...props}
  />
);

/**
 * __useGetConsultant_AllReferencesQuery__
 *
 * To run a query within a React component, call `useGetConsultant_AllReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultant_AllReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultant_AllReferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultant_AllReferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsultant_AllReferencesQuery,
    GetConsultant_AllReferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsultant_AllReferencesQuery,
    GetConsultant_AllReferencesQueryVariables
  >(GetConsultant_AllReferencesDocument, options);
}
export function useGetConsultant_AllReferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsultant_AllReferencesQuery,
    GetConsultant_AllReferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsultant_AllReferencesQuery,
    GetConsultant_AllReferencesQueryVariables
  >(GetConsultant_AllReferencesDocument, options);
}
export type GetConsultant_AllReferencesQueryHookResult = ReturnType<
  typeof useGetConsultant_AllReferencesQuery
>;
export type GetConsultant_AllReferencesLazyQueryHookResult = ReturnType<
  typeof useGetConsultant_AllReferencesLazyQuery
>;
export namespace GetConsultant_allReferences {
  export type Return = GetConsultant_AllReferencesQuery;
  export type Variables = GetConsultant_AllReferencesQueryVariables;
  export const OperationName = "getConsultant_allReferences";

  export const Document = GetConsultant_AllReferencesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetTodoTotalDocument = gql`
  query getTodoTotal($filter: TodoSearchFilter) {
    todoTotal(filter: $filter) {
      dbTime
      total
    }
  }
`;
export type GetTodoTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetTodoTotalQuery,
    GetTodoTotalQueryVariables
  >,
  "query"
>;

export const GetTodoTotalComponent = (props: GetTodoTotalComponentProps) => (
  <ApolloReactComponents.Query<GetTodoTotalQuery, GetTodoTotalQueryVariables>
    query={GetTodoTotalDocument}
    {...props}
  />
);

/**
 * __useGetTodoTotalQuery__
 *
 * To run a query within a React component, call `useGetTodoTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodoTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodoTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTodoTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTodoTotalQuery, GetTodoTotalQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTodoTotalQuery, GetTodoTotalQueryVariables>(
    GetTodoTotalDocument,
    options
  );
}
export function useGetTodoTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTodoTotalQuery, GetTodoTotalQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTodoTotalQuery, GetTodoTotalQueryVariables>(
    GetTodoTotalDocument,
    options
  );
}
export type GetTodoTotalQueryHookResult = ReturnType<typeof useGetTodoTotalQuery>;
export type GetTodoTotalLazyQueryHookResult = ReturnType<typeof useGetTodoTotalLazyQuery>;
export namespace GetTodoTotal {
  export type Return = GetTodoTotalQuery;
  export type Variables = GetTodoTotalQueryVariables;
  export const OperationName = "getTodoTotal";

  export const Document = GetTodoTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TravelRequestSearchDocument = gql`
  query TravelRequestSearch(
    $filter: TravelRequestQueryInput!
    $skip: Int
    $limit: Int
    $sortBy: TravelRequestSortBy
    $sortOrder: SortOrder
  ) {
    travelRequestSearch(
      filter: $filter
      skip: $skip
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      dbTime
      items {
        ...TravelRequestSearchItem
      }
      skip
      limit
    }
  }
  ${TravelRequestSearchItemFragmentDoc}
`;
export type TravelRequestSearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TravelRequestSearchQuery,
    TravelRequestSearchQueryVariables
  >,
  "query"
> &
  ({ variables: TravelRequestSearchQueryVariables; skip?: boolean } | { skip: boolean });

export const TravelRequestSearchComponent = (
  props: TravelRequestSearchComponentProps
) => (
  <ApolloReactComponents.Query<
    TravelRequestSearchQuery,
    TravelRequestSearchQueryVariables
  >
    query={TravelRequestSearchDocument}
    {...props}
  />
);

/**
 * __useTravelRequestSearchQuery__
 *
 * To run a query within a React component, call `useTravelRequestSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRequestSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRequestSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useTravelRequestSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TravelRequestSearchQuery,
    TravelRequestSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TravelRequestSearchQuery, TravelRequestSearchQueryVariables>(
    TravelRequestSearchDocument,
    options
  );
}
export function useTravelRequestSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TravelRequestSearchQuery,
    TravelRequestSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TravelRequestSearchQuery, TravelRequestSearchQueryVariables>(
    TravelRequestSearchDocument,
    options
  );
}
export type TravelRequestSearchQueryHookResult = ReturnType<
  typeof useTravelRequestSearchQuery
>;
export type TravelRequestSearchLazyQueryHookResult = ReturnType<
  typeof useTravelRequestSearchLazyQuery
>;
export namespace TravelRequestSearch {
  export type Return = TravelRequestSearchQuery;
  export type Variables = TravelRequestSearchQueryVariables;
  export const OperationName = "TravelRequestSearch";

  export const Document = TravelRequestSearchDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const TravelRequestSearchTotalDocument = gql`
  query TravelRequestSearchTotal($filter: TravelRequestQueryInput!) {
    travelRequestSearchTotal(filter: $filter) {
      dbTime
      total
    }
  }
`;
export type TravelRequestSearchTotalComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TravelRequestSearchTotalQuery,
    TravelRequestSearchTotalQueryVariables
  >,
  "query"
> &
  (
    | { variables: TravelRequestSearchTotalQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const TravelRequestSearchTotalComponent = (
  props: TravelRequestSearchTotalComponentProps
) => (
  <ApolloReactComponents.Query<
    TravelRequestSearchTotalQuery,
    TravelRequestSearchTotalQueryVariables
  >
    query={TravelRequestSearchTotalDocument}
    {...props}
  />
);

/**
 * __useTravelRequestSearchTotalQuery__
 *
 * To run a query within a React component, call `useTravelRequestSearchTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRequestSearchTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRequestSearchTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTravelRequestSearchTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TravelRequestSearchTotalQuery,
    TravelRequestSearchTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TravelRequestSearchTotalQuery,
    TravelRequestSearchTotalQueryVariables
  >(TravelRequestSearchTotalDocument, options);
}
export function useTravelRequestSearchTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TravelRequestSearchTotalQuery,
    TravelRequestSearchTotalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TravelRequestSearchTotalQuery,
    TravelRequestSearchTotalQueryVariables
  >(TravelRequestSearchTotalDocument, options);
}
export type TravelRequestSearchTotalQueryHookResult = ReturnType<
  typeof useTravelRequestSearchTotalQuery
>;
export type TravelRequestSearchTotalLazyQueryHookResult = ReturnType<
  typeof useTravelRequestSearchTotalLazyQuery
>;
export namespace TravelRequestSearchTotal {
  export type Return = TravelRequestSearchTotalQuery;
  export type Variables = TravelRequestSearchTotalQueryVariables;
  export const OperationName = "TravelRequestSearchTotal";

  export const Document = TravelRequestSearchTotalDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetWorkflowRunsByOwnerDocument = gql`
  query GetWorkflowRunsByOwner(
    $status: WorkflowStatus
    $workflowType: String
    $skip: Int
    $limit: Int
  ) {
    getWorkflowRunsByOwner(
      status: $status
      workflowType: $workflowType
      skip: $skip
      limit: $limit
    ) {
      total
      items {
        _id
        workflowType
        entityId
        entityType
        status
        errorMessage
        scheduledAt
        startedAt
        completedAt
        metadata
        steps {
          _id
          title
          startedAt
          completedAt
          failedAt
        }
      }
    }
  }
`;
export type GetWorkflowRunsByOwnerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetWorkflowRunsByOwnerQuery,
    GetWorkflowRunsByOwnerQueryVariables
  >,
  "query"
>;

export const GetWorkflowRunsByOwnerComponent = (
  props: GetWorkflowRunsByOwnerComponentProps
) => (
  <ApolloReactComponents.Query<
    GetWorkflowRunsByOwnerQuery,
    GetWorkflowRunsByOwnerQueryVariables
  >
    query={GetWorkflowRunsByOwnerDocument}
    {...props}
  />
);

/**
 * __useGetWorkflowRunsByOwnerQuery__
 *
 * To run a query within a React component, call `useGetWorkflowRunsByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowRunsByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowRunsByOwnerQuery({
 *   variables: {
 *      status: // value for 'status'
 *      workflowType: // value for 'workflowType'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWorkflowRunsByOwnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowRunsByOwnerQuery,
    GetWorkflowRunsByOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowRunsByOwnerQuery,
    GetWorkflowRunsByOwnerQueryVariables
  >(GetWorkflowRunsByOwnerDocument, options);
}
export function useGetWorkflowRunsByOwnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowRunsByOwnerQuery,
    GetWorkflowRunsByOwnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowRunsByOwnerQuery,
    GetWorkflowRunsByOwnerQueryVariables
  >(GetWorkflowRunsByOwnerDocument, options);
}
export type GetWorkflowRunsByOwnerQueryHookResult = ReturnType<
  typeof useGetWorkflowRunsByOwnerQuery
>;
export type GetWorkflowRunsByOwnerLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowRunsByOwnerLazyQuery
>;
export namespace GetWorkflowRunsByOwner {
  export type Return = GetWorkflowRunsByOwnerQuery;
  export type Variables = GetWorkflowRunsByOwnerQueryVariables;
  export const OperationName = "GetWorkflowRunsByOwner";

  export const Document = GetWorkflowRunsByOwnerDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetSearchQualityItemsDocument = gql`
  query getSearchQualityItems {
    getConsultantSearchQualityItems {
      ...QualityCheckFilterItem
    }
  }
  ${QualityCheckFilterItemFragmentDoc}
`;
export type GetSearchQualityItemsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSearchQualityItemsQuery,
    GetSearchQualityItemsQueryVariables
  >,
  "query"
>;

export const GetSearchQualityItemsComponent = (
  props: GetSearchQualityItemsComponentProps
) => (
  <ApolloReactComponents.Query<
    GetSearchQualityItemsQuery,
    GetSearchQualityItemsQueryVariables
  >
    query={GetSearchQualityItemsDocument}
    {...props}
  />
);

/**
 * __useGetSearchQualityItemsQuery__
 *
 * To run a query within a React component, call `useGetSearchQualityItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchQualityItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchQualityItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchQualityItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSearchQualityItemsQuery,
    GetSearchQualityItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSearchQualityItemsQuery, GetSearchQualityItemsQueryVariables>(
    GetSearchQualityItemsDocument,
    options
  );
}
export function useGetSearchQualityItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSearchQualityItemsQuery,
    GetSearchQualityItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSearchQualityItemsQuery,
    GetSearchQualityItemsQueryVariables
  >(GetSearchQualityItemsDocument, options);
}
export type GetSearchQualityItemsQueryHookResult = ReturnType<
  typeof useGetSearchQualityItemsQuery
>;
export type GetSearchQualityItemsLazyQueryHookResult = ReturnType<
  typeof useGetSearchQualityItemsLazyQuery
>;
export namespace GetSearchQualityItems {
  export type Return = GetSearchQualityItemsQuery;
  export type Variables = GetSearchQualityItemsQueryVariables;
  export const OperationName = "getSearchQualityItems";

  export const Document = GetSearchQualityItemsDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const SearchSearchProfilesDocument = gql`
  query searchSearchProfiles($filter: SearchProfilesFilter!, $skip: Int, $limit: Int) {
    SearchProfiles(filter: $filter, limit: $limit, skip: $skip) {
      items {
        ...SearchProfileOptionData
      }
    }
  }
  ${SearchProfileOptionDataFragmentDoc}
`;
export type SearchSearchProfilesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SearchSearchProfilesQuery,
    SearchSearchProfilesQueryVariables
  >,
  "query"
> &
  ({ variables: SearchSearchProfilesQueryVariables; skip?: boolean } | { skip: boolean });

export const SearchSearchProfilesComponent = (
  props: SearchSearchProfilesComponentProps
) => (
  <ApolloReactComponents.Query<
    SearchSearchProfilesQuery,
    SearchSearchProfilesQueryVariables
  >
    query={SearchSearchProfilesDocument}
    {...props}
  />
);

/**
 * __useSearchSearchProfilesQuery__
 *
 * To run a query within a React component, call `useSearchSearchProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSearchProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSearchProfilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSearchProfilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchSearchProfilesQuery,
    SearchSearchProfilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchSearchProfilesQuery, SearchSearchProfilesQueryVariables>(
    SearchSearchProfilesDocument,
    options
  );
}
export function useSearchSearchProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSearchProfilesQuery,
    SearchSearchProfilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchSearchProfilesQuery,
    SearchSearchProfilesQueryVariables
  >(SearchSearchProfilesDocument, options);
}
export type SearchSearchProfilesQueryHookResult = ReturnType<
  typeof useSearchSearchProfilesQuery
>;
export type SearchSearchProfilesLazyQueryHookResult = ReturnType<
  typeof useSearchSearchProfilesLazyQuery
>;
export namespace SearchSearchProfiles {
  export type Return = SearchSearchProfilesQuery;
  export type Variables = SearchSearchProfilesQueryVariables;
  export const OperationName = "searchSearchProfiles";

  export const Document = SearchSearchProfilesDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const GetSearchProfileDocument = gql`
  query getSearchProfile($id: ObjectId!) {
    searchProfileById(id: $id) {
      ...SearchProfileData
    }
  }
  ${SearchProfileDataFragmentDoc}
`;
export type GetSearchProfileComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSearchProfileQuery,
    GetSearchProfileQueryVariables
  >,
  "query"
> &
  ({ variables: GetSearchProfileQueryVariables; skip?: boolean } | { skip: boolean });

export const GetSearchProfileComponent = (props: GetSearchProfileComponentProps) => (
  <ApolloReactComponents.Query<GetSearchProfileQuery, GetSearchProfileQueryVariables>
    query={GetSearchProfileDocument}
    {...props}
  />
);

/**
 * __useGetSearchProfileQuery__
 *
 * To run a query within a React component, call `useGetSearchProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSearchProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSearchProfileQuery,
    GetSearchProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSearchProfileQuery, GetSearchProfileQueryVariables>(
    GetSearchProfileDocument,
    options
  );
}
export function useGetSearchProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSearchProfileQuery,
    GetSearchProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSearchProfileQuery, GetSearchProfileQueryVariables>(
    GetSearchProfileDocument,
    options
  );
}
export type GetSearchProfileQueryHookResult = ReturnType<typeof useGetSearchProfileQuery>;
export type GetSearchProfileLazyQueryHookResult = ReturnType<
  typeof useGetSearchProfileLazyQuery
>;
export namespace GetSearchProfile {
  export type Return = GetSearchProfileQuery;
  export type Variables = GetSearchProfileQueryVariables;
  export const OperationName = "getSearchProfile";

  export const Document = GetSearchProfileDocument;
  export const { func, funcWatch } = query<Variables, Return>(Document, getClient);
}
export const DeleteSearchProfileDocument = gql`
  mutation deleteSearchProfile($id: ObjectId!) {
    removeSearchProfile(searchProfileId: $id)
  }
`;
export type DeleteSearchProfileMutationFn = Apollo.MutationFunction<
  DeleteSearchProfileMutation,
  DeleteSearchProfileMutationVariables
>;
export type DeleteSearchProfileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteSearchProfileMutation,
    DeleteSearchProfileMutationVariables
  >,
  "mutation"
>;

export const DeleteSearchProfileComponent = (
  props: DeleteSearchProfileComponentProps
) => (
  <ApolloReactComponents.Mutation<
    DeleteSearchProfileMutation,
    DeleteSearchProfileMutationVariables
  >
    mutation={DeleteSearchProfileDocument}
    {...props}
  />
);

/**
 * __useDeleteSearchProfileMutation__
 *
 * To run a mutation, you first call `useDeleteSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchProfileMutation, { data, loading, error }] = useDeleteSearchProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSearchProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSearchProfileMutation,
    DeleteSearchProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSearchProfileMutation,
    DeleteSearchProfileMutationVariables
  >(DeleteSearchProfileDocument, options);
}
export type DeleteSearchProfileMutationHookResult = ReturnType<
  typeof useDeleteSearchProfileMutation
>;
export namespace DeleteSearchProfile {
  export type Return = DeleteSearchProfileMutation;
  export type Variables = DeleteSearchProfileMutationVariables;
  export const OperationName = "deleteSearchProfile";

  export const Document = DeleteSearchProfileDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
export const UpsertSearchProfileDocument = gql`
  mutation upsertSearchProfile($data: SearchProfileFormInput!, $id: ObjectId) {
    submitSearchProfileForm(data: $data, searchProfileId: $id) {
      ...SearchProfileData
    }
  }
  ${SearchProfileDataFragmentDoc}
`;
export type UpsertSearchProfileMutationFn = Apollo.MutationFunction<
  UpsertSearchProfileMutation,
  UpsertSearchProfileMutationVariables
>;
export type UpsertSearchProfileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpsertSearchProfileMutation,
    UpsertSearchProfileMutationVariables
  >,
  "mutation"
>;

export const UpsertSearchProfileComponent = (
  props: UpsertSearchProfileComponentProps
) => (
  <ApolloReactComponents.Mutation<
    UpsertSearchProfileMutation,
    UpsertSearchProfileMutationVariables
  >
    mutation={UpsertSearchProfileDocument}
    {...props}
  />
);

/**
 * __useUpsertSearchProfileMutation__
 *
 * To run a mutation, you first call `useUpsertSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSearchProfileMutation, { data, loading, error }] = useUpsertSearchProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpsertSearchProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertSearchProfileMutation,
    UpsertSearchProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertSearchProfileMutation,
    UpsertSearchProfileMutationVariables
  >(UpsertSearchProfileDocument, options);
}
export type UpsertSearchProfileMutationHookResult = ReturnType<
  typeof useUpsertSearchProfileMutation
>;
export namespace UpsertSearchProfile {
  export type Return = UpsertSearchProfileMutation;
  export type Variables = UpsertSearchProfileMutationVariables;
  export const OperationName = "upsertSearchProfile";

  export const Document = UpsertSearchProfileDocument;
  export const { func } = mutation<Variables, Return>(Document, getClient);
}
